export const categoriesData = [
  {
    "segment": "Palniki gazowe",
    "categoryPath": [
      "(315261) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy",
      "Akcesoria"
    ],
    "hierarchy": "(315261) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Akcesoria / Palniki gazowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(315213) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy",
      "Akcesoria"
    ],
    "hierarchy": "(315213) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Akcesoria / Taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wiatrownice",
    "categoryPath": [
      "(315249) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy",
      "Akcesoria"
    ],
    "hierarchy": "(315249) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Akcesoria / Wiatrownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Elementy montażowe",
    "categoryPath": [
      "(255632) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(255632) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Elementy montażowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Farby i uszczelniacze do dachów",
    "categoryPath": [
      "(255633) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(255633) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Farby i uszczelniacze do dachów",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Folie i izolacja",
    "categoryPath": [
      "(46120) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(46120) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Folie i izolacja",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kominki wentylacyjne",
    "categoryPath": [
      "(258714) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(258714) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Kominki wentylacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stopnie kominiarskie",
    "categoryPath": [
      "(319255) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy",
      "Komunikacja dachowa"
    ],
    "hierarchy": "(319255) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Komunikacja dachowa / Stopnie kominiarskie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Ławy kominiarskie",
    "categoryPath": [
      "(319252) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy",
      "Komunikacja dachowa"
    ],
    "hierarchy": "(319252) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Komunikacja dachowa / Ławy kominiarskie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pokrycia dachowe",
    "categoryPath": [
      "(46119) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(46119) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Pokrycia dachowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Płotki śniegowe",
    "categoryPath": [
      "(305349) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(305349) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Płotki śniegowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rynny i rury spustowe",
    "categoryPath": [
      "(111853) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(111853) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Rynny i rury spustowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Więźby i podbitki",
    "categoryPath": [
      "(111854) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Dachy"
    ],
    "hierarchy": "(111854) Dom i Ogród / Budownictwo i Akcesoria / Dachy / Więźby i podbitki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Cyfry i litery na drzwi",
    "categoryPath": [
      "(316447) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(316447) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Cyfry i litery na drzwi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Daszki nad drzwi",
    "categoryPath": [
      "(256503) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(256503) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Daszki nad drzwi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Drzwi wewnętrzne",
    "categoryPath": [
      "(46100) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(46100) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Drzwi wewnętrzne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Drzwi zewnętrzne",
    "categoryPath": [
      "(46101) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(46101) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Drzwi zewnętrzne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Klamki",
    "categoryPath": [
      "(255634) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(255634) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Klamki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kłódki",
    "categoryPath": [
      "(261829) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(261829) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Kłódki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Listwy",
    "categoryPath": [
      "(316453) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(316453) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Listwy",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Odbojniki",
    "categoryPath": [
      "(258277) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(258277) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Odbojniki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Ościeżnice",
    "categoryPath": [
      "(255648) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(255648) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Ościeżnice",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Podpórki",
    "categoryPath": [
      "(261823) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(261823) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Podpórki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Samozamykacze",
    "categoryPath": [
      "(258273) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(258273) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Samozamykacze",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Systemy do drzwi przesuwnych",
    "categoryPath": [
      "(260548) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(260548) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Systemy do drzwi przesuwnych",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Tabliczki na drzwi",
    "categoryPath": [
      "(261820) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(261820) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Tabliczki na drzwi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Tapicerka drzwiowa",
    "categoryPath": [
      "(258274) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(258274) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Tapicerka drzwiowa",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Tuleje wentylacyjne",
    "categoryPath": [
      "(316450) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(316450) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Tuleje wentylacyjne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Uchwyty do drzwi",
    "categoryPath": [
      "(316444) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(316444) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Uchwyty do drzwi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(258281) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(258281) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Uszczelki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Wizjery",
    "categoryPath": [
      "(258275) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(258275) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Wizjery",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zamki",
    "categoryPath": [
      "(255635) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(255635) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Zamki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(258276) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Drzwi"
    ],
    "hierarchy": "(258276) Dom i Ogród / Budownictwo i Akcesoria / Drzwi / Zawiasy",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Dławnice",
    "categoryPath": [
      "(316070) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316070) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Dławnice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Izolacje",
    "categoryPath": [
      "(316073) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316073) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Izolacje",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Końcówki kablowe",
    "categoryPath": [
      "(316076) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316076) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Końcówki kablowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mufa kablowa",
    "categoryPath": [
      "(316079) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316079) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Mufa kablowa",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rury",
    "categoryPath": [
      "(316085) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316085) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Rury",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tulejki",
    "categoryPath": [
      "(316100) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316100) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Tulejki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(316091) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316091) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Złączki",
    "categoryPath": [
      "(316097) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(316097) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Akcesoria montażowe / Złączki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Centrale alarmowe",
    "categoryPath": [
      "(46113) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Alarmy"
    ],
    "hierarchy": "(46113) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Alarmy / Centrale alarmowe",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Detektory",
    "categoryPath": [
      "(46114) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Alarmy"
    ],
    "hierarchy": "(46114) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Alarmy / Detektory",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Sygnalizatory",
    "categoryPath": [
      "(46115) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Alarmy"
    ],
    "hierarchy": "(46115) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Alarmy / Sygnalizatory",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zestawy alarmowe",
    "categoryPath": [
      "(46116) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria",
      "Alarmy"
    ],
    "hierarchy": "(46116) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Alarmy / Zestawy alarmowe",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Domofony i wideodomofony",
    "categoryPath": [
      "(46106) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(46106) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Domofony i wideodomofony",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Dzwonki",
    "categoryPath": [
      "(15963) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(15963) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Dzwonki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Gniazda",
    "categoryPath": [
      "(111855) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(111855) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Gniazda",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kable i przewody",
    "categoryPath": [
      "(15962) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(15962) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Kable i przewody",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kanały kablowe",
    "categoryPath": [
      "(318831) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(318831) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Kanały kablowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Narzędzia dla elektryka",
    "categoryPath": [
      "(260566) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(260566) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Narzędzia dla elektryka",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Peszle",
    "categoryPath": [
      "(302402) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(302402) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Peszle",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(15961) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(15961) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przedłużacze",
    "categoryPath": [
      "(111856) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(111856) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Przedłużacze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Puszki elektryczne",
    "categoryPath": [
      "(256021) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(256021) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Puszki elektryczne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Ramki",
    "categoryPath": [
      "(258295) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(258295) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Ramki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szybkozłączki",
    "categoryPath": [
      "(302414) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(302414) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Szybkozłączki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Watomierze",
    "categoryPath": [
      "(260562) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(260562) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Watomierze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wtyczki",
    "categoryPath": [
      "(316094) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(316094) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Wtyczki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wyłączniki i ściemniacze",
    "categoryPath": [
      "(46109) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(46109) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Wyłączniki i ściemniacze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zabezpieczenia i rozdzielnice",
    "categoryPath": [
      "(46107) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Elektryka i akcesoria"
    ],
    "hierarchy": "(46107) Dom i Ogród / Budownictwo i Akcesoria / Elektryka i akcesoria / Zabezpieczenia i rozdzielnice",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Garaże",
    "categoryPath": [
      "(316267) Dom i Ogród",
      "Budownictwo i Akcesoria"
    ],
    "hierarchy": "(316267) Dom i Ogród / Budownictwo i Akcesoria / Garaże",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Akcesoria do uszczelniania",
    "categoryPath": [
      "(309493) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(309493) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Akcesoria do uszczelniania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Filtry i zmiękczacze wody",
    "categoryPath": [
      "(260391) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(260391) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Filtry i zmiękczacze wody",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Głowice",
    "categoryPath": [
      "(321723) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(321723) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Głowice",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(260392) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(260392) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Korki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Narzędzia",
    "categoryPath": [
      "(46139) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(46139) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Narzędzia",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Otuliny",
    "categoryPath": [
      "(318837) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(318837) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Otuliny",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pokrywy i włazy",
    "categoryPath": [
      "(306009) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(306009) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Pokrywy i włazy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(46143) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(46143) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kształtki",
    "categoryPath": [
      "(313429) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313429) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Kształtki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(313441) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313441) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rozety",
    "categoryPath": [
      "(322357) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(322357) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rozety",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury PEX",
    "categoryPath": [
      "(313357) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313357) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury PEX",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury ceramiczne",
    "categoryPath": [
      "(313321) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313321) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury ceramiczne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury gazowe",
    "categoryPath": [
      "(313381) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313381) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury gazowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury kanalizacyjne",
    "categoryPath": [
      "(313405) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313405) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury kanalizacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury karbowane - peszle",
    "categoryPath": [
      "(313369) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313369) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury karbowane - peszle",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury miedziane",
    "categoryPath": [
      "(313393) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313393) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury miedziane",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury nierdzewne",
    "categoryPath": [
      "(313345) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313345) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury nierdzewne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rury wentylacyjne",
    "categoryPath": [
      "(313417) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria",
      "Rury i kształtki"
    ],
    "hierarchy": "(313417) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Rury i kształtki / Rury wentylacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Studnie",
    "categoryPath": [
      "(310301) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(310301) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Studnie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Syfony",
    "categoryPath": [
      "(111859) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(111859) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Syfony",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki i skrzynki gazowe",
    "categoryPath": [
      "(302829) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(302829) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Szafki i skrzynki gazowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(307453) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(307453) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Uszczelki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wodomierze i liczniki",
    "categoryPath": [
      "(46141) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(46141) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Wodomierze i liczniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(111858) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(111858) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Węże",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(111857) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Hydraulika i akcesoria"
    ],
    "hierarchy": "(111857) Dom i Ogród / Budownictwo i Akcesoria / Hydraulika i akcesoria / Zawory",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Anemostaty",
    "categoryPath": [
      "(68620) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(68620) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Anemostaty",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drzwiczki rewizyjne",
    "categoryPath": [
      "(256068) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(256068) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Drzwiczki rewizyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kanały, kształtki, przewody",
    "categoryPath": [
      "(68621) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(68621) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Kanały, kształtki, przewody",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Klimatyzatory",
    "categoryPath": [
      "(85035) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(85035) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Klimatyzatory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kratki wentylacyjne",
    "categoryPath": [
      "(256067) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(256067) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Kratki wentylacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Nasady kominowe",
    "categoryPath": [
      "(258840) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(258840) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Nasady kominowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(68619) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(68619) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Regulatory obrotów",
    "categoryPath": [
      "(68622) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(68622) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Regulatory obrotów",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(322158) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja",
      "Rekuperacja"
    ],
    "hierarchy": "(322158) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Rekuperacja / Części",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rekuperatory",
    "categoryPath": [
      "(68623) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja",
      "Rekuperacja"
    ],
    "hierarchy": "(68623) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Rekuperacja / Rekuperatory",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Taśmy izolacyjne",
    "categoryPath": [
      "(258841) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(258841) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Taśmy izolacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(111876) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(111876) Dom i Ogród / Budownictwo i Akcesoria / Klimatyzacja i wentylacja / Wentylatory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(27964) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria do płaszcza wodnego"
    ],
    "hierarchy": "(27964) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria do płaszcza wodnego / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wymienniki i pompy",
    "categoryPath": [
      "(27965) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria do płaszcza wodnego"
    ],
    "hierarchy": "(27965) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria do płaszcza wodnego / Wymienniki i pompy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne elementy",
    "categoryPath": [
      "(27975) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria kominkowe",
      "Elementy kominków i pieców"
    ],
    "hierarchy": "(27975) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria kominkowe / Elementy kominków i pieców / Inne elementy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obudowy kominkowe",
    "categoryPath": [
      "(27976) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria kominkowe",
      "Elementy kominków i pieców"
    ],
    "hierarchy": "(27976) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria kominkowe / Elementy kominków i pieców / Obudowy kominkowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(27970) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria kominkowe"
    ],
    "hierarchy": "(27970) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria kominkowe / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosze na drewno",
    "categoryPath": [
      "(27973) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria kominkowe"
    ],
    "hierarchy": "(27973) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria kominkowe / Kosze na drewno",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odkurzacze do popiołu",
    "categoryPath": [
      "(258352) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria kominkowe"
    ],
    "hierarchy": "(258352) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria kominkowe / Odkurzacze do popiołu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy kominkowe",
    "categoryPath": [
      "(27971) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Akcesoria kominkowe"
    ],
    "hierarchy": "(27971) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Akcesoria kominkowe / Zestawy kominkowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Biokominki",
    "categoryPath": [
      "(111885) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(111885) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Biokominki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Drewno kominkowe",
    "categoryPath": [
      "(111882) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(111882) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Drewno kominkowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kratki",
    "categoryPath": [
      "(27968) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Dystrybucja gorącego powietrza"
    ],
    "hierarchy": "(27968) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Dystrybucja gorącego powietrza / Kratki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Przewody i kanały",
    "categoryPath": [
      "(27967) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Dystrybucja gorącego powietrza"
    ],
    "hierarchy": "(27967) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Dystrybucja gorącego powietrza / Przewody i kanały",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Turbiny i filtry",
    "categoryPath": [
      "(27969) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria",
      "Dystrybucja gorącego powietrza"
    ],
    "hierarchy": "(27969) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Dystrybucja gorącego powietrza / Turbiny i filtry",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kominki elektryczne",
    "categoryPath": [
      "(257639) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(257639) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Kominki elektryczne",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kominki gazowe",
    "categoryPath": [
      "(258703) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(258703) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Kominki gazowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Obudowy kominkowe",
    "categoryPath": [
      "(111881) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(111881) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Obudowy kominkowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Paliwa do biokominków",
    "categoryPath": [
      "(322194) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(322194) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Paliwa do biokominków",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Piece wolnostojące",
    "categoryPath": [
      "(111884) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(111884) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Piece wolnostojące",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(27958) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(27958) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Systemy kominowe",
    "categoryPath": [
      "(27963) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(27963) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Systemy kominowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Wkłady kominkowe",
    "categoryPath": [
      "(111883) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kominki i akcesoria"
    ],
    "hierarchy": "(111883) Dom i Ogród / Budownictwo i Akcesoria / Kominki i akcesoria / Wkłady kominkowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Baterie kuchenne",
    "categoryPath": [
      "(46125) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kuchnia"
    ],
    "hierarchy": "(46125) Dom i Ogród / Budownictwo i Akcesoria / Kuchnia / Baterie kuchenne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Dozowniki",
    "categoryPath": [
      "(260413) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kuchnia"
    ],
    "hierarchy": "(260413) Dom i Ogród / Budownictwo i Akcesoria / Kuchnia / Dozowniki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Młynki do odpadów",
    "categoryPath": [
      "(253698) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kuchnia"
    ],
    "hierarchy": "(253698) Dom i Ogród / Budownictwo i Akcesoria / Kuchnia / Młynki do odpadów",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(46127) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kuchnia"
    ],
    "hierarchy": "(46127) Dom i Ogród / Budownictwo i Akcesoria / Kuchnia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wylewki do baterii",
    "categoryPath": [
      "(322506) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kuchnia"
    ],
    "hierarchy": "(322506) Dom i Ogród / Budownictwo i Akcesoria / Kuchnia / Wylewki do baterii",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zlewozmywaki",
    "categoryPath": [
      "(46126) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kuchnia"
    ],
    "hierarchy": "(46126) Dom i Ogród / Budownictwo i Akcesoria / Kuchnia / Zlewozmywaki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zlewy gospodarcze",
    "categoryPath": [
      "(322508) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Kuchnia"
    ],
    "hierarchy": "(322508) Dom i Ogród / Budownictwo i Akcesoria / Kuchnia / Zlewy gospodarcze",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Gniazda ssące",
    "categoryPath": [
      "(256078) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Odkurzacze centralne"
    ],
    "hierarchy": "(256078) Dom i Ogród / Budownictwo i Akcesoria / Odkurzacze centralne / Gniazda ssące",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Jednostki centralne",
    "categoryPath": [
      "(111890) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Odkurzacze centralne"
    ],
    "hierarchy": "(111890) Dom i Ogród / Budownictwo i Akcesoria / Odkurzacze centralne / Jednostki centralne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Szufelki",
    "categoryPath": [
      "(258235) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Odkurzacze centralne"
    ],
    "hierarchy": "(258235) Dom i Ogród / Budownictwo i Akcesoria / Odkurzacze centralne / Szufelki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Węże ssące",
    "categoryPath": [
      "(111891) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Odkurzacze centralne"
    ],
    "hierarchy": "(111891) Dom i Ogród / Budownictwo i Akcesoria / Odkurzacze centralne / Węże ssące",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fotokomórki",
    "categoryPath": [
      "(315165) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315165) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Fotokomórki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klamki i pochwyty",
    "categoryPath": [
      "(319478) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(319478) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Klamki i pochwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odbiorniki",
    "categoryPath": [
      "(315177) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315177) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Odbiorniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piloty",
    "categoryPath": [
      "(315069) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315069) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Piloty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Profile",
    "categoryPath": [
      "(315117) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315117) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Profile",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(315153) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315153) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Sterowniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty i obejmy",
    "categoryPath": [
      "(315081) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315081) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Uchwyty i obejmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wózki i rolki",
    "categoryPath": [
      "(315093) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315093) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Wózki i rolki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zamki",
    "categoryPath": [
      "(315129) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315129) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Zamki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zasuwy",
    "categoryPath": [
      "(315189) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315189) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Zasuwy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(315141) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315141) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Zawiasy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zaślepki",
    "categoryPath": [
      "(315105) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy",
      "Akcesoria"
    ],
    "hierarchy": "(315105) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Akcesoria / Zaślepki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bramy",
    "categoryPath": [
      "(46144) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(46144) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Bramy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drut kolczasty i naciągowy",
    "categoryPath": [
      "(258400) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(258400) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Drut kolczasty i naciągowy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Elementy kute",
    "categoryPath": [
      "(322395) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(322395) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Elementy kute",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Furtki",
    "categoryPath": [
      "(256108) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(256108) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Furtki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Napędy",
    "categoryPath": [
      "(46146) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(46146) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Napędy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(46148) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(46148) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przęsła",
    "categoryPath": [
      "(111893) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(111893) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Przęsła",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Siatka i panele ogrodzeniowe",
    "categoryPath": [
      "(111894) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(111894) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Siatka i panele ogrodzeniowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Skrzynki na listy",
    "categoryPath": [
      "(46147) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrodzenia i bramy"
    ],
    "hierarchy": "(46147) Dom i Ogród / Budownictwo i Akcesoria / Ogrodzenia i bramy / Skrzynki na listy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Akcesoria do kotłów i pieców",
    "categoryPath": [
      "(111867) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(111867) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Akcesoria do kotłów i pieców",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bojlery",
    "categoryPath": [
      "(257640) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(257640) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Bojlery",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Grzałki",
    "categoryPath": [
      "(321504) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(321504) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzałki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Ekrany i maty zagrzejnikowe",
    "categoryPath": [
      "(308233) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki",
      "Akcesoria"
    ],
    "hierarchy": "(308233) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Akcesoria / Ekrany i maty zagrzejnikowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(308209) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki",
      "Akcesoria"
    ],
    "hierarchy": "(308209) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Akcesoria / Korki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe akcesoria",
    "categoryPath": [
      "(308245) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki",
      "Akcesoria"
    ],
    "hierarchy": "(308245) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Akcesoria / Pozostałe akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty i haki do grzejników",
    "categoryPath": [
      "(308221) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki",
      "Akcesoria"
    ],
    "hierarchy": "(308221) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Akcesoria / Uchwyty i haki do grzejników",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Grzejniki aluminiowe",
    "categoryPath": [
      "(308101) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308101) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Grzejniki aluminiowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Grzejniki dekoracyjne",
    "categoryPath": [
      "(308173) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308173) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Grzejniki dekoracyjne",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Grzejniki konwektorowe",
    "categoryPath": [
      "(308125) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308125) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Grzejniki konwektorowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Grzejniki olejowe",
    "categoryPath": [
      "(308137) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308137) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Grzejniki olejowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Grzejniki stalowe - panelowe",
    "categoryPath": [
      "(308089) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308089) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Grzejniki stalowe - panelowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Grzejniki łazienkowe",
    "categoryPath": [
      "(308113) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308113) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Grzejniki łazienkowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe grzejniki",
    "categoryPath": [
      "(308197) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308197) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Pozostałe grzejniki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Suszarki elektryczne",
    "categoryPath": [
      "(308161) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308161) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Suszarki elektryczne",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Termowentylatory",
    "categoryPath": [
      "(308149) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie",
      "Grzejniki"
    ],
    "hierarchy": "(308149) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Grzejniki / Termowentylatory",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Głowice termostatyczne i zawory",
    "categoryPath": [
      "(256119) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(256119) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Głowice termostatyczne i zawory",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kolektory słoneczne i panele fotowoltaiczne",
    "categoryPath": [
      "(258713) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(258713) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Kolektory słoneczne i panele fotowoltaiczne",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kotły i piece",
    "categoryPath": [
      "(111869) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(111869) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Kotły i piece",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kurtyny powietrzne",
    "categoryPath": [
      "(257638) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(257638) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Kurtyny powietrzne",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Nagrzewnice",
    "categoryPath": [
      "(256110) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(256110) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Nagrzewnice",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Ogrzewanie podłogowe",
    "categoryPath": [
      "(256109) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(256109) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Ogrzewanie podłogowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Opał",
    "categoryPath": [
      "(253377) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(253377) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Opał",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Podgrzewacze wody",
    "categoryPath": [
      "(302354) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(302354) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Podgrzewacze wody",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pompy ciepła",
    "categoryPath": [
      "(257641) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(257641) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Pompy ciepła",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pompy i filtry",
    "categoryPath": [
      "(111870) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(111870) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Pompy i filtry",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(111866) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(111866) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Promienniki",
    "categoryPath": [
      "(261809) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(261809) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Promienniki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Przewody grzejne",
    "categoryPath": [
      "(256504) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(256504) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Przewody grzejne",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Rozdzielacze",
    "categoryPath": [
      "(258351) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(258351) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Rozdzielacze",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Sterowniki, regulatory",
    "categoryPath": [
      "(322383) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ogrzewanie"
    ],
    "hierarchy": "(322383) Dom i Ogród / Budownictwo i Akcesoria / Ogrzewanie / Sterowniki, regulatory",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Blokady",
    "categoryPath": [
      "(316426) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(316426) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Blokady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kasety naprawcze",
    "categoryPath": [
      "(316435) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(316435) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Kasety naprawcze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nawiewniki",
    "categoryPath": [
      "(316423) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(316423) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Nawiewniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Osłonki",
    "categoryPath": [
      "(316438) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(316438) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Osłonki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(316432) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(316432) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zaczepy",
    "categoryPath": [
      "(322653) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(322653) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Zaczepy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zasuwnice",
    "categoryPath": [
      "(316441) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(316441) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Zasuwnice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zatrzaski",
    "categoryPath": [
      "(322668) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(322668) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Zatrzaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(316429) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety",
      "Akcesoria"
    ],
    "hierarchy": "(316429) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Akcesoria / Zawiasy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drzwi balkonowe i tarasowe",
    "categoryPath": [
      "(256171) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(256171) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Drzwi balkonowe i tarasowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Klamki okienne",
    "categoryPath": [
      "(256169) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(256169) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Klamki okienne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Markizy",
    "categoryPath": [
      "(256507) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(256507) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Markizy",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Okiennice",
    "categoryPath": [
      "(300333) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(300333) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Okiennice",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Okna dachowe",
    "categoryPath": [
      "(46157) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(46157) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Okna dachowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Okna ścienne",
    "categoryPath": [
      "(46156) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(46156) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Okna ścienne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Parapety",
    "categoryPath": [
      "(68628) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(68628) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Parapety",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(46168) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(46168) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rolety zewnętrzne",
    "categoryPath": [
      "(256508) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(256508) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Rolety zewnętrzne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(256168) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Okna i parapety"
    ],
    "hierarchy": "(256168) Dom i Ogród / Budownictwo i Akcesoria / Okna i parapety / Uszczelki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Gilotyny",
    "categoryPath": [
      "(260864) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(260864) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Akcesoria montażowe / Gilotyny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Systemy poziomowania",
    "categoryPath": [
      "(260860) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(260860) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Akcesoria montażowe / Systemy poziomowania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wkręty",
    "categoryPath": [
      "(260861) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(260861) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Akcesoria montażowe / Wkręty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chemia do podłóg",
    "categoryPath": [
      "(256173) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi"
    ],
    "hierarchy": "(256173) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Chemia do podłóg",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Deski lite",
    "categoryPath": [
      "(304829) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Deski podłogowe"
    ],
    "hierarchy": "(304829) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Deski podłogowe / Deski lite",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Deski trójwarstwowe",
    "categoryPath": [
      "(304817) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Deski podłogowe"
    ],
    "hierarchy": "(304817) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Deski podłogowe / Deski trójwarstwowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(304841) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Deski podłogowe"
    ],
    "hierarchy": "(304841) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Deski podłogowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kleje do drewna",
    "categoryPath": [
      "(306849) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi"
    ],
    "hierarchy": "(306849) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Kleje do drewna",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Listwy progowe",
    "categoryPath": [
      "(319274) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi"
    ],
    "hierarchy": "(319274) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Listwy progowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Listwy przypodłogowe",
    "categoryPath": [
      "(256179) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi"
    ],
    "hierarchy": "(256179) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Listwy przypodłogowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Panele laminowane",
    "categoryPath": [
      "(304865) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Panele podłogowe"
    ],
    "hierarchy": "(304865) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Panele podłogowe / Panele laminowane",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Panele winylowe",
    "categoryPath": [
      "(304877) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Panele podłogowe"
    ],
    "hierarchy": "(304877) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Panele podłogowe / Panele winylowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Parkiety",
    "categoryPath": [
      "(46162) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi"
    ],
    "hierarchy": "(46162) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Parkiety",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Podkłady pod panele",
    "categoryPath": [
      "(258346) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi"
    ],
    "hierarchy": "(258346) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Podkłady pod panele",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Gres",
    "categoryPath": [
      "(316775) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Płytki podłogowe"
    ],
    "hierarchy": "(316775) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Płytki podłogowe / Gres",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Klinkier",
    "categoryPath": [
      "(316778) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Płytki podłogowe"
    ],
    "hierarchy": "(316778) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Płytki podłogowe / Klinkier",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(316784) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Płytki podłogowe"
    ],
    "hierarchy": "(316784) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Płytki podłogowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płytki kamienne",
    "categoryPath": [
      "(316781) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Płytki podłogowe"
    ],
    "hierarchy": "(316781) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Płytki podłogowe / Płytki kamienne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Terakota",
    "categoryPath": [
      "(316772) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi",
      "Płytki podłogowe"
    ],
    "hierarchy": "(316772) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Płytki podłogowe / Terakota",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Żywica epoksydowa",
    "categoryPath": [
      "(261338) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Podłogi"
    ],
    "hierarchy": "(261338) Dom i Ogród / Budownictwo i Akcesoria / Podłogi / Żywica epoksydowa",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(126) Dom i Ogród",
      "Budownictwo i Akcesoria"
    ],
    "hierarchy": "(126) Dom i Ogród / Budownictwo i Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Drabiny",
    "categoryPath": [
      "(258860) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Prace na wysokości"
    ],
    "hierarchy": "(258860) Dom i Ogród / Budownictwo i Akcesoria / Prace na wysokości / Drabiny",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Stopnie i drabiny domowe",
    "categoryPath": [
      "(258861) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Prace na wysokości"
    ],
    "hierarchy": "(258861) Dom i Ogród / Budownictwo i Akcesoria / Prace na wysokości / Stopnie i drabiny domowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Szczudła budowlane",
    "categoryPath": [
      "(305361) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Prace na wysokości"
    ],
    "hierarchy": "(305361) Dom i Ogród / Budownictwo i Akcesoria / Prace na wysokości / Szczudła budowlane",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Uchwyty i haki na drabiny",
    "categoryPath": [
      "(260565) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Prace na wysokości"
    ],
    "hierarchy": "(260565) Dom i Ogród / Budownictwo i Akcesoria / Prace na wysokości / Uchwyty i haki na drabiny",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Balustrady",
    "categoryPath": [
      "(256176) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Schody"
    ],
    "hierarchy": "(256176) Dom i Ogród / Budownictwo i Akcesoria / Schody / Balustrady",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Barierki zabezpieczające",
    "categoryPath": [
      "(256175) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Schody"
    ],
    "hierarchy": "(256175) Dom i Ogród / Budownictwo i Akcesoria / Schody / Barierki zabezpieczające",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Profile i listwy schodowe",
    "categoryPath": [
      "(322195) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Schody"
    ],
    "hierarchy": "(322195) Dom i Ogród / Budownictwo i Akcesoria / Schody / Profile i listwy schodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Schody strychowe",
    "categoryPath": [
      "(258711) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Schody"
    ],
    "hierarchy": "(258711) Dom i Ogród / Budownictwo i Akcesoria / Schody / Schody strychowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Schody wewnętrzne",
    "categoryPath": [
      "(256174) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Schody"
    ],
    "hierarchy": "(256174) Dom i Ogród / Budownictwo i Akcesoria / Schody / Schody wewnętrzne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Schody zewnętrzne",
    "categoryPath": [
      "(258710) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Schody"
    ],
    "hierarchy": "(258710) Dom i Ogród / Budownictwo i Akcesoria / Schody / Schody zewnętrzne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Bloczki",
    "categoryPath": [
      "(316055) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316055) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Bloczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kielnie",
    "categoryPath": [
      "(316043) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316043) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Kielnie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kredy",
    "categoryPath": [
      "(320962) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(320962) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Kredy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mieszadła",
    "categoryPath": [
      "(316061) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316061) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Mieszadła",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pace",
    "categoryPath": [
      "(316049) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316049) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Pace",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sznurki",
    "categoryPath": [
      "(316064) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316064) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Sznurki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szpachelki",
    "categoryPath": [
      "(316046) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316046) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Szpachelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(316058) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316058) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zaciski",
    "categoryPath": [
      "(316050) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane",
      "Akcesoria murarskie"
    ],
    "hierarchy": "(316050) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Akcesoria murarskie / Zaciski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Blacha",
    "categoryPath": [
      "(302725) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(302725) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Blacha",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Formy do betonu",
    "categoryPath": [
      "(261691) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261691) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Formy do betonu",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Gwoździe, wkręty, śruby, kołki",
    "categoryPath": [
      "(261258) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261258) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Gwoździe, wkręty, śruby, kołki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kantówki",
    "categoryPath": [
      "(302869) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(302869) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Kantówki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Karabińczyki",
    "categoryPath": [
      "(261532) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261532) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Karabińczyki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kotwy",
    "categoryPath": [
      "(261257) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261257) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Kotwy",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Liny",
    "categoryPath": [
      "(261530) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261530) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Liny",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254843) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(254843) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Siatka",
    "categoryPath": [
      "(302737) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(302737) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Siatka",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Stojaki, koziołki, kobyłki",
    "categoryPath": [
      "(302909) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(302909) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Stojaki, koziołki, kobyłki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Tablice informacyjne",
    "categoryPath": [
      "(261256) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261256) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Tablice informacyjne",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Taczki",
    "categoryPath": [
      "(261255) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261255) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Taczki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Taśmy montażowe",
    "categoryPath": [
      "(261692) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261692) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Taśmy montażowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Wiadra i kastry budowlane",
    "categoryPath": [
      "(260957) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(260957) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Wiadra i kastry budowlane",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zaślepki",
    "categoryPath": [
      "(261664) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261664) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Zaślepki",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Łańcuchy",
    "categoryPath": [
      "(261531) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Sprzęt i akcesoria budowlane"
    ],
    "hierarchy": "(261531) Dom i Ogród / Budownictwo i Akcesoria / Sprzęt i akcesoria budowlane / Łańcuchy",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zabezpieczenia przeciwpożarowe",
    "categoryPath": [
      "(310361) Dom i Ogród",
      "Budownictwo i Akcesoria"
    ],
    "hierarchy": "(310361) Dom i Ogród / Budownictwo i Akcesoria / Zabezpieczenia przeciwpożarowe",
    "comissionGroupOld": "C6",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(321853) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(321853) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Baterie - serie",
    "categoryPath": [
      "(260421) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(260421) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Baterie - serie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Baterie bidetowe",
    "categoryPath": [
      "(260417) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(260417) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Baterie bidetowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Baterie podtynkowe",
    "categoryPath": [
      "(260418) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(260418) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Baterie podtynkowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Baterie prysznicowe",
    "categoryPath": [
      "(260419) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(260419) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Baterie prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Baterie umywalkowe",
    "categoryPath": [
      "(260416) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(260416) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Baterie umywalkowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Baterie wannowo-prysznicowe",
    "categoryPath": [
      "(260420) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(260420) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Baterie wannowo-prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Perlatory",
    "categoryPath": [
      "(309505) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(309505) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Perlatory",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Wylewki do baterii",
    "categoryPath": [
      "(260422) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Baterie łazienkowe"
    ],
    "hierarchy": "(260422) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Baterie łazienkowe / Wylewki do baterii",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Bidety",
    "categoryPath": [
      "(111861) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(111861) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Bidety",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(321854) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Deski WC i mocowania"
    ],
    "hierarchy": "(321854) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Deski WC i mocowania / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Deski sedesowe",
    "categoryPath": [
      "(316793) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Deski WC i mocowania"
    ],
    "hierarchy": "(316793) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Deski WC i mocowania / Deski sedesowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Mocowania",
    "categoryPath": [
      "(316796) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Deski WC i mocowania"
    ],
    "hierarchy": "(316796) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Deski WC i mocowania / Mocowania",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Gałki, rączki, klamki",
    "categoryPath": [
      "(315309) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki",
      "Akcesoria"
    ],
    "hierarchy": "(315309) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Akcesoria / Gałki, rączki, klamki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kostki, łączniki",
    "categoryPath": [
      "(322376) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki",
      "Akcesoria"
    ],
    "hierarchy": "(322376) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Akcesoria / Kostki, łączniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rolki",
    "categoryPath": [
      "(315285) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki",
      "Akcesoria"
    ],
    "hierarchy": "(315285) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Akcesoria / Rolki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uszczelnianie",
    "categoryPath": [
      "(315297) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki",
      "Akcesoria"
    ],
    "hierarchy": "(315297) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Akcesoria / Uszczelnianie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Brodziki",
    "categoryPath": [
      "(253706) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki"
    ],
    "hierarchy": "(253706) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Brodziki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Drzwi i ścianki prysznicowe",
    "categoryPath": [
      "(253744) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki"
    ],
    "hierarchy": "(253744) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Drzwi i ścianki prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kabiny prysznicowe",
    "categoryPath": [
      "(253705) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki"
    ],
    "hierarchy": "(253705) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Kabiny prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kabiny z hydromasażem",
    "categoryPath": [
      "(260492) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki"
    ],
    "hierarchy": "(260492) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Kabiny z hydromasażem",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Odpływy",
    "categoryPath": [
      "(260473) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kabiny i brodziki"
    ],
    "hierarchy": "(260473) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kabiny i brodziki / Odpływy",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Panele prysznicowe",
    "categoryPath": [
      "(260491) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kolumny i zestawy prysznicowe"
    ],
    "hierarchy": "(260491) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kolumny i zestawy prysznicowe / Panele prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Słuchawki prysznicowe",
    "categoryPath": [
      "(260997) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kolumny i zestawy prysznicowe"
    ],
    "hierarchy": "(260997) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kolumny i zestawy prysznicowe / Słuchawki prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Uchwyty i drążki prysznicowe",
    "categoryPath": [
      "(322060) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kolumny i zestawy prysznicowe"
    ],
    "hierarchy": "(322060) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kolumny i zestawy prysznicowe / Uchwyty i drążki prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Węże prysznicowe",
    "categoryPath": [
      "(260998) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kolumny i zestawy prysznicowe"
    ],
    "hierarchy": "(260998) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kolumny i zestawy prysznicowe / Węże prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zestawy prysznicowe",
    "categoryPath": [
      "(260493) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Kolumny i zestawy prysznicowe"
    ],
    "hierarchy": "(260493) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kolumny i zestawy prysznicowe / Zestawy prysznicowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kompakty WC",
    "categoryPath": [
      "(322058) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(322058) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Kompakty WC",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Miski WC",
    "categoryPath": [
      "(111863) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(111863) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Miski WC",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pisuary",
    "categoryPath": [
      "(316766) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(316766) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Pisuary",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pokrętła i głowice",
    "categoryPath": [
      "(302713) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(302713) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Pokrętła i głowice",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(46133) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(46133) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyciski spłukujące",
    "categoryPath": [
      "(253702) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(253702) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Przyciski spłukujące",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Rozdrabniacze i pompy do WC",
    "categoryPath": [
      "(305373) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(305373) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Rozdrabniacze i pompy do WC",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Silikony sanitarne",
    "categoryPath": [
      "(308617) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(308617) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Silikony sanitarne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Stelaże podtynkowe",
    "categoryPath": [
      "(253703) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(253703) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Stelaże podtynkowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Umywalki",
    "categoryPath": [
      "(46130) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(46130) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Umywalki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(313477) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Wanny i akcesoria"
    ],
    "hierarchy": "(313477) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Wanny i akcesoria / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obudowy do wanien",
    "categoryPath": [
      "(260509) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Wanny i akcesoria"
    ],
    "hierarchy": "(260509) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Wanny i akcesoria / Obudowy do wanien",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Parawany nawannowe",
    "categoryPath": [
      "(260508) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Wanny i akcesoria"
    ],
    "hierarchy": "(260508) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Wanny i akcesoria / Parawany nawannowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Wanny",
    "categoryPath": [
      "(260507) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta",
      "Wanny i akcesoria"
    ],
    "hierarchy": "(260507) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Wanny i akcesoria / Wanny",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(111864) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(111864) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Zestawy",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zestawy podtynkowe WC",
    "categoryPath": [
      "(260414) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(260414) Dom i Ogród / Budownictwo i Akcesoria / Łazienka i toaleta / Zestawy podtynkowe WC",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Drzwi przeciwpyłowe",
    "categoryPath": [
      "(316588) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(316588) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Drzwi przeciwpyłowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Folie malarskie",
    "categoryPath": [
      "(261005) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(261005) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Folie malarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gąbki",
    "categoryPath": [
      "(322393) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(322393) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Gąbki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kuwety malarskie",
    "categoryPath": [
      "(261038) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(261038) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Kuwety malarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pędzle malarskie",
    "categoryPath": [
      "(261006) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(261006) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Pędzle malarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Skrobaki",
    "categoryPath": [
      "(300657) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(300657) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Skrobaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy malarskie",
    "categoryPath": [
      "(261007) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(261007) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Taśmy malarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wałki malarskie",
    "categoryPath": [
      "(261008) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(261008) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Wałki malarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy malarskie",
    "categoryPath": [
      "(261107) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Akcesoria malarskie"
    ],
    "hierarchy": "(261107) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Akcesoria malarskie / Zestawy malarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Beton architektoniczny",
    "categoryPath": [
      "(316591) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(316591) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Beton architektoniczny",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Brokaty do farb",
    "categoryPath": [
      "(322372) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(322372) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Brokaty do farb",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Cegły",
    "categoryPath": [
      "(322470) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(322470) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Cegły",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Deski elewacyjne",
    "categoryPath": [
      "(261047) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(261047) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Deski elewacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Emalie",
    "categoryPath": [
      "(258816) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(258816) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Emalie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Farby",
    "categoryPath": [
      "(126182) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(126182) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Farby",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Farby gruntujące",
    "categoryPath": [
      "(322881) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(322881) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Farby gruntujące",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fugi",
    "categoryPath": [
      "(111898) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(111898) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Fugi",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Folie izolacyjne",
    "categoryPath": [
      "(261124) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(261124) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Folie izolacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kołki i zaślepki",
    "categoryPath": [
      "(259450) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(259450) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Kołki i zaślepki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Noże do materiałów izolacyjnych",
    "categoryPath": [
      "(259451) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(259451) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Noże do materiałów izolacyjnych",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Piana montażowa",
    "categoryPath": [
      "(258837) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(258837) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Piana montażowa",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pistolety",
    "categoryPath": [
      "(261125) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(261125) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Pistolety",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Siatki elewacyjne",
    "categoryPath": [
      "(258835) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(258835) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Siatki elewacyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Styropian",
    "categoryPath": [
      "(258838) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(258838) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Styropian",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wełna",
    "categoryPath": [
      "(258836) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Izolacja i ocieplenie"
    ],
    "hierarchy": "(258836) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Izolacja i ocieplenie / Wełna",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kamienie",
    "categoryPath": [
      "(322471) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(322471) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Kamienie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kleje do glazury i terakoty",
    "categoryPath": [
      "(256180) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Kleje"
    ],
    "hierarchy": "(256180) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Kleje / Kleje do glazury i terakoty",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kleje do styropianu",
    "categoryPath": [
      "(315879) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Kleje"
    ],
    "hierarchy": "(315879) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Kleje / Kleje do styropianu",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kleje do tapet",
    "categoryPath": [
      "(322123) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Kleje"
    ],
    "hierarchy": "(322123) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Kleje / Kleje do tapet",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kleje uniwersalne",
    "categoryPath": [
      "(306873) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Kleje"
    ],
    "hierarchy": "(306873) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Kleje / Kleje uniwersalne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe kleje",
    "categoryPath": [
      "(306885) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Kleje"
    ],
    "hierarchy": "(306885) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Kleje / Pozostałe kleje",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Lakierobejce",
    "categoryPath": [
      "(261724) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(261724) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Lakierobejce",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Lamele",
    "categoryPath": [
      "(322451) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(322451) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Lamele",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Listwy przysufitowe",
    "categoryPath": [
      "(257009) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(257009) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Listwy przysufitowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Naklejki i szablony",
    "categoryPath": [
      "(54068) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(54068) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Naklejki i szablony",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Numery na dom",
    "categoryPath": [
      "(257006) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(257006) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Numery na dom",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Panele dekoracyjne",
    "categoryPath": [
      "(258819) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(258819) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Panele dekoracyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Panele szklane",
    "categoryPath": [
      "(261046) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(261046) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Panele szklane",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(46163) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(46163) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dekor",
    "categoryPath": [
      "(316669) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Płytki ścienne"
    ],
    "hierarchy": "(316669) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Płytki ścienne / Dekor",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Glazura",
    "categoryPath": [
      "(316666) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Płytki ścienne"
    ],
    "hierarchy": "(316666) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Płytki ścienne / Glazura",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Listwy, cokoły, narożniki",
    "categoryPath": [
      "(316675) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Płytki ścienne"
    ],
    "hierarchy": "(316675) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Płytki ścienne / Listwy, cokoły, narożniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Mozaika",
    "categoryPath": [
      "(316672) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Płytki ścienne"
    ],
    "hierarchy": "(316672) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Płytki ścienne / Mozaika",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(316678) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Płytki ścienne"
    ],
    "hierarchy": "(316678) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Płytki ścienne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płyty budowlane",
    "categoryPath": [
      "(260659) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(260659) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Płyty budowlane",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sufity podwieszane",
    "categoryPath": [
      "(256506) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(256506) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Sufity podwieszane",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sztukateria",
    "categoryPath": [
      "(257010) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(257010) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Sztukateria",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Tapety",
    "categoryPath": [
      "(46166) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(46166) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Tapety",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fototapety",
    "categoryPath": [
      "(68631) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Tapety"
    ],
    "hierarchy": "(68631) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Tapety / Fototapety",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły do tapetowania",
    "categoryPath": [
      "(260695) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Tapety"
    ],
    "hierarchy": "(260695) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Tapety / Stoły do tapetowania",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Tapety w rolce",
    "categoryPath": [
      "(68630) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje",
      "Tapety"
    ],
    "hierarchy": "(68630) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Tapety / Tapety w rolce",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Tynki i gładzie",
    "categoryPath": [
      "(111897) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(111897) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Tynki i gładzie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Środki do gruntowania",
    "categoryPath": [
      "(111896) Dom i Ogród",
      "Budownictwo i Akcesoria",
      "Ściany i elewacje"
    ],
    "hierarchy": "(111896) Dom i Ogród / Budownictwo i Akcesoria / Ściany i elewacje / Środki do gruntowania",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drążki meblowe",
    "categoryPath": [
      "(316213) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316213) Dom i Ogród / Meble / Akcesoria / Drążki meblowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Fronty",
    "categoryPath": [
      "(251004) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(251004) Dom i Ogród / Meble / Akcesoria / Fronty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Granulat",
    "categoryPath": [
      "(251005) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(251005) Dom i Ogród / Meble / Akcesoria / Granulat",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Hamulce i ograniczniki",
    "categoryPath": [
      "(112715) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112715) Dom i Ogród / Meble / Akcesoria / Hamulce i ograniczniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Komandorki",
    "categoryPath": [
      "(316808) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316808) Dom i Ogród / Meble / Akcesoria / Komandorki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Konfirmaty meblowe",
    "categoryPath": [
      "(316817) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316817) Dom i Ogród / Meble / Akcesoria / Konfirmaty meblowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kołki meblowe",
    "categoryPath": [
      "(314853) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(314853) Dom i Ogród / Meble / Akcesoria / Kołki meblowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kółka",
    "categoryPath": [
      "(112716) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112716) Dom i Ogród / Meble / Akcesoria / Kółka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Listwy przyblatowe",
    "categoryPath": [
      "(310217) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(310217) Dom i Ogród / Meble / Akcesoria / Listwy przyblatowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maty i organizery do szuflad i szafek",
    "categoryPath": [
      "(251009) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(251009) Dom i Ogród / Meble / Akcesoria / Maty i organizery do szuflad i szafek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mufy",
    "categoryPath": [
      "(318849) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(318849) Dom i Ogród / Meble / Akcesoria / Mufy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nogi i nóżki",
    "categoryPath": [
      "(112717) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112717) Dom i Ogród / Meble / Akcesoria / Nogi i nóżki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze meblowe",
    "categoryPath": [
      "(316799) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316799) Dom i Ogród / Meble / Akcesoria / Ochraniacze meblowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ociekarki",
    "categoryPath": [
      "(112718) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112718) Dom i Ogród / Meble / Akcesoria / Ociekarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Okleiny i naklejki",
    "categoryPath": [
      "(251007) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(251007) Dom i Ogród / Meble / Akcesoria / Okleiny i naklejki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pantografy do szafy",
    "categoryPath": [
      "(310229) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(310229) Dom i Ogród / Meble / Akcesoria / Pantografy do szafy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pasy do przenoszenia mebli",
    "categoryPath": [
      "(316811) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316811) Dom i Ogród / Meble / Akcesoria / Pasy do przenoszenia mebli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pianki i gąbki",
    "categoryPath": [
      "(316216) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316216) Dom i Ogród / Meble / Akcesoria / Pianki i gąbki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkładki i filc",
    "categoryPath": [
      "(251006) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(251006) Dom i Ogród / Meble / Akcesoria / Podkładki i filc",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podnośniki",
    "categoryPath": [
      "(112720) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112720) Dom i Ogród / Meble / Akcesoria / Podnośniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Poduszki na krzesła",
    "categoryPath": [
      "(320242) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(320242) Dom i Ogród / Meble / Akcesoria / Poduszki na krzesła",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podłokietniki",
    "categoryPath": [
      "(320813) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(320813) Dom i Ogród / Meble / Akcesoria / Podłokietniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112712) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112712) Dom i Ogród / Meble / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prowadnice",
    "categoryPath": [
      "(112721) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112721) Dom i Ogród / Meble / Akcesoria / Prowadnice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Przepusty kablowe",
    "categoryPath": [
      "(316814) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316814) Dom i Ogród / Meble / Akcesoria / Przepusty kablowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sortowanie śmieci",
    "categoryPath": [
      "(251008) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(251008) Dom i Ogród / Meble / Akcesoria / Sortowanie śmieci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Systemy przesuwne",
    "categoryPath": [
      "(316802) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316802) Dom i Ogród / Meble / Akcesoria / Systemy przesuwne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(112724) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112724) Dom i Ogród / Meble / Akcesoria / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty do szkła",
    "categoryPath": [
      "(318846) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(318846) Dom i Ogród / Meble / Akcesoria / Uchwyty do szkła",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(318840) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(318840) Dom i Ogród / Meble / Akcesoria / Wieszaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wsporniki do półek",
    "categoryPath": [
      "(318843) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(318843) Dom i Ogród / Meble / Akcesoria / Wsporniki do półek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zamki meblowe",
    "categoryPath": [
      "(316805) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(316805) Dom i Ogród / Meble / Akcesoria / Zamki meblowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(112725) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112725) Dom i Ogród / Meble / Akcesoria / Zawiasy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zaślepki do mebli",
    "categoryPath": [
      "(318852) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(318852) Dom i Ogród / Meble / Akcesoria / Zaślepki do mebli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Złącza meblowe",
    "categoryPath": [
      "(320834) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(320834) Dom i Ogród / Meble / Akcesoria / Złącza meblowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Środki pielęgnujące i naprawcze",
    "categoryPath": [
      "(112723) Dom i Ogród",
      "Meble",
      "Akcesoria"
    ],
    "hierarchy": "(112723) Dom i Ogród / Meble / Akcesoria / Środki pielęgnujące i naprawcze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Blaty kuchenne",
    "categoryPath": [
      "(260673) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(260673) Dom i Ogród / Meble / Kuchnia / Blaty kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Cargo i kosze",
    "categoryPath": [
      "(112714) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112714) Dom i Ogród / Meble / Kuchnia / Cargo i kosze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Hokery",
    "categoryPath": [
      "(112726) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112726) Dom i Ogród / Meble / Kuchnia / Hokery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kredensy i witryny",
    "categoryPath": [
      "(112727) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112727) Dom i Ogród / Meble / Kuchnia / Kredensy i witryny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(20265) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(20265) Dom i Ogród / Meble / Kuchnia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półki",
    "categoryPath": [
      "(112729) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112729) Dom i Ogród / Meble / Kuchnia / Półki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stołki i taborety",
    "categoryPath": [
      "(112730) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112730) Dom i Ogród / Meble / Kuchnia / Stołki i taborety",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły i krzesła zestawy",
    "categoryPath": [
      "(302701) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(302701) Dom i Ogród / Meble / Kuchnia / Stoły i krzesła zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły kuchenne",
    "categoryPath": [
      "(112731) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112731) Dom i Ogród / Meble / Kuchnia / Stoły kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki kuchenne",
    "categoryPath": [
      "(20266) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(20266) Dom i Ogród / Meble / Kuchnia / Szafki kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szuflady",
    "categoryPath": [
      "(112722) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112722) Dom i Ogród / Meble / Kuchnia / Szuflady",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wyspy kuchenne",
    "categoryPath": [
      "(319376) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(319376) Dom i Ogród / Meble / Kuchnia / Wyspy kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wózki kuchenne",
    "categoryPath": [
      "(320933) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(320933) Dom i Ogród / Meble / Kuchnia / Wózki kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy mebli kuchennych",
    "categoryPath": [
      "(112732) Dom i Ogród",
      "Meble",
      "Kuchnia"
    ],
    "hierarchy": "(112732) Dom i Ogród / Meble / Kuchnia / Zestawy mebli kuchennych",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Haki, wieszaki",
    "categoryPath": [
      "(321365) Dom i Ogród",
      "Meble",
      "Piwnica/garaż"
    ],
    "hierarchy": "(321365) Dom i Ogród / Meble / Piwnica/garaż / Haki, wieszaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Półki",
    "categoryPath": [
      "(251025) Dom i Ogród",
      "Meble",
      "Piwnica/garaż"
    ],
    "hierarchy": "(251025) Dom i Ogród / Meble / Piwnica/garaż / Półki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Regały",
    "categoryPath": [
      "(251024) Dom i Ogród",
      "Meble",
      "Piwnica/garaż"
    ],
    "hierarchy": "(251024) Dom i Ogród / Meble / Piwnica/garaż / Regały",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Skrzynki",
    "categoryPath": [
      "(261681) Dom i Ogród",
      "Meble",
      "Piwnica/garaż"
    ],
    "hierarchy": "(261681) Dom i Ogród / Meble / Piwnica/garaż / Skrzynki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafy gospodarcze",
    "categoryPath": [
      "(319962) Dom i Ogród",
      "Meble",
      "Piwnica/garaż"
    ],
    "hierarchy": "(319962) Dom i Ogród / Meble / Piwnica/garaż / Szafy gospodarcze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pomocniki kuchenne",
    "categoryPath": [
      "(319544) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Stoliki i krzesła"
    ],
    "hierarchy": "(319544) Dom i Ogród / Meble / Pokój dziecięcy / Stoliki i krzesła / Pomocniki kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy stoliki i krzesła",
    "categoryPath": [
      "(319541) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Stoliki i krzesła"
    ],
    "hierarchy": "(319541) Dom i Ogród / Meble / Pokój dziecięcy / Stoliki i krzesła / Zestawy stoliki i krzesła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki nocne",
    "categoryPath": [
      "(320998) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy"
    ],
    "hierarchy": "(320998) Dom i Ogród / Meble / Pokój dziecięcy / Szafki nocne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sofy i kanapy",
    "categoryPath": [
      "(319610) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Łóżka i kojce"
    ],
    "hierarchy": "(319610) Dom i Ogród / Meble / Pokój dziecięcy / Łóżka i kojce / Sofy i kanapy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżeczka drewniane",
    "categoryPath": [
      "(319593) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Łóżka i kojce"
    ],
    "hierarchy": "(319593) Dom i Ogród / Meble / Pokój dziecięcy / Łóżka i kojce / Łóżeczka drewniane",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżeczka turystyczne",
    "categoryPath": [
      "(319598) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Łóżka i kojce"
    ],
    "hierarchy": "(319598) Dom i Ogród / Meble / Pokój dziecięcy / Łóżka i kojce / Łóżeczka turystyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka piętrowe",
    "categoryPath": [
      "(319607) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Łóżka i kojce"
    ],
    "hierarchy": "(319607) Dom i Ogród / Meble / Pokój dziecięcy / Łóżka i kojce / Łóżka piętrowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka pojedyncze",
    "categoryPath": [
      "(319604) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Łóżka i kojce"
    ],
    "hierarchy": "(319604) Dom i Ogród / Meble / Pokój dziecięcy / Łóżka i kojce / Łóżka pojedyncze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka pozostałe",
    "categoryPath": [
      "(319613) Dom i Ogród",
      "Meble",
      "Pokój dziecięcy",
      "Łóżka i kojce"
    ],
    "hierarchy": "(319613) Dom i Ogród / Meble / Pokój dziecięcy / Łóżka i kojce / Łóżka pozostałe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Biurka",
    "categoryPath": [
      "(251028) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(251028) Dom i Ogród / Meble / Pokój młodzieżowy / Biurka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Biurka gamingowe",
    "categoryPath": [
      "(261158) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(261158) Dom i Ogród / Meble / Pokój młodzieżowy / Biurka gamingowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Komplety mebli",
    "categoryPath": [
      "(251030) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(251030) Dom i Ogród / Meble / Pokój młodzieżowy / Komplety mebli",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Materace",
    "categoryPath": [
      "(320020) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(320020) Dom i Ogród / Meble / Pokój młodzieżowy / Materace",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoliki i ławy",
    "categoryPath": [
      "(319884) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(319884) Dom i Ogród / Meble / Pokój młodzieżowy / Stoliki i ławy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki nocne",
    "categoryPath": [
      "(319887) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(319887) Dom i Ogród / Meble / Pokój młodzieżowy / Szafki nocne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(319890) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(319890) Dom i Ogród / Meble / Pokój młodzieżowy / Wieszaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka",
    "categoryPath": [
      "(251035) Dom i Ogród",
      "Meble",
      "Pokój młodzieżowy"
    ],
    "hierarchy": "(251035) Dom i Ogród / Meble / Pokój młodzieżowy / Łóżka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(527) Dom i Ogród",
      "Meble"
    ],
    "hierarchy": "(527) Dom i Ogród / Meble / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Biurka",
    "categoryPath": [
      "(20273) Dom i Ogród",
      "Meble",
      "Pracownia"
    ],
    "hierarchy": "(20273) Dom i Ogród / Meble / Pracownia / Biurka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fotele i krzesła",
    "categoryPath": [
      "(20274) Dom i Ogród",
      "Meble",
      "Pracownia"
    ],
    "hierarchy": "(20274) Dom i Ogród / Meble / Pracownia / Fotele i krzesła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fotele obrotowe",
    "categoryPath": [
      "(251011) Dom i Ogród",
      "Meble",
      "Pracownia"
    ],
    "hierarchy": "(251011) Dom i Ogród / Meble / Pracownia / Fotele obrotowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Klękosiady",
    "categoryPath": [
      "(319553) Dom i Ogród",
      "Meble",
      "Pracownia"
    ],
    "hierarchy": "(319553) Dom i Ogród / Meble / Pracownia / Klękosiady",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Podstawy do fotela",
    "categoryPath": [
      "(321980) Dom i Ogród",
      "Meble",
      "Pracownia"
    ],
    "hierarchy": "(321980) Dom i Ogród / Meble / Pracownia / Podstawy do fotela",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Regały",
    "categoryPath": [
      "(20272) Dom i Ogród",
      "Meble",
      "Pracownia"
    ],
    "hierarchy": "(20272) Dom i Ogród / Meble / Pracownia / Regały",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Garderoby i szafy",
    "categoryPath": [
      "(20276) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(20276) Dom i Ogród / Meble / Przedpokój / Garderoby i szafy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(251014) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(251014) Dom i Ogród / Meble / Przedpokój / Konsole",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Półki",
    "categoryPath": [
      "(112734) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(112734) Dom i Ogród / Meble / Przedpokój / Półki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stojaki na parasole",
    "categoryPath": [
      "(316693) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(316693) Dom i Ogród / Meble / Przedpokój / Stojaki na parasole",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki na buty",
    "categoryPath": [
      "(20277) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(20277) Dom i Ogród / Meble / Przedpokój / Szafki na buty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki na klucze",
    "categoryPath": [
      "(322096) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(322096) Dom i Ogród / Meble / Przedpokój / Szafki na klucze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(112733) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(112733) Dom i Ogród / Meble / Przedpokój / Wieszaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Ławki",
    "categoryPath": [
      "(251013) Dom i Ogród",
      "Meble",
      "Przedpokój"
    ],
    "hierarchy": "(251013) Dom i Ogród / Meble / Przedpokój / Ławki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fotele",
    "categoryPath": [
      "(20285) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20285) Dom i Ogród / Meble / Salon / Fotele",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kanapy",
    "categoryPath": [
      "(20283) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20283) Dom i Ogród / Meble / Salon / Kanapy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Komody",
    "categoryPath": [
      "(112735) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(112735) Dom i Ogród / Meble / Salon / Komody",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Komplety wypoczynkowe",
    "categoryPath": [
      "(20288) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20288) Dom i Ogród / Meble / Salon / Komplety wypoczynkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Krzesła",
    "categoryPath": [
      "(112737) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(112737) Dom i Ogród / Meble / Salon / Krzesła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Narożniki",
    "categoryPath": [
      "(20286) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20286) Dom i Ogród / Meble / Salon / Narożniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(20279) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20279) Dom i Ogród / Meble / Salon / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pufy",
    "categoryPath": [
      "(54090) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(54090) Dom i Ogród / Meble / Salon / Pufy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Półki",
    "categoryPath": [
      "(260600) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(260600) Dom i Ogród / Meble / Salon / Półki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Regały",
    "categoryPath": [
      "(20284) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20284) Dom i Ogród / Meble / Salon / Regały",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoliki i ławy",
    "categoryPath": [
      "(54089) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(54089) Dom i Ogród / Meble / Salon / Stoliki i ławy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(112738) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(112738) Dom i Ogród / Meble / Salon / Stoły",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły i krzesła zestawy",
    "categoryPath": [
      "(20287) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20287) Dom i Ogród / Meble / Salon / Stoły i krzesła zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki RTV",
    "categoryPath": [
      "(249162) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(249162) Dom i Ogród / Meble / Salon / Szafki RTV",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szezlongi",
    "categoryPath": [
      "(321368) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(321368) Dom i Ogród / Meble / Salon / Szezlongi",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Witryny",
    "categoryPath": [
      "(20281) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20281) Dom i Ogród / Meble / Salon / Witryny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy mebli",
    "categoryPath": [
      "(20280) Dom i Ogród",
      "Meble",
      "Salon"
    ],
    "hierarchy": "(20280) Dom i Ogród / Meble / Salon / Zestawy mebli",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Komody",
    "categoryPath": [
      "(20291) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(20291) Dom i Ogród / Meble / Sypialnia / Komody",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Komplety mebli",
    "categoryPath": [
      "(68645) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(68645) Dom i Ogród / Meble / Sypialnia / Komplety mebli",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Materace",
    "categoryPath": [
      "(20292) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(20292) Dom i Ogród / Meble / Sypialnia / Materace",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Panele tapicerowane",
    "categoryPath": [
      "(314841) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(314841) Dom i Ogród / Meble / Sypialnia / Panele tapicerowane",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(20289) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(20289) Dom i Ogród / Meble / Sypialnia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzynie",
    "categoryPath": [
      "(251018) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(251018) Dom i Ogród / Meble / Sypialnia / Skrzynie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stelaże",
    "categoryPath": [
      "(251017) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(251017) Dom i Ogród / Meble / Sypialnia / Stelaże",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki nocne",
    "categoryPath": [
      "(20294) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(20294) Dom i Ogród / Meble / Sypialnia / Szafki nocne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafy",
    "categoryPath": [
      "(20293) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(20293) Dom i Ogród / Meble / Sypialnia / Szafy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szuflady pod łóżko",
    "categoryPath": [
      "(68646) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(68646) Dom i Ogród / Meble / Sypialnia / Szuflady pod łóżko",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Toaletki",
    "categoryPath": [
      "(260620) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(260620) Dom i Ogród / Meble / Sypialnia / Toaletki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wezgłowia",
    "categoryPath": [
      "(322674) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(322674) Dom i Ogród / Meble / Sypialnia / Wezgłowia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka",
    "categoryPath": [
      "(20290) Dom i Ogród",
      "Meble",
      "Sypialnia"
    ],
    "hierarchy": "(20290) Dom i Ogród / Meble / Sypialnia / Łóżka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Blaty łazienkowe",
    "categoryPath": [
      "(322345) Dom i Ogród",
      "Meble",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(322345) Dom i Ogród / Meble / Łazienka i toaleta / Blaty łazienkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(68665) Dom i Ogród",
      "Meble",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(68665) Dom i Ogród / Meble / Łazienka i toaleta / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Regały",
    "categoryPath": [
      "(68667) Dom i Ogród",
      "Meble",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(68667) Dom i Ogród / Meble / Łazienka i toaleta / Regały",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki",
    "categoryPath": [
      "(68671) Dom i Ogród",
      "Meble",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(68671) Dom i Ogród / Meble / Łazienka i toaleta / Szafki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy mebli łazienkowych",
    "categoryPath": [
      "(68672) Dom i Ogród",
      "Meble",
      "Łazienka i toaleta"
    ],
    "hierarchy": "(68672) Dom i Ogród / Meble / Łazienka i toaleta / Zestawy mebli łazienkowych",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Agregaty prądotwórcze",
    "categoryPath": [
      "(147642) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147642) Dom i Ogród / Narzędzia / Agregaty prądotwórcze",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Bruzdownice",
    "categoryPath": [
      "(147644) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147644) Dom i Ogród / Narzędzia / Bruzdownice",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Bijaki",
    "categoryPath": [
      "(321600) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321600) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Bijaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Blokady",
    "categoryPath": [
      "(321579) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321579) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Blokady",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Bębny",
    "categoryPath": [
      "(314617) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314617) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Bębny",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Cewki",
    "categoryPath": [
      "(321597) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321597) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Cewki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Cięgna",
    "categoryPath": [
      "(321594) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321594) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Cięgna",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Cylindry",
    "categoryPath": [
      "(314497) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314497) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Cylindry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Dyfuzory",
    "categoryPath": [
      "(321564) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321564) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Dyfuzory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Dźwignie",
    "categoryPath": [
      "(321576) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321576) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Dźwignie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(314281) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314281) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Filtry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Gaźniki",
    "categoryPath": [
      "(314533) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314533) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Gaźniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Głowice",
    "categoryPath": [
      "(314557) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314557) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Głowice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Kliny",
    "categoryPath": [
      "(321612) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321612) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Kliny",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Klucze do szlifierek kątowych",
    "categoryPath": [
      "(321543) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321543) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Klucze do szlifierek kątowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Klucze do uchwytów wiertarskich",
    "categoryPath": [
      "(321546) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321546) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Klucze do uchwytów wiertarskich",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Korbowody",
    "categoryPath": [
      "(321591) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321591) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Korbowody",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Koła zębate",
    "categoryPath": [
      "(321549) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321549) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Koła zębate",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Kulki stalowe",
    "categoryPath": [
      "(321552) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321552) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Kulki stalowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Moduły elektroniczne",
    "categoryPath": [
      "(321582) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321582) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Moduły elektroniczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Nakrętki do szlifierek kątowych",
    "categoryPath": [
      "(321526) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321526) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Nakrętki do szlifierek kątowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Napinacze",
    "categoryPath": [
      "(321588) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321588) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Napinacze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(315876) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(315876) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Obudowy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(314569) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314569) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Osłony",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(314581) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314581) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Paski",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pierścienie",
    "categoryPath": [
      "(321570) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321570) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Pierścienie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Podkładki do szlifierek kątowych",
    "categoryPath": [
      "(321523) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321523) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Podkładki do szlifierek kątowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Prowadnice",
    "categoryPath": [
      "(314461) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314461) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Prowadnice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Przejściówki",
    "categoryPath": [
      "(314437) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314437) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Przejściówki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Przekładnie",
    "categoryPath": [
      "(321796) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321796) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Przekładnie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(321555) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321555) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Przewody",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Regulatory obrotów",
    "categoryPath": [
      "(321799) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321799) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Regulatory obrotów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Rolki",
    "categoryPath": [
      "(321558) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321558) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Rolki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Rozruszniki",
    "categoryPath": [
      "(314593) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314593) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Rozruszniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(314485) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314485) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Silniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Smary do wierteł",
    "categoryPath": [
      "(321517) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321517) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Smary do wierteł",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Sprzęgła",
    "categoryPath": [
      "(321603) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321603) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Sprzęgła",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Sprężyny",
    "categoryPath": [
      "(321567) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321567) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Sprężyny",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Stojany",
    "categoryPath": [
      "(315873) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(315873) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Stojany",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Sworznie tłoka",
    "categoryPath": [
      "(321520) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321520) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Sworznie tłoka",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Szczotki węglowe",
    "categoryPath": [
      "(132981) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(132981) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Szczotki węglowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Talerze szlifierskie",
    "categoryPath": [
      "(321585) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321585) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Talerze szlifierskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Tłoki",
    "categoryPath": [
      "(314521) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314521) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Tłoki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(314449) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314449) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Uchwyty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(314269) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314269) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Uszczelki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(321573) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321573) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Wentylatory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wirniki",
    "categoryPath": [
      "(315870) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(315870) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Wirniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wrzeciona",
    "categoryPath": [
      "(321606) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321606) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Wrzeciona",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Włączniki",
    "categoryPath": [
      "(314509) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314509) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Włączniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(314245) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314245) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Zawory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(321561) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(321561) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Zbiorniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Łańcuchy",
    "categoryPath": [
      "(314473) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314473) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Łańcuchy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(314605) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314605) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Łożyska",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Świece zapłonowe",
    "categoryPath": [
      "(314293) Dom i Ogród",
      "Narzędzia",
      "Części do elektronarzędzi"
    ],
    "hierarchy": "(314293) Dom i Ogród / Narzędzia / Części do elektronarzędzi / Świece zapłonowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Frezarki",
    "categoryPath": [
      "(147645) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147645) Dom i Ogród / Narzędzia / Frezarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Gwoździarki",
    "categoryPath": [
      "(319036) Dom i Ogród",
      "Narzędzia",
      "Gwoździarki i gwoździe"
    ],
    "hierarchy": "(319036) Dom i Ogród / Narzędzia / Gwoździarki i gwoździe / Gwoździarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Gwoździe",
    "categoryPath": [
      "(319039) Dom i Ogród",
      "Narzędzia",
      "Gwoździarki i gwoździe"
    ],
    "hierarchy": "(319039) Dom i Ogród / Narzędzia / Gwoździarki i gwoździe / Gwoździe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Imadła",
    "categoryPath": [
      "(147646) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147646) Dom i Ogród / Narzędzia / Imadła",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Lutownice",
    "categoryPath": [
      "(147648) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147648) Dom i Ogród / Narzędzia / Lutownice",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Mieszarki",
    "categoryPath": [
      "(257183) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(257183) Dom i Ogród / Narzędzia / Mieszarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Myjki ciśnieniowe",
    "categoryPath": [
      "(147652) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147652) Dom i Ogród / Narzędzia / Myjki ciśnieniowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Młotki, przecinaki i dłuta",
    "categoryPath": [
      "(147649) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147649) Dom i Ogród / Narzędzia / Młotki, przecinaki i dłuta",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Młotowiertarki",
    "categoryPath": [
      "(147650) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147650) Dom i Ogród / Narzędzia / Młotowiertarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Młoty udarowe",
    "categoryPath": [
      "(147651) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147651) Dom i Ogród / Narzędzia / Młoty udarowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Młoty wyburzeniowe",
    "categoryPath": [
      "(252042) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(252042) Dom i Ogród / Narzędzia / Młoty wyburzeniowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Giętarki do rur",
    "categoryPath": [
      "(306633) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306633) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Giętarki do rur",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Gwintownice do rur",
    "categoryPath": [
      "(306657) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306657) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Gwintownice do rur",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Kalibratory",
    "categoryPath": [
      "(306609) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306609) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Kalibratory",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Klucze hydrauliczne",
    "categoryPath": [
      "(306621) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306621) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Klucze hydrauliczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Noże termiczne",
    "categoryPath": [
      "(306645) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306645) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Noże termiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Nożyce do cięcia rur",
    "categoryPath": [
      "(306585) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306585) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Nożyce do cięcia rur",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Spirale kanalizacyjne",
    "categoryPath": [
      "(306549) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306549) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Spirale kanalizacyjne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zaciskarki do rur",
    "categoryPath": [
      "(306561) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306561) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Zaciskarki do rur",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Zgrzewarki do rur",
    "categoryPath": [
      "(306597) Dom i Ogród",
      "Narzędzia",
      "Narzędzia hydrauliczne"
    ],
    "hierarchy": "(306597) Dom i Ogród / Narzędzia / Narzędzia hydrauliczne / Zgrzewarki do rur",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Narzędzia wielofunkcyjne",
    "categoryPath": [
      "(320858) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(320858) Dom i Ogród / Narzędzia / Narzędzia wielofunkcyjne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Nożyce do blachy",
    "categoryPath": [
      "(256107) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(256107) Dom i Ogród / Narzędzia / Nożyce do blachy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Nożyki",
    "categoryPath": [
      "(319054) Dom i Ogród",
      "Narzędzia",
      "Nożyki i ostrza"
    ],
    "hierarchy": "(319054) Dom i Ogród / Narzędzia / Nożyki i ostrza / Nożyki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Ostrza",
    "categoryPath": [
      "(319057) Dom i Ogród",
      "Narzędzia",
      "Nożyki i ostrza"
    ],
    "hierarchy": "(319057) Dom i Ogród / Narzędzia / Nożyki i ostrza / Ostrza",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Odkurzacze piorące",
    "categoryPath": [
      "(257200) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(257200) Dom i Ogród / Narzędzia / Odkurzacze piorące",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Odkurzacze przemysłowe",
    "categoryPath": [
      "(147653) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147653) Dom i Ogród / Narzędzia / Odkurzacze przemysłowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(304173) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Akcesoria"
    ],
    "hierarchy": "(304173) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Akcesoria / Czapki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(322684) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Akcesoria"
    ],
    "hierarchy": "(322684) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Akcesoria / Kaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Buty wysokie",
    "categoryPath": [
      "(304137) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Obuwie"
    ],
    "hierarchy": "(304137) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Obuwie / Buty wysokie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Gumowce",
    "categoryPath": [
      "(304089) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Obuwie"
    ],
    "hierarchy": "(304089) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Obuwie / Gumowce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(304149) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Obuwie"
    ],
    "hierarchy": "(304149) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Obuwie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półbuty",
    "categoryPath": [
      "(304113) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Obuwie"
    ],
    "hierarchy": "(304113) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Obuwie / Półbuty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sandały",
    "categoryPath": [
      "(304101) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Obuwie"
    ],
    "hierarchy": "(304101) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Obuwie / Sandały",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trzewiki",
    "categoryPath": [
      "(304125) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Obuwie"
    ],
    "hierarchy": "(304125) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Obuwie / Trzewiki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(303981) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Odzież"
    ],
    "hierarchy": "(303981) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Fartuchy",
    "categoryPath": [
      "(322933) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Odzież"
    ],
    "hierarchy": "(322933) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Odzież / Fartuchy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule",
    "categoryPath": [
      "(304017) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Odzież"
    ],
    "hierarchy": "(304017) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Odzież / Koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(304029) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Odzież"
    ],
    "hierarchy": "(304029) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(304065) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza",
      "Odzież"
    ],
    "hierarchy": "(304065) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Odzież / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(259377) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza"
    ],
    "hierarchy": "(259377) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sprzęt asekuracyjny",
    "categoryPath": [
      "(322938) Dom i Ogród",
      "Narzędzia",
      "Odzież ochronna i robocza"
    ],
    "hierarchy": "(322938) Dom i Ogród / Narzędzia / Odzież ochronna i robocza / Sprzęt asekuracyjny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opalarki",
    "categoryPath": [
      "(147654) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147654) Dom i Ogród / Narzędzia / Opalarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Opaski magnetyczne",
    "categoryPath": [
      "(317420) Dom i Ogród",
      "Narzędzia",
      "Organizacja i przechowywanie narzędzi"
    ],
    "hierarchy": "(317420) Dom i Ogród / Narzędzia / Organizacja i przechowywanie narzędzi / Opaski magnetyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pasy narzędziowe",
    "categoryPath": [
      "(306237) Dom i Ogród",
      "Narzędzia",
      "Organizacja i przechowywanie narzędzi"
    ],
    "hierarchy": "(306237) Dom i Ogród / Narzędzia / Organizacja i przechowywanie narzędzi / Pasy narzędziowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Plecaki",
    "categoryPath": [
      "(306213) Dom i Ogród",
      "Narzędzia",
      "Organizacja i przechowywanie narzędzi"
    ],
    "hierarchy": "(306213) Dom i Ogród / Narzędzia / Organizacja i przechowywanie narzędzi / Plecaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Skrzynki narzędziowe",
    "categoryPath": [
      "(306189) Dom i Ogród",
      "Narzędzia",
      "Organizacja i przechowywanie narzędzi"
    ],
    "hierarchy": "(306189) Dom i Ogród / Narzędzia / Organizacja i przechowywanie narzędzi / Skrzynki narzędziowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Torby monterskie i walizki narzędziowe",
    "categoryPath": [
      "(306201) Dom i Ogród",
      "Narzędzia",
      "Organizacja i przechowywanie narzędzi"
    ],
    "hierarchy": "(306201) Dom i Ogród / Narzędzia / Organizacja i przechowywanie narzędzi / Torby monterskie i walizki narzędziowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wieszaki ścienne",
    "categoryPath": [
      "(306249) Dom i Ogród",
      "Narzędzia",
      "Organizacja i przechowywanie narzędzi"
    ],
    "hierarchy": "(306249) Dom i Ogród / Narzędzia / Organizacja i przechowywanie narzędzi / Wieszaki ścienne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wózki transportowe",
    "categoryPath": [
      "(320795) Dom i Ogród",
      "Narzędzia",
      "Organizacja i przechowywanie narzędzi",
      "Wózki narzędziowe i transportowe"
    ],
    "hierarchy": "(320795) Dom i Ogród / Narzędzia / Organizacja i przechowywanie narzędzi / Wózki narzędziowe i transportowe / Wózki transportowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Adaptery do elektronarzędzi",
    "categoryPath": [
      "(321170) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(321170) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Adaptery do elektronarzędzi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Akumulatory do elektronarzędzi",
    "categoryPath": [
      "(257357) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(257357) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Akumulatory do elektronarzędzi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Bity",
    "categoryPath": [
      "(147669) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147669) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Bity",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Brzeszczoty",
    "categoryPath": [
      "(147670) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147670) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Brzeszczoty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Dyski",
    "categoryPath": [
      "(322410) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(322410) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Dyski",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Dłuta",
    "categoryPath": [
      "(147672) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147672) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Dłuta",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Frezy",
    "categoryPath": [
      "(147673) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147673) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Frezy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Latarki akumulatorowe",
    "categoryPath": [
      "(321086) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(321086) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Latarki akumulatorowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Adaptery",
    "categoryPath": [
      "(314641) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314641) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Adaptery",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Dysze",
    "categoryPath": [
      "(314653) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314653) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Dysze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(314665) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314665) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Filtry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Lance",
    "categoryPath": [
      "(314677) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314677) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Lance",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pianownice",
    "categoryPath": [
      "(314689) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314689) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Pianownice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pistolety",
    "categoryPath": [
      "(314701) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314701) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Pistolety",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(314713) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314713) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Szczotki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(314725) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314725) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Węże",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Zestaw osprzętu",
    "categoryPath": [
      "(314749) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314749) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Zestaw osprzętu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Zestawy do piaskowania",
    "categoryPath": [
      "(314737) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt do myjek"
    ],
    "hierarchy": "(314737) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do myjek / Zestawy do piaskowania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Osprzęt do odkurzaczy",
    "categoryPath": [
      "(258227) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(258227) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt do odkurzaczy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Drut spawalniczy",
    "categoryPath": [
      "(314401) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt i materiały spawalnicze"
    ],
    "hierarchy": "(314401) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt i materiały spawalnicze / Drut spawalniczy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Elektrody spawalnicze",
    "categoryPath": [
      "(314329) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt i materiały spawalnicze"
    ],
    "hierarchy": "(314329) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt i materiały spawalnicze / Elektrody spawalnicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Filtry i szkła",
    "categoryPath": [
      "(314389) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt i materiały spawalnicze"
    ],
    "hierarchy": "(314389) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt i materiały spawalnicze / Filtry i szkła",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Uchwyty spawalnicze",
    "categoryPath": [
      "(314365) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi",
      "Osprzęt i materiały spawalnicze"
    ],
    "hierarchy": "(314365) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Osprzęt i materiały spawalnicze / Uchwyty spawalnicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Otwornice",
    "categoryPath": [
      "(147674) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147674) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Otwornice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Ołówki, rysiki, znaczniki",
    "categoryPath": [
      "(318401) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(318401) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Ołówki, rysiki, znaczniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147667) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147667) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyrządy do połączeń kołkowych",
    "categoryPath": [
      "(321122) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(321122) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Przyrządy do połączeń kołkowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Przystawki kątowe",
    "categoryPath": [
      "(321119) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(321119) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Przystawki kątowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Stojaki na wiertarki",
    "categoryPath": [
      "(321173) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(321173) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Stojaki na wiertarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(147675) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147675) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Szczotki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Tarcze",
    "categoryPath": [
      "(147676) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147676) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Tarcze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wiertła",
    "categoryPath": [
      "(147677) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147677) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Wiertła",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wkłady klejowe do pistoletów",
    "categoryPath": [
      "(308305) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(308305) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Wkłady klejowe do pistoletów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Worki na pył",
    "categoryPath": [
      "(321116) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(321116) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Worki na pył",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(147678) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(147678) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Zestawy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(314425) Dom i Ogród",
      "Narzędzia",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(314425) Dom i Ogród / Narzędzia / Osprzęt do elektronarzędzi / Ładowarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Ostrzałki",
    "categoryPath": [
      "(257184) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(257184) Dom i Ogród / Narzędzia / Ostrzałki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Palniki gazowe",
    "categoryPath": [
      "(322322) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(322322) Dom i Ogród / Narzędzia / Palniki gazowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pistolety do kleju",
    "categoryPath": [
      "(256911) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(256911) Dom i Ogród / Narzędzia / Pistolety do kleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pistolety do pianki",
    "categoryPath": [
      "(257185) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(257185) Dom i Ogród / Narzędzia / Pistolety do pianki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pistolety do silikonu",
    "categoryPath": [
      "(257186) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(257186) Dom i Ogród / Narzędzia / Pistolety do silikonu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pistolety malarskie",
    "categoryPath": [
      "(256910) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(256910) Dom i Ogród / Narzędzia / Pistolety malarskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Piły i pilarki",
    "categoryPath": [
      "(147655) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147655) Dom i Ogród / Narzędzia / Piły i pilarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Brzeszczoty do pił ręcznych",
    "categoryPath": [
      "(322403) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(322403) Dom i Ogród / Narzędzia / Piły i pilarki / Brzeszczoty do pił ręcznych",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Ostrzałki do łańcuchów",
    "categoryPath": [
      "(260878) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260878) Dom i Ogród / Narzędzia / Piły i pilarki / Ostrzałki do łańcuchów",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pilarko-zagłębiarki",
    "categoryPath": [
      "(260873) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260873) Dom i Ogród / Narzędzia / Piły i pilarki / Pilarko-zagłębiarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły ręczne",
    "categoryPath": [
      "(260874) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260874) Dom i Ogród / Narzędzia / Piły i pilarki / Piły ręczne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły stołowe",
    "categoryPath": [
      "(260879) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260879) Dom i Ogród / Narzędzia / Piły i pilarki / Piły stołowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły szablaste",
    "categoryPath": [
      "(260875) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260875) Dom i Ogród / Narzędzia / Piły i pilarki / Piły szablaste",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły tarczowe",
    "categoryPath": [
      "(260881) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260881) Dom i Ogród / Narzędzia / Piły i pilarki / Piły tarczowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły taśmowe",
    "categoryPath": [
      "(260884) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260884) Dom i Ogród / Narzędzia / Piły i pilarki / Piły taśmowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły ukośnice",
    "categoryPath": [
      "(260880) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260880) Dom i Ogród / Narzędzia / Piły i pilarki / Piły ukośnice",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły włosowe",
    "categoryPath": [
      "(260877) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260877) Dom i Ogród / Narzędzia / Piły i pilarki / Piły włosowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piły łańcuchowe",
    "categoryPath": [
      "(260872) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260872) Dom i Ogród / Narzędzia / Piły i pilarki / Piły łańcuchowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260876) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(260876) Dom i Ogród / Narzędzia / Piły i pilarki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzynki uciosowe",
    "categoryPath": [
      "(320947) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(320947) Dom i Ogród / Narzędzia / Piły i pilarki / Skrzynki uciosowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szyny prowadzące",
    "categoryPath": [
      "(321176) Dom i Ogród",
      "Narzędzia",
      "Piły i pilarki"
    ],
    "hierarchy": "(321176) Dom i Ogród / Narzędzia / Piły i pilarki / Szyny prowadzące",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(269) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(269) Dom i Ogród / Narzędzia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przecinarki do glazury",
    "categoryPath": [
      "(256908) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(256908) Dom i Ogród / Narzędzia / Przecinarki do glazury",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Dalmierze",
    "categoryPath": [
      "(110192) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(110192) Dom i Ogród / Narzędzia / Przyrządy miernicze / Dalmierze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Kątowniki i kątomierze",
    "categoryPath": [
      "(110193) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(110193) Dom i Ogród / Narzędzia / Przyrządy miernicze / Kątowniki i kątomierze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Lasery krzyżowe",
    "categoryPath": [
      "(303957) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(303957) Dom i Ogród / Narzędzia / Przyrządy miernicze / Lasery krzyżowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Miary i taśmy",
    "categoryPath": [
      "(26847) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(26847) Dom i Ogród / Narzędzia / Przyrządy miernicze / Miary i taśmy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Mierniki i testery",
    "categoryPath": [
      "(322921) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(322921) Dom i Ogród / Narzędzia / Przyrządy miernicze / Mierniki i testery",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Poziomice",
    "categoryPath": [
      "(26848) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(26848) Dom i Ogród / Narzędzia / Przyrządy miernicze / Poziomice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26849) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(26849) Dom i Ogród / Narzędzia / Przyrządy miernicze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sznur traserski",
    "categoryPath": [
      "(321092) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(321092) Dom i Ogród / Narzędzia / Przyrządy miernicze / Sznur traserski",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wykrywacze",
    "categoryPath": [
      "(110194) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(110194) Dom i Ogród / Narzędzia / Przyrządy miernicze / Wykrywacze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wzorniki, szablony",
    "categoryPath": [
      "(321125) Dom i Ogród",
      "Narzędzia",
      "Przyrządy miernicze"
    ],
    "hierarchy": "(321125) Dom i Ogród / Narzędzia / Przyrządy miernicze / Wzorniki, szablony",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Radia budowlane",
    "categoryPath": [
      "(256909) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(256909) Dom i Ogród / Narzędzia / Radia budowlane",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(306129) Dom i Ogród",
      "Narzędzia",
      "Spawarki"
    ],
    "hierarchy": "(306129) Dom i Ogród / Narzędzia / Spawarki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przecinarki plazmowe",
    "categoryPath": [
      "(306117) Dom i Ogród",
      "Narzędzia",
      "Spawarki"
    ],
    "hierarchy": "(306117) Dom i Ogród / Narzędzia / Spawarki / Przecinarki plazmowe",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Półautomaty spawalnicze",
    "categoryPath": [
      "(306093) Dom i Ogród",
      "Narzędzia",
      "Spawarki"
    ],
    "hierarchy": "(306093) Dom i Ogród / Narzędzia / Spawarki / Półautomaty spawalnicze",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Spawarki inwertorowe",
    "categoryPath": [
      "(306081) Dom i Ogród",
      "Narzędzia",
      "Spawarki"
    ],
    "hierarchy": "(306081) Dom i Ogród / Narzędzia / Spawarki / Spawarki inwertorowe",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Spawarki transformatorowe",
    "categoryPath": [
      "(306105) Dom i Ogród",
      "Narzędzia",
      "Spawarki"
    ],
    "hierarchy": "(306105) Dom i Ogród / Narzędzia / Spawarki / Spawarki transformatorowe",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Strugi",
    "categoryPath": [
      "(147658) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147658) Dom i Ogród / Narzędzia / Strugi",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szczypce, nożyce, obcęgi",
    "categoryPath": [
      "(147659) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147659) Dom i Ogród / Narzędzia / Szczypce, nożyce, obcęgi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Szlifierki do betonu",
    "categoryPath": [
      "(321359) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(321359) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki do betonu",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki do gipsu",
    "categoryPath": [
      "(310849) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310849) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki do gipsu",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki kątowe",
    "categoryPath": [
      "(310825) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310825) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki kątowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki mimośrodowe",
    "categoryPath": [
      "(310861) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310861) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki mimośrodowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki oscylacyjne",
    "categoryPath": [
      "(310873) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310873) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki oscylacyjne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki proste",
    "categoryPath": [
      "(310909) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310909) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki proste",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki stołowe",
    "categoryPath": [
      "(310837) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310837) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki stołowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki taśmowe",
    "categoryPath": [
      "(310885) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310885) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki taśmowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Szlifierki wielofunkcyjne",
    "categoryPath": [
      "(310897) Dom i Ogród",
      "Narzędzia",
      "Szlifierki"
    ],
    "hierarchy": "(310897) Dom i Ogród / Narzędzia / Szlifierki / Szlifierki wielofunkcyjne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Listwy zbierające do myjek",
    "categoryPath": [
      "(321631) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(321631) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Listwy zbierające do myjek",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Mopy parowe",
    "categoryPath": [
      "(258822) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(258822) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Mopy parowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Myjki do okien",
    "categoryPath": [
      "(258824) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(258824) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Myjki do okien",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Nakładki do mopów parowych",
    "categoryPath": [
      "(321619) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(321619) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Nakładki do mopów parowych",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Parownice",
    "categoryPath": [
      "(258823) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(258823) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Parownice",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Podkładki od mopów parowych",
    "categoryPath": [
      "(321628) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(321628) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Podkładki od mopów parowych",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258826) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(258826) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szczotki do parownic",
    "categoryPath": [
      "(321622) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(321622) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Szczotki do parownic",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wkłady do myjek do okien",
    "categoryPath": [
      "(321625) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(321625) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Wkłady do myjek do okien",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(321634) Dom i Ogród",
      "Narzędzia",
      "Urządzenia czyszczące"
    ],
    "hierarchy": "(321634) Dom i Ogród / Narzędzia / Urządzenia czyszczące / Ładowarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wciągarki",
    "categoryPath": [
      "(257187) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(257187) Dom i Ogród / Narzędzia / Wciągarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wiertarki",
    "categoryPath": [
      "(252043) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(252043) Dom i Ogród / Narzędzia / Wiertarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wiertnice",
    "categoryPath": [
      "(254844) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(254844) Dom i Ogród / Narzędzia / Wiertnice",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wkrętaki",
    "categoryPath": [
      "(147661) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147661) Dom i Ogród / Narzędzia / Wkrętaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Wkrętarki",
    "categoryPath": [
      "(147662) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147662) Dom i Ogród / Narzędzia / Wkrętarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wyrzynarki",
    "categoryPath": [
      "(147663) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147663) Dom i Ogród / Narzędzia / Wyrzynarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Zakrętarki udarowe",
    "categoryPath": [
      "(320801) Dom i Ogród",
      "Narzędzia",
      "Zakrętarki i klucze udarowe"
    ],
    "hierarchy": "(320801) Dom i Ogród / Narzędzia / Zakrętarki i klucze udarowe / Zakrętarki udarowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Zestawy elektronarzędzi",
    "categoryPath": [
      "(300893) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(300893) Dom i Ogród / Narzędzia / Zestawy elektronarzędzi",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Zgrzewarki",
    "categoryPath": [
      "(147664) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(147664) Dom i Ogród / Narzędzia / Zgrzewarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Zszywacze",
    "categoryPath": [
      "(319850) Dom i Ogród",
      "Narzędzia",
      "Zszywacze i zszywki"
    ],
    "hierarchy": "(319850) Dom i Ogród / Narzędzia / Zszywacze i zszywki / Zszywacze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Zszywki",
    "categoryPath": [
      "(319853) Dom i Ogród",
      "Narzędzia",
      "Zszywacze i zszywki"
    ],
    "hierarchy": "(319853) Dom i Ogród / Narzędzia / Zszywacze i zszywki / Zszywki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Ściski",
    "categoryPath": [
      "(257191) Dom i Ogród",
      "Narzędzia"
    ],
    "hierarchy": "(257191) Dom i Ogród / Narzędzia / Ściski",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D7"
  },
  {
    "segment": "Agrowłókniny",
    "categoryPath": [
      "(126186) Dom i Ogród",
      "Ogród",
      "Agrowłókniny i akcesoria"
    ],
    "hierarchy": "(126186) Dom i Ogród / Ogród / Agrowłókniny i akcesoria / Agrowłókniny",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szpilki i kołki",
    "categoryPath": [
      "(320197) Dom i Ogród",
      "Ogród",
      "Agrowłókniny i akcesoria"
    ],
    "hierarchy": "(320197) Dom i Ogród / Ogród / Agrowłókniny i akcesoria / Szpilki i kołki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Chemia",
    "categoryPath": [
      "(316169) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316169) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Chemia",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Druty",
    "categoryPath": [
      "(316163) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316163) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Druty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Etykiety i banderole",
    "categoryPath": [
      "(316300) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316300) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Etykiety i banderole",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Hodowla matek",
    "categoryPath": [
      "(316576) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316576) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Hodowla matek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Izolatory",
    "categoryPath": [
      "(316573) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316573) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Izolatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miodarki",
    "categoryPath": [
      "(316154) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316154) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Miodarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odstojniki",
    "categoryPath": [
      "(316175) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316175) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Odstojniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkarmiaczki",
    "categoryPath": [
      "(316166) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316166) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Podkarmiaczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkurzacze",
    "categoryPath": [
      "(316172) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316172) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Podkurzacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokarmy",
    "categoryPath": [
      "(316148) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316148) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Pokarmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ramki",
    "categoryPath": [
      "(316567) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316567) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Ramki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sprzęt pasieczny",
    "categoryPath": [
      "(316570) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316570) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Sprzęt pasieczny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Strój pszczelarski",
    "categoryPath": [
      "(316157) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316157) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Strój pszczelarski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Słoiki",
    "categoryPath": [
      "(316146) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316146) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Słoiki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ule i komponenty",
    "categoryPath": [
      "(316145) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316145) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Ule i komponenty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Węzy",
    "categoryPath": [
      "(316151) Dom i Ogród",
      "Ogród",
      "Akcesoria pszczelarskie"
    ],
    "hierarchy": "(316151) Dom i Ogród / Ogród / Akcesoria pszczelarskie / Węzy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(320758) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(320758) Dom i Ogród / Ogród / Architektura ogrodowa / Akcesoria montażowe / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podstawy słupa",
    "categoryPath": [
      "(320749) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(320749) Dom i Ogród / Ogród / Architektura ogrodowa / Akcesoria montażowe / Podstawy słupa",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wkręty",
    "categoryPath": [
      "(320752) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(320752) Dom i Ogród / Ogród / Architektura ogrodowa / Akcesoria montażowe / Wkręty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wsporniki",
    "categoryPath": [
      "(320755) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa",
      "Akcesoria montażowe"
    ],
    "hierarchy": "(320755) Dom i Ogród / Ogród / Architektura ogrodowa / Akcesoria montażowe / Wsporniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Altany, wiaty, zadaszenia",
    "categoryPath": [
      "(82282) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(82282) Dom i Ogród / Ogród / Architektura ogrodowa / Altany, wiaty, zadaszenia",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Chemia do architektury ogrodowej",
    "categoryPath": [
      "(256668) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(256668) Dom i Ogród / Ogród / Architektura ogrodowa / Chemia do architektury ogrodowej",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Części i osprzęt",
    "categoryPath": [
      "(261626) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(261626) Dom i Ogród / Ogród / Architektura ogrodowa / Części i osprzęt",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Domki",
    "categoryPath": [
      "(82283) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(82283) Dom i Ogród / Ogród / Architektura ogrodowa / Domki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Domki dla dzieci",
    "categoryPath": [
      "(318882) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(318882) Dom i Ogród / Ogród / Architektura ogrodowa / Domki dla dzieci",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Drewutnie",
    "categoryPath": [
      "(256670) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(256670) Dom i Ogród / Ogród / Architektura ogrodowa / Drewutnie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Gabiony",
    "categoryPath": [
      "(256669) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(256669) Dom i Ogród / Ogród / Architektura ogrodowa / Gabiony",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Mała infrastruktura",
    "categoryPath": [
      "(261625) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(261625) Dom i Ogród / Ogród / Architektura ogrodowa / Mała infrastruktura",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Obrzeża",
    "categoryPath": [
      "(82278) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(82278) Dom i Ogród / Ogród / Architektura ogrodowa / Obrzeża",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pawilony i namioty",
    "categoryPath": [
      "(124003) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(124003) Dom i Ogród / Ogród / Architektura ogrodowa / Pawilony i namioty",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pergole i trejaże",
    "categoryPath": [
      "(82281) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(82281) Dom i Ogród / Ogród / Architektura ogrodowa / Pergole i trejaże",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Plandeki",
    "categoryPath": [
      "(99709) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(99709) Dom i Ogród / Ogród / Architektura ogrodowa / Plandeki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Podesty i deski tarasowe",
    "categoryPath": [
      "(254138) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(254138) Dom i Ogród / Ogród / Architektura ogrodowa / Podesty i deski tarasowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82277) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(82277) Dom i Ogród / Ogród / Architektura ogrodowa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sauny i balie ogrodowe",
    "categoryPath": [
      "(300465) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(300465) Dom i Ogród / Ogród / Architektura ogrodowa / Sauny i balie ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szklarnie",
    "categoryPath": [
      "(82279) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(82279) Dom i Ogród / Ogród / Architektura ogrodowa / Szklarnie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Tunele foliowe",
    "categoryPath": [
      "(82280) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(82280) Dom i Ogród / Ogród / Architektura ogrodowa / Tunele foliowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Tyczki",
    "categoryPath": [
      "(261624) Dom i Ogród",
      "Ogród",
      "Architektura ogrodowa"
    ],
    "hierarchy": "(261624) Dom i Ogród / Ogród / Architektura ogrodowa / Tyczki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drabinki",
    "categoryPath": [
      "(316127) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(316127) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Drabinki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odkurzacze",
    "categoryPath": [
      "(316121) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(316121) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Odkurzacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Oświetlenie basenowe",
    "categoryPath": [
      "(320584) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(320584) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Oświetlenie basenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podgrzewacze basenowe",
    "categoryPath": [
      "(319559) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(319559) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Podgrzewacze basenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(316124) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(316124) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Pompy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Prysznice ogrodowe",
    "categoryPath": [
      "(320587) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(320587) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Prysznice ogrodowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Siatki i podbieraki",
    "categoryPath": [
      "(316133) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(316133) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Siatki i podbieraki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Termometry",
    "categoryPath": [
      "(316139) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(316139) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Termometry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(316130) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(316130) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Węże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(316136) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(316136) Dom i Ogród / Ogród / Baseny i akcesoria / Akcesoria / Zestawy naprawcze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Baseny",
    "categoryPath": [
      "(49846) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria"
    ],
    "hierarchy": "(49846) Dom i Ogród / Ogród / Baseny i akcesoria / Baseny",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Chemia basenowa",
    "categoryPath": [
      "(110020) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria"
    ],
    "hierarchy": "(110020) Dom i Ogród / Ogród / Baseny i akcesoria / Chemia basenowa",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Jacuzzi",
    "categoryPath": [
      "(302390) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria"
    ],
    "hierarchy": "(302390) Dom i Ogród / Ogród / Baseny i akcesoria / Jacuzzi",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pokrywy, folie, plandeki",
    "categoryPath": [
      "(110021) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria"
    ],
    "hierarchy": "(110021) Dom i Ogród / Ogród / Baseny i akcesoria / Pokrywy, folie, plandeki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pompy i filtry",
    "categoryPath": [
      "(110022) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria"
    ],
    "hierarchy": "(110022) Dom i Ogród / Ogród / Baseny i akcesoria / Pompy i filtry",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(110023) Dom i Ogród",
      "Ogród",
      "Baseny i akcesoria"
    ],
    "hierarchy": "(110023) Dom i Ogród / Ogród / Baseny i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Drabinki",
    "categoryPath": [
      "(316106) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki",
      "Akcesoria"
    ],
    "hierarchy": "(316106) Dom i Ogród / Ogród / Doniczki i pojemniki / Akcesoria / Drabinki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tyczki",
    "categoryPath": [
      "(316115) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki",
      "Akcesoria"
    ],
    "hierarchy": "(316115) Dom i Ogród / Ogród / Doniczki i pojemniki / Akcesoria / Tyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Beczki",
    "categoryPath": [
      "(261593) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(261593) Dom i Ogród / Ogród / Doniczki i pojemniki / Beczki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Doniczki",
    "categoryPath": [
      "(126202) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(126202) Dom i Ogród / Ogród / Doniczki i pojemniki / Doniczki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kwietniki",
    "categoryPath": [
      "(126203) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(126203) Dom i Ogród / Ogród / Doniczki i pojemniki / Kwietniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Miniszklarenki",
    "categoryPath": [
      "(126204) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(126204) Dom i Ogród / Ogród / Doniczki i pojemniki / Miniszklarenki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Osłonki",
    "categoryPath": [
      "(126205) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(126205) Dom i Ogród / Ogród / Doniczki i pojemniki / Osłonki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Podstawki pod doniczki",
    "categoryPath": [
      "(254139) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(254139) Dom i Ogród / Ogród / Doniczki i pojemniki / Podstawki pod doniczki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(126201) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(126201) Dom i Ogród / Ogród / Doniczki i pojemniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzynki balkonowe",
    "categoryPath": [
      "(126206) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(126206) Dom i Ogród / Ogród / Doniczki i pojemniki / Skrzynki balkonowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Uchwyty i wieszaki do skrzynek i donic",
    "categoryPath": [
      "(254140) Dom i Ogród",
      "Ogród",
      "Doniczki i pojemniki"
    ],
    "hierarchy": "(254140) Dom i Ogród / Ogród / Doniczki i pojemniki / Uchwyty i wieszaki do skrzynek i donic",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Dmuchawy do grilla",
    "categoryPath": [
      "(316721) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316721) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Dmuchawy do grilla",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Dodatki",
    "categoryPath": [
      "(261575) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(261575) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Dodatki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fartuchy do grillowania",
    "categoryPath": [
      "(316751) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316751) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Fartuchy do grillowania",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Haki wędzarnicze",
    "categoryPath": [
      "(316754) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316754) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Haki wędzarnicze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Maty do grilla",
    "categoryPath": [
      "(316724) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316724) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Maty do grilla",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pokrowce na grilla",
    "categoryPath": [
      "(316730) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316730) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Pokrowce na grilla",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Płyty grillowe",
    "categoryPath": [
      "(316727) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316727) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Płyty grillowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rozpalanie",
    "categoryPath": [
      "(316757) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316757) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Rozpalanie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rożna",
    "categoryPath": [
      "(320245) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(320245) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Rożna",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Ruszty",
    "categoryPath": [
      "(316733) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316733) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Ruszty",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(320383) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(320383) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Rękawice",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szczotki do rusztów",
    "categoryPath": [
      "(316736) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316736) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Szczotki do rusztów",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sztućce do grillowania",
    "categoryPath": [
      "(316748) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316748) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Sztućce do grillowania",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Tacki",
    "categoryPath": [
      "(316745) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316745) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Tacki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Termometry grillowe",
    "categoryPath": [
      "(316763) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316763) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Termometry grillowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Widelce ogniskowe i szaszłyki",
    "categoryPath": [
      "(316739) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316739) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Widelce ogniskowe i szaszłyki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zrębki",
    "categoryPath": [
      "(316760) Dom i Ogród",
      "Ogród",
      "Grillowanie",
      "Części i przybory"
    ],
    "hierarchy": "(316760) Dom i Ogród / Ogród / Grillowanie / Części i przybory / Zrębki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Grille betonowe",
    "categoryPath": [
      "(320251) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(320251) Dom i Ogród / Ogród / Grillowanie / Grille betonowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Grille elektryczne",
    "categoryPath": [
      "(260556) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(260556) Dom i Ogród / Ogród / Grillowanie / Grille elektryczne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Grille gazowe",
    "categoryPath": [
      "(260555) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(260555) Dom i Ogród / Ogród / Grillowanie / Grille gazowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Grille węglowe",
    "categoryPath": [
      "(82269) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(82269) Dom i Ogród / Ogród / Grillowanie / Grille węglowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kociołki",
    "categoryPath": [
      "(82270) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(82270) Dom i Ogród / Ogród / Grillowanie / Kociołki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Paleniska ogrodowe",
    "categoryPath": [
      "(260557) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(260557) Dom i Ogród / Ogród / Grillowanie / Paleniska ogrodowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82272) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(82272) Dom i Ogród / Ogród / Grillowanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rozpałki i brykiety",
    "categoryPath": [
      "(99561) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(99561) Dom i Ogród / Ogród / Grillowanie / Rozpałki i brykiety",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wędzarnie",
    "categoryPath": [
      "(101549) Dom i Ogród",
      "Ogród",
      "Grillowanie"
    ],
    "hierarchy": "(101549) Dom i Ogród / Ogród / Grillowanie / Wędzarnie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kompostowniki",
    "categoryPath": [
      "(126183) Dom i Ogród",
      "Ogród"
    ],
    "hierarchy": "(126183) Dom i Ogród / Ogród / Kompostowniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Markizy, osłony, maty",
    "categoryPath": [
      "(254141) Dom i Ogród",
      "Ogród"
    ],
    "hierarchy": "(254141) Dom i Ogród / Ogród / Markizy, osłony, maty",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Barki ogrodowe",
    "categoryPath": [
      "(261595) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(261595) Dom i Ogród / Ogród / Meble ogrodowe / Barki ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Części i dodatki",
    "categoryPath": [
      "(261599) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(261599) Dom i Ogród / Ogród / Meble ogrodowe / Części i dodatki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fotele wiszące",
    "categoryPath": [
      "(257757) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(257757) Dom i Ogród / Ogród / Meble ogrodowe / Fotele wiszące",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Hamaki",
    "categoryPath": [
      "(82257) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(82257) Dom i Ogród / Ogród / Meble ogrodowe / Hamaki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Huśtawki",
    "categoryPath": [
      "(82258) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(82258) Dom i Ogród / Ogród / Meble ogrodowe / Huśtawki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Komplety mebli",
    "categoryPath": [
      "(257756) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(257756) Dom i Ogród / Ogród / Meble ogrodowe / Komplety mebli",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Krzesła",
    "categoryPath": [
      "(257755) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(257755) Dom i Ogród / Ogród / Meble ogrodowe / Krzesła",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Leżaki i leżanki",
    "categoryPath": [
      "(82259) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(82259) Dom i Ogród / Ogród / Meble ogrodowe / Leżaki i leżanki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Parasole grzewcze",
    "categoryPath": [
      "(257758) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(257758) Dom i Ogród / Ogród / Meble ogrodowe / Parasole grzewcze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Oświetlenie do parasoli",
    "categoryPath": [
      "(320434) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe",
      "Parasole ogrodowe i akcesoria"
    ],
    "hierarchy": "(320434) Dom i Ogród / Ogród / Meble ogrodowe / Parasole ogrodowe i akcesoria / Oświetlenie do parasoli",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Parasole ogrodowe",
    "categoryPath": [
      "(82261) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe",
      "Parasole ogrodowe i akcesoria"
    ],
    "hierarchy": "(82261) Dom i Ogród / Ogród / Meble ogrodowe / Parasole ogrodowe i akcesoria / Parasole ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Podstawy do parasoli",
    "categoryPath": [
      "(320431) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe",
      "Parasole ogrodowe i akcesoria"
    ],
    "hierarchy": "(320431) Dom i Ogród / Ogród / Meble ogrodowe / Parasole ogrodowe i akcesoria / Podstawy do parasoli",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(320437) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe",
      "Parasole ogrodowe i akcesoria"
    ],
    "hierarchy": "(320437) Dom i Ogród / Ogród / Meble ogrodowe / Parasole ogrodowe i akcesoria / Pokrowce",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(249002) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(249002) Dom i Ogród / Ogród / Meble ogrodowe / Poduszki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pokrowce ogrodowe",
    "categoryPath": [
      "(261596) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(261596) Dom i Ogród / Ogród / Meble ogrodowe / Pokrowce ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82263) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(82263) Dom i Ogród / Ogród / Meble ogrodowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzynie ogrodowe",
    "categoryPath": [
      "(257759) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(257759) Dom i Ogród / Ogród / Meble ogrodowe / Skrzynie ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły i krzesła",
    "categoryPath": [
      "(82262) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(82262) Dom i Ogród / Ogród / Meble ogrodowe / Stoły i krzesła",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły i stoliki",
    "categoryPath": [
      "(257754) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(257754) Dom i Ogród / Ogród / Meble ogrodowe / Stoły i stoliki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Suszarki ogrodowe",
    "categoryPath": [
      "(261597) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(261597) Dom i Ogród / Ogród / Meble ogrodowe / Suszarki ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafy i regały ogrodowe",
    "categoryPath": [
      "(261598) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(261598) Dom i Ogród / Ogród / Meble ogrodowe / Szafy i regały ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Ławy i ławki",
    "categoryPath": [
      "(82260) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(82260) Dom i Ogród / Ogród / Meble ogrodowe / Ławy i ławki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka ogrodowe",
    "categoryPath": [
      "(318819) Dom i Ogród",
      "Ogród",
      "Meble ogrodowe"
    ],
    "hierarchy": "(318819) Dom i Ogród / Ogród / Meble ogrodowe / Łóżka ogrodowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Cylindry",
    "categoryPath": [
      "(318531) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318531) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Cylindry",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gaźniki do kos",
    "categoryPath": [
      "(318564) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318564) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Gaźniki do kos",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Głowice",
    "categoryPath": [
      "(318537) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318537) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Głowice",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne części i akcesoria",
    "categoryPath": [
      "(318585) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318585) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Inne części i akcesoria",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kliny do drewna",
    "categoryPath": [
      "(322455) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(322455) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Kliny do drewna",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koła",
    "categoryPath": [
      "(318540) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318540) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Koła",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Oleje",
    "categoryPath": [
      "(318543) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318543) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Oleje",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(318546) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318546) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Osłony",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Prowadnice do pił",
    "categoryPath": [
      "(318582) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318582) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Prowadnice do pił",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Przystawki",
    "categoryPath": [
      "(318549) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318549) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Przystawki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rozruszniki",
    "categoryPath": [
      "(318552) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318552) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Rozruszniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Silniki do kos",
    "categoryPath": [
      "(318567) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318567) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Silniki do kos",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sprężyny",
    "categoryPath": [
      "(318555) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318555) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Sprężyny",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczotki do kos",
    "categoryPath": [
      "(318570) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318570) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Szczotki do kos",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szelki do kos",
    "categoryPath": [
      "(318573) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318573) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Szelki do kos",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tarcze do kos",
    "categoryPath": [
      "(318576) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318576) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Tarcze do kos",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Torby na liście",
    "categoryPath": [
      "(318558) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318558) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Torby na liście",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łańcuchy do pił",
    "categoryPath": [
      "(318579) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318579) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Łańcuchy do pił",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Żyłki",
    "categoryPath": [
      "(318561) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Części i akcesoria"
    ],
    "hierarchy": "(318561) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Części i akcesoria / Żyłki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Glebogryzarki",
    "categoryPath": [
      "(85194) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85194) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Glebogryzarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Grabie",
    "categoryPath": [
      "(85195) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85195) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Grabie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(318437) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318437) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Akumulatory",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Cewki",
    "categoryPath": [
      "(320014) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320014) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Cewki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Deflektory",
    "categoryPath": [
      "(320044) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320044) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Deflektory",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Drążki",
    "categoryPath": [
      "(320053) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320053) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Drążki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Dętki",
    "categoryPath": [
      "(320047) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320047) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Dętki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Dźwignie",
    "categoryPath": [
      "(320056) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320056) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Dźwignie",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(318425) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318425) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Filtry",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Gaźniki",
    "categoryPath": [
      "(318440) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318440) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Gaźniki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(318459) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318459) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Inne akcesoria",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(320062) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320062) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Korki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kosiska",
    "categoryPath": [
      "(320017) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320017) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Kosiska",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kosze",
    "categoryPath": [
      "(320059) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320059) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Kosze",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Koła",
    "categoryPath": [
      "(318434) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318434) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Koła",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kraniki",
    "categoryPath": [
      "(320065) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320065) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Kraniki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Linki",
    "categoryPath": [
      "(321508) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(321508) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Linki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Noże",
    "categoryPath": [
      "(318410) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318410) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Noże",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Oleje",
    "categoryPath": [
      "(318419) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318419) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Oleje",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(320068) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320068) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Osłony",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(318413) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318413) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Paski",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Piasty",
    "categoryPath": [
      "(318453) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318453) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Piasty",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pierścienie",
    "categoryPath": [
      "(320071) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320071) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Pierścienie",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Przekładnie napędu",
    "categoryPath": [
      "(318422) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318422) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Przekładnie napędu",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Regulatory i sprężyny",
    "categoryPath": [
      "(320074) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320074) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Regulatory i sprężyny",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Rozruszniki",
    "categoryPath": [
      "(318428) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318428) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Rozruszniki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Siedzenia",
    "categoryPath": [
      "(320080) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320080) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Siedzenia",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(318416) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318416) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Silniki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Solenoidy",
    "categoryPath": [
      "(320077) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320077) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Solenoidy",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Sprzęgła",
    "categoryPath": [
      "(320083) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320083) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Sprzęgła",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Stacyjki",
    "categoryPath": [
      "(320101) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320101) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Stacyjki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Startery",
    "categoryPath": [
      "(318444) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318444) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Startery",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Tuleje",
    "categoryPath": [
      "(320086) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320086) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Tuleje",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(318447) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318447) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Uszczelki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wałki",
    "categoryPath": [
      "(320089) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320089) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Wałki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(320092) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320092) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Wentylatory",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(320098) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320098) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Zawory",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Zębatki",
    "categoryPath": [
      "(320095) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(320095) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Zębatki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(318431) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318431) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Łożyska",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Świece",
    "categoryPath": [
      "(318456) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki",
      "Części i akcesoria do kosiarek"
    ],
    "hierarchy": "(318456) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Części i akcesoria do kosiarek / Świece",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kosiarki akumulatorowe",
    "categoryPath": [
      "(260335) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki"
    ],
    "hierarchy": "(260335) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Kosiarki akumulatorowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kosiarki elektryczne",
    "categoryPath": [
      "(85212) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki"
    ],
    "hierarchy": "(85212) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Kosiarki elektryczne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kosiarki ręczne",
    "categoryPath": [
      "(313637) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki"
    ],
    "hierarchy": "(313637) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Kosiarki ręczne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kosiarki spalinowe",
    "categoryPath": [
      "(85213) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki"
    ],
    "hierarchy": "(85213) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Kosiarki spalinowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Roboty koszące",
    "categoryPath": [
      "(260696) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki"
    ],
    "hierarchy": "(260696) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Roboty koszące",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Traktorki",
    "categoryPath": [
      "(318184) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze",
      "Kosiarki"
    ],
    "hierarchy": "(318184) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosiarki / Traktorki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Kosy i podkaszarki",
    "categoryPath": [
      "(85197) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85197) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Kosy i podkaszarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Miotły i szczotki",
    "categoryPath": [
      "(99705) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(99705) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Miotły i szczotki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Motyki i kultywatory",
    "categoryPath": [
      "(85199) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85199) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Motyki i kultywatory",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Noże ogrodnicze",
    "categoryPath": [
      "(99563) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(99563) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Noże ogrodnicze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Nożyce i sekatory",
    "categoryPath": [
      "(121255) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(121255) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Nożyce i sekatory",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Odkurzacze i dmuchawy",
    "categoryPath": [
      "(85202) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85202) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Odkurzacze i dmuchawy",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Odśnieżarki",
    "categoryPath": [
      "(85203) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85203) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Odśnieżarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Opryskiwacze",
    "categoryPath": [
      "(85204) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85204) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Opryskiwacze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Piły",
    "categoryPath": [
      "(121256) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(121256) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Piły",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(85193) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85193) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rozdrabniacze",
    "categoryPath": [
      "(85206) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85206) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Rozdrabniacze",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Rękawice i odzież ochronna",
    "categoryPath": [
      "(99704) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(99704) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Rękawice i odzież ochronna",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Siekiery",
    "categoryPath": [
      "(85207) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85207) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Siekiery",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Siewniki",
    "categoryPath": [
      "(85208) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85208) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Siewniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Taczki i wózki ogrodnicze",
    "categoryPath": [
      "(99565) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(99565) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Taczki i wózki ogrodnicze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Walce",
    "categoryPath": [
      "(321062) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(321062) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Walce",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wertykulatory i aeratory",
    "categoryPath": [
      "(85210) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85210) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Wertykulatory i aeratory",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D6"
  },
  {
    "segment": "Wyrywacze do chwastów",
    "categoryPath": [
      "(321059) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(321059) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Wyrywacze do chwastów",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy narzędzi",
    "categoryPath": [
      "(85211) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85211) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Zestawy narzędzi",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łopatki, motyczki, pikowniki",
    "categoryPath": [
      "(99706) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(99706) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Łopatki, motyczki, pikowniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łopaty i widły",
    "categoryPath": [
      "(85198) Dom i Ogród",
      "Ogród",
      "Narzędzia ogrodnicze"
    ],
    "hierarchy": "(85198) Dom i Ogród / Ogród / Narzędzia ogrodnicze / Łopaty i widły",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(316456) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316456) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Filtry",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Głowice studni",
    "categoryPath": [
      "(322192) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(322192) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Głowice studni",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Krany",
    "categoryPath": [
      "(316459) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316459) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Krany",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Podstawy",
    "categoryPath": [
      "(316462) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316462) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Podstawy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(316457) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316457) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Sterowniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(316468) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316468) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Wieszaki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wózki",
    "categoryPath": [
      "(316471) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316471) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Wózki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zbieracze",
    "categoryPath": [
      "(316474) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316474) Dom i Ogród / Ogród / Nawadnianie / Części i osprzęt / Zbieracze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Konewki",
    "categoryPath": [
      "(82286) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(82286) Dom i Ogród / Ogród / Nawadnianie / Konewki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pompy i hydrofory",
    "categoryPath": [
      "(85214) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(85214) Dom i Ogród / Ogród / Nawadnianie / Pompy i hydrofory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82285) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(82285) Dom i Ogród / Ogród / Nawadnianie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody kroplujące",
    "categoryPath": [
      "(82289) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(82289) Dom i Ogród / Ogród / Nawadnianie / Przewody kroplujące",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Części i akcesoria",
    "categoryPath": [
      "(320635) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Systemy nawadniające"
    ],
    "hierarchy": "(320635) Dom i Ogród / Ogród / Nawadnianie / Systemy nawadniające / Części i akcesoria",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Elektrozawory",
    "categoryPath": [
      "(320638) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Systemy nawadniające"
    ],
    "hierarchy": "(320638) Dom i Ogród / Ogród / Nawadnianie / Systemy nawadniające / Elektrozawory",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Nawadniacze",
    "categoryPath": [
      "(320626) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Systemy nawadniające"
    ],
    "hierarchy": "(320626) Dom i Ogród / Ogród / Nawadnianie / Systemy nawadniające / Nawadniacze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(320629) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Systemy nawadniające"
    ],
    "hierarchy": "(320629) Dom i Ogród / Ogród / Nawadnianie / Systemy nawadniające / Sterowniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(320632) Dom i Ogród",
      "Ogród",
      "Nawadnianie",
      "Systemy nawadniające"
    ],
    "hierarchy": "(320632) Dom i Ogród / Ogród / Nawadnianie / Systemy nawadniające / Zestawy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(320410) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(320410) Dom i Ogród / Ogród / Nawadnianie / Węże",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zbiorniki hydroforowe",
    "categoryPath": [
      "(322109) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(322109) Dom i Ogród / Ogród / Nawadnianie / Zbiorniki hydroforowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zbiorniki na deszczówkę",
    "categoryPath": [
      "(261600) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(261600) Dom i Ogród / Ogród / Nawadnianie / Zbiorniki na deszczówkę",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zraszacze",
    "categoryPath": [
      "(320413) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(320413) Dom i Ogród / Ogród / Nawadnianie / Zraszacze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Złączki i końcówki",
    "categoryPath": [
      "(82288) Dom i Ogród",
      "Ogród",
      "Nawadnianie"
    ],
    "hierarchy": "(82288) Dom i Ogród / Ogród / Nawadnianie / Złączki i końcówki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Grzybnie i mikoryza",
    "categoryPath": [
      "(126198) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(126198) Dom i Ogród / Ogród / Nawozy i preparaty / Grzybnie i mikoryza",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Hydrożele",
    "categoryPath": [
      "(320125) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(320125) Dom i Ogród / Ogród / Nawozy i preparaty / Hydrożele",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Maści ogrodnicze",
    "categoryPath": [
      "(321655) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(321655) Dom i Ogród / Ogród / Nawozy i preparaty / Maści ogrodnicze",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Nawozy",
    "categoryPath": [
      "(126197) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(126197) Dom i Ogród / Ogród / Nawozy i preparaty / Nawozy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sól drogowa i środki antypoślizgowe",
    "categoryPath": [
      "(254078) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(254078) Dom i Ogród / Ogród / Nawozy i preparaty / Sól drogowa i środki antypoślizgowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Środki do deszczówki",
    "categoryPath": [
      "(316240) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(316240) Dom i Ogród / Ogród / Nawozy i preparaty / Środki do deszczówki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Środki do kompostowania",
    "categoryPath": [
      "(316237) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(316237) Dom i Ogród / Ogród / Nawozy i preparaty / Środki do kompostowania",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Środki ochrony roślin",
    "categoryPath": [
      "(126200) Dom i Ogród",
      "Ogród",
      "Nawozy i preparaty"
    ],
    "hierarchy": "(126200) Dom i Ogród / Ogród / Nawozy i preparaty / Środki ochrony roślin",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Dekoracje",
    "categoryPath": [
      "(261577) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(261577) Dom i Ogród / Ogród / Oczka wodne / Dekoracje",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Filtry i sterylizatory",
    "categoryPath": [
      "(148164) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148164) Dom i Ogród / Ogród / Oczka wodne / Filtry i sterylizatory",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Oczka",
    "categoryPath": [
      "(148165) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148165) Dom i Ogród / Ogród / Oczka wodne / Oczka",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(148166) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148166) Dom i Ogród / Ogród / Oczka wodne / Oświetlenie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pojemniki na rośliny",
    "categoryPath": [
      "(148167) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148167) Dom i Ogród / Ogród / Oczka wodne / Pojemniki na rośliny",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pokarmy dla ryb",
    "categoryPath": [
      "(148168) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148168) Dom i Ogród / Ogród / Oczka wodne / Pokarmy dla ryb",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(148169) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148169) Dom i Ogród / Ogród / Oczka wodne / Pompy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148163) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148163) Dom i Ogród / Ogród / Oczka wodne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty",
    "categoryPath": [
      "(148170) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(148170) Dom i Ogród / Ogród / Oczka wodne / Preparaty",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wyposażenie oczek",
    "categoryPath": [
      "(261576) Dom i Ogród",
      "Ogród",
      "Oczka wodne"
    ],
    "hierarchy": "(261576) Dom i Ogród / Ogród / Oczka wodne / Wyposażenie oczek",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Odstraszacze owadów",
    "categoryPath": [
      "(254018) Dom i Ogród",
      "Ogród"
    ],
    "hierarchy": "(254018) Dom i Ogród / Ogród / Odstraszacze owadów",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Odstraszacze zwierząt",
    "categoryPath": [
      "(126184) Dom i Ogród",
      "Ogród"
    ],
    "hierarchy": "(126184) Dom i Ogród / Ogród / Odstraszacze zwierząt",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Czujniki i akcesoria",
    "categoryPath": [
      "(302945) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(302945) Dom i Ogród / Ogród / Oświetlenie / Czujniki i akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Girlandy",
    "categoryPath": [
      "(261574) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(261574) Dom i Ogród / Ogród / Oświetlenie / Girlandy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kinkiety",
    "categoryPath": [
      "(47478) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(47478) Dom i Ogród / Ogród / Oświetlenie / Kinkiety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Elewacyjne",
    "categoryPath": [
      "(302969) Dom i Ogród",
      "Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(302969) Dom i Ogród / Ogród / Oświetlenie / Lampy / Elewacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Najazdowe",
    "categoryPath": [
      "(47483) Dom i Ogród",
      "Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(47483) Dom i Ogród / Ogród / Oświetlenie / Lampy / Najazdowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(47480) Dom i Ogród",
      "Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(47480) Dom i Ogród / Ogród / Oświetlenie / Lampy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pływające",
    "categoryPath": [
      "(309469) Dom i Ogród",
      "Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(309469) Dom i Ogród / Ogród / Oświetlenie / Lampy / Pływające",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Uliczne",
    "categoryPath": [
      "(302957) Dom i Ogród",
      "Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(302957) Dom i Ogród / Ogród / Oświetlenie / Lampy / Uliczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wbijane, solarne",
    "categoryPath": [
      "(302981) Dom i Ogród",
      "Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(302981) Dom i Ogród / Ogród / Oświetlenie / Lampy / Wbijane, solarne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wiszące",
    "categoryPath": [
      "(47482) Dom i Ogród",
      "Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(47482) Dom i Ogród / Ogród / Oświetlenie / Lampy / Wiszące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Odbłyśniki",
    "categoryPath": [
      "(309289) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(309289) Dom i Ogród / Ogród / Oświetlenie / Odbłyśniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Oświetlenie do uprawy roślin",
    "categoryPath": [
      "(302933) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(302933) Dom i Ogród / Ogród / Oświetlenie / Oświetlenie do uprawy roślin",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pochodnie",
    "categoryPath": [
      "(261573) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(261573) Dom i Ogród / Ogród / Oświetlenie / Pochodnie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Projektory laserowe",
    "categoryPath": [
      "(256720) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(256720) Dom i Ogród / Ogród / Oświetlenie / Projektory laserowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Słupki oświetleniowe",
    "categoryPath": [
      "(302921) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(302921) Dom i Ogród / Ogród / Oświetlenie / Słupki oświetleniowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Żarówki i oprawy",
    "categoryPath": [
      "(47479) Dom i Ogród",
      "Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(47479) Dom i Ogród / Ogród / Oświetlenie / Żarówki i oprawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Grys i keramzyt",
    "categoryPath": [
      "(261602) Dom i Ogród",
      "Ogród",
      "Podłoża"
    ],
    "hierarchy": "(261602) Dom i Ogród / Ogród / Podłoża / Grys i keramzyt",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kora",
    "categoryPath": [
      "(126192) Dom i Ogród",
      "Ogród",
      "Podłoża"
    ],
    "hierarchy": "(126192) Dom i Ogród / Ogród / Podłoża / Kora",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kostka brukowa",
    "categoryPath": [
      "(126193) Dom i Ogród",
      "Ogród",
      "Podłoża"
    ],
    "hierarchy": "(126193) Dom i Ogród / Ogród / Podłoża / Kostka brukowa",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kratki i nawierzchnie",
    "categoryPath": [
      "(261603) Dom i Ogród",
      "Ogród",
      "Podłoża"
    ],
    "hierarchy": "(261603) Dom i Ogród / Ogród / Podłoża / Kratki i nawierzchnie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Testery podłoża",
    "categoryPath": [
      "(320272) Dom i Ogród",
      "Ogród",
      "Podłoża"
    ],
    "hierarchy": "(320272) Dom i Ogród / Ogród / Podłoża / Testery podłoża",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Ziemia",
    "categoryPath": [
      "(126194) Dom i Ogród",
      "Ogród",
      "Podłoża"
    ],
    "hierarchy": "(126194) Dom i Ogród / Ogród / Podłoża / Ziemia",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Żwir i kamienie",
    "categoryPath": [
      "(126195) Dom i Ogród",
      "Ogród",
      "Podłoża"
    ],
    "hierarchy": "(126195) Dom i Ogród / Ogród / Podłoża / Żwir i kamienie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(315) Dom i Ogród",
      "Ogród"
    ],
    "hierarchy": "(315) Dom i Ogród / Ogród / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Budki lęgowe i karmniki",
    "categoryPath": [
      "(148444) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(148444) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Budki lęgowe i karmniki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Dodatki dekoracyjne",
    "categoryPath": [
      "(261628) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(261628) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Dodatki dekoracyjne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Dzwonki wietrzne",
    "categoryPath": [
      "(320380) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(320380) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Dzwonki wietrzne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fontanny i pompy",
    "categoryPath": [
      "(148445) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(148445) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Fontanny i pompy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Mała architektura dekoracyjna",
    "categoryPath": [
      "(261627) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(261627) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Mała architektura dekoracyjna",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148443) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(148443) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rzeźby i figury",
    "categoryPath": [
      "(148446) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(148446) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Rzeźby i figury",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wiatrowskazy",
    "categoryPath": [
      "(320260) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(320260) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Wiatrowskazy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Wiklina ogrodowa",
    "categoryPath": [
      "(148447) Dom i Ogród",
      "Ogród",
      "Przedmioty dekoracyjne"
    ],
    "hierarchy": "(148447) Dom i Ogród / Ogród / Przedmioty dekoracyjne / Wiklina ogrodowa",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Etykiety i tabliczki",
    "categoryPath": [
      "(316480) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Akcesoria"
    ],
    "hierarchy": "(316480) Dom i Ogród / Ogród / Rośliny / Akcesoria / Etykiety i tabliczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klipsy do roślin",
    "categoryPath": [
      "(316483) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Akcesoria"
    ],
    "hierarchy": "(316483) Dom i Ogród / Ogród / Rośliny / Akcesoria / Klipsy do roślin",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podpórki",
    "categoryPath": [
      "(316477) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Akcesoria"
    ],
    "hierarchy": "(316477) Dom i Ogród / Ogród / Rośliny / Akcesoria / Podpórki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Akcesoria i narzędzia",
    "categoryPath": [
      "(47502) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Bonsai"
    ],
    "hierarchy": "(47502) Dom i Ogród / Ogród / Rośliny / Bonsai / Akcesoria i narzędzia",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drzewka",
    "categoryPath": [
      "(47503) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Bonsai"
    ],
    "hierarchy": "(47503) Dom i Ogród / Ogród / Rośliny / Bonsai / Drzewka",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Bulwy, cebulki, kłącza",
    "categoryPath": [
      "(12922) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(12922) Dom i Ogród / Ogród / Rośliny / Bulwy, cebulki, kłącza",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Byliny ozdobne",
    "categoryPath": [
      "(99806) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99806) Dom i Ogród / Ogród / Rośliny / Byliny ozdobne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drzewa i krzewy iglaste",
    "categoryPath": [
      "(99745) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99745) Dom i Ogród / Ogród / Rośliny / Drzewa i krzewy iglaste",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drzewa i krzewy liściaste",
    "categoryPath": [
      "(99754) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99754) Dom i Ogród / Ogród / Rośliny / Drzewa i krzewy liściaste",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Drzewa i krzewy ozdobne",
    "categoryPath": [
      "(99772) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99772) Dom i Ogród / Ogród / Rośliny / Nasiona / Drzewa i krzewy ozdobne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(99827) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99827) Dom i Ogród / Ogród / Rośliny / Nasiona / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rośliny owocowe",
    "categoryPath": [
      "(99775) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99775) Dom i Ogród / Ogród / Rośliny / Nasiona / Rośliny owocowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny ozdobne",
    "categoryPath": [
      "(99791) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99791) Dom i Ogród / Ogród / Rośliny / Nasiona / Rośliny ozdobne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny pnące",
    "categoryPath": [
      "(99790) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99790) Dom i Ogród / Ogród / Rośliny / Nasiona / Rośliny pnące",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny pokojowe",
    "categoryPath": [
      "(99773) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99773) Dom i Ogród / Ogród / Rośliny / Nasiona / Rośliny pokojowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Trawy",
    "categoryPath": [
      "(99774) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99774) Dom i Ogród / Ogród / Rośliny / Nasiona / Trawy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Warzywa",
    "categoryPath": [
      "(99776) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99776) Dom i Ogród / Ogród / Rośliny / Nasiona / Warzywa",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zioła",
    "categoryPath": [
      "(99789) Dom i Ogród",
      "Ogród",
      "Rośliny",
      "Nasiona"
    ],
    "hierarchy": "(99789) Dom i Ogród / Ogród / Rośliny / Nasiona / Zioła",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(12919) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(12919) Dom i Ogród / Ogród / Rośliny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rośliny doniczkowe",
    "categoryPath": [
      "(16022) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(16022) Dom i Ogród / Ogród / Rośliny / Rośliny doniczkowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny jednoroczne i dwuletnie",
    "categoryPath": [
      "(99831) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99831) Dom i Ogród / Ogród / Rośliny / Rośliny jednoroczne i dwuletnie",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny owocowe",
    "categoryPath": [
      "(99730) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99730) Dom i Ogród / Ogród / Rośliny / Rośliny owocowe",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny pnące",
    "categoryPath": [
      "(99818) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99818) Dom i Ogród / Ogród / Rośliny / Rośliny pnące",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny skalne",
    "categoryPath": [
      "(99826) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99826) Dom i Ogród / Ogród / Rośliny / Rośliny skalne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Rośliny wodne",
    "categoryPath": [
      "(16644) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(16644) Dom i Ogród / Ogród / Rośliny / Rośliny wodne",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Róże",
    "categoryPath": [
      "(99816) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99816) Dom i Ogród / Ogród / Rośliny / Róże",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Storczyki",
    "categoryPath": [
      "(261622) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(261622) Dom i Ogród / Ogród / Rośliny / Storczyki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Trawy",
    "categoryPath": [
      "(99817) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99817) Dom i Ogród / Ogród / Rośliny / Trawy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zioła",
    "categoryPath": [
      "(99828) Dom i Ogród",
      "Ogród",
      "Rośliny"
    ],
    "hierarchy": "(99828) Dom i Ogród / Ogród / Rośliny / Zioła",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Nadstawki",
    "categoryPath": [
      "(316495) Dom i Ogród",
      "Ogród",
      "Szamba i oczyszczalnie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316495) Dom i Ogród / Ogród / Szamba i oczyszczalnie / Części i osprzęt / Nadstawki",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pokrywy",
    "categoryPath": [
      "(316492) Dom i Ogród",
      "Ogród",
      "Szamba i oczyszczalnie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316492) Dom i Ogród / Ogród / Szamba i oczyszczalnie / Części i osprzęt / Pokrywy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(316486) Dom i Ogród",
      "Ogród",
      "Szamba i oczyszczalnie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316486) Dom i Ogród / Ogród / Szamba i oczyszczalnie / Części i osprzęt / Pompy",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(316489) Dom i Ogród",
      "Ogród",
      "Szamba i oczyszczalnie",
      "Części i osprzęt"
    ],
    "hierarchy": "(316489) Dom i Ogród / Ogród / Szamba i oczyszczalnie / Części i osprzęt / Węże",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Oczyszczalnie ścieków",
    "categoryPath": [
      "(256907) Dom i Ogród",
      "Ogród",
      "Szamba i oczyszczalnie"
    ],
    "hierarchy": "(256907) Dom i Ogród / Ogród / Szamba i oczyszczalnie / Oczyszczalnie ścieków",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Preparaty do szamb",
    "categoryPath": [
      "(256906) Dom i Ogród",
      "Ogród",
      "Szamba i oczyszczalnie"
    ],
    "hierarchy": "(256906) Dom i Ogród / Ogród / Szamba i oczyszczalnie / Preparaty do szamb",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szamba",
    "categoryPath": [
      "(261572) Dom i Ogród",
      "Ogród",
      "Szamba i oczyszczalnie"
    ],
    "hierarchy": "(261572) Dom i Ogród / Ogród / Szamba i oczyszczalnie / Szamba",
    "comissionGroupOld": "C2",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Abażury i klosze",
    "categoryPath": [
      "(49855) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(49855) Dom i Ogród / Oświetlenie / Abażury i klosze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(318591) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318591) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Czujniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gniazda przyłączeniowe",
    "categoryPath": [
      "(318594) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318594) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Gniazda przyłączeniowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(318630) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318630) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kable",
    "categoryPath": [
      "(318597) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318597) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Kable",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odbłyśniki",
    "categoryPath": [
      "(318600) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318600) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Odbłyśniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Osłonki",
    "categoryPath": [
      "(318603) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318603) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Osłonki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piloty",
    "categoryPath": [
      "(318606) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318606) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Piloty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Profile do LED",
    "categoryPath": [
      "(318609) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318609) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Profile do LED",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(318612) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318612) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Sterowniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy przyłączeniowe",
    "categoryPath": [
      "(318615) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318615) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Taśmy przyłączeniowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(318618) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318618) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(318621) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318621) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zaślepki",
    "categoryPath": [
      "(318624) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318624) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Zaślepki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Złączki",
    "categoryPath": [
      "(318627) Dom i Ogród",
      "Oświetlenie",
      "Akcesoria i osprzęt oświetleniowy"
    ],
    "hierarchy": "(318627) Dom i Ogród / Oświetlenie / Akcesoria i osprzęt oświetleniowy / Złączki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Girlandy świetlne",
    "categoryPath": [
      "(256542) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(256542) Dom i Ogród / Oświetlenie / Girlandy świetlne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Halogeny i naświetlacze",
    "categoryPath": [
      "(301034) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(301034) Dom i Ogród / Oświetlenie / Halogeny i naświetlacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kinkiety",
    "categoryPath": [
      "(259813) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259813) Dom i Ogród / Oświetlenie / Lampy / Kinkiety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampki biurkowe",
    "categoryPath": [
      "(259810) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259810) Dom i Ogród / Oświetlenie / Lampy / Lampki biurkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampy podłogowe",
    "categoryPath": [
      "(259809) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259809) Dom i Ogród / Oświetlenie / Lampy / Lampy podłogowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampy solne",
    "categoryPath": [
      "(300841) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(300841) Dom i Ogród / Oświetlenie / Lampy / Lampy solne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampy stołowe",
    "categoryPath": [
      "(259811) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259811) Dom i Ogród / Oświetlenie / Lampy / Lampy stołowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampy wiszące",
    "categoryPath": [
      "(259808) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259808) Dom i Ogród / Oświetlenie / Lampy / Lampy wiszące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Oczka",
    "categoryPath": [
      "(259815) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259815) Dom i Ogród / Oświetlenie / Lampy / Oczka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259816) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259816) Dom i Ogród / Oświetlenie / Lampy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półplafony i plafony",
    "categoryPath": [
      "(259812) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259812) Dom i Ogród / Oświetlenie / Lampy / Półplafony i plafony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Spoty, reflektory sufitowe i ścienne",
    "categoryPath": [
      "(259814) Dom i Ogród",
      "Oświetlenie",
      "Lampy"
    ],
    "hierarchy": "(259814) Dom i Ogród / Oświetlenie / Lampy / Spoty, reflektory sufitowe i ścienne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Oprawy oświetleniowe",
    "categoryPath": [
      "(257007) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(257007) Dom i Ogród / Oświetlenie / Oprawy oświetleniowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(260778) Dom i Ogród",
      "Oświetlenie",
      "Oświetlenie inteligentne"
    ],
    "hierarchy": "(260778) Dom i Ogród / Oświetlenie / Oświetlenie inteligentne / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Źródła światła",
    "categoryPath": [
      "(260777) Dom i Ogród",
      "Oświetlenie",
      "Oświetlenie inteligentne"
    ],
    "hierarchy": "(260777) Dom i Ogród / Oświetlenie / Oświetlenie inteligentne / Źródła światła",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Oświetlenie meblowe",
    "categoryPath": [
      "(257008) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(257008) Dom i Ogród / Oświetlenie / Oświetlenie meblowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kostka brukowa LED",
    "categoryPath": [
      "(314865) Dom i Ogród",
      "Oświetlenie",
      "Oświetlenie zewnętrzne"
    ],
    "hierarchy": "(314865) Dom i Ogród / Oświetlenie / Oświetlenie zewnętrzne / Kostka brukowa LED",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(305265) Dom i Ogród",
      "Oświetlenie",
      "Oświetlenie zewnętrzne",
      "Lampy"
    ],
    "hierarchy": "(305265) Dom i Ogród / Oświetlenie / Oświetlenie zewnętrzne / Lampy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(305181) Dom i Ogród",
      "Oświetlenie",
      "Oświetlenie zewnętrzne"
    ],
    "hierarchy": "(305181) Dom i Ogród / Oświetlenie / Oświetlenie zewnętrzne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Żarówki i oprawy",
    "categoryPath": [
      "(305157) Dom i Ogród",
      "Oświetlenie",
      "Oświetlenie zewnętrzne"
    ],
    "hierarchy": "(305157) Dom i Ogród / Oświetlenie / Oświetlenie zewnętrzne / Żarówki i oprawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Systemy linkowe i szynowe",
    "categoryPath": [
      "(260141) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(260141) Dom i Ogród / Oświetlenie / Systemy linkowe i szynowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Taśmy LED",
    "categoryPath": [
      "(320404) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(320404) Dom i Ogród / Oświetlenie / Taśmy LED",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Źródła światła",
    "categoryPath": [
      "(10774) Dom i Ogród",
      "Oświetlenie"
    ],
    "hierarchy": "(10774) Dom i Ogród / Oświetlenie / Źródła światła",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dozowniki do mydła",
    "categoryPath": [
      "(105334) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105334) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Dozowniki do mydła",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drążki prysznicowe",
    "categoryPath": [
      "(254278) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(254278) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Drążki prysznicowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosze i pojemniki na pranie",
    "categoryPath": [
      "(105335) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105335) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Kosze i pojemniki na pranie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosze na śmieci",
    "categoryPath": [
      "(105336) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105336) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Kosze na śmieci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kubki i pojemniki łazienkowe",
    "categoryPath": [
      "(106447) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(106447) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Kubki i pojemniki łazienkowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lustra",
    "categoryPath": [
      "(105337) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105337) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Lustra",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maty antypoślizgowe",
    "categoryPath": [
      "(320146) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(320146) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Maty antypoślizgowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maty grzewcze pod lustra",
    "categoryPath": [
      "(322486) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(322486) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Maty grzewcze pod lustra",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miski i miednice",
    "categoryPath": [
      "(105338) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105338) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Miski i miednice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mydelniczki",
    "categoryPath": [
      "(105339) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105339) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Mydelniczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Papier toaletowy",
    "categoryPath": [
      "(300469) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(300469) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Papier toaletowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pochłaniacze wilgoci",
    "categoryPath": [
      "(54052) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(54052) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Pochłaniacze wilgoci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(54057) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(54057) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półki łazienkowe",
    "categoryPath": [
      "(105340) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105340) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Półki łazienkowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Suszarki do rąk",
    "categoryPath": [
      "(105342) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105342) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Suszarki do rąk",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Suszarki na ubrania",
    "categoryPath": [
      "(300477) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(300477) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Suszarki na ubrania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty i pojemniki na papier",
    "categoryPath": [
      "(105343) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(105343) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Uchwyty i pojemniki na papier",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(54054) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(54054) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Wieszaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zasłony prysznicowe",
    "categoryPath": [
      "(54055) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(54055) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Zasłony prysznicowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy akcesoriów",
    "categoryPath": [
      "(54056) Dom i Ogród",
      "Wyposażenie",
      "Akcesoria łazienkowe"
    ],
    "hierarchy": "(54056) Dom i Ogród / Wyposażenie / Akcesoria łazienkowe / Zestawy akcesoriów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Doniczki i osłonki",
    "categoryPath": [
      "(258712) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(258712) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Doniczki i osłonki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Figurki i rzeźby",
    "categoryPath": [
      "(16002) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(16002) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Figurki i rzeźby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kompozycje kwiatowe",
    "categoryPath": [
      "(254478) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(254478) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Kompozycje kwiatowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kopuły dekoracyjne",
    "categoryPath": [
      "(319950) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(319950) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Kopuły dekoracyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kwietniki",
    "categoryPath": [
      "(110907) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110907) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Kwietniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampiony i latarnie",
    "categoryPath": [
      "(110914) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110914) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Lampiony i latarnie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Las w słoiku",
    "categoryPath": [
      "(300457) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(300457) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Las w słoiku",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Litery 3D",
    "categoryPath": [
      "(254279) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(254279) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Litery 3D",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Magnesy na lodówkę",
    "categoryPath": [
      "(110908) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110908) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Magnesy na lodówkę",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mech dekoracyjny",
    "categoryPath": [
      "(308641) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(308641) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Mech dekoracyjny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mocowania ścienne",
    "categoryPath": [
      "(300461) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(300461) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Mocowania ścienne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Obrazki i obrazy",
    "categoryPath": [
      "(110911) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110911) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Obrazki i obrazy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Osłony na kaloryfer",
    "categoryPath": [
      "(261524) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(261524) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Osłony na kaloryfer",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ozdobne zawieszki",
    "categoryPath": [
      "(110910) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110910) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Ozdobne zawieszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Panele i ścianki dekoracyjne",
    "categoryPath": [
      "(261525) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(261525) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Panele i ścianki dekoracyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Parawany",
    "categoryPath": [
      "(260601) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(260601) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Parawany",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Plakaty",
    "categoryPath": [
      "(110912) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110912) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Plakaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podpórki do książek",
    "categoryPath": [
      "(261526) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(261526) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Podpórki do książek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(15997) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(15997) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ramki do zdjęć",
    "categoryPath": [
      "(110913) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110913) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Ramki do zdjęć",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stojaki na wino",
    "categoryPath": [
      "(261604) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(261604) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Stojaki na wino",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sztuczne kwiaty i owoce",
    "categoryPath": [
      "(16008) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(16008) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Sztuczne kwiaty i owoce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wazony",
    "categoryPath": [
      "(110915) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(110915) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Wazony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wianki",
    "categoryPath": [
      "(254019) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(254019) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Wianki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Witrażyki",
    "categoryPath": [
      "(16005) Dom i Ogród",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(16005) Dom i Ogród / Wyposażenie / Dekoracje i ozdoby / Witrażyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty i siatki",
    "categoryPath": [
      "(314185) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki",
      "Akcesoria antypoślizgowe pod dywany"
    ],
    "hierarchy": "(314185) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Akcesoria antypoślizgowe pod dywany / Maty i siatki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkładki",
    "categoryPath": [
      "(314197) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki",
      "Akcesoria antypoślizgowe pod dywany"
    ],
    "hierarchy": "(314197) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Akcesoria antypoślizgowe pod dywany / Podkładki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(314209) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki",
      "Akcesoria antypoślizgowe pod dywany"
    ],
    "hierarchy": "(314209) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Akcesoria antypoślizgowe pod dywany / Taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chodniki",
    "categoryPath": [
      "(20256) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(20256) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Chodniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dywaniki łazienkowe",
    "categoryPath": [
      "(20255) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(20255) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Dywaniki łazienkowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dywany",
    "categoryPath": [
      "(20257) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(20257) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Dywany",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty łazienkowe",
    "categoryPath": [
      "(260678) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(260678) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Maty łazienkowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nakładki na schody",
    "categoryPath": [
      "(110184) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(110184) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Nakładki na schody",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podkłady pod dywany i wykładziny",
    "categoryPath": [
      "(319974) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(319974) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Podkłady pod dywany i wykładziny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(20253) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(20253) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skóry",
    "categoryPath": [
      "(20254) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(20254) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Skóry",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sztuczna trawa",
    "categoryPath": [
      "(110185) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(110185) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Sztuczna trawa",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wycieraczki",
    "categoryPath": [
      "(110186) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(110186) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Wycieraczki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wykładziny PCV",
    "categoryPath": [
      "(110187) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(110187) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Wykładziny PCV",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wykładziny dywanowe",
    "categoryPath": [
      "(110188) Dom i Ogród",
      "Wyposażenie",
      "Dywany i dywaniki"
    ],
    "hierarchy": "(110188) Dom i Ogród / Wyposażenie / Dywany i dywaniki / Wykładziny dywanowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Gazetniki",
    "categoryPath": [
      "(319953) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(319953) Dom i Ogród / Wyposażenie / Gazetniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(251247) Dom i Ogród",
      "Wyposażenie",
      "Inteligentny dom"
    ],
    "hierarchy": "(251247) Dom i Ogród / Wyposażenie / Inteligentny dom / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(251245) Dom i Ogród",
      "Wyposażenie",
      "Inteligentny dom"
    ],
    "hierarchy": "(251245) Dom i Ogród / Wyposażenie / Inteligentny dom / Czujniki",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Elementy wykonawcze",
    "categoryPath": [
      "(251244) Dom i Ogród",
      "Wyposażenie",
      "Inteligentny dom"
    ],
    "hierarchy": "(251244) Dom i Ogród / Wyposażenie / Inteligentny dom / Elementy wykonawcze",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Jednostki centralne",
    "categoryPath": [
      "(251243) Dom i Ogród",
      "Wyposażenie",
      "Inteligentny dom"
    ],
    "hierarchy": "(251243) Dom i Ogród / Wyposażenie / Inteligentny dom / Jednostki centralne",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Moduły peryferyjne",
    "categoryPath": [
      "(251246) Dom i Ogród",
      "Wyposażenie",
      "Inteligentny dom"
    ],
    "hierarchy": "(251246) Dom i Ogród / Wyposażenie / Inteligentny dom / Moduły peryferyjne",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(251248) Dom i Ogród",
      "Wyposażenie",
      "Inteligentny dom"
    ],
    "hierarchy": "(251248) Dom i Ogród / Wyposażenie / Inteligentny dom / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(311781) Dom i Ogród",
      "Wyposażenie",
      "Inteligentny dom"
    ],
    "hierarchy": "(311781) Dom i Ogród / Wyposażenie / Inteligentny dom / Zestawy",
    "comissionGroupOld": "C4",
    "comissionGroupNew": "D3"
  },
  {
    "segment": "Koszyki",
    "categoryPath": [
      "(68679) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(68679) Dom i Ogród / Wyposażenie / Koszyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lustra",
    "categoryPath": [
      "(15973) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(15973) Dom i Ogród / Wyposażenie / Lustra",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bieżniki",
    "categoryPath": [
      "(68688) Dom i Ogród",
      "Wyposażenie",
      "Obrusy, serwetki, podkładki"
    ],
    "hierarchy": "(68688) Dom i Ogród / Wyposażenie / Obrusy, serwetki, podkładki / Bieżniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Obrusy",
    "categoryPath": [
      "(68689) Dom i Ogród",
      "Wyposażenie",
      "Obrusy, serwetki, podkładki"
    ],
    "hierarchy": "(68689) Dom i Ogród / Wyposażenie / Obrusy, serwetki, podkładki / Obrusy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podkładki i maty",
    "categoryPath": [
      "(111696) Dom i Ogród",
      "Wyposażenie",
      "Obrusy, serwetki, podkładki"
    ],
    "hierarchy": "(111696) Dom i Ogród / Wyposażenie / Obrusy, serwetki, podkładki / Podkładki i maty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(68687) Dom i Ogród",
      "Wyposażenie",
      "Obrusy, serwetki, podkładki"
    ],
    "hierarchy": "(68687) Dom i Ogród / Wyposażenie / Obrusy, serwetki, podkładki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Serwety i serwetki",
    "categoryPath": [
      "(68691) Dom i Ogród",
      "Wyposażenie",
      "Obrusy, serwetki, podkładki"
    ],
    "hierarchy": "(68691) Dom i Ogród / Wyposażenie / Obrusy, serwetki, podkładki / Serwety i serwetki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Akcesoria i dodatki do strojów",
    "categoryPath": [
      "(300773) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(300773) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Akcesoria i dodatki do strojów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bombki i ozdoby choinkowe",
    "categoryPath": [
      "(11984) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11984) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Bombki i ozdoby choinkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Choinki",
    "categoryPath": [
      "(11981) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11981) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Choinki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dekoracje okienne",
    "categoryPath": [
      "(11987) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11987) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Dekoracje okienne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dekoracje stołu",
    "categoryPath": [
      "(318735) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(318735) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Dekoracje stołu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(11982) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11982) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Figurki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Iluminacje Świąteczne",
    "categoryPath": [
      "(311141) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(311141) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Iluminacje Świąteczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kalendarze adwentowe",
    "categoryPath": [
      "(300673) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(300673) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Kalendarze adwentowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kartki świąteczne",
    "categoryPath": [
      "(11983) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11983) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Kartki świąteczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Opakowania na prezenty",
    "categoryPath": [
      "(54049) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(54049) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Opakowania na prezenty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Opłatek, sianko",
    "categoryPath": [
      "(318729) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(318729) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Opłatek, sianko",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ozdoby z piernika",
    "categoryPath": [
      "(316687) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(316687) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Ozdoby z piernika",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Oświetlenie choinkowe",
    "categoryPath": [
      "(11985) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11985) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Oświetlenie choinkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Oświetlenie świąteczne zewnętrzne",
    "categoryPath": [
      "(300665) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(300665) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Oświetlenie świąteczne zewnętrzne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pokrowce dekoracyjne",
    "categoryPath": [
      "(300781) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(300781) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Pokrowce dekoracyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(11989) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11989) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Projektory laserowe i rzutniki",
    "categoryPath": [
      "(300669) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(300669) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Projektory laserowe i rzutniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Skarpety świąteczne na prezenty",
    "categoryPath": [
      "(320008) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(320008) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Skarpety świąteczne na prezenty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stojaki choinkowe",
    "categoryPath": [
      "(300677) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(300677) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Stojaki choinkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szopki i stroiki",
    "categoryPath": [
      "(11986) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11986) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Szopki i stroiki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sztuczny śnieg",
    "categoryPath": [
      "(320023) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(320023) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Sztuczny śnieg",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Worki na prezenty",
    "categoryPath": [
      "(320011) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(320011) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Worki na prezenty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zastawa stołowa",
    "categoryPath": [
      "(318732) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(318732) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Zastawa stołowa",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Świeczniki i lampiony",
    "categoryPath": [
      "(11988) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Boże Narodzenie"
    ],
    "hierarchy": "(11988) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Boże Narodzenie / Świeczniki i lampiony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dymy",
    "categoryPath": [
      "(300761) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300761) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Dymy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Flary",
    "categoryPath": [
      "(310241) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(310241) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Flary",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Fontanny",
    "categoryPath": [
      "(300749) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300749) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Fontanny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ognie rzymskie",
    "categoryPath": [
      "(300745) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300745) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Ognie rzymskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Petardy",
    "categoryPath": [
      "(300757) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300757) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Petardy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(300769) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300769) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Profesjonalne zestawy pirotechniczne",
    "categoryPath": [
      "(300765) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300765) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Profesjonalne zestawy pirotechniczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Race",
    "categoryPath": [
      "(310253) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(310253) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Race",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rakiety",
    "categoryPath": [
      "(300741) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300741) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Rakiety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stroboskopy",
    "categoryPath": [
      "(310265) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(310265) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Stroboskopy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wyrzutnie",
    "categoryPath": [
      "(300737) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Fajerwerki"
    ],
    "hierarchy": "(300737) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Fajerwerki / Wyrzutnie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Atrybuty",
    "categoryPath": [
      "(317594) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317594) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Atrybuty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(317817) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317817) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Krew",
    "categoryPath": [
      "(317588) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317588) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Krew",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maski",
    "categoryPath": [
      "(317576) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317576) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Maski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nakrycia głowy",
    "categoryPath": [
      "(317579) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317579) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Nakrycia głowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Opaski i spinki",
    "categoryPath": [
      "(317582) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317582) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Opaski i spinki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rogi",
    "categoryPath": [
      "(317591) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317591) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Rogi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zęby",
    "categoryPath": [
      "(317585) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween",
      "Akcesoria i dodatki do strojów"
    ],
    "hierarchy": "(317585) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Akcesoria i dodatki do strojów / Zęby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Balony i girlandy",
    "categoryPath": [
      "(300693) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300693) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Balony i girlandy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bufet halloweenowy",
    "categoryPath": [
      "(300721) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300721) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Bufet halloweenowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dekoracje interaktywne i świecące",
    "categoryPath": [
      "(300709) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300709) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Dekoracje interaktywne i świecące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dekoracje stołu",
    "categoryPath": [
      "(300705) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300705) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Dekoracje stołu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampiony i świece",
    "categoryPath": [
      "(300697) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300697) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Lampiony i świece",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pajęczyny i pająki",
    "categoryPath": [
      "(300701) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300701) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Pajęczyny i pająki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(300729) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300729) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szkielety i czaszki",
    "categoryPath": [
      "(300833) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300833) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Szkielety i czaszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Torebki i opakowania na słodycze",
    "categoryPath": [
      "(300713) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300713) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Torebki i opakowania na słodycze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy halloweenowe",
    "categoryPath": [
      "(300725) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Halloween"
    ],
    "hierarchy": "(300725) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Halloween / Zestawy halloweenowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kartki okolicznościowe",
    "categoryPath": [
      "(253751) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe"
    ],
    "hierarchy": "(253751) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Kartki okolicznościowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(11996) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe"
    ],
    "hierarchy": "(11996) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Balony",
    "categoryPath": [
      "(300845) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Walentynki"
    ],
    "hierarchy": "(300845) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Walentynki / Balony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(11991) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Walentynki"
    ],
    "hierarchy": "(11991) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Walentynki / Figurki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kartki okazyjne",
    "categoryPath": [
      "(11993) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Walentynki"
    ],
    "hierarchy": "(11993) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Walentynki / Kartki okazyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kubki i kieliszki",
    "categoryPath": [
      "(300853) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Walentynki"
    ],
    "hierarchy": "(300853) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Walentynki / Kubki i kieliszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kwiaty i flower boxy",
    "categoryPath": [
      "(300857) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Walentynki"
    ],
    "hierarchy": "(300857) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Walentynki / Kwiaty i flower boxy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Obrazki i witrażyki",
    "categoryPath": [
      "(11992) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Walentynki"
    ],
    "hierarchy": "(11992) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Walentynki / Obrazki i witrażyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(300849) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Walentynki"
    ],
    "hierarchy": "(300849) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Walentynki / Poduszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(12365) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wielkanoc"
    ],
    "hierarchy": "(12365) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wielkanoc / Figurki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kartki świąteczne",
    "categoryPath": [
      "(12366) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wielkanoc"
    ],
    "hierarchy": "(12366) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wielkanoc / Kartki świąteczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Koszyczki i stroiki",
    "categoryPath": [
      "(12364) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wielkanoc"
    ],
    "hierarchy": "(12364) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wielkanoc / Koszyczki i stroiki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Opakowania",
    "categoryPath": [
      "(54050) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wielkanoc"
    ],
    "hierarchy": "(54050) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wielkanoc / Opakowania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pisanki i barwniki",
    "categoryPath": [
      "(12363) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wielkanoc"
    ],
    "hierarchy": "(12363) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wielkanoc / Pisanki i barwniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(12367) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wielkanoc"
    ],
    "hierarchy": "(12367) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wielkanoc / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zawieszki wielkanocne",
    "categoryPath": [
      "(310277) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wielkanoc"
    ],
    "hierarchy": "(310277) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wielkanoc / Zawieszki wielkanocne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kwiaty i wiązanki",
    "categoryPath": [
      "(300681) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wszystkich Świętych"
    ],
    "hierarchy": "(300681) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wszystkich Świętych / Kwiaty i wiązanki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podstawki pod znicze",
    "categoryPath": [
      "(300977) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wszystkich Świętych"
    ],
    "hierarchy": "(300977) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wszystkich Świętych / Podstawki pod znicze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256452) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wszystkich Świętych"
    ],
    "hierarchy": "(256452) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wszystkich Świętych / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wkłady do zniczy",
    "categoryPath": [
      "(256451) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wszystkich Świętych"
    ],
    "hierarchy": "(256451) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wszystkich Świętych / Wkłady do zniczy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Znicze",
    "categoryPath": [
      "(256450) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe",
      "Wszystkich Świętych"
    ],
    "hierarchy": "(256450) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Wszystkich Świętych / Znicze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zimne ognie",
    "categoryPath": [
      "(300753) Dom i Ogród",
      "Wyposażenie",
      "Ozdoby świąteczne i okolicznościowe"
    ],
    "hierarchy": "(300753) Dom i Ogród / Wyposażenie / Ozdoby świąteczne i okolicznościowe / Zimne ognie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(320449) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(320449) Dom i Ogród / Wyposażenie / Poduszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(300777) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(300777) Dom i Ogród / Wyposażenie / Pokrowce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(128) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(128) Dom i Ogród / Wyposażenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Koce i narzuty",
    "categoryPath": [
      "(15990) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(15990) Dom i Ogród / Wyposażenie / Pościel i koce / Koce i narzuty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komplety pościeli",
    "categoryPath": [
      "(15986) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(15986) Dom i Ogród / Wyposażenie / Pościel i koce / Komplety pościeli",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kołdry",
    "categoryPath": [
      "(15987) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(15987) Dom i Ogród / Wyposażenie / Pościel i koce / Kołdry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty i ochraniacze na materac",
    "categoryPath": [
      "(110183) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(110183) Dom i Ogród / Wyposażenie / Pościel i koce / Maty i ochraniacze na materac",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(15988) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(15988) Dom i Ogród / Wyposażenie / Pościel i koce / Poduszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poszewki",
    "categoryPath": [
      "(15996) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(15996) Dom i Ogród / Wyposażenie / Pościel i koce / Poszewki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(15995) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(15995) Dom i Ogród / Wyposażenie / Pościel i koce / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prześcieradła",
    "categoryPath": [
      "(15989) Dom i Ogród",
      "Wyposażenie",
      "Pościel i koce"
    ],
    "hierarchy": "(15989) Dom i Ogród / Wyposażenie / Pościel i koce / Prześcieradła",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Projekty wnętrz",
    "categoryPath": [
      "(319697) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(319697) Dom i Ogród / Wyposażenie / Projekty wnętrz",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dziadki do orzechów",
    "categoryPath": [
      "(308665) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(308665) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Dziadki do orzechów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Filtry i sitka do zlewów",
    "categoryPath": [
      "(316708) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(316708) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Filtry i sitka do zlewów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Folia spożywcza",
    "categoryPath": [
      "(302474) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(302474) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Folia spożywcza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Formy do gotowania jajek",
    "categoryPath": [
      "(313937) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(313937) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Formy do gotowania jajek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Formy do jajek sadzonych",
    "categoryPath": [
      "(313925) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(313925) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Formy do jajek sadzonych",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Formy do lodu i lodów",
    "categoryPath": [
      "(308677) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(308677) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Formy do lodu i lodów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Formy do pierogów",
    "categoryPath": [
      "(308689) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(308689) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Formy do pierogów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korki do zlewu",
    "categoryPath": [
      "(308701) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(308701) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Korki do zlewu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lejki",
    "categoryPath": [
      "(254280) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(254280) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Lejki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obieraczki i drylownice",
    "categoryPath": [
      "(110923) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110923) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Obieraczki i drylownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Otwieracze i korkociągi",
    "categoryPath": [
      "(110918) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110918) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Otwieracze i korkociągi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Palniki",
    "categoryPath": [
      "(308713) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(308713) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Palniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Papier i rękawy do pieczenia",
    "categoryPath": [
      "(302462) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(302462) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Papier i rękawy do pieczenia",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkładki pod garnki",
    "categoryPath": [
      "(319667) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(319667) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Podkładki pod garnki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(110925) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110925) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pędzelki do mięs i ciast",
    "categoryPath": [
      "(254281) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(254281) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Pędzelki do mięs i ciast",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ręczniki papierowe",
    "categoryPath": [
      "(302857) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(302857) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Ręczniki papierowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczypce",
    "categoryPath": [
      "(257674) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(257674) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Szczypce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tarki i szatkownice",
    "categoryPath": [
      "(110922) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110922) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Tarki i szatkownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Trzepaczki",
    "categoryPath": [
      "(110919) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110919) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Trzepaczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tłuczki",
    "categoryPath": [
      "(110921) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110921) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Tłuczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty na ręczniki kuchenne",
    "categoryPath": [
      "(317417) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(317417) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Uchwyty na ręczniki kuchenne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Woskowijki",
    "categoryPath": [
      "(306057) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(306057) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Woskowijki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wyciskarki i praski",
    "categoryPath": [
      "(110924) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110924) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Wyciskarki i praski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wykałaczki i patyczki",
    "categoryPath": [
      "(261819) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(261819) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Wykałaczki i patyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łopatki i łyżki kuchenne",
    "categoryPath": [
      "(110920) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria"
    ],
    "hierarchy": "(110920) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria / Łopatki i łyżki kuchenne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dozowniki",
    "categoryPath": [
      "(317603) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317603) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Dozowniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(317808) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317808) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Schładzanie napojów",
    "categoryPath": [
      "(317600) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317600) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Schładzanie napojów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Shakery",
    "categoryPath": [
      "(317609) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317609) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Shakery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szklanki",
    "categoryPath": [
      "(317623) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317623) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Szklanki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Słomki",
    "categoryPath": [
      "(317614) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317614) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Słomki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zatyczki, zakrętki, korki",
    "categoryPath": [
      "(317617) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317617) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Zatyczki, zakrętki, korki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(317620) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317620) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria barmańskie / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dekoratory",
    "categoryPath": [
      "(317814) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria cukiernicze"
    ],
    "hierarchy": "(317814) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria cukiernicze / Dekoratory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(317811) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria cukiernicze"
    ],
    "hierarchy": "(317811) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria cukiernicze / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maszynki do ciastek",
    "categoryPath": [
      "(317567) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria cukiernicze"
    ],
    "hierarchy": "(317567) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria cukiernicze / Maszynki do ciastek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rękawy cukiernicze",
    "categoryPath": [
      "(317558) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria cukiernicze"
    ],
    "hierarchy": "(317558) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria cukiernicze / Rękawy cukiernicze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tylki, końcówki do rękawów",
    "categoryPath": [
      "(317561) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria cukiernicze"
    ],
    "hierarchy": "(317561) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria cukiernicze / Tylki, końcówki do rękawów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy akcesoriów",
    "categoryPath": [
      "(317570) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria cukiernicze"
    ],
    "hierarchy": "(317570) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria cukiernicze / Zestawy akcesoriów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łopatki i szpatuły",
    "categoryPath": [
      "(317564) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Akcesoria cukiernicze"
    ],
    "hierarchy": "(317564) Dom i Ogród / Wyposażenie / Przybory kuchenne / Akcesoria cukiernicze / Łopatki i szpatuły",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Beczki i kamionki",
    "categoryPath": [
      "(300805) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(300805) Dom i Ogród / Wyposażenie / Przybory kuchenne / Beczki i kamionki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Blachy i formy do pieczenia",
    "categoryPath": [
      "(110916) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110916) Dom i Ogród / Wyposażenie / Przybory kuchenne / Blachy i formy do pieczenia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Butelki, bidony i lunch boxy",
    "categoryPath": [
      "(306837) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(306837) Dom i Ogród / Wyposażenie / Przybory kuchenne / Butelki, bidony i lunch boxy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Chlebaki",
    "categoryPath": [
      "(49871) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(49871) Dom i Ogród / Wyposażenie / Przybory kuchenne / Chlebaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Czajniki i imbryki",
    "categoryPath": [
      "(110926) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110926) Dom i Ogród / Wyposażenie / Przybory kuchenne / Czajniki i imbryki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Deski do krojenia",
    "categoryPath": [
      "(68722) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(68722) Dom i Ogród / Wyposażenie / Przybory kuchenne / Deski do krojenia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dozowniki na płyn i zmywaki",
    "categoryPath": [
      "(261818) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(261818) Dom i Ogród / Wyposażenie / Przybory kuchenne / Dozowniki na płyn i zmywaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Brytfanny",
    "categoryPath": [
      "(49890) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(49890) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Brytfanny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Garnki",
    "categoryPath": [
      "(110949) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(110949) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Garnki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Organizery",
    "categoryPath": [
      "(321104) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(321104) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Organizery",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Parowary",
    "categoryPath": [
      "(110927) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(110927) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Parowary",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Patelnie",
    "categoryPath": [
      "(110950) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(110950) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Patelnie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pokrywki",
    "categoryPath": [
      "(68710) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(68710) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Pokrywki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sokowniki",
    "categoryPath": [
      "(110929) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(110929) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Sokowniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szybkowary",
    "categoryPath": [
      "(110930) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(110930) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Szybkowary",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szynkowary",
    "categoryPath": [
      "(306933) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(306933) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Szynkowary",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Woki",
    "categoryPath": [
      "(110931) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(110931) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Woki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy do fondue",
    "categoryPath": [
      "(68711) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(68711) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Zestawy do fondue",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy garnków",
    "categoryPath": [
      "(49870) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(49870) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Zestawy garnków",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy patelni",
    "categoryPath": [
      "(319580) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Garnki i patelnie"
    ],
    "hierarchy": "(319580) Dom i Ogród / Wyposażenie / Przybory kuchenne / Garnki i patelnie / Zestawy patelni",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kiełkownice",
    "categoryPath": [
      "(302817) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(302817) Dom i Ogród / Wyposażenie / Przybory kuchenne / Kiełkownice",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kosze na śmieci i pojemniki do segregacji",
    "categoryPath": [
      "(300497) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(300497) Dom i Ogród / Wyposażenie / Przybory kuchenne / Kosze na śmieci i pojemniki do segregacji",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maselniczki",
    "categoryPath": [
      "(68724) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(68724) Dom i Ogród / Wyposażenie / Przybory kuchenne / Maselniczki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maszynki i roboty kuchenne",
    "categoryPath": [
      "(110933) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110933) Dom i Ogród / Wyposażenie / Przybory kuchenne / Maszynki i roboty kuchenne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty do zlewu",
    "categoryPath": [
      "(322271) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(322271) Dom i Ogród / Wyposażenie / Przybory kuchenne / Maty do zlewu",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Miski",
    "categoryPath": [
      "(110932) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110932) Dom i Ogród / Wyposażenie / Przybory kuchenne / Miski",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Młynki i moździerze",
    "categoryPath": [
      "(68705) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(68705) Dom i Ogród / Wyposażenie / Przybory kuchenne / Młynki i moździerze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Naczynia żaroodporne",
    "categoryPath": [
      "(110935) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110935) Dom i Ogród / Wyposażenie / Przybory kuchenne / Naczynia żaroodporne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komplety noży",
    "categoryPath": [
      "(68693) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Noże i nożyce kuchenne"
    ],
    "hierarchy": "(68693) Dom i Ogród / Wyposażenie / Przybory kuchenne / Noże i nożyce kuchenne / Komplety noży",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Listwy magnetyczne",
    "categoryPath": [
      "(316705) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Noże i nożyce kuchenne"
    ],
    "hierarchy": "(316705) Dom i Ogród / Wyposażenie / Przybory kuchenne / Noże i nożyce kuchenne / Listwy magnetyczne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nożyce",
    "categoryPath": [
      "(68694) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Noże i nożyce kuchenne"
    ],
    "hierarchy": "(68694) Dom i Ogród / Wyposażenie / Przybory kuchenne / Noże i nożyce kuchenne / Nożyce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ostrzałki do noży",
    "categoryPath": [
      "(110936) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Noże i nożyce kuchenne"
    ],
    "hierarchy": "(110936) Dom i Ogród / Wyposażenie / Przybory kuchenne / Noże i nożyce kuchenne / Ostrzałki do noży",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pojedyncze noże",
    "categoryPath": [
      "(68695) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Noże i nożyce kuchenne"
    ],
    "hierarchy": "(68695) Dom i Ogród / Wyposażenie / Przybory kuchenne / Noże i nożyce kuchenne / Pojedyncze noże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stojaki na noże",
    "categoryPath": [
      "(316498) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Noże i nożyce kuchenne"
    ],
    "hierarchy": "(316498) Dom i Ogród / Wyposażenie / Przybory kuchenne / Noże i nożyce kuchenne / Stojaki na noże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tasaki",
    "categoryPath": [
      "(68719) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne",
      "Noże i nożyce kuchenne"
    ],
    "hierarchy": "(68719) Dom i Ogród / Wyposażenie / Przybory kuchenne / Noże i nożyce kuchenne / Tasaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ociekacze i suszarki do naczyń",
    "categoryPath": [
      "(300489) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(300489) Dom i Ogród / Wyposażenie / Przybory kuchenne / Ociekacze i suszarki do naczyń",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Organizery do zlewu",
    "categoryPath": [
      "(320326) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(320326) Dom i Ogród / Wyposażenie / Przybory kuchenne / Organizery do zlewu",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pojemniki i przechowywanie żywności",
    "categoryPath": [
      "(15979) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(15979) Dom i Ogród / Wyposażenie / Przybory kuchenne / Pojemniki i przechowywanie żywności",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(15974) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(15974) Dom i Ogród / Wyposażenie / Przybory kuchenne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płyty na kuchenkę",
    "categoryPath": [
      "(322091) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(322091) Dom i Ogród / Wyposażenie / Przybory kuchenne / Płyty na kuchenkę",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Relingi kuchenne",
    "categoryPath": [
      "(316718) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(316718) Dom i Ogród / Wyposażenie / Przybory kuchenne / Relingi kuchenne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sitka i cedzaki",
    "categoryPath": [
      "(68721) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(68721) Dom i Ogród / Wyposażenie / Przybory kuchenne / Sitka i cedzaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Solniczki i pieprzniczki",
    "categoryPath": [
      "(110938) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110938) Dom i Ogród / Wyposażenie / Przybory kuchenne / Solniczki i pieprzniczki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stolnice i wałki",
    "categoryPath": [
      "(110939) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110939) Dom i Ogród / Wyposażenie / Przybory kuchenne / Stolnice i wałki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tace i stoliki",
    "categoryPath": [
      "(110940) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110940) Dom i Ogród / Wyposażenie / Przybory kuchenne / Tace i stoliki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Termometry i minutniki",
    "categoryPath": [
      "(110942) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110942) Dom i Ogród / Wyposażenie / Przybory kuchenne / Termometry i minutniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Termosy i kubki termiczne",
    "categoryPath": [
      "(110941) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110941) Dom i Ogród / Wyposażenie / Przybory kuchenne / Termosy i kubki termiczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wagi i miarki kuchenne",
    "categoryPath": [
      "(110943) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110943) Dom i Ogród / Wyposażenie / Przybory kuchenne / Wagi i miarki kuchenne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wkłady do szuflad",
    "categoryPath": [
      "(261817) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(261817) Dom i Ogród / Wyposażenie / Przybory kuchenne / Wkłady do szuflad",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zaparzacze i kawiarki",
    "categoryPath": [
      "(110944) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110944) Dom i Ogród / Wyposażenie / Przybory kuchenne / Zaparzacze i kawiarki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ścierki, rękawice i fartuchy",
    "categoryPath": [
      "(110945) Dom i Ogród",
      "Wyposażenie",
      "Przybory kuchenne"
    ],
    "hierarchy": "(110945) Dom i Ogród / Wyposażenie / Przybory kuchenne / Ścierki, rękawice i fartuchy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pudełka",
    "categoryPath": [
      "(54045) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(54045) Dom i Ogród / Wyposażenie / Pudełka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ręczniki do sauny",
    "categoryPath": [
      "(303921) Dom i Ogród",
      "Wyposażenie",
      "Ręczniki"
    ],
    "hierarchy": "(303921) Dom i Ogród / Wyposażenie / Ręczniki / Ręczniki do sauny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ręczniki kąpielowe",
    "categoryPath": [
      "(303945) Dom i Ogród",
      "Wyposażenie",
      "Ręczniki"
    ],
    "hierarchy": "(303945) Dom i Ogród / Wyposażenie / Ręczniki / Ręczniki kąpielowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ręczniki plażowe",
    "categoryPath": [
      "(68734) Dom i Ogród",
      "Wyposażenie",
      "Ręczniki"
    ],
    "hierarchy": "(68734) Dom i Ogród / Wyposażenie / Ręczniki / Ręczniki plażowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Turbany na głowę",
    "categoryPath": [
      "(303933) Dom i Ogród",
      "Wyposażenie",
      "Ręczniki"
    ],
    "hierarchy": "(303933) Dom i Ogród / Wyposażenie / Ręczniki / Turbany na głowę",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy ręczników",
    "categoryPath": [
      "(68735) Dom i Ogród",
      "Wyposażenie",
      "Ręczniki"
    ],
    "hierarchy": "(68735) Dom i Ogród / Wyposażenie / Ręczniki / Zestawy ręczników",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sauny i akcesoria",
    "categoryPath": [
      "(110195) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(110195) Dom i Ogród / Wyposażenie / Sauny i akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szkatułki i kuferki",
    "categoryPath": [
      "(110196) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(110196) Dom i Ogród / Wyposażenie / Szkatułki i kuferki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Torby i worki na zakupy",
    "categoryPath": [
      "(300789) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(300789) Dom i Ogród / Wyposażenie / Torby i worki na zakupy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wentylatory domowe",
    "categoryPath": [
      "(255504) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(255504) Dom i Ogród / Wyposażenie / Wentylatory domowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria do świec",
    "categoryPath": [
      "(313721) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria"
    ],
    "hierarchy": "(313721) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Akcesoria do świec",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dyfuzory elektryczne",
    "categoryPath": [
      "(254288) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Dyfuzory zapachowe"
    ],
    "hierarchy": "(254288) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Dyfuzory zapachowe / Dyfuzory elektryczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dyfuzory ultradźwiękowe",
    "categoryPath": [
      "(313709) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Dyfuzory zapachowe"
    ],
    "hierarchy": "(313709) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Dyfuzory zapachowe / Dyfuzory ultradźwiękowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dyfuzory z patyczkami (kuleczkami)",
    "categoryPath": [
      "(313697) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Dyfuzory zapachowe"
    ],
    "hierarchy": "(313697) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Dyfuzory zapachowe / Dyfuzory z patyczkami (kuleczkami)",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kadzidełka",
    "categoryPath": [
      "(254300) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Kadzidełka i akcesoria"
    ],
    "hierarchy": "(254300) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Kadzidełka i akcesoria / Kadzidełka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podstawki",
    "categoryPath": [
      "(254301) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Kadzidełka i akcesoria"
    ],
    "hierarchy": "(254301) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Kadzidełka i akcesoria / Podstawki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kominki zapachowe",
    "categoryPath": [
      "(254290) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Kominki i woski"
    ],
    "hierarchy": "(254290) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Kominki i woski / Kominki zapachowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Woski zapachowe",
    "categoryPath": [
      "(254291) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Kominki i woski"
    ],
    "hierarchy": "(254291) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Kominki i woski / Woski zapachowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy kominek i woski",
    "categoryPath": [
      "(254292) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Kominki i woski"
    ],
    "hierarchy": "(254292) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Kominki i woski / Zestawy kominek i woski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampy do olejków",
    "categoryPath": [
      "(254296) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Lampy i olejki"
    ],
    "hierarchy": "(254296) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Lampy i olejki / Lampy do olejków",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy lampa i olejki",
    "categoryPath": [
      "(254298) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Lampy i olejki"
    ],
    "hierarchy": "(254298) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Lampy i olejki / Zestawy lampa i olejki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Olejki zapachowe",
    "categoryPath": [
      "(254297) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria",
      "Olejki"
    ],
    "hierarchy": "(254297) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Olejki / Olejki zapachowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Woski naturalne",
    "categoryPath": [
      "(322394) Dom i Ogród",
      "Wyposażenie",
      "Woski, olejki i akcesoria"
    ],
    "hierarchy": "(322394) Dom i Ogród / Wyposażenie / Woski, olejki i akcesoria / Woski naturalne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(49864) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Firany"
    ],
    "hierarchy": "(49864) Dom i Ogród / Wyposażenie / Wystrój okien / Firany / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Firany gotowe",
    "categoryPath": [
      "(49862) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Firany"
    ],
    "hierarchy": "(49862) Dom i Ogród / Wyposażenie / Wystrój okien / Firany / Firany gotowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Firany na metry",
    "categoryPath": [
      "(49863) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Firany"
    ],
    "hierarchy": "(49863) Dom i Ogród / Wyposażenie / Wystrój okien / Firany / Firany na metry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Folie okienne",
    "categoryPath": [
      "(112556) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien"
    ],
    "hierarchy": "(112556) Dom i Ogród / Wyposażenie / Wystrój okien / Folie okienne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Karnisze gotowe",
    "categoryPath": [
      "(260691) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Karnisze"
    ],
    "hierarchy": "(260691) Dom i Ogród / Wyposażenie / Wystrój okien / Karnisze / Karnisze gotowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Karnisze mini",
    "categoryPath": [
      "(260693) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Karnisze"
    ],
    "hierarchy": "(260693) Dom i Ogród / Wyposażenie / Wystrój okien / Karnisze / Karnisze mini",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Karnisze w elementach",
    "categoryPath": [
      "(260692) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Karnisze"
    ],
    "hierarchy": "(260692) Dom i Ogród / Wyposażenie / Wystrój okien / Karnisze / Karnisze w elementach",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szyny sufitowe i akcesoria",
    "categoryPath": [
      "(260694) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Karnisze"
    ],
    "hierarchy": "(260694) Dom i Ogród / Wyposażenie / Wystrój okien / Karnisze / Szyny sufitowe i akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Moskitiery",
    "categoryPath": [
      "(112555) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien"
    ],
    "hierarchy": "(112555) Dom i Ogród / Wyposażenie / Wystrój okien / Moskitiery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Próbki tkanin",
    "categoryPath": [
      "(320548) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien"
    ],
    "hierarchy": "(320548) Dom i Ogród / Wyposażenie / Wystrój okien / Próbki tkanin",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rolety",
    "categoryPath": [
      "(15984) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien"
    ],
    "hierarchy": "(15984) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Haczyki",
    "categoryPath": [
      "(315045) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(315045) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Haczyki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kasety",
    "categoryPath": [
      "(314961) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(314961) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Kasety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mechanizmy",
    "categoryPath": [
      "(315033) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(315033) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Mechanizmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Napinacze",
    "categoryPath": [
      "(314997) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(314997) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Napinacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obciążniki",
    "categoryPath": [
      "(315009) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(315009) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Obciążniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Prowadnice",
    "categoryPath": [
      "(315021) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(315021) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Prowadnice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łańcuszki",
    "categoryPath": [
      "(314985) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(314985) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Łańcuszki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łączniki łańcuszków",
    "categoryPath": [
      "(314973) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety",
      "Akcesoria"
    ],
    "hierarchy": "(314973) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Akcesoria / Łączniki łańcuszków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rolety dachowe",
    "categoryPath": [
      "(260699) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety"
    ],
    "hierarchy": "(260699) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Rolety dachowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rolety dzień i noc",
    "categoryPath": [
      "(260698) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety"
    ],
    "hierarchy": "(260698) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Rolety dzień i noc",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rolety plisowane",
    "categoryPath": [
      "(260701) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety"
    ],
    "hierarchy": "(260701) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Rolety plisowane",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rolety proste",
    "categoryPath": [
      "(260697) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety"
    ],
    "hierarchy": "(260697) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Rolety proste",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rolety rzymskie",
    "categoryPath": [
      "(260700) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Rolety"
    ],
    "hierarchy": "(260700) Dom i Ogród / Wyposażenie / Wystrój okien / Rolety / Rolety rzymskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zasłony gotowe",
    "categoryPath": [
      "(49865) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Zasłony"
    ],
    "hierarchy": "(49865) Dom i Ogród / Wyposażenie / Wystrój okien / Zasłony / Zasłony gotowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zasłony na metry",
    "categoryPath": [
      "(49866) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien",
      "Zasłony"
    ],
    "hierarchy": "(49866) Dom i Ogród / Wyposażenie / Wystrój okien / Zasłony / Zasłony na metry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Żaluzje",
    "categoryPath": [
      "(68685) Dom i Ogród",
      "Wyposażenie",
      "Wystrój okien"
    ],
    "hierarchy": "(68685) Dom i Ogród / Wyposażenie / Wystrój okien / Żaluzje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zabawne gadżety",
    "categoryPath": [
      "(121237) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(121237) Dom i Ogród / Wyposażenie / Zabawne gadżety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bulionówki",
    "categoryPath": [
      "(260895) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(260895) Dom i Ogród / Wyposażenie / Zastawa stołowa / Bulionówki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Cukiernice",
    "categoryPath": [
      "(110882) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110882) Dom i Ogród / Wyposażenie / Zastawa stołowa / Cukiernice",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dzbanki, karafki i mleczniki",
    "categoryPath": [
      "(110881) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110881) Dom i Ogród / Wyposażenie / Zastawa stołowa / Dzbanki, karafki i mleczniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Filiżanki",
    "categoryPath": [
      "(110883) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110883) Dom i Ogród / Wyposażenie / Zastawa stołowa / Filiżanki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Imbryki",
    "categoryPath": [
      "(110884) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110884) Dom i Ogród / Wyposażenie / Zastawa stołowa / Imbryki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kieliszki i pucharki",
    "categoryPath": [
      "(110885) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110885) Dom i Ogród / Wyposażenie / Zastawa stołowa / Kieliszki i pucharki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kubki",
    "categoryPath": [
      "(110886) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110886) Dom i Ogród / Wyposażenie / Zastawa stołowa / Kubki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kubki i zestawy do grzanego wina",
    "categoryPath": [
      "(316699) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(316699) Dom i Ogród / Wyposażenie / Zastawa stołowa / Kubki i zestawy do grzanego wina",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Miski",
    "categoryPath": [
      "(110887) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110887) Dom i Ogród / Wyposażenie / Zastawa stołowa / Miski",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Naczynia do jajek",
    "categoryPath": [
      "(320329) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(320329) Dom i Ogród / Wyposażenie / Zastawa stołowa / Naczynia do jajek",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Naczynia jednorazowe",
    "categoryPath": [
      "(121254) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(121254) Dom i Ogród / Wyposażenie / Zastawa stołowa / Naczynia jednorazowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Obrączki na serwetki",
    "categoryPath": [
      "(320116) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(320116) Dom i Ogród / Wyposażenie / Zastawa stołowa / Obrączki na serwetki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Patery",
    "categoryPath": [
      "(110888) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110888) Dom i Ogród / Wyposażenie / Zastawa stołowa / Patery",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(110880) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110880) Dom i Ogród / Wyposażenie / Zastawa stołowa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Salaterki i półmiski",
    "categoryPath": [
      "(110889) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110889) Dom i Ogród / Wyposażenie / Zastawa stołowa / Salaterki i półmiski",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Serwetniki",
    "categoryPath": [
      "(260896) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(260896) Dom i Ogród / Wyposażenie / Zastawa stołowa / Serwetniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Serwisy",
    "categoryPath": [
      "(110890) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110890) Dom i Ogród / Wyposażenie / Zastawa stołowa / Serwisy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sosjerki i dipówki",
    "categoryPath": [
      "(110895) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110895) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sosjerki i dipówki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Spodki",
    "categoryPath": [
      "(321074) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(321074) Dom i Ogród / Wyposażenie / Zastawa stołowa / Spodki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szklanki i kufle",
    "categoryPath": [
      "(110896) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110896) Dom i Ogród / Wyposażenie / Zastawa stołowa / Szklanki i kufle",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komplety sztućców",
    "categoryPath": [
      "(110902) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(110902) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Komplety sztućców",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Noże",
    "categoryPath": [
      "(110898) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(110898) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Noże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pałeczki",
    "categoryPath": [
      "(110903) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(110903) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Pałeczki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sztućce dla dzieci",
    "categoryPath": [
      "(254378) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(254378) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Sztućce dla dzieci",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Widelce",
    "categoryPath": [
      "(110901) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(110901) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Widelce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Widelczyki deserowe",
    "categoryPath": [
      "(147365) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(147365) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Widelczyki deserowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Łyżeczki",
    "categoryPath": [
      "(110900) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(110900) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Łyżeczki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Łyżki",
    "categoryPath": [
      "(110899) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa",
      "Sztućce"
    ],
    "hierarchy": "(110899) Dom i Ogród / Wyposażenie / Zastawa stołowa / Sztućce / Łyżki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Talerze",
    "categoryPath": [
      "(110904) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110904) Dom i Ogród / Wyposażenie / Zastawa stołowa / Talerze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wazy",
    "categoryPath": [
      "(110905) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(110905) Dom i Ogród / Wyposażenie / Zastawa stołowa / Wazy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy do sushi",
    "categoryPath": [
      "(316696) Dom i Ogród",
      "Wyposażenie",
      "Zastawa stołowa"
    ],
    "hierarchy": "(316696) Dom i Ogród / Wyposażenie / Zastawa stołowa / Zestawy do sushi",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zegary",
    "categoryPath": [
      "(541) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(541) Dom i Ogród / Wyposażenie / Zegary",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Świece",
    "categoryPath": [
      "(254295) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(254295) Dom i Ogród / Wyposażenie / Świece",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Świeczniki",
    "categoryPath": [
      "(254294) Dom i Ogród",
      "Wyposażenie"
    ],
    "hierarchy": "(254294) Dom i Ogród / Wyposażenie / Świeczniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Adaptery do pasów",
    "categoryPath": [
      "(257936) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257936) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Adaptery do pasów",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Koszule dla karmiących",
    "categoryPath": [
      "(257940) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257940) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Koszule dla karmiących",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kremy dla mamy",
    "categoryPath": [
      "(257941) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257941) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Kremy dla mamy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Majtki poporodowe",
    "categoryPath": [
      "(258006) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(258006) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Majtki poporodowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Osłonki na piersi",
    "categoryPath": [
      "(257945) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257945) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Osłonki na piersi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pasy ciążowe",
    "categoryPath": [
      "(257946) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257946) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Pasy ciążowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podkłady higieniczne",
    "categoryPath": [
      "(257935) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257935) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Podkłady higieniczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poduszki do spania i karmienia",
    "categoryPath": [
      "(257937) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257937) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Poduszki do spania i karmienia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257944) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257944) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Testy ciążowe",
    "categoryPath": [
      "(257939) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257939) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Testy ciążowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wkładki laktacyjne i muszle",
    "categoryPath": [
      "(257942) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Akcesoria dla mamy"
    ],
    "hierarchy": "(257942) Dziecko / Akcesoria dla mamy i dziecka / Akcesoria dla mamy / Wkładki laktacyjne i muszle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Akcesoria odblaskowe",
    "categoryPath": [
      "(257901) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(257901) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Akcesoria odblaskowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bramki",
    "categoryPath": [
      "(82698) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(82698) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Bramki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Imienniki",
    "categoryPath": [
      "(257719) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(257719) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Imienniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kaski ochronne",
    "categoryPath": [
      "(82703) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(82703) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Kaski ochronne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lokalizatory GPS",
    "categoryPath": [
      "(257720) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(257720) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Lokalizatory GPS",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty antypoślizgowe",
    "categoryPath": [
      "(83700) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(83700) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Maty antypoślizgowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ochrona dokumentów",
    "categoryPath": [
      "(257721) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(257721) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Ochrona dokumentów",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82706) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(82706) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szelki zabezpieczające",
    "categoryPath": [
      "(82705) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(82705) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Szelki zabezpieczające",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Słuchawki ochronne",
    "categoryPath": [
      "(257902) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(257902) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Słuchawki ochronne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zabezpieczenia",
    "categoryPath": [
      "(257785) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Bezpieczeństwo"
    ],
    "hierarchy": "(257785) Dziecko / Akcesoria dla mamy i dziecka / Bezpieczeństwo / Zabezpieczenia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Karty i maty do zdjęć",
    "categoryPath": [
      "(316558) Dziecko",
      "Akcesoria dla mamy i dziecka"
    ],
    "hierarchy": "(316558) Dziecko / Akcesoria dla mamy i dziecka / Karty i maty do zdjęć",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Elektryczne",
    "categoryPath": [
      "(315539) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Laktatory i akcesoria"
    ],
    "hierarchy": "(315539) Dziecko / Akcesoria dla mamy i dziecka / Laktatory i akcesoria / Elektryczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kolektory",
    "categoryPath": [
      "(315545) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Laktatory i akcesoria"
    ],
    "hierarchy": "(315545) Dziecko / Akcesoria dla mamy i dziecka / Laktatory i akcesoria / Kolektory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lejki i nakładki",
    "categoryPath": [
      "(315548) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Laktatory i akcesoria"
    ],
    "hierarchy": "(315548) Dziecko / Akcesoria dla mamy i dziecka / Laktatory i akcesoria / Lejki i nakładki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Membrany i zaworki",
    "categoryPath": [
      "(315551) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Laktatory i akcesoria"
    ],
    "hierarchy": "(315551) Dziecko / Akcesoria dla mamy i dziecka / Laktatory i akcesoria / Membrany i zaworki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ręczne",
    "categoryPath": [
      "(315542) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Laktatory i akcesoria"
    ],
    "hierarchy": "(315542) Dziecko / Akcesoria dla mamy i dziecka / Laktatory i akcesoria / Ręczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Leżaczki i huśtawki",
    "categoryPath": [
      "(82596) Dziecko",
      "Akcesoria dla mamy i dziecka"
    ],
    "hierarchy": "(82596) Dziecko / Akcesoria dla mamy i dziecka / Leżaczki i huśtawki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nianie elektroniczne i monitory oddechu",
    "categoryPath": [
      "(260394) Dziecko",
      "Akcesoria dla mamy i dziecka"
    ],
    "hierarchy": "(260394) Dziecko / Akcesoria dla mamy i dziecka / Nianie elektroniczne i monitory oddechu",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Chusty",
    "categoryPath": [
      "(83685) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Nosidełka i chusty"
    ],
    "hierarchy": "(83685) Dziecko / Akcesoria dla mamy i dziecka / Nosidełka i chusty / Chusty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nosidełka",
    "categoryPath": [
      "(83684) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Nosidełka i chusty"
    ],
    "hierarchy": "(83684) Dziecko / Akcesoria dla mamy i dziecka / Nosidełka i chusty / Nosidełka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82602) Dziecko",
      "Akcesoria dla mamy i dziecka"
    ],
    "hierarchy": "(82602) Dziecko / Akcesoria dla mamy i dziecka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Gryzaki",
    "categoryPath": [
      "(257799) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Smoczki uspokajające i gryzaki"
    ],
    "hierarchy": "(257799) Dziecko / Akcesoria dla mamy i dziecka / Smoczki uspokajające i gryzaki / Gryzaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pojemniki na smoczki",
    "categoryPath": [
      "(257801) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Smoczki uspokajające i gryzaki"
    ],
    "hierarchy": "(257801) Dziecko / Akcesoria dla mamy i dziecka / Smoczki uspokajające i gryzaki / Pojemniki na smoczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Smoczki",
    "categoryPath": [
      "(257798) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Smoczki uspokajające i gryzaki"
    ],
    "hierarchy": "(257798) Dziecko / Akcesoria dla mamy i dziecka / Smoczki uspokajające i gryzaki / Smoczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zawieszki",
    "categoryPath": [
      "(257800) Dziecko",
      "Akcesoria dla mamy i dziecka",
      "Smoczki uspokajające i gryzaki"
    ],
    "hierarchy": "(257800) Dziecko / Akcesoria dla mamy i dziecka / Smoczki uspokajające i gryzaki / Zawieszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bibuły",
    "categoryPath": [
      "(260959) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(260959) Dziecko / Artykuły szkolne / Artykuły papiernicze / Bibuły",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bloki",
    "categoryPath": [
      "(50681) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(50681) Dziecko / Artykuły szkolne / Artykuły papiernicze / Bloki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dziurkacze, zszywacze",
    "categoryPath": [
      "(260960) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(260960) Dziecko / Artykuły szkolne / Artykuły papiernicze / Dziurkacze, zszywacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Karteczki",
    "categoryPath": [
      "(84744) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(84744) Dziecko / Artykuły szkolne / Artykuły papiernicze / Karteczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kolorowanki",
    "categoryPath": [
      "(84743) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(84743) Dziecko / Artykuły szkolne / Artykuły papiernicze / Kolorowanki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Naklejki, tatuaże",
    "categoryPath": [
      "(84742) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(84742) Dziecko / Artykuły szkolne / Artykuły papiernicze / Naklejki, tatuaże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Notesy, pamiętniki",
    "categoryPath": [
      "(50682) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(50682) Dziecko / Artykuły szkolne / Artykuły papiernicze / Notesy, pamiętniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Okładki",
    "categoryPath": [
      "(260921) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(260921) Dziecko / Artykuły szkolne / Artykuły papiernicze / Okładki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Papiery",
    "categoryPath": [
      "(260922) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(260922) Dziecko / Artykuły szkolne / Artykuły papiernicze / Papiery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Plany lekcji",
    "categoryPath": [
      "(85155) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(85155) Dziecko / Artykuły szkolne / Artykuły papiernicze / Plany lekcji",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podkładki na biurko",
    "categoryPath": [
      "(85154) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(85154) Dziecko / Artykuły szkolne / Artykuły papiernicze / Podkładki na biurko",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50680) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(50680) Dziecko / Artykuły szkolne / Artykuły papiernicze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Teczki",
    "categoryPath": [
      "(50684) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(50684) Dziecko / Artykuły szkolne / Artykuły papiernicze / Teczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zeszyty",
    "categoryPath": [
      "(50685) Dziecko",
      "Artykuły szkolne",
      "Artykuły papiernicze"
    ],
    "hierarchy": "(50685) Dziecko / Artykuły szkolne / Artykuły papiernicze / Zeszyty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Farby",
    "categoryPath": [
      "(50687) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(50687) Dziecko / Artykuły szkolne / Artykuły plastyczne / Farby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Fartuszki dla dzieci",
    "categoryPath": [
      "(261001) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(261001) Dziecko / Artykuły szkolne / Artykuły plastyczne / Fartuszki dla dzieci",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(50688) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(50688) Dziecko / Artykuły szkolne / Artykuły plastyczne / Kleje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kredki",
    "categoryPath": [
      "(50689) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(50689) Dziecko / Artykuły szkolne / Artykuły plastyczne / Kredki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kredy",
    "categoryPath": [
      "(84819) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(84819) Dziecko / Artykuły szkolne / Artykuły plastyczne / Kredy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nożyczki",
    "categoryPath": [
      "(50690) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(50690) Dziecko / Artykuły szkolne / Artykuły plastyczne / Nożyczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pisaki, mazaki, flamastry",
    "categoryPath": [
      "(50691) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(50691) Dziecko / Artykuły szkolne / Artykuły plastyczne / Pisaki, mazaki, flamastry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Plasteliny, modeliny",
    "categoryPath": [
      "(50692) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(50692) Dziecko / Artykuły szkolne / Artykuły plastyczne / Plasteliny, modeliny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50686) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(50686) Dziecko / Artykuły szkolne / Artykuły plastyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pędzelki, palety i kubki na wodę",
    "categoryPath": [
      "(260999) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(260999) Dziecko / Artykuły szkolne / Artykuły plastyczne / Pędzelki, palety i kubki na wodę",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(261000) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(261000) Dziecko / Artykuły szkolne / Artykuły plastyczne / Taśmy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(84745) Dziecko",
      "Artykuły szkolne",
      "Artykuły plastyczne"
    ],
    "hierarchy": "(84745) Dziecko / Artykuły szkolne / Artykuły plastyczne / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Birety",
    "categoryPath": [
      "(301142) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(301142) Dziecko / Artykuły szkolne / Birety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dyplomy",
    "categoryPath": [
      "(322677) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(322677) Dziecko / Artykuły szkolne / Dyplomy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nerki dla dzieci",
    "categoryPath": [
      "(258851) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(258851) Dziecko / Artykuły szkolne / Nerki dla dzieci",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Piórniki",
    "categoryPath": [
      "(84735) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(84735) Dziecko / Artykuły szkolne / Piórniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Plecaki przedszkolne",
    "categoryPath": [
      "(99485) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(99485) Dziecko / Artykuły szkolne / Plecaki przedszkolne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Plecaki szkolne",
    "categoryPath": [
      "(50678) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(50678) Dziecko / Artykuły szkolne / Plecaki szkolne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Globusy",
    "categoryPath": [
      "(84738) Dziecko",
      "Artykuły szkolne",
      "Pomoce naukowe"
    ],
    "hierarchy": "(84738) Dziecko / Artykuły szkolne / Pomoce naukowe / Globusy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mapy",
    "categoryPath": [
      "(84739) Dziecko",
      "Artykuły szkolne",
      "Pomoce naukowe"
    ],
    "hierarchy": "(84739) Dziecko / Artykuły szkolne / Pomoce naukowe / Mapy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nauka liczenia",
    "categoryPath": [
      "(261052) Dziecko",
      "Artykuły szkolne",
      "Pomoce naukowe"
    ],
    "hierarchy": "(261052) Dziecko / Artykuły szkolne / Pomoce naukowe / Nauka liczenia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(84741) Dziecko",
      "Artykuły szkolne",
      "Pomoce naukowe"
    ],
    "hierarchy": "(84741) Dziecko / Artykuły szkolne / Pomoce naukowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przybory geometryczne",
    "categoryPath": [
      "(85102) Dziecko",
      "Artykuły szkolne",
      "Pomoce naukowe"
    ],
    "hierarchy": "(85102) Dziecko / Artykuły szkolne / Pomoce naukowe / Przybory geometryczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sport i animacja",
    "categoryPath": [
      "(261053) Dziecko",
      "Artykuły szkolne",
      "Pomoce naukowe"
    ],
    "hierarchy": "(261053) Dziecko / Artykuły szkolne / Pomoce naukowe / Sport i animacja",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tablice",
    "categoryPath": [
      "(84740) Dziecko",
      "Artykuły szkolne",
      "Pomoce naukowe"
    ],
    "hierarchy": "(84740) Dziecko / Artykuły szkolne / Pomoce naukowe / Tablice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Portfele",
    "categoryPath": [
      "(99487) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(99487) Dziecko / Artykuły szkolne / Portfele",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50674) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(50674) Dziecko / Artykuły szkolne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Gumki do mazania",
    "categoryPath": [
      "(50700) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania",
      "Akcesoria"
    ],
    "hierarchy": "(50700) Dziecko / Artykuły szkolne / Przybory do pisania / Akcesoria / Gumki do mazania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50699) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania",
      "Akcesoria"
    ],
    "hierarchy": "(50699) Dziecko / Artykuły szkolne / Przybory do pisania / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Temperówki",
    "categoryPath": [
      "(50702) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania",
      "Akcesoria"
    ],
    "hierarchy": "(50702) Dziecko / Artykuły szkolne / Przybory do pisania / Akcesoria / Temperówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korektory",
    "categoryPath": [
      "(261304) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania"
    ],
    "hierarchy": "(261304) Dziecko / Artykuły szkolne / Przybory do pisania / Korektory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Organizery na biurko",
    "categoryPath": [
      "(261305) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania"
    ],
    "hierarchy": "(261305) Dziecko / Artykuły szkolne / Przybory do pisania / Organizery na biurko",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ołówki",
    "categoryPath": [
      "(50696) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania"
    ],
    "hierarchy": "(50696) Dziecko / Artykuły szkolne / Przybory do pisania / Ołówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pióra",
    "categoryPath": [
      "(50697) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania"
    ],
    "hierarchy": "(50697) Dziecko / Artykuły szkolne / Przybory do pisania / Pióra",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(50698) Dziecko",
      "Artykuły szkolne",
      "Przybory do pisania"
    ],
    "hierarchy": "(50698) Dziecko / Artykuły szkolne / Przybory do pisania / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Torby szkolne",
    "categoryPath": [
      "(50679) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(50679) Dziecko / Artykuły szkolne / Torby szkolne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Torebki dziecięce",
    "categoryPath": [
      "(258853) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(258853) Dziecko / Artykuły szkolne / Torebki dziecięce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tornistry",
    "categoryPath": [
      "(258849) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(258849) Dziecko / Artykuły szkolne / Tornistry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Walizki dla dzieci",
    "categoryPath": [
      "(258852) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(258852) Dziecko / Artykuły szkolne / Walizki dla dzieci",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Worki",
    "categoryPath": [
      "(258850) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(258850) Dziecko / Artykuły szkolne / Worki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wyprawki",
    "categoryPath": [
      "(322908) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(322908) Dziecko / Artykuły szkolne / Wyprawki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Śniadaniówki i bidony",
    "categoryPath": [
      "(84737) Dziecko",
      "Artykuły szkolne"
    ],
    "hierarchy": "(84737) Dziecko / Artykuły szkolne / Śniadaniówki i bidony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Adaptery do fotelików",
    "categoryPath": [
      "(82766) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(82766) Dziecko / Foteliki samochodowe / Akcesoria / Adaptery do fotelików",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lusterka",
    "categoryPath": [
      "(260670) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(260670) Dziecko / Foteliki samochodowe / Akcesoria / Lusterka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze, maty",
    "categoryPath": [
      "(82765) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(82765) Dziecko / Foteliki samochodowe / Akcesoria / Ochraniacze, maty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Organizery",
    "categoryPath": [
      "(319772) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(319772) Dziecko / Foteliki samochodowe / Akcesoria / Organizery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Otulacze i kocyki do fotelików",
    "categoryPath": [
      "(319766) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(319766) Dziecko / Foteliki samochodowe / Akcesoria / Otulacze i kocyki do fotelików",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pasy",
    "categoryPath": [
      "(260669) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(260669) Dziecko / Foteliki samochodowe / Akcesoria / Pasy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce i śpiworki",
    "categoryPath": [
      "(82764) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(82764) Dziecko / Foteliki samochodowe / Akcesoria / Pokrowce i śpiworki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82769) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(82769) Dziecko / Foteliki samochodowe / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rolety samochodowe",
    "categoryPath": [
      "(82767) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(82767) Dziecko / Foteliki samochodowe / Akcesoria / Rolety samochodowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stoliki podróżne i podnóżki",
    "categoryPath": [
      "(319763) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(319763) Dziecko / Foteliki samochodowe / Akcesoria / Stoliki podróżne i podnóżki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tabliczki do samochodu",
    "categoryPath": [
      "(260671) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(260671) Dziecko / Foteliki samochodowe / Akcesoria / Tabliczki do samochodu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wkładki do fotelików",
    "categoryPath": [
      "(260672) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(260672) Dziecko / Foteliki samochodowe / Akcesoria / Wkładki do fotelików",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zagłówki i opaski",
    "categoryPath": [
      "(82768) Dziecko",
      "Foteliki samochodowe",
      "Akcesoria"
    ],
    "hierarchy": "(82768) Dziecko / Foteliki samochodowe / Akcesoria / Zagłówki i opaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bazy isofix",
    "categoryPath": [
      "(317192) Dziecko",
      "Foteliki samochodowe"
    ],
    "hierarchy": "(317192) Dziecko / Foteliki samochodowe / Bazy isofix",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Foteliki",
    "categoryPath": [
      "(251842) Dziecko",
      "Foteliki samochodowe"
    ],
    "hierarchy": "(251842) Dziecko / Foteliki samochodowe / Foteliki",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Podstawki",
    "categoryPath": [
      "(82714) Dziecko",
      "Foteliki samochodowe"
    ],
    "hierarchy": "(82714) Dziecko / Foteliki samochodowe / Podstawki",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Do mycia butelek",
    "categoryPath": [
      "(99437) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(99437) Dziecko / Karmienie dziecka / Butelki i akcesoria / Akcesoria / Do mycia butelek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pojemniki",
    "categoryPath": [
      "(99436) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(99436) Dziecko / Karmienie dziecka / Butelki i akcesoria / Akcesoria / Pojemniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(99434) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(99434) Dziecko / Karmienie dziecka / Butelki i akcesoria / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Saszetki na pokarm",
    "categoryPath": [
      "(306021) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(306021) Dziecko / Karmienie dziecka / Butelki i akcesoria / Akcesoria / Saszetki na pokarm",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Termoopakowania",
    "categoryPath": [
      "(99435) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(99435) Dziecko / Karmienie dziecka / Butelki i akcesoria / Akcesoria / Termoopakowania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Butelki",
    "categoryPath": [
      "(99424) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria"
    ],
    "hierarchy": "(99424) Dziecko / Karmienie dziecka / Butelki i akcesoria / Butelki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Smoczki",
    "categoryPath": [
      "(99422) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria",
      "Smoczki i ustniki do butelek"
    ],
    "hierarchy": "(99422) Dziecko / Karmienie dziecka / Butelki i akcesoria / Smoczki i ustniki do butelek / Smoczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ustniki",
    "categoryPath": [
      "(99423) Dziecko",
      "Karmienie dziecka",
      "Butelki i akcesoria",
      "Smoczki i ustniki do butelek"
    ],
    "hierarchy": "(99423) Dziecko / Karmienie dziecka / Butelki i akcesoria / Smoczki i ustniki do butelek / Ustniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Chusty do karmienia",
    "categoryPath": [
      "(316001) Dziecko",
      "Karmienie dziecka"
    ],
    "hierarchy": "(316001) Dziecko / Karmienie dziecka / Chusty do karmienia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Krzesełka do karmienia",
    "categoryPath": [
      "(258070) Dziecko",
      "Karmienie dziecka"
    ],
    "hierarchy": "(258070) Dziecko / Karmienie dziecka / Krzesełka do karmienia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(322896) Dziecko",
      "Karmienie dziecka",
      "Naczynia i sztućce"
    ],
    "hierarchy": "(322896) Dziecko / Karmienie dziecka / Naczynia i sztućce / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kubki i bidony",
    "categoryPath": [
      "(99442) Dziecko",
      "Karmienie dziecka",
      "Naczynia i sztućce"
    ],
    "hierarchy": "(99442) Dziecko / Karmienie dziecka / Naczynia i sztućce / Kubki i bidony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sztućce",
    "categoryPath": [
      "(99440) Dziecko",
      "Karmienie dziecka",
      "Naczynia i sztućce"
    ],
    "hierarchy": "(99440) Dziecko / Karmienie dziecka / Naczynia i sztućce / Sztućce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Talerzyki i miseczki",
    "categoryPath": [
      "(99441) Dziecko",
      "Karmienie dziecka",
      "Naczynia i sztućce"
    ],
    "hierarchy": "(99441) Dziecko / Karmienie dziecka / Naczynia i sztućce / Talerzyki i miseczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Termosy",
    "categoryPath": [
      "(255437) Dziecko",
      "Karmienie dziecka",
      "Naczynia i sztućce"
    ],
    "hierarchy": "(255437) Dziecko / Karmienie dziecka / Naczynia i sztućce / Termosy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(99449) Dziecko",
      "Karmienie dziecka",
      "Naczynia i sztućce"
    ],
    "hierarchy": "(99449) Dziecko / Karmienie dziecka / Naczynia i sztućce / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podgrzewacze",
    "categoryPath": [
      "(99455) Dziecko",
      "Karmienie dziecka"
    ],
    "hierarchy": "(99455) Dziecko / Karmienie dziecka / Podgrzewacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(99361) Dziecko",
      "Karmienie dziecka"
    ],
    "hierarchy": "(99361) Dziecko / Karmienie dziecka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sterylizatory",
    "categoryPath": [
      "(99461) Dziecko",
      "Karmienie dziecka"
    ],
    "hierarchy": "(99461) Dziecko / Karmienie dziecka / Sterylizatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Śliniaki",
    "categoryPath": [
      "(99465) Dziecko",
      "Karmienie dziecka"
    ],
    "hierarchy": "(99465) Dziecko / Karmienie dziecka / Śliniaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ciasteczka i przekąski",
    "categoryPath": [
      "(99477) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci"
    ],
    "hierarchy": "(99477) Dziecko / Karmienie dziecka / Żywność dla dzieci / Ciasteczka i przekąski",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Deserki",
    "categoryPath": [
      "(99475) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci"
    ],
    "hierarchy": "(99475) Dziecko / Karmienie dziecka / Żywność dla dzieci / Deserki",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbatki",
    "categoryPath": [
      "(253518) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci"
    ],
    "hierarchy": "(253518) Dziecko / Karmienie dziecka / Żywność dla dzieci / Herbatki",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kaszki",
    "categoryPath": [
      "(99473) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci"
    ],
    "hierarchy": "(99473) Dziecko / Karmienie dziecka / Żywność dla dzieci / Kaszki",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "następne",
    "categoryPath": [
      "(256972) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci",
      "Mleka modyfikowane"
    ],
    "hierarchy": "(256972) Dziecko / Karmienie dziecka / Żywność dla dzieci / Mleka modyfikowane / następne",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "początkowe",
    "categoryPath": [
      "(256973) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci",
      "Mleka modyfikowane"
    ],
    "hierarchy": "(256973) Dziecko / Karmienie dziecka / Żywność dla dzieci / Mleka modyfikowane / początkowe",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Obiadki",
    "categoryPath": [
      "(99474) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci"
    ],
    "hierarchy": "(99474) Dziecko / Karmienie dziecka / Żywność dla dzieci / Obiadki",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Soki",
    "categoryPath": [
      "(253519) Dziecko",
      "Karmienie dziecka",
      "Żywność dla dzieci"
    ],
    "hierarchy": "(253519) Dziecko / Karmienie dziecka / Żywność dla dzieci / Soki",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Baleriny",
    "categoryPath": [
      "(83674) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(83674) Dziecko / Obuwie / Baleriny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Baletki",
    "categoryPath": [
      "(147742) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(147742) Dziecko / Obuwie / Baletki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Botki",
    "categoryPath": [
      "(148137) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(148137) Dziecko / Obuwie / Botki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dla niemowląt",
    "categoryPath": [
      "(25954) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25954) Dziecko / Obuwie / Dla niemowląt",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ocieplacze do kaloszy",
    "categoryPath": [
      "(321032) Dziecko",
      "Obuwie",
      "Dodatki do obuwia"
    ],
    "hierarchy": "(321032) Dziecko / Obuwie / Dodatki do obuwia / Ocieplacze do kaloszy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sznurówki",
    "categoryPath": [
      "(321035) Dziecko",
      "Obuwie",
      "Dodatki do obuwia"
    ],
    "hierarchy": "(321035) Dziecko / Obuwie / Dodatki do obuwia / Sznurówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wkładki do butów",
    "categoryPath": [
      "(147744) Dziecko",
      "Obuwie",
      "Dodatki do obuwia"
    ],
    "hierarchy": "(147744) Dziecko / Obuwie / Dodatki do obuwia / Wkładki do butów",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kalosze",
    "categoryPath": [
      "(83659) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(83659) Dziecko / Obuwie / Kalosze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kapcie",
    "categoryPath": [
      "(25955) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25955) Dziecko / Obuwie / Kapcie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Klapki",
    "categoryPath": [
      "(25956) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25956) Dziecko / Obuwie / Klapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kozaki",
    "categoryPath": [
      "(25957) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25957) Dziecko / Obuwie / Kozaki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(25953) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25953) Dziecko / Obuwie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Profilaktyczne",
    "categoryPath": [
      "(83664) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(83664) Dziecko / Obuwie / Profilaktyczne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sandałki",
    "categoryPath": [
      "(25958) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25958) Dziecko / Obuwie / Sandałki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(25959) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25959) Dziecko / Obuwie / Sportowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trampki",
    "categoryPath": [
      "(147745) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(147745) Dziecko / Obuwie / Trampki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trzewiki i półbuty",
    "categoryPath": [
      "(25960) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(25960) Dziecko / Obuwie / Trzewiki i półbuty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Śniegowce",
    "categoryPath": [
      "(147743) Dziecko",
      "Obuwie"
    ],
    "hierarchy": "(147743) Dziecko / Obuwie / Śniegowce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Biżuteria",
    "categoryPath": [
      "(320701) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320701) Dziecko / Odzież / Akcesoria / Biżuteria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(320728) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320728) Dziecko / Odzież / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Krawaty",
    "categoryPath": [
      "(320710) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320710) Dziecko / Odzież / Akcesoria / Krawaty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Muszki",
    "categoryPath": [
      "(320713) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320713) Dziecko / Odzież / Akcesoria / Muszki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Okulary",
    "categoryPath": [
      "(320716) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320716) Dziecko / Odzież / Akcesoria / Okulary",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ozdoby do włosów",
    "categoryPath": [
      "(320719) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320719) Dziecko / Odzież / Akcesoria / Ozdoby do włosów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(320722) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320722) Dziecko / Odzież / Akcesoria / Paski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szelki",
    "categoryPath": [
      "(320780) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320780) Dziecko / Odzież / Akcesoria / Szelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Torebki",
    "categoryPath": [
      "(320725) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320725) Dziecko / Odzież / Akcesoria / Torebki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(320783) Dziecko",
      "Odzież",
      "Akcesoria"
    ],
    "hierarchy": "(320783) Dziecko / Odzież / Akcesoria / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Biustonosze",
    "categoryPath": [
      "(257190) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(257190) Dziecko / Odzież / Bielizna / Biustonosze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Body gimnastyczne",
    "categoryPath": [
      "(259083) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(259083) Dziecko / Odzież / Bielizna / Body gimnastyczne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Getry",
    "categoryPath": [
      "(89319) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(89319) Dziecko / Odzież / Bielizna / Getry",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kalesony",
    "categoryPath": [
      "(91512) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(91512) Dziecko / Odzież / Bielizna / Kalesony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety bielizny",
    "categoryPath": [
      "(89314) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(89314) Dziecko / Odzież / Bielizna / Komplety bielizny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Majtki",
    "categoryPath": [
      "(89318) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(89318) Dziecko / Odzież / Bielizna / Majtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Podkoszulki",
    "categoryPath": [
      "(89315) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(89315) Dziecko / Odzież / Bielizna / Podkoszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rajstopy",
    "categoryPath": [
      "(89323) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(89323) Dziecko / Odzież / Bielizna / Rajstopy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpetki, podkolanówki",
    "categoryPath": [
      "(89452) Dziecko",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(89452) Dziecko / Odzież / Bielizna / Skarpetki, podkolanówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzki",
    "categoryPath": [
      "(89508) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89508) Dziecko / Odzież / Bluzki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(89510) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89510) Dziecko / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bolerka",
    "categoryPath": [
      "(89509) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89509) Dziecko / Odzież / Bolerka",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki, chustki",
    "categoryPath": [
      "(89517) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89517) Dziecko / Odzież / Czapki, chustki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dresy kompletne",
    "categoryPath": [
      "(89511) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89511) Dziecko / Odzież / Dresy kompletne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Garnitury",
    "categoryPath": [
      "(89519) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89519) Dziecko / Odzież / Garnitury",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Golfy",
    "categoryPath": [
      "(89520) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89520) Dziecko / Odzież / Golfy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki, bezrękawniki",
    "categoryPath": [
      "(89512) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89512) Dziecko / Odzież / Kamizelki, bezrękawniki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kombinezony",
    "categoryPath": [
      "(89516) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89516) Dziecko / Odzież / Kombinezony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(89530) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89530) Dziecko / Odzież / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule",
    "categoryPath": [
      "(89513) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89513) Dziecko / Odzież / Koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Krótkie spodenki",
    "categoryPath": [
      "(89514) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89514) Dziecko / Odzież / Krótkie spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki, płaszcze",
    "categoryPath": [
      "(89515) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89515) Dziecko / Odzież / Kurtki, płaszcze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Legginsy",
    "categoryPath": [
      "(91501) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(91501) Dziecko / Odzież / Legginsy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Marynarki",
    "categoryPath": [
      "(89518) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89518) Dziecko / Odzież / Marynarki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Body",
    "categoryPath": [
      "(259089) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259089) Dziecko / Odzież / Odzież niemowlęca / Body",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki niemowlęce",
    "categoryPath": [
      "(259094) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259094) Dziecko / Odzież / Odzież niemowlęca / Czapki niemowlęce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kaftaniki",
    "categoryPath": [
      "(259092) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259092) Dziecko / Odzież / Odzież niemowlęca / Kaftaniki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety niemowlęce",
    "categoryPath": [
      "(259095) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259095) Dziecko / Odzież / Odzież niemowlęca / Komplety niemowlęce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Niedrapki",
    "categoryPath": [
      "(259090) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259090) Dziecko / Odzież / Odzież niemowlęca / Niedrapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pajacyki",
    "categoryPath": [
      "(259091) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259091) Dziecko / Odzież / Odzież niemowlęca / Pajacyki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259342) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259342) Dziecko / Odzież / Odzież niemowlęca / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półśpiochy",
    "categoryPath": [
      "(259093) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259093) Dziecko / Odzież / Odzież niemowlęca / Półśpiochy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rampersy",
    "categoryPath": [
      "(259099) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259099) Dziecko / Odzież / Odzież niemowlęca / Rampersy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpetki niemowlęce",
    "categoryPath": [
      "(259096) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259096) Dziecko / Odzież / Odzież niemowlęca / Skarpetki niemowlęce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Śpiochy",
    "categoryPath": [
      "(259098) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259098) Dziecko / Odzież / Odzież niemowlęca / Śpiochy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Śpiworki",
    "categoryPath": [
      "(259097) Dziecko",
      "Odzież",
      "Odzież niemowlęca"
    ],
    "hierarchy": "(259097) Dziecko / Odzież / Odzież niemowlęca / Śpiworki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piżamy, szlafroki",
    "categoryPath": [
      "(259167) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(259167) Dziecko / Odzież / Piżamy, szlafroki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostała odzież",
    "categoryPath": [
      "(89532) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89532) Dziecko / Odzież / Pozostała odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(89526) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89526) Dziecko / Odzież / Rękawiczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dresowe",
    "categoryPath": [
      "(259287) Dziecko",
      "Odzież",
      "Spodnie"
    ],
    "hierarchy": "(259287) Dziecko / Odzież / Spodnie / Dresowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Jeansowe",
    "categoryPath": [
      "(259289) Dziecko",
      "Odzież",
      "Spodnie"
    ],
    "hierarchy": "(259289) Dziecko / Odzież / Spodnie / Jeansowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Materiałowe",
    "categoryPath": [
      "(259286) Dziecko",
      "Odzież",
      "Spodnie"
    ],
    "hierarchy": "(259286) Dziecko / Odzież / Spodnie / Materiałowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Narciarskie",
    "categoryPath": [
      "(259290) Dziecko",
      "Odzież",
      "Spodnie"
    ],
    "hierarchy": "(259290) Dziecko / Odzież / Spodnie / Narciarskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Przeciwdeszczowe",
    "categoryPath": [
      "(260332) Dziecko",
      "Odzież",
      "Spodnie"
    ],
    "hierarchy": "(260332) Dziecko / Odzież / Spodnie / Przeciwdeszczowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wizytowe",
    "categoryPath": [
      "(259288) Dziecko",
      "Odzież",
      "Spodnie"
    ],
    "hierarchy": "(259288) Dziecko / Odzież / Spodnie / Wizytowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spódniczki",
    "categoryPath": [
      "(89522) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89522) Dziecko / Odzież / Spódniczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Stroje kąpielowe, kąpielówki",
    "categoryPath": [
      "(259285) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(259285) Dziecko / Odzież / Stroje kąpielowe, kąpielówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki",
    "categoryPath": [
      "(89521) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89521) Dziecko / Odzież / Sukienki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sweterki",
    "categoryPath": [
      "(89525) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89525) Dziecko / Odzież / Sweterki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Szaliki",
    "categoryPath": [
      "(257173) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(257173) Dziecko / Odzież / Szaliki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "T-shirty",
    "categoryPath": [
      "(89528) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89528) Dziecko / Odzież / T-shirty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Topy",
    "categoryPath": [
      "(89529) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89529) Dziecko / Odzież / Topy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Tuniki",
    "categoryPath": [
      "(89527) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89527) Dziecko / Odzież / Tuniki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zestawy ubrań",
    "categoryPath": [
      "(89531) Dziecko",
      "Odzież"
    ],
    "hierarchy": "(89531) Dziecko / Odzież / Zestawy ubrań",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bransoletki",
    "categoryPath": [
      "(99498) Dziecko",
      "Okazje, przyjęcia",
      "Biżuteria"
    ],
    "hierarchy": "(99498) Dziecko / Okazje, przyjęcia / Biżuteria / Bransoletki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kolczyki, klipsy",
    "categoryPath": [
      "(99497) Dziecko",
      "Okazje, przyjęcia",
      "Biżuteria"
    ],
    "hierarchy": "(99497) Dziecko / Okazje, przyjęcia / Biżuteria / Kolczyki, klipsy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Naszyjniki, korale",
    "categoryPath": [
      "(99499) Dziecko",
      "Okazje, przyjęcia",
      "Biżuteria"
    ],
    "hierarchy": "(99499) Dziecko / Okazje, przyjęcia / Biżuteria / Naszyjniki, korale",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pierścionki, przypinki",
    "categoryPath": [
      "(313745) Dziecko",
      "Okazje, przyjęcia",
      "Biżuteria"
    ],
    "hierarchy": "(313745) Dziecko / Okazje, przyjęcia / Biżuteria / Pierścionki, przypinki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zegarki",
    "categoryPath": [
      "(99500) Dziecko",
      "Okazje, przyjęcia",
      "Biżuteria"
    ],
    "hierarchy": "(99500) Dziecko / Okazje, przyjęcia / Biżuteria / Zegarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(99501) Dziecko",
      "Okazje, przyjęcia",
      "Biżuteria"
    ],
    "hierarchy": "(99501) Dziecko / Okazje, przyjęcia / Biżuteria / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Balony",
    "categoryPath": [
      "(88350) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(88350) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Balony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Czapeczki urodzinowe",
    "categoryPath": [
      "(320050) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(320050) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Czapeczki urodzinowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Girlandy",
    "categoryPath": [
      "(88349) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(88349) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Girlandy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Gwizdki urodzinowe",
    "categoryPath": [
      "(320927) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(320927) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Gwizdki urodzinowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Obrusy",
    "categoryPath": [
      "(88346) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(88346) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Obrusy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Piniaty",
    "categoryPath": [
      "(261030) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(261030) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Piniaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88344) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(88344) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Serpentyny, konfetti",
    "categoryPath": [
      "(88348) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(88348) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Serpentyny, konfetti",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Serwetki",
    "categoryPath": [
      "(88347) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(88347) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Serwetki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Toppery",
    "categoryPath": [
      "(321438) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(321438) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Toppery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Świeczki",
    "categoryPath": [
      "(88345) Dziecko",
      "Okazje, przyjęcia",
      "Dekoracje i gadżety"
    ],
    "hierarchy": "(88345) Dziecko / Okazje, przyjęcia / Dekoracje i gadżety / Świeczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88325) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Chrzest"
    ],
    "hierarchy": "(88325) Dziecko / Okazje, przyjęcia / Dodatki / Chrzest / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rożki, beciki",
    "categoryPath": [
      "(88326) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Chrzest"
    ],
    "hierarchy": "(88326) Dziecko / Okazje, przyjęcia / Dodatki / Chrzest / Rożki, beciki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szatki, świece, okapniki",
    "categoryPath": [
      "(88327) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Chrzest"
    ],
    "hierarchy": "(88327) Dziecko / Okazje, przyjęcia / Dodatki / Chrzest / Szatki, świece, okapniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Chusteczki",
    "categoryPath": [
      "(88329) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Komunia"
    ],
    "hierarchy": "(88329) Dziecko / Okazje, przyjęcia / Dodatki / Komunia / Chusteczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Krawaty i muszniki",
    "categoryPath": [
      "(88333) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Komunia"
    ],
    "hierarchy": "(88333) Dziecko / Okazje, przyjęcia / Dodatki / Komunia / Krawaty i muszniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88328) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Komunia"
    ],
    "hierarchy": "(88328) Dziecko / Okazje, przyjęcia / Dodatki / Komunia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(313649) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Komunia"
    ],
    "hierarchy": "(313649) Dziecko / Okazje, przyjęcia / Dodatki / Komunia / Rękawiczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Torebki",
    "categoryPath": [
      "(88330) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Komunia"
    ],
    "hierarchy": "(88330) Dziecko / Okazje, przyjęcia / Dodatki / Komunia / Torebki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wianki, stroiki",
    "categoryPath": [
      "(88331) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Komunia"
    ],
    "hierarchy": "(88331) Dziecko / Okazje, przyjęcia / Dodatki / Komunia / Wianki, stroiki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Świece i okapniki",
    "categoryPath": [
      "(88332) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki",
      "Komunia"
    ],
    "hierarchy": "(88332) Dziecko / Okazje, przyjęcia / Dodatki / Komunia / Świece i okapniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Okulary przeciwsłoneczne",
    "categoryPath": [
      "(99493) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki"
    ],
    "hierarchy": "(99493) Dziecko / Okazje, przyjęcia / Dodatki / Okulary przeciwsłoneczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Parasolki",
    "categoryPath": [
      "(99494) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki"
    ],
    "hierarchy": "(99494) Dziecko / Okazje, przyjęcia / Dodatki / Parasolki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(99495) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki"
    ],
    "hierarchy": "(99495) Dziecko / Okazje, przyjęcia / Dodatki / Paski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88321) Dziecko",
      "Okazje, przyjęcia",
      "Dodatki"
    ],
    "hierarchy": "(88321) Dziecko / Okazje, przyjęcia / Dodatki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Karnety okolicznościowe",
    "categoryPath": [
      "(320924) Dziecko",
      "Okazje, przyjęcia"
    ],
    "hierarchy": "(320924) Dziecko / Okazje, przyjęcia / Karnety okolicznościowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kapelusze",
    "categoryPath": [
      "(88335) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88335) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Kapelusze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kostiumy dla chłopców",
    "categoryPath": [
      "(88318) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88318) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Kostiumy dla chłopców",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kostiumy dla dziewczynek",
    "categoryPath": [
      "(88319) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88319) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Kostiumy dla dziewczynek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kostiumy uniseks",
    "categoryPath": [
      "(88320) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88320) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Kostiumy uniseks",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maski",
    "categoryPath": [
      "(88337) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88337) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Maski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Peruki",
    "categoryPath": [
      "(88339) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88339) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Peruki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Skrzydła",
    "categoryPath": [
      "(88338) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88338) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Skrzydła",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szable i miecze",
    "categoryPath": [
      "(88336) Dziecko",
      "Okazje, przyjęcia",
      "Kostiumy, przebrania"
    ],
    "hierarchy": "(88336) Dziecko / Okazje, przyjęcia / Kostiumy, przebrania / Szable i miecze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kubeczki",
    "categoryPath": [
      "(88354) Dziecko",
      "Okazje, przyjęcia",
      "Naczynia"
    ],
    "hierarchy": "(88354) Dziecko / Okazje, przyjęcia / Naczynia / Kubeczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88351) Dziecko",
      "Okazje, przyjęcia",
      "Naczynia"
    ],
    "hierarchy": "(88351) Dziecko / Okazje, przyjęcia / Naczynia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Słomki",
    "categoryPath": [
      "(88352) Dziecko",
      "Okazje, przyjęcia",
      "Naczynia"
    ],
    "hierarchy": "(88352) Dziecko / Okazje, przyjęcia / Naczynia / Słomki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Talerzyki",
    "categoryPath": [
      "(88353) Dziecko",
      "Okazje, przyjęcia",
      "Naczynia"
    ],
    "hierarchy": "(88353) Dziecko / Okazje, przyjęcia / Naczynia / Talerzyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Buciki",
    "categoryPath": [
      "(88309) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Chrzest"
    ],
    "hierarchy": "(88309) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Chrzest / Buciki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapeczki",
    "categoryPath": [
      "(88308) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Chrzest"
    ],
    "hierarchy": "(88308) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Chrzest / Czapeczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Garnitury i ubranka",
    "categoryPath": [
      "(88306) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Chrzest"
    ],
    "hierarchy": "(88306) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Chrzest / Garnitury i ubranka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukieneczki i stroje",
    "categoryPath": [
      "(88307) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Chrzest"
    ],
    "hierarchy": "(88307) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Chrzest / Sukieneczki i stroje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sweterki, pelerynki",
    "categoryPath": [
      "(88310) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Chrzest"
    ],
    "hierarchy": "(88310) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Chrzest / Sweterki, pelerynki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Alby",
    "categoryPath": [
      "(88312) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Komunia"
    ],
    "hierarchy": "(88312) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Komunia / Alby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Garnitury",
    "categoryPath": [
      "(88314) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Komunia"
    ],
    "hierarchy": "(88314) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Komunia / Garnitury",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule",
    "categoryPath": [
      "(88315) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Komunia"
    ],
    "hierarchy": "(88315) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Komunia / Koszule",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(88316) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Komunia"
    ],
    "hierarchy": "(88316) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Komunia / Obuwie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki",
    "categoryPath": [
      "(88313) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Komunia"
    ],
    "hierarchy": "(88313) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Komunia / Sukienki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sweterki, pelerynki",
    "categoryPath": [
      "(88317) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie",
      "Komunia"
    ],
    "hierarchy": "(88317) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Komunia / Sweterki, pelerynki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88301) Dziecko",
      "Okazje, przyjęcia",
      "Odzież, obuwie"
    ],
    "hierarchy": "(88301) Dziecko / Okazje, przyjęcia / Odzież, obuwie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Opaski",
    "categoryPath": [
      "(99490) Dziecko",
      "Okazje, przyjęcia",
      "Ozdoby do włosów"
    ],
    "hierarchy": "(99490) Dziecko / Okazje, przyjęcia / Ozdoby do włosów / Opaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(99492) Dziecko",
      "Okazje, przyjęcia",
      "Ozdoby do włosów"
    ],
    "hierarchy": "(99492) Dziecko / Okazje, przyjęcia / Ozdoby do włosów / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Albumy",
    "categoryPath": [
      "(88359) Dziecko",
      "Okazje, przyjęcia",
      "Pamiątki"
    ],
    "hierarchy": "(88359) Dziecko / Okazje, przyjęcia / Pamiątki / Albumy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Figurki, statuetki",
    "categoryPath": [
      "(88356) Dziecko",
      "Okazje, przyjęcia",
      "Pamiątki"
    ],
    "hierarchy": "(88356) Dziecko / Okazje, przyjęcia / Pamiątki / Figurki, statuetki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Księgi pamiątkowe",
    "categoryPath": [
      "(88361) Dziecko",
      "Okazje, przyjęcia",
      "Pamiątki"
    ],
    "hierarchy": "(88361) Dziecko / Okazje, przyjęcia / Pamiątki / Księgi pamiątkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Obrazki, ramki, odciski",
    "categoryPath": [
      "(88358) Dziecko",
      "Okazje, przyjęcia",
      "Pamiątki"
    ],
    "hierarchy": "(88358) Dziecko / Okazje, przyjęcia / Pamiątki / Obrazki, ramki, odciski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88355) Dziecko",
      "Okazje, przyjęcia",
      "Pamiątki"
    ],
    "hierarchy": "(88355) Dziecko / Okazje, przyjęcia / Pamiątki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Łyżeczki, grzechotki",
    "categoryPath": [
      "(88360) Dziecko",
      "Okazje, przyjęcia",
      "Pamiątki"
    ],
    "hierarchy": "(88360) Dziecko / Okazje, przyjęcia / Pamiątki / Łyżeczki, grzechotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Podziękowania",
    "categoryPath": [
      "(88357) Dziecko",
      "Okazje, przyjęcia"
    ],
    "hierarchy": "(88357) Dziecko / Okazje, przyjęcia / Podziękowania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88300) Dziecko",
      "Okazje, przyjęcia"
    ],
    "hierarchy": "(88300) Dziecko / Okazje, przyjęcia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Chrzest",
    "categoryPath": [
      "(88341) Dziecko",
      "Okazje, przyjęcia",
      "Zaproszenia"
    ],
    "hierarchy": "(88341) Dziecko / Okazje, przyjęcia / Zaproszenia / Chrzest",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komunia",
    "categoryPath": [
      "(88342) Dziecko",
      "Okazje, przyjęcia",
      "Zaproszenia"
    ],
    "hierarchy": "(88342) Dziecko / Okazje, przyjęcia / Zaproszenia / Komunia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(88340) Dziecko",
      "Okazje, przyjęcia",
      "Zaproszenia"
    ],
    "hierarchy": "(88340) Dziecko / Okazje, przyjęcia / Zaproszenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Urodziny",
    "categoryPath": [
      "(88343) Dziecko",
      "Okazje, przyjęcia",
      "Zaproszenia"
    ],
    "hierarchy": "(88343) Dziecko / Okazje, przyjęcia / Zaproszenia / Urodziny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Cotton balls",
    "categoryPath": [
      "(304985) Dziecko",
      "Pokój dziecięcy",
      "Lampy"
    ],
    "hierarchy": "(304985) Dziecko / Pokój dziecięcy / Lampy / Cotton balls",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampki - projektory",
    "categoryPath": [
      "(98762) Dziecko",
      "Pokój dziecięcy",
      "Lampy"
    ],
    "hierarchy": "(98762) Dziecko / Pokój dziecięcy / Lampy / Lampki - projektory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampki na biurko",
    "categoryPath": [
      "(304997) Dziecko",
      "Pokój dziecięcy",
      "Lampy"
    ],
    "hierarchy": "(304997) Dziecko / Pokój dziecięcy / Lampy / Lampki na biurko",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampki nocne",
    "categoryPath": [
      "(98761) Dziecko",
      "Pokój dziecięcy",
      "Lampy"
    ],
    "hierarchy": "(98761) Dziecko / Pokój dziecięcy / Lampy / Lampki nocne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampy sufitowe",
    "categoryPath": [
      "(98763) Dziecko",
      "Pokój dziecięcy",
      "Lampy"
    ],
    "hierarchy": "(98763) Dziecko / Pokój dziecięcy / Lampy / Lampy sufitowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lampy ścienne",
    "categoryPath": [
      "(98764) Dziecko",
      "Pokój dziecięcy",
      "Lampy"
    ],
    "hierarchy": "(98764) Dziecko / Pokój dziecięcy / Lampy / Lampy ścienne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(98760) Dziecko",
      "Pokój dziecięcy",
      "Lampy"
    ],
    "hierarchy": "(98760) Dziecko / Pokój dziecięcy / Lampy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Biurka",
    "categoryPath": [
      "(98754) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(98754) Dziecko / Pokój dziecięcy / Meble / Biurka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fotele",
    "categoryPath": [
      "(316246) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(316246) Dziecko / Pokój dziecięcy / Meble / Fotele",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Komplety mebli",
    "categoryPath": [
      "(98759) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(98759) Dziecko / Pokój dziecięcy / Meble / Komplety mebli",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Krzesła i fotele biurkowe",
    "categoryPath": [
      "(98755) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(98755) Dziecko / Pokój dziecięcy / Meble / Krzesła i fotele biurkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Materace",
    "categoryPath": [
      "(98752) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(98752) Dziecko / Pokój dziecięcy / Meble / Materace",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pojemniki na zabawki",
    "categoryPath": [
      "(19537) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(19537) Dziecko / Pokój dziecięcy / Meble / Pojemniki na zabawki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pufy",
    "categoryPath": [
      "(316249) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(316249) Dziecko / Pokój dziecięcy / Meble / Pufy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Półki",
    "categoryPath": [
      "(261402) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(261402) Dziecko / Pokój dziecięcy / Meble / Półki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Regały",
    "categoryPath": [
      "(98756) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(98756) Dziecko / Pokój dziecięcy / Meble / Regały",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Krzesła",
    "categoryPath": [
      "(319352) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Stoliki i krzesła"
    ],
    "hierarchy": "(319352) Dziecko / Pokój dziecięcy / Meble / Stoliki i krzesła / Krzesła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pomocniki kuchenne",
    "categoryPath": [
      "(319358) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Stoliki i krzesła"
    ],
    "hierarchy": "(319358) Dziecko / Pokój dziecięcy / Meble / Stoliki i krzesła / Pomocniki kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoliki",
    "categoryPath": [
      "(319349) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Stoliki i krzesła"
    ],
    "hierarchy": "(319349) Dziecko / Pokój dziecięcy / Meble / Stoliki i krzesła / Stoliki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy stoliki i krzesła",
    "categoryPath": [
      "(319355) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Stoliki i krzesła"
    ],
    "hierarchy": "(319355) Dziecko / Pokój dziecięcy / Meble / Stoliki i krzesła / Zestawy stoliki i krzesła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafki nocne",
    "categoryPath": [
      "(321019) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(321019) Dziecko / Pokój dziecięcy / Meble / Szafki nocne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafy",
    "categoryPath": [
      "(98758) Dziecko",
      "Pokój dziecięcy",
      "Meble"
    ],
    "hierarchy": "(98758) Dziecko / Pokój dziecięcy / Meble / Szafy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kojce",
    "categoryPath": [
      "(98748) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98748) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Kojce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kosze Mojżesza",
    "categoryPath": [
      "(316504) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(316504) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Kosze Mojżesza",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kołyski",
    "categoryPath": [
      "(98749) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98749) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Kołyski",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pojemniki pod łóżko",
    "categoryPath": [
      "(321849) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(321849) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Pojemniki pod łóżko",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Sofy i kanapy",
    "categoryPath": [
      "(98773) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98773) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Sofy i kanapy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżeczka drewniane",
    "categoryPath": [
      "(98746) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98746) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Łóżeczka drewniane",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżeczka turystyczne",
    "categoryPath": [
      "(98747) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98747) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Łóżeczka turystyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka piętrowe",
    "categoryPath": [
      "(98751) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98751) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Łóżka piętrowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka pojedyncze",
    "categoryPath": [
      "(98750) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98750) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Łóżka pojedyncze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Łóżka pozostałe",
    "categoryPath": [
      "(98745) Dziecko",
      "Pokój dziecięcy",
      "Meble",
      "Łóżka i kojce"
    ],
    "hierarchy": "(98745) Dziecko / Pokój dziecięcy / Meble / Łóżka i kojce / Łóżka pozostałe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(17284) Dziecko",
      "Pokój dziecięcy"
    ],
    "hierarchy": "(17284) Dziecko / Pokój dziecięcy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Bordery",
    "categoryPath": [
      "(98729) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98729) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Bordery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Magnesy",
    "categoryPath": [
      "(98739) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98739) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Magnesy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Miarki wzrostu",
    "categoryPath": [
      "(98731) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98731) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Miarki wzrostu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Naklejki ścienne",
    "categoryPath": [
      "(98726) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98726) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Naklejki ścienne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Obrazki i plakaty",
    "categoryPath": [
      "(98738) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98738) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Obrazki i plakaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ozdoby 3D",
    "categoryPath": [
      "(98733) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98733) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Ozdoby 3D",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pudełka",
    "categoryPath": [
      "(98736) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98736) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Pudełka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ramki",
    "categoryPath": [
      "(98730) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98730) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Ramki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Skarbonki",
    "categoryPath": [
      "(98734) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98734) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Skarbonki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tapety",
    "categoryPath": [
      "(98728) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98728) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Tapety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(98735) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98735) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Wieszaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zegary",
    "categoryPath": [
      "(98737) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Dekoracje i ozdoby"
    ],
    "hierarchy": "(98737) Dziecko / Pokój dziecięcy / Wyposażenie / Dekoracje i ozdoby / Zegary",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dywany",
    "categoryPath": [
      "(98741) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie"
    ],
    "hierarchy": "(98741) Dziecko / Pokój dziecięcy / Wyposażenie / Dywany",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Baldachimy i stelaże",
    "categoryPath": [
      "(28117) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(28117) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Baldachimy i stelaże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kocyki",
    "categoryPath": [
      "(28118) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(28118) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Kocyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kokony i gniazda",
    "categoryPath": [
      "(304937) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(304937) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Kokony i gniazda",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komplety pościeli",
    "categoryPath": [
      "(28120) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(28120) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Komplety pościeli",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(28133) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Kołdry i poduszki"
    ],
    "hierarchy": "(28133) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Kołdry i poduszki / Komplety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kołdry",
    "categoryPath": [
      "(28131) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Kołdry i poduszki"
    ],
    "hierarchy": "(28131) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Kołdry i poduszki / Kołdry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(28132) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Kołdry i poduszki"
    ],
    "hierarchy": "(28132) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Kołdry i poduszki / Poduszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(28119) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(28119) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poduszki antywstrząsowe",
    "categoryPath": [
      "(304949) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(304949) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Poduszki antywstrząsowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poduszki dekoracyjne",
    "categoryPath": [
      "(98732) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(98732) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Poduszki dekoracyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(28126) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Poszewki"
    ],
    "hierarchy": "(28126) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Poszewki / Komplety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poszewki na poduszki",
    "categoryPath": [
      "(28127) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Poszewki"
    ],
    "hierarchy": "(28127) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Poszewki / Poszewki na poduszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Poszwy na kołdry",
    "categoryPath": [
      "(28128) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Poszewki"
    ],
    "hierarchy": "(28128) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Poszewki / Poszwy na kołdry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28116) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(28116) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pościele do wózka",
    "categoryPath": [
      "(304961) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(304961) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Pościele do wózka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pościele z wypełnieniem",
    "categoryPath": [
      "(304973) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(304973) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Pościele z wypełnieniem",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bez gumki",
    "categoryPath": [
      "(28129) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Prześcieradła"
    ],
    "hierarchy": "(28129) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Prześcieradła / Bez gumki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Z gumką",
    "categoryPath": [
      "(28130) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki",
      "Prześcieradła"
    ],
    "hierarchy": "(28130) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Prześcieradła / Z gumką",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Przyborniki i dodatki",
    "categoryPath": [
      "(28123) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(28123) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Przyborniki i dodatki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rożki i beciki",
    "categoryPath": [
      "(28124) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(28124) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Rożki i beciki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Śpiworki do spania",
    "categoryPath": [
      "(98765) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Pościel i kocyki"
    ],
    "hierarchy": "(98765) Dziecko / Pokój dziecięcy / Wyposażenie / Pościel i kocyki / Śpiworki do spania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Firanki",
    "categoryPath": [
      "(98742) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Wystrój okien"
    ],
    "hierarchy": "(98742) Dziecko / Pokój dziecięcy / Wyposażenie / Wystrój okien / Firanki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zasłony",
    "categoryPath": [
      "(98743) Dziecko",
      "Pokój dziecięcy",
      "Wyposażenie",
      "Wystrój okien"
    ],
    "hierarchy": "(98743) Dziecko / Pokój dziecięcy / Wyposażenie / Wystrój okien / Zasłony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bidony",
    "categoryPath": [
      "(256681) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256681) Dziecko / Rowery i pojazdy / Akcesoria / Bidony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dzwonki",
    "categoryPath": [
      "(256683) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256683) Dziecko / Rowery i pojazdy / Akcesoria / Dzwonki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(256698) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256698) Dziecko / Rowery i pojazdy / Akcesoria / Kaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koszyki",
    "categoryPath": [
      "(308749) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(308749) Dziecko / Rowery i pojazdy / Akcesoria / Koszyki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kółka boczne",
    "categoryPath": [
      "(308761) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(308761) Dziecko / Rowery i pojazdy / Akcesoria / Kółka boczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Naklejki",
    "categoryPath": [
      "(256684) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256684) Dziecko / Rowery i pojazdy / Akcesoria / Naklejki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(256699) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256699) Dziecko / Rowery i pojazdy / Akcesoria / Ochraniacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(256685) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256685) Dziecko / Rowery i pojazdy / Akcesoria / Osłony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256680) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256680) Dziecko / Rowery i pojazdy / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(256688) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256688) Dziecko / Rowery i pojazdy / Akcesoria / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wiatraczki",
    "categoryPath": [
      "(308773) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(308773) Dziecko / Rowery i pojazdy / Akcesoria / Wiatraczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wstążki",
    "categoryPath": [
      "(308797) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(308797) Dziecko / Rowery i pojazdy / Akcesoria / Wstążki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zabezpieczenia",
    "categoryPath": [
      "(256689) Dziecko",
      "Rowery i pojazdy",
      "Akcesoria"
    ],
    "hierarchy": "(256689) Dziecko / Rowery i pojazdy / Akcesoria / Zabezpieczenia",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Deskorolki",
    "categoryPath": [
      "(86396) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86396) Dziecko / Rowery i pojazdy / Deskorolki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Gokarty",
    "categoryPath": [
      "(86413) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86413) Dziecko / Rowery i pojazdy / Gokarty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Hulajnogi",
    "categoryPath": [
      "(86394) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86394) Dziecko / Rowery i pojazdy / Hulajnogi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Jeździki",
    "categoryPath": [
      "(86393) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86393) Dziecko / Rowery i pojazdy / Jeździki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(318861) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318861) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Akumulatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bezpieczniki",
    "categoryPath": [
      "(318873) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318873) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Bezpieczniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Centralki",
    "categoryPath": [
      "(318984) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318984) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Centralki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(318879) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318879) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(318942) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318942) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Kierownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koła",
    "categoryPath": [
      "(318876) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318876) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Koła",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kołpaki",
    "categoryPath": [
      "(318939) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318939) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Kołpaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Panele muzyczne",
    "categoryPath": [
      "(318945) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318945) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Panele muzyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piloty",
    "categoryPath": [
      "(318948) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318948) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Piloty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Przełączniki, pedały, drążki",
    "categoryPath": [
      "(318870) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318870) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Przełączniki, pedały, drążki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(318864) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318864) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Silniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zderzaki",
    "categoryPath": [
      "(319030) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(319030) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Zderzaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(318867) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne",
      "Akcesoria"
    ],
    "hierarchy": "(318867) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Akcesoria / Ładowarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Hulajnogi, deskorolki",
    "categoryPath": [
      "(86446) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne"
    ],
    "hierarchy": "(86446) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Hulajnogi, deskorolki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Motory",
    "categoryPath": [
      "(86401) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne"
    ],
    "hierarchy": "(86401) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Motory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(86398) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne"
    ],
    "hierarchy": "(86398) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Quady",
    "categoryPath": [
      "(86400) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne"
    ],
    "hierarchy": "(86400) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Quady",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Samochody",
    "categoryPath": [
      "(86399) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne"
    ],
    "hierarchy": "(86399) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Samochody",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Traktory",
    "categoryPath": [
      "(321056) Dziecko",
      "Rowery i pojazdy",
      "Pojazdy elektryczne"
    ],
    "hierarchy": "(321056) Dziecko / Rowery i pojazdy / Pojazdy elektryczne / Traktory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Quady na pedały",
    "categoryPath": [
      "(86444) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86444) Dziecko / Rowery i pojazdy / Quady na pedały",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rowery biegowe",
    "categoryPath": [
      "(86414) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86414) Dziecko / Rowery i pojazdy / Rowery biegowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rowery tradycyjne",
    "categoryPath": [
      "(86415) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86415) Dziecko / Rowery i pojazdy / Rowery tradycyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Rowery trójkołowe",
    "categoryPath": [
      "(86389) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86389) Dziecko / Rowery i pojazdy / Rowery trójkołowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Samochody na pedały",
    "categoryPath": [
      "(86443) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86443) Dziecko / Rowery i pojazdy / Samochody na pedały",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sanki",
    "categoryPath": [
      "(93171) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(93171) Dziecko / Rowery i pojazdy / Sanki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Traktorki",
    "categoryPath": [
      "(86390) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(86390) Dziecko / Rowery i pojazdy / Traktorki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Łyżwy",
    "categoryPath": [
      "(256883) Dziecko",
      "Rowery i pojazdy"
    ],
    "hierarchy": "(256883) Dziecko / Rowery i pojazdy / Łyżwy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Adaptery do wózków",
    "categoryPath": [
      "(82663) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82663) Dziecko / Wózki / Akcesoria / Adaptery do wózków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dostawki, platformy",
    "categoryPath": [
      "(82664) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82664) Dziecko / Wózki / Akcesoria / Dostawki, platformy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Folie i moskitiery",
    "categoryPath": [
      "(82662) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82662) Dziecko / Wózki / Akcesoria / Folie i moskitiery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gondole",
    "categoryPath": [
      "(82658) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82658) Dziecko / Wózki / Akcesoria / Gondole",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koła, opony",
    "categoryPath": [
      "(82900) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82900) Dziecko / Wózki / Akcesoria / Koła, opony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Materace do gondoli",
    "categoryPath": [
      "(320572) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(320572) Dziecko / Wózki / Akcesoria / Materace do gondoli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mufki",
    "categoryPath": [
      "(302582) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(302582) Dziecko / Wózki / Akcesoria / Mufki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze na pasy",
    "categoryPath": [
      "(320581) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(320581) Dziecko / Wózki / Akcesoria / Ochraniacze na pasy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze, wkładki do gondoli",
    "categoryPath": [
      "(320578) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(320578) Dziecko / Wózki / Akcesoria / Ochraniacze, wkładki do gondoli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Organizery do wózków",
    "categoryPath": [
      "(320575) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(320575) Dziecko / Wózki / Akcesoria / Organizery do wózków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Parasolki do wózków",
    "categoryPath": [
      "(82660) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82660) Dziecko / Wózki / Akcesoria / Parasolki do wózków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82657) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82657) Dziecko / Wózki / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stelaże",
    "categoryPath": [
      "(309733) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(309733) Dziecko / Wózki / Akcesoria / Stelaże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tekstylia do wózków",
    "categoryPath": [
      "(319775) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(319775) Dziecko / Wózki / Akcesoria / Tekstylia do wózków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Torby i plecaki",
    "categoryPath": [
      "(82661) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82661) Dziecko / Wózki / Akcesoria / Torby i plecaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty do wózka, haczyki",
    "categoryPath": [
      "(82889) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82889) Dziecko / Wózki / Akcesoria / Uchwyty do wózka, haczyki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wkładki do wózków spacerowych",
    "categoryPath": [
      "(83013) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(83013) Dziecko / Wózki / Akcesoria / Wkładki do wózków spacerowych",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Śpiworki i okrycia na nóżki",
    "categoryPath": [
      "(82659) Dziecko",
      "Wózki",
      "Akcesoria"
    ],
    "hierarchy": "(82659) Dziecko / Wózki / Akcesoria / Śpiworki i okrycia na nóżki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Biegowe i sportowe",
    "categoryPath": [
      "(309589) Dziecko",
      "Wózki"
    ],
    "hierarchy": "(309589) Dziecko / Wózki / Biegowe i sportowe",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Bliźniacze",
    "categoryPath": [
      "(82612) Dziecko",
      "Wózki"
    ],
    "hierarchy": "(82612) Dziecko / Wózki / Bliźniacze",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Głębokie",
    "categoryPath": [
      "(82613) Dziecko",
      "Wózki"
    ],
    "hierarchy": "(82613) Dziecko / Wózki / Głębokie",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Spacerowe",
    "categoryPath": [
      "(82611) Dziecko",
      "Wózki"
    ],
    "hierarchy": "(82611) Dziecko / Wózki / Spacerowe",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Wielofunkcyjne",
    "categoryPath": [
      "(82610) Dziecko",
      "Wózki"
    ],
    "hierarchy": "(82610) Dziecko / Wózki / Wielofunkcyjne",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(322026) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(322026) Dziecko / Zabawki / AGD / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drobne AGD",
    "categoryPath": [
      "(93703) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93703) Dziecko / Zabawki / AGD / Drobne AGD",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kuchnie",
    "categoryPath": [
      "(93681) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93681) Dziecko / Zabawki / AGD / Kuchnie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maszyny do szycia",
    "categoryPath": [
      "(93687) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93687) Dziecko / Zabawki / AGD / Maszyny do szycia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Odkurzacze",
    "categoryPath": [
      "(93683) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93683) Dziecko / Zabawki / AGD / Odkurzacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93680) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93680) Dziecko / Zabawki / AGD / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pralki",
    "categoryPath": [
      "(93682) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93682) Dziecko / Zabawki / AGD / Pralki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sklepy i kasy",
    "categoryPath": [
      "(93688) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93688) Dziecko / Zabawki / AGD / Sklepy i kasy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Toaletki",
    "categoryPath": [
      "(93684) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93684) Dziecko / Zabawki / AGD / Toaletki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy do sprzątania",
    "categoryPath": [
      "(93686) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93686) Dziecko / Zabawki / AGD / Zestawy do sprzątania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Żelazka i deski",
    "categoryPath": [
      "(93685) Dziecko",
      "Zabawki",
      "AGD"
    ],
    "hierarchy": "(93685) Dziecko / Zabawki / AGD / Żelazka i deski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Fidget Spinner",
    "categoryPath": [
      "(259498) Dziecko",
      "Zabawki",
      "Antystresowe"
    ],
    "hierarchy": "(259498) Dziecko / Zabawki / Antystresowe / Fidget Spinner",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Gniotki",
    "categoryPath": [
      "(259499) Dziecko",
      "Zabawki",
      "Antystresowe"
    ],
    "hierarchy": "(259499) Dziecko / Zabawki / Antystresowe / Gniotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kostki antystresowe",
    "categoryPath": [
      "(259502) Dziecko",
      "Zabawki",
      "Antystresowe"
    ],
    "hierarchy": "(259502) Dziecko / Zabawki / Antystresowe / Kostki antystresowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Masy antystresowe",
    "categoryPath": [
      "(259500) Dziecko",
      "Zabawki",
      "Antystresowe"
    ],
    "hierarchy": "(259500) Dziecko / Zabawki / Antystresowe / Masy antystresowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Piłeczki antystresowe",
    "categoryPath": [
      "(259501) Dziecko",
      "Zabawki",
      "Antystresowe"
    ],
    "hierarchy": "(259501) Dziecko / Zabawki / Antystresowe / Piłeczki antystresowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bujaki",
    "categoryPath": [
      "(82776) Dziecko",
      "Zabawki",
      "Bujaki, skoczki"
    ],
    "hierarchy": "(82776) Dziecko / Zabawki / Bujaki, skoczki / Bujaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Konie na biegunach",
    "categoryPath": [
      "(82774) Dziecko",
      "Zabawki",
      "Bujaki, skoczki"
    ],
    "hierarchy": "(82774) Dziecko / Zabawki / Bujaki, skoczki / Konie na biegunach",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Skoczki",
    "categoryPath": [
      "(82775) Dziecko",
      "Zabawki",
      "Bujaki, skoczki"
    ],
    "hierarchy": "(82775) Dziecko / Zabawki / Bujaki, skoczki / Skoczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Baseny z kulkami",
    "categoryPath": [
      "(320768) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(320768) Dziecko / Zabawki / Dla niemowląt / Baseny z kulkami",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bączki",
    "categoryPath": [
      "(93588) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(93588) Dziecko / Zabawki / Dla niemowląt / Bączki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Chodziki",
    "categoryPath": [
      "(258071) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(258071) Dziecko / Zabawki / Dla niemowląt / Chodziki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Do pchania i ciągnięcia",
    "categoryPath": [
      "(316609) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(316609) Dziecko / Zabawki / Dla niemowląt / Do pchania i ciągnięcia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Do raczkowania",
    "categoryPath": [
      "(93590) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(93590) Dziecko / Zabawki / Dla niemowląt / Do raczkowania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pałąki z zabawkami",
    "categoryPath": [
      "(313045) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Do wózka"
    ],
    "hierarchy": "(313045) Dziecko / Zabawki / Dla niemowląt / Do wózka / Pałąki z zabawkami",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(313069) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Do wózka"
    ],
    "hierarchy": "(313069) Dziecko / Zabawki / Dla niemowląt / Do wózka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zawieszki",
    "categoryPath": [
      "(313057) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Do wózka"
    ],
    "hierarchy": "(313057) Dziecko / Zabawki / Dla niemowląt / Do wózka / Zawieszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Fontanny z piłek",
    "categoryPath": [
      "(93589) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(93589) Dziecko / Zabawki / Dla niemowląt / Fontanny z piłek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Grzechotki",
    "categoryPath": [
      "(17305) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(17305) Dziecko / Zabawki / Dla niemowląt / Grzechotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Książeczki edukacyjne",
    "categoryPath": [
      "(313093) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Interaktywne"
    ],
    "hierarchy": "(313093) Dziecko / Zabawki / Dla niemowląt / Interaktywne / Książeczki edukacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pluszaki interaktywne",
    "categoryPath": [
      "(313117) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Interaktywne"
    ],
    "hierarchy": "(313117) Dziecko / Zabawki / Dla niemowląt / Interaktywne / Pluszaki interaktywne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(313129) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Interaktywne"
    ],
    "hierarchy": "(313129) Dziecko / Zabawki / Dla niemowląt / Interaktywne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Karuzele",
    "categoryPath": [
      "(17307) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(17307) Dziecko / Zabawki / Dla niemowląt / Karuzele",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Książeczki",
    "categoryPath": [
      "(93585) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(93585) Dziecko / Zabawki / Dla niemowląt / Książeczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty edukacyjne",
    "categoryPath": [
      "(93578) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(93578) Dziecko / Zabawki / Dla niemowląt / Maty edukacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pchacze",
    "categoryPath": [
      "(261495) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(261495) Dziecko / Zabawki / Dla niemowląt / Pchacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(17310) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(17310) Dziecko / Zabawki / Dla niemowląt / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sensoryczne",
    "categoryPath": [
      "(261496) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(261496) Dziecko / Zabawki / Dla niemowląt / Sensoryczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stojaki gimnastyczne",
    "categoryPath": [
      "(93587) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(93587) Dziecko / Zabawki / Dla niemowląt / Stojaki gimnastyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stoliczki edukacyjne",
    "categoryPath": [
      "(93586) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(93586) Dziecko / Zabawki / Dla niemowląt / Stoliczki edukacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(313153) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Usypiacze i uspokajacze"
    ],
    "hierarchy": "(313153) Dziecko / Zabawki / Dla niemowląt / Usypiacze i uspokajacze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozytywki",
    "categoryPath": [
      "(19412) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Usypiacze i uspokajacze"
    ],
    "hierarchy": "(19412) Dziecko / Zabawki / Dla niemowląt / Usypiacze i uspokajacze / Pozytywki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Przytulanki",
    "categoryPath": [
      "(124323) Dziecko",
      "Zabawki",
      "Dla niemowląt",
      "Usypiacze i uspokajacze"
    ],
    "hierarchy": "(124323) Dziecko / Zabawki / Dla niemowląt / Usypiacze i uspokajacze / Przytulanki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wczesna nauka",
    "categoryPath": [
      "(313105) Dziecko",
      "Zabawki",
      "Dla niemowląt"
    ],
    "hierarchy": "(313105) Dziecko / Zabawki / Dla niemowląt / Wczesna nauka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Do kąpieli",
    "categoryPath": [
      "(19416) Dziecko",
      "Zabawki"
    ],
    "hierarchy": "(19416) Dziecko / Zabawki / Do kąpieli",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Instrumenty muzyczne",
    "categoryPath": [
      "(261571) Dziecko",
      "Zabawki",
      "Edukacyjne"
    ],
    "hierarchy": "(261571) Dziecko / Zabawki / Edukacyjne / Instrumenty muzyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kukiełki i Pacynki",
    "categoryPath": [
      "(316600) Dziecko",
      "Zabawki",
      "Edukacyjne"
    ],
    "hierarchy": "(316600) Dziecko / Zabawki / Edukacyjne / Kukiełki i Pacynki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Odgrywanie ról",
    "categoryPath": [
      "(322029) Dziecko",
      "Zabawki",
      "Edukacyjne"
    ],
    "hierarchy": "(322029) Dziecko / Zabawki / Edukacyjne / Odgrywanie ról",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lornetki",
    "categoryPath": [
      "(313261) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Pomoce dydaktyczne"
    ],
    "hierarchy": "(313261) Dziecko / Zabawki / Edukacyjne / Pomoce dydaktyczne / Lornetki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(312697) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Pomoce dydaktyczne"
    ],
    "hierarchy": "(312697) Dziecko / Zabawki / Edukacyjne / Pomoce dydaktyczne / Lupy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mikroskopy",
    "categoryPath": [
      "(93708) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Pomoce dydaktyczne"
    ],
    "hierarchy": "(93708) Dziecko / Zabawki / Edukacyjne / Pomoce dydaktyczne / Mikroskopy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93705) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Pomoce dydaktyczne"
    ],
    "hierarchy": "(93705) Dziecko / Zabawki / Edukacyjne / Pomoce dydaktyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Teleskopy, kalejdoskopy, lunety",
    "categoryPath": [
      "(93706) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Pomoce dydaktyczne"
    ],
    "hierarchy": "(93706) Dziecko / Zabawki / Edukacyjne / Pomoce dydaktyczne / Teleskopy, kalejdoskopy, lunety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19417) Dziecko",
      "Zabawki",
      "Edukacyjne"
    ],
    "hierarchy": "(19417) Dziecko / Zabawki / Edukacyjne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Nauka czytania",
    "categoryPath": [
      "(319069) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Słowne i liczbowe"
    ],
    "hierarchy": "(319069) Dziecko / Zabawki / Edukacyjne / Słowne i liczbowe / Nauka czytania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nauka liczenia",
    "categoryPath": [
      "(319066) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Słowne i liczbowe"
    ],
    "hierarchy": "(319066) Dziecko / Zabawki / Edukacyjne / Słowne i liczbowe / Nauka liczenia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nauka pisania",
    "categoryPath": [
      "(319872) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Słowne i liczbowe"
    ],
    "hierarchy": "(319872) Dziecko / Zabawki / Edukacyjne / Słowne i liczbowe / Nauka pisania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Łamigłówki",
    "categoryPath": [
      "(319072) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Słowne i liczbowe"
    ],
    "hierarchy": "(319072) Dziecko / Zabawki / Edukacyjne / Słowne i liczbowe / Łamigłówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Magnetyczne, Kredowe i Suchościeralne",
    "categoryPath": [
      "(312685) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Tablice"
    ],
    "hierarchy": "(312685) Dziecko / Zabawki / Edukacyjne / Tablice / Magnetyczne, Kredowe i Suchościeralne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Manipulacyjne",
    "categoryPath": [
      "(312673) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Tablice"
    ],
    "hierarchy": "(312673) Dziecko / Zabawki / Edukacyjne / Tablice / Manipulacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Motywacyjne",
    "categoryPath": [
      "(312649) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Tablice"
    ],
    "hierarchy": "(312649) Dziecko / Zabawki / Edukacyjne / Tablice / Motywacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(312661) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Tablice"
    ],
    "hierarchy": "(312661) Dziecko / Zabawki / Edukacyjne / Tablice / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Drewniane",
    "categoryPath": [
      "(321435) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Układanki"
    ],
    "hierarchy": "(321435) Dziecko / Zabawki / Edukacyjne / Układanki / Drewniane",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kulki magnetyczne",
    "categoryPath": [
      "(321901) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Układanki"
    ],
    "hierarchy": "(321901) Dziecko / Zabawki / Edukacyjne / Układanki / Kulki magnetyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Montessori",
    "categoryPath": [
      "(312709) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Układanki"
    ],
    "hierarchy": "(312709) Dziecko / Zabawki / Edukacyjne / Układanki / Montessori",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Piramidki",
    "categoryPath": [
      "(93717) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Układanki"
    ],
    "hierarchy": "(93717) Dziecko / Zabawki / Edukacyjne / Układanki / Piramidki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93715) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Układanki"
    ],
    "hierarchy": "(93715) Dziecko / Zabawki / Edukacyjne / Układanki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sortery",
    "categoryPath": [
      "(93716) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Układanki"
    ],
    "hierarchy": "(93716) Dziecko / Zabawki / Edukacyjne / Układanki / Sortery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Labirynty, przeplatanki",
    "categoryPath": [
      "(93719) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Umysłowe"
    ],
    "hierarchy": "(93719) Dziecko / Zabawki / Edukacyjne / Umysłowe / Labirynty, przeplatanki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Memorki",
    "categoryPath": [
      "(320401) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Umysłowe"
    ],
    "hierarchy": "(320401) Dziecko / Zabawki / Edukacyjne / Umysłowe / Memorki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zabawki logiczne",
    "categoryPath": [
      "(320131) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Umysłowe"
    ],
    "hierarchy": "(320131) Dziecko / Zabawki / Edukacyjne / Umysłowe / Zabawki logiczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zabawki konstrukcyjne",
    "categoryPath": [
      "(317246) Dziecko",
      "Zabawki",
      "Edukacyjne"
    ],
    "hierarchy": "(317246) Dziecko / Zabawki / Edukacyjne / Zabawki konstrukcyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zabawki na energię słoneczną",
    "categoryPath": [
      "(319869) Dziecko",
      "Zabawki",
      "Edukacyjne"
    ],
    "hierarchy": "(319869) Dziecko / Zabawki / Edukacyjne / Zabawki na energię słoneczną",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Laboratorium kosmetyków, mydełek",
    "categoryPath": [
      "(318477) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(318477) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Laboratorium kosmetyków, mydełek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mały archeolog",
    "categoryPath": [
      "(318471) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(318471) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Mały archeolog",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mały biolog",
    "categoryPath": [
      "(322319) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(322319) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Mały biolog",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mały chemik",
    "categoryPath": [
      "(312589) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(312589) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Mały chemik",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mały elektronik",
    "categoryPath": [
      "(312601) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(312601) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Mały elektronik",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mały fizyk",
    "categoryPath": [
      "(312613) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(312613) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Mały fizyk",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mały magik",
    "categoryPath": [
      "(317189) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(317189) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Mały magik",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(312625) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(312625) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Układ Słoneczny, planety",
    "categoryPath": [
      "(318474) Dziecko",
      "Zabawki",
      "Edukacyjne",
      "Zestawy doświadczalne"
    ],
    "hierarchy": "(318474) Dziecko / Zabawki / Edukacyjne / Zestawy doświadczalne / Układ Słoneczny, planety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(322030) Dziecko",
      "Zabawki"
    ],
    "hierarchy": "(322030) Dziecko / Zabawki / Figurki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Drewniane",
    "categoryPath": [
      "(46097) Dziecko",
      "Zabawki",
      "Klocki"
    ],
    "hierarchy": "(46097) Dziecko / Zabawki / Klocki / Drewniane",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Klocki cegły",
    "categoryPath": [
      "(309241) Dziecko",
      "Zabawki",
      "Klocki"
    ],
    "hierarchy": "(309241) Dziecko / Zabawki / Klocki / Klocki cegły",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Breloczki",
    "categoryPath": [
      "(319258) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(319258) Dziecko / Zabawki / Klocki / LEGO / Breloczki",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Gry",
    "categoryPath": [
      "(93204) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(93204) Dziecko / Zabawki / Klocki / LEGO / Gry",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Instrukcje",
    "categoryPath": [
      "(306465) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(306465) Dziecko / Zabawki / Klocki / LEGO / Instrukcje",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Kalendarze adwentowe",
    "categoryPath": [
      "(305637) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(305637) Dziecko / Zabawki / Klocki / LEGO / Kalendarze adwentowe",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Elementy",
    "categoryPath": [
      "(305685) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Klocki pojedyncze"
    ],
    "hierarchy": "(305685) Dziecko / Zabawki / Klocki / LEGO / Klocki pojedyncze / Elementy",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Power Functions i Powered UP",
    "categoryPath": [
      "(256803) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Klocki pojedyncze"
    ],
    "hierarchy": "(256803) Dziecko / Zabawki / Klocki / LEGO / Klocki pojedyncze / Power Functions i Powered UP",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Płytki konstrukcyjne",
    "categoryPath": [
      "(93217) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Klocki pojedyncze"
    ],
    "hierarchy": "(93217) Dziecko / Zabawki / Klocki / LEGO / Klocki pojedyncze / Płytki konstrukcyjne",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Mieszane",
    "categoryPath": [
      "(17870) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(17870) Dziecko / Zabawki / Klocki / LEGO / Mieszane",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Minifigurki",
    "categoryPath": [
      "(93209) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(93209) Dziecko / Zabawki / Klocki / LEGO / Minifigurki",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Pojemniki",
    "categoryPath": [
      "(305661) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(305661) Dziecko / Zabawki / Klocki / LEGO / Pojemniki",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93218) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO"
    ],
    "hierarchy": "(93218) Dziecko / Zabawki / Klocki / LEGO / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Angry Birds",
    "categoryPath": [
      "(256996) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(256996) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Angry Birds",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Architecture",
    "categoryPath": [
      "(254938) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(254938) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Architecture",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Art",
    "categoryPath": [
      "(313733) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(313733) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Art",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Avatar",
    "categoryPath": [
      "(322275) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322275) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Avatar",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Batman Movie",
    "categoryPath": [
      "(256994) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(256994) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Batman Movie",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Boost",
    "categoryPath": [
      "(260710) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(260710) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Boost",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Brick Sketches",
    "categoryPath": [
      "(322065) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322065) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Brick Sketches",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "BrickHeadz",
    "categoryPath": [
      "(257675) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(257675) Dziecko / Zabawki / Klocki / LEGO / Zestawy / BrickHeadz",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Bricklink",
    "categoryPath": [
      "(322318) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322318) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Bricklink",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "City",
    "categoryPath": [
      "(93206) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(93206) Dziecko / Zabawki / Klocki / LEGO / Zestawy / City",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Classic",
    "categoryPath": [
      "(251664) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251664) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Classic",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Creator",
    "categoryPath": [
      "(93213) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(93213) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Creator",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Creator 3 w 1",
    "categoryPath": [
      "(305697) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(305697) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Creator 3 w 1",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Creator Expert",
    "categoryPath": [
      "(305709) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(305709) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Creator Expert",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "DREAMZzz",
    "categoryPath": [
      "(322670) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322670) Dziecko / Zabawki / Klocki / LEGO / Zestawy / DREAMZzz",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "DUPLO",
    "categoryPath": [
      "(17872) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(17872) Dziecko / Zabawki / Klocki / LEGO / Zestawy / DUPLO",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Disney",
    "categoryPath": [
      "(251665) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251665) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Disney",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Dots",
    "categoryPath": [
      "(305781) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(305781) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Dots",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Education",
    "categoryPath": [
      "(315506) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(315506) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Education",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Elves",
    "categoryPath": [
      "(251666) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251666) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Elves",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Friends",
    "categoryPath": [
      "(111994) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(111994) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Friends",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Harry Potter",
    "categoryPath": [
      "(93202) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(93202) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Harry Potter",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Hidden Side",
    "categoryPath": [
      "(261614) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(261614) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Hidden Side",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "ICONS",
    "categoryPath": [
      "(322143) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322143) Dziecko / Zabawki / Klocki / LEGO / Zestawy / ICONS",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Ideas",
    "categoryPath": [
      "(260713) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(260713) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Ideas",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Juniors",
    "categoryPath": [
      "(251667) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251667) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Juniors",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Jurassic World",
    "categoryPath": [
      "(305985) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(305985) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Jurassic World",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Koci domek Gabi",
    "categoryPath": [
      "(322673) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322673) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Koci domek Gabi",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Legoland",
    "categoryPath": [
      "(322382) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322382) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Legoland",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Mindstorms",
    "categoryPath": [
      "(251668) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251668) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Mindstorms",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Minecraft",
    "categoryPath": [
      "(251678) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251678) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Minecraft",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Minionki",
    "categoryPath": [
      "(313625) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(313625) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Minionki",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Monkie Kid",
    "categoryPath": [
      "(315509) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(315509) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Monkie Kid",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Nexo Knights",
    "categoryPath": [
      "(254038) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(254038) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Nexo Knights",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Ninjago",
    "categoryPath": [
      "(110015) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(110015) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Ninjago",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Overwatch",
    "categoryPath": [
      "(260709) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(260709) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Overwatch",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Atlantis",
    "categoryPath": [
      "(93199) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93199) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Atlantis",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Bionicle",
    "categoryPath": [
      "(17871) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(17871) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Bionicle",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Castle",
    "categoryPath": [
      "(93251) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93251) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Castle",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Chima",
    "categoryPath": [
      "(125702) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(125702) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Chima",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "DC Super Hero Girls",
    "categoryPath": [
      "(256995) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(256995) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / DC Super Hero Girls",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Dimensions",
    "categoryPath": [
      "(260712) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(260712) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Dimensions",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Dino",
    "categoryPath": [
      "(124899) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(124899) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Dino",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Hero Factory",
    "categoryPath": [
      "(93200) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93200) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Hero Factory",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Indiana Jones",
    "categoryPath": [
      "(93214) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93214) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Indiana Jones",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Kingdoms",
    "categoryPath": [
      "(93207) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93207) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Kingdoms",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Mixels",
    "categoryPath": [
      "(251669) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(251669) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Mixels",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Monster Fighters",
    "categoryPath": [
      "(124901) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(124901) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Monster Fighters",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Pirates",
    "categoryPath": [
      "(93215) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93215) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Pirates",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Power Miners",
    "categoryPath": [
      "(256802) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(256802) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Power Miners",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(305625) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(305625) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Racers",
    "categoryPath": [
      "(93211) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93211) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Racers",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Space",
    "categoryPath": [
      "(93208) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(93208) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / Space",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "The Lord of the Rings",
    "categoryPath": [
      "(251671) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy",
      "Pozostałe serie"
    ],
    "hierarchy": "(251671) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Pozostałe serie / The Lord of the Rings",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Sonic the Hedgehog",
    "categoryPath": [
      "(322671) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322671) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Sonic the Hedgehog",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Speed Champions",
    "categoryPath": [
      "(251670) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251670) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Speed Champions",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Star Wars",
    "categoryPath": [
      "(93205) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(93205) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Star Wars",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Super Heroes",
    "categoryPath": [
      "(124902) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(124902) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Super Heroes",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Super Mario",
    "categoryPath": [
      "(313613) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(313613) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Super Mario",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Technic",
    "categoryPath": [
      "(17873) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(17873) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Technic",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "The Movie",
    "categoryPath": [
      "(251672) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(251672) Dziecko / Zabawki / Klocki / LEGO / Zestawy / The Movie",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Toy Story",
    "categoryPath": [
      "(93203) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(93203) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Toy Story",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Trolls",
    "categoryPath": [
      "(305733) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(305733) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Trolls",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Unikitty",
    "categoryPath": [
      "(260711) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(260711) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Unikitty",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "VIDIYO",
    "categoryPath": [
      "(317898) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(317898) Dziecko / Zabawki / Klocki / LEGO / Zestawy / VIDIYO",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Xtra",
    "categoryPath": [
      "(322066) Dziecko",
      "Zabawki",
      "Klocki",
      "LEGO",
      "Zestawy"
    ],
    "hierarchy": "(322066) Dziecko / Zabawki / Klocki / LEGO / Zestawy / Xtra",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Magnetyczne",
    "categoryPath": [
      "(19535) Dziecko",
      "Zabawki",
      "Klocki"
    ],
    "hierarchy": "(19535) Dziecko / Zabawki / Klocki / Magnetyczne",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Piankowe i gumowe",
    "categoryPath": [
      "(317629) Dziecko",
      "Zabawki",
      "Klocki"
    ],
    "hierarchy": "(317629) Dziecko / Zabawki / Klocki / Piankowe i gumowe",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Jeżyki",
    "categoryPath": [
      "(317626) Dziecko",
      "Zabawki",
      "Klocki",
      "Plastikowe"
    ],
    "hierarchy": "(317626) Dziecko / Zabawki / Klocki / Plastikowe / Jeżyki",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Klocki konstrukcyjne",
    "categoryPath": [
      "(309529) Dziecko",
      "Zabawki",
      "Klocki",
      "Plastikowe"
    ],
    "hierarchy": "(309529) Dziecko / Zabawki / Klocki / Plastikowe / Klocki konstrukcyjne",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Wafle",
    "categoryPath": [
      "(93198) Dziecko",
      "Zabawki",
      "Klocki",
      "Plastikowe"
    ],
    "hierarchy": "(93198) Dziecko / Zabawki / Klocki / Plastikowe / Wafle",
    "comissionGroupOld": "C15",
    "comissionGroupNew": "D11"
  },
  {
    "segment": "Bigjigs",
    "categoryPath": [
      "(258010) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(258010) Dziecko / Zabawki / Kolejki i tory / Bigjigs",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Brio",
    "categoryPath": [
      "(93574) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(93574) Dziecko / Zabawki / Kolejki i tory / Brio",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Classic World",
    "categoryPath": [
      "(313949) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(313949) Dziecko / Zabawki / Kolejki i tory / Classic World",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ecotoys",
    "categoryPath": [
      "(313985) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(313985) Dziecko / Zabawki / Kolejki i tory / Ecotoys",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Eichhorn",
    "categoryPath": [
      "(313973) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(313973) Dziecko / Zabawki / Kolejki i tory / Eichhorn",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Fenfa",
    "categoryPath": [
      "(322856) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(322856) Dziecko / Zabawki / Kolejki i tory / Fenfa",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Fisher Price",
    "categoryPath": [
      "(93571) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(93571) Dziecko / Zabawki / Kolejki i tory / Fisher Price",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Goki",
    "categoryPath": [
      "(313997) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(313997) Dziecko / Zabawki / Kolejki i tory / Goki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Melissa and Doug",
    "categoryPath": [
      "(314009) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(314009) Dziecko / Zabawki / Kolejki i tory / Melissa and Doug",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93569) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(93569) Dziecko / Zabawki / Kolejki i tory / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tomy",
    "categoryPath": [
      "(93570) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(93570) Dziecko / Zabawki / Kolejki i tory / Tomy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Viga",
    "categoryPath": [
      "(314021) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(314021) Dziecko / Zabawki / Kolejki i tory / Viga",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wader",
    "categoryPath": [
      "(93572) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(93572) Dziecko / Zabawki / Kolejki i tory / Wader",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Woodyland",
    "categoryPath": [
      "(314033) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(314033) Dziecko / Zabawki / Kolejki i tory / Woodyland",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy drewniane",
    "categoryPath": [
      "(93577) Dziecko",
      "Zabawki",
      "Kolejki i tory"
    ],
    "hierarchy": "(93577) Dziecko / Zabawki / Kolejki i tory / Zestawy drewniane",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Nosidełka i foteliki dla lalek",
    "categoryPath": [
      "(259372) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Akcesoria dla lalek"
    ],
    "hierarchy": "(259372) Dziecko / Zabawki / Lalki i akcesoria / Akcesoria dla lalek / Nosidełka i foteliki dla lalek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259379) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Akcesoria dla lalek"
    ],
    "hierarchy": "(259379) Dziecko / Zabawki / Lalki i akcesoria / Akcesoria dla lalek / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zestawy do pielęgnacji",
    "categoryPath": [
      "(259374) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Akcesoria dla lalek"
    ],
    "hierarchy": "(259374) Dziecko / Zabawki / Lalki i akcesoria / Akcesoria dla lalek / Zestawy do pielęgnacji",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Łóżeczka i kołyski",
    "categoryPath": [
      "(259373) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Akcesoria dla lalek"
    ],
    "hierarchy": "(259373) Dziecko / Zabawki / Lalki i akcesoria / Akcesoria dla lalek / Łóżeczka i kołyski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Domki",
    "categoryPath": [
      "(259368) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Domki i mebelki dla lalek"
    ],
    "hierarchy": "(259368) Dziecko / Zabawki / Lalki i akcesoria / Domki i mebelki dla lalek / Domki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Mebelki",
    "categoryPath": [
      "(259369) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Domki i mebelki dla lalek"
    ],
    "hierarchy": "(259369) Dziecko / Zabawki / Lalki i akcesoria / Domki i mebelki dla lalek / Mebelki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Głowy do stylizacji",
    "categoryPath": [
      "(259370) Dziecko",
      "Zabawki",
      "Lalki i akcesoria"
    ],
    "hierarchy": "(259370) Dziecko / Zabawki / Lalki i akcesoria / Głowy do stylizacji",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Barbie",
    "categoryPath": [
      "(11828) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki"
    ],
    "hierarchy": "(11828) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Barbie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Agatki",
    "categoryPath": [
      "(259349) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259349) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Agatki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Anne Geddes",
    "categoryPath": [
      "(259350) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259350) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Anne Geddes",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Baby Alive",
    "categoryPath": [
      "(259351) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259351) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Baby Alive",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Baby Annabell",
    "categoryPath": [
      "(259352) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259352) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Baby Annabell",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Baby born",
    "categoryPath": [
      "(259353) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259353) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Baby born",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Chou Chou",
    "categoryPath": [
      "(259359) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259359) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Chou Chou",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Cry Babies",
    "categoryPath": [
      "(260139) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(260139) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Cry Babies",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "MiniKiss",
    "categoryPath": [
      "(320974) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(320974) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / MiniKiss",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "My Garden Baby",
    "categoryPath": [
      "(320765) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(320765) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / My Garden Baby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Natalia",
    "categoryPath": [
      "(259355) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259355) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Natalia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "New Born Baby",
    "categoryPath": [
      "(260123) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(260123) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / New Born Baby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259348) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(259348) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Smily Play",
    "categoryPath": [
      "(321973) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Bobasy"
    ],
    "hierarchy": "(321973) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Bobasy / Smily Play",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dodatki",
    "categoryPath": [
      "(317632) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "L.O.L. Surprise"
    ],
    "hierarchy": "(317632) Dziecko / Zabawki / Lalki i akcesoria / Lalki / L.O.L. Surprise / Dodatki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maskotki",
    "categoryPath": [
      "(317549) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "L.O.L. Surprise"
    ],
    "hierarchy": "(317549) Dziecko / Zabawki / Lalki i akcesoria / Lalki / L.O.L. Surprise / Maskotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Małe lalki",
    "categoryPath": [
      "(307309) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "L.O.L. Surprise"
    ],
    "hierarchy": "(307309) Dziecko / Zabawki / Lalki i akcesoria / Lalki / L.O.L. Surprise / Małe lalki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "O.M.G.",
    "categoryPath": [
      "(307321) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "L.O.L. Surprise"
    ],
    "hierarchy": "(307321) Dziecko / Zabawki / Lalki i akcesoria / Lalki / L.O.L. Surprise / O.M.G.",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pojazdy",
    "categoryPath": [
      "(317546) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "L.O.L. Surprise"
    ],
    "hierarchy": "(317546) Dziecko / Zabawki / Lalki i akcesoria / Lalki / L.O.L. Surprise / Pojazdy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zwierzątka",
    "categoryPath": [
      "(307333) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "L.O.L. Surprise"
    ],
    "hierarchy": "(307333) Dziecko / Zabawki / Lalki i akcesoria / Lalki / L.O.L. Surprise / Zwierzątka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lalki hiszpańskie",
    "categoryPath": [
      "(259356) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki"
    ],
    "hierarchy": "(259356) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki hiszpańskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Anlily",
    "categoryPath": [
      "(317787) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki klasyczne"
    ],
    "hierarchy": "(317787) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki klasyczne / Anlily",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ever After High",
    "categoryPath": [
      "(250150) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki klasyczne"
    ],
    "hierarchy": "(250150) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki klasyczne / Ever After High",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Evi",
    "categoryPath": [
      "(85260) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki klasyczne"
    ],
    "hierarchy": "(85260) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki klasyczne / Evi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(307297) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki klasyczne"
    ],
    "hierarchy": "(307297) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki klasyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Shibajuku",
    "categoryPath": [
      "(259354) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki klasyczne"
    ],
    "hierarchy": "(259354) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki klasyczne / Shibajuku",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Steffi",
    "categoryPath": [
      "(84949) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki klasyczne"
    ],
    "hierarchy": "(84949) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki klasyczne / Steffi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Porcelanowe",
    "categoryPath": [
      "(259346) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki kolekcjonerskie"
    ],
    "hierarchy": "(259346) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki kolekcjonerskie / Porcelanowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259394) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki kolekcjonerskie"
    ],
    "hierarchy": "(259394) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki kolekcjonerskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reborn",
    "categoryPath": [
      "(259345) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki kolekcjonerskie"
    ],
    "hierarchy": "(259345) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki kolekcjonerskie / Reborn",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tonner",
    "categoryPath": [
      "(259344) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki kolekcjonerskie"
    ],
    "hierarchy": "(259344) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki kolekcjonerskie / Tonner",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lalki modowe",
    "categoryPath": [
      "(321971) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki"
    ],
    "hierarchy": "(321971) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki modowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Biedronka i Czarny Kot",
    "categoryPath": [
      "(307633) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307633) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Biedronka i Czarny Kot",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Cave Club",
    "categoryPath": [
      "(316501) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(316501) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Cave Club",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "DC Super Hero Girls",
    "categoryPath": [
      "(307645) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307645) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / DC Super Hero Girls",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Disney",
    "categoryPath": [
      "(307669) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307669) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Disney",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Enchantimals",
    "categoryPath": [
      "(259347) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(259347) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Enchantimals",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Equestria Girls",
    "categoryPath": [
      "(308041) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(308041) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Equestria Girls",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Harry Potter",
    "categoryPath": [
      "(320971) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(320971) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Harry Potter",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kraina Lodu",
    "categoryPath": [
      "(307657) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307657) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Kraina Lodu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Lalaloopsy",
    "categoryPath": [
      "(146162) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(146162) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Lalaloopsy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Masza i Niedźwiedź",
    "categoryPath": [
      "(307681) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307681) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Masza i Niedźwiedź",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Monster High",
    "categoryPath": [
      "(110014) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(110014) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Monster High",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(307741) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307741) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Shimmer i Shine",
    "categoryPath": [
      "(307693) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307693) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Shimmer i Shine",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Spirit",
    "categoryPath": [
      "(307705) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307705) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Spirit",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sunny Day",
    "categoryPath": [
      "(307717) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307717) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Sunny Day",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wissper",
    "categoryPath": [
      "(307729) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Lalki z bajek"
    ],
    "hierarchy": "(307729) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Lalki z bajek / Wissper",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Bizzy Bubs",
    "categoryPath": [
      "(307765) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(307765) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Bizzy Bubs",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Candylock",
    "categoryPath": [
      "(307777) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(307777) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Candylock",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Cupcake",
    "categoryPath": [
      "(308413) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(308413) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Cupcake",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Glitter Babyz",
    "categoryPath": [
      "(320977) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(320977) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Glitter Babyz",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "HAIRDORABLES",
    "categoryPath": [
      "(307789) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(307789) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / HAIRDORABLES",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kindi Kids",
    "categoryPath": [
      "(319661) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(319661) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Kindi Kids",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Na! Na! Na! Surprise",
    "categoryPath": [
      "(307801) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(307801) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Na! Na! Na! Surprise",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Party Pop Teenies",
    "categoryPath": [
      "(307813) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(307813) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Party Pop Teenies",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Polly Pocket",
    "categoryPath": [
      "(307825) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(307825) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Polly Pocket",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pop Pop Hair Surprise",
    "categoryPath": [
      "(308389) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(308389) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Pop Pop Hair Surprise",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(307837) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki",
      "Minilalki"
    ],
    "hierarchy": "(307837) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Minilalki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(307849) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki"
    ],
    "hierarchy": "(307849) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rainbow High",
    "categoryPath": [
      "(317931) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki"
    ],
    "hierarchy": "(317931) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Rainbow High",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Syrenki",
    "categoryPath": [
      "(321972) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki"
    ],
    "hierarchy": "(321972) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Syrenki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Szmacianki",
    "categoryPath": [
      "(85264) Dziecko",
      "Zabawki",
      "Lalki i akcesoria",
      "Lalki"
    ],
    "hierarchy": "(85264) Dziecko / Zabawki / Lalki i akcesoria / Lalki / Szmacianki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pojazdy dla lalek",
    "categoryPath": [
      "(322031) Dziecko",
      "Zabawki",
      "Lalki i akcesoria"
    ],
    "hierarchy": "(322031) Dziecko / Zabawki / Lalki i akcesoria / Pojazdy dla lalek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(11830) Dziecko",
      "Zabawki",
      "Lalki i akcesoria"
    ],
    "hierarchy": "(11830) Dziecko / Zabawki / Lalki i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ubranka i buciki",
    "categoryPath": [
      "(259367) Dziecko",
      "Zabawki",
      "Lalki i akcesoria"
    ],
    "hierarchy": "(259367) Dziecko / Zabawki / Lalki i akcesoria / Ubranka i buciki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wózki dla lalek",
    "categoryPath": [
      "(259371) Dziecko",
      "Zabawki",
      "Lalki i akcesoria"
    ],
    "hierarchy": "(259371) Dziecko / Zabawki / Lalki i akcesoria / Wózki dla lalek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Narzędzia",
    "categoryPath": [
      "(93701) Dziecko",
      "Zabawki",
      "Majsterkowanie"
    ],
    "hierarchy": "(93701) Dziecko / Zabawki / Majsterkowanie / Narzędzia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93698) Dziecko",
      "Zabawki",
      "Majsterkowanie"
    ],
    "hierarchy": "(93698) Dziecko / Zabawki / Majsterkowanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzynki, walizki",
    "categoryPath": [
      "(93699) Dziecko",
      "Zabawki",
      "Majsterkowanie"
    ],
    "hierarchy": "(93699) Dziecko / Zabawki / Majsterkowanie / Skrzynki, walizki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Warsztaty",
    "categoryPath": [
      "(93700) Dziecko",
      "Zabawki",
      "Majsterkowanie"
    ],
    "hierarchy": "(93700) Dziecko / Zabawki / Majsterkowanie / Warsztaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy konstrukcyjne",
    "categoryPath": [
      "(93707) Dziecko",
      "Zabawki",
      "Majsterkowanie"
    ],
    "hierarchy": "(93707) Dziecko / Zabawki / Majsterkowanie / Zestawy konstrukcyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Chomiki",
    "categoryPath": [
      "(320158) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(320158) Dziecko / Zabawki / Maskotki / Interaktywne / Chomiki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Disney",
    "categoryPath": [
      "(93631) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(93631) Dziecko / Zabawki / Maskotki / Interaktywne / Disney",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Furby",
    "categoryPath": [
      "(130662) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(130662) Dziecko / Zabawki / Maskotki / Interaktywne / Furby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Hatchimals",
    "categoryPath": [
      "(317456) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(317456) Dziecko / Zabawki / Maskotki / Interaktywne / Hatchimals",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kaktusy",
    "categoryPath": [
      "(321425) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(321425) Dziecko / Zabawki / Maskotki / Interaktywne / Kaktusy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kotki",
    "categoryPath": [
      "(93629) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(93629) Dziecko / Zabawki / Maskotki / Interaktywne / Kotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Misie",
    "categoryPath": [
      "(93628) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(93628) Dziecko / Zabawki / Maskotki / Interaktywne / Misie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pieski",
    "categoryPath": [
      "(93627) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(93627) Dziecko / Zabawki / Maskotki / Interaktywne / Pieski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93632) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(93632) Dziecko / Zabawki / Maskotki / Interaktywne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Słoniki",
    "categoryPath": [
      "(320155) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(320155) Dziecko / Zabawki / Maskotki / Interaktywne / Słoniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zhu Zhu Pets",
    "categoryPath": [
      "(93626) Dziecko",
      "Zabawki",
      "Maskotki",
      "Interaktywne"
    ],
    "hierarchy": "(93626) Dziecko / Zabawki / Maskotki / Interaktywne / Zhu Zhu Pets",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Postacie z bajek",
    "categoryPath": [
      "(322049) Dziecko",
      "Zabawki",
      "Maskotki"
    ],
    "hierarchy": "(322049) Dziecko / Zabawki / Maskotki / Postacie z bajek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19473) Dziecko",
      "Zabawki",
      "Maskotki"
    ],
    "hierarchy": "(19473) Dziecko / Zabawki / Maskotki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zwierzątka",
    "categoryPath": [
      "(322039) Dziecko",
      "Zabawki",
      "Maskotki"
    ],
    "hierarchy": "(322039) Dziecko / Zabawki / Maskotki / Zwierzątka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Karabiny",
    "categoryPath": [
      "(93567) Dziecko",
      "Zabawki",
      "Militarne"
    ],
    "hierarchy": "(93567) Dziecko / Zabawki / Militarne / Karabiny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Miecze Świetlne",
    "categoryPath": [
      "(93568) Dziecko",
      "Zabawki",
      "Militarne"
    ],
    "hierarchy": "(93568) Dziecko / Zabawki / Militarne / Miecze Świetlne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pistolety",
    "categoryPath": [
      "(93566) Dziecko",
      "Zabawki",
      "Militarne"
    ],
    "hierarchy": "(93566) Dziecko / Zabawki / Militarne / Pistolety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93565) Dziecko",
      "Zabawki",
      "Militarne"
    ],
    "hierarchy": "(93565) Dziecko / Zabawki / Militarne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Bindeez",
    "categoryPath": [
      "(93659) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(93659) Dziecko / Zabawki / Plastyczne / Bindeez",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Długopisy 3D",
    "categoryPath": [
      "(321970) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(321970) Dziecko / Zabawki / Plastyczne / Długopisy 3D",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Masy plastyczne",
    "categoryPath": [
      "(93655) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(93655) Dziecko / Zabawki / Plastyczne / Masy plastyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty wodne",
    "categoryPath": [
      "(93660) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(93660) Dziecko / Zabawki / Plastyczne / Maty wodne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Piankolina",
    "categoryPath": [
      "(94189) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(94189) Dziecko / Zabawki / Plastyczne / Piankolina",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Piasek kinetyczny",
    "categoryPath": [
      "(93657) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(93657) Dziecko / Zabawki / Plastyczne / Piasek kinetyczny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93654) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(93654) Dziecko / Zabawki / Plastyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prace ręczne",
    "categoryPath": [
      "(93663) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(93663) Dziecko / Zabawki / Plastyczne / Prace ręczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Projektory",
    "categoryPath": [
      "(93658) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(93658) Dziecko / Zabawki / Plastyczne / Projektory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Stempelki",
    "categoryPath": [
      "(148139) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(148139) Dziecko / Zabawki / Plastyczne / Stempelki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zabawki z kartonu",
    "categoryPath": [
      "(319875) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(319875) Dziecko / Zabawki / Plastyczne / Zabawki z kartonu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy do makijażu",
    "categoryPath": [
      "(318891) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(318891) Dziecko / Zabawki / Plastyczne / Zestawy do makijażu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Znikopisy",
    "categoryPath": [
      "(94135) Dziecko",
      "Zabawki",
      "Plastyczne"
    ],
    "hierarchy": "(94135) Dziecko / Zabawki / Plastyczne / Znikopisy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(11842) Dziecko",
      "Zabawki"
    ],
    "hierarchy": "(11842) Dziecko / Zabawki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kleje do puzzli",
    "categoryPath": [
      "(315521) Dziecko",
      "Zabawki",
      "Puzzle",
      "Akcesoria"
    ],
    "hierarchy": "(315521) Dziecko / Zabawki / Puzzle / Akcesoria / Kleje do puzzli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maty do układania",
    "categoryPath": [
      "(315515) Dziecko",
      "Zabawki",
      "Puzzle",
      "Akcesoria"
    ],
    "hierarchy": "(315515) Dziecko / Zabawki / Puzzle / Akcesoria / Maty do układania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sortery do puzzli",
    "categoryPath": [
      "(315518) Dziecko",
      "Zabawki",
      "Puzzle",
      "Akcesoria"
    ],
    "hierarchy": "(315518) Dziecko / Zabawki / Puzzle / Akcesoria / Sortery do puzzli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piankowe",
    "categoryPath": [
      "(257814) Dziecko",
      "Zabawki",
      "Puzzle"
    ],
    "hierarchy": "(257814) Dziecko / Zabawki / Puzzle / Piankowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Przestrzenne 3D, 4D",
    "categoryPath": [
      "(257831) Dziecko",
      "Zabawki",
      "Puzzle"
    ],
    "hierarchy": "(257831) Dziecko / Zabawki / Puzzle / Przestrzenne 3D, 4D",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tradycyjne",
    "categoryPath": [
      "(257813) Dziecko",
      "Zabawki",
      "Puzzle"
    ],
    "hierarchy": "(257813) Dziecko / Zabawki / Puzzle / Tradycyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ambulanse",
    "categoryPath": [
      "(86362) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86362) Dziecko / Zabawki / Samochody i pojazdy / Ambulanse",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Autobusy i tramwaje",
    "categoryPath": [
      "(86354) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86354) Dziecko / Zabawki / Samochody i pojazdy / Autobusy i tramwaje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Betoniarki",
    "categoryPath": [
      "(86364) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86364) Dziecko / Zabawki / Samochody i pojazdy / Betoniarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ciężarówki",
    "categoryPath": [
      "(86359) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86359) Dziecko / Zabawki / Samochody i pojazdy / Ciężarówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Dźwigi",
    "categoryPath": [
      "(86357) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86357) Dziecko / Zabawki / Samochody i pojazdy / Dźwigi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Garaże",
    "categoryPath": [
      "(86367) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86367) Dziecko / Zabawki / Samochody i pojazdy / Garaże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kombajny",
    "categoryPath": [
      "(310313) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(310313) Dziecko / Zabawki / Samochody i pojazdy / Kombajny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Koparki",
    "categoryPath": [
      "(86358) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86358) Dziecko / Zabawki / Samochody i pojazdy / Koparki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Motory",
    "categoryPath": [
      "(86365) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86365) Dziecko / Zabawki / Samochody i pojazdy / Motory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Osobowe",
    "categoryPath": [
      "(86355) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86355) Dziecko / Zabawki / Samochody i pojazdy / Osobowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pojazdy z bajek",
    "categoryPath": [
      "(86370) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86370) Dziecko / Zabawki / Samochody i pojazdy / Pojazdy z bajek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Policja",
    "categoryPath": [
      "(86363) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86363) Dziecko / Zabawki / Samochody i pojazdy / Policja",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(86353) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86353) Dziecko / Zabawki / Samochody i pojazdy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyczepy",
    "categoryPath": [
      "(310385) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(310385) Dziecko / Zabawki / Samochody i pojazdy / Przyczepy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Serie",
    "categoryPath": [
      "(86369) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86369) Dziecko / Zabawki / Samochody i pojazdy / Serie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Straż",
    "categoryPath": [
      "(86361) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86361) Dziecko / Zabawki / Samochody i pojazdy / Straż",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Symulatory jazdy",
    "categoryPath": [
      "(310397) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(310397) Dziecko / Zabawki / Samochody i pojazdy / Symulatory jazdy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Terenowe",
    "categoryPath": [
      "(310337) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(310337) Dziecko / Zabawki / Samochody i pojazdy / Terenowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Tory samochodowe",
    "categoryPath": [
      "(124322) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(124322) Dziecko / Zabawki / Samochody i pojazdy / Tory samochodowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Traktory",
    "categoryPath": [
      "(86356) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86356) Dziecko / Zabawki / Samochody i pojazdy / Traktory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wojskowe",
    "categoryPath": [
      "(310349) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(310349) Dziecko / Zabawki / Samochody i pojazdy / Wojskowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wywrotki",
    "categoryPath": [
      "(86366) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86366) Dziecko / Zabawki / Samochody i pojazdy / Wywrotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wózki widłowe",
    "categoryPath": [
      "(321362) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(321362) Dziecko / Zabawki / Samochody i pojazdy / Wózki widłowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(86368) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86368) Dziecko / Zabawki / Samochody i pojazdy / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Znaki drogowe i sygnalizatory",
    "categoryPath": [
      "(310325) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(310325) Dziecko / Zabawki / Samochody i pojazdy / Znaki drogowe i sygnalizatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Śmieciarki",
    "categoryPath": [
      "(86360) Dziecko",
      "Zabawki",
      "Samochody i pojazdy"
    ],
    "hierarchy": "(86360) Dziecko / Zabawki / Samochody i pojazdy / Śmieciarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Helikoptery",
    "categoryPath": [
      "(86382) Dziecko",
      "Zabawki",
      "Samoloty i pokrewne"
    ],
    "hierarchy": "(86382) Dziecko / Zabawki / Samoloty i pokrewne / Helikoptery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(86385) Dziecko",
      "Zabawki",
      "Samoloty i pokrewne"
    ],
    "hierarchy": "(86385) Dziecko / Zabawki / Samoloty i pokrewne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rakiety, promy",
    "categoryPath": [
      "(86383) Dziecko",
      "Zabawki",
      "Samoloty i pokrewne"
    ],
    "hierarchy": "(86383) Dziecko / Zabawki / Samoloty i pokrewne / Rakiety, promy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Samoloty",
    "categoryPath": [
      "(86381) Dziecko",
      "Zabawki",
      "Samoloty i pokrewne"
    ],
    "hierarchy": "(86381) Dziecko / Zabawki / Samoloty i pokrewne / Samoloty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Łodzie, statki",
    "categoryPath": [
      "(86384) Dziecko",
      "Zabawki",
      "Samoloty i pokrewne"
    ],
    "hierarchy": "(86384) Dziecko / Zabawki / Samoloty i pokrewne / Łodzie, statki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Aparaty fotograficzne",
    "categoryPath": [
      "(261608) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(261608) Dziecko / Zabawki / Zabawki elektroniczne / Aparaty fotograficzne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Drony",
    "categoryPath": [
      "(312509) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(312509) Dziecko / Zabawki / Zabawki elektroniczne / Drony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Gry elektroniczne",
    "categoryPath": [
      "(319048) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(319048) Dziecko / Zabawki / Zabawki elektroniczne / Gry elektroniczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Instrumenty elektroniczne",
    "categoryPath": [
      "(312437) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(312437) Dziecko / Zabawki / Zabawki elektroniczne / Instrumenty elektroniczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Komputerki",
    "categoryPath": [
      "(19422) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(19422) Dziecko / Zabawki / Zabawki elektroniczne / Komputerki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Maty do tańczenia",
    "categoryPath": [
      "(312521) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(312521) Dziecko / Zabawki / Zabawki elektroniczne / Maty do tańczenia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(312557) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(312557) Dziecko / Zabawki / Zabawki elektroniczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Do programowania i kodowania",
    "categoryPath": [
      "(312473) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne",
      "Roboty"
    ],
    "hierarchy": "(312473) Dziecko / Zabawki / Zabawki elektroniczne / Roboty / Do programowania i kodowania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Do zbudowania",
    "categoryPath": [
      "(312461) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne",
      "Roboty"
    ],
    "hierarchy": "(312461) Dziecko / Zabawki / Zabawki elektroniczne / Roboty / Do zbudowania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(312497) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne",
      "Roboty"
    ],
    "hierarchy": "(312497) Dziecko / Zabawki / Zabawki elektroniczne / Roboty / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tablety",
    "categoryPath": [
      "(256113) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(256113) Dziecko / Zabawki / Zabawki elektroniczne / Tablety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Telefony",
    "categoryPath": [
      "(93710) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(93710) Dziecko / Zabawki / Zabawki elektroniczne / Telefony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Walkie talkie",
    "categoryPath": [
      "(312545) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(312545) Dziecko / Zabawki / Zabawki elektroniczne / Walkie talkie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zegarki elektroniczne",
    "categoryPath": [
      "(318162) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(318162) Dziecko / Zabawki / Zabawki elektroniczne / Zegarki elektroniczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zestawy do karaoke",
    "categoryPath": [
      "(312533) Dziecko",
      "Zabawki",
      "Zabawki elektroniczne"
    ],
    "hierarchy": "(312533) Dziecko / Zabawki / Zabawki elektroniczne / Zestawy do karaoke",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Zabawki terapeutyczne",
    "categoryPath": [
      "(319706) Dziecko",
      "Zabawki"
    ],
    "hierarchy": "(319706) Dziecko / Zabawki / Zabawki terapeutyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Cymbergaje",
    "categoryPath": [
      "(320122) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(320122) Dziecko / Zabawki / Zabawki zręcznościowe / Cymbergaje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Gry zręcznościowe",
    "categoryPath": [
      "(123948) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(123948) Dziecko / Zabawki / Zabawki zręcznościowe / Gry zręcznościowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kendamy",
    "categoryPath": [
      "(319081) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(319081) Dziecko / Zabawki / Zabawki zręcznościowe / Kendamy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kręgle",
    "categoryPath": [
      "(319078) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(319078) Dziecko / Zabawki / Zabawki zręcznościowe / Kręgle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Piłkarzyki",
    "categoryPath": [
      "(319075) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(319075) Dziecko / Zabawki / Zabawki zręcznościowe / Piłkarzyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(123955) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(123955) Dziecko / Zabawki / Zabawki zręcznościowe / Sportowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Wbijaki",
    "categoryPath": [
      "(320119) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(320119) Dziecko / Zabawki / Zabawki zręcznościowe / Wbijaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Łuki",
    "categoryPath": [
      "(319084) Dziecko",
      "Zabawki",
      "Zabawki zręcznościowe"
    ],
    "hierarchy": "(319084) Dziecko / Zabawki / Zabawki zręcznościowe / Łuki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Chodzące",
    "categoryPath": [
      "(320980) Dziecko",
      "Zabawki",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(320980) Dziecko / Zabawki / Zdalnie sterowane / Chodzące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(318328) Dziecko",
      "Zabawki",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(318328) Dziecko / Zabawki / Zdalnie sterowane / Części",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Jeżdżące",
    "categoryPath": [
      "(19498) Dziecko",
      "Zabawki",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(19498) Dziecko / Zabawki / Zdalnie sterowane / Jeżdżące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Latające",
    "categoryPath": [
      "(19499) Dziecko",
      "Zabawki",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(19499) Dziecko / Zabawki / Zdalnie sterowane / Latające",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19497) Dziecko",
      "Zabawki",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(19497) Dziecko / Zabawki / Zdalnie sterowane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pływające",
    "categoryPath": [
      "(19500) Dziecko",
      "Zabawki",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(19500) Dziecko / Zabawki / Zdalnie sterowane / Pływające",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Kosiarki",
    "categoryPath": [
      "(86288) Dziecko",
      "Zabawki ogrodowe",
      "Akcesoria ogrodnicze"
    ],
    "hierarchy": "(86288) Dziecko / Zabawki ogrodowe / Akcesoria ogrodnicze / Kosiarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Na owady",
    "categoryPath": [
      "(258347) Dziecko",
      "Zabawki ogrodowe",
      "Akcesoria ogrodnicze"
    ],
    "hierarchy": "(258347) Dziecko / Zabawki ogrodowe / Akcesoria ogrodnicze / Na owady",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Narzędzia",
    "categoryPath": [
      "(258350) Dziecko",
      "Zabawki ogrodowe",
      "Akcesoria ogrodnicze"
    ],
    "hierarchy": "(258350) Dziecko / Zabawki ogrodowe / Akcesoria ogrodnicze / Narzędzia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Taczki",
    "categoryPath": [
      "(86289) Dziecko",
      "Zabawki ogrodowe",
      "Akcesoria ogrodnicze"
    ],
    "hierarchy": "(86289) Dziecko / Zabawki ogrodowe / Akcesoria ogrodnicze / Taczki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Wózki",
    "categoryPath": [
      "(86290) Dziecko",
      "Zabawki ogrodowe",
      "Akcesoria ogrodnicze"
    ],
    "hierarchy": "(86290) Dziecko / Zabawki ogrodowe / Akcesoria ogrodnicze / Wózki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Deski, makarony, płetwy",
    "categoryPath": [
      "(317641) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody",
      "Akcesoria do pływania"
    ],
    "hierarchy": "(317641) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Akcesoria do pływania / Deski, makarony, płetwy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(317841) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody",
      "Akcesoria do pływania"
    ],
    "hierarchy": "(317841) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Akcesoria do pływania / Inne akcesoria",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kamizelki, rękawki",
    "categoryPath": [
      "(317647) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody",
      "Akcesoria do pływania"
    ],
    "hierarchy": "(317647) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Akcesoria do pływania / Kamizelki, rękawki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Koła",
    "categoryPath": [
      "(317644) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody",
      "Akcesoria do pływania"
    ],
    "hierarchy": "(317644) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Akcesoria do pływania / Koła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kołnierze",
    "categoryPath": [
      "(317653) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody",
      "Akcesoria do pływania"
    ],
    "hierarchy": "(317653) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Akcesoria do pływania / Kołnierze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Materace, pontony",
    "categoryPath": [
      "(317650) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody",
      "Akcesoria do pływania"
    ],
    "hierarchy": "(317650) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Akcesoria do pływania / Materace, pontony",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Zabawki do nurkowania",
    "categoryPath": [
      "(317638) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody",
      "Akcesoria do pływania"
    ],
    "hierarchy": "(317638) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Akcesoria do pływania / Zabawki do nurkowania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Zabawki wodne",
    "categoryPath": [
      "(260302) Dziecko",
      "Zabawki ogrodowe",
      "Baseny i zabawki do wody"
    ],
    "hierarchy": "(260302) Dziecko / Zabawki ogrodowe / Baseny i zabawki do wody / Zabawki wodne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Domki",
    "categoryPath": [
      "(86306) Dziecko",
      "Zabawki ogrodowe",
      "Domki, namioty"
    ],
    "hierarchy": "(86306) Dziecko / Zabawki ogrodowe / Domki, namioty / Domki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Namioty",
    "categoryPath": [
      "(86307) Dziecko",
      "Zabawki ogrodowe",
      "Domki, namioty"
    ],
    "hierarchy": "(86307) Dziecko / Zabawki ogrodowe / Domki, namioty / Namioty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Bańki mydlane",
    "categoryPath": [
      "(258397) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(258397) Dziecko / Zabawki ogrodowe / Gry i zabawy / Bańki mydlane",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Hokej",
    "categoryPath": [
      "(86323) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86323) Dziecko / Zabawki ogrodowe / Gry i zabawy / Hokej",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Jojo",
    "categoryPath": [
      "(86324) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86324) Dziecko / Zabawki ogrodowe / Gry i zabawy / Jojo",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Koszykówka",
    "categoryPath": [
      "(86320) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86320) Dziecko / Zabawki ogrodowe / Gry i zabawy / Koszykówka",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Latawce",
    "categoryPath": [
      "(86325) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86325) Dziecko / Zabawki ogrodowe / Gry i zabawy / Latawce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Mini golf",
    "categoryPath": [
      "(86321) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86321) Dziecko / Zabawki ogrodowe / Gry i zabawy / Mini golf",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Piłka nożna",
    "categoryPath": [
      "(86319) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86319) Dziecko / Zabawki ogrodowe / Gry i zabawy / Piłka nożna",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(260260) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(260260) Dziecko / Zabawki ogrodowe / Gry i zabawy / Piłki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(86318) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86318) Dziecko / Zabawki ogrodowe / Gry i zabawy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skakanki",
    "categoryPath": [
      "(86322) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy"
    ],
    "hierarchy": "(86322) Dziecko / Zabawki ogrodowe / Gry i zabawy / Skakanki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Hula-hoop",
    "categoryPath": [
      "(258321) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy",
      "Zręcznościowe"
    ],
    "hierarchy": "(258321) Dziecko / Zabawki ogrodowe / Gry i zabawy / Zręcznościowe / Hula-hoop",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kręgle",
    "categoryPath": [
      "(258319) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy",
      "Zręcznościowe"
    ],
    "hierarchy": "(258319) Dziecko / Zabawki ogrodowe / Gry i zabawy / Zręcznościowe / Kręgle",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Ringo, dyski, bumerangi",
    "categoryPath": [
      "(258320) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy",
      "Zręcznościowe"
    ],
    "hierarchy": "(258320) Dziecko / Zabawki ogrodowe / Gry i zabawy / Zręcznościowe / Ringo, dyski, bumerangi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Szczudła",
    "categoryPath": [
      "(258322) Dziecko",
      "Zabawki ogrodowe",
      "Gry i zabawy",
      "Zręcznościowe"
    ],
    "hierarchy": "(258322) Dziecko / Zabawki ogrodowe / Gry i zabawy / Zręcznościowe / Szczudła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Huśtawki",
    "categoryPath": [
      "(86280) Dziecko",
      "Zabawki ogrodowe"
    ],
    "hierarchy": "(86280) Dziecko / Zabawki ogrodowe / Huśtawki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Meble ogrodowe",
    "categoryPath": [
      "(86279) Dziecko",
      "Zabawki ogrodowe"
    ],
    "hierarchy": "(86279) Dziecko / Zabawki ogrodowe / Meble ogrodowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Piasek do piaskownic",
    "categoryPath": [
      "(321882) Dziecko",
      "Zabawki ogrodowe",
      "Piaskownice i zabawki do piasku"
    ],
    "hierarchy": "(321882) Dziecko / Zabawki ogrodowe / Piaskownice i zabawki do piasku / Piasek do piaskownic",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Piaskownice",
    "categoryPath": [
      "(260303) Dziecko",
      "Zabawki ogrodowe",
      "Piaskownice i zabawki do piasku"
    ],
    "hierarchy": "(260303) Dziecko / Zabawki ogrodowe / Piaskownice i zabawki do piasku / Piaskownice",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Stoliki wodne",
    "categoryPath": [
      "(260315) Dziecko",
      "Zabawki ogrodowe",
      "Piaskownice i zabawki do piasku"
    ],
    "hierarchy": "(260315) Dziecko / Zabawki ogrodowe / Piaskownice i zabawki do piasku / Stoliki wodne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Zabawki do piasku",
    "categoryPath": [
      "(260304) Dziecko",
      "Zabawki ogrodowe",
      "Piaskownice i zabawki do piasku"
    ],
    "hierarchy": "(260304) Dziecko / Zabawki ogrodowe / Piaskownice i zabawki do piasku / Zabawki do piasku",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Place zabaw",
    "categoryPath": [
      "(86342) Dziecko",
      "Zabawki ogrodowe"
    ],
    "hierarchy": "(86342) Dziecko / Zabawki ogrodowe / Place zabaw",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(86274) Dziecko",
      "Zabawki ogrodowe"
    ],
    "hierarchy": "(86274) Dziecko / Zabawki ogrodowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Drabinki",
    "categoryPath": [
      "(255107) Dziecko",
      "Zabawki ogrodowe",
      "Trampoliny i akcesoria"
    ],
    "hierarchy": "(255107) Dziecko / Zabawki ogrodowe / Trampoliny i akcesoria / Drabinki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Maty",
    "categoryPath": [
      "(255108) Dziecko",
      "Zabawki ogrodowe",
      "Trampoliny i akcesoria"
    ],
    "hierarchy": "(255108) Dziecko / Zabawki ogrodowe / Trampoliny i akcesoria / Maty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(255109) Dziecko",
      "Zabawki ogrodowe",
      "Trampoliny i akcesoria"
    ],
    "hierarchy": "(255109) Dziecko / Zabawki ogrodowe / Trampoliny i akcesoria / Osłony",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255112) Dziecko",
      "Zabawki ogrodowe",
      "Trampoliny i akcesoria"
    ],
    "hierarchy": "(255112) Dziecko / Zabawki ogrodowe / Trampoliny i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(255110) Dziecko",
      "Zabawki ogrodowe",
      "Trampoliny i akcesoria"
    ],
    "hierarchy": "(255110) Dziecko / Zabawki ogrodowe / Trampoliny i akcesoria / Siatki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Sprężyny",
    "categoryPath": [
      "(255111) Dziecko",
      "Zabawki ogrodowe",
      "Trampoliny i akcesoria"
    ],
    "hierarchy": "(255111) Dziecko / Zabawki ogrodowe / Trampoliny i akcesoria / Sprężyny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Trampoliny",
    "categoryPath": [
      "(255106) Dziecko",
      "Zabawki ogrodowe",
      "Trampoliny i akcesoria"
    ],
    "hierarchy": "(255106) Dziecko / Zabawki ogrodowe / Trampoliny i akcesoria / Trampoliny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Zjeżdżalnie",
    "categoryPath": [
      "(260261) Dziecko",
      "Zabawki ogrodowe"
    ],
    "hierarchy": "(260261) Dziecko / Zabawki ogrodowe / Zjeżdżalnie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Aspiratory i gruszki do nosa",
    "categoryPath": [
      "(99337) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99337) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Aspiratory i gruszki do nosa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kosze i wkłady",
    "categoryPath": [
      "(99345) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99345) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Kosze i wkłady",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Patyczki higieniczne",
    "categoryPath": [
      "(99338) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99338) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Patyczki higieniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Podkłady do przewijania",
    "categoryPath": [
      "(99346) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99346) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Podkłady do przewijania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Płatki kosmetyczne",
    "categoryPath": [
      "(99341) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99341) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Płatki kosmetyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Płyny do mycia butelek i akcesoriów",
    "categoryPath": [
      "(99344) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99344) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Płyny do mycia butelek i akcesoriów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Szczoteczki do zębów",
    "categoryPath": [
      "(99339) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99339) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Szczoteczki do zębów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Szczotki i grzebienie",
    "categoryPath": [
      "(99343) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99343) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Szczotki i grzebienie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Sól fizjologiczna",
    "categoryPath": [
      "(316013) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(316013) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Sól fizjologiczna",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Zestawy do paznokci",
    "categoryPath": [
      "(99342) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99342) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Zestawy do paznokci",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Środki do prania",
    "categoryPath": [
      "(99336) Dziecko",
      "Zdrowie i higiena",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(99336) Dziecko / Zdrowie i higiena / Artykuły higieniczne / Środki do prania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Balsamy i olejki do ciała",
    "categoryPath": [
      "(99387) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99387) Dziecko / Zdrowie i higiena / Kosmetyki / Balsamy i olejki do ciała",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Dezodoranty i wody zapachowe dla dzieci",
    "categoryPath": [
      "(316037) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(316037) Dziecko / Zdrowie i higiena / Kosmetyki / Dezodoranty i wody zapachowe dla dzieci",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Emulsje i mydła",
    "categoryPath": [
      "(99386) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99386) Dziecko / Zdrowie i higiena / Kosmetyki / Emulsje i mydła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kremy i mleczka na słońce",
    "categoryPath": [
      "(99384) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99384) Dziecko / Zdrowie i higiena / Kosmetyki / Kremy i mleczka na słońce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kremy na odparzenia",
    "categoryPath": [
      "(99382) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99382) Dziecko / Zdrowie i higiena / Kosmetyki / Kremy na odparzenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kremy pielęgnacyjne",
    "categoryPath": [
      "(99383) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99383) Dziecko / Zdrowie i higiena / Kosmetyki / Kremy pielęgnacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Mleczka",
    "categoryPath": [
      "(99388) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99388) Dziecko / Zdrowie i higiena / Kosmetyki / Mleczka",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Preparaty na komary",
    "categoryPath": [
      "(316034) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(316034) Dziecko / Zdrowie i higiena / Kosmetyki / Preparaty na komary",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pudry i zasypki",
    "categoryPath": [
      "(316028) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(316028) Dziecko / Zdrowie i higiena / Kosmetyki / Pudry i zasypki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Płyny do kąpieli",
    "categoryPath": [
      "(99385) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99385) Dziecko / Zdrowie i higiena / Kosmetyki / Płyny do kąpieli",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Szampony i żele",
    "categoryPath": [
      "(99389) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(99389) Dziecko / Zdrowie i higiena / Kosmetyki / Szampony i żele",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Zestawy kosmetyków",
    "categoryPath": [
      "(316040) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(316040) Dziecko / Zdrowie i higiena / Kosmetyki / Zestawy kosmetyków",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Żele antybakteryjne dla dzieci",
    "categoryPath": [
      "(316031) Dziecko",
      "Zdrowie i higiena",
      "Kosmetyki"
    ],
    "hierarchy": "(316031) Dziecko / Zdrowie i higiena / Kosmetyki / Żele antybakteryjne dla dzieci",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Nakładki na sedes",
    "categoryPath": [
      "(99528) Dziecko",
      "Zdrowie i higiena",
      "Nocniki i nakładki"
    ],
    "hierarchy": "(99528) Dziecko / Zdrowie i higiena / Nocniki i nakładki / Nakładki na sedes",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Nocniki interaktywne",
    "categoryPath": [
      "(99366) Dziecko",
      "Zdrowie i higiena",
      "Nocniki i nakładki"
    ],
    "hierarchy": "(99366) Dziecko / Zdrowie i higiena / Nocniki i nakładki / Nocniki interaktywne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Nocniki tradycyjne",
    "categoryPath": [
      "(99365) Dziecko",
      "Zdrowie i higiena",
      "Nocniki i nakładki"
    ],
    "hierarchy": "(99365) Dziecko / Zdrowie i higiena / Nocniki i nakładki / Nocniki tradycyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Nocniki turystyczne",
    "categoryPath": [
      "(316185) Dziecko",
      "Zdrowie i higiena",
      "Nocniki i nakładki"
    ],
    "hierarchy": "(316185) Dziecko / Zdrowie i higiena / Nocniki i nakładki / Nocniki turystyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pisuary",
    "categoryPath": [
      "(316182) Dziecko",
      "Zdrowie i higiena",
      "Nocniki i nakładki"
    ],
    "hierarchy": "(316182) Dziecko / Zdrowie i higiena / Nocniki i nakładki / Pisuary",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Podesty",
    "categoryPath": [
      "(99367) Dziecko",
      "Zdrowie i higiena",
      "Nocniki i nakładki"
    ],
    "hierarchy": "(99367) Dziecko / Zdrowie i higiena / Nocniki i nakładki / Podesty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Wkłady",
    "categoryPath": [
      "(317659) Dziecko",
      "Zdrowie i higiena",
      "Nocniki i nakładki"
    ],
    "hierarchy": "(317659) Dziecko / Zdrowie i higiena / Nocniki i nakładki / Wkłady",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Chusteczki nawilżane",
    "categoryPath": [
      "(99393) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(99393) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Chusteczki nawilżane",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Majteczki treningowe",
    "categoryPath": [
      "(99405) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(99405) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Majteczki treningowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pieluchomajtki",
    "categoryPath": [
      "(304709) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(304709) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Pieluchomajtki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pieluszki i majtki do pływania",
    "categoryPath": [
      "(315998) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(315998) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Pieluszki i majtki do pływania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pieluszki jednorazowe",
    "categoryPath": [
      "(99391) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(99391) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Pieluszki jednorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pieluszki wielorazowe",
    "categoryPath": [
      "(99392) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(99392) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Pieluszki wielorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pudełka na chusteczki",
    "categoryPath": [
      "(322159) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(322159) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Pudełka na chusteczki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Woreczki na pieluszki",
    "categoryPath": [
      "(99529) Dziecko",
      "Zdrowie i higiena",
      "Pieluszki i chusteczki"
    ],
    "hierarchy": "(99529) Dziecko / Zdrowie i higiena / Pieluszki i chusteczki / Woreczki na pieluszki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(17299) Dziecko",
      "Zdrowie i higiena"
    ],
    "hierarchy": "(17299) Dziecko / Zdrowie i higiena / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Komody pielęgnacyjne",
    "categoryPath": [
      "(99371) Dziecko",
      "Zdrowie i higiena",
      "Przewijaki"
    ],
    "hierarchy": "(99371) Dziecko / Zdrowie i higiena / Przewijaki / Komody pielęgnacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Miękkie",
    "categoryPath": [
      "(99369) Dziecko",
      "Zdrowie i higiena",
      "Przewijaki"
    ],
    "hierarchy": "(99369) Dziecko / Zdrowie i higiena / Przewijaki / Miękkie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(321314) Dziecko",
      "Zdrowie i higiena",
      "Przewijaki"
    ],
    "hierarchy": "(321314) Dziecko / Zdrowie i higiena / Przewijaki / Pokrowce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Sztywne",
    "categoryPath": [
      "(99370) Dziecko",
      "Zdrowie i higiena",
      "Przewijaki"
    ],
    "hierarchy": "(99370) Dziecko / Zdrowie i higiena / Przewijaki / Sztywne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Okrycia z kapturem",
    "categoryPath": [
      "(99409) Dziecko",
      "Zdrowie i higiena",
      "Ręczniki i okrycia"
    ],
    "hierarchy": "(99409) Dziecko / Zdrowie i higiena / Ręczniki i okrycia / Okrycia z kapturem",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(99406) Dziecko",
      "Zdrowie i higiena",
      "Ręczniki i okrycia"
    ],
    "hierarchy": "(99406) Dziecko / Zdrowie i higiena / Ręczniki i okrycia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ręczniki kąpielowe",
    "categoryPath": [
      "(99407) Dziecko",
      "Zdrowie i higiena",
      "Ręczniki i okrycia"
    ],
    "hierarchy": "(99407) Dziecko / Zdrowie i higiena / Ręczniki i okrycia / Ręczniki kąpielowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Ręczniki plażowe",
    "categoryPath": [
      "(99408) Dziecko",
      "Zdrowie i higiena",
      "Ręczniki i okrycia"
    ],
    "hierarchy": "(99408) Dziecko / Zdrowie i higiena / Ręczniki i okrycia / Ręczniki plażowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D9"
  },
  {
    "segment": "Detektory tętna płodu",
    "categoryPath": [
      "(260401) Dziecko",
      "Zdrowie i higiena",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(260401) Dziecko / Zdrowie i higiena / Urządzenia medyczne / Detektory tętna płodu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Katetery i rurki antykolkowe",
    "categoryPath": [
      "(316552) Dziecko",
      "Zdrowie i higiena",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(316552) Dziecko / Zdrowie i higiena / Urządzenia medyczne / Katetery i rurki antykolkowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260407) Dziecko",
      "Zdrowie i higiena",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(260407) Dziecko / Zdrowie i higiena / Urządzenia medyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wagi",
    "categoryPath": [
      "(260406) Dziecko",
      "Zdrowie i higiena",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(260406) Dziecko / Zdrowie i higiena / Urządzenia medyczne / Wagi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Wibratory logopedyczne",
    "categoryPath": [
      "(316555) Dziecko",
      "Zdrowie i higiena",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(316555) Dziecko / Zdrowie i higiena / Urządzenia medyczne / Wibratory logopedyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Foteliki kąpielowe",
    "categoryPath": [
      "(99378) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(99378) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Foteliki kąpielowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Komody kąpielowe",
    "categoryPath": [
      "(99374) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(99374) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Komody kąpielowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Kubki do spłukiwania",
    "categoryPath": [
      "(309793) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(309793) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Kubki do spłukiwania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Maty do kąpieli",
    "categoryPath": [
      "(99377) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(99377) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Maty do kąpieli",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Myjki i gąbki",
    "categoryPath": [
      "(309805) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(309805) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Myjki i gąbki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Nakładki na kran",
    "categoryPath": [
      "(309829) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(309829) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Nakładki na kran",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Pojemniki na zabawki do kąpieli",
    "categoryPath": [
      "(316179) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(316179) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Pojemniki na zabawki do kąpieli",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Ronda kąpielowe",
    "categoryPath": [
      "(99380) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(99380) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Ronda kąpielowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Stojaki",
    "categoryPath": [
      "(99376) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(99376) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Stojaki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Termometry do kąpieli",
    "categoryPath": [
      "(310021) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(310021) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Termometry do kąpieli",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Wanienki",
    "categoryPath": [
      "(99375) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(99375) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Wanienki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Wiaderka do kąpieli",
    "categoryPath": [
      "(99379) Dziecko",
      "Zdrowie i higiena",
      "Wanienki i akcesoria do kąpieli"
    ],
    "hierarchy": "(99379) Dziecko / Zdrowie i higiena / Wanienki i akcesoria do kąpieli / Wiaderka do kąpieli",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D12"
  },
  {
    "segment": "Bibułki",
    "categoryPath": [
      "(313513) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(313513) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Bibułki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Gruszki",
    "categoryPath": [
      "(309181) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(309181) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Gruszki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lupy do matryc",
    "categoryPath": [
      "(313525) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(313525) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Lupy do matryc",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pędzelki, pióra, czyściki",
    "categoryPath": [
      "(19979) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(19979) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Pędzelki, pióra, czyściki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Płyny, pianki",
    "categoryPath": [
      "(313501) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(313501) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Płyny, pianki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szpatułki, patyczki",
    "categoryPath": [
      "(313489) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(313489) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Szpatułki, patyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(19980) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(19980) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ściereczki",
    "categoryPath": [
      "(19978) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria i środki czyszczące"
    ],
    "hierarchy": "(19978) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria i środki czyszczące / Ściereczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(90214) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria wodoszczelne"
    ],
    "hierarchy": "(90214) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria wodoszczelne / Obudowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pokrowce i futerały",
    "categoryPath": [
      "(97894) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Akcesoria wodoszczelne"
    ],
    "hierarchy": "(97894) Elektronika / Fotografia / Akcesoria fotograficzne / Akcesoria wodoszczelne / Pokrowce i futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Albumy",
    "categoryPath": [
      "(320762) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Albumy i ramki na zdjęcia"
    ],
    "hierarchy": "(320762) Elektronika / Fotografia / Akcesoria fotograficzne / Albumy i ramki na zdjęcia / Albumy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Antyramy",
    "categoryPath": [
      "(97876) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Albumy i ramki na zdjęcia"
    ],
    "hierarchy": "(97876) Elektronika / Fotografia / Akcesoria fotograficzne / Albumy i ramki na zdjęcia / Antyramy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Klej i przylepce do zdjęć",
    "categoryPath": [
      "(309745) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Albumy i ramki na zdjęcia"
    ],
    "hierarchy": "(309745) Elektronika / Fotografia / Akcesoria fotograficzne / Albumy i ramki na zdjęcia / Klej i przylepce do zdjęć",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ramki cyfrowe",
    "categoryPath": [
      "(261826) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Albumy i ramki na zdjęcia"
    ],
    "hierarchy": "(261826) Elektronika / Fotografia / Akcesoria fotograficzne / Albumy i ramki na zdjęcia / Ramki cyfrowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy ramek",
    "categoryPath": [
      "(97879) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Albumy i ramki na zdjęcia"
    ],
    "hierarchy": "(97879) Elektronika / Fotografia / Akcesoria fotograficzne / Albumy i ramki na zdjęcia / Zestawy ramek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Klapki",
    "categoryPath": [
      "(90216) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90216) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Klapki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Matryce",
    "categoryPath": [
      "(90218) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90218) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Matryce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Matówki",
    "categoryPath": [
      "(90217) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90217) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Matówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obiektywy",
    "categoryPath": [
      "(90219) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90219) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Obiektywy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(90220) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90220) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Obudowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(90215) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90215) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płyty główne",
    "categoryPath": [
      "(90221) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90221) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Płyty główne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wyświetlacze LCD",
    "categoryPath": [
      "(90222) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Części zamienne"
    ],
    "hierarchy": "(90222) Elektronika / Fotografia / Akcesoria fotograficzne / Części zamienne / Wyświetlacze LCD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Drukarki fotograficzne",
    "categoryPath": [
      "(8851) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(8851) Elektronika / Fotografia / Akcesoria fotograficzne / Drukarki fotograficzne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie i pergaminy",
    "categoryPath": [
      "(46661) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze",
      "Akcesoria archiwizacyjne"
    ],
    "hierarchy": "(46661) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Akcesoria archiwizacyjne / Folie i pergaminy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pojemniki",
    "categoryPath": [
      "(313537) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze",
      "Akcesoria archiwizacyjne"
    ],
    "hierarchy": "(313537) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Akcesoria archiwizacyjne / Pojemniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Segregatory",
    "categoryPath": [
      "(46662) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze",
      "Akcesoria archiwizacyjne"
    ],
    "hierarchy": "(46662) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Akcesoria archiwizacyjne / Segregatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szpule, taśmy",
    "categoryPath": [
      "(313549) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze",
      "Akcesoria archiwizacyjne"
    ],
    "hierarchy": "(313549) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Akcesoria archiwizacyjne / Szpule, taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Fotografia natychmiastowa",
    "categoryPath": [
      "(255493) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze"
    ],
    "hierarchy": "(255493) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Fotografia natychmiastowa",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Inne formaty",
    "categoryPath": [
      "(11704) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze"
    ],
    "hierarchy": "(11704) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Inne formaty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Małoobrazkowe",
    "categoryPath": [
      "(314121) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze"
    ],
    "hierarchy": "(314121) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Małoobrazkowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wielkoformatowe",
    "categoryPath": [
      "(314161) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze"
    ],
    "hierarchy": "(314161) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Wielkoformatowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Średnioformatowe",
    "categoryPath": [
      "(314149) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filmy i klisze"
    ],
    "hierarchy": "(314149) Elektronika / Fotografia / Akcesoria fotograficzne / Filmy i klisze / Średnioformatowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Efektowe",
    "categoryPath": [
      "(8870) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(8870) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Efektowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kompensacyjne (szare)",
    "categoryPath": [
      "(11730) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(11730) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Kompensacyjne (szare)",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ochronne",
    "categoryPath": [
      "(257349) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(257349) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Podczerwone",
    "categoryPath": [
      "(90223) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(90223) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Podczerwone",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Polaryzacyjne",
    "categoryPath": [
      "(8871) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(8871) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Polaryzacyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(8872) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(8872) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Połówkowe",
    "categoryPath": [
      "(90224) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(90224) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Połówkowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Prostokątne",
    "categoryPath": [
      "(19956) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(19956) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Prostokątne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Skylight",
    "categoryPath": [
      "(8868) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(8868) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Skylight",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "UV",
    "categoryPath": [
      "(8869) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(8869) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / UV",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(16274) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Filtry"
    ],
    "hierarchy": "(16274) Elektronika / Fotografia / Akcesoria fotograficzne / Filtry / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie ochronne",
    "categoryPath": [
      "(20007) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Folie ochronne i osłony LCD"
    ],
    "hierarchy": "(20007) Elektronika / Fotografia / Akcesoria fotograficzne / Folie ochronne i osłony LCD / Folie ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Osłony LCD",
    "categoryPath": [
      "(20008) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Folie ochronne i osłony LCD"
    ],
    "hierarchy": "(20008) Elektronika / Fotografia / Akcesoria fotograficzne / Folie ochronne i osłony LCD / Osłony LCD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Futerały",
    "categoryPath": [
      "(11708) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Futerały i paski"
    ],
    "hierarchy": "(11708) Elektronika / Fotografia / Akcesoria fotograficzne / Futerały i paski / Futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Paski i smycze",
    "categoryPath": [
      "(11709) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Futerały i paski"
    ],
    "hierarchy": "(11709) Elektronika / Fotografia / Akcesoria fotograficzne / Futerały i paski / Paski i smycze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "AV",
    "categoryPath": [
      "(90226) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Kable, przewody i stacje dokujące"
    ],
    "hierarchy": "(90226) Elektronika / Fotografia / Akcesoria fotograficzne / Kable, przewody i stacje dokujące / AV",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "HDMI",
    "categoryPath": [
      "(90225) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Kable, przewody i stacje dokujące"
    ],
    "hierarchy": "(90225) Elektronika / Fotografia / Akcesoria fotograficzne / Kable, przewody i stacje dokujące / HDMI",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(11741) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Kable, przewody i stacje dokujące"
    ],
    "hierarchy": "(11741) Elektronika / Fotografia / Akcesoria fotograficzne / Kable, przewody i stacje dokujące / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stacje dokujące",
    "categoryPath": [
      "(19981) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Kable, przewody i stacje dokujące"
    ],
    "hierarchy": "(19981) Elektronika / Fotografia / Akcesoria fotograficzne / Kable, przewody i stacje dokujące / Stacje dokujące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "USB",
    "categoryPath": [
      "(11706) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Kable, przewody i stacje dokujące"
    ],
    "hierarchy": "(11706) Elektronika / Fotografia / Akcesoria fotograficzne / Kable, przewody i stacje dokujące / USB",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wężyki spustowe",
    "categoryPath": [
      "(11707) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Kable, przewody i stacje dokujące"
    ],
    "hierarchy": "(11707) Elektronika / Fotografia / Akcesoria fotograficzne / Kable, przewody i stacje dokujące / Wężyki spustowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kalibrowanie i profilowanie",
    "categoryPath": [
      "(255488) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(255488) Elektronika / Fotografia / Akcesoria fotograficzne / Kalibrowanie i profilowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Fisheye",
    "categoryPath": [
      "(90231) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Konwertery"
    ],
    "hierarchy": "(90231) Elektronika / Fotografia / Akcesoria fotograficzne / Konwertery / Fisheye",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Makro",
    "categoryPath": [
      "(90230) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Konwertery"
    ],
    "hierarchy": "(90230) Elektronika / Fotografia / Akcesoria fotograficzne / Konwertery / Makro",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(90227) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Konwertery"
    ],
    "hierarchy": "(90227) Elektronika / Fotografia / Akcesoria fotograficzne / Konwertery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szerokokątne",
    "categoryPath": [
      "(90228) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Konwertery"
    ],
    "hierarchy": "(90228) Elektronika / Fotografia / Akcesoria fotograficzne / Konwertery / Szerokokątne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Telekonwertery",
    "categoryPath": [
      "(90229) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Konwertery"
    ],
    "hierarchy": "(90229) Elektronika / Fotografia / Akcesoria fotograficzne / Konwertery / Telekonwertery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Adaptery",
    "categoryPath": [
      "(255494) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Makro"
    ],
    "hierarchy": "(255494) Elektronika / Fotografia / Akcesoria fotograficzne / Makro / Adaptery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mieszki",
    "categoryPath": [
      "(8873) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Makro"
    ],
    "hierarchy": "(8873) Elektronika / Fotografia / Akcesoria fotograficzne / Makro / Mieszki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pierścienie",
    "categoryPath": [
      "(8874) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Makro"
    ],
    "hierarchy": "(8874) Elektronika / Fotografia / Akcesoria fotograficzne / Makro / Pierścienie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Soczewki",
    "categoryPath": [
      "(8875) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Makro"
    ],
    "hierarchy": "(8875) Elektronika / Fotografia / Akcesoria fotograficzne / Makro / Soczewki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mikrofony",
    "categoryPath": [
      "(255490) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(255490) Elektronika / Fotografia / Akcesoria fotograficzne / Mikrofony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Minilaby",
    "categoryPath": [
      "(314125) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(314125) Elektronika / Fotografia / Akcesoria fotograficzne / Minilaby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Monitory podglądowe",
    "categoryPath": [
      "(255489) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(255489) Elektronika / Fotografia / Akcesoria fotograficzne / Monitory podglądowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Muszle oczne i wizjery",
    "categoryPath": [
      "(97891) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(97891) Elektronika / Fotografia / Akcesoria fotograficzne / Muszle oczne i wizjery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Dekielki i zaślepki",
    "categoryPath": [
      "(19962) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Osłony na obiektywy"
    ],
    "hierarchy": "(19962) Elektronika / Fotografia / Akcesoria fotograficzne / Osłony na obiektywy / Dekielki i zaślepki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Etui do obiektywów",
    "categoryPath": [
      "(313573) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Osłony na obiektywy"
    ],
    "hierarchy": "(313573) Elektronika / Fotografia / Akcesoria fotograficzne / Osłony na obiektywy / Etui do obiektywów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Osłony maskujące",
    "categoryPath": [
      "(313561) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Osłony na obiektywy"
    ],
    "hierarchy": "(313561) Elektronika / Fotografia / Akcesoria fotograficzne / Osłony na obiektywy / Osłony maskujące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Przeciwsłoneczne",
    "categoryPath": [
      "(19961) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Osłony na obiektywy"
    ],
    "hierarchy": "(19961) Elektronika / Fotografia / Akcesoria fotograficzne / Osłony na obiektywy / Przeciwsłoneczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy ochronne",
    "categoryPath": [
      "(19963) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Osłony na obiektywy"
    ],
    "hierarchy": "(19963) Elektronika / Fotografia / Akcesoria fotograficzne / Osłony na obiektywy / Zestawy ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Papiery i folie fotograficzne",
    "categoryPath": [
      "(19982) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(19982) Elektronika / Fotografia / Akcesoria fotograficzne / Papiery i folie fotograficzne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Piloty",
    "categoryPath": [
      "(301114) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(301114) Elektronika / Fotografia / Akcesoria fotograficzne / Piloty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Poziomice",
    "categoryPath": [
      "(97892) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(97892) Elektronika / Fotografia / Akcesoria fotograficzne / Poziomice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(8867) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(8867) Elektronika / Fotografia / Akcesoria fotograficzne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pudełka",
    "categoryPath": [
      "(28156) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(28156) Elektronika / Fotografia / Akcesoria fotograficzne / Pudełka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Magazynki",
    "categoryPath": [
      "(28152) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Rzutniki",
      "Akcesoria"
    ],
    "hierarchy": "(28152) Elektronika / Fotografia / Akcesoria fotograficzne / Rzutniki / Akcesoria / Magazynki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ramki",
    "categoryPath": [
      "(28153) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Rzutniki",
      "Akcesoria"
    ],
    "hierarchy": "(28153) Elektronika / Fotografia / Akcesoria fotograficzne / Rzutniki / Akcesoria / Ramki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Slajdy",
    "categoryPath": [
      "(28154) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Rzutniki",
      "Akcesoria"
    ],
    "hierarchy": "(28154) Elektronika / Fotografia / Akcesoria fotograficzne / Rzutniki / Akcesoria / Slajdy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(28149) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Rzutniki"
    ],
    "hierarchy": "(28149) Elektronika / Fotografia / Akcesoria fotograficzne / Rzutniki / Urządzenia",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Selfie sticki",
    "categoryPath": [
      "(255492) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(255492) Elektronika / Fotografia / Akcesoria fotograficzne / Selfie sticki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stabilizatory obrazu dla aparatów i kamer",
    "categoryPath": [
      "(148922) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(148922) Elektronika / Fotografia / Akcesoria fotograficzne / Stabilizatory obrazu dla aparatów i kamer",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głowice do statywów",
    "categoryPath": [
      "(11717) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Statywy"
    ],
    "hierarchy": "(11717) Elektronika / Fotografia / Akcesoria fotograficzne / Statywy / Głowice do statywów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Statywy elastyczne",
    "categoryPath": [
      "(255495) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Statywy"
    ],
    "hierarchy": "(255495) Elektronika / Fotografia / Akcesoria fotograficzne / Statywy / Statywy elastyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stołowe",
    "categoryPath": [
      "(11716) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Statywy"
    ],
    "hierarchy": "(11716) Elektronika / Fotografia / Akcesoria fotograficzne / Statywy / Stołowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szybkozłączki",
    "categoryPath": [
      "(256623) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Statywy"
    ],
    "hierarchy": "(256623) Elektronika / Fotografia / Akcesoria fotograficzne / Statywy / Szybkozłączki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Monopody",
    "categoryPath": [
      "(90233) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Statywy",
      "Wysokie"
    ],
    "hierarchy": "(90233) Elektronika / Fotografia / Akcesoria fotograficzne / Statywy / Wysokie / Monopody",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Tripody",
    "categoryPath": [
      "(90232) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Statywy",
      "Wysokie"
    ],
    "hierarchy": "(90232) Elektronika / Fotografia / Akcesoria fotograficzne / Statywy / Wysokie / Tripody",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Plecaki",
    "categoryPath": [
      "(19988) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Torby i plecaki"
    ],
    "hierarchy": "(19988) Elektronika / Fotografia / Akcesoria fotograficzne / Torby i plecaki / Plecaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Skrzynie i walizki",
    "categoryPath": [
      "(254978) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Torby i plecaki"
    ],
    "hierarchy": "(254978) Elektronika / Fotografia / Akcesoria fotograficzne / Torby i plecaki / Skrzynie i walizki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Torby",
    "categoryPath": [
      "(19987) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Torby i plecaki"
    ],
    "hierarchy": "(19987) Elektronika / Fotografia / Akcesoria fotograficzne / Torby i plecaki / Torby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Tuleje, pierścienie redukcyjne",
    "categoryPath": [
      "(257194) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(257194) Elektronika / Fotografia / Akcesoria fotograficzne / Tuleje, pierścienie redukcyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(11721) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Wyposażenie ciemni"
    ],
    "hierarchy": "(11721) Elektronika / Fotografia / Akcesoria fotograficzne / Wyposażenie ciemni / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obiektywy powiększalnikowe",
    "categoryPath": [
      "(19985) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Wyposażenie ciemni"
    ],
    "hierarchy": "(19985) Elektronika / Fotografia / Akcesoria fotograficzne / Wyposażenie ciemni / Obiektywy powiększalnikowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Papier i chemikalia",
    "categoryPath": [
      "(11722) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Wyposażenie ciemni"
    ],
    "hierarchy": "(11722) Elektronika / Fotografia / Akcesoria fotograficzne / Wyposażenie ciemni / Papier i chemikalia",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Powiększalniki",
    "categoryPath": [
      "(11723) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Wyposażenie ciemni"
    ],
    "hierarchy": "(11723) Elektronika / Fotografia / Akcesoria fotograficzne / Wyposażenie ciemni / Powiększalniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Suszarki",
    "categoryPath": [
      "(11724) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Wyposażenie ciemni"
    ],
    "hierarchy": "(11724) Elektronika / Fotografia / Akcesoria fotograficzne / Wyposażenie ciemni / Suszarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(11725) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne",
      "Wyposażenie ciemni"
    ],
    "hierarchy": "(11725) Elektronika / Fotografia / Akcesoria fotograficzne / Wyposażenie ciemni / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy akcesoriów",
    "categoryPath": [
      "(8866) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(8866) Elektronika / Fotografia / Akcesoria fotograficzne / Zestawy akcesoriów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Światłomierze",
    "categoryPath": [
      "(11718) Elektronika",
      "Fotografia",
      "Akcesoria fotograficzne"
    ],
    "hierarchy": "(11718) Elektronika / Fotografia / Akcesoria fotograficzne / Światłomierze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Jednorazowe",
    "categoryPath": [
      "(110615) Elektronika",
      "Fotografia",
      "Aparaty analogowe"
    ],
    "hierarchy": "(110615) Elektronika / Fotografia / Aparaty analogowe / Jednorazowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kolekcjonerskie",
    "categoryPath": [
      "(110616) Elektronika",
      "Fotografia",
      "Aparaty analogowe"
    ],
    "hierarchy": "(110616) Elektronika / Fotografia / Aparaty analogowe / Kolekcjonerskie",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kompaktowe",
    "categoryPath": [
      "(261824) Elektronika",
      "Fotografia",
      "Aparaty analogowe"
    ],
    "hierarchy": "(261824) Elektronika / Fotografia / Aparaty analogowe / Kompaktowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lustrzanki",
    "categoryPath": [
      "(261825) Elektronika",
      "Fotografia",
      "Aparaty analogowe"
    ],
    "hierarchy": "(261825) Elektronika / Fotografia / Aparaty analogowe / Lustrzanki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(110590) Elektronika",
      "Fotografia",
      "Aparaty analogowe"
    ],
    "hierarchy": "(110590) Elektronika / Fotografia / Aparaty analogowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Średnio- i wielkoformatowe",
    "categoryPath": [
      "(110614) Elektronika",
      "Fotografia",
      "Aparaty analogowe"
    ],
    "hierarchy": "(110614) Elektronika / Fotografia / Aparaty analogowe / Średnio- i wielkoformatowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Bezlusterkowce",
    "categoryPath": [
      "(257931) Elektronika",
      "Fotografia",
      "Aparaty cyfrowe"
    ],
    "hierarchy": "(257931) Elektronika / Fotografia / Aparaty cyfrowe / Bezlusterkowce",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kompaktowe",
    "categoryPath": [
      "(257932) Elektronika",
      "Fotografia",
      "Aparaty cyfrowe"
    ],
    "hierarchy": "(257932) Elektronika / Fotografia / Aparaty cyfrowe / Kompaktowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lustrzanki",
    "categoryPath": [
      "(257933) Elektronika",
      "Fotografia",
      "Aparaty cyfrowe"
    ],
    "hierarchy": "(257933) Elektronika / Fotografia / Aparaty cyfrowe / Lustrzanki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Aparaty natychmiastowe",
    "categoryPath": [
      "(258665) Elektronika",
      "Fotografia"
    ],
    "hierarchy": "(258665) Elektronika / Fotografia / Aparaty natychmiastowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Fotobudki",
    "categoryPath": [
      "(255486) Elektronika",
      "Fotografia"
    ],
    "hierarchy": "(255486) Elektronika / Fotografia / Fotobudki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Banki danych",
    "categoryPath": [
      "(50610) Elektronika",
      "Fotografia",
      "Karty pamięci"
    ],
    "hierarchy": "(50610) Elektronika / Fotografia / Karty pamięci / Banki danych",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "CompactFlash",
    "categoryPath": [
      "(8904) Elektronika",
      "Fotografia",
      "Karty pamięci"
    ],
    "hierarchy": "(8904) Elektronika / Fotografia / Karty pamięci / CompactFlash",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "CompactFlash",
    "categoryPath": [
      "(8910) Elektronika",
      "Fotografia",
      "Karty pamięci",
      "Czytniki i adaptery"
    ],
    "hierarchy": "(8910) Elektronika / Fotografia / Karty pamięci / Czytniki i adaptery / CompactFlash",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "MMC/SD",
    "categoryPath": [
      "(8912) Elektronika",
      "Fotografia",
      "Karty pamięci",
      "Czytniki i adaptery"
    ],
    "hierarchy": "(8912) Elektronika / Fotografia / Karty pamięci / Czytniki i adaptery / MMC/SD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Memory Stick",
    "categoryPath": [
      "(8911) Elektronika",
      "Fotografia",
      "Karty pamięci",
      "Czytniki i adaptery"
    ],
    "hierarchy": "(8911) Elektronika / Fotografia / Karty pamięci / Czytniki i adaptery / Memory Stick",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(8915) Elektronika",
      "Fotografia",
      "Karty pamięci",
      "Czytniki i adaptery"
    ],
    "hierarchy": "(8915) Elektronika / Fotografia / Karty pamięci / Czytniki i adaptery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Uniwersalne",
    "categoryPath": [
      "(8914) Elektronika",
      "Fotografia",
      "Karty pamięci",
      "Czytniki i adaptery"
    ],
    "hierarchy": "(8914) Elektronika / Fotografia / Karty pamięci / Czytniki i adaptery / Uniwersalne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257898) Elektronika",
      "Fotografia",
      "Karty pamięci"
    ],
    "hierarchy": "(257898) Elektronika / Fotografia / Karty pamięci / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pudełka i futerały",
    "categoryPath": [
      "(19998) Elektronika",
      "Fotografia",
      "Karty pamięci"
    ],
    "hierarchy": "(19998) Elektronika / Fotografia / Karty pamięci / Pudełka i futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "SD",
    "categoryPath": [
      "(16242) Elektronika",
      "Fotografia",
      "Karty pamięci"
    ],
    "hierarchy": "(16242) Elektronika / Fotografia / Karty pamięci / SD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(110697) Elektronika",
      "Fotografia",
      "Lampy błyskowe"
    ],
    "hierarchy": "(110697) Elektronika / Fotografia / Lampy błyskowe / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(110698) Elektronika",
      "Fotografia",
      "Lampy błyskowe"
    ],
    "hierarchy": "(110698) Elektronika / Fotografia / Lampy błyskowe / Urządzenia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Czasopisma",
    "categoryPath": [
      "(124884) Elektronika",
      "Fotografia",
      "Literatura i instrukcje"
    ],
    "hierarchy": "(124884) Elektronika / Fotografia / Literatura i instrukcje / Czasopisma",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Instrukcje obsługi",
    "categoryPath": [
      "(124885) Elektronika",
      "Fotografia",
      "Literatura i instrukcje"
    ],
    "hierarchy": "(124885) Elektronika / Fotografia / Literatura i instrukcje / Instrukcje obsługi",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Katalogi i foldery",
    "categoryPath": [
      "(124886) Elektronika",
      "Fotografia",
      "Literatura i instrukcje"
    ],
    "hierarchy": "(124886) Elektronika / Fotografia / Literatura i instrukcje / Katalogi i foldery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Podręczniki",
    "categoryPath": [
      "(124887) Elektronika",
      "Fotografia",
      "Literatura i instrukcje"
    ],
    "hierarchy": "(124887) Elektronika / Fotografia / Literatura i instrukcje / Podręczniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Obiektywy",
    "categoryPath": [
      "(258269) Elektronika",
      "Fotografia"
    ],
    "hierarchy": "(258269) Elektronika / Fotografia / Obiektywy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Fotoksiążki",
    "categoryPath": [
      "(258667) Elektronika",
      "Fotografia",
      "Odbitki"
    ],
    "hierarchy": "(258667) Elektronika / Fotografia / Odbitki / Fotoksiążki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zdjęcia",
    "categoryPath": [
      "(258668) Elektronika",
      "Fotografia",
      "Odbitki"
    ],
    "hierarchy": "(258668) Elektronika / Fotografia / Odbitki / Zdjęcia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255485) Elektronika",
      "Fotografia"
    ],
    "hierarchy": "(255485) Elektronika / Fotografia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przedmioty na sesje",
    "categoryPath": [
      "(255487) Elektronika",
      "Fotografia"
    ],
    "hierarchy": "(255487) Elektronika / Fotografia / Przedmioty na sesje",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Dalmierze",
    "categoryPath": [
      "(255502) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(255502) Elektronika / Fotografia / Sprzęt optyczny / Dalmierze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lornetki",
    "categoryPath": [
      "(124889) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(124889) Elektronika / Fotografia / Sprzęt optyczny / Lornetki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lunety obserwacyjne",
    "categoryPath": [
      "(255503) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(255503) Elektronika / Fotografia / Sprzęt optyczny / Lunety obserwacyjne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(124891) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(124891) Elektronika / Fotografia / Sprzęt optyczny / Lupy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mikroskopy",
    "categoryPath": [
      "(124892) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(124892) Elektronika / Fotografia / Sprzęt optyczny / Mikroskopy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Monokulary",
    "categoryPath": [
      "(255501) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(255501) Elektronika / Fotografia / Sprzęt optyczny / Monokulary",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Noktowizory",
    "categoryPath": [
      "(124893) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(124893) Elektronika / Fotografia / Sprzęt optyczny / Noktowizory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(124895) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(124895) Elektronika / Fotografia / Sprzęt optyczny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Teleskopy",
    "categoryPath": [
      "(124894) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(124894) Elektronika / Fotografia / Sprzęt optyczny / Teleskopy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Termowizory",
    "categoryPath": [
      "(322400) Elektronika",
      "Fotografia",
      "Sprzęt optyczny"
    ],
    "hierarchy": "(322400) Elektronika / Fotografia / Sprzęt optyczny / Termowizory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Fotografia 360 stopni",
    "categoryPath": [
      "(255498) Elektronika",
      "Fotografia",
      "Wyposażenie studia"
    ],
    "hierarchy": "(255498) Elektronika / Fotografia / Wyposażenie studia / Fotografia 360 stopni",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Blendy",
    "categoryPath": [
      "(148930) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(148930) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Blendy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modyfikatory światła",
    "categoryPath": [
      "(255500) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(255500) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Inne modyfikatory światła",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lampy błyskowe",
    "categoryPath": [
      "(148932) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(148932) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Lampy błyskowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Oświetlenie ciągłe",
    "categoryPath": [
      "(148933) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(148933) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Oświetlenie ciągłe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Oświetlenie plenerowe",
    "categoryPath": [
      "(255499) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(255499) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Oświetlenie plenerowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Parasolki",
    "categoryPath": [
      "(148931) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(148931) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Parasolki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Softboxy",
    "categoryPath": [
      "(148934) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(148934) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Softboxy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Uchwyty i mocowania",
    "categoryPath": [
      "(148936) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(148936) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Uchwyty i mocowania",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wyzwalacze",
    "categoryPath": [
      "(148937) Elektronika",
      "Fotografia",
      "Wyposażenie studia",
      "Oświetlenie"
    ],
    "hierarchy": "(148937) Elektronika / Fotografia / Wyposażenie studia / Oświetlenie / Wyzwalacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148929) Elektronika",
      "Fotografia",
      "Wyposażenie studia"
    ],
    "hierarchy": "(148929) Elektronika / Fotografia / Wyposażenie studia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sprzęt bezcieniowy",
    "categoryPath": [
      "(148925) Elektronika",
      "Fotografia",
      "Wyposażenie studia"
    ],
    "hierarchy": "(148925) Elektronika / Fotografia / Wyposażenie studia / Sprzęt bezcieniowy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Tła fotograficzne",
    "categoryPath": [
      "(148926) Elektronika",
      "Fotografia",
      "Wyposażenie studia"
    ],
    "hierarchy": "(148926) Elektronika / Fotografia / Wyposażenie studia / Tła fotograficzne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wycinarki do zdjęć",
    "categoryPath": [
      "(148927) Elektronika",
      "Fotografia",
      "Wyposażenie studia"
    ],
    "hierarchy": "(148927) Elektronika / Fotografia / Wyposażenie studia / Wycinarki do zdjęć",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(148928) Elektronika",
      "Fotografia",
      "Wyposażenie studia"
    ],
    "hierarchy": "(148928) Elektronika / Fotografia / Wyposażenie studia / Zestawy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Dedykowane",
    "categoryPath": [
      "(110679) Elektronika",
      "Fotografia",
      "Zasilanie aparatów",
      "Akumulatory"
    ],
    "hierarchy": "(110679) Elektronika / Fotografia / Zasilanie aparatów / Akumulatory / Dedykowane",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Windery i batterypacki",
    "categoryPath": [
      "(110675) Elektronika",
      "Fotografia",
      "Zasilanie aparatów"
    ],
    "hierarchy": "(110675) Elektronika / Fotografia / Zasilanie aparatów / Windery i batterypacki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(110674) Elektronika",
      "Fotografia",
      "Zasilanie aparatów"
    ],
    "hierarchy": "(110674) Elektronika / Fotografia / Zasilanie aparatów / Zasilacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(110673) Elektronika",
      "Fotografia",
      "Zasilanie aparatów"
    ],
    "hierarchy": "(110673) Elektronika / Fotografia / Zasilanie aparatów / Zestawy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(110676) Elektronika",
      "Fotografia",
      "Zasilanie aparatów"
    ],
    "hierarchy": "(110676) Elektronika / Fotografia / Zasilanie aparatów / Ładowarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lampki USB",
    "categoryPath": [
      "(77889) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Akcesoria"
    ],
    "hierarchy": "(77889) Elektronika / Komputery / Akcesoria (Laptop, PC) / Akcesoria / Lampki USB",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Linki zabezpieczające",
    "categoryPath": [
      "(320257) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Akcesoria"
    ],
    "hierarchy": "(320257) Elektronika / Komputery / Akcesoria (Laptop, PC) / Akcesoria / Linki zabezpieczające",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(77886) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Akcesoria"
    ],
    "hierarchy": "(77886) Elektronika / Komputery / Akcesoria (Laptop, PC) / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skórki na laptopa",
    "categoryPath": [
      "(77888) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Akcesoria"
    ],
    "hierarchy": "(77888) Elektronika / Komputery / Akcesoria (Laptop, PC) / Akcesoria / Skórki na laptopa",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasłonki na kamerę",
    "categoryPath": [
      "(320819) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Akcesoria"
    ],
    "hierarchy": "(320819) Elektronika / Komputery / Akcesoria (Laptop, PC) / Akcesoria / Zasłonki na kamerę",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Fotele gamingowe",
    "categoryPath": [
      "(257064) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(257064) Elektronika / Komputery / Akcesoria (Laptop, PC) / Fotele gamingowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "GSM",
    "categoryPath": [
      "(315585) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(315585) Elektronika / Komputery / Akcesoria (Laptop, PC) / GSM",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Audio",
    "categoryPath": [
      "(4721) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(4721) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / Audio",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "DVI",
    "categoryPath": [
      "(125343) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(125343) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / DVI",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "DisplayPort",
    "categoryPath": [
      "(125345) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(125345) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / DisplayPort",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "FireWire",
    "categoryPath": [
      "(4722) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(4722) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / FireWire",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "HDMI",
    "categoryPath": [
      "(125344) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(125344) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / HDMI",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "LPT",
    "categoryPath": [
      "(4723) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(4723) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / LPT",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "PS/2, DIN",
    "categoryPath": [
      "(9242) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(9242) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / PS/2, DIN",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4728) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(4728) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "SATA",
    "categoryPath": [
      "(27700) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(27700) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / SATA",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szeregowe RS",
    "categoryPath": [
      "(4725) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(4725) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / Szeregowe RS",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "A - B",
    "categoryPath": [
      "(48943) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze",
      "USB"
    ],
    "hierarchy": "(48943) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / USB / A - B",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "C",
    "categoryPath": [
      "(320944) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze",
      "USB"
    ],
    "hierarchy": "(320944) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / USB / C",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(48941) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze",
      "USB"
    ],
    "hierarchy": "(48941) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / USB / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przedłużacze",
    "categoryPath": [
      "(48942) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze",
      "USB"
    ],
    "hierarchy": "(48942) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / USB / Przedłużacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Video",
    "categoryPath": [
      "(4727) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze",
      "Kable i przedłużacze"
    ],
    "hierarchy": "(4727) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable i przedłużacze / Video",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kable zasilające",
    "categoryPath": [
      "(4718) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze"
    ],
    "hierarchy": "(4718) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Kable zasilające",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4720) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze"
    ],
    "hierarchy": "(4720) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przełączniki KVM",
    "categoryPath": [
      "(27748) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze"
    ],
    "hierarchy": "(27748) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Przełączniki KVM",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(260292) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Kable, taśmy, przedłużacze"
    ],
    "hierarchy": "(260292) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kable, taśmy, przedłużacze / Taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kamery internetowe",
    "categoryPath": [
      "(260021) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(260021) Elektronika / Komputery / Akcesoria (Laptop, PC) / Kamery internetowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Karty PCMCIA i ExpressCard",
    "categoryPath": [
      "(315586) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(315586) Elektronika / Komputery / Akcesoria (Laptop, PC) / Karty PCMCIA i ExpressCard",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Karty video",
    "categoryPath": [
      "(260045) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Karty i rejestratory video"
    ],
    "hierarchy": "(260045) Elektronika / Komputery / Akcesoria (Laptop, PC) / Karty i rejestratory video / Karty video",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Rejestratory i grabbery",
    "categoryPath": [
      "(260046) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Karty i rejestratory video"
    ],
    "hierarchy": "(260046) Elektronika / Komputery / Akcesoria (Laptop, PC) / Karty i rejestratory video / Rejestratory i grabbery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Karty miniPCI, miniPCIe",
    "categoryPath": [
      "(77770) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(77770) Elektronika / Komputery / Akcesoria (Laptop, PC) / Karty miniPCI, miniPCIe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Plomby i stickery",
    "categoryPath": [
      "(77755) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(77755) Elektronika / Komputery / Akcesoria (Laptop, PC) / Plomby i stickery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Podstawki chłodzące",
    "categoryPath": [
      "(77780) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(77780) Elektronika / Komputery / Akcesoria (Laptop, PC) / Podstawki chłodzące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Przejściówki",
    "categoryPath": [
      "(315587) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Przejściówki, śledzie"
    ],
    "hierarchy": "(315587) Elektronika / Komputery / Akcesoria (Laptop, PC) / Przejściówki, śledzie / Przejściówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Śledzie",
    "categoryPath": [
      "(315588) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Przejściówki, śledzie"
    ],
    "hierarchy": "(315588) Elektronika / Komputery / Akcesoria (Laptop, PC) / Przejściówki, śledzie / Śledzie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Przetwornice",
    "categoryPath": [
      "(125642) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(125642) Elektronika / Komputery / Akcesoria (Laptop, PC) / Przetwornice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stacje dokujące",
    "categoryPath": [
      "(77781) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(77781) Elektronika / Komputery / Akcesoria (Laptop, PC) / Stacje dokujące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stoliki pod laptopa",
    "categoryPath": [
      "(77885) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(77885) Elektronika / Komputery / Akcesoria (Laptop, PC) / Stoliki pod laptopa",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Plecaki",
    "categoryPath": [
      "(77783) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Torby, pokrowce"
    ],
    "hierarchy": "(77783) Elektronika / Komputery / Akcesoria (Laptop, PC) / Torby, pokrowce / Plecaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pokrowce i etui",
    "categoryPath": [
      "(77784) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Torby, pokrowce"
    ],
    "hierarchy": "(77784) Elektronika / Komputery / Akcesoria (Laptop, PC) / Torby, pokrowce / Pokrowce i etui",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Torby",
    "categoryPath": [
      "(77785) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Torby, pokrowce"
    ],
    "hierarchy": "(77785) Elektronika / Komputery / Akcesoria (Laptop, PC) / Torby, pokrowce / Torby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Tunery TV i SAT",
    "categoryPath": [
      "(260020) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(260020) Elektronika / Komputery / Akcesoria (Laptop, PC) / Tunery TV i SAT",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zestawy i kamery do wideokonferencji",
    "categoryPath": [
      "(260023) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)"
    ],
    "hierarchy": "(260023) Elektronika / Komputery / Akcesoria (Laptop, PC) / Zestawy i kamery do wideokonferencji",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pianki",
    "categoryPath": [
      "(77890) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Środki czyszczące"
    ],
    "hierarchy": "(77890) Elektronika / Komputery / Akcesoria (Laptop, PC) / Środki czyszczące / Pianki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Płyny",
    "categoryPath": [
      "(77891) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Środki czyszczące"
    ],
    "hierarchy": "(77891) Elektronika / Komputery / Akcesoria (Laptop, PC) / Środki czyszczące / Płyny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Sprężone powietrze",
    "categoryPath": [
      "(77893) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Środki czyszczące"
    ],
    "hierarchy": "(77893) Elektronika / Komputery / Akcesoria (Laptop, PC) / Środki czyszczące / Sprężone powietrze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(77894) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Środki czyszczące"
    ],
    "hierarchy": "(77894) Elektronika / Komputery / Akcesoria (Laptop, PC) / Środki czyszczące / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ściereczki",
    "categoryPath": [
      "(77892) Elektronika",
      "Komputery",
      "Akcesoria (Laptop, PC)",
      "Środki czyszczące"
    ],
    "hierarchy": "(77892) Elektronika / Komputery / Akcesoria (Laptop, PC) / Środki czyszczące / Ściereczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Baterie",
    "categoryPath": [
      "(147905) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(147905) Elektronika / Komputery / Części do laptopów / Baterie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Klawiatury",
    "categoryPath": [
      "(77803) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(77803) Elektronika / Komputery / Części do laptopów / Klawiatury",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Matryce",
    "categoryPath": [
      "(310033) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Matryce i części"
    ],
    "hierarchy": "(310033) Elektronika / Komputery / Części do laptopów / Matryce i części / Matryce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Taśmy i inwertery",
    "categoryPath": [
      "(77843) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Matryce i części"
    ],
    "hierarchy": "(77843) Elektronika / Komputery / Części do laptopów / Matryce i części / Taśmy i inwertery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Napędy",
    "categoryPath": [
      "(77805) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(77805) Elektronika / Komputery / Części do laptopów / Napędy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kadłubki",
    "categoryPath": [
      "(77854) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Obudowy i kadłubki"
    ],
    "hierarchy": "(77854) Elektronika / Komputery / Części do laptopów / Obudowy i kadłubki / Kadłubki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kieszenie i zaślepki",
    "categoryPath": [
      "(77855) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Obudowy i kadłubki"
    ],
    "hierarchy": "(77855) Elektronika / Komputery / Części do laptopów / Obudowy i kadłubki / Kieszenie i zaślepki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Klapy i ramki",
    "categoryPath": [
      "(77856) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Obudowy i kadłubki"
    ],
    "hierarchy": "(77856) Elektronika / Komputery / Części do laptopów / Obudowy i kadłubki / Klapy i ramki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(77857) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Obudowy i kadłubki"
    ],
    "hierarchy": "(77857) Elektronika / Komputery / Części do laptopów / Obudowy i kadłubki / Obudowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(77859) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Obudowy i kadłubki"
    ],
    "hierarchy": "(77859) Elektronika / Komputery / Części do laptopów / Obudowy i kadłubki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(77858) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Obudowy i kadłubki"
    ],
    "hierarchy": "(77858) Elektronika / Komputery / Części do laptopów / Obudowy i kadłubki / Zawiasy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pamięć RAM",
    "categoryPath": [
      "(77809) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(77809) Elektronika / Komputery / Części do laptopów / Pamięć RAM",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Chipy BGA",
    "categoryPath": [
      "(77877) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Pozostałe części"
    ],
    "hierarchy": "(77877) Elektronika / Komputery / Części do laptopów / Pozostałe części / Chipy BGA",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Gniazda zasilania",
    "categoryPath": [
      "(77881) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Pozostałe części"
    ],
    "hierarchy": "(77881) Elektronika / Komputery / Części do laptopów / Pozostałe części / Gniazda zasilania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(77880) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Pozostałe części"
    ],
    "hierarchy": "(77880) Elektronika / Komputery / Części do laptopów / Pozostałe części / Głośniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty graficzne",
    "categoryPath": [
      "(77879) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Pozostałe części"
    ],
    "hierarchy": "(77879) Elektronika / Komputery / Części do laptopów / Pozostałe części / Karty graficzne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Moduły Bluetooth",
    "categoryPath": [
      "(77878) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Pozostałe części"
    ],
    "hierarchy": "(77878) Elektronika / Komputery / Części do laptopów / Pozostałe części / Moduły Bluetooth",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(77883) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Pozostałe części"
    ],
    "hierarchy": "(77883) Elektronika / Komputery / Części do laptopów / Pozostałe części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(77882) Elektronika",
      "Komputery",
      "Części do laptopów",
      "Pozostałe części"
    ],
    "hierarchy": "(77882) Elektronika / Komputery / Części do laptopów / Pozostałe części / Taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Procesory",
    "categoryPath": [
      "(260288) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(260288) Elektronika / Komputery / Części do laptopów / Procesory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Płyty główne",
    "categoryPath": [
      "(260289) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(260289) Elektronika / Komputery / Części do laptopów / Płyty główne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wentylatory i radiatory",
    "categoryPath": [
      "(77810) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(77810) Elektronika / Komputery / Części do laptopów / Wentylatory i radiatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze do laptopów",
    "categoryPath": [
      "(147906) Elektronika",
      "Komputery",
      "Części do laptopów"
    ],
    "hierarchy": "(147906) Elektronika / Komputery / Części do laptopów / Zasilacze do laptopów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Materiały do regeneracji",
    "categoryPath": [
      "(123859) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Bębny"
    ],
    "hierarchy": "(123859) Elektronika / Komputery / Drukarki i skanery / Bębny / Materiały do regeneracji",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Oryginalne",
    "categoryPath": [
      "(260338) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Bębny"
    ],
    "hierarchy": "(260338) Elektronika / Komputery / Drukarki i skanery / Bębny / Oryginalne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zamienniki",
    "categoryPath": [
      "(260339) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Bębny"
    ],
    "hierarchy": "(260339) Elektronika / Komputery / Drukarki i skanery / Bębny / Zamienniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Moduły sieciowe",
    "categoryPath": [
      "(11890) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(11890) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Moduły sieciowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pamięć",
    "categoryPath": [
      "(11891) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(11891) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Pamięć",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Podajniki/Szuflady/Duplexy",
    "categoryPath": [
      "(63043) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(63043) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Podajniki/Szuflady/Duplexy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Postscript i czcionki",
    "categoryPath": [
      "(11892) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(11892) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Postscript i czcionki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(11895) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(11895) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(11893) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(11893) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Przełączniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Sortery i odbiorniki papieru",
    "categoryPath": [
      "(63044) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(63044) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Sortery i odbiorniki papieru",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(11894) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(11894) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Akcesoria / Zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Elementy grzewcze",
    "categoryPath": [
      "(11897) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Części"
    ],
    "hierarchy": "(11897) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Części / Elementy grzewcze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Elementy obudowy, podajniki",
    "categoryPath": [
      "(11898) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Części"
    ],
    "hierarchy": "(11898) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Części / Elementy obudowy, podajniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lasery, głowice, karetki",
    "categoryPath": [
      "(11899) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Części"
    ],
    "hierarchy": "(11899) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Części / Lasery, głowice, karetki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(11896) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Części"
    ],
    "hierarchy": "(11896) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rolki, prowadnice, zębatki",
    "categoryPath": [
      "(11900) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Części"
    ],
    "hierarchy": "(11900) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Części / Rolki, prowadnice, zębatki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Separatory",
    "categoryPath": [
      "(11901) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Części"
    ],
    "hierarchy": "(11901) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Części / Separatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Silniki, płyty",
    "categoryPath": [
      "(11902) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Części i akcesoria",
      "Części"
    ],
    "hierarchy": "(11902) Elektronika / Komputery / Drukarki i skanery / Części i akcesoria / Części / Silniki, płyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(322906) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Drukarki 3D"
    ],
    "hierarchy": "(322906) Elektronika / Komputery / Drukarki i skanery / Drukarki 3D / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(130505) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Drukarki 3D"
    ],
    "hierarchy": "(130505) Elektronika / Komputery / Drukarki i skanery / Drukarki 3D / Części",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Filamenty",
    "categoryPath": [
      "(130503) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Drukarki 3D"
    ],
    "hierarchy": "(130503) Elektronika / Komputery / Drukarki i skanery / Drukarki 3D / Filamenty",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(130504) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Drukarki 3D"
    ],
    "hierarchy": "(130504) Elektronika / Komputery / Drukarki i skanery / Drukarki 3D / Urządzenia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Żywice",
    "categoryPath": [
      "(303741) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Drukarki 3D"
    ],
    "hierarchy": "(303741) Elektronika / Komputery / Drukarki i skanery / Drukarki 3D / Żywice",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Drukarki atramentowe i laserowe",
    "categoryPath": [
      "(260347) Elektronika",
      "Komputery",
      "Drukarki i skanery"
    ],
    "hierarchy": "(260347) Elektronika / Komputery / Drukarki i skanery / Drukarki atramentowe i laserowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Drukarki igłowe",
    "categoryPath": [
      "(4582) Elektronika",
      "Komputery",
      "Drukarki i skanery"
    ],
    "hierarchy": "(4582) Elektronika / Komputery / Drukarki i skanery / Drukarki igłowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Drukarki inne",
    "categoryPath": [
      "(8634) Elektronika",
      "Komputery",
      "Drukarki i skanery"
    ],
    "hierarchy": "(8634) Elektronika / Komputery / Drukarki i skanery / Drukarki inne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Etykiety, naklejki",
    "categoryPath": [
      "(17255) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Papiery, folie"
    ],
    "hierarchy": "(17255) Elektronika / Komputery / Drukarki i skanery / Papiery, folie / Etykiety, naklejki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie, termotransfery",
    "categoryPath": [
      "(17254) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Papiery, folie"
    ],
    "hierarchy": "(17254) Elektronika / Komputery / Drukarki i skanery / Papiery, folie / Folie, termotransfery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Papier składany i w rolach",
    "categoryPath": [
      "(17256) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Papiery, folie"
    ],
    "hierarchy": "(17256) Elektronika / Komputery / Drukarki i skanery / Papiery, folie / Papier składany i w rolach",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Papiery Foto",
    "categoryPath": [
      "(17253) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Papiery, folie"
    ],
    "hierarchy": "(17253) Elektronika / Komputery / Drukarki i skanery / Papiery, folie / Papiery Foto",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Plotery",
    "categoryPath": [
      "(4586) Elektronika",
      "Komputery",
      "Drukarki i skanery"
    ],
    "hierarchy": "(4586) Elektronika / Komputery / Drukarki i skanery / Plotery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Do filmów",
    "categoryPath": [
      "(9494) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Skanery"
    ],
    "hierarchy": "(9494) Elektronika / Komputery / Drukarki i skanery / Skanery / Do filmów",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Profesjonalne",
    "categoryPath": [
      "(4624) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Skanery"
    ],
    "hierarchy": "(4624) Elektronika / Komputery / Drukarki i skanery / Skanery / Profesjonalne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Płaskie USB",
    "categoryPath": [
      "(260340) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Skanery"
    ],
    "hierarchy": "(260340) Elektronika / Komputery / Drukarki i skanery / Skanery / Płaskie USB",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Płaskie inne",
    "categoryPath": [
      "(9493) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Skanery"
    ],
    "hierarchy": "(9493) Elektronika / Komputery / Drukarki i skanery / Skanery / Płaskie inne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Ręczne",
    "categoryPath": [
      "(310169) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Skanery"
    ],
    "hierarchy": "(310169) Elektronika / Komputery / Drukarki i skanery / Skanery / Ręczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Oryginalne",
    "categoryPath": [
      "(4607) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Taśmy barwiące"
    ],
    "hierarchy": "(4607) Elektronika / Komputery / Drukarki i skanery / Taśmy barwiące / Oryginalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zamienniki",
    "categoryPath": [
      "(4608) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Taśmy barwiące"
    ],
    "hierarchy": "(4608) Elektronika / Komputery / Drukarki i skanery / Taśmy barwiące / Zamienniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Materiały do regeneracji",
    "categoryPath": [
      "(260344) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tonery"
    ],
    "hierarchy": "(260344) Elektronika / Komputery / Drukarki i skanery / Tonery / Materiały do regeneracji",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Oryginalne",
    "categoryPath": [
      "(260341) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tonery"
    ],
    "hierarchy": "(260341) Elektronika / Komputery / Drukarki i skanery / Tonery / Oryginalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Proszki do napełniania",
    "categoryPath": [
      "(260343) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tonery"
    ],
    "hierarchy": "(260343) Elektronika / Komputery / Drukarki i skanery / Tonery / Proszki do napełniania",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Puste tonery",
    "categoryPath": [
      "(123872) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tonery"
    ],
    "hierarchy": "(123872) Elektronika / Komputery / Drukarki i skanery / Tonery / Puste tonery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zamienniki",
    "categoryPath": [
      "(260342) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tonery"
    ],
    "hierarchy": "(260342) Elektronika / Komputery / Drukarki i skanery / Tonery / Zamienniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Akcesoria do regeneracji",
    "categoryPath": [
      "(9112) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tusze"
    ],
    "hierarchy": "(9112) Elektronika / Komputery / Drukarki i skanery / Tusze / Akcesoria do regeneracji",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Oryginalne",
    "categoryPath": [
      "(260345) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tusze"
    ],
    "hierarchy": "(260345) Elektronika / Komputery / Drukarki i skanery / Tusze / Oryginalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Puste cartridge",
    "categoryPath": [
      "(9113) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tusze"
    ],
    "hierarchy": "(9113) Elektronika / Komputery / Drukarki i skanery / Tusze / Puste cartridge",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Tusze w butlach",
    "categoryPath": [
      "(9114) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tusze"
    ],
    "hierarchy": "(9114) Elektronika / Komputery / Drukarki i skanery / Tusze / Tusze w butlach",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zamienniki",
    "categoryPath": [
      "(260346) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tusze"
    ],
    "hierarchy": "(260346) Elektronika / Komputery / Drukarki i skanery / Tusze / Zamienniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy regeneracyjne",
    "categoryPath": [
      "(260348) Elektronika",
      "Komputery",
      "Drukarki i skanery",
      "Tusze"
    ],
    "hierarchy": "(260348) Elektronika / Komputery / Drukarki i skanery / Tusze / Zestawy regeneracyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Dyski HDD",
    "categoryPath": [
      "(4476) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne"
    ],
    "hierarchy": "(4476) Elektronika / Komputery / Dyski i pamięci przenośne / Dyski HDD",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Dyski SSD",
    "categoryPath": [
      "(257335) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne"
    ],
    "hierarchy": "(257335) Elektronika / Komputery / Dyski i pamięci przenośne / Dyski SSD",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Dyski zewnętrzne i przenośne",
    "categoryPath": [
      "(77939) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne"
    ],
    "hierarchy": "(77939) Elektronika / Komputery / Dyski i pamięci przenośne / Dyski zewnętrzne i przenośne",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Klucze sprzętowe",
    "categoryPath": [
      "(322384) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne"
    ],
    "hierarchy": "(322384) Elektronika / Komputery / Dyski i pamięci przenośne / Klucze sprzętowe",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Adaptery IDE/SATA",
    "categoryPath": [
      "(45940) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Obudowy i kieszenie"
    ],
    "hierarchy": "(45940) Elektronika / Komputery / Dyski i pamięci przenośne / Obudowy i kieszenie / Adaptery IDE/SATA",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kieszenie",
    "categoryPath": [
      "(4541) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Obudowy i kieszenie"
    ],
    "hierarchy": "(4541) Elektronika / Komputery / Dyski i pamięci przenośne / Obudowy i kieszenie / Kieszenie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy CD, CD-R, DVD",
    "categoryPath": [
      "(6133) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Obudowy i kieszenie"
    ],
    "hierarchy": "(6133) Elektronika / Komputery / Dyski i pamięci przenośne / Obudowy i kieszenie / Obudowy CD, CD-R, DVD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy dysków 2,5\"",
    "categoryPath": [
      "(77937) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Obudowy i kieszenie"
    ],
    "hierarchy": "(77937) Elektronika / Komputery / Dyski i pamięci przenośne / Obudowy i kieszenie / Obudowy dysków 2,5\"",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy dysków 3,5\"",
    "categoryPath": [
      "(6134) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Obudowy i kieszenie"
    ],
    "hierarchy": "(6134) Elektronika / Komputery / Dyski i pamięci przenośne / Obudowy i kieszenie / Obudowy dysków 3,5\"",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ramki i sanki",
    "categoryPath": [
      "(4543) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Obudowy i kieszenie"
    ],
    "hierarchy": "(4543) Elektronika / Komputery / Dyski i pamięci przenośne / Obudowy i kieszenie / Ramki i sanki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stacje dokujące",
    "categoryPath": [
      "(124122) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Obudowy i kieszenie"
    ],
    "hierarchy": "(124122) Elektronika / Komputery / Dyski i pamięci przenośne / Obudowy i kieszenie / Stacje dokujące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pendrive",
    "categoryPath": [
      "(257960) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Pamięci przenośne"
    ],
    "hierarchy": "(257960) Elektronika / Komputery / Dyski i pamięci przenośne / Pamięci przenośne / Pendrive",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Pokrowce i etui",
    "categoryPath": [
      "(48891) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne",
      "Pamięci przenośne"
    ],
    "hierarchy": "(48891) Elektronika / Komputery / Dyski i pamięci przenośne / Pamięci przenośne / Pokrowce i etui",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4485) Elektronika",
      "Komputery",
      "Dyski i pamięci przenośne"
    ],
    "hierarchy": "(4485) Elektronika / Komputery / Dyski i pamięci przenośne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(259434) Elektronika",
      "Komputery"
    ],
    "hierarchy": "(259434) Elektronika / Komputery / Głośniki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Domeny",
    "categoryPath": [
      "(260287) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(260287) Elektronika / Komputery / Internet / Domeny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Linki",
    "categoryPath": [
      "(17244) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(17244) Elektronika / Komputery / Internet / Linki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(15827) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(15827) Elektronika / Komputery / Internet / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reklamy i bannery",
    "categoryPath": [
      "(17247) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(17247) Elektronika / Komputery / Internet / Reklamy i bannery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Serwisy hostingowe",
    "categoryPath": [
      "(77949) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(77949) Elektronika / Komputery / Internet / Serwisy hostingowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Serwisy internetowe",
    "categoryPath": [
      "(15825) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(15825) Elektronika / Komputery / Internet / Serwisy internetowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Skrypty",
    "categoryPath": [
      "(48879) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(48879) Elektronika / Komputery / Internet / Skrypty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szablony",
    "categoryPath": [
      "(17246) Elektronika",
      "Komputery",
      "Internet"
    ],
    "hierarchy": "(17246) Elektronika / Komputery / Internet / Szablony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Komputery stacjonarne",
    "categoryPath": [
      "(486) Elektronika",
      "Komputery"
    ],
    "hierarchy": "(486) Elektronika / Komputery / Komputery stacjonarne",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(259441) Elektronika",
      "Komputery",
      "Kryptowaluty"
    ],
    "hierarchy": "(259441) Elektronika / Komputery / Kryptowaluty / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Koparki",
    "categoryPath": [
      "(259439) Elektronika",
      "Komputery",
      "Kryptowaluty"
    ],
    "hierarchy": "(259439) Elektronika / Komputery / Kryptowaluty / Koparki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(259440) Elektronika",
      "Komputery",
      "Kryptowaluty"
    ],
    "hierarchy": "(259440) Elektronika / Komputery / Kryptowaluty / Obudowy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Acer",
    "categoryPath": [
      "(77914) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77914) Elektronika / Komputery / Laptopy / Acer",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Apple",
    "categoryPath": [
      "(77915) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77915) Elektronika / Komputery / Laptopy / Apple",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Asus",
    "categoryPath": [
      "(77916) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77916) Elektronika / Komputery / Laptopy / Asus",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Chuwi",
    "categoryPath": [
      "(321643) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(321643) Elektronika / Komputery / Laptopy / Chuwi",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Dell",
    "categoryPath": [
      "(77917) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77917) Elektronika / Komputery / Laptopy / Dell",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Dream Machines",
    "categoryPath": [
      "(322547) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(322547) Elektronika / Komputery / Laptopy / Dream Machines",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Fujitsu",
    "categoryPath": [
      "(77918) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77918) Elektronika / Komputery / Laptopy / Fujitsu",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Gigabyte",
    "categoryPath": [
      "(322347) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(322347) Elektronika / Komputery / Laptopy / Gigabyte",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "HP, Compaq",
    "categoryPath": [
      "(77919) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77919) Elektronika / Komputery / Laptopy / HP, Compaq",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Huawei",
    "categoryPath": [
      "(257180) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(257180) Elektronika / Komputery / Laptopy / Huawei",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Hyperbook",
    "categoryPath": [
      "(319099) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(319099) Elektronika / Komputery / Laptopy / Hyperbook",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "IBM, Lenovo",
    "categoryPath": [
      "(77920) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77920) Elektronika / Komputery / Laptopy / IBM, Lenovo",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Inne marki",
    "categoryPath": [
      "(315455) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(315455) Elektronika / Komputery / Laptopy / Inne marki",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Kiano",
    "categoryPath": [
      "(258398) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(258398) Elektronika / Komputery / Laptopy / Kiano",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Kruger&Matz",
    "categoryPath": [
      "(315410) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(315410) Elektronika / Komputery / Laptopy / Kruger&Matz",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "MSI",
    "categoryPath": [
      "(77921) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77921) Elektronika / Komputery / Laptopy / MSI",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Maibenben",
    "categoryPath": [
      "(316010) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(316010) Elektronika / Komputery / Laptopy / Maibenben",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Medion",
    "categoryPath": [
      "(257162) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(257162) Elektronika / Komputery / Laptopy / Medion",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Microsoft",
    "categoryPath": [
      "(257723) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(257723) Elektronika / Komputery / Laptopy / Microsoft",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Razer",
    "categoryPath": [
      "(322980) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(322980) Elektronika / Komputery / Laptopy / Razer",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Samsung",
    "categoryPath": [
      "(77922) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77922) Elektronika / Komputery / Laptopy / Samsung",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Sony",
    "categoryPath": [
      "(77923) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77923) Elektronika / Komputery / Laptopy / Sony",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Toshiba, Dynabook",
    "categoryPath": [
      "(77924) Elektronika",
      "Komputery",
      "Laptopy"
    ],
    "hierarchy": "(77924) Elektronika / Komputery / Laptopy / Toshiba, Dynabook",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Listwy, filtry sieciowe",
    "categoryPath": [
      "(4553) Elektronika",
      "Komputery",
      "Listwy zasilające i UPS"
    ],
    "hierarchy": "(4553) Elektronika / Komputery / Listwy zasilające i UPS / Listwy, filtry sieciowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(19167) Elektronika",
      "Komputery",
      "Listwy zasilające i UPS",
      "UPS"
    ],
    "hierarchy": "(19167) Elektronika / Komputery / Listwy zasilające i UPS / UPS / Akumulatory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zasilacze awaryjne",
    "categoryPath": [
      "(19166) Elektronika",
      "Komputery",
      "Listwy zasilające i UPS",
      "UPS"
    ],
    "hierarchy": "(19166) Elektronika / Komputery / Listwy zasilające i UPS / UPS / Zasilacze awaryjne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Mikrofony",
    "categoryPath": [
      "(259425) Elektronika",
      "Komputery",
      "Mikrofony i słuchawki"
    ],
    "hierarchy": "(259425) Elektronika / Komputery / Mikrofony i słuchawki / Mikrofony",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Słuchawki bezprzewodowe",
    "categoryPath": [
      "(259426) Elektronika",
      "Komputery",
      "Mikrofony i słuchawki"
    ],
    "hierarchy": "(259426) Elektronika / Komputery / Mikrofony i słuchawki / Słuchawki bezprzewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Słuchawki przewodowe",
    "categoryPath": [
      "(259427) Elektronika",
      "Komputery",
      "Mikrofony i słuchawki"
    ],
    "hierarchy": "(259427) Elektronika / Komputery / Mikrofony i słuchawki / Słuchawki przewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(254503) Elektronika",
      "Komputery",
      "Mikrokomputery",
      "Arduino"
    ],
    "hierarchy": "(254503) Elektronika / Komputery / Mikrokomputery / Arduino / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Komputery",
    "categoryPath": [
      "(254502) Elektronika",
      "Komputery",
      "Mikrokomputery",
      "Arduino"
    ],
    "hierarchy": "(254502) Elektronika / Komputery / Mikrokomputery / Arduino / Komputery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HDMI Stick",
    "categoryPath": [
      "(254501) Elektronika",
      "Komputery",
      "Mikrokomputery"
    ],
    "hierarchy": "(254501) Elektronika / Komputery / Mikrokomputery / HDMI Stick",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254506) Elektronika",
      "Komputery",
      "Mikrokomputery"
    ],
    "hierarchy": "(254506) Elektronika / Komputery / Mikrokomputery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(254504) Elektronika",
      "Komputery",
      "Mikrokomputery",
      "Raspberry Pi"
    ],
    "hierarchy": "(254504) Elektronika / Komputery / Mikrokomputery / Raspberry Pi / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Komputery",
    "categoryPath": [
      "(254505) Elektronika",
      "Komputery",
      "Mikrokomputery",
      "Raspberry Pi"
    ],
    "hierarchy": "(254505) Elektronika / Komputery / Mikrokomputery / Raspberry Pi / Komputery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(260050) Elektronika",
      "Komputery",
      "Monitory komputerowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(260050) Elektronika / Komputery / Monitory komputerowe / Części i akcesoria / Części",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Matryce LCD",
    "categoryPath": [
      "(260051) Elektronika",
      "Komputery",
      "Monitory komputerowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(260051) Elektronika / Komputery / Monitory komputerowe / Części i akcesoria / Matryce LCD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Podstawki i półki",
    "categoryPath": [
      "(260052) Elektronika",
      "Komputery",
      "Monitory komputerowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(260052) Elektronika / Komputery / Monitory komputerowe / Części i akcesoria / Podstawki i półki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260056) Elektronika",
      "Komputery",
      "Monitory komputerowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(260056) Elektronika / Komputery / Monitory komputerowe / Części i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rozgałęziacze sygnału",
    "categoryPath": [
      "(260053) Elektronika",
      "Komputery",
      "Monitory komputerowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(260053) Elektronika / Komputery / Monitory komputerowe / Części i akcesoria / Rozgałęziacze sygnału",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(260054) Elektronika",
      "Komputery",
      "Monitory komputerowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(260054) Elektronika / Komputery / Monitory komputerowe / Części i akcesoria / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze LCD",
    "categoryPath": [
      "(260055) Elektronika",
      "Komputery",
      "Monitory komputerowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(260055) Elektronika / Komputery / Monitory komputerowe / Części i akcesoria / Zasilacze LCD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Monitory",
    "categoryPath": [
      "(260041) Elektronika",
      "Komputery",
      "Monitory komputerowe"
    ],
    "hierarchy": "(260041) Elektronika / Komputery / Monitory komputerowe / Monitory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nagrywarki i napędy",
    "categoryPath": [
      "(257526) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki"
    ],
    "hierarchy": "(257526) Elektronika / Komputery / Napędy optyczne i nośniki / Nagrywarki i napędy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Napędy dyskietek",
    "categoryPath": [
      "(257262) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki"
    ],
    "hierarchy": "(257262) Elektronika / Komputery / Napędy optyczne i nośniki / Napędy dyskietek",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Etui i albumy",
    "categoryPath": [
      "(259412) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259412) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Etui i albumy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Etykiety na płyty",
    "categoryPath": [
      "(259418) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259418) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Etykiety na płyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Koperty",
    "categoryPath": [
      "(259413) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259413) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Koperty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kufry",
    "categoryPath": [
      "(259414) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259414) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Kufry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Markery do płyt",
    "categoryPath": [
      "(259419) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259419) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Markery do płyt",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pudełka",
    "categoryPath": [
      "(259415) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259415) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Pudełka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Segregatory",
    "categoryPath": [
      "(259416) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259416) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Segregatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stojaki i półki",
    "categoryPath": [
      "(259417) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki",
      "Akcesoria"
    ],
    "hierarchy": "(259417) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Akcesoria / Stojaki i półki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Blu-ray",
    "categoryPath": [
      "(257291) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki"
    ],
    "hierarchy": "(257291) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Blu-ray",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "CD",
    "categoryPath": [
      "(257287) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki"
    ],
    "hierarchy": "(257287) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / CD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "DVD",
    "categoryPath": [
      "(257289) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki"
    ],
    "hierarchy": "(257289) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / DVD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Dyskietki",
    "categoryPath": [
      "(257293) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki"
    ],
    "hierarchy": "(257293) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Dyskietki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257294) Elektronika",
      "Komputery",
      "Napędy optyczne i nośniki",
      "Nośniki"
    ],
    "hierarchy": "(257294) Elektronika / Komputery / Napędy optyczne i nośniki / Nośniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Antywirusy i bezpieczeństwo",
    "categoryPath": [
      "(258224) Elektronika",
      "Komputery",
      "Oprogramowanie"
    ],
    "hierarchy": "(258224) Elektronika / Komputery / Oprogramowanie / Antywirusy i bezpieczeństwo",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pakiety biurowe",
    "categoryPath": [
      "(4632) Elektronika",
      "Komputery",
      "Oprogramowanie",
      "Biuro i zarządzanie firmą"
    ],
    "hierarchy": "(4632) Elektronika / Komputery / Oprogramowanie / Biuro i zarządzanie firmą / Pakiety biurowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zarządzanie firmą",
    "categoryPath": [
      "(4633) Elektronika",
      "Komputery",
      "Oprogramowanie",
      "Biuro i zarządzanie firmą"
    ],
    "hierarchy": "(4633) Elektronika / Komputery / Oprogramowanie / Biuro i zarządzanie firmą / Zarządzanie firmą",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Grafika i multimedia",
    "categoryPath": [
      "(258233) Elektronika",
      "Komputery",
      "Oprogramowanie"
    ],
    "hierarchy": "(258233) Elektronika / Komputery / Oprogramowanie / Grafika i multimedia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Nauka i edukacja",
    "categoryPath": [
      "(74) Elektronika",
      "Komputery",
      "Oprogramowanie"
    ],
    "hierarchy": "(74) Elektronika / Komputery / Oprogramowanie / Nauka i edukacja",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(75) Elektronika",
      "Komputery",
      "Oprogramowanie"
    ],
    "hierarchy": "(75) Elektronika / Komputery / Oprogramowanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Linux",
    "categoryPath": [
      "(258230) Elektronika",
      "Komputery",
      "Oprogramowanie",
      "Systemy operacyjne"
    ],
    "hierarchy": "(258230) Elektronika / Komputery / Oprogramowanie / Systemy operacyjne / Linux",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "MacOS",
    "categoryPath": [
      "(258231) Elektronika",
      "Komputery",
      "Oprogramowanie",
      "Systemy operacyjne"
    ],
    "hierarchy": "(258231) Elektronika / Komputery / Oprogramowanie / Systemy operacyjne / MacOS",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Microsoft",
    "categoryPath": [
      "(258229) Elektronika",
      "Komputery",
      "Oprogramowanie",
      "Systemy operacyjne"
    ],
    "hierarchy": "(258229) Elektronika / Komputery / Oprogramowanie / Systemy operacyjne / Microsoft",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Chłodzenie kart graficznych",
    "categoryPath": [
      "(260026) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260026) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie kart graficznych",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Chłodzenie procesorów",
    "categoryPath": [
      "(260029) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260029) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie procesorów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Bloki wodne",
    "categoryPath": [
      "(260845) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning",
      "Chłodzenie wodne"
    ],
    "hierarchy": "(260845) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie wodne / Bloki wodne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Chłodnice",
    "categoryPath": [
      "(260848) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning",
      "Chłodzenie wodne"
    ],
    "hierarchy": "(260848) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie wodne / Chłodnice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pompy i rezerwuary",
    "categoryPath": [
      "(260849) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning",
      "Chłodzenie wodne"
    ],
    "hierarchy": "(260849) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie wodne / Pompy i rezerwuary",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260048) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning",
      "Chłodzenie wodne"
    ],
    "hierarchy": "(260048) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie wodne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płyny i koncentraty",
    "categoryPath": [
      "(260846) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning",
      "Chłodzenie wodne"
    ],
    "hierarchy": "(260846) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie wodne / Płyny i koncentraty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(260049) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning",
      "Chłodzenie wodne"
    ],
    "hierarchy": "(260049) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie wodne / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złączki, zawory i wężyki",
    "categoryPath": [
      "(260847) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning",
      "Chłodzenie wodne"
    ],
    "hierarchy": "(260847) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Chłodzenie wodne / Złączki, zawory i wężyki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Elementy oświetleniowe",
    "categoryPath": [
      "(260031) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260031) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Elementy oświetleniowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Grile i maskownice",
    "categoryPath": [
      "(260032) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260032) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Grile i maskownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kołki i zatrzaski",
    "categoryPath": [
      "(260844) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260844) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Kołki i zatrzaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Maty wygłuszające i tłumiki",
    "categoryPath": [
      "(260033) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260033) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Maty wygłuszające i tłumiki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Naklejki",
    "categoryPath": [
      "(260034) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260034) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Naklejki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ogniwa peltiera",
    "categoryPath": [
      "(260035) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260035) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Ogniwa peltiera",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Panele i czytniki",
    "categoryPath": [
      "(260036) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260036) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Panele i czytniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pasty i taśmy termoprzewodzące",
    "categoryPath": [
      "(260037) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260037) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Pasty i taśmy termoprzewodzące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260016) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260016) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Radiatory",
    "categoryPath": [
      "(260038) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260038) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Radiatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Regulatory obrotów i alarmy",
    "categoryPath": [
      "(260039) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260039) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Regulatory obrotów i alarmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(260040) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Chłodzenie i tuning"
    ],
    "hierarchy": "(260040) Elektronika / Komputery / Podzespoły komputerowe / Chłodzenie i tuning / Wentylatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty graficzne",
    "categoryPath": [
      "(260019) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(260019) Elektronika / Komputery / Podzespoły komputerowe / Karty graficzne",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Karty muzyczne",
    "categoryPath": [
      "(259435) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(259435) Elektronika / Komputery / Podzespoły komputerowe / Karty muzyczne",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Kontrolery komputerowe",
    "categoryPath": [
      "(311033) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(311033) Elektronika / Komputery / Podzespoły komputerowe / Kontrolery komputerowe",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(259436) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(259436) Elektronika / Komputery / Podzespoły komputerowe / Obudowy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pamięć RAM",
    "categoryPath": [
      "(257226) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(257226) Elektronika / Komputery / Podzespoły komputerowe / Pamięć RAM",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Procesory",
    "categoryPath": [
      "(257222) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(257222) Elektronika / Komputery / Podzespoły komputerowe / Procesory",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Płyty główne",
    "categoryPath": [
      "(4228) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(4228) Elektronika / Komputery / Podzespoły komputerowe / Płyty główne",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Karty diagnostyczne",
    "categoryPath": [
      "(4308) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Sprzęt serwisowy"
    ],
    "hierarchy": "(4308) Elektronika / Komputery / Podzespoły komputerowe / Sprzęt serwisowy / Karty diagnostyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kondensatory do płyt głównych",
    "categoryPath": [
      "(27746) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Sprzęt serwisowy"
    ],
    "hierarchy": "(27746) Elektronika / Komputery / Podzespoły komputerowe / Sprzęt serwisowy / Kondensatory do płyt głównych",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kości BIOS i Cache",
    "categoryPath": [
      "(4309) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Sprzęt serwisowy"
    ],
    "hierarchy": "(4309) Elektronika / Komputery / Podzespoły komputerowe / Sprzęt serwisowy / Kości BIOS i Cache",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4311) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Sprzęt serwisowy"
    ],
    "hierarchy": "(4311) Elektronika / Komputery / Podzespoły komputerowe / Sprzęt serwisowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Testery monitorów",
    "categoryPath": [
      "(4310) Elektronika",
      "Komputery",
      "Podzespoły komputerowe",
      "Sprzęt serwisowy"
    ],
    "hierarchy": "(4310) Elektronika / Komputery / Podzespoły komputerowe / Sprzęt serwisowy / Testery monitorów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(259437) Elektronika",
      "Komputery",
      "Podzespoły komputerowe"
    ],
    "hierarchy": "(259437) Elektronika / Komputery / Podzespoły komputerowe / Zasilacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(315899) Elektronika",
      "Komputery"
    ],
    "hierarchy": "(315899) Elektronika / Komputery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kable i taśmy",
    "categoryPath": [
      "(9082) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(9082) Elektronika / Komputery / Serwery i akcesoria / Akcesoria / Kable i taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(258815) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(258815) Elektronika / Komputery / Serwery i akcesoria / Akcesoria / Obudowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(9085) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(9085) Elektronika / Komputery / Serwery i akcesoria / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ramki i kieszenie",
    "categoryPath": [
      "(258814) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(258814) Elektronika / Komputery / Serwery i akcesoria / Akcesoria / Ramki i kieszenie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szyny montażowe",
    "categoryPath": [
      "(258813) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(258813) Elektronika / Komputery / Serwery i akcesoria / Akcesoria / Szyny montażowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Macierze",
    "categoryPath": [
      "(261323) Elektronika",
      "Komputery",
      "Serwery i akcesoria"
    ],
    "hierarchy": "(261323) Elektronika / Komputery / Serwery i akcesoria / Macierze",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Radiatory",
    "categoryPath": [
      "(317426) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe",
      "Chłodzenie"
    ],
    "hierarchy": "(317426) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Chłodzenie / Radiatory",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(317429) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe",
      "Chłodzenie"
    ],
    "hierarchy": "(317429) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Chłodzenie / Wentylatory",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Dyski",
    "categoryPath": [
      "(260286) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(260286) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Dyski",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Kontrolery serwerowe",
    "categoryPath": [
      "(258811) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(258811) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Kontrolery serwerowe",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Pamięć RAM",
    "categoryPath": [
      "(125346) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(125346) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Pamięć RAM",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(9071) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(9071) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Procesory",
    "categoryPath": [
      "(9065) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(9065) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Procesory",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Płyty główne",
    "categoryPath": [
      "(9066) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(9066) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Płyty główne",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Streamery",
    "categoryPath": [
      "(9069) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(9069) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Streamery",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(258812) Elektronika",
      "Komputery",
      "Serwery i akcesoria",
      "Podzespoły serwerowe"
    ],
    "hierarchy": "(258812) Elektronika / Komputery / Serwery i akcesoria / Podzespoły serwerowe / Zasilacze",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Serwery",
    "categoryPath": [
      "(258709) Elektronika",
      "Komputery",
      "Serwery i akcesoria"
    ],
    "hierarchy": "(258709) Elektronika / Komputery / Serwery i akcesoria / Serwery",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Komputery",
    "categoryPath": [
      "(77932) Elektronika",
      "Komputery",
      "Stare komputery",
      "Amiga"
    ],
    "hierarchy": "(77932) Elektronika / Komputery / Stare komputery / Amiga / Komputery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(77935) Elektronika",
      "Komputery",
      "Stare komputery",
      "Amiga"
    ],
    "hierarchy": "(77935) Elektronika / Komputery / Stare komputery / Amiga / Literatura",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Oprogramowanie",
    "categoryPath": [
      "(77933) Elektronika",
      "Komputery",
      "Stare komputery",
      "Amiga"
    ],
    "hierarchy": "(77933) Elektronika / Komputery / Stare komputery / Amiga / Oprogramowanie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Osprzęt",
    "categoryPath": [
      "(77934) Elektronika",
      "Komputery",
      "Stare komputery",
      "Amiga"
    ],
    "hierarchy": "(77934) Elektronika / Komputery / Stare komputery / Amiga / Osprzęt",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Apple",
    "categoryPath": [
      "(252024) Elektronika",
      "Komputery",
      "Stare komputery"
    ],
    "hierarchy": "(252024) Elektronika / Komputery / Stare komputery / Apple",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Atari",
    "categoryPath": [
      "(77929) Elektronika",
      "Komputery",
      "Stare komputery"
    ],
    "hierarchy": "(77929) Elektronika / Komputery / Stare komputery / Atari",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Commodore",
    "categoryPath": [
      "(77930) Elektronika",
      "Komputery",
      "Stare komputery"
    ],
    "hierarchy": "(77930) Elektronika / Komputery / Stare komputery / Commodore",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(77927) Elektronika",
      "Komputery",
      "Stare komputery"
    ],
    "hierarchy": "(77927) Elektronika / Komputery / Stare komputery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spectrum",
    "categoryPath": [
      "(77931) Elektronika",
      "Komputery",
      "Stare komputery"
    ],
    "hierarchy": "(77931) Elektronika / Komputery / Stare komputery / Spectrum",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(310513) Elektronika",
      "Komputery",
      "Tablety"
    ],
    "hierarchy": "(310513) Elektronika / Komputery / Tablety / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Części serwisowe",
    "categoryPath": [
      "(123642) Elektronika",
      "Komputery",
      "Tablety"
    ],
    "hierarchy": "(123642) Elektronika / Komputery / Tablety / Części serwisowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(260660) Elektronika",
      "Komputery",
      "Tablety"
    ],
    "hierarchy": "(260660) Elektronika / Komputery / Tablety / Urządzenia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(260044) Elektronika",
      "Komputery",
      "Urządzenia VR"
    ],
    "hierarchy": "(260044) Elektronika / Komputery / Urządzenia VR / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Gogle VR",
    "categoryPath": [
      "(260043) Elektronika",
      "Komputery",
      "Urządzenia VR"
    ],
    "hierarchy": "(260043) Elektronika / Komputery / Urządzenia VR / Gogle VR",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne kable",
    "categoryPath": [
      "(63055) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria",
      "Kable"
    ],
    "hierarchy": "(63055) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Kable / Inne kable",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konektory i kable antenowe",
    "categoryPath": [
      "(77950) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria",
      "Kable"
    ],
    "hierarchy": "(77950) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Kable / Konektory i kable antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Patchcord",
    "categoryPath": [
      "(63052) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria",
      "Kable"
    ],
    "hierarchy": "(63052) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Kable / Patchcord",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Skrętka",
    "categoryPath": [
      "(63051) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria",
      "Kable"
    ],
    "hierarchy": "(63051) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Kable / Skrętka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4446) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria"
    ],
    "hierarchy": "(4446) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szafy",
    "categoryPath": [
      "(71708) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria"
    ],
    "hierarchy": "(71708) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Szafy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Testery sieci",
    "categoryPath": [
      "(4443) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria"
    ],
    "hierarchy": "(4443) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Testery sieci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wtyki, trójniki, końcówki",
    "categoryPath": [
      "(260738) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria"
    ],
    "hierarchy": "(260738) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Wtyki, trójniki, końcówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zaciskarki",
    "categoryPath": [
      "(4445) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria"
    ],
    "hierarchy": "(4445) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Zaciskarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Światłowody",
    "categoryPath": [
      "(4442) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Akcesoria"
    ],
    "hierarchy": "(4442) Elektronika / Komputery / Urządzenia sieciowe / Akcesoria / Światłowody",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Dookólne",
    "categoryPath": [
      "(77958) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Anteny"
    ],
    "hierarchy": "(77958) Elektronika / Komputery / Urządzenia sieciowe / Anteny / Dookólne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Helikalne i Yagi",
    "categoryPath": [
      "(77959) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Anteny"
    ],
    "hierarchy": "(77959) Elektronika / Komputery / Urządzenia sieciowe / Anteny / Helikalne i Yagi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Panelowe",
    "categoryPath": [
      "(77960) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Anteny"
    ],
    "hierarchy": "(77960) Elektronika / Komputery / Urządzenia sieciowe / Anteny / Panelowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Paraboliczne",
    "categoryPath": [
      "(77961) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Anteny"
    ],
    "hierarchy": "(77961) Elektronika / Komputery / Urządzenia sieciowe / Anteny / Paraboliczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(77957) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Anteny"
    ],
    "hierarchy": "(77957) Elektronika / Komputery / Urządzenia sieciowe / Anteny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szczelinowe",
    "categoryPath": [
      "(77962) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Anteny"
    ],
    "hierarchy": "(77962) Elektronika / Komputery / Urządzenia sieciowe / Anteny / Szczelinowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty i obejmy",
    "categoryPath": [
      "(77963) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Anteny"
    ],
    "hierarchy": "(77963) Elektronika / Komputery / Urządzenia sieciowe / Anteny / Uchwyty i obejmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Bluetooth",
    "categoryPath": [
      "(10855) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(10855) Elektronika / Komputery / Urządzenia sieciowe / Bluetooth",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Huby USB",
    "categoryPath": [
      "(4421) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(4421) Elektronika / Komputery / Urządzenia sieciowe / Huby USB",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kamery IP",
    "categoryPath": [
      "(260022) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(260022) Elektronika / Komputery / Urządzenia sieciowe / Kamery IP",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Karty sieciowe",
    "categoryPath": [
      "(260735) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(260735) Elektronika / Komputery / Urządzenia sieciowe / Karty sieciowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Karty sieciowe Wi-Fi",
    "categoryPath": [
      "(260736) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(260736) Elektronika / Komputery / Urządzenia sieciowe / Karty sieciowe Wi-Fi",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kontrolery sieciowe",
    "categoryPath": [
      "(260737) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(260737) Elektronika / Komputery / Urządzenia sieciowe / Kontrolery sieciowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Modemy bezprzewodowe USB",
    "categoryPath": [
      "(260647) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(260647) Elektronika / Komputery / Urządzenia sieciowe / Modemy bezprzewodowe USB",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Modemy kablowe",
    "categoryPath": [
      "(257203) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(257203) Elektronika / Komputery / Urządzenia sieciowe / Modemy kablowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Modemy wewnętrzne",
    "categoryPath": [
      "(257204) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(257204) Elektronika / Komputery / Urządzenia sieciowe / Modemy wewnętrzne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4425) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(4425) Elektronika / Komputery / Urządzenia sieciowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Routery WiFi i Access Pointy",
    "categoryPath": [
      "(257731) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(257731) Elektronika / Komputery / Urządzenia sieciowe / Routery WiFi i Access Pointy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Routery mobilne",
    "categoryPath": [
      "(260648) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(260648) Elektronika / Komputery / Urządzenia sieciowe / Routery mobilne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Routery przewodowe",
    "categoryPath": [
      "(77982) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(77982) Elektronika / Komputery / Urządzenia sieciowe / Routery przewodowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Serwery plików (NAS)",
    "categoryPath": [
      "(259438) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(259438) Elektronika / Komputery / Urządzenia sieciowe / Serwery plików (NAS)",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Printserwer",
    "categoryPath": [
      "(4438) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Sprzęt sieciowy"
    ],
    "hierarchy": "(4438) Elektronika / Komputery / Urządzenia sieciowe / Sprzęt sieciowy / Printserwer",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Switche i huby",
    "categoryPath": [
      "(260739) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Sprzęt sieciowy"
    ],
    "hierarchy": "(260739) Elektronika / Komputery / Urządzenia sieciowe / Sprzęt sieciowy / Switche i huby",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Transceiver i konwertery",
    "categoryPath": [
      "(4439) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Sprzęt sieciowy"
    ],
    "hierarchy": "(4439) Elektronika / Komputery / Urządzenia sieciowe / Sprzęt sieciowy / Transceiver i konwertery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(63049) Elektronika",
      "Komputery",
      "Urządzenia sieciowe",
      "Sprzęt sieciowy"
    ],
    "hierarchy": "(63049) Elektronika / Komputery / Urządzenia sieciowe / Sprzęt sieciowy / Zasilacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Telefony USB i VoIP",
    "categoryPath": [
      "(259433) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(259433) Elektronika / Komputery / Urządzenia sieciowe / Telefony USB i VoIP",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Transmitery sieciowe (PowerLine)",
    "categoryPath": [
      "(256052) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(256052) Elektronika / Komputery / Urządzenia sieciowe / Transmitery sieciowe (PowerLine)",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wzmacniacze sygnału Wi-Fi",
    "categoryPath": [
      "(256053) Elektronika",
      "Komputery",
      "Urządzenia sieciowe"
    ],
    "hierarchy": "(256053) Elektronika / Komputery / Urządzenia sieciowe / Wzmacniacze sygnału Wi-Fi",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Joysticki",
    "categoryPath": [
      "(4565) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(4565) Elektronika / Komputery / Urządzenia wskazujące / Joysticki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(4567) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(4567) Elektronika / Komputery / Urządzenia wskazujące / Kierownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Bezprzewodowe",
    "categoryPath": [
      "(4573) Elektronika",
      "Komputery",
      "Urządzenia wskazujące",
      "Klawiatury"
    ],
    "hierarchy": "(4573) Elektronika / Komputery / Urządzenia wskazujące / Klawiatury / Bezprzewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Przewodowe",
    "categoryPath": [
      "(4574) Elektronika",
      "Komputery",
      "Urządzenia wskazujące",
      "Klawiatury"
    ],
    "hierarchy": "(4574) Elektronika / Komputery / Urządzenia wskazujące / Klawiatury / Przewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Maty do tańczenia",
    "categoryPath": [
      "(63034) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(63034) Elektronika / Komputery / Urządzenia wskazujące / Maty do tańczenia",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Bezprzewodowe",
    "categoryPath": [
      "(4575) Elektronika",
      "Komputery",
      "Urządzenia wskazujące",
      "Myszki"
    ],
    "hierarchy": "(4575) Elektronika / Komputery / Urządzenia wskazujące / Myszki / Bezprzewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Podkładki",
    "categoryPath": [
      "(4577) Elektronika",
      "Komputery",
      "Urządzenia wskazujące",
      "Myszki"
    ],
    "hierarchy": "(4577) Elektronika / Komputery / Urządzenia wskazujące / Myszki / Podkładki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Przewodowe",
    "categoryPath": [
      "(4576) Elektronika",
      "Komputery",
      "Urządzenia wskazujące",
      "Myszki"
    ],
    "hierarchy": "(4576) Elektronika / Komputery / Urządzenia wskazujące / Myszki / Przewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pady",
    "categoryPath": [
      "(4569) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(4569) Elektronika / Komputery / Urządzenia wskazujące / Pady",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Piloty",
    "categoryPath": [
      "(16641) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(16641) Elektronika / Komputery / Urządzenia wskazujące / Piloty",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4572) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(4572) Elektronika / Komputery / Urządzenia wskazujące / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tablety graficzne",
    "categoryPath": [
      "(4570) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(4570) Elektronika / Komputery / Urządzenia wskazujące / Tablety graficzne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Trackball",
    "categoryPath": [
      "(4571) Elektronika",
      "Komputery",
      "Urządzenia wskazujące"
    ],
    "hierarchy": "(4571) Elektronika / Komputery / Urządzenia wskazujące / Trackball",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Bezprzewodowe",
    "categoryPath": [
      "(63069) Elektronika",
      "Komputery",
      "Urządzenia wskazujące",
      "Zestaw klawiatura i mysz"
    ],
    "hierarchy": "(63069) Elektronika / Komputery / Urządzenia wskazujące / Zestaw klawiatura i mysz / Bezprzewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Przewodowe",
    "categoryPath": [
      "(63068) Elektronika",
      "Komputery",
      "Urządzenia wskazujące",
      "Zestaw klawiatura i mysz"
    ],
    "hierarchy": "(63068) Elektronika / Komputery / Urządzenia wskazujące / Zestaw klawiatura i mysz / Przewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "'Gierki' elektroniczne",
    "categoryPath": [
      "(122317) Elektronika",
      "Konsole i automaty"
    ],
    "hierarchy": "(122317) Elektronika / Konsole i automaty / 'Gierki' elektroniczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(322688) Elektronika",
      "Konsole i automaty",
      "ASUS ROG ALLY"
    ],
    "hierarchy": "(322688) Elektronika / Konsole i automaty / ASUS ROG ALLY / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(322687) Elektronika",
      "Konsole i automaty",
      "ASUS ROG ALLY"
    ],
    "hierarchy": "(322687) Elektronika / Konsole i automaty / ASUS ROG ALLY / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(122320) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122320) Elektronika / Konsole i automaty / Automaty do gier / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Arcade",
    "categoryPath": [
      "(122321) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122321) Elektronika / Konsole i automaty / Automaty do gier / Arcade",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Bujaki",
    "categoryPath": [
      "(122322) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122322) Elektronika / Konsole i automaty / Automaty do gier / Bujaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Dart",
    "categoryPath": [
      "(122323) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122323) Elektronika / Konsole i automaty / Automaty do gier / Dart",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Flipery",
    "categoryPath": [
      "(122324) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122324) Elektronika / Konsole i automaty / Automaty do gier / Flipery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Poker",
    "categoryPath": [
      "(122326) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122326) Elektronika / Konsole i automaty / Automaty do gier / Poker",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122328) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122328) Elektronika / Konsole i automaty / Automaty do gier / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Symulatory",
    "categoryPath": [
      "(122327) Elektronika",
      "Konsole i automaty",
      "Automaty do gier"
    ],
    "hierarchy": "(122327) Elektronika / Konsole i automaty / Automaty do gier / Symulatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(322926) Elektronika",
      "Konsole i automaty",
      "Lenovo Legion Go"
    ],
    "hierarchy": "(322926) Elektronika / Konsole i automaty / Lenovo Legion Go / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(322925) Elektronika",
      "Konsole i automaty",
      "Lenovo Legion Go"
    ],
    "hierarchy": "(322925) Elektronika / Konsole i automaty / Lenovo Legion Go / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(122241) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox"
    ],
    "hierarchy": "(122241) Elektronika / Konsole i automaty / Microsoft Xbox / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122242) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox"
    ],
    "hierarchy": "(122242) Elektronika / Konsole i automaty / Microsoft Xbox / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Dyski",
    "categoryPath": [
      "(122245) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122245) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Dyski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Headsety",
    "categoryPath": [
      "(122246) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122246) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Headsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Inne kontrolery",
    "categoryPath": [
      "(122250) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122250) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Inne kontrolery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kinect",
    "categoryPath": [
      "(122247) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122247) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Kinect",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122244) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122244) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(122248) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122248) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pady",
    "categoryPath": [
      "(122249) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122249) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Pady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Panele i tuning",
    "categoryPath": [
      "(122251) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122251) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Panele i tuning",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122254) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122254) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zdrapki",
    "categoryPath": [
      "(122252) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(122252) Elektronika / Konsole i automaty / Microsoft Xbox 360 / Zdrapki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Headsety",
    "categoryPath": [
      "(302510) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(302510) Elektronika / Konsole i automaty / Microsoft Xbox One / Headsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(302522) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(302522) Elektronika / Konsole i automaty / Microsoft Xbox One / Kierownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kinect",
    "categoryPath": [
      "(147137) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147137) Elektronika / Konsole i automaty / Microsoft Xbox One / Kinect",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(147136) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147136) Elektronika / Konsole i automaty / Microsoft Xbox One / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(147138) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147138) Elektronika / Konsole i automaty / Microsoft Xbox One / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pady",
    "categoryPath": [
      "(147139) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147139) Elektronika / Konsole i automaty / Microsoft Xbox One / Pady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147135) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147135) Elektronika / Konsole i automaty / Microsoft Xbox One / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(315503) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(315503) Elektronika / Konsole i automaty / Microsoft Xbox Series X / S / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Headsety",
    "categoryPath": [
      "(315500) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(315500) Elektronika / Konsole i automaty / Microsoft Xbox Series X / S / Headsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(315497) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(315497) Elektronika / Konsole i automaty / Microsoft Xbox Series X / S / Kierownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(318804) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(318804) Elektronika / Konsole i automaty / Microsoft Xbox Series X / S / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pady",
    "categoryPath": [
      "(315494) Elektronika",
      "Konsole i automaty",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(315494) Elektronika / Konsole i automaty / Microsoft Xbox Series X / S / Pady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(125803) Elektronika",
      "Konsole i automaty",
      "Nintendo 3DS i 2DS"
    ],
    "hierarchy": "(125803) Elektronika / Konsole i automaty / Nintendo 3DS i 2DS / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(125802) Elektronika",
      "Konsole i automaty",
      "Nintendo 3DS i 2DS"
    ],
    "hierarchy": "(125802) Elektronika / Konsole i automaty / Nintendo 3DS i 2DS / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257366) Elektronika",
      "Konsole i automaty",
      "Nintendo 64"
    ],
    "hierarchy": "(257366) Elektronika / Konsole i automaty / Nintendo 64 / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257365) Elektronika",
      "Konsole i automaty",
      "Nintendo 64"
    ],
    "hierarchy": "(257365) Elektronika / Konsole i automaty / Nintendo 64 / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(122260) Elektronika",
      "Konsole i automaty",
      "Nintendo DS"
    ],
    "hierarchy": "(122260) Elektronika / Konsole i automaty / Nintendo DS / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122258) Elektronika",
      "Konsole i automaty",
      "Nintendo DS"
    ],
    "hierarchy": "(122258) Elektronika / Konsole i automaty / Nintendo DS / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pokrowce i futerały",
    "categoryPath": [
      "(122259) Elektronika",
      "Konsole i automaty",
      "Nintendo DS"
    ],
    "hierarchy": "(122259) Elektronika / Konsole i automaty / Nintendo DS / Pokrowce i futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257379) Elektronika",
      "Konsole i automaty",
      "Nintendo Game Boy"
    ],
    "hierarchy": "(257379) Elektronika / Konsole i automaty / Nintendo Game Boy / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257378) Elektronika",
      "Konsole i automaty",
      "Nintendo Game Boy"
    ],
    "hierarchy": "(257378) Elektronika / Konsole i automaty / Nintendo Game Boy / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(122235) Elektronika",
      "Konsole i automaty",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(122235) Elektronika / Konsole i automaty / Nintendo Game Boy Advance / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122236) Elektronika",
      "Konsole i automaty",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(122236) Elektronika / Konsole i automaty / Nintendo Game Boy Advance / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(122262) Elektronika",
      "Konsole i automaty",
      "Nintendo GameCube"
    ],
    "hierarchy": "(122262) Elektronika / Konsole i automaty / Nintendo GameCube / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122263) Elektronika",
      "Konsole i automaty",
      "Nintendo GameCube"
    ],
    "hierarchy": "(122263) Elektronika / Konsole i automaty / Nintendo GameCube / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257374) Elektronika",
      "Konsole i automaty",
      "Nintendo SNES i NES",
      "NES"
    ],
    "hierarchy": "(257374) Elektronika / Konsole i automaty / Nintendo SNES i NES / NES / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257373) Elektronika",
      "Konsole i automaty",
      "Nintendo SNES i NES",
      "NES"
    ],
    "hierarchy": "(257373) Elektronika / Konsole i automaty / Nintendo SNES i NES / NES / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257376) Elektronika",
      "Konsole i automaty",
      "Nintendo SNES i NES",
      "SNES"
    ],
    "hierarchy": "(257376) Elektronika / Konsole i automaty / Nintendo SNES i NES / SNES / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257375) Elektronika",
      "Konsole i automaty",
      "Nintendo SNES i NES",
      "SNES"
    ],
    "hierarchy": "(257375) Elektronika / Konsole i automaty / Nintendo SNES i NES / SNES / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(256864) Elektronika",
      "Konsole i automaty",
      "Nintendo Switch"
    ],
    "hierarchy": "(256864) Elektronika / Konsole i automaty / Nintendo Switch / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(256863) Elektronika",
      "Konsole i automaty",
      "Nintendo Switch"
    ],
    "hierarchy": "(256863) Elektronika / Konsole i automaty / Nintendo Switch / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kontrolery",
    "categoryPath": [
      "(257386) Elektronika",
      "Konsole i automaty",
      "Nintendo Switch"
    ],
    "hierarchy": "(257386) Elektronika / Konsole i automaty / Nintendo Switch / Kontrolery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Inne kontrolery",
    "categoryPath": [
      "(122271) Elektronika",
      "Konsole i automaty",
      "Nintendo Wii"
    ],
    "hierarchy": "(122271) Elektronika / Konsole i automaty / Nintendo Wii / Inne kontrolery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122268) Elektronika",
      "Konsole i automaty",
      "Nintendo Wii"
    ],
    "hierarchy": "(122268) Elektronika / Konsole i automaty / Nintendo Wii / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(122269) Elektronika",
      "Konsole i automaty",
      "Nintendo Wii"
    ],
    "hierarchy": "(122269) Elektronika / Konsole i automaty / Nintendo Wii / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122272) Elektronika",
      "Konsole i automaty",
      "Nintendo Wii"
    ],
    "hierarchy": "(122272) Elektronika / Konsole i automaty / Nintendo Wii / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wii Remote, nunchucki",
    "categoryPath": [
      "(122270) Elektronika",
      "Konsole i automaty",
      "Nintendo Wii"
    ],
    "hierarchy": "(122270) Elektronika / Konsole i automaty / Nintendo Wii / Wii Remote, nunchucki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257364) Elektronika",
      "Konsole i automaty",
      "Nintendo Wii U"
    ],
    "hierarchy": "(257364) Elektronika / Konsole i automaty / Nintendo Wii U / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257363) Elektronika",
      "Konsole i automaty",
      "Nintendo Wii U"
    ],
    "hierarchy": "(257363) Elektronika / Konsole i automaty / Nintendo Wii U / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257372) Elektronika",
      "Konsole i automaty",
      "Pegasus"
    ],
    "hierarchy": "(257372) Elektronika / Konsole i automaty / Pegasus / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257371) Elektronika",
      "Konsole i automaty",
      "Pegasus"
    ],
    "hierarchy": "(257371) Elektronika / Konsole i automaty / Pegasus / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(122330) Elektronika",
      "Konsole i automaty",
      "Pozostałe"
    ],
    "hierarchy": "(122330) Elektronika / Konsole i automaty / Pozostałe / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257368) Elektronika",
      "Konsole i automaty",
      "Sega Dreamcast"
    ],
    "hierarchy": "(257368) Elektronika / Konsole i automaty / Sega Dreamcast / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257367) Elektronika",
      "Konsole i automaty",
      "Sega Dreamcast"
    ],
    "hierarchy": "(257367) Elektronika / Konsole i automaty / Sega Dreamcast / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257370) Elektronika",
      "Konsole i automaty",
      "Sega inne"
    ],
    "hierarchy": "(257370) Elektronika / Konsole i automaty / Sega inne / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(257369) Elektronika",
      "Konsole i automaty",
      "Sega inne"
    ],
    "hierarchy": "(257369) Elektronika / Konsole i automaty / Sega inne / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Karty pamięci",
    "categoryPath": [
      "(125807) Elektronika",
      "Konsole i automaty",
      "Sony PS Vita",
      "Akcesoria"
    ],
    "hierarchy": "(125807) Elektronika / Konsole i automaty / Sony PS Vita / Akcesoria / Karty pamięci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(125806) Elektronika",
      "Konsole i automaty",
      "Sony PS Vita",
      "Akcesoria"
    ],
    "hierarchy": "(125806) Elektronika / Konsole i automaty / Sony PS Vita / Akcesoria / Pokrowce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(125808) Elektronika",
      "Konsole i automaty",
      "Sony PS Vita",
      "Akcesoria"
    ],
    "hierarchy": "(125808) Elektronika / Konsole i automaty / Sony PS Vita / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(125804) Elektronika",
      "Konsole i automaty",
      "Sony PS Vita"
    ],
    "hierarchy": "(125804) Elektronika / Konsole i automaty / Sony PS Vita / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Baterie",
    "categoryPath": [
      "(122303) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122303) Elektronika / Konsole i automaty / Sony PSP / Baterie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Joysticki",
    "categoryPath": [
      "(122305) Elektronika",
      "Konsole i automaty",
      "Sony PSP",
      "Części"
    ],
    "hierarchy": "(122305) Elektronika / Konsole i automaty / Sony PSP / Części / Joysticki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy, panele",
    "categoryPath": [
      "(122306) Elektronika",
      "Konsole i automaty",
      "Sony PSP",
      "Części"
    ],
    "hierarchy": "(122306) Elektronika / Konsole i automaty / Sony PSP / Części / Obudowy, panele",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122308) Elektronika",
      "Konsole i automaty",
      "Sony PSP",
      "Części"
    ],
    "hierarchy": "(122308) Elektronika / Konsole i automaty / Sony PSP / Części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wyświetlacze",
    "categoryPath": [
      "(122307) Elektronika",
      "Konsole i automaty",
      "Sony PSP",
      "Części"
    ],
    "hierarchy": "(122307) Elektronika / Konsole i automaty / Sony PSP / Części / Wyświetlacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Etui i futerały",
    "categoryPath": [
      "(122309) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122309) Elektronika / Konsole i automaty / Sony PSP / Etui i futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie",
    "categoryPath": [
      "(122310) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122310) Elektronika / Konsole i automaty / Sony PSP / Folie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty pamięci",
    "categoryPath": [
      "(122311) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122311) Elektronika / Konsole i automaty / Sony PSP / Karty pamięci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122302) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122302) Elektronika / Konsole i automaty / Sony PSP / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(122313) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122313) Elektronika / Konsole i automaty / Sony PSP / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Słuchawki dedykowane",
    "categoryPath": [
      "(122314) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122314) Elektronika / Konsole i automaty / Sony PSP / Słuchawki dedykowane",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(122315) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122315) Elektronika / Konsole i automaty / Sony PSP / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(122312) Elektronika",
      "Konsole i automaty",
      "Sony PSP"
    ],
    "hierarchy": "(122312) Elektronika / Konsole i automaty / Sony PSP / Ładowarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głowice lasera",
    "categoryPath": [
      "(122294) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(122294) Elektronika / Konsole i automaty / Sony PlayStation (PSX) / Głowice lasera",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Inne kontrolery",
    "categoryPath": [
      "(122296) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(122296) Elektronika / Konsole i automaty / Sony PlayStation (PSX) / Inne kontrolery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Joypady",
    "categoryPath": [
      "(122295) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(122295) Elektronika / Konsole i automaty / Sony PlayStation (PSX) / Joypady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty pamięci",
    "categoryPath": [
      "(122297) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(122297) Elektronika / Konsole i automaty / Sony PlayStation (PSX) / Karty pamięci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122293) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(122293) Elektronika / Konsole i automaty / Sony PlayStation (PSX) / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(122298) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(122298) Elektronika / Konsole i automaty / Sony PlayStation (PSX) / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122299) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(122299) Elektronika / Konsole i automaty / Sony PlayStation (PSX) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Eye Toy",
    "categoryPath": [
      "(122277) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122277) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Eye Toy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głowice lasera",
    "categoryPath": [
      "(122278) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122278) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Głowice lasera",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Inne kontrolery",
    "categoryPath": [
      "(122280) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122280) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Inne kontrolery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Joypady",
    "categoryPath": [
      "(122279) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122279) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Joypady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty pamięci",
    "categoryPath": [
      "(122281) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122281) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Karty pamięci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122276) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122276) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(122282) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122282) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122283) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(122283) Elektronika / Konsole i automaty / Sony PlayStation 2 (PS2) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Inne kontrolery",
    "categoryPath": [
      "(122289) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(122289) Elektronika / Konsole i automaty / Sony PlayStation 3 (PS3) / Inne kontrolery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(122285) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(122285) Elektronika / Konsole i automaty / Sony PlayStation 3 (PS3) / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(122286) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(122286) Elektronika / Konsole i automaty / Sony PlayStation 3 (PS3) / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pady",
    "categoryPath": [
      "(122287) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(122287) Elektronika / Konsole i automaty / Sony PlayStation 3 (PS3) / Pady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Playstation Move",
    "categoryPath": [
      "(122288) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(122288) Elektronika / Konsole i automaty / Sony PlayStation 3 (PS3) / Playstation Move",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122291) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(122291) Elektronika / Konsole i automaty / Sony PlayStation 3 (PS3) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Headsety",
    "categoryPath": [
      "(302534) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(302534) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / Headsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(302546) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(302546) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / Kierownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(147130) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(147130) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okablowanie",
    "categoryPath": [
      "(147132) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(147132) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / Okablowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pady",
    "categoryPath": [
      "(147131) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(147131) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / Pady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "PlayStation Camera",
    "categoryPath": [
      "(147133) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(147133) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / PlayStation Camera",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "PlayStation VR",
    "categoryPath": [
      "(254839) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(254839) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / PlayStation VR",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147129) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(147129) Elektronika / Konsole i automaty / Sony PlayStation 4 (PS4) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(315581) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 5 (PS5)"
    ],
    "hierarchy": "(315581) Elektronika / Konsole i automaty / Sony PlayStation 5 (PS5) / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Headsety",
    "categoryPath": [
      "(315578) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 5 (PS5)"
    ],
    "hierarchy": "(315578) Elektronika / Konsole i automaty / Sony PlayStation 5 (PS5) / Headsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(315575) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 5 (PS5)"
    ],
    "hierarchy": "(315575) Elektronika / Konsole i automaty / Sony PlayStation 5 (PS5) / Kierownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(315569) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 5 (PS5)"
    ],
    "hierarchy": "(315569) Elektronika / Konsole i automaty / Sony PlayStation 5 (PS5) / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pady",
    "categoryPath": [
      "(315572) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 5 (PS5)"
    ],
    "hierarchy": "(315572) Elektronika / Konsole i automaty / Sony PlayStation 5 (PS5) / Pady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "PlayStation VR2",
    "categoryPath": [
      "(322390) Elektronika",
      "Konsole i automaty",
      "Sony PlayStation 5 (PS5)"
    ],
    "hierarchy": "(322390) Elektronika / Konsole i automaty / Sony PlayStation 5 (PS5) / PlayStation VR2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(321652) Elektronika",
      "Konsole i automaty",
      "Steam Deck"
    ],
    "hierarchy": "(321652) Elektronika / Konsole i automaty / Steam Deck / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konsole",
    "categoryPath": [
      "(321649) Elektronika",
      "Konsole i automaty",
      "Steam Deck"
    ],
    "hierarchy": "(321649) Elektronika / Konsole i automaty / Steam Deck / Konsole",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Filtry do okapów",
    "categoryPath": [
      "(260632) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy",
      "Akcesoria"
    ],
    "hierarchy": "(260632) Elektronika / RTV i AGD / AGD do zabudowy / Akcesoria / Filtry do okapów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260633) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy",
      "Akcesoria"
    ],
    "hierarchy": "(260633) Elektronika / RTV i AGD / AGD do zabudowy / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Chemia gospodarcza",
    "categoryPath": [
      "(125349) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(125349) Elektronika / RTV i AGD / AGD do zabudowy / Chemia gospodarcza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Chłodziarki do wina",
    "categoryPath": [
      "(256522) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(256522) Elektronika / RTV i AGD / AGD do zabudowy / Chłodziarki do wina",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(127363) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(127363) Elektronika / RTV i AGD / AGD do zabudowy / Części",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ekspresy do kawy",
    "categoryPath": [
      "(67525) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(67525) Elektronika / RTV i AGD / AGD do zabudowy / Ekspresy do kawy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kuchenki mikrofalowe",
    "categoryPath": [
      "(67526) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(67526) Elektronika / RTV i AGD / AGD do zabudowy / Kuchenki mikrofalowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lodówki",
    "categoryPath": [
      "(67528) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(67528) Elektronika / RTV i AGD / AGD do zabudowy / Lodówki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okapy",
    "categoryPath": [
      "(67529) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(67529) Elektronika / RTV i AGD / AGD do zabudowy / Okapy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Piekarniki",
    "categoryPath": [
      "(67530) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(67530) Elektronika / RTV i AGD / AGD do zabudowy / Piekarniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67534) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(67534) Elektronika / RTV i AGD / AGD do zabudowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pralki",
    "categoryPath": [
      "(76255) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(76255) Elektronika / RTV i AGD / AGD do zabudowy / Pralki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pralko-suszarki",
    "categoryPath": [
      "(254439) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(254439) Elektronika / RTV i AGD / AGD do zabudowy / Pralko-suszarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Płyty ceramiczne",
    "categoryPath": [
      "(257223) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy",
      "Płyty grzewcze"
    ],
    "hierarchy": "(257223) Elektronika / RTV i AGD / AGD do zabudowy / Płyty grzewcze / Płyty ceramiczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Płyty elektryczne",
    "categoryPath": [
      "(67536) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy",
      "Płyty grzewcze"
    ],
    "hierarchy": "(67536) Elektronika / RTV i AGD / AGD do zabudowy / Płyty grzewcze / Płyty elektryczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Płyty gazowe",
    "categoryPath": [
      "(67537) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy",
      "Płyty grzewcze"
    ],
    "hierarchy": "(67537) Elektronika / RTV i AGD / AGD do zabudowy / Płyty grzewcze / Płyty gazowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Płyty indukcyjne",
    "categoryPath": [
      "(67535) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy",
      "Płyty grzewcze"
    ],
    "hierarchy": "(67535) Elektronika / RTV i AGD / AGD do zabudowy / Płyty grzewcze / Płyty indukcyjne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Płyty kombinowane",
    "categoryPath": [
      "(67538) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy",
      "Płyty grzewcze"
    ],
    "hierarchy": "(67538) Elektronika / RTV i AGD / AGD do zabudowy / Płyty grzewcze / Płyty kombinowane",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Suszarki do ubrań",
    "categoryPath": [
      "(322178) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(322178) Elektronika / RTV i AGD / AGD do zabudowy / Suszarki do ubrań",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Szuflady do podgrzewania",
    "categoryPath": [
      "(125348) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(125348) Elektronika / RTV i AGD / AGD do zabudowy / Szuflady do podgrzewania",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zamrażarki",
    "categoryPath": [
      "(258280) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(258280) Elektronika / RTV i AGD / AGD do zabudowy / Zamrażarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zestawy AGD do zabudowy",
    "categoryPath": [
      "(73133) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(73133) Elektronika / RTV i AGD / AGD do zabudowy / Zestawy AGD do zabudowy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zmywarki",
    "categoryPath": [
      "(67532) Elektronika",
      "RTV i AGD",
      "AGD do zabudowy"
    ],
    "hierarchy": "(67532) Elektronika / RTV i AGD / AGD do zabudowy / Zmywarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Części zamienne",
    "categoryPath": [
      "(67422) Elektronika",
      "RTV i AGD",
      "AGD drobne"
    ],
    "hierarchy": "(67422) Elektronika / RTV i AGD / AGD drobne / Części zamienne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(320599) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Części i akcesoria"
    ],
    "hierarchy": "(320599) Elektronika / RTV i AGD / AGD drobne / Do domu / Części i akcesoria / Akumulatory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Filtry i wkłady",
    "categoryPath": [
      "(320617) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Części i akcesoria"
    ],
    "hierarchy": "(320617) Elektronika / RTV i AGD / AGD drobne / Do domu / Części i akcesoria / Filtry i wkłady",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(320611) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Części i akcesoria"
    ],
    "hierarchy": "(320611) Elektronika / RTV i AGD / AGD drobne / Do domu / Części i akcesoria / Inne akcesoria",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Oczyszczanie",
    "categoryPath": [
      "(320608) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Części i akcesoria"
    ],
    "hierarchy": "(320608) Elektronika / RTV i AGD / AGD drobne / Do domu / Części i akcesoria / Oczyszczanie",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Silniki i akcesoria",
    "categoryPath": [
      "(320605) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Części i akcesoria"
    ],
    "hierarchy": "(320605) Elektronika / RTV i AGD / AGD drobne / Do domu / Części i akcesoria / Silniki i akcesoria",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stopki do maszyn",
    "categoryPath": [
      "(321640) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Części i akcesoria"
    ],
    "hierarchy": "(321640) Elektronika / RTV i AGD / AGD drobne / Do domu / Części i akcesoria / Stopki do maszyn",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szczotki i nakładki",
    "categoryPath": [
      "(320614) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Części i akcesoria"
    ],
    "hierarchy": "(320614) Elektronika / RTV i AGD / AGD drobne / Do domu / Części i akcesoria / Szczotki i nakładki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Golarki do ubrań",
    "categoryPath": [
      "(67461) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(67461) Elektronika / RTV i AGD / AGD drobne / Do domu / Golarki do ubrań",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Grzejniki elektryczne",
    "categoryPath": [
      "(67462) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(67462) Elektronika / RTV i AGD / AGD drobne / Do domu / Grzejniki elektryczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Klimatory",
    "categoryPath": [
      "(322273) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(322273) Elektronika / RTV i AGD / AGD drobne / Do domu / Klimatyzacja i wentylacja / Klimatory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Klimatyzatory przenośne",
    "categoryPath": [
      "(258774) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(258774) Elektronika / RTV i AGD / AGD drobne / Do domu / Klimatyzacja i wentylacja / Klimatyzatory przenośne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Klimatyzatory split",
    "categoryPath": [
      "(258775) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Klimatyzacja i wentylacja"
    ],
    "hierarchy": "(258775) Elektronika / RTV i AGD / AGD drobne / Do domu / Klimatyzacja i wentylacja / Klimatyzatory split",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Maszyny do szycia",
    "categoryPath": [
      "(67464) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(67464) Elektronika / RTV i AGD / AGD drobne / Do domu / Maszyny do szycia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nawilżacze",
    "categoryPath": [
      "(67465) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(67465) Elektronika / RTV i AGD / AGD drobne / Do domu / Nawilżacze",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Oczyszczacze powietrza",
    "categoryPath": [
      "(256842) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(256842) Elektronika / RTV i AGD / AGD drobne / Do domu / Oczyszczacze powietrza",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akumulatory do odkurzaczy",
    "categoryPath": [
      "(317021) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(317021) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Akumulatory do odkurzaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Chemia do odkurzaczy",
    "categoryPath": [
      "(307369) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(307369) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Chemia do odkurzaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Filtry do odkurzaczy",
    "categoryPath": [
      "(67468) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(67468) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Filtry do odkurzaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Odkurzacze pionowe",
    "categoryPath": [
      "(257198) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(257198) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Odkurzacze pionowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Odkurzacze ręczne",
    "categoryPath": [
      "(257199) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(257199) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Odkurzacze ręczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Odkurzacze tradycyjne",
    "categoryPath": [
      "(67467) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(67467) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Odkurzacze tradycyjne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Odkurzacze wodne i piorące",
    "categoryPath": [
      "(257197) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(257197) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Odkurzacze wodne i piorące",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67470) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(67470) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Roboty sprzątające",
    "categoryPath": [
      "(256019) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(256019) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Roboty sprzątające",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Rury i węże do odkurzaczy",
    "categoryPath": [
      "(257012) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(257012) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Rury i węże do odkurzaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ssawki i szczotki do odkurzaczy",
    "categoryPath": [
      "(257013) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(257013) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Ssawki i szczotki do odkurzaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Worki do odkurzaczy",
    "categoryPath": [
      "(67469) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu",
      "Odkurzacze"
    ],
    "hierarchy": "(67469) Elektronika / RTV i AGD / AGD drobne / Do domu / Odkurzacze / Worki do odkurzaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Osuszacze powietrza",
    "categoryPath": [
      "(67471) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(67471) Elektronika / RTV i AGD / AGD drobne / Do domu / Osuszacze powietrza",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Parownice, myjki i mopy parowe",
    "categoryPath": [
      "(255484) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(255484) Elektronika / RTV i AGD / AGD drobne / Do domu / Parownice, myjki i mopy parowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Stacje parowe",
    "categoryPath": [
      "(255483) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(255483) Elektronika / RTV i AGD / AGD drobne / Do domu / Stacje parowe",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Steamery do ubrań",
    "categoryPath": [
      "(258662) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(258662) Elektronika / RTV i AGD / AGD drobne / Do domu / Steamery do ubrań",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Termowentylatory",
    "categoryPath": [
      "(67472) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(67472) Elektronika / RTV i AGD / AGD drobne / Do domu / Termowentylatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Żelazka",
    "categoryPath": [
      "(67473) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do domu"
    ],
    "hierarchy": "(67473) Elektronika / RTV i AGD / AGD drobne / Do domu / Żelazka",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Blendery kielichowe",
    "categoryPath": [
      "(257245) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(257245) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Blendery kielichowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Blendery ręczne",
    "categoryPath": [
      "(257244) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(257244) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Blendery ręczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Czajniki elektryczne",
    "categoryPath": [
      "(67428) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67428) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Czajniki elektryczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Drobne akcesoria",
    "categoryPath": [
      "(319643) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319643) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Drobne akcesoria",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Filtry do ekspresów",
    "categoryPath": [
      "(319589) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319589) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Filtry do ekspresów",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mieszadła",
    "categoryPath": [
      "(319637) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319637) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Mieszadła",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Noże i ostrza",
    "categoryPath": [
      "(319628) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319628) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Noże i ostrza",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Oczyszczanie",
    "categoryPath": [
      "(319619) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319619) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Oczyszczanie",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Odkamieniacze",
    "categoryPath": [
      "(319586) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319586) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Odkamieniacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Osłony i pokrywki",
    "categoryPath": [
      "(319622) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319622) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Osłony i pokrywki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pojemniki",
    "categoryPath": [
      "(319634) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319634) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Pojemniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Sitka",
    "categoryPath": [
      "(319640) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319640) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Sitka",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Smary",
    "categoryPath": [
      "(319625) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319625) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Smary",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(319631) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Części i akcesoria"
    ],
    "hierarchy": "(319631) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Części i akcesoria / Uszczelki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ekspresy ciśnieniowe",
    "categoryPath": [
      "(258242) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Ekspresy do kawy"
    ],
    "hierarchy": "(258242) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Ekspresy do kawy / Ekspresy ciśnieniowe",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Ekspresy ciśnieniowo-przelewowe",
    "categoryPath": [
      "(258243) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Ekspresy do kawy"
    ],
    "hierarchy": "(258243) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Ekspresy do kawy / Ekspresy ciśnieniowo-przelewowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Ekspresy kapsułkowe",
    "categoryPath": [
      "(258244) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Ekspresy do kawy"
    ],
    "hierarchy": "(258244) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Ekspresy do kawy / Ekspresy kapsułkowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Ekspresy przelewowe",
    "categoryPath": [
      "(258245) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Ekspresy do kawy"
    ],
    "hierarchy": "(258245) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Ekspresy do kawy / Ekspresy przelewowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Dzbanki i butelki filtrujące",
    "categoryPath": [
      "(73134) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Filtry do wody"
    ],
    "hierarchy": "(73134) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Filtry do wody / Dzbanki i butelki filtrujące",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Filtry nakranowe i podzlewozmywakowe",
    "categoryPath": [
      "(259067) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Filtry do wody"
    ],
    "hierarchy": "(259067) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Filtry do wody / Filtry nakranowe i podzlewozmywakowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Systemy odwróconej osmozy",
    "categoryPath": [
      "(259069) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Filtry do wody"
    ],
    "hierarchy": "(259069) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Filtry do wody / Systemy odwróconej osmozy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wkłady",
    "categoryPath": [
      "(73135) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Filtry do wody"
    ],
    "hierarchy": "(73135) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Filtry do wody / Wkłady",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Frytkownice",
    "categoryPath": [
      "(67439) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67439) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Frytkownice",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Gofrownice",
    "categoryPath": [
      "(67440) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67440) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Gofrownice",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Grille elektryczne",
    "categoryPath": [
      "(67442) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67442) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Grille elektryczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Jajowary",
    "categoryPath": [
      "(67444) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67444) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Jajowary",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kawiarki",
    "categoryPath": [
      "(85159) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(85159) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Kawiarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kombiwary",
    "categoryPath": [
      "(76257) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(76257) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Kombiwary",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kostkarki do lodu",
    "categoryPath": [
      "(258075) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(258075) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Kostkarki do lodu",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Krajalnice",
    "categoryPath": [
      "(67446) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67446) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Krajalnice",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Maszynki do mielenia mięsa",
    "categoryPath": [
      "(67447) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67447) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Maszynki do mielenia mięsa",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Miksery ręczne",
    "categoryPath": [
      "(67448) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67448) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Miksery ręczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mini piekarniki",
    "categoryPath": [
      "(67449) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67449) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Mini piekarniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Multicookery i garnki elektryczne",
    "categoryPath": [
      "(258248) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(258248) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Multicookery i garnki elektryczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Młynki elektryczne",
    "categoryPath": [
      "(67450) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67450) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Młynki elektryczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Naleśnikarki",
    "categoryPath": [
      "(307561) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(307561) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Naleśnikarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Opiekacze",
    "categoryPath": [
      "(257086) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(257086) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Opiekacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Parowary",
    "categoryPath": [
      "(67451) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67451) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Parowary",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Prodiże",
    "categoryPath": [
      "(258249) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(258249) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Prodiże",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Roboty kuchenne",
    "categoryPath": [
      "(67452) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67452) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Roboty kuchenne",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(322352) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Saturatory i dodatki"
    ],
    "hierarchy": "(322352) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Saturatory i dodatki / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Butle i naboje CO2",
    "categoryPath": [
      "(322351) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Saturatory i dodatki"
    ],
    "hierarchy": "(322351) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Saturatory i dodatki / Butle i naboje CO2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Saturatory",
    "categoryPath": [
      "(322349) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Saturatory i dodatki"
    ],
    "hierarchy": "(322349) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Saturatory i dodatki / Saturatory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Syropy i napoje",
    "categoryPath": [
      "(322350) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni",
      "Saturatory i dodatki"
    ],
    "hierarchy": "(322350) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Saturatory i dodatki / Syropy i napoje",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Sokowirówki",
    "categoryPath": [
      "(67453) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67453) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Sokowirówki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Spieniacze do mleka",
    "categoryPath": [
      "(258012) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(258012) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Spieniacze do mleka",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Suszarki spożywcze",
    "categoryPath": [
      "(67454) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67454) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Suszarki spożywcze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Szatkownice i rozdrabniacze",
    "categoryPath": [
      "(258120) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(258120) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Szatkownice i rozdrabniacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Tostery",
    "categoryPath": [
      "(67455) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67455) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Tostery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Urządzenia do czekolady",
    "categoryPath": [
      "(76256) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(76256) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Urządzenia do czekolady",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Urządzenia do hot dogów",
    "categoryPath": [
      "(307609) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(307609) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Urządzenia do hot dogów",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Urządzenia do lodów i jogurtów",
    "categoryPath": [
      "(255938) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(255938) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Urządzenia do lodów i jogurtów",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Urządzenia do popcornu",
    "categoryPath": [
      "(258076) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(258076) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Urządzenia do popcornu",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Urządzenia do sous vide",
    "categoryPath": [
      "(315744) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(315744) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Urządzenia do sous vide",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Urządzenia do waty cukrowej",
    "categoryPath": [
      "(67456) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67456) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Urządzenia do waty cukrowej",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wagi kuchenne",
    "categoryPath": [
      "(67457) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67457) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Wagi kuchenne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wolnowary",
    "categoryPath": [
      "(257018) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(257018) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Wolnowary",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wyciskarki do cytrusów",
    "categoryPath": [
      "(258663) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(258663) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Wyciskarki do cytrusów",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wyciskarki wolnoobrotowe",
    "categoryPath": [
      "(254958) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(254958) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Wyciskarki wolnoobrotowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wypiekacze do chleba",
    "categoryPath": [
      "(67427) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(67427) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Wypiekacze do chleba",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zgrzewarki",
    "categoryPath": [
      "(257017) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Do kuchni"
    ],
    "hierarchy": "(257017) Elektronika / RTV i AGD / AGD drobne / Do kuchni / Zgrzewarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Części i akcesoria",
    "categoryPath": [
      "(306429) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(306429) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Części i akcesoria",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Depilatory",
    "categoryPath": [
      "(67476) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67476) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Depilatory",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Golarki",
    "categoryPath": [
      "(67477) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67477) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Golarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lokówki",
    "categoryPath": [
      "(67478) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67478) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Lokówki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Maszynki do strzyżenia",
    "categoryPath": [
      "(67480) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67480) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Maszynki do strzyżenia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Prostownice i karbownice",
    "categoryPath": [
      "(67479) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67479) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Prostownice i karbownice",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Suszarki do włosów",
    "categoryPath": [
      "(67481) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67481) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Suszarki do włosów",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Szczoteczki elektryczne",
    "categoryPath": [
      "(67482) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67482) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Szczoteczki elektryczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Trymery",
    "categoryPath": [
      "(257205) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(257205) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Trymery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wagi łazienkowe",
    "categoryPath": [
      "(67483) Elektronika",
      "RTV i AGD",
      "AGD drobne",
      "Higiena i pielęgnacja"
    ],
    "hierarchy": "(67483) Elektronika / RTV i AGD / AGD drobne / Higiena i pielęgnacja / Wagi łazienkowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67424) Elektronika",
      "RTV i AGD",
      "AGD drobne"
    ],
    "hierarchy": "(67424) Elektronika / RTV i AGD / AGD drobne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Filtry wody",
    "categoryPath": [
      "(260635) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące",
      "Akcesoria"
    ],
    "hierarchy": "(260635) Elektronika / RTV i AGD / AGD wolnostojące / Akcesoria / Filtry wody",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Maty antywibracyjne",
    "categoryPath": [
      "(260636) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące",
      "Akcesoria"
    ],
    "hierarchy": "(260636) Elektronika / RTV i AGD / AGD wolnostojące / Akcesoria / Maty antywibracyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260638) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące",
      "Akcesoria"
    ],
    "hierarchy": "(260638) Elektronika / RTV i AGD / AGD wolnostojące / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Węże do wody",
    "categoryPath": [
      "(260637) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące",
      "Akcesoria"
    ],
    "hierarchy": "(260637) Elektronika / RTV i AGD / AGD wolnostojące / Akcesoria / Węże do wody",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Łączniki pralki z suszarką",
    "categoryPath": [
      "(317264) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące",
      "Akcesoria"
    ],
    "hierarchy": "(317264) Elektronika / RTV i AGD / AGD wolnostojące / Akcesoria / Łączniki pralki z suszarką",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Chłodziarki do wina",
    "categoryPath": [
      "(256069) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(256069) Elektronika / RTV i AGD / AGD wolnostojące / Chłodziarki do wina",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(67435) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67435) Elektronika / RTV i AGD / AGD wolnostojące / Części",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kuchenki mikrofalowe",
    "categoryPath": [
      "(67417) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67417) Elektronika / RTV i AGD / AGD wolnostojące / Kuchenki mikrofalowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kuchenki przenośne",
    "categoryPath": [
      "(257963) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(257963) Elektronika / RTV i AGD / AGD wolnostojące / Kuchenki przenośne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kuchnie wolnostojące",
    "categoryPath": [
      "(257964) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(257964) Elektronika / RTV i AGD / AGD wolnostojące / Kuchnie wolnostojące",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lodówki",
    "categoryPath": [
      "(67430) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67430) Elektronika / RTV i AGD / AGD wolnostojące / Lodówki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Okapy",
    "categoryPath": [
      "(67436) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67436) Elektronika / RTV i AGD / AGD wolnostojące / Okapy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67485) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67485) Elektronika / RTV i AGD / AGD wolnostojące / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pralki",
    "categoryPath": [
      "(67441) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67441) Elektronika / RTV i AGD / AGD wolnostojące / Pralki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pralki wirnikowe i wirówki",
    "categoryPath": [
      "(256118) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(256118) Elektronika / RTV i AGD / AGD wolnostojące / Pralki wirnikowe i wirówki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pralko-suszarki",
    "categoryPath": [
      "(254438) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(254438) Elektronika / RTV i AGD / AGD wolnostojące / Pralko-suszarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Suszarki do ubrań",
    "categoryPath": [
      "(67484) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67484) Elektronika / RTV i AGD / AGD wolnostojące / Suszarki do ubrań",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Witryny chłodnicze",
    "categoryPath": [
      "(258913) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(258913) Elektronika / RTV i AGD / AGD wolnostojące / Witryny chłodnicze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zamrażarki",
    "categoryPath": [
      "(67433) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67433) Elektronika / RTV i AGD / AGD wolnostojące / Zamrażarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zestawy AGD",
    "categoryPath": [
      "(85160) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(85160) Elektronika / RTV i AGD / AGD wolnostojące / Zestawy AGD",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zmywarki",
    "categoryPath": [
      "(67443) Elektronika",
      "RTV i AGD",
      "AGD wolnostojące"
    ],
    "hierarchy": "(67443) Elektronika / RTV i AGD / AGD wolnostojące / Zmywarki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Folie i szkła ochronne",
    "categoryPath": [
      "(320560) Elektronika",
      "RTV i AGD",
      "Czytniki ebooków",
      "Akcesoria"
    ],
    "hierarchy": "(320560) Elektronika / RTV i AGD / Czytniki ebooków / Akcesoria / Folie i szkła ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(320563) Elektronika",
      "RTV i AGD",
      "Czytniki ebooków",
      "Akcesoria"
    ],
    "hierarchy": "(320563) Elektronika / RTV i AGD / Czytniki ebooków / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pokrowce i etui",
    "categoryPath": [
      "(320554) Elektronika",
      "RTV i AGD",
      "Czytniki ebooków",
      "Akcesoria"
    ],
    "hierarchy": "(320554) Elektronika / RTV i AGD / Czytniki ebooków / Akcesoria / Pokrowce i etui",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilanie",
    "categoryPath": [
      "(320557) Elektronika",
      "RTV i AGD",
      "Czytniki ebooków",
      "Akcesoria"
    ],
    "hierarchy": "(320557) Elektronika / RTV i AGD / Czytniki ebooków / Akcesoria / Zasilanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Czytniki",
    "categoryPath": [
      "(110212) Elektronika",
      "RTV i AGD",
      "Czytniki ebooków"
    ],
    "hierarchy": "(110212) Elektronika / RTV i AGD / Czytniki ebooków / Czytniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(305517) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(305517) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Amperomierze",
    "categoryPath": [
      "(67209) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67209) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Amperomierze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Anemometry",
    "categoryPath": [
      "(303789) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(303789) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Anemometry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Generatory",
    "categoryPath": [
      "(67210) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67210) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Generatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Higrometry i termohigrometry",
    "categoryPath": [
      "(303813) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(303813) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Higrometry i termohigrometry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Luksomierze",
    "categoryPath": [
      "(303825) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(303825) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Luksomierze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Multimetry",
    "categoryPath": [
      "(67211) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67211) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Multimetry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Oscyloskopy",
    "categoryPath": [
      "(67212) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67212) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Oscyloskopy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pirometry",
    "categoryPath": [
      "(67213) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67213) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Pirometry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67208) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67208) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sonometry",
    "categoryPath": [
      "(303837) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(303837) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Sonometry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Tachometry",
    "categoryPath": [
      "(303801) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(303801) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Tachometry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wagi elektroniczne",
    "categoryPath": [
      "(67214) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67214) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Wagi elektroniczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Woltomierze",
    "categoryPath": [
      "(67215) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Aparatura pomiarowa"
    ],
    "hierarchy": "(67215) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura pomiarowa / Woltomierze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Aparatura sterująca",
    "categoryPath": [
      "(67199) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika"
    ],
    "hierarchy": "(67199) Elektronika / RTV i AGD / Elektronika / Elektronika / Aparatura sterująca",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Czyszczenie",
    "categoryPath": [
      "(67217) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki"
    ],
    "hierarchy": "(67217) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Czyszczenie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(67222) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Izolacja"
    ],
    "hierarchy": "(67222) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Izolacja / Koszulki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(67223) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Izolacja"
    ],
    "hierarchy": "(67223) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Izolacja / Taśmy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zalewy, lakiery",
    "categoryPath": [
      "(67224) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Izolacja"
    ],
    "hierarchy": "(67224) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Izolacja / Zalewy, lakiery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Konserwacja, smarowanie",
    "categoryPath": [
      "(67219) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki"
    ],
    "hierarchy": "(67219) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Konserwacja, smarowanie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Cyna",
    "categoryPath": [
      "(67226) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Lutowanie"
    ],
    "hierarchy": "(67226) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Lutowanie / Cyna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kalafonia",
    "categoryPath": [
      "(67227) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Lutowanie"
    ],
    "hierarchy": "(67227) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Lutowanie / Kalafonia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pasty, topniki",
    "categoryPath": [
      "(67228) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Lutowanie"
    ],
    "hierarchy": "(67228) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Lutowanie / Pasty, topniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Laminat",
    "categoryPath": [
      "(67230) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Trawienie płytek"
    ],
    "hierarchy": "(67230) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Trawienie płytek / Laminat",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pisaki",
    "categoryPath": [
      "(67231) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Trawienie płytek"
    ],
    "hierarchy": "(67231) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Trawienie płytek / Pisaki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wytrawiacze",
    "categoryPath": [
      "(67232) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki",
      "Trawienie płytek"
    ],
    "hierarchy": "(67232) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Trawienie płytek / Wytrawiacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wykrywanie i naprawa usterek",
    "categoryPath": [
      "(305385) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Chemia dla elektroniki"
    ],
    "hierarchy": "(305385) Elektronika / RTV i AGD / Elektronika / Elektronika / Chemia dla elektroniki / Wykrywanie i naprawa usterek",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Cewki, dławiki",
    "categoryPath": [
      "(67244) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Cewki, filtry, generatory"
    ],
    "hierarchy": "(67244) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Cewki, filtry, generatory / Cewki, dławiki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ceramiczne",
    "categoryPath": [
      "(67247) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Cewki, filtry, generatory",
      "Filtry"
    ],
    "hierarchy": "(67247) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Cewki, filtry, generatory / Filtry / Ceramiczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "LC",
    "categoryPath": [
      "(67248) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Cewki, filtry, generatory",
      "Filtry"
    ],
    "hierarchy": "(67248) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Cewki, filtry, generatory / Filtry / LC",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Generatory",
    "categoryPath": [
      "(67249) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Cewki, filtry, generatory",
      "Kwarce"
    ],
    "hierarchy": "(67249) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Cewki, filtry, generatory / Kwarce / Generatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Rezonatory",
    "categoryPath": [
      "(67250) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Cewki, filtry, generatory",
      "Kwarce"
    ],
    "hierarchy": "(67250) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Cewki, filtry, generatory / Kwarce / Rezonatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Fotodiody",
    "categoryPath": [
      "(67253) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Diody"
    ],
    "hierarchy": "(67253) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Diody / Fotodiody",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "LED",
    "categoryPath": [
      "(67252) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Diody"
    ],
    "hierarchy": "(67252) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Diody / LED",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67251) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Diody"
    ],
    "hierarchy": "(67251) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Diody / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Mostki",
    "categoryPath": [
      "(67520) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Diody",
      "Prostownicze"
    ],
    "hierarchy": "(67520) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Diody / Prostownicze / Mostki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pojedyncze",
    "categoryPath": [
      "(67521) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Diody",
      "Prostownicze"
    ],
    "hierarchy": "(67521) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Diody / Prostownicze / Pojedyncze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zenera",
    "categoryPath": [
      "(67255) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Diody"
    ],
    "hierarchy": "(67255) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Diody / Zenera",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ceramiczne",
    "categoryPath": [
      "(67257) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Kondensatory"
    ],
    "hierarchy": "(67257) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Kondensatory / Ceramiczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Elektrolityczne",
    "categoryPath": [
      "(67258) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Kondensatory"
    ],
    "hierarchy": "(67258) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Kondensatory / Elektrolityczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Foliowe",
    "categoryPath": [
      "(67259) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Kondensatory"
    ],
    "hierarchy": "(67259) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Kondensatory / Foliowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67256) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Kondensatory"
    ],
    "hierarchy": "(67256) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Kondensatory / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Silnikowe",
    "categoryPath": [
      "(308785) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Kondensatory"
    ],
    "hierarchy": "(308785) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Kondensatory / Silnikowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wysokonapięciowe (>200V)",
    "categoryPath": [
      "(67260) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Kondensatory"
    ],
    "hierarchy": "(67260) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Kondensatory / Wysokonapięciowe (>200V)",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Lampy",
    "categoryPath": [
      "(67238) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne"
    ],
    "hierarchy": "(67238) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Lampy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67234) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne"
    ],
    "hierarchy": "(67234) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dużej mocy (powyżej 2W)",
    "categoryPath": [
      "(67263) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Rezystory"
    ],
    "hierarchy": "(67263) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Rezystory / Dużej mocy (powyżej 2W)",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Małej mocy (do 2W)",
    "categoryPath": [
      "(67262) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Rezystory"
    ],
    "hierarchy": "(67262) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Rezystory / Małej mocy (do 2W)",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Potencjometry",
    "categoryPath": [
      "(67264) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Rezystory"
    ],
    "hierarchy": "(67264) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Rezystory / Potencjometry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Tranzystory",
    "categoryPath": [
      "(67239) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne"
    ],
    "hierarchy": "(67239) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Tranzystory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Triaki",
    "categoryPath": [
      "(317273) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne"
    ],
    "hierarchy": "(317273) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Triaki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Analogowe",
    "categoryPath": [
      "(67266) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone"
    ],
    "hierarchy": "(67266) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Analogowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Cyfrowe",
    "categoryPath": [
      "(67267) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone"
    ],
    "hierarchy": "(67267) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Cyfrowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Końcówki mocy",
    "categoryPath": [
      "(67269) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone"
    ],
    "hierarchy": "(67269) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Końcówki mocy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "ARM",
    "categoryPath": [
      "(67276) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone",
      "Mikroprocesory"
    ],
    "hierarchy": "(67276) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Mikroprocesory / ARM",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Atmel",
    "categoryPath": [
      "(302621) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone",
      "Mikroprocesory"
    ],
    "hierarchy": "(302621) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Mikroprocesory / Atmel",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Microchip",
    "categoryPath": [
      "(67275) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone",
      "Mikroprocesory"
    ],
    "hierarchy": "(67275) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Mikroprocesory / Microchip",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pamięci",
    "categoryPath": [
      "(67271) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone"
    ],
    "hierarchy": "(67271) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Pamięci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67265) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone"
    ],
    "hierarchy": "(67265) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przetworniki AC i CA",
    "categoryPath": [
      "(67268) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone"
    ],
    "hierarchy": "(67268) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Przetworniki AC i CA",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Stabilizatory",
    "categoryPath": [
      "(260440) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne",
      "Układy scalone"
    ],
    "hierarchy": "(260440) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Układy scalone / Stabilizatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wyświetlacze",
    "categoryPath": [
      "(260437) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części elektroniczne"
    ],
    "hierarchy": "(260437) Elektronika / RTV i AGD / Elektronika / Elektronika / Części elektroniczne / Wyświetlacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Elementy montażowe",
    "categoryPath": [
      "(308809) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne"
    ],
    "hierarchy": "(308809) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Elementy montażowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(67325) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne"
    ],
    "hierarchy": "(67325) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Obudowy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pokrętła",
    "categoryPath": [
      "(67326) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne"
    ],
    "hierarchy": "(67326) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Pokrętła",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67324) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne"
    ],
    "hierarchy": "(67324) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Radiatory",
    "categoryPath": [
      "(67329) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne"
    ],
    "hierarchy": "(67329) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Radiatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "AC",
    "categoryPath": [
      "(67330) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne",
      "Silniki"
    ],
    "hierarchy": "(67330) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Silniki / AC",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "DC",
    "categoryPath": [
      "(67331) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne",
      "Silniki"
    ],
    "hierarchy": "(67331) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Silniki / DC",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Krokowe",
    "categoryPath": [
      "(67332) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części mechaniczne",
      "Silniki"
    ],
    "hierarchy": "(67332) Elektronika / RTV i AGD / Elektronika / Elektronika / Części mechaniczne / Silniki / Krokowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Podstawki",
    "categoryPath": [
      "(67343) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części stykowe"
    ],
    "hierarchy": "(67343) Elektronika / RTV i AGD / Elektronika / Elektronika / Części stykowe / Podstawki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Przekaźniki",
    "categoryPath": [
      "(260441) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części stykowe"
    ],
    "hierarchy": "(260441) Elektronika / RTV i AGD / Elektronika / Elektronika / Części stykowe / Przekaźniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(67342) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części stykowe"
    ],
    "hierarchy": "(67342) Elektronika / RTV i AGD / Elektronika / Elektronika / Części stykowe / Przełączniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Złącza",
    "categoryPath": [
      "(68368) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Części stykowe"
    ],
    "hierarchy": "(68368) Elektronika / RTV i AGD / Elektronika / Elektronika / Części stykowe / Złącza",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(67204) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika"
    ],
    "hierarchy": "(67204) Elektronika / RTV i AGD / Elektronika / Elektronika / Literatura",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Dysze do gorącego powietrza",
    "categoryPath": [
      "(305409) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305409) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Dysze do gorącego powietrza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Gąbki, czyściki do grotów",
    "categoryPath": [
      "(67359) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(67359) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Gąbki, czyściki do grotów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(305421) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305421) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Lupy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Maty",
    "categoryPath": [
      "(305433) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305433) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Maty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Opaski antystatyczne",
    "categoryPath": [
      "(305445) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305445) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Opaski antystatyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Otwieraki",
    "categoryPath": [
      "(305457) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305457) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Otwieraki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Plecionki do cyny",
    "categoryPath": [
      "(67360) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(67360) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Plecionki do cyny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Podstawki pod lutownicę",
    "categoryPath": [
      "(305481) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305481) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Podstawki pod lutownicę",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67358) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(67358) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pędzelki i szczotki",
    "categoryPath": [
      "(305469) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305469) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Pędzelki i szczotki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Sita BGA",
    "categoryPath": [
      "(305493) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305493) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Sita BGA",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Srebrzanki",
    "categoryPath": [
      "(67361) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(67361) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Srebrzanki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty montażowe",
    "categoryPath": [
      "(305505) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia",
      "Akcesoria"
    ],
    "hierarchy": "(305505) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Akcesoria / Uchwyty montażowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Groty do lutownic",
    "categoryPath": [
      "(67348) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia"
    ],
    "hierarchy": "(67348) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Groty do lutownic",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Nożyce do kabli",
    "categoryPath": [
      "(67350) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia"
    ],
    "hierarchy": "(67350) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Nożyce do kabli",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odsysacze",
    "categoryPath": [
      "(67351) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia"
    ],
    "hierarchy": "(67351) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Odsysacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pęsety",
    "categoryPath": [
      "(67352) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia"
    ],
    "hierarchy": "(67352) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Pęsety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szczypce",
    "categoryPath": [
      "(67354) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia"
    ],
    "hierarchy": "(67354) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Szczypce",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zaciskarki",
    "categoryPath": [
      "(67357) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia"
    ],
    "hierarchy": "(67357) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Zaciskarki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ściągacze izolacji",
    "categoryPath": [
      "(67355) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Narzędzia"
    ],
    "hierarchy": "(67355) Elektronika / RTV i AGD / Elektronika / Elektronika / Narzędzia / Ściągacze izolacji",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67197) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika"
    ],
    "hierarchy": "(67197) Elektronika / RTV i AGD / Elektronika / Elektronika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Programatory",
    "categoryPath": [
      "(68366) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika"
    ],
    "hierarchy": "(68366) Elektronika / RTV i AGD / Elektronika / Elektronika / Programatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Listwy LED",
    "categoryPath": [
      "(67364) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Płytki drukowane, moduły"
    ],
    "hierarchy": "(67364) Elektronika / RTV i AGD / Elektronika / Elektronika / Płytki drukowane, moduły / Listwy LED",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Moduły",
    "categoryPath": [
      "(67363) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Płytki drukowane, moduły"
    ],
    "hierarchy": "(67363) Elektronika / RTV i AGD / Elektronika / Elektronika / Płytki drukowane, moduły / Moduły",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Przejściówki",
    "categoryPath": [
      "(67366) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Płytki drukowane, moduły"
    ],
    "hierarchy": "(67366) Elektronika / RTV i AGD / Elektronika / Elektronika / Płytki drukowane, moduły / Przejściówki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Płytki uniwersalne",
    "categoryPath": [
      "(67365) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Płytki drukowane, moduły"
    ],
    "hierarchy": "(67365) Elektronika / RTV i AGD / Elektronika / Elektronika / Płytki drukowane, moduły / Płytki uniwersalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy do montażu",
    "categoryPath": [
      "(67367) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Płytki drukowane, moduły"
    ],
    "hierarchy": "(67367) Elektronika / RTV i AGD / Elektronika / Elektronika / Płytki drukowane, moduły / Zestawy do montażu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "RFID i SmartCard",
    "categoryPath": [
      "(68367) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika"
    ],
    "hierarchy": "(68367) Elektronika / RTV i AGD / Elektronika / Elektronika / RFID i SmartCard",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wykrywacze podsłuchów",
    "categoryPath": [
      "(319658) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika"
    ],
    "hierarchy": "(319658) Elektronika / RTV i AGD / Elektronika / Elektronika / Wykrywacze podsłuchów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(67369) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie"
    ],
    "hierarchy": "(67369) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Akumulatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Bezpieczniki",
    "categoryPath": [
      "(67371) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie"
    ],
    "hierarchy": "(67371) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Bezpieczniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Koszyki na baterie",
    "categoryPath": [
      "(67372) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie"
    ],
    "hierarchy": "(67372) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Koszyki na baterie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Transformatory",
    "categoryPath": [
      "(67373) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie"
    ],
    "hierarchy": "(67373) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Transformatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Do LED",
    "categoryPath": [
      "(308821) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie",
      "Zasilacze"
    ],
    "hierarchy": "(308821) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Zasilacze / Do LED",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Laboratoryjne",
    "categoryPath": [
      "(67376) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie",
      "Zasilacze"
    ],
    "hierarchy": "(67376) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Zasilacze / Laboratoryjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Na szynę DIN",
    "categoryPath": [
      "(308833) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie",
      "Zasilacze"
    ],
    "hierarchy": "(308833) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Zasilacze / Na szynę DIN",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67375) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie",
      "Zasilacze"
    ],
    "hierarchy": "(67375) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Zasilacze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Standardowe",
    "categoryPath": [
      "(67378) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie",
      "Zasilacze"
    ],
    "hierarchy": "(67378) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Zasilacze / Standardowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Uniwersalne",
    "categoryPath": [
      "(67379) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie",
      "Zasilacze"
    ],
    "hierarchy": "(67379) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Zasilacze / Uniwersalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(67377) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Elektronika",
      "Zasilanie",
      "Zasilacze"
    ],
    "hierarchy": "(67377) Elektronika / RTV i AGD / Elektronika / Elektronika / Zasilanie / Zasilacze / Ładowarki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Antenowe",
    "categoryPath": [
      "(67295) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67295) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Coaxial",
    "categoryPath": [
      "(67297) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67297) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Coaxial",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Component video",
    "categoryPath": [
      "(67298) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67298) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Component video",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "D-Sub (VGA)",
    "categoryPath": [
      "(67299) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67299) Elektronika / RTV i AGD / Elektronika / Kable, przewody / D-Sub (VGA)",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "DVI i HDMI",
    "categoryPath": [
      "(304609) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(304609) Elektronika / RTV i AGD / Elektronika / Kable, przewody / DVI i HDMI",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Do wzmacniacza",
    "categoryPath": [
      "(67316) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody",
      "Dedykowane dla car audio"
    ],
    "hierarchy": "(67316) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Dedykowane dla car audio / Do wzmacniacza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Do zmieniarki",
    "categoryPath": [
      "(67317) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody",
      "Dedykowane dla car audio"
    ],
    "hierarchy": "(67317) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Dedykowane dla car audio / Do zmieniarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilające",
    "categoryPath": [
      "(67318) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody",
      "Dedykowane dla car audio"
    ],
    "hierarchy": "(67318) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Dedykowane dla car audio / Zasilające",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(67319) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody",
      "Dedykowane dla car audio"
    ],
    "hierarchy": "(67319) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Dedykowane dla car audio / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Do subwooferów",
    "categoryPath": [
      "(76266) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(76266) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Do subwooferów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Euro",
    "categoryPath": [
      "(303437) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(303437) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Euro",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głośnikowe",
    "categoryPath": [
      "(67303) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67303) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Głośnikowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Jack i Cinch",
    "categoryPath": [
      "(305293) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(305293) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Jack i Cinch",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Oploty na kable",
    "categoryPath": [
      "(308869) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(308869) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Oploty na kable",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Optyczne",
    "categoryPath": [
      "(67304) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67304) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Optyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Organizery na kable",
    "categoryPath": [
      "(308845) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(308845) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Organizery na kable",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67307) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67307) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "S-Video (SVHS)",
    "categoryPath": [
      "(303417) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(303417) Elektronika / RTV i AGD / Elektronika / Kable, przewody / S-Video (SVHS)",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilające",
    "categoryPath": [
      "(67306) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Kable, przewody"
    ],
    "hierarchy": "(67306) Elektronika / RTV i AGD / Elektronika / Kable, przewody / Zasilające",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Listwy",
    "categoryPath": [
      "(76264) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Listwy zasilające"
    ],
    "hierarchy": "(76264) Elektronika / RTV i AGD / Elektronika / Listwy zasilające / Listwy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Antenowe",
    "categoryPath": [
      "(67288) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(67288) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / Antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "BNC",
    "categoryPath": [
      "(76273) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(76273) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / BNC",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Cinch",
    "categoryPath": [
      "(67289) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(67289) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / Cinch",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Euro",
    "categoryPath": [
      "(67290) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(67290) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / Euro",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głośnikowe",
    "categoryPath": [
      "(67291) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(67291) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / Głośnikowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "HDMI i DVI",
    "categoryPath": [
      "(76274) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(76274) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / HDMI i DVI",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Jack",
    "categoryPath": [
      "(67292) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(67292) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / Jack",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67294) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(67294) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "SVHS",
    "categoryPath": [
      "(67293) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(67293) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / SVHS",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "USB",
    "categoryPath": [
      "(306369) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(306369) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / USB",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "XLR",
    "categoryPath": [
      "(306381) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(306381) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / XLR",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilające",
    "categoryPath": [
      "(306357) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki",
      "Gniazda i wtyki"
    ],
    "hierarchy": "(306357) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Gniazda i wtyki / Zasilające",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Przejściówki",
    "categoryPath": [
      "(67285) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki"
    ],
    "hierarchy": "(67285) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Przejściówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Splittery antenowe",
    "categoryPath": [
      "(67286) Elektronika",
      "RTV i AGD",
      "Elektronika",
      "Wtyki, gniazda, przejściówki"
    ],
    "hierarchy": "(67286) Elektronika / RTV i AGD / Elektronika / Wtyki, gniazda, przejściówki / Splittery antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie i szkła ochronne",
    "categoryPath": [
      "(76275) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(76275) Elektronika / RTV i AGD / GPS i akcesoria / Akcesoria / Folie i szkła ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(67101) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(67101) Elektronika / RTV i AGD / GPS i akcesoria / Akcesoria / Pokrowce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(67102) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(67102) Elektronika / RTV i AGD / GPS i akcesoria / Akcesoria / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ładowarki, zasilacze",
    "categoryPath": [
      "(67103) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(67103) Elektronika / RTV i AGD / GPS i akcesoria / Akcesoria / Ładowarki, zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Anteny GPS",
    "categoryPath": [
      "(67096) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria"
    ],
    "hierarchy": "(67096) Elektronika / RTV i AGD / GPS i akcesoria / Anteny GPS",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Części i podzespoły",
    "categoryPath": [
      "(110214) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria"
    ],
    "hierarchy": "(110214) Elektronika / RTV i AGD / GPS i akcesoria / Części i podzespoły",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lokalizacja GPS",
    "categoryPath": [
      "(147886) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria"
    ],
    "hierarchy": "(147886) Elektronika / RTV i AGD / GPS i akcesoria / Lokalizacja GPS",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Oprogramowanie",
    "categoryPath": [
      "(67097) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria"
    ],
    "hierarchy": "(67097) Elektronika / RTV i AGD / GPS i akcesoria / Oprogramowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67100) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria"
    ],
    "hierarchy": "(67100) Elektronika / RTV i AGD / GPS i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(305297) Elektronika",
      "RTV i AGD",
      "GPS i akcesoria"
    ],
    "hierarchy": "(305297) Elektronika / RTV i AGD / GPS i akcesoria / Urządzenia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria do podgrzewaczy tytoniu",
    "categoryPath": [
      "(321903) Elektronika",
      "RTV i AGD",
      "Gadżety elektroniczne"
    ],
    "hierarchy": "(321903) Elektronika / RTV i AGD / Gadżety elektroniczne / Akcesoria do podgrzewaczy tytoniu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stacje pogody",
    "categoryPath": [
      "(14201) Elektronika",
      "RTV i AGD",
      "Gadżety elektroniczne"
    ],
    "hierarchy": "(14201) Elektronika / RTV i AGD / Gadżety elektroniczne / Stacje pogody",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Termometry",
    "categoryPath": [
      "(14204) Elektronika",
      "RTV i AGD",
      "Gadżety elektroniczne"
    ],
    "hierarchy": "(14204) Elektronika / RTV i AGD / Gadżety elektroniczne / Termometry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Translatory",
    "categoryPath": [
      "(14202) Elektronika",
      "RTV i AGD",
      "Gadżety elektroniczne"
    ],
    "hierarchy": "(14202) Elektronika / RTV i AGD / Gadżety elektroniczne / Translatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(8788) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(8788) Elektronika / RTV i AGD / Kamery / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Fotopułapki",
    "categoryPath": [
      "(308581) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(308581) Elektronika / RTV i AGD / Kamery / Fotopułapki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kamery analogowe",
    "categoryPath": [
      "(258966) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(258966) Elektronika / RTV i AGD / Kamery / Kamery analogowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kamery cyfrowe",
    "categoryPath": [
      "(258938) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(258938) Elektronika / RTV i AGD / Kamery / Kamery cyfrowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Baterie i ładowarki",
    "categoryPath": [
      "(250948) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe",
      "Akcesoria"
    ],
    "hierarchy": "(250948) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Akcesoria / Baterie i ładowarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(250952) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe",
      "Akcesoria"
    ],
    "hierarchy": "(250952) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Akcesoria / Filtry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie i szkła ochronne",
    "categoryPath": [
      "(308329) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe",
      "Akcesoria"
    ],
    "hierarchy": "(308329) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Akcesoria / Folie i szkła ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mocowania i uchwyty",
    "categoryPath": [
      "(250951) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe",
      "Akcesoria"
    ],
    "hierarchy": "(250951) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Akcesoria / Mocowania i uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(250949) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe",
      "Akcesoria"
    ],
    "hierarchy": "(250949) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Akcesoria / Obudowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pokrowce i etui",
    "categoryPath": [
      "(308317) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe",
      "Akcesoria"
    ],
    "hierarchy": "(308317) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Akcesoria / Pokrowce i etui",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(250953) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe",
      "Akcesoria"
    ],
    "hierarchy": "(250953) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kamery",
    "categoryPath": [
      "(250946) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Kamery sportowe"
    ],
    "hierarchy": "(250946) Elektronika / RTV i AGD / Kamery / Kamery sportowe / Kamery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Literatura i instrukcje",
    "categoryPath": [
      "(14208) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(14208) Elektronika / RTV i AGD / Kamery / Literatura i instrukcje",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mini kamery",
    "categoryPath": [
      "(76284) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(76284) Elektronika / RTV i AGD / Kamery / Mini kamery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nośniki",
    "categoryPath": [
      "(8789) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(8789) Elektronika / RTV i AGD / Kamery / Nośniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(8791) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(8791) Elektronika / RTV i AGD / Kamery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe kamery",
    "categoryPath": [
      "(76286) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(76286) Elektronika / RTV i AGD / Kamery / Pozostałe kamery",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Torby, futerały",
    "categoryPath": [
      "(14206) Elektronika",
      "RTV i AGD",
      "Kamery"
    ],
    "hierarchy": "(14206) Elektronika / RTV i AGD / Kamery / Torby, futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(301110) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Zasilanie"
    ],
    "hierarchy": "(301110) Elektronika / RTV i AGD / Kamery / Zasilanie / Akumulatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(8806) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Zasilanie"
    ],
    "hierarchy": "(8806) Elektronika / RTV i AGD / Kamery / Zasilanie / Zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(8805) Elektronika",
      "RTV i AGD",
      "Kamery",
      "Zasilanie"
    ],
    "hierarchy": "(8805) Elektronika / RTV i AGD / Kamery / Zasilanie / Ładowarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Oryginalne",
    "categoryPath": [
      "(63490) Elektronika",
      "RTV i AGD",
      "Piloty"
    ],
    "hierarchy": "(63490) Elektronika / RTV i AGD / Piloty / Oryginalne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uniwersalne",
    "categoryPath": [
      "(63491) Elektronika",
      "RTV i AGD",
      "Piloty"
    ],
    "hierarchy": "(63491) Elektronika / RTV i AGD / Piloty / Uniwersalne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zamienniki",
    "categoryPath": [
      "(63638) Elektronika",
      "RTV i AGD",
      "Piloty"
    ],
    "hierarchy": "(63638) Elektronika / RTV i AGD / Piloty / Zamienniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(1329) Elektronika",
      "RTV i AGD",
      "Pozostałe"
    ],
    "hierarchy": "(1329) Elektronika / RTV i AGD / Pozostałe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Adaptery Bluetooth",
    "categoryPath": [
      "(309133) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(309133) Elektronika / RTV i AGD / Sprzęt audio dla domu / Adaptery Bluetooth",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Amplitunery",
    "categoryPath": [
      "(358) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(358) Elektronika / RTV i AGD / Sprzęt audio dla domu / Amplitunery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Części i podzespoły",
    "categoryPath": [
      "(49122) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(49122) Elektronika / RTV i AGD / Sprzęt audio dla domu / Części i podzespoły",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "DIY",
    "categoryPath": [
      "(148402) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(148402) Elektronika / RTV i AGD / Sprzęt audio dla domu / DIY",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Elementy wygłuszające",
    "categoryPath": [
      "(63476) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(63476) Elektronika / RTV i AGD / Sprzęt audio dla domu / Elementy wygłuszające",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(76334) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Gramofony"
    ],
    "hierarchy": "(76334) Elektronika / RTV i AGD / Sprzęt audio dla domu / Gramofony / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Części zamienne",
    "categoryPath": [
      "(20081) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Gramofony"
    ],
    "hierarchy": "(20081) Elektronika / RTV i AGD / Sprzęt audio dla domu / Gramofony / Części zamienne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Gramofony",
    "categoryPath": [
      "(20078) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Gramofony"
    ],
    "hierarchy": "(20078) Elektronika / RTV i AGD / Sprzęt audio dla domu / Gramofony / Gramofony",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Igły do gramofonów",
    "categoryPath": [
      "(260570) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Gramofony"
    ],
    "hierarchy": "(260570) Elektronika / RTV i AGD / Sprzęt audio dla domu / Gramofony / Igły do gramofonów",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Maty",
    "categoryPath": [
      "(20079) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Gramofony"
    ],
    "hierarchy": "(20079) Elektronika / RTV i AGD / Sprzęt audio dla domu / Gramofony / Maty",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Przedwzmacniacze gramofonowe",
    "categoryPath": [
      "(76335) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Gramofony"
    ],
    "hierarchy": "(76335) Elektronika / RTV i AGD / Sprzęt audio dla domu / Gramofony / Przedwzmacniacze gramofonowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wkładki gramofonowe",
    "categoryPath": [
      "(20080) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Gramofony"
    ],
    "hierarchy": "(20080) Elektronika / RTV i AGD / Sprzęt audio dla domu / Gramofony / Wkładki gramofonowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Części zamienne",
    "categoryPath": [
      "(66930) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(66930) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Części zamienne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Niskotonowe",
    "categoryPath": [
      "(66928) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(66928) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Niskotonowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(66933) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(66933) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sufitowe",
    "categoryPath": [
      "(76336) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(76336) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Sufitowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Szerokopasmowe",
    "categoryPath": [
      "(66929) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(66929) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Szerokopasmowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wysokotonowe",
    "categoryPath": [
      "(66926) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(66926) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Wysokotonowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zwrotnice",
    "categoryPath": [
      "(66931) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(66931) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Zwrotnice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Średniotonowe",
    "categoryPath": [
      "(66927) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Głośniki"
    ],
    "hierarchy": "(66927) Elektronika / RTV i AGD / Sprzęt audio dla domu / Głośniki / Średniotonowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Instrukcje i katalogi",
    "categoryPath": [
      "(5220) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(5220) Elektronika / RTV i AGD / Sprzęt audio dla domu / Instrukcje i katalogi",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Centralne",
    "categoryPath": [
      "(8992) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Kolumny głośnikowe",
      "Kolumny głośnikowe"
    ],
    "hierarchy": "(8992) Elektronika / RTV i AGD / Sprzęt audio dla domu / Kolumny głośnikowe / Kolumny głośnikowe / Centralne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Do zabudowy",
    "categoryPath": [
      "(76337) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Kolumny głośnikowe",
      "Kolumny głośnikowe"
    ],
    "hierarchy": "(76337) Elektronika / RTV i AGD / Sprzęt audio dla domu / Kolumny głośnikowe / Kolumny głośnikowe / Do zabudowy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kino domowe",
    "categoryPath": [
      "(8993) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Kolumny głośnikowe",
      "Kolumny głośnikowe"
    ],
    "hierarchy": "(8993) Elektronika / RTV i AGD / Sprzęt audio dla domu / Kolumny głośnikowe / Kolumny głośnikowe / Kino domowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Stereo",
    "categoryPath": [
      "(302997) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Kolumny głośnikowe",
      "Kolumny głośnikowe"
    ],
    "hierarchy": "(302997) Elektronika / RTV i AGD / Sprzęt audio dla domu / Kolumny głośnikowe / Kolumny głośnikowe / Stereo",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Subwoofery",
    "categoryPath": [
      "(8994) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Kolumny głośnikowe",
      "Kolumny głośnikowe"
    ],
    "hierarchy": "(8994) Elektronika / RTV i AGD / Sprzęt audio dla domu / Kolumny głośnikowe / Kolumny głośnikowe / Subwoofery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Stojaki na kolumny",
    "categoryPath": [
      "(260571) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Kolumny głośnikowe",
      "Podstawy, stojaki, uchwyty"
    ],
    "hierarchy": "(260571) Elektronika / RTV i AGD / Sprzęt audio dla domu / Kolumny głośnikowe / Podstawy, stojaki, uchwyty / Stojaki na kolumny",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Uchwyty do kolumn",
    "categoryPath": [
      "(260572) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Kolumny głośnikowe",
      "Podstawy, stojaki, uchwyty"
    ],
    "hierarchy": "(260572) Elektronika / RTV i AGD / Sprzęt audio dla domu / Kolumny głośnikowe / Podstawy, stojaki, uchwyty / Uchwyty do kolumn",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Konwertery DAC",
    "categoryPath": [
      "(76328) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(76328) Elektronika / RTV i AGD / Sprzęt audio dla domu / Konwertery DAC",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Korektory graficzne",
    "categoryPath": [
      "(698) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(698) Elektronika / RTV i AGD / Sprzęt audio dla domu / Korektory graficzne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kasetowe",
    "categoryPath": [
      "(260438) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Magnetofony i nośniki"
    ],
    "hierarchy": "(260438) Elektronika / RTV i AGD / Sprzęt audio dla domu / Magnetofony i nośniki / Kasetowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Nośniki",
    "categoryPath": [
      "(66935) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Magnetofony i nośniki"
    ],
    "hierarchy": "(66935) Elektronika / RTV i AGD / Sprzęt audio dla domu / Magnetofony i nośniki / Nośniki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Szpulowe",
    "categoryPath": [
      "(66934) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Magnetofony i nośniki"
    ],
    "hierarchy": "(66934) Elektronika / RTV i AGD / Sprzęt audio dla domu / Magnetofony i nośniki / Szpulowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Odtwarzacze CD i MD",
    "categoryPath": [
      "(304613) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(304613) Elektronika / RTV i AGD / Sprzęt audio dla domu / Odtwarzacze CD i MD",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Odtwarzacze sieciowe",
    "categoryPath": [
      "(303021) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(303021) Elektronika / RTV i AGD / Sprzęt audio dla domu / Odtwarzacze sieciowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(19) Elektronika / RTV i AGD / Sprzęt audio dla domu / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Radia",
    "categoryPath": [
      "(14310) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(14310) Elektronika / RTV i AGD / Sprzęt audio dla domu / Radia",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Stoliki",
    "categoryPath": [
      "(73140) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(73140) Elektronika / RTV i AGD / Sprzęt audio dla domu / Stoliki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Tunery radiowe",
    "categoryPath": [
      "(260439) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(260439) Elektronika / RTV i AGD / Sprzęt audio dla domu / Tunery radiowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wieże stereo",
    "categoryPath": [
      "(260119) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(260119) Elektronika / RTV i AGD / Sprzęt audio dla domu / Wieże stereo",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Końcówki mocy",
    "categoryPath": [
      "(20118) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Wzmacniacze i pokrewne"
    ],
    "hierarchy": "(20118) Elektronika / RTV i AGD / Sprzęt audio dla domu / Wzmacniacze i pokrewne / Końcówki mocy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Przedwzmacniacze",
    "categoryPath": [
      "(20119) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Wzmacniacze i pokrewne"
    ],
    "hierarchy": "(20119) Elektronika / RTV i AGD / Sprzęt audio dla domu / Wzmacniacze i pokrewne / Przedwzmacniacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wzmacniacze",
    "categoryPath": [
      "(257182) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Wzmacniacze i pokrewne"
    ],
    "hierarchy": "(257182) Elektronika / RTV i AGD / Sprzęt audio dla domu / Wzmacniacze i pokrewne / Wzmacniacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wzmacniacze lampowe",
    "categoryPath": [
      "(20121) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu",
      "Wzmacniacze i pokrewne"
    ],
    "hierarchy": "(20121) Elektronika / RTV i AGD / Sprzęt audio dla domu / Wzmacniacze i pokrewne / Wzmacniacze lampowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zestawy stereo",
    "categoryPath": [
      "(76329) Elektronika",
      "RTV i AGD",
      "Sprzęt audio dla domu"
    ],
    "hierarchy": "(76329) Elektronika / RTV i AGD / Sprzęt audio dla domu / Zestawy stereo",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Dyktafony",
    "categoryPath": [
      "(20137) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(20137) Elektronika / RTV i AGD / Sprzęt audio przenośny / Dyktafony",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Głośniki przenośne",
    "categoryPath": [
      "(49128) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(49128) Elektronika / RTV i AGD / Sprzęt audio przenośny / Głośniki przenośne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "MP3",
    "categoryPath": [
      "(258348) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(258348) Elektronika / RTV i AGD / Sprzęt audio przenośny / MP3",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "MP4",
    "categoryPath": [
      "(258349) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(258349) Elektronika / RTV i AGD / Sprzęt audio przenośny / MP4",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Miniradio",
    "categoryPath": [
      "(20140) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(20140) Elektronika / RTV i AGD / Sprzęt audio przenośny / Miniradio",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Odtwarzacze CD, MD i kasetowe",
    "categoryPath": [
      "(307033) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(307033) Elektronika / RTV i AGD / Sprzęt audio przenośny / Odtwarzacze CD, MD i kasetowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pokrowce i etui",
    "categoryPath": [
      "(260442) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(260442) Elektronika / RTV i AGD / Sprzęt audio przenośny / Pokrowce i etui",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(20145) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(20145) Elektronika / RTV i AGD / Sprzęt audio przenośny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Radioodtwarzacze",
    "categoryPath": [
      "(303729) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(303729) Elektronika / RTV i AGD / Sprzęt audio przenośny / Radioodtwarzacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Sprzęt do karaoke",
    "categoryPath": [
      "(258011) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(258011) Elektronika / RTV i AGD / Sprzęt audio przenośny / Sprzęt do karaoke",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(49129) Elektronika",
      "RTV i AGD",
      "Sprzęt audio przenośny"
    ],
    "hierarchy": "(49129) Elektronika / RTV i AGD / Sprzęt audio przenośny / Ładowarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Adaptery do sterowania z kierownicy",
    "categoryPath": [
      "(259080) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria"
    ],
    "hierarchy": "(259080) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Adaptery do sterowania z kierownicy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kieszenie i półkieszenie",
    "categoryPath": [
      "(67160) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kieszenie, ramki"
    ],
    "hierarchy": "(67160) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kieszenie, ramki / Kieszenie i półkieszenie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Klucze",
    "categoryPath": [
      "(67162) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kieszenie, ramki"
    ],
    "hierarchy": "(67162) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kieszenie, ramki / Klucze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(67163) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kieszenie, ramki"
    ],
    "hierarchy": "(67163) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kieszenie, ramki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ramki do paneli radioodtwarzaczy",
    "categoryPath": [
      "(67161) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kieszenie, ramki"
    ],
    "hierarchy": "(67161) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kieszenie, ramki / Ramki do paneli radioodtwarzaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ramki radiowe",
    "categoryPath": [
      "(67159) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kieszenie, ramki"
    ],
    "hierarchy": "(67159) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kieszenie, ramki / Ramki radiowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Adaptery Bluetooth",
    "categoryPath": [
      "(304269) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(304269) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Adaptery Bluetooth",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Adaptery antenowe",
    "categoryPath": [
      "(304257) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(304257) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Adaptery antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Adaptery do instalacji samochodowej",
    "categoryPath": [
      "(67164) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(67164) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Adaptery do instalacji samochodowej",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złącza do głośników",
    "categoryPath": [
      "(304281) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(304281) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Złącza do głośników",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złącza do radioodbiorników",
    "categoryPath": [
      "(67166) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(67166) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Złącza do radioodbiorników",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złącza do radioodbiorników fabrycznych",
    "categoryPath": [
      "(67165) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(67165) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Złącza do radioodbiorników fabrycznych",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złącza do wzmacniaczy",
    "categoryPath": [
      "(304293) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(304293) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Złącza do wzmacniaczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złącza do zestawów głośnomówiących",
    "categoryPath": [
      "(304305) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(304305) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Złącza do zestawów głośnomówiących",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złącza do zmieniarek",
    "categoryPath": [
      "(304317) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Akcesoria",
      "Kostki ISO, złączki, kable"
    ],
    "hierarchy": "(304317) Elektronika / RTV i AGD / Sprzęt car audio / Akcesoria / Kostki ISO, złączki, kable / Złącza do zmieniarek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Elementy wygłuszające",
    "categoryPath": [
      "(85172) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(85172) Elektronika / RTV i AGD / Sprzęt car audio / Elementy wygłuszające",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Emulatory zmieniarek",
    "categoryPath": [
      "(302594) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(302594) Elektronika / RTV i AGD / Sprzęt car audio / Emulatory zmieniarek",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "100 mm",
    "categoryPath": [
      "(5166) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5166) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 100 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "120 mm",
    "categoryPath": [
      "(67169) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(67169) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 120 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "130 i 135 mm",
    "categoryPath": [
      "(5167) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5167) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 130 i 135 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "160 i 165 mm",
    "categoryPath": [
      "(5168) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5168) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 160 i 165 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "200 mm",
    "categoryPath": [
      "(5169) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5169) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 200 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "250 mm",
    "categoryPath": [
      "(45594) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(45594) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 250 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "300 mm",
    "categoryPath": [
      "(14168) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(14168) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 300 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "380 mm i większe",
    "categoryPath": [
      "(67170) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(67170) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 380 mm i większe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "4x6''",
    "categoryPath": [
      "(52550) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(52550) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 4x6''",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "5x7\"",
    "categoryPath": [
      "(67171) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(67171) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 5x7\"",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "6x9''",
    "categoryPath": [
      "(5174) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5174) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 6x9''",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "87 mm",
    "categoryPath": [
      "(67168) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(67168) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / 87 mm",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Dystanse",
    "categoryPath": [
      "(67172) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(67172) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / Dystanse",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Elementy zabudowy",
    "categoryPath": [
      "(20162) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(20162) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / Elementy zabudowy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5173) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5173) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzynie basowe i tuby",
    "categoryPath": [
      "(5170) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5170) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / Skrzynie basowe i tuby",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wysokotonowe",
    "categoryPath": [
      "(5171) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5171) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / Wysokotonowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zestawy głośnikowe",
    "categoryPath": [
      "(5172) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Głośniki"
    ],
    "hierarchy": "(5172) Elektronika / RTV i AGD / Sprzęt car audio / Głośniki / Zestawy głośnikowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Instrukcje i katalogi",
    "categoryPath": [
      "(5192) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(5192) Elektronika / RTV i AGD / Sprzęt car audio / Instrukcje i katalogi",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kondensatory, filtry",
    "categoryPath": [
      "(73150) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(73150) Elektronika / RTV i AGD / Sprzęt car audio / Kondensatory, filtry",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Panele LCD/TV",
    "categoryPath": [
      "(20175) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(20175) Elektronika / RTV i AGD / Sprzęt car audio / Panele LCD/TV",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Etui",
    "categoryPath": [
      "(20164) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Panele i etui"
    ],
    "hierarchy": "(20164) Elektronika / RTV i AGD / Sprzęt car audio / Panele i etui / Etui",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Panele",
    "categoryPath": [
      "(301118) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio",
      "Panele i etui"
    ],
    "hierarchy": "(301118) Elektronika / RTV i AGD / Sprzęt car audio / Panele i etui / Panele",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Piloty i joysticki",
    "categoryPath": [
      "(5191) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(5191) Elektronika / RTV i AGD / Sprzęt car audio / Piloty i joysticki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(12) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(12) Elektronika / RTV i AGD / Sprzęt car audio / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Procesory dźwięku",
    "categoryPath": [
      "(14174) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(14174) Elektronika / RTV i AGD / Sprzęt car audio / Procesory dźwięku",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Radioodtwarzacze",
    "categoryPath": [
      "(712) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(712) Elektronika / RTV i AGD / Sprzęt car audio / Radioodtwarzacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Transmitery",
    "categoryPath": [
      "(14172) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(14172) Elektronika / RTV i AGD / Sprzęt car audio / Transmitery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wzmacniacze",
    "categoryPath": [
      "(260176) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(260176) Elektronika / RTV i AGD / Sprzęt car audio / Wzmacniacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zmieniarki CD",
    "categoryPath": [
      "(302613) Elektronika",
      "RTV i AGD",
      "Sprzęt car audio"
    ],
    "hierarchy": "(302613) Elektronika / RTV i AGD / Sprzęt car audio / Zmieniarki CD",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kable Null Modem",
    "categoryPath": [
      "(67136) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny",
      "Akcesoria"
    ],
    "hierarchy": "(67136) Elektronika / RTV i AGD / Sprzęt satelitarny / Akcesoria / Kable Null Modem",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty, moduły CA",
    "categoryPath": [
      "(67137) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny",
      "Akcesoria"
    ],
    "hierarchy": "(67137) Elektronika / RTV i AGD / Sprzęt satelitarny / Akcesoria / Karty, moduły CA",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mierniki, wzmacniacze sygnału",
    "categoryPath": [
      "(67138) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny",
      "Akcesoria"
    ],
    "hierarchy": "(67138) Elektronika / RTV i AGD / Sprzęt satelitarny / Akcesoria / Mierniki, wzmacniacze sygnału",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Modulatory",
    "categoryPath": [
      "(76361) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny",
      "Akcesoria"
    ],
    "hierarchy": "(76361) Elektronika / RTV i AGD / Sprzęt satelitarny / Akcesoria / Modulatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Splittery",
    "categoryPath": [
      "(67139) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny",
      "Akcesoria"
    ],
    "hierarchy": "(67139) Elektronika / RTV i AGD / Sprzęt satelitarny / Akcesoria / Splittery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stojaki antenowe",
    "categoryPath": [
      "(76362) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny",
      "Akcesoria"
    ],
    "hierarchy": "(76362) Elektronika / RTV i AGD / Sprzęt satelitarny / Akcesoria / Stojaki antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Anteny",
    "categoryPath": [
      "(67130) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny"
    ],
    "hierarchy": "(67130) Elektronika / RTV i AGD / Sprzęt satelitarny / Anteny",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Części i podzespoły",
    "categoryPath": [
      "(127361) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny"
    ],
    "hierarchy": "(127361) Elektronika / RTV i AGD / Sprzęt satelitarny / Części i podzespoły",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Doładowania",
    "categoryPath": [
      "(127360) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny"
    ],
    "hierarchy": "(127360) Elektronika / RTV i AGD / Sprzęt satelitarny / Doładowania",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Konwertery",
    "categoryPath": [
      "(67131) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny"
    ],
    "hierarchy": "(67131) Elektronika / RTV i AGD / Sprzęt satelitarny / Konwertery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Multiswitche",
    "categoryPath": [
      "(76360) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny"
    ],
    "hierarchy": "(76360) Elektronika / RTV i AGD / Sprzęt satelitarny / Multiswitche",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Tunery",
    "categoryPath": [
      "(303149) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny"
    ],
    "hierarchy": "(303149) Elektronika / RTV i AGD / Sprzęt satelitarny / Tunery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(73151) Elektronika",
      "RTV i AGD",
      "Sprzęt satelitarny"
    ],
    "hierarchy": "(73151) Elektronika / RTV i AGD / Sprzęt satelitarny / Zestawy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Etui i pokrowce na słuchawki",
    "categoryPath": [
      "(314093) Elektronika",
      "RTV i AGD",
      "Słuchawki",
      "Akcesoria do słuchawek"
    ],
    "hierarchy": "(314093) Elektronika / RTV i AGD / Słuchawki / Akcesoria do słuchawek / Etui i pokrowce na słuchawki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Nakładki do słuchawek",
    "categoryPath": [
      "(314069) Elektronika",
      "RTV i AGD",
      "Słuchawki",
      "Akcesoria do słuchawek"
    ],
    "hierarchy": "(314069) Elektronika / RTV i AGD / Słuchawki / Akcesoria do słuchawek / Nakładki do słuchawek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stojaki na słuchawki",
    "categoryPath": [
      "(314081) Elektronika",
      "RTV i AGD",
      "Słuchawki",
      "Akcesoria do słuchawek"
    ],
    "hierarchy": "(314081) Elektronika / RTV i AGD / Słuchawki / Akcesoria do słuchawek / Stojaki na słuchawki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Bezprzewodowe",
    "categoryPath": [
      "(85166) Elektronika",
      "RTV i AGD",
      "Słuchawki"
    ],
    "hierarchy": "(85166) Elektronika / RTV i AGD / Słuchawki / Bezprzewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Przewodowe",
    "categoryPath": [
      "(257109) Elektronika",
      "RTV i AGD",
      "Słuchawki"
    ],
    "hierarchy": "(257109) Elektronika / RTV i AGD / Słuchawki / Przewodowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wzmacniacze słuchawkowe",
    "categoryPath": [
      "(73139) Elektronika",
      "RTV i AGD",
      "Słuchawki"
    ],
    "hierarchy": "(73139) Elektronika / RTV i AGD / Słuchawki / Wzmacniacze słuchawkowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Abonamenty",
    "categoryPath": [
      "(252972) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(252972) Elektronika / RTV i AGD / TV i Video / Abonamenty",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Akcesoria do telewizorów",
    "categoryPath": [
      "(125350) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(125350) Elektronika / RTV i AGD / TV i Video / Akcesoria do telewizorów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Części i podzespoły",
    "categoryPath": [
      "(49143) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(49143) Elektronika / RTV i AGD / TV i Video / Części i podzespoły",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Instrukcje i katalogi",
    "categoryPath": [
      "(5126) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(5126) Elektronika / RTV i AGD / TV i Video / Instrukcje i katalogi",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Magnetowidy",
    "categoryPath": [
      "(67173) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Magnetowidy i taśmy"
    ],
    "hierarchy": "(67173) Elektronika / RTV i AGD / TV i Video / Magnetowidy i taśmy / Magnetowidy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Nośniki",
    "categoryPath": [
      "(67174) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Magnetowidy i taśmy"
    ],
    "hierarchy": "(67174) Elektronika / RTV i AGD / TV i Video / Magnetowidy i taśmy / Nośniki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Maskownice",
    "categoryPath": [
      "(127362) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(127362) Elektronika / RTV i AGD / TV i Video / Maskownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Nadajniki TV",
    "categoryPath": [
      "(14213) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(14213) Elektronika / RTV i AGD / TV i Video / Nadajniki TV",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Nagrywarki DVD/HDD",
    "categoryPath": [
      "(259428) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(259428) Elektronika / RTV i AGD / TV i Video / Nagrywarki DVD/HDD",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Odtwarzacze Blu-ray",
    "categoryPath": [
      "(259430) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(259430) Elektronika / RTV i AGD / TV i Video / Odtwarzacze Blu-ray",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Odtwarzacze DVD",
    "categoryPath": [
      "(259446) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(259446) Elektronika / RTV i AGD / TV i Video / Odtwarzacze DVD",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Odtwarzacze DVD przenośne",
    "categoryPath": [
      "(259432) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(259432) Elektronika / RTV i AGD / TV i Video / Odtwarzacze DVD przenośne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(85174) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Odtwarzacze HDD i multimedialne"
    ],
    "hierarchy": "(85174) Elektronika / RTV i AGD / TV i Video / Odtwarzacze HDD i multimedialne / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(85173) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Odtwarzacze HDD i multimedialne"
    ],
    "hierarchy": "(85173) Elektronika / RTV i AGD / TV i Video / Odtwarzacze HDD i multimedialne / Urządzenia",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(724) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(724) Elektronika / RTV i AGD / TV i Video / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ekrany",
    "categoryPath": [
      "(49150) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory",
      "Akcesoria"
    ],
    "hierarchy": "(49150) Elektronika / RTV i AGD / TV i Video / Projektory / Akcesoria / Ekrany",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Farby projekcyjne",
    "categoryPath": [
      "(316684) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory",
      "Akcesoria"
    ],
    "hierarchy": "(316684) Elektronika / RTV i AGD / TV i Video / Projektory / Akcesoria / Farby projekcyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Filtry powietrza",
    "categoryPath": [
      "(309637) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory",
      "Akcesoria"
    ],
    "hierarchy": "(309637) Elektronika / RTV i AGD / TV i Video / Projektory / Akcesoria / Filtry powietrza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lampy",
    "categoryPath": [
      "(49151) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory",
      "Akcesoria"
    ],
    "hierarchy": "(49151) Elektronika / RTV i AGD / TV i Video / Projektory / Akcesoria / Lampy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(49149) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory",
      "Akcesoria"
    ],
    "hierarchy": "(49149) Elektronika / RTV i AGD / TV i Video / Projektory / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Torby na projektory",
    "categoryPath": [
      "(309649) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory",
      "Akcesoria"
    ],
    "hierarchy": "(309649) Elektronika / RTV i AGD / TV i Video / Projektory / Akcesoria / Torby na projektory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(49152) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory",
      "Akcesoria"
    ],
    "hierarchy": "(49152) Elektronika / RTV i AGD / TV i Video / Projektory / Akcesoria / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(259431) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Projektory"
    ],
    "hierarchy": "(259431) Elektronika / RTV i AGD / TV i Video / Projektory / Urządzenia",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Soundbary",
    "categoryPath": [
      "(260779) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(260779) Elektronika / RTV i AGD / TV i Video / Soundbary",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Anteny",
    "categoryPath": [
      "(49145) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Sprzęt naziemny"
    ],
    "hierarchy": "(49145) Elektronika / RTV i AGD / TV i Video / Sprzęt naziemny / Anteny",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Tunery",
    "categoryPath": [
      "(52558) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Sprzęt naziemny"
    ],
    "hierarchy": "(52558) Elektronika / RTV i AGD / TV i Video / Sprzęt naziemny / Tunery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wzmacniacze",
    "categoryPath": [
      "(49146) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Sprzęt naziemny"
    ],
    "hierarchy": "(49146) Elektronika / RTV i AGD / TV i Video / Sprzęt naziemny / Wzmacniacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zasilacze antenowe",
    "categoryPath": [
      "(310205) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Sprzęt naziemny"
    ],
    "hierarchy": "(310205) Elektronika / RTV i AGD / TV i Video / Sprzęt naziemny / Zasilacze antenowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Podstawy",
    "categoryPath": [
      "(45580) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Stoliki, uchwyty, półki"
    ],
    "hierarchy": "(45580) Elektronika / RTV i AGD / TV i Video / Stoliki, uchwyty, półki / Podstawy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Półki",
    "categoryPath": [
      "(16302) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Stoliki, uchwyty, półki"
    ],
    "hierarchy": "(16302) Elektronika / RTV i AGD / TV i Video / Stoliki, uchwyty, półki / Półki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Stoliki",
    "categoryPath": [
      "(16300) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Stoliki, uchwyty, półki"
    ],
    "hierarchy": "(16300) Elektronika / RTV i AGD / TV i Video / Stoliki, uchwyty, półki / Stoliki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(16301) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Stoliki, uchwyty, półki"
    ],
    "hierarchy": "(16301) Elektronika / RTV i AGD / TV i Video / Stoliki, uchwyty, półki / Uchwyty",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(14238) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Telewizja przemysłowa"
    ],
    "hierarchy": "(14238) Elektronika / RTV i AGD / TV i Video / Telewizja przemysłowa / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Atrapy",
    "categoryPath": [
      "(67192) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Telewizja przemysłowa"
    ],
    "hierarchy": "(67192) Elektronika / RTV i AGD / TV i Video / Telewizja przemysłowa / Atrapy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kamery",
    "categoryPath": [
      "(14237) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Telewizja przemysłowa"
    ],
    "hierarchy": "(14237) Elektronika / RTV i AGD / TV i Video / Telewizja przemysłowa / Kamery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Karty DVR",
    "categoryPath": [
      "(16307) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Telewizja przemysłowa"
    ],
    "hierarchy": "(16307) Elektronika / RTV i AGD / TV i Video / Telewizja przemysłowa / Karty DVR",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Monitory",
    "categoryPath": [
      "(14240) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Telewizja przemysłowa"
    ],
    "hierarchy": "(14240) Elektronika / RTV i AGD / TV i Video / Telewizja przemysłowa / Monitory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Rejestratory",
    "categoryPath": [
      "(14239) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Telewizja przemysłowa"
    ],
    "hierarchy": "(14239) Elektronika / RTV i AGD / TV i Video / Telewizja przemysłowa / Rejestratory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(51829) Elektronika",
      "RTV i AGD",
      "TV i Video",
      "Telewizja przemysłowa"
    ],
    "hierarchy": "(51829) Elektronika / RTV i AGD / TV i Video / Telewizja przemysłowa / Zestawy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Telewizory",
    "categoryPath": [
      "(257732) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(257732) Elektronika / RTV i AGD / TV i Video / Telewizory",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Telewizory kineskopowe",
    "categoryPath": [
      "(257686) Elektronika",
      "RTV i AGD",
      "TV i Video"
    ],
    "hierarchy": "(257686) Elektronika / RTV i AGD / TV i Video / Telewizory kineskopowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Adaptery",
    "categoryPath": [
      "(76369) Elektronika",
      "RTV i AGD",
      "Zasilanie"
    ],
    "hierarchy": "(76369) Elektronika / RTV i AGD / Zasilanie / Adaptery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Akumulatorki",
    "categoryPath": [
      "(305581) Elektronika",
      "RTV i AGD",
      "Zasilanie"
    ],
    "hierarchy": "(305581) Elektronika / RTV i AGD / Zasilanie / Akumulatorki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Baterie",
    "categoryPath": [
      "(305585) Elektronika",
      "RTV i AGD",
      "Zasilanie"
    ],
    "hierarchy": "(305585) Elektronika / RTV i AGD / Zasilanie / Baterie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Baterie specjalistyczne",
    "categoryPath": [
      "(305589) Elektronika",
      "RTV i AGD",
      "Zasilanie"
    ],
    "hierarchy": "(305589) Elektronika / RTV i AGD / Zasilanie / Baterie specjalistyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(76371) Elektronika",
      "RTV i AGD",
      "Zasilanie"
    ],
    "hierarchy": "(76371) Elektronika / RTV i AGD / Zasilanie / Zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(76372) Elektronika",
      "RTV i AGD",
      "Zasilanie"
    ],
    "hierarchy": "(76372) Elektronika / RTV i AGD / Zasilanie / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(76370) Elektronika",
      "RTV i AGD",
      "Zasilanie"
    ],
    "hierarchy": "(76370) Elektronika / RTV i AGD / Zasilanie / Ładowarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "CD-playery dla DJ-ów",
    "categoryPath": [
      "(305301) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski"
    ],
    "hierarchy": "(305301) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / CD-playery dla DJ-ów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Części zamienne",
    "categoryPath": [
      "(122348) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Gramofony dla DJ-ów"
    ],
    "hierarchy": "(122348) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Gramofony dla DJ-ów / Części zamienne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Gramofony",
    "categoryPath": [
      "(311833) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Gramofony dla DJ-ów"
    ],
    "hierarchy": "(311833) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Gramofony dla DJ-ów / Gramofony",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kable, przewody",
    "categoryPath": [
      "(122350) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Kable, przewody i wtyki"
    ],
    "hierarchy": "(122350) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Kable, przewody i wtyki / Kable, przewody",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Przejściówki",
    "categoryPath": [
      "(122351) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Kable, przewody i wtyki"
    ],
    "hierarchy": "(122351) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Kable, przewody i wtyki / Przejściówki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wtyczki",
    "categoryPath": [
      "(122352) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Kable, przewody i wtyki"
    ],
    "hierarchy": "(122352) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Kable, przewody i wtyki / Wtyczki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Filtry mikrofonowe",
    "categoryPath": [
      "(310813) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria"
    ],
    "hierarchy": "(310813) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Filtry mikrofonowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Gąbki mikrofonowe",
    "categoryPath": [
      "(310801) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria"
    ],
    "hierarchy": "(310801) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Gąbki mikrofonowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Do ręki",
    "categoryPath": [
      "(122356) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria",
      "Mikrofony bezprzewodowe"
    ],
    "hierarchy": "(122356) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Mikrofony bezprzewodowe / Do ręki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Na klip",
    "categoryPath": [
      "(122357) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria",
      "Mikrofony bezprzewodowe"
    ],
    "hierarchy": "(122357) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Mikrofony bezprzewodowe / Na klip",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Nagłowne",
    "categoryPath": [
      "(122358) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria",
      "Mikrofony bezprzewodowe"
    ],
    "hierarchy": "(122358) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Mikrofony bezprzewodowe / Nagłowne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(122359) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria",
      "Mikrofony bezprzewodowe"
    ],
    "hierarchy": "(122359) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Mikrofony bezprzewodowe / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Mikrofony przewodowe",
    "categoryPath": [
      "(122360) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria"
    ],
    "hierarchy": "(122360) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Mikrofony przewodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122369) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria"
    ],
    "hierarchy": "(122369) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Statywy i uchwyty",
    "categoryPath": [
      "(122368) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Mikrofony i akcesoria"
    ],
    "hierarchy": "(122368) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Mikrofony i akcesoria / Statywy i uchwyty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Dla DJ-ów",
    "categoryPath": [
      "(122371) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Miksery audio"
    ],
    "hierarchy": "(122371) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Miksery audio / Dla DJ-ów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Powermixery",
    "categoryPath": [
      "(122372) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Miksery audio"
    ],
    "hierarchy": "(122372) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Miksery audio / Powermixery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Studyjne i estradowe",
    "categoryPath": [
      "(122373) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Miksery audio"
    ],
    "hierarchy": "(122373) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Miksery audio / Studyjne i estradowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Equalizery",
    "categoryPath": [
      "(122375) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122375) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Equalizery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(122376) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122376) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Głośniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kolumny",
    "categoryPath": [
      "(122377) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122377) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Kolumny",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Końcówki mocy, wzmacniacze",
    "categoryPath": [
      "(122378) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122378) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Końcówki mocy, wzmacniacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Maty wygłuszające",
    "categoryPath": [
      "(122379) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122379) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Maty wygłuszające",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Monitory studyjne",
    "categoryPath": [
      "(122380) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122380) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Monitory studyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Procesory dźwięku",
    "categoryPath": [
      "(122381) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122381) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Procesory dźwięku",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Statywy",
    "categoryPath": [
      "(122382) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122382) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Statywy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Subwoofery",
    "categoryPath": [
      "(122383) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(122383) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Subwoofery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy nagłośnieniowe",
    "categoryPath": [
      "(311661) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Nagłośnienie"
    ],
    "hierarchy": "(311661) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Nagłośnienie / Zestawy nagłośnieniowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122414) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski"
    ],
    "hierarchy": "(122414) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sceny, estrady, podesty",
    "categoryPath": [
      "(122385) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski"
    ],
    "hierarchy": "(122385) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Sceny, estrady, podesty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Dla DJ-ów",
    "categoryPath": [
      "(122387) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Słuchawki"
    ],
    "hierarchy": "(122387) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Słuchawki / Dla DJ-ów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Studyjne",
    "categoryPath": [
      "(122388) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Słuchawki"
    ],
    "hierarchy": "(122388) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Słuchawki / Studyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Urządzenia rejestrujące",
    "categoryPath": [
      "(122412) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski"
    ],
    "hierarchy": "(122412) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Urządzenia rejestrujące",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Video dla studia",
    "categoryPath": [
      "(122406) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski"
    ],
    "hierarchy": "(122406) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Video dla studia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Części i akcesoria",
    "categoryPath": [
      "(122411) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Walizki i torby"
    ],
    "hierarchy": "(122411) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Walizki i torby / Części i akcesoria",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Walizki, skrzynie i torby",
    "categoryPath": [
      "(122408) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Walizki i torby"
    ],
    "hierarchy": "(122408) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Walizki i torby / Walizki, skrzynie i torby",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Lasery",
    "categoryPath": [
      "(122390) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122390) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Lasery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Lustrzane kule",
    "categoryPath": [
      "(122391) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122391) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Lustrzane kule",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Płyny do wytwornic",
    "categoryPath": [
      "(122402) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty",
      "Materiały eksploatacyjne"
    ],
    "hierarchy": "(122402) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Materiały eksploatacyjne / Płyny do wytwornic",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Żarówki",
    "categoryPath": [
      "(122403) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty",
      "Materiały eksploatacyjne"
    ],
    "hierarchy": "(122403) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Materiały eksploatacyjne / Żarówki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122405) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122405) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reflektory",
    "categoryPath": [
      "(122392) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122392) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Reflektory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ruchome głowy",
    "categoryPath": [
      "(122393) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122393) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Ruchome głowy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Skanery",
    "categoryPath": [
      "(122394) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122394) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Skanery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Statywy",
    "categoryPath": [
      "(122395) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122395) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Statywy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(122396) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122396) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Sterowniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Stroboskopy",
    "categoryPath": [
      "(122397) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122397) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Stroboskopy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "UV",
    "categoryPath": [
      "(122398) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122398) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / UV",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wyrzutnie konfetti",
    "categoryPath": [
      "(311625) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(311625) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Wyrzutnie konfetti",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wytwornice dymu",
    "categoryPath": [
      "(122399) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122399) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Wytwornice dymu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wytwornice iskier",
    "categoryPath": [
      "(311637) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(311637) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Wytwornice iskier",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wytwornice piany i baniek",
    "categoryPath": [
      "(122400) Elektronika",
      "Sprzęt estradowy, studyjny i DJ-ski",
      "Światło i efekty"
    ],
    "hierarchy": "(122400) Elektronika / Sprzęt estradowy, studyjny i DJ-ski / Światło i efekty / Wytwornice piany i baniek",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Adaptery, przejściówki",
    "categoryPath": [
      "(257347) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(257347) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Adaptery, przejściówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Boxy",
    "categoryPath": [
      "(316176) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Akcesoria serwisowe"
    ],
    "hierarchy": "(316176) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Akcesoria serwisowe / Boxy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(52890) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Akcesoria serwisowe"
    ],
    "hierarchy": "(52890) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Akcesoria serwisowe / Lupy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Naprawa LCD",
    "categoryPath": [
      "(256402) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Akcesoria serwisowe"
    ],
    "hierarchy": "(256402) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Akcesoria serwisowe / Naprawa LCD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19289) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Akcesoria serwisowe"
    ],
    "hierarchy": "(19289) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Akcesoria serwisowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wanny ultradźwiękowe",
    "categoryPath": [
      "(52892) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Akcesoria serwisowe"
    ],
    "hierarchy": "(52892) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Akcesoria serwisowe / Wanny ultradźwiękowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wkrętaki",
    "categoryPath": [
      "(19287) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Akcesoria serwisowe"
    ],
    "hierarchy": "(19287) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Akcesoria serwisowe / Wkrętaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Aparaty wewnętrzne",
    "categoryPath": [
      "(46778) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(46778) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Aparaty wewnętrzne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Buzzery",
    "categoryPath": [
      "(75515) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(75515) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Buzzery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Digitizery",
    "categoryPath": [
      "(108652) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(108652) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Digitizery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Gumki",
    "categoryPath": [
      "(19291) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19291) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Gumki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głośniczki",
    "categoryPath": [
      "(300837) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(300837) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Głośniczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Joysticki",
    "categoryPath": [
      "(19293) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19293) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Joysticki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Membrany",
    "categoryPath": [
      "(19294) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19294) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Membrany",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mikrofony",
    "categoryPath": [
      "(19295) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19295) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Mikrofony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obudowy, panele",
    "categoryPath": [
      "(310061) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(310061) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Obudowy, panele",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19305) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19305) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płyty główne",
    "categoryPath": [
      "(46779) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(46779) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Płyty główne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Płyty klawiatury",
    "categoryPath": [
      "(52893) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(52893) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Płyty klawiatury",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Płyty wyświetlacza",
    "categoryPath": [
      "(52894) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(52894) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Płyty wyświetlacza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Silniczki wibracyjne",
    "categoryPath": [
      "(19297) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19297) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Silniczki wibracyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Szybki",
    "categoryPath": [
      "(52895) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(52895) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Szybki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Taśmy LCD",
    "categoryPath": [
      "(19298) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19298) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Taśmy LCD",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty karty SIM",
    "categoryPath": [
      "(19299) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19299) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Uchwyty karty SIM",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Układy scalone",
    "categoryPath": [
      "(19300) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19300) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Układy scalone",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wyświetlacze",
    "categoryPath": [
      "(19302) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19302) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Wyświetlacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Włączniki",
    "categoryPath": [
      "(19301) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19301) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Włączniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(50970) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(50970) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Złącza",
    "categoryPath": [
      "(19303) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19303) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Złącza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Śrubki",
    "categoryPath": [
      "(19304) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Akcesoria i części serwisowe",
      "Części zamienne"
    ],
    "hierarchy": "(19304) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Akcesoria i części serwisowe / Części zamienne / Śrubki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Konektory antenowe",
    "categoryPath": [
      "(19317) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Anteny i wzmacniacze"
    ],
    "hierarchy": "(19317) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Anteny i wzmacniacze / Konektory antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Samochodowe",
    "categoryPath": [
      "(19315) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Anteny i wzmacniacze"
    ],
    "hierarchy": "(19315) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Anteny i wzmacniacze / Samochodowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Stacjonarne",
    "categoryPath": [
      "(19316) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Anteny i wzmacniacze"
    ],
    "hierarchy": "(19316) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Anteny i wzmacniacze / Stacjonarne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wzmacniacze antenowe",
    "categoryPath": [
      "(19318) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Anteny i wzmacniacze"
    ],
    "hierarchy": "(19318) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Anteny i wzmacniacze / Wzmacniacze antenowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Atrapy i telefony demonstracyjne",
    "categoryPath": [
      "(8539) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(8539) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Atrapy i telefony demonstracyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Baterie",
    "categoryPath": [
      "(352) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(352) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Baterie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Etui i pokrowce",
    "categoryPath": [
      "(353) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(353) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Etui i pokrowce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie i szkła ochronne",
    "categoryPath": [
      "(10532) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(10532) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Folie i szkła ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pojedyncze kable",
    "categoryPath": [
      "(4793) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Kable"
    ],
    "hierarchy": "(4793) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Kable / Pojedyncze kable",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy kabli",
    "categoryPath": [
      "(4800) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Kable"
    ],
    "hierarchy": "(4800) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Kable / Zestawy kabli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty X-SIM/Turbosim",
    "categoryPath": [
      "(53970) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(53970) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Karty X-SIM/Turbosim",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Klawiatury",
    "categoryPath": [
      "(4801) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(4801) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Klawiatury",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lampy pierścieniowe",
    "categoryPath": [
      "(319769) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(319769) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Lampy pierścieniowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Maty antypoślizgowe",
    "categoryPath": [
      "(95593) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(95593) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Maty antypoślizgowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Aparaty cyfrowe",
    "categoryPath": [
      "(4803) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Multimedia"
    ],
    "hierarchy": "(4803) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Multimedia / Aparaty cyfrowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głośniki zewnętrzne",
    "categoryPath": [
      "(46780) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Multimedia"
    ],
    "hierarchy": "(46780) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Multimedia / Głośniki zewnętrzne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Obiektywy",
    "categoryPath": [
      "(63257) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Multimedia"
    ],
    "hierarchy": "(63257) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Multimedia / Obiektywy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Okulary VR",
    "categoryPath": [
      "(257014) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Multimedia"
    ],
    "hierarchy": "(257014) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Multimedia / Okulary VR",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Podstawki",
    "categoryPath": [
      "(95594) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(95594) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Podstawki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(439) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(439) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pudełka",
    "categoryPath": [
      "(19353) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(19353) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Pudełka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Rysiki",
    "categoryPath": [
      "(19352) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(19352) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Rysiki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Breloki",
    "categoryPath": [
      "(19349) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Smycze, flash stickery, breloki"
    ],
    "hierarchy": "(19349) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Smycze, flash stickery, breloki / Breloki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Flash stickery",
    "categoryPath": [
      "(19351) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Smycze, flash stickery, breloki"
    ],
    "hierarchy": "(19351) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Smycze, flash stickery, breloki / Flash stickery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Smycze",
    "categoryPath": [
      "(19350) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Smycze, flash stickery, breloki"
    ],
    "hierarchy": "(19350) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Smycze, flash stickery, breloki / Smycze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(95595) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(95595) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Uchwyty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy akcesoriów",
    "categoryPath": [
      "(1291) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(1291) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Zestawy akcesoriów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zestawy głośnomówiące",
    "categoryPath": [
      "(354) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM"
    ],
    "hierarchy": "(354) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Zestawy głośnomówiące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Bezprzewodowe",
    "categoryPath": [
      "(4863) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Zestawy słuchawkowe"
    ],
    "hierarchy": "(4863) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Zestawy słuchawkowe / Bezprzewodowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Przewodowe",
    "categoryPath": [
      "(4862) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Zestawy słuchawkowe"
    ],
    "hierarchy": "(4862) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Zestawy słuchawkowe / Przewodowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Bezprzewodowe",
    "categoryPath": [
      "(147162) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Ładowarki"
    ],
    "hierarchy": "(147162) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Ładowarki / Bezprzewodowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Biurkowe/Stacje dokujące",
    "categoryPath": [
      "(19355) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Ładowarki"
    ],
    "hierarchy": "(19355) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Ładowarki / Biurkowe/Stacje dokujące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19366) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Ładowarki"
    ],
    "hierarchy": "(19366) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Ładowarki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Samochodowe",
    "categoryPath": [
      "(19356) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Ładowarki"
    ],
    "hierarchy": "(19356) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Ładowarki / Samochodowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Sieciowe",
    "categoryPath": [
      "(19357) Elektronika",
      "Telefony i Akcesoria",
      "Akcesoria GSM",
      "Ładowarki"
    ],
    "hierarchy": "(19357) Elektronika / Telefony i Akcesoria / Akcesoria GSM / Ładowarki / Sieciowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Karty pamięci",
    "categoryPath": [
      "(257818) Elektronika",
      "Telefony i Akcesoria"
    ],
    "hierarchy": "(257818) Elektronika / Telefony i Akcesoria / Karty pamięci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Powerbanki",
    "categoryPath": [
      "(252023) Elektronika",
      "Telefony i Akcesoria"
    ],
    "hierarchy": "(252023) Elektronika / Telefony i Akcesoria / Powerbanki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(311009) Elektronika",
      "Telefony i Akcesoria"
    ],
    "hierarchy": "(311009) Elektronika / Telefony i Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Doładowania",
    "categoryPath": [
      "(261584) Elektronika",
      "Telefony i Akcesoria",
      "Pre-paid"
    ],
    "hierarchy": "(261584) Elektronika / Telefony i Akcesoria / Pre-paid / Doładowania",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Startery",
    "categoryPath": [
      "(261585) Elektronika",
      "Telefony i Akcesoria",
      "Pre-paid"
    ],
    "hierarchy": "(261585) Elektronika / Telefony i Akcesoria / Pre-paid / Startery",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(55835) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Krótkofalówki i Walkie-talkie"
    ],
    "hierarchy": "(55835) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Krótkofalówki i Walkie-talkie / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(55834) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Krótkofalówki i Walkie-talkie"
    ],
    "hierarchy": "(55834) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Krótkofalówki i Walkie-talkie / Urządzenia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28283) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja"
    ],
    "hierarchy": "(28283) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(16630) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(16630) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Filtry",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(46820) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(46820) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Głośniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kable i wtyki",
    "categoryPath": [
      "(46818) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(46818) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Kable i wtyki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mierniki",
    "categoryPath": [
      "(46819) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(46819) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Mierniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Mikrofony",
    "categoryPath": [
      "(16627) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(16627) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Mikrofony",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16626) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(16626) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Uchwyty i podstawy",
    "categoryPath": [
      "(16628) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(16628) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Uchwyty i podstawy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Wzmacniacze",
    "categoryPath": [
      "(16629) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(16629) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Wzmacniacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(16631) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Akcesoria i części"
    ],
    "hierarchy": "(16631) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Akcesoria i części / Zasilacze",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Bazowe",
    "categoryPath": [
      "(95832) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Anteny"
    ],
    "hierarchy": "(95832) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Anteny / Bazowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Magnesowe",
    "categoryPath": [
      "(95835) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Anteny"
    ],
    "hierarchy": "(95835) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Anteny / Magnesowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Montażowe",
    "categoryPath": [
      "(95833) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB",
      "Anteny"
    ],
    "hierarchy": "(95833) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Anteny / Montażowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "CB Radia",
    "categoryPath": [
      "(5058) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB"
    ],
    "hierarchy": "(5058) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / CB Radia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Radiotelefony przenośne",
    "categoryPath": [
      "(5057) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt CB"
    ],
    "hierarchy": "(5057) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt CB / Radiotelefony przenośne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Anteny",
    "categoryPath": [
      "(16635) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(16635) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Anteny",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Gniazda i złącza",
    "categoryPath": [
      "(16638) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(16638) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Gniazda i złącza",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kondensatory",
    "categoryPath": [
      "(16636) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(16636) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Kondensatory",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kwarce i filtry",
    "categoryPath": [
      "(16637) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(16637) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Kwarce i filtry",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Lampy",
    "categoryPath": [
      "(28269) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(28269) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Lampy",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Moduły i płytki",
    "categoryPath": [
      "(28270) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(28270) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Moduły i płytki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16634) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(16634) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(28268) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(28268) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Przewody",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Półprzewodniki",
    "categoryPath": [
      "(28267) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Akcesoria i części"
    ],
    "hierarchy": "(28267) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Akcesoria i części / Półprzewodniki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Literatura i instrukcje",
    "categoryPath": [
      "(5065) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski"
    ],
    "hierarchy": "(5065) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Literatura i instrukcje",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Przenośne",
    "categoryPath": [
      "(28272) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Radiostacje"
    ],
    "hierarchy": "(28272) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Radiostacje / Przenośne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Stacjonarne",
    "categoryPath": [
      "(28273) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt krótkofalarski",
      "Radiostacje"
    ],
    "hierarchy": "(28273) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt krótkofalarski / Radiostacje / Stacjonarne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Akcesoria i części",
    "categoryPath": [
      "(28276) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt profesjonalny"
    ],
    "hierarchy": "(28276) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt profesjonalny / Akcesoria i części",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Służby",
    "categoryPath": [
      "(28279) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt profesjonalny",
      "Radiostacje"
    ],
    "hierarchy": "(28279) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt profesjonalny / Radiostacje / Służby",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Taxi",
    "categoryPath": [
      "(28281) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt profesjonalny",
      "Radiostacje"
    ],
    "hierarchy": "(28281) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt profesjonalny / Radiostacje / Taxi",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wojsko",
    "categoryPath": [
      "(28280) Elektronika",
      "Telefony i Akcesoria",
      "Radiokomunikacja",
      "Sprzęt profesjonalny",
      "Radiostacje"
    ],
    "hierarchy": "(28280) Elektronika / Telefony i Akcesoria / Radiokomunikacja / Sprzęt profesjonalny / Radiostacje / Wojsko",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "1B 2020",
    "categoryPath": [
      "(319171) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Alcatel"
    ],
    "hierarchy": "(319171) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Alcatel / 1B 2020",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "1C 2019",
    "categoryPath": [
      "(319174) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Alcatel"
    ],
    "hierarchy": "(319174) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Alcatel / 1C 2019",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(146523) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Alcatel"
    ],
    "hierarchy": "(146523) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Alcatel / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(256076) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Allview"
    ],
    "hierarchy": "(256076) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Allview / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(54002) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(54002) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 11",
    "categoryPath": [
      "(300501) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(300501) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 11 Pro",
    "categoryPath": [
      "(300505) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(300505) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 11 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 11 Pro Max",
    "categoryPath": [
      "(300509) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(300509) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 11 Pro Max",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 12",
    "categoryPath": [
      "(316188) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(316188) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 12 Pro",
    "categoryPath": [
      "(316191) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(316191) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 12 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 12 Pro Max",
    "categoryPath": [
      "(316194) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(316194) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 12 Pro Max",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 12 mini",
    "categoryPath": [
      "(316197) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(316197) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 12 mini",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 13",
    "categoryPath": [
      "(320536) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(320536) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 13",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 13 Pro",
    "categoryPath": [
      "(320542) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(320542) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 13 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 13 Pro Max",
    "categoryPath": [
      "(320545) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(320545) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 13 Pro Max",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 13 mini",
    "categoryPath": [
      "(320539) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(320539) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 13 mini",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 14",
    "categoryPath": [
      "(322124) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322124) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 14",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 14 Plus",
    "categoryPath": [
      "(322125) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322125) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 14 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 14 Pro",
    "categoryPath": [
      "(322126) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322126) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 14 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 14 Pro Max",
    "categoryPath": [
      "(322127) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322127) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 14 Pro Max",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 15",
    "categoryPath": [
      "(322851) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322851) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 15",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 15 Plus",
    "categoryPath": [
      "(322852) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322852) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 15 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 15 Pro",
    "categoryPath": [
      "(322854) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322854) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 15 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 15 Pro Max",
    "categoryPath": [
      "(322855) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(322855) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 15 Pro Max",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 5",
    "categoryPath": [
      "(123602) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(123602) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 5S",
    "categoryPath": [
      "(145923) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(145923) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 5S",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 6",
    "categoryPath": [
      "(249586) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(249586) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 6 Plus",
    "categoryPath": [
      "(249587) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(249587) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 6 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 6S",
    "categoryPath": [
      "(253002) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(253002) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 6S",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 7",
    "categoryPath": [
      "(256094) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(256094) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 7 Plus",
    "categoryPath": [
      "(256095) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(256095) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 7 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 8",
    "categoryPath": [
      "(257246) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(257246) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone 8 Plus",
    "categoryPath": [
      "(257247) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(257247) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone 8 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone SE",
    "categoryPath": [
      "(254738) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(254738) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone SE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone SE (2020)",
    "categoryPath": [
      "(308029) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(308029) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone SE (2020)",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone SE (2022)",
    "categoryPath": [
      "(321616) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(321616) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone SE (2022)",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone X",
    "categoryPath": [
      "(257248) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(257248) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone X",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone XR",
    "categoryPath": [
      "(259718) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(259718) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone XR",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone XS",
    "categoryPath": [
      "(259716) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(259716) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone XS",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "iPhone XS Max",
    "categoryPath": [
      "(259717) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Apple"
    ],
    "hierarchy": "(259717) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Apple / iPhone XS Max",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Archos",
    "categoryPath": [
      "(319670) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(319670) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Archos",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(258854) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Asus"
    ],
    "hierarchy": "(258854) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Asus / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "ROG Phone 6",
    "categoryPath": [
      "(322083) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Asus"
    ],
    "hierarchy": "(322083) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Asus / ROG Phone 6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zenfone 8",
    "categoryPath": [
      "(320041) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Asus"
    ],
    "hierarchy": "(320041) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Asus / Zenfone 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zenfone 9",
    "categoryPath": [
      "(322061) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Asus"
    ],
    "hierarchy": "(322061) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Asus / Zenfone 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(75538) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "BlackBerry"
    ],
    "hierarchy": "(75538) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / BlackBerry / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A50",
    "categoryPath": [
      "(322431) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(322431) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / A50",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "BL5000",
    "categoryPath": [
      "(322424) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(322424) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / BL5000",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "BV4900 Pro",
    "categoryPath": [
      "(322422) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(322422) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / BV4900 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "BV5200",
    "categoryPath": [
      "(322429) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(322429) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / BV5200",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "BV6300 Pro",
    "categoryPath": [
      "(322420) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(322420) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / BV6300 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "BV6600",
    "categoryPath": [
      "(322426) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(322426) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / BV6600",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "BV6600 Pro",
    "categoryPath": [
      "(322416) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(322416) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / BV6600 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(258024) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Blackview"
    ],
    "hierarchy": "(258024) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Blackview / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "B25",
    "categoryPath": [
      "(253026) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Cat Phones"
    ],
    "hierarchy": "(253026) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Cat Phones / B25",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(258305) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Cat Phones"
    ],
    "hierarchy": "(258305) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Cat Phones / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "S42",
    "categoryPath": [
      "(319189) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Cat Phones"
    ],
    "hierarchy": "(319189) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Cat Phones / S42",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "S53",
    "categoryPath": [
      "(322326) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Cat Phones"
    ],
    "hierarchy": "(322326) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Cat Phones / S53",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "S62 Pro",
    "categoryPath": [
      "(319192) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Cat Phones"
    ],
    "hierarchy": "(319192) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Cat Phones / S62 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Cubot",
    "categoryPath": [
      "(258336) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(258336) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Cubot",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "DooGee",
    "categoryPath": [
      "(253981) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(253981) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / DooGee",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(261222) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(261222) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 4",
    "categoryPath": [
      "(317252) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(317252) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 4a",
    "categoryPath": [
      "(317258) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(317258) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 4a",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 5",
    "categoryPath": [
      "(317261) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(317261) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 6",
    "categoryPath": [
      "(320918) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(320918) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 6 Pro",
    "categoryPath": [
      "(320921) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(320921) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 6 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 6a",
    "categoryPath": [
      "(322068) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(322068) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 6a",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 7",
    "categoryPath": [
      "(322242) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(322242) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 7 Pro",
    "categoryPath": [
      "(322243) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(322243) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 7 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 7a",
    "categoryPath": [
      "(322631) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(322631) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 7a",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 8",
    "categoryPath": [
      "(322913) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(322913) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel 8 Pro",
    "categoryPath": [
      "(322914) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(322914) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel 8 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pixel Fold",
    "categoryPath": [
      "(322912) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Google"
    ],
    "hierarchy": "(322912) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Google / Pixel Fold",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOTWAV",
    "categoryPath": [
      "(322238) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(322238) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / HOTWAV",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HTC Desire 820",
    "categoryPath": [
      "(251142) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "HTC"
    ],
    "hierarchy": "(251142) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / HTC / HTC Desire 820",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HTC One",
    "categoryPath": [
      "(127365) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "HTC"
    ],
    "hierarchy": "(127365) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / HTC / HTC One",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HTC One M8",
    "categoryPath": [
      "(148762) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "HTC"
    ],
    "hierarchy": "(148762) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / HTC / HTC One M8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(16619) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "HTC"
    ],
    "hierarchy": "(16619) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / HTC / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Hammer",
    "categoryPath": [
      "(148768) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(148768) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Hammer",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Hammer",
    "categoryPath": [
      "(253005) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Hammer"
    ],
    "hierarchy": "(253005) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Hammer / Hammer",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Hammer Blade 3",
    "categoryPath": [
      "(317685) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Hammer"
    ],
    "hierarchy": "(317685) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Hammer / Hammer Blade 3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Hammer Energy 2",
    "categoryPath": [
      "(317688) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Hammer"
    ],
    "hierarchy": "(317688) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Hammer / Hammer Energy 2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Hammer Explorer",
    "categoryPath": [
      "(317874) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Hammer"
    ],
    "hierarchy": "(317874) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Hammer / Hammer Explorer",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Hammer Iron",
    "categoryPath": [
      "(253009) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Hammer"
    ],
    "hierarchy": "(253009) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Hammer / Hammer Iron",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(322062) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Hammer"
    ],
    "hierarchy": "(322062) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Hammer / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Honor 5X",
    "categoryPath": [
      "(254430) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Honor"
    ],
    "hierarchy": "(254430) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Honor / Honor 5X",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Honor 90",
    "categoryPath": [
      "(322859) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Honor"
    ],
    "hierarchy": "(322859) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Honor / Honor 90",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Honor 90 Lite",
    "categoryPath": [
      "(322858) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Honor"
    ],
    "hierarchy": "(322858) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Honor / Honor 90 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(255953) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Honor"
    ],
    "hierarchy": "(255953) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Honor / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(144922) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(144922) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mate 10 lite",
    "categoryPath": [
      "(257377) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(257377) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Mate 10 lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mate 20 Lite",
    "categoryPath": [
      "(259423) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(259423) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Mate 20 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mate 20 Pro",
    "categoryPath": [
      "(260144) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(260144) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Mate 20 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nova 10 Pro",
    "categoryPath": [
      "(322085) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(322085) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Nova 10 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nova 10 SE",
    "categoryPath": [
      "(322369) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(322369) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Nova 10 SE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nova 8i",
    "categoryPath": [
      "(320774) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(320774) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Nova 8i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nova 9",
    "categoryPath": [
      "(320771) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(320771) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Nova 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nova Y70",
    "categoryPath": [
      "(322037) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(322037) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Nova Y70",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P Smart",
    "categoryPath": [
      "(258079) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(258079) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P Smart",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P Smart 2021",
    "categoryPath": [
      "(316405) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(316405) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P Smart 2021",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P Smart Pro",
    "categoryPath": [
      "(303849) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(303849) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P Smart Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P Smart Z",
    "categoryPath": [
      "(261523) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(261523) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P Smart Z",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P10",
    "categoryPath": [
      "(256784) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(256784) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P10 Lite",
    "categoryPath": [
      "(256785) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(256785) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P10 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P20",
    "categoryPath": [
      "(258088) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(258088) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P20",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P20 Lite",
    "categoryPath": [
      "(258089) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(258089) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P20 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P20 Pro",
    "categoryPath": [
      "(258090) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(258090) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P20 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P30",
    "categoryPath": [
      "(260645) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(260645) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P30",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P30 Lite",
    "categoryPath": [
      "(260865) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(260865) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P30 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P30 Pro",
    "categoryPath": [
      "(260646) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(260646) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P30 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P40",
    "categoryPath": [
      "(306333) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(306333) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P40",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P40 Lite",
    "categoryPath": [
      "(305553) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(305553) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P40 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P40 Pro",
    "categoryPath": [
      "(306345) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(306345) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P40 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P50 Pocket",
    "categoryPath": [
      "(321350) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(321350) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P50 Pocket",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P50 Pro",
    "categoryPath": [
      "(320170) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(320170) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P50 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P60 Pro",
    "categoryPath": [
      "(322511) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(322511) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P60 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P8",
    "categoryPath": [
      "(252816) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(252816) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P8 Lite",
    "categoryPath": [
      "(252817) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(252817) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P8 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P9",
    "categoryPath": [
      "(255526) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(255526) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "P9 Lite",
    "categoryPath": [
      "(256070) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(256070) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / P9 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y3 II",
    "categoryPath": [
      "(256114) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(256114) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Y3 II",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y5",
    "categoryPath": [
      "(253385) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(253385) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Y5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y5 II",
    "categoryPath": [
      "(256115) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(256115) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Y5 II",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y6",
    "categoryPath": [
      "(253389) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(253389) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Y6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y6 II",
    "categoryPath": [
      "(256116) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(256116) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Y6 II",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y6P",
    "categoryPath": [
      "(308605) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(308605) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Y6P",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y7",
    "categoryPath": [
      "(257169) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Huawei"
    ],
    "hierarchy": "(257169) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Huawei / Y7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 11",
    "categoryPath": [
      "(322077) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322077) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 11S NFC",
    "categoryPath": [
      "(322076) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322076) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 11S NFC",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 12 Play NFC",
    "categoryPath": [
      "(322078) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322078) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 12 Play NFC",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 12i",
    "categoryPath": [
      "(322073) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322073) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 12i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 20 5G",
    "categoryPath": [
      "(322546) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322546) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 20 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 20i",
    "categoryPath": [
      "(322368) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322368) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 20i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 30",
    "categoryPath": [
      "(322657) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322657) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 30",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "HOT 30i",
    "categoryPath": [
      "(322636) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322636) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / HOT 30i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(322080) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322080) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 12",
    "categoryPath": [
      "(322075) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322075) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 12 2023",
    "categoryPath": [
      "(322355) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322355) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 12 2023",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 12 Pro",
    "categoryPath": [
      "(322150) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322150) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 12 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 12 Pro 5G",
    "categoryPath": [
      "(322156) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322156) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 12 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 30 4G",
    "categoryPath": [
      "(322639) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322639) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 30 4G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 30 5G",
    "categoryPath": [
      "(322640) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322640) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 30 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 30 PRO",
    "categoryPath": [
      "(322642) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322642) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 30 PRO",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "NOTE 30 VIP",
    "categoryPath": [
      "(322641) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322641) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / NOTE 30 VIP",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "SMART 6",
    "categoryPath": [
      "(322074) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322074) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / SMART 6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "SMART 7",
    "categoryPath": [
      "(322637) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322637) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / SMART 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "SMART 7 HD",
    "categoryPath": [
      "(322638) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322638) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / SMART 7 HD",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "ZERO 30 5G",
    "categoryPath": [
      "(322920) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322920) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / ZERO 30 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "ZERO Ultra",
    "categoryPath": [
      "(322277) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322277) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / ZERO Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "ZERO X Pro",
    "categoryPath": [
      "(322079) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Infinix"
    ],
    "hierarchy": "(322079) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Infinix / ZERO X Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne marki",
    "categoryPath": [
      "(170) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(170) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Inne marki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Drive 9",
    "categoryPath": [
      "(321290) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Kruger&Matz"
    ],
    "hierarchy": "(321290) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Kruger&Matz / Drive 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Flow 9",
    "categoryPath": [
      "(321287) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Kruger&Matz"
    ],
    "hierarchy": "(321287) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Kruger&Matz / Flow 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(321302) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Kruger&Matz"
    ],
    "hierarchy": "(321302) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Kruger&Matz / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Iron",
    "categoryPath": [
      "(321299) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Kruger&Matz"
    ],
    "hierarchy": "(321299) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Kruger&Matz / Iron",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Live 9",
    "categoryPath": [
      "(321281) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Kruger&Matz"
    ],
    "hierarchy": "(321281) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Kruger&Matz / Live 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "G2 Mini",
    "categoryPath": [
      "(148764) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(148764) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / G2 Mini",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "G3 S",
    "categoryPath": [
      "(250366) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(250366) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / G3 S",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "G6",
    "categoryPath": [
      "(256979) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(256979) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / G6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(14432) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(14432) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "K10",
    "categoryPath": [
      "(254979) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(254979) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / K10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "K11",
    "categoryPath": [
      "(258750) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(258750) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / K11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "K4 LTE",
    "categoryPath": [
      "(255205) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(255205) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / K4 LTE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "K8 LTE",
    "categoryPath": [
      "(255204) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(255204) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / K8 LTE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "K9",
    "categoryPath": [
      "(258749) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(258749) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / K9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Q6",
    "categoryPath": [
      "(257436) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(257436) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / Q6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Q7",
    "categoryPath": [
      "(258965) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(258965) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / Q7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "X Power",
    "categoryPath": [
      "(256146) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "LG"
    ],
    "hierarchy": "(256146) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / LG / X Power",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(257657) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Lenovo"
    ],
    "hierarchy": "(257657) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Lenovo / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "K6 Note",
    "categoryPath": [
      "(257654) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Lenovo"
    ],
    "hierarchy": "(257654) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Lenovo / K6 Note",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Manta",
    "categoryPath": [
      "(257178) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(257178) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Manta",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Maxcom",
    "categoryPath": [
      "(257179) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(257179) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Maxcom",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(258451) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Meizu"
    ],
    "hierarchy": "(258451) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Meizu / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(250944) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Microsoft"
    ],
    "hierarchy": "(250944) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Microsoft / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lumia 532",
    "categoryPath": [
      "(251696) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Microsoft"
    ],
    "hierarchy": "(251696) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Microsoft / Lumia 532",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lumia 535",
    "categoryPath": [
      "(250943) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Microsoft"
    ],
    "hierarchy": "(250943) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Microsoft / Lumia 535",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lumia 550",
    "categoryPath": [
      "(254258) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Microsoft"
    ],
    "hierarchy": "(254258) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Microsoft / Lumia 550",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lumia 640",
    "categoryPath": [
      "(251695) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Microsoft"
    ],
    "hierarchy": "(251695) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Microsoft / Lumia 640",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lumia 650",
    "categoryPath": [
      "(254878) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Microsoft"
    ],
    "hierarchy": "(254878) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Microsoft / Lumia 650",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 20",
    "categoryPath": [
      "(320182) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(320182) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 20",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 20 Lite",
    "categoryPath": [
      "(320185) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(320185) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 20 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 20 Pro",
    "categoryPath": [
      "(320188) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(320188) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 20 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 30",
    "categoryPath": [
      "(322015) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322015) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 30",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 30 Fusion",
    "categoryPath": [
      "(322099) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322099) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 30 Fusion",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 30 Neo",
    "categoryPath": [
      "(322098) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322098) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 30 Neo",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 30 Pro",
    "categoryPath": [
      "(321802) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321802) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 30 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 30 Ultra",
    "categoryPath": [
      "(322100) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322100) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 30 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 40",
    "categoryPath": [
      "(322650) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322650) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 40",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 40 Neo",
    "categoryPath": [
      "(322904) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322904) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 40 Neo",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Edge 40 Pro",
    "categoryPath": [
      "(322651) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322651) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Edge 40 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(147143) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(147143) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto C",
    "categoryPath": [
      "(257659) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(257659) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto C",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto C Plus",
    "categoryPath": [
      "(257660) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(257660) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto C Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E13",
    "categoryPath": [
      "(322474) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322474) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E13",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E20",
    "categoryPath": [
      "(320777) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(320777) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E20",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E22",
    "categoryPath": [
      "(322101) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322101) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E22",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E22i",
    "categoryPath": [
      "(322152) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322152) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E22i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E32s",
    "categoryPath": [
      "(322033) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322033) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E32s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E4 Plus",
    "categoryPath": [
      "(257662) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(257662) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E4 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E40",
    "categoryPath": [
      "(321083) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321083) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E40",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E5 Plus",
    "categoryPath": [
      "(260279) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(260279) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E5 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E6 Play",
    "categoryPath": [
      "(302657) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(302657) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E6 Play",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E6s",
    "categoryPath": [
      "(315642) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(315642) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E6s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E7",
    "categoryPath": [
      "(318319) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(318319) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E7 Plus",
    "categoryPath": [
      "(316203) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(316203) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E7 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E7 Power",
    "categoryPath": [
      "(318316) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(318316) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E7 Power",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto E7i Power",
    "categoryPath": [
      "(320029) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(320029) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto E7i Power",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G 5G",
    "categoryPath": [
      "(317895) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(317895) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G10",
    "categoryPath": [
      "(318304) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(318304) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G100",
    "categoryPath": [
      "(318313) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(318313) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G100",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G13",
    "categoryPath": [
      "(322476) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322476) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G13",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G14",
    "categoryPath": [
      "(322850) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322850) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G14",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G2",
    "categoryPath": [
      "(254243) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(254243) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G23",
    "categoryPath": [
      "(322478) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322478) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G23",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G3",
    "categoryPath": [
      "(254244) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(254244) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G30",
    "categoryPath": [
      "(318307) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(318307) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G30",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G31",
    "categoryPath": [
      "(321347) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321347) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G31",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G32",
    "categoryPath": [
      "(322315) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322315) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G32",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G4",
    "categoryPath": [
      "(256049) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(256049) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G4 Plus",
    "categoryPath": [
      "(256050) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(256050) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G4 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G41",
    "categoryPath": [
      "(321344) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321344) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G41",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G42",
    "categoryPath": [
      "(322036) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322036) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G42",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G5",
    "categoryPath": [
      "(256985) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(256985) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G50",
    "categoryPath": [
      "(318310) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(318310) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G50",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G51",
    "categoryPath": [
      "(321053) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321053) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G51",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G52",
    "categoryPath": [
      "(322016) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322016) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G52",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G5s",
    "categoryPath": [
      "(257663) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(257663) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G5s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G5s Plus",
    "categoryPath": [
      "(257664) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(257664) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G5s Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G6",
    "categoryPath": [
      "(258546) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(258546) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G6 Play",
    "categoryPath": [
      "(258751) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(258751) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G6 Play",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G6 Plus",
    "categoryPath": [
      "(258545) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(258545) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G6 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G60",
    "categoryPath": [
      "(319027) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(319027) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G60",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G62 5G",
    "categoryPath": [
      "(322035) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322035) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G62 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G7 Play",
    "categoryPath": [
      "(260663) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(260663) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G7 Play",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G7 Power",
    "categoryPath": [
      "(260665) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(260665) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G7 Power",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G72",
    "categoryPath": [
      "(322102) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322102) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G72",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G73",
    "categoryPath": [
      "(322475) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322475) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G73",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G8",
    "categoryPath": [
      "(311649) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(311649) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G8 Plus",
    "categoryPath": [
      "(302645) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(302645) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G8 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G8 Power",
    "categoryPath": [
      "(305037) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(305037) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G8 Power",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G82 5G",
    "categoryPath": [
      "(322034) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322034) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G82 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G84",
    "categoryPath": [
      "(322905) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322905) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G84",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto G9 Play",
    "categoryPath": [
      "(315627) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(315627) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto G9 Play",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Moto X4",
    "categoryPath": [
      "(257495) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(257495) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Moto X4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "One",
    "categoryPath": [
      "(260330) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(260330) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / One",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "One Action",
    "categoryPath": [
      "(300321) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(300321) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / One Action",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "One Macro",
    "categoryPath": [
      "(302633) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(302633) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / One Macro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "One Vision",
    "categoryPath": [
      "(261680) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(261680) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / One Vision",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Razr 2022",
    "categoryPath": [
      "(322103) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322103) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Razr 2022",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Razr 40",
    "categoryPath": [
      "(322849) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322849) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Razr 40",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Razr 40 Ultra",
    "categoryPath": [
      "(322848) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322848) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Razr 40 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Razr 5G",
    "categoryPath": [
      "(315639) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(315639) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / Razr 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "ThinkPhone",
    "categoryPath": [
      "(322477) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(322477) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / ThinkPhone",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "V3",
    "categoryPath": [
      "(254250) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(254250) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / V3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "g200",
    "categoryPath": [
      "(321829) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321829) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / g200",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "g22",
    "categoryPath": [
      "(321808) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321808) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / g22",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "g71 5G",
    "categoryPath": [
      "(321805) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Motorola"
    ],
    "hierarchy": "(321805) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Motorola / g71 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "105",
    "categoryPath": [
      "(145928) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(145928) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 105",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "150",
    "categoryPath": [
      "(256964) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(256964) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 150",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "230",
    "categoryPath": [
      "(148384) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(148384) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 230",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "3",
    "categoryPath": [
      "(257023) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(257023) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "3.1",
    "categoryPath": [
      "(258991) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(258991) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 3.1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "3310",
    "categoryPath": [
      "(4980) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(4980) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 3310",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "3310 (2017)",
    "categoryPath": [
      "(257021) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(257021) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 3310 (2017)",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "5",
    "categoryPath": [
      "(257024) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(257024) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "5.1",
    "categoryPath": [
      "(258992) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(258992) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 5.1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "520 Lumia",
    "categoryPath": [
      "(132165) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(132165) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 520 Lumia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "630 Lumia",
    "categoryPath": [
      "(148772) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(148772) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 630 Lumia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "6300",
    "categoryPath": [
      "(46785) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(46785) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 6300",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "6303 Classic",
    "categoryPath": [
      "(64294) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(64294) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 6303 Classic",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "6310i",
    "categoryPath": [
      "(15689) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(15689) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 6310i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "635 Lumia",
    "categoryPath": [
      "(249183) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(249183) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 635 Lumia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "735 Lumia",
    "categoryPath": [
      "(250376) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(250376) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 735 Lumia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8",
    "categoryPath": [
      "(257387) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(257387) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8800",
    "categoryPath": [
      "(14455) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(14455) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 8800",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "930 Lumia",
    "categoryPath": [
      "(249184) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(249184) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / 930 Lumia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C5",
    "categoryPath": [
      "(79501) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(79501) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / C5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "E52",
    "categoryPath": [
      "(66386) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(66386) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / E52",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "G42",
    "categoryPath": [
      "(322861) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(322861) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / G42",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(5006) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Nokia"
    ],
    "hierarchy": "(5006) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nokia / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nothing",
    "categoryPath": [
      "(322104) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(322104) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Nothing",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "10 Pro",
    "categoryPath": [
      "(321700) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(321700) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 10 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "10T",
    "categoryPath": [
      "(322082) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(322082) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 10T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "11",
    "categoryPath": [
      "(322401) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(322401) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "6",
    "categoryPath": [
      "(258705) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(258705) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "6T",
    "categoryPath": [
      "(260334) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(260334) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 6T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "7",
    "categoryPath": [
      "(261033) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(261033) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "7 Pro",
    "categoryPath": [
      "(261034) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(261034) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 7 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "7T",
    "categoryPath": [
      "(300929) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(300929) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 7T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8",
    "categoryPath": [
      "(306909) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(306909) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8 Pro",
    "categoryPath": [
      "(306921) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(306921) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 8 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8T",
    "categoryPath": [
      "(317829) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(317829) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 8T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "9",
    "categoryPath": [
      "(317883) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(317883) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "9 Pro",
    "categoryPath": [
      "(317886) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(317886) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / 9 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(257784) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(257784) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nord",
    "categoryPath": [
      "(313165) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(313165) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / Nord",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nord 2",
    "categoryPath": [
      "(320167) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(320167) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / Nord 2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nord 2T 5G",
    "categoryPath": [
      "(321965) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(321965) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / Nord 2T 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nord 3 5G",
    "categoryPath": [
      "(322675) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(322675) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / Nord 3 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nord CE 2 Lite 5G",
    "categoryPath": [
      "(321966) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(321966) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / Nord CE 2 Lite 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nord CE 3 Lite",
    "categoryPath": [
      "(322510) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "OnePlus"
    ],
    "hierarchy": "(322510) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / OnePlus / Nord CE 3 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A12",
    "categoryPath": [
      "(311709) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(311709) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A15",
    "categoryPath": [
      "(321403) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321403) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A15",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A15s",
    "categoryPath": [
      "(318813) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(318813) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A15s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A16",
    "categoryPath": [
      "(321400) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321400) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A16",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A31",
    "categoryPath": [
      "(307393) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(307393) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A31",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A38",
    "categoryPath": [
      "(322909) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322909) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A38",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A5 2020",
    "categoryPath": [
      "(302270) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(302270) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A5 2020",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A52",
    "categoryPath": [
      "(311721) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(311721) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A52",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A53",
    "categoryPath": [
      "(317411) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(317411) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A53",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A54",
    "categoryPath": [
      "(321050) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321050) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A54",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A54s",
    "categoryPath": [
      "(321047) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321047) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A54s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A58",
    "categoryPath": [
      "(322910) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322910) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A58",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A72",
    "categoryPath": [
      "(311697) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(311697) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A72",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A73",
    "categoryPath": [
      "(316200) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(316200) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A73",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A74",
    "categoryPath": [
      "(321397) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321397) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A74",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A9 2020",
    "categoryPath": [
      "(302282) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(302282) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A9 2020",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A91",
    "categoryPath": [
      "(311685) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(311685) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A91",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "A96",
    "categoryPath": [
      "(321747) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321747) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / A96",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Find N2 Flip",
    "categoryPath": [
      "(322409) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322409) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Find N2 Flip",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Find X",
    "categoryPath": [
      "(260586) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(260586) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Find X",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Find X5",
    "categoryPath": [
      "(321453) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321453) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Find X5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Find X5 Lite",
    "categoryPath": [
      "(321532) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321532) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Find X5 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Find X5 Pro",
    "categoryPath": [
      "(321529) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321529) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Find X5 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(260599) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(260599) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno 10X Zoom",
    "categoryPath": [
      "(302246) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(302246) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno 10X Zoom",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno10",
    "categoryPath": [
      "(322806) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322806) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno10 Pro",
    "categoryPath": [
      "(322807) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322807) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno10 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno2 Z",
    "categoryPath": [
      "(302318) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(302318) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno2 Z",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno3",
    "categoryPath": [
      "(307573) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(307573) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno4 Lite",
    "categoryPath": [
      "(315908) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(315908) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno4 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno4 Pro",
    "categoryPath": [
      "(315905) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(315905) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno4 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno4 Z",
    "categoryPath": [
      "(317414) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(317414) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno4 Z",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno5",
    "categoryPath": [
      "(318247) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(318247) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno5 Lite",
    "categoryPath": [
      "(318250) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(318250) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno5 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno5 Z",
    "categoryPath": [
      "(321394) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321394) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno5 Z",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno6 5G",
    "categoryPath": [
      "(321388) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321388) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno6 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno6 Pro 5G",
    "categoryPath": [
      "(321391) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321391) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno6 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno7",
    "categoryPath": [
      "(321714) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321714) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno7 5G",
    "categoryPath": [
      "(321720) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321720) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno7 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno7 Lite 5G",
    "categoryPath": [
      "(321717) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(321717) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno7 Lite 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno8 5G",
    "categoryPath": [
      "(322324) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322324) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno8 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno8 Pro 5G",
    "categoryPath": [
      "(322325) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322325) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno8 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Reno8 T",
    "categoryPath": [
      "(322408) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oppo"
    ],
    "hierarchy": "(322408) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oppo / Reno8 T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(317534) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oukitel"
    ],
    "hierarchy": "(317534) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oukitel / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "WP10",
    "categoryPath": [
      "(317513) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oukitel"
    ],
    "hierarchy": "(317513) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oukitel / WP10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "WP5",
    "categoryPath": [
      "(317528) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oukitel"
    ],
    "hierarchy": "(317528) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oukitel / WP5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "WP5 Pro",
    "categoryPath": [
      "(317525) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oukitel"
    ],
    "hierarchy": "(317525) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oukitel / WP5 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "WP6",
    "categoryPath": [
      "(317522) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oukitel"
    ],
    "hierarchy": "(317522) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oukitel / WP6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "WP8 Pro",
    "categoryPath": [
      "(317516) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Oukitel"
    ],
    "hierarchy": "(317516) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Oukitel / WP8 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(322903) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322903) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO C40",
    "categoryPath": [
      "(322056) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322056) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO C40",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO C65",
    "categoryPath": [
      "(322931) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322931) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO C65",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO F3",
    "categoryPath": [
      "(318325) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(318325) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO F3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO F4",
    "categoryPath": [
      "(321995) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(321995) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO F4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO F4 GT",
    "categoryPath": [
      "(321878) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(321878) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO F4 GT",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO F5",
    "categoryPath": [
      "(322518) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322518) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO F5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO F5 Pro",
    "categoryPath": [
      "(322519) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322519) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO F5 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO M3",
    "categoryPath": [
      "(316715) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(316715) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO M3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO M3 Pro 5G",
    "categoryPath": [
      "(319295) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(319295) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO M3 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO M4 Pro",
    "categoryPath": [
      "(321637) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(321637) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO M4 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO M4 Pro 5G",
    "categoryPath": [
      "(320891) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(320891) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO M4 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO M5",
    "categoryPath": [
      "(322089) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322089) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO M5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO M5s",
    "categoryPath": [
      "(322090) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322090) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO M5s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO X3",
    "categoryPath": [
      "(315357) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(315357) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO X3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO X3 Pro",
    "categoryPath": [
      "(318205) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(318205) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO X3 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO X4 GT",
    "categoryPath": [
      "(321996) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(321996) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO X4 GT",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO X4 Pro 5G",
    "categoryPath": [
      "(321474) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(321474) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO X4 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO X5 5G",
    "categoryPath": [
      "(322389) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322389) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO X5 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POCO X5 Pro 5G",
    "categoryPath": [
      "(322388) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "POCO"
    ],
    "hierarchy": "(322388) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / POCO / POCO X5 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Panasonic",
    "categoryPath": [
      "(319676) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(319676) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Panasonic",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "B2710 Solid",
    "categoryPath": [
      "(107021) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(107021) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / B2710 Solid",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A02s",
    "categoryPath": [
      "(317216) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317216) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A02s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A03s",
    "categoryPath": [
      "(320677) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(320677) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A03s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A04s",
    "categoryPath": [
      "(322239) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322239) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A04s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A10",
    "categoryPath": [
      "(260885) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260885) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A12",
    "categoryPath": [
      "(317213) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317213) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A13",
    "categoryPath": [
      "(321738) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321738) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A13",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A14",
    "categoryPath": [
      "(322415) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322415) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A14",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A20e",
    "categoryPath": [
      "(260886) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260886) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A20e",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A20s",
    "categoryPath": [
      "(313237) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(313237) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A20s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A21s",
    "categoryPath": [
      "(309661) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(309661) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A21s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A22",
    "categoryPath": [
      "(319778) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(319778) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A22",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A23",
    "categoryPath": [
      "(322837) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322837) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A23",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A3",
    "categoryPath": [
      "(251202) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(251202) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A30s",
    "categoryPath": [
      "(260850) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260850) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A30s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A31",
    "categoryPath": [
      "(313009) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(313009) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A31",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A32",
    "categoryPath": [
      "(317219) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317219) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A32",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A32 5G",
    "categoryPath": [
      "(317694) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317694) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A32 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A33",
    "categoryPath": [
      "(321661) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321661) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A33",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A34",
    "categoryPath": [
      "(322414) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322414) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A34",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A40",
    "categoryPath": [
      "(260866) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260866) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A40",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A41",
    "categoryPath": [
      "(309673) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(309673) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A41",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A42",
    "categoryPath": [
      "(316612) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(316612) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A42",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A5",
    "categoryPath": [
      "(251203) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(251203) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A50",
    "categoryPath": [
      "(260851) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260851) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A50",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A51",
    "categoryPath": [
      "(303677) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303677) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A51",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A52",
    "categoryPath": [
      "(317222) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317222) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A52",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A52s",
    "categoryPath": [
      "(320164) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(320164) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A52s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A53",
    "categoryPath": [
      "(321658) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321658) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A53",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A54",
    "categoryPath": [
      "(322413) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322413) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A54",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A6",
    "categoryPath": [
      "(258706) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(258706) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A6+",
    "categoryPath": [
      "(258707) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(258707) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A6+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A7",
    "categoryPath": [
      "(251681) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(251681) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A70",
    "categoryPath": [
      "(260887) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260887) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A70",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A71",
    "categoryPath": [
      "(303689) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303689) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A71",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A72",
    "categoryPath": [
      "(317225) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317225) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A72",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A8",
    "categoryPath": [
      "(257645) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(257645) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A80",
    "categoryPath": [
      "(260888) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260888) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A80",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy A9",
    "categoryPath": [
      "(260180) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260180) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy A9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Fold",
    "categoryPath": [
      "(301046) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(301046) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Fold",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy J3",
    "categoryPath": [
      "(255528) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(255528) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy J3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy J4+",
    "categoryPath": [
      "(260116) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260116) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy J4+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy J5",
    "categoryPath": [
      "(255207) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(255207) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy J5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy J6",
    "categoryPath": [
      "(259311) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(259311) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy J6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy J6+",
    "categoryPath": [
      "(260174) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260174) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy J6+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy J7",
    "categoryPath": [
      "(255529) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(255529) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy J7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M11",
    "categoryPath": [
      "(316004) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(316004) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M12",
    "categoryPath": [
      "(318885) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(318885) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M13",
    "categoryPath": [
      "(321968) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321968) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M13",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M21",
    "categoryPath": [
      "(309817) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(309817) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M21",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M22",
    "categoryPath": [
      "(320816) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(320816) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M22",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M23",
    "categoryPath": [
      "(321664) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321664) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M23",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M31s",
    "categoryPath": [
      "(315330) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(315330) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M31s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M33",
    "categoryPath": [
      "(322370) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322370) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M33",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M34",
    "categoryPath": [
      "(322922) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322922) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M34",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M51",
    "categoryPath": [
      "(315527) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(315527) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M51",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M52",
    "categoryPath": [
      "(320641) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(320641) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M52",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy M53",
    "categoryPath": [
      "(321741) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321741) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy M53",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 10",
    "categoryPath": [
      "(261762) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(261762) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 10 Lite",
    "categoryPath": [
      "(303701) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303701) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 10 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 10+",
    "categoryPath": [
      "(261763) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(261763) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 10+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 20",
    "categoryPath": [
      "(313589) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(313589) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 20",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 20 Ultra",
    "categoryPath": [
      "(313601) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(313601) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 20 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 4",
    "categoryPath": [
      "(250379) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(250379) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 8",
    "categoryPath": [
      "(257243) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(257243) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Note 9",
    "categoryPath": [
      "(258995) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(258995) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Note 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S10",
    "categoryPath": [
      "(260666) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260666) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S10 Lite",
    "categoryPath": [
      "(303713) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303713) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S10 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S10+",
    "categoryPath": [
      "(260667) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260667) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S10+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S10e",
    "categoryPath": [
      "(260682) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(260682) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S10e",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S20",
    "categoryPath": [
      "(303885) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303885) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S20",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S20 FE",
    "categoryPath": [
      "(315681) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(315681) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S20 FE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S20 Ultra",
    "categoryPath": [
      "(303909) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303909) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S20 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S20+",
    "categoryPath": [
      "(303897) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303897) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S20+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S21",
    "categoryPath": [
      "(317195) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317195) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S21",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S21 FE",
    "categoryPath": [
      "(321128) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321128) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S21 FE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S21 Ultra",
    "categoryPath": [
      "(317201) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317201) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S21 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S21+",
    "categoryPath": [
      "(317198) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(317198) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S21+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S22",
    "categoryPath": [
      "(321329) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321329) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S22",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S22 Ultra",
    "categoryPath": [
      "(321335) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321335) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S22 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S22+",
    "categoryPath": [
      "(321332) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(321332) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S22+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S23",
    "categoryPath": [
      "(322377) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322377) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S23",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S23 FE",
    "categoryPath": [
      "(322970) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322970) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S23 FE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S23 Ultra",
    "categoryPath": [
      "(322379) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322379) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S23 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S23+",
    "categoryPath": [
      "(322378) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322378) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S23+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S6",
    "categoryPath": [
      "(251462) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(251462) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S6 edge",
    "categoryPath": [
      "(251463) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(251463) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S6 edge",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S7",
    "categoryPath": [
      "(254338) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(254338) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S7 edge",
    "categoryPath": [
      "(254339) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(254339) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S7 edge",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S8",
    "categoryPath": [
      "(256962) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(256962) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S8+",
    "categoryPath": [
      "(256963) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(256963) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S8+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S9",
    "categoryPath": [
      "(257671) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(257671) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy S9+",
    "categoryPath": [
      "(257672) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(257672) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy S9+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy XCover 4s",
    "categoryPath": [
      "(302841) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(302841) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy XCover 4s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy XCover 5",
    "categoryPath": [
      "(320407) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(320407) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy XCover 5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy XCover Pro",
    "categoryPath": [
      "(303873) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(303873) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy XCover Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Xcover 3",
    "categoryPath": [
      "(252977) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(252977) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Xcover 3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Xcover 4",
    "categoryPath": [
      "(256969) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(256969) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Xcover 4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Flip",
    "categoryPath": [
      "(316007) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(316007) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Flip",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Flip3",
    "categoryPath": [
      "(320113) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(320113) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Flip3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Flip4",
    "categoryPath": [
      "(322070) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322070) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Flip4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Flip5",
    "categoryPath": [
      "(322703) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322703) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Flip5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Fold2",
    "categoryPath": [
      "(314761) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(314761) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Fold2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Fold3",
    "categoryPath": [
      "(320110) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(320110) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Fold3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Fold4",
    "categoryPath": [
      "(322069) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322069) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Fold4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Galaxy Z Fold5",
    "categoryPath": [
      "(322704) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(322704) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Galaxy Z Fold5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(5015) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Samsung"
    ],
    "hierarchy": "(5015) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Samsung / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(121187) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(121187) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA 1",
    "categoryPath": [
      "(260714) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(260714) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA 1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA 10",
    "categoryPath": [
      "(260715) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(260715) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA 5",
    "categoryPath": [
      "(300617) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(300617) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA 5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA E",
    "categoryPath": [
      "(132168) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(132168) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA E",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA E4",
    "categoryPath": [
      "(251724) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(251724) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA E4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA E5",
    "categoryPath": [
      "(256026) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(256026) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA E5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA J",
    "categoryPath": [
      "(125189) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(125189) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA J",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA L1",
    "categoryPath": [
      "(257003) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(257003) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA L1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA M",
    "categoryPath": [
      "(145936) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(145936) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA M",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA M2",
    "categoryPath": [
      "(248971) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(248971) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA M2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA M4 Aqua",
    "categoryPath": [
      "(251726) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(251726) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA M4 Aqua",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA M5",
    "categoryPath": [
      "(254838) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(254838) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA M5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA T3",
    "categoryPath": [
      "(249469) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(249469) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA T3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA XA",
    "categoryPath": [
      "(256022) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(256022) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA XA",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA XA1",
    "categoryPath": [
      "(257001) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(257001) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA XA1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA XA2",
    "categoryPath": [
      "(257666) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(257666) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA XA2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA XZ",
    "categoryPath": [
      "(256092) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(256092) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA XZ",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA Z",
    "categoryPath": [
      "(127374) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(127374) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA Z",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA Z1",
    "categoryPath": [
      "(146537) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(146537) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA Z1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA Z1 Compact",
    "categoryPath": [
      "(148290) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(148290) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA Z1 Compact",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA Z3",
    "categoryPath": [
      "(249583) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(249583) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA Z3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "XPERIA Z3 Compact",
    "categoryPath": [
      "(249584) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony"
    ],
    "hierarchy": "(249584) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony / XPERIA Z3 Compact",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(5045) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Sony Ericsson"
    ],
    "hierarchy": "(5045) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Sony Ericsson / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "30",
    "categoryPath": [
      "(321726) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(321726) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / 30",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "30 Plus",
    "categoryPath": [
      "(321729) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(321729) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / 30 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "30 SE",
    "categoryPath": [
      "(321759) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(321759) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / 30 SE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "306",
    "categoryPath": [
      "(321735) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(321735) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / 306",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "3189 4G",
    "categoryPath": [
      "(322017) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(322017) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / 3189 4G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "403",
    "categoryPath": [
      "(322878) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(322878) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / 403",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "406",
    "categoryPath": [
      "(322875) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(322875) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / 406",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(321762) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(321762) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Onetouch 4021",
    "categoryPath": [
      "(322876) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(322876) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / Onetouch 4021",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Onetouch 4042s",
    "categoryPath": [
      "(322874) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TCL"
    ],
    "hierarchy": "(322874) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TCL / Onetouch 4042s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(257984) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "TP-Link"
    ],
    "hierarchy": "(257984) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / TP-Link / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "POVA 5 Pro 5G",
    "categoryPath": [
      "(322863) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Tecno"
    ],
    "hierarchy": "(322863) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Tecno / POVA 5 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pop 7",
    "categoryPath": [
      "(322683) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Tecno"
    ],
    "hierarchy": "(322683) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Tecno / Pop 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Spark 10",
    "categoryPath": [
      "(322680) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Tecno"
    ],
    "hierarchy": "(322680) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Tecno / Spark 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Spark 10 Pro",
    "categoryPath": [
      "(322681) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Tecno"
    ],
    "hierarchy": "(322681) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Tecno / Spark 10 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Spark GO 2023",
    "categoryPath": [
      "(322682) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Tecno"
    ],
    "hierarchy": "(322682) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Tecno / Spark GO 2023",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "UMI",
    "categoryPath": [
      "(256447) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(256447) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / UMI",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor",
    "categoryPath": [
      "(258015) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(258015) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor 11 5G",
    "categoryPath": [
      "(320032) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(320032) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor 11 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor 17 Pro",
    "categoryPath": [
      "(322317) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(322317) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor 17 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor 8",
    "categoryPath": [
      "(319219) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(319219) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor X6",
    "categoryPath": [
      "(319230) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(319230) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor X6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor X7 Pro",
    "categoryPath": [
      "(319201) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(319201) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor X7 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor X8",
    "categoryPath": [
      "(319213) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(319213) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor X8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor X9",
    "categoryPath": [
      "(320846) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(320846) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor X9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Armor X9 Pro",
    "categoryPath": [
      "(320849) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(320849) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Armor X9 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(258014) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(258014) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Power Armor 18T",
    "categoryPath": [
      "(322316) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(322316) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Power Armor 18T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Power Armor 19",
    "categoryPath": [
      "(322472) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Ulefone"
    ],
    "hierarchy": "(322472) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Ulefone / Power Armor 19",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(319757) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(319757) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "X51",
    "categoryPath": [
      "(317838) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(317838) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / X51",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y01",
    "categoryPath": [
      "(321685) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(321685) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y01",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y16",
    "categoryPath": [
      "(322676) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(322676) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y16",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y20s",
    "categoryPath": [
      "(317835) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(317835) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y20s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y21s",
    "categoryPath": [
      "(321688) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(321688) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y21s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y33s",
    "categoryPath": [
      "(321673) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(321673) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y33s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y52",
    "categoryPath": [
      "(321679) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(321679) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y52",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y70",
    "categoryPath": [
      "(317682) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(317682) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y70",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y72",
    "categoryPath": [
      "(321676) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(321676) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y72",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Y76 5G",
    "categoryPath": [
      "(321341) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Vivo"
    ],
    "hierarchy": "(321341) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Vivo / Y76 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wiko",
    "categoryPath": [
      "(251585) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(251585) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Wiko",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "11 lite 5G",
    "categoryPath": [
      "(320822) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(320822) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 11 lite 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "11T",
    "categoryPath": [
      "(320731) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(320731) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 11T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "11T Pro",
    "categoryPath": [
      "(320734) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(320734) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 11T Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "12",
    "categoryPath": [
      "(321468) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321468) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "12 Pro",
    "categoryPath": [
      "(321471) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321471) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 12 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "12 lite",
    "categoryPath": [
      "(322279) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322279) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 12 lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "12T",
    "categoryPath": [
      "(322161) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322161) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 12T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "12T Pro",
    "categoryPath": [
      "(322162) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322162) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 12T Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "12X",
    "categoryPath": [
      "(321756) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321756) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 12X",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "13",
    "categoryPath": [
      "(322405) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322405) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 13",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "13 Pro",
    "categoryPath": [
      "(322406) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322406) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 13 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "13 Ultra",
    "categoryPath": [
      "(322515) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322515) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 13 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "13 lite",
    "categoryPath": [
      "(322407) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322407) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 13 lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "13T",
    "categoryPath": [
      "(322899) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322899) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 13T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "13T Pro",
    "categoryPath": [
      "(322900) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322900) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / 13T Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(256124) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(256124) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 10",
    "categoryPath": [
      "(307069) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(307069) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 10 Lite 5G",
    "categoryPath": [
      "(310621) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(310621) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 10 Lite 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 10T",
    "categoryPath": [
      "(316016) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(316016) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 10T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 10T Lite",
    "categoryPath": [
      "(316022) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(316022) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 10T Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 10T Pro",
    "categoryPath": [
      "(316019) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(316019) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 10T Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 11",
    "categoryPath": [
      "(317865) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(317865) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 11 Lite",
    "categoryPath": [
      "(317871) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(317871) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 11 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 11 Pro",
    "categoryPath": [
      "(317868) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(317868) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 11 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 11 Ultra",
    "categoryPath": [
      "(318777) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(318777) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 11 Ultra",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 11i",
    "categoryPath": [
      "(318807) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(318807) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 11i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 8 Lite",
    "categoryPath": [
      "(260331) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(260331) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 8 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 9",
    "categoryPath": [
      "(260703) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(260703) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 9T",
    "categoryPath": [
      "(261307) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(261307) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 9T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi 9T Pro",
    "categoryPath": [
      "(261308) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(261308) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi 9T Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi A1",
    "categoryPath": [
      "(257348) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(257348) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi A1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi A2 Lite",
    "categoryPath": [
      "(259086) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(259086) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi A2 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi Note 10",
    "categoryPath": [
      "(302450) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(302450) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi Note 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi Note 10 Lite",
    "categoryPath": [
      "(309685) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(309685) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi Note 10 Lite",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mi Note 10 Pro",
    "categoryPath": [
      "(302486) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(302486) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Mi Note 10 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 10",
    "categoryPath": [
      "(320530) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(320530) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 10 (2022)",
    "categoryPath": [
      "(322278) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322278) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 10 (2022)",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 10A",
    "categoryPath": [
      "(322672) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322672) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 10A",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 10C",
    "categoryPath": [
      "(321850) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321850) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 10C",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 12",
    "categoryPath": [
      "(322665) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322665) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 12C",
    "categoryPath": [
      "(322443) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322443) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 12C",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 13C",
    "categoryPath": [
      "(322930) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322930) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 13C",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 4A",
    "categoryPath": [
      "(256843) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(256843) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 4A",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 5",
    "categoryPath": [
      "(258007) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(258007) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 5 Plus",
    "categoryPath": [
      "(258450) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(258450) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 5 Plus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 5A",
    "categoryPath": [
      "(258013) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(258013) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 5A",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 6",
    "categoryPath": [
      "(259087) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(259087) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 6",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 6A",
    "categoryPath": [
      "(259088) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(259088) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 6A",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 7",
    "categoryPath": [
      "(260867) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(260867) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 7A",
    "categoryPath": [
      "(261583) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(261583) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 7A",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 8",
    "categoryPath": [
      "(300989) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(300989) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 8A",
    "categoryPath": [
      "(301001) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(301001) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 8A",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 9",
    "categoryPath": [
      "(311673) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(311673) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 9A",
    "categoryPath": [
      "(313273) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(313273) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 9A",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 9AT",
    "categoryPath": [
      "(316411) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(316411) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 9AT",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 9C",
    "categoryPath": [
      "(315621) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(315621) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 9C",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi 9T",
    "categoryPath": [
      "(318054) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(318054) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi 9T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi A1",
    "categoryPath": [
      "(322249) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322249) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi A1",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi A2",
    "categoryPath": [
      "(322634) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322634) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi A2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 10",
    "categoryPath": [
      "(318202) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(318202) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 10 Pro",
    "categoryPath": [
      "(318783) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(318783) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 10 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 10s",
    "categoryPath": [
      "(318810) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(318810) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 10s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 11",
    "categoryPath": [
      "(321383) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321383) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 11 Pro",
    "categoryPath": [
      "(321465) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321465) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 11 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 11 Pro 5G",
    "categoryPath": [
      "(321459) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321459) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 11 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 11 Pro+ 5G",
    "categoryPath": [
      "(321753) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321753) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 11 Pro+ 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 11S",
    "categoryPath": [
      "(321462) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(321462) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 11S",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 12",
    "categoryPath": [
      "(322501) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322501) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 12",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 12 Pro 5G",
    "categoryPath": [
      "(322502) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322502) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 12 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 12 Pro+ 5G",
    "categoryPath": [
      "(322503) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322503) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 12 Pro+ 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 12S",
    "categoryPath": [
      "(322520) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322520) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 12S",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 13 Pro",
    "categoryPath": [
      "(322981) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(322981) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 13 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 13 Pro+",
    "categoryPath": [
      "(323043) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(323043) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 13 Pro+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 4",
    "categoryPath": [
      "(256966) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(256966) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 4",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 5",
    "categoryPath": [
      "(258234) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(258234) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 5",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 7",
    "categoryPath": [
      "(260781) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(260781) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 8",
    "categoryPath": [
      "(300521) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(300521) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 8 Pro",
    "categoryPath": [
      "(300525) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(300525) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 8 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 8T",
    "categoryPath": [
      "(302330) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(302330) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 8T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 9",
    "categoryPath": [
      "(309769) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(309769) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 9",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 9 Pro",
    "categoryPath": [
      "(309781) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(309781) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 9 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 9T",
    "categoryPath": [
      "(317024) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(317024) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 9T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Redmi Note 9s",
    "categoryPath": [
      "(308509) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "Xiaomi"
    ],
    "hierarchy": "(308509) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / Xiaomi / Redmi Note 9s",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "ZTE",
    "categoryPath": [
      "(127376) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe"
    ],
    "hierarchy": "(127376) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / ZTE",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Halo 2",
    "categoryPath": [
      "(253011) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "myPhone"
    ],
    "hierarchy": "(253011) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / myPhone / Halo 2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(70581) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "myPhone"
    ],
    "hierarchy": "(70581) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / myPhone / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "10",
    "categoryPath": [
      "(322304) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322304) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 10",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "11 5G",
    "categoryPath": [
      "(322898) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322898) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 11 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "11 Pro 5G",
    "categoryPath": [
      "(322656) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322656) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 11 Pro 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "11 Pro+ 5G",
    "categoryPath": [
      "(322655) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322655) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 11 Pro+ 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "7",
    "categoryPath": [
      "(315929) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(315929) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 7",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "7 5G",
    "categoryPath": [
      "(319361) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(319361) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 7 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "7 Pro",
    "categoryPath": [
      "(315926) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(315926) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 7 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "7i",
    "categoryPath": [
      "(316408) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(316408) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 7i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8",
    "categoryPath": [
      "(318214) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(318214) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 8",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8 Pro",
    "categoryPath": [
      "(318217) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(318217) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 8 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "8i",
    "categoryPath": [
      "(320689) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(320689) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 8i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "9 4G",
    "categoryPath": [
      "(321847) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321847) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 9 4G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "9 5G",
    "categoryPath": [
      "(321846) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321846) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 9 5G",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "9 Pro",
    "categoryPath": [
      "(321377) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321377) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 9 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "9 Pro+",
    "categoryPath": [
      "(321380) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321380) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 9 Pro+",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "9i",
    "categoryPath": [
      "(321374) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321374) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / 9i",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C11",
    "categoryPath": [
      "(318126) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(318126) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C11",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C11 2021",
    "categoryPath": [
      "(320692) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(320692) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C11 2021",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C21",
    "categoryPath": [
      "(319298) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(319298) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C21",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C21Y",
    "categoryPath": [
      "(320894) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(320894) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C21Y",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C25Y",
    "categoryPath": [
      "(320843) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(320843) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C25Y",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C30",
    "categoryPath": [
      "(322027) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322027) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C30",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C31",
    "categoryPath": [
      "(321820) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321820) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C31",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C33",
    "categoryPath": [
      "(322270) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322270) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C33",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C35",
    "categoryPath": [
      "(321750) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321750) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C35",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C51",
    "categoryPath": [
      "(322835) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322835) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C51",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C53",
    "categoryPath": [
      "(322662) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322662) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C53",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "C55",
    "categoryPath": [
      "(322442) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322442) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / C55",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "GT",
    "categoryPath": [
      "(319577) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(319577) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / GT",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "GT 2",
    "categoryPath": [
      "(321511) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321511) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / GT 2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "GT 2 Pro",
    "categoryPath": [
      "(321514) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321514) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / GT 2 Pro",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "GT ME",
    "categoryPath": [
      "(321071) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321071) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / GT ME",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "GT Neo 2",
    "categoryPath": [
      "(320897) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(320897) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / GT Neo 2",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "GT Neo 3",
    "categoryPath": [
      "(321997) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321997) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / GT Neo 3",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "GT Neo 3T",
    "categoryPath": [
      "(321998) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321998) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / GT Neo 3T",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne modele",
    "categoryPath": [
      "(307153) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(307153) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / Inne modele",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Narzo 50",
    "categoryPath": [
      "(321963) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321963) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / Narzo 50",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Narzo 50A Prime",
    "categoryPath": [
      "(321964) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(321964) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / Narzo 50A Prime",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Narzo 50i Prime",
    "categoryPath": [
      "(322028) Elektronika",
      "Telefony i Akcesoria",
      "Smartfony i telefony komórkowe",
      "realme"
    ],
    "hierarchy": "(322028) Elektronika / Telefony i Akcesoria / Smartfony i telefony komórkowe / realme / Narzo 50i Prime",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Etui",
    "categoryPath": [
      "(261196) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria"
    ],
    "hierarchy": "(261196) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Etui",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Folie i szkła ochronne",
    "categoryPath": [
      "(261195) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria"
    ],
    "hierarchy": "(261195) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Folie i szkła ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Paski i bransolety",
    "categoryPath": [
      "(257989) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria"
    ],
    "hierarchy": "(257989) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Paski i bransolety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "ART",
    "categoryPath": [
      "(258003) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(258003) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / ART",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Amazfit",
    "categoryPath": [
      "(309169) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(309169) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Amazfit",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Apple",
    "categoryPath": [
      "(257990) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257990) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Apple",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Asus",
    "categoryPath": [
      "(257991) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257991) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Asus",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Bemi",
    "categoryPath": [
      "(322057) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(322057) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Bemi",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "CALMEAN",
    "categoryPath": [
      "(317662) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(317662) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / CALMEAN",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Cubot",
    "categoryPath": [
      "(318780) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(318780) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Cubot",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Fitbit",
    "categoryPath": [
      "(258004) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(258004) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Fitbit",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "G.Rossi",
    "categoryPath": [
      "(319093) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(319093) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / G.Rossi",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Garett",
    "categoryPath": [
      "(258005) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(258005) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Garett",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Garmin",
    "categoryPath": [
      "(260390) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(260390) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Garmin",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Giewont",
    "categoryPath": [
      "(322122) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(322122) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Giewont",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Goclever",
    "categoryPath": [
      "(257992) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257992) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Goclever",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Haylou",
    "categoryPath": [
      "(319679) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(319679) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Haylou",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Honor",
    "categoryPath": [
      "(309157) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(309157) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Honor",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Huawei",
    "categoryPath": [
      "(257993) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257993) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Huawei",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Inne marki",
    "categoryPath": [
      "(258002) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(258002) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Inne marki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "KingWear",
    "categoryPath": [
      "(319682) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(319682) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / KingWear",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Kruger&Matz",
    "categoryPath": [
      "(257994) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257994) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Kruger&Matz",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "LG",
    "categoryPath": [
      "(257995) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257995) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / LG",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Lenovo",
    "categoryPath": [
      "(310157) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(310157) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Lenovo",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Manta",
    "categoryPath": [
      "(322087) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(322087) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Manta",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Maxcom",
    "categoryPath": [
      "(322864) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(322864) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Maxcom",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Motorola",
    "categoryPath": [
      "(257996) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257996) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Motorola",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mykronoz",
    "categoryPath": [
      "(257997) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257997) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Mykronoz",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Oppo",
    "categoryPath": [
      "(317790) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(317790) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Oppo",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Overmax",
    "categoryPath": [
      "(257998) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257998) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Overmax",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pacific",
    "categoryPath": [
      "(319096) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(319096) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Pacific",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Realme",
    "categoryPath": [
      "(317670) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(317670) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Realme",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Rubicon",
    "categoryPath": [
      "(319090) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(319090) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Rubicon",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Samsung",
    "categoryPath": [
      "(257999) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(257999) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Samsung",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Sony",
    "categoryPath": [
      "(258000) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(258000) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Sony",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "TCL",
    "categoryPath": [
      "(321994) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(321994) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / TCL",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Ulefone",
    "categoryPath": [
      "(321356) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(321356) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Ulefone",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Watchmark",
    "categoryPath": [
      "(308905) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(308905) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Watchmark",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Xiaomi",
    "categoryPath": [
      "(258001) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(258001) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Xiaomi",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zaxer",
    "categoryPath": [
      "(318855) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria",
      "Smartwatche"
    ],
    "hierarchy": "(318855) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Smartwatche / Zaxer",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Ładowarki i stacje dokujące",
    "categoryPath": [
      "(261732) Elektronika",
      "Telefony i Akcesoria",
      "Smartwatche i akcesoria"
    ],
    "hierarchy": "(261732) Elektronika / Telefony i Akcesoria / Smartwatche i akcesoria / Ładowarki i stacje dokujące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Baterie i akumulatory",
    "categoryPath": [
      "(46813) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Akcesoria"
    ],
    "hierarchy": "(46813) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Akcesoria / Baterie i akumulatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Gniazda i wtyki",
    "categoryPath": [
      "(46816) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Akcesoria"
    ],
    "hierarchy": "(46816) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Akcesoria / Gniazda i wtyki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Kable i przewody",
    "categoryPath": [
      "(46814) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Akcesoria"
    ],
    "hierarchy": "(46814) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Akcesoria / Kable i przewody",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Zasilacze i ładowarki",
    "categoryPath": [
      "(46815) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Akcesoria"
    ],
    "hierarchy": "(46815) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Akcesoria / Zasilacze i ładowarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Centrale telefoniczne",
    "categoryPath": [
      "(440) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne"
    ],
    "hierarchy": "(440) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Centrale telefoniczne",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Folie",
    "categoryPath": [
      "(46793) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Faxy",
      "Akcesoria"
    ],
    "hierarchy": "(46793) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Faxy / Akcesoria / Folie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(46796) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Faxy"
    ],
    "hierarchy": "(46796) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Faxy / Urządzenia",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(245) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne"
    ],
    "hierarchy": "(245) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Telefony bezprzewodowe",
    "categoryPath": [
      "(310065) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne"
    ],
    "hierarchy": "(310065) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Telefony bezprzewodowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Telefony przewodowe",
    "categoryPath": [
      "(310069) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne"
    ],
    "hierarchy": "(310069) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Telefony przewodowe",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Bramki",
    "categoryPath": [
      "(15676) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Urządzenia VOIP"
    ],
    "hierarchy": "(15676) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Urządzenia VOIP / Bramki",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Telefony",
    "categoryPath": [
      "(15675) Elektronika",
      "Telefony i Akcesoria",
      "Urządzenia stacjonarne",
      "Urządzenia VOIP"
    ],
    "hierarchy": "(15675) Elektronika / Telefony i Akcesoria / Urządzenia stacjonarne / Urządzenia VOIP / Telefony",
    "comissionGroupOld": "C7",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Złote numery",
    "categoryPath": [
      "(310073) Elektronika",
      "Telefony i Akcesoria"
    ],
    "hierarchy": "(310073) Elektronika / Telefony i Akcesoria / Złote numery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D13"
  },
  {
    "segment": "Dziurkacze",
    "categoryPath": [
      "(64641) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64641) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Dziurkacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Identyfikatory",
    "categoryPath": [
      "(64489) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64489) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Identyfikatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kalendarze",
    "categoryPath": [
      "(306165) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(306165) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Kalendarze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kasetki",
    "categoryPath": [
      "(75759) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(75759) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Kasetki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosze na śmieci",
    "categoryPath": [
      "(64490) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64490) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Kosze na śmieci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Magnesy",
    "categoryPath": [
      "(305865) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(305865) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Magnesy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Noże do papieru",
    "categoryPath": [
      "(101346) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(101346) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Noże do papieru",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nożyczki",
    "categoryPath": [
      "(64491) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64491) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Nożyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Datowniki",
    "categoryPath": [
      "(64499) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe",
      "Pieczątki i akcesoria"
    ],
    "hierarchy": "(64499) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pieczątki i akcesoria / Datowniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drukarenki",
    "categoryPath": [
      "(64500) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe",
      "Pieczątki i akcesoria"
    ],
    "hierarchy": "(64500) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pieczątki i akcesoria / Drukarenki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gumki do pieczątek",
    "categoryPath": [
      "(64501) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe",
      "Pieczątki i akcesoria"
    ],
    "hierarchy": "(64501) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pieczątki i akcesoria / Gumki do pieczątek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Numeratory",
    "categoryPath": [
      "(64502) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe",
      "Pieczątki i akcesoria"
    ],
    "hierarchy": "(64502) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pieczątki i akcesoria / Numeratory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pieczątki",
    "categoryPath": [
      "(64503) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe",
      "Pieczątki i akcesoria"
    ],
    "hierarchy": "(64503) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pieczątki i akcesoria / Pieczątki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Poduszki i tuszownice",
    "categoryPath": [
      "(64504) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe",
      "Pieczątki i akcesoria"
    ],
    "hierarchy": "(64504) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pieczątki i akcesoria / Poduszki i tuszownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tusze",
    "categoryPath": [
      "(64505) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe",
      "Pieczątki i akcesoria"
    ],
    "hierarchy": "(64505) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pieczątki i akcesoria / Tusze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkładki na biurko",
    "categoryPath": [
      "(305793) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(305793) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Podkładki na biurko",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64488) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64488) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyborniki",
    "categoryPath": [
      "(64493) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64493) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Przyborniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Spinacze, klipsy i pinezki",
    "categoryPath": [
      "(64494) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64494) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Spinacze, klipsy i pinezki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy klejące i kleje",
    "categoryPath": [
      "(64495) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64495) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Taśmy klejące i kleje",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wizytowniki i skorowidze",
    "categoryPath": [
      "(64496) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64496) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Wizytowniki i skorowidze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zszywacze i rozszywacze",
    "categoryPath": [
      "(64497) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(64497) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Zszywacze i rozszywacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zszywki",
    "categoryPath": [
      "(305313) Firma i usługi",
      "Biuro i Reklama",
      "Akcesoria biurowe"
    ],
    "hierarchy": "(305313) Firma i usługi / Biuro i Reklama / Akcesoria biurowe / Zszywki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Etui i piórniki",
    "categoryPath": [
      "(101349) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze",
      "Akcesoria"
    ],
    "hierarchy": "(101349) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Akcesoria / Etui i piórniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Naboje i atramenty",
    "categoryPath": [
      "(101347) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze",
      "Akcesoria"
    ],
    "hierarchy": "(101347) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Akcesoria / Naboje i atramenty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wkłady",
    "categoryPath": [
      "(101348) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze",
      "Akcesoria"
    ],
    "hierarchy": "(101348) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Akcesoria / Wkłady",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Cienkopisy",
    "categoryPath": [
      "(64508) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64508) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Cienkopisy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Długopisy",
    "categoryPath": [
      "(64509) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64509) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Długopisy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gumki i korektory",
    "categoryPath": [
      "(64510) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64510) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Gumki i korektory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Markery i pisaki",
    "categoryPath": [
      "(64511) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64511) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Markery i pisaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Automatyczne",
    "categoryPath": [
      "(101350) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze",
      "Ołówki"
    ],
    "hierarchy": "(101350) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Ołówki / Automatyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tradycyjne",
    "categoryPath": [
      "(101351) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze",
      "Ołówki"
    ],
    "hierarchy": "(101351) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Ołówki / Tradycyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pióra",
    "categoryPath": [
      "(64513) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64513) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Pióra",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pióra kulkowe",
    "categoryPath": [
      "(64514) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64514) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Pióra kulkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64506) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64506) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zakreślacze",
    "categoryPath": [
      "(64515) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64515) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Zakreślacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(64516) Firma i usługi",
      "Biuro i Reklama",
      "Artykuły piśmiennicze"
    ],
    "hierarchy": "(64516) Firma i usługi / Biuro i Reklama / Artykuły piśmiennicze / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maty ochronne",
    "categoryPath": [
      "(261605) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe",
      "Akcesoria"
    ],
    "hierarchy": "(261605) Firma i usługi / Biuro i Reklama / Meble biurowe / Akcesoria / Maty ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podnóżki",
    "categoryPath": [
      "(261587) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe",
      "Akcesoria"
    ],
    "hierarchy": "(261587) Firma i usługi / Biuro i Reklama / Meble biurowe / Akcesoria / Podnóżki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podpórki pod plecy",
    "categoryPath": [
      "(261588) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe",
      "Akcesoria"
    ],
    "hierarchy": "(261588) Firma i usługi / Biuro i Reklama / Meble biurowe / Akcesoria / Podpórki pod plecy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stelaże",
    "categoryPath": [
      "(261589) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe",
      "Akcesoria"
    ],
    "hierarchy": "(261589) Firma i usługi / Biuro i Reklama / Meble biurowe / Akcesoria / Stelaże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Biurka",
    "categoryPath": [
      "(101357) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(101357) Firma i usługi / Biuro i Reklama / Meble biurowe / Biurka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Blaty do biurek",
    "categoryPath": [
      "(322097) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(322097) Firma i usługi / Biuro i Reklama / Meble biurowe / Blaty do biurek",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Fotele",
    "categoryPath": [
      "(64519) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(64519) Firma i usługi / Biuro i Reklama / Meble biurowe / Fotele",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Kontenery",
    "categoryPath": [
      "(64520) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(64520) Firma i usługi / Biuro i Reklama / Meble biurowe / Kontenery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Lady",
    "categoryPath": [
      "(101358) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(101358) Firma i usługi / Biuro i Reklama / Meble biurowe / Lady",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64517) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(64517) Firma i usługi / Biuro i Reklama / Meble biurowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sejfy i kasy pancerne",
    "categoryPath": [
      "(64523) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(64523) Firma i usługi / Biuro i Reklama / Meble biurowe / Sejfy i kasy pancerne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły i ławy",
    "categoryPath": [
      "(64524) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(64524) Firma i usługi / Biuro i Reklama / Meble biurowe / Stoły i ławy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Szafy",
    "categoryPath": [
      "(64525) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(64525) Firma i usługi / Biuro i Reklama / Meble biurowe / Szafy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Zestawy mebli",
    "categoryPath": [
      "(64526) Firma i usługi",
      "Biuro i Reklama",
      "Meble biurowe"
    ],
    "hierarchy": "(64526) Firma i usługi / Biuro i Reklama / Meble biurowe / Zestawy mebli",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Clipboardy",
    "categoryPath": [
      "(261498) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(261498) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Clipboardy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kartony archiwizacyjne",
    "categoryPath": [
      "(64528) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64528) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Kartony archiwizacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koszulki i obwoluty",
    "categoryPath": [
      "(64529) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64529) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Koszulki i obwoluty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kuwety na dokumenty",
    "categoryPath": [
      "(261499) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(261499) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Kuwety na dokumenty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ofertówki",
    "categoryPath": [
      "(64530) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64530) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Ofertówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oprawa prac",
    "categoryPath": [
      "(261606) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(261606) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Oprawa prac",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Organizery i szuflady",
    "categoryPath": [
      "(261500) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(261500) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Organizery i szuflady",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64527) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64527) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przekładki i zakładki",
    "categoryPath": [
      "(64531) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64531) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Przekładki i zakładki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Segregatory",
    "categoryPath": [
      "(64532) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64532) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Segregatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skoroszyty",
    "categoryPath": [
      "(64533) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64533) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Skoroszyty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Teczki",
    "categoryPath": [
      "(64534) Firma i usługi",
      "Biuro i Reklama",
      "Organizacja dokumentów"
    ],
    "hierarchy": "(64534) Firma i usługi / Biuro i Reklama / Organizacja dokumentów / Teczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Doypack",
    "categoryPath": [
      "(322838) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(322838) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Doypack",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dyspensery",
    "categoryPath": [
      "(101356) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(101356) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Dyspensery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Etykiety samoprzylepne",
    "categoryPath": [
      "(64536) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64536) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Etykiety samoprzylepne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bąbelkowa",
    "categoryPath": [
      "(64547) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Folia"
    ],
    "hierarchy": "(64547) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Folia / Bąbelkowa",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Celofan",
    "categoryPath": [
      "(260958) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Folia"
    ],
    "hierarchy": "(260958) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Folia / Celofan",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rękawy foliowe",
    "categoryPath": [
      "(306309) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Folia"
    ],
    "hierarchy": "(306309) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Folia / Rękawy foliowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stretch",
    "categoryPath": [
      "(64548) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Folia"
    ],
    "hierarchy": "(64548) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Folia / Stretch",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Foliopaki",
    "categoryPath": [
      "(320825) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(320825) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Foliopaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gumki recepturki",
    "categoryPath": [
      "(75757) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(75757) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Gumki recepturki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Biurowe",
    "categoryPath": [
      "(64550) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Koperty"
    ],
    "hierarchy": "(64550) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Koperty / Biurowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ochronne",
    "categoryPath": [
      "(64551) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Koperty"
    ],
    "hierarchy": "(64551) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Koperty / Ochronne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ozdobne",
    "categoryPath": [
      "(64552) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Koperty"
    ],
    "hierarchy": "(64552) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Koperty / Ozdobne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64549) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka",
      "Koperty"
    ],
    "hierarchy": "(64549) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Koperty / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Papier pakowy",
    "categoryPath": [
      "(64539) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64539) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Papier pakowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64535) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64535) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przylgi",
    "categoryPath": [
      "(322469) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(322469) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Przylgi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pudełka i kartony",
    "categoryPath": [
      "(64540) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64540) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Pudełka i kartony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Taśmy pakowe",
    "categoryPath": [
      "(64541) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64541) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Taśmy pakowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tektura",
    "categoryPath": [
      "(76773) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(76773) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Tektura",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Torby papierowe",
    "categoryPath": [
      "(64542) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64542) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Torby papierowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tuby",
    "categoryPath": [
      "(64543) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64543) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Tuby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Woreczki i torby foliowe",
    "categoryPath": [
      "(64544) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64544) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Woreczki i torby foliowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wypełniacze",
    "categoryPath": [
      "(64545) Firma i usługi",
      "Biuro i Reklama",
      "Pakowanie i wysyłka"
    ],
    "hierarchy": "(64545) Firma i usługi / Biuro i Reklama / Pakowanie i wysyłka / Wypełniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bloki",
    "categoryPath": [
      "(64554) Firma i usługi",
      "Biuro i Reklama",
      "Papier"
    ],
    "hierarchy": "(64554) Firma i usługi / Biuro i Reklama / Papier / Bloki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bruliony",
    "categoryPath": [
      "(64555) Firma i usługi",
      "Biuro i Reklama",
      "Papier"
    ],
    "hierarchy": "(64555) Firma i usługi / Biuro i Reklama / Papier / Bruliony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Druki",
    "categoryPath": [
      "(64556) Firma i usługi",
      "Biuro i Reklama",
      "Papier"
    ],
    "hierarchy": "(64556) Firma i usługi / Biuro i Reklama / Papier / Druki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kostki, bloczki samoprzylepne",
    "categoryPath": [
      "(64557) Firma i usługi",
      "Biuro i Reklama",
      "Papier"
    ],
    "hierarchy": "(64557) Firma i usługi / Biuro i Reklama / Papier / Kostki, bloczki samoprzylepne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Papier biurowy",
    "categoryPath": [
      "(64558) Firma i usługi",
      "Biuro i Reklama",
      "Papier"
    ],
    "hierarchy": "(64558) Firma i usługi / Biuro i Reklama / Papier / Papier biurowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Papier ozdobny i wizytówkowy",
    "categoryPath": [
      "(125403) Firma i usługi",
      "Biuro i Reklama",
      "Papier"
    ],
    "hierarchy": "(125403) Firma i usługi / Biuro i Reklama / Papier / Papier ozdobny i wizytówkowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64553) Firma i usługi",
      "Biuro i Reklama",
      "Papier"
    ],
    "hierarchy": "(64553) Firma i usługi / Biuro i Reklama / Papier / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Cyrkle",
    "categoryPath": [
      "(64561) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64561) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Cyrkle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Deski kreślarskie",
    "categoryPath": [
      "(64562) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64562) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Deski kreślarskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Linijki i ekierki",
    "categoryPath": [
      "(64563) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64563) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Linijki i ekierki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64560) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64560) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rapidografy",
    "categoryPath": [
      "(64564) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64564) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Rapidografy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skalówki",
    "categoryPath": [
      "(64565) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64565) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Skalówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szablony",
    "categoryPath": [
      "(64566) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64566) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Szablony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tusze kreślarskie",
    "categoryPath": [
      "(64567) Firma i usługi",
      "Biuro i Reklama",
      "Przybory kreślarskie"
    ],
    "hierarchy": "(64567) Firma i usługi / Biuro i Reklama / Przybory kreślarskie / Tusze kreślarskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bloczki, notesy",
    "categoryPath": [
      "(64632) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64632) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Bloczki, notesy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Etykiety samoprzylepne",
    "categoryPath": [
      "(64633) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64633) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Etykiety samoprzylepne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kalendarzyki",
    "categoryPath": [
      "(64634) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64634) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Kalendarzyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koperty",
    "categoryPath": [
      "(64635) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64635) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Koperty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nadruki na CD/DVD",
    "categoryPath": [
      "(101353) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(101353) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Nadruki na CD/DVD",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Papier firmowy",
    "categoryPath": [
      "(64636) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64636) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Papier firmowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Plakaty",
    "categoryPath": [
      "(64637) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64637) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Plakaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pocztówki i widokówki",
    "categoryPath": [
      "(261497) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(261497) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Pocztówki i widokówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64631) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64631) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Projekty",
    "categoryPath": [
      "(101354) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(101354) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Projekty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(306321) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(306321) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Taśmy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Teczki",
    "categoryPath": [
      "(64638) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64638) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Teczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ulotki",
    "categoryPath": [
      "(64639) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64639) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Ulotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wizytówki",
    "categoryPath": [
      "(64640) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(64640) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Wizytówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zaproszenia",
    "categoryPath": [
      "(306393) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(306393) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Zaproszenia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Złączki (spinki)",
    "categoryPath": [
      "(306405) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Akcydensy (poligrafia)"
    ],
    "hierarchy": "(306405) Firma i usługi / Biuro i Reklama / Reklama / Akcydensy (poligrafia) / Złączki (spinki)",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Balony",
    "categoryPath": [
      "(260533) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(260533) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Balony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Breloki, otwieracze",
    "categoryPath": [
      "(64604) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64604) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Breloki, otwieracze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Cukierki",
    "categoryPath": [
      "(260532) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(260532) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Cukierki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Długopisy",
    "categoryPath": [
      "(64606) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64606) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Długopisy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gadżety antystresowe",
    "categoryPath": [
      "(307057) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(307057) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Gadżety antystresowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gadżety do sublimacji",
    "categoryPath": [
      "(261581) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(261581) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Gadżety do sublimacji",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kalendarze",
    "categoryPath": [
      "(260536) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(260536) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Kalendarze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kubki, szklanki, kufle",
    "categoryPath": [
      "(64607) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64607) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Kubki, szklanki, kufle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Leżaki",
    "categoryPath": [
      "(261469) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(261469) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Leżaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Magnesy",
    "categoryPath": [
      "(260534) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(260534) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Magnesy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(64605) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64605) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Odzież",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski",
    "categoryPath": [
      "(261468) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(261468) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Opaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Parasole",
    "categoryPath": [
      "(260537) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(260537) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Parasole",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pendrive",
    "categoryPath": [
      "(260538) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(260538) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Pendrive",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podkładki",
    "categoryPath": [
      "(260535) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(260535) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Podkładki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64603) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64603) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przypinki, znaczki",
    "categoryPath": [
      "(64608) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64608) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Przypinki, znaczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Smycze",
    "categoryPath": [
      "(64609) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64609) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Smycze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Torby i plecaki",
    "categoryPath": [
      "(64610) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64610) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Torby i plecaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zapałki i zapalniczki",
    "categoryPath": [
      "(64611) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Gadżety"
    ],
    "hierarchy": "(64611) Firma i usługi / Biuro i Reklama / Reklama / Gadżety / Zapałki i zapalniczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64597) Firma i usługi",
      "Biuro i Reklama",
      "Reklama"
    ],
    "hierarchy": "(64597) Firma i usługi / Biuro i Reklama / Reklama / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Banery",
    "categoryPath": [
      "(64618) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64618) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Banery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Flagi i maszty",
    "categoryPath": [
      "(64619) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64619) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Flagi i maszty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Folie i naklejki samoprzylepne",
    "categoryPath": [
      "(261682) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(261682) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Folie i naklejki samoprzylepne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kasetony",
    "categoryPath": [
      "(64620) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64620) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Kasetony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Litery",
    "categoryPath": [
      "(64621) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64621) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Litery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Neony",
    "categoryPath": [
      "(64622) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64622) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Neony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Panele LED",
    "categoryPath": [
      "(64623) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64623) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Panele LED",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Plotery",
    "categoryPath": [
      "(101355) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(101355) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Plotery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Potykacze",
    "categoryPath": [
      "(64624) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64624) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Potykacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64617) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64617) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pylony",
    "categoryPath": [
      "(64625) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64625) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Pylony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Reklama magnetyczna",
    "categoryPath": [
      "(261578) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(261578) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Reklama magnetyczna",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tablice i szyldy",
    "categoryPath": [
      "(64626) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Reklama zewnętrzna"
    ],
    "hierarchy": "(64626) Firma i usługi / Biuro i Reklama / Reklama / Reklama zewnętrzna / Tablice i szyldy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kieszenie na ulotki",
    "categoryPath": [
      "(64628) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Systemy wystawiennicze"
    ],
    "hierarchy": "(64628) Firma i usługi / Biuro i Reklama / Reklama / Systemy wystawiennicze / Kieszenie na ulotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64627) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Systemy wystawiennicze"
    ],
    "hierarchy": "(64627) Firma i usługi / Biuro i Reklama / Reklama / Systemy wystawiennicze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ramki",
    "categoryPath": [
      "(307213) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Systemy wystawiennicze"
    ],
    "hierarchy": "(307213) Firma i usługi / Biuro i Reklama / Reklama / Systemy wystawiennicze / Ramki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Roll-upy, standy",
    "categoryPath": [
      "(64629) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Systemy wystawiennicze"
    ],
    "hierarchy": "(64629) Firma i usługi / Biuro i Reklama / Reklama / Systemy wystawiennicze / Roll-upy, standy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stojaki",
    "categoryPath": [
      "(64630) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Systemy wystawiennicze"
    ],
    "hierarchy": "(64630) Firma i usługi / Biuro i Reklama / Reklama / Systemy wystawiennicze / Stojaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urny i skarbonki",
    "categoryPath": [
      "(307225) Firma i usługi",
      "Biuro i Reklama",
      "Reklama",
      "Systemy wystawiennicze"
    ],
    "hierarchy": "(307225) Firma i usługi / Biuro i Reklama / Reklama / Systemy wystawiennicze / Urny i skarbonki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bindownice",
    "categoryPath": [
      "(64579) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy",
      "Bindownice i akcesoria"
    ],
    "hierarchy": "(64579) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Bindownice i akcesoria / Bindownice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Grzbiety i okładki",
    "categoryPath": [
      "(64580) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy",
      "Bindownice i akcesoria"
    ],
    "hierarchy": "(64580) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Bindownice i akcesoria / Grzbiety i okładki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Czytniki i rejestratory",
    "categoryPath": [
      "(75758) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy"
    ],
    "hierarchy": "(75758) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Czytniki i rejestratory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Filtry prywatyzujące",
    "categoryPath": [
      "(259651) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy"
    ],
    "hierarchy": "(259651) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Filtry prywatyzujące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gilotyny i trymery",
    "categoryPath": [
      "(64571) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy"
    ],
    "hierarchy": "(64571) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Gilotyny i trymery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kalkulatory",
    "categoryPath": [
      "(64572) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy"
    ],
    "hierarchy": "(64572) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Kalkulatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Części zamienne",
    "categoryPath": [
      "(64584) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy",
      "Kserokopiarki i akcesoria"
    ],
    "hierarchy": "(64584) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Kserokopiarki i akcesoria / Części zamienne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kserokopiarki",
    "categoryPath": [
      "(64583) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy",
      "Kserokopiarki i akcesoria"
    ],
    "hierarchy": "(64583) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Kserokopiarki i akcesoria / Kserokopiarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materiały eksploatacyjne",
    "categoryPath": [
      "(64585) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy",
      "Kserokopiarki i akcesoria"
    ],
    "hierarchy": "(64585) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Kserokopiarki i akcesoria / Materiały eksploatacyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Folia",
    "categoryPath": [
      "(64587) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy",
      "Laminatory i akcesoria"
    ],
    "hierarchy": "(64587) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Laminatory i akcesoria / Folia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Laminatory",
    "categoryPath": [
      "(64588) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy",
      "Laminatory i akcesoria"
    ],
    "hierarchy": "(64588) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Laminatory i akcesoria / Laminatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Liczarki, sortery, testery",
    "categoryPath": [
      "(101352) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy"
    ],
    "hierarchy": "(101352) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Liczarki, sortery, testery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Niszczarki",
    "categoryPath": [
      "(64577) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy"
    ],
    "hierarchy": "(64577) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Niszczarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64568) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt biurowy"
    ],
    "hierarchy": "(64568) Firma i usługi / Biuro i Reklama / Sprzęt biurowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Flipcharty",
    "categoryPath": [
      "(64591) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt do prezentacji"
    ],
    "hierarchy": "(64591) Firma i usługi / Biuro i Reklama / Sprzęt do prezentacji / Flipcharty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64589) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt do prezentacji"
    ],
    "hierarchy": "(64589) Firma i usługi / Biuro i Reklama / Sprzęt do prezentacji / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Korkowe",
    "categoryPath": [
      "(64595) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt do prezentacji",
      "Tablice"
    ],
    "hierarchy": "(64595) Firma i usługi / Biuro i Reklama / Sprzęt do prezentacji / Tablice / Korkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Magnetyczne i suchościeralne",
    "categoryPath": [
      "(64596) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt do prezentacji",
      "Tablice"
    ],
    "hierarchy": "(64596) Firma i usługi / Biuro i Reklama / Sprzęt do prezentacji / Tablice / Magnetyczne i suchościeralne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(64594) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt do prezentacji",
      "Tablice"
    ],
    "hierarchy": "(64594) Firma i usługi / Biuro i Reklama / Sprzęt do prezentacji / Tablice / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wskaźniki",
    "categoryPath": [
      "(64593) Firma i usługi",
      "Biuro i Reklama",
      "Sprzęt do prezentacji"
    ],
    "hierarchy": "(64593) Firma i usługi / Biuro i Reklama / Sprzęt do prezentacji / Wskaźniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Krzyże na cmentarz",
    "categoryPath": [
      "(322647) Firma i usługi",
      "Przemysł",
      "Artykuły pogrzebowe"
    ],
    "hierarchy": "(322647) Firma i usługi / Przemysł / Artykuły pogrzebowe / Krzyże na cmentarz",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nagrobki",
    "categoryPath": [
      "(322644) Firma i usługi",
      "Przemysł",
      "Artykuły pogrzebowe"
    ],
    "hierarchy": "(322644) Firma i usługi / Przemysł / Artykuły pogrzebowe / Nagrobki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tablice na cmentarz",
    "categoryPath": [
      "(322646) Firma i usługi",
      "Przemysł",
      "Artykuły pogrzebowe"
    ],
    "hierarchy": "(322646) Firma i usługi / Przemysł / Artykuły pogrzebowe / Tablice na cmentarz",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urny",
    "categoryPath": [
      "(322645) Firma i usługi",
      "Przemysł",
      "Artykuły pogrzebowe"
    ],
    "hierarchy": "(322645) Firma i usługi / Przemysł / Artykuły pogrzebowe / Urny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wazony na cmentarz",
    "categoryPath": [
      "(322648) Firma i usługi",
      "Przemysł",
      "Artykuły pogrzebowe"
    ],
    "hierarchy": "(322648) Firma i usługi / Przemysł / Artykuły pogrzebowe / Wazony na cmentarz",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkłady i znicze",
    "categoryPath": [
      "(260568) Firma i usługi",
      "Przemysł",
      "Artykuły pogrzebowe"
    ],
    "hierarchy": "(260568) Firma i usługi / Przemysł / Artykuły pogrzebowe / Wkłady i znicze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ławki cmentarne",
    "categoryPath": [
      "(322649) Firma i usługi",
      "Przemysł",
      "Artykuły pogrzebowe"
    ],
    "hierarchy": "(322649) Firma i usługi / Przemysł / Artykuły pogrzebowe / Ławki cmentarne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Agregaty",
    "categoryPath": [
      "(121341) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(121341) Firma i usługi / Przemysł / Budownictwo przemysłowe / Agregaty",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Agregaty hydrauliczne",
    "categoryPath": [
      "(261215) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Agregaty"
    ],
    "hierarchy": "(261215) Firma i usługi / Przemysł / Budownictwo przemysłowe / Agregaty / Agregaty hydrauliczne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Agregaty malarskie",
    "categoryPath": [
      "(261212) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Agregaty"
    ],
    "hierarchy": "(261212) Firma i usługi / Przemysł / Budownictwo przemysłowe / Agregaty / Agregaty malarskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Agregaty tynkarskie",
    "categoryPath": [
      "(261214) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Agregaty"
    ],
    "hierarchy": "(261214) Firma i usługi / Przemysł / Budownictwo przemysłowe / Agregaty / Agregaty tynkarskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Betoniarki",
    "categoryPath": [
      "(121340) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(121340) Firma i usługi / Przemysł / Budownictwo przemysłowe / Betoniarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Chwytaki",
    "categoryPath": [
      "(261162) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Brukarstwo"
    ],
    "hierarchy": "(261162) Firma i usługi / Przemysł / Budownictwo przemysłowe / Brukarstwo / Chwytaki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Gilotyny brukarskie",
    "categoryPath": [
      "(261164) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Brukarstwo"
    ],
    "hierarchy": "(261164) Firma i usługi / Przemysł / Budownictwo przemysłowe / Brukarstwo / Gilotyny brukarskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Listwy zgarniające",
    "categoryPath": [
      "(261163) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Brukarstwo"
    ],
    "hierarchy": "(261163) Firma i usługi / Przemysł / Budownictwo przemysłowe / Brukarstwo / Listwy zgarniające",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Młotki brukarskie",
    "categoryPath": [
      "(261166) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Brukarstwo"
    ],
    "hierarchy": "(261166) Firma i usługi / Przemysł / Budownictwo przemysłowe / Brukarstwo / Młotki brukarskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wyważaki brukarskie",
    "categoryPath": [
      "(261165) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Brukarstwo"
    ],
    "hierarchy": "(261165) Firma i usługi / Przemysł / Budownictwo przemysłowe / Brukarstwo / Wyważaki brukarskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wózki brukarskie",
    "categoryPath": [
      "(261168) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Brukarstwo"
    ],
    "hierarchy": "(261168) Firma i usługi / Przemysł / Budownictwo przemysłowe / Brukarstwo / Wózki brukarskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Akryle",
    "categoryPath": [
      "(322870) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(322870) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Akryle",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bejce, Lakierobejce",
    "categoryPath": [
      "(261191) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261191) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Bejce, Lakierobejce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Farby",
    "categoryPath": [
      "(261189) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261189) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Farby",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Impregnaty",
    "categoryPath": [
      "(261187) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261187) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Impregnaty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inna chemia budowlana",
    "categoryPath": [
      "(261194) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261194) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Inna chemia budowlana",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(261188) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261188) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Kleje",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lakiery",
    "categoryPath": [
      "(261190) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261190) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Lakiery",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oleje",
    "categoryPath": [
      "(261193) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261193) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Oleje",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Silikony",
    "categoryPath": [
      "(261192) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Chemia budowlana"
    ],
    "hierarchy": "(261192) Firma i usługi / Przemysł / Budownictwo przemysłowe / Chemia budowlana / Silikony",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Cięcie styropianu",
    "categoryPath": [
      "(260627) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(260627) Firma i usługi / Przemysł / Budownictwo przemysłowe / Cięcie styropianu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Do pił",
    "categoryPath": [
      "(261722) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(261722) Firma i usługi / Przemysł / Budownictwo przemysłowe / Części i akcesoria / Do pił",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Do silników małolitrażowych",
    "categoryPath": [
      "(261721) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(261721) Firma i usługi / Przemysł / Budownictwo przemysłowe / Części i akcesoria / Do silników małolitrażowych",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261723) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(261723) Firma i usługi / Przemysł / Budownictwo przemysłowe / Części i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Druty, pręty, liny stalowe",
    "categoryPath": [
      "(121603) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121603) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Druty, pręty, liny stalowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gwoździe",
    "categoryPath": [
      "(121602) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121602) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Gwoździe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karabińczyki",
    "categoryPath": [
      "(306825) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(306825) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Karabińczyki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kruszywa",
    "categoryPath": [
      "(121589) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121589) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Kruszywa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kształtowniki i profile",
    "categoryPath": [
      "(121601) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121601) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Kształtowniki i profile",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materiały izolacyjne",
    "categoryPath": [
      "(121597) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121597) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Materiały izolacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materiały konstrukcyjne",
    "categoryPath": [
      "(121599) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121599) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Materiały konstrukcyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materiały wiążące",
    "categoryPath": [
      "(121605) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121605) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Materiały wiążące",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nawierzchnie",
    "categoryPath": [
      "(121598) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121598) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Nawierzchnie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rury",
    "categoryPath": [
      "(121604) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121604) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Rury",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szalunki i stemple",
    "categoryPath": [
      "(121474) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121474) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Szalunki i stemple",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szekle",
    "categoryPath": [
      "(306765) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(306765) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Szekle",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tarcze i akcesoria",
    "categoryPath": [
      "(121477) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121477) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Tarcze i akcesoria",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkręty",
    "categoryPath": [
      "(260644) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(260644) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Wkręty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Śruby, nakrętki, podkładki",
    "categoryPath": [
      "(121600) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121600) Firma i usługi / Przemysł / Budownictwo przemysłowe / Materiały i akcesoria / Śruby, nakrętki, podkładki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mieszadła elektryczne",
    "categoryPath": [
      "(261176) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(261176) Firma i usługi / Przemysł / Budownictwo przemysłowe / Mieszadła elektryczne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Nożyce",
    "categoryPath": [
      "(121343) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(121343) Firma i usługi / Przemysł / Budownictwo przemysłowe / Nożyce",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Osuszacze i pochłaniacze",
    "categoryPath": [
      "(261177) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(261177) Firma i usługi / Przemysł / Budownictwo przemysłowe / Osuszacze i pochłaniacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Piły",
    "categoryPath": [
      "(121345) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(121345) Firma i usługi / Przemysł / Budownictwo przemysłowe / Piły",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Podnośniki i wciągarki",
    "categoryPath": [
      "(125765) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(125765) Firma i usługi / Przemysł / Budownictwo przemysłowe / Podnośniki i wciągarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Podnośniki do płyt",
    "categoryPath": [
      "(261310) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Podnośniki i wciągarki"
    ],
    "hierarchy": "(261310) Firma i usługi / Przemysł / Budownictwo przemysłowe / Podnośniki i wciągarki / Podnośniki do płyt",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Podnośniki magnetyczne",
    "categoryPath": [
      "(261311) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Podnośniki i wciągarki"
    ],
    "hierarchy": "(261311) Firma i usługi / Przemysł / Budownictwo przemysłowe / Podnośniki i wciągarki / Podnośniki magnetyczne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wciągarki i wyciągarki",
    "categoryPath": [
      "(261309) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Podnośniki i wciągarki"
    ],
    "hierarchy": "(261309) Firma i usługi / Przemysł / Budownictwo przemysłowe / Podnośniki i wciągarki / Wciągarki i wyciągarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Windy dekarskie",
    "categoryPath": [
      "(261312) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Podnośniki i wciągarki"
    ],
    "hierarchy": "(261312) Firma i usługi / Przemysł / Budownictwo przemysłowe / Podnośniki i wciągarki / Windy dekarskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pompy i akcesoria do betonu",
    "categoryPath": [
      "(121346) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(121346) Firma i usługi / Przemysł / Budownictwo przemysłowe / Pompy i akcesoria do betonu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261202) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(261202) Firma i usługi / Przemysł / Budownictwo przemysłowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Klucze do rusztowań",
    "categoryPath": [
      "(315846) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości",
      "Akcesoria do rusztowań"
    ],
    "hierarchy": "(315846) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Akcesoria do rusztowań / Klucze do rusztowań",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koła do rusztowań",
    "categoryPath": [
      "(315840) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości",
      "Akcesoria do rusztowań"
    ],
    "hierarchy": "(315840) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Akcesoria do rusztowań / Koła do rusztowań",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podesty",
    "categoryPath": [
      "(321880) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości",
      "Akcesoria do rusztowań"
    ],
    "hierarchy": "(321880) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Akcesoria do rusztowań / Podesty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podstawy i stopy",
    "categoryPath": [
      "(315837) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości",
      "Akcesoria do rusztowań"
    ],
    "hierarchy": "(315837) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Akcesoria do rusztowań / Podstawy i stopy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Śruby do rusztowań",
    "categoryPath": [
      "(315843) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości",
      "Akcesoria do rusztowań"
    ],
    "hierarchy": "(315843) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Akcesoria do rusztowań / Śruby do rusztowań",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rusztowania",
    "categoryPath": [
      "(261208) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości"
    ],
    "hierarchy": "(261208) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Rusztowania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zawiesia pasowe",
    "categoryPath": [
      "(261172) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości"
    ],
    "hierarchy": "(261172) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Zawiesia pasowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zsypy budowlane",
    "categoryPath": [
      "(261171) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Prace na wysokości"
    ],
    "hierarchy": "(261171) Firma i usługi / Przemysł / Budownictwo przemysłowe / Prace na wysokości / Zsypy budowlane",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Farby geodezyjne",
    "categoryPath": [
      "(315363) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne",
      "Akcesoria"
    ],
    "hierarchy": "(315363) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Akcesoria / Farby geodezyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Folie dalmiercze",
    "categoryPath": [
      "(315395) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne",
      "Akcesoria"
    ],
    "hierarchy": "(315395) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Akcesoria / Folie dalmiercze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miary i taśmy geodezyjne",
    "categoryPath": [
      "(315390) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne",
      "Akcesoria"
    ],
    "hierarchy": "(315390) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Akcesoria / Miary i taśmy geodezyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczelinomierze i suwmiarki",
    "categoryPath": [
      "(315398) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne",
      "Akcesoria"
    ],
    "hierarchy": "(315398) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Akcesoria / Szczelinomierze i suwmiarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szkicowniki i mapniki",
    "categoryPath": [
      "(315387) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne",
      "Akcesoria"
    ],
    "hierarchy": "(315387) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Akcesoria / Szkicowniki i mapniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tyczki i paliki",
    "categoryPath": [
      "(315381) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne",
      "Akcesoria"
    ],
    "hierarchy": "(315381) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Akcesoria / Tyczki i paliki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ładowarki i baterie",
    "categoryPath": [
      "(315366) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne",
      "Akcesoria"
    ],
    "hierarchy": "(315366) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Akcesoria / Ładowarki i baterie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dalmierze i tachimetry",
    "categoryPath": [
      "(121570) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne"
    ],
    "hierarchy": "(121570) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Dalmierze i tachimetry",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koła pomiarowe",
    "categoryPath": [
      "(261324) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne"
    ],
    "hierarchy": "(261324) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Koła pomiarowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lasery",
    "categoryPath": [
      "(261325) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne"
    ],
    "hierarchy": "(261325) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Lasery",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Niwelatory",
    "categoryPath": [
      "(121571) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne"
    ],
    "hierarchy": "(121571) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Niwelatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Statywy",
    "categoryPath": [
      "(261326) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne"
    ],
    "hierarchy": "(261326) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Statywy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łaty",
    "categoryPath": [
      "(261314) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Przyrządy geodezyjne"
    ],
    "hierarchy": "(261314) Firma i usługi / Przemysł / Budownictwo przemysłowe / Przyrządy geodezyjne / Łaty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Silniki elektryczne i małolitrażowe",
    "categoryPath": [
      "(260859) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(260859) Firma i usługi / Przemysł / Budownictwo przemysłowe / Silniki elektryczne i małolitrażowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Szlifierki do gipsu",
    "categoryPath": [
      "(261175) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(261175) Firma i usługi / Przemysł / Budownictwo przemysłowe / Szlifierki do gipsu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Taczki i miniwywrotki",
    "categoryPath": [
      "(261519) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(261519) Firma i usługi / Przemysł / Budownictwo przemysłowe / Taczki i miniwywrotki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wibratory do betonu",
    "categoryPath": [
      "(125762) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(125762) Firma i usługi / Przemysł / Budownictwo przemysłowe / Wibratory do betonu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wibroizolatory",
    "categoryPath": [
      "(312413) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(312413) Firma i usługi / Przemysł / Budownictwo przemysłowe / Wibroizolatory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Zacieraczki",
    "categoryPath": [
      "(125764) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(125764) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zacieraczki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Zagęszczarki",
    "categoryPath": [
      "(121349) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(121349) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zagęszczarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Kontenery",
    "categoryPath": [
      "(121538) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Zaplecze budowlane"
    ],
    "hierarchy": "(121538) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zaplecze budowlane / Kontenery",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lustra drogowe i magazynowe",
    "categoryPath": [
      "(261766) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Zaplecze budowlane"
    ],
    "hierarchy": "(261766) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zaplecze budowlane / Lustra drogowe i magazynowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ogrodzenia",
    "categoryPath": [
      "(121539) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Zaplecze budowlane"
    ],
    "hierarchy": "(121539) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zaplecze budowlane / Ogrodzenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tablice ostrzegawcze i informacyjne",
    "categoryPath": [
      "(121541) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Zaplecze budowlane"
    ],
    "hierarchy": "(121541) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zaplecze budowlane / Tablice ostrzegawcze i informacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Toalety przenośne",
    "categoryPath": [
      "(121542) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Zaplecze budowlane"
    ],
    "hierarchy": "(121542) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zaplecze budowlane / Toalety przenośne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Umywalki przenośne",
    "categoryPath": [
      "(261767) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Zaplecze budowlane"
    ],
    "hierarchy": "(261767) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zaplecze budowlane / Umywalki przenośne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zabezpieczenia",
    "categoryPath": [
      "(121543) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe",
      "Zaplecze budowlane"
    ],
    "hierarchy": "(121543) Firma i usługi / Przemysł / Budownictwo przemysłowe / Zaplecze budowlane / Zabezpieczenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łaty wibracyjne",
    "categoryPath": [
      "(261313) Firma i usługi",
      "Przemysł",
      "Budownictwo przemysłowe"
    ],
    "hierarchy": "(261313) Firma i usługi / Przemysł / Budownictwo przemysłowe / Łaty wibracyjne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Magnesy neodymowe",
    "categoryPath": [
      "(121236) Firma i usługi",
      "Przemysł"
    ],
    "hierarchy": "(121236) Firma i usługi / Przemysł / Magnesy neodymowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obróbka kamienia",
    "categoryPath": [
      "(121395) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121395) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka kamienia",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Dźwigi warsztatowe",
    "categoryPath": [
      "(121403) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121403) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Dźwigi warsztatowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Frezarki",
    "categoryPath": [
      "(121404) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121404) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Frezarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Giętarki",
    "categoryPath": [
      "(125763) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(125763) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Giętarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Osprzęt lakierniczy",
    "categoryPath": [
      "(121409) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121409) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Osprzęt lakierniczy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Piły i przecinarki",
    "categoryPath": [
      "(121405) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121405) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Piły i przecinarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121402) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121402) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prasy przemysłowe i gilotyny",
    "categoryPath": [
      "(121406) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121406) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Prasy przemysłowe i gilotyny",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Dysze",
    "categoryPath": [
      "(318741) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo",
      "Akcesoria"
    ],
    "hierarchy": "(318741) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Akcesoria / Dysze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(318765) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo",
      "Akcesoria"
    ],
    "hierarchy": "(318765) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kątowniki magnetyczne",
    "categoryPath": [
      "(318744) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo",
      "Akcesoria"
    ],
    "hierarchy": "(318744) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Akcesoria / Kątowniki magnetyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozycjonery",
    "categoryPath": [
      "(318753) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo",
      "Akcesoria"
    ],
    "hierarchy": "(318753) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Akcesoria / Pozycjonery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(318756) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo",
      "Akcesoria"
    ],
    "hierarchy": "(318756) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Akcesoria / Rękawice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zaciski",
    "categoryPath": [
      "(318762) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo",
      "Akcesoria"
    ],
    "hierarchy": "(318762) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Akcesoria / Zaciski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Butle gazowe",
    "categoryPath": [
      "(259077) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo"
    ],
    "hierarchy": "(259077) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Butle gazowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Druty spawalnicze",
    "categoryPath": [
      "(322702) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo"
    ],
    "hierarchy": "(322702) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Druty spawalnicze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Elektrody spawalnicze",
    "categoryPath": [
      "(259079) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo"
    ],
    "hierarchy": "(259079) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Elektrody spawalnicze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maski spawalnicze",
    "categoryPath": [
      "(259076) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo"
    ],
    "hierarchy": "(259076) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Maski spawalnicze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(310085) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo"
    ],
    "hierarchy": "(310085) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Przewody",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Spawarki i przecinarki",
    "categoryPath": [
      "(259075) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo"
    ],
    "hierarchy": "(259075) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Spawarki i przecinarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wózki spawalnicze",
    "categoryPath": [
      "(261719) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali",
      "Spawalnictwo"
    ],
    "hierarchy": "(261719) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Spawalnictwo / Wózki spawalnicze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Szlifierki stacjonarne",
    "categoryPath": [
      "(121407) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121407) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Szlifierki stacjonarne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Tokarki",
    "categoryPath": [
      "(121408) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(121408) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Tokarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wycinarki laserowe",
    "categoryPath": [
      "(322923) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Obróbka metali"
    ],
    "hierarchy": "(322923) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Obróbka metali / Wycinarki laserowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Przemysł metalowy i hutnictwo",
    "categoryPath": [
      "(121398) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121398) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Przemysł metalowy i hutnictwo",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Przemysł spożywczy",
    "categoryPath": [
      "(121399) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121399) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Przemysł spożywczy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Przemysł włókienniczy i pokrewne",
    "categoryPath": [
      "(302617) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(302617) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Przemysł włókienniczy i pokrewne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wtryskarki",
    "categoryPath": [
      "(121419) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Tworzywa sztuczne"
    ],
    "hierarchy": "(121419) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Tworzywa sztuczne / Wtryskarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Zgrzewarki",
    "categoryPath": [
      "(121420) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Automatyka przemysłowa",
      "Tworzywa sztuczne"
    ],
    "hierarchy": "(121420) Firma i usługi / Przemysł / Maszyny i urządzenia / Automatyka przemysłowa / Tworzywa sztuczne / Zgrzewarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Brykieciarki do trocin",
    "categoryPath": [
      "(121370) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121370) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Brykieciarki do trocin",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Czopiarki",
    "categoryPath": [
      "(121371) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121371) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Czopiarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Dłutarki",
    "categoryPath": [
      "(121372) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121372) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Dłutarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Frezarki",
    "categoryPath": [
      "(121373) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121373) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Frezarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Gilotyny",
    "categoryPath": [
      "(121374) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121374) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Gilotyny",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Karczowniki",
    "categoryPath": [
      "(121375) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121375) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Karczowniki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny do forniru",
    "categoryPath": [
      "(320674) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(320674) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Maszyny do forniru",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Młyny",
    "categoryPath": [
      "(121379) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121379) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Młyny",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Obrabiarki",
    "categoryPath": [
      "(121567) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121567) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Obrabiarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Odciągi do trocin",
    "categoryPath": [
      "(260284) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(260284) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Odciągi do trocin",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Okleiniarki",
    "categoryPath": [
      "(121380) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121380) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Okleiniarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Piły i pilarki",
    "categoryPath": [
      "(121381) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121381) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Piły i pilarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Posuwy mechaniczne",
    "categoryPath": [
      "(320683) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(320683) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Posuwy mechaniczne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121369) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121369) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prasy",
    "categoryPath": [
      "(121382) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121382) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Prasy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Rębaki",
    "categoryPath": [
      "(121565) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121565) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Rębaki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Strugarki",
    "categoryPath": [
      "(121564) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121564) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Strugarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Suszarnie i komory lakiernicze",
    "categoryPath": [
      "(320680) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(320680) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Suszarnie i komory lakiernicze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Szlifierki i cykliniarki",
    "categoryPath": [
      "(121385) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121385) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Szlifierki i cykliniarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Tokarki",
    "categoryPath": [
      "(121386) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121386) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Tokarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Transport drewna",
    "categoryPath": [
      "(121387) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121387) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Transport drewna",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Turbiny i wentylatory",
    "categoryPath": [
      "(320671) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(320671) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Turbiny i wentylatory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Urządzenia tapicerskie",
    "categoryPath": [
      "(121388) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121388) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Urządzenia tapicerskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wciągarki",
    "categoryPath": [
      "(121389) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121389) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Wciągarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wiertarki",
    "categoryPath": [
      "(121390) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121390) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Wiertarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wilgotnościomierze",
    "categoryPath": [
      "(261377) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(261377) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Wilgotnościomierze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Łuparki",
    "categoryPath": [
      "(121377) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Dla leśnictwa i przemysłu drzewnego"
    ],
    "hierarchy": "(121377) Firma i usługi / Przemysł / Maszyny i urządzenia / Dla leśnictwa i przemysłu drzewnego / Łuparki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Automaty do lodów",
    "categoryPath": [
      "(121363) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121363) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Automaty do lodów",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Chłodziarki, lodówki",
    "categoryPath": [
      "(121364) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121364) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Chłodziarki, lodówki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Dzielarko-zaokrąglarki",
    "categoryPath": [
      "(121576) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121576) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Dzielarko-zaokrąglarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Ekspresy do kawy",
    "categoryPath": [
      "(260733) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(260733) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Ekspresy do kawy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Frytownice",
    "categoryPath": [
      "(121356) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121356) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Frytownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Gofrownice",
    "categoryPath": [
      "(125768) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(125768) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Gofrownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Grille",
    "categoryPath": [
      "(121357) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121357) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Grille",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Kostkarki do lodu",
    "categoryPath": [
      "(260642) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(260642) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Kostkarki do lodu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Krajalnice",
    "categoryPath": [
      "(121353) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121353) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Krajalnice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Kuchnie",
    "categoryPath": [
      "(121358) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121358) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Kuchnie",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Linie produkcyjne",
    "categoryPath": [
      "(121368) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121368) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Linie produkcyjne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny do mięsa",
    "categoryPath": [
      "(125766) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(125766) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Maszyny do mięsa",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny do popcornu",
    "categoryPath": [
      "(121366) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121366) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Maszyny do popcornu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny do waty cukrowej",
    "categoryPath": [
      "(121367) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121367) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Maszyny do waty cukrowej",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny zmywające",
    "categoryPath": [
      "(121352) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121352) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Maszyny zmywające",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Mieszarki do ciast",
    "categoryPath": [
      "(121578) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121578) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Mieszarki do ciast",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Miksery",
    "categoryPath": [
      "(121354) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121354) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Miksery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Naboje i syfony",
    "categoryPath": [
      "(260591) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(260591) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Naboje i syfony",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Nadziewarki",
    "categoryPath": [
      "(125769) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(125769) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Nadziewarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Obieraczki i skubarki",
    "categoryPath": [
      "(260583) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(260583) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Obieraczki i skubarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pakowarki próżniowe",
    "categoryPath": [
      "(257192) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(257192) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Pakowarki próżniowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Patelnie gastronomiczne",
    "categoryPath": [
      "(260593) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(260593) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Patelnie gastronomiczne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Piece do pizzy",
    "categoryPath": [
      "(121359) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121359) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Piece do pizzy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Piece konwekcyjno parowe",
    "categoryPath": [
      "(121360) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121360) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Piece konwekcyjno parowe",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Podgrzewacze",
    "categoryPath": [
      "(125767) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(125767) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Podgrzewacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121351) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121351) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rożna",
    "categoryPath": [
      "(121361) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121361) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Rożna",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Sterylizatory i naświetlacze",
    "categoryPath": [
      "(260592) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(260592) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Sterylizatory i naświetlacze",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Szatkownice",
    "categoryPath": [
      "(121355) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121355) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Szatkownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Ubijaczki do mas",
    "categoryPath": [
      "(121577) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121577) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Ubijaczki do mas",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Urządzenia do kebabu",
    "categoryPath": [
      "(121362) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121362) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Urządzenia do kebabu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Warniki",
    "categoryPath": [
      "(260590) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(260590) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Warniki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Wałkownice",
    "categoryPath": [
      "(121580) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121580) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Wałkownice",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Zamrażarki",
    "categoryPath": [
      "(121365) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia",
      "Gastronomiczne"
    ],
    "hierarchy": "(121365) Firma i usługi / Przemysł / Maszyny i urządzenia / Gastronomiczne / Zamrażarki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121620) Firma i usługi",
      "Przemysł",
      "Maszyny i urządzenia"
    ],
    "hierarchy": "(121620) Firma i usługi / Przemysł / Maszyny i urządzenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Czujniki i przetworniki",
    "categoryPath": [
      "(121440) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121440) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Czujniki i przetworniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Falowniki",
    "categoryPath": [
      "(121441) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121441) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Falowniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Hydraulika siłowa",
    "categoryPath": [
      "(121442) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121442) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Hydraulika siłowa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kable i przewody",
    "categoryPath": [
      "(121443) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121443) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Kable i przewody",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mierniki i aparat. pomiarowa",
    "categoryPath": [
      "(121445) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121445) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Mierniki i aparat. pomiarowa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Motoreduktory",
    "categoryPath": [
      "(121452) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(121452) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Motoreduktory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(121453) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(121453) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Pompy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przekładnie",
    "categoryPath": [
      "(121454) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(121454) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Przekładnie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przetwornice częstotliwości",
    "categoryPath": [
      "(322893) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(322893) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Przetwornice częstotliwości",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(121456) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(121456) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Silniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Softstartery",
    "categoryPath": [
      "(322894) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(322894) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Softstartery",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sterowanie i zabezpieczenie",
    "categoryPath": [
      "(322895) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(322895) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Sterowanie i zabezpieczenie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(121455) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Napędy"
    ],
    "hierarchy": "(121455) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Napędy / Wentylatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Panele operatorskie i iPC",
    "categoryPath": [
      "(322887) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(322887) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Panele operatorskie i iPC",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pneumatyka",
    "categoryPath": [
      "(121447) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121447) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Pneumatyka",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121439) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121439) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Bezpieczeństwa",
    "categoryPath": [
      "(322891) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Przekaźniki"
    ],
    "hierarchy": "(322891) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Przekaźniki / Bezpieczeństwa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Elektromechaniczne",
    "categoryPath": [
      "(322889) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Przekaźniki"
    ],
    "hierarchy": "(322889) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Przekaźniki / Elektromechaniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kontrolne",
    "categoryPath": [
      "(322892) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Przekaźniki"
    ],
    "hierarchy": "(322892) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Przekaźniki / Kontrolne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Półprzewodnikowe",
    "categoryPath": [
      "(322890) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Przekaźniki"
    ],
    "hierarchy": "(322890) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Przekaźniki / Półprzewodnikowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przyciski, przełączniki, lampki",
    "categoryPath": [
      "(322885) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Sterowanie, sygnalizacja"
    ],
    "hierarchy": "(322885) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Sterowanie, sygnalizacja / Przyciski, przełączniki, lampki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urządzenia sygnalizacyjne",
    "categoryPath": [
      "(322886) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Sterowanie, sygnalizacja"
    ],
    "hierarchy": "(322886) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Sterowanie, sygnalizacja / Urządzenia sygnalizacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sterowniki i regulatory",
    "categoryPath": [
      "(121448) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121448) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Sterowniki i regulatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szafy sterownicze i obudowy uniwersalne",
    "categoryPath": [
      "(322883) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(322883) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Szafy sterownicze i obudowy uniwersalne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urządzenia sieciowe",
    "categoryPath": [
      "(121449) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121449) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Urządzenia sieciowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urządzenia zasilające",
    "categoryPath": [
      "(121450) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121450) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Urządzenia zasilające",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zabezpieczenia i bezpieczniki",
    "categoryPath": [
      "(121451) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa"
    ],
    "hierarchy": "(121451) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Zabezpieczenia i bezpieczniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Moduły i łączniki półprzewod.",
    "categoryPath": [
      "(121459) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Łączniki"
    ],
    "hierarchy": "(121459) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Łączniki / Moduły i łączniki półprzewod.",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Styczniki i przekaźniki",
    "categoryPath": [
      "(121458) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Łączniki"
    ],
    "hierarchy": "(121458) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Łączniki / Styczniki i przekaźniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Styczniki, wyłączniki silnikowe",
    "categoryPath": [
      "(322882) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Łączniki"
    ],
    "hierarchy": "(322882) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Łączniki / Styczniki, wyłączniki silnikowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wyłączniki i krańcówki",
    "categoryPath": [
      "(121457) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Automatyka przemysłowa",
      "Łączniki"
    ],
    "hierarchy": "(121457) Firma i usługi / Przemysł / Materiały i akcesoria / Automatyka przemysłowa / Łączniki / Wyłączniki i krańcówki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kondensatory",
    "categoryPath": [
      "(121510) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Elektroenergetyka"
    ],
    "hierarchy": "(121510) Firma i usługi / Przemysł / Materiały i akcesoria / Elektroenergetyka / Kondensatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Linie kablowe",
    "categoryPath": [
      "(121512) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Elektroenergetyka"
    ],
    "hierarchy": "(121512) Firma i usługi / Przemysł / Materiały i akcesoria / Elektroenergetyka / Linie kablowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odłączniki i uziemiacze",
    "categoryPath": [
      "(121509) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Elektroenergetyka"
    ],
    "hierarchy": "(121509) Firma i usługi / Przemysł / Materiały i akcesoria / Elektroenergetyka / Odłączniki i uziemiacze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Systemy zabezpieczeń",
    "categoryPath": [
      "(121513) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Elektroenergetyka"
    ],
    "hierarchy": "(121513) Firma i usługi / Przemysł / Materiały i akcesoria / Elektroenergetyka / Systemy zabezpieczeń",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(318156) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(318156) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Akcesoria barmańskie / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Otwieracze, korkociągi",
    "categoryPath": [
      "(317850) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Akcesoria barmańskie"
    ],
    "hierarchy": "(317850) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Akcesoria barmańskie / Otwieracze, korkociągi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Akcesoria kuchenne",
    "categoryPath": [
      "(121584) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121584) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Akcesoria kuchenne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Filiżanki, szklanki, kieliszki",
    "categoryPath": [
      "(121586) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121586) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Filiżanki, szklanki, kieliszki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Garnki i patelnie",
    "categoryPath": [
      "(121582) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121582) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Garnki i patelnie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kubki, filiżanki, kieliszki",
    "categoryPath": [
      "(261776) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Naczynia i akcesoria jednorazowe"
    ],
    "hierarchy": "(261776) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Naczynia i akcesoria jednorazowe / Kubki, filiżanki, kieliszki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pojemniki i opakowania",
    "categoryPath": [
      "(261783) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Naczynia i akcesoria jednorazowe"
    ],
    "hierarchy": "(261783) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Naczynia i akcesoria jednorazowe / Pojemniki i opakowania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Serwetki",
    "categoryPath": [
      "(261774) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Naczynia i akcesoria jednorazowe"
    ],
    "hierarchy": "(261774) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Naczynia i akcesoria jednorazowe / Serwetki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sztućce jednorazowe",
    "categoryPath": [
      "(261772) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Naczynia i akcesoria jednorazowe"
    ],
    "hierarchy": "(261772) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Naczynia i akcesoria jednorazowe / Sztućce jednorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Słomki",
    "categoryPath": [
      "(261775) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Naczynia i akcesoria jednorazowe"
    ],
    "hierarchy": "(261775) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Naczynia i akcesoria jednorazowe / Słomki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Talerzyki, miseczki, tacki",
    "categoryPath": [
      "(261773) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia",
      "Naczynia i akcesoria jednorazowe"
    ],
    "hierarchy": "(261773) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Naczynia i akcesoria jednorazowe / Talerzyki, miseczki, tacki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pojemniki GN",
    "categoryPath": [
      "(121585) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121585) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Pojemniki GN",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pokrywki do pojemników GN",
    "categoryPath": [
      "(322148) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(322148) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Pokrywki do pojemników GN",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121575) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121575) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sztućce",
    "categoryPath": [
      "(121581) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121581) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Sztućce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urządzenia barmańskie",
    "categoryPath": [
      "(121588) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121588) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Urządzenia barmańskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zastawa stołowa",
    "categoryPath": [
      "(121583) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Gastronomia"
    ],
    "hierarchy": "(121583) Firma i usługi / Przemysł / Materiały i akcesoria / Gastronomia / Zastawa stołowa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obróbka kamienia",
    "categoryPath": [
      "(121430) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121430) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka kamienia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Frezy",
    "categoryPath": [
      "(121489) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121489) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Frezy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gwintowniki i narzynki",
    "categoryPath": [
      "(121618) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121618) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Gwintowniki i narzynki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Narzędzia ślusarskie i montażowe",
    "categoryPath": [
      "(121491) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121491) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Narzędzia ślusarskie i montażowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Noże tokarskie",
    "categoryPath": [
      "(121492) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121492) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Noże tokarskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121488) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121488) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płytki wieloostrzowe",
    "categoryPath": [
      "(121493) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121493) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Płytki wieloostrzowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szlifierki ręczne",
    "categoryPath": [
      "(121494) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121494) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Szlifierki ręczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tarcze i ściernice",
    "categoryPath": [
      "(121495) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121495) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Tarcze i ściernice",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uchwyty i przyrządy do mocowania",
    "categoryPath": [
      "(121496) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121496) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Uchwyty i przyrządy do mocowania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wiertarki i gwinciarki",
    "categoryPath": [
      "(121497) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121497) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Wiertarki i gwinciarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łożyska toczne",
    "categoryPath": [
      "(121490) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Obróbka metali"
    ],
    "hierarchy": "(121490) Firma i usługi / Przemysł / Materiały i akcesoria / Obróbka metali / Łożyska toczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121438) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121438) Firma i usługi / Przemysł / Materiały i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Frezy",
    "categoryPath": [
      "(121479) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przemysł drzewny"
    ],
    "hierarchy": "(121479) Firma i usługi / Przemysł / Materiały i akcesoria / Przemysł drzewny / Frezy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121566) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przemysł drzewny"
    ],
    "hierarchy": "(121566) Firma i usługi / Przemysł / Materiały i akcesoria / Przemysł drzewny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tarcze",
    "categoryPath": [
      "(121480) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przemysł drzewny"
    ],
    "hierarchy": "(121480) Firma i usługi / Przemysł / Materiały i akcesoria / Przemysł drzewny / Tarcze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(121515) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przemysł metalowy i hutnictwo"
    ],
    "hierarchy": "(121515) Firma i usługi / Przemysł / Materiały i akcesoria / Przemysł metalowy i hutnictwo / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Surowce",
    "categoryPath": [
      "(121514) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przemysł metalowy i hutnictwo"
    ],
    "hierarchy": "(121514) Firma i usługi / Przemysł / Materiały i akcesoria / Przemysł metalowy i hutnictwo / Surowce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przemysł włókienniczy i pokrewne",
    "categoryPath": [
      "(121435) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121435) Firma i usługi / Przemysł / Materiały i akcesoria / Przemysł włókienniczy i pokrewne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Czujniki zegarowe i uchylne",
    "categoryPath": [
      "(121500) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121500) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Czujniki zegarowe i uchylne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kątowniki i liniały krawędziowe",
    "categoryPath": [
      "(121502) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121502) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Kątowniki i liniały krawędziowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mikromierze",
    "categoryPath": [
      "(121503) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121503) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Mikromierze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Passametry i Transametry",
    "categoryPath": [
      "(121504) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121504) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Passametry i Transametry",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121499) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121499) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Suwmiarki",
    "categoryPath": [
      "(121505) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121505) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Suwmiarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wzorce i sprawdziany",
    "categoryPath": [
      "(121507) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121507) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Wzorce i sprawdziany",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Średnicówki",
    "categoryPath": [
      "(121506) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Przyrządy pomiarowe"
    ],
    "hierarchy": "(121506) Firma i usługi / Przemysł / Materiały i akcesoria / Przyrządy pomiarowe / Średnicówki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materiały spawalnicze",
    "categoryPath": [
      "(121525) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Spawanie"
    ],
    "hierarchy": "(121525) Firma i usługi / Przemysł / Materiały i akcesoria / Spawanie / Materiały spawalnicze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Palniki",
    "categoryPath": [
      "(121522) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Spawanie"
    ],
    "hierarchy": "(121522) Firma i usługi / Przemysł / Materiały i akcesoria / Spawanie / Palniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121521) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Spawanie"
    ],
    "hierarchy": "(121521) Firma i usługi / Przemysł / Materiały i akcesoria / Spawanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reduktory",
    "categoryPath": [
      "(121523) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Spawanie"
    ],
    "hierarchy": "(121523) Firma i usługi / Przemysł / Materiały i akcesoria / Spawanie / Reduktory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uchwyty, kątowniki",
    "categoryPath": [
      "(121524) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Spawanie"
    ],
    "hierarchy": "(121524) Firma i usługi / Przemysł / Materiały i akcesoria / Spawanie / Uchwyty, kątowniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tapicerstwo",
    "categoryPath": [
      "(121426) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(121426) Firma i usługi / Przemysł / Materiały i akcesoria / Tapicerstwo",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Formy i matryce",
    "categoryPath": [
      "(121516) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Tworzywa sztuczne"
    ],
    "hierarchy": "(121516) Firma i usługi / Przemysł / Materiały i akcesoria / Tworzywa sztuczne / Formy i matryce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Surowce",
    "categoryPath": [
      "(121517) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria",
      "Tworzywa sztuczne"
    ],
    "hierarchy": "(121517) Firma i usługi / Przemysł / Materiały i akcesoria / Tworzywa sztuczne / Surowce",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wiadra",
    "categoryPath": [
      "(260567) Firma i usługi",
      "Przemysł",
      "Materiały i akcesoria"
    ],
    "hierarchy": "(260567) Firma i usługi / Przemysł / Materiały i akcesoria / Wiadra",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Apteczki",
    "categoryPath": [
      "(110254) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP"
    ],
    "hierarchy": "(110254) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Apteczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pachołki i słupki",
    "categoryPath": [
      "(259405) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP",
      "Bezpieczeństwo ruchu"
    ],
    "hierarchy": "(259405) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Bezpieczeństwo ruchu / Pachołki i słupki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Taśmy ostrzegawcze",
    "categoryPath": [
      "(259404) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP",
      "Bezpieczeństwo ruchu"
    ],
    "hierarchy": "(259404) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Bezpieczeństwo ruchu / Taśmy ostrzegawcze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Łańcuchy ostrzegawcze",
    "categoryPath": [
      "(322700) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP",
      "Bezpieczeństwo ruchu"
    ],
    "hierarchy": "(322700) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Bezpieczeństwo ruchu / Łańcuchy ostrzegawcze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Chemia przemysłowa",
    "categoryPath": [
      "(261251) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP"
    ],
    "hierarchy": "(261251) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Chemia przemysłowa",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sorbent",
    "categoryPath": [
      "(302342) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP"
    ],
    "hierarchy": "(302342) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Sorbent",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sprzęt Ppoż.",
    "categoryPath": [
      "(110250) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP"
    ],
    "hierarchy": "(110250) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Sprzęt Ppoż.",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Szafy BHP",
    "categoryPath": [
      "(125782) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP"
    ],
    "hierarchy": "(125782) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Szafy BHP",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Naklejki",
    "categoryPath": [
      "(321879) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP",
      "Tablice i oznaczenia"
    ],
    "hierarchy": "(321879) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Tablice i oznaczenia / Naklejki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Tablice",
    "categoryPath": [
      "(110251) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Artykuły BHP",
      "Tablice i oznaczenia"
    ],
    "hierarchy": "(110251) Firma i usługi / Przemysł / Odzież robocza i BHP / Artykuły BHP / Tablice i oznaczenia / Tablice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Buty robocze",
    "categoryPath": [
      "(110290) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP"
    ],
    "hierarchy": "(110290) Firma i usługi / Przemysł / Odzież robocza i BHP / Buty robocze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(110264) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Ochrona głowy"
    ],
    "hierarchy": "(110264) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona głowy / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(110253) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Ochrona głowy"
    ],
    "hierarchy": "(110253) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona głowy / Kaski",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochrona kolan",
    "categoryPath": [
      "(259100) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP"
    ],
    "hierarchy": "(259100) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona kolan",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Filtry i pochłaniacze",
    "categoryPath": [
      "(261339) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Ochrona oczu i twarzy"
    ],
    "hierarchy": "(261339) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona oczu i twarzy / Filtry i pochłaniacze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Maski",
    "categoryPath": [
      "(110257) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Ochrona oczu i twarzy"
    ],
    "hierarchy": "(110257) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona oczu i twarzy / Maski",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Okulary i gogle",
    "categoryPath": [
      "(110256) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Ochrona oczu i twarzy"
    ],
    "hierarchy": "(110256) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona oczu i twarzy / Okulary i gogle",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Przyłbice",
    "categoryPath": [
      "(308341) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Ochrona oczu i twarzy"
    ],
    "hierarchy": "(308341) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona oczu i twarzy / Przyłbice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochrona słuchu",
    "categoryPath": [
      "(110252) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP"
    ],
    "hierarchy": "(110252) Firma i usługi / Przemysł / Odzież robocza i BHP / Ochrona słuchu",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(110260) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(110260) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Fartuchy",
    "categoryPath": [
      "(110263) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(110263) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Fartuchy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(110265) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(110265) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kombinezony",
    "categoryPath": [
      "(110262) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(110262) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Kombinezony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule",
    "categoryPath": [
      "(322667) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(322667) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki robocze",
    "categoryPath": [
      "(110261) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(110261) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Kurtki robocze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(110258) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(110258) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety robocze",
    "categoryPath": [
      "(322911) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(322911) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Skarpety robocze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(110259) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(110259) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "T-shirty",
    "categoryPath": [
      "(259317) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(259317) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / T-shirty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zapaski",
    "categoryPath": [
      "(322678) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(322678) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Zapaski",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zarękawki ochronne",
    "categoryPath": [
      "(321197) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP",
      "Odzież"
    ],
    "hierarchy": "(321197) Firma i usługi / Przemysł / Odzież robocza i BHP / Odzież / Zarękawki ochronne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(110246) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP"
    ],
    "hierarchy": "(110246) Firma i usługi / Przemysł / Odzież robocza i BHP / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sprzęt asekuracyjny",
    "categoryPath": [
      "(125785) Firma i usługi",
      "Przemysł",
      "Odzież robocza i BHP"
    ],
    "hierarchy": "(125785) Firma i usługi / Przemysł / Odzież robocza i BHP / Sprzęt asekuracyjny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Automatyka przemysłowa",
    "categoryPath": [
      "(110241) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110241) Firma i usługi / Przemysł / Oferty hurtowe / Automatyka przemysłowa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Budownictwo",
    "categoryPath": [
      "(110236) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110236) Firma i usługi / Przemysł / Oferty hurtowe / Budownictwo",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gastronomia",
    "categoryPath": [
      "(110237) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110237) Firma i usługi / Przemysł / Oferty hurtowe / Gastronomia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Galanteria",
    "categoryPath": [
      "(110245) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe",
      "Odzież i galanteria"
    ],
    "hierarchy": "(110245) Firma i usługi / Przemysł / Oferty hurtowe / Odzież i galanteria / Galanteria",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odzież nowa",
    "categoryPath": [
      "(110244) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe",
      "Odzież i galanteria"
    ],
    "hierarchy": "(110244) Firma i usługi / Przemysł / Oferty hurtowe / Odzież i galanteria / Odzież nowa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odzież używana",
    "categoryPath": [
      "(110243) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe",
      "Odzież i galanteria"
    ],
    "hierarchy": "(110243) Firma i usługi / Przemysł / Oferty hurtowe / Odzież i galanteria / Odzież używana",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poligrafia",
    "categoryPath": [
      "(110239) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110239) Firma i usługi / Przemysł / Oferty hurtowe / Poligrafia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(110242) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110242) Firma i usługi / Przemysł / Oferty hurtowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przemysł drzewny",
    "categoryPath": [
      "(110238) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110238) Firma i usługi / Przemysł / Oferty hurtowe / Przemysł drzewny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rolnictwo",
    "categoryPath": [
      "(110240) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110240) Firma i usługi / Przemysł / Oferty hurtowe / Rolnictwo",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sprzęt AGD",
    "categoryPath": [
      "(110235) Firma i usługi",
      "Przemysł",
      "Oferty hurtowe"
    ],
    "hierarchy": "(110235) Firma i usługi / Przemysł / Oferty hurtowe / Sprzęt AGD",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kosiarki",
    "categoryPath": [
      "(17123) Firma i usługi",
      "Przemysł",
      "Pielęgnacja zieleni miejskiej"
    ],
    "hierarchy": "(17123) Firma i usługi / Przemysł / Pielęgnacja zieleni miejskiej / Kosiarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Noże i bijaki",
    "categoryPath": [
      "(313769) Firma i usługi",
      "Przemysł",
      "Pielęgnacja zieleni miejskiej"
    ],
    "hierarchy": "(313769) Firma i usługi / Przemysł / Pielęgnacja zieleni miejskiej / Noże i bijaki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sekatory mechaniczne",
    "categoryPath": [
      "(17125) Firma i usługi",
      "Przemysł",
      "Pielęgnacja zieleni miejskiej"
    ],
    "hierarchy": "(17125) Firma i usługi / Przemysł / Pielęgnacja zieleni miejskiej / Sekatory mechaniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Części do maszyn",
    "categoryPath": [
      "(121617) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121617) Firma i usługi / Przemysł / Poligrafia / Części do maszyn",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Farby, tusze, tonery",
    "categoryPath": [
      "(121482) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121482) Firma i usługi / Przemysł / Poligrafia / Farby, tusze, tonery",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Kleje introligatorskie",
    "categoryPath": [
      "(316258) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(316258) Firma i usługi / Przemysł / Poligrafia / Kleje introligatorskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny do produkcji opakowań",
    "categoryPath": [
      "(121391) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121391) Firma i usługi / Przemysł / Poligrafia / Maszyny do produkcji opakowań",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny drukujące",
    "categoryPath": [
      "(121392) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121392) Firma i usługi / Przemysł / Poligrafia / Maszyny drukujące",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Maszyny introligatorskie",
    "categoryPath": [
      "(121393) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121393) Firma i usługi / Przemysł / Poligrafia / Maszyny introligatorskie",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Papier, folia do zadrukowania",
    "categoryPath": [
      "(121483) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121483) Firma i usługi / Przemysł / Poligrafia / Papier, folia do zadrukowania",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121481) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121481) Firma i usługi / Przemysł / Poligrafia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty do czyszczenia",
    "categoryPath": [
      "(316264) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(316264) Firma i usługi / Przemysł / Poligrafia / Preparaty do czyszczenia",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Przygotowanie druku",
    "categoryPath": [
      "(121394) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(121394) Firma i usługi / Przemysł / Poligrafia / Przygotowanie druku",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(316261) Firma i usługi",
      "Przemysł",
      "Poligrafia"
    ],
    "hierarchy": "(316261) Firma i usługi / Przemysł / Poligrafia / Taśmy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(17098) Firma i usługi",
      "Przemysł"
    ],
    "hierarchy": "(17098) Firma i usługi / Przemysł / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(260172) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260172) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Automaty szorujące",
    "categoryPath": [
      "(260161) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260161) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Automaty szorujące",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Chemia profesjonalna",
    "categoryPath": [
      "(260162) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260162) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Chemia profesjonalna",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Odśnieżarki i pługi",
    "categoryPath": [
      "(260167) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260167) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Odśnieżarki i pługi",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Parownice profesjonalne",
    "categoryPath": [
      "(260168) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260168) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Parownice profesjonalne",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Polerki podłogowe",
    "categoryPath": [
      "(260169) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260169) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Polerki podłogowe",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Wózki przemysłowe",
    "categoryPath": [
      "(260170) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260170) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Wózki przemysłowe",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Zamiatarki",
    "categoryPath": [
      "(260171) Firma i usługi",
      "Przemysł",
      "Profesjonalne urządzenia czyszczące"
    ],
    "hierarchy": "(260171) Firma i usługi / Przemysł / Profesjonalne urządzenia czyszczące / Zamiatarki",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Alternatywne źródła energii",
    "categoryPath": [
      "(121619) Firma i usługi",
      "Przemysł",
      "Przemysł energetyczny"
    ],
    "hierarchy": "(121619) Firma i usługi / Przemysł / Przemysł energetyczny / Alternatywne źródła energii",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Fotowoltaika",
    "categoryPath": [
      "(322024) Firma i usługi",
      "Przemysł",
      "Przemysł energetyczny"
    ],
    "hierarchy": "(322024) Firma i usługi / Przemysł / Przemysł energetyczny / Fotowoltaika",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121612) Firma i usługi",
      "Przemysł",
      "Przemysł energetyczny"
    ],
    "hierarchy": "(121612) Firma i usługi / Przemysł / Przemysł energetyczny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przesył energii",
    "categoryPath": [
      "(121616) Firma i usługi",
      "Przemysł",
      "Przemysł energetyczny"
    ],
    "hierarchy": "(121616) Firma i usługi / Przemysł / Przemysł energetyczny / Przesył energii",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Transformatory",
    "categoryPath": [
      "(121613) Firma i usługi",
      "Przemysł",
      "Przemysł energetyczny"
    ],
    "hierarchy": "(121613) Firma i usługi / Przemysł / Przemysł energetyczny / Transformatory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D18"
  },
  {
    "segment": "Kontenery",
    "categoryPath": [
      "(260290) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(260290) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Kontenery",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kosze na śmieci",
    "categoryPath": [
      "(260295) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(260295) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Kosze na śmieci",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maszyny do przerobu surow. wtórnych",
    "categoryPath": [
      "(260293) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(260293) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Maszyny do przerobu surow. wtórnych",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Naklejki do segregacji śmieci",
    "categoryPath": [
      "(313781) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(313781) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Naklejki do segregacji śmieci",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pojemniki na surowce wtórne",
    "categoryPath": [
      "(260296) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(260296) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Pojemniki na surowce wtórne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Siatki transportowe",
    "categoryPath": [
      "(313961) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(313961) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Siatki transportowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stelaże do segregacji",
    "categoryPath": [
      "(260298) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(260298) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Stelaże do segregacji",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Worki",
    "categoryPath": [
      "(260294) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(260294) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Worki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zgniatarki do puszek",
    "categoryPath": [
      "(260297) Firma i usługi",
      "Przemysł",
      "Recykling i wywóz śmieci"
    ],
    "hierarchy": "(260297) Firma i usługi / Przemysł / Recykling i wywóz śmieci / Zgniatarki do puszek",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dezynfekcja i higiena",
    "categoryPath": [
      "(261716) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261716) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Dezynfekcja i higiena",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Flizy",
    "categoryPath": [
      "(261146) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261146) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Flizy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Folie",
    "categoryPath": [
      "(261586) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261586) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Folie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obroże i uwiązy",
    "categoryPath": [
      "(261718) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261718) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Obroże i uwiązy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Plandeki",
    "categoryPath": [
      "(261715) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261715) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Plandeki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sznurki",
    "categoryPath": [
      "(261533) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261533) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Sznurki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Worki",
    "categoryPath": [
      "(261143) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261143) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Worki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wytłaczanki na jajka",
    "categoryPath": [
      "(261147) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261147) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Wytłaczanki na jajka",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Węże ssawne",
    "categoryPath": [
      "(261782) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261782) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Węże ssawne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zawleczki rolnicze",
    "categoryPath": [
      "(306981) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(306981) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Zawleczki rolnicze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(261717) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Akcesoria i preparaty rolnicze"
    ],
    "hierarchy": "(261717) Firma i usługi / Przemysł / Rolnictwo / Akcesoria i preparaty rolnicze / Zbiorniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dekornizatory elektryczne",
    "categoryPath": [
      "(261689) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(261689) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dekornizatory elektryczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dla drobiu",
    "categoryPath": [
      "(109652) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(109652) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Higiena",
    "categoryPath": [
      "(261616) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Dla drobiu"
    ],
    "hierarchy": "(261616) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu / Higiena",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inkubatory i wylęgarki",
    "categoryPath": [
      "(261619) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Dla drobiu"
    ],
    "hierarchy": "(261619) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu / Inkubatory i wylęgarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmniki i poidła",
    "categoryPath": [
      "(261618) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Dla drobiu"
    ],
    "hierarchy": "(261618) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu / Karmniki i poidła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmy i preparaty",
    "categoryPath": [
      "(261617) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Dla drobiu"
    ],
    "hierarchy": "(261617) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu / Karmy i preparaty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kurniki i wyposażenie",
    "categoryPath": [
      "(261621) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Dla drobiu"
    ],
    "hierarchy": "(261621) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu / Kurniki i wyposażenie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261615) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Dla drobiu"
    ],
    "hierarchy": "(261615) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Siatki, woliery, zabezpieczenia",
    "categoryPath": [
      "(261620) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Dla drobiu"
    ],
    "hierarchy": "(261620) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Dla drobiu / Siatki, woliery, zabezpieczenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmidła",
    "categoryPath": [
      "(322160) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(322160) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Karmidła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kojce i wygrodzenia",
    "categoryPath": [
      "(121546) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(121546) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Kojce i wygrodzenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mieszalniki paszowe",
    "categoryPath": [
      "(121547) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(121547) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Mieszalniki paszowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(261118) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261118) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Baterie",
    "categoryPath": [
      "(261609) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261609) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Baterie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Elektryzatory",
    "categoryPath": [
      "(261114) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261114) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Elektryzatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Izolatory",
    "categoryPath": [
      "(261116) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261116) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Izolatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kable i przewody",
    "categoryPath": [
      "(261688) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261688) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Kable i przewody",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mierniki napięcia",
    "categoryPath": [
      "(261610) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261610) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Mierniki napięcia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Słupki i paliki",
    "categoryPath": [
      "(261115) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261115) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Słupki i paliki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Taśmy, plecionki, siatki",
    "categoryPath": [
      "(261117) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261117) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Taśmy, plecionki, siatki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(261686) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261686) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Uchwyty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(261119) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261119) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Zestawy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zwijacze (odwijacze)",
    "categoryPath": [
      "(261611) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261611) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Zwijacze (odwijacze)",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łączniki",
    "categoryPath": [
      "(261687) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Pastuchy elektryczne i ogrodzenia"
    ],
    "hierarchy": "(261687) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Pastuchy elektryczne i ogrodzenia / Łączniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poganiacze",
    "categoryPath": [
      "(261145) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(261145) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Poganiacze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poidła",
    "categoryPath": [
      "(121550) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(121550) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Poidła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Silosy paszowe",
    "categoryPath": [
      "(121552) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(121552) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Silosy paszowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Systemy udojowe",
    "categoryPath": [
      "(121553) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(121553) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Systemy udojowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kolczykowanie",
    "categoryPath": [
      "(261144) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Znakowanie zwierząt"
    ],
    "hierarchy": "(261144) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Znakowanie zwierząt / Kolczykowanie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kredki i spraye do znakowania zwierząt",
    "categoryPath": [
      "(261685) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Znakowanie zwierząt"
    ],
    "hierarchy": "(261685) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Znakowanie zwierząt / Kredki i spraye do znakowania zwierząt",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tatuowanie",
    "categoryPath": [
      "(261684) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla",
      "Znakowanie zwierząt"
    ],
    "hierarchy": "(261684) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Znakowanie zwierząt / Tatuowanie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łańcuchy pastwiskowe",
    "categoryPath": [
      "(306753) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(306753) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Łańcuchy pastwiskowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żywienie i suplementacja zwierząt",
    "categoryPath": [
      "(121591) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Hodowla"
    ],
    "hierarchy": "(121591) Firma i usługi / Przemysł / Rolnictwo / Hodowla / Żywienie i suplementacja zwierząt",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261635) Firma i usługi",
      "Przemysł",
      "Rolnictwo"
    ],
    "hierarchy": "(261635) Firma i usługi / Przemysł / Rolnictwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Agregaty i opryskiwacze",
    "categoryPath": [
      "(261683) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Uprawa"
    ],
    "hierarchy": "(261683) Firma i usługi / Przemysł / Rolnictwo / Uprawa / Agregaty i opryskiwacze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Narzędzia ręczne",
    "categoryPath": [
      "(121563) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Urządzenia"
    ],
    "hierarchy": "(121563) Firma i usługi / Przemysł / Rolnictwo / Urządzenia / Narzędzia ręczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Paszociągi, automaty paszowe i akcesoria",
    "categoryPath": [
      "(121549) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Urządzenia"
    ],
    "hierarchy": "(121549) Firma i usługi / Przemysł / Rolnictwo / Urządzenia / Paszociągi, automaty paszowe i akcesoria",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Okna inwentarskie",
    "categoryPath": [
      "(121548) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Wyposażenie pomieszczeń"
    ],
    "hierarchy": "(121548) Firma i usługi / Przemysł / Rolnictwo / Wyposażenie pomieszczeń / Okna inwentarskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tablice informacyjne",
    "categoryPath": [
      "(306141) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Wyposażenie pomieszczeń"
    ],
    "hierarchy": "(306141) Firma i usługi / Przemysł / Rolnictwo / Wyposażenie pomieszczeń / Tablice informacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wagi",
    "categoryPath": [
      "(306153) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Wyposażenie pomieszczeń"
    ],
    "hierarchy": "(306153) Firma i usługi / Przemysł / Rolnictwo / Wyposażenie pomieszczeń / Wagi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wentylacja",
    "categoryPath": [
      "(121554) Firma i usługi",
      "Przemysł",
      "Rolnictwo",
      "Wyposażenie pomieszczeń"
    ],
    "hierarchy": "(121554) Firma i usługi / Przemysł / Rolnictwo / Wyposażenie pomieszczeń / Wentylacja",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Etykiety",
    "categoryPath": [
      "(315431) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Akcesoria do kas i drukarek"
    ],
    "hierarchy": "(315431) Firma i usługi / Przemysł / Sklep i magazyn / Akcesoria do kas i drukarek / Etykiety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce na kasy",
    "categoryPath": [
      "(315428) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Akcesoria do kas i drukarek"
    ],
    "hierarchy": "(315428) Firma i usługi / Przemysł / Sklep i magazyn / Akcesoria do kas i drukarek / Pokrowce na kasy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rolki i taśmy kasowe",
    "categoryPath": [
      "(315419) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Akcesoria do kas i drukarek"
    ],
    "hierarchy": "(315419) Firma i usługi / Przemysł / Sklep i magazyn / Akcesoria do kas i drukarek / Rolki i taśmy kasowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tacki i szuflady kasowe",
    "categoryPath": [
      "(315416) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Akcesoria do kas i drukarek"
    ],
    "hierarchy": "(315416) Firma i usługi / Przemysł / Sklep i magazyn / Akcesoria do kas i drukarek / Tacki i szuflady kasowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bramki i kurtyny",
    "categoryPath": [
      "(121462) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121462) Firma i usługi / Przemysł / Sklep i magazyn / Bramki i kurtyny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Czytniki i skanery kodów",
    "categoryPath": [
      "(121463) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121463) Firma i usługi / Przemysł / Sklep i magazyn / Czytniki i skanery kodów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Drukarki etykiet",
    "categoryPath": [
      "(121464) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Drukarki i kasy fiskalne"
    ],
    "hierarchy": "(121464) Firma i usługi / Przemysł / Sklep i magazyn / Drukarki i kasy fiskalne / Drukarki etykiet",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Drukarki fiskalne",
    "categoryPath": [
      "(121466) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Drukarki i kasy fiskalne"
    ],
    "hierarchy": "(121466) Firma i usługi / Przemysł / Sklep i magazyn / Drukarki i kasy fiskalne / Drukarki fiskalne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kasy fiskalne",
    "categoryPath": [
      "(121465) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Drukarki i kasy fiskalne"
    ],
    "hierarchy": "(121465) Firma i usługi / Przemysł / Sklep i magazyn / Drukarki i kasy fiskalne / Kasy fiskalne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gabloty i witryny",
    "categoryPath": [
      "(121556) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Ekspozycja towarów"
    ],
    "hierarchy": "(121556) Firma i usługi / Przemysł / Sklep i magazyn / Ekspozycja towarów / Gabloty i witryny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Haki i zawieszki",
    "categoryPath": [
      "(321501) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Ekspozycja towarów"
    ],
    "hierarchy": "(321501) Firma i usługi / Przemysł / Sklep i magazyn / Ekspozycja towarów / Haki i zawieszki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kieszenie",
    "categoryPath": [
      "(321450) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Ekspozycja towarów"
    ],
    "hierarchy": "(321450) Firma i usługi / Przemysł / Sklep i magazyn / Ekspozycja towarów / Kieszenie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lady",
    "categoryPath": [
      "(121558) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Ekspozycja towarów"
    ],
    "hierarchy": "(121558) Firma i usługi / Przemysł / Sklep i magazyn / Ekspozycja towarów / Lady",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Manekiny",
    "categoryPath": [
      "(121560) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Ekspozycja towarów"
    ],
    "hierarchy": "(121560) Firma i usługi / Przemysł / Sklep i magazyn / Ekspozycja towarów / Manekiny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Półki",
    "categoryPath": [
      "(257673) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Ekspozycja towarów"
    ],
    "hierarchy": "(257673) Firma i usługi / Przemysł / Sklep i magazyn / Ekspozycja towarów / Półki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stojaki i wieszaki",
    "categoryPath": [
      "(121561) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Ekspozycja towarów"
    ],
    "hierarchy": "(121561) Firma i usługi / Przemysł / Sklep i magazyn / Ekspozycja towarów / Stojaki i wieszaki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koszyki i wózki",
    "categoryPath": [
      "(121467) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121467) Firma i usługi / Przemysł / Sklep i magazyn / Koszyki i wózki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Listwy cenowe",
    "categoryPath": [
      "(322548) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(322548) Firma i usługi / Przemysł / Sklep i magazyn / Listwy cenowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Metkownice",
    "categoryPath": [
      "(121468) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121468) Firma i usługi / Przemysł / Sklep i magazyn / Metkownice",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Namioty magazynowe",
    "categoryPath": [
      "(257563) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(257563) Firma i usługi / Przemysł / Sklep i magazyn / Namioty magazynowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Osłony ochronne",
    "categoryPath": [
      "(310373) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(310373) Firma i usługi / Przemysł / Sklep i magazyn / Osłony ochronne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Palety i pojemniki",
    "categoryPath": [
      "(121469) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121469) Firma i usługi / Przemysł / Sklep i magazyn / Palety i pojemniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podkłady i maty",
    "categoryPath": [
      "(261769) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(261769) Firma i usługi / Przemysł / Sklep i magazyn / Podkłady i maty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121460) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121460) Firma i usługi / Przemysł / Sklep i magazyn / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Regały magazynowe",
    "categoryPath": [
      "(121557) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Regały sklepowe i magazynowe"
    ],
    "hierarchy": "(121557) Firma i usługi / Przemysł / Sklep i magazyn / Regały sklepowe i magazynowe / Regały magazynowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Regały sklepowe",
    "categoryPath": [
      "(321444) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Regały sklepowe i magazynowe"
    ],
    "hierarchy": "(321444) Firma i usługi / Przemysł / Sklep i magazyn / Regały sklepowe i magazynowe / Regały sklepowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D2"
  },
  {
    "segment": "Stoły handlowe i bazarowe",
    "categoryPath": [
      "(261770) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(261770) Firma i usługi / Przemysł / Sklep i magazyn / Stoły handlowe i bazarowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szafy metalowe i socjalne",
    "categoryPath": [
      "(261768) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(261768) Firma i usługi / Przemysł / Sklep i magazyn / Szafy metalowe i socjalne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Terminale płatnicze",
    "categoryPath": [
      "(260175) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(260175) Firma i usługi / Przemysł / Sklep i magazyn / Terminale płatnicze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Testery banknotów",
    "categoryPath": [
      "(121470) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121470) Firma i usługi / Przemysł / Sklep i magazyn / Testery banknotów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Folie do pakowania próżniowego",
    "categoryPath": [
      "(319787) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Osprzęt"
    ],
    "hierarchy": "(319787) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Osprzęt / Folie do pakowania próżniowego",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inny osprzęt",
    "categoryPath": [
      "(319802) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Osprzęt"
    ],
    "hierarchy": "(319802) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Osprzęt / Inny osprzęt",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(319790) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Osprzęt"
    ],
    "hierarchy": "(319790) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Osprzęt / Taśmy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(319793) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Osprzęt"
    ],
    "hierarchy": "(319793) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Osprzęt / Uchwyty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Worki",
    "categoryPath": [
      "(319796) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Osprzęt"
    ],
    "hierarchy": "(319796) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Osprzęt / Worki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zapinki",
    "categoryPath": [
      "(319799) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Osprzęt"
    ],
    "hierarchy": "(319799) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Osprzęt / Zapinki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bandownice",
    "categoryPath": [
      "(319808) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319808) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Bandownice",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Datowniki",
    "categoryPath": [
      "(319811) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319811) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Datowniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inne urządzenia",
    "categoryPath": [
      "(319832) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319832) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Inne urządzenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pakowarki",
    "categoryPath": [
      "(319817) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319817) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Pakowarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stoły do pakowania",
    "categoryPath": [
      "(319820) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319820) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Stoły do pakowania",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wózki",
    "categoryPath": [
      "(319823) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319823) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Wózki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zaszywarki",
    "categoryPath": [
      "(319878) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319878) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Zaszywarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy pakowe",
    "categoryPath": [
      "(319826) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319826) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Zestawy pakowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zgrzewarki",
    "categoryPath": [
      "(319829) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn",
      "Urządzenia i akcesoria do pakowania",
      "Urządzenia"
    ],
    "hierarchy": "(319829) Firma i usługi / Przemysł / Sklep i magazyn / Urządzenia i akcesoria do pakowania / Urządzenia / Zgrzewarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wagi",
    "categoryPath": [
      "(121472) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121472) Firma i usługi / Przemysł / Sklep i magazyn / Wagi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wózki paletowe",
    "categoryPath": [
      "(121473) Firma i usługi",
      "Przemysł",
      "Sklep i magazyn"
    ],
    "hierarchy": "(121473) Firma i usługi / Przemysł / Sklep i magazyn / Wózki paletowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Naszywki, naklejki",
    "categoryPath": [
      "(314045) Firma i usługi",
      "Przemysł",
      "Służby bezpieczeństwa publicznego"
    ],
    "hierarchy": "(314045) Firma i usługi / Przemysł / Służby bezpieczeństwa publicznego / Naszywki, naklejki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sprzęt ratowniczy",
    "categoryPath": [
      "(17129) Firma i usługi",
      "Przemysł",
      "Służby bezpieczeństwa publicznego"
    ],
    "hierarchy": "(17129) Firma i usługi / Przemysł / Służby bezpieczeństwa publicznego / Sprzęt ratowniczy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Elementy dekoracyjne",
    "categoryPath": [
      "(121536) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne"
    ],
    "hierarchy": "(121536) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Elementy dekoracyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Meble dla lokali",
    "categoryPath": [
      "(121535) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne"
    ],
    "hierarchy": "(121535) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Meble dla lokali",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Baseny",
    "categoryPath": [
      "(121621) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne",
      "Meble technologiczne"
    ],
    "hierarchy": "(121621) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Meble technologiczne / Baseny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bemary",
    "categoryPath": [
      "(121622) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne",
      "Meble technologiczne"
    ],
    "hierarchy": "(121622) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Meble technologiczne / Bemary",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Okapy",
    "categoryPath": [
      "(121623) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne",
      "Meble technologiczne"
    ],
    "hierarchy": "(121623) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Meble technologiczne / Okapy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Regały, półki",
    "categoryPath": [
      "(121626) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne",
      "Meble technologiczne"
    ],
    "hierarchy": "(121626) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Meble technologiczne / Regały, półki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(121625) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne",
      "Meble technologiczne"
    ],
    "hierarchy": "(121625) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Meble technologiczne / Stoły",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szafy",
    "categoryPath": [
      "(121624) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne",
      "Meble technologiczne"
    ],
    "hierarchy": "(121624) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Meble technologiczne / Szafy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wózki kelnerskie",
    "categoryPath": [
      "(322145) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń",
      "Gastronomiczne"
    ],
    "hierarchy": "(322145) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Gastronomiczne / Wózki kelnerskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121526) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń"
    ],
    "hierarchy": "(121526) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Systemy oświetleniowe",
    "categoryPath": [
      "(121530) Firma i usługi",
      "Przemysł",
      "Wyposażenie pomieszczeń"
    ],
    "hierarchy": "(121530) Firma i usługi / Przemysł / Wyposażenie pomieszczeń / Systemy oświetleniowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Druk płaski",
    "categoryPath": [
      "(256424) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Grafika"
    ],
    "hierarchy": "(256424) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Grafika / Druk płaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Druk wklęsły",
    "categoryPath": [
      "(256425) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Grafika"
    ],
    "hierarchy": "(256425) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Grafika / Druk wklęsły",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Druk wypukły",
    "categoryPath": [
      "(256423) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Grafika"
    ],
    "hierarchy": "(256423) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Grafika / Druk wypukły",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne techniki",
    "categoryPath": [
      "(256422) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Grafika"
    ],
    "hierarchy": "(256422) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Grafika / Inne techniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bloki i papiery",
    "categoryPath": [
      "(260836) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Kaligrafia"
    ],
    "hierarchy": "(260836) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Kaligrafia / Bloki i papiery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pisaki i cienkopisy",
    "categoryPath": [
      "(260838) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Kaligrafia"
    ],
    "hierarchy": "(260838) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Kaligrafia / Pisaki i cienkopisy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pióra",
    "categoryPath": [
      "(260839) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Kaligrafia"
    ],
    "hierarchy": "(260839) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Kaligrafia / Pióra",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tusze i atramenty",
    "categoryPath": [
      "(260837) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Kaligrafia"
    ],
    "hierarchy": "(260837) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Kaligrafia / Tusze i atramenty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(260840) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Kaligrafia"
    ],
    "hierarchy": "(260840) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Kaligrafia / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drewno",
    "categoryPath": [
      "(256463) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Konserwacja"
    ],
    "hierarchy": "(256463) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Konserwacja / Drewno",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kamień",
    "categoryPath": [
      "(256466) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Konserwacja"
    ],
    "hierarchy": "(256466) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Konserwacja / Kamień",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Metal",
    "categoryPath": [
      "(256464) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Konserwacja"
    ],
    "hierarchy": "(256464) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Konserwacja / Metal",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Papier",
    "categoryPath": [
      "(256465) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Konserwacja"
    ],
    "hierarchy": "(256465) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Konserwacja / Papier",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256462) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Konserwacja"
    ],
    "hierarchy": "(256462) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Konserwacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skóra",
    "categoryPath": [
      "(256467) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Konserwacja"
    ],
    "hierarchy": "(256467) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Konserwacja / Skóra",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Farby",
    "categoryPath": [
      "(256385) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Malarstwo"
    ],
    "hierarchy": "(256385) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Malarstwo / Farby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Malowanie po numerach",
    "categoryPath": [
      "(260064) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Malarstwo"
    ],
    "hierarchy": "(260064) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Malarstwo / Malowanie po numerach",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Palety",
    "categoryPath": [
      "(256384) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Malarstwo"
    ],
    "hierarchy": "(256384) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Malarstwo / Palety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkłady malarskie",
    "categoryPath": [
      "(256386) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Malarstwo"
    ],
    "hierarchy": "(256386) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Malarstwo / Podkłady malarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pędzle",
    "categoryPath": [
      "(256383) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Malarstwo"
    ],
    "hierarchy": "(256383) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Malarstwo / Pędzle",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(260842) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Malarstwo"
    ],
    "hierarchy": "(260842) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Malarstwo / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(27949) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne"
    ],
    "hierarchy": "(27949) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozłotnictwo",
    "categoryPath": [
      "(99915) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne"
    ],
    "hierarchy": "(99915) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Pozłotnictwo",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gotowe",
    "categoryPath": [
      "(256637) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Ramy i oprawy"
    ],
    "hierarchy": "(256637) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Ramy i oprawy / Gotowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Na wymiar",
    "categoryPath": [
      "(256638) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Ramy i oprawy"
    ],
    "hierarchy": "(256638) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Ramy i oprawy / Na wymiar",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bloki, szkicowniki",
    "categoryPath": [
      "(260313) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rysunek"
    ],
    "hierarchy": "(260313) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rysunek / Bloki, szkicowniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kredki",
    "categoryPath": [
      "(256342) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rysunek"
    ],
    "hierarchy": "(256342) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rysunek / Kredki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Markery i pisaki",
    "categoryPath": [
      "(99925) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rysunek"
    ],
    "hierarchy": "(99925) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rysunek / Markery i pisaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ołówki",
    "categoryPath": [
      "(256343) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rysunek"
    ],
    "hierarchy": "(256343) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rysunek / Ołówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Teczki i tuby",
    "categoryPath": [
      "(256344) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rysunek"
    ],
    "hierarchy": "(256344) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rysunek / Teczki i tuby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Węgiel",
    "categoryPath": [
      "(99926) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rysunek"
    ],
    "hierarchy": "(99926) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rysunek / Węgiel",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(256345) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rysunek"
    ],
    "hierarchy": "(256345) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rysunek / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drewno",
    "categoryPath": [
      "(256443) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rzeźbiarstwo"
    ],
    "hierarchy": "(256443) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rzeźbiarstwo / Drewno",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Glina i gips",
    "categoryPath": [
      "(256444) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rzeźbiarstwo"
    ],
    "hierarchy": "(256444) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rzeźbiarstwo / Glina i gips",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kamień",
    "categoryPath": [
      "(256445) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rzeźbiarstwo"
    ],
    "hierarchy": "(256445) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rzeźbiarstwo / Kamień",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Metal",
    "categoryPath": [
      "(256446) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne",
      "Rzeźbiarstwo"
    ],
    "hierarchy": "(256446) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Rzeźbiarstwo / Metal",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sztalugi",
    "categoryPath": [
      "(27947) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne"
    ],
    "hierarchy": "(27947) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Sztalugi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(99916) Kolekcje i sztuka",
      "Design i Antyki",
      "Akcesoria plastyczne"
    ],
    "hierarchy": "(99916) Kolekcje i sztuka / Design i Antyki / Akcesoria plastyczne / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Autografy i rękopisy",
    "categoryPath": [
      "(26099) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat"
    ],
    "hierarchy": "(26099) Kolekcje i sztuka / Design i Antyki / Antykwariat / Autografy i rękopisy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czasopisma",
    "categoryPath": [
      "(26100) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat"
    ],
    "hierarchy": "(26100) Kolekcje i sztuka / Design i Antyki / Antykwariat / Czasopisma",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Exlibrisy",
    "categoryPath": [
      "(26117) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat"
    ],
    "hierarchy": "(26117) Kolekcje i sztuka / Design i Antyki / Antykwariat / Exlibrisy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bibliofilskie",
    "categoryPath": [
      "(26113) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki",
      "Bibliofilskie i starodruki"
    ],
    "hierarchy": "(26113) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Bibliofilskie i starodruki / Bibliofilskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Starodruki do 1800",
    "categoryPath": [
      "(26131) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki",
      "Bibliofilskie i starodruki"
    ],
    "hierarchy": "(26131) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Bibliofilskie i starodruki / Starodruki do 1800",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Biografie, wspomnienia",
    "categoryPath": [
      "(322114) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322114) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Biografie, wspomnienia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(259468) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259468) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Dla dzieci",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ekonomia",
    "categoryPath": [
      "(259469) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259469) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Ekonomia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Etnografia",
    "categoryPath": [
      "(259470) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259470) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Etnografia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Geografia",
    "categoryPath": [
      "(259471) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259471) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Geografia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gospodarstwo domowe, kuchnia",
    "categoryPath": [
      "(259472) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259472) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Gospodarstwo domowe, kuchnia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Heraldyka i genealogia",
    "categoryPath": [
      "(259473) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259473) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Heraldyka i genealogia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Historia",
    "categoryPath": [
      "(259474) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259474) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Historia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Językoznawstwo",
    "categoryPath": [
      "(259475) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259475) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Językoznawstwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Komiksy",
    "categoryPath": [
      "(322115) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322115) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Komiksy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Książki dla młodzieży",
    "categoryPath": [
      "(322116) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322116) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Książki dla młodzieży",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Książki do nauki języka obcego",
    "categoryPath": [
      "(322117) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322117) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Książki do nauki języka obcego",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(259476) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259476) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Literatura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Marketing i zarządzanie",
    "categoryPath": [
      "(322120) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322120) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Marketing i zarządzanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Marynistyka",
    "categoryPath": [
      "(260545) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(260545) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Marynistyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Medycyna",
    "categoryPath": [
      "(259477) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259477) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Medycyna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Muzyka",
    "categoryPath": [
      "(259478) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259478) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Muzyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nauki humanistyczne",
    "categoryPath": [
      "(259479) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259479) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Nauki humanistyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nauki przyrodnicze",
    "categoryPath": [
      "(259480) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259480) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Nauki przyrodnicze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nauki ścisłe",
    "categoryPath": [
      "(259481) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259481) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Nauki ścisłe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Podręczniki do szkół podstawowych i średnich",
    "categoryPath": [
      "(322118) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322118) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Podręczniki do szkół podstawowych i średnich",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polityka",
    "categoryPath": [
      "(259482) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259482) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Polityka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Poradniki i albumy",
    "categoryPath": [
      "(322121) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322121) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Poradniki i albumy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259489) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259489) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prawo",
    "categoryPath": [
      "(259483) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259483) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Prawo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Przewodniki turystyczne",
    "categoryPath": [
      "(260854) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(260854) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Przewodniki turystyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Religia",
    "categoryPath": [
      "(259484) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259484) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Religia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Reportaż, literatura faktu",
    "categoryPath": [
      "(322119) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(322119) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Reportaż, literatura faktu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sport",
    "categoryPath": [
      "(260544) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(260544) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Sport",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sztuka i kultura",
    "categoryPath": [
      "(259485) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259485) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Sztuka i kultura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Słowniki i encyklopedie",
    "categoryPath": [
      "(259486) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259486) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Słowniki i encyklopedie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Technika, informatyka",
    "categoryPath": [
      "(259487) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Książki"
    ],
    "hierarchy": "(259487) Kolekcje i sztuka / Design i Antyki / Antykwariat / Książki / Technika, informatyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26110) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat"
    ],
    "hierarchy": "(26110) Kolekcje i sztuka / Design i Antyki / Antykwariat / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stara reklama",
    "categoryPath": [
      "(26103) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat"
    ],
    "hierarchy": "(26103) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stara reklama",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akty i umowy",
    "categoryPath": [
      "(26145) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare dokumenty"
    ],
    "hierarchy": "(26145) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare dokumenty / Akty i umowy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dokumenty do 1800",
    "categoryPath": [
      "(26143) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare dokumenty"
    ],
    "hierarchy": "(26143) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare dokumenty / Dokumenty do 1800",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Faktury i rachunki",
    "categoryPath": [
      "(26146) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare dokumenty"
    ],
    "hierarchy": "(26146) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare dokumenty / Faktury i rachunki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Identyfikacyjne",
    "categoryPath": [
      "(26144) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare dokumenty"
    ],
    "hierarchy": "(26144) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare dokumenty / Identyfikacyjne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Listy i pisma",
    "categoryPath": [
      "(26147) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare dokumenty"
    ],
    "hierarchy": "(26147) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare dokumenty / Listy i pisma",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26149) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare dokumenty"
    ],
    "hierarchy": "(26149) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare dokumenty / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stare kalendarze",
    "categoryPath": [
      "(260558) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat"
    ],
    "hierarchy": "(260558) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare kalendarze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Afryka",
    "categoryPath": [
      "(26155) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy"
    ],
    "hierarchy": "(26155) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Afryka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ameryki",
    "categoryPath": [
      "(26156) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy"
    ],
    "hierarchy": "(26156) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Ameryki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Azja",
    "categoryPath": [
      "(26157) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy"
    ],
    "hierarchy": "(26157) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Azja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy i Słowacja",
    "categoryPath": [
      "(322353) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy"
    ],
    "hierarchy": "(322353) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Czechy i Słowacja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Europa",
    "categoryPath": [
      "(26158) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy"
    ],
    "hierarchy": "(26158) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Europa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polska",
    "categoryPath": [
      "(26159) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy"
    ],
    "hierarchy": "(26159) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Polska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26160) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy"
    ],
    "hierarchy": "(26160) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Afryka",
    "categoryPath": [
      "(260818) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy",
      "Reprodukcje"
    ],
    "hierarchy": "(260818) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Reprodukcje / Afryka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ameryki",
    "categoryPath": [
      "(260817) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy",
      "Reprodukcje"
    ],
    "hierarchy": "(260817) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Reprodukcje / Ameryki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Azja",
    "categoryPath": [
      "(260819) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy",
      "Reprodukcje"
    ],
    "hierarchy": "(260819) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Reprodukcje / Azja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Europa",
    "categoryPath": [
      "(260816) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy",
      "Reprodukcje"
    ],
    "hierarchy": "(260816) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Reprodukcje / Europa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mapy świata",
    "categoryPath": [
      "(260814) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy",
      "Reprodukcje"
    ],
    "hierarchy": "(260814) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Reprodukcje / Mapy świata",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polska",
    "categoryPath": [
      "(260815) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy",
      "Reprodukcje"
    ],
    "hierarchy": "(260815) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Reprodukcje / Polska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260826) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat",
      "Stare mapy",
      "Reprodukcje"
    ],
    "hierarchy": "(260826) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare mapy / Reprodukcje / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stare ulotki",
    "categoryPath": [
      "(26108) Kolekcje i sztuka",
      "Design i Antyki",
      "Antykwariat"
    ],
    "hierarchy": "(26108) Kolekcje i sztuka / Design i Antyki / Antykwariat / Stare ulotki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bransoletki",
    "categoryPath": [
      "(62219) Kolekcje i sztuka",
      "Design i Antyki",
      "Biżuteria"
    ],
    "hierarchy": "(62219) Kolekcje i sztuka / Design i Antyki / Biżuteria / Bransoletki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Broszki",
    "categoryPath": [
      "(62220) Kolekcje i sztuka",
      "Design i Antyki",
      "Biżuteria"
    ],
    "hierarchy": "(62220) Kolekcje i sztuka / Design i Antyki / Biżuteria / Broszki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolczyki i klipsy",
    "categoryPath": [
      "(62221) Kolekcje i sztuka",
      "Design i Antyki",
      "Biżuteria"
    ],
    "hierarchy": "(62221) Kolekcje i sztuka / Design i Antyki / Biżuteria / Kolczyki i klipsy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Naszyjniki",
    "categoryPath": [
      "(62222) Kolekcje i sztuka",
      "Design i Antyki",
      "Biżuteria"
    ],
    "hierarchy": "(62222) Kolekcje i sztuka / Design i Antyki / Biżuteria / Naszyjniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pierścionki",
    "categoryPath": [
      "(62223) Kolekcje i sztuka",
      "Design i Antyki",
      "Biżuteria"
    ],
    "hierarchy": "(62223) Kolekcje i sztuka / Design i Antyki / Biżuteria / Pierścionki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(62225) Kolekcje i sztuka",
      "Design i Antyki",
      "Biżuteria"
    ],
    "hierarchy": "(62225) Kolekcje i sztuka / Design i Antyki / Biżuteria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wisiorki",
    "categoryPath": [
      "(62224) Kolekcje i sztuka",
      "Design i Antyki",
      "Biżuteria"
    ],
    "hierarchy": "(62224) Kolekcje i sztuka / Design i Antyki / Biżuteria / Wisiorki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Donice",
    "categoryPath": [
      "(308257) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(308257) Kolekcje i sztuka / Design i Antyki / Ceramika / Donice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(26016) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26016) Kolekcje i sztuka / Design i Antyki / Ceramika / Figurki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Naczynia do kawy i herbaty",
    "categoryPath": [
      "(26017) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26017) Kolekcje i sztuka / Design i Antyki / Ceramika / Naczynia do kawy i herbaty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Piece, kafle i płytki",
    "categoryPath": [
      "(26018) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26018) Kolekcje i sztuka / Design i Antyki / Ceramika / Piece, kafle i płytki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26024) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26024) Kolekcje i sztuka / Design i Antyki / Ceramika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przedmioty kuchenne",
    "categoryPath": [
      "(26019) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26019) Kolekcje i sztuka / Design i Antyki / Ceramika / Przedmioty kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Talerze, patery, półmiski",
    "categoryPath": [
      "(26020) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26020) Kolekcje i sztuka / Design i Antyki / Ceramika / Talerze, patery, półmiski",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wazony i dzbanki",
    "categoryPath": [
      "(26021) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26021) Kolekcje i sztuka / Design i Antyki / Ceramika / Wazony i dzbanki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyroby gliniane",
    "categoryPath": [
      "(26022) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(26022) Kolekcje i sztuka / Design i Antyki / Ceramika / Wyroby gliniane",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Świeczniki",
    "categoryPath": [
      "(308269) Kolekcje i sztuka",
      "Design i Antyki",
      "Ceramika"
    ],
    "hierarchy": "(308269) Kolekcje i sztuka / Design i Antyki / Ceramika / Świeczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kropielnice",
    "categoryPath": [
      "(308353) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(308353) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Kropielnice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Krzyżyki",
    "categoryPath": [
      "(52331) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(52331) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Krzyżyki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Medaliki",
    "categoryPath": [
      "(52332) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(52332) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Medaliki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Modlitewniki",
    "categoryPath": [
      "(52333) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(52333) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Modlitewniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obrazki",
    "categoryPath": [
      "(52334) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(52334) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Obrazki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obrazy i figurki",
    "categoryPath": [
      "(52335) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(52335) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Obrazy i figurki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(52337) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(52337) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Różańce",
    "categoryPath": [
      "(52336) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(52336) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Różańce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(99930) Kolekcje i sztuka",
      "Design i Antyki",
      "Dewocjonalia"
    ],
    "hierarchy": "(99930) Kolekcje i sztuka / Design i Antyki / Dewocjonalia / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Instrumenty dęte",
    "categoryPath": [
      "(260685) Kolekcje i sztuka",
      "Design i Antyki",
      "Instrumenty muzyczne"
    ],
    "hierarchy": "(260685) Kolekcje i sztuka / Design i Antyki / Instrumenty muzyczne / Instrumenty dęte",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Instrumenty klawiszowe",
    "categoryPath": [
      "(260686) Kolekcje i sztuka",
      "Design i Antyki",
      "Instrumenty muzyczne"
    ],
    "hierarchy": "(260686) Kolekcje i sztuka / Design i Antyki / Instrumenty muzyczne / Instrumenty klawiszowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Instrumenty perkusyjne",
    "categoryPath": [
      "(260687) Kolekcje i sztuka",
      "Design i Antyki",
      "Instrumenty muzyczne"
    ],
    "hierarchy": "(260687) Kolekcje i sztuka / Design i Antyki / Instrumenty muzyczne / Instrumenty perkusyjne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Instrumenty smyczkowe",
    "categoryPath": [
      "(260688) Kolekcje i sztuka",
      "Design i Antyki",
      "Instrumenty muzyczne"
    ],
    "hierarchy": "(260688) Kolekcje i sztuka / Design i Antyki / Instrumenty muzyczne / Instrumenty smyczkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Instrumenty strunowe",
    "categoryPath": [
      "(260689) Kolekcje i sztuka",
      "Design i Antyki",
      "Instrumenty muzyczne"
    ],
    "hierarchy": "(260689) Kolekcje i sztuka / Design i Antyki / Instrumenty muzyczne / Instrumenty strunowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260690) Kolekcje i sztuka",
      "Design i Antyki",
      "Instrumenty muzyczne"
    ],
    "hierarchy": "(260690) Kolekcje i sztuka / Design i Antyki / Instrumenty muzyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Antyki",
    "categoryPath": [
      "(26081) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(26081) Kolekcje i sztuka / Design i Antyki / Literatura / Antyki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Księgoznawstwo",
    "categoryPath": [
      "(26161) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(26161) Kolekcje i sztuka / Design i Antyki / Literatura / Księgoznawstwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malarstwo",
    "categoryPath": [
      "(26279) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(26279) Kolekcje i sztuka / Design i Antyki / Literatura / Malarstwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Meble",
    "categoryPath": [
      "(26251) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(26251) Kolekcje i sztuka / Design i Antyki / Literatura / Meble",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Opracowania ogólne",
    "categoryPath": [
      "(316549) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(316549) Kolekcje i sztuka / Design i Antyki / Literatura / Opracowania ogólne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Porcelana",
    "categoryPath": [
      "(26193) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(26193) Kolekcje i sztuka / Design i Antyki / Literatura / Porcelana",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sztuka współczesna",
    "categoryPath": [
      "(99928) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(99928) Kolekcje i sztuka / Design i Antyki / Literatura / Sztuka współczesna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tkaniny",
    "categoryPath": [
      "(99929) Kolekcje i sztuka",
      "Design i Antyki",
      "Literatura"
    ],
    "hierarchy": "(99929) Kolekcje i sztuka / Design i Antyki / Literatura / Tkaniny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Biblioteki",
    "categoryPath": [
      "(26230) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26230) Kolekcje i sztuka / Design i Antyki / Meble / Biblioteki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Biurka",
    "categoryPath": [
      "(26229) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26229) Kolekcje i sztuka / Design i Antyki / Meble / Biurka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Elementy i akcesoria",
    "categoryPath": [
      "(26250) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26250) Kolekcje i sztuka / Design i Antyki / Meble / Elementy i akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Fotele",
    "categoryPath": [
      "(26231) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26231) Kolekcje i sztuka / Design i Antyki / Meble / Fotele",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kanapy i sofy",
    "categoryPath": [
      "(26236) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26236) Kolekcje i sztuka / Design i Antyki / Meble / Kanapy i sofy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Komody",
    "categoryPath": [
      "(26233) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26233) Kolekcje i sztuka / Design i Antyki / Meble / Komody",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Komplety mebli",
    "categoryPath": [
      "(26249) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26249) Kolekcje i sztuka / Design i Antyki / Meble / Komplety mebli",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kredensy",
    "categoryPath": [
      "(26234) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26234) Kolekcje i sztuka / Design i Antyki / Meble / Kredensy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Krzesła",
    "categoryPath": [
      "(26232) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26232) Kolekcje i sztuka / Design i Antyki / Meble / Krzesła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lustra",
    "categoryPath": [
      "(26244) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26244) Kolekcje i sztuka / Design i Antyki / Meble / Lustra",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Meble do 1820 roku",
    "categoryPath": [
      "(26228) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26228) Kolekcje i sztuka / Design i Antyki / Meble / Meble do 1820 roku",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Serwantki",
    "categoryPath": [
      "(26235) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26235) Kolekcje i sztuka / Design i Antyki / Meble / Serwantki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skrzynie i kufry",
    "categoryPath": [
      "(26245) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26245) Kolekcje i sztuka / Design i Antyki / Meble / Skrzynie i kufry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skrzynki i szkatułki",
    "categoryPath": [
      "(26261) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26261) Kolekcje i sztuka / Design i Antyki / Meble / Skrzynki i szkatułki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Stoliki",
    "categoryPath": [
      "(26239) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26239) Kolekcje i sztuka / Design i Antyki / Meble / Stoliki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(26238) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26238) Kolekcje i sztuka / Design i Antyki / Meble / Stoły",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szafki",
    "categoryPath": [
      "(26241) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26241) Kolekcje i sztuka / Design i Antyki / Meble / Szafki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szafy",
    "categoryPath": [
      "(26240) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26240) Kolekcje i sztuka / Design i Antyki / Meble / Szafy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(26243) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26243) Kolekcje i sztuka / Design i Antyki / Meble / Wieszaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Witryny",
    "categoryPath": [
      "(26242) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26242) Kolekcje i sztuka / Design i Antyki / Meble / Witryny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Łóżka",
    "categoryPath": [
      "(26237) Kolekcje i sztuka",
      "Design i Antyki",
      "Meble"
    ],
    "hierarchy": "(26237) Kolekcje i sztuka / Design i Antyki / Meble / Łóżka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Miedź, mosiądz, cyna",
    "categoryPath": [
      "(321540) Kolekcje i sztuka",
      "Design i Antyki"
    ],
    "hierarchy": "(321540) Kolekcje i sztuka / Design i Antyki / Miedź, mosiądz, cyna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Części i akcesoria",
    "categoryPath": [
      "(321498) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(321498) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Części i akcesoria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kinkiety",
    "categoryPath": [
      "(46853) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(46853) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Kinkiety",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Klosze",
    "categoryPath": [
      "(315858) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(315858) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Klosze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lampki",
    "categoryPath": [
      "(26027) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(26027) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Lampki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lampy naftowe",
    "categoryPath": [
      "(46848) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(46848) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Lampy naftowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lampy podłogowe",
    "categoryPath": [
      "(46849) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(46849) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Lampy podłogowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(46851) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(46851) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Świeczniki, kandelabry",
    "categoryPath": [
      "(26028) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(26028) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Świeczniki, kandelabry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Żyrandole",
    "categoryPath": [
      "(26029) Kolekcje i sztuka",
      "Design i Antyki",
      "Oświetlenie"
    ],
    "hierarchy": "(26029) Kolekcje i sztuka / Design i Antyki / Oświetlenie / Żyrandole",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bibeloty",
    "categoryPath": [
      "(26031) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26031) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Bibeloty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Cukiernice",
    "categoryPath": [
      "(26032) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26032) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Cukiernice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dzbanki i mleczniki",
    "categoryPath": [
      "(26033) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26033) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Dzbanki i mleczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Galanteria stołowa",
    "categoryPath": [
      "(26034) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26034) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Galanteria stołowa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Patery",
    "categoryPath": [
      "(26035) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26035) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Patery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26039) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26039) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Puchary i kielichy",
    "categoryPath": [
      "(26036) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26036) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Puchary i kielichy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sztućce",
    "categoryPath": [
      "(26037) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26037) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Sztućce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Talerze i półmiski",
    "categoryPath": [
      "(26038) Kolekcje i sztuka",
      "Design i Antyki",
      "Platery, posrebrzane i inne"
    ],
    "hierarchy": "(26038) Kolekcje i sztuka / Design i Antyki / Platery, posrebrzane i inne / Talerze i półmiski",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Antyki do 1850",
    "categoryPath": [
      "(26164) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26164) Kolekcje i sztuka / Design i Antyki / Porcelana / Antyki do 1850",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Cukiernice i bomboniery",
    "categoryPath": [
      "(26179) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26179) Kolekcje i sztuka / Design i Antyki / Porcelana / Cukiernice i bomboniery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dzbanki i czajniki",
    "categoryPath": [
      "(26180) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26180) Kolekcje i sztuka / Design i Antyki / Porcelana / Dzbanki i czajniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(26191) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26191) Kolekcje i sztuka / Design i Antyki / Porcelana / Figurki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Filiżanki",
    "categoryPath": [
      "(26182) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26182) Kolekcje i sztuka / Design i Antyki / Porcelana / Filiżanki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Galanteria stołowa",
    "categoryPath": [
      "(26312) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26312) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Galanteria stołowa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Popielniczki",
    "categoryPath": [
      "(308629) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(308629) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Popielniczki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26319) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26319) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przybory kuchenne",
    "categoryPath": [
      "(26313) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26313) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Przybory kuchenne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Salaterki",
    "categoryPath": [
      "(26314) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26314) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Salaterki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sosjerki",
    "categoryPath": [
      "(26315) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26315) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Sosjerki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tace i półmiski",
    "categoryPath": [
      "(26316) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26316) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Tace i półmiski",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wazy",
    "categoryPath": [
      "(26317) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26317) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Wazy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Świeczniki",
    "categoryPath": [
      "(26318) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana",
      "Inne przedmioty"
    ],
    "hierarchy": "(26318) Kolekcje i sztuka / Design i Antyki / Porcelana / Inne przedmioty / Świeczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kabarety, koszyki, misy, żardiniery",
    "categoryPath": [
      "(26186) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26186) Kolekcje i sztuka / Design i Antyki / Porcelana / Kabarety, koszyki, misy, żardiniery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Miśnia",
    "categoryPath": [
      "(26165) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26165) Kolekcje i sztuka / Design i Antyki / Porcelana / Miśnia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mleczniki",
    "categoryPath": [
      "(26181) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26181) Kolekcje i sztuka / Design i Antyki / Porcelana / Mleczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Patery i duże talerze",
    "categoryPath": [
      "(26184) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26184) Kolekcje i sztuka / Design i Antyki / Porcelana / Patery i duże talerze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rosenthal",
    "categoryPath": [
      "(26171) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26171) Kolekcje i sztuka / Design i Antyki / Porcelana / Rosenthal",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Serwisy - części",
    "categoryPath": [
      "(26187) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26187) Kolekcje i sztuka / Design i Antyki / Porcelana / Serwisy - części",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Serwisy kompletne",
    "categoryPath": [
      "(26188) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26188) Kolekcje i sztuka / Design i Antyki / Porcelana / Serwisy kompletne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sorau - Żary",
    "categoryPath": [
      "(26176) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26176) Kolekcje i sztuka / Design i Antyki / Porcelana / Sorau - Żary",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkatułki i puzdra",
    "categoryPath": [
      "(26190) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26190) Kolekcje i sztuka / Design i Antyki / Porcelana / Szkatułki i puzdra",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Talerzyki i podstawki",
    "categoryPath": [
      "(26185) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26185) Kolekcje i sztuka / Design i Antyki / Porcelana / Talerzyki i podstawki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wazony",
    "categoryPath": [
      "(26189) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26189) Kolekcje i sztuka / Design i Antyki / Porcelana / Wazony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy śniadaniowe",
    "categoryPath": [
      "(26183) Kolekcje i sztuka",
      "Design i Antyki",
      "Porcelana"
    ],
    "hierarchy": "(26183) Kolekcje i sztuka / Design i Antyki / Porcelana / Zestawy śniadaniowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26097) Kolekcje i sztuka",
      "Design i Antyki"
    ],
    "hierarchy": "(26097) Kolekcje i sztuka / Design i Antyki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ceramika",
    "categoryPath": [
      "(321927) Kolekcje i sztuka",
      "Design i Antyki",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321927) Kolekcje i sztuka / Design i Antyki / Reprodukcje i przedmioty stylizowane / Ceramika",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Meble",
    "categoryPath": [
      "(321931) Kolekcje i sztuka",
      "Design i Antyki",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321931) Kolekcje i sztuka / Design i Antyki / Reprodukcje i przedmioty stylizowane / Meble",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(321928) Kolekcje i sztuka",
      "Design i Antyki",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321928) Kolekcje i sztuka / Design i Antyki / Reprodukcje i przedmioty stylizowane / Oświetlenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(321930) Kolekcje i sztuka",
      "Design i Antyki",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321930) Kolekcje i sztuka / Design i Antyki / Reprodukcje i przedmioty stylizowane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zegary, zegarki",
    "categoryPath": [
      "(321929) Kolekcje i sztuka",
      "Design i Antyki",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321929) Kolekcje i sztuka / Design i Antyki / Reprodukcje i przedmioty stylizowane / Zegary, zegarki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bibeloty",
    "categoryPath": [
      "(26048) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26048) Kolekcje i sztuka / Design i Antyki / Srebra / Bibeloty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Cukiernice",
    "categoryPath": [
      "(26049) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26049) Kolekcje i sztuka / Design i Antyki / Srebra / Cukiernice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dzbanki i mleczniki",
    "categoryPath": [
      "(26050) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26050) Kolekcje i sztuka / Design i Antyki / Srebra / Dzbanki i mleczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Galanteria stołowa",
    "categoryPath": [
      "(26051) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26051) Kolekcje i sztuka / Design i Antyki / Srebra / Galanteria stołowa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Patery",
    "categoryPath": [
      "(26052) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26052) Kolekcje i sztuka / Design i Antyki / Srebra / Patery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26055) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26055) Kolekcje i sztuka / Design i Antyki / Srebra / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Puchary i kielichy",
    "categoryPath": [
      "(26053) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26053) Kolekcje i sztuka / Design i Antyki / Srebra / Puchary i kielichy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sztućce",
    "categoryPath": [
      "(26054) Kolekcje i sztuka",
      "Design i Antyki",
      "Srebra"
    ],
    "hierarchy": "(26054) Kolekcje i sztuka / Design i Antyki / Srebra / Sztućce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkło apteczne",
    "categoryPath": [
      "(26060) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło"
    ],
    "hierarchy": "(26060) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło apteczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(26062) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło dekoracyjne"
    ],
    "hierarchy": "(26062) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło dekoracyjne / Figurki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26064) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło dekoracyjne"
    ],
    "hierarchy": "(26064) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło dekoracyjne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Witraże",
    "categoryPath": [
      "(26063) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło dekoracyjne"
    ],
    "hierarchy": "(26063) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło dekoracyjne / Witraże",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkło do 1900",
    "categoryPath": [
      "(26057) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło"
    ],
    "hierarchy": "(26057) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło do 1900",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkło kryształowe",
    "categoryPath": [
      "(26061) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło"
    ],
    "hierarchy": "(26061) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło kryształowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Butelki",
    "categoryPath": [
      "(26065) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(26065) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Butelki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Cukiernice i bomboniery",
    "categoryPath": [
      "(26066) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(26066) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Cukiernice i bomboniery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karafki",
    "categoryPath": [
      "(26067) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(26067) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Karafki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kieliszki",
    "categoryPath": [
      "(26068) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(26068) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Kieliszki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Popielnice",
    "categoryPath": [
      "(308545) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(308545) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Popielnice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26071) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(26071) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Talerze i patery",
    "categoryPath": [
      "(26069) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(26069) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Talerze i patery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wazony",
    "categoryPath": [
      "(26070) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(26070) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Wazony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Świeczniki",
    "categoryPath": [
      "(308557) Kolekcje i sztuka",
      "Design i Antyki",
      "Szkło",
      "Szkło użytkowe"
    ],
    "hierarchy": "(308557) Kolekcje i sztuka / Design i Antyki / Szkło / Szkło użytkowe / Świeczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dywany",
    "categoryPath": [
      "(86078) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86078) Kolekcje i sztuka / Design i Antyki / Tkaniny / Dywany",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Firany",
    "categoryPath": [
      "(86075) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86075) Kolekcje i sztuka / Design i Antyki / Tkaniny / Firany",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gobeliny",
    "categoryPath": [
      "(86077) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86077) Kolekcje i sztuka / Design i Antyki / Tkaniny / Gobeliny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kilimy",
    "categoryPath": [
      "(86079) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86079) Kolekcje i sztuka / Design i Antyki / Tkaniny / Kilimy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Naparstki",
    "categoryPath": [
      "(47971) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(47971) Kolekcje i sztuka / Design i Antyki / Tkaniny / Naparstki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obrusy",
    "categoryPath": [
      "(86080) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86080) Kolekcje i sztuka / Design i Antyki / Tkaniny / Obrusy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Poszwy i poszewki",
    "categoryPath": [
      "(320665) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(320665) Kolekcje i sztuka / Design i Antyki / Tkaniny / Poszwy i poszewki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(86074) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86074) Kolekcje i sztuka / Design i Antyki / Tkaniny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Serwety",
    "categoryPath": [
      "(86081) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86081) Kolekcje i sztuka / Design i Antyki / Tkaniny / Serwety",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zasłony",
    "categoryPath": [
      "(86076) Kolekcje i sztuka",
      "Design i Antyki",
      "Tkaniny"
    ],
    "hierarchy": "(86076) Kolekcje i sztuka / Design i Antyki / Tkaniny / Zasłony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Aparaty fotograficzne",
    "categoryPath": [
      "(86082) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(86082) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Aparaty fotograficzne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Barometry",
    "categoryPath": [
      "(47918) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47918) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Barometry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dzwonki",
    "categoryPath": [
      "(26088) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(26088) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Dzwonki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Instrukcje i katalogi",
    "categoryPath": [
      "(260771) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(260771) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Instrukcje i katalogi",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Klucze, kłódki, zamki",
    "categoryPath": [
      "(47919) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47919) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Klucze, kłódki, zamki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Maszyny do pisania",
    "categoryPath": [
      "(47911) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47911) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Maszyny do pisania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Maszyny do szycia",
    "categoryPath": [
      "(47912) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47912) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Maszyny do szycia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Maszyny liczące",
    "categoryPath": [
      "(47925) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47925) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Maszyny liczące",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Młynki",
    "categoryPath": [
      "(47913) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47913) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Młynki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Narzędzia",
    "categoryPath": [
      "(47926) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47926) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Narzędzia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Patefony i gramofony",
    "categoryPath": [
      "(321497) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(321497) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Patefony i gramofony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Podzespoły RTV",
    "categoryPath": [
      "(47927) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47927) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Podzespoły RTV",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pojazdy zabytkowe",
    "categoryPath": [
      "(321496) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(321496) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Pojazdy zabytkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(47928) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47928) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rzutniki, projektory, kamery",
    "categoryPath": [
      "(47917) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47917) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Rzutniki, projektory, kamery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Stare magnetofony",
    "categoryPath": [
      "(52329) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(52329) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Stare magnetofony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Stare radia",
    "categoryPath": [
      "(47920) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47920) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Stare radia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Stare telefony",
    "categoryPath": [
      "(47921) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47921) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Stare telefony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Stare telewizory",
    "categoryPath": [
      "(47922) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47922) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Stare telewizory",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Urządzenia optyczne",
    "categoryPath": [
      "(47923) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47923) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Urządzenia optyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Urządzenia pomiarowe",
    "categoryPath": [
      "(47924) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47924) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Urządzenia pomiarowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wagi",
    "categoryPath": [
      "(47914) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47914) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Wagi",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Włączniki światła",
    "categoryPath": [
      "(308569) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(308569) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Włączniki światła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Żelazka",
    "categoryPath": [
      "(47915) Kolekcje i sztuka",
      "Design i Antyki",
      "Zabytki techniki"
    ],
    "hierarchy": "(47915) Kolekcje i sztuka / Design i Antyki / Zabytki techniki / Żelazka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kieszonkowe",
    "categoryPath": [
      "(26073) Kolekcje i sztuka",
      "Design i Antyki",
      "Zegary, zegarki"
    ],
    "hierarchy": "(26073) Kolekcje i sztuka / Design i Antyki / Zegary, zegarki / Kieszonkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kominkowe",
    "categoryPath": [
      "(26074) Kolekcje i sztuka",
      "Design i Antyki",
      "Zegary, zegarki"
    ],
    "hierarchy": "(26074) Kolekcje i sztuka / Design i Antyki / Zegary, zegarki / Kominkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mechanizmy i części",
    "categoryPath": [
      "(26078) Kolekcje i sztuka",
      "Design i Antyki",
      "Zegary, zegarki"
    ],
    "hierarchy": "(26078) Kolekcje i sztuka / Design i Antyki / Zegary, zegarki / Mechanizmy i części",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Naręczne",
    "categoryPath": [
      "(26075) Kolekcje i sztuka",
      "Design i Antyki",
      "Zegary, zegarki"
    ],
    "hierarchy": "(26075) Kolekcje i sztuka / Design i Antyki / Zegary, zegarki / Naręczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26080) Kolekcje i sztuka",
      "Design i Antyki",
      "Zegary, zegarki"
    ],
    "hierarchy": "(26080) Kolekcje i sztuka / Design i Antyki / Zegary, zegarki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stojące",
    "categoryPath": [
      "(26076) Kolekcje i sztuka",
      "Design i Antyki",
      "Zegary, zegarki"
    ],
    "hierarchy": "(26076) Kolekcje i sztuka / Design i Antyki / Zegary, zegarki / Stojące",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wiszące",
    "categoryPath": [
      "(26077) Kolekcje i sztuka",
      "Design i Antyki",
      "Zegary, zegarki"
    ],
    "hierarchy": "(26077) Kolekcje i sztuka / Design i Antyki / Zegary, zegarki / Wiszące",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Butelki",
    "categoryPath": [
      "(93831) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93831) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Butelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Esencje, zaprawki",
    "categoryPath": [
      "(99876) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(99876) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Esencje, zaprawki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(255997) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Gorzelnictwo",
      "Destylacja"
    ],
    "hierarchy": "(255997) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Gorzelnictwo / Destylacja / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Destylatory",
    "categoryPath": [
      "(255995) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Gorzelnictwo",
      "Destylacja"
    ],
    "hierarchy": "(255995) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Gorzelnictwo / Destylacja / Destylatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Węgiel",
    "categoryPath": [
      "(255998) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Gorzelnictwo",
      "Destylacja"
    ],
    "hierarchy": "(255998) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Gorzelnictwo / Destylacja / Węgiel",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy gorzelnicze",
    "categoryPath": [
      "(255996) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Gorzelnictwo",
      "Destylacja"
    ],
    "hierarchy": "(255996) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Gorzelnictwo / Destylacja / Zestawy gorzelnicze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drożdże",
    "categoryPath": [
      "(255994) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Gorzelnictwo"
    ],
    "hierarchy": "(255994) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Gorzelnictwo / Drożdże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kieliszki",
    "categoryPath": [
      "(93832) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93832) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Kieliszki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(93833) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93833) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Korki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korkociągi",
    "categoryPath": [
      "(93834) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93834) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Korkociągi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piersiówki",
    "categoryPath": [
      "(93836) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93836) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piersiówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Butelki",
    "categoryPath": [
      "(255990) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(255990) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Butelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chmiel",
    "categoryPath": [
      "(93848) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(93848) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Chmiel",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drożdże",
    "categoryPath": [
      "(93849) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(93849) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Drożdże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kapsle",
    "categoryPath": [
      "(93851) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(93851) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Kapsle",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kapslownice",
    "categoryPath": [
      "(255992) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(255992) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Kapslownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pojemniki fermentacyjne",
    "categoryPath": [
      "(255993) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(255993) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Pojemniki fermentacyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Słód",
    "categoryPath": [
      "(255991) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(255991) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Słód",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy warzelnicze",
    "categoryPath": [
      "(93854) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Piwowarstwo"
    ],
    "hierarchy": "(93854) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Piwowarstwo / Zestawy warzelnicze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93826) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93826) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pudełka i skrzynki",
    "categoryPath": [
      "(93838) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93838) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Pudełka i skrzynki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chemia winiarska",
    "categoryPath": [
      "(255962) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo"
    ],
    "hierarchy": "(255962) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Chemia winiarska",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drożdże",
    "categoryPath": [
      "(255965) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo"
    ],
    "hierarchy": "(255965) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Drożdże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gąsiory",
    "categoryPath": [
      "(255970) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Gąsiory"
    ],
    "hierarchy": "(255970) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Gąsiory / Gąsiory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(255971) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Gąsiory"
    ],
    "hierarchy": "(255971) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Gąsiory / Korki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosze",
    "categoryPath": [
      "(255972) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Gąsiory"
    ],
    "hierarchy": "(255972) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Gąsiory / Kosze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rurki fermentacyjne",
    "categoryPath": [
      "(255973) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Gąsiory"
    ],
    "hierarchy": "(255973) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Gąsiory / Rurki fermentacyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wężyki i pompki",
    "categoryPath": [
      "(255974) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Gąsiory"
    ],
    "hierarchy": "(255974) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Gąsiory / Wężyki i pompki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Beczki",
    "categoryPath": [
      "(255978) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Przechowywanie"
    ],
    "hierarchy": "(255978) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Przechowywanie / Beczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Butelki",
    "categoryPath": [
      "(255975) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Przechowywanie"
    ],
    "hierarchy": "(255975) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Przechowywanie / Butelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korkownice",
    "categoryPath": [
      "(255980) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo",
      "Przechowywanie"
    ],
    "hierarchy": "(255980) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Przechowywanie / Korkownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wskaźniki",
    "categoryPath": [
      "(255968) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo"
    ],
    "hierarchy": "(255968) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Wskaźniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wyciskarki i prasy",
    "categoryPath": [
      "(255963) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo"
    ],
    "hierarchy": "(255963) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Wyciskarki i prasy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy winiarskie",
    "categoryPath": [
      "(255967) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe",
      "Winiarstwo"
    ],
    "hierarchy": "(255967) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Winiarstwo / Zestawy winiarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(93827) Kolekcje i sztuka",
      "Kolekcje",
      "Akcesoria alkoholowe"
    ],
    "hierarchy": "(93827) Kolekcje i sztuka / Kolekcje / Akcesoria alkoholowe / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Butelki",
    "categoryPath": [
      "(957) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(957) Kolekcje i sztuka / Kolekcje / Birofilistyka / Butelki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Etykiety",
    "categoryPath": [
      "(322259) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(322259) Kolekcje i sztuka / Kolekcje / Birofilistyka / Etykiety",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gadżety piwne",
    "categoryPath": [
      "(93533) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(93533) Kolekcje i sztuka / Kolekcje / Birofilistyka / Gadżety piwne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kapsle",
    "categoryPath": [
      "(322260) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(322260) Kolekcje i sztuka / Kolekcje / Birofilistyka / Kapsle",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kufle",
    "categoryPath": [
      "(322128) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(322128) Kolekcje i sztuka / Kolekcje / Birofilistyka / Kufle",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Otwieracze do butelek",
    "categoryPath": [
      "(3571) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(3571) Kolekcje i sztuka / Kolekcje / Birofilistyka / Otwieracze do butelek",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Podstawki",
    "categoryPath": [
      "(322261) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(322261) Kolekcje i sztuka / Kolekcje / Birofilistyka / Podstawki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pokale",
    "categoryPath": [
      "(18000) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(18000) Kolekcje i sztuka / Kolekcje / Birofilistyka / Pokale",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Porcelanki",
    "categoryPath": [
      "(12202) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(12202) Kolekcje i sztuka / Kolekcje / Birofilistyka / Porcelanki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Puszki",
    "categoryPath": [
      "(53676) Kolekcje i sztuka",
      "Kolekcje",
      "Birofilistyka"
    ],
    "hierarchy": "(53676) Kolekcje i sztuka / Kolekcje / Birofilistyka / Puszki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Afryka",
    "categoryPath": [
      "(81) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka"
    ],
    "hierarchy": "(81) Kolekcje i sztuka / Kolekcje / Filatelistyka / Afryka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Hawidy",
    "categoryPath": [
      "(261414) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Akcesoria"
    ],
    "hierarchy": "(261414) Kolekcje i sztuka / Kolekcje / Filatelistyka / Akcesoria / Hawidy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klasery",
    "categoryPath": [
      "(3648) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Akcesoria"
    ],
    "hierarchy": "(3648) Kolekcje i sztuka / Kolekcje / Filatelistyka / Akcesoria / Klasery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(261412) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Akcesoria"
    ],
    "hierarchy": "(261412) Kolekcje i sztuka / Kolekcje / Filatelistyka / Akcesoria / Lupy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3649) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Akcesoria"
    ],
    "hierarchy": "(3649) Kolekcje i sztuka / Kolekcje / Filatelistyka / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pęsety",
    "categoryPath": [
      "(261413) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Akcesoria"
    ],
    "hierarchy": "(261413) Kolekcje i sztuka / Kolekcje / Filatelistyka / Akcesoria / Pęsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ameryka Łacińska",
    "categoryPath": [
      "(3620) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Ameryka Pn i Pd."
    ],
    "hierarchy": "(3620) Kolekcje i sztuka / Kolekcje / Filatelistyka / Ameryka Pn i Pd. / Ameryka Łacińska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karaiby i Kuba",
    "categoryPath": [
      "(9587) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Ameryka Pn i Pd."
    ],
    "hierarchy": "(9587) Kolekcje i sztuka / Kolekcje / Filatelistyka / Ameryka Pn i Pd. / Karaiby i Kuba",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "USA i Kanada",
    "categoryPath": [
      "(3621) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Ameryka Pn i Pd."
    ],
    "hierarchy": "(3621) Kolekcje i sztuka / Kolekcje / Filatelistyka / Ameryka Pn i Pd. / USA i Kanada",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Australia i Oceania",
    "categoryPath": [
      "(83) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka"
    ],
    "hierarchy": "(83) Kolekcje i sztuka / Kolekcje / Filatelistyka / Australia i Oceania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Azja",
    "categoryPath": [
      "(82) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka"
    ],
    "hierarchy": "(82) Kolekcje i sztuka / Kolekcje / Filatelistyka / Azja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całostki",
    "categoryPath": [
      "(322188) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Czechy"
    ],
    "hierarchy": "(322188) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Czechy / Całostki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1918-1939",
    "categoryPath": [
      "(322184) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Czechy"
    ],
    "hierarchy": "(322184) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Czechy / Całości 1918-1939",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1939-1945",
    "categoryPath": [
      "(322185) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Czechy"
    ],
    "hierarchy": "(322185) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Czechy / Całości 1939-1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1945-1992",
    "categoryPath": [
      "(322186) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Czechy"
    ],
    "hierarchy": "(322186) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Czechy / Całości 1945-1992",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości od 1993",
    "categoryPath": [
      "(322187) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Czechy"
    ],
    "hierarchy": "(322187) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Czechy / Całości od 1993",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całostki",
    "categoryPath": [
      "(9595) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Europa"
    ],
    "hierarchy": "(9595) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Europa / Całostki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1901-1945",
    "categoryPath": [
      "(9592) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Europa"
    ],
    "hierarchy": "(9592) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Europa / Całości 1901-1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości do 1900",
    "categoryPath": [
      "(9591) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Europa"
    ],
    "hierarchy": "(9591) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Europa / Całości do 1900",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości po 1945",
    "categoryPath": [
      "(9593) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Europa"
    ],
    "hierarchy": "(9593) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Europa / Całości po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "FDC i inne",
    "categoryPath": [
      "(9594) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Europa"
    ],
    "hierarchy": "(9594) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Europa / FDC i inne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karty maximum",
    "categoryPath": [
      "(17918) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Europa"
    ],
    "hierarchy": "(17918) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Europa / Karty maximum",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całostki 1944 - 1960",
    "categoryPath": [
      "(53793) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(53793) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całostki 1944 - 1960",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całostki 1961 - 1994",
    "categoryPath": [
      "(53794) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(53794) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całostki 1961 - 1994",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całostki do 1945",
    "categoryPath": [
      "(9606) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(9606) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całostki do 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całostki od 1995",
    "categoryPath": [
      "(53795) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(53795) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całostki od 1995",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1918 - 1939",
    "categoryPath": [
      "(9603) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(9603) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całości 1918 - 1939",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1939 - 1945",
    "categoryPath": [
      "(19140) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(19140) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całości 1939 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1944 - 1960",
    "categoryPath": [
      "(53790) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(53790) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całości 1944 - 1960",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1961 - 1994",
    "categoryPath": [
      "(53791) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(53791) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całości 1961 - 1994",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości do 1918",
    "categoryPath": [
      "(9601) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(9601) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całości do 1918",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości od 1995",
    "categoryPath": [
      "(53792) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(53792) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Całości od 1995",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karty maximum",
    "categoryPath": [
      "(17919) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(17919) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Karty maximum",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Koperty FDC",
    "categoryPath": [
      "(9605) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(9605) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Koperty FDC",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(53615) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Polska"
    ],
    "hierarchy": "(53615) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Polska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Całostki",
    "categoryPath": [
      "(9600) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Świat"
    ],
    "hierarchy": "(9600) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Świat / Całostki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości 1901 - 1945",
    "categoryPath": [
      "(9597) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Świat"
    ],
    "hierarchy": "(9597) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Świat / Całości 1901 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości do 1900",
    "categoryPath": [
      "(9596) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Świat"
    ],
    "hierarchy": "(9596) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Świat / Całości do 1900",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Całości po 1945",
    "categoryPath": [
      "(9598) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Świat"
    ],
    "hierarchy": "(9598) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Świat / Całości po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "FDC i inne",
    "categoryPath": [
      "(9599) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Świat"
    ],
    "hierarchy": "(9599) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Świat / FDC i inne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karty maximum",
    "categoryPath": [
      "(17920) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Całości i całostki",
      "Świat"
    ],
    "hierarchy": "(17920) Kolekcje i sztuka / Kolekcje / Filatelistyka / Całości i całostki / Świat / Karty maximum",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy i Słowacja",
    "categoryPath": [
      "(322182) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka"
    ],
    "hierarchy": "(322182) Kolekcje i sztuka / Kolekcje / Filatelistyka / Czechy i Słowacja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1901 - 1945",
    "categoryPath": [
      "(9610) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Wschodnia"
    ],
    "hierarchy": "(9610) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Wschodnia / 1901 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1900",
    "categoryPath": [
      "(9611) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Wschodnia"
    ],
    "hierarchy": "(9611) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Wschodnia / do 1900",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1945",
    "categoryPath": [
      "(9609) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Wschodnia"
    ],
    "hierarchy": "(9609) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Wschodnia / po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1901 - 1945",
    "categoryPath": [
      "(9613) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia"
    ],
    "hierarchy": "(9613) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / 1901 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1900",
    "categoryPath": [
      "(9614) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia"
    ],
    "hierarchy": "(9614) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / do 1900",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Austria",
    "categoryPath": [
      "(53627) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(53627) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Austria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Francja",
    "categoryPath": [
      "(308725) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(308725) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Francja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Hiszpania",
    "categoryPath": [
      "(322386) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(322386) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Hiszpania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Liechtenstein",
    "categoryPath": [
      "(53629) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(53629) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Liechtenstein",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(53633) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(53633) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "San Marino",
    "categoryPath": [
      "(53630) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(53630) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / San Marino",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skandynawia",
    "categoryPath": [
      "(308737) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(308737) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Skandynawia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szwajcaria",
    "categoryPath": [
      "(53628) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(53628) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Szwajcaria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Watykan",
    "categoryPath": [
      "(53631) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(53631) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Watykan",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Włochy",
    "categoryPath": [
      "(53632) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Europa Zachodnia",
      "po 1945"
    ],
    "hierarchy": "(53632) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Europa Zachodnia / po 1945 / Włochy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1918 - 1945",
    "categoryPath": [
      "(3628) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(3628) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Niemcy / 1918 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Prusy",
    "categoryPath": [
      "(3626) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(3626) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Niemcy / Prusy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1918",
    "categoryPath": [
      "(3629) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(3629) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Niemcy / do 1918",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "NRD i Berlin Zachodni",
    "categoryPath": [
      "(53635) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Niemcy",
      "po 1945"
    ],
    "hierarchy": "(53635) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Niemcy / po 1945 / NRD i Berlin Zachodni",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "RFN",
    "categoryPath": [
      "(53636) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Niemcy",
      "po 1945"
    ],
    "hierarchy": "(53636) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Niemcy / po 1945 / RFN",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Strefy okupacyjne i Saarland",
    "categoryPath": [
      "(53634) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Niemcy",
      "po 1945"
    ],
    "hierarchy": "(53634) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Niemcy / po 1945 / Strefy okupacyjne i Saarland",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Powiązane z Rosją",
    "categoryPath": [
      "(14821) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(14821) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Rosja i ZSRR / Powiązane z Rosją",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rosja do 1923",
    "categoryPath": [
      "(14819) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(14819) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Rosja i ZSRR / Rosja do 1923",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rosja po 1992",
    "categoryPath": [
      "(14820) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(14820) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Rosja i ZSRR / Rosja po 1992",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "ZSRR 1923 - 1991",
    "categoryPath": [
      "(14818) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Europa",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(14818) Kolekcje i sztuka / Kolekcje / Filatelistyka / Europa / Rosja i ZSRR / ZSRR 1923 - 1991",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Katalogi",
    "categoryPath": [
      "(3651) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Literatura"
    ],
    "hierarchy": "(3651) Kolekcje i sztuka / Kolekcje / Filatelistyka / Literatura / Katalogi",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3652) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Literatura"
    ],
    "hierarchy": "(3652) Kolekcje i sztuka / Kolekcje / Filatelistyka / Literatura / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "1918-1919 i lokalne",
    "categoryPath": [
      "(13319) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska",
      "1918 - 1939"
    ],
    "hierarchy": "(13319) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1918 - 1939 / 1918-1919 i lokalne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1920-1929",
    "categoryPath": [
      "(13318) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska",
      "1918 - 1939"
    ],
    "hierarchy": "(13318) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1918 - 1939 / 1920-1929",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1930-1939",
    "categoryPath": [
      "(13317) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska",
      "1918 - 1939"
    ],
    "hierarchy": "(13317) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1918 - 1939 / 1930-1939",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1939 - 1945 Emigracja",
    "categoryPath": [
      "(3632) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(3632) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1939 - 1945 Emigracja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1939 - 1945 GG",
    "categoryPath": [
      "(9580) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(9580) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1939 - 1945 GG",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1939 - 1945 Pozostałe",
    "categoryPath": [
      "(10131) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(10131) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1939 - 1945 Pozostałe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1944 - 1950",
    "categoryPath": [
      "(3633) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(3633) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1944 - 1950",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1951 - 1960",
    "categoryPath": [
      "(3634) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(3634) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1951 - 1960",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1961 - 1970",
    "categoryPath": [
      "(9581) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(9581) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1961 - 1970",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1971 - 1980",
    "categoryPath": [
      "(9582) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(9582) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1971 - 1980",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1981 - 1990",
    "categoryPath": [
      "(9583) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(9583) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1981 - 1990",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1991 - 2000",
    "categoryPath": [
      "(3635) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(3635) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 1991 - 2000",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "2001 - 2010",
    "categoryPath": [
      "(17886) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(17886) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / 2001 - 2010",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Błędy, usterki, odmiany",
    "categoryPath": [
      "(19122) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(19122) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / Błędy, usterki, odmiany",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Litwa Środkowa",
    "categoryPath": [
      "(10134) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(10134) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / Litwa Środkowa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Plebiscyty",
    "categoryPath": [
      "(9584) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(9584) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / Plebiscyty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "WM Gdańsk",
    "categoryPath": [
      "(3636) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(3636) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / WM Gdańsk",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1918",
    "categoryPath": [
      "(3631) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(3631) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / do 1918",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 2011",
    "categoryPath": [
      "(254178) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Polska"
    ],
    "hierarchy": "(254178) Kolekcje i sztuka / Kolekcje / Filatelistyka / Polska / od 2011",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Fantazyjne",
    "categoryPath": [
      "(82542) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Pozostałe"
    ],
    "hierarchy": "(82542) Kolekcje i sztuka / Kolekcje / Filatelistyka / Pozostałe / Fantazyjne",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Fałszerstwa",
    "categoryPath": [
      "(14902) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Pozostałe"
    ],
    "hierarchy": "(14902) Kolekcje i sztuka / Kolekcje / Filatelistyka / Pozostałe / Fałszerstwa",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(14900) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Pozostałe"
    ],
    "hierarchy": "(14900) Kolekcje i sztuka / Kolekcje / Filatelistyka / Pozostałe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Revenue",
    "categoryPath": [
      "(14901) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Pozostałe"
    ],
    "hierarchy": "(14901) Kolekcje i sztuka / Kolekcje / Filatelistyka / Pozostałe / Revenue",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Architektura",
    "categoryPath": [
      "(304637) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(304637) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Architektura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Boże Narodzenie",
    "categoryPath": [
      "(322088) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(322088) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Boże Narodzenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gady i Płazy",
    "categoryPath": [
      "(14897) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Fauna"
    ],
    "hierarchy": "(14897) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Fauna / Gady i Płazy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Owady",
    "categoryPath": [
      "(14896) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Fauna"
    ],
    "hierarchy": "(14896) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Fauna / Owady",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(14892) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Fauna"
    ],
    "hierarchy": "(14892) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Fauna / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ptaki",
    "categoryPath": [
      "(14894) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Fauna"
    ],
    "hierarchy": "(14894) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Fauna / Ptaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ryby",
    "categoryPath": [
      "(14895) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Fauna"
    ],
    "hierarchy": "(14895) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Fauna / Ryby",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ssaki",
    "categoryPath": [
      "(14893) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Fauna"
    ],
    "hierarchy": "(14893) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Fauna / Ssaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zwierzęta wymarłe",
    "categoryPath": [
      "(14898) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Fauna"
    ],
    "hierarchy": "(14898) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Fauna / Zwierzęta wymarłe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Flora",
    "categoryPath": [
      "(3640) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(3640) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Flora",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Harcerstwo i Skauting",
    "categoryPath": [
      "(10133) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(10133) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Harcerstwo i Skauting",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolejnictwo",
    "categoryPath": [
      "(9585) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(9585) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Kolejnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kosmos",
    "categoryPath": [
      "(53612) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(53612) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Kosmos",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lotnictwo",
    "categoryPath": [
      "(3642) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(3642) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Lotnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malarstwo",
    "categoryPath": [
      "(3641) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(3641) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Malarstwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Marynistyka",
    "categoryPath": [
      "(9586) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(9586) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Marynistyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Medycyna i Czerwony Krzyż",
    "categoryPath": [
      "(304673) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(304673) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Medycyna i Czerwony Krzyż",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Motoryzacja",
    "categoryPath": [
      "(14899) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(14899) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Motoryzacja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Muzyka",
    "categoryPath": [
      "(304649) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(304649) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Muzyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nauka i technologia",
    "categoryPath": [
      "(304697) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(304697) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Nauka i technologia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polonica",
    "categoryPath": [
      "(3645) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(3645) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Polonica",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3647) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(3647) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Jan Paweł II",
    "categoryPath": [
      "(319041) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Religia i Papież"
    ],
    "hierarchy": "(319041) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Religia i Papież / Jan Paweł II",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obiekty i miejsca",
    "categoryPath": [
      "(319040) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Religia i Papież"
    ],
    "hierarchy": "(319040) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Religia i Papież / Obiekty i miejsca",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polska",
    "categoryPath": [
      "(53625) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Religia i Papież"
    ],
    "hierarchy": "(53625) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Religia i Papież / Polska",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(319042) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne",
      "Religia i Papież"
    ],
    "hierarchy": "(319042) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Religia i Papież / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Solidarność",
    "categoryPath": [
      "(3646) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(3646) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Solidarność",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sport",
    "categoryPath": [
      "(3643) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(3643) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Sport",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sztuka",
    "categoryPath": [
      "(304661) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(304661) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Sztuka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sławni ludzie",
    "categoryPath": [
      "(304685) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(304685) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Sławni ludzie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wojsko i wojna",
    "categoryPath": [
      "(304625) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Tematyczne"
    ],
    "hierarchy": "(304625) Kolekcje i sztuka / Kolekcje / Filatelistyka / Tematyczne / Wojsko i wojna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zbiory i kolekcje",
    "categoryPath": [
      "(14903) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Zestawy i zbiory"
    ],
    "hierarchy": "(14903) Kolekcje i sztuka / Kolekcje / Filatelistyka / Zestawy i zbiory / Zbiory i kolekcje",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy i serie",
    "categoryPath": [
      "(14904) Kolekcje i sztuka",
      "Kolekcje",
      "Filatelistyka",
      "Zestawy i zbiory"
    ],
    "hierarchy": "(14904) Kolekcje i sztuka / Kolekcje / Filatelistyka / Zestawy i zbiory / Zestawy i serie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Flagi",
    "categoryPath": [
      "(99864) Kolekcje i sztuka",
      "Kolekcje",
      "Flagi i symbole narodowe"
    ],
    "hierarchy": "(99864) Kolekcje i sztuka / Kolekcje / Flagi i symbole narodowe / Flagi",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Herby i godła",
    "categoryPath": [
      "(99865) Kolekcje i sztuka",
      "Kolekcje",
      "Flagi i symbole narodowe"
    ],
    "hierarchy": "(99865) Kolekcje i sztuka / Kolekcje / Flagi i symbole narodowe / Herby i godła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kotyliony i przypinki",
    "categoryPath": [
      "(316333) Kolekcje i sztuka",
      "Kolekcje",
      "Flagi i symbole narodowe"
    ],
    "hierarchy": "(316333) Kolekcje i sztuka / Kolekcje / Flagi i symbole narodowe / Kotyliony i przypinki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Opaski",
    "categoryPath": [
      "(316330) Kolekcje i sztuka",
      "Kolekcje",
      "Flagi i symbole narodowe"
    ],
    "hierarchy": "(316330) Kolekcje i sztuka / Kolekcje / Flagi i symbole narodowe / Opaski",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karty telefoniczne",
    "categoryPath": [
      "(322149) Kolekcje i sztuka",
      "Kolekcje"
    ],
    "hierarchy": "(322149) Kolekcje i sztuka / Kolekcje / Karty telefoniczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Elementy i akcesoria",
    "categoryPath": [
      "(53678) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia"
    ],
    "hierarchy": "(53678) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Elementy i akcesoria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kopie",
    "categoryPath": [
      "(50447) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia"
    ],
    "hierarchy": "(50447) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Kopie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(53677) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia"
    ],
    "hierarchy": "(53677) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Literatura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Austria",
    "categoryPath": [
      "(93534) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(93534) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Austria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322179) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(322179) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Francja",
    "categoryPath": [
      "(50448) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(50448) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Francja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(50449) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(50449) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1945",
    "categoryPath": [
      "(50453) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale",
      "Polska"
    ],
    "hierarchy": "(50453) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Polska / do 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1945",
    "categoryPath": [
      "(50454) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale",
      "Polska"
    ],
    "hierarchy": "(50454) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Polska / po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50452) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(50452) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja i ZSRR",
    "categoryPath": [
      "(50451) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(50451) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Rosja i ZSRR",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szwajcaria",
    "categoryPath": [
      "(93535) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(93535) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Szwajcaria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wielka Brytania",
    "categoryPath": [
      "(93536) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(93536) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Wielka Brytania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Włochy",
    "categoryPath": [
      "(93537) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Medale"
    ],
    "hierarchy": "(93537) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Medale / Włochy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322180) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaczenia"
    ],
    "hierarchy": "(322180) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaczenia / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(93539) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaczenia"
    ],
    "hierarchy": "(93539) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaczenia / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polska",
    "categoryPath": [
      "(50455) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaczenia"
    ],
    "hierarchy": "(50455) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaczenia / Polska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50456) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaczenia"
    ],
    "hierarchy": "(50456) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaczenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja i ZSRR",
    "categoryPath": [
      "(93538) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaczenia"
    ],
    "hierarchy": "(93538) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaczenia / Rosja i ZSRR",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322181) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaki"
    ],
    "hierarchy": "(322181) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaki / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(50457) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaki"
    ],
    "hierarchy": "(50457) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaki / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1944 - 1989",
    "categoryPath": [
      "(93540) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(93540) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaki / Polska / 1944 - 1989",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1939",
    "categoryPath": [
      "(50461) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(50461) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaki / Polska / do 1939",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 1990",
    "categoryPath": [
      "(93541) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(93541) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaki / Polska / od 1990",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50460) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaki"
    ],
    "hierarchy": "(50460) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja i ZSRR",
    "categoryPath": [
      "(50459) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia",
      "Odznaki"
    ],
    "hierarchy": "(50459) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Odznaki / Rosja i ZSRR",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Plakiety",
    "categoryPath": [
      "(50446) Kolekcje i sztuka",
      "Kolekcje",
      "Medale i odznaczenia"
    ],
    "hierarchy": "(50446) Kolekcje i sztuka / Kolekcje / Medale i odznaczenia / Plakiety",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bagnety i Noże",
    "categoryPath": [
      "(126047) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń",
      "Broń biała"
    ],
    "hierarchy": "(126047) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Broń biała / Bagnety i Noże",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kordziki i Tasaki",
    "categoryPath": [
      "(126048) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń",
      "Broń biała"
    ],
    "hierarchy": "(126048) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Broń biała / Kordziki i Tasaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(126050) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń",
      "Broń biała"
    ],
    "hierarchy": "(126050) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Broń biała / Literatura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Miecze i Katany",
    "categoryPath": [
      "(126052) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń",
      "Broń biała"
    ],
    "hierarchy": "(126052) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Broń biała / Miecze i Katany",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szable",
    "categoryPath": [
      "(126049) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń",
      "Broń biała"
    ],
    "hierarchy": "(126049) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Broń biała / Szable",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(16532) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń",
      "Czarnoprochowce"
    ],
    "hierarchy": "(16532) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Czarnoprochowce / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Broń",
    "categoryPath": [
      "(16533) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń",
      "Czarnoprochowce"
    ],
    "hierarchy": "(16533) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Czarnoprochowce / Broń",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Części amunicji",
    "categoryPath": [
      "(12041) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń"
    ],
    "hierarchy": "(12041) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Części amunicji",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Części broni",
    "categoryPath": [
      "(9200) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń"
    ],
    "hierarchy": "(9200) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Części broni",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Repliki broni białej",
    "categoryPath": [
      "(126053) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń"
    ],
    "hierarchy": "(126053) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Repliki broni białej",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Repliki broni palnej",
    "categoryPath": [
      "(126054) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Broń"
    ],
    "hierarchy": "(126054) Kolekcje i sztuka / Kolekcje / Militaria / Broń / Repliki broni palnej",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dokumenty",
    "categoryPath": [
      "(940) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria"
    ],
    "hierarchy": "(940) Kolekcje i sztuka / Kolekcje / Militaria / Dokumenty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Guziki wojskowe",
    "categoryPath": [
      "(322113) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria"
    ],
    "hierarchy": "(322113) Kolekcje i sztuka / Kolekcje / Militaria / Guziki wojskowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "wydanie do 1945",
    "categoryPath": [
      "(3730) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Czasopisma i gazety"
    ],
    "hierarchy": "(3730) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Czasopisma i gazety / wydanie do 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "wydanie po 1945",
    "categoryPath": [
      "(3731) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Czasopisma i gazety"
    ],
    "hierarchy": "(3731) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Czasopisma i gazety / wydanie po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Instrukcje i regulaminy",
    "categoryPath": [
      "(55745) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura"
    ],
    "hierarchy": "(55745) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Instrukcje i regulaminy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "wydanie do 1945",
    "categoryPath": [
      "(3726) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki"
    ],
    "hierarchy": "(3726) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie do 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Artyleria",
    "categoryPath": [
      "(12076) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12076) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Artyleria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Broń palna",
    "categoryPath": [
      "(12073) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12073) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Broń palna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Broń pancerna",
    "categoryPath": [
      "(12074) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12074) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Broń pancerna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Fortyfikacje",
    "categoryPath": [
      "(12080) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12080) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Fortyfikacje",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Jednostki specjalne",
    "categoryPath": [
      "(27865) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(27865) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Jednostki specjalne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kampanie i bitwy",
    "categoryPath": [
      "(55744) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(55744) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Kampanie i bitwy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kawaleria",
    "categoryPath": [
      "(12077) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12077) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Kawaleria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lotnictwo",
    "categoryPath": [
      "(12078) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12078) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Lotnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Marynarka Wojenna",
    "categoryPath": [
      "(12075) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12075) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Marynarka Wojenna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Odznaki i odznaczenia",
    "categoryPath": [
      "(12081) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12081) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Odznaki i odznaczenia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Piechota",
    "categoryPath": [
      "(12079) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12079) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Piechota",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(12071) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12071) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ruch oporu",
    "categoryPath": [
      "(27863) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(27863) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Ruch oporu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie",
    "categoryPath": [
      "(12082) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(12082) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Umundurowanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wojska powietrzno - desantowe",
    "categoryPath": [
      "(27864) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(27864) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Wojska powietrzno - desantowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wybitne postaci",
    "categoryPath": [
      "(55743) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura",
      "Książki",
      "wydanie po 1945"
    ],
    "hierarchy": "(55743) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Książki / wydanie po 1945 / Wybitne postaci",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Seria TBiU",
    "categoryPath": [
      "(12070) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Literatura"
    ],
    "hierarchy": "(12070) Kolekcje i sztuka / Kolekcje / Militaria / Literatura / Seria TBiU",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322155) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Naszywki"
    ],
    "hierarchy": "(322155) Kolekcje i sztuka / Kolekcje / Militaria / Naszywki / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(14604) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Naszywki"
    ],
    "hierarchy": "(14604) Kolekcje i sztuka / Kolekcje / Militaria / Naszywki / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polska",
    "categoryPath": [
      "(3742) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Naszywki"
    ],
    "hierarchy": "(3742) Kolekcje i sztuka / Kolekcje / Militaria / Naszywki / Polska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3743) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Naszywki"
    ],
    "hierarchy": "(3743) Kolekcje i sztuka / Kolekcje / Militaria / Naszywki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja i ZSRR",
    "categoryPath": [
      "(12048) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Naszywki"
    ],
    "hierarchy": "(12048) Kolekcje i sztuka / Kolekcje / Militaria / Naszywki / Rosja i ZSRR",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "USA",
    "categoryPath": [
      "(12047) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Naszywki"
    ],
    "hierarchy": "(12047) Kolekcje i sztuka / Kolekcje / Militaria / Naszywki / USA",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Austro- Węgry",
    "categoryPath": [
      "(12054) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia"
    ],
    "hierarchy": "(12054) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Austro- Węgry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322153) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia"
    ],
    "hierarchy": "(322153) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Europa",
    "categoryPath": [
      "(12055) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia"
    ],
    "hierarchy": "(12055) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Europa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Francja",
    "categoryPath": [
      "(14605) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia"
    ],
    "hierarchy": "(14605) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Francja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kopie",
    "categoryPath": [
      "(3739) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia"
    ],
    "hierarchy": "(3739) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Kopie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1918 - 1945",
    "categoryPath": [
      "(12052) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Niemcy"
    ],
    "hierarchy": "(12052) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Niemcy / 1918 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1918",
    "categoryPath": [
      "(12051) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Niemcy"
    ],
    "hierarchy": "(12051) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Niemcy / do 1918",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1945",
    "categoryPath": [
      "(12053) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Niemcy"
    ],
    "hierarchy": "(12053) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Niemcy / po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "LWP 1943 - 1989",
    "categoryPath": [
      "(55737) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Polska"
    ],
    "hierarchy": "(55737) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Polska / LWP 1943 - 1989",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "PSZ na Zachodzie",
    "categoryPath": [
      "(16535) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Polska"
    ],
    "hierarchy": "(16535) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Polska / PSZ na Zachodzie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ruch oporu",
    "categoryPath": [
      "(55738) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Polska"
    ],
    "hierarchy": "(55738) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Polska / Ruch oporu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1939",
    "categoryPath": [
      "(3735) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Polska"
    ],
    "hierarchy": "(3735) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Polska / do 1939",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1990",
    "categoryPath": [
      "(12050) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Polska"
    ],
    "hierarchy": "(12050) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Polska / po 1990",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Reszta świata",
    "categoryPath": [
      "(12056) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia"
    ],
    "hierarchy": "(12056) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Reszta świata",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rosja carska",
    "categoryPath": [
      "(16536) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(16536) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Rosja i ZSRR / Rosja carska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "ZSRR i Rosja po 1991",
    "categoryPath": [
      "(16537) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(16537) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / Rosja i ZSRR / ZSRR i Rosja po 1991",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "USA",
    "categoryPath": [
      "(14595) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaczenia"
    ],
    "hierarchy": "(14595) Kolekcje i sztuka / Kolekcje / Militaria / Odznaczenia / USA",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Austro-Węgry",
    "categoryPath": [
      "(12061) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(12061) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Austro-Węgry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Biżuteria patriotyczna",
    "categoryPath": [
      "(55742) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(55742) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Biżuteria patriotyczna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322154) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(322154) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Europa",
    "categoryPath": [
      "(12064) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(12064) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Europa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Francja",
    "categoryPath": [
      "(12060) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(12060) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Francja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(12063) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Kopie"
    ],
    "hierarchy": "(12063) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Kopie / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Polska",
    "categoryPath": [
      "(12062) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Kopie"
    ],
    "hierarchy": "(12062) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Kopie / Polska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1918 - 1945",
    "categoryPath": [
      "(3711) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Niemcy"
    ],
    "hierarchy": "(3711) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Niemcy / 1918 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1918",
    "categoryPath": [
      "(12057) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Niemcy"
    ],
    "hierarchy": "(12057) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Niemcy / do 1918",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1945",
    "categoryPath": [
      "(3712) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Niemcy"
    ],
    "hierarchy": "(3712) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Niemcy / po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "obce",
    "categoryPath": [
      "(53680) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Orły"
    ],
    "hierarchy": "(53680) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Orły / obce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "polskie",
    "categoryPath": [
      "(53679) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Orły"
    ],
    "hierarchy": "(53679) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Orły / polskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "LWP 1943 - 1989",
    "categoryPath": [
      "(55740) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(55740) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Polska / LWP 1943 - 1989",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "PSZ na Zachodzie",
    "categoryPath": [
      "(12058) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(12058) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Polska / PSZ na Zachodzie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ruch oporu",
    "categoryPath": [
      "(55739) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(55739) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Polska / Ruch oporu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1939",
    "categoryPath": [
      "(3707) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(3707) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Polska / do 1939",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1990",
    "categoryPath": [
      "(3709) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Polska"
    ],
    "hierarchy": "(3709) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Polska / po 1990",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Reszta świata",
    "categoryPath": [
      "(12065) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(12065) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Reszta świata",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rosja carska",
    "categoryPath": [
      "(16538) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(16538) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Rosja i ZSRR / Rosja carska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "ZSRR i Rosja po 1991",
    "categoryPath": [
      "(16539) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(16539) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Rosja i ZSRR / ZSRR i Rosja po 1991",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "USA",
    "categoryPath": [
      "(12059) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(12059) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / USA",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wielka Brytania",
    "categoryPath": [
      "(55741) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Odznaki"
    ],
    "hierarchy": "(55741) Kolekcje i sztuka / Kolekcje / Militaria / Odznaki / Wielka Brytania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bractwa Kurkowe",
    "categoryPath": [
      "(16542) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Paramilitarne"
    ],
    "hierarchy": "(16542) Kolekcje i sztuka / Kolekcje / Militaria / Paramilitarne / Bractwa Kurkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Harcerstwo i Sokół",
    "categoryPath": [
      "(3718) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Paramilitarne"
    ],
    "hierarchy": "(3718) Kolekcje i sztuka / Kolekcje / Militaria / Paramilitarne / Harcerstwo i Sokół",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Policja",
    "categoryPath": [
      "(322517) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Paramilitarne"
    ],
    "hierarchy": "(322517) Kolekcje i sztuka / Kolekcje / Militaria / Paramilitarne / Policja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Straż miejska",
    "categoryPath": [
      "(16540) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Paramilitarne"
    ],
    "hierarchy": "(16540) Kolekcje i sztuka / Kolekcje / Militaria / Paramilitarne / Straż miejska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Straż pożarna",
    "categoryPath": [
      "(3720) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Paramilitarne"
    ],
    "hierarchy": "(3720) Kolekcje i sztuka / Kolekcje / Militaria / Paramilitarne / Straż pożarna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Służby graniczne",
    "categoryPath": [
      "(16541) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Paramilitarne"
    ],
    "hierarchy": "(16541) Kolekcje i sztuka / Kolekcje / Militaria / Paramilitarne / Służby graniczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(694) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria"
    ],
    "hierarchy": "(694) Kolekcje i sztuka / Kolekcje / Militaria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(93552) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Pozostałe"
    ],
    "hierarchy": "(93552) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Pozostałe / Odzież",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93551) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Pozostałe"
    ],
    "hierarchy": "(93551) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Pozostałe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Uzbrojenie",
    "categoryPath": [
      "(93553) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Pozostałe"
    ],
    "hierarchy": "(93553) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Pozostałe / Uzbrojenie",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Broń",
    "categoryPath": [
      "(93543) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Rycerze"
    ],
    "hierarchy": "(93543) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Rycerze / Broń",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93544) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Rycerze"
    ],
    "hierarchy": "(93544) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Rycerze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zbroje i elementy",
    "categoryPath": [
      "(93542) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Rycerze"
    ],
    "hierarchy": "(93542) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Rycerze / Zbroje i elementy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(93545) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Słowianie"
    ],
    "hierarchy": "(93545) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Słowianie / Odzież",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93547) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Słowianie"
    ],
    "hierarchy": "(93547) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Słowianie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Uzbrojenie",
    "categoryPath": [
      "(93546) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Słowianie"
    ],
    "hierarchy": "(93546) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Słowianie / Uzbrojenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(93550) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Wikingowie"
    ],
    "hierarchy": "(93550) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Wikingowie / Odzież",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93548) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Wikingowie"
    ],
    "hierarchy": "(93548) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Wikingowie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Uzbrojenie",
    "categoryPath": [
      "(93549) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Rycerstwo",
      "Wikingowie"
    ],
    "hierarchy": "(93549) Kolekcje i sztuka / Kolekcje / Militaria / Rycerstwo / Wikingowie / Uzbrojenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Austro-Węgry",
    "categoryPath": [
      "(12104) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie"
    ],
    "hierarchy": "(12104) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Austro-Węgry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322189) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie"
    ],
    "hierarchy": "(322189) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1945",
    "categoryPath": [
      "(16554) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Francja"
    ],
    "hierarchy": "(16554) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Francja / do 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1945",
    "categoryPath": [
      "(16555) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Francja"
    ],
    "hierarchy": "(16555) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Francja / po 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(16550) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Nakrycia głowy"
    ],
    "hierarchy": "(16550) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Nakrycia głowy / Czapki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Hełmy",
    "categoryPath": [
      "(16551) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Nakrycia głowy"
    ],
    "hierarchy": "(16551) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Nakrycia głowy / Hełmy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie i insygnia",
    "categoryPath": [
      "(12172) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Niemcy",
      "1918 - 1945"
    ],
    "hierarchy": "(12172) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Niemcy / 1918 - 1945 / Umundurowanie i insygnia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(12173) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Niemcy",
      "1918 - 1945"
    ],
    "hierarchy": "(12173) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Niemcy / 1918 - 1945 / Wyposażenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1918",
    "categoryPath": [
      "(12087) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Niemcy"
    ],
    "hierarchy": "(12087) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Niemcy / do 1918",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie i insygnia",
    "categoryPath": [
      "(12174) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Niemcy",
      "po 1945"
    ],
    "hierarchy": "(12174) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Niemcy / po 1945 / Umundurowanie i insygnia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(12175) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Niemcy",
      "po 1945"
    ],
    "hierarchy": "(12175) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Niemcy / po 1945 / Wyposażenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obozy jenieckie",
    "categoryPath": [
      "(27862) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie"
    ],
    "hierarchy": "(27862) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Obozy jenieckie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie",
    "categoryPath": [
      "(93560) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "1945 - 1960"
    ],
    "hierarchy": "(93560) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / 1945 - 1960 / Umundurowanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(93561) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "1945 - 1960"
    ],
    "hierarchy": "(93561) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / 1945 - 1960 / Wyposażenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie",
    "categoryPath": [
      "(93556) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "1961 - 1989"
    ],
    "hierarchy": "(93556) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / 1961 - 1989 / Umundurowanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(93557) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "1961 - 1989"
    ],
    "hierarchy": "(93557) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / 1961 - 1989 / Wyposażenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "PSZ na Zachodzie i Ruch Oporu",
    "categoryPath": [
      "(12093) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska"
    ],
    "hierarchy": "(12093) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / PSZ na Zachodzie i Ruch Oporu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "WP na Wschodzie 1943 - 1945",
    "categoryPath": [
      "(16558) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska"
    ],
    "hierarchy": "(16558) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / WP na Wschodzie 1943 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie",
    "categoryPath": [
      "(78674) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "do 1939"
    ],
    "hierarchy": "(78674) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / do 1939 / Umundurowanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(78673) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "do 1939"
    ],
    "hierarchy": "(78673) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / do 1939 / Wyposażenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie",
    "categoryPath": [
      "(12180) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "po 1990"
    ],
    "hierarchy": "(12180) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / po 1990 / Umundurowanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(12181) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Polska",
      "po 1990"
    ],
    "hierarchy": "(12181) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Polska / po 1990 / Wyposażenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1945",
    "categoryPath": [
      "(12106) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Pozostałe"
    ],
    "hierarchy": "(12106) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Pozostałe / do 1945",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Umundurowanie",
    "categoryPath": [
      "(12176) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Pozostałe",
      "po 1945"
    ],
    "hierarchy": "(12176) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Pozostałe / po 1945 / Umundurowanie",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(12177) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Pozostałe",
      "po 1945"
    ],
    "hierarchy": "(12177) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Pozostałe / po 1945 / Wyposażenie",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja carska",
    "categoryPath": [
      "(13919) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(13919) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Rosja i ZSRR / Rosja carska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "ZSRR i Rosja od 1991",
    "categoryPath": [
      "(13920) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Rosja i ZSRR"
    ],
    "hierarchy": "(13920) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Rosja i ZSRR / ZSRR i Rosja od 1991",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1975 roku",
    "categoryPath": [
      "(19501) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "USA",
      "Umundurowanie"
    ],
    "hierarchy": "(19501) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / USA / Umundurowanie / do 1975 roku",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 1976 roku",
    "categoryPath": [
      "(19502) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "USA",
      "Umundurowanie"
    ],
    "hierarchy": "(19502) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / USA / Umundurowanie / od 1976 roku",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1975 roku",
    "categoryPath": [
      "(19503) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "USA",
      "Wyposażenie"
    ],
    "hierarchy": "(19503) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / USA / Wyposażenie / do 1975 roku",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 1976 roku",
    "categoryPath": [
      "(19504) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "USA",
      "Wyposażenie"
    ],
    "hierarchy": "(19504) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / USA / Wyposażenie / od 1976 roku",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1960",
    "categoryPath": [
      "(16556) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Wielka Brytania"
    ],
    "hierarchy": "(16556) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Wielka Brytania / do 1960",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Umundurowanie",
    "categoryPath": [
      "(93558) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Wielka Brytania",
      "po 1960"
    ],
    "hierarchy": "(93558) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Wielka Brytania / po 1960 / Umundurowanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(93559) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Umundurowanie i Wyposażenie",
      "Wielka Brytania",
      "po 1960"
    ],
    "hierarchy": "(93559) Kolekcje i sztuka / Kolekcje / Militaria / Umundurowanie i Wyposażenie / Wielka Brytania / po 1960 / Wyposażenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Austro-Węgry",
    "categoryPath": [
      "(3772) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia"
    ],
    "hierarchy": "(3772) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Austro-Węgry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1918 - 1945",
    "categoryPath": [
      "(3771) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia",
      "Niemcy"
    ],
    "hierarchy": "(3771) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Niemcy / 1918 - 1945",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1918",
    "categoryPath": [
      "(3770) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia",
      "Niemcy"
    ],
    "hierarchy": "(3770) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Niemcy / do 1918",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "LWP",
    "categoryPath": [
      "(14594) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia",
      "Polska"
    ],
    "hierarchy": "(14594) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Polska / LWP",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obozy jenieckie",
    "categoryPath": [
      "(14596) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia",
      "Polska"
    ],
    "hierarchy": "(14596) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Polska / Obozy jenieckie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "PSZ na Zachodzie i Ruch Oporu",
    "categoryPath": [
      "(14593) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia",
      "Polska"
    ],
    "hierarchy": "(14593) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Polska / PSZ na Zachodzie i Ruch Oporu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "WP do 1939",
    "categoryPath": [
      "(14592) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia",
      "Polska"
    ],
    "hierarchy": "(14592) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Polska / WP do 1939",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3774) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia"
    ],
    "hierarchy": "(3774) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja i ZSRR",
    "categoryPath": [
      "(3773) Kolekcje i sztuka",
      "Kolekcje",
      "Militaria",
      "Zdjęcia"
    ],
    "hierarchy": "(3773) Kolekcje i sztuka / Kolekcje / Militaria / Zdjęcia / Rosja i ZSRR",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Druk 3D",
    "categoryPath": [
      "(316522) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo"
    ],
    "hierarchy": "(316522) Kolekcje i sztuka / Kolekcje / Modelarstwo / Druk 3D",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(3591) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Figurki"
    ],
    "hierarchy": "(3591) Kolekcje i sztuka / Kolekcje / Modelarstwo / Figurki / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3592) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Figurki"
    ],
    "hierarchy": "(3592) Kolekcje i sztuka / Kolekcje / Modelarstwo / Figurki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "skala 1:16",
    "categoryPath": [
      "(3593) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Figurki"
    ],
    "hierarchy": "(3593) Kolekcje i sztuka / Kolekcje / Modelarstwo / Figurki / skala 1:16",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:32 i 1:35",
    "categoryPath": [
      "(3594) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Figurki"
    ],
    "hierarchy": "(3594) Kolekcje i sztuka / Kolekcje / Modelarstwo / Figurki / skala 1:32 i 1:35",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:48",
    "categoryPath": [
      "(3595) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Figurki"
    ],
    "hierarchy": "(3595) Kolekcje i sztuka / Kolekcje / Modelarstwo / Figurki / skala 1:48",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:72 i 1:76",
    "categoryPath": [
      "(3596) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Figurki"
    ],
    "hierarchy": "(3596) Kolekcje i sztuka / Kolekcje / Modelarstwo / Figurki / skala 1:72 i 1:76",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Elementy elektryczne i elektrotechniczne",
    "categoryPath": [
      "(26927) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Akcesoria"
    ],
    "hierarchy": "(26927) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Akcesoria / Elementy elektryczne i elektrotechniczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "HO - 1:87",
    "categoryPath": [
      "(26924) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Akcesoria"
    ],
    "hierarchy": "(26924) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Akcesoria / HO - 1:87",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "N - 1:160",
    "categoryPath": [
      "(26925) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Akcesoria"
    ],
    "hierarchy": "(26925) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Akcesoria / N - 1:160",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "TT - 1:120",
    "categoryPath": [
      "(26926) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Akcesoria"
    ],
    "hierarchy": "(26926) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Akcesoria / TT - 1:120",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "H0 - 1:87",
    "categoryPath": [
      "(26929) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Budownictwo"
    ],
    "hierarchy": "(26929) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Budownictwo / H0 - 1:87",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "N - 1:160",
    "categoryPath": [
      "(26930) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Budownictwo"
    ],
    "hierarchy": "(26930) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Budownictwo / N - 1:160",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26932) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Budownictwo"
    ],
    "hierarchy": "(26932) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Budownictwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "TT - 1:120",
    "categoryPath": [
      "(26931) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "Budownictwo"
    ],
    "hierarchy": "(26931) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Budownictwo / TT - 1:120",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tabor kolejowy",
    "categoryPath": [
      "(26917) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "H0 - 1:87"
    ],
    "hierarchy": "(26917) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / H0 - 1:87 / Tabor kolejowy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Torowiska",
    "categoryPath": [
      "(26918) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "H0 - 1:87"
    ],
    "hierarchy": "(26918) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / H0 - 1:87 / Torowiska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(46000) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "H0 - 1:87"
    ],
    "hierarchy": "(46000) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / H0 - 1:87 / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Inne skale",
    "categoryPath": [
      "(26923) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety"
    ],
    "hierarchy": "(26923) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / Inne skale",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tabor kolejowy",
    "categoryPath": [
      "(26919) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "N - 1:160"
    ],
    "hierarchy": "(26919) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / N - 1:160 / Tabor kolejowy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Torowiska",
    "categoryPath": [
      "(26920) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "N - 1:160"
    ],
    "hierarchy": "(26920) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / N - 1:160 / Torowiska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(46001) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "N - 1:160"
    ],
    "hierarchy": "(46001) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / N - 1:160 / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tabor kolejowy",
    "categoryPath": [
      "(26921) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "TT - 1:120"
    ],
    "hierarchy": "(26921) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / TT - 1:120 / Tabor kolejowy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Torowiska",
    "categoryPath": [
      "(26922) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "TT - 1:120"
    ],
    "hierarchy": "(26922) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / TT - 1:120 / Torowiska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(46002) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Kolej, dioramy, makiety",
      "TT - 1:120"
    ],
    "hierarchy": "(46002) Kolekcje i sztuka / Kolekcje / Modelarstwo / Kolej, dioramy, makiety / TT - 1:120 / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Koleje",
    "categoryPath": [
      "(26933) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Literatura"
    ],
    "hierarchy": "(26933) Kolekcje i sztuka / Kolekcje / Modelarstwo / Literatura / Koleje",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Literatura ogólna",
    "categoryPath": [
      "(3614) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Literatura"
    ],
    "hierarchy": "(3614) Kolekcje i sztuka / Kolekcje / Modelarstwo / Literatura / Literatura ogólna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lotnictwo",
    "categoryPath": [
      "(3615) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Literatura"
    ],
    "hierarchy": "(3615) Kolekcje i sztuka / Kolekcje / Modelarstwo / Literatura / Lotnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Motoryzacja",
    "categoryPath": [
      "(3618) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Literatura"
    ],
    "hierarchy": "(3618) Kolekcje i sztuka / Kolekcje / Modelarstwo / Literatura / Motoryzacja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pojazdy wojskowe",
    "categoryPath": [
      "(3617) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Literatura"
    ],
    "hierarchy": "(3617) Kolekcje i sztuka / Kolekcje / Modelarstwo / Literatura / Pojazdy wojskowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkutnictwo",
    "categoryPath": [
      "(3616) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Literatura"
    ],
    "hierarchy": "(3616) Kolekcje i sztuka / Kolekcje / Modelarstwo / Literatura / Szkutnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(319996) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(319996) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne skale",
    "categoryPath": [
      "(51148) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(51148) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Inne skale",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:100",
    "categoryPath": [
      "(260503) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(260503) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:100",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:144",
    "categoryPath": [
      "(99868) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(99868) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:144",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:200",
    "categoryPath": [
      "(99867) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(99867) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:200",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:32",
    "categoryPath": [
      "(51146) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(51146) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:32",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:400",
    "categoryPath": [
      "(260504) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(260504) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:400",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:48",
    "categoryPath": [
      "(26943) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(26943) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:48",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:500",
    "categoryPath": [
      "(260505) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(260505) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:500",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:72",
    "categoryPath": [
      "(26945) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Lotnictwo"
    ],
    "hierarchy": "(26945) Kolekcje i sztuka / Kolekcje / Modelarstwo / Lotnictwo / Skala 1:72",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Materiały modelarskie",
    "categoryPath": [
      "(26958) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo"
    ],
    "hierarchy": "(26958) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Barwniki i pigmenty do żywic",
    "categoryPath": [
      "(261743) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261743) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Barwniki i pigmenty do żywic",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(261741) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261741) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Kleje",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lakiery bezbarwne",
    "categoryPath": [
      "(261747) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261747) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Lakiery bezbarwne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Podkłady",
    "categoryPath": [
      "(261746) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261746) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Podkłady",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Płyny do kalkomanii",
    "categoryPath": [
      "(261748) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261748) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Płyny do kalkomanii",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rozcieńczalniki",
    "categoryPath": [
      "(261744) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261744) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Rozcieńczalniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szpachle i masy modelarskie",
    "categoryPath": [
      "(261745) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261745) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Szpachle i masy modelarskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Żywice",
    "categoryPath": [
      "(261742) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Chemia modelarska"
    ],
    "hierarchy": "(261742) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Chemia modelarska / Żywice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Balsa",
    "categoryPath": [
      "(261738) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Elementy makiet"
    ],
    "hierarchy": "(261738) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Elementy makiet / Balsa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Blachy, pręty",
    "categoryPath": [
      "(261739) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Elementy makiet"
    ],
    "hierarchy": "(261739) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Elementy makiet / Blachy, pręty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kamienie",
    "categoryPath": [
      "(261737) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Elementy makiet"
    ],
    "hierarchy": "(261737) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Elementy makiet / Kamienie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261740) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Elementy makiet"
    ],
    "hierarchy": "(261740) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Elementy makiet / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zieleń do makiet",
    "categoryPath": [
      "(322960) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie",
      "Elementy makiet"
    ],
    "hierarchy": "(322960) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Elementy makiet / Zieleń do makiet",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Farby",
    "categoryPath": [
      "(261734) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Materiały modelarskie"
    ],
    "hierarchy": "(261734) Kolekcje i sztuka / Kolekcje / Modelarstwo / Materiały modelarskie / Farby",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Budownictwo",
    "categoryPath": [
      "(3608) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Modele kartonowe"
    ],
    "hierarchy": "(3608) Kolekcje i sztuka / Kolekcje / Modelarstwo / Modele kartonowe / Budownictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolej",
    "categoryPath": [
      "(99869) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Modele kartonowe"
    ],
    "hierarchy": "(99869) Kolekcje i sztuka / Kolekcje / Modelarstwo / Modele kartonowe / Kolej",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lotnictwo",
    "categoryPath": [
      "(3605) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Modele kartonowe"
    ],
    "hierarchy": "(3605) Kolekcje i sztuka / Kolekcje / Modelarstwo / Modele kartonowe / Lotnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pojazdy wojskowe",
    "categoryPath": [
      "(3607) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Modele kartonowe"
    ],
    "hierarchy": "(3607) Kolekcje i sztuka / Kolekcje / Modelarstwo / Modele kartonowe / Pojazdy wojskowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Samochody",
    "categoryPath": [
      "(26956) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Modele kartonowe"
    ],
    "hierarchy": "(26956) Kolekcje i sztuka / Kolekcje / Modelarstwo / Modele kartonowe / Samochody",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkutnictwo",
    "categoryPath": [
      "(3606) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Modele kartonowe"
    ],
    "hierarchy": "(3606) Kolekcje i sztuka / Kolekcje / Modelarstwo / Modele kartonowe / Szkutnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Motocykle",
    "categoryPath": [
      "(16218) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo"
    ],
    "hierarchy": "(16218) Kolekcje i sztuka / Kolekcje / Modelarstwo / Motocykle",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Narzędzia modelarskie",
    "categoryPath": [
      "(8765) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo"
    ],
    "hierarchy": "(8765) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Aerografy",
    "categoryPath": [
      "(261751) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261751) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Aerografy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dremele",
    "categoryPath": [
      "(261754) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261754) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Dremele",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kompresory i butle",
    "categoryPath": [
      "(261752) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261752) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Kompresory i butle",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lupy modelarskie",
    "categoryPath": [
      "(309145) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(309145) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Lupy modelarskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Maty do cięcia",
    "categoryPath": [
      "(261753) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261753) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Maty do cięcia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pilniki, papiery ścierne, pasty polerskie",
    "categoryPath": [
      "(261758) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261758) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Pilniki, papiery ścierne, pasty polerskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pędzelki",
    "categoryPath": [
      "(261756) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261756) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Pędzelki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pęsety",
    "categoryPath": [
      "(261757) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261757) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Pęsety",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skalpele, noże i nożyczki",
    "categoryPath": [
      "(261755) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261755) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Skalpele, noże i nożyczki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szczypce, obcinacze",
    "categoryPath": [
      "(261760) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261760) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Szczypce, obcinacze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Taśmy maskujące",
    "categoryPath": [
      "(261759) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261759) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Taśmy maskujące",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Środki czyszczące",
    "categoryPath": [
      "(261761) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Narzędzia modelarskie"
    ],
    "hierarchy": "(261761) Kolekcje i sztuka / Kolekcje / Modelarstwo / Narzędzia modelarskie / Środki czyszczące",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Broń pancerna",
    "categoryPath": [
      "(3612) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Plany modelarskie"
    ],
    "hierarchy": "(3612) Kolekcje i sztuka / Kolekcje / Modelarstwo / Plany modelarskie / Broń pancerna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Koleje",
    "categoryPath": [
      "(3613) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Plany modelarskie"
    ],
    "hierarchy": "(3613) Kolekcje i sztuka / Kolekcje / Modelarstwo / Plany modelarskie / Koleje",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lotnictwo",
    "categoryPath": [
      "(3610) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Plany modelarskie"
    ],
    "hierarchy": "(3610) Kolekcje i sztuka / Kolekcje / Modelarstwo / Plany modelarskie / Lotnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkutnictwo",
    "categoryPath": [
      "(3611) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Plany modelarskie"
    ],
    "hierarchy": "(3611) Kolekcje i sztuka / Kolekcje / Modelarstwo / Plany modelarskie / Szkutnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(319995) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Pojazdy wojskowe"
    ],
    "hierarchy": "(319995) Kolekcje i sztuka / Kolekcje / Modelarstwo / Pojazdy wojskowe / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne skale",
    "categoryPath": [
      "(51139) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Pojazdy wojskowe"
    ],
    "hierarchy": "(51139) Kolekcje i sztuka / Kolekcje / Modelarstwo / Pojazdy wojskowe / Inne skale",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:35",
    "categoryPath": [
      "(26948) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Pojazdy wojskowe"
    ],
    "hierarchy": "(26948) Kolekcje i sztuka / Kolekcje / Modelarstwo / Pojazdy wojskowe / Skala 1:35",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:48",
    "categoryPath": [
      "(51142) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Pojazdy wojskowe"
    ],
    "hierarchy": "(51142) Kolekcje i sztuka / Kolekcje / Modelarstwo / Pojazdy wojskowe / Skala 1:48",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skala 1:72 i 1:76",
    "categoryPath": [
      "(26950) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Pojazdy wojskowe"
    ],
    "hierarchy": "(26950) Kolekcje i sztuka / Kolekcje / Modelarstwo / Pojazdy wojskowe / Skala 1:72 i 1:76",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(1068) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo"
    ],
    "hierarchy": "(1068) Kolekcje i sztuka / Kolekcje / Modelarstwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(3572) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(3572) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne skale",
    "categoryPath": [
      "(26955) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(26955) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / Inne skale",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:43",
    "categoryPath": [
      "(11734) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(11734) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skala 1:43",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:87",
    "categoryPath": [
      "(26954) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(26954) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skala 1:87",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skale 1:19 do 1:25",
    "categoryPath": [
      "(11732) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(11732) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skale 1:19 do 1:25",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skale 1:26 do 1:42",
    "categoryPath": [
      "(11733) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(11733) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skale 1:26 do 1:42",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skale 1:44 do 1:59",
    "categoryPath": [
      "(26952) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(26952) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skale 1:44 do 1:59",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skale 1:60 do 1:66",
    "categoryPath": [
      "(26953) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(26953) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skale 1:60 do 1:66",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skale 1:67 do 1:72",
    "categoryPath": [
      "(11736) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(11736) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skale 1:67 do 1:72",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skale do 1:18",
    "categoryPath": [
      "(11731) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Samochody"
    ],
    "hierarchy": "(11731) Kolekcje i sztuka / Kolekcje / Modelarstwo / Samochody / skale do 1:18",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(3587) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Szkutnictwo"
    ],
    "hierarchy": "(3587) Kolekcje i sztuka / Kolekcje / Modelarstwo / Szkutnictwo / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3586) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Szkutnictwo"
    ],
    "hierarchy": "(3586) Kolekcje i sztuka / Kolekcje / Modelarstwo / Szkutnictwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "skala 1:1200",
    "categoryPath": [
      "(309265) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Szkutnictwo"
    ],
    "hierarchy": "(309265) Kolekcje i sztuka / Kolekcje / Modelarstwo / Szkutnictwo / skala 1:1200",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:350 i 1:400",
    "categoryPath": [
      "(3589) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Szkutnictwo"
    ],
    "hierarchy": "(3589) Kolekcje i sztuka / Kolekcje / Modelarstwo / Szkutnictwo / skala 1:350 i 1:400",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:500",
    "categoryPath": [
      "(322959) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Szkutnictwo"
    ],
    "hierarchy": "(322959) Kolekcje i sztuka / Kolekcje / Modelarstwo / Szkutnictwo / skala 1:500",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:700",
    "categoryPath": [
      "(3588) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Szkutnictwo"
    ],
    "hierarchy": "(3588) Kolekcje i sztuka / Kolekcje / Modelarstwo / Szkutnictwo / skala 1:700",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "skala 1:72",
    "categoryPath": [
      "(309253) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Szkutnictwo"
    ],
    "hierarchy": "(309253) Kolekcje i sztuka / Kolekcje / Modelarstwo / Szkutnictwo / skala 1:72",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akumulatory, baterie",
    "categoryPath": [
      "(319379) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319379) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Akumulatory, baterie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Aparatury",
    "categoryPath": [
      "(16217) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(16217) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Aparatury",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Blokady śmigieł",
    "categoryPath": [
      "(319382) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319382) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Blokady śmigieł",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(319385) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319385) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Części montażowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne części i akcesoria",
    "categoryPath": [
      "(319469) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319469) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Inne części i akcesoria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kable i przewody",
    "categoryPath": [
      "(319388) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319388) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Kable i przewody",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kamery",
    "categoryPath": [
      "(319391) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319391) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Kamery",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klucze",
    "categoryPath": [
      "(319394) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319394) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Klucze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kontrolery lotu",
    "categoryPath": [
      "(319400) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319400) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Kontrolery lotu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koła",
    "categoryPath": [
      "(319397) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319397) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Koła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Moduły zrzutu",
    "categoryPath": [
      "(319409) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319409) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Moduły zrzutu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(319412) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319412) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Obudowy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odbiorniki",
    "categoryPath": [
      "(319415) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319415) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Odbiorniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Osłony termokurczliwe",
    "categoryPath": [
      "(319421) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319421) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Osłony termokurczliwe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Osłony śmigieł",
    "categoryPath": [
      "(319418) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319418) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Osłony śmigieł",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(319424) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319424) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Oświetlenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piasty",
    "categoryPath": [
      "(319427) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319427) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Piasty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podwozia i płozy",
    "categoryPath": [
      "(319430) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319430) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Podwozia i płozy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Regulatory",
    "categoryPath": [
      "(319433) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319433) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Regulatory",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Serwomechanizmy",
    "categoryPath": [
      "(319436) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319436) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Serwomechanizmy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(319439) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319439) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Silniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Torby, pokrowce, futerały",
    "categoryPath": [
      "(319448) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319448) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Torby, pokrowce, futerały",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty na tablet, smartfon",
    "categoryPath": [
      "(319451) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319451) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Uchwyty na tablet, smartfon",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(319454) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319454) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Uszczelki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wały napędowe",
    "categoryPath": [
      "(319457) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319457) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Wały napędowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zabezpieczenia drążków",
    "categoryPath": [
      "(319460) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319460) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Zabezpieczenia drążków",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zębatki i koła pasowe",
    "categoryPath": [
      "(319463) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319463) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Zębatki i koła pasowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Złącza i gniazda",
    "categoryPath": [
      "(319466) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319466) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Złącza i gniazda",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(319403) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319403) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Ładowarki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(319406) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319406) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Łożyska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Śmigła",
    "categoryPath": [
      "(319442) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319442) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Śmigła",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Śruby napędowe",
    "categoryPath": [
      "(319445) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Części i akcesoria"
    ],
    "hierarchy": "(319445) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Części i akcesoria / Śruby napędowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drony",
    "categoryPath": [
      "(250408) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Lotnicze"
    ],
    "hierarchy": "(250408) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Lotnicze / Drony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Samoloty i szybowce",
    "categoryPath": [
      "(51144) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Lotnicze"
    ],
    "hierarchy": "(51144) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Lotnicze / Samoloty i szybowce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Śmigłowce",
    "categoryPath": [
      "(51145) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane",
      "Lotnicze"
    ],
    "hierarchy": "(51145) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Lotnicze / Śmigłowce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pojazdy budowlane",
    "categoryPath": [
      "(318768) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(318768) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Pojazdy budowlane",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pojazdy rolnicze",
    "categoryPath": [
      "(318771) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(318771) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Pojazdy rolnicze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pojazdy wojskowe",
    "categoryPath": [
      "(26957) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(26957) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Pojazdy wojskowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Roboty",
    "categoryPath": [
      "(318774) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(318774) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Roboty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Samochody",
    "categoryPath": [
      "(8762) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(8762) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Samochody",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkutnicze",
    "categoryPath": [
      "(8763) Kolekcje i sztuka",
      "Kolekcje",
      "Modelarstwo",
      "Zdalnie sterowane"
    ],
    "hierarchy": "(8763) Kolekcje i sztuka / Kolekcje / Modelarstwo / Zdalnie sterowane / Szkutnicze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Algieria",
    "categoryPath": [
      "(93601) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93601) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Algieria",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Angola",
    "categoryPath": [
      "(317312) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317312) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Angola",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Botswana",
    "categoryPath": [
      "(317315) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317315) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Botswana",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Egipt",
    "categoryPath": [
      "(93602) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93602) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Egipt",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Etiopia",
    "categoryPath": [
      "(317318) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317318) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Etiopia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gambia",
    "categoryPath": [
      "(317321) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317321) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Gambia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gwinea, Gwinea Równikowa i Bissau",
    "categoryPath": [
      "(317324) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317324) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Gwinea, Gwinea Równikowa i Bissau",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kamerun",
    "categoryPath": [
      "(93603) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93603) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Kamerun",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kenia",
    "categoryPath": [
      "(317327) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317327) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Kenia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolonie",
    "categoryPath": [
      "(317360) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317360) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Kolonie",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kongo",
    "categoryPath": [
      "(93604) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93604) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Kongo",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Liberia",
    "categoryPath": [
      "(317330) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317330) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Liberia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Libia",
    "categoryPath": [
      "(317322) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317322) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Libia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malawi",
    "categoryPath": [
      "(317336) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317336) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Malawi",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Maroko",
    "categoryPath": [
      "(309565) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(309565) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Maroko",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mauritius",
    "categoryPath": [
      "(93605) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93605) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Mauritius",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mozambik",
    "categoryPath": [
      "(317339) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317339) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Mozambik",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Namibia",
    "categoryPath": [
      "(317342) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317342) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Namibia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niger i Nigeria",
    "categoryPath": [
      "(317345) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317345) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Niger i Nigeria",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93595) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93595) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "RPA",
    "categoryPath": [
      "(309577) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(309577) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / RPA",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rwanda",
    "categoryPath": [
      "(317348) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317348) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Rwanda",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Somalia",
    "categoryPath": [
      "(93606) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93606) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Somalia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sudan i Sudan Południowy",
    "categoryPath": [
      "(317351) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317351) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Sudan i Sudan Południowy",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tanzania",
    "categoryPath": [
      "(321778) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(321778) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Tanzania",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tunezja",
    "categoryPath": [
      "(318894) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(318894) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Tunezja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Uganda",
    "categoryPath": [
      "(93607) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(93607) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Uganda",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zambia",
    "categoryPath": [
      "(317354) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317354) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Zambia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(317363) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317363) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Zestawy",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zimbabwe",
    "categoryPath": [
      "(317357) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Afryka"
    ],
    "hierarchy": "(317357) Kolekcje i sztuka / Kolekcje / Numizmatyka / Afryka / Zimbabwe",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Albumy i klasery",
    "categoryPath": [
      "(16228) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(16228) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Albumy i klasery",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Holdery",
    "categoryPath": [
      "(16229) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(16229) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Holdery",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kapsle i pudełka",
    "categoryPath": [
      "(16233) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(16233) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Kapsle i pudełka",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Konserwacja",
    "categoryPath": [
      "(16232) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(16232) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Konserwacja",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kuferki i kasety",
    "categoryPath": [
      "(16230) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(16230) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Kuferki i kasety",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(16234) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(16234) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Lupy",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mikroskopy",
    "categoryPath": [
      "(320566) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(320566) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Mikroskopy",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wagi",
    "categoryPath": [
      "(16231) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Akcesoria"
    ],
    "hierarchy": "(16231) Kolekcje i sztuka / Kolekcje / Numizmatyka / Akcesoria / Wagi",
    "comissionGroupOld": "C23",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ameryka Łacińska",
    "categoryPath": [
      "(3654) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(3654) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / Ameryka Łacińska",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kanada",
    "categoryPath": [
      "(10793) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(10793) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / Kanada",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karaiby",
    "categoryPath": [
      "(3655) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(3655) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / Karaiby",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3657) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(3657) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "do 1945 roku",
    "categoryPath": [
      "(19514) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd.",
      "USA",
      "obiegowe"
    ],
    "hierarchy": "(19514) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / USA / obiegowe / do 1945 roku",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 1946 roku",
    "categoryPath": [
      "(19513) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd.",
      "USA",
      "obiegowe"
    ],
    "hierarchy": "(19513) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / USA / obiegowe / od 1946 roku",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "pozostałe",
    "categoryPath": [
      "(10795) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd.",
      "USA"
    ],
    "hierarchy": "(10795) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / USA / pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(317300) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(317300) Kolekcje i sztuka / Kolekcje / Numizmatyka / Ameryka Pn. i Pd. / Zestawy",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Artefakty",
    "categoryPath": [
      "(16222) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Antyczne"
    ],
    "hierarchy": "(16222) Kolekcje i sztuka / Kolekcje / Numizmatyka / Antyczne / Artefakty",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bizancjum",
    "categoryPath": [
      "(317303) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Antyczne"
    ],
    "hierarchy": "(317303) Kolekcje i sztuka / Kolekcje / Numizmatyka / Antyczne / Bizancjum",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Celtowie",
    "categoryPath": [
      "(317306) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Antyczne"
    ],
    "hierarchy": "(317306) Kolekcje i sztuka / Kolekcje / Numizmatyka / Antyczne / Celtowie",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Daleki Wschód",
    "categoryPath": [
      "(317309) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Antyczne"
    ],
    "hierarchy": "(317309) Kolekcje i sztuka / Kolekcje / Numizmatyka / Antyczne / Daleki Wschód",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Grecja",
    "categoryPath": [
      "(3659) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Antyczne"
    ],
    "hierarchy": "(3659) Kolekcje i sztuka / Kolekcje / Numizmatyka / Antyczne / Grecja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3658) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Antyczne"
    ],
    "hierarchy": "(3658) Kolekcje i sztuka / Kolekcje / Numizmatyka / Antyczne / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rzym",
    "categoryPath": [
      "(3660) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Antyczne"
    ],
    "hierarchy": "(3660) Kolekcje i sztuka / Kolekcje / Numizmatyka / Antyczne / Rzym",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolekcjonerskie",
    "categoryPath": [
      "(93608) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Australia i Oceania"
    ],
    "hierarchy": "(93608) Kolekcje i sztuka / Kolekcje / Numizmatyka / Australia i Oceania / Kolekcjonerskie",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obiegowe",
    "categoryPath": [
      "(93609) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Australia i Oceania"
    ],
    "hierarchy": "(93609) Kolekcje i sztuka / Kolekcje / Numizmatyka / Australia i Oceania / Obiegowe",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Arabia Saudyjska",
    "categoryPath": [
      "(317276) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317276) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Arabia Saudyjska",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Armenia",
    "categoryPath": [
      "(93610) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93610) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Armenia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1949",
    "categoryPath": [
      "(14092) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja",
      "Chiny"
    ],
    "hierarchy": "(14092) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Chiny / do 1949",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1949",
    "categoryPath": [
      "(14093) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja",
      "Chiny"
    ],
    "hierarchy": "(14093) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Chiny / po 1949",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Filipiny",
    "categoryPath": [
      "(309601) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(309601) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Filipiny",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1947",
    "categoryPath": [
      "(50441) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja",
      "Indie"
    ],
    "hierarchy": "(50441) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Indie / do 1947",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1947",
    "categoryPath": [
      "(50440) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja",
      "Indie"
    ],
    "hierarchy": "(50440) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Indie / po 1947",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Indonezja",
    "categoryPath": [
      "(93611) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93611) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Indonezja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Irak",
    "categoryPath": [
      "(93612) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93612) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Irak",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Iran",
    "categoryPath": [
      "(93613) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93613) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Iran",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Izrael",
    "categoryPath": [
      "(93614) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93614) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Izrael",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Japonia",
    "categoryPath": [
      "(14090) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(14090) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Japonia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Jordania",
    "categoryPath": [
      "(321781) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(321781) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Jordania",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kazachstan",
    "categoryPath": [
      "(93615) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93615) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Kazachstan",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Korea Południowa",
    "categoryPath": [
      "(317018) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317018) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Korea Południowa",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Korea Północna",
    "categoryPath": [
      "(317015) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317015) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Korea Północna",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Liban",
    "categoryPath": [
      "(317279) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317279) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Liban",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malediwy",
    "categoryPath": [
      "(317282) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317282) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Malediwy",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malezja",
    "categoryPath": [
      "(309625) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(309625) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Malezja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Monety keszowe Cash",
    "categoryPath": [
      "(14088) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(14088) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Monety keszowe Cash",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mongolia",
    "categoryPath": [
      "(93616) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93616) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Mongolia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nepal",
    "categoryPath": [
      "(93617) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93617) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Nepal",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Oman",
    "categoryPath": [
      "(321784) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(321784) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Oman",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(14087) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(14087) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Singapur",
    "categoryPath": [
      "(317285) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317285) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Singapur",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sri Lanka",
    "categoryPath": [
      "(309613) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(309613) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Sri Lanka",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tajlandia",
    "categoryPath": [
      "(93618) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(93618) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Tajlandia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wietnam",
    "categoryPath": [
      "(317288) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317288) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Wietnam",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(317291) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(317291) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Zestawy",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zjednoczone Emiraty Arabskie",
    "categoryPath": [
      "(321787) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Azja"
    ],
    "hierarchy": "(321787) Kolekcje i sztuka / Kolekcje / Numizmatyka / Azja / Zjednoczone Emiraty Arabskie",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy i Słowacja",
    "categoryPath": [
      "(11747) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka"
    ],
    "hierarchy": "(11747) Kolekcje i sztuka / Kolekcje / Numizmatyka / Czechy i Słowacja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Andora",
    "categoryPath": [
      "(317396) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317396) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Andora",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1848 - 1918",
    "categoryPath": [
      "(11755) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Austro-Węgry i Austria"
    ],
    "hierarchy": "(11755) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Austro-Węgry i Austria / 1848 - 1918",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1848",
    "categoryPath": [
      "(11756) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Austro-Węgry i Austria"
    ],
    "hierarchy": "(11756) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Austro-Węgry i Austria / do 1848",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "po 1918",
    "categoryPath": [
      "(11754) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Austro-Węgry i Austria"
    ],
    "hierarchy": "(11754) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Austro-Węgry i Austria / po 1918",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Benelux",
    "categoryPath": [
      "(11752) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(11752) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Benelux",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Białoruś",
    "categoryPath": [
      "(16223) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(16223) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Białoruś",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bułgaria",
    "categoryPath": [
      "(317540) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317540) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Bułgaria",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Cypr",
    "categoryPath": [
      "(317405) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317405) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Cypr",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1 euro",
    "categoryPath": [
      "(45650) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro"
    ],
    "hierarchy": "(45650) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 1 euro",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1 – 5 centów",
    "categoryPath": [
      "(45648) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro"
    ],
    "hierarchy": "(45648) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 1 – 5 centów",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1,5 euro",
    "categoryPath": [
      "(315783) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro"
    ],
    "hierarchy": "(315783) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 1,5 euro",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "10 - 35 euro",
    "categoryPath": [
      "(315789) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro"
    ],
    "hierarchy": "(315789) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 10 - 35 euro",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "10 – 50 centów",
    "categoryPath": [
      "(45649) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro"
    ],
    "hierarchy": "(45649) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 10 – 50 centów",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "obiegowe",
    "categoryPath": [
      "(99875) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro",
      "2 euro"
    ],
    "hierarchy": "(99875) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 2 euro / obiegowe",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "okolicznościowe",
    "categoryPath": [
      "(99874) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro",
      "2 euro"
    ],
    "hierarchy": "(99874) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 2 euro / okolicznościowe",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "3 - 5 euro",
    "categoryPath": [
      "(315786) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro"
    ],
    "hierarchy": "(315786) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / 3 - 5 euro",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(45647) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Euro"
    ],
    "hierarchy": "(45647) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Euro / Zestawy",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Francja",
    "categoryPath": [
      "(11748) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(11748) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Francja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Grecja",
    "categoryPath": [
      "(317009) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317009) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Grecja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Hiszpania",
    "categoryPath": [
      "(16225) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(16225) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Hiszpania",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Islandia",
    "categoryPath": [
      "(319481) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(319481) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Islandia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje bałtyckie",
    "categoryPath": [
      "(3666) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(3666) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Kraje bałtyckie",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje byłej Jugosławii",
    "categoryPath": [
      "(317012) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317012) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Kraje byłej Jugosławii",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malta",
    "categoryPath": [
      "(321790) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(321790) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Malta",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Monako",
    "categoryPath": [
      "(321793) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(321793) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Monako",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mołdawia",
    "categoryPath": [
      "(317399) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317399) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Mołdawia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Naddniestrze",
    "categoryPath": [
      "(317408) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317408) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Naddniestrze",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1871 - 1918",
    "categoryPath": [
      "(11746) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(11746) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Niemcy / 1871 - 1918",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1918 - 1933",
    "categoryPath": [
      "(11757) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(11757) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Niemcy / 1918 - 1933",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1933 - 1945",
    "categoryPath": [
      "(3668) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(3668) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Niemcy / 1933 - 1945",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1871",
    "categoryPath": [
      "(11745) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(11745) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Niemcy / do 1871",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 1945",
    "categoryPath": [
      "(3669) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Niemcy"
    ],
    "hierarchy": "(3669) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Niemcy / od 1945",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Portugalia",
    "categoryPath": [
      "(317537) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317537) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Portugalia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3661) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(3661) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "do 1917",
    "categoryPath": [
      "(3670) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Rosja"
    ],
    "hierarchy": "(3670) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Rosja / do 1917",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 1918",
    "categoryPath": [
      "(3671) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa",
      "Rosja"
    ],
    "hierarchy": "(3671) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Rosja / od 1918",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rumunia",
    "categoryPath": [
      "(16227) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(16227) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Rumunia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "San Marino",
    "categoryPath": [
      "(317402) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(317402) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / San Marino",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skandynawia",
    "categoryPath": [
      "(11753) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(11753) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Skandynawia",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szwajcaria",
    "categoryPath": [
      "(11750) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(11750) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Szwajcaria",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Turcja",
    "categoryPath": [
      "(93619) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(93619) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Turcja",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ukraina",
    "categoryPath": [
      "(3665) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(3665) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Ukraina",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Watykan",
    "categoryPath": [
      "(16224) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(16224) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Watykan",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wielka Brytania",
    "categoryPath": [
      "(11751) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(11751) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Wielka Brytania",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Węgry",
    "categoryPath": [
      "(16226) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(16226) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Węgry",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Włochy",
    "categoryPath": [
      "(11749) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Europa"
    ],
    "hierarchy": "(11749) Kolekcje i sztuka / Kolekcje / Numizmatyka / Europa / Włochy",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "XIX wiek",
    "categoryPath": [
      "(12199) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Islam"
    ],
    "hierarchy": "(12199) Kolekcje i sztuka / Kolekcje / Numizmatyka / Islam / XIX wiek",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "XVIII wiek i starsze",
    "categoryPath": [
      "(12198) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Islam"
    ],
    "hierarchy": "(12198) Kolekcje i sztuka / Kolekcje / Numizmatyka / Islam / XVIII wiek i starsze",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "XX wiek",
    "categoryPath": [
      "(12200) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Islam"
    ],
    "hierarchy": "(12200) Kolekcje i sztuka / Kolekcje / Numizmatyka / Islam / XX wiek",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czasopisma",
    "categoryPath": [
      "(3689) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Literatura"
    ],
    "hierarchy": "(3689) Kolekcje i sztuka / Kolekcje / Numizmatyka / Literatura / Czasopisma",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Foldery i ulotki",
    "categoryPath": [
      "(55196) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Literatura"
    ],
    "hierarchy": "(55196) Kolekcje i sztuka / Kolekcje / Numizmatyka / Literatura / Foldery i ulotki",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Katalogi",
    "categoryPath": [
      "(3686) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Literatura"
    ],
    "hierarchy": "(3686) Kolekcje i sztuka / Kolekcje / Numizmatyka / Literatura / Katalogi",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Katalogi aukcyjne",
    "categoryPath": [
      "(3687) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Literatura"
    ],
    "hierarchy": "(3687) Kolekcje i sztuka / Kolekcje / Numizmatyka / Literatura / Katalogi aukcyjne",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Książki",
    "categoryPath": [
      "(3688) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Literatura"
    ],
    "hierarchy": "(3688) Kolekcje i sztuka / Kolekcje / Numizmatyka / Literatura / Książki",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1999",
    "categoryPath": [
      "(50438) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Monety zastępcze"
    ],
    "hierarchy": "(50438) Kolekcje i sztuka / Kolekcje / Numizmatyka / Monety zastępcze / do 1999",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "od 2000",
    "categoryPath": [
      "(50439) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Monety zastępcze"
    ],
    "hierarchy": "(50439) Kolekcje i sztuka / Kolekcje / Numizmatyka / Monety zastępcze / od 2000",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Monety złote do 1800 roku",
    "categoryPath": [
      "(257778) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka"
    ],
    "hierarchy": "(257778) Kolekcje i sztuka / Kolekcje / Numizmatyka / Monety złote do 1800 roku",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1916 - 1922",
    "categoryPath": [
      "(254679) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska 1916 - 1945"
    ],
    "hierarchy": "(254679) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska 1916 - 1945 / 1916 - 1922",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1923 - 1939",
    "categoryPath": [
      "(254680) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska 1916 - 1945"
    ],
    "hierarchy": "(254680) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska 1916 - 1945 / 1923 - 1939",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1939 - 1945",
    "categoryPath": [
      "(254681) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska 1916 - 1945"
    ],
    "hierarchy": "(254681) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska 1916 - 1945 / 1939 - 1945",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1506 - 1586",
    "categoryPath": [
      "(9332) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska do 1864"
    ],
    "hierarchy": "(9332) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska do 1864 / 1506 - 1586",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1587 - 1668",
    "categoryPath": [
      "(9333) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska do 1864"
    ],
    "hierarchy": "(9333) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska do 1864 / 1587 - 1668",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1669 - 1795",
    "categoryPath": [
      "(3676) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska do 1864"
    ],
    "hierarchy": "(3676) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska do 1864 / 1669 - 1795",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1796 - 1864",
    "categoryPath": [
      "(3677) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska do 1864"
    ],
    "hierarchy": "(3677) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska do 1864 / 1796 - 1864",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "960 - 1506",
    "categoryPath": [
      "(3675) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska do 1864"
    ],
    "hierarchy": "(3675) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska do 1864 / 960 - 1506",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "2 zł okolicznościowe",
    "categoryPath": [
      "(9001) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "III RP 1990 -"
    ],
    "hierarchy": "(9001) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / III RP 1990 - / 2 zł okolicznościowe",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "5 zł okolicznościowe",
    "categoryPath": [
      "(249502) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "III RP 1990 -"
    ],
    "hierarchy": "(249502) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / III RP 1990 - / 5 zł okolicznościowe",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "kolekcjonerskie",
    "categoryPath": [
      "(8758) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "III RP 1990 -"
    ],
    "hierarchy": "(8758) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / III RP 1990 - / kolekcjonerskie",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "obiegowe",
    "categoryPath": [
      "(8757) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "III RP 1990 -"
    ],
    "hierarchy": "(8757) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / III RP 1990 - / obiegowe",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "próbne",
    "categoryPath": [
      "(8759) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "III RP 1990 -"
    ],
    "hierarchy": "(8759) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / III RP 1990 - / próbne",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "zestawy",
    "categoryPath": [
      "(9025) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "III RP 1990 -"
    ],
    "hierarchy": "(9025) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / III RP 1990 - / zestawy",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "kolekcjonerskie",
    "categoryPath": [
      "(8755) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "PRL 1945 - 1990"
    ],
    "hierarchy": "(8755) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / PRL 1945 - 1990 / kolekcjonerskie",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "obiegowe",
    "categoryPath": [
      "(8754) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "PRL 1945 - 1990"
    ],
    "hierarchy": "(8754) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / PRL 1945 - 1990 / obiegowe",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "próbne",
    "categoryPath": [
      "(8756) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "PRL 1945 - 1990"
    ],
    "hierarchy": "(8756) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / PRL 1945 - 1990 / próbne",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "zestawy",
    "categoryPath": [
      "(9024) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Polska",
      "Polska po 1945",
      "PRL 1945 - 1990"
    ],
    "hierarchy": "(9024) Kolekcje i sztuka / Kolekcje / Numizmatyka / Polska / Polska po 1945 / PRL 1945 - 1990 / zestawy",
    "comissionGroupOld": "C21",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pomorze",
    "categoryPath": [
      "(4767) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Powiązane z Polską"
    ],
    "hierarchy": "(4767) Kolekcje i sztuka / Kolekcje / Numizmatyka / Powiązane z Polską / Pomorze",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4770) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Powiązane z Polską"
    ],
    "hierarchy": "(4770) Kolekcje i sztuka / Kolekcje / Numizmatyka / Powiązane z Polską / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prusy Książęce",
    "categoryPath": [
      "(4769) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Powiązane z Polską"
    ],
    "hierarchy": "(4769) Kolekcje i sztuka / Kolekcje / Numizmatyka / Powiązane z Polską / Prusy Książęce",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zakon Krzyżacki",
    "categoryPath": [
      "(11742) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Powiązane z Polską"
    ],
    "hierarchy": "(11742) Kolekcje i sztuka / Kolekcje / Numizmatyka / Powiązane z Polską / Zakon Krzyżacki",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Śląsk",
    "categoryPath": [
      "(4768) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Powiązane z Polską"
    ],
    "hierarchy": "(4768) Kolekcje i sztuka / Kolekcje / Numizmatyka / Powiązane z Polską / Śląsk",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Biżuteria numizmatyczna i wyroby",
    "categoryPath": [
      "(317297) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(317297) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Biżuteria numizmatyczna i wyroby",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Destrukty",
    "categoryPath": [
      "(317294) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(317294) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Destrukty",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Fantazyjne",
    "categoryPath": [
      "(9335) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(9335) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Fantazyjne",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kopie i reprodukcje",
    "categoryPath": [
      "(4772) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(4772) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Kopie i reprodukcje",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pieczęcie",
    "categoryPath": [
      "(15778) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(15778) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Pieczęcie",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Plomby",
    "categoryPath": [
      "(15779) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(15779) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Plomby",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4771) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(4771) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(4773) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(4773) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Zestawy",
    "comissionGroupOld": "C24",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Żetony",
    "categoryPath": [
      "(9029) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Pozostałe"
    ],
    "hierarchy": "(9029) Kolekcje i sztuka / Kolekcje / Numizmatyka / Pozostałe / Żetony",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Talary",
    "categoryPath": [
      "(1004) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka"
    ],
    "hierarchy": "(1004) Kolekcje i sztuka / Kolekcje / Numizmatyka / Talary",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Flora",
    "categoryPath": [
      "(11743) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Tematyczne"
    ],
    "hierarchy": "(11743) Kolekcje i sztuka / Kolekcje / Numizmatyka / Tematyczne / Flora",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Marynistyka",
    "categoryPath": [
      "(11744) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Tematyczne"
    ],
    "hierarchy": "(11744) Kolekcje i sztuka / Kolekcje / Numizmatyka / Tematyczne / Marynistyka",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Benedykt XVI",
    "categoryPath": [
      "(19126) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Tematyczne",
      "Postacie"
    ],
    "hierarchy": "(19126) Kolekcje i sztuka / Kolekcje / Numizmatyka / Tematyczne / Postacie / Benedykt XVI",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Jan Paweł II",
    "categoryPath": [
      "(19125) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Tematyczne",
      "Postacie"
    ],
    "hierarchy": "(19125) Kolekcje i sztuka / Kolekcje / Numizmatyka / Tematyczne / Postacie / Jan Paweł II",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19127) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Tematyczne",
      "Postacie"
    ],
    "hierarchy": "(19127) Kolekcje i sztuka / Kolekcje / Numizmatyka / Tematyczne / Postacie / Pozostałe",
    "comissionGroupOld": "C22",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sport",
    "categoryPath": [
      "(4779) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Tematyczne"
    ],
    "hierarchy": "(4779) Kolekcje i sztuka / Kolekcje / Numizmatyka / Tematyczne / Sport",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zwierzęta",
    "categoryPath": [
      "(4778) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka",
      "Tematyczne"
    ],
    "hierarchy": "(4778) Kolekcje i sztuka / Kolekcje / Numizmatyka / Tematyczne / Zwierzęta",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wolne Miasto Gdańsk",
    "categoryPath": [
      "(362) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka"
    ],
    "hierarchy": "(362) Kolekcje i sztuka / Kolekcje / Numizmatyka / Wolne Miasto Gdańsk",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Złote monety kolekcjonerskie",
    "categoryPath": [
      "(260897) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka"
    ],
    "hierarchy": "(260897) Kolekcje i sztuka / Kolekcje / Numizmatyka / Złote monety kolekcjonerskie",
    "comissionGroupOld": "C25",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Średniowieczne",
    "categoryPath": [
      "(968) Kolekcje i sztuka",
      "Kolekcje",
      "Numizmatyka"
    ],
    "hierarchy": "(968) Kolekcje i sztuka / Kolekcje / Numizmatyka / Średniowieczne",
    "comissionGroupOld": "C20",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Artykuły drogeryjne",
    "categoryPath": [
      "(47938) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47938) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Artykuły drogeryjne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bibeloty",
    "categoryPath": [
      "(47939) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47939) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Bibeloty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czasopisma i książki",
    "categoryPath": [
      "(47940) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47940) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Czasopisma i książki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dokumenty",
    "categoryPath": [
      "(47941) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47941) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Dokumenty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Medale i odznaczenia",
    "categoryPath": [
      "(47942) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47942) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Medale i odznaczenia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Naczynia i sztućce",
    "categoryPath": [
      "(47943) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47943) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Naczynia i sztućce",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Odzież, obuwie, dodatki",
    "categoryPath": [
      "(47944) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47944) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Odzież, obuwie, dodatki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Opakowania",
    "categoryPath": [
      "(47945) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47945) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Opakowania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Postacie PRL-u",
    "categoryPath": [
      "(47946) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47946) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Postacie PRL-u",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(47952) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47952) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Projektory i przeźrocza",
    "categoryPath": [
      "(93797) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(93797) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Projektory i przeźrocza",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Reklama i propaganda",
    "categoryPath": [
      "(47947) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47947) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Reklama i propaganda",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sztandary, godła, proporczyki",
    "categoryPath": [
      "(47948) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47948) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Sztandary, godła, proporczyki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tablice informacyjno – ostrzegawcze",
    "categoryPath": [
      "(47949) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47949) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Tablice informacyjno – ostrzegawcze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(47950) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47950) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Urządzenia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zabawki",
    "categoryPath": [
      "(47951) Kolekcje i sztuka",
      "Kolekcje",
      "Pamiątki PRL-u"
    ],
    "hierarchy": "(47951) Kolekcje i sztuka / Kolekcje / Pamiątki PRL-u / Zabawki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Papiery wartościowe",
    "categoryPath": [
      "(322438) Kolekcje i sztuka",
      "Kolekcje"
    ],
    "hierarchy": "(322438) Kolekcje i sztuka / Kolekcje / Papiery wartościowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Burundi",
    "categoryPath": [
      "(93798) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(93798) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Burundi",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Egipt",
    "categoryPath": [
      "(28345) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28345) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Egipt",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Erytrea",
    "categoryPath": [
      "(254199) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(254199) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Erytrea",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gambia",
    "categoryPath": [
      "(254200) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(254200) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Gambia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ghana",
    "categoryPath": [
      "(254202) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(254202) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Ghana",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gwinea",
    "categoryPath": [
      "(93799) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(93799) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Gwinea",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kenia",
    "categoryPath": [
      "(93800) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(93800) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Kenia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kongo",
    "categoryPath": [
      "(28357) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28357) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Kongo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Libia",
    "categoryPath": [
      "(28346) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28346) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Libia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Madagaskar",
    "categoryPath": [
      "(28347) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28347) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Madagaskar",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malawi",
    "categoryPath": [
      "(93801) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(93801) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Malawi",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mauritius",
    "categoryPath": [
      "(93803) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(93803) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Mauritius",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mozambik",
    "categoryPath": [
      "(28348) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28348) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Mozambik",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nigeria",
    "categoryPath": [
      "(28349) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28349) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Nigeria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28354) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28354) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rwanda",
    "categoryPath": [
      "(254201) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(254201) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Rwanda",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sudan",
    "categoryPath": [
      "(28350) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28350) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Sudan",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Uganda",
    "categoryPath": [
      "(93805) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(93805) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Uganda",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zair",
    "categoryPath": [
      "(28351) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28351) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Zair",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zambia",
    "categoryPath": [
      "(28352) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28352) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Zambia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(28353) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(28353) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zimbabwe",
    "categoryPath": [
      "(254198) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Afryka"
    ],
    "hierarchy": "(254198) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Afryka / Zimbabwe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Albumy",
    "categoryPath": [
      "(315762) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Akcesoria"
    ],
    "hierarchy": "(315762) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Akcesoria / Albumy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Karty, folie ochronne",
    "categoryPath": [
      "(315765) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Akcesoria"
    ],
    "hierarchy": "(315765) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Akcesoria / Karty, folie ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(315774) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Akcesoria"
    ],
    "hierarchy": "(315774) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Akcesoria / Lupy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Argentyna",
    "categoryPath": [
      "(28304) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28304) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Argentyna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Brazylia",
    "categoryPath": [
      "(28305) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28305) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Brazylia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Chile",
    "categoryPath": [
      "(28306) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28306) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Chile",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolumbia",
    "categoryPath": [
      "(28307) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28307) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Kolumbia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kuba",
    "categoryPath": [
      "(28308) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28308) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Kuba",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Meksyk",
    "categoryPath": [
      "(28309) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28309) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Meksyk",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nikaragua",
    "categoryPath": [
      "(28310) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28310) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Nikaragua",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Peru",
    "categoryPath": [
      "(28311) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28311) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Peru",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28313) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28313) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wenezuela",
    "categoryPath": [
      "(28312) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd.",
      "Ameryka Łacińska"
    ],
    "hierarchy": "(28312) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Ameryka Łacińska / Wenezuela",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kanada",
    "categoryPath": [
      "(28300) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(28300) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Kanada",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karaiby",
    "categoryPath": [
      "(28299) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(28299) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Karaiby",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28303) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(28303) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "USA",
    "categoryPath": [
      "(28298) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(28298) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / USA",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(28302) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Ameryka Pn. i Pd."
    ],
    "hierarchy": "(28302) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Ameryka Pn. i Pd. / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Afganistan",
    "categoryPath": [
      "(28315) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28315) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Afganistan",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bangladesz",
    "categoryPath": [
      "(93811) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93811) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Bangladesz",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bhutan",
    "categoryPath": [
      "(93813) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93813) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Bhutan",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Birma",
    "categoryPath": [
      "(93812) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93812) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Birma",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Chiny",
    "categoryPath": [
      "(28314) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28314) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Chiny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Filipiny",
    "categoryPath": [
      "(93814) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93814) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Filipiny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Indie",
    "categoryPath": [
      "(28316) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28316) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Indie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Indonezja",
    "categoryPath": [
      "(28318) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28318) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Indonezja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Irak",
    "categoryPath": [
      "(28319) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28319) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Irak",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Iran",
    "categoryPath": [
      "(28320) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28320) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Iran",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Izrael",
    "categoryPath": [
      "(93815) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93815) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Izrael",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Japonia",
    "categoryPath": [
      "(259081) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(259081) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Japonia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Jemen",
    "categoryPath": [
      "(93816) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93816) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Jemen",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Jordania",
    "categoryPath": [
      "(93817) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93817) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Jordania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kambodża",
    "categoryPath": [
      "(93818) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93818) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Kambodża",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Korea",
    "categoryPath": [
      "(28321) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28321) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Korea",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kuwejt",
    "categoryPath": [
      "(93819) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93819) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Kuwejt",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Laos",
    "categoryPath": [
      "(93820) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93820) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Laos",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Liban",
    "categoryPath": [
      "(93821) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93821) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Liban",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malediwy",
    "categoryPath": [
      "(93822) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93822) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Malediwy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malezja",
    "categoryPath": [
      "(93823) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93823) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Malezja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mongolia",
    "categoryPath": [
      "(28322) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28322) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Mongolia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nepal",
    "categoryPath": [
      "(28323) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28323) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Nepal",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pakistan",
    "categoryPath": [
      "(28324) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28324) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Pakistan",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28328) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28328) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Republiki/Kraje byłego ZSRR",
    "categoryPath": [
      "(28325) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28325) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Republiki/Kraje byłego ZSRR",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Syria",
    "categoryPath": [
      "(93824) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93824) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Syria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tajlandia",
    "categoryPath": [
      "(28326) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28326) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Tajlandia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wietnam",
    "categoryPath": [
      "(93825) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(93825) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Wietnam",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(28327) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Azja"
    ],
    "hierarchy": "(28327) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Azja / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy",
    "categoryPath": [
      "(322191) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy"
    ],
    "hierarchy": "(322191) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Czechy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(13837) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy"
    ],
    "hierarchy": "(13837) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Były zabór rosyjski",
    "categoryPath": [
      "(45418) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45418) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Były zabór rosyjski",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Galicja",
    "categoryPath": [
      "(45419) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45419) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Galicja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pomorze",
    "categoryPath": [
      "(45420) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45420) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Pomorze",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(45424) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45424) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Warmia i Mazury",
    "categoryPath": [
      "(45421) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45421) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Warmia i Mazury",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wielkopolska",
    "categoryPath": [
      "(45422) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45422) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Wielkopolska",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(45423) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45423) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Śląsk",
    "categoryPath": [
      "(45417) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy",
      "Polska i powiązane"
    ],
    "hierarchy": "(45417) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Polska i powiązane / Śląsk",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13836) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Bony i notgeldy"
    ],
    "hierarchy": "(13836) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Bony i notgeldy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Austro-Węgry i Austria",
    "categoryPath": [
      "(28332) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28332) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Austro-Węgry i Austria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Benelux",
    "categoryPath": [
      "(28333) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28333) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Benelux",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Białoruś",
    "categoryPath": [
      "(28334) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28334) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Białoruś",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Czechy i Słowacja",
    "categoryPath": [
      "(28335) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28335) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Czechy i Słowacja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Francja",
    "categoryPath": [
      "(28336) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28336) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Francja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Grecja",
    "categoryPath": [
      "(254203) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(254203) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Grecja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Hiszpania i Portugalia",
    "categoryPath": [
      "(28337) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28337) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Hiszpania i Portugalia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje bałtyckie",
    "categoryPath": [
      "(28338) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28338) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Kraje bałtyckie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje byłej Jugosławii",
    "categoryPath": [
      "(28331) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28331) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Kraje byłej Jugosławii",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje skandynawskie",
    "categoryPath": [
      "(28358) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28358) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Kraje skandynawskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(3567) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(3567) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3565) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(3565) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja",
    "categoryPath": [
      "(3566) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(3566) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Rosja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rumunia i Bułgaria",
    "categoryPath": [
      "(28339) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28339) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Rumunia i Bułgaria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Turcja",
    "categoryPath": [
      "(28340) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28340) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Turcja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ukraina",
    "categoryPath": [
      "(28341) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28341) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Ukraina",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wielka Brytania",
    "categoryPath": [
      "(28343) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28343) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Wielka Brytania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Węgry",
    "categoryPath": [
      "(28342) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28342) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Węgry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Włochy",
    "categoryPath": [
      "(94060) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(94060) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Włochy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(28344) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Europa"
    ],
    "hierarchy": "(28344) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Europa / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(8538) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy"
    ],
    "hierarchy": "(8538) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Literatura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1916 - 1924 marki i ruble",
    "categoryPath": [
      "(13845) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(13845) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / 1916 - 1924 marki i ruble",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1919 - 1939 złote",
    "categoryPath": [
      "(3568) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(3568) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / 1919 - 1939 złote",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1939 - 1941",
    "categoryPath": [
      "(13842) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(13842) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / 1939 - 1941",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1944 - 1965",
    "categoryPath": [
      "(9059) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(9059) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / 1944 - 1965",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "1966 - 1993",
    "categoryPath": [
      "(3569) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(3569) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / 1966 - 1993",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pewex i Baltona",
    "categoryPath": [
      "(13846) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(13846) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / Pewex i Baltona",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(28356) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(28356) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / Zestawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "do 1915",
    "categoryPath": [
      "(13844) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska"
    ],
    "hierarchy": "(13844) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / do 1915",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "kolekcjonerskie",
    "categoryPath": [
      "(99873) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska",
      "od 1994"
    ],
    "hierarchy": "(99873) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / od 1994 / kolekcjonerskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "obiegowe",
    "categoryPath": [
      "(99872) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Polska",
      "od 1994"
    ],
    "hierarchy": "(99872) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Polska / od 1994 / obiegowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Fantazyjne",
    "categoryPath": [
      "(13840) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Pozostałe"
    ],
    "hierarchy": "(13840) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Pozostałe / Fantazyjne",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kopie i faksymile",
    "categoryPath": [
      "(13841) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Pozostałe"
    ],
    "hierarchy": "(13841) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Pozostałe / Kopie i faksymile",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13839) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Pozostałe"
    ],
    "hierarchy": "(13839) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Pozostałe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(28355) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy",
      "Pozostałe"
    ],
    "hierarchy": "(28355) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Pozostałe / Zestawy",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reszta Świata",
    "categoryPath": [
      "(386) Kolekcje i sztuka",
      "Kolekcje",
      "Pieniądz papierowy"
    ],
    "hierarchy": "(386) Kolekcje i sztuka / Kolekcje / Pieniądz papierowy / Reszta Świata",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Albumy",
    "categoryPath": [
      "(315750) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Akcesoria"
    ],
    "hierarchy": "(315750) Kolekcje i sztuka / Kolekcje / Pocztówki / Akcesoria / Albumy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Karty, kieszonki",
    "categoryPath": [
      "(315753) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Akcesoria"
    ],
    "hierarchy": "(315753) Kolekcje i sztuka / Kolekcje / Pocztówki / Akcesoria / Karty, kieszonki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Czechy i Słowacja",
    "categoryPath": [
      "(309721) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki"
    ],
    "hierarchy": "(309721) Kolekcje i sztuka / Kolekcje / Pocztówki / Czechy i Słowacja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(99871) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki"
    ],
    "hierarchy": "(99871) Kolekcje i sztuka / Kolekcje / Pocztówki / Literatura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Częstochowa i okolice",
    "categoryPath": [
      "(10238) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Centralna Polska"
    ],
    "hierarchy": "(10238) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Centralna Polska / Częstochowa i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kalisz i okolice",
    "categoryPath": [
      "(10237) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Centralna Polska"
    ],
    "hierarchy": "(10237) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Centralna Polska / Kalisz i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kielce i okolice",
    "categoryPath": [
      "(10239) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Centralna Polska"
    ],
    "hierarchy": "(10239) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Centralna Polska / Kielce i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Radom i okolice",
    "categoryPath": [
      "(10240) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Centralna Polska"
    ],
    "hierarchy": "(10240) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Centralna Polska / Radom i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Łódź i okolice",
    "categoryPath": [
      "(10236) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Centralna Polska"
    ],
    "hierarchy": "(10236) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Centralna Polska / Łódź i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Jeleniogórskie (Riesengebirge)",
    "categoryPath": [
      "(10242) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Dolny Śląsk (Niederschlesien)"
    ],
    "hierarchy": "(10242) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Dolny Śląsk (Niederschlesien) / Jeleniogórskie (Riesengebirge)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kotlina Kłodzka (Glatz)",
    "categoryPath": [
      "(10246) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Dolny Śląsk (Niederschlesien)"
    ],
    "hierarchy": "(10246) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Dolny Śląsk (Niederschlesien) / Kotlina Kłodzka (Glatz)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Legnickie (Liegnitz)",
    "categoryPath": [
      "(10244) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Dolny Śląsk (Niederschlesien)"
    ],
    "hierarchy": "(10244) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Dolny Śląsk (Niederschlesien) / Legnickie (Liegnitz)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wałbrzyskie (Waldenburg)",
    "categoryPath": [
      "(10245) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Dolny Śląsk (Niederschlesien)"
    ],
    "hierarchy": "(10245) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Dolny Śląsk (Niederschlesien) / Wałbrzyskie (Waldenburg)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wrocławskie (Breslau)",
    "categoryPath": [
      "(10243) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Dolny Śląsk (Niederschlesien)"
    ],
    "hierarchy": "(10243) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Dolny Śląsk (Niederschlesien) / Wrocławskie (Breslau)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lwów",
    "categoryPath": [
      "(10268) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Kresy wschodnie"
    ],
    "hierarchy": "(10268) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Kresy wschodnie / Lwów",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(10270) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Kresy wschodnie"
    ],
    "hierarchy": "(10270) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Kresy wschodnie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wilno",
    "categoryPath": [
      "(10269) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Kresy wschodnie"
    ],
    "hierarchy": "(10269) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Kresy wschodnie / Wilno",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lublin i Podlasie",
    "categoryPath": [
      "(10271) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska"
    ],
    "hierarchy": "(10271) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Lublin i Podlasie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Białostockie",
    "categoryPath": [
      "(10285) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Mazowsze"
    ],
    "hierarchy": "(10285) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Mazowsze / Białostockie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mazowieckie",
    "categoryPath": [
      "(10286) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Mazowsze"
    ],
    "hierarchy": "(10286) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Mazowsze / Mazowieckie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Warszawa",
    "categoryPath": [
      "(10287) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Mazowsze"
    ],
    "hierarchy": "(10287) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Mazowsze / Warszawa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karpaty i Podkarpacie",
    "categoryPath": [
      "(10275) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Małopolska"
    ],
    "hierarchy": "(10275) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Małopolska / Karpaty i Podkarpacie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraków i okolice",
    "categoryPath": [
      "(10276) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Małopolska"
    ],
    "hierarchy": "(10276) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Małopolska / Kraków i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rzeszów i okolice",
    "categoryPath": [
      "(10277) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Małopolska"
    ],
    "hierarchy": "(10277) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Małopolska / Rzeszów i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gdańsk i okolice",
    "categoryPath": [
      "(10300) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Pomorze (Pommern)"
    ],
    "hierarchy": "(10300) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Pomorze (Pommern) / Gdańsk i okolice",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kujawy i Pomorze Pd",
    "categoryPath": [
      "(10295) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Pomorze (Pommern)"
    ],
    "hierarchy": "(10295) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Pomorze (Pommern) / Kujawy i Pomorze Pd",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pomorze Wschodnie",
    "categoryPath": [
      "(10297) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Pomorze (Pommern)"
    ],
    "hierarchy": "(10297) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Pomorze (Pommern) / Pomorze Wschodnie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pomorze Zachodnie",
    "categoryPath": [
      "(10298) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Pomorze (Pommern)"
    ],
    "hierarchy": "(10298) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Pomorze (Pommern) / Pomorze Zachodnie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pomorze Środkowe",
    "categoryPath": [
      "(10296) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Pomorze (Pommern)"
    ],
    "hierarchy": "(10296) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Pomorze (Pommern) / Pomorze Środkowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szczecin",
    "categoryPath": [
      "(10299) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Pomorze (Pommern)"
    ],
    "hierarchy": "(10299) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Pomorze (Pommern) / Szczecin",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe miasta i regiony",
    "categoryPath": [
      "(10348) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska"
    ],
    "hierarchy": "(10348) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Pozostałe miasta i regiony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mazury",
    "categoryPath": [
      "(10327) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Warmia i Mazury (Ostpreussen)"
    ],
    "hierarchy": "(10327) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Warmia i Mazury (Ostpreussen) / Mazury",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(10329) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Warmia i Mazury (Ostpreussen)"
    ],
    "hierarchy": "(10329) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Warmia i Mazury (Ostpreussen) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Warmia",
    "categoryPath": [
      "(10328) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Warmia i Mazury (Ostpreussen)"
    ],
    "hierarchy": "(10328) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Warmia i Mazury (Ostpreussen) / Warmia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Leszczyńskie",
    "categoryPath": [
      "(10335) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Wielkopolska (Grosspolen)"
    ],
    "hierarchy": "(10335) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Wielkopolska (Grosspolen) / Leszczyńskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Poznańskie",
    "categoryPath": [
      "(10336) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Wielkopolska (Grosspolen)"
    ],
    "hierarchy": "(10336) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Wielkopolska (Grosspolen) / Poznańskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lubuskie (Ostbrandenburg)",
    "categoryPath": [
      "(10343) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Zielonogórskie i Lubuskie"
    ],
    "hierarchy": "(10343) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Zielonogórskie i Lubuskie / Lubuskie (Ostbrandenburg)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zielonogórskie (Grünberg)",
    "categoryPath": [
      "(10342) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Zielonogórskie i Lubuskie"
    ],
    "hierarchy": "(10342) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Zielonogórskie i Lubuskie / Zielonogórskie (Grünberg)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Górny Śląsk (Oberschlesien)",
    "categoryPath": [
      "(10314) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Śląsk (Schlesien)"
    ],
    "hierarchy": "(10314) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Śląsk (Schlesien) / Górny Śląsk (Oberschlesien)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zagłębie",
    "categoryPath": [
      "(10317) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Śląsk (Schlesien)"
    ],
    "hierarchy": "(10317) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Śląsk (Schlesien) / Zagłębie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Śląsk Cieszyński",
    "categoryPath": [
      "(10315) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Śląsk (Schlesien)"
    ],
    "hierarchy": "(10315) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Śląsk (Schlesien) / Śląsk Cieszyński",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Śląsk Opolski (Oppeln)",
    "categoryPath": [
      "(10316) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Polska",
      "Śląsk (Schlesien)"
    ],
    "hierarchy": "(10316) Kolekcje i sztuka / Kolekcje / Pocztówki / Polska / Śląsk (Schlesien) / Śląsk Opolski (Oppeln)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(10381) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki"
    ],
    "hierarchy": "(10381) Kolekcje i sztuka / Kolekcje / Pocztówki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Artystyczne",
    "categoryPath": [
      "(10382) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10382) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Artystyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Boże Narodzenie",
    "categoryPath": [
      "(147546) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(147546) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Boże Narodzenie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Erotyka i Akt",
    "categoryPath": [
      "(10362) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10362) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Erotyka i Akt",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Etnografia",
    "categoryPath": [
      "(10361) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10361) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Etnografia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Flora i Fauna",
    "categoryPath": [
      "(10369) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10369) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Flora i Fauna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Humor",
    "categoryPath": [
      "(10363) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10363) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Humor",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Judaica",
    "categoryPath": [
      "(10364) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10364) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Judaica",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kino, teatr i reklama",
    "categoryPath": [
      "(10365) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10365) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Kino, teatr i reklama",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolejnictwo",
    "categoryPath": [
      "(10368) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10368) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Kolejnictwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malarstwo",
    "categoryPath": [
      "(10359) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10359) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Malarstwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mapki",
    "categoryPath": [
      "(10367) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10367) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Mapki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Nowy Rok",
    "categoryPath": [
      "(256502) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(256502) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Nowy Rok",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Okolicznościowe",
    "categoryPath": [
      "(147548) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(147548) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Okolicznościowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Religijne",
    "categoryPath": [
      "(147545) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(147545) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Religijne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Samoloty i samochody",
    "categoryPath": [
      "(10370) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10370) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Samoloty i samochody",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sport",
    "categoryPath": [
      "(10371) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10371) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Sport",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Statki i okręty",
    "categoryPath": [
      "(10372) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10372) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Statki i okręty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sztuka",
    "categoryPath": [
      "(10360) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10360) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Sztuka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Sławni ludzie",
    "categoryPath": [
      "(10366) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10366) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Sławni ludzie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tramwaje i trolejbusy",
    "categoryPath": [
      "(10374) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10374) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Tramwaje i trolejbusy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Trójwymiarowe i muzyczne",
    "categoryPath": [
      "(10376) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10376) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Trójwymiarowe i muzyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Twierdze, zamki, pałace",
    "categoryPath": [
      "(10375) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10375) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Twierdze, zamki, pałace",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wielkanoc",
    "categoryPath": [
      "(147547) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(147547) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Wielkanoc",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wojskowe i patriotyczne",
    "categoryPath": [
      "(10377) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Tematyczne"
    ],
    "hierarchy": "(10377) Kolekcje i sztuka / Kolekcje / Pocztówki / Tematyczne / Wojskowe i patriotyczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Afryka",
    "categoryPath": [
      "(10350) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne"
    ],
    "hierarchy": "(10350) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Afryka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ameryka Pn i Pd",
    "categoryPath": [
      "(10351) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne"
    ],
    "hierarchy": "(10351) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Ameryka Pn i Pd",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Australia i Oceania",
    "categoryPath": [
      "(10352) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne"
    ],
    "hierarchy": "(10352) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Australia i Oceania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Azja",
    "categoryPath": [
      "(10353) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne"
    ],
    "hierarchy": "(10353) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Azja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Austria i Szwajcaria",
    "categoryPath": [
      "(320653) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(320653) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Austria i Szwajcaria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Bałkany",
    "categoryPath": [
      "(319748) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(319748) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Bałkany",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Francja",
    "categoryPath": [
      "(309697) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(309697) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Francja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Hiszpania i Portugalia",
    "categoryPath": [
      "(319742) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(319742) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Hiszpania i Portugalia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje Beneluksu",
    "categoryPath": [
      "(319733) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(319733) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Kraje Beneluksu",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje Skandynawskie",
    "categoryPath": [
      "(319736) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(319736) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Kraje Skandynawskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kraje bałtyckie",
    "categoryPath": [
      "(320659) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(320659) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Kraje bałtyckie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Niemcy",
    "categoryPath": [
      "(10355) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(10355) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Niemcy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(10357) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(10357) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rosja",
    "categoryPath": [
      "(10356) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(10356) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Rosja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ukraina",
    "categoryPath": [
      "(320656) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(320656) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Ukraina",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wielka Brytania i Irlandia",
    "categoryPath": [
      "(319745) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(319745) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Wielka Brytania i Irlandia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Węgry",
    "categoryPath": [
      "(320662) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(320662) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Węgry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Włochy",
    "categoryPath": [
      "(309709) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki",
      "Zagraniczne",
      "Europa"
    ],
    "hierarchy": "(309709) Kolekcje i sztuka / Kolekcje / Pocztówki / Zagraniczne / Europa / Włochy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zestawy i kolekcje",
    "categoryPath": [
      "(10385) Kolekcje i sztuka",
      "Kolekcje",
      "Pocztówki"
    ],
    "hierarchy": "(10385) Kolekcje i sztuka / Kolekcje / Pocztówki / Zestawy i kolekcje",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(260773) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania"
    ],
    "hierarchy": "(260773) Kolekcje i sztuka / Kolekcje / Poszukiwania / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(260774) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania"
    ],
    "hierarchy": "(260774) Kolekcje i sztuka / Kolekcje / Poszukiwania / Literatura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Cewki",
    "categoryPath": [
      "(74255) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania",
      "Wykrywacze metali"
    ],
    "hierarchy": "(74255) Kolekcje i sztuka / Kolekcje / Poszukiwania / Wykrywacze metali / Cewki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(321536) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania",
      "Wykrywacze metali"
    ],
    "hierarchy": "(321536) Kolekcje i sztuka / Kolekcje / Poszukiwania / Wykrywacze metali / Części",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Detektory",
    "categoryPath": [
      "(74254) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania",
      "Wykrywacze metali"
    ],
    "hierarchy": "(74254) Kolekcje i sztuka / Kolekcje / Poszukiwania / Wykrywacze metali / Detektory",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Osłony i torby",
    "categoryPath": [
      "(74257) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania",
      "Wykrywacze metali"
    ],
    "hierarchy": "(74257) Kolekcje i sztuka / Kolekcje / Poszukiwania / Wykrywacze metali / Osłony i torby",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Słuchawki",
    "categoryPath": [
      "(74256) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania",
      "Wykrywacze metali"
    ],
    "hierarchy": "(74256) Kolekcje i sztuka / Kolekcje / Poszukiwania / Wykrywacze metali / Słuchawki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zasilanie",
    "categoryPath": [
      "(74258) Kolekcje i sztuka",
      "Kolekcje",
      "Poszukiwania",
      "Wykrywacze metali"
    ],
    "hierarchy": "(74258) Kolekcje i sztuka / Kolekcje / Poszukiwania / Wykrywacze metali / Zasilanie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Film",
    "categoryPath": [
      "(93869) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Autografy"
    ],
    "hierarchy": "(93869) Kolekcje i sztuka / Kolekcje / Pozostałe / Autografy / Film",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Książka",
    "categoryPath": [
      "(99862) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Autografy"
    ],
    "hierarchy": "(99862) Kolekcje i sztuka / Kolekcje / Pozostałe / Autografy / Książka",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Muzyka",
    "categoryPath": [
      "(99860) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Autografy"
    ],
    "hierarchy": "(99860) Kolekcje i sztuka / Kolekcje / Pozostałe / Autografy / Muzyka",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Polityka",
    "categoryPath": [
      "(93870) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Autografy"
    ],
    "hierarchy": "(93870) Kolekcje i sztuka / Kolekcje / Pozostałe / Autografy / Polityka",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93873) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Autografy"
    ],
    "hierarchy": "(93873) Kolekcje i sztuka / Kolekcje / Pozostałe / Autografy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Religia",
    "categoryPath": [
      "(99861) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Autografy"
    ],
    "hierarchy": "(99861) Kolekcje i sztuka / Kolekcje / Pozostałe / Autografy / Religia",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sport",
    "categoryPath": [
      "(93872) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Autografy"
    ],
    "hierarchy": "(93872) Kolekcje i sztuka / Kolekcje / Pozostałe / Autografy / Sport",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Breloki",
    "categoryPath": [
      "(47934) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(47934) Kolekcje i sztuka / Kolekcje / Pozostałe / Breloki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Długopisy i pióra",
    "categoryPath": [
      "(47935) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(47935) Kolekcje i sztuka / Kolekcje / Pozostałe / Długopisy i pióra",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Etykiety butelkowe",
    "categoryPath": [
      "(53671) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(53671) Kolekcje i sztuka / Kolekcje / Pozostałe / Etykiety butelkowe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Etykiety zapałczane",
    "categoryPath": [
      "(3563) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(3563) Kolekcje i sztuka / Kolekcje / Pozostałe / Etykiety zapałczane",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Guziki",
    "categoryPath": [
      "(28464) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(28464) Kolekcje i sztuka / Kolekcje / Pozostałe / Guziki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kalendarze listkowe",
    "categoryPath": [
      "(47933) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(47933) Kolekcje i sztuka / Kolekcje / Pozostałe / Kalendarze listkowe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kinder-niespodzianki",
    "categoryPath": [
      "(889) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(889) Kolekcje i sztuka / Kolekcje / Pozostałe / Kinder-niespodzianki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(53659) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Kolekcje dziecięce"
    ],
    "hierarchy": "(53659) Kolekcje i sztuka / Kolekcje / Pozostałe / Kolekcje dziecięce / Figurki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Karteczki",
    "categoryPath": [
      "(53660) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Kolekcje dziecięce"
    ],
    "hierarchy": "(53660) Kolekcje i sztuka / Kolekcje / Pozostałe / Kolekcje dziecięce / Karteczki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Obrazki i żetony",
    "categoryPath": [
      "(53661) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Kolekcje dziecięce"
    ],
    "hierarchy": "(53661) Kolekcje i sztuka / Kolekcje / Pozostałe / Kolekcje dziecięce / Obrazki i żetony",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(53663) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Kolekcje dziecięce"
    ],
    "hierarchy": "(53663) Kolekcje i sztuka / Kolekcje / Pozostałe / Kolekcje dziecięce / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Segregatory",
    "categoryPath": [
      "(53662) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Kolekcje dziecięce"
    ],
    "hierarchy": "(53662) Kolekcje i sztuka / Kolekcje / Pozostałe / Kolekcje dziecięce / Segregatory",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kubki",
    "categoryPath": [
      "(53672) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(53672) Kolekcje i sztuka / Kolekcje / Pozostałe / Kubki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kule śnieżne",
    "categoryPath": [
      "(317228) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(317228) Kolekcje i sztuka / Kolekcje / Pozostałe / Kule śnieżne",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Magnesy",
    "categoryPath": [
      "(93874) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(93874) Kolekcje i sztuka / Kolekcje / Pozostałe / Magnesy",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(260930) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Owady, pajęczaki i inne"
    ],
    "hierarchy": "(260930) Kolekcje i sztuka / Kolekcje / Pozostałe / Owady, pajęczaki i inne / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chrząszcze",
    "categoryPath": [
      "(93884) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Owady, pajęczaki i inne"
    ],
    "hierarchy": "(93884) Kolekcje i sztuka / Kolekcje / Pozostałe / Owady, pajęczaki i inne / Chrząszcze",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Modliszki",
    "categoryPath": [
      "(260931) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Owady, pajęczaki i inne"
    ],
    "hierarchy": "(260931) Kolekcje i sztuka / Kolekcje / Pozostałe / Owady, pajęczaki i inne / Modliszki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Motyle",
    "categoryPath": [
      "(93883) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Owady, pajęczaki i inne"
    ],
    "hierarchy": "(93883) Kolekcje i sztuka / Kolekcje / Pozostałe / Owady, pajęczaki i inne / Motyle",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pajęczaki",
    "categoryPath": [
      "(93885) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Owady, pajęczaki i inne"
    ],
    "hierarchy": "(93885) Kolekcje i sztuka / Kolekcje / Pozostałe / Owady, pajęczaki i inne / Pajęczaki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pluskwiaki",
    "categoryPath": [
      "(260932) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Owady, pajęczaki i inne"
    ],
    "hierarchy": "(260932) Kolekcje i sztuka / Kolekcje / Pozostałe / Owady, pajęczaki i inne / Pluskwiaki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(99859) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Owady, pajęczaki i inne"
    ],
    "hierarchy": "(99859) Kolekcje i sztuka / Kolekcje / Pozostałe / Owady, pajęczaki i inne / Zestawy",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(320) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(320) Kolekcje i sztuka / Kolekcje / Pozostałe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Puszki",
    "categoryPath": [
      "(53670) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(53670) Kolekcje i sztuka / Kolekcje / Pozostałe / Puszki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Solidarność",
    "categoryPath": [
      "(19189) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(19189) Kolekcje i sztuka / Kolekcje / Pozostałe / Solidarność",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stare zabawki",
    "categoryPath": [
      "(26012) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(26012) Kolekcje i sztuka / Kolekcje / Pozostałe / Stare zabawki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria dla lalek",
    "categoryPath": [
      "(260987) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Stare zabawki"
    ],
    "hierarchy": "(260987) Kolekcje i sztuka / Kolekcje / Pozostałe / Stare zabawki / Akcesoria dla lalek",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(260984) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Stare zabawki"
    ],
    "hierarchy": "(260984) Kolekcje i sztuka / Kolekcje / Pozostałe / Stare zabawki / Figurki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Lalki",
    "categoryPath": [
      "(260986) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Stare zabawki"
    ],
    "hierarchy": "(260986) Kolekcje i sztuka / Kolekcje / Pozostałe / Stare zabawki / Lalki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Maskotki",
    "categoryPath": [
      "(260985) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Stare zabawki"
    ],
    "hierarchy": "(260985) Kolekcje i sztuka / Kolekcje / Pozostałe / Stare zabawki / Maskotki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pojazdy",
    "categoryPath": [
      "(260983) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Stare zabawki"
    ],
    "hierarchy": "(260983) Kolekcje i sztuka / Kolekcje / Pozostałe / Stare zabawki / Pojazdy",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skarbonki",
    "categoryPath": [
      "(260982) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Stare zabawki"
    ],
    "hierarchy": "(260982) Kolekcje i sztuka / Kolekcje / Pozostałe / Stare zabawki / Skarbonki",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kolejnictwo",
    "categoryPath": [
      "(321410) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Transport"
    ],
    "hierarchy": "(321410) Kolekcje i sztuka / Kolekcje / Pozostałe / Transport / Kolejnictwo",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Komunikacja miejska i PKS",
    "categoryPath": [
      "(321385) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Transport"
    ],
    "hierarchy": "(321385) Kolekcje i sztuka / Kolekcje / Pozostałe / Transport / Komunikacja miejska i PKS",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Lotnictwo",
    "categoryPath": [
      "(321384) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Transport"
    ],
    "hierarchy": "(321384) Kolekcje i sztuka / Kolekcje / Pozostałe / Transport / Lotnictwo",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Transport wodny",
    "categoryPath": [
      "(317799) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe",
      "Transport"
    ],
    "hierarchy": "(317799) Kolekcje i sztuka / Kolekcje / Pozostałe / Transport / Transport wodny",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Znaczki turystyczne",
    "categoryPath": [
      "(317802) Kolekcje i sztuka",
      "Kolekcje",
      "Pozostałe"
    ],
    "hierarchy": "(317802) Kolekcje i sztuka / Kolekcje / Pozostałe / Znaczki turystyczne",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Literatura i akcesoria",
    "categoryPath": [
      "(11919) Kolekcje i sztuka",
      "Kolekcje",
      "Skamieliny, minerały i muszle"
    ],
    "hierarchy": "(11919) Kolekcje i sztuka / Kolekcje / Skamieliny, minerały i muszle / Literatura i akcesoria",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Meteoryty",
    "categoryPath": [
      "(11930) Kolekcje i sztuka",
      "Kolekcje",
      "Skamieliny, minerały i muszle"
    ],
    "hierarchy": "(11930) Kolekcje i sztuka / Kolekcje / Skamieliny, minerały i muszle / Meteoryty",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Minerały",
    "categoryPath": [
      "(11916) Kolekcje i sztuka",
      "Kolekcje",
      "Skamieliny, minerały i muszle"
    ],
    "hierarchy": "(11916) Kolekcje i sztuka / Kolekcje / Skamieliny, minerały i muszle / Minerały",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Muszle",
    "categoryPath": [
      "(11918) Kolekcje i sztuka",
      "Kolekcje",
      "Skamieliny, minerały i muszle"
    ],
    "hierarchy": "(11918) Kolekcje i sztuka / Kolekcje / Skamieliny, minerały i muszle / Muszle",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skamieliny",
    "categoryPath": [
      "(11917) Kolekcje i sztuka",
      "Kolekcje",
      "Skamieliny, minerały i muszle"
    ],
    "hierarchy": "(11917) Kolekcje i sztuka / Kolekcje / Skamieliny, minerały i muszle / Skamieliny",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Gilzy i bletki",
    "categoryPath": [
      "(78997) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(78997) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Gilzy i bletki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Humidory",
    "categoryPath": [
      "(315885) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(315885) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Humidory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kulki smakowe do papierosów",
    "categoryPath": [
      "(318159) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(318159) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Kulki smakowe do papierosów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lufki",
    "categoryPath": [
      "(79000) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(79000) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Lufki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nabijarki",
    "categoryPath": [
      "(78996) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(78996) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Nabijarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obcinarki",
    "categoryPath": [
      "(315891) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(315891) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Obcinarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Papierośnice",
    "categoryPath": [
      "(78999) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(78999) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Papierośnice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pojemniki, etui",
    "categoryPath": [
      "(315888) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(315888) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Pojemniki, etui",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Popielnice",
    "categoryPath": [
      "(315894) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(315894) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Popielnice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Popielniczki",
    "categoryPath": [
      "(78998) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Akcesoria papierosowe"
    ],
    "hierarchy": "(78998) Kolekcje i sztuka / Kolekcje / Trafika / Akcesoria papierosowe / Popielniczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(126064) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Fajki tradycyjne"
    ],
    "hierarchy": "(126064) Kolekcje i sztuka / Kolekcje / Trafika / Fajki tradycyjne / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Fajki",
    "categoryPath": [
      "(126062) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Fajki tradycyjne"
    ],
    "hierarchy": "(126062) Kolekcje i sztuka / Kolekcje / Trafika / Fajki tradycyjne / Fajki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(126067) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Fajki wodne"
    ],
    "hierarchy": "(126067) Kolekcje i sztuka / Kolekcje / Trafika / Fajki wodne / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Fajki",
    "categoryPath": [
      "(126065) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika",
      "Fajki wodne"
    ],
    "hierarchy": "(126065) Kolekcje i sztuka / Kolekcje / Trafika / Fajki wodne / Fajki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(47957) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika"
    ],
    "hierarchy": "(47957) Kolekcje i sztuka / Kolekcje / Trafika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zapalniczki",
    "categoryPath": [
      "(47956) Kolekcje i sztuka",
      "Kolekcje",
      "Trafika"
    ],
    "hierarchy": "(47956) Kolekcje i sztuka / Kolekcje / Trafika / Zapalniczki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Diamenty",
    "categoryPath": [
      "(257918) Kolekcje i sztuka",
      "Produkty inwestycyjne"
    ],
    "hierarchy": "(257918) Kolekcje i sztuka / Produkty inwestycyjne / Diamenty",
    "comissionGroupOld": "C25",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Platyna, pallad i miedź",
    "categoryPath": [
      "(260178) Kolekcje i sztuka",
      "Produkty inwestycyjne"
    ],
    "hierarchy": "(260178) Kolekcje i sztuka / Produkty inwestycyjne / Platyna, pallad i miedź",
    "comissionGroupOld": "C26",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Monety inwestycyjne",
    "categoryPath": [
      "(257924) Kolekcje i sztuka",
      "Produkty inwestycyjne",
      "Srebro"
    ],
    "hierarchy": "(257924) Kolekcje i sztuka / Produkty inwestycyjne / Srebro / Monety inwestycyjne",
    "comissionGroupOld": "C25",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Sztabki",
    "categoryPath": [
      "(257926) Kolekcje i sztuka",
      "Produkty inwestycyjne",
      "Srebro"
    ],
    "hierarchy": "(257926) Kolekcje i sztuka / Produkty inwestycyjne / Srebro / Sztabki",
    "comissionGroupOld": "C25",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Złom srebra i złota",
    "categoryPath": [
      "(321771) Kolekcje i sztuka",
      "Produkty inwestycyjne"
    ],
    "hierarchy": "(321771) Kolekcje i sztuka / Produkty inwestycyjne / Złom srebra i złota",
    "comissionGroupOld": "C25",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Monety inwestycyjne",
    "categoryPath": [
      "(257920) Kolekcje i sztuka",
      "Produkty inwestycyjne",
      "Złoto"
    ],
    "hierarchy": "(257920) Kolekcje i sztuka / Produkty inwestycyjne / Złoto / Monety inwestycyjne",
    "comissionGroupOld": "C25",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Sztabki",
    "categoryPath": [
      "(257922) Kolekcje i sztuka",
      "Produkty inwestycyjne",
      "Złoto"
    ],
    "hierarchy": "(257922) Kolekcje i sztuka / Produkty inwestycyjne / Złoto / Sztabki",
    "comissionGroupOld": "C25",
    "comissionGroupNew": "D20"
  },
  {
    "segment": "Bursztyn",
    "categoryPath": [
      "(76654) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty"
    ],
    "hierarchy": "(76654) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Bursztyn",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Cekiny",
    "categoryPath": [
      "(259833) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty"
    ],
    "hierarchy": "(259833) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Cekiny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kamienie ozdobne",
    "categoryPath": [
      "(76751) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty"
    ],
    "hierarchy": "(76751) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie ozdobne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Agaty",
    "categoryPath": [
      "(259973) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259973) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Agaty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Amazonity",
    "categoryPath": [
      "(305889) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(305889) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Amazonity",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Ametysty",
    "categoryPath": [
      "(259974) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259974) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Ametysty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Czaroit",
    "categoryPath": [
      "(309217) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(309217) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Czaroit",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Fluoryty",
    "categoryPath": [
      "(305925) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(305925) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Fluoryty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Hematyty",
    "categoryPath": [
      "(259975) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259975) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Hematyty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Howlity",
    "categoryPath": [
      "(305913) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(305913) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Howlity",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Jadeity",
    "categoryPath": [
      "(259976) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259976) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Jadeity",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Jaspisy",
    "categoryPath": [
      "(259977) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259977) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Jaspisy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kamienie księżycowe",
    "categoryPath": [
      "(259978) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259978) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Kamienie księżycowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kamienie słoneczne",
    "categoryPath": [
      "(305937) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(305937) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Kamienie słoneczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kryształy górskie",
    "categoryPath": [
      "(259979) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259979) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Kryształy górskie",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kwarce",
    "categoryPath": [
      "(305901) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(305901) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Kwarce",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Labradoryty",
    "categoryPath": [
      "(259980) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259980) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Labradoryty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Malachity",
    "categoryPath": [
      "(259981) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259981) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Malachity",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Onyksy",
    "categoryPath": [
      "(259982) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259982) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Onyksy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259972) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259972) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Topazy",
    "categoryPath": [
      "(259968) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259968) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Topazy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Turkusy",
    "categoryPath": [
      "(259969) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259969) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Turkusy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Turmaliny",
    "categoryPath": [
      "(259970) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259970) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Turmaliny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Tygrysie oko",
    "categoryPath": [
      "(259971) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie półszlachetne"
    ],
    "hierarchy": "(259971) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie półszlachetne / Tygrysie oko",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kamienie syntetyczne",
    "categoryPath": [
      "(76655) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty"
    ],
    "hierarchy": "(76655) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie syntetyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Akwamaryny",
    "categoryPath": [
      "(259844) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(259844) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Akwamaryny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Aleksandryty",
    "categoryPath": [
      "(76752) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76752) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Aleksandryty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Awenturyn",
    "categoryPath": [
      "(309193) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(309193) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Awenturyn",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Cytryn",
    "categoryPath": [
      "(309205) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(309205) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Cytryn",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Diamenty",
    "categoryPath": [
      "(76753) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76753) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Diamenty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Moissanity",
    "categoryPath": [
      "(322832) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(322832) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Moissanity",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Opale",
    "categoryPath": [
      "(76754) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76754) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Opale",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76761) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76761) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rubiny",
    "categoryPath": [
      "(76755) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76755) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Rubiny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szafiry",
    "categoryPath": [
      "(76756) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76756) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Szafiry",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szmaragdy",
    "categoryPath": [
      "(76757) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76757) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Szmaragdy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Tanzanity",
    "categoryPath": [
      "(76758) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Kamienie szlachetne"
    ],
    "hierarchy": "(76758) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Kamienie szlachetne / Tanzanity",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Drewno",
    "categoryPath": [
      "(259859) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki naturalne"
    ],
    "hierarchy": "(259859) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki naturalne / Drewno",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Koral",
    "categoryPath": [
      "(259857) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki naturalne"
    ],
    "hierarchy": "(259857) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki naturalne / Koral",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Lawa wulkaniczna",
    "categoryPath": [
      "(309229) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki naturalne"
    ],
    "hierarchy": "(309229) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki naturalne / Lawa wulkaniczna",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Perły, masa perłowa, muszle",
    "categoryPath": [
      "(259858) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki naturalne"
    ],
    "hierarchy": "(259858) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki naturalne / Perły, masa perłowa, muszle",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Koraliki porcelanowe",
    "categoryPath": [
      "(259850) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259850) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Koraliki porcelanowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259867) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259867) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szklane - TOHO",
    "categoryPath": [
      "(260013) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(260013) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - TOHO",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - crackle",
    "categoryPath": [
      "(260011) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(260011) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - crackle",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - czeskie",
    "categoryPath": [
      "(259874) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259874) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - czeskie",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - kryształki",
    "categoryPath": [
      "(259868) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259868) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - kryształki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - kryształki Swarovski",
    "categoryPath": [
      "(260012) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(260012) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - kryształki Swarovski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - lampwork",
    "categoryPath": [
      "(259869) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259869) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - lampwork",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - millefiori",
    "categoryPath": [
      "(259870) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259870) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - millefiori",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - miyuki",
    "categoryPath": [
      "(260014) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(260014) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - miyuki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - perełki, kuleczki",
    "categoryPath": [
      "(259871) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259871) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - perełki, kuleczki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - powlekane",
    "categoryPath": [
      "(259872) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259872) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - powlekane",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szklane - weneckie",
    "categoryPath": [
      "(259873) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki porcelanowe i szklane"
    ],
    "hierarchy": "(259873) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki porcelanowe i szklane / Szklane - weneckie",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Akrylowe",
    "categoryPath": [
      "(259851) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259851) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Akrylowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Koraliki pozostałe",
    "categoryPath": [
      "(259855) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259855) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Koraliki pozostałe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Modułowe",
    "categoryPath": [
      "(259853) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259853) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Modułowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Plastikowe - caramballa",
    "categoryPath": [
      "(259862) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259862) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Plastikowe - caramballa",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Plastikowe - fimo",
    "categoryPath": [
      "(259863) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259863) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Plastikowe - fimo",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Plastikowe - kostki",
    "categoryPath": [
      "(259865) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259865) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Plastikowe - kostki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Plastikowe - kryształki",
    "categoryPath": [
      "(259866) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259866) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Plastikowe - kryształki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Plastikowe - perełki, kuleczki",
    "categoryPath": [
      "(259864) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259864) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Plastikowe - perełki, kuleczki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Welurowe",
    "categoryPath": [
      "(259854) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Koraliki syntetyczne"
    ],
    "hierarchy": "(259854) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Koraliki syntetyczne / Welurowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Gumki polerskie",
    "categoryPath": [
      "(259822) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259822) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Gumki polerskie",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Igły",
    "categoryPath": [
      "(259878) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259878) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Igły",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(259826) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259826) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Kleje",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Krosna",
    "categoryPath": [
      "(310057) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(310057) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Krosna",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Lupy",
    "categoryPath": [
      "(259823) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259823) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Lupy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Nożyce, nożyczki",
    "categoryPath": [
      "(310121) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(310121) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Nożyce, nożyczki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Papiery ścierne",
    "categoryPath": [
      "(259825) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259825) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Papiery ścierne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Puncyny",
    "categoryPath": [
      "(259824) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259824) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Puncyny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pęsety",
    "categoryPath": [
      "(259821) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259821) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Pęsety",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szczypce, kleszcze",
    "categoryPath": [
      "(259820) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(259820) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Szczypce, kleszcze",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(310045) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Narzędzia i kleje"
    ],
    "hierarchy": "(310045) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Narzędzia i kleje / Zestawy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Opakowania, metki",
    "categoryPath": [
      "(259838) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty"
    ],
    "hierarchy": "(259838) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Opakowania, metki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Organizery, pojemniki, stojaki",
    "categoryPath": [
      "(259837) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty"
    ],
    "hierarchy": "(259837) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Organizery, pojemniki, stojaki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Breloki",
    "categoryPath": [
      "(259827) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(259827) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Breloki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Broszki",
    "categoryPath": [
      "(259828) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(259828) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Broszki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kolczyki",
    "categoryPath": [
      "(259829) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(259829) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Kolczyki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Naszyjniki",
    "categoryPath": [
      "(310133) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(310133) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Naszyjniki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Opaski i spinki do włosów",
    "categoryPath": [
      "(259831) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(259831) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Opaski i spinki do włosów",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pierścionki",
    "categoryPath": [
      "(259830) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(259830) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Pierścionki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(98593) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(98593) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spinki do mankietów",
    "categoryPath": [
      "(259832) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(259832) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Spinki do mankietów",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zapięcia",
    "categoryPath": [
      "(310145) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty",
      "Bazy"
    ],
    "hierarchy": "(310145) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bazy / Zapięcia",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Bigle i sztyfty",
    "categoryPath": [
      "(76672) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76672) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Bigle i sztyfty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Chwosty",
    "categoryPath": [
      "(259909) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(259909) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Chwosty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Drut jubilerski",
    "categoryPath": [
      "(76762) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76762) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Drut jubilerski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Elementy ozdobne",
    "categoryPath": [
      "(76763) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76763) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Elementy ozdobne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Linki i żyłki",
    "categoryPath": [
      "(76673) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76673) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Linki i żyłki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Przekładki",
    "categoryPath": [
      "(98614) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(98614) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Przekładki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Rurki",
    "categoryPath": [
      "(98613) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(98613) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Rurki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Rzemyki i sznurek jubilerski",
    "categoryPath": [
      "(76674) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76674) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Rzemyki i sznurek jubilerski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Siatki jubilerskie",
    "categoryPath": [
      "(259847) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(259847) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Siatki jubilerskie",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szpilki i haczyki",
    "categoryPath": [
      "(76678) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76678) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Szpilki i haczyki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zaciski i stopery",
    "categoryPath": [
      "(76679) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76679) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Zaciski i stopery",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zapięcia i karabińczyki",
    "categoryPath": [
      "(76680) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76680) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Zapięcia i karabińczyki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zawieszki",
    "categoryPath": [
      "(98333) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(98333) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Zawieszki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Łapaczki i końcówki",
    "categoryPath": [
      "(76676) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76676) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Łapaczki i końcówki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Łańcuszki i ogniwa",
    "categoryPath": [
      "(76675) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Półfabrykaty"
    ],
    "hierarchy": "(76675) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Półfabrykaty / Łańcuszki i ogniwa",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kaboszony",
    "categoryPath": [
      "(259842) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Sutasz"
    ],
    "hierarchy": "(259842) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Sutasz / Kaboszony",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Koraliki",
    "categoryPath": [
      "(259841) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Sutasz"
    ],
    "hierarchy": "(259841) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Sutasz / Koraliki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Sznurki",
    "categoryPath": [
      "(259840) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty",
      "Sutasz"
    ],
    "hierarchy": "(259840) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Sutasz / Sznurki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy do tworzenia biżuterii",
    "categoryPath": [
      "(259836) Kolekcje i sztuka",
      "Rękodzieło",
      "Biżuteria - półprodukty"
    ],
    "hierarchy": "(259836) Kolekcje i sztuka / Rękodzieło / Biżuteria - półprodukty / Zestawy do tworzenia biżuterii",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Farby i lakiery",
    "categoryPath": [
      "(76686) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(76686) Kolekcje i sztuka / Rękodzieło / Decoupage / Farby i lakiery",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Haczyki",
    "categoryPath": [
      "(259160) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(259160) Kolekcje i sztuka / Rękodzieło / Decoupage / Haczyki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kleje i media",
    "categoryPath": [
      "(76687) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(76687) Kolekcje i sztuka / Rękodzieło / Decoupage / Kleje i media",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Narzędzia i pędzle",
    "categoryPath": [
      "(76688) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(76688) Kolekcje i sztuka / Rękodzieło / Decoupage / Narzędzia i pędzle",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Papiery",
    "categoryPath": [
      "(76689) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(76689) Kolekcje i sztuka / Rękodzieło / Decoupage / Papiery",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76692) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(76692) Kolekcje i sztuka / Rękodzieło / Decoupage / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kieliszki",
    "categoryPath": [
      "(315702) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania",
      "Akcesoria kuchenne"
    ],
    "hierarchy": "(315702) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Akcesoria kuchenne / Kieliszki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Misy, cukiernice",
    "categoryPath": [
      "(315705) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania",
      "Akcesoria kuchenne"
    ],
    "hierarchy": "(315705) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Akcesoria kuchenne / Misy, cukiernice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Przybory",
    "categoryPath": [
      "(315708) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania",
      "Akcesoria kuchenne"
    ],
    "hierarchy": "(315708) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Akcesoria kuchenne / Przybory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sztućce",
    "categoryPath": [
      "(315699) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania",
      "Akcesoria kuchenne"
    ],
    "hierarchy": "(315699) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Akcesoria kuchenne / Sztućce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tace, deski",
    "categoryPath": [
      "(315696) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania",
      "Akcesoria kuchenne"
    ],
    "hierarchy": "(315696) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Akcesoria kuchenne / Tace, deski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Biżuteria",
    "categoryPath": [
      "(259357) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259357) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Biżuteria",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Chusteczniki",
    "categoryPath": [
      "(259003) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259003) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Chusteczniki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Dekoracje stojące",
    "categoryPath": [
      "(259304) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259304) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Dekoracje stojące",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Dekory",
    "categoryPath": [
      "(259002) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259002) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Dekory",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Herbaciarki",
    "categoryPath": [
      "(259009) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259009) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Herbaciarki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Klamerki",
    "categoryPath": [
      "(259066) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259066) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Klamerki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kule, jajka",
    "categoryPath": [
      "(259007) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259007) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Kule, jajka",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Plastry drewniane",
    "categoryPath": [
      "(259303) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259303) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Plastry drewniane",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Podkładki pod kubek",
    "categoryPath": [
      "(259163) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259163) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Podkładki pod kubek",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Przedmioty styropianowe",
    "categoryPath": [
      "(259162) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259162) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Przedmioty styropianowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Ramki",
    "categoryPath": [
      "(259004) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259004) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Ramki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Serwetniki",
    "categoryPath": [
      "(259008) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259008) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Serwetniki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Sklejki, płyty MDF",
    "categoryPath": [
      "(307969) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(307969) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Sklejki, płyty MDF",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Skrzynki, kuferki, pudełka",
    "categoryPath": [
      "(259001) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259001) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Skrzynki, kuferki, pudełka",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Toppery",
    "categoryPath": [
      "(259161) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259161) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Toppery",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zakładki do książek",
    "categoryPath": [
      "(259012) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259012) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Zakładki do książek",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zawieszki do samochodu",
    "categoryPath": [
      "(259005) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259005) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Zawieszki do samochodu",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zawieszki ozdobne",
    "categoryPath": [
      "(259006) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259006) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Zawieszki ozdobne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Świeczniki",
    "categoryPath": [
      "(259013) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage",
      "Przedmioty do ozdabiania"
    ],
    "hierarchy": "(259013) Kolekcje i sztuka / Rękodzieło / Decoupage / Przedmioty do ozdabiania / Świeczniki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Serwetki",
    "categoryPath": [
      "(76690) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(76690) Kolekcje i sztuka / Rękodzieło / Decoupage / Serwetki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Stojaki i podstawki",
    "categoryPath": [
      "(259159) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(259159) Kolekcje i sztuka / Rękodzieło / Decoupage / Stojaki i podstawki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Wzory i szablony",
    "categoryPath": [
      "(258963) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(258963) Kolekcje i sztuka / Rękodzieło / Decoupage / Wzory i szablony",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zatrzaski i uchwyty",
    "categoryPath": [
      "(258964) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(258964) Kolekcje i sztuka / Rękodzieło / Decoupage / Zatrzaski i uchwyty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy startowe",
    "categoryPath": [
      "(259000) Kolekcje i sztuka",
      "Rękodzieło",
      "Decoupage"
    ],
    "hierarchy": "(259000) Kolekcje i sztuka / Rękodzieło / Decoupage / Zestawy startowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Bobinki",
    "categoryPath": [
      "(315657) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(315657) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Akcesoria / Bobinki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Haft diamentowy",
    "categoryPath": [
      "(315675) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(315675) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Akcesoria / Haft diamentowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Krosna",
    "categoryPath": [
      "(176087) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(176087) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Akcesoria / Krosna",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Liczniki, znaczniki",
    "categoryPath": [
      "(315669) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(315669) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Akcesoria / Liczniki, znaczniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miarki do drutów, szydełek",
    "categoryPath": [
      "(315663) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(315663) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Akcesoria / Miarki do drutów, szydełek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obręcze",
    "categoryPath": [
      "(315666) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(315666) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Akcesoria / Obręcze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(315672) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(315672) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Akcesoria / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Czółenka",
    "categoryPath": [
      "(314817) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Druty, szydełka, czółenka"
    ],
    "hierarchy": "(314817) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Druty, szydełka, czółenka / Czółenka",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Druty",
    "categoryPath": [
      "(258757) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Druty, szydełka, czółenka"
    ],
    "hierarchy": "(258757) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Druty, szydełka, czółenka / Druty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szydełka",
    "categoryPath": [
      "(258551) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Druty, szydełka, czółenka"
    ],
    "hierarchy": "(258551) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Druty, szydełka, czółenka / Szydełka",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(258756) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo",
      "Druty, szydełka, czółenka"
    ],
    "hierarchy": "(258756) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Druty, szydełka, czółenka / Zestawy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kanwy",
    "categoryPath": [
      "(258755) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo"
    ],
    "hierarchy": "(258755) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Kanwy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kordonki",
    "categoryPath": [
      "(258642) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo"
    ],
    "hierarchy": "(258642) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Kordonki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Muliny",
    "categoryPath": [
      "(258555) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo"
    ],
    "hierarchy": "(258555) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Muliny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258559) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo"
    ],
    "hierarchy": "(258559) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyrządy do pomponów",
    "categoryPath": [
      "(258558) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo"
    ],
    "hierarchy": "(258558) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Przyrządy do pomponów",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Tamborki",
    "categoryPath": [
      "(258556) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo"
    ],
    "hierarchy": "(258556) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Tamborki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Włóczki",
    "categoryPath": [
      "(258557) Kolekcje i sztuka",
      "Rękodzieło",
      "Dziewiarstwo"
    ],
    "hierarchy": "(258557) Kolekcje i sztuka / Rękodzieło / Dziewiarstwo / Włóczki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Czesanka, wełna do filcowania",
    "categoryPath": [
      "(258967) Kolekcje i sztuka",
      "Rękodzieło",
      "Filcowanie"
    ],
    "hierarchy": "(258967) Kolekcje i sztuka / Rękodzieło / Filcowanie / Czesanka, wełna do filcowania",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Elementy zdobnicze",
    "categoryPath": [
      "(307981) Kolekcje i sztuka",
      "Rękodzieło",
      "Filcowanie"
    ],
    "hierarchy": "(307981) Kolekcje i sztuka / Rękodzieło / Filcowanie / Elementy zdobnicze",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Filc",
    "categoryPath": [
      "(258958) Kolekcje i sztuka",
      "Rękodzieło",
      "Filcowanie"
    ],
    "hierarchy": "(258958) Kolekcje i sztuka / Rękodzieło / Filcowanie / Filc",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Igły i narzędzia",
    "categoryPath": [
      "(76695) Kolekcje i sztuka",
      "Rękodzieło",
      "Filcowanie"
    ],
    "hierarchy": "(76695) Kolekcje i sztuka / Rękodzieło / Filcowanie / Igły i narzędzia",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kulki filcowe",
    "categoryPath": [
      "(259164) Kolekcje i sztuka",
      "Rękodzieło",
      "Filcowanie"
    ],
    "hierarchy": "(259164) Kolekcje i sztuka / Rękodzieło / Filcowanie / Kulki filcowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76696) Kolekcje i sztuka",
      "Rękodzieło",
      "Filcowanie"
    ],
    "hierarchy": "(76696) Kolekcje i sztuka / Rękodzieło / Filcowanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zestawy kreatywne",
    "categoryPath": [
      "(259165) Kolekcje i sztuka",
      "Rękodzieło",
      "Filcowanie"
    ],
    "hierarchy": "(259165) Kolekcje i sztuka / Rękodzieło / Filcowanie / Zestawy kreatywne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Formy do odlewów",
    "categoryPath": [
      "(258956) Kolekcje i sztuka",
      "Rękodzieło",
      "Masy do modelowania"
    ],
    "hierarchy": "(258956) Kolekcje i sztuka / Rękodzieło / Masy do modelowania / Formy do odlewów",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Masy",
    "categoryPath": [
      "(258954) Kolekcje i sztuka",
      "Rękodzieło",
      "Masy do modelowania"
    ],
    "hierarchy": "(258954) Kolekcje i sztuka / Rękodzieło / Masy do modelowania / Masy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Narzędzia do modelowania",
    "categoryPath": [
      "(258955) Kolekcje i sztuka",
      "Rękodzieło",
      "Masy do modelowania"
    ],
    "hierarchy": "(258955) Kolekcje i sztuka / Rękodzieło / Masy do modelowania / Narzędzia do modelowania",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy startowe",
    "categoryPath": [
      "(322144) Kolekcje i sztuka",
      "Rękodzieło",
      "Masy do modelowania"
    ],
    "hierarchy": "(322144) Kolekcje i sztuka / Rękodzieło / Masy do modelowania / Zestawy startowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76652) Kolekcje i sztuka",
      "Rękodzieło"
    ],
    "hierarchy": "(76652) Kolekcje i sztuka / Rękodzieło / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Bransoletki",
    "categoryPath": [
      "(259509) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(259509) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Bransoletki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Broszki",
    "categoryPath": [
      "(259510) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(259510) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Broszki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kolczyki",
    "categoryPath": [
      "(259511) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(259511) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Kolczyki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Komplety biżuterii",
    "categoryPath": [
      "(259512) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(259512) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Komplety biżuterii",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Naszyjniki i korale",
    "categoryPath": [
      "(259513) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(259513) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Naszyjniki i korale",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pierścionki",
    "categoryPath": [
      "(259514) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(259514) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Pierścionki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wisiorki",
    "categoryPath": [
      "(307993) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(307993) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Wisiorki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zegarki",
    "categoryPath": [
      "(319373) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Biżuteria, zegarki"
    ],
    "hierarchy": "(319373) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Biżuteria, zegarki / Zegarki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Breloki",
    "categoryPath": [
      "(260010) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Galanteria, dodatki"
    ],
    "hierarchy": "(260010) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Galanteria, dodatki / Breloki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kosmetyczki",
    "categoryPath": [
      "(319370) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Galanteria, dodatki"
    ],
    "hierarchy": "(319370) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Galanteria, dodatki / Kosmetyczki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Torebki",
    "categoryPath": [
      "(259515) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Galanteria, dodatki"
    ],
    "hierarchy": "(259515) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Galanteria, dodatki / Torebki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kartki okolicznościowe",
    "categoryPath": [
      "(316510) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Kartki, zaproszenia, podziękowania"
    ],
    "hierarchy": "(316510) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Kartki, zaproszenia, podziękowania / Kartki okolicznościowe",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Podziękowania",
    "categoryPath": [
      "(316516) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Kartki, zaproszenia, podziękowania"
    ],
    "hierarchy": "(316516) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Kartki, zaproszenia, podziękowania / Podziękowania",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zaproszenia",
    "categoryPath": [
      "(316513) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Kartki, zaproszenia, podziękowania"
    ],
    "hierarchy": "(316513) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Kartki, zaproszenia, podziękowania / Zaproszenia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Odzież ręcznie wykonana",
    "categoryPath": [
      "(101269) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane"
    ],
    "hierarchy": "(101269) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Odzież ręcznie wykonana",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ozdoby świąteczne",
    "categoryPath": [
      "(260007) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane"
    ],
    "hierarchy": "(260007) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Ozdoby świąteczne",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76749) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane"
    ],
    "hierarchy": "(76749) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dywany",
    "categoryPath": [
      "(322958) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Tekstylia"
    ],
    "hierarchy": "(322958) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Tekstylia / Dywany",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Narzuty i kołdry",
    "categoryPath": [
      "(259517) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Tekstylia"
    ],
    "hierarchy": "(259517) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Tekstylia / Narzuty i kołdry",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obrusy, serwety, bieżniki",
    "categoryPath": [
      "(259518) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Tekstylia"
    ],
    "hierarchy": "(259518) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Tekstylia / Obrusy, serwety, bieżniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(259519) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Tekstylia"
    ],
    "hierarchy": "(259519) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Tekstylia / Poduszki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Chusteczniki",
    "categoryPath": [
      "(259521) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259521) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Chusteczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Karafki",
    "categoryPath": [
      "(259522) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259522) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Karafki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kubki",
    "categoryPath": [
      "(259523) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259523) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Kubki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Kwiaty, bukiety",
    "categoryPath": [
      "(316372) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(316372) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Kwiaty, bukiety",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Makramy",
    "categoryPath": [
      "(316375) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(316375) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Makramy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mozaiki",
    "categoryPath": [
      "(260871) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(260871) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Mozaiki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obrazki i ramki",
    "categoryPath": [
      "(259525) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259525) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Obrazki i ramki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Odpromienniki",
    "categoryPath": [
      "(260008) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(260008) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Odpromienniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Skarbonki",
    "categoryPath": [
      "(259697) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259697) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Skarbonki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Szkatułki, skrzynki",
    "categoryPath": [
      "(259526) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259526) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Szkatułki, skrzynki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Tace, chlebaki, podkładki",
    "categoryPath": [
      "(259528) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259528) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Tace, chlebaki, podkładki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(259529) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259529) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Wieszaki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Witraże",
    "categoryPath": [
      "(260009) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(260009) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Witraże",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Łapacze snów",
    "categoryPath": [
      "(259524) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259524) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Łapacze snów",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Świece",
    "categoryPath": [
      "(259707) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259707) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Świece",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Świeczniki",
    "categoryPath": [
      "(259527) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Wyposażenie domu"
    ],
    "hierarchy": "(259527) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Wyposażenie domu / Świeczniki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Lalki i figurki kolekcjonerskie",
    "categoryPath": [
      "(259531) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Zabawki i figurki kolekcjonerskie"
    ],
    "hierarchy": "(259531) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Zabawki i figurki kolekcjonerskie / Lalki i figurki kolekcjonerskie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zabawki i maskotki",
    "categoryPath": [
      "(259532) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane",
      "Zabawki i figurki kolekcjonerskie"
    ],
    "hierarchy": "(259532) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Zabawki i figurki kolekcjonerskie / Zabawki i maskotki",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Zakładki do książek",
    "categoryPath": [
      "(259818) Kolekcje i sztuka",
      "Rękodzieło",
      "Przedmioty ręcznie wykonane"
    ],
    "hierarchy": "(259818) Kolekcje i sztuka / Rękodzieło / Przedmioty ręcznie wykonane / Zakładki do książek",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Grzebienie",
    "categoryPath": [
      "(258767) Kolekcje i sztuka",
      "Rękodzieło",
      "Quilling"
    ],
    "hierarchy": "(258767) Kolekcje i sztuka / Rękodzieło / Quilling / Grzebienie",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Igły i nakładki",
    "categoryPath": [
      "(258800) Kolekcje i sztuka",
      "Rękodzieło",
      "Quilling"
    ],
    "hierarchy": "(258800) Kolekcje i sztuka / Rękodzieło / Quilling / Igły i nakładki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Karbownice",
    "categoryPath": [
      "(258766) Kolekcje i sztuka",
      "Rękodzieło",
      "Quilling"
    ],
    "hierarchy": "(258766) Kolekcje i sztuka / Rękodzieło / Quilling / Karbownice",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(258768) Kolekcje i sztuka",
      "Rękodzieło",
      "Quilling"
    ],
    "hierarchy": "(258768) Kolekcje i sztuka / Rękodzieło / Quilling / Paski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szablony, podkłady, formy",
    "categoryPath": [
      "(258765) Kolekcje i sztuka",
      "Rękodzieło",
      "Quilling"
    ],
    "hierarchy": "(258765) Kolekcje i sztuka / Rękodzieło / Quilling / Szablony, podkłady, formy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy startowe",
    "categoryPath": [
      "(258769) Kolekcje i sztuka",
      "Rękodzieło",
      "Quilling"
    ],
    "hierarchy": "(258769) Kolekcje i sztuka / Rękodzieło / Quilling / Zestawy startowe",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Bazy, albumy",
    "categoryPath": [
      "(76699) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(76699) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Bazy, albumy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Brokat",
    "categoryPath": [
      "(259188) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259188) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Brokat",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Druciki kreatywne, florystyczne",
    "categoryPath": [
      "(259318) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259318) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Druciki kreatywne, florystyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Elementy dekoracyjne",
    "categoryPath": [
      "(259335) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259335) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Elementy dekoracyjne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Guziki, aplikacje",
    "categoryPath": [
      "(259310) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259310) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Guziki, aplikacje",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Klamerki",
    "categoryPath": [
      "(259122) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259122) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Klamerki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Koraliki, cekiny",
    "categoryPath": [
      "(308005) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(308005) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Koraliki, cekiny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kryształki, perełki",
    "categoryPath": [
      "(259284) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259284) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Kryształki, perełki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kwiaty",
    "categoryPath": [
      "(259305) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259305) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Kwiaty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Naklejki, kalkomanie, taśmy",
    "categoryPath": [
      "(259132) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259132) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Naklejki, kalkomanie, taśmy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Nity, ćwieki",
    "categoryPath": [
      "(259125) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259125) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Nity, ćwieki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Patyczki",
    "categoryPath": [
      "(259126) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259126) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Patyczki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pióra",
    "categoryPath": [
      "(259127) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259127) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Pióra",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pompony",
    "categoryPath": [
      "(259128) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259128) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Pompony",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Rafia",
    "categoryPath": [
      "(259129) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259129) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Rafia",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Sianka",
    "categoryPath": [
      "(259130) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259130) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Sianka",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Sznurki",
    "categoryPath": [
      "(259131) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Dodatki i ozdoby"
    ],
    "hierarchy": "(259131) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Dodatki i ozdoby / Sznurki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Farby, preparaty",
    "categoryPath": [
      "(259320) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(259320) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Farby, preparaty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kleje, taśmy klejące",
    "categoryPath": [
      "(259393) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(259393) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Kleje, taśmy klejące",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Dziurkacze ozdobne",
    "categoryPath": [
      "(259334) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Narzędzia i urządzenia"
    ],
    "hierarchy": "(259334) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Narzędzia i urządzenia / Dziurkacze ozdobne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Maszyny tnąco-wytłaczające",
    "categoryPath": [
      "(259333) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Narzędzia i urządzenia"
    ],
    "hierarchy": "(259333) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Narzędzia i urządzenia / Maszyny tnąco-wytłaczające",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Nożyczki, noże",
    "categoryPath": [
      "(259332) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking",
      "Narzędzia i urządzenia"
    ],
    "hierarchy": "(259332) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Narzędzia i urządzenia / Nożyczki, noże",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Papiery, bibuły, tektury",
    "categoryPath": [
      "(76706) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(76706) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Papiery, bibuły, tektury",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pianki, filce",
    "categoryPath": [
      "(259321) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(259321) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Pianki, filce",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76712) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(76712) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Scrapki",
    "categoryPath": [
      "(76709) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(76709) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Scrapki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Stemple",
    "categoryPath": [
      "(76708) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(76708) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Stemple",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Szablony, maski, wykrojniki",
    "categoryPath": [
      "(76710) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(76710) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Szablony, maski, wykrojniki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Tusze, pudry",
    "categoryPath": [
      "(76711) Kolekcje i sztuka",
      "Rękodzieło",
      "Scrapbooking"
    ],
    "hierarchy": "(76711) Kolekcje i sztuka / Rękodzieło / Scrapbooking / Tusze, pudry",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Gryzaki",
    "categoryPath": [
      "(315714) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria do zabawek"
    ],
    "hierarchy": "(315714) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria do zabawek / Gryzaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Grzechotki, pozytywki",
    "categoryPath": [
      "(315717) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria do zabawek"
    ],
    "hierarchy": "(315717) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria do zabawek / Grzechotki, pozytywki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nosy",
    "categoryPath": [
      "(315720) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria do zabawek"
    ],
    "hierarchy": "(315720) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria do zabawek / Nosy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Oczy, rzęsy",
    "categoryPath": [
      "(315723) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria do zabawek"
    ],
    "hierarchy": "(315723) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria do zabawek / Oczy, rzęsy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piszczałki",
    "categoryPath": [
      "(315726) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria do zabawek"
    ],
    "hierarchy": "(315726) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria do zabawek / Piszczałki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Włosy",
    "categoryPath": [
      "(315729) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria do zabawek"
    ],
    "hierarchy": "(315729) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria do zabawek / Włosy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Agrafki",
    "categoryPath": [
      "(258717) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258717) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Agrafki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dziurkacze, napownice",
    "categoryPath": [
      "(258801) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258801) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Dziurkacze, napownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kredy, znaczniki",
    "categoryPath": [
      "(258802) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258802) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Kredy, znaczniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miary",
    "categoryPath": [
      "(258803) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258803) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Miary",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Naparstki",
    "categoryPath": [
      "(258721) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258721) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Naparstki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nożyczki i noże",
    "categoryPath": [
      "(258804) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258804) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Nożyczki i noże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258716) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258716) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyborniki, niciarki",
    "categoryPath": [
      "(258807) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258807) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Przyborniki, niciarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szpilki",
    "categoryPath": [
      "(258724) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258724) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Szpilki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wykroje",
    "categoryPath": [
      "(319301) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(319301) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Wykroje",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy krawieckie",
    "categoryPath": [
      "(258725) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie",
      "Akcesoria krawieckie"
    ],
    "hierarchy": "(258725) Kolekcje i sztuka / Rękodzieło / Szycie / Akcesoria krawieckie / Zestawy krawieckie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Aplikacje, łatki",
    "categoryPath": [
      "(258951) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258951) Kolekcje i sztuka / Rękodzieło / Szycie / Aplikacje, łatki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Barwniki, farby, flamastry",
    "categoryPath": [
      "(258941) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258941) Kolekcje i sztuka / Rękodzieło / Szycie / Barwniki, farby, flamastry",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Guziki",
    "categoryPath": [
      "(76718) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(76718) Kolekcje i sztuka / Rękodzieło / Szycie / Guziki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Igły",
    "categoryPath": [
      "(258961) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258961) Kolekcje i sztuka / Rękodzieło / Szycie / Igły",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(258876) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258876) Kolekcje i sztuka / Rękodzieło / Szycie / Kleje",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Koronki i hafty",
    "categoryPath": [
      "(76722) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(76722) Kolekcje i sztuka / Rękodzieło / Szycie / Koronki i hafty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Metki, wszywki",
    "categoryPath": [
      "(258877) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258877) Kolekcje i sztuka / Rękodzieło / Szycie / Metki, wszywki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Nici",
    "categoryPath": [
      "(76723) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(76723) Kolekcje i sztuka / Rękodzieło / Szycie / Nici",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(258878) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258878) Kolekcje i sztuka / Rękodzieło / Szycie / Paski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Sznurki",
    "categoryPath": [
      "(258879) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258879) Kolekcje i sztuka / Rękodzieło / Szycie / Sznurki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Taśmy i tasiemki",
    "categoryPath": [
      "(76724) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(76724) Kolekcje i sztuka / Rękodzieło / Szycie / Taśmy i tasiemki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Tkaniny",
    "categoryPath": [
      "(258939) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258939) Kolekcje i sztuka / Rękodzieło / Szycie / Tkaniny",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Wypełnienia",
    "categoryPath": [
      "(258940) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258940) Kolekcje i sztuka / Rękodzieło / Szycie / Wypełnienia",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zamki",
    "categoryPath": [
      "(76738) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(76738) Kolekcje i sztuka / Rękodzieło / Szycie / Zamki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zapięcia",
    "categoryPath": [
      "(258962) Kolekcje i sztuka",
      "Rękodzieło",
      "Szycie"
    ],
    "hierarchy": "(258962) Kolekcje i sztuka / Rękodzieło / Szycie / Zapięcia",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Fotografia archiwalna i użytkowa",
    "categoryPath": [
      "(321814) Kolekcje i sztuka",
      "Sztuka",
      "Fotografia"
    ],
    "hierarchy": "(321814) Kolekcje i sztuka / Sztuka / Fotografia / Fotografia archiwalna i użytkowa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Fotografia artystyczna",
    "categoryPath": [
      "(321817) Kolekcje i sztuka",
      "Sztuka",
      "Fotografia"
    ],
    "hierarchy": "(321817) Kolekcje i sztuka / Sztuka / Fotografia / Fotografia artystyczna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Grafika archiwalna i użytkowa",
    "categoryPath": [
      "(26105) Kolekcje i sztuka",
      "Sztuka",
      "Grafika"
    ],
    "hierarchy": "(26105) Kolekcje i sztuka / Sztuka / Grafika / Grafika archiwalna i użytkowa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Grafika artystyczna",
    "categoryPath": [
      "(26283) Kolekcje i sztuka",
      "Sztuka",
      "Grafika"
    ],
    "hierarchy": "(26283) Kolekcje i sztuka / Sztuka / Grafika / Grafika artystyczna",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Abstrakcja",
    "categoryPath": [
      "(316624) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316624) Kolekcje i sztuka / Sztuka / Malarstwo / Abstrakcja",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Akt",
    "categoryPath": [
      "(316627) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316627) Kolekcje i sztuka / Sztuka / Malarstwo / Akt",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Animalistyka",
    "categoryPath": [
      "(316820) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316820) Kolekcje i sztuka / Sztuka / Malarstwo / Animalistyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Batalistyka",
    "categoryPath": [
      "(316823) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316823) Kolekcje i sztuka / Sztuka / Malarstwo / Batalistyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Historia",
    "categoryPath": [
      "(316630) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316630) Kolekcje i sztuka / Sztuka / Malarstwo / Historia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ikony",
    "categoryPath": [
      "(26273) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(26273) Kolekcje i sztuka / Sztuka / Malarstwo / Ikony",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Martwa natura",
    "categoryPath": [
      "(316633) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316633) Kolekcje i sztuka / Sztuka / Malarstwo / Martwa natura",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Marynistyka",
    "categoryPath": [
      "(316636) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316636) Kolekcje i sztuka / Sztuka / Malarstwo / Marynistyka",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Mitologia",
    "categoryPath": [
      "(316639) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316639) Kolekcje i sztuka / Sztuka / Malarstwo / Mitologia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pejzaż",
    "categoryPath": [
      "(316642) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316642) Kolekcje i sztuka / Sztuka / Malarstwo / Pejzaż",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Portret",
    "categoryPath": [
      "(316645) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316645) Kolekcje i sztuka / Sztuka / Malarstwo / Portret",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(26280) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(26280) Kolekcje i sztuka / Sztuka / Malarstwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Religia",
    "categoryPath": [
      "(316648) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316648) Kolekcje i sztuka / Sztuka / Malarstwo / Religia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Scena rodzajowa",
    "categoryPath": [
      "(316651) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316651) Kolekcje i sztuka / Sztuka / Malarstwo / Scena rodzajowa",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Weduta (pejzaż miejski)",
    "categoryPath": [
      "(316654) Kolekcje i sztuka",
      "Sztuka",
      "Malarstwo"
    ],
    "hierarchy": "(316654) Kolekcje i sztuka / Sztuka / Malarstwo / Weduta (pejzaż miejski)",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Plakat",
    "categoryPath": [
      "(26284) Kolekcje i sztuka",
      "Sztuka"
    ],
    "hierarchy": "(26284) Kolekcje i sztuka / Sztuka / Plakat",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Ramy i oprawy",
    "categoryPath": [
      "(308401) Kolekcje i sztuka",
      "Sztuka"
    ],
    "hierarchy": "(308401) Kolekcje i sztuka / Sztuka / Ramy i oprawy",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Fotografia",
    "categoryPath": [
      "(321905) Kolekcje i sztuka",
      "Sztuka",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321905) Kolekcje i sztuka / Sztuka / Reprodukcje i przedmioty stylizowane / Fotografia",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Grafika",
    "categoryPath": [
      "(321906) Kolekcje i sztuka",
      "Sztuka",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321906) Kolekcje i sztuka / Sztuka / Reprodukcje i przedmioty stylizowane / Grafika",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Malarstwo",
    "categoryPath": [
      "(321907) Kolekcje i sztuka",
      "Sztuka",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321907) Kolekcje i sztuka / Sztuka / Reprodukcje i przedmioty stylizowane / Malarstwo",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Obrazy i obrazki malowane ręcznie",
    "categoryPath": [
      "(322809) Kolekcje i sztuka",
      "Sztuka",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(322809) Kolekcje i sztuka / Sztuka / Reprodukcje i przedmioty stylizowane / Obrazy i obrazki malowane ręcznie",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Plakat",
    "categoryPath": [
      "(321908) Kolekcje i sztuka",
      "Sztuka",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321908) Kolekcje i sztuka / Sztuka / Reprodukcje i przedmioty stylizowane / Plakat",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rysunek",
    "categoryPath": [
      "(321909) Kolekcje i sztuka",
      "Sztuka",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321909) Kolekcje i sztuka / Sztuka / Reprodukcje i przedmioty stylizowane / Rysunek",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rzeźba",
    "categoryPath": [
      "(321910) Kolekcje i sztuka",
      "Sztuka",
      "Reprodukcje i przedmioty stylizowane"
    ],
    "hierarchy": "(321910) Kolekcje i sztuka / Sztuka / Reprodukcje i przedmioty stylizowane / Rzeźba",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rysunek",
    "categoryPath": [
      "(26959) Kolekcje i sztuka",
      "Sztuka"
    ],
    "hierarchy": "(26959) Kolekcje i sztuka / Sztuka / Rysunek",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Rzeźba",
    "categoryPath": [
      "(26040) Kolekcje i sztuka",
      "Sztuka"
    ],
    "hierarchy": "(26040) Kolekcje i sztuka / Sztuka / Rzeźba",
    "comissionGroupOld": "C8",
    "comissionGroupNew": "D19"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(20604) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20604) Kultura i rozrywka / Filmy / Kasety wideo / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dokumentalne",
    "categoryPath": [
      "(20605) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20605) Kultura i rozrywka / Filmy / Kasety wideo / Dokumentalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dramaty",
    "categoryPath": [
      "(20606) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20606) Kultura i rozrywka / Filmy / Kasety wideo / Dramaty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy",
    "categoryPath": [
      "(20607) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20607) Kultura i rozrywka / Filmy / Kasety wideo / Fantasy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Horrory",
    "categoryPath": [
      "(20608) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20608) Kultura i rozrywka / Filmy / Kasety wideo / Horrory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Komedie",
    "categoryPath": [
      "(20609) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20609) Kultura i rozrywka / Filmy / Kasety wideo / Komedie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Koncerty, teledyski",
    "categoryPath": [
      "(20768) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20768) Kultura i rozrywka / Filmy / Kasety wideo / Koncerty, teledyski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kostiumowe",
    "categoryPath": [
      "(20610) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20610) Kultura i rozrywka / Filmy / Kasety wideo / Kostiumowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kryminały",
    "categoryPath": [
      "(20611) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20611) Kultura i rozrywka / Filmy / Kasety wideo / Kryminały",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(20618) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20618) Kultura i rozrywka / Filmy / Kasety wideo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(20612) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20612) Kultura i rozrywka / Filmy / Kasety wideo / Przygodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Science Fiction",
    "categoryPath": [
      "(20613) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20613) Kultura i rozrywka / Filmy / Kasety wideo / Science Fiction",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sensacyjne",
    "categoryPath": [
      "(20614) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20614) Kultura i rozrywka / Filmy / Kasety wideo / Sensacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Seriale",
    "categoryPath": [
      "(20615) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20615) Kultura i rozrywka / Filmy / Kasety wideo / Seriale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Thrillery",
    "categoryPath": [
      "(20616) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20616) Kultura i rozrywka / Filmy / Kasety wideo / Thrillery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Wojenne",
    "categoryPath": [
      "(20617) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20617) Kultura i rozrywka / Filmy / Kasety wideo / Wojenne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy, pakiety",
    "categoryPath": [
      "(20619) Kultura i rozrywka",
      "Filmy",
      "Kasety wideo"
    ],
    "hierarchy": "(20619) Kultura i rozrywka / Filmy / Kasety wideo / Zestawy, pakiety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(98716) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98716) Kultura i rozrywka / Filmy / Płyty 3D / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy",
    "categoryPath": [
      "(98717) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98717) Kultura i rozrywka / Filmy / Płyty 3D / Fantasy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Horrory",
    "categoryPath": [
      "(98715) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98715) Kultura i rozrywka / Filmy / Płyty 3D / Horrory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Koncerty",
    "categoryPath": [
      "(98718) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98718) Kultura i rozrywka / Filmy / Płyty 3D / Koncerty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Okulary 3D",
    "categoryPath": [
      "(148153) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(148153) Kultura i rozrywka / Filmy / Płyty 3D / Okulary 3D",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Popularnonaukowe",
    "categoryPath": [
      "(98720) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98720) Kultura i rozrywka / Filmy / Płyty 3D / Popularnonaukowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(98721) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98721) Kultura i rozrywka / Filmy / Płyty 3D / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Science fiction",
    "categoryPath": [
      "(98714) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98714) Kultura i rozrywka / Filmy / Płyty 3D / Science fiction",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sensacyjne",
    "categoryPath": [
      "(98719) Kultura i rozrywka",
      "Filmy",
      "Płyty 3D"
    ],
    "hierarchy": "(98719) Kultura i rozrywka / Filmy / Płyty 3D / Sensacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Anime",
    "categoryPath": [
      "(92573) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(92573) Kultura i rozrywka / Filmy / Płyty Blu-ray / Anime",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(89056) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89056) Kultura i rozrywka / Filmy / Płyty Blu-ray / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dokumentalne",
    "categoryPath": [
      "(89057) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89057) Kultura i rozrywka / Filmy / Płyty Blu-ray / Dokumentalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dramaty",
    "categoryPath": [
      "(89058) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89058) Kultura i rozrywka / Filmy / Płyty Blu-ray / Dramaty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy",
    "categoryPath": [
      "(92574) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(92574) Kultura i rozrywka / Filmy / Płyty Blu-ray / Fantasy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Horrory",
    "categoryPath": [
      "(89059) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89059) Kultura i rozrywka / Filmy / Płyty Blu-ray / Horrory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kabarety",
    "categoryPath": [
      "(92575) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(92575) Kultura i rozrywka / Filmy / Płyty Blu-ray / Kabarety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Komedie",
    "categoryPath": [
      "(89060) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89060) Kultura i rozrywka / Filmy / Płyty Blu-ray / Komedie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Koncerty",
    "categoryPath": [
      "(89061) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89061) Kultura i rozrywka / Filmy / Płyty Blu-ray / Koncerty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kryminały",
    "categoryPath": [
      "(89062) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89062) Kultura i rozrywka / Filmy / Płyty Blu-ray / Kryminały",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kursy, ćwiczenia",
    "categoryPath": [
      "(92576) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(92576) Kultura i rozrywka / Filmy / Płyty Blu-ray / Kursy, ćwiczenia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Musicale",
    "categoryPath": [
      "(92577) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(92577) Kultura i rozrywka / Filmy / Płyty Blu-ray / Musicale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(89055) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89055) Kultura i rozrywka / Filmy / Płyty Blu-ray / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(89063) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89063) Kultura i rozrywka / Filmy / Płyty Blu-ray / Przygodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Science Fiction",
    "categoryPath": [
      "(89064) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89064) Kultura i rozrywka / Filmy / Płyty Blu-ray / Science Fiction",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sensacyjne",
    "categoryPath": [
      "(89065) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89065) Kultura i rozrywka / Filmy / Płyty Blu-ray / Sensacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Seriale",
    "categoryPath": [
      "(89070) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89070) Kultura i rozrywka / Filmy / Płyty Blu-ray / Seriale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Thrillery",
    "categoryPath": [
      "(89066) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89066) Kultura i rozrywka / Filmy / Płyty Blu-ray / Thrillery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Westerny",
    "categoryPath": [
      "(92578) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(92578) Kultura i rozrywka / Filmy / Płyty Blu-ray / Westerny",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Wojenne",
    "categoryPath": [
      "(89067) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89067) Kultura i rozrywka / Filmy / Płyty Blu-ray / Wojenne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(89068) Kultura i rozrywka",
      "Filmy",
      "Płyty Blu-ray"
    ],
    "hierarchy": "(89068) Kultura i rozrywka / Filmy / Płyty Blu-ray / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Anime",
    "categoryPath": [
      "(100076) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100076) Kultura i rozrywka / Filmy / Płyty DVD / Anime",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Bollywood",
    "categoryPath": [
      "(100077) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100077) Kultura i rozrywka / Filmy / Płyty DVD / Bollywood",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Animowane",
    "categoryPath": [
      "(100079) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dla dzieci"
    ],
    "hierarchy": "(100079) Kultura i rozrywka / Filmy / Płyty DVD / Dla dzieci / Animowane",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fabularne",
    "categoryPath": [
      "(100080) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dla dzieci"
    ],
    "hierarchy": "(100080) Kultura i rozrywka / Filmy / Płyty DVD / Dla dzieci / Fabularne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(100081) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dla dzieci"
    ],
    "hierarchy": "(100081) Kultura i rozrywka / Filmy / Płyty DVD / Dla dzieci / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Biograficzne",
    "categoryPath": [
      "(100086) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dokumentalne"
    ],
    "hierarchy": "(100086) Kultura i rozrywka / Filmy / Płyty DVD / Dokumentalne / Biograficzne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Historyczne",
    "categoryPath": [
      "(100083) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dokumentalne"
    ],
    "hierarchy": "(100083) Kultura i rozrywka / Filmy / Płyty DVD / Dokumentalne / Historyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Podróżnicze",
    "categoryPath": [
      "(100084) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dokumentalne"
    ],
    "hierarchy": "(100084) Kultura i rozrywka / Filmy / Płyty DVD / Dokumentalne / Podróżnicze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Popularnonaukowe",
    "categoryPath": [
      "(100085) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dokumentalne"
    ],
    "hierarchy": "(100085) Kultura i rozrywka / Filmy / Płyty DVD / Dokumentalne / Popularnonaukowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(100087) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Dokumentalne"
    ],
    "hierarchy": "(100087) Kultura i rozrywka / Filmy / Płyty DVD / Dokumentalne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dramaty",
    "categoryPath": [
      "(322240) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(322240) Kultura i rozrywka / Filmy / Płyty DVD / Dramaty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy",
    "categoryPath": [
      "(100091) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100091) Kultura i rozrywka / Filmy / Płyty DVD / Fantasy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Horrory",
    "categoryPath": [
      "(100092) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100092) Kultura i rozrywka / Filmy / Płyty DVD / Horrory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Komedie",
    "categoryPath": [
      "(322241) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(322241) Kultura i rozrywka / Filmy / Płyty DVD / Komedie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kabarety",
    "categoryPath": [
      "(100105) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr"
    ],
    "hierarchy": "(100105) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Kabarety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Blues",
    "categoryPath": [
      "(316306) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(316306) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Blues",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dance, techno",
    "categoryPath": [
      "(100098) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(100098) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Dance, techno",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Jazz, Swing",
    "categoryPath": [
      "(316321) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(316321) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Jazz, Swing",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Metal",
    "categoryPath": [
      "(316309) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(316309) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Metal",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka alternatywna",
    "categoryPath": [
      "(316315) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(316315) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Muzyka alternatywna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka elektroniczna",
    "categoryPath": [
      "(316312) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(316312) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Muzyka elektroniczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka klasyczna",
    "categoryPath": [
      "(100099) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(100099) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Muzyka klasyczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pop",
    "categoryPath": [
      "(100102) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(100102) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Pop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rap, hip-hop",
    "categoryPath": [
      "(100101) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(100101) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Rap, hip-hop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Reggae, Ska",
    "categoryPath": [
      "(316318) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(316318) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Reggae, Ska",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rock",
    "categoryPath": [
      "(100100) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr",
      "Koncerty"
    ],
    "hierarchy": "(100100) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Koncerty / Rock",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Opery",
    "categoryPath": [
      "(315333) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr"
    ],
    "hierarchy": "(315333) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Opery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Spektakle teatralne",
    "categoryPath": [
      "(100106) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Koncerty, kabarety, opery, teatr"
    ],
    "hierarchy": "(100106) Kultura i rozrywka / Filmy / Płyty DVD / Koncerty, kabarety, opery, teatr / Spektakle teatralne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kostiumowe",
    "categoryPath": [
      "(100104) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100104) Kultura i rozrywka / Filmy / Płyty DVD / Kostiumowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kryminały",
    "categoryPath": [
      "(100108) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100108) Kultura i rozrywka / Filmy / Płyty DVD / Kryminały",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Informatyka",
    "categoryPath": [
      "(100111) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Kursy, ćwiczenia, karaoke"
    ],
    "hierarchy": "(100111) Kultura i rozrywka / Filmy / Płyty DVD / Kursy, ćwiczenia, karaoke / Informatyka",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Karaoke",
    "categoryPath": [
      "(100112) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Kursy, ćwiczenia, karaoke"
    ],
    "hierarchy": "(100112) Kultura i rozrywka / Filmy / Płyty DVD / Kursy, ćwiczenia, karaoke / Karaoke",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kursy",
    "categoryPath": [
      "(315336) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Kursy, ćwiczenia, karaoke"
    ],
    "hierarchy": "(315336) Kultura i rozrywka / Filmy / Płyty DVD / Kursy, ćwiczenia, karaoke / Kursy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ćwiczenia fizyczne, taniec",
    "categoryPath": [
      "(100110) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD",
      "Kursy, ćwiczenia, karaoke"
    ],
    "hierarchy": "(100110) Kultura i rozrywka / Filmy / Płyty DVD / Kursy, ćwiczenia, karaoke / Ćwiczenia fizyczne, taniec",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Musicale",
    "categoryPath": [
      "(100114) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100114) Kultura i rozrywka / Filmy / Płyty DVD / Musicale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(100125) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100125) Kultura i rozrywka / Filmy / Płyty DVD / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(100115) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100115) Kultura i rozrywka / Filmy / Płyty DVD / Przygodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Romanse",
    "categoryPath": [
      "(100116) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100116) Kultura i rozrywka / Filmy / Płyty DVD / Romanse",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Science Fiction",
    "categoryPath": [
      "(100117) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100117) Kultura i rozrywka / Filmy / Płyty DVD / Science Fiction",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sensacyjne",
    "categoryPath": [
      "(100124) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100124) Kultura i rozrywka / Filmy / Płyty DVD / Sensacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Seriale",
    "categoryPath": [
      "(322245) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(322245) Kultura i rozrywka / Filmy / Płyty DVD / Seriale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Thrillery",
    "categoryPath": [
      "(100121) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100121) Kultura i rozrywka / Filmy / Płyty DVD / Thrillery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Westerny",
    "categoryPath": [
      "(100122) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100122) Kultura i rozrywka / Filmy / Płyty DVD / Westerny",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Wojenne",
    "categoryPath": [
      "(100123) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100123) Kultura i rozrywka / Filmy / Płyty DVD / Wojenne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy, pakiety",
    "categoryPath": [
      "(100137) Kultura i rozrywka",
      "Filmy",
      "Płyty DVD"
    ],
    "hierarchy": "(100137) Kultura i rozrywka / Filmy / Płyty DVD / Zestawy, pakiety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Anime",
    "categoryPath": [
      "(320464) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320464) Kultura i rozrywka / Filmy / Płyty HD DVD / Anime",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(320467) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320467) Kultura i rozrywka / Filmy / Płyty HD DVD / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dokumentalne",
    "categoryPath": [
      "(320470) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320470) Kultura i rozrywka / Filmy / Płyty HD DVD / Dokumentalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dramaty",
    "categoryPath": [
      "(320473) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320473) Kultura i rozrywka / Filmy / Płyty HD DVD / Dramaty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy",
    "categoryPath": [
      "(320476) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320476) Kultura i rozrywka / Filmy / Płyty HD DVD / Fantasy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Horror",
    "categoryPath": [
      "(320479) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320479) Kultura i rozrywka / Filmy / Płyty HD DVD / Horror",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kabarety",
    "categoryPath": [
      "(320485) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320485) Kultura i rozrywka / Filmy / Płyty HD DVD / Kabarety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Komedie",
    "categoryPath": [
      "(320491) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320491) Kultura i rozrywka / Filmy / Płyty HD DVD / Komedie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Koncerty",
    "categoryPath": [
      "(320488) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320488) Kultura i rozrywka / Filmy / Płyty HD DVD / Koncerty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Musicale",
    "categoryPath": [
      "(320500) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320500) Kultura i rozrywka / Filmy / Płyty HD DVD / Musicale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(320503) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320503) Kultura i rozrywka / Filmy / Płyty HD DVD / Przygodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Science fiction",
    "categoryPath": [
      "(320506) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320506) Kultura i rozrywka / Filmy / Płyty HD DVD / Science fiction",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sensacyjne",
    "categoryPath": [
      "(320509) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320509) Kultura i rozrywka / Filmy / Płyty HD DVD / Sensacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Seriale",
    "categoryPath": [
      "(320512) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320512) Kultura i rozrywka / Filmy / Płyty HD DVD / Seriale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Westerny",
    "categoryPath": [
      "(320518) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320518) Kultura i rozrywka / Filmy / Płyty HD DVD / Westerny",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(320524) Kultura i rozrywka",
      "Filmy",
      "Płyty HD DVD"
    ],
    "hierarchy": "(320524) Kultura i rozrywka / Filmy / Płyty HD DVD / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(20665) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20665) Kultura i rozrywka / Filmy / Płyty VCD / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dokumentalne",
    "categoryPath": [
      "(20666) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20666) Kultura i rozrywka / Filmy / Płyty VCD / Dokumentalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dramaty",
    "categoryPath": [
      "(20667) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20667) Kultura i rozrywka / Filmy / Płyty VCD / Dramaty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Filmy z gazety",
    "categoryPath": [
      "(20676) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20676) Kultura i rozrywka / Filmy / Płyty VCD / Filmy z gazety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Horrory",
    "categoryPath": [
      "(20668) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20668) Kultura i rozrywka / Filmy / Płyty VCD / Horrory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Komedie",
    "categoryPath": [
      "(20669) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20669) Kultura i rozrywka / Filmy / Płyty VCD / Komedie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Koncerty, teledyski",
    "categoryPath": [
      "(20780) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20780) Kultura i rozrywka / Filmy / Płyty VCD / Koncerty, teledyski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kryminały",
    "categoryPath": [
      "(20670) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20670) Kultura i rozrywka / Filmy / Płyty VCD / Kryminały",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(20677) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20677) Kultura i rozrywka / Filmy / Płyty VCD / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(20671) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20671) Kultura i rozrywka / Filmy / Płyty VCD / Przygodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Science Fiction",
    "categoryPath": [
      "(20672) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20672) Kultura i rozrywka / Filmy / Płyty VCD / Science Fiction",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sensacyjne",
    "categoryPath": [
      "(20673) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20673) Kultura i rozrywka / Filmy / Płyty VCD / Sensacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Seriale",
    "categoryPath": [
      "(20674) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20674) Kultura i rozrywka / Filmy / Płyty VCD / Seriale",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Thrillery",
    "categoryPath": [
      "(20675) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20675) Kultura i rozrywka / Filmy / Płyty VCD / Thrillery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy, pakiety",
    "categoryPath": [
      "(20678) Kultura i rozrywka",
      "Filmy",
      "Płyty VCD"
    ],
    "hierarchy": "(20678) Kultura i rozrywka / Filmy / Płyty VCD / Zestawy, pakiety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Artbook",
    "categoryPath": [
      "(319751) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(319751) Kultura i rozrywka / Gadżety / Artbook",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Autografy",
    "categoryPath": [
      "(20761) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(20761) Kultura i rozrywka / Gadżety / Autografy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Biżuteria",
    "categoryPath": [
      "(92734) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(92734) Kultura i rozrywka / Gadżety / Biżuteria",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Breloki",
    "categoryPath": [
      "(98697) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(98697) Kultura i rozrywka / Gadżety / Breloki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Figurki",
    "categoryPath": [
      "(53451) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(53451) Kultura i rozrywka / Gadżety / Figurki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kalendarze",
    "categoryPath": [
      "(100132) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(100132) Kultura i rozrywka / Gadżety / Kalendarze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(20766) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(20766) Kultura i rozrywka / Gadżety / Koszulki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kubki",
    "categoryPath": [
      "(100129) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(100129) Kultura i rozrywka / Gadżety / Kubki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Lampki",
    "categoryPath": [
      "(321095) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(321095) Kultura i rozrywka / Gadżety / Lampki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Naszywki, znaczki, przypinki",
    "categoryPath": [
      "(20764) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(20764) Kultura i rozrywka / Gadżety / Naszywki, znaczki, przypinki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Plakaty, zdjęcia",
    "categoryPath": [
      "(100128) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(100128) Kultura i rozrywka / Gadżety / Plakaty, zdjęcia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Poduszki i poszewki",
    "categoryPath": [
      "(98696) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(98696) Kultura i rozrywka / Gadżety / Poduszki i poszewki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostała odzież",
    "categoryPath": [
      "(100135) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(100135) Kultura i rozrywka / Gadżety / Pozostała odzież",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(100136) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(100136) Kultura i rozrywka / Gadżety / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ręczniki",
    "categoryPath": [
      "(318888) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(318888) Kultura i rozrywka / Gadżety / Ręczniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Steelbook",
    "categoryPath": [
      "(319754) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(319754) Kultura i rozrywka / Gadżety / Steelbook",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Torby i plecaki",
    "categoryPath": [
      "(98699) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(98699) Kultura i rozrywka / Gadżety / Torby i plecaki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zegary i zegarki",
    "categoryPath": [
      "(98698) Kultura i rozrywka",
      "Gadżety"
    ],
    "hierarchy": "(98698) Kultura i rozrywka / Gadżety / Zegary i zegarki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(82355) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(82355) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(82356) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(82356) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258660) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(258660) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82362) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(82362) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(82358) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(82358) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(82357) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(82357) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(82360) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(82360) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258658) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(258658) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258659) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(258659) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258661) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(258661) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(82364) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(82364) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258657) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox 360"
    ],
    "hierarchy": "(258657) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox 360 / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258650) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(258650) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(147125) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147125) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258654) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(258654) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147124) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147124) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(147126) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147126) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258652) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(258652) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(147127) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147127) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258653) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(258653) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258656) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(258656) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258655) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(258655) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(147128) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(147128) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258651) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox One"
    ],
    "hierarchy": "(258651) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox One / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(316336) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316336) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(316339) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316339) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(316342) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316342) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(316369) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316369) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(316345) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316345) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(316348) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316348) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(316351) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316351) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(316354) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316354) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(316357) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316357) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(316360) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316360) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(316363) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316363) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(316366) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Microsoft Xbox Series X",
      "S"
    ],
    "hierarchy": "(316366) Kultura i rozrywka / Gry / Gry na konsole / Microsoft Xbox Series X / S / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258606) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258606) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(258604) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258604) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258613) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258613) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258615) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258615) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(258609) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258609) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258607) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258607) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(258610) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258610) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258608) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258608) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258612) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258612) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258614) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258614) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258611) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258611) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258605) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo 3DS"
    ],
    "hierarchy": "(258605) Kultura i rozrywka / Gry / Gry na konsole / Nintendo 3DS / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258597) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(258597) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(82368) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(82368) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(82369) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(82369) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82373) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(82373) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(82371) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(82371) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258599) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(258599) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(82372) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(82372) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258600) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(258600) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258602) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(258602) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258601) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(258601) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258603) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(258603) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258598) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo DS"
    ],
    "hierarchy": "(258598) Kultura i rozrywka / Gry / Gry na konsole / Nintendo DS / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258618) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258618) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(258616) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258616) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258625) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258625) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258627) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258627) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(258621) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258621) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258619) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258619) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(258622) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258622) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258620) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258620) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258624) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258624) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258626) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258626) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258623) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258623) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258617) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Switch"
    ],
    "hierarchy": "(258617) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Switch / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258583) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(258583) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(82381) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(82381) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258581) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(258581) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Platformówki",
    "categoryPath": [
      "(82383) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(82383) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Platformówki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82385) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(82385) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(82382) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(82382) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258584) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(258584) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(82384) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(82384) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258579) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(258579) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258580) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(258580) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258582) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(258582) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258578) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii"
    ],
    "hierarchy": "(258578) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258587) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258587) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(258585) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258585) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258594) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258594) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258596) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258596) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(258590) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258590) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258588) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258588) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(258591) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258591) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258589) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258589) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258593) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258593) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258595) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258595) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258592) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258592) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258586) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Nintendo Wii U"
    ],
    "hierarchy": "(258586) Kultura i rozrywka / Gry / Gry na konsole / Nintendo Wii U / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82327) Kultura i rozrywka",
      "Gry",
      "Gry na konsole"
    ],
    "hierarchy": "(82327) Kultura i rozrywka / Gry / Gry na konsole / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258492) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258492) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(258490) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258490) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258499) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258499) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258501) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258501) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(258495) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258495) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258493) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258493) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(258496) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258496) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258494) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258494) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258498) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258498) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258500) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258500) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258497) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258497) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258491) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Microsoft Xbox"
    ],
    "hierarchy": "(258491) Kultura i rozrywka / Gry / Gry na konsole / Retro / Microsoft Xbox / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "NES",
    "categoryPath": [
      "(258538) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo (SNES, NES)"
    ],
    "hierarchy": "(258538) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo (SNES, NES) / NES",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "SNES",
    "categoryPath": [
      "(258539) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo (SNES, NES)"
    ],
    "hierarchy": "(258539) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo (SNES, NES) / SNES",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Nintendo 64",
    "categoryPath": [
      "(258474) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(258474) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo 64",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258514) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258514) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(258537) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258537) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258521) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258521) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258523) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258523) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(258517) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258517) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258515) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258515) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(258518) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258518) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258516) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258516) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258520) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258520) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258522) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258522) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258519) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258519) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258513) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Nintendo Game Boy Advance"
    ],
    "hierarchy": "(258513) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Advance / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Nintendo Game Boy Classic",
    "categoryPath": [
      "(258477) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(258477) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Classic",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Nintendo Game Boy Color",
    "categoryPath": [
      "(258476) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(258476) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo Game Boy Color",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Nintendo GameCube",
    "categoryPath": [
      "(258475) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(258475) Kultura i rozrywka / Gry / Gry na konsole / Retro / Nintendo GameCube",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pegasus",
    "categoryPath": [
      "(258473) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(258473) Kultura i rozrywka / Gry / Gry na konsole / Retro / Pegasus",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258472) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(258472) Kultura i rozrywka / Gry / Gry na konsole / Retro / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sega (Game Gear, Master System)",
    "categoryPath": [
      "(314781) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(314781) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sega (Game Gear, Master System)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Megadrive",
    "categoryPath": [
      "(258540) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sega (Megadrive, Saturn)"
    ],
    "hierarchy": "(258540) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sega (Megadrive, Saturn) / Megadrive",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Saturn",
    "categoryPath": [
      "(258541) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sega (Megadrive, Saturn)"
    ],
    "hierarchy": "(258541) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sega (Megadrive, Saturn) / Saturn",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sega Dreamcast",
    "categoryPath": [
      "(258470) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro"
    ],
    "hierarchy": "(258470) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sega Dreamcast",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258503) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258503) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(258536) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258536) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258510) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258510) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258512) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258512) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(258506) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258506) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258504) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258504) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(258507) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258507) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258505) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258505) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258509) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258509) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258511) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258511) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258508) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258508) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258502) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation (PSX)"
    ],
    "hierarchy": "(258502) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation (PSX) / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258480) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258480) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(258524) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258524) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258487) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258487) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258489) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258489) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(258483) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258483) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258481) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258481) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(258484) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258484) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258482) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258482) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258486) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258486) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258488) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258488) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(258485) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258485) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258479) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Retro",
      "Sony PlayStation 2 (PS2)"
    ],
    "hierarchy": "(258479) Kultura i rozrywka / Gry / Gry na konsole / Retro / Sony PlayStation 2 (PS2) / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(109955) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(109955) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(109956) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(109956) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258635) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(258635) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(109954) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(109954) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(109958) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(109958) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(109959) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(109959) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(109960) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(109960) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258633) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(258633) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258634) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(258634) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258636) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(258636) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(109961) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(109961) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258632) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PS Vita"
    ],
    "hierarchy": "(258632) Kultura i rozrywka / Gry / Gry na konsole / Sony PS Vita / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(82454) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82454) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Filmy UMD",
    "categoryPath": [
      "(82452) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82452) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Filmy UMD",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(82453) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82453) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258631) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(258631) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82460) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82460) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(82455) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82455) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(82458) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82458) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(82456) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82456) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258629) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(258629) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258630) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(258630) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258664) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(258664) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(82457) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(82457) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258628) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PSP"
    ],
    "hierarchy": "(258628) Kultura i rozrywka / Gry / Gry na konsole / Sony PSP / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(82421) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(82421) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(82422) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(82422) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258640) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(258640) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(82428) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(82428) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(82423) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(82423) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(82424) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(82424) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(82429) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(82429) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258638) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(258638) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258639) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(258639) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258641) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(258641) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(82426) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(82426) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258637) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 3 (PS3)"
    ],
    "hierarchy": "(258637) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 3 (PS3) / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258643) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(258643) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(146704) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(146704) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(258648) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(258648) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(146703) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(146703) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(146707) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(146707) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(258645) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(258645) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(146706) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(146706) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(258646) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(258646) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(258647) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(258647) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258649) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(258649) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(146705) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(146705) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258644) Kultura i rozrywka",
      "Gry",
      "Gry na konsole",
      "Sony PlayStation 4 (PS4)"
    ],
    "hierarchy": "(258644) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 4 (PS4) / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sony PlayStation 5 (PS5)",
    "categoryPath": [
      "(314793) Kultura i rozrywka",
      "Gry",
      "Gry na konsole"
    ],
    "hierarchy": "(314793) Kultura i rozrywka / Gry / Gry na konsole / Sony PlayStation 5 (PS5)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bijatyki",
    "categoryPath": [
      "(258848) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(258848) Kultura i rozrywka / Gry / Komputerowe PC / Bijatyki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Czasopisma z grami",
    "categoryPath": [
      "(45716) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45716) Kultura i rozrywka / Gry / Komputerowe PC / Czasopisma z grami",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Edukacyjne",
    "categoryPath": [
      "(317207) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(317207) Kultura i rozrywka / Gry / Komputerowe PC / Edukacyjne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Gry akcji",
    "categoryPath": [
      "(45718) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45718) Kultura i rozrywka / Gry / Komputerowe PC / Gry akcji",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Logiczne",
    "categoryPath": [
      "(45719) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45719) Kultura i rozrywka / Gry / Komputerowe PC / Logiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(45727) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45727) Kultura i rozrywka / Gry / Komputerowe PC / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(45720) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45720) Kultura i rozrywka / Gry / Komputerowe PC / Przygodowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Role Playing (RPG)",
    "categoryPath": [
      "(45721) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45721) Kultura i rozrywka / Gry / Komputerowe PC / Role Playing (RPG)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(45722) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45722) Kultura i rozrywka / Gry / Komputerowe PC / Sportowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strategiczne",
    "categoryPath": [
      "(45723) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45723) Kultura i rozrywka / Gry / Komputerowe PC / Strategiczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Strzelaniny",
    "categoryPath": [
      "(82484) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(82484) Kultura i rozrywka / Gry / Komputerowe PC / Strzelaniny",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Symulacje",
    "categoryPath": [
      "(45724) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45724) Kultura i rozrywka / Gry / Komputerowe PC / Symulacje",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Towarzyskie",
    "categoryPath": [
      "(258847) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(258847) Kultura i rozrywka / Gry / Komputerowe PC / Towarzyskie",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wyścigi",
    "categoryPath": [
      "(45725) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(45725) Kultura i rozrywka / Gry / Komputerowe PC / Wyścigi",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zręcznościowe",
    "categoryPath": [
      "(258846) Kultura i rozrywka",
      "Gry",
      "Komputerowe PC"
    ],
    "hierarchy": "(258846) Kultura i rozrywka / Gry / Komputerowe PC / Zręcznościowe",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Poradniki",
    "categoryPath": [
      "(258715) Kultura i rozrywka",
      "Gry"
    ],
    "hierarchy": "(258715) Kultura i rozrywka / Gry / Poradniki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Konta do gier F2P",
    "categoryPath": [
      "(45755) Kultura i rozrywka",
      "Gry",
      "Przedmioty cyfrowe"
    ],
    "hierarchy": "(45755) Kultura i rozrywka / Gry / Przedmioty cyfrowe / Konta do gier F2P",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(45754) Kultura i rozrywka",
      "Gry",
      "Przedmioty cyfrowe"
    ],
    "hierarchy": "(45754) Kultura i rozrywka / Gry / Przedmioty cyfrowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przedmioty",
    "categoryPath": [
      "(45766) Kultura i rozrywka",
      "Gry",
      "Przedmioty cyfrowe"
    ],
    "hierarchy": "(45766) Kultura i rozrywka / Gry / Przedmioty cyfrowe / Przedmioty",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Przedmioty kosmetyczne",
    "categoryPath": [
      "(256914) Kultura i rozrywka",
      "Gry",
      "Przedmioty cyfrowe"
    ],
    "hierarchy": "(256914) Kultura i rozrywka / Gry / Przedmioty cyfrowe / Przedmioty kosmetyczne",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Waluty",
    "categoryPath": [
      "(45764) Kultura i rozrywka",
      "Gry",
      "Przedmioty cyfrowe"
    ],
    "hierarchy": "(45764) Kultura i rozrywka / Gry / Przedmioty cyfrowe / Waluty",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Akcesoria do transportu",
    "categoryPath": [
      "(310461) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(310461) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Akcesoria do transportu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Farby",
    "categoryPath": [
      "(256605) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(256605) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Farby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koszulki na karty",
    "categoryPath": [
      "(256606) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(256606) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Koszulki na karty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kości",
    "categoryPath": [
      "(256604) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(256604) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Kości",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(256608) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(256608) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Literatura",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maty",
    "categoryPath": [
      "(310449) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(310449) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Maty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Monety i żetony",
    "categoryPath": [
      "(310473) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(310473) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Monety i żetony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Organizery i inserty",
    "categoryPath": [
      "(310437) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(310437) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Organizery i inserty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256609) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(256609) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wieże do kości",
    "categoryPath": [
      "(310425) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(310425) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Wieże do kości",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Woreczki i sakiewki",
    "categoryPath": [
      "(310413) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Akcesoria"
    ],
    "hierarchy": "(310413) Kultura i rozrywka / Gry / Towarzyskie / Akcesoria / Woreczki i sakiewki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Makiety, dioramy",
    "categoryPath": [
      "(312389) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Akcesoria"
    ],
    "hierarchy": "(312389) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Akcesoria / Makiety, dioramy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maty",
    "categoryPath": [
      "(312353) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Akcesoria"
    ],
    "hierarchy": "(312353) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Akcesoria / Maty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(312401) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Akcesoria"
    ],
    "hierarchy": "(312401) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Inne systemy",
    "categoryPath": [
      "(6059) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne"
    ],
    "hierarchy": "(6059) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Inne systemy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Lord of the Rings",
    "categoryPath": [
      "(9191) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne"
    ],
    "hierarchy": "(9191) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Lord of the Rings",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(6052) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne"
    ],
    "hierarchy": "(6052) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Star Wars: X-wing",
    "categoryPath": [
      "(312329) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne"
    ],
    "hierarchy": "(312329) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Star Wars: X-wing",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Chaos Daemons",
    "categoryPath": [
      "(257225) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of Chaos"
    ],
    "hierarchy": "(257225) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of Chaos / Chaos Daemons",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Chaos Knights",
    "categoryPath": [
      "(317081) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of Chaos"
    ],
    "hierarchy": "(317081) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of Chaos / Chaos Knights",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Chaos Space Marines",
    "categoryPath": [
      "(45836) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of Chaos"
    ],
    "hierarchy": "(45836) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of Chaos / Chaos Space Marines",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Death Guard",
    "categoryPath": [
      "(317084) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of Chaos"
    ],
    "hierarchy": "(317084) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of Chaos / Death Guard",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Thousand Sons",
    "categoryPath": [
      "(317087) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of Chaos"
    ],
    "hierarchy": "(317087) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of Chaos / Thousand Sons",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Adepta Sororitas",
    "categoryPath": [
      "(317063) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(317063) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Adepta Sororitas",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Adeptus Custodes",
    "categoryPath": [
      "(317066) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(317066) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Adeptus Custodes",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Adeptus Mechanicus",
    "categoryPath": [
      "(317069) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(317069) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Adeptus Mechanicus",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Astra Militarum",
    "categoryPath": [
      "(45839) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(45839) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Astra Militarum",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Imperial Inquisition/Inquisition",
    "categoryPath": [
      "(45840) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(45840) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Imperial Inquisition/Inquisition",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Imperial Knights",
    "categoryPath": [
      "(317072) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(317072) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Imperial Knights",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Officio Assassinorum",
    "categoryPath": [
      "(317075) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(317075) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Officio Assassinorum",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sisters of Silence",
    "categoryPath": [
      "(317078) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Armies of the Imperium"
    ],
    "hierarchy": "(317078) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Armies of the Imperium / Sisters of Silence",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(45834) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000"
    ],
    "hierarchy": "(45834) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Black Templars",
    "categoryPath": [
      "(317030) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317030) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Black Templars",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Blood Angels",
    "categoryPath": [
      "(317033) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317033) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Blood Angels",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dark Angels",
    "categoryPath": [
      "(317036) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317036) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Dark Angels",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Deathwatch",
    "categoryPath": [
      "(317039) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317039) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Deathwatch",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Grey Knights",
    "categoryPath": [
      "(257224) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(257224) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Grey Knights",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Imperial Fists",
    "categoryPath": [
      "(317042) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317042) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Imperial Fists",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Iron Hands",
    "categoryPath": [
      "(317045) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317045) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Iron Hands",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Raven Guard",
    "categoryPath": [
      "(317048) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317048) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Raven Guard",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Salamanders",
    "categoryPath": [
      "(317051) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317051) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Salamanders",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Space Marines",
    "categoryPath": [
      "(45843) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(45843) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Space Marines",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Space Wolves",
    "categoryPath": [
      "(317054) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317054) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Space Wolves",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ultramarines",
    "categoryPath": [
      "(317057) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317057) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / Ultramarines",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "White Scars",
    "categoryPath": [
      "(317060) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Space Marines"
    ],
    "hierarchy": "(317060) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Space Marines / White Scars",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dark Eldar/Drukhari",
    "categoryPath": [
      "(45837) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(45837) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Dark Eldar/Drukhari",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Eldar/Craftworlds",
    "categoryPath": [
      "(45838) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(45838) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Eldar/Craftworlds",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Genestealer Cults",
    "categoryPath": [
      "(317090) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(317090) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Genestealer Cults",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Harlequins",
    "categoryPath": [
      "(317093) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(317093) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Harlequins",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Necrons",
    "categoryPath": [
      "(45841) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(45841) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Necrons",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Orks",
    "categoryPath": [
      "(45842) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(45842) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Orks",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "T'au Empire",
    "categoryPath": [
      "(45844) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(45844) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / T'au Empire",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Tyranids",
    "categoryPath": [
      "(45845) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(45845) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Tyranids",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ynnari",
    "categoryPath": [
      "(317096) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000",
      "Xenos Armies"
    ],
    "hierarchy": "(317096) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Xenos Armies / Ynnari",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(45835) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer 40000"
    ],
    "hierarchy": "(45835) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer 40000 / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Beast of Chaos",
    "categoryPath": [
      "(317141) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Chaos"
    ],
    "hierarchy": "(317141) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Chaos / Beast of Chaos",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Blades of Khorne",
    "categoryPath": [
      "(317144) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Chaos"
    ],
    "hierarchy": "(317144) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Chaos / Blades of Khorne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Disciples of Tzeentch",
    "categoryPath": [
      "(317147) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Chaos"
    ],
    "hierarchy": "(317147) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Chaos / Disciples of Tzeentch",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Hedoniets of Slaanesh",
    "categoryPath": [
      "(317150) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Chaos"
    ],
    "hierarchy": "(317150) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Chaos / Hedoniets of Slaanesh",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Maggothkin of Nurgle",
    "categoryPath": [
      "(317153) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Chaos"
    ],
    "hierarchy": "(317153) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Chaos / Maggothkin of Nurgle",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Skaven",
    "categoryPath": [
      "(317156) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Chaos"
    ],
    "hierarchy": "(317156) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Chaos / Skaven",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Slaves of Darkness",
    "categoryPath": [
      "(317159) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Chaos"
    ],
    "hierarchy": "(317159) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Chaos / Slaves of Darkness",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Flesh-eater Courts",
    "categoryPath": [
      "(317162) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Death"
    ],
    "hierarchy": "(317162) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Death / Flesh-eater Courts",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Legions of Nagash",
    "categoryPath": [
      "(317165) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Death"
    ],
    "hierarchy": "(317165) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Death / Legions of Nagash",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Nighthaunt",
    "categoryPath": [
      "(317168) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Death"
    ],
    "hierarchy": "(317168) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Death / Nighthaunt",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ossiarch Bonereapers",
    "categoryPath": [
      "(317171) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Death"
    ],
    "hierarchy": "(317171) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Death / Ossiarch Bonereapers",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Gloomspite Gitz",
    "categoryPath": [
      "(317174) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Destruction"
    ],
    "hierarchy": "(317174) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Destruction / Gloomspite Gitz",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ogor Mawtribes",
    "categoryPath": [
      "(317177) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Destruction"
    ],
    "hierarchy": "(317177) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Destruction / Ogor Mawtribes",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Orruk Warclans",
    "categoryPath": [
      "(317180) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Destruction"
    ],
    "hierarchy": "(317180) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Destruction / Orruk Warclans",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sons of Behemat",
    "categoryPath": [
      "(317183) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Destruction"
    ],
    "hierarchy": "(317183) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Destruction / Sons of Behemat",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Cities of Sigmar",
    "categoryPath": [
      "(317117) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317117) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Cities of Sigmar",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Daughters of Khaime",
    "categoryPath": [
      "(317120) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317120) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Daughters of Khaime",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fyreslayers",
    "categoryPath": [
      "(317270) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317270) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Fyreslayers",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Idoneth Deepkin",
    "categoryPath": [
      "(317123) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317123) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Idoneth Deepkin",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kharadron Overlords",
    "categoryPath": [
      "(317126) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317126) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Kharadron Overlords",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Lumineth Realm-lords",
    "categoryPath": [
      "(317129) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317129) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Lumineth Realm-lords",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Seraphon",
    "categoryPath": [
      "(317132) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317132) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Seraphon",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Stormcast Eternals",
    "categoryPath": [
      "(317135) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317135) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Stormcast Eternals",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sylvaneth",
    "categoryPath": [
      "(317138) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar",
      "Grand Alliance Order"
    ],
    "hierarchy": "(317138) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Grand Alliance Order / Sylvaneth",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(317204) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Age of Sigmar"
    ],
    "hierarchy": "(317204) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Age of Sigmar / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Bretonnia",
    "categoryPath": [
      "(12956) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12956) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Bretonnia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Chaos",
    "categoryPath": [
      "(12955) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12955) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Chaos",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Daemons of Chaos",
    "categoryPath": [
      "(82483) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(82483) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Daemons of Chaos",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dark Elves",
    "categoryPath": [
      "(12957) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12957) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Dark Elves",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dwarfs",
    "categoryPath": [
      "(12959) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12959) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Dwarfs",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Empire",
    "categoryPath": [
      "(12960) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12960) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Empire",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "High Elves",
    "categoryPath": [
      "(12961) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12961) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / High Elves",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Lizardmen",
    "categoryPath": [
      "(12962) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12962) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Lizardmen",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ogre Kingdoms",
    "categoryPath": [
      "(12963) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12963) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Ogre Kingdoms",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Orcs and Goblins",
    "categoryPath": [
      "(12964) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12964) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Orcs and Goblins",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(12953) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12953) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skaven",
    "categoryPath": [
      "(12965) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12965) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Skaven",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Tomb Kings",
    "categoryPath": [
      "(19528) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(19528) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Tomb Kings",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Vampire Counts",
    "categoryPath": [
      "(19529) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(19529) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Vampire Counts",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Wood Elves",
    "categoryPath": [
      "(12967) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12967) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Wood Elves",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(12954) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Bitewne",
      "Warhammer Fantasy Battle"
    ],
    "hierarchy": "(12954) Kultura i rozrywka / Gry / Towarzyskie / Bitewne / Warhammer Fantasy Battle / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(6099) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Fabularne (RPG)"
    ],
    "hierarchy": "(6099) Kultura i rozrywka / Gry / Towarzyskie / Fabularne (RPG) / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gry paragrafowe",
    "categoryPath": [
      "(311153) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Fabularne (RPG)"
    ],
    "hierarchy": "(311153) Kultura i rozrywka / Gry / Towarzyskie / Fabularne (RPG) / Gry paragrafowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Systemy, podręczniki",
    "categoryPath": [
      "(315401) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Fabularne (RPG)"
    ],
    "hierarchy": "(315401) Kultura i rozrywka / Gry / Towarzyskie / Fabularne (RPG) / Systemy, podręczniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Imprezowe",
    "categoryPath": [
      "(258903) Kultura i rozrywka",
      "Gry",
      "Towarzyskie"
    ],
    "hierarchy": "(258903) Kultura i rozrywka / Gry / Towarzyskie / Imprezowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(6060) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane"
    ],
    "hierarchy": "(6060) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Karciane dla najmłodszych",
    "categoryPath": [
      "(319045) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane"
    ],
    "hierarchy": "(319045) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Karciane dla najmłodszych",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Karciane tradycyjne",
    "categoryPath": [
      "(256618) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane"
    ],
    "hierarchy": "(256618) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Karciane tradycyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Inne systemy",
    "categoryPath": [
      "(312233) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie"
    ],
    "hierarchy": "(312233) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Inne systemy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Artefakty",
    "categoryPath": [
      "(6089) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6089) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Artefakty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Bezkolorowe",
    "categoryPath": [
      "(261207) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(261207) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Bezkolorowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Białe",
    "categoryPath": [
      "(6090) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6090) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Białe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Czarne",
    "categoryPath": [
      "(6091) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6091) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Czarne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Czerwone",
    "categoryPath": [
      "(6092) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6092) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Czerwone",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Lądy",
    "categoryPath": [
      "(6093) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6093) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Lądy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Multikolor",
    "categoryPath": [
      "(6094) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6094) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Multikolor",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Niebieskie",
    "categoryPath": [
      "(6095) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6095) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Niebieskie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(6087) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6087) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Decki i boostery (nowe)",
    "categoryPath": [
      "(9319) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering",
      "Zestawy kart"
    ],
    "hierarchy": "(9319) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Zestawy kart / Decki i boostery (nowe)",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(9318) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering",
      "Zestawy kart"
    ],
    "hierarchy": "(9318) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Zestawy kart / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Talie i repacki",
    "categoryPath": [
      "(9320) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering",
      "Zestawy kart"
    ],
    "hierarchy": "(9320) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Zestawy kart / Talie i repacki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zielone",
    "categoryPath": [
      "(6096) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie",
      "Magic: The Gathering"
    ],
    "hierarchy": "(6096) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Magic: The Gathering / Zielone",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pokemon",
    "categoryPath": [
      "(6067) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie"
    ],
    "hierarchy": "(6067) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Pokemon",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Yu-Gi-Oh!",
    "categoryPath": [
      "(9324) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane",
      "Kolekcjonerskie"
    ],
    "hierarchy": "(9324) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Kolekcjonerskie / Yu-Gi-Oh!",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Poker",
    "categoryPath": [
      "(312089) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane"
    ],
    "hierarchy": "(312089) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Poker",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(6070) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane"
    ],
    "hierarchy": "(6070) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Talie tradycyjne",
    "categoryPath": [
      "(312101) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane"
    ],
    "hierarchy": "(312101) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Talie tradycyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Tarot",
    "categoryPath": [
      "(312113) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Karciane"
    ],
    "hierarchy": "(312113) Kultura i rozrywka / Gry / Towarzyskie / Karciane / Tarot",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kościane",
    "categoryPath": [
      "(258902) Kultura i rozrywka",
      "Gry",
      "Towarzyskie"
    ],
    "hierarchy": "(258902) Kultura i rozrywka / Gry / Towarzyskie / Kościane",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dorosłych",
    "categoryPath": [
      "(256617) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(256617) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Dla dorosłych",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla najmłodszych",
    "categoryPath": [
      "(123958) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(123958) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Dla najmłodszych",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ekonomiczne",
    "categoryPath": [
      "(256612) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(256612) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Ekonomiczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kooperacyjne",
    "categoryPath": [
      "(310525) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(310525) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Kooperacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Logiczne i edukacyjne",
    "categoryPath": [
      "(6106) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(6106) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Logiczne i edukacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(6102) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(6102) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przygodowe",
    "categoryPath": [
      "(256614) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(256614) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Przygodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rodzinne",
    "categoryPath": [
      "(6105) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(6105) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Rodzinne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sportowe i wyścigowe",
    "categoryPath": [
      "(256615) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(256615) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Sportowe i wyścigowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Strategiczne i wojenne",
    "categoryPath": [
      "(6103) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(6103) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Strategiczne i wojenne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Figury szachowe",
    "categoryPath": [
      "(303185) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Akcesoria"
    ],
    "hierarchy": "(303185) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Akcesoria / Figury szachowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(303209) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Akcesoria"
    ],
    "hierarchy": "(303209) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Akcesoria / Literatura",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stoły szachowe",
    "categoryPath": [
      "(303221) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Akcesoria"
    ],
    "hierarchy": "(303221) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Akcesoria / Stoły szachowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szachownice",
    "categoryPath": [
      "(303197) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Akcesoria"
    ],
    "hierarchy": "(303197) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Akcesoria / Szachownice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zegary szachowe",
    "categoryPath": [
      "(303173) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Akcesoria"
    ],
    "hierarchy": "(303173) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Akcesoria / Zegary szachowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(6109) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy"
    ],
    "hierarchy": "(6109) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(303141) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Szachy Drewniane"
    ],
    "hierarchy": "(303141) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Drewniane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rzeźbione",
    "categoryPath": [
      "(303129) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Szachy Drewniane"
    ],
    "hierarchy": "(303129) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Drewniane / Rzeźbione",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Tradycyjne",
    "categoryPath": [
      "(303105) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Szachy Drewniane"
    ],
    "hierarchy": "(303105) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Drewniane / Tradycyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Turniejowe",
    "categoryPath": [
      "(303117) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy",
      "Szachy Drewniane"
    ],
    "hierarchy": "(303117) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Drewniane / Turniejowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Szachy Elektroniczne",
    "categoryPath": [
      "(6112) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy"
    ],
    "hierarchy": "(6112) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Elektroniczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Szachy Magnetyczne",
    "categoryPath": [
      "(6113) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy"
    ],
    "hierarchy": "(6113) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Magnetyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Szachy Metalowe",
    "categoryPath": [
      "(303057) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy"
    ],
    "hierarchy": "(303057) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Metalowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Szachy Szklane",
    "categoryPath": [
      "(9241) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy"
    ],
    "hierarchy": "(9241) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy Szklane",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Szachy z tworzywa",
    "categoryPath": [
      "(303081) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy"
    ],
    "hierarchy": "(303081) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Szachy z tworzywa",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(303069) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Szachy"
    ],
    "hierarchy": "(303069) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Szachy / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Słowne i liczbowe",
    "categoryPath": [
      "(315554) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(315554) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Słowne i liczbowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Backgammon",
    "categoryPath": [
      "(310669) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Tradycyjne"
    ],
    "hierarchy": "(310669) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Tradycyjne / Backgammon",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Chińczyk",
    "categoryPath": [
      "(310657) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Tradycyjne"
    ],
    "hierarchy": "(310657) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Tradycyjne / Chińczyk",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Domino",
    "categoryPath": [
      "(256610) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Tradycyjne"
    ],
    "hierarchy": "(256610) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Tradycyjne / Domino",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Warcaby",
    "categoryPath": [
      "(6108) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe",
      "Tradycyjne"
    ],
    "hierarchy": "(6108) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Tradycyjne / Warcaby",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Układanki",
    "categoryPath": [
      "(310537) Kultura i rozrywka",
      "Gry",
      "Towarzyskie",
      "Planszowe"
    ],
    "hierarchy": "(310537) Kultura i rozrywka / Gry / Towarzyskie / Planszowe / Układanki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(6047) Kultura i rozrywka",
      "Gry",
      "Towarzyskie"
    ],
    "hierarchy": "(6047) Kultura i rozrywka / Gry / Towarzyskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akustyczne",
    "categoryPath": [
      "(260274) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(260274) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Akustyczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Basowe",
    "categoryPath": [
      "(260307) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(260307) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Basowe",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Potencjometry",
    "categoryPath": [
      "(148348) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Elektronika"
    ],
    "hierarchy": "(148348) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Elektronika / Potencjometry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122744) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Elektronika"
    ],
    "hierarchy": "(122744) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Elektronika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przetworniki",
    "categoryPath": [
      "(122742) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Elektronika"
    ],
    "hierarchy": "(122742) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Elektronika / Przetworniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tunery i metronomy",
    "categoryPath": [
      "(122743) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Elektronika"
    ],
    "hierarchy": "(122743) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Elektronika / Tunery i metronomy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gałki",
    "categoryPath": [
      "(122745) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122745) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Gałki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kable",
    "categoryPath": [
      "(122746) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122746) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Kable",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kapodastry",
    "categoryPath": [
      "(122747) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122747) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Kapodastry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klucze",
    "categoryPath": [
      "(122748) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122748) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Klucze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podstrunnica",
    "categoryPath": [
      "(148352) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Konserwacja, pielęgnacja"
    ],
    "hierarchy": "(148352) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Konserwacja, pielęgnacja / Podstrunnica",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Powierzchnie lakierowane",
    "categoryPath": [
      "(148354) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Konserwacja, pielęgnacja"
    ],
    "hierarchy": "(148354) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Konserwacja, pielęgnacja / Powierzchnie lakierowane",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Powierzchnie nielakierowane",
    "categoryPath": [
      "(148353) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Konserwacja, pielęgnacja"
    ],
    "hierarchy": "(148353) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Konserwacja, pielęgnacja / Powierzchnie nielakierowane",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148351) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Konserwacja, pielęgnacja"
    ],
    "hierarchy": "(148351) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Konserwacja, pielęgnacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Struny",
    "categoryPath": [
      "(148355) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Konserwacja, pielęgnacja"
    ],
    "hierarchy": "(148355) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Konserwacja, pielęgnacja / Struny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ściereczki",
    "categoryPath": [
      "(148356) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria",
      "Konserwacja, pielęgnacja"
    ],
    "hierarchy": "(148356) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Konserwacja, pielęgnacja / Ściereczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korbki",
    "categoryPath": [
      "(318253) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(318253) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Korbki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korpusy i gryfy",
    "categoryPath": [
      "(148349) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(148349) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Korpusy i gryfy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kostki",
    "categoryPath": [
      "(122749) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122749) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Kostki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mostki",
    "categoryPath": [
      "(122750) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122750) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Mostki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(122751) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122751) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Paski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podgitarniki i podnóżki",
    "categoryPath": [
      "(148357) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(148357) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Podgitarniki i podnóżki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce, futerały",
    "categoryPath": [
      "(122752) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122752) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Pokrowce, futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122760) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122760) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Slidy",
    "categoryPath": [
      "(122753) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122753) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Slidy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Struny",
    "categoryPath": [
      "(122755) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(122755) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Struny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(322917) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Części i akcesoria"
    ],
    "hierarchy": "(322917) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Części i akcesoria / Zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(122724) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(122724) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Dla dzieci",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Elektroakustyczne",
    "categoryPath": [
      "(319547) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(319547) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Elektroakustyczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Elektryczne",
    "categoryPath": [
      "(260310) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(260310) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Elektryczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Hybrydowe",
    "categoryPath": [
      "(122725) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(122725) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Hybrydowe",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Klasyczne",
    "categoryPath": [
      "(260311) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(260311) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Klasyczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Mandoliny, banjo",
    "categoryPath": [
      "(318256) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(318256) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Mandoliny, banjo",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Procesory, Efekty, Preampy",
    "categoryPath": [
      "(122726) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(122726) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Procesory, Efekty, Preampy",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Ukulele",
    "categoryPath": [
      "(260316) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria"
    ],
    "hierarchy": "(260316) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Ukulele",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Basowe",
    "categoryPath": [
      "(122731) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Wzmacniacze i kolumny"
    ],
    "hierarchy": "(122731) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Wzmacniacze i kolumny / Basowe",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Części i akcesoria",
    "categoryPath": [
      "(122739) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Wzmacniacze i kolumny"
    ],
    "hierarchy": "(122739) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Wzmacniacze i kolumny / Części i akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gitarowe",
    "categoryPath": [
      "(122735) Kultura i rozrywka",
      "Instrumenty",
      "Gitary i akcesoria",
      "Wzmacniacze i kolumny"
    ],
    "hierarchy": "(122735) Kultura i rozrywka / Instrumenty / Gitary i akcesoria / Wzmacniacze i kolumny / Gitarowe",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122767) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Blaszane"
    ],
    "hierarchy": "(122767) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Blaszane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Puzony",
    "categoryPath": [
      "(122763) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Blaszane"
    ],
    "hierarchy": "(122763) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Blaszane / Puzony",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Rogi",
    "categoryPath": [
      "(122764) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Blaszane"
    ],
    "hierarchy": "(122764) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Blaszane / Rogi",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Trąbki",
    "categoryPath": [
      "(122765) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Blaszane"
    ],
    "hierarchy": "(122765) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Blaszane / Trąbki",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Trąbki sygnałowe",
    "categoryPath": [
      "(122766) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Blaszane"
    ],
    "hierarchy": "(122766) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Blaszane / Trąbki sygnałowe",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Tuby",
    "categoryPath": [
      "(317435) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Blaszane"
    ],
    "hierarchy": "(317435) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Blaszane / Tuby",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Waltornie",
    "categoryPath": [
      "(317432) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Blaszane"
    ],
    "hierarchy": "(317432) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Blaszane / Waltornie",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Części zamienne",
    "categoryPath": [
      "(317390) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(317390) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Części zamienne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Konserwacja, pielęgnacja",
    "categoryPath": [
      "(317444) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(317444) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Konserwacja, pielęgnacja",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lirki",
    "categoryPath": [
      "(122783) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(122783) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Lirki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(317387) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(317387) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Ochraniacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(122784) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(122784) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Paski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce, futerały",
    "categoryPath": [
      "(122785) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(122785) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Pokrowce, futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122789) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(122789) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stroiki, tunery",
    "categoryPath": [
      "(122787) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(122787) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Stroiki, tunery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tłumiki",
    "categoryPath": [
      "(317381) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(317381) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Tłumiki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ustniki",
    "categoryPath": [
      "(122788) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(122788) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Ustniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wyciory",
    "categoryPath": [
      "(317384) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Części i akcesoria"
    ],
    "hierarchy": "(317384) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Części i akcesoria / Wyciory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Didgeridoo",
    "categoryPath": [
      "(317438) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(317438) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Didgeridoo",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Fletnia Pana",
    "categoryPath": [
      "(318259) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(318259) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Fletnia Pana",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Flety poprzeczne",
    "categoryPath": [
      "(122770) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(122770) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Flety poprzeczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Flety proste",
    "categoryPath": [
      "(122771) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(122771) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Flety proste",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Klarnety",
    "categoryPath": [
      "(122772) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(122772) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Klarnety",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Kontrafagoty",
    "categoryPath": [
      "(122773) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(122773) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Kontrafagoty",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122776) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(122776) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Saksofony",
    "categoryPath": [
      "(122775) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Drewniane"
    ],
    "hierarchy": "(122775) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Drewniane / Saksofony",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Flażolety",
    "categoryPath": [
      "(322110) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte"
    ],
    "hierarchy": "(322110) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Flażolety",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Harmonijki",
    "categoryPath": [
      "(122777) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte"
    ],
    "hierarchy": "(122777) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Harmonijki",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Kazoo",
    "categoryPath": [
      "(318262) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte"
    ],
    "hierarchy": "(318262) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Kazoo",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Melodyki",
    "categoryPath": [
      "(317441) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Klawiszowe"
    ],
    "hierarchy": "(317441) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Klawiszowe / Melodyki",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122780) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte",
      "Klawiszowe"
    ],
    "hierarchy": "(122780) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Klawiszowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122781) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty dęte"
    ],
    "hierarchy": "(122781) Kultura i rozrywka / Instrumenty / Instrumenty dęte / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Instrumenty etniczne",
    "categoryPath": [
      "(318277) Kultura i rozrywka",
      "Instrumenty"
    ],
    "hierarchy": "(318277) Kultura i rozrywka / Instrumenty / Instrumenty etniczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Akordeony",
    "categoryPath": [
      "(122791) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI"
    ],
    "hierarchy": "(122791) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Akordeony",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Kable, złącza",
    "categoryPath": [
      "(122807) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Części i akcesoria"
    ],
    "hierarchy": "(122807) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Części i akcesoria / Kable, złącza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(318398) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Części i akcesoria"
    ],
    "hierarchy": "(318398) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Części i akcesoria / Paski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pedały",
    "categoryPath": [
      "(122808) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Części i akcesoria"
    ],
    "hierarchy": "(122808) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Części i akcesoria / Pedały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce, futerały",
    "categoryPath": [
      "(122809) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Części i akcesoria"
    ],
    "hierarchy": "(122809) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Części i akcesoria / Pokrowce, futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122812) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Części i akcesoria"
    ],
    "hierarchy": "(122812) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Części i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stołki, krzesła, ławy",
    "categoryPath": [
      "(122811) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Części i akcesoria"
    ],
    "hierarchy": "(122811) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Części i akcesoria / Stołki, krzesła, ławy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(322916) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Części i akcesoria"
    ],
    "hierarchy": "(322916) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Części i akcesoria / Zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Keyboardy",
    "categoryPath": [
      "(318178) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI"
    ],
    "hierarchy": "(318178) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Keyboardy",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Moduły brzmieniowe i samplery",
    "categoryPath": [
      "(122804) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI"
    ],
    "hierarchy": "(122804) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Moduły brzmieniowe i samplery",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pianina cyfrowe",
    "categoryPath": [
      "(122803) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI"
    ],
    "hierarchy": "(122803) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Pianina cyfrowe",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Fortepiany",
    "categoryPath": [
      "(122793) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Pianina i fortepiany"
    ],
    "hierarchy": "(122793) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Pianina i fortepiany / Fortepiany",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pianina",
    "categoryPath": [
      "(122794) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI",
      "Pianina i fortepiany"
    ],
    "hierarchy": "(122794) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Pianina i fortepiany / Pianina",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122805) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI"
    ],
    "hierarchy": "(122805) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Syntezatory i klawiatury sterujące",
    "categoryPath": [
      "(122795) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty klawiszowe i MIDI"
    ],
    "hierarchy": "(122795) Kultura i rozrywka / Instrumenty / Instrumenty klawiszowe i MIDI / Syntezatory i klawiatury sterujące",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Bongosy",
    "categoryPath": [
      "(122815) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Bębny i bębenki"
    ],
    "hierarchy": "(122815) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Bębny i bębenki / Bongosy",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Cajony",
    "categoryPath": [
      "(317450) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Bębny i bębenki"
    ],
    "hierarchy": "(317450) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Bębny i bębenki / Cajony",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Conga",
    "categoryPath": [
      "(317453) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Bębny i bębenki"
    ],
    "hierarchy": "(317453) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Bębny i bębenki / Conga",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Djembe",
    "categoryPath": [
      "(122816) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Bębny i bębenki"
    ],
    "hierarchy": "(122816) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Bębny i bębenki / Djembe",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Klasyczne",
    "categoryPath": [
      "(122817) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Bębny i bębenki"
    ],
    "hierarchy": "(122817) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Bębny i bębenki / Klasyczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122818) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Bębny i bębenki"
    ],
    "hierarchy": "(122818) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Bębny i bębenki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tamburyna",
    "categoryPath": [
      "(122819) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Bębny i bębenki"
    ],
    "hierarchy": "(122819) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Bębny i bębenki / Tamburyna",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Naciągi",
    "categoryPath": [
      "(122830) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Części i akcesoria"
    ],
    "hierarchy": "(122830) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Części i akcesoria / Naciągi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pady ćwiczeniowe",
    "categoryPath": [
      "(317447) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Części i akcesoria"
    ],
    "hierarchy": "(317447) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Części i akcesoria / Pady ćwiczeniowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pałki",
    "categoryPath": [
      "(122831) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Części i akcesoria"
    ],
    "hierarchy": "(122831) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Części i akcesoria / Pałki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce, futerały",
    "categoryPath": [
      "(122832) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Części i akcesoria"
    ],
    "hierarchy": "(122832) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Części i akcesoria / Pokrowce, futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122835) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Części i akcesoria"
    ],
    "hierarchy": "(122835) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Części i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stołki, taborety",
    "categoryPath": [
      "(122833) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Części i akcesoria"
    ],
    "hierarchy": "(122833) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Części i akcesoria / Stołki, taborety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stroiki, tunery",
    "categoryPath": [
      "(122834) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Części i akcesoria"
    ],
    "hierarchy": "(122834) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Części i akcesoria / Stroiki, tunery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dzwonki, cymbałki, trójkąty",
    "categoryPath": [
      "(122820) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne"
    ],
    "hierarchy": "(122820) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Dzwonki, cymbałki, trójkąty",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Kalimby",
    "categoryPath": [
      "(318265) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne"
    ],
    "hierarchy": "(318265) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Kalimby",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Maracasy, grzechotki, kastaniety",
    "categoryPath": [
      "(122821) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne"
    ],
    "hierarchy": "(122821) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Maracasy, grzechotki, kastaniety",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Hardware",
    "categoryPath": [
      "(122827) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Perkusje"
    ],
    "hierarchy": "(122827) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Perkusje / Hardware",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Talerze",
    "categoryPath": [
      "(122825) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Perkusje"
    ],
    "hierarchy": "(122825) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Perkusje / Talerze",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Werble, kotły, centrale",
    "categoryPath": [
      "(122826) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Perkusje"
    ],
    "hierarchy": "(122826) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Perkusje / Werble, kotły, centrale",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zestawy akustyczne",
    "categoryPath": [
      "(122823) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Perkusje"
    ],
    "hierarchy": "(122823) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Perkusje / Zestawy akustyczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zestawy elektroniczne",
    "categoryPath": [
      "(122824) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne",
      "Perkusje"
    ],
    "hierarchy": "(122824) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Perkusje / Zestawy elektroniczne",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122828) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty perkusyjne"
    ],
    "hierarchy": "(122828) Kultura i rozrywka / Instrumenty / Instrumenty perkusyjne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Altówki",
    "categoryPath": [
      "(122837) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe"
    ],
    "hierarchy": "(122837) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Altówki",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Części zamienne",
    "categoryPath": [
      "(318271) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(318271) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Części zamienne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kalafonie",
    "categoryPath": [
      "(122842) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(122842) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Kalafonie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Konserwacja, pielęgnacja",
    "categoryPath": [
      "(318274) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(318274) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Konserwacja, pielęgnacja",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce, futerały",
    "categoryPath": [
      "(122843) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(122843) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Pokrowce, futerały",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122847) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(122847) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Smyczki",
    "categoryPath": [
      "(122844) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(122844) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Smyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Struny",
    "categoryPath": [
      "(122845) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(122845) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Struny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Żeberka",
    "categoryPath": [
      "(122846) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe",
      "Części i akcesoria"
    ],
    "hierarchy": "(122846) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Części i akcesoria / Żeberka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kontrabasy",
    "categoryPath": [
      "(122838) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe"
    ],
    "hierarchy": "(122838) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Kontrabasy",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122848) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe"
    ],
    "hierarchy": "(122848) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzypce",
    "categoryPath": [
      "(122839) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe"
    ],
    "hierarchy": "(122839) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Skrzypce",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Wiolonczele",
    "categoryPath": [
      "(122840) Kultura i rozrywka",
      "Instrumenty",
      "Instrumenty smyczkowe"
    ],
    "hierarchy": "(122840) Kultura i rozrywka / Instrumenty / Instrumenty smyczkowe / Wiolonczele",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Kursy gry, nuty, śpiewniki",
    "categoryPath": [
      "(122849) Kultura i rozrywka",
      "Instrumenty"
    ],
    "hierarchy": "(122849) Kultura i rozrywka / Instrumenty / Kursy gry, nuty, śpiewniki",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Batuty",
    "categoryPath": [
      "(318268) Kultura i rozrywka",
      "Instrumenty",
      "Pozostałe"
    ],
    "hierarchy": "(318268) Kultura i rozrywka / Instrumenty / Pozostałe / Batuty",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122853) Kultura i rozrywka",
      "Instrumenty",
      "Pozostałe"
    ],
    "hierarchy": "(122853) Kultura i rozrywka / Instrumenty / Pozostałe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sample",
    "categoryPath": [
      "(122851) Kultura i rozrywka",
      "Instrumenty",
      "Pozostałe"
    ],
    "hierarchy": "(122851) Kultura i rozrywka / Instrumenty / Pozostałe / Sample",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Statywy, pulpity",
    "categoryPath": [
      "(122852) Kultura i rozrywka",
      "Instrumenty"
    ],
    "hierarchy": "(122852) Kultura i rozrywka / Instrumenty / Statywy, pulpity",
    "comissionGroupOld": "C28",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Blizzard",
    "categoryPath": [
      "(45769) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(45769) Kultura i rozrywka / Kody i doładowania / Gry / Blizzard",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Doładowania Xbox (Microsoft Store)",
    "categoryPath": [
      "(258099) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258099) Kultura i rozrywka / Kody i doładowania / Gry / Doładowania Xbox (Microsoft Store)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "EA Access",
    "categoryPath": [
      "(258097) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258097) Kultura i rozrywka / Kody i doładowania / Gry / EA Access",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "EA FC",
    "categoryPath": [
      "(322907) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(322907) Kultura i rozrywka / Kody i doładowania / Gry / EA FC",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "EA Origin",
    "categoryPath": [
      "(258096) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258096) Kultura i rozrywka / Kody i doładowania / Gry / EA Origin",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "FIFA",
    "categoryPath": [
      "(320377) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(320377) Kultura i rozrywka / Kody i doładowania / Gry / FIFA",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Fortnite",
    "categoryPath": [
      "(317243) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(317243) Kultura i rozrywka / Kody i doładowania / Gry / Fortnite",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nintendo Switch Online",
    "categoryPath": [
      "(322276) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(322276) Kultura i rozrywka / Kody i doładowania / Gry / Nintendo Switch Online",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Nintendo eShop",
    "categoryPath": [
      "(258102) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258102) Kultura i rozrywka / Kody i doładowania / Gry / Nintendo eShop",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "PlayStation Plus",
    "categoryPath": [
      "(258101) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258101) Kultura i rozrywka / Kody i doładowania / Gry / PlayStation Plus",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "PlayStation Store",
    "categoryPath": [
      "(258098) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258098) Kultura i rozrywka / Kody i doładowania / Gry / PlayStation Store",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258106) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258106) Kultura i rozrywka / Kody i doładowania / Gry / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Roblox",
    "categoryPath": [
      "(317240) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(317240) Kultura i rozrywka / Kody i doładowania / Gry / Roblox",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Steam",
    "categoryPath": [
      "(258095) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258095) Kultura i rozrywka / Kody i doładowania / Gry / Steam",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Subskrypcja Game Pass (PC, Ultimate, Xbox)",
    "categoryPath": [
      "(260003) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(260003) Kultura i rozrywka / Kody i doładowania / Gry / Subskrypcja Game Pass (PC, Ultimate, Xbox)",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Subskrypcja Xbox Live Gold",
    "categoryPath": [
      "(258100) Kultura i rozrywka",
      "Kody i doładowania",
      "Gry"
    ],
    "hierarchy": "(258100) Kultura i rozrywka / Kody i doładowania / Gry / Subskrypcja Xbox Live Gold",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "CDA Premium",
    "categoryPath": [
      "(317231) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(317231) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / CDA Premium",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Empik",
    "categoryPath": [
      "(319313) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(319313) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Empik",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Google Play",
    "categoryPath": [
      "(259444) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(259444) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Google Play",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Karty Allegro",
    "categoryPath": [
      "(259408) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(259408) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Karty Allegro",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Netflix",
    "categoryPath": [
      "(260520) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(260520) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Netflix",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Nike",
    "categoryPath": [
      "(319316) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(319316) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Nike",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259409) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(259409) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rakuten TV",
    "categoryPath": [
      "(317237) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(317237) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Rakuten TV",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Zalando",
    "categoryPath": [
      "(319319) Kultura i rozrywka",
      "Kody i doładowania",
      "Karty podarunkowe"
    ],
    "hierarchy": "(319319) Kultura i rozrywka / Kody i doładowania / Karty podarunkowe / Zalando",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Kupony, vouchery",
    "categoryPath": [
      "(300341) Kultura i rozrywka",
      "Kody i doładowania"
    ],
    "hierarchy": "(300341) Kultura i rozrywka / Kody i doładowania / Kupony, vouchery",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258112) Kultura i rozrywka",
      "Kody i doładowania",
      "Muzyka"
    ],
    "hierarchy": "(258112) Kultura i rozrywka / Kody i doładowania / Muzyka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spotify",
    "categoryPath": [
      "(258110) Kultura i rozrywka",
      "Kody i doładowania",
      "Muzyka"
    ],
    "hierarchy": "(258110) Kultura i rozrywka / Kody i doładowania / Muzyka / Spotify",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "iTunes",
    "categoryPath": [
      "(260181) Kultura i rozrywka",
      "Kody i doładowania",
      "Muzyka"
    ],
    "hierarchy": "(260181) Kultura i rozrywka / Kody i doładowania / Muzyka / iTunes",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258109) Kultura i rozrywka",
      "Kody i doładowania"
    ],
    "hierarchy": "(258109) Kultura i rozrywka / Kody i doładowania / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Paypal",
    "categoryPath": [
      "(317393) Kultura i rozrywka",
      "Kody i doładowania",
      "Płatności internetowe"
    ],
    "hierarchy": "(317393) Kultura i rozrywka / Kody i doładowania / Płatności internetowe / Paypal",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Paysafecard",
    "categoryPath": [
      "(258113) Kultura i rozrywka",
      "Kody i doładowania",
      "Płatności internetowe"
    ],
    "hierarchy": "(258113) Kultura i rozrywka / Kody i doładowania / Płatności internetowe / Paysafecard",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258114) Kultura i rozrywka",
      "Kody i doładowania",
      "Płatności internetowe"
    ],
    "hierarchy": "(258114) Kultura i rozrywka / Kody i doładowania / Płatności internetowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wex",
    "categoryPath": [
      "(259406) Kultura i rozrywka",
      "Kody i doładowania",
      "Płatności internetowe"
    ],
    "hierarchy": "(259406) Kultura i rozrywka / Kody i doładowania / Płatności internetowe / Wex",
    "comissionGroupOld": "C3",
    "comissionGroupNew": "D23"
  },
  {
    "segment": "Biografie, wspomnienia",
    "categoryPath": [
      "(97761) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97761) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Biografie, wspomnienia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Edukacja i lektury szkolne",
    "categoryPath": [
      "(66818) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(66818) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Edukacja i lektury szkolne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy, science fiction, horror",
    "categoryPath": [
      "(97764) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97764) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Fantasy, science fiction, horror",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Historia, archeologia",
    "categoryPath": [
      "(97767) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97767) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Historia, archeologia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Komiksy",
    "categoryPath": [
      "(261378) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(261378) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Komiksy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kryminał, sensacja, thriller",
    "categoryPath": [
      "(97766) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97766) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Kryminał, sensacja, thriller",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Książki dla dzieci",
    "categoryPath": [
      "(66814) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(66814) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Książki dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Książki dla młodzieży",
    "categoryPath": [
      "(261379) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(261379) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Książki dla młodzieży",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Książki obcojęzyczne",
    "categoryPath": [
      "(97759) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97759) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Książki obcojęzyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Literatura obyczajowa, erotyczna",
    "categoryPath": [
      "(97765) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97765) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Literatura obyczajowa, erotyczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Literatura piękna",
    "categoryPath": [
      "(97760) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97760) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Literatura piękna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Literatura podróżnicza",
    "categoryPath": [
      "(97762) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97762) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Literatura podróżnicza",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Nauka języków",
    "categoryPath": [
      "(66817) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(66817) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Nauka języków",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Naukowe i popularnonaukowe",
    "categoryPath": [
      "(97769) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97769) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Naukowe i popularnonaukowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Poradniki",
    "categoryPath": [
      "(97768) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97768) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Poradniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(66819) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(66819) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Religioznawstwo, nauki teologiczne",
    "categoryPath": [
      "(97770) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97770) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Religioznawstwo, nauki teologiczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Reportaż, literatura faktu",
    "categoryPath": [
      "(97763) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97763) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Reportaż, literatura faktu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy, kolekcje",
    "categoryPath": [
      "(97771) Kultura i rozrywka",
      "Książki i Komiksy",
      "Audiobooki - CD"
    ],
    "hierarchy": "(97771) Kultura i rozrywka / Książki i Komiksy / Audiobooki - CD / Zestawy, kolekcje",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Biografie, wspomnienia",
    "categoryPath": [
      "(261197) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(261197) Kultura i rozrywka / Książki i Komiksy / Biografie, wspomnienia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Biznes, ekonomia",
    "categoryPath": [
      "(745) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(745) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Biznes, ekonomia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Budownictwo, wnętrza, ogród",
    "categoryPath": [
      "(28471) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(28471) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Budownictwo, wnętrza, ogród",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(28524) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(28524) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla nastolatek",
    "categoryPath": [
      "(66773) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66773) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Dla nastolatek",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Elektronika, technika",
    "categoryPath": [
      "(754) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(754) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Elektronika, technika",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ezoteryka, magia, ufo",
    "categoryPath": [
      "(66774) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66774) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Ezoteryka, magia, ufo",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantastyka",
    "categoryPath": [
      "(808) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(808) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Fantastyka",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Film, telewizja",
    "categoryPath": [
      "(748) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(748) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Film, telewizja",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fotografia",
    "categoryPath": [
      "(753) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(753) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Fotografia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Hobbystyczne",
    "categoryPath": [
      "(120) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(120) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Hobbystyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Internet, komputery",
    "categoryPath": [
      "(66780) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66780) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Internet, komputery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kryminalno-detektywistyczne",
    "categoryPath": [
      "(66775) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66775) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Kryminalno-detektywistyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kultura, sztuka",
    "categoryPath": [
      "(262) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(262) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Kultura, sztuka",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka, instrumenty",
    "categoryPath": [
      "(121) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(121) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Muzyka, instrumenty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Plotki, moda, uroda",
    "categoryPath": [
      "(746) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(746) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Plotki, moda, uroda",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Podróżnicze",
    "categoryPath": [
      "(263) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(263) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Podróżnicze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Popularnonaukowe",
    "categoryPath": [
      "(5884) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(5884) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Popularnonaukowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(122) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Samochody, motocykle",
    "categoryPath": [
      "(755) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(755) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Samochody, motocykle",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sport, zdrowie, kondycja",
    "categoryPath": [
      "(798) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(798) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Sport, zdrowie, kondycja",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Społeczno-polityczne",
    "categoryPath": [
      "(66776) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66776) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Społeczno-polityczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Wojsko, militaria",
    "categoryPath": [
      "(66777) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66777) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Wojsko, militaria",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Wychowanie, rodzina",
    "categoryPath": [
      "(28472) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(28472) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Wychowanie, rodzina",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zbiory opowiadań",
    "categoryPath": [
      "(66778) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66778) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Zbiory opowiadań",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zwierzęta, przyroda",
    "categoryPath": [
      "(66779) Kultura i rozrywka",
      "Książki i Komiksy",
      "Czasopisma"
    ],
    "hierarchy": "(66779) Kultura i rozrywka / Książki i Komiksy / Czasopisma / Zwierzęta, przyroda",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy, science fiction, horror",
    "categoryPath": [
      "(261209) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(261209) Kultura i rozrywka / Książki i Komiksy / Fantasy, science fiction, horror",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Historia, archeologia",
    "categoryPath": [
      "(79466) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79466) Kultura i rozrywka / Książki i Komiksy / Historia, archeologia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Informatyka, internet",
    "categoryPath": [
      "(79468) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79468) Kultura i rozrywka / Książki i Komiksy / Informatyka, internet",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Adresowniki, pamiętniki",
    "categoryPath": [
      "(66807) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(66807) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Adresowniki, pamiętniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dzienniki szkolne",
    "categoryPath": [
      "(260272) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(260272) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Dzienniki szkolne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kalendarze biurkowe",
    "categoryPath": [
      "(260271) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(260271) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Kalendarze biurkowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kalendarze książkowe",
    "categoryPath": [
      "(66809) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(66809) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Kalendarze książkowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kalendarze ścienne",
    "categoryPath": [
      "(66810) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(66810) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Kalendarze ścienne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Lampki, lupy, stojaki",
    "categoryPath": [
      "(66808) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(66808) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Lampki, lupy, stojaki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Notesy, planery",
    "categoryPath": [
      "(260273) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(260273) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Notesy, planery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Okładki, ekslibrisy",
    "categoryPath": [
      "(66811) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(66811) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Okładki, ekslibrisy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(66812) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(66812) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wkłady do kalendarzy",
    "categoryPath": [
      "(260270) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(260270) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Wkłady do kalendarzy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zakładki",
    "categoryPath": [
      "(260306) Kultura i rozrywka",
      "Książki i Komiksy",
      "Kalendarze, gadżety i akcesoria"
    ],
    "hierarchy": "(260306) Kultura i rozrywka / Książki i Komiksy / Kalendarze, gadżety i akcesoria / Zakładki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Komiksy",
    "categoryPath": [
      "(79413) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79413) Kultura i rozrywka / Książki i Komiksy / Komiksy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dorosłych",
    "categoryPath": [
      "(261371) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261371) Kultura i rozrywka / Książki i Komiksy / Komiksy / Dla dorosłych",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(261363) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261363) Kultura i rozrywka / Książki i Komiksy / Komiksy / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Fantasy, science fiction",
    "categoryPath": [
      "(261364) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261364) Kultura i rozrywka / Książki i Komiksy / Komiksy / Fantasy, science fiction",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Historyczne, wojenne",
    "categoryPath": [
      "(261365) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261365) Kultura i rozrywka / Książki i Komiksy / Komiksy / Historyczne, wojenne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Horrory, groza",
    "categoryPath": [
      "(261366) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261366) Kultura i rozrywka / Książki i Komiksy / Komiksy / Horrory, groza",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Humor, satyra",
    "categoryPath": [
      "(261367) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261367) Kultura i rozrywka / Książki i Komiksy / Komiksy / Humor, satyra",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Manga i komiks japoński",
    "categoryPath": [
      "(261368) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261368) Kultura i rozrywka / Książki i Komiksy / Komiksy / Manga i komiks japoński",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Obcojęzyczne",
    "categoryPath": [
      "(92873) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(92873) Kultura i rozrywka / Książki i Komiksy / Komiksy / Obcojęzyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Obyczajowe i przygodowe",
    "categoryPath": [
      "(261369) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261369) Kultura i rozrywka / Książki i Komiksy / Komiksy / Obyczajowe i przygodowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(79419) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(79419) Kultura i rozrywka / Książki i Komiksy / Komiksy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Superbohaterowie",
    "categoryPath": [
      "(261370) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(261370) Kultura i rozrywka / Książki i Komiksy / Komiksy / Superbohaterowie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy mieszane, kolekcje",
    "categoryPath": [
      "(92874) Kultura i rozrywka",
      "Książki i Komiksy",
      "Komiksy"
    ],
    "hierarchy": "(92874) Kultura i rozrywka / Książki i Komiksy / Komiksy / Zestawy mieszane, kolekcje",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kryminał, sensacja, thriller",
    "categoryPath": [
      "(261210) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(261210) Kultura i rozrywka / Książki i Komiksy / Kryminał, sensacja, thriller",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Książki dla dzieci",
    "categoryPath": [
      "(66781) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(66781) Kultura i rozrywka / Książki i Komiksy / Książki dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Książki dla młodzieży",
    "categoryPath": [
      "(260379) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(260379) Kultura i rozrywka / Książki i Komiksy / Książki dla młodzieży",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Książki do nauki języka obcego",
    "categoryPath": [
      "(66794) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(66794) Kultura i rozrywka / Książki i Komiksy / Książki do nauki języka obcego",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Książki naukowe i popularnonaukowe",
    "categoryPath": [
      "(79455) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79455) Kultura i rozrywka / Książki i Komiksy / Książki naukowe i popularnonaukowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Literatura obyczajowa, erotyczna",
    "categoryPath": [
      "(261250) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(261250) Kultura i rozrywka / Książki i Komiksy / Literatura obyczajowa, erotyczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Literatura piękna",
    "categoryPath": [
      "(79153) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79153) Kultura i rozrywka / Książki i Komiksy / Literatura piękna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Mapy, przewodniki, książki podróżnicze",
    "categoryPath": [
      "(79420) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79420) Kultura i rozrywka / Książki i Komiksy / Mapy, przewodniki, książki podróżnicze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Gimnazjum",
    "categoryPath": [
      "(111776) Kultura i rozrywka",
      "Książki i Komiksy",
      "Podręczniki do szkół podst. i średnich"
    ],
    "hierarchy": "(111776) Kultura i rozrywka / Książki i Komiksy / Podręczniki do szkół podst. i średnich / Gimnazjum",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Przedszkole",
    "categoryPath": [
      "(111773) Kultura i rozrywka",
      "Książki i Komiksy",
      "Podręczniki do szkół podst. i średnich"
    ],
    "hierarchy": "(111773) Kultura i rozrywka / Książki i Komiksy / Podręczniki do szkół podst. i średnich / Przedszkole",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Szkoła podstawowa",
    "categoryPath": [
      "(111775) Kultura i rozrywka",
      "Książki i Komiksy",
      "Podręczniki do szkół podst. i średnich"
    ],
    "hierarchy": "(111775) Kultura i rozrywka / Książki i Komiksy / Podręczniki do szkół podst. i średnich / Szkoła podstawowa",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Szkoła średnia",
    "categoryPath": [
      "(111777) Kultura i rozrywka",
      "Książki i Komiksy",
      "Podręczniki do szkół podst. i średnich"
    ],
    "hierarchy": "(111777) Kultura i rozrywka / Książki i Komiksy / Podręczniki do szkół podst. i średnich / Szkoła średnia",
    "comissionGroupOld": "C14",
    "comissionGroupNew": "D5"
  },
  {
    "segment": "Poradniki i albumy",
    "categoryPath": [
      "(79193) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79193) Kultura i rozrywka / Książki i Komiksy / Poradniki i albumy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Religioznawstwo, nauki teologiczne",
    "categoryPath": [
      "(79475) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79475) Kultura i rozrywka / Książki i Komiksy / Religioznawstwo, nauki teologiczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Reportaż, literatura faktu",
    "categoryPath": [
      "(261249) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(261249) Kultura i rozrywka / Książki i Komiksy / Reportaż, literatura faktu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Sport, forma fizyczna",
    "categoryPath": [
      "(79216) Kultura i rozrywka",
      "Książki i Komiksy"
    ],
    "hierarchy": "(79216) Kultura i rozrywka / Książki i Komiksy / Sport, forma fizyczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Opaski koncertowe",
    "categoryPath": [
      "(300337) Kultura i rozrywka",
      "Muzyka",
      "Akcesoria"
    ],
    "hierarchy": "(300337) Kultura i rozrywka / Muzyka / Akcesoria / Opaski koncertowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ballada, Poezja śpiewana",
    "categoryPath": [
      "(1370) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(1370) Kultura i rozrywka / Muzyka / Kasety audio / Ballada, Poezja śpiewana",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Blues, Rhythm'n'Blues",
    "categoryPath": [
      "(1371) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(1371) Kultura i rozrywka / Muzyka / Kasety audio / Blues, Rhythm'n'Blues",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dance",
    "categoryPath": [
      "(212) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(212) Kultura i rozrywka / Muzyka / Kasety audio / Dance",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(5590) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(5590) Kultura i rozrywka / Muzyka / Kasety audio / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ethno, Folk, World music",
    "categoryPath": [
      "(1373) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(1373) Kultura i rozrywka / Muzyka / Kasety audio / Ethno, Folk, World music",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Jazz, Swing",
    "categoryPath": [
      "(261) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(261) Kultura i rozrywka / Muzyka / Kasety audio / Jazz, Swing",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kolędy",
    "categoryPath": [
      "(5589) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(5589) Kultura i rozrywka / Muzyka / Kasety audio / Kolędy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Metal",
    "categoryPath": [
      "(260978) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(260978) Kultura i rozrywka / Muzyka / Kasety audio / Metal",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka alternatywna",
    "categoryPath": [
      "(10831) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(10831) Kultura i rozrywka / Muzyka / Kasety audio / Muzyka alternatywna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka elektroniczna",
    "categoryPath": [
      "(5588) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(5588) Kultura i rozrywka / Muzyka / Kasety audio / Muzyka elektroniczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka filmowa",
    "categoryPath": [
      "(208) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(208) Kultura i rozrywka / Muzyka / Kasety audio / Muzyka filmowa",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka klasyczna, Opera, Operetka",
    "categoryPath": [
      "(209) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(209) Kultura i rozrywka / Muzyka / Kasety audio / Muzyka klasyczna, Opera, Operetka",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pop",
    "categoryPath": [
      "(322358) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(322358) Kultura i rozrywka / Muzyka / Kasety audio / Pop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(210) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(210) Kultura i rozrywka / Muzyka / Kasety audio / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rap, Hip-Hop",
    "categoryPath": [
      "(205) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(205) Kultura i rozrywka / Muzyka / Kasety audio / Rap, Hip-Hop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Reggae, Ska",
    "categoryPath": [
      "(201) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(201) Kultura i rozrywka / Muzyka / Kasety audio / Reggae, Ska",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rock",
    "categoryPath": [
      "(261037) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(261037) Kultura i rozrywka / Muzyka / Kasety audio / Rock",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rock'n'roll",
    "categoryPath": [
      "(5587) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(5587) Kultura i rozrywka / Muzyka / Kasety audio / Rock'n'roll",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Składanki",
    "categoryPath": [
      "(1378) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(1378) Kultura i rozrywka / Muzyka / Kasety audio / Składanki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Synth-pop",
    "categoryPath": [
      "(321962) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(321962) Kultura i rozrywka / Muzyka / Kasety audio / Synth-pop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy, pakiety",
    "categoryPath": [
      "(9529) Kultura i rozrywka",
      "Muzyka",
      "Kasety audio"
    ],
    "hierarchy": "(9529) Kultura i rozrywka / Muzyka / Kasety audio / Zestawy, pakiety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe nośniki",
    "categoryPath": [
      "(307249) Kultura i rozrywka",
      "Muzyka"
    ],
    "hierarchy": "(307249) Kultura i rozrywka / Muzyka / Pozostałe nośniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ballada, Poezja śpiewana",
    "categoryPath": [
      "(1361) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(1361) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Ballada, Poezja śpiewana",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Blues, Rhythm'n'Blues",
    "categoryPath": [
      "(261036) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261036) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Blues, Rhythm'n'Blues",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Country",
    "categoryPath": [
      "(1143) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(1143) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Country",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dance",
    "categoryPath": [
      "(261035) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261035) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Dance",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Disco polo, biesiadna, karaoke",
    "categoryPath": [
      "(89757) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(89757) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Disco polo, biesiadna, karaoke",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(261028) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261028) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ethno, Folk, World music",
    "categoryPath": [
      "(261100) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261100) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Ethno, Folk, World music",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Jazz, Swing",
    "categoryPath": [
      "(260) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(260) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Jazz, Swing",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kolędy",
    "categoryPath": [
      "(5607) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(5607) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Kolędy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Metal",
    "categoryPath": [
      "(261128) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261128) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Metal",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka alternatywna",
    "categoryPath": [
      "(261029) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261029) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Muzyka alternatywna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka elektroniczna",
    "categoryPath": [
      "(261111) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261111) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Muzyka elektroniczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka filmowa",
    "categoryPath": [
      "(322237) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(322237) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Muzyka filmowa",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka klasyczna",
    "categoryPath": [
      "(9536) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(9536) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Muzyka klasyczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka religijna, oazowa",
    "categoryPath": [
      "(89751) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(89751) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Muzyka religijna, oazowa",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Nowe brzmienia",
    "categoryPath": [
      "(261042) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261042) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Nowe brzmienia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Opera, Operetka",
    "categoryPath": [
      "(9537) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(9537) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Opera, Operetka",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pop",
    "categoryPath": [
      "(261127) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261127) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Pop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(191) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(191) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rap, Hip-Hop",
    "categoryPath": [
      "(261044) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261044) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Rap, Hip-Hop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Reggae, Ska",
    "categoryPath": [
      "(182) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(182) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Reggae, Ska",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rock",
    "categoryPath": [
      "(261110) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261110) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Rock",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rock'n'roll",
    "categoryPath": [
      "(5605) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(5605) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Rock'n'roll",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Single",
    "categoryPath": [
      "(322236) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(322236) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Single",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Składanki",
    "categoryPath": [
      "(261102) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(261102) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Składanki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Soul, Funk",
    "categoryPath": [
      "(181) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(181) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Soul, Funk",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Synth-pop",
    "categoryPath": [
      "(321960) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(321960) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Synth-pop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy, pakiety",
    "categoryPath": [
      "(9530) Kultura i rozrywka",
      "Muzyka",
      "Płyty kompaktowe"
    ],
    "hierarchy": "(9530) Kultura i rozrywka / Muzyka / Płyty kompaktowe / Zestawy, pakiety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ballada, Poezja śpiewana",
    "categoryPath": [
      "(1410) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(1410) Kultura i rozrywka / Muzyka / Płyty winylowe / Ballada, Poezja śpiewana",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Blues, Rhythm'n'Blues",
    "categoryPath": [
      "(1411) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(1411) Kultura i rozrywka / Muzyka / Płyty winylowe / Blues, Rhythm'n'Blues",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Country",
    "categoryPath": [
      "(1145) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(1145) Kultura i rozrywka / Muzyka / Płyty winylowe / Country",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dance",
    "categoryPath": [
      "(5638) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(5638) Kultura i rozrywka / Muzyka / Płyty winylowe / Dance",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(5626) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(5626) Kultura i rozrywka / Muzyka / Płyty winylowe / Dla dzieci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ethno, Folk, World music",
    "categoryPath": [
      "(5639) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(5639) Kultura i rozrywka / Muzyka / Płyty winylowe / Ethno, Folk, World music",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Jazz, Swing",
    "categoryPath": [
      "(289) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(289) Kultura i rozrywka / Muzyka / Płyty winylowe / Jazz, Swing",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Kolędy",
    "categoryPath": [
      "(5625) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(5625) Kultura i rozrywka / Muzyka / Płyty winylowe / Kolędy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Metal",
    "categoryPath": [
      "(260981) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(260981) Kultura i rozrywka / Muzyka / Płyty winylowe / Metal",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka alternatywna",
    "categoryPath": [
      "(10830) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(10830) Kultura i rozrywka / Muzyka / Płyty winylowe / Muzyka alternatywna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka elektroniczna",
    "categoryPath": [
      "(261112) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(261112) Kultura i rozrywka / Muzyka / Płyty winylowe / Muzyka elektroniczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka filmowa",
    "categoryPath": [
      "(292) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(292) Kultura i rozrywka / Muzyka / Płyty winylowe / Muzyka filmowa",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Muzyka klasyczna",
    "categoryPath": [
      "(286) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(286) Kultura i rozrywka / Muzyka / Płyty winylowe / Muzyka klasyczna",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Nowe brzmienia",
    "categoryPath": [
      "(284) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(284) Kultura i rozrywka / Muzyka / Płyty winylowe / Nowe brzmienia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Okładki, koszulki",
    "categoryPath": [
      "(98700) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(98700) Kultura i rozrywka / Muzyka / Płyty winylowe / Okładki, koszulki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Opera, Operetka",
    "categoryPath": [
      "(261156) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(261156) Kultura i rozrywka / Muzyka / Płyty winylowe / Opera, Operetka",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pop",
    "categoryPath": [
      "(261039) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(261039) Kultura i rozrywka / Muzyka / Płyty winylowe / Pop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(293) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(293) Kultura i rozrywka / Muzyka / Płyty winylowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rap, Hip-Hop",
    "categoryPath": [
      "(261040) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(261040) Kultura i rozrywka / Muzyka / Płyty winylowe / Rap, Hip-Hop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Reggae, Ska",
    "categoryPath": [
      "(1413) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(1413) Kultura i rozrywka / Muzyka / Płyty winylowe / Reggae, Ska",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rock",
    "categoryPath": [
      "(261043) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(261043) Kultura i rozrywka / Muzyka / Płyty winylowe / Rock",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Rock'n'roll",
    "categoryPath": [
      "(5623) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(5623) Kultura i rozrywka / Muzyka / Płyty winylowe / Rock'n'roll",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Single",
    "categoryPath": [
      "(261041) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(261041) Kultura i rozrywka / Muzyka / Płyty winylowe / Single",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Składanki",
    "categoryPath": [
      "(1419) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(1419) Kultura i rozrywka / Muzyka / Płyty winylowe / Składanki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Soul, Funk",
    "categoryPath": [
      "(1420) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(1420) Kultura i rozrywka / Muzyka / Płyty winylowe / Soul, Funk",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Synth-pop",
    "categoryPath": [
      "(321961) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(321961) Kultura i rozrywka / Muzyka / Płyty winylowe / Synth-pop",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Zestawy, pakiety",
    "categoryPath": [
      "(9531) Kultura i rozrywka",
      "Muzyka",
      "Płyty winylowe"
    ],
    "hierarchy": "(9531) Kultura i rozrywka / Muzyka / Płyty winylowe / Zestawy, pakiety",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D22"
  },
  {
    "segment": "Ekspozytory i stojaki",
    "categoryPath": [
      "(124044) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do biżuterii"
    ],
    "hierarchy": "(124044) Moda / Biżuteria i Zegarki / Akcesoria do biżuterii / Ekspozytory i stojaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miarki i wagi jubilerskie",
    "categoryPath": [
      "(124045) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do biżuterii"
    ],
    "hierarchy": "(124045) Moda / Biżuteria i Zegarki / Akcesoria do biżuterii / Miarki i wagi jubilerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(77738) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do biżuterii"
    ],
    "hierarchy": "(77738) Moda / Biżuteria i Zegarki / Akcesoria do biżuterii / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szkatułki i pudełeczka",
    "categoryPath": [
      "(77735) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do biżuterii"
    ],
    "hierarchy": "(77735) Moda / Biżuteria i Zegarki / Akcesoria do biżuterii / Szkatułki i pudełeczka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Woreczki",
    "categoryPath": [
      "(77736) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do biżuterii"
    ],
    "hierarchy": "(77736) Moda / Biżuteria i Zegarki / Akcesoria do biżuterii / Woreczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Środki czyszczące",
    "categoryPath": [
      "(77737) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do biżuterii"
    ],
    "hierarchy": "(77737) Moda / Biżuteria i Zegarki / Akcesoria do biżuterii / Środki czyszczące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bransolety",
    "categoryPath": [
      "(256629) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(256629) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Bransolety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Etui",
    "categoryPath": [
      "(256628) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(256628) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Etui",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klamry",
    "categoryPath": [
      "(319364) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(319364) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Klamry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koperty",
    "categoryPath": [
      "(310097) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(310097) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Koperty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Paski do zegarków",
    "categoryPath": [
      "(256626) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(256626) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Paski do zegarków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256630) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(256630) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rotomaty",
    "categoryPath": [
      "(256627) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(256627) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Rotomaty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Teleskopy",
    "categoryPath": [
      "(257235) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(257235) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Teleskopy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uszczelki do zegarków",
    "categoryPath": [
      "(310109) Moda",
      "Biżuteria i Zegarki",
      "Akcesoria do zegarków"
    ],
    "hierarchy": "(310109) Moda / Biżuteria i Zegarki / Akcesoria do zegarków / Uszczelki do zegarków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bransoletki",
    "categoryPath": [
      "(257987) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(257987) Moda / Biżuteria i Zegarki / Biżuteria damska / Bransoletki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Broszki",
    "categoryPath": [
      "(123427) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123427) Moda / Biżuteria i Zegarki / Biżuteria damska / Broszki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Chokery",
    "categoryPath": [
      "(258031) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(258031) Moda / Biżuteria i Zegarki / Biżuteria damska / Chokery",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Klipsy",
    "categoryPath": [
      "(123428) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123428) Moda / Biżuteria i Zegarki / Biżuteria damska / Klipsy",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kolczyki",
    "categoryPath": [
      "(123429) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123429) Moda / Biżuteria i Zegarki / Biżuteria damska / Kolczyki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(123430) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123430) Moda / Biżuteria i Zegarki / Biżuteria damska / Komplety",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Korale",
    "categoryPath": [
      "(123431) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123431) Moda / Biżuteria i Zegarki / Biżuteria damska / Korale",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Naszyjniki",
    "categoryPath": [
      "(123433) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123433) Moda / Biżuteria i Zegarki / Biżuteria damska / Naszyjniki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Nausznice",
    "categoryPath": [
      "(257253) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(257253) Moda / Biżuteria i Zegarki / Biżuteria damska / Nausznice",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pierścionki, obrączki",
    "categoryPath": [
      "(123450) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123450) Moda / Biżuteria i Zegarki / Biżuteria damska / Pierścionki, obrączki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(123423) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123423) Moda / Biżuteria i Zegarki / Biżuteria damska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wisiorki",
    "categoryPath": [
      "(123448) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123448) Moda / Biżuteria i Zegarki / Biżuteria damska / Wisiorki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zawieszki do bransoletek",
    "categoryPath": [
      "(123449) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123449) Moda / Biżuteria i Zegarki / Biżuteria damska / Zawieszki do bransoletek",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Łańcuszki",
    "categoryPath": [
      "(123432) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria damska"
    ],
    "hierarchy": "(123432) Moda / Biżuteria i Zegarki / Biżuteria damska / Łańcuszki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bransoletki",
    "categoryPath": [
      "(123444) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria dziecięca"
    ],
    "hierarchy": "(123444) Moda / Biżuteria i Zegarki / Biżuteria dziecięca / Bransoletki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kolczyki",
    "categoryPath": [
      "(123445) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria dziecięca"
    ],
    "hierarchy": "(123445) Moda / Biżuteria i Zegarki / Biżuteria dziecięca / Kolczyki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wisiorki",
    "categoryPath": [
      "(319556) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria dziecięca"
    ],
    "hierarchy": "(319556) Moda / Biżuteria i Zegarki / Biżuteria dziecięca / Wisiorki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Łańcuszki, naszyjniki",
    "categoryPath": [
      "(123446) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria dziecięca"
    ],
    "hierarchy": "(123446) Moda / Biżuteria i Zegarki / Biżuteria dziecięca / Łańcuszki, naszyjniki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bransoletki",
    "categoryPath": [
      "(123436) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123436) Moda / Biżuteria i Zegarki / Biżuteria męska / Bransoletki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kolczyki",
    "categoryPath": [
      "(123437) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123437) Moda / Biżuteria i Zegarki / Biżuteria męska / Kolczyki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(123435) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123435) Moda / Biżuteria i Zegarki / Biżuteria męska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spinki do krawatów",
    "categoryPath": [
      "(123439) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123439) Moda / Biżuteria i Zegarki / Biżuteria męska / Spinki do krawatów",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spinki do mankietów",
    "categoryPath": [
      "(123440) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123440) Moda / Biżuteria i Zegarki / Biżuteria męska / Spinki do mankietów",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sygnety, obrączki",
    "categoryPath": [
      "(123441) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123441) Moda / Biżuteria i Zegarki / Biżuteria męska / Sygnety, obrączki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wisiorki",
    "categoryPath": [
      "(123447) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123447) Moda / Biżuteria i Zegarki / Biżuteria męska / Wisiorki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Łańcuszki, naszyjniki",
    "categoryPath": [
      "(123438) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria męska"
    ],
    "hierarchy": "(123438) Moda / Biżuteria i Zegarki / Biżuteria męska / Łańcuszki, naszyjniki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bransoletki",
    "categoryPath": [
      "(255522) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria ślubna"
    ],
    "hierarchy": "(255522) Moda / Biżuteria i Zegarki / Biżuteria ślubna / Bransoletki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kolczyki",
    "categoryPath": [
      "(255523) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria ślubna"
    ],
    "hierarchy": "(255523) Moda / Biżuteria i Zegarki / Biżuteria ślubna / Kolczyki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(123442) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria ślubna"
    ],
    "hierarchy": "(123442) Moda / Biżuteria i Zegarki / Biżuteria ślubna / Komplety",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Naszyjniki",
    "categoryPath": [
      "(255524) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria ślubna"
    ],
    "hierarchy": "(255524) Moda / Biżuteria i Zegarki / Biżuteria ślubna / Naszyjniki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Obrączki",
    "categoryPath": [
      "(110773) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria ślubna"
    ],
    "hierarchy": "(110773) Moda / Biżuteria i Zegarki / Biżuteria ślubna / Obrączki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pierścionki zaręczynowe",
    "categoryPath": [
      "(110774) Moda",
      "Biżuteria i Zegarki",
      "Biżuteria ślubna"
    ],
    "hierarchy": "(110774) Moda / Biżuteria i Zegarki / Biżuteria ślubna / Pierścionki zaręczynowe",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dewocjonalia",
    "categoryPath": [
      "(257500) Moda",
      "Biżuteria i Zegarki"
    ],
    "hierarchy": "(257500) Moda / Biżuteria i Zegarki / Dewocjonalia",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(315603) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów",
      "Akcesoria do koków"
    ],
    "hierarchy": "(315603) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Akcesoria do koków / Siatki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Spinki, szpilki",
    "categoryPath": [
      "(315609) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów",
      "Akcesoria do koków"
    ],
    "hierarchy": "(315609) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Akcesoria do koków / Spinki, szpilki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wypełniacze",
    "categoryPath": [
      "(315606) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów",
      "Akcesoria do koków"
    ],
    "hierarchy": "(315606) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Akcesoria do koków / Wypełniacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Diademy i ozdoby ślubne",
    "categoryPath": [
      "(124043) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów"
    ],
    "hierarchy": "(124043) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Diademy i ozdoby ślubne",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Gumki",
    "categoryPath": [
      "(19807) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów"
    ],
    "hierarchy": "(19807) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Gumki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski do włosów",
    "categoryPath": [
      "(26991) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów"
    ],
    "hierarchy": "(26991) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Opaski do włosów",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19806) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów"
    ],
    "hierarchy": "(19806) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spinki, klamry, wsuwki",
    "categoryPath": [
      "(19808) Moda",
      "Biżuteria i Zegarki",
      "Ozdoby do włosów"
    ],
    "hierarchy": "(19808) Moda / Biżuteria i Zegarki / Ozdoby do włosów / Spinki, klamry, wsuwki",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Biżuteria",
    "categoryPath": [
      "(257527) Moda",
      "Biżuteria i Zegarki",
      "Piercing"
    ],
    "hierarchy": "(257527) Moda / Biżuteria i Zegarki / Piercing / Biżuteria",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(257498) Moda",
      "Biżuteria i Zegarki",
      "Piercing"
    ],
    "hierarchy": "(257498) Moda / Biżuteria i Zegarki / Piercing / Części",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Narzędzia i akcesoria",
    "categoryPath": [
      "(61110) Moda",
      "Biżuteria i Zegarki",
      "Piercing"
    ],
    "hierarchy": "(61110) Moda / Biżuteria i Zegarki / Piercing / Narzędzia i akcesoria",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19733) Moda",
      "Biżuteria i Zegarki"
    ],
    "hierarchy": "(19733) Moda / Biżuteria i Zegarki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tatuaże zmywalne",
    "categoryPath": [
      "(255525) Moda",
      "Biżuteria i Zegarki"
    ],
    "hierarchy": "(255525) Moda / Biżuteria i Zegarki / Tatuaże zmywalne",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Damskie",
    "categoryPath": [
      "(19864) Moda",
      "Biżuteria i Zegarki",
      "Zegarki"
    ],
    "hierarchy": "(19864) Moda / Biżuteria i Zegarki / Zegarki / Damskie",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dziecięce",
    "categoryPath": [
      "(19866) Moda",
      "Biżuteria i Zegarki",
      "Zegarki"
    ],
    "hierarchy": "(19866) Moda / Biżuteria i Zegarki / Zegarki / Dziecięce",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Męskie",
    "categoryPath": [
      "(19865) Moda",
      "Biżuteria i Zegarki",
      "Zegarki"
    ],
    "hierarchy": "(19865) Moda / Biżuteria i Zegarki / Zegarki / Męskie",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Unisex",
    "categoryPath": [
      "(256625) Moda",
      "Biżuteria i Zegarki",
      "Zegarki"
    ],
    "hierarchy": "(256625) Moda / Biżuteria i Zegarki / Zegarki / Unisex",
    "comissionGroupOld": "C29",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(300561) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bagaż"
    ],
    "hierarchy": "(300561) Moda / Odzież, Obuwie, Dodatki / Bagaż / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Walizki duże",
    "categoryPath": [
      "(300553) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bagaż"
    ],
    "hierarchy": "(300553) Moda / Odzież, Obuwie, Dodatki / Bagaż / Walizki duże",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Walizki kabinowe",
    "categoryPath": [
      "(300545) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bagaż"
    ],
    "hierarchy": "(300545) Moda / Odzież, Obuwie, Dodatki / Bagaż / Walizki kabinowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Walizki kabinowe małe",
    "categoryPath": [
      "(300541) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bagaż"
    ],
    "hierarchy": "(300541) Moda / Odzież, Obuwie, Dodatki / Bagaż / Walizki kabinowe małe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Walizki średnie",
    "categoryPath": [
      "(300549) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bagaż"
    ],
    "hierarchy": "(300549) Moda / Odzież, Obuwie, Dodatki / Bagaż / Walizki średnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zestawy walizek",
    "categoryPath": [
      "(300557) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bagaż"
    ],
    "hierarchy": "(300557) Moda / Odzież, Obuwie, Dodatki / Bagaż / Zestawy walizek",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Body",
    "categoryPath": [
      "(308449) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Bielizna wyszczuplająca"
    ],
    "hierarchy": "(308449) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Bielizna wyszczuplająca / Body",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Gorsety",
    "categoryPath": [
      "(78719) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Bielizna wyszczuplająca"
    ],
    "hierarchy": "(78719) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Bielizna wyszczuplająca / Gorsety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Halki",
    "categoryPath": [
      "(308437) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Bielizna wyszczuplająca"
    ],
    "hierarchy": "(308437) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Bielizna wyszczuplająca / Halki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Majtki",
    "categoryPath": [
      "(78720) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Bielizna wyszczuplająca"
    ],
    "hierarchy": "(78720) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Bielizna wyszczuplająca / Majtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski przeciw otarciom",
    "categoryPath": [
      "(308473) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Bielizna wyszczuplająca"
    ],
    "hierarchy": "(308473) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Bielizna wyszczuplająca / Opaski przeciw otarciom",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pasy",
    "categoryPath": [
      "(78721) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Bielizna wyszczuplająca"
    ],
    "hierarchy": "(78721) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Bielizna wyszczuplająca / Pasy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki, szorty",
    "categoryPath": [
      "(308461) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Bielizna wyszczuplająca"
    ],
    "hierarchy": "(308461) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Bielizna wyszczuplająca / Spodenki, szorty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Biustonosze",
    "categoryPath": [
      "(75994) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(75994) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Biustonosze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Biustonosze - dodatki",
    "categoryPath": [
      "(75995) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(75995) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Biustonosze - dodatki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Body",
    "categoryPath": [
      "(75996) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(75996) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Body",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Gorsety",
    "categoryPath": [
      "(75998) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(75998) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Gorsety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Halki",
    "categoryPath": [
      "(124262) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(124262) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Halki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(76012) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76012) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki nocne",
    "categoryPath": [
      "(124263) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(124263) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Koszulki nocne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Majtki",
    "categoryPath": [
      "(112112) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(112112) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Majtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Naklejki na sutki",
    "categoryPath": [
      "(322094) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(322094) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Naklejki na sutki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Onesie (kombinezony)",
    "categoryPath": [
      "(257206) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(257206) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Onesie (kombinezony)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Parea i tuniki plażowe",
    "categoryPath": [
      "(257234) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(257234) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Parea i tuniki plażowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pasy do pończoch",
    "categoryPath": [
      "(76001) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76001) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Pasy do pończoch",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piżamy",
    "categoryPath": [
      "(76027) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76027) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Piżamy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Podkoszulki",
    "categoryPath": [
      "(112121) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(112121) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Podkoszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76013) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76013) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pończochy",
    "categoryPath": [
      "(76003) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76003) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Pończochy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rajstopy",
    "categoryPath": [
      "(76004) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76004) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Rajstopy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpetki i kolanówki",
    "categoryPath": [
      "(76005) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76005) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Skarpetki i kolanówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dwuczęściowe",
    "categoryPath": [
      "(76024) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Stroje kąpielowe"
    ],
    "hierarchy": "(76024) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Stroje kąpielowe / Dwuczęściowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Jednoczęściowe",
    "categoryPath": [
      "(76025) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska",
      "Stroje kąpielowe"
    ],
    "hierarchy": "(76025) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Stroje kąpielowe / Jednoczęściowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Szlafroki",
    "categoryPath": [
      "(76028) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76028) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Szlafroki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Taśmy do biustu",
    "categoryPath": [
      "(322093) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(322093) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Taśmy do biustu",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Topy",
    "categoryPath": [
      "(76010) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna damska"
    ],
    "hierarchy": "(76010) Moda / Odzież, Obuwie, Dodatki / Bielizna damska / Topy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kalesony",
    "categoryPath": [
      "(256926) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256926) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Kalesony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kąpielówki",
    "categoryPath": [
      "(256927) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256927) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Kąpielówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Majtki",
    "categoryPath": [
      "(256928) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256928) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Majtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piżamy",
    "categoryPath": [
      "(256929) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256929) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Piżamy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Podkoszulki",
    "categoryPath": [
      "(256930) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256930) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Podkoszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256933) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256933) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skarpetki",
    "categoryPath": [
      "(256931) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256931) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Skarpetki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Szlafroki",
    "categoryPath": [
      "(256932) Moda",
      "Odzież, Obuwie, Dodatki",
      "Bielizna męska"
    ],
    "hierarchy": "(256932) Moda / Odzież, Obuwie, Dodatki / Bielizna męska / Szlafroki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Biustonosze",
    "categoryPath": [
      "(258916) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Bielizna ciążowa"
    ],
    "hierarchy": "(258916) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Bielizna ciążowa / Biustonosze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule nocne",
    "categoryPath": [
      "(258919) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Bielizna ciążowa"
    ],
    "hierarchy": "(258919) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Bielizna ciążowa / Koszule nocne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Majtki",
    "categoryPath": [
      "(258917) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Bielizna ciążowa"
    ],
    "hierarchy": "(258917) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Bielizna ciążowa / Majtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piżamy",
    "categoryPath": [
      "(258920) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Bielizna ciążowa"
    ],
    "hierarchy": "(258920) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Bielizna ciążowa / Piżamy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rajstopy",
    "categoryPath": [
      "(258921) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Bielizna ciążowa"
    ],
    "hierarchy": "(258921) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Bielizna ciążowa / Rajstopy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzki",
    "categoryPath": [
      "(258922) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258922) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Bluzki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(258923) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258923) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Jeansy",
    "categoryPath": [
      "(258950) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258950) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Jeansy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Legginsy",
    "categoryPath": [
      "(258924) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258924) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Legginsy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Płaszcze",
    "categoryPath": [
      "(258928) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258928) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Płaszcze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(258949) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258949) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Casual (na co dzień)",
    "categoryPath": [
      "(258935) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa",
      "Spodnie"
    ],
    "hierarchy": "(258935) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Spodnie / Casual (na co dzień)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dresowe",
    "categoryPath": [
      "(258931) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa",
      "Spodnie"
    ],
    "hierarchy": "(258931) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Spodnie / Dresowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Eleganckie",
    "categoryPath": [
      "(258934) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa",
      "Spodnie"
    ],
    "hierarchy": "(258934) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Spodnie / Eleganckie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ogrodniczki",
    "categoryPath": [
      "(258933) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa",
      "Spodnie"
    ],
    "hierarchy": "(258933) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Spodnie / Ogrodniczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spódnice",
    "categoryPath": [
      "(258926) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258926) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Spódnice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki",
    "categoryPath": [
      "(258927) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258927) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Sukienki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Swetry",
    "categoryPath": [
      "(258929) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258929) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Swetry",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Tuniki",
    "categoryPath": [
      "(258930) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo",
      "Odzież ciążowa"
    ],
    "hierarchy": "(258930) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Odzież ciążowa / Tuniki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(78029) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ciąża i macierzyństwo"
    ],
    "hierarchy": "(78029) Moda / Odzież, Obuwie, Dodatki / Ciąża i macierzyństwo / Zestawy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Breloki",
    "categoryPath": [
      "(15557) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(15557) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Breloki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Chusty i apaszki",
    "categoryPath": [
      "(15550) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(15550) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Chusty i apaszki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Etui i pokrowce",
    "categoryPath": [
      "(68951) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(68951) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Etui i pokrowce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Krawaty",
    "categoryPath": [
      "(68950) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(68950) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Krawaty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Maseczki bawełniane",
    "categoryPath": [
      "(308533) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(308533) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Maseczki bawełniane",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Muszki",
    "categoryPath": [
      "(255439) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(255439) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Muszki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Berety",
    "categoryPath": [
      "(97554) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(97554) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Berety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki z daszkiem",
    "categoryPath": [
      "(5553) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(5553) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Czapki z daszkiem",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki zimowe",
    "categoryPath": [
      "(78147) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(78147) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Czapki zimowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Daszki",
    "categoryPath": [
      "(322833) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(322833) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Daszki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kapelusze",
    "categoryPath": [
      "(5554) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(5554) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Kapelusze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kaszkiety",
    "categoryPath": [
      "(78139) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(78139) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Kaszkiety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety z czapkami",
    "categoryPath": [
      "(55253) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(55253) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Komplety z czapkami",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski",
    "categoryPath": [
      "(78140) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(78140) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Opaski",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Patrolówki",
    "categoryPath": [
      "(78716) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(78716) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Patrolówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5555) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(5555) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Turbany",
    "categoryPath": [
      "(305745) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Nakrycia głowy"
    ],
    "hierarchy": "(305745) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nakrycia głowy / Turbany",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Naszywki",
    "categoryPath": [
      "(257196) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(257196) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Naszywki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Nesesery i aktówki",
    "categoryPath": [
      "(1488) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1488) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Nesesery i aktówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ocieplacze (getry)",
    "categoryPath": [
      "(111646) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(111646) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Ocieplacze (getry)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Okulary przeciwsłoneczne",
    "categoryPath": [
      "(1494) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1494) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Okulary przeciwsłoneczne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Okulary zerówki",
    "categoryPath": [
      "(257677) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(257677) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Okulary zerówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski na oczy",
    "categoryPath": [
      "(257172) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(257172) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Opaski na oczy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Parasole",
    "categoryPath": [
      "(11068) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(11068) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Parasole",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(1489) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1489) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Paski",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Plecaki",
    "categoryPath": [
      "(5556) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(5556) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Plecaki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Portfele",
    "categoryPath": [
      "(1490) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1490) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Portfele",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Poszetki",
    "categoryPath": [
      "(255954) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(255954) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Poszetki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(1497) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1497) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przypinki i piny",
    "categoryPath": [
      "(305997) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(305997) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Przypinki i piny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(1493) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1493) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Rękawiczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Saszetki i nerki",
    "categoryPath": [
      "(27838) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(27838) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Saszetki i nerki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Szaliki i szale",
    "categoryPath": [
      "(1495) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1495) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Szaliki i szale",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Szelki",
    "categoryPath": [
      "(74230) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(74230) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Szelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Torby",
    "categoryPath": [
      "(1491) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(1491) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torby",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Klasyczne",
    "categoryPath": [
      "(261787) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261787) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Klasyczne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kopertówki",
    "categoryPath": [
      "(261788) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261788) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Kopertówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszyki",
    "categoryPath": [
      "(261789) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261789) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Koszyki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kuferki",
    "categoryPath": [
      "(261790) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261790) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Kuferki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Listonoszki",
    "categoryPath": [
      "(261791) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261791) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Listonoszki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Paski do torebek",
    "categoryPath": [
      "(320686) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(320686) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Paski do torebek",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Plażowe",
    "categoryPath": [
      "(261792) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261792) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Plażowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(15561) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(15561) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Shoppery",
    "categoryPath": [
      "(261793) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261793) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Shoppery",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(78714) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(78714) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Sportowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Worki",
    "categoryPath": [
      "(261794) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki",
      "Torebki"
    ],
    "hierarchy": "(261794) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Torebki / Worki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wieszaki na torebki",
    "categoryPath": [
      "(74231) Moda",
      "Odzież, Obuwie, Dodatki",
      "Galanteria i dodatki"
    ],
    "hierarchy": "(74231) Moda / Odzież, Obuwie, Dodatki / Galanteria i dodatki / Wieszaki na torebki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(53201) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie"
    ],
    "hierarchy": "(53201) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Farby do butów",
    "categoryPath": [
      "(261264) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261264) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Farby do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Fleki",
    "categoryPath": [
      "(261268) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261268) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Fleki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Impregnaty do butów",
    "categoryPath": [
      "(261272) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261272) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Impregnaty do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kleje do butów",
    "categoryPath": [
      "(322392) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(322392) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Kleje do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klipsy ozdobne",
    "categoryPath": [
      "(308881) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(308881) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Klipsy ozdobne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odświeżacze do butów",
    "categoryPath": [
      "(261273) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261273) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Odświeżacze do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pasty i kremy do butów",
    "categoryPath": [
      "(261267) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261267) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Pasty i kremy do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podpiętki i zapiętki",
    "categoryPath": [
      "(261269) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261269) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Podpiętki i zapiętki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261262) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261262) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prawidła do butów",
    "categoryPath": [
      "(261270) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261270) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Prawidła do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Preparaty czyszczące",
    "categoryPath": [
      "(261274) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261274) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Preparaty czyszczące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pudełka i organizery na buty",
    "categoryPath": [
      "(261266) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261266) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Pudełka i organizery na buty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczotki do butów",
    "categoryPath": [
      "(261277) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261277) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Szczotki do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sznurówki",
    "categoryPath": [
      "(261263) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261263) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Sznurówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wkładki do butów",
    "categoryPath": [
      "(261271) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261271) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Wkładki do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy do pielęgnacji butów",
    "categoryPath": [
      "(261306) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261306) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Zestawy do pielęgnacji butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łyżki do butów",
    "categoryPath": [
      "(261265) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Akcesoria"
    ],
    "hierarchy": "(261265) Moda / Odzież, Obuwie, Dodatki / Obuwie / Akcesoria / Łyżki do butów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Baleriny",
    "categoryPath": [
      "(27000) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(27000) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Baleriny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Botki",
    "categoryPath": [
      "(55202) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(55202) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Botki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Creepersy",
    "categoryPath": [
      "(148422) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(148422) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Creepersy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czółenka",
    "categoryPath": [
      "(5543) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(5543) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Czółenka",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Espadryle",
    "categoryPath": [
      "(257083) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(257083) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Espadryle",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Glany",
    "categoryPath": [
      "(55203) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(55203) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Glany",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Japonki",
    "categoryPath": [
      "(19918) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(19918) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Japonki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kalosze",
    "categoryPath": [
      "(55204) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(55204) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Kalosze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kapcie",
    "categoryPath": [
      "(10783) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(10783) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Kapcie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Casual (na co dzień)",
    "categoryPath": [
      "(19915) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie",
      "Klapki"
    ],
    "hierarchy": "(19915) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Klapki / Casual (na co dzień)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Drewniaki",
    "categoryPath": [
      "(19916) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie",
      "Klapki"
    ],
    "hierarchy": "(19916) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Klapki / Drewniaki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Eleganckie",
    "categoryPath": [
      "(19917) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie",
      "Klapki"
    ],
    "hierarchy": "(19917) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Klapki / Eleganckie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(19919) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie",
      "Klapki"
    ],
    "hierarchy": "(19919) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Klapki / Sportowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kozaki",
    "categoryPath": [
      "(5541) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(5541) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Kozaki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Mokasyny",
    "categoryPath": [
      "(147417) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(147417) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Mokasyny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5544) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(5544) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półbuty",
    "categoryPath": [
      "(5542) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(5542) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Półbuty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sandały",
    "categoryPath": [
      "(5540) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(5540) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Sandały",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(257903) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(257903) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Sportowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trampki",
    "categoryPath": [
      "(87981) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(87981) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Trampki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trekkingowe",
    "categoryPath": [
      "(55205) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(55205) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Trekkingowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Śniegowce",
    "categoryPath": [
      "(97557) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Damskie"
    ],
    "hierarchy": "(97557) Moda / Odzież, Obuwie, Dodatki / Obuwie / Damskie / Śniegowce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Espadryle",
    "categoryPath": [
      "(257084) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(257084) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Espadryle",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Glany",
    "categoryPath": [
      "(55206) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(55206) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Glany",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kalosze",
    "categoryPath": [
      "(70085) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(70085) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Kalosze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kapcie",
    "categoryPath": [
      "(15587) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(15587) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Kapcie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Klapki",
    "categoryPath": [
      "(19913) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(19913) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Klapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kowbojki",
    "categoryPath": [
      "(97555) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(97555) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Kowbojki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Mokasyny",
    "categoryPath": [
      "(147418) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(147418) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Mokasyny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5549) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(5549) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półbuty",
    "categoryPath": [
      "(5547) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(5547) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Półbuty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sandały",
    "categoryPath": [
      "(19912) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(19912) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Sandały",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sportowe",
    "categoryPath": [
      "(257929) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(257929) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Sportowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sztyblety",
    "categoryPath": [
      "(257112) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(257112) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Sztyblety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trampki",
    "categoryPath": [
      "(251128) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(251128) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Trampki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trekkingowe",
    "categoryPath": [
      "(55207) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(55207) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Trekkingowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trzewiki",
    "categoryPath": [
      "(260415) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(260415) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Trzewiki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Śniegowce",
    "categoryPath": [
      "(97556) Moda",
      "Odzież, Obuwie, Dodatki",
      "Obuwie",
      "Męskie"
    ],
    "hierarchy": "(97556) Moda / Odzież, Obuwie, Dodatki / Obuwie / Męskie / Śniegowce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzki",
    "categoryPath": [
      "(76034) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76034) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Bluzki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(76035) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76035) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Body",
    "categoryPath": [
      "(76036) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76036) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Body",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bolerka",
    "categoryPath": [
      "(76037) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76037) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Bolerka",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dresy kompletne",
    "categoryPath": [
      "(76039) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76039) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Dresy kompletne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Garsonki i kostiumy",
    "categoryPath": [
      "(76040) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76040) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Garsonki i kostiumy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Golfy",
    "categoryPath": [
      "(76041) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76041) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Golfy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Gorsety",
    "categoryPath": [
      "(78138) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(78138) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Gorsety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Jeansy",
    "categoryPath": [
      "(254259) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(254259) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Jeansy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(76042) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76042) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kombinezony",
    "categoryPath": [
      "(78137) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(78137) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Kombinezony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(76110) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76110) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule",
    "categoryPath": [
      "(76043) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76043) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki polo",
    "categoryPath": [
      "(257020) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(257020) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Koszulki polo",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Legginsy",
    "categoryPath": [
      "(91193) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(91193) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Legginsy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Marynarki i żakiety",
    "categoryPath": [
      "(76044) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76044) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Marynarki i żakiety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Futra i kożuchy",
    "categoryPath": [
      "(76075) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(76075) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Okrycia wierzchnie / Futra i kożuchy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(76076) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(76076) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Okrycia wierzchnie / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Poncza",
    "categoryPath": [
      "(76078) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(76078) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Okrycia wierzchnie / Poncza",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76079) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(76079) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Okrycia wierzchnie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płaszcze",
    "categoryPath": [
      "(76077) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(76077) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Okrycia wierzchnie / Płaszcze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(76085) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76085) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(76083) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76083) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Casual (na co dzień)",
    "categoryPath": [
      "(254778) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Spodnie"
    ],
    "hierarchy": "(254778) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Spodnie / Casual (na co dzień)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dresowe",
    "categoryPath": [
      "(76095) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Spodnie"
    ],
    "hierarchy": "(76095) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Spodnie / Dresowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Eleganckie",
    "categoryPath": [
      "(76096) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska",
      "Spodnie"
    ],
    "hierarchy": "(76096) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Spodnie / Eleganckie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spódnice i spódniczki",
    "categoryPath": [
      "(76084) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76084) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Spódnice i spódniczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki",
    "categoryPath": [
      "(124264) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(124264) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Sukienki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki wieczorowe",
    "categoryPath": [
      "(124265) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(124265) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Sukienki wieczorowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Swetry",
    "categoryPath": [
      "(76102) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76102) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Swetry",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "T-shirty",
    "categoryPath": [
      "(76104) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76104) Moda / Odzież, Obuwie, Dodatki / Odzież damska / T-shirty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Topy",
    "categoryPath": [
      "(76103) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76103) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Topy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Tuniki",
    "categoryPath": [
      "(76105) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76105) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Tuniki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(76111) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież damska"
    ],
    "hierarchy": "(76111) Moda / Odzież, Obuwie, Dodatki / Odzież damska / Zestawy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(87843) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87843) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dresy kompletne",
    "categoryPath": [
      "(87844) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87844) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Dresy kompletne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Garnitury",
    "categoryPath": [
      "(87833) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87833) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Garnitury",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Jeansy",
    "categoryPath": [
      "(254260) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(254260) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Jeansy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki casual (na co dzień)",
    "categoryPath": [
      "(87846) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Kamizelki"
    ],
    "hierarchy": "(87846) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Kamizelki / Kamizelki casual (na co dzień)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki eleganckie",
    "categoryPath": [
      "(87835) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Kamizelki"
    ],
    "hierarchy": "(87835) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Kamizelki / Kamizelki eleganckie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(87878) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87878) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule casual (na co dzień)",
    "categoryPath": [
      "(87873) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Koszule"
    ],
    "hierarchy": "(87873) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Koszule / Koszule casual (na co dzień)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule eleganckie",
    "categoryPath": [
      "(87837) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Koszule"
    ],
    "hierarchy": "(87837) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Koszule / Koszule eleganckie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki bez rękawów",
    "categoryPath": [
      "(87874) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87874) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Koszulki bez rękawów",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki polo",
    "categoryPath": [
      "(87875) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87875) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Koszulki polo",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki z długim rękawem",
    "categoryPath": [
      "(87876) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87876) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Koszulki z długim rękawem",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Marynarki",
    "categoryPath": [
      "(87839) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87839) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Marynarki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(5537) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(5537) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Okrycia wierzchnie / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5539) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(5539) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Okrycia wierzchnie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płaszcze",
    "categoryPath": [
      "(5538) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Okrycia wierzchnie"
    ],
    "hierarchy": "(5538) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Okrycia wierzchnie / Płaszcze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(535) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(535) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(87893) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87893) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Casual (na co dzień)",
    "categoryPath": [
      "(254779) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Spodnie"
    ],
    "hierarchy": "(254779) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Spodnie / Casual (na co dzień)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dresowe",
    "categoryPath": [
      "(87894) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Spodnie"
    ],
    "hierarchy": "(87894) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Spodnie / Dresowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Eleganckie",
    "categoryPath": [
      "(87842) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska",
      "Spodnie"
    ],
    "hierarchy": "(87842) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Spodnie / Eleganckie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Swetry",
    "categoryPath": [
      "(87897) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87897) Moda / Odzież, Obuwie, Dodatki / Odzież męska / Swetry",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "T-shirty",
    "categoryPath": [
      "(87913) Moda",
      "Odzież, Obuwie, Dodatki",
      "Odzież męska"
    ],
    "hierarchy": "(87913) Moda / Odzież, Obuwie, Dodatki / Odzież męska / T-shirty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(319929) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319929) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nakrycia głowy",
    "categoryPath": [
      "(319899) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319899) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Nakrycia głowy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Naszyjniki",
    "categoryPath": [
      "(319902) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319902) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Naszyjniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Okulary",
    "categoryPath": [
      "(319905) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319905) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Okulary",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Opaski i bransoletki",
    "categoryPath": [
      "(319908) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319908) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Opaski i bransoletki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(319911) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319911) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Rękawiczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szarfy i szale",
    "categoryPath": [
      "(319917) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319917) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Szarfy i szale",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sztuczne tatuaże",
    "categoryPath": [
      "(319914) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319914) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Sztuczne tatuaże",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wachlarze",
    "categoryPath": [
      "(319920) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319920) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Wachlarze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wąsy i brody",
    "categoryPath": [
      "(319923) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319923) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Wąsy i brody",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy akcesoriów",
    "categoryPath": [
      "(319926) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski",
      "Akcesoria"
    ],
    "hierarchy": "(319926) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Akcesoria / Zestawy akcesoriów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Farbki do twarzy, ciała, włosów",
    "categoryPath": [
      "(259984) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski"
    ],
    "hierarchy": "(259984) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Farbki do twarzy, ciała, włosów",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kostiumy damskie",
    "categoryPath": [
      "(74173) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski"
    ],
    "hierarchy": "(74173) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Kostiumy damskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kostiumy męskie",
    "categoryPath": [
      "(74174) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski"
    ],
    "hierarchy": "(74174) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Kostiumy męskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Maski",
    "categoryPath": [
      "(74175) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski"
    ],
    "hierarchy": "(74175) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Maski",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Peruki",
    "categoryPath": [
      "(124269) Moda",
      "Odzież, Obuwie, Dodatki",
      "Przebrania, kostiumy, maski"
    ],
    "hierarchy": "(124269) Moda / Odzież, Obuwie, Dodatki / Przebrania, kostiumy, maski / Peruki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(258091) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne",
      "Balony i akcesoria"
    ],
    "hierarchy": "(258091) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Balony i akcesoria / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Balony",
    "categoryPath": [
      "(258084) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne",
      "Balony i akcesoria"
    ],
    "hierarchy": "(258084) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Balony i akcesoria / Balony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bańki mydlane",
    "categoryPath": [
      "(260882) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(260882) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Bańki mydlane",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dekoracja samochodu",
    "categoryPath": [
      "(74181) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(74181) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Dekoracja samochodu",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dekoracja stołu",
    "categoryPath": [
      "(74182) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(74182) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Dekoracja stołu",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Figurki na tort, toppery",
    "categoryPath": [
      "(258087) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258087) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Figurki na tort, toppery",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Gąbki florystyczne",
    "categoryPath": [
      "(258121) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258121) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Gąbki florystyczne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Konfetti",
    "categoryPath": [
      "(258124) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258124) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Konfetti",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kotyliony",
    "categoryPath": [
      "(74183) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(74183) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Kotyliony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Lampiony",
    "categoryPath": [
      "(111633) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(111633) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Lampiony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Litery 3D, inicjały",
    "categoryPath": [
      "(258085) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258085) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Litery 3D, inicjały",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Naklejki na buty",
    "categoryPath": [
      "(258218) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258218) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Naklejki na buty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Poduszki i pudełka na obrączki",
    "categoryPath": [
      "(74184) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(74184) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Poduszki i pudełka na obrączki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pokrowce na krzesła",
    "categoryPath": [
      "(258086) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258086) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Pokrowce na krzesła",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pompony, rozety, kule",
    "categoryPath": [
      "(258122) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258122) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Pompony, rozety, kule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74179) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(74179) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płatki róż",
    "categoryPath": [
      "(311805) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(311805) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Płatki róż",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rekwizyty do fotobudki",
    "categoryPath": [
      "(258125) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(258125) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Rekwizyty do fotobudki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Stroiki i akcesoria",
    "categoryPath": [
      "(74185) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dekoracje ślubne"
    ],
    "hierarchy": "(74185) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dekoracje ślubne / Stroiki i akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bolerka i etole",
    "categoryPath": [
      "(111639) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(111639) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Bolerka i etole",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety bielizny",
    "categoryPath": [
      "(111643) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(111643) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Komplety bielizny",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Parasolki",
    "categoryPath": [
      "(257792) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(257792) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Parasolki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Podwiązki",
    "categoryPath": [
      "(257791) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(257791) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Podwiązki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(111638) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(111638) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(111640) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(111640) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Rękawiczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Stroiki, wianki i ozdoby do włosów",
    "categoryPath": [
      "(111641) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(111641) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Stroiki, wianki i ozdoby do włosów",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Welony",
    "categoryPath": [
      "(111642) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Dodatki damskie"
    ],
    "hierarchy": "(111642) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki damskie / Welony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dodatki męskie",
    "categoryPath": [
      "(111637) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele"
    ],
    "hierarchy": "(111637) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Dodatki męskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Obuwie ślubne",
    "categoryPath": [
      "(111635) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele"
    ],
    "hierarchy": "(111635) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Obuwie ślubne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Etykiety i zawieszki na alkohol",
    "categoryPath": [
      "(74188) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(74188) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Etykiety i zawieszki na alkohol",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Księgi i ramki na życzenia",
    "categoryPath": [
      "(74189) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(74189) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Księgi i ramki na życzenia",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Menu weselne",
    "categoryPath": [
      "(258221) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(258221) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Menu weselne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Plakaty",
    "categoryPath": [
      "(258222) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(258222) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Plakaty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74187) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(74187) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pudełka na koperty",
    "categoryPath": [
      "(258228) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(258228) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Pudełka na koperty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Winietki",
    "categoryPath": [
      "(74191) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(74191) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Winietki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zaproszenia ślubne, zawiadomienia",
    "categoryPath": [
      "(74192) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Papeteria ślubna"
    ],
    "hierarchy": "(74192) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Papeteria ślubna / Zaproszenia ślubne, zawiadomienia",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Magnesy",
    "categoryPath": [
      "(258271) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania",
      "Dla Gości"
    ],
    "hierarchy": "(258271) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Dla Gości / Magnesy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pudełka na ciasta i alkohol",
    "categoryPath": [
      "(258257) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania",
      "Dla Gości"
    ],
    "hierarchy": "(258257) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Dla Gości / Pudełka na ciasta i alkohol",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Słodycze",
    "categoryPath": [
      "(258272) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania",
      "Dla Gości"
    ],
    "hierarchy": "(258272) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Dla Gości / Słodycze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Karafki",
    "categoryPath": [
      "(258255) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania",
      "Dla Rodziców"
    ],
    "hierarchy": "(258255) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Dla Rodziców / Karafki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skrzynki na alkohol",
    "categoryPath": [
      "(258256) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania",
      "Dla Rodziców"
    ],
    "hierarchy": "(258256) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Dla Rodziców / Skrzynki na alkohol",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Statuetki",
    "categoryPath": [
      "(258296) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania",
      "Dla Rodziców"
    ],
    "hierarchy": "(258296) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Dla Rodziców / Statuetki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wazony",
    "categoryPath": [
      "(258254) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania",
      "Dla Rodziców"
    ],
    "hierarchy": "(258254) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Dla Rodziców / Wazony",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258270) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele",
      "Podziękowania"
    ],
    "hierarchy": "(258270) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Podziękowania / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Suknie ślubne",
    "categoryPath": [
      "(111634) Moda",
      "Odzież, Obuwie, Dodatki",
      "Ślub i wesele"
    ],
    "hierarchy": "(111634) Moda / Odzież, Obuwie, Dodatki / Ślub i wesele / Suknie ślubne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Akrylowe",
    "categoryPath": [
      "(253286) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Lakiery"
    ],
    "hierarchy": "(253286) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Lakiery / Akrylowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bazowe",
    "categoryPath": [
      "(253287) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Lakiery"
    ],
    "hierarchy": "(253287) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Lakiery / Bazowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bezbarwne",
    "categoryPath": [
      "(253288) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Lakiery"
    ],
    "hierarchy": "(253288) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Lakiery / Bezbarwne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Powłoki gumowe",
    "categoryPath": [
      "(253289) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Lakiery"
    ],
    "hierarchy": "(253289) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Lakiery / Powłoki gumowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253285) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Lakiery"
    ],
    "hierarchy": "(253285) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Lakiery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wodne",
    "categoryPath": [
      "(253290) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Lakiery"
    ],
    "hierarchy": "(253290) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Lakiery / Wodne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Żaroodporne",
    "categoryPath": [
      "(322371) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Lakiery"
    ],
    "hierarchy": "(322371) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Lakiery / Żaroodporne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Maty szklane",
    "categoryPath": [
      "(253296) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza"
    ],
    "hierarchy": "(253296) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Maty szklane",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Polerowanie lakieru",
    "categoryPath": [
      "(253305) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Mleczka i pasty polerskie"
    ],
    "hierarchy": "(253305) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Mleczka i pasty polerskie / Polerowanie lakieru",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Polerowanie lamp",
    "categoryPath": [
      "(253306) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Mleczka i pasty polerskie"
    ],
    "hierarchy": "(253306) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Mleczka i pasty polerskie / Polerowanie lamp",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Polerowanie szyb",
    "categoryPath": [
      "(253307) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Mleczka i pasty polerskie"
    ],
    "hierarchy": "(253307) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Mleczka i pasty polerskie / Polerowanie szyb",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odtłuszczacze",
    "categoryPath": [
      "(253298) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza"
    ],
    "hierarchy": "(253298) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Odtłuszczacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akrylowe",
    "categoryPath": [
      "(253292) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Podkłady i grunty"
    ],
    "hierarchy": "(253292) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Podkłady i grunty / Akrylowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Do tworzyw sztucznych",
    "categoryPath": [
      "(253293) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Podkłady i grunty"
    ],
    "hierarchy": "(253293) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Podkłady i grunty / Do tworzyw sztucznych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Epoksydowe",
    "categoryPath": [
      "(253294) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Podkłady i grunty"
    ],
    "hierarchy": "(253294) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Podkłady i grunty / Epoksydowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253291) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Podkłady i grunty"
    ],
    "hierarchy": "(253291) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Podkłady i grunty / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reaktywne",
    "categoryPath": [
      "(253295) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Podkłady i grunty"
    ],
    "hierarchy": "(253295) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Podkłady i grunty / Reaktywne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozcieńczalniki",
    "categoryPath": [
      "(253299) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza"
    ],
    "hierarchy": "(253299) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Rozcieńczalniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozpuszczalniki",
    "categoryPath": [
      "(18912) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza"
    ],
    "hierarchy": "(18912) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Rozpuszczalniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szpachlówki",
    "categoryPath": [
      "(253300) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza"
    ],
    "hierarchy": "(253300) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Szpachlówki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kredki, pisaki",
    "categoryPath": [
      "(253308) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Usuwanie rys"
    ],
    "hierarchy": "(253308) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Usuwanie rys / Kredki, pisaki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253311) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Usuwanie rys"
    ],
    "hierarchy": "(253311) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Usuwanie rys / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zaprawki",
    "categoryPath": [
      "(253309) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Usuwanie rys"
    ],
    "hierarchy": "(253309) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Usuwanie rys / Zaprawki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(253310) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Usuwanie rys"
    ],
    "hierarchy": "(253310) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Usuwanie rys / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Utwardzacze",
    "categoryPath": [
      "(253302) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza"
    ],
    "hierarchy": "(253302) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Utwardzacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Konserwacja nadwozia",
    "categoryPath": [
      "(253312) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Środki antykorozyjne"
    ],
    "hierarchy": "(253312) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Środki antykorozyjne / Konserwacja nadwozia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Konserwacja podwozia",
    "categoryPath": [
      "(253313) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Środki antykorozyjne"
    ],
    "hierarchy": "(253313) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Środki antykorozyjne / Konserwacja podwozia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Konserwacja profili zamkniętych",
    "categoryPath": [
      "(253314) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Środki antykorozyjne"
    ],
    "hierarchy": "(253314) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Środki antykorozyjne / Konserwacja profili zamkniętych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253315) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza",
      "Środki antykorozyjne"
    ],
    "hierarchy": "(253315) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Środki antykorozyjne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Żywice",
    "categoryPath": [
      "(253304) Motoryzacja",
      "Chemia",
      "Chemia blacharsko-lakiernicza"
    ],
    "hierarchy": "(253304) Motoryzacja / Chemia / Chemia blacharsko-lakiernicza / Żywice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pielęgnacja kasku",
    "categoryPath": [
      "(315324) Motoryzacja",
      "Chemia",
      "Chemia motocyklowa"
    ],
    "hierarchy": "(315324) Motoryzacja / Chemia / Chemia motocyklowa / Pielęgnacja kasku",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pielęgnacja motocykla",
    "categoryPath": [
      "(315321) Motoryzacja",
      "Chemia",
      "Chemia motocyklowa"
    ],
    "hierarchy": "(315321) Motoryzacja / Chemia / Chemia motocyklowa / Pielęgnacja motocykla",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pielęgnacja łańcucha",
    "categoryPath": [
      "(315318) Motoryzacja",
      "Chemia",
      "Chemia motocyklowa"
    ],
    "hierarchy": "(315318) Motoryzacja / Chemia / Chemia motocyklowa / Pielęgnacja łańcucha",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płyny eksploatacyjne",
    "categoryPath": [
      "(315327) Motoryzacja",
      "Chemia",
      "Chemia motocyklowa"
    ],
    "hierarchy": "(315327) Motoryzacja / Chemia / Chemia motocyklowa / Płyny eksploatacyjne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Hydrowoski",
    "categoryPath": [
      "(253246) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Chemia dla myjni"
    ],
    "hierarchy": "(253246) Motoryzacja / Chemia / Mycie i pielęgnacja / Chemia dla myjni / Hydrowoski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Piany aktywne",
    "categoryPath": [
      "(253247) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Chemia dla myjni"
    ],
    "hierarchy": "(253247) Motoryzacja / Chemia / Mycie i pielęgnacja / Chemia dla myjni / Piany aktywne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253250) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Chemia dla myjni"
    ],
    "hierarchy": "(253250) Motoryzacja / Chemia / Mycie i pielęgnacja / Chemia dla myjni / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Proszki",
    "categoryPath": [
      "(253248) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Chemia dla myjni"
    ],
    "hierarchy": "(253248) Motoryzacja / Chemia / Mycie i pielęgnacja / Chemia dla myjni / Proszki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Środki uniwersalne APC",
    "categoryPath": [
      "(253249) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Chemia dla myjni"
    ],
    "hierarchy": "(253249) Motoryzacja / Chemia / Mycie i pielęgnacja / Chemia dla myjni / Środki uniwersalne APC",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie felg",
    "categoryPath": [
      "(253253) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Felgi i opony"
    ],
    "hierarchy": "(253253) Motoryzacja / Chemia / Mycie i pielęgnacja / Felgi i opony / Czyszczenie felg",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie opon",
    "categoryPath": [
      "(253254) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Felgi i opony"
    ],
    "hierarchy": "(253254) Motoryzacja / Chemia / Mycie i pielęgnacja / Felgi i opony / Czyszczenie opon",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dressingi do opon",
    "categoryPath": [
      "(253252) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Felgi i opony"
    ],
    "hierarchy": "(253252) Motoryzacja / Chemia / Mycie i pielęgnacja / Felgi i opony / Dressingi do opon",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253255) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Felgi i opony"
    ],
    "hierarchy": "(253255) Motoryzacja / Chemia / Mycie i pielęgnacja / Felgi i opony / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Glinki",
    "categoryPath": [
      "(253256) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253256) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Glinki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Konserwacja dachów kabrioletów",
    "categoryPath": [
      "(253257) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253257) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Konserwacja dachów kabrioletów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Konserwacja uszczelek",
    "categoryPath": [
      "(253258) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253258) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Konserwacja uszczelek",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mycie silnika",
    "categoryPath": [
      "(253259) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253259) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Mycie silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Niewidzialne wycieraczki",
    "categoryPath": [
      "(253260) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253260) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Niewidzialne wycieraczki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odmrażacze",
    "categoryPath": [
      "(253261) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253261) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Odmrażacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Politury",
    "categoryPath": [
      "(253262) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253262) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Politury",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Powłoki ceramiczne i kwarcowe",
    "categoryPath": [
      "(257016) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(257016) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Powłoki ceramiczne i kwarcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płyny do szyb",
    "categoryPath": [
      "(253263) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253263) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Płyny do szyb",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Quick detailery",
    "categoryPath": [
      "(253264) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253264) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Quick detailery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szampony",
    "categoryPath": [
      "(253265) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253265) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Szampony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Usuwanie owadów",
    "categoryPath": [
      "(253266) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253266) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Usuwanie owadów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Usuwanie smoły, żywicy i asfaltu",
    "categoryPath": [
      "(253267) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253267) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Usuwanie smoły, żywicy i asfaltu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Woski",
    "categoryPath": [
      "(253268) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Nadwozie"
    ],
    "hierarchy": "(253268) Motoryzacja / Chemia / Mycie i pielęgnacja / Nadwozie / Woski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18914) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja"
    ],
    "hierarchy": "(18914) Motoryzacja / Chemia / Mycie i pielęgnacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Aplikatory",
    "categoryPath": [
      "(253235) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253235) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Aplikatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Atomizery i pianownice",
    "categoryPath": [
      "(258900) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(258900) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Atomizery i pianownice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyściwa",
    "categoryPath": [
      "(253236) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253236) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Czyściwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gąbki do mycia",
    "categoryPath": [
      "(253237) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253237) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Gąbki do mycia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Gąbki polerskie",
    "categoryPath": [
      "(253238) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253238) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Gąbki polerskie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pędzelki",
    "categoryPath": [
      "(253239) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253239) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Pędzelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rękawice do mycia",
    "categoryPath": [
      "(253240) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253240) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Rękawice do mycia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(253241) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253241) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Szczotki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wiadra",
    "categoryPath": [
      "(253242) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253242) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Wiadra",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ścierki i ręczniki",
    "categoryPath": [
      "(253243) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253243) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Ścierki i ręczniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągaczki do wody",
    "categoryPath": [
      "(253244) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Przybory i akcesoria"
    ],
    "hierarchy": "(253244) Motoryzacja / Chemia / Mycie i pielęgnacja / Przybory i akcesoria / Ściągaczki do wody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie plastików",
    "categoryPath": [
      "(253270) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze"
    ],
    "hierarchy": "(253270) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Czyszczenie plastików",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie skóry",
    "categoryPath": [
      "(253277) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Konserwacja tapicerki"
    ],
    "hierarchy": "(253277) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Konserwacja tapicerki / Czyszczenie skóry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie tekstyliów",
    "categoryPath": [
      "(253278) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Konserwacja tapicerki"
    ],
    "hierarchy": "(253278) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Konserwacja tapicerki / Czyszczenie tekstyliów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Renowacja skóry",
    "categoryPath": [
      "(253279) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Konserwacja tapicerki"
    ],
    "hierarchy": "(253279) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Konserwacja tapicerki / Renowacja skóry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odgrzybiacze do klimatyzacji",
    "categoryPath": [
      "(253272) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze"
    ],
    "hierarchy": "(253272) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Odgrzybiacze do klimatyzacji",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pochłaniacze wilgoci",
    "categoryPath": [
      "(253273) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze"
    ],
    "hierarchy": "(253273) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Pochłaniacze wilgoci",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253276) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze"
    ],
    "hierarchy": "(253276) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Atomizery",
    "categoryPath": [
      "(253280) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Zapachy samochodowe"
    ],
    "hierarchy": "(253280) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Zapachy samochodowe / Atomizery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Do kratki nawiewu",
    "categoryPath": [
      "(253281) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Zapachy samochodowe"
    ],
    "hierarchy": "(253281) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Zapachy samochodowe / Do kratki nawiewu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253284) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Zapachy samochodowe"
    ],
    "hierarchy": "(253284) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Zapachy samochodowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Puszki zapachowe",
    "categoryPath": [
      "(317375) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Zapachy samochodowe"
    ],
    "hierarchy": "(317375) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Zapachy samochodowe / Puszki zapachowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawieszki",
    "categoryPath": [
      "(253282) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Zapachy samochodowe"
    ],
    "hierarchy": "(253282) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Zapachy samochodowe / Zawieszki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Żele",
    "categoryPath": [
      "(253283) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze",
      "Zapachy samochodowe"
    ],
    "hierarchy": "(253283) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Zapachy samochodowe / Żele",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Środki przeciw parowaniu",
    "categoryPath": [
      "(253275) Motoryzacja",
      "Chemia",
      "Mycie i pielęgnacja",
      "Wnętrze"
    ],
    "hierarchy": "(253275) Motoryzacja / Chemia / Mycie i pielęgnacja / Wnętrze / Środki przeciw parowaniu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mineralne",
    "categoryPath": [
      "(253182) Motoryzacja",
      "Chemia",
      "Oleje silnikowe"
    ],
    "hierarchy": "(253182) Motoryzacja / Chemia / Oleje silnikowe / Mineralne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Półsyntetyczne",
    "categoryPath": [
      "(253183) Motoryzacja",
      "Chemia",
      "Oleje silnikowe"
    ],
    "hierarchy": "(253183) Motoryzacja / Chemia / Oleje silnikowe / Półsyntetyczne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Syntetyczne",
    "categoryPath": [
      "(253184) Motoryzacja",
      "Chemia",
      "Oleje silnikowe"
    ],
    "hierarchy": "(253184) Motoryzacja / Chemia / Oleje silnikowe / Syntetyczne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18904) Motoryzacja",
      "Chemia"
    ],
    "hierarchy": "(18904) Motoryzacja / Chemia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "AdBlue",
    "categoryPath": [
      "(253223) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(253223) Motoryzacja / Chemia / Płyny eksploatacyjne / AdBlue",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czynniki klimatyzacji",
    "categoryPath": [
      "(259983) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(259983) Motoryzacja / Chemia / Płyny eksploatacyjne / Czynniki klimatyzacji",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dodatki do benzyny",
    "categoryPath": [
      "(253218) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne",
      "Dodatki do olejów i paliw"
    ],
    "hierarchy": "(253218) Motoryzacja / Chemia / Płyny eksploatacyjne / Dodatki do olejów i paliw / Dodatki do benzyny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dodatki do oleju napędowego",
    "categoryPath": [
      "(253219) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne",
      "Dodatki do olejów i paliw"
    ],
    "hierarchy": "(253219) Motoryzacja / Chemia / Płyny eksploatacyjne / Dodatki do olejów i paliw / Dodatki do oleju napędowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dodatki do oleju przekładniowego",
    "categoryPath": [
      "(253220) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne",
      "Dodatki do olejów i paliw"
    ],
    "hierarchy": "(253220) Motoryzacja / Chemia / Płyny eksploatacyjne / Dodatki do olejów i paliw / Dodatki do oleju przekładniowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dodatki do oleju silnikowego",
    "categoryPath": [
      "(253221) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne",
      "Dodatki do olejów i paliw"
    ],
    "hierarchy": "(253221) Motoryzacja / Chemia / Płyny eksploatacyjne / Dodatki do olejów i paliw / Dodatki do oleju silnikowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dodatki do układu wspomagania",
    "categoryPath": [
      "(253222) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne",
      "Dodatki do olejów i paliw"
    ],
    "hierarchy": "(253222) Motoryzacja / Chemia / Płyny eksploatacyjne / Dodatki do olejów i paliw / Dodatki do układu wspomagania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253217) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne",
      "Dodatki do olejów i paliw"
    ],
    "hierarchy": "(253217) Motoryzacja / Chemia / Płyny eksploatacyjne / Dodatki do olejów i paliw / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Lubryfikatory LPG",
    "categoryPath": [
      "(255921) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(255921) Motoryzacja / Chemia / Płyny eksploatacyjne / Lubryfikatory LPG",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Oleje do klimatyzacji",
    "categoryPath": [
      "(253224) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(253224) Motoryzacja / Chemia / Płyny eksploatacyjne / Oleje do klimatyzacji",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oleje do zawieszenia",
    "categoryPath": [
      "(253225) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(253225) Motoryzacja / Chemia / Płyny eksploatacyjne / Oleje do zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oleje filtrów powietrza",
    "categoryPath": [
      "(253226) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(253226) Motoryzacja / Chemia / Płyny eksploatacyjne / Oleje filtrów powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oleje hydrauliczne",
    "categoryPath": [
      "(253227) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(253227) Motoryzacja / Chemia / Płyny eksploatacyjne / Oleje hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oleje przekładniowe",
    "categoryPath": [
      "(18929) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(18929) Motoryzacja / Chemia / Płyny eksploatacyjne / Oleje przekładniowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oleje sprężarkowe",
    "categoryPath": [
      "(253228) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(253228) Motoryzacja / Chemia / Płyny eksploatacyjne / Oleje sprężarkowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Paliwa",
    "categoryPath": [
      "(311845) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(311845) Motoryzacja / Chemia / Płyny eksploatacyjne / Paliwa",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Płyny chłodnicze",
    "categoryPath": [
      "(18927) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(18927) Motoryzacja / Chemia / Płyny eksploatacyjne / Płyny chłodnicze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płyny do FAP",
    "categoryPath": [
      "(321881) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(321881) Motoryzacja / Chemia / Płyny eksploatacyjne / Płyny do FAP",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płyny do spryskiwaczy",
    "categoryPath": [
      "(18936) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(18936) Motoryzacja / Chemia / Płyny eksploatacyjne / Płyny do spryskiwaczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płyny do wspomagania",
    "categoryPath": [
      "(18928) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(18928) Motoryzacja / Chemia / Płyny eksploatacyjne / Płyny do wspomagania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płyny hamulcowe",
    "categoryPath": [
      "(18934) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(18934) Motoryzacja / Chemia / Płyny eksploatacyjne / Płyny hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Woda destylowana",
    "categoryPath": [
      "(253229) Motoryzacja",
      "Chemia",
      "Płyny eksploatacyjne"
    ],
    "hierarchy": "(253229) Motoryzacja / Chemia / Płyny eksploatacyjne / Woda destylowana",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie filtrów DPF/FAP",
    "categoryPath": [
      "(253202) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Czyszczenie części"
    ],
    "hierarchy": "(253202) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Czyszczenie części / Czyszczenie filtrów DPF/FAP",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie gaźników, wtrysków",
    "categoryPath": [
      "(253203) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Czyszczenie części"
    ],
    "hierarchy": "(253203) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Czyszczenie części / Czyszczenie gaźników, wtrysków",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie hamulców",
    "categoryPath": [
      "(253251) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Czyszczenie części"
    ],
    "hierarchy": "(253251) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Czyszczenie części / Czyszczenie hamulców",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Czyszczenie przepływomierzy",
    "categoryPath": [
      "(253204) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Czyszczenie części"
    ],
    "hierarchy": "(253204) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Czyszczenie części / Czyszczenie przepływomierzy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Czyszczenie styków",
    "categoryPath": [
      "(253205) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Czyszczenie części"
    ],
    "hierarchy": "(253205) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Czyszczenie części / Czyszczenie styków",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyszczenie turbo, kolektora, EGR",
    "categoryPath": [
      "(253206) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Czyszczenie części"
    ],
    "hierarchy": "(253206) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Czyszczenie części / Czyszczenie turbo, kolektora, EGR",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253207) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Czyszczenie części"
    ],
    "hierarchy": "(253207) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Czyszczenie części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(253187) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253187) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Kleje",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Montaż i naprawa wydechu",
    "categoryPath": [
      "(253188) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253188) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Montaż i naprawa wydechu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Naprawa opon",
    "categoryPath": [
      "(253189) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253189) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Naprawa opon",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odrdzewiacze i penetratory",
    "categoryPath": [
      "(253190) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253190) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Odrdzewiacze i penetratory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odstraszacze zwierząt",
    "categoryPath": [
      "(253191) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253191) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Odstraszacze zwierząt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasty do hamulców",
    "categoryPath": [
      "(253192) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253192) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Pasty do hamulców",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasty do rąk",
    "categoryPath": [
      "(253193) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253193) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Pasty do rąk",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasty zaworowe",
    "categoryPath": [
      "(253194) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253194) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Pasty zaworowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253201) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253201) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płukanki silnika",
    "categoryPath": [
      "(257045) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(257045) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Płukanki silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Samostarty",
    "categoryPath": [
      "(253195) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253195) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Samostarty",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Silikony, masy uszczelniające",
    "categoryPath": [
      "(253196) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253196) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Silikony, masy uszczelniające",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Biały smar",
    "categoryPath": [
      "(253208) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253208) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Biały smar",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasta ceramiczna",
    "categoryPath": [
      "(253216) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253216) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Pasta ceramiczna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253215) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253215) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Smar grafitowy",
    "categoryPath": [
      "(253209) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253209) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Smar grafitowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Smar miedziowy",
    "categoryPath": [
      "(253210) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253210) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Smar miedziowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Smar silikonowy",
    "categoryPath": [
      "(253211) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253211) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Smar silikonowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Smar teflonowy",
    "categoryPath": [
      "(253212) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253212) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Smar teflonowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Towot",
    "categoryPath": [
      "(253213) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253213) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Towot",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wazelina techniczna",
    "categoryPath": [
      "(253214) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania",
      "Smary"
    ],
    "hierarchy": "(253214) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Smary / Wazelina techniczna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery szczelności",
    "categoryPath": [
      "(253198) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253198) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Testery szczelności",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelnianie i czyszczenie chłodnic",
    "categoryPath": [
      "(253199) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253199) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Uszczelnianie i czyszczenie chłodnic",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Środki do usuwania uszczelek",
    "categoryPath": [
      "(253200) Motoryzacja",
      "Chemia",
      "Środki do napraw i zabezpieczania"
    ],
    "hierarchy": "(253200) Motoryzacja / Chemia / Środki do napraw i zabezpieczania / Środki do usuwania uszczelek",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części do gokartów",
    "categoryPath": [
      "(18558) Motoryzacja",
      "Części do maszyn i innych pojazdów"
    ],
    "hierarchy": "(18558) Motoryzacja / Części do maszyn i innych pojazdów / Części do gokartów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodzenie silnika",
    "categoryPath": [
      "(252232) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252232) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Chłodzenie silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części karoserii",
    "categoryPath": [
      "(252233) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252233) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Części karoserii",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(252234) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252234) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Gąsienice",
    "categoryPath": [
      "(252235) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252235) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Gąsienice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ogrzewanie, wentylacja, klimatyzacja",
    "categoryPath": [
      "(252236) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252236) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Ogrzewanie, wentylacja, klimatyzacja",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chwytaki",
    "categoryPath": [
      "(252255) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252255) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Osprzęt roboczy / Chwytaki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Młoty",
    "categoryPath": [
      "(252250) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252250) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Osprzęt roboczy / Młoty",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252249) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252249) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Osprzęt roboczy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pługi, lemiesze",
    "categoryPath": [
      "(252251) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252251) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Osprzęt roboczy / Pługi, lemiesze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szybkozłącza",
    "categoryPath": [
      "(252252) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252252) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Osprzęt roboczy / Szybkozłącza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zęby",
    "categoryPath": [
      "(252253) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252253) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Osprzęt roboczy / Zęby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łyżki",
    "categoryPath": [
      "(252254) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252254) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Osprzęt roboczy / Łyżki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(252238) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252238) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Oświetlenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252231) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252231) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Silnik i osprzęt",
    "categoryPath": [
      "(252239) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252239) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Silnik i osprzęt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ elektryczny, zapłon",
    "categoryPath": [
      "(252240) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252240) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ elektryczny, zapłon",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hamulcowy",
    "categoryPath": [
      "(252241) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252241) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ hamulcowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Układ hydrauliczny",
    "categoryPath": [
      "(252242) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252242) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ hydrauliczny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ kierowniczy",
    "categoryPath": [
      "(252243) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252243) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ kierowniczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ napędowy",
    "categoryPath": [
      "(252244) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252244) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ napędowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ paliwowy",
    "categoryPath": [
      "(252245) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252245) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ paliwowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ wydechowy",
    "categoryPath": [
      "(252246) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252246) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ wydechowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ zawieszenia",
    "categoryPath": [
      "(252247) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252247) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Układ zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyposażenie wnętrza",
    "categoryPath": [
      "(252248) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn budowlanych"
    ],
    "hierarchy": "(252248) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn budowlanych / Wyposażenie wnętrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części do maszyn przemysłowych",
    "categoryPath": [
      "(252230) Motoryzacja",
      "Części do maszyn i innych pojazdów"
    ],
    "hierarchy": "(252230) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn przemysłowych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Balotowanie",
    "categoryPath": [
      "(252428) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252428) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Balotowanie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Hodowla zwierząt",
    "categoryPath": [
      "(252429) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252429) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Hodowla zwierząt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Leśnictwo",
    "categoryPath": [
      "(252430) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252430) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Leśnictwo",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nawożenie",
    "categoryPath": [
      "(252431) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252431) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Nawożenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obróbka i przechowywanie",
    "categoryPath": [
      "(252432) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252432) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Obróbka i przechowywanie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Opryskiwanie",
    "categoryPath": [
      "(252433) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252433) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Opryskiwanie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252427) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252427) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sadzenie",
    "categoryPath": [
      "(252434) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252434) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Sadzenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uprawa ziemi",
    "categoryPath": [
      "(252435) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252435) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Uprawa ziemi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbieranie",
    "categoryPath": [
      "(252436) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do innych maszyn rolniczych"
    ],
    "hierarchy": "(252436) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do innych maszyn rolniczych / Zbieranie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodzenie silnika",
    "categoryPath": [
      "(319144) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319144) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Chłodzenie silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części karoserii",
    "categoryPath": [
      "(319147) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319147) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Części karoserii",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(319159) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319159) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(319150) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319150) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(321863) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321863) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nagarniacz",
    "categoryPath": [
      "(321856) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321856) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Nagarniacz",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Napęd hedera",
    "categoryPath": [
      "(321861) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321861) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Napęd hedera",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Napęd kosy",
    "categoryPath": [
      "(321862) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321862) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Napęd kosy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podajnik pochyły",
    "categoryPath": [
      "(321859) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321859) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Podajnik pochyły",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podajnik ślimakowy",
    "categoryPath": [
      "(321858) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321858) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Podajnik ślimakowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozdzielacz łanu",
    "categoryPath": [
      "(321860) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321860) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Rozdzielacz łanu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zespół tnący",
    "categoryPath": [
      "(321857) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Heder"
    ],
    "hierarchy": "(321857) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Heder / Zespół tnący",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Koła, felgi",
    "categoryPath": [
      "(319153) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319153) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Koła, felgi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Ogrzewanie, wentylacja, klimatyzacja",
    "categoryPath": [
      "(319156) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319156) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Ogrzewanie, wentylacja, klimatyzacja",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bagnety",
    "categoryPath": [
      "(319328) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(319328) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Osprzęt roboczy / Bagnety",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kosy",
    "categoryPath": [
      "(319331) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(319331) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Osprzęt roboczy / Kosy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(319340) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(319340) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Osprzęt roboczy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zęby",
    "categoryPath": [
      "(319337) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(319337) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Osprzęt roboczy / Zęby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(319141) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319141) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Oświetlenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(319322) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319322) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Silnik i osprzęt",
    "categoryPath": [
      "(319138) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319138) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Silnik i osprzęt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ elektryczny, zapłon",
    "categoryPath": [
      "(319135) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319135) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ elektryczny, zapłon",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hamulcowy",
    "categoryPath": [
      "(319111) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319111) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ hamulcowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hydrauliczny",
    "categoryPath": [
      "(319114) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319114) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ hydrauliczny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ kierowniczy",
    "categoryPath": [
      "(319117) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319117) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ kierowniczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ napędowy",
    "categoryPath": [
      "(319120) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319120) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ napędowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ paliwowy",
    "categoryPath": [
      "(319123) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319123) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ paliwowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ wydechowy",
    "categoryPath": [
      "(319126) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319126) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ wydechowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Układ zawieszenia",
    "categoryPath": [
      "(319129) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319129) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Układ zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wyposażenie wnętrza",
    "categoryPath": [
      "(319132) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów"
    ],
    "hierarchy": "(319132) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Wyposażenie wnętrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(321877) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół czyszczący"
    ],
    "hierarchy": "(321877) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół czyszczący / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podsiewacz",
    "categoryPath": [
      "(321874) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół czyszczący"
    ],
    "hierarchy": "(321874) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół czyszczący / Podsiewacz",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przenośniki kłosowe",
    "categoryPath": [
      "(321876) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół czyszczący"
    ],
    "hierarchy": "(321876) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół czyszczący / Przenośniki kłosowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sita",
    "categoryPath": [
      "(321875) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół czyszczący"
    ],
    "hierarchy": "(321875) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół czyszczący / Sita",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylator",
    "categoryPath": [
      "(321873) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół czyszczący"
    ],
    "hierarchy": "(321873) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół czyszczący / Wentylator",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bęben młócący",
    "categoryPath": [
      "(321865) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół młócący"
    ],
    "hierarchy": "(321865) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół młócący / Bęben młócący",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cepy",
    "categoryPath": [
      "(321866) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół młócący"
    ],
    "hierarchy": "(321866) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół młócący / Cepy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chwytacz kamieni",
    "categoryPath": [
      "(321869) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół młócący"
    ],
    "hierarchy": "(321869) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół młócący / Chwytacz kamieni",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(321871) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół młócący"
    ],
    "hierarchy": "(321871) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół młócący / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klepiska",
    "categoryPath": [
      "(321867) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół młócący"
    ],
    "hierarchy": "(321867) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół młócący / Klepiska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odrzutnik",
    "categoryPath": [
      "(321870) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół młócący"
    ],
    "hierarchy": "(321870) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół młócący / Odrzutnik",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wytrząsacze",
    "categoryPath": [
      "(321868) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do kombajnów",
      "Zespół młócący"
    ],
    "hierarchy": "(321868) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do kombajnów / Zespół młócący / Wytrząsacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodzenie silnika",
    "categoryPath": [
      "(252206) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252206) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Chłodzenie silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Części karoserii",
    "categoryPath": [
      "(252207) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252207) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Części karoserii",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(305829) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(305829) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(252208) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252208) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła, felgi",
    "categoryPath": [
      "(252209) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252209) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Koła, felgi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ogrzewanie, wentylacja, klimatyzacja",
    "categoryPath": [
      "(252210) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252210) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Ogrzewanie, wentylacja, klimatyzacja",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bagnety",
    "categoryPath": [
      "(305853) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(305853) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Osprzęt roboczy / Bagnety",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kosy",
    "categoryPath": [
      "(305841) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(305841) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Osprzęt roboczy / Kosy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252223) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252223) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Osprzęt roboczy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pługi śnieżne",
    "categoryPath": [
      "(252226) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252226) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Osprzęt roboczy / Pługi śnieżne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zęby",
    "categoryPath": [
      "(252227) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252227) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Osprzęt roboczy / Zęby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ładowacze",
    "categoryPath": [
      "(252224) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252224) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Osprzęt roboczy / Ładowacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łyżki",
    "categoryPath": [
      "(252225) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Osprzęt roboczy"
    ],
    "hierarchy": "(252225) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Osprzęt roboczy / Łyżki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(252212) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252212) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Oświetlenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252205) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252205) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Silnik i osprzęt",
    "categoryPath": [
      "(252213) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252213) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Silnik i osprzęt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Układ elektryczny, zapłon",
    "categoryPath": [
      "(252214) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252214) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ elektryczny, zapłon",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hamulcowy",
    "categoryPath": [
      "(252215) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252215) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ hamulcowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hydrauliczny",
    "categoryPath": [
      "(252216) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252216) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ hydrauliczny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ kierowniczy",
    "categoryPath": [
      "(252217) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252217) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ kierowniczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ napędowy",
    "categoryPath": [
      "(252218) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252218) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ napędowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ paliwowy",
    "categoryPath": [
      "(252219) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252219) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ paliwowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ wydechowy",
    "categoryPath": [
      "(252220) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252220) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ wydechowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ zawieszenia",
    "categoryPath": [
      "(252221) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów"
    ],
    "hierarchy": "(252221) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Układ zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(322177) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322177) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dywaniki",
    "categoryPath": [
      "(322165) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322165) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Dywaniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gałki i mieszki",
    "categoryPath": [
      "(322167) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322167) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Gałki i mieszki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(322166) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322166) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Kierownice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klamki",
    "categoryPath": [
      "(322169) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322169) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Klamki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Liczniki, zegary",
    "categoryPath": [
      "(322168) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322168) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Liczniki, zegary",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lusterka wewnętrzne",
    "categoryPath": [
      "(322170) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322170) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Lusterka wewnętrzne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony, zaślepki",
    "categoryPath": [
      "(322175) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322175) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Osłony, zaślepki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Panele sterowania, przełączniki",
    "categoryPath": [
      "(322171) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322171) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Panele sterowania, przełączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pedały",
    "categoryPath": [
      "(322174) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322174) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Pedały",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poduszki powietrzne",
    "categoryPath": [
      "(322176) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322176) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Poduszki powietrzne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podłokietniki",
    "categoryPath": [
      "(322173) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322173) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Podłokietniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Siedzenia",
    "categoryPath": [
      "(322164) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322164) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Siedzenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprężyny gazowe",
    "categoryPath": [
      "(322172) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Do traktorów",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(322172) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Do traktorów / Wyposażenie wnętrza / Sprężyny gazowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Agregaty hydrauliczne",
    "categoryPath": [
      "(319502) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319502) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Agregaty hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Manometry",
    "categoryPath": [
      "(319493) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza",
      "Armatura pomiarowa"
    ],
    "hierarchy": "(319493) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Armatura pomiarowa / Manometry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wakuometry",
    "categoryPath": [
      "(319496) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza",
      "Armatura pomiarowa"
    ],
    "hierarchy": "(319496) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Armatura pomiarowa / Wakuometry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Złącza pomiarowe",
    "categoryPath": [
      "(319499) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza",
      "Armatura pomiarowa"
    ],
    "hierarchy": "(319499) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Armatura pomiarowa / Złącza pomiarowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy hydrauliczne",
    "categoryPath": [
      "(319505) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319505) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Pompy hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(319529) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319529) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody hydrauliczne",
    "categoryPath": [
      "(319508) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319508) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Przewody hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozdzielacze",
    "categoryPath": [
      "(319511) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319511) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Rozdzielacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki hydrauliczne",
    "categoryPath": [
      "(319514) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319514) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Silniki hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Siłowniki",
    "categoryPath": [
      "(319517) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319517) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Siłowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szybkozłącza",
    "categoryPath": [
      "(319520) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319520) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Szybkozłącza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory hydrauliczne",
    "categoryPath": [
      "(319523) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319523) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Zawory hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Złączki",
    "categoryPath": [
      "(319526) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do maszyn rolniczych",
      "Hydraulika rolnicza"
    ],
    "hierarchy": "(319526) Motoryzacja / Części do maszyn i innych pojazdów / Części do maszyn rolniczych / Hydraulika rolnicza / Złączki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Anteny",
    "categoryPath": [
      "(313829) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313829) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Anteny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(18568) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(18568) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Części",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Drzwi",
    "categoryPath": [
      "(315467) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315467) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Drzwi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instalacja gazowa",
    "categoryPath": [
      "(315597) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315597) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Instalacja gazowa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instalacja wodna",
    "categoryPath": [
      "(315443) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315443) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Instalacja wodna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła podporowe",
    "categoryPath": [
      "(315446) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315446) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Koła podporowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy, maskownice",
    "categoryPath": [
      "(315482) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315482) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Listwy, maskownice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lusterka",
    "categoryPath": [
      "(313901) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313901) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Lusterka",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Markizy",
    "categoryPath": [
      "(313853) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313853) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Markizy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Meble do przyczep",
    "categoryPath": [
      "(315473) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315473) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Meble do przyczep",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Okna",
    "categoryPath": [
      "(313889) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313889) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Okna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Oświetlenie pojazdu",
    "categoryPath": [
      "(315404) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315404) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Oświetlenie pojazdu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Oświetlenie turystyczne",
    "categoryPath": [
      "(313877) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313877) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Oświetlenie turystyczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Panele słoneczne",
    "categoryPath": [
      "(313805) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313805) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Panele słoneczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pojemniki na wodę",
    "categoryPath": [
      "(313865) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313865) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Pojemniki na wodę",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy wody",
    "categoryPath": [
      "(315485) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315485) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Pompy wody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przedsionki",
    "categoryPath": [
      "(313841) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313841) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Przedsionki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Schodki i stopnie",
    "categoryPath": [
      "(313793) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313793) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Schodki i stopnie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stopy, podpory, podkładki",
    "categoryPath": [
      "(315458) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315458) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Stopy, podpory, podkładki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tabliczki znamionowe",
    "categoryPath": [
      "(315437) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315437) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Tabliczki znamionowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Toalety i środki czystości",
    "categoryPath": [
      "(313817) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313817) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Toalety i środki czystości",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ elektryczny",
    "categoryPath": [
      "(313913) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(313913) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Układ elektryczny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hamulcowy",
    "categoryPath": [
      "(315476) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315476) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Układ hamulcowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ zawieszenia",
    "categoryPath": [
      "(315530) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315530) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Układ zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(315354) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315354) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylacja",
    "categoryPath": [
      "(315434) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315434) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Wentylacja",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(18567) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(18567) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Wyposażenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wyposażenie kuchni",
    "categoryPath": [
      "(315645) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315645) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Wyposażenie kuchni",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Węże i rury",
    "categoryPath": [
      "(315470) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315470) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Węże i rury",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zamki",
    "categoryPath": [
      "(315461) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Kempingowe"
    ],
    "hierarchy": "(315461) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Kempingowe / Zamki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18566) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep"
    ],
    "hierarchy": "(18566) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(18571) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Towarowe"
    ],
    "hierarchy": "(18571) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Towarowe / Części",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(18570) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do przyczep i naczep",
      "Towarowe"
    ],
    "hierarchy": "(18570) Motoryzacja / Części do maszyn i innych pojazdów / Części do przyczep i naczep / Towarowe / Wyposażenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(18578) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do samolotów"
    ],
    "hierarchy": "(18578) Motoryzacja / Części do maszyn i innych pojazdów / Części do samolotów / Części",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18579) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do samolotów"
    ],
    "hierarchy": "(18579) Motoryzacja / Części do maszyn i innych pojazdów / Części do samolotów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wyposażenie",
    "categoryPath": [
      "(18577) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do samolotów"
    ],
    "hierarchy": "(18577) Motoryzacja / Części do maszyn i innych pojazdów / Części do samolotów / Wyposażenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodzenie silnika",
    "categoryPath": [
      "(252257) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252257) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Chłodzenie silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części karoserii",
    "categoryPath": [
      "(252258) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252258) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Części karoserii",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(252259) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252259) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła, felgi",
    "categoryPath": [
      "(252260) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252260) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Koła, felgi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ogrzewanie, wentylacja, klimatyzacja",
    "categoryPath": [
      "(252261) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252261) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Ogrzewanie, wentylacja, klimatyzacja",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(252262) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252262) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Oświetlenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252256) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252256) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Silnik i osprzęt",
    "categoryPath": [
      "(252263) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252263) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Silnik i osprzęt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ elektryczny, zapłon",
    "categoryPath": [
      "(252264) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252264) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ elektryczny, zapłon",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hamulcowy",
    "categoryPath": [
      "(252265) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252265) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ hamulcowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hydrauliczny",
    "categoryPath": [
      "(252266) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252266) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ hydrauliczny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ kierowniczy",
    "categoryPath": [
      "(252267) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252267) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ kierowniczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ napędowy",
    "categoryPath": [
      "(252268) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252268) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ napędowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ paliwowy",
    "categoryPath": [
      "(252269) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252269) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ paliwowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ wydechowy",
    "categoryPath": [
      "(252270) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252270) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ wydechowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ zawieszenia",
    "categoryPath": [
      "(252271) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252271) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Układ zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Widły, osprzęt roboczy",
    "categoryPath": [
      "(252272) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252272) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Widły, osprzęt roboczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyposażenie wnętrza",
    "categoryPath": [
      "(252273) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do wózków widłowych"
    ],
    "hierarchy": "(252273) Motoryzacja / Części do maszyn i innych pojazdów / Części do wózków widłowych / Wyposażenie wnętrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kuchenki i zlewy",
    "categoryPath": [
      "(318141) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "AGD jachtowe"
    ],
    "hierarchy": "(318141) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / AGD jachtowe / Kuchenki i zlewy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lodówki",
    "categoryPath": [
      "(318138) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "AGD jachtowe"
    ],
    "hierarchy": "(318138) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / AGD jachtowe / Lodówki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(318135) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Części montażowe"
    ],
    "hierarchy": "(318135) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Części montażowe / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(318181) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Części montażowe"
    ],
    "hierarchy": "(318181) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Części montażowe / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Śruby",
    "categoryPath": [
      "(318132) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Części montażowe"
    ],
    "hierarchy": "(318132) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Części montażowe / Śruby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki i wskaźniki",
    "categoryPath": [
      "(318021) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektronika i nawigacja"
    ],
    "hierarchy": "(318021) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektronika i nawigacja / Czujniki i wskaźniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nawigacja",
    "categoryPath": [
      "(318015) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektronika i nawigacja"
    ],
    "hierarchy": "(318015) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektronika i nawigacja / Nawigacja",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(317982) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(317982) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Akumulatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Generatory, ładowarki",
    "categoryPath": [
      "(317985) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(317985) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Generatory, ładowarki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gniazda i wtyczki",
    "categoryPath": [
      "(318000) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(318000) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Gniazda i wtyczki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(317997) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(317997) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Oświetlenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(317991) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(317991) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(317994) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(317994) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Przełączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozruszniki",
    "categoryPath": [
      "(317988) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(317988) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Rozruszniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Świece",
    "categoryPath": [
      "(318003) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Elektryka i oświetlenie"
    ],
    "hierarchy": "(318003) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Elektryka i oświetlenie / Świece",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(317964) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi"
    ],
    "hierarchy": "(317964) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Inne części i osprzęt",
    "categoryPath": [
      "(317967) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi"
    ],
    "hierarchy": "(317967) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Inne części i osprzęt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Krany",
    "categoryPath": [
      "(318045) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318045) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Krany",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Króćce",
    "categoryPath": [
      "(318039) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318039) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Króćce",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Odpływy",
    "categoryPath": [
      "(318027) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318027) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Odpływy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(318030) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318030) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Pompy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Prysznice",
    "categoryPath": [
      "(318024) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318024) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Prysznice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Toalety",
    "categoryPath": [
      "(318036) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318036) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Toalety",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(318042) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318042) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Węże",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(318033) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Instalacja wodna"
    ],
    "hierarchy": "(318033) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Instalacja wodna / Zbiorniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Piasty śruby napędowej",
    "categoryPath": [
      "(317973) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Jednostka napędowa"
    ],
    "hierarchy": "(317973) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Jednostka napędowa / Piasty śruby napędowej",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przekładnie",
    "categoryPath": [
      "(317979) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Jednostka napędowa"
    ],
    "hierarchy": "(317979) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Jednostka napędowa / Przekładnie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki i akcesoria",
    "categoryPath": [
      "(317970) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Jednostka napędowa"
    ],
    "hierarchy": "(317970) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Jednostka napędowa / Silniki i akcesoria",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Śruby napędowe",
    "categoryPath": [
      "(317976) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Jednostka napędowa"
    ],
    "hierarchy": "(317976) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Jednostka napędowa / Śruby napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kotwice",
    "categoryPath": [
      "(318120) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Kotwiczenie i cumowanie"
    ],
    "hierarchy": "(318120) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Kotwiczenie i cumowanie / Kotwice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odbijacze",
    "categoryPath": [
      "(318111) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Kotwiczenie i cumowanie"
    ],
    "hierarchy": "(318111) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Kotwiczenie i cumowanie / Odbijacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wciągarki",
    "categoryPath": [
      "(318123) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Kotwiczenie i cumowanie"
    ],
    "hierarchy": "(318123) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Kotwiczenie i cumowanie / Wciągarki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bosaki",
    "categoryPath": [
      "(318337) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Osprzęt"
    ],
    "hierarchy": "(318337) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Osprzęt / Bosaki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Fotele, siedziska",
    "categoryPath": [
      "(318108) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Osprzęt"
    ],
    "hierarchy": "(318108) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Osprzęt / Fotele, siedziska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Kabestany",
    "categoryPath": [
      "(318096) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Osprzęt"
    ],
    "hierarchy": "(318096) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Osprzęt / Kabestany",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Karabińczyki",
    "categoryPath": [
      "(318078) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Osprzęt"
    ],
    "hierarchy": "(318078) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Osprzęt / Karabińczyki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kausze",
    "categoryPath": [
      "(318081) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Osprzęt"
    ],
    "hierarchy": "(318081) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Osprzęt / Kausze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Liny",
    "categoryPath": [
      "(318072) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Osprzęt"
    ],
    "hierarchy": "(318072) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Osprzęt / Liny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szekle",
    "categoryPath": [
      "(318075) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Osprzęt"
    ],
    "hierarchy": "(318075) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Osprzęt / Szekle",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki wlewu",
    "categoryPath": [
      "(318358) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ paliwowy"
    ],
    "hierarchy": "(318358) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ paliwowy / Korki wlewu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odpowietrzniki zbiornika",
    "categoryPath": [
      "(318361) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ paliwowy"
    ],
    "hierarchy": "(318361) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ paliwowy / Odpowietrzniki zbiornika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(318343) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ paliwowy"
    ],
    "hierarchy": "(318343) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ paliwowy / Pompy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(318346) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ paliwowy"
    ],
    "hierarchy": "(318346) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ paliwowy / Przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Regulatory ciśnienia",
    "categoryPath": [
      "(318352) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ paliwowy"
    ],
    "hierarchy": "(318352) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ paliwowy / Regulatory ciśnienia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(318355) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ paliwowy"
    ],
    "hierarchy": "(318355) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ paliwowy / Zbiorniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Złączki",
    "categoryPath": [
      "(318349) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ paliwowy"
    ],
    "hierarchy": "(318349) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ paliwowy / Złączki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cięgna",
    "categoryPath": [
      "(318049) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ sterowania"
    ],
    "hierarchy": "(318049) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ sterowania / Cięgna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierownice, stery",
    "categoryPath": [
      "(318069) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ sterowania"
    ],
    "hierarchy": "(318069) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ sterowania / Kierownice, stery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Manetki",
    "categoryPath": [
      "(318057) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ sterowania"
    ],
    "hierarchy": "(318057) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ sterowania / Manetki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Przekładnie kierownicze",
    "categoryPath": [
      "(318060) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ sterowania"
    ],
    "hierarchy": "(318060) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ sterowania / Przekładnie kierownicze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody hydrauliczne",
    "categoryPath": [
      "(318066) Motoryzacja",
      "Części do maszyn i innych pojazdów",
      "Części do łodzi",
      "Układ sterowania"
    ],
    "hierarchy": "(318066) Motoryzacja / Części do maszyn i innych pojazdów / Części do łodzi / Układ sterowania / Przewody hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18563) Motoryzacja",
      "Części do maszyn i innych pojazdów"
    ],
    "hierarchy": "(18563) Motoryzacja / Części do maszyn i innych pojazdów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(321131) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów"
    ],
    "hierarchy": "(321131) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(321834) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321834) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Kierownice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lusterka",
    "categoryPath": [
      "(321833) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321833) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Lusterka",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Manetki",
    "categoryPath": [
      "(321835) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321835) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Manetki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony dłoni",
    "categoryPath": [
      "(321841) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321841) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Osłony dłoni",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony i owiewki",
    "categoryPath": [
      "(322448) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(322448) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Osłony i owiewki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ramy",
    "categoryPath": [
      "(321836) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321836) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Ramy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Siedzenia",
    "categoryPath": [
      "(321837) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321837) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Siedzenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stopnie (podnóżki)",
    "categoryPath": [
      "(321840) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321840) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Stopnie (podnóżki)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zderzaki",
    "categoryPath": [
      "(321844) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Elementy nadwozia"
    ],
    "hierarchy": "(321844) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Elementy nadwozia / Zderzaki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry oleju",
    "categoryPath": [
      "(321137) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Filtry"
    ],
    "hierarchy": "(321137) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Filtry / Filtry oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Filtry paliwa",
    "categoryPath": [
      "(321143) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Filtry"
    ],
    "hierarchy": "(321143) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Filtry / Filtry paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Filtry powietrza",
    "categoryPath": [
      "(321140) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Filtry"
    ],
    "hierarchy": "(321140) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Filtry / Filtry powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła, felgi, opony, dętki",
    "categoryPath": [
      "(251346) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów"
    ],
    "hierarchy": "(251346) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Koła, felgi, opony, dętki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierunkowskazy",
    "categoryPath": [
      "(321158) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Oświetlenie"
    ],
    "hierarchy": "(321158) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Oświetlenie / Kierunkowskazy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy przednie",
    "categoryPath": [
      "(321152) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Oświetlenie"
    ],
    "hierarchy": "(321152) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Oświetlenie / Lampy przednie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy tylne",
    "categoryPath": [
      "(321149) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Oświetlenie"
    ],
    "hierarchy": "(321149) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Oświetlenie / Lampy tylne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oświetlenie dodatkowe",
    "categoryPath": [
      "(322446) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Oświetlenie"
    ],
    "hierarchy": "(322446) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Oświetlenie / Oświetlenie dodatkowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Żarówki",
    "categoryPath": [
      "(321155) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Oświetlenie"
    ],
    "hierarchy": "(321155) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Oświetlenie / Żarówki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(251355) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów"
    ],
    "hierarchy": "(251355) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Cylindry i komponenty",
    "categoryPath": [
      "(321886) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321886) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Cylindry i komponenty",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki silnika i osprzętu",
    "categoryPath": [
      "(321895) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321895) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Czujniki silnika i osprzętu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Głowice silnika",
    "categoryPath": [
      "(321885) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321885) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Głowice silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korbowody",
    "categoryPath": [
      "(321890) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321890) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Korbowody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pokrywy silnika",
    "categoryPath": [
      "(321896) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321896) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Pokrywy silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki kompletne",
    "categoryPath": [
      "(321884) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321884) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Silniki kompletne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Sworznie",
    "categoryPath": [
      "(321892) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321892) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Sworznie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuleje cylindrowe",
    "categoryPath": [
      "(321894) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321894) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Tuleje cylindrowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tłoki, sworznie, pierścienie tłokowe",
    "categoryPath": [
      "(321891) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321891) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Tłoki, sworznie, pierścienie tłokowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki silnika i osprzętu",
    "categoryPath": [
      "(321887) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321887) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Uszczelki silnika i osprzętu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wałki rozrządu",
    "categoryPath": [
      "(321897) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321897) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Wałki rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wałki zdawcze",
    "categoryPath": [
      "(321898) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321898) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Wałki zdawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wały korbowe",
    "categoryPath": [
      "(321899) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321899) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Wały korbowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory ssące i wydechowe",
    "categoryPath": [
      "(321900) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321900) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Zawory ssące i wydechowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łańcuchy rozrządu",
    "categoryPath": [
      "(321889) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(321889) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Silniki i osprzęt / Łańcuchy rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodnice",
    "categoryPath": [
      "(321164) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ chłodzenia"
    ],
    "hierarchy": "(321164) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ chłodzenia / Chłodnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki chłodnicy",
    "categoryPath": [
      "(322449) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ chłodzenia"
    ],
    "hierarchy": "(322449) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ chłodzenia / Korki chłodnicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(321167) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ chłodzenia"
    ],
    "hierarchy": "(321167) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ chłodzenia / Wentylatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akumulatory i części do akumulatorów",
    "categoryPath": [
      "(321920) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321920) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Akumulatory i części do akumulatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Alternatory",
    "categoryPath": [
      "(321921) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321921) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Alternatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bendiks",
    "categoryPath": [
      "(321893) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321893) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Bendiks",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Iskrowniki",
    "categoryPath": [
      "(321923) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321923) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Iskrowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Klaksony",
    "categoryPath": [
      "(321916) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321916) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Klaksony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Liczniki",
    "categoryPath": [
      "(321922) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321922) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Liczniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przekaźniki",
    "categoryPath": [
      "(321918) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321918) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Przekaźniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(321924) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321924) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Przełączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Regulatory napięcia",
    "categoryPath": [
      "(321914) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321914) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Regulatory napięcia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozruszniki",
    "categoryPath": [
      "(321913) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321913) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Rozruszniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stacyjki",
    "categoryPath": [
      "(321912) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321912) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Stacyjki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(321915) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321915) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Świece zapłonowe",
    "categoryPath": [
      "(321917) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(321917) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ elektryczny, zapłon / Świece zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki hamulcowe",
    "categoryPath": [
      "(321938) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321938) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Czujniki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dźwignie hamulca",
    "categoryPath": [
      "(321838) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321838) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Dźwignie hamulca",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klocki hamulcowe",
    "categoryPath": [
      "(321937) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321937) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Klocki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki hamulcowe",
    "categoryPath": [
      "(322445) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(322445) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Linki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy hamulcowe",
    "categoryPath": [
      "(321939) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321939) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Pompy hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Przewody hamulcowe",
    "categoryPath": [
      "(321934) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321934) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Przewody hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Szczęki hamulcowe",
    "categoryPath": [
      "(321935) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321935) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Szczęki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tarcze hamulcowe",
    "categoryPath": [
      "(321936) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321936) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Tarcze hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zaciski hamulcowe",
    "categoryPath": [
      "(321940) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321940) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Zaciski hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniczki płynu hamulcowego",
    "categoryPath": [
      "(321942) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321942) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Zbiorniczki płynu hamulcowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze układu hamulcowego",
    "categoryPath": [
      "(321941) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ hamulcowy"
    ],
    "hierarchy": "(321941) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ hamulcowy / Zestawy naprawcze układu hamulcowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dyferencjały do quadów",
    "categoryPath": [
      "(321272) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321272) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Dyferencjały do quadów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dźwignie sprzęgła",
    "categoryPath": [
      "(321839) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321839) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Dźwignie sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Krzyżaki wału",
    "categoryPath": [
      "(321260) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321260) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Krzyżaki wału",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki gazu i sprzęgła",
    "categoryPath": [
      "(321842) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321842) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Linki gazu i sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony przegubów",
    "categoryPath": [
      "(321263) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321263) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Osłony przegubów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Paski napędowe",
    "categoryPath": [
      "(321257) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321257) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Paski napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przeguby",
    "categoryPath": [
      "(321269) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321269) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Przeguby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Półosie",
    "categoryPath": [
      "(321266) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321266) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Półosie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprzęgła",
    "categoryPath": [
      "(321888) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321888) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wały napędowe",
    "categoryPath": [
      "(321254) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(321254) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Wały napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Łańcuchy napędowe, zębatki napędowe, zestawy",
    "categoryPath": [
      "(322447) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ napędowy"
    ],
    "hierarchy": "(322447) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ napędowy / Łańcuchy napędowe, zębatki napędowe, zestawy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gaźniki",
    "categoryPath": [
      "(321206) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321206) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Gaźniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki wlewu paliwa",
    "categoryPath": [
      "(321218) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321218) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Korki wlewu paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kraniki paliwa",
    "categoryPath": [
      "(321221) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321221) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Kraniki paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Króćce układu paliwowego",
    "categoryPath": [
      "(321209) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321209) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Króćce układu paliwowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy paliwa",
    "categoryPath": [
      "(321224) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321224) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Pompy paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody paliwowe",
    "categoryPath": [
      "(321212) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321212) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Przewody paliwowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki układu paliwowego",
    "categoryPath": [
      "(321203) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321203) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Uszczelki układu paliwowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki paliwa",
    "categoryPath": [
      "(321215) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(321215) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Zbiorniki paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze gaźnika/kranika paliwa",
    "categoryPath": [
      "(322450) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ paliwowy"
    ],
    "hierarchy": "(322450) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ paliwowy / Zestawy naprawcze gaźnika/kranika paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kolektory wydechowe",
    "categoryPath": [
      "(321185) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ wydechowy"
    ],
    "hierarchy": "(321185) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ wydechowy / Kolektory wydechowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obejmy tłumików",
    "categoryPath": [
      "(321194) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ wydechowy"
    ],
    "hierarchy": "(321194) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ wydechowy / Obejmy tłumików",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony tłumików",
    "categoryPath": [
      "(321188) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ wydechowy"
    ],
    "hierarchy": "(321188) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ wydechowy / Osłony tłumików",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tłumiki",
    "categoryPath": [
      "(321182) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ wydechowy"
    ],
    "hierarchy": "(321182) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ wydechowy / Tłumiki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Uszczelki wydechu",
    "categoryPath": [
      "(321191) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ wydechowy"
    ],
    "hierarchy": "(321191) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ wydechowy / Uszczelki wydechu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Amortyzatory",
    "categoryPath": [
      "(321236) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ zawieszenia"
    ],
    "hierarchy": "(321236) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ zawieszenia / Amortyzatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Końcówki drążka kierownicy",
    "categoryPath": [
      "(321233) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ zawieszenia"
    ],
    "hierarchy": "(321233) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ zawieszenia / Końcówki drążka kierownicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sworznie",
    "categoryPath": [
      "(321248) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ zawieszenia"
    ],
    "hierarchy": "(321248) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ zawieszenia / Sworznie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuleje",
    "categoryPath": [
      "(321242) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ zawieszenia"
    ],
    "hierarchy": "(321242) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ zawieszenia / Tuleje",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wahacze",
    "categoryPath": [
      "(321245) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ zawieszenia"
    ],
    "hierarchy": "(321245) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ zawieszenia / Wahacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(321239) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ zawieszenia"
    ],
    "hierarchy": "(321239) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ zawieszenia / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska kół",
    "categoryPath": [
      "(321230) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części do quadów",
      "Układ zawieszenia"
    ],
    "hierarchy": "(321230) Motoryzacja / Części i wyposażenie motocyklowe / Części do quadów / Układ zawieszenia / Łożyska kół",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Błotniki",
    "categoryPath": [
      "(147524) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(147524) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Błotniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dźwignie sprzęgła i hamulca",
    "categoryPath": [
      "(147491) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(147491) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Dźwignie sprzęgła i hamulca",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(316847) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316847) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Głośniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(147523) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(147523) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Kierownice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Końcówki i ciężarki kierownicy",
    "categoryPath": [
      "(260425) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(260425) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Końcówki i ciężarki kierownicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gazu",
    "categoryPath": [
      "(147485) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(147485) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Gazu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Hamulca",
    "categoryPath": [
      "(147487) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(147487) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Hamulca",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Obrotomierza",
    "categoryPath": [
      "(147489) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(147489) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Obrotomierza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147484) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(147484) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prędkościomierza",
    "categoryPath": [
      "(147488) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(147488) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Prędkościomierza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprzęgła",
    "categoryPath": [
      "(147486) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(147486) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ssania",
    "categoryPath": [
      "(147490) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(147490) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Ssania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zamki siedzenia",
    "categoryPath": [
      "(260427) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia",
      "Linki i cięgna"
    ],
    "hierarchy": "(260427) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Linki i cięgna / Zamki siedzenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lusterka",
    "categoryPath": [
      "(19008) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(19008) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Lusterka",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Manetki",
    "categoryPath": [
      "(19009) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(19009) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Manetki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mocowania i uchwyty",
    "categoryPath": [
      "(316832) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316832) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Mocowania i uchwyty",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakrętki",
    "categoryPath": [
      "(316835) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316835) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Nakrętki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakładki na bak",
    "categoryPath": [
      "(316850) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316850) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Nakładki na bak",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy liczników",
    "categoryPath": [
      "(260426) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(260426) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Obudowy liczników",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Okleiny",
    "categoryPath": [
      "(316844) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316844) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Okleiny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oparcia",
    "categoryPath": [
      "(316853) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316853) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Oparcia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony dłoni",
    "categoryPath": [
      "(257506) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(257506) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Osłony dłoni",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Osłony kierownicy",
    "categoryPath": [
      "(316856) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316856) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Osłony kierownicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Owiewki",
    "categoryPath": [
      "(19011) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(19011) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Owiewki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Plastiki",
    "categoryPath": [
      "(316841) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316841) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Plastiki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnóżki",
    "categoryPath": [
      "(19012) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(19012) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Podnóżki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podwyższenia kierownicy",
    "categoryPath": [
      "(257507) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(257507) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Podwyższenia kierownicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19007) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(19007) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Radia i anteny",
    "categoryPath": [
      "(316859) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316859) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Radia i anteny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ramy",
    "categoryPath": [
      "(19013) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(19013) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Ramy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Siedzenia",
    "categoryPath": [
      "(147522) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(147522) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Siedzenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stopki",
    "categoryPath": [
      "(147525) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(147525) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Stopki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szyby",
    "categoryPath": [
      "(19014) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(19014) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Szyby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tabliczki znamionowe",
    "categoryPath": [
      "(316829) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316829) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Tabliczki znamionowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Śruby",
    "categoryPath": [
      "(316838) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Elementy nadwozia"
    ],
    "hierarchy": "(316838) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Elementy nadwozia / Śruby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry oleju",
    "categoryPath": [
      "(19017) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Filtry"
    ],
    "hierarchy": "(19017) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Filtry / Filtry oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry paliwa",
    "categoryPath": [
      "(19018) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Filtry"
    ],
    "hierarchy": "(19018) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Filtry / Filtry paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Filtry powietrza",
    "categoryPath": [
      "(19019) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Filtry"
    ],
    "hierarchy": "(19019) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Filtry / Filtry powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Obudowy do filtrów",
    "categoryPath": [
      "(316862) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Filtry"
    ],
    "hierarchy": "(316862) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Filtry / Obudowy do filtrów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19016) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Filtry"
    ],
    "hierarchy": "(19016) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Filtry / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Halogeny",
    "categoryPath": [
      "(258532) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(258532) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Halogeny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierunkowskazy",
    "categoryPath": [
      "(19025) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(19025) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Kierunkowskazy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klosze",
    "categoryPath": [
      "(260428) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(260428) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Klosze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy tylne",
    "categoryPath": [
      "(19026) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(19026) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Lampy tylne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odblaski",
    "categoryPath": [
      "(316874) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(316874) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Odblaski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(316871) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(316871) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Osłony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podświetlenie tablicy",
    "categoryPath": [
      "(260429) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(260429) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Podświetlenie tablicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19024) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(19024) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przerywacze kierunkowskazów",
    "categoryPath": [
      "(316868) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(316868) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Przerywacze kierunkowskazów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Reflektory",
    "categoryPath": [
      "(19027) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(19027) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Reflektory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uchwyty reflektorów",
    "categoryPath": [
      "(260430) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(260430) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Uchwyty reflektorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Włączniki",
    "categoryPath": [
      "(316865) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(316865) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Włączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Żarówki",
    "categoryPath": [
      "(19028) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Oświetlenie"
    ],
    "hierarchy": "(19028) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Oświetlenie / Żarówki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4068) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe"
    ],
    "hierarchy": "(4068) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Głowice cylindra",
    "categoryPath": [
      "(260460) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Cylindry i komponenty"
    ],
    "hierarchy": "(260460) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Cylindry i komponenty / Głowice cylindra",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne cylindry",
    "categoryPath": [
      "(260459) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Cylindry i komponenty"
    ],
    "hierarchy": "(260459) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Cylindry i komponenty / Kompletne cylindry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pierścienie",
    "categoryPath": [
      "(260461) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Cylindry i komponenty"
    ],
    "hierarchy": "(260461) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Cylindry i komponenty / Pierścienie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260462) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Cylindry i komponenty"
    ],
    "hierarchy": "(260462) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Cylindry i komponenty / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(260432) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(260432) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Czujniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kartery",
    "categoryPath": [
      "(316883) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(316883) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Kartery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kopniaki, startery",
    "categoryPath": [
      "(316877) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(316877) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Kopniaki, startery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kosze sprzęgłowe",
    "categoryPath": [
      "(260433) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(260433) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Kosze sprzęgłowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pokrywy, osłony",
    "categoryPath": [
      "(256690) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(256690) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Pokrywy, osłony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19034) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(19034) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płytki zaworowe",
    "categoryPath": [
      "(316892) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(316892) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Płytki zaworowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(19038) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(19038) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Silniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skrzynie biegów",
    "categoryPath": [
      "(19037) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(19037) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Skrzynie biegów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprężyny",
    "categoryPath": [
      "(316889) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(316889) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Sprężyny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korbowody",
    "categoryPath": [
      "(260453) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Układ korbowo-tłokowy"
    ],
    "hierarchy": "(260453) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Układ korbowo-tłokowy / Korbowody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260458) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Układ korbowo-tłokowy"
    ],
    "hierarchy": "(260458) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Układ korbowo-tłokowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sworznie",
    "categoryPath": [
      "(260454) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Układ korbowo-tłokowy"
    ],
    "hierarchy": "(260454) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Układ korbowo-tłokowy / Sworznie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tłoki",
    "categoryPath": [
      "(260455) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Układ korbowo-tłokowy"
    ],
    "hierarchy": "(260455) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Układ korbowo-tłokowy / Tłoki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wały korbowe",
    "categoryPath": [
      "(260456) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Układ korbowo-tłokowy"
    ],
    "hierarchy": "(260456) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Układ korbowo-tłokowy / Wały korbowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska silnika",
    "categoryPath": [
      "(260457) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt",
      "Układ korbowo-tłokowy"
    ],
    "hierarchy": "(260457) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Układ korbowo-tłokowy / Łożyska silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(19040) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(19040) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(316886) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(316886) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łańcuchy i napinacze rozrządu",
    "categoryPath": [
      "(19036) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(19036) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Łańcuchy i napinacze rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągacze",
    "categoryPath": [
      "(316895) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(316895) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Silniki i osprzęt / Ściągacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodnice",
    "categoryPath": [
      "(260443) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260443) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Chłodnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(260444) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260444) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Czujniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(260445) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260445) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Korki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony chłodnicy",
    "categoryPath": [
      "(260446) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260446) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Osłony chłodnicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260450) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260450) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Termostaty",
    "categoryPath": [
      "(260447) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260447) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Termostaty",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(260448) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260448) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Wentylatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Węże i przewody",
    "categoryPath": [
      "(306417) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(306417) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Węże i przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(260449) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ chłodzenia"
    ],
    "hierarchy": "(260449) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ chłodzenia / Zbiorniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(19031) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(19031) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Akumulatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bezpieczniki",
    "categoryPath": [
      "(322081) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(322081) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Bezpieczniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cewki zapłonowe",
    "categoryPath": [
      "(256673) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256673) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Cewki zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(256675) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256675) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Czujniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Fajki zapłonowe",
    "categoryPath": [
      "(256677) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256677) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Fajki zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klaksony",
    "categoryPath": [
      "(260463) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(260463) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Klaksony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kondensatory",
    "categoryPath": [
      "(313201) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(313201) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Kondensatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Liczniki",
    "categoryPath": [
      "(260464) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(260464) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Liczniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły zapłonowe",
    "categoryPath": [
      "(19032) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(19032) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Moduły zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19030) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(19030) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przekaźniki",
    "categoryPath": [
      "(256678) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256678) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Przekaźniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przerywacze",
    "categoryPath": [
      "(256679) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256679) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Przerywacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody zapłonowe",
    "categoryPath": [
      "(322484) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(322484) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Przewody zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(256671) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256671) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Przełączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Regulatory napięcia",
    "categoryPath": [
      "(256672) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256672) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Regulatory napięcia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozruszniki",
    "categoryPath": [
      "(256674) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256674) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Rozruszniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sondy lambda",
    "categoryPath": [
      "(306045) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(306045) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Sondy lambda",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stacyjki",
    "categoryPath": [
      "(19033) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(19033) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Stacyjki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(260465) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(260465) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stojany",
    "categoryPath": [
      "(260466) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(260466) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Stojany",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wiązki elektryczne",
    "categoryPath": [
      "(256676) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(256676) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Wiązki elektryczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Świece",
    "categoryPath": [
      "(147542) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(147542) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ elektryczny, zapłon / Świece",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cięgna",
    "categoryPath": [
      "(316916) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(316916) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Cięgna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki stopu",
    "categoryPath": [
      "(260467) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(260467) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Czujniki stopu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klocki hamulcowe",
    "categoryPath": [
      "(19043) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(19043) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Klocki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(316919) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(316919) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Osłony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy hamulcowe",
    "categoryPath": [
      "(19044) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(19044) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Pompy hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19042) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(19042) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody hamulcowe",
    "categoryPath": [
      "(256692) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(256692) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Przewody hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozpieraki",
    "categoryPath": [
      "(316913) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(316913) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Rozpieraki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczęki",
    "categoryPath": [
      "(19045) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(19045) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Szczęki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tarcze hamulcowe",
    "categoryPath": [
      "(19046) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(19046) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Tarcze hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zaciski",
    "categoryPath": [
      "(19047) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(19047) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Zaciski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniczki płynu hamulcowego",
    "categoryPath": [
      "(316910) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(316910) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Zbiorniczki płynu hamulcowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(260468) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(260468) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ hamulcowy / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mocowania i śruby",
    "categoryPath": [
      "(316907) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(316907) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Mocowania i śruby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Napinacze i naciągi łańcucha",
    "categoryPath": [
      "(316904) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(316904) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Napinacze i naciągi łańcucha",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony zębatki",
    "categoryPath": [
      "(260470) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260470) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Osłony zębatki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony łańcucha",
    "categoryPath": [
      "(260469) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260469) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Osłony łańcucha",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Paski napędowe",
    "categoryPath": [
      "(19051) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(19051) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Paski napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19049) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(19049) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prowadnice łańcucha",
    "categoryPath": [
      "(316901) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(316901) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Prowadnice łańcucha",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rolki łańcucha",
    "categoryPath": [
      "(316898) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(316898) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Rolki łańcucha",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Sprzęgła",
    "categoryPath": [
      "(19050) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(19050) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wariatory",
    "categoryPath": [
      "(260471) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260471) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Wariatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wały kardana",
    "categoryPath": [
      "(260472) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260472) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Wały kardana",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy napędowe",
    "categoryPath": [
      "(260474) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260474) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Zestawy napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zębatki napędowe",
    "categoryPath": [
      "(260475) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260475) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Zębatki napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łańcuchy napędowe",
    "categoryPath": [
      "(260476) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260476) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ napędowy / Łańcuchy napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gaźniki",
    "categoryPath": [
      "(19055) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(19055) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Gaźniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki wlewu",
    "categoryPath": [
      "(19056) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(19056) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Korki wlewu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kraniki",
    "categoryPath": [
      "(147543) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(147543) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Kraniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Króćce",
    "categoryPath": [
      "(260477) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(260477) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Króćce",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony zbiornika paliwa",
    "categoryPath": [
      "(260478) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(260478) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Osłony zbiornika paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy paliwa",
    "categoryPath": [
      "(260479) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(260479) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Pompy paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19054) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(19054) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przepustnice",
    "categoryPath": [
      "(313213) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(313213) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Przepustnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(256693) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(256693) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Regulatory ciśnienia paliwa",
    "categoryPath": [
      "(313177) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(313177) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Regulatory ciśnienia paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Spinki, zaciski, opaski",
    "categoryPath": [
      "(316922) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(316922) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Spinki, zaciski, opaski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory membranowe",
    "categoryPath": [
      "(260480) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(260480) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Zawory membranowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki paliwa",
    "categoryPath": [
      "(19057) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(19057) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Zbiorniki paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(260481) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(260481) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ paliwowy / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kolektory wydechowe",
    "categoryPath": [
      "(256696) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(256696) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Kolektory wydechowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne układy",
    "categoryPath": [
      "(260482) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(260482) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Kompletne układy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Materiały izolacyjne",
    "categoryPath": [
      "(316928) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(316928) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Materiały izolacyjne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obejmy",
    "categoryPath": [
      "(316925) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(316925) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Obejmy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony tłumików",
    "categoryPath": [
      "(260483) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(260483) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Osłony tłumików",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256694) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(256694) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tłumiki",
    "categoryPath": [
      "(256695) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(256695) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Tłumiki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(256697) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(256697) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ wydechowy / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Amortyzatory",
    "categoryPath": [
      "(19060) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(19060) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Amortyzatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Amortyzatory skrętu",
    "categoryPath": [
      "(260484) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260484) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Amortyzatory skrętu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Osłony amortyzatora",
    "categoryPath": [
      "(260485) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260485) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Osłony amortyzatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ośki",
    "categoryPath": [
      "(260486) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260486) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Ośki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19059) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(19059) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półki zawieszenia",
    "categoryPath": [
      "(260487) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260487) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Półki zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuleje",
    "categoryPath": [
      "(316931) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(316931) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Tuleje",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelniacze",
    "categoryPath": [
      "(147544) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(147544) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Uszczelniacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wahacze",
    "categoryPath": [
      "(256701) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(256701) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Wahacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(260488) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260488) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska amortyzatora",
    "categoryPath": [
      "(260489) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260489) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Łożyska amortyzatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska główki ramy",
    "categoryPath": [
      "(256700) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(256700) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Łożyska główki ramy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska kół",
    "categoryPath": [
      "(19061) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(19061) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Układ zawieszenia / Łożyska kół",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(256655) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256655) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Elementy nadwozia",
    "categoryPath": [
      "(256656) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256656) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Elementy nadwozia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(256657) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256657) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Koła, felgi, opony",
    "categoryPath": [
      "(256658) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256658) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Koła, felgi, opony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(256659) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256659) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Oświetlenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256667) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256667) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Silniki i osprzęt",
    "categoryPath": [
      "(256660) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256660) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Silniki i osprzęt",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ elektryczny",
    "categoryPath": [
      "(256661) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256661) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Układ elektryczny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ hamulcowy",
    "categoryPath": [
      "(256662) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256662) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Układ hamulcowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ napędowy",
    "categoryPath": [
      "(256663) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256663) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Układ napędowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ paliwowy",
    "categoryPath": [
      "(256664) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256664) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Układ paliwowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ wydechowy",
    "categoryPath": [
      "(256665) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256665) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Układ wydechowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układ zawieszenia",
    "categoryPath": [
      "(256666) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Części motocyklowe",
      "Zabytkowe"
    ],
    "hierarchy": "(256666) Motoryzacja / Części i wyposażenie motocyklowe / Części motocyklowe / Zabytkowe / Układ zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blendy",
    "categoryPath": [
      "(315378) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(315378) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Blendy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Daszki do kasków",
    "categoryPath": [
      "(317249) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(317249) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Daszki do kasków",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Folie przeciwparujące",
    "categoryPath": [
      "(315384) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(315384) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Folie przeciwparujące",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(256717) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(256717) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Kaski",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ozdoby do kasków",
    "categoryPath": [
      "(316943) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(316943) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Ozdoby do kasków",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pokrowce do kasków",
    "categoryPath": [
      "(316940) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(316940) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Pokrowce do kasków",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szyby",
    "categoryPath": [
      "(315375) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(315375) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Szyby",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wloty wentylacyjne",
    "categoryPath": [
      "(316949) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(316949) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Wloty wentylacyjne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wyściółki do kasków",
    "categoryPath": [
      "(316934) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(316934) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Wyściółki do kasków",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Zapięcia",
    "categoryPath": [
      "(316937) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Kaski i dodatki"
    ],
    "hierarchy": "(316937) Motoryzacja / Części i wyposażenie motocyklowe / Kaski i dodatki / Zapięcia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chusty",
    "categoryPath": [
      "(19066) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(19066) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Chusty",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gogle",
    "categoryPath": [
      "(19068) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(19068) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Gogle",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(256718) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(256718) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Kamizelki",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koce",
    "categoryPath": [
      "(316973) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316973) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Koce",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kombinezony",
    "categoryPath": [
      "(4076) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(4076) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Kombinezony",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kominiarki",
    "categoryPath": [
      "(19069) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(19069) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Kominiarki",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Konserwacja odzieży",
    "categoryPath": [
      "(258527) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(258527) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Konserwacja odzieży",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koszulki i bluzy",
    "categoryPath": [
      "(19070) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(19070) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Koszulki i bluzy",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kołnierze",
    "categoryPath": [
      "(316958) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316958) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Kołnierze",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(4077) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(4077) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Kurtki",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Naszywki",
    "categoryPath": [
      "(316967) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316967) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Naszywki",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(4078) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(4078) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Obuwie",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(19074) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(19074) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Ochraniacze",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Ocieplacze",
    "categoryPath": [
      "(316970) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316970) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Ocieplacze",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Odblaski",
    "categoryPath": [
      "(316952) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316952) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odblaski",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odzież przeciwdeszczowa",
    "categoryPath": [
      "(317099) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(317099) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odzież przeciwdeszczowa",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(316985) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież",
      "Odzież termoaktywna"
    ],
    "hierarchy": "(316985) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odzież termoaktywna / Bluzy",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kominy",
    "categoryPath": [
      "(316994) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież",
      "Odzież termoaktywna"
    ],
    "hierarchy": "(316994) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odzież termoaktywna / Kominy",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(316979) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież",
      "Odzież termoaktywna"
    ],
    "hierarchy": "(316979) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odzież termoaktywna / Komplety",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(316988) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież",
      "Odzież termoaktywna"
    ],
    "hierarchy": "(316988) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odzież termoaktywna / Koszulki",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(316982) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież",
      "Odzież termoaktywna"
    ],
    "hierarchy": "(316982) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odzież termoaktywna / Rękawice",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(316991) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież",
      "Odzież termoaktywna"
    ],
    "hierarchy": "(316991) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Odzież termoaktywna / Spodnie",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Okulary",
    "categoryPath": [
      "(316955) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316955) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Okulary",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(316961) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316961) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Paski",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasy nerkowe",
    "categoryPath": [
      "(258525) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(258525) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Pasy nerkowe",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4074) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(4074) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(19073) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(19073) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Rękawice",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(256719) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(256719) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Skarpety",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Slidery",
    "categoryPath": [
      "(258526) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(258526) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Slidery",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(19072) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(19072) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Spodnie",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szelki",
    "categoryPath": [
      "(316964) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Odzież"
    ],
    "hierarchy": "(316964) Motoryzacja / Części i wyposażenie motocyklowe / Odzież / Szelki",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bagażniki",
    "categoryPath": [
      "(320950) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria do quadów"
    ],
    "hierarchy": "(320950) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria do quadów / Bagażniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kufry",
    "categoryPath": [
      "(256714) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria do quadów"
    ],
    "hierarchy": "(256714) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria do quadów / Kufry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(256713) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria do quadów"
    ],
    "hierarchy": "(256713) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria do quadów / Osłony",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(320953) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria do quadów"
    ],
    "hierarchy": "(320953) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria do quadów / Pokrowce",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256711) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria do quadów"
    ],
    "hierarchy": "(256711) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria do quadów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pługi",
    "categoryPath": [
      "(256716) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria do quadów"
    ],
    "hierarchy": "(256716) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria do quadów / Pługi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyciągarki",
    "categoryPath": [
      "(256712) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria do quadów"
    ],
    "hierarchy": "(256712) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria do quadów / Wyciągarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Alarmy",
    "categoryPath": [
      "(18999) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(18999) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Alarmy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bagażniki",
    "categoryPath": [
      "(147483) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(147483) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Bagażniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blokady",
    "categoryPath": [
      "(19000) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(19000) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Blokady",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Crash pady",
    "categoryPath": [
      "(256710) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256710) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Crash pady",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czyściki",
    "categoryPath": [
      "(317000) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(317000) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Czyściki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gadżety OE",
    "categoryPath": [
      "(321826) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(321826) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Gadżety OE",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Gmole",
    "categoryPath": [
      "(256704) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256704) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Gmole",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Gniazda zapalniczki",
    "categoryPath": [
      "(256707) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256707) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Gniazda zapalniczki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Interkomy",
    "categoryPath": [
      "(19001) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(19001) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Interkomy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kufry",
    "categoryPath": [
      "(19002) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(19002) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Kufry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lokalizatory",
    "categoryPath": [
      "(256775) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256775) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Lokalizatory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Naklejki",
    "categoryPath": [
      "(260451) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(260451) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Naklejki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nawigacje motocyklowe",
    "categoryPath": [
      "(258312) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(258312) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Nawigacje motocyklowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oparcia",
    "categoryPath": [
      "(256705) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256705) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Oparcia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony chłodnicy",
    "categoryPath": [
      "(256706) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256706) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Osłony chłodnicy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Plecaki",
    "categoryPath": [
      "(258528) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(258528) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Plecaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(19003) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(19003) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Pokrowce",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18998) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(18998) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ramki tablic",
    "categoryPath": [
      "(256715) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256715) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Ramki tablic",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sakwy i torby",
    "categoryPath": [
      "(19004) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(19004) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Sakwy i torby",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Saszetki",
    "categoryPath": [
      "(258530) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(258530) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Saszetki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Siatki bagażowe",
    "categoryPath": [
      "(19005) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(19005) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Siatki bagażowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stelaże",
    "categoryPath": [
      "(256709) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256709) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Stelaże",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stojaki, podnośniki",
    "categoryPath": [
      "(147482) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(147482) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Stojaki, podnośniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(316997) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(316997) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Szczotki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Torby na bak",
    "categoryPath": [
      "(258529) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(258529) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Torby na bak",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(256708) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(256708) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Uchwyty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyświetlacze biegów",
    "categoryPath": [
      "(317003) Motoryzacja",
      "Części i wyposażenie motocyklowe",
      "Wyposażenie i akcesoria motocyklowe"
    ],
    "hierarchy": "(317003) Motoryzacja / Części i wyposażenie motocyklowe / Wyposażenie i akcesoria motocyklowe / Wyświetlacze biegów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Atrapy chłodnicy",
    "categoryPath": [
      "(254664) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(254664) Motoryzacja / Części samochodowe / Części karoserii / Atrapy chłodnicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Belki",
    "categoryPath": [
      "(261281) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261281) Motoryzacja / Części samochodowe / Części karoserii / Belki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blachy",
    "categoryPath": [
      "(261282) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261282) Motoryzacja / Części samochodowe / Części karoserii / Blachy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Błotniki",
    "categoryPath": [
      "(254683) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Błotniki"
    ],
    "hierarchy": "(254683) Motoryzacja / Części samochodowe / Części karoserii / Błotniki / Błotniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Elementy mocujące",
    "categoryPath": [
      "(254684) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Błotniki"
    ],
    "hierarchy": "(254684) Motoryzacja / Części samochodowe / Części karoserii / Błotniki / Elementy mocujące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy, nakładki",
    "categoryPath": [
      "(254685) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Błotniki"
    ],
    "hierarchy": "(254685) Motoryzacja / Części samochodowe / Części karoserii / Błotniki / Listwy, nakładki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254688) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Błotniki"
    ],
    "hierarchy": "(254688) Motoryzacja / Części samochodowe / Części karoserii / Błotniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reperaturki",
    "categoryPath": [
      "(254686) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Błotniki"
    ],
    "hierarchy": "(254686) Motoryzacja / Części samochodowe / Części karoserii / Błotniki / Reperaturki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(261290) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Błotniki"
    ],
    "hierarchy": "(261290) Motoryzacja / Części samochodowe / Części karoserii / Błotniki / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wygłuszenie",
    "categoryPath": [
      "(254687) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Błotniki"
    ],
    "hierarchy": "(254687) Motoryzacja / Części samochodowe / Części karoserii / Błotniki / Wygłuszenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261283) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261283) Motoryzacja / Części samochodowe / Części karoserii / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dachy",
    "categoryPath": [
      "(254659) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Dachy"
    ],
    "hierarchy": "(254659) Motoryzacja / Części samochodowe / Części karoserii / Dachy / Dachy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy, zaślepki",
    "categoryPath": [
      "(254661) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Dachy"
    ],
    "hierarchy": "(254661) Motoryzacja / Części samochodowe / Części karoserii / Dachy / Listwy, zaślepki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254663) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Dachy"
    ],
    "hierarchy": "(254663) Motoryzacja / Części samochodowe / Części karoserii / Dachy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Relingi dachowe",
    "categoryPath": [
      "(254662) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Dachy"
    ],
    "hierarchy": "(254662) Motoryzacja / Części samochodowe / Części karoserii / Dachy / Relingi dachowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(261292) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Dachy"
    ],
    "hierarchy": "(261292) Motoryzacja / Części samochodowe / Części karoserii / Dachy / Silniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(261289) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Dachy"
    ],
    "hierarchy": "(261289) Motoryzacja / Części samochodowe / Części karoserii / Dachy / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cięgna",
    "categoryPath": [
      "(254599) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254599) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Cięgna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Drzwi",
    "categoryPath": [
      "(254580) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254580) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Drzwi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Elementy mocujące",
    "categoryPath": [
      "(254600) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254600) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Elementy mocujące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klamki zewnętrzne",
    "categoryPath": [
      "(254601) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254601) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Klamki zewnętrzne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy",
    "categoryPath": [
      "(254602) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254602) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Listwy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ograniczniki",
    "categoryPath": [
      "(254603) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254603) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Ograniczniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254581) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254581) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Reperaturki",
    "categoryPath": [
      "(254604) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254604) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Reperaturki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rygle",
    "categoryPath": [
      "(254605) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254605) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Rygle",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(254606) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254606) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wkładki zamka",
    "categoryPath": [
      "(254607) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254607) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Wkładki zamka",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wygłuszenie",
    "categoryPath": [
      "(254638) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254638) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Wygłuszenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wózki, prowadnice",
    "categoryPath": [
      "(254608) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254608) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Wózki, prowadnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zamki",
    "categoryPath": [
      "(254639) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254639) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Zamki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(254640) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Drzwi"
    ],
    "hierarchy": "(254640) Motoryzacja / Części samochodowe / Części karoserii / Drzwi / Zawiasy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kabiny",
    "categoryPath": [
      "(250542) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(250542) Motoryzacja / Części samochodowe / Części karoserii / Kabiny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cięgna",
    "categoryPath": [
      "(254643) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapki wlewu paliwa"
    ],
    "hierarchy": "(254643) Motoryzacja / Części samochodowe / Części karoserii / Klapki wlewu paliwa / Cięgna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klapki",
    "categoryPath": [
      "(254642) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapki wlewu paliwa"
    ],
    "hierarchy": "(254642) Motoryzacja / Części samochodowe / Części karoserii / Klapki wlewu paliwa / Klapki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254645) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapki wlewu paliwa"
    ],
    "hierarchy": "(254645) Motoryzacja / Części samochodowe / Części karoserii / Klapki wlewu paliwa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zamki i siłowniki",
    "categoryPath": [
      "(254644) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapki wlewu paliwa"
    ],
    "hierarchy": "(254644) Motoryzacja / Części samochodowe / Części karoserii / Klapki wlewu paliwa / Zamki i siłowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cięgna",
    "categoryPath": [
      "(254549) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254549) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Cięgna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Elementy mocujące",
    "categoryPath": [
      "(254550) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254550) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Elementy mocujące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Klamki",
    "categoryPath": [
      "(254551) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254551) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Klamki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klapy bagażnika",
    "categoryPath": [
      "(254548) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254548) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Klapy bagażnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254557) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254557) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rygle",
    "categoryPath": [
      "(254552) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254552) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Rygle",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki",
    "categoryPath": [
      "(261295) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(261295) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Silniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Siłowniki",
    "categoryPath": [
      "(254553) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254553) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Siłowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(254554) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254554) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zamki",
    "categoryPath": [
      "(254555) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254555) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Zamki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(254556) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Klapy bagażnika"
    ],
    "hierarchy": "(254556) Motoryzacja / Części samochodowe / Części karoserii / Klapy bagażnika / Zawiasy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy",
    "categoryPath": [
      "(261294) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261294) Motoryzacja / Części samochodowe / Części karoserii / Listwy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261296) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Lusterka zewnętrzne"
    ],
    "hierarchy": "(261296) Motoryzacja / Części samochodowe / Części karoserii / Lusterka zewnętrzne / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne",
    "categoryPath": [
      "(18711) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Lusterka zewnętrzne"
    ],
    "hierarchy": "(18711) Motoryzacja / Części samochodowe / Części karoserii / Lusterka zewnętrzne / Kompletne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(18712) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Lusterka zewnętrzne"
    ],
    "hierarchy": "(18712) Motoryzacja / Części samochodowe / Części karoserii / Lusterka zewnętrzne / Obudowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18710) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Lusterka zewnętrzne"
    ],
    "hierarchy": "(18710) Motoryzacja / Części samochodowe / Części karoserii / Lusterka zewnętrzne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wkłady",
    "categoryPath": [
      "(18713) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Lusterka zewnętrzne"
    ],
    "hierarchy": "(18713) Motoryzacja / Części samochodowe / Części karoserii / Lusterka zewnętrzne / Wkłady",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cięgna",
    "categoryPath": [
      "(254560) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254560) Motoryzacja / Części samochodowe / Części karoserii / Maski / Cięgna",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Elementy mocujące",
    "categoryPath": [
      "(254561) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254561) Motoryzacja / Części samochodowe / Części karoserii / Maski / Elementy mocujące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Maski",
    "categoryPath": [
      "(254559) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254559) Motoryzacja / Części samochodowe / Części karoserii / Maski / Maski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254566) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254566) Motoryzacja / Części samochodowe / Części karoserii / Maski / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Siłowniki",
    "categoryPath": [
      "(254562) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254562) Motoryzacja / Części samochodowe / Części karoserii / Maski / Siłowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(254563) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254563) Motoryzacja / Części samochodowe / Części karoserii / Maski / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wygłuszenie",
    "categoryPath": [
      "(254564) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254564) Motoryzacja / Części samochodowe / Części karoserii / Maski / Wygłuszenie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zamki",
    "categoryPath": [
      "(254565) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254565) Motoryzacja / Części samochodowe / Części karoserii / Maski / Zamki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(254578) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Maski"
    ],
    "hierarchy": "(254578) Motoryzacja / Części samochodowe / Części karoserii / Maski / Zawiasy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nadkola",
    "categoryPath": [
      "(18708) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(18708) Motoryzacja / Części samochodowe / Części karoserii / Nadkola",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony przeciwbłotne",
    "categoryPath": [
      "(261287) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261287) Motoryzacja / Części samochodowe / Części karoserii / Osłony przeciwbłotne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasy przednie",
    "categoryPath": [
      "(254518) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(254518) Motoryzacja / Części samochodowe / Części karoserii / Pasy przednie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasy tylne",
    "categoryPath": [
      "(254519) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(254519) Motoryzacja / Części samochodowe / Części karoserii / Pasy tylne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podszybia",
    "categoryPath": [
      "(249303) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(249303) Motoryzacja / Części samochodowe / Części karoserii / Podszybia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podłogi",
    "categoryPath": [
      "(261284) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261284) Motoryzacja / Części samochodowe / Części karoserii / Podłogi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4095) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(4095) Motoryzacja / Części samochodowe / Części karoserii / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Listwy progowe, nakładki",
    "categoryPath": [
      "(254522) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Progi"
    ],
    "hierarchy": "(254522) Motoryzacja / Części samochodowe / Części karoserii / Progi / Listwy progowe, nakładki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254524) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Progi"
    ],
    "hierarchy": "(254524) Motoryzacja / Części samochodowe / Części karoserii / Progi / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Progi",
    "categoryPath": [
      "(254521) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Progi"
    ],
    "hierarchy": "(254521) Motoryzacja / Części samochodowe / Części karoserii / Progi / Progi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Reperaturki",
    "categoryPath": [
      "(254523) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Progi"
    ],
    "hierarchy": "(254523) Motoryzacja / Części samochodowe / Części karoserii / Progi / Reperaturki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ramy",
    "categoryPath": [
      "(261285) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261285) Motoryzacja / Części samochodowe / Części karoserii / Ramy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Spoilery",
    "categoryPath": [
      "(254525) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(254525) Motoryzacja / Części samochodowe / Części karoserii / Spoilery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stopnie",
    "categoryPath": [
      "(261286) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261286) Motoryzacja / Części samochodowe / Części karoserii / Stopnie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Boczne (drzwi)",
    "categoryPath": [
      "(18720) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(18720) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Boczne (drzwi)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Elementy mocujące",
    "categoryPath": [
      "(254526) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(254526) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Elementy mocujące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Karoseryjne",
    "categoryPath": [
      "(146544) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(146544) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Karoseryjne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy",
    "categoryPath": [
      "(261297) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(261297) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Listwy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18716) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(18716) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przednie",
    "categoryPath": [
      "(18719) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(18719) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Przednie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szyberdachy",
    "categoryPath": [
      "(18718) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(18718) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Szyberdachy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tylne",
    "categoryPath": [
      "(18717) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(18717) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Tylne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki szyb",
    "categoryPath": [
      "(146543) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Szyby"
    ],
    "hierarchy": "(146543) Motoryzacja / Części samochodowe / Części karoserii / Szyby / Uszczelki szyb",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Słupki",
    "categoryPath": [
      "(261280) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261280) Motoryzacja / Części samochodowe / Części karoserii / Słupki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wsporniki, mocowania",
    "categoryPath": [
      "(261152) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261152) Motoryzacja / Części samochodowe / Części karoserii / Wsporniki, mocowania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zabudowy",
    "categoryPath": [
      "(250543) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(250543) Motoryzacja / Części samochodowe / Części karoserii / Zabudowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Absorbery",
    "categoryPath": [
      "(254700) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254700) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Absorbery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Atrapy, zaślepki",
    "categoryPath": [
      "(254701) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254701) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Atrapy, zaślepki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Elementy mocujące",
    "categoryPath": [
      "(254702) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254702) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Elementy mocujące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy",
    "categoryPath": [
      "(254703) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254703) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Listwy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254706) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254706) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spoilery",
    "categoryPath": [
      "(254704) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254704) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Spoilery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wzmocnienia zderzaków (belki)",
    "categoryPath": [
      "(254705) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254705) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Wzmocnienia zderzaków (belki)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zderzaki",
    "categoryPath": [
      "(254699) Motoryzacja",
      "Części samochodowe",
      "Części karoserii",
      "Zderzaki"
    ],
    "hierarchy": "(254699) Motoryzacja / Części samochodowe / Części karoserii / Zderzaki / Zderzaki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy części blacharskich",
    "categoryPath": [
      "(254718) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(254718) Motoryzacja / Części samochodowe / Części karoserii / Zestawy części blacharskich",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściany, panele",
    "categoryPath": [
      "(261288) Motoryzacja",
      "Części samochodowe",
      "Części karoserii"
    ],
    "hierarchy": "(261288) Motoryzacja / Części samochodowe / Części karoserii / Ściany, panele",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry hydrauliczne",
    "categoryPath": [
      "(260584) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(260584) Motoryzacja / Części samochodowe / Filtry / Filtry hydrauliczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry kabinowe",
    "categoryPath": [
      "(49237) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(49237) Motoryzacja / Części samochodowe / Filtry / Filtry kabinowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry odmy",
    "categoryPath": [
      "(256993) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(256993) Motoryzacja / Części samochodowe / Filtry / Filtry odmy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry oleju",
    "categoryPath": [
      "(49239) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(49239) Motoryzacja / Części samochodowe / Filtry / Filtry oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Filtry paliwa",
    "categoryPath": [
      "(49240) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(49240) Motoryzacja / Części samochodowe / Filtry / Filtry paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Filtry powietrza",
    "categoryPath": [
      "(49241) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(49241) Motoryzacja / Części samochodowe / Filtry / Filtry powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry skrzyni biegów",
    "categoryPath": [
      "(255961) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(255961) Motoryzacja / Części samochodowe / Filtry / Filtry skrzyni biegów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Inne filtry",
    "categoryPath": [
      "(250545) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(250545) Motoryzacja / Części samochodowe / Filtry / Inne filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy filtrów",
    "categoryPath": [
      "(49242) Motoryzacja",
      "Części samochodowe",
      "Filtry"
    ],
    "hierarchy": "(49242) Motoryzacja / Części samochodowe / Filtry / Zestawy filtrów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Agregaty chłodnicze",
    "categoryPath": [
      "(258672) Motoryzacja",
      "Części samochodowe",
      "Ogrzewanie postojowe i chłodnictwo samochodowe",
      "Chłodnictwo samochodowe"
    ],
    "hierarchy": "(258672) Motoryzacja / Części samochodowe / Ogrzewanie postojowe i chłodnictwo samochodowe / Chłodnictwo samochodowe / Agregaty chłodnicze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części i elementy montażowe",
    "categoryPath": [
      "(258674) Motoryzacja",
      "Części samochodowe",
      "Ogrzewanie postojowe i chłodnictwo samochodowe",
      "Chłodnictwo samochodowe"
    ],
    "hierarchy": "(258674) Motoryzacja / Części samochodowe / Ogrzewanie postojowe i chłodnictwo samochodowe / Chłodnictwo samochodowe / Części i elementy montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rejestratory temperatury",
    "categoryPath": [
      "(258673) Motoryzacja",
      "Części samochodowe",
      "Ogrzewanie postojowe i chłodnictwo samochodowe",
      "Chłodnictwo samochodowe"
    ],
    "hierarchy": "(258673) Motoryzacja / Części samochodowe / Ogrzewanie postojowe i chłodnictwo samochodowe / Chłodnictwo samochodowe / Rejestratory temperatury",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(258676) Motoryzacja",
      "Części samochodowe",
      "Ogrzewanie postojowe i chłodnictwo samochodowe",
      "Ogrzewanie postojowe"
    ],
    "hierarchy": "(258676) Motoryzacja / Części samochodowe / Ogrzewanie postojowe i chłodnictwo samochodowe / Ogrzewanie postojowe / Części",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne instalacje",
    "categoryPath": [
      "(258675) Motoryzacja",
      "Części samochodowe",
      "Ogrzewanie postojowe i chłodnictwo samochodowe",
      "Ogrzewanie postojowe"
    ],
    "hierarchy": "(258675) Motoryzacja / Części samochodowe / Ogrzewanie postojowe i chłodnictwo samochodowe / Ogrzewanie postojowe / Kompletne instalacje",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poziomowania",
    "categoryPath": [
      "(256999) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Czujniki"
    ],
    "hierarchy": "(256999) Motoryzacja / Części samochodowe / Oświetlenie / Czujniki / Poziomowania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256997) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Czujniki"
    ],
    "hierarchy": "(256997) Motoryzacja / Części samochodowe / Oświetlenie / Czujniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zmierzchu",
    "categoryPath": [
      "(256998) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Czujniki"
    ],
    "hierarchy": "(256998) Motoryzacja / Części samochodowe / Oświetlenie / Czujniki / Zmierzchu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Świateł cofania",
    "categoryPath": [
      "(320446) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Czujniki"
    ],
    "hierarchy": "(320446) Motoryzacja / Części samochodowe / Oświetlenie / Czujniki / Świateł cofania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Świateł stop",
    "categoryPath": [
      "(257000) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Czujniki"
    ],
    "hierarchy": "(257000) Motoryzacja / Części samochodowe / Oświetlenie / Czujniki / Świateł stop",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261075) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(261075) Motoryzacja / Części samochodowe / Oświetlenie / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gniazda żarówek",
    "categoryPath": [
      "(261086) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(261086) Motoryzacja / Części samochodowe / Oświetlenie / Gniazda żarówek",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierunkowskazy",
    "categoryPath": [
      "(4136) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(4136) Motoryzacja / Części samochodowe / Oświetlenie / Kierunkowskazy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampki tablicy rejestracyjnej",
    "categoryPath": [
      "(18800) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(18800) Motoryzacja / Części samochodowe / Oświetlenie / Lampki tablicy rejestracyjnej",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy obrysowe",
    "categoryPath": [
      "(18798) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(18798) Motoryzacja / Części samochodowe / Oświetlenie / Lampy obrysowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy ostrzegawcze, koguty",
    "categoryPath": [
      "(49255) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(49255) Motoryzacja / Części samochodowe / Oświetlenie / Lampy ostrzegawcze, koguty",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy dalekosiężne",
    "categoryPath": [
      "(255101) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy przednie i elementy"
    ],
    "hierarchy": "(255101) Motoryzacja / Części samochodowe / Oświetlenie / Lampy przednie i elementy / Lampy dalekosiężne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy przeciwmgielne",
    "categoryPath": [
      "(255100) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy przednie i elementy"
    ],
    "hierarchy": "(255100) Motoryzacja / Części samochodowe / Oświetlenie / Lampy przednie i elementy / Lampy przeciwmgielne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy przednie",
    "categoryPath": [
      "(255099) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy przednie i elementy"
    ],
    "hierarchy": "(255099) Motoryzacja / Części samochodowe / Oświetlenie / Lampy przednie i elementy / Lampy przednie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255105) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy przednie i elementy"
    ],
    "hierarchy": "(255105) Motoryzacja / Części samochodowe / Oświetlenie / Lampy przednie i elementy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przetwornice",
    "categoryPath": [
      "(255103) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy przednie i elementy"
    ],
    "hierarchy": "(255103) Motoryzacja / Części samochodowe / Oświetlenie / Lampy przednie i elementy / Przetwornice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniczki regulacji",
    "categoryPath": [
      "(255104) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy przednie i elementy"
    ],
    "hierarchy": "(255104) Motoryzacja / Części samochodowe / Oświetlenie / Lampy przednie i elementy / Silniczki regulacji",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Światła do jazdy dziennej DRL",
    "categoryPath": [
      "(255102) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy przednie i elementy"
    ],
    "hierarchy": "(255102) Motoryzacja / Części samochodowe / Oświetlenie / Lampy przednie i elementy / Światła do jazdy dziennej DRL",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy robocze",
    "categoryPath": [
      "(255138) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(255138) Motoryzacja / Części samochodowe / Oświetlenie / Lampy robocze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy cofania",
    "categoryPath": [
      "(255120) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy tylne i elementy"
    ],
    "hierarchy": "(255120) Motoryzacja / Części samochodowe / Oświetlenie / Lampy tylne i elementy / Lampy cofania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Lampy przeciwmgielne",
    "categoryPath": [
      "(255121) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy tylne i elementy"
    ],
    "hierarchy": "(255121) Motoryzacja / Części samochodowe / Oświetlenie / Lampy tylne i elementy / Lampy przeciwmgielne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy tylne",
    "categoryPath": [
      "(255119) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy tylne i elementy"
    ],
    "hierarchy": "(255119) Motoryzacja / Części samochodowe / Oświetlenie / Lampy tylne i elementy / Lampy tylne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255123) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy tylne i elementy"
    ],
    "hierarchy": "(255123) Motoryzacja / Części samochodowe / Oświetlenie / Lampy tylne i elementy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Światła stop",
    "categoryPath": [
      "(255122) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie",
      "Lampy tylne i elementy"
    ],
    "hierarchy": "(255122) Motoryzacja / Części samochodowe / Oświetlenie / Lampy tylne i elementy / Światła stop",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odblaski",
    "categoryPath": [
      "(255139) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(255139) Motoryzacja / Części samochodowe / Oświetlenie / Odblaski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4135) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(4135) Motoryzacja / Części samochodowe / Oświetlenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sterowniki świateł",
    "categoryPath": [
      "(256287) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(256287) Motoryzacja / Części samochodowe / Oświetlenie / Sterowniki świateł",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(261078) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(261078) Motoryzacja / Części samochodowe / Oświetlenie / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wsporniki, mocowania, obudowy",
    "categoryPath": [
      "(261076) Motoryzacja",
      "Części samochodowe",
      "Oświetlenie"
    ],
    "hierarchy": "(261076) Motoryzacja / Części samochodowe / Oświetlenie / Wsporniki, mocowania, obudowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(629) Motoryzacja",
      "Części samochodowe"
    ],
    "hierarchy": "(629) Motoryzacja / Części samochodowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Bloki",
    "categoryPath": [
      "(50825) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(50825) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Bloki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki położenia wału korbowego",
    "categoryPath": [
      "(256143) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(256143) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Czujniki położenia wału korbowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korbowody",
    "categoryPath": [
      "(255440) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(255440) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Korbowody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odma",
    "categoryPath": [
      "(255441) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(255441) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Odma",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Panewki",
    "categoryPath": [
      "(50828) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(50828) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Panewki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pierścienie tłokowe",
    "categoryPath": [
      "(50829) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(50829) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Pierścienie tłokowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50824) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(50824) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tuleje cylindra",
    "categoryPath": [
      "(261131) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(261131) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Tuleje cylindra",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Tłoki",
    "categoryPath": [
      "(50830) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(50830) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Tłoki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelniacze wału",
    "categoryPath": [
      "(255442) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(255442) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Uszczelniacze wału",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wały korbowe",
    "categoryPath": [
      "(50831) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(50831) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Wały korbowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(261150) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Blok silnika"
    ],
    "hierarchy": "(261150) Motoryzacja / Części samochodowe / Silniki i osprzęt / Blok silnika / Łożyska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki ciśnienia w kolektorze (MAP)",
    "categoryPath": [
      "(256158) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(256158) Motoryzacja / Części samochodowe / Silniki i osprzęt / Czujniki ciśnienia w kolektorze (MAP)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki spalania stukowego",
    "categoryPath": [
      "(256141) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(256141) Motoryzacja / Części samochodowe / Silniki i osprzęt / Czujniki spalania stukowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła pasowe",
    "categoryPath": [
      "(255443) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Elementy napędu paska osprzętu"
    ],
    "hierarchy": "(255443) Motoryzacja / Części samochodowe / Silniki i osprzęt / Elementy napędu paska osprzętu / Koła pasowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Napinacze paska klinowego",
    "categoryPath": [
      "(50834) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Elementy napędu paska osprzętu"
    ],
    "hierarchy": "(50834) Motoryzacja / Części samochodowe / Silniki i osprzęt / Elementy napędu paska osprzętu / Napinacze paska klinowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Paski klinowe",
    "categoryPath": [
      "(50835) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Elementy napędu paska osprzętu"
    ],
    "hierarchy": "(50835) Motoryzacja / Części samochodowe / Silniki i osprzęt / Elementy napędu paska osprzętu / Paski klinowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50833) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Elementy napędu paska osprzętu"
    ],
    "hierarchy": "(50833) Motoryzacja / Części samochodowe / Silniki i osprzęt / Elementy napędu paska osprzętu / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rolki paska klinowego",
    "categoryPath": [
      "(255444) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Elementy napędu paska osprzętu"
    ],
    "hierarchy": "(255444) Motoryzacja / Części samochodowe / Silniki i osprzęt / Elementy napędu paska osprzętu / Rolki paska klinowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(261132) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Elementy napędu paska osprzętu"
    ],
    "hierarchy": "(261132) Motoryzacja / Części samochodowe / Silniki i osprzęt / Elementy napędu paska osprzętu / Zestawy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dźwigienki",
    "categoryPath": [
      "(255445) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255445) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Dźwigienki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Głowice",
    "categoryPath": [
      "(50838) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(50838) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Głowice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pokrywy zaworów",
    "categoryPath": [
      "(50839) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(50839) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Pokrywy zaworów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Popychacze",
    "categoryPath": [
      "(255446) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255446) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Popychacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50837) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(50837) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prowadnice",
    "categoryPath": [
      "(255447) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255447) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Prowadnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprężyny zaworów",
    "categoryPath": [
      "(261133) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(261133) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Sprężyny zaworów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki głowicy",
    "categoryPath": [
      "(50840) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(50840) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Uszczelki głowicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki kolektorów",
    "categoryPath": [
      "(255629) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255629) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Uszczelki kolektorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki pokrywy zaworów",
    "categoryPath": [
      "(255448) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255448) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Uszczelki pokrywy zaworów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelniacze zaworów",
    "categoryPath": [
      "(255449) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255449) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Uszczelniacze zaworów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(255450) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255450) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy uszczelek",
    "categoryPath": [
      "(261148) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(261148) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Zestawy uszczelek",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Śruby głowicy",
    "categoryPath": [
      "(255451) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Głowice cylindrów"
    ],
    "hierarchy": "(255451) Motoryzacja / Części samochodowe / Silniki i osprzęt / Głowice cylindrów / Śruby głowicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kolektory ssące",
    "categoryPath": [
      "(50841) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(50841) Motoryzacja / Części samochodowe / Silniki i osprzęt / Kolektory ssące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki gazu",
    "categoryPath": [
      "(255517) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(255517) Motoryzacja / Części samochodowe / Silniki i osprzęt / Linki gazu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy filtrów powietrza",
    "categoryPath": [
      "(256227) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(256227) Motoryzacja / Części samochodowe / Silniki i osprzęt / Obudowy filtrów powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261134) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Osłony silnika"
    ],
    "hierarchy": "(261134) Motoryzacja / Części samochodowe / Silniki i osprzęt / Osłony silnika / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dolne",
    "categoryPath": [
      "(256224) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Osłony silnika"
    ],
    "hierarchy": "(256224) Motoryzacja / Części samochodowe / Silniki i osprzęt / Osłony silnika / Dolne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Górne",
    "categoryPath": [
      "(256223) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Osłony silnika"
    ],
    "hierarchy": "(256223) Motoryzacja / Części samochodowe / Silniki i osprzęt / Osłony silnika / Górne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pompy podciśnieniowe",
    "categoryPath": [
      "(255519) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(255519) Motoryzacja / Części samochodowe / Silniki i osprzęt / Pompy podciśnieniowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50822) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(50822) Motoryzacja / Części samochodowe / Silniki i osprzęt / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przepustnice",
    "categoryPath": [
      "(255520) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(255520) Motoryzacja / Części samochodowe / Silniki i osprzęt / Przepustnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przepływomierze",
    "categoryPath": [
      "(256142) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(256142) Motoryzacja / Części samochodowe / Silniki i osprzęt / Przepływomierze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody powietrza",
    "categoryPath": [
      "(255521) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(255521) Motoryzacja / Części samochodowe / Silniki i osprzęt / Przewody powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodnice spalin",
    "categoryPath": [
      "(255457) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Recyrkulacja spalin EGR"
    ],
    "hierarchy": "(255457) Motoryzacja / Części samochodowe / Silniki i osprzęt / Recyrkulacja spalin EGR / Chłodnice spalin",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy powietrza wtórnego",
    "categoryPath": [
      "(255458) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Recyrkulacja spalin EGR"
    ],
    "hierarchy": "(255458) Motoryzacja / Części samochodowe / Silniki i osprzęt / Recyrkulacja spalin EGR / Pompy powietrza wtórnego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255459) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Recyrkulacja spalin EGR"
    ],
    "hierarchy": "(255459) Motoryzacja / Części samochodowe / Silniki i osprzęt / Recyrkulacja spalin EGR / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody EGR",
    "categoryPath": [
      "(261135) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Recyrkulacja spalin EGR"
    ],
    "hierarchy": "(261135) Motoryzacja / Części samochodowe / Silniki i osprzęt / Recyrkulacja spalin EGR / Przewody EGR",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(261093) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Recyrkulacja spalin EGR"
    ],
    "hierarchy": "(261093) Motoryzacja / Części samochodowe / Silniki i osprzęt / Recyrkulacja spalin EGR / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory EGR",
    "categoryPath": [
      "(255456) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Recyrkulacja spalin EGR"
    ],
    "hierarchy": "(255456) Motoryzacja / Części samochodowe / Silniki i osprzęt / Recyrkulacja spalin EGR / Zawory EGR",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki położenia wałka rozrządu",
    "categoryPath": [
      "(256144) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(256144) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Czujniki położenia wałka rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261136) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(261136) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne rozrządy",
    "categoryPath": [
      "(50844) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(50844) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Kompletne rozrządy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Koła zębate",
    "categoryPath": [
      "(255477) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(255477) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Koła zębate",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Napinacze paska rozrządu",
    "categoryPath": [
      "(50845) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(50845) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Napinacze paska rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Napinacze łańcucha",
    "categoryPath": [
      "(255479) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(255479) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Napinacze łańcucha",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(50847) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(50847) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Obudowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Paski rozrządu",
    "categoryPath": [
      "(50846) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(50846) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Paski rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50843) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(50843) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prowadnice łańcuchów",
    "categoryPath": [
      "(255480) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(255480) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Prowadnice łańcuchów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rolki paska rozrządu",
    "categoryPath": [
      "(255481) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(255481) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Rolki paska rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(261129) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(261129) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wałki rozrządu",
    "categoryPath": [
      "(50848) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(50848) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Wałki rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(261137) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(261137) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łańcuchy rozrządu",
    "categoryPath": [
      "(255478) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(255478) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Łańcuchy rozrządu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(261149) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Rozrząd"
    ],
    "hierarchy": "(261149) Motoryzacja / Części samochodowe / Silniki i osprzęt / Rozrząd / Łożyska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki kompletne",
    "categoryPath": [
      "(312565) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(312565) Motoryzacja / Części samochodowe / Silniki i osprzęt / Silniki kompletne",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Silniki krokowe",
    "categoryPath": [
      "(50862) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(50862) Motoryzacja / Części samochodowe / Silniki i osprzęt / Silniki krokowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bagnety",
    "categoryPath": [
      "(147923) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(147923) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Bagnety",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki ciśnienia oleju",
    "categoryPath": [
      "(50854) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(50854) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Czujniki ciśnienia oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki poziomu oleju",
    "categoryPath": [
      "(259309) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(259309) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Czujniki poziomu oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki temperatury oleju",
    "categoryPath": [
      "(256159) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(256159) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Czujniki temperatury oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Części napędu",
    "categoryPath": [
      "(261130) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(261130) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Części napędu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Dysze olejowe",
    "categoryPath": [
      "(261138) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(261138) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Dysze olejowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki spustu oleju",
    "categoryPath": [
      "(255506) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(255506) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Korki spustu oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki wlewu oleju",
    "categoryPath": [
      "(147924) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(147924) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Korki wlewu oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Miski olejowe",
    "categoryPath": [
      "(50855) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(50855) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Miski olejowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy filtrów oleju",
    "categoryPath": [
      "(255507) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(255507) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Obudowy filtrów oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy oleju",
    "categoryPath": [
      "(147922) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(147922) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Pompy oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50853) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(50853) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody oleju",
    "categoryPath": [
      "(255508) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(255508) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Przewody oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Smoki (ssaki oleju)",
    "categoryPath": [
      "(261139) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(261139) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Smoki (ssaki oleju)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(261140) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(261140) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki miski",
    "categoryPath": [
      "(50856) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(50856) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Uszczelki miski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wlewy oleju",
    "categoryPath": [
      "(261142) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Smarowanie silnika"
    ],
    "hierarchy": "(261142) Motoryzacja / Części samochodowe / Silniki i osprzęt / Smarowanie silnika / Wlewy oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki ciśnienia",
    "categoryPath": [
      "(256160) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(256160) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Czujniki ciśnienia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260943) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(260943) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne turbosprężarki",
    "categoryPath": [
      "(255509) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(255509) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Kompletne turbosprężarki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255515) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(255515) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody powietrza turbosprężarki",
    "categoryPath": [
      "(255511) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(255511) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Przewody powietrza turbosprężarki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Smarowanie",
    "categoryPath": [
      "(260944) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(260944) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Smarowanie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(255512) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(255512) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(255513) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(255513) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(255514) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(255514) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(261141) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Turbosprężarki"
    ],
    "hierarchy": "(261141) Motoryzacja / Części samochodowe / Silniki i osprzęt / Turbosprężarki / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poduszki silnika",
    "categoryPath": [
      "(50860) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Zawieszenie silnika"
    ],
    "hierarchy": "(50860) Motoryzacja / Części samochodowe / Silniki i osprzęt / Zawieszenie silnika / Poduszki silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50859) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Zawieszenie silnika"
    ],
    "hierarchy": "(50859) Motoryzacja / Części samochodowe / Silniki i osprzęt / Zawieszenie silnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wsporniki i łapy",
    "categoryPath": [
      "(50861) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Zawieszenie silnika"
    ],
    "hierarchy": "(50861) Motoryzacja / Części samochodowe / Silniki i osprzęt / Zawieszenie silnika / Wsporniki i łapy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wózki i belki silnika",
    "categoryPath": [
      "(255516) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt",
      "Zawieszenie silnika"
    ],
    "hierarchy": "(255516) Motoryzacja / Części samochodowe / Silniki i osprzęt / Zawieszenie silnika / Wózki i belki silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory podciśnienia",
    "categoryPath": [
      "(256205) Motoryzacja",
      "Części samochodowe",
      "Silniki i osprzęt"
    ],
    "hierarchy": "(256205) Motoryzacja / Części samochodowe / Silniki i osprzęt / Zawory podciśnienia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Adaptery tuningowe",
    "categoryPath": [
      "(322225) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny"
    ],
    "hierarchy": "(322225) Motoryzacja / Części samochodowe / Tuning mechaniczny / Adaptery tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sportowe filtry powietrza",
    "categoryPath": [
      "(255616) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Filtry i obudowy"
    ],
    "hierarchy": "(255616) Motoryzacja / Części samochodowe / Tuning mechaniczny / Filtry i obudowy / Sportowe filtry powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuningowe filtry odmy",
    "categoryPath": [
      "(322216) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Filtry i obudowy"
    ],
    "hierarchy": "(322216) Motoryzacja / Części samochodowe / Tuning mechaniczny / Filtry i obudowy / Tuningowe filtry odmy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuningowe filtry paliwa",
    "categoryPath": [
      "(322215) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Filtry i obudowy"
    ],
    "hierarchy": "(322215) Motoryzacja / Części samochodowe / Tuning mechaniczny / Filtry i obudowy / Tuningowe filtry paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuningowe obudowy filtrów",
    "categoryPath": [
      "(322217) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Filtry i obudowy"
    ],
    "hierarchy": "(322217) Motoryzacja / Części samochodowe / Tuning mechaniczny / Filtry i obudowy / Tuningowe obudowy filtrów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chiptuning",
    "categoryPath": [
      "(255617) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Podzespoły elektroniczne"
    ],
    "hierarchy": "(255617) Motoryzacja / Części samochodowe / Tuning mechaniczny / Podzespoły elektroniczne / Chiptuning",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Komputery i moduły tuningowe",
    "categoryPath": [
      "(322222) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Podzespoły elektroniczne"
    ],
    "hierarchy": "(322222) Motoryzacja / Części samochodowe / Tuning mechaniczny / Podzespoły elektroniczne / Komputery i moduły tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody, wiązki, wtyczki",
    "categoryPath": [
      "(322221) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Podzespoły elektroniczne"
    ],
    "hierarchy": "(322221) Motoryzacja / Części samochodowe / Tuning mechaniczny / Podzespoły elektroniczne / Przewody, wiązki, wtyczki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Turbo Timer",
    "categoryPath": [
      "(322220) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Podzespoły elektroniczne"
    ],
    "hierarchy": "(322220) Motoryzacja / Części samochodowe / Tuning mechaniczny / Podzespoły elektroniczne / Turbo Timer",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyświetlacze i wskaźniki tuningowe",
    "categoryPath": [
      "(322223) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Podzespoły elektroniczne"
    ],
    "hierarchy": "(322223) Motoryzacja / Części samochodowe / Tuning mechaniczny / Podzespoły elektroniczne / Wyświetlacze i wskaźniki tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253797) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny"
    ],
    "hierarchy": "(253797) Motoryzacja / Części samochodowe / Tuning mechaniczny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Intercoolery tuningowe",
    "categoryPath": [
      "(255618) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(255618) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Intercoolery tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kolektory ssące tuningowe",
    "categoryPath": [
      "(322196) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322196) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Kolektory ssące tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korbowody kute",
    "categoryPath": [
      "(322200) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322200) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Korbowody kute",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oil Catch",
    "categoryPath": [
      "(322198) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322198) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Oil Catch",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255619) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(255619) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przepustnice tuningowe",
    "categoryPath": [
      "(322202) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322202) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Przepustnice tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody powietrza tuningowe",
    "categoryPath": [
      "(255615) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(255615) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Przewody powietrza tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozrząd i części tuningowe",
    "categoryPath": [
      "(322199) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322199) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Rozrząd i części tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuningowe zawieszenie silnika",
    "categoryPath": [
      "(322203) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322203) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Tuningowe zawieszenie silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Turbosprężarki tuningowe",
    "categoryPath": [
      "(322197) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322197) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Turbosprężarki tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Układy dolotowe tuningowe",
    "categoryPath": [
      "(322205) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322205) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Układy dolotowe tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory tuningowe",
    "categoryPath": [
      "(322204) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322204) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Zawory tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łączniki i oploty przewodów tuningowych",
    "categoryPath": [
      "(322201) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Silnik i osprzęt"
    ],
    "hierarchy": "(322201) Motoryzacja / Części samochodowe / Tuning mechaniczny / Silnik i osprzęt / Łączniki i oploty przewodów tuningowych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(322209) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ hamulcowy"
    ],
    "hierarchy": "(322209) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ hamulcowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sportowe klocki hamulcowe",
    "categoryPath": [
      "(322207) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ hamulcowy"
    ],
    "hierarchy": "(322207) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ hamulcowy / Sportowe klocki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sportowe tarcze hamulcowe",
    "categoryPath": [
      "(322208) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ hamulcowy"
    ],
    "hierarchy": "(322208) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ hamulcowy / Sportowe tarcze hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Downpipe",
    "categoryPath": [
      "(322212) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ wydechowy"
    ],
    "hierarchy": "(322212) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ wydechowy / Downpipe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255623) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ wydechowy"
    ],
    "hierarchy": "(255623) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ wydechowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sportowe kolektory wydechowe",
    "categoryPath": [
      "(322211) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ wydechowy"
    ],
    "hierarchy": "(322211) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ wydechowy / Sportowe kolektory wydechowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sportowe przepustnice wydechu",
    "categoryPath": [
      "(322210) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ wydechowy"
    ],
    "hierarchy": "(322210) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ wydechowy / Sportowe przepustnice wydechu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Strumienice sportowe",
    "categoryPath": [
      "(255622) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ wydechowy"
    ],
    "hierarchy": "(255622) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ wydechowy / Strumienice sportowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuningowe osłony termoizolacyjne",
    "categoryPath": [
      "(322213) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ wydechowy"
    ],
    "hierarchy": "(322213) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ wydechowy / Tuningowe osłony termoizolacyjne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tłumiki sportowe",
    "categoryPath": [
      "(255621) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ wydechowy"
    ],
    "hierarchy": "(255621) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ wydechowy / Tłumiki sportowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Amortyzatory sportowe",
    "categoryPath": [
      "(255626) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(255626) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Amortyzatory sportowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony i odboje tuningowe",
    "categoryPath": [
      "(322227) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322227) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Osłony i odboje tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255628) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(255628) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płyty Camber",
    "categoryPath": [
      "(322234) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322234) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Płyty Camber",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ramy stabilizatora",
    "categoryPath": [
      "(322231) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322231) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Ramy stabilizatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozpórki",
    "categoryPath": [
      "(322233) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322233) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Rozpórki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprężyny sportowe",
    "categoryPath": [
      "(255625) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(255625) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Sprężyny sportowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stabilizatory tuningowe",
    "categoryPath": [
      "(322232) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322232) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Stabilizatory tuningowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuleje sportowe",
    "categoryPath": [
      "(322235) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322235) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Tuleje sportowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuningowe łączniki stabilizatora",
    "categoryPath": [
      "(322230) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322230) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Tuningowe łączniki stabilizatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wahacze sportowe",
    "categoryPath": [
      "(322228) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322228) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Wahacze sportowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawieszenie gwintowane",
    "categoryPath": [
      "(322226) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(322226) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Zawieszenie gwintowane",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy zawieszenia sportowego",
    "categoryPath": [
      "(255627) Motoryzacja",
      "Części samochodowe",
      "Tuning mechaniczny",
      "Układ zawieszenia"
    ],
    "hierarchy": "(255627) Motoryzacja / Części samochodowe / Tuning mechaniczny / Układ zawieszenia / Zestawy zawieszenia sportowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodnice oleju",
    "categoryPath": [
      "(251083) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Chłodnice"
    ],
    "hierarchy": "(251083) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Chłodnice / Chłodnice oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Chłodnice powietrza (intercoolery)",
    "categoryPath": [
      "(251084) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Chłodnice"
    ],
    "hierarchy": "(251084) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Chłodnice / Chłodnice powietrza (intercoolery)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Chłodnice wody",
    "categoryPath": [
      "(251082) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Chłodnice"
    ],
    "hierarchy": "(251082) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Chłodnice / Chłodnice wody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260783) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Chłodnice"
    ],
    "hierarchy": "(260783) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Chłodnice / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki chłodnic",
    "categoryPath": [
      "(251085) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Chłodnice"
    ],
    "hierarchy": "(251085) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Chłodnice / Korki chłodnic",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki poziomu płynu",
    "categoryPath": [
      "(260784) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(260784) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Czujniki poziomu płynu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki temperatury płynu",
    "categoryPath": [
      "(256137) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(256137) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Czujniki temperatury płynu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierownice powietrza",
    "categoryPath": [
      "(252810) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(252810) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Kierownice powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki zbiorników wyrównawczych",
    "categoryPath": [
      "(251125) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(251125) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Korki zbiorników wyrównawczych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Króćce głowicy",
    "categoryPath": [
      "(251126) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(251126) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Króćce głowicy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260785) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Pompy wody"
    ],
    "hierarchy": "(260785) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Pompy wody / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła pasowe pomp wody",
    "categoryPath": [
      "(251087) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Pompy wody"
    ],
    "hierarchy": "(251087) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Pompy wody / Koła pasowe pomp wody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy wody",
    "categoryPath": [
      "(251086) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Pompy wody"
    ],
    "hierarchy": "(251086) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Pompy wody / Pompy wody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18698) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(18698) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody chłodnic oleju",
    "categoryPath": [
      "(251122) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Przewody układów chłodzenia"
    ],
    "hierarchy": "(251122) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Przewody układów chłodzenia / Przewody chłodnic oleju",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody chłodnic powietrza",
    "categoryPath": [
      "(256242) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Przewody układów chłodzenia"
    ],
    "hierarchy": "(256242) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Przewody układów chłodzenia / Przewody chłodnic powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Przewody chłodnic wody",
    "categoryPath": [
      "(251124) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Przewody układów chłodzenia"
    ],
    "hierarchy": "(251124) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Przewody układów chłodzenia / Przewody chłodnic wody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy termostatów",
    "categoryPath": [
      "(251103) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Termostaty"
    ],
    "hierarchy": "(251103) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Termostaty / Obudowy termostatów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Termostaty",
    "categoryPath": [
      "(251102) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Termostaty"
    ],
    "hierarchy": "(251102) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Termostaty / Termostaty",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(260786) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Termostaty"
    ],
    "hierarchy": "(260786) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Termostaty / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(251127) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(251127) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260787) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Wentylatory chłodnicy"
    ],
    "hierarchy": "(260787) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Wentylatory chłodnicy / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy wentylatorów",
    "categoryPath": [
      "(251105) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Wentylatory chłodnicy"
    ],
    "hierarchy": "(251105) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Wentylatory chłodnicy / Obudowy wentylatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki i łożyska wentylatorów",
    "categoryPath": [
      "(251106) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Wentylatory chłodnicy"
    ],
    "hierarchy": "(251106) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Wentylatory chłodnicy / Silniki i łożyska wentylatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprzęgła wiskotyczne",
    "categoryPath": [
      "(251107) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Wentylatory chłodnicy"
    ],
    "hierarchy": "(251107) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Wentylatory chłodnicy / Sprzęgła wiskotyczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(251104) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Wentylatory chłodnicy"
    ],
    "hierarchy": "(251104) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Wentylatory chłodnicy / Wentylatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wiatraki wentylatorów",
    "categoryPath": [
      "(251108) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Wentylatory chłodnicy"
    ],
    "hierarchy": "(251108) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Wentylatory chłodnicy / Wiatraki wentylatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Włączniki, sterowniki",
    "categoryPath": [
      "(251109) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika",
      "Wentylatory chłodnicy"
    ],
    "hierarchy": "(251109) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Wentylatory chłodnicy / Włączniki, sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki wyrównawcze",
    "categoryPath": [
      "(18697) Motoryzacja",
      "Części samochodowe",
      "Układ chłodzenia silnika"
    ],
    "hierarchy": "(18697) Motoryzacja / Części samochodowe / Układ chłodzenia silnika / Zbiorniki wyrównawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(4142) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(4142) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Akumulatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(255608) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Centralne zamki"
    ],
    "hierarchy": "(255608) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Centralne zamki / Pompy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18821) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Centralne zamki"
    ],
    "hierarchy": "(18821) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Centralne zamki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Siłowniki",
    "categoryPath": [
      "(18823) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Centralne zamki"
    ],
    "hierarchy": "(18823) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Centralne zamki / Siłowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(18824) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Centralne zamki"
    ],
    "hierarchy": "(18824) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Centralne zamki / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(18822) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Centralne zamki"
    ],
    "hierarchy": "(18822) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Centralne zamki / Zestawy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chip tuning",
    "categoryPath": [
      "(258701) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(258701) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Chip tuning",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki drzwi",
    "categoryPath": [
      "(256165) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(256165) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki drzwi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki parkowania",
    "categoryPath": [
      "(256161) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(256161) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki parkowania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki pasa ruchu",
    "categoryPath": [
      "(261299) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(261299) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki pasa ruchu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki położenia",
    "categoryPath": [
      "(260606) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(260606) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki położenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki przyspieszenia",
    "categoryPath": [
      "(260605) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(260605) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki przyspieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki prędkości",
    "categoryPath": [
      "(256164) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(256164) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki prędkości",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki temperatury",
    "categoryPath": [
      "(261072) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(261072) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki temperatury",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki temperatury wewnętrznej",
    "categoryPath": [
      "(261073) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(261073) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki temperatury wewnętrznej",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki temperatury zewnętrznej",
    "categoryPath": [
      "(256162) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(256162) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki temperatury zewnętrznej",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki uderzenia",
    "categoryPath": [
      "(256163) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(256163) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki uderzenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Czujniki zasysanego powietrza",
    "categoryPath": [
      "(259306) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(259306) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Czujniki zasysanego powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50745) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Czujniki"
    ],
    "hierarchy": "(50745) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Czujniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Bezpieczniki",
    "categoryPath": [
      "(50768) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Materiały instalacyjne"
    ],
    "hierarchy": "(50768) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Materiały instalacyjne / Bezpieczniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klemy",
    "categoryPath": [
      "(255609) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Materiały instalacyjne"
    ],
    "hierarchy": "(255609) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Materiały instalacyjne / Klemy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kostki, złączki",
    "categoryPath": [
      "(50753) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Materiały instalacyjne"
    ],
    "hierarchy": "(50753) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Materiały instalacyjne / Kostki, złączki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony, izolacje przewodów",
    "categoryPath": [
      "(261065) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Materiały instalacyjne"
    ],
    "hierarchy": "(261065) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Materiały instalacyjne / Osłony, izolacje przewodów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50752) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Materiały instalacyjne"
    ],
    "hierarchy": "(50752) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Materiały instalacyjne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wiązki przewodów",
    "categoryPath": [
      "(50754) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Materiały instalacyjne"
    ],
    "hierarchy": "(50754) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Materiały instalacyjne / Wiązki przewodów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy akumulatorów",
    "categoryPath": [
      "(255612) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(255612) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Obudowy akumulatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oporniki",
    "categoryPath": [
      "(261077) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(261077) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Oporniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Potencjometry",
    "categoryPath": [
      "(261080) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(261080) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Potencjometry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4147) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(4147) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przekaźniki",
    "categoryPath": [
      "(50755) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(50755) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Przekaźniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody ładowania",
    "categoryPath": [
      "(261563) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(261563) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Przewody ładowania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skrzynki bezpieczników",
    "categoryPath": [
      "(255613) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(255613) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Skrzynki bezpieczników",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kluczyki",
    "categoryPath": [
      "(255611) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Stacyjki i kluczyki"
    ],
    "hierarchy": "(255611) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Stacyjki i kluczyki / Kluczyki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Stacyjki",
    "categoryPath": [
      "(255610) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Stacyjki i kluczyki"
    ],
    "hierarchy": "(255610) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Stacyjki i kluczyki / Stacyjki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki ASR",
    "categoryPath": [
      "(261087) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(261087) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Sterowniki ASR",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki silnika",
    "categoryPath": [
      "(4145) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon"
    ],
    "hierarchy": "(4145) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Sterowniki silnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Alternatory",
    "categoryPath": [
      "(50769) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(50769) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Alternatory kompletne",
    "categoryPath": [
      "(261054) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261054) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Alternatory kompletne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła alternatora",
    "categoryPath": [
      "(261088) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261088) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Koła alternatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Prostowniki alternatora",
    "categoryPath": [
      "(261058) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261058) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Prostowniki alternatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Regulatory",
    "categoryPath": [
      "(261060) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261060) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Regulatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprzęgła alternatora",
    "categoryPath": [
      "(261055) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261055) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Sprzęgła alternatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stojany",
    "categoryPath": [
      "(261059) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261059) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Stojany",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(261057) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261057) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Szczotki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uzwojenia",
    "categoryPath": [
      "(261061) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261061) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Uzwojenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(261063) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261063) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Wentylatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wirniki",
    "categoryPath": [
      "(261062) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261062) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Wirniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(261064) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261064) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Łożyska alternatora",
    "categoryPath": [
      "(261056) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Alternatory"
    ],
    "hierarchy": "(261056) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Alternatory / Łożyska alternatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Aparaty zapłonowe",
    "categoryPath": [
      "(50770) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(50770) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Aparaty zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cewki zapłonowe",
    "categoryPath": [
      "(50771) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(50771) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Cewki zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły zapłonowe",
    "categoryPath": [
      "(50763) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(50763) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Moduły zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50762) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(50762) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody zapłonowe",
    "categoryPath": [
      "(50772) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(50772) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Przewody zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozruszniki",
    "categoryPath": [
      "(50773) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(50773) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Rozruszniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozruszniki kompletne",
    "categoryPath": [
      "(261066) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Rozruszniki"
    ],
    "hierarchy": "(261066) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Rozruszniki / Rozruszniki kompletne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprzęgła rozrusznika (bendiks)",
    "categoryPath": [
      "(261069) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Rozruszniki"
    ],
    "hierarchy": "(261069) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Rozruszniki / Sprzęgła rozrusznika (bendiks)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(261068) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Rozruszniki"
    ],
    "hierarchy": "(261068) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Rozruszniki / Szczotki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tulejki, łożyska",
    "categoryPath": [
      "(261067) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Rozruszniki"
    ],
    "hierarchy": "(261067) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Rozruszniki / Tulejki, łożyska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Włączniki elektromagnetyczne",
    "categoryPath": [
      "(261071) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Rozruszniki"
    ],
    "hierarchy": "(261071) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Rozruszniki / Włączniki elektromagnetyczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(261070) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika",
      "Rozruszniki"
    ],
    "hierarchy": "(261070) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Rozruszniki / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tulejki, łożyska",
    "categoryPath": [
      "(261085) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Układ elektryczny silnika"
    ],
    "hierarchy": "(261085) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Układ elektryczny silnika / Tulejki, łożyska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gniazda zapalniczki",
    "categoryPath": [
      "(50779) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(50779) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Gniazda zapalniczki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Kamery",
    "categoryPath": [
      "(320761) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(320761) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Kamery",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Klaksony",
    "categoryPath": [
      "(50766) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(50766) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Klaksony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły drzwi",
    "categoryPath": [
      "(256283) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(256283) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Moduły drzwi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły immobilizera",
    "categoryPath": [
      "(256284) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(256284) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Moduły immobilizera",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły komfortu",
    "categoryPath": [
      "(256285) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(256285) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Moduły komfortu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły poduszek powietrznych",
    "categoryPath": [
      "(256282) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(256282) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Moduły poduszek powietrznych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły tempomatu",
    "categoryPath": [
      "(261376) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(261376) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Moduły tempomatu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnośniki szyb",
    "categoryPath": [
      "(256182) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(256182) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Podnośniki szyb",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50765) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(50765) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przetwornice",
    "categoryPath": [
      "(261074) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(261074) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Przetwornice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniczki regulacji fotela",
    "categoryPath": [
      "(50775) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(50775) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Silniczki regulacji fotela",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniczki szyb",
    "categoryPath": [
      "(50776) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(50776) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Silniczki szyb",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniczki szyberdachu",
    "categoryPath": [
      "(50777) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(50777) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Silniczki szyberdachu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(261300) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Wyposażenie elektryczne"
    ],
    "hierarchy": "(261300) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Wyposażenie elektryczne / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(261079) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Świece"
    ],
    "hierarchy": "(261079) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Świece / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Zapłonowe",
    "categoryPath": [
      "(50759) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Świece"
    ],
    "hierarchy": "(50759) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Świece / Zapłonowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Żarowe",
    "categoryPath": [
      "(50760) Motoryzacja",
      "Części samochodowe",
      "Układ elektryczny, zapłon",
      "Świece"
    ],
    "hierarchy": "(50760) Motoryzacja / Części samochodowe / Układ elektryczny, zapłon / Świece / Żarowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bębny hamulcowe",
    "categoryPath": [
      "(250423) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce bębnowe"
    ],
    "hierarchy": "(250423) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce bębnowe / Bębny hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cylinderki",
    "categoryPath": [
      "(250424) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce bębnowe"
    ],
    "hierarchy": "(250424) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce bębnowe / Cylinderki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260575) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce bębnowe"
    ],
    "hierarchy": "(260575) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce bębnowe / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Okładziny szczęk hamulcowych",
    "categoryPath": [
      "(260578) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce bębnowe"
    ],
    "hierarchy": "(260578) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce bębnowe / Okładziny szczęk hamulcowych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczęki hamulcowe",
    "categoryPath": [
      "(250425) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce bębnowe"
    ],
    "hierarchy": "(250425) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce bębnowe / Szczęki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy (bębny, szczęki, cylinderki)",
    "categoryPath": [
      "(250426) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce bębnowe"
    ],
    "hierarchy": "(250426) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce bębnowe / Zestawy (bębny, szczęki, cylinderki)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260604) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce pneumatyczne"
    ],
    "hierarchy": "(260604) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce pneumatyczne / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy",
    "categoryPath": [
      "(260582) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce pneumatyczne"
    ],
    "hierarchy": "(260582) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce pneumatyczne / Pompy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Siłowniki",
    "categoryPath": [
      "(260581) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce pneumatyczne"
    ],
    "hierarchy": "(260581) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce pneumatyczne / Siłowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260608) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce postojowe"
    ],
    "hierarchy": "(260608) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce postojowe / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dźwignie hamulca ręcznego",
    "categoryPath": [
      "(260615) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce postojowe"
    ],
    "hierarchy": "(260615) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce postojowe / Dźwignie hamulca ręcznego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki hamulca ręcznego",
    "categoryPath": [
      "(260614) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce postojowe"
    ],
    "hierarchy": "(260614) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce postojowe / Linki hamulca ręcznego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki zużycia klocków",
    "categoryPath": [
      "(250403) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce tarczowe"
    ],
    "hierarchy": "(250403) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce tarczowe / Czujniki zużycia klocków",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Części montażowe i naprawcze",
    "categoryPath": [
      "(260579) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce tarczowe"
    ],
    "hierarchy": "(260579) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce tarczowe / Części montażowe i naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Jarzma",
    "categoryPath": [
      "(250404) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce tarczowe"
    ],
    "hierarchy": "(250404) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce tarczowe / Jarzma",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klocki hamulcowe",
    "categoryPath": [
      "(250405) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce tarczowe"
    ],
    "hierarchy": "(250405) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce tarczowe / Klocki hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tarcze hamulcowe",
    "categoryPath": [
      "(250406) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce tarczowe"
    ],
    "hierarchy": "(250406) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce tarczowe / Tarcze hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zaciski",
    "categoryPath": [
      "(250427) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce tarczowe"
    ],
    "hierarchy": "(250427) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce tarczowe / Zaciski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy (tarcze, klocki, zaciski)",
    "categoryPath": [
      "(250407) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Hamulce tarczowe"
    ],
    "hierarchy": "(250407) Motoryzacja / Części samochodowe / Układ hamulcowy / Hamulce tarczowe / Zestawy (tarcze, klocki, zaciski)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korektory siły hamowania",
    "categoryPath": [
      "(250428) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(250428) Motoryzacja / Części samochodowe / Układ hamulcowy / Korektory siły hamowania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy hamulcowe",
    "categoryPath": [
      "(18839) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(18839) Motoryzacja / Części samochodowe / Układ hamulcowy / Pompy hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18843) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(18843) Motoryzacja / Części samochodowe / Układ hamulcowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody hamulcowe",
    "categoryPath": [
      "(250429) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(250429) Motoryzacja / Części samochodowe / Układ hamulcowy / Przewody hamulcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki ABS",
    "categoryPath": [
      "(260616) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Układ ABS i ESP"
    ],
    "hierarchy": "(260616) Motoryzacja / Części samochodowe / Układ hamulcowy / Układ ABS i ESP / Czujniki ABS",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki ESP",
    "categoryPath": [
      "(260617) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Układ ABS i ESP"
    ],
    "hierarchy": "(260617) Motoryzacja / Części samochodowe / Układ hamulcowy / Układ ABS i ESP / Czujniki ESP",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260580) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Układ ABS i ESP"
    ],
    "hierarchy": "(260580) Motoryzacja / Części samochodowe / Układ hamulcowy / Układ ABS i ESP / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sterowniki ABS",
    "categoryPath": [
      "(260618) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Układ ABS i ESP"
    ],
    "hierarchy": "(260618) Motoryzacja / Części samochodowe / Układ hamulcowy / Układ ABS i ESP / Sterowniki ABS",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260611) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Wspomaganie hamulca"
    ],
    "hierarchy": "(260611) Motoryzacja / Części samochodowe / Układ hamulcowy / Wspomaganie hamulca / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Hamulec pracy ciągłej",
    "categoryPath": [
      "(260612) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Wspomaganie hamulca"
    ],
    "hierarchy": "(260612) Motoryzacja / Części samochodowe / Układ hamulcowy / Wspomaganie hamulca / Hamulec pracy ciągłej",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy podciśnieniowe",
    "categoryPath": [
      "(260610) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Wspomaganie hamulca"
    ],
    "hierarchy": "(260610) Motoryzacja / Części samochodowe / Układ hamulcowy / Wspomaganie hamulca / Pompy podciśnieniowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Serwa hamulca",
    "categoryPath": [
      "(260619) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy",
      "Wspomaganie hamulca"
    ],
    "hierarchy": "(260619) Motoryzacja / Części samochodowe / Układ hamulcowy / Wspomaganie hamulca / Serwa hamulca",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki płynu hamulcowego",
    "categoryPath": [
      "(250431) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(250431) Motoryzacja / Części samochodowe / Układ hamulcowy / Zbiorniki płynu hamulcowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy montażowe i naprawcze",
    "categoryPath": [
      "(18842) Motoryzacja",
      "Części samochodowe",
      "Układ hamulcowy"
    ],
    "hierarchy": "(18842) Motoryzacja / Części samochodowe / Układ hamulcowy / Zestawy montażowe i naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Amortyzatory",
    "categoryPath": [
      "(260946) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(260946) Motoryzacja / Części samochodowe / Układ kierowniczy / Amortyzatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodnice wspomagania",
    "categoryPath": [
      "(260947) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(260947) Motoryzacja / Części samochodowe / Układ kierowniczy / Chłodnice wspomagania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki kąta skrętu",
    "categoryPath": [
      "(256140) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(256140) Motoryzacja / Części samochodowe / Układ kierowniczy / Czujniki kąta skrętu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260948) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(260948) Motoryzacja / Części samochodowe / Układ kierowniczy / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Drążki kierownicze",
    "categoryPath": [
      "(250843) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250843) Motoryzacja / Części samochodowe / Układ kierowniczy / Drążki kierownicze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kolumny kierownicze",
    "categoryPath": [
      "(250844) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250844) Motoryzacja / Części samochodowe / Układ kierowniczy / Kolumny kierownicze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Końcówki drążków kierowniczych",
    "categoryPath": [
      "(250845) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250845) Motoryzacja / Części samochodowe / Układ kierowniczy / Końcówki drążków kierowniczych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony przekładni kierowniczych",
    "categoryPath": [
      "(250846) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250846) Motoryzacja / Części samochodowe / Układ kierowniczy / Osłony przekładni kierowniczych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy wspomagania",
    "categoryPath": [
      "(250862) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250862) Motoryzacja / Części samochodowe / Układ kierowniczy / Pompy wspomagania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(250850) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250850) Motoryzacja / Części samochodowe / Układ kierowniczy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przekładnie kierownicze",
    "categoryPath": [
      "(250847) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250847) Motoryzacja / Części samochodowe / Układ kierowniczy / Przekładnie kierownicze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Przewody układu wspomagania",
    "categoryPath": [
      "(250848) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250848) Motoryzacja / Części samochodowe / Układ kierowniczy / Przewody układu wspomagania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(261084) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(261084) Motoryzacja / Części samochodowe / Układ kierowniczy / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(260949) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(260949) Motoryzacja / Części samochodowe / Układ kierowniczy / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki płynu wspomagania",
    "categoryPath": [
      "(250849) Motoryzacja",
      "Części samochodowe",
      "Układ kierowniczy"
    ],
    "hierarchy": "(250849) Motoryzacja / Części samochodowe / Układ kierowniczy / Zbiorniki płynu wspomagania",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodnice klimatyzacji (skraplacze)",
    "categoryPath": [
      "(258678) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258678) Motoryzacja / Części samochodowe / Układ klimatyzacji / Chłodnice klimatyzacji (skraplacze)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(258680) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258680) Motoryzacja / Części samochodowe / Układ klimatyzacji / Czujniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260953) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(260953) Motoryzacja / Części samochodowe / Układ klimatyzacji / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dysze",
    "categoryPath": [
      "(260951) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(260951) Motoryzacja / Części samochodowe / Układ klimatyzacji / Dysze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne instalacje",
    "categoryPath": [
      "(258682) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258682) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompletne instalacje",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cewki kompresorów",
    "categoryPath": [
      "(258698) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji",
      "Kompresory klimatyzacji"
    ],
    "hierarchy": "(258698) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompresory klimatyzacji / Cewki kompresorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260950) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji",
      "Kompresory klimatyzacji"
    ],
    "hierarchy": "(260950) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompresory klimatyzacji / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Głowice",
    "categoryPath": [
      "(260952) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji",
      "Kompresory klimatyzacji"
    ],
    "hierarchy": "(260952) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompresory klimatyzacji / Głowice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompresory klimatyzacji",
    "categoryPath": [
      "(258697) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji",
      "Kompresory klimatyzacji"
    ],
    "hierarchy": "(258697) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompresory klimatyzacji / Kompresory klimatyzacji",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprzęgła kompresorów",
    "categoryPath": [
      "(258699) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji",
      "Kompresory klimatyzacji"
    ],
    "hierarchy": "(258699) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompresory klimatyzacji / Sprzęgła kompresorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(260954) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji",
      "Kompresory klimatyzacji"
    ],
    "hierarchy": "(260954) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompresory klimatyzacji / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Łożyska kompresorów",
    "categoryPath": [
      "(258700) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji",
      "Kompresory klimatyzacji"
    ],
    "hierarchy": "(258700) Motoryzacja / Części samochodowe / Układ klimatyzacji / Kompresory klimatyzacji / Łożyska kompresorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Osuszacze",
    "categoryPath": [
      "(258685) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258685) Motoryzacja / Części samochodowe / Układ klimatyzacji / Osuszacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Parowniki",
    "categoryPath": [
      "(258687) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258687) Motoryzacja / Części samochodowe / Układ klimatyzacji / Parowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258689) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258689) Motoryzacja / Części samochodowe / Układ klimatyzacji / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody klimatyzacji",
    "categoryPath": [
      "(258691) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258691) Motoryzacja / Części samochodowe / Układ klimatyzacji / Przewody klimatyzacji",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki i elementy elektryczne",
    "categoryPath": [
      "(258693) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258693) Motoryzacja / Części samochodowe / Układ klimatyzacji / Sterowniki i elementy elektryczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(260955) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(260955) Motoryzacja / Części samochodowe / Układ klimatyzacji / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylatory chłodnic klimatyzacji",
    "categoryPath": [
      "(258694) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258694) Motoryzacja / Części samochodowe / Układ klimatyzacji / Wentylatory chłodnic klimatyzacji",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory rozprężne",
    "categoryPath": [
      "(258696) Motoryzacja",
      "Części samochodowe",
      "Układ klimatyzacji"
    ],
    "hierarchy": "(258696) Motoryzacja / Części samochodowe / Układ klimatyzacji / Zawory rozprężne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dyferencjały",
    "categoryPath": [
      "(50865) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy"
    ],
    "hierarchy": "(50865) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260925) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Dyferencjały"
    ],
    "hierarchy": "(260925) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały / Części montażowe",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Kompletne dyferencjały",
    "categoryPath": [
      "(260923) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Dyferencjały"
    ],
    "hierarchy": "(260923) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały / Kompletne dyferencjały",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Koła zębate",
    "categoryPath": [
      "(260924) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Dyferencjały"
    ],
    "hierarchy": "(260924) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały / Koła zębate",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(260927) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Dyferencjały"
    ],
    "hierarchy": "(260927) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały / Obudowy",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(260928) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Dyferencjały"
    ],
    "hierarchy": "(260928) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały / Uszczelki",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(260929) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Dyferencjały"
    ],
    "hierarchy": "(260929) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały / Zestawy naprawcze",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(260926) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Dyferencjały"
    ],
    "hierarchy": "(260926) Motoryzacja / Części samochodowe / Układ napędowy / Dyferencjały / Łożyska",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Przednie",
    "categoryPath": [
      "(50867) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Mosty"
    ],
    "hierarchy": "(50867) Motoryzacja / Części samochodowe / Układ napędowy / Mosty / Przednie",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Tylne",
    "categoryPath": [
      "(50868) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Mosty"
    ],
    "hierarchy": "(50868) Motoryzacja / Części samochodowe / Układ napędowy / Mosty / Tylne",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Napęd hybrydowy, elektryczny",
    "categoryPath": [
      "(260901) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy"
    ],
    "hierarchy": "(260901) Motoryzacja / Części samochodowe / Układ napędowy / Napęd hybrydowy, elektryczny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50864) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy"
    ],
    "hierarchy": "(50864) Motoryzacja / Części samochodowe / Układ napędowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260902) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(260902) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Krzyżaki wału",
    "categoryPath": [
      "(256001) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256001) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Krzyżaki wału",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Nakrętki półosi",
    "categoryPath": [
      "(260904) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(260904) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Nakrętki półosi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony przegubów",
    "categoryPath": [
      "(256002) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256002) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Osłony przegubów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podpory półosi",
    "categoryPath": [
      "(256003) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256003) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Podpory półosi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podpory wału",
    "categoryPath": [
      "(256004) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256004) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Podpory wału",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256009) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256009) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przeguby",
    "categoryPath": [
      "(256005) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256005) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Przeguby",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Półosie",
    "categoryPath": [
      "(256006) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256006) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Półosie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skrzynie rozdzielacza",
    "categoryPath": [
      "(260908) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(260908) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Skrzynie rozdzielacza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tłumiki drgań",
    "categoryPath": [
      "(260905) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(260905) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Tłumiki drgań",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelniacze półosi",
    "categoryPath": [
      "(256007) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256007) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Uszczelniacze półosi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelniacze wału",
    "categoryPath": [
      "(260906) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(260906) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Uszczelniacze wału",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wały napędowe",
    "categoryPath": [
      "(256008) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(256008) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Wały napędowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(260903) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Półosie, przeguby, wały"
    ],
    "hierarchy": "(260903) Motoryzacja / Części samochodowe / Układ napędowy / Półosie, przeguby, wały / Łożyska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki skrzyni",
    "categoryPath": [
      "(260910) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260910) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Czujniki skrzyni",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260909) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260909) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompletne skrzynie",
    "categoryPath": [
      "(50873) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(50873) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Kompletne skrzynie",
    "comissionGroupOld": "C31",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Koła zębate",
    "categoryPath": [
      "(260911) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260911) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Koła zębate",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lewarki i wybieraki",
    "categoryPath": [
      "(256018) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256018) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Lewarki i wybieraki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki zmiany biegów",
    "categoryPath": [
      "(256010) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256010) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Linki zmiany biegów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(256012) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256012) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Obudowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(256013) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256013) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Poduszki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50872) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(50872) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(260913) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260913) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(260898) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260898) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Przełączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Reduktory",
    "categoryPath": [
      "(256014) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256014) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Reduktory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skrzynie rozdzielacza",
    "categoryPath": [
      "(260907) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260907) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Skrzynie rozdzielacza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Smarowanie",
    "categoryPath": [
      "(256015) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256015) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Smarowanie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki skrzyni",
    "categoryPath": [
      "(256016) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256016) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Sterowniki skrzyni",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Synchronizatory",
    "categoryPath": [
      "(256017) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256017) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Synchronizatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(260899) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260899) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wałki skrzyni",
    "categoryPath": [
      "(260900) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260900) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Wałki skrzyni",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(260914) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260914) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(260915) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260915) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Łapy, podpory",
    "categoryPath": [
      "(256011) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(256011) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Łapy, podpory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(260912) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Skrzynie biegów"
    ],
    "hierarchy": "(260912) Motoryzacja / Części samochodowe / Układ napędowy / Skrzynie biegów / Łożyska",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260916) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(260916) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dociski sprzęgła",
    "categoryPath": [
      "(50882) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(50882) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Dociski sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dźwignie sprzęgła (łapy)",
    "categoryPath": [
      "(260917) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(260917) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Dźwignie sprzęgła (łapy)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Komplety sprzęgieł",
    "categoryPath": [
      "(50884) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(50884) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Komplety sprzęgieł",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koła dwumasowe i zamachowe",
    "categoryPath": [
      "(50883) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(50883) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Koła dwumasowe i zamachowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki sprzęgła",
    "categoryPath": [
      "(255986) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(255986) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Linki sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(260918) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(260918) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Obudowy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy sprzęgła",
    "categoryPath": [
      "(50886) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(50886) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Pompy sprzęgła",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(50881) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(50881) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(255987) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(255987) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tarcze",
    "categoryPath": [
      "(50887) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(50887) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Tarcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wysprzęgliki",
    "categoryPath": [
      "(255988) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(255988) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Wysprzęgliki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Łożyska oporowe",
    "categoryPath": [
      "(50885) Motoryzacja",
      "Części samochodowe",
      "Układ napędowy",
      "Sprzęgła"
    ],
    "hierarchy": "(50885) Motoryzacja / Części samochodowe / Układ napędowy / Sprzęgła / Łożyska oporowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(260934) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260934) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Czujniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260936) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260936) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Moduły",
    "categoryPath": [
      "(260937) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260937) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Moduły",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podgrzewacze",
    "categoryPath": [
      "(260935) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260935) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Podgrzewacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(260938) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260938) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wlewy, korki",
    "categoryPath": [
      "(260939) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260939) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Wlewy, korki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wtryskiwacze",
    "categoryPath": [
      "(260940) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260940) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Wtryskiwacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(260941) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "AdBlue"
    ],
    "hierarchy": "(260941) Motoryzacja / Części samochodowe / Układ paliwowy / AdBlue / Zbiorniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chłodnice paliwa",
    "categoryPath": [
      "(261091) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(261091) Motoryzacja / Części samochodowe / Układ paliwowy / Chłodnice paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki poziomu paliwa",
    "categoryPath": [
      "(255917) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255917) Motoryzacja / Części samochodowe / Układ paliwowy / Czujniki poziomu paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki temperatury paliwa",
    "categoryPath": [
      "(261200) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(261200) Motoryzacja / Części samochodowe / Układ paliwowy / Czujniki temperatury paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261089) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(261089) Motoryzacja / Części samochodowe / Układ paliwowy / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gaźniki",
    "categoryPath": [
      "(255918) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255918) Motoryzacja / Części samochodowe / Układ paliwowy / Gaźniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki wlewu",
    "categoryPath": [
      "(255919) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255919) Motoryzacja / Części samochodowe / Układ paliwowy / Korki wlewu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Końcówki wtryskiwaczy",
    "categoryPath": [
      "(255922) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255922) Motoryzacja / Części samochodowe / Układ paliwowy / Końcówki wtryskiwaczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Adaptery, przejściówki",
    "categoryPath": [
      "(18856) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(18856) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Adaptery, przejściówki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(255910) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(255910) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Czujniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Elektrozawory",
    "categoryPath": [
      "(319691) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(319691) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Elektrozawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Emulatory",
    "categoryPath": [
      "(255911) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(255911) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Emulatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(18858) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(18858) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Filtry",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instalacje kompletne",
    "categoryPath": [
      "(18859) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(18859) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Instalacje kompletne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18855) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(18855) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(255912) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(255912) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(255914) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(255914) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Przełączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Reduktory",
    "categoryPath": [
      "(18860) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(18860) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Reduktory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(255913) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(255913) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wielozawory",
    "categoryPath": [
      "(319694) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(319694) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Wielozawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wlewy, korki",
    "categoryPath": [
      "(255915) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(255915) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Wlewy, korki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wtryskiwacze",
    "categoryPath": [
      "(255916) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(255916) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Wtryskiwacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(18857) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(18857) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Zbiorniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(18861) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy",
      "LPG"
    ],
    "hierarchy": "(18861) Motoryzacja / Części samochodowe / Układ paliwowy / LPG / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy wtryskowe",
    "categoryPath": [
      "(255923) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255923) Motoryzacja / Części samochodowe / Układ paliwowy / Listwy wtryskowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Monowtryski",
    "categoryPath": [
      "(255929) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255929) Motoryzacja / Części samochodowe / Układ paliwowy / Monowtryski",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy filtrów paliwa",
    "categoryPath": [
      "(256226) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(256226) Motoryzacja / Części samochodowe / Układ paliwowy / Obudowy filtrów paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podgrzewacze",
    "categoryPath": [
      "(261092) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(261092) Motoryzacja / Części samochodowe / Układ paliwowy / Podgrzewacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompowtryskiwacze",
    "categoryPath": [
      "(255931) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255931) Motoryzacja / Części samochodowe / Układ paliwowy / Pompowtryskiwacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy paliwa",
    "categoryPath": [
      "(255920) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255920) Motoryzacja / Części samochodowe / Układ paliwowy / Pompy paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy wtryskowe",
    "categoryPath": [
      "(255927) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255927) Motoryzacja / Części samochodowe / Układ paliwowy / Pompy wtryskowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(255928) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255928) Motoryzacja / Części samochodowe / Układ paliwowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody paliwa",
    "categoryPath": [
      "(255930) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255930) Motoryzacja / Części samochodowe / Układ paliwowy / Przewody paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody wtryskowe",
    "categoryPath": [
      "(255932) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255932) Motoryzacja / Części samochodowe / Układ paliwowy / Przewody wtryskowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Regulatory ciśnienia paliwa",
    "categoryPath": [
      "(256204) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(256204) Motoryzacja / Części samochodowe / Układ paliwowy / Regulatory ciśnienia paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozdzielacze",
    "categoryPath": [
      "(255933) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255933) Motoryzacja / Części samochodowe / Układ paliwowy / Rozdzielacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(261083) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(261083) Motoryzacja / Części samochodowe / Układ paliwowy / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(255924) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255924) Motoryzacja / Części samochodowe / Układ paliwowy / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wlewy paliwa",
    "categoryPath": [
      "(255934) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255934) Motoryzacja / Części samochodowe / Układ paliwowy / Wlewy paliwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wtryskiwacze",
    "categoryPath": [
      "(255926) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255926) Motoryzacja / Części samochodowe / Układ paliwowy / Wtryskiwacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(255935) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255935) Motoryzacja / Części samochodowe / Układ paliwowy / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(255925) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(255925) Motoryzacja / Części samochodowe / Układ paliwowy / Zbiorniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(261094) Motoryzacja",
      "Części samochodowe",
      "Układ paliwowy"
    ],
    "hierarchy": "(261094) Motoryzacja / Części samochodowe / Układ paliwowy / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki",
    "categoryPath": [
      "(261554) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261554) Motoryzacja / Części samochodowe / Układ pneumatyczny / Czujniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261556) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261556) Motoryzacja / Części samochodowe / Układ pneumatyczny / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompresory i części",
    "categoryPath": [
      "(261565) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261565) Motoryzacja / Części samochodowe / Układ pneumatyczny / Kompresory i części",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osuszacze",
    "categoryPath": [
      "(261555) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261555) Motoryzacja / Części samochodowe / Układ pneumatyczny / Osuszacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody spiralne",
    "categoryPath": [
      "(261559) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261559) Motoryzacja / Części samochodowe / Układ pneumatyczny / Przewody spiralne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Regulatory",
    "categoryPath": [
      "(261560) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261560) Motoryzacja / Części samochodowe / Układ pneumatyczny / Regulatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(261558) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261558) Motoryzacja / Części samochodowe / Układ pneumatyczny / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki",
    "categoryPath": [
      "(261561) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261561) Motoryzacja / Części samochodowe / Układ pneumatyczny / Zbiorniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(261562) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261562) Motoryzacja / Części samochodowe / Układ pneumatyczny / Zestawy naprawcze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Złączki i przewody",
    "categoryPath": [
      "(261557) Motoryzacja",
      "Części samochodowe",
      "Układ pneumatyczny"
    ],
    "hierarchy": "(261557) Motoryzacja / Części samochodowe / Układ pneumatyczny / Złączki i przewody",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Dmuchawy",
    "categoryPath": [
      "(258679) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258679) Motoryzacja / Części samochodowe / Układ wentylacji / Dmuchawy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kanały powietrza",
    "categoryPath": [
      "(261301) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(261301) Motoryzacja / Części samochodowe / Układ wentylacji / Kanały powietrza",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nagrzewnice",
    "categoryPath": [
      "(258681) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258681) Motoryzacja / Części samochodowe / Układ wentylacji / Nagrzewnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obudowy filtrów kabinowych",
    "categoryPath": [
      "(258683) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258683) Motoryzacja / Części samochodowe / Układ wentylacji / Obudowy filtrów kabinowych",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258686) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258686) Motoryzacja / Części samochodowe / Układ wentylacji / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody nagrzewnic",
    "categoryPath": [
      "(258688) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258688) Motoryzacja / Części samochodowe / Układ wentylacji / Przewody nagrzewnic",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rezystory dmuchaw",
    "categoryPath": [
      "(258690) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258690) Motoryzacja / Części samochodowe / Układ wentylacji / Rezystory dmuchaw",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Silniki dmuchaw",
    "categoryPath": [
      "(258692) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258692) Motoryzacja / Części samochodowe / Układ wentylacji / Silniki dmuchaw",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory nagrzewnic",
    "categoryPath": [
      "(258695) Motoryzacja",
      "Części samochodowe",
      "Układ wentylacji"
    ],
    "hierarchy": "(258695) Motoryzacja / Części samochodowe / Układ wentylacji / Zawory nagrzewnic",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki ciśnienia spalin",
    "categoryPath": [
      "(259308) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(259308) Motoryzacja / Części samochodowe / Układ wydechowy / Czujniki ciśnienia spalin",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki temperatury spalin",
    "categoryPath": [
      "(259307) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(259307) Motoryzacja / Części samochodowe / Układ wydechowy / Czujniki temperatury spalin",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry cząstek stałych DPF/FAP",
    "categoryPath": [
      "(255639) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255639) Motoryzacja / Części samochodowe / Układ wydechowy / Filtry cząstek stałych DPF/FAP",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Katalizatory",
    "categoryPath": [
      "(18864) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(18864) Motoryzacja / Części samochodowe / Układ wydechowy / Katalizatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kolektory wydechowe",
    "categoryPath": [
      "(18865) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(18865) Motoryzacja / Części samochodowe / Układ wydechowy / Kolektory wydechowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Końcówki wydechu",
    "categoryPath": [
      "(255640) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255640) Motoryzacja / Części samochodowe / Układ wydechowy / Końcówki wydechu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Obejmy",
    "categoryPath": [
      "(255642) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255642) Motoryzacja / Części samochodowe / Układ wydechowy / Obejmy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(255643) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255643) Motoryzacja / Części samochodowe / Układ wydechowy / Osłony",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18863) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(18863) Motoryzacja / Części samochodowe / Układ wydechowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przepustnice wydechu",
    "categoryPath": [
      "(260942) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(260942) Motoryzacja / Części samochodowe / Układ wydechowy / Przepustnice wydechu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rury wydechowe",
    "categoryPath": [
      "(255644) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255644) Motoryzacja / Części samochodowe / Układ wydechowy / Rury wydechowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sondy lambda",
    "categoryPath": [
      "(18866) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(18866) Motoryzacja / Części samochodowe / Układ wydechowy / Sondy lambda",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Strumienice",
    "categoryPath": [
      "(258761) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(258761) Motoryzacja / Części samochodowe / Układ wydechowy / Strumienice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(255661) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy",
      "Tłumiki"
    ],
    "hierarchy": "(255661) Motoryzacja / Części samochodowe / Układ wydechowy / Tłumiki / Komplety",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Końcowe",
    "categoryPath": [
      "(255658) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy",
      "Tłumiki"
    ],
    "hierarchy": "(255658) Motoryzacja / Części samochodowe / Układ wydechowy / Tłumiki / Końcowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przednie",
    "categoryPath": [
      "(255659) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy",
      "Tłumiki"
    ],
    "hierarchy": "(255659) Motoryzacja / Części samochodowe / Układ wydechowy / Tłumiki / Przednie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Środkowe",
    "categoryPath": [
      "(255660) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy",
      "Tłumiki"
    ],
    "hierarchy": "(255660) Motoryzacja / Części samochodowe / Układ wydechowy / Tłumiki / Środkowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(255645) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255645) Motoryzacja / Części samochodowe / Układ wydechowy / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(255646) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255646) Motoryzacja / Części samochodowe / Układ wydechowy / Wieszaki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łączniki elastyczne",
    "categoryPath": [
      "(255641) Motoryzacja",
      "Części samochodowe",
      "Układ wydechowy"
    ],
    "hierarchy": "(255641) Motoryzacja / Części samochodowe / Układ wydechowy / Łączniki elastyczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Amortyzatory",
    "categoryPath": [
      "(19063) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Amortyzatory i elementy"
    ],
    "hierarchy": "(19063) Motoryzacja / Części samochodowe / Układ zawieszenia / Amortyzatory i elementy / Amortyzatory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260723) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Amortyzatory i elementy"
    ],
    "hierarchy": "(260723) Motoryzacja / Części samochodowe / Układ zawieszenia / Amortyzatory i elementy / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony i odboje amortyzatorów",
    "categoryPath": [
      "(250863) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Amortyzatory i elementy"
    ],
    "hierarchy": "(250863) Motoryzacja / Części samochodowe / Układ zawieszenia / Amortyzatory i elementy / Osłony i odboje amortyzatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poduszki i łożyska amortyzatorów",
    "categoryPath": [
      "(250864) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Amortyzatory i elementy"
    ],
    "hierarchy": "(250864) Motoryzacja / Części samochodowe / Układ zawieszenia / Amortyzatory i elementy / Poduszki i łożyska amortyzatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuleje amortyzatorów",
    "categoryPath": [
      "(250865) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Amortyzatory i elementy"
    ],
    "hierarchy": "(250865) Motoryzacja / Części samochodowe / Układ zawieszenia / Amortyzatory i elementy / Tuleje amortyzatorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Belki przednie",
    "categoryPath": [
      "(250867) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Belki zawieszenia"
    ],
    "hierarchy": "(250867) Motoryzacja / Części samochodowe / Układ zawieszenia / Belki zawieszenia / Belki przednie",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Belki tylne",
    "categoryPath": [
      "(250868) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Belki zawieszenia"
    ],
    "hierarchy": "(250868) Motoryzacja / Części samochodowe / Układ zawieszenia / Belki zawieszenia / Belki tylne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260731) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Belki zawieszenia"
    ],
    "hierarchy": "(260731) Motoryzacja / Części samochodowe / Układ zawieszenia / Belki zawieszenia / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260724) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260724) Motoryzacja / Części samochodowe / Układ zawieszenia / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podkładki sprężyn zawieszenia",
    "categoryPath": [
      "(250869) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(250869) Motoryzacja / Części samochodowe / Układ zawieszenia / Podkładki sprężyn zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(8687) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(8687) Motoryzacja / Części samochodowe / Układ zawieszenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260728) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Resory i elementy"
    ],
    "hierarchy": "(260728) Motoryzacja / Części samochodowe / Układ zawieszenia / Resory i elementy / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odboje i jarzma resorów",
    "categoryPath": [
      "(250871) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Resory i elementy"
    ],
    "hierarchy": "(250871) Motoryzacja / Części samochodowe / Układ zawieszenia / Resory i elementy / Odboje i jarzma resorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pióra resorów",
    "categoryPath": [
      "(250872) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Resory i elementy"
    ],
    "hierarchy": "(250872) Motoryzacja / Części samochodowe / Układ zawieszenia / Resory i elementy / Pióra resorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuleje resorów",
    "categoryPath": [
      "(250873) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Resory i elementy"
    ],
    "hierarchy": "(250873) Motoryzacja / Części samochodowe / Układ zawieszenia / Resory i elementy / Tuleje resorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Sprężyny zawieszenia",
    "categoryPath": [
      "(18965) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(18965) Motoryzacja / Części samochodowe / Układ zawieszenia / Sprężyny zawieszenia",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260730) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Stabilizatory i elementy"
    ],
    "hierarchy": "(260730) Motoryzacja / Części samochodowe / Układ zawieszenia / Stabilizatory i elementy / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Drążki stabilizatora",
    "categoryPath": [
      "(250876) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Stabilizatory i elementy"
    ],
    "hierarchy": "(250876) Motoryzacja / Części samochodowe / Układ zawieszenia / Stabilizatory i elementy / Drążki stabilizatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gumy drążków stabilizatora",
    "categoryPath": [
      "(250877) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Stabilizatory i elementy"
    ],
    "hierarchy": "(250877) Motoryzacja / Części samochodowe / Układ zawieszenia / Stabilizatory i elementy / Gumy drążków stabilizatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łączniki drążków stabilizatora",
    "categoryPath": [
      "(250878) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Stabilizatory i elementy"
    ],
    "hierarchy": "(250878) Motoryzacja / Części samochodowe / Układ zawieszenia / Stabilizatory i elementy / Łączniki drążków stabilizatora",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260729) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Wahacze i elementy"
    ],
    "hierarchy": "(260729) Motoryzacja / Części samochodowe / Układ zawieszenia / Wahacze i elementy / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sworznie wahaczy",
    "categoryPath": [
      "(250883) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Wahacze i elementy"
    ],
    "hierarchy": "(250883) Motoryzacja / Części samochodowe / Układ zawieszenia / Wahacze i elementy / Sworznie wahaczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tuleje wahaczy",
    "categoryPath": [
      "(250884) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Wahacze i elementy"
    ],
    "hierarchy": "(250884) Motoryzacja / Części samochodowe / Układ zawieszenia / Wahacze i elementy / Tuleje wahaczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wahacze",
    "categoryPath": [
      "(250885) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Wahacze i elementy"
    ],
    "hierarchy": "(250885) Motoryzacja / Części samochodowe / Układ zawieszenia / Wahacze i elementy / Wahacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Amortyzator",
    "categoryPath": [
      "(260727) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(260727) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Amortyzator",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(260722) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(260722) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompresory",
    "categoryPath": [
      "(256099) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(256099) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Kompresory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poduszki i miechy",
    "categoryPath": [
      "(256100) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(256100) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Poduszki i miechy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256101) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(256101) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sfery, gruszki",
    "categoryPath": [
      "(256098) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(256098) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Sfery, gruszki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Sterowniki",
    "categoryPath": [
      "(261082) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(261082) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Sterowniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(260725) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia",
      "Zawieszenie hydrauliczne i pneumatyczne"
    ],
    "hierarchy": "(260725) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie hydrauliczne i pneumatyczne / Zawory",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawieszenie kabiny kierowcy",
    "categoryPath": [
      "(260726) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(260726) Motoryzacja / Części samochodowe / Układ zawieszenia / Zawieszenie kabiny kierowcy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy zawieszenia (amortyzatory i sprężyny)",
    "categoryPath": [
      "(258702) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(258702) Motoryzacja / Części samochodowe / Układ zawieszenia / Zestawy zawieszenia (amortyzatory i sprężyny)",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zwrotnice",
    "categoryPath": [
      "(250902) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(250902) Motoryzacja / Części samochodowe / Układ zawieszenia / Zwrotnice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łożyska i piasty kół",
    "categoryPath": [
      "(18962) Motoryzacja",
      "Części samochodowe",
      "Układ zawieszenia"
    ],
    "hierarchy": "(18962) Motoryzacja / Części samochodowe / Układ zawieszenia / Łożyska i piasty kół",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki deszczu",
    "categoryPath": [
      "(256139) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(256139) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Czujniki deszczu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części montażowe",
    "categoryPath": [
      "(261223) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(261223) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Części montażowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dysze spryskiwaczy",
    "categoryPath": [
      "(254180) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254180) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Dysze spryskiwaczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Korki zbiornika",
    "categoryPath": [
      "(261225) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(261225) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Korki zbiornika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mechanizmy wycieraczek",
    "categoryPath": [
      "(254181) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254181) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Mechanizmy wycieraczek",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompki spryskiwaczy",
    "categoryPath": [
      "(254183) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254183) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Pompki spryskiwaczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(254188) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254188) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przewody, złączki",
    "categoryPath": [
      "(261224) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(261224) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Przewody, złączki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ramiona wycieraczek",
    "categoryPath": [
      "(254184) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254184) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Ramiona wycieraczek",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Silniki wycieraczek",
    "categoryPath": [
      "(254185) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254185) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Silniki wycieraczek",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Spryskiwacze reflektorów",
    "categoryPath": [
      "(254186) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254186) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Spryskiwacze reflektorów",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki",
    "categoryPath": [
      "(261226) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(261226) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Uszczelki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki płynu do spryskiwaczy",
    "categoryPath": [
      "(254187) Motoryzacja",
      "Części samochodowe",
      "Wycieraczki i spryskiwacze"
    ],
    "hierarchy": "(254187) Motoryzacja / Części samochodowe / Wycieraczki i spryskiwacze / Zbiorniki płynu do spryskiwaczy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Boczki bagażnika",
    "categoryPath": [
      "(256104) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(256104) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Boczki bagażnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Boczki drzwi",
    "categoryPath": [
      "(256035) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(256035) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Boczki drzwi",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Części kabiny kierowcy",
    "categoryPath": [
      "(261302) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(261302) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Części kabiny kierowcy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Deski rozdzielcze, konsole",
    "categoryPath": [
      "(18886) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18886) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Deski rozdzielcze, konsole",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Elementy mocujące",
    "categoryPath": [
      "(250282) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250282) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Elementy mocujące",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Fotele, kanapy",
    "categoryPath": [
      "(8682) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(8682) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Fotele, kanapy",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gałki",
    "categoryPath": [
      "(256029) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Gałki i mieszki"
    ],
    "hierarchy": "(256029) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Gałki i mieszki / Gałki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(256031) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Gałki i mieszki"
    ],
    "hierarchy": "(256031) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Gałki i mieszki / Komplety",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mieszki",
    "categoryPath": [
      "(256030) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Gałki i mieszki"
    ],
    "hierarchy": "(256030) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Gałki i mieszki / Mieszki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(4133) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(4133) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Kierownice",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klamki wewnętrzne",
    "categoryPath": [
      "(250222) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250222) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Klamki wewnętrzne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Korbki szyb",
    "categoryPath": [
      "(252814) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(252814) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Korbki szyb",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Kratki nawiewu",
    "categoryPath": [
      "(147885) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(147885) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Kratki nawiewu",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Liczniki, zegary",
    "categoryPath": [
      "(4134) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(4134) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Liczniki, zegary",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lusterka wewnętrzne",
    "categoryPath": [
      "(18888) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18888) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Lusterka wewnętrzne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mocowanie koła zapasowego",
    "categoryPath": [
      "(261303) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(261303) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Mocowanie koła zapasowego",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nawigacje GPS fabryczne",
    "categoryPath": [
      "(250553) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250553) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Nawigacje GPS fabryczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony przeciwsłoneczne",
    "categoryPath": [
      "(250224) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250224) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Osłony przeciwsłoneczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony, zaślepki",
    "categoryPath": [
      "(250302) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250302) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Osłony, zaślepki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oświetlenie kabiny",
    "categoryPath": [
      "(18891) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18891) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Oświetlenie kabiny",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Panele sterowania, przełączniki",
    "categoryPath": [
      "(18892) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18892) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Panele sterowania, przełączniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pasy bezpieczeństwa",
    "categoryPath": [
      "(18894) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18894) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Pasy bezpieczeństwa",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pedały",
    "categoryPath": [
      "(250243) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250243) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Pedały",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podsufitki",
    "categoryPath": [
      "(18895) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18895) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Podsufitki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poduszki powietrzne",
    "categoryPath": [
      "(18896) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18896) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Poduszki powietrzne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podłokietniki",
    "categoryPath": [
      "(18893) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18893) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Podłokietniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Popielniczki",
    "categoryPath": [
      "(250223) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250223) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Popielniczki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Poszycia słupków",
    "categoryPath": [
      "(256105) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(256105) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Poszycia słupków",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(4132) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(4132) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Półki tylne",
    "categoryPath": [
      "(18897) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18897) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Półki tylne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rolety bagażnika",
    "categoryPath": [
      "(18898) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18898) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Rolety bagażnika",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Schowki, półki",
    "categoryPath": [
      "(250242) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250242) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Schowki, półki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(250550) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Sprzęt audio fabryczny"
    ],
    "hierarchy": "(250550) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Sprzęt audio fabryczny / Głośniki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(250552) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Sprzęt audio fabryczny"
    ],
    "hierarchy": "(250552) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Sprzęt audio fabryczny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Radioodtwarzacze",
    "categoryPath": [
      "(250548) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Sprzęt audio fabryczny"
    ],
    "hierarchy": "(250548) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Sprzęt audio fabryczny / Radioodtwarzacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wzmacniacze",
    "categoryPath": [
      "(250549) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Sprzęt audio fabryczny"
    ],
    "hierarchy": "(250549) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Sprzęt audio fabryczny / Wzmacniacze",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zmieniarki CD",
    "categoryPath": [
      "(250551) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza",
      "Sprzęt audio fabryczny"
    ],
    "hierarchy": "(250551) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Sprzęt audio fabryczny / Zmieniarki CD",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprężyny gazowe",
    "categoryPath": [
      "(261081) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(261081) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Sprężyny gazowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tunele środkowe",
    "categoryPath": [
      "(256032) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(256032) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Tunele środkowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uchwyty fabryczne",
    "categoryPath": [
      "(250285) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(250285) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Uchwyty fabryczne",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wykładzina",
    "categoryPath": [
      "(256034) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(256034) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Wykładzina",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zagłówki",
    "categoryPath": [
      "(18900) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18900) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Zagłówki",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Zapalniczki samochodowe",
    "categoryPath": [
      "(18901) Motoryzacja",
      "Części samochodowe",
      "Wyposażenie wnętrza"
    ],
    "hierarchy": "(18901) Motoryzacja / Części samochodowe / Wyposażenie wnętrza / Zapalniczki samochodowe",
    "comissionGroupOld": "C30",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Babki, kowadełka",
    "categoryPath": [
      "(259535) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259535) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Babki, kowadełka",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Haki",
    "categoryPath": [
      "(261638) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(261638) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Haki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Folie maskujące",
    "categoryPath": [
      "(259741) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Maskowanie"
    ],
    "hierarchy": "(259741) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Maskowanie / Folie maskujące",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Papier maskujący",
    "categoryPath": [
      "(259742) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Maskowanie"
    ],
    "hierarchy": "(259742) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Maskowanie / Papier maskujący",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Taśmy maskujące",
    "categoryPath": [
      "(259743) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Maskowanie"
    ],
    "hierarchy": "(259743) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Maskowanie / Taśmy maskujące",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filc polerski",
    "categoryPath": [
      "(259744) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Materiały ścierne"
    ],
    "hierarchy": "(259744) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Materiały ścierne / Filc polerski",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klocki szlifierskie",
    "categoryPath": [
      "(259746) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Materiały ścierne"
    ],
    "hierarchy": "(259746) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Materiały ścierne / Klocki szlifierskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Papier ścierny",
    "categoryPath": [
      "(259747) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Materiały ścierne"
    ],
    "hierarchy": "(259747) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Materiały ścierne / Papier ścierny",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Piasek do piaskowania",
    "categoryPath": [
      "(311857) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Materiały ścierne"
    ],
    "hierarchy": "(311857) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Materiały ścierne / Piasek do piaskowania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259750) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Materiały ścierne"
    ],
    "hierarchy": "(259750) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Materiały ścierne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Włóknina ścierna",
    "categoryPath": [
      "(259748) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Materiały ścierne"
    ],
    "hierarchy": "(259748) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Materiały ścierne / Włóknina ścierna",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściernice",
    "categoryPath": [
      "(259749) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Materiały ścierne"
    ],
    "hierarchy": "(259749) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Materiały ścierne / Ściernice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtry lakiernicze",
    "categoryPath": [
      "(259751) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Mieszanie lakieru"
    ],
    "hierarchy": "(259751) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Mieszanie lakieru / Filtry lakiernicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kubki lakiernicze",
    "categoryPath": [
      "(259752) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Mieszanie lakieru"
    ],
    "hierarchy": "(259752) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Mieszanie lakieru / Kubki lakiernicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Mieszadła do lakieru",
    "categoryPath": [
      "(259753) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Mieszanie lakieru"
    ],
    "hierarchy": "(259753) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Mieszanie lakieru / Mieszadła do lakieru",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Młotki bezwładnościowe",
    "categoryPath": [
      "(259539) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259539) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Młotki bezwładnościowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Młotki blacharskie",
    "categoryPath": [
      "(259540) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259540) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Młotki blacharskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Młotki pneumatyczne",
    "categoryPath": [
      "(259579) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259579) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Młotki pneumatyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia i zestawy do usuwania wgnieceń",
    "categoryPath": [
      "(319947) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(319947) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Narzędzia i zestawy do usuwania wgnieceń",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nitownice",
    "categoryPath": [
      "(322051) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(322051) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Nitownice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki do demontażu",
    "categoryPath": [
      "(259755) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Obsługa szyb"
    ],
    "hierarchy": "(259755) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Obsługa szyb / Linki do demontażu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Noże do szyb",
    "categoryPath": [
      "(259756) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Obsługa szyb"
    ],
    "hierarchy": "(259756) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Obsługa szyb / Noże do szyb",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uchwyty do szyb",
    "categoryPath": [
      "(259758) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Obsługa szyb"
    ],
    "hierarchy": "(259758) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Obsługa szyb / Uchwyty do szyb",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągacze wycieraczek",
    "categoryPath": [
      "(259757) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo",
      "Obsługa szyb"
    ],
    "hierarchy": "(259757) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Obsługa szyb / Ściągacze wycieraczek",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pistolety do piaskowania",
    "categoryPath": [
      "(259543) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259543) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Pistolety do piaskowania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pistolety lakiernicze",
    "categoryPath": [
      "(259544) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259544) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Pistolety lakiernicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259553) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259553) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prasy",
    "categoryPath": [
      "(259545) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259545) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Prasy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pręty blacharskie",
    "categoryPath": [
      "(259546) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259546) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Pręty blacharskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Ramy blacharskie",
    "categoryPath": [
      "(259547) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259547) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Ramy blacharskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozpieraki",
    "categoryPath": [
      "(259548) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259548) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Rozpieraki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stojaki lakiernicze",
    "categoryPath": [
      "(259549) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259549) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Stojaki lakiernicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczypce blacharskie",
    "categoryPath": [
      "(259550) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259550) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Szczypce blacharskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szpachelki blacharskie",
    "categoryPath": [
      "(259551) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259551) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Szpachelki blacharskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łyżki blacharskie",
    "categoryPath": [
      "(259552) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Blacharstwo i lakiernictwo"
    ],
    "hierarchy": "(259552) Motoryzacja / Narzędzia i sprzęt warsztatowy / Blacharstwo i lakiernictwo / Łyżki blacharskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Analizatory spalin",
    "categoryPath": [
      "(259554) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259554) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Analizatory spalin",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Endoskopy",
    "categoryPath": [
      "(259556) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259556) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Endoskopy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kątomierze",
    "categoryPath": [
      "(259557) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259557) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Kątomierze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lusterka inspekcyjne",
    "categoryPath": [
      "(259558) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259558) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Lusterka inspekcyjne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Miarki",
    "categoryPath": [
      "(259559) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259559) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Miarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mierniki ciśnienia",
    "categoryPath": [
      "(259560) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259560) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Mierniki ciśnienia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mierniki grubości lakieru",
    "categoryPath": [
      "(259561) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259561) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Mierniki grubości lakieru",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Multimetry",
    "categoryPath": [
      "(259563) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259563) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Multimetry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Oprogramowanie",
    "categoryPath": [
      "(261641) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(261641) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Oprogramowanie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28411) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(28411) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stetoskopy",
    "categoryPath": [
      "(259565) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259565) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Stetoskopy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczelinomierze",
    "categoryPath": [
      "(259567) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259567) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Szczelinomierze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Termometry, pirometry",
    "categoryPath": [
      "(259568) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259568) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Termometry, pirometry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery geometrii kół",
    "categoryPath": [
      "(261661) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(261661) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Testery geometrii kół",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery i interfejsy diagnostyczne",
    "categoryPath": [
      "(28413) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(28413) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Testery i interfejsy diagnostyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery płynu chłodniczego",
    "categoryPath": [
      "(259569) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Diagnostyka i pomiary"
    ],
    "hierarchy": "(259569) Motoryzacja / Narzędzia i sprzęt warsztatowy / Diagnostyka i pomiary / Testery płynu chłodniczego",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze udarowe",
    "categoryPath": [
      "(322022) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy"
    ],
    "hierarchy": "(322022) Motoryzacja / Narzędzia i sprzęt warsztatowy / Klucze udarowe",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Filtroreduktory",
    "categoryPath": [
      "(259570) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(259570) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Filtroreduktory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kompresory",
    "categoryPath": [
      "(252276) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(252276) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Kompresory",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pistolety pneumatyczne",
    "categoryPath": [
      "(259581) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(259581) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Pistolety pneumatyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252275) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(252275) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szybkozłączki pneumatyczne",
    "categoryPath": [
      "(259572) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(259572) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Szybkozłączki pneumatyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyłączniki ciśnieniowe",
    "categoryPath": [
      "(259574) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(259574) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Wyłączniki ciśnieniowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Węże pneumatyczne",
    "categoryPath": [
      "(259573) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(259573) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Węże pneumatyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Zawory do kompresorów",
    "categoryPath": [
      "(259575) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(259575) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Zawory do kompresorów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zbiorniki kompresorów",
    "categoryPath": [
      "(305529) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Kompresory i akcesoria"
    ],
    "hierarchy": "(305529) Motoryzacja / Narzędzia i sprzęt warsztatowy / Kompresory i akcesoria / Zbiorniki kompresorów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Myjnie parowe",
    "categoryPath": [
      "(252283) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Mycie i czyszczenie"
    ],
    "hierarchy": "(252283) Motoryzacja / Narzędzia i sprzęt warsztatowy / Mycie i czyszczenie / Myjnie parowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odkurzacze",
    "categoryPath": [
      "(252284) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Mycie i czyszczenie"
    ],
    "hierarchy": "(252284) Motoryzacja / Narzędzia i sprzęt warsztatowy / Mycie i czyszczenie / Odkurzacze",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252278) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Mycie i czyszczenie"
    ],
    "hierarchy": "(252278) Motoryzacja / Narzędzia i sprzęt warsztatowy / Mycie i czyszczenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(252287) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Mycie i czyszczenie"
    ],
    "hierarchy": "(252287) Motoryzacja / Narzędzia i sprzęt warsztatowy / Mycie i czyszczenie / Szczotki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągaczki do wody",
    "categoryPath": [
      "(252290) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Mycie i czyszczenie"
    ],
    "hierarchy": "(252290) Motoryzacja / Narzędzia i sprzęt warsztatowy / Mycie i czyszczenie / Ściągaczki do wody",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Imbusy (HEX)",
    "categoryPath": [
      "(252646) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Bity"
    ],
    "hierarchy": "(252646) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Bity / Imbusy (HEX)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Krzyżakowe (Philips PH)",
    "categoryPath": [
      "(252647) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Bity"
    ],
    "hierarchy": "(252647) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Bity / Krzyżakowe (Philips PH)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozidriv PZ",
    "categoryPath": [
      "(252648) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Bity"
    ],
    "hierarchy": "(252648) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Bity / Pozidriv PZ",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płaskie",
    "categoryPath": [
      "(252649) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Bity"
    ],
    "hierarchy": "(252649) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Bity / Płaskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Torx",
    "categoryPath": [
      "(252650) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Bity"
    ],
    "hierarchy": "(252650) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Bity / Torx",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uchwyty i adaptery",
    "categoryPath": [
      "(252645) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Bity"
    ],
    "hierarchy": "(252645) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Bity / Uchwyty i adaptery",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy mieszane",
    "categoryPath": [
      "(252651) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Bity"
    ],
    "hierarchy": "(252651) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Bity / Zestawy mieszane",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chwytaki",
    "categoryPath": [
      "(252625) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252625) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Chwytaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Cęgi",
    "categoryPath": [
      "(261640) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(261640) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Cęgi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gwintowniki",
    "categoryPath": [
      "(252628) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252628) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Gwintowniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Klucze",
    "categoryPath": [
      "(321505) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(321505) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Klucze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Młotki",
    "categoryPath": [
      "(252631) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252631) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Młotki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Noże",
    "categoryPath": [
      "(252634) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252634) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Noże",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pilniki",
    "categoryPath": [
      "(252635) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252635) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Pilniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252623) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252623) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przecinaki, punktaki, wybijaki",
    "categoryPath": [
      "(252637) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252637) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Przecinaki, punktaki, wybijaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczotki druciane",
    "categoryPath": [
      "(252638) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252638) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Szczotki druciane",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Do pierścieni Segera",
    "categoryPath": [
      "(252684) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Szczypce, kombinerki"
    ],
    "hierarchy": "(252684) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Szczypce, kombinerki / Do pierścieni Segera",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nastawne",
    "categoryPath": [
      "(252685) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Szczypce, kombinerki"
    ],
    "hierarchy": "(252685) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Szczypce, kombinerki / Nastawne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252683) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Szczypce, kombinerki"
    ],
    "hierarchy": "(252683) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Szczypce, kombinerki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tnące",
    "categoryPath": [
      "(252686) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Szczypce, kombinerki"
    ],
    "hierarchy": "(252686) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Szczypce, kombinerki / Tnące",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uniwersalne (kombinerki)",
    "categoryPath": [
      "(252687) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Szczypce, kombinerki"
    ],
    "hierarchy": "(252687) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Szczypce, kombinerki / Uniwersalne (kombinerki)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zaciskowe",
    "categoryPath": [
      "(252688) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Szczypce, kombinerki"
    ],
    "hierarchy": "(252688) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Szczypce, kombinerki / Zaciskowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Imbusy (HEX)",
    "categoryPath": [
      "(252690) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252690) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Imbusy (HEX)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Krzyżakowe (Philips PH)",
    "categoryPath": [
      "(252691) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252691) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Krzyżakowe (Philips PH)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozidriv PZ",
    "categoryPath": [
      "(252692) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252692) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Pozidriv PZ",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252689) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252689) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Precyzyjne",
    "categoryPath": [
      "(252693) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252693) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Precyzyjne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Płaskie",
    "categoryPath": [
      "(252694) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252694) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Płaskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Torx",
    "categoryPath": [
      "(252695) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252695) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Torx",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy mieszane",
    "categoryPath": [
      "(252696) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne",
      "Wkrętaki (śrubokręty)"
    ],
    "hierarchy": "(252696) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Wkrętaki (śrubokręty) / Zestawy mieszane",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy narzędzi",
    "categoryPath": [
      "(252642) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252642) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Zestawy narzędzi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łyżki, dźwignie, łomy",
    "categoryPath": [
      "(252643) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(252643) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Łyżki, dźwignie, łomy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągacze",
    "categoryPath": [
      "(260956) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Narzędzia ręczne"
    ],
    "hierarchy": "(260956) Motoryzacja / Narzędzia i sprzęt warsztatowy / Narzędzia ręczne / Ściągacze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Adaptery",
    "categoryPath": [
      "(261549) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(261549) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Adaptery",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bezpieczniki",
    "categoryPath": [
      "(259778) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259778) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Bezpieczniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kalamitki",
    "categoryPath": [
      "(259603) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259603) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Kalamitki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Konektory",
    "categoryPath": [
      "(259605) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259605) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Konektory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kołki",
    "categoryPath": [
      "(259604) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259604) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Kołki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakrętki",
    "categoryPath": [
      "(252291) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(252291) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Nakrętki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nity",
    "categoryPath": [
      "(259606) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259606) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Nity",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Opaski zaciskowe",
    "categoryPath": [
      "(252292) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(252292) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Opaski zaciskowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pierścienie",
    "categoryPath": [
      "(252293) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(252293) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Pierścienie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podkładki",
    "categoryPath": [
      "(252294) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(252294) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Podkładki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przewody",
    "categoryPath": [
      "(261550) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(261550) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Przewody",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Spinki",
    "categoryPath": [
      "(259607) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259607) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Spinki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Sprężynki",
    "categoryPath": [
      "(259608) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259608) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Sprężynki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uszczelki, oringi",
    "categoryPath": [
      "(28419) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(28419) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Uszczelki, oringi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wkręty",
    "categoryPath": [
      "(259609) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(259609) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Wkręty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zawleczki",
    "categoryPath": [
      "(252295) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(252295) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Zawleczki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Złączki",
    "categoryPath": [
      "(261298) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(261298) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Złączki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Śruby",
    "categoryPath": [
      "(28420) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Normalia"
    ],
    "hierarchy": "(28420) Motoryzacja / Narzędzia i sprzęt warsztatowy / Normalia / Śruby",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do demontażu alternatora",
    "categoryPath": [
      "(261153) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(261153) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Klucze do demontażu alternatora",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do świec",
    "categoryPath": [
      "(259636) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259636) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Klucze do świec",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy stroboskopowe",
    "categoryPath": [
      "(259637) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259637) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Lampy stroboskopowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do cewek zapłonowych",
    "categoryPath": [
      "(259638) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259638) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Narzędzia do cewek zapłonowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Narzędzia do demontażu świec",
    "categoryPath": [
      "(259639) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259639) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Narzędzia do demontażu świec",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259646) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259646) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prostowniki",
    "categoryPath": [
      "(259640) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259640) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Prostowniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Prostowniki z rozruchem",
    "categoryPath": [
      "(259641) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259641) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Prostowniki z rozruchem",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Regeneracja gwintów świec",
    "categoryPath": [
      "(259642) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259642) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Regeneracja gwintów świec",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szczypce do świec",
    "categoryPath": [
      "(259643) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259643) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Szczypce do świec",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery akumulatorów",
    "categoryPath": [
      "(259644) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259644) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Testery akumulatorów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Urządzenia rozruchowe (boostery)",
    "categoryPath": [
      "(259645) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa akumulatorów i układu elektrycznego"
    ],
    "hierarchy": "(259645) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa akumulatorów i układu elektrycznego / Urządzenia rozruchowe (boostery)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Generatory ozonu",
    "categoryPath": [
      "(259611) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa klimatyzacji"
    ],
    "hierarchy": "(259611) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa klimatyzacji / Generatory ozonu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do obsługi klimatyzacji",
    "categoryPath": [
      "(259612) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa klimatyzacji"
    ],
    "hierarchy": "(259612) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa klimatyzacji / Klucze do obsługi klimatyzacji",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259615) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa klimatyzacji"
    ],
    "hierarchy": "(259615) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa klimatyzacji / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stacje klimatyzacji",
    "categoryPath": [
      "(259613) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa klimatyzacji"
    ],
    "hierarchy": "(259613) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa klimatyzacji / Stacje klimatyzacji",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery szczelności",
    "categoryPath": [
      "(259614) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa klimatyzacji"
    ],
    "hierarchy": "(259614) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa klimatyzacji / Testery szczelności",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ciężarki do felg",
    "categoryPath": [
      "(259617) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259617) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Ciężarki do felg",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ciśnieniomierze do kół",
    "categoryPath": [
      "(259618) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259618) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Ciśnieniomierze do kół",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Inflatory",
    "categoryPath": [
      "(259619) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259619) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Inflatory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do kół",
    "categoryPath": [
      "(259620) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259620) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Klucze do kół",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mierniki głębokości bieżnika",
    "categoryPath": [
      "(259623) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259623) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Mierniki głębokości bieżnika",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Montażownice",
    "categoryPath": [
      "(259624) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259624) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Montażownice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nastawianie kół",
    "categoryPath": [
      "(260732) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(260732) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Nastawianie kół",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259628) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259628) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prostowarki do felg",
    "categoryPath": [
      "(305541) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(305541) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Prostowarki do felg",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Przechowywanie opon",
    "categoryPath": [
      "(259954) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259954) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Przechowywanie opon",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Worki na opony",
    "categoryPath": [
      "(320930) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(320930) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Worki na opony",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wulkanizatory",
    "categoryPath": [
      "(305577) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(305577) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Wulkanizatory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyważarki do kół",
    "categoryPath": [
      "(259626) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259626) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Wyważarki do kół",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze",
    "categoryPath": [
      "(259627) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259627) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Zestawy naprawcze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łatki do ogumienia",
    "categoryPath": [
      "(259622) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(259622) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Łatki do ogumienia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łyżki do opon",
    "categoryPath": [
      "(261642) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa kół i ogumienia"
    ],
    "hierarchy": "(261642) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa kół i ogumienia / Łyżki do opon",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do filtrów oleju",
    "categoryPath": [
      "(302745) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(302745) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Klucze do filtrów oleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do filtrów paliwa",
    "categoryPath": [
      "(261090) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(261090) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Klucze do filtrów paliwa",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Klucze do korków oleju",
    "categoryPath": [
      "(259659) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259659) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Klucze do korków oleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Konewki do oleju",
    "categoryPath": [
      "(259660) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259660) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Konewki do oleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Miski i wanny zlewowe",
    "categoryPath": [
      "(259662) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259662) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Miski i wanny zlewowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Napełniacze do oleju",
    "categoryPath": [
      "(259663) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259663) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Napełniacze do oleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Obsługa AdBlue",
    "categoryPath": [
      "(259664) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259664) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Obsługa AdBlue",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pistolety do paliw i oleju",
    "categoryPath": [
      "(259665) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259665) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Pistolety do paliw i oleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy elektryczne i pneumatyczne",
    "categoryPath": [
      "(259786) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów",
      "Pompy do oleju"
    ],
    "hierarchy": "(259786) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Pompy do oleju / Pompy elektryczne i pneumatyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy ręczne",
    "categoryPath": [
      "(259785) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów",
      "Pompy do oleju"
    ],
    "hierarchy": "(259785) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Pompy do oleju / Pompy ręczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompy do paliw",
    "categoryPath": [
      "(259667) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259667) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Pompy do paliw",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Smarownice",
    "categoryPath": [
      "(259668) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259668) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Smarownice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wysysarki",
    "categoryPath": [
      "(259669) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259669) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Wysysarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy naprawcze gniazd korków oleju",
    "categoryPath": [
      "(259670) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259670) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Zestawy naprawcze gniazd korków oleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zlewarki",
    "categoryPath": [
      "(259671) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259671) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Zlewarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zlewarko-wysysarki",
    "categoryPath": [
      "(259672) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa olejów, paliw i smarów"
    ],
    "hierarchy": "(259672) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa olejów, paliw i smarów / Zlewarko-wysysarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kable do ładowania pojazdów elektrycznych",
    "categoryPath": [
      "(322397) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa pojazdów elektrycznych"
    ],
    "hierarchy": "(322397) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa pojazdów elektrycznych / Kable do ładowania pojazdów elektrycznych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Osprzęt do ładowania pojazdów elektrycznych",
    "categoryPath": [
      "(322399) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa pojazdów elektrycznych"
    ],
    "hierarchy": "(322399) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa pojazdów elektrycznych / Osprzęt do ładowania pojazdów elektrycznych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Stacje ładowania pojazdów elektrycznych",
    "categoryPath": [
      "(261151) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa pojazdów elektrycznych"
    ],
    "hierarchy": "(261151) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa pojazdów elektrycznych / Stacje ładowania pojazdów elektrycznych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blokady wału korbowego",
    "categoryPath": [
      "(261629) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika"
    ],
    "hierarchy": "(261629) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Blokady wału korbowego",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Honownice",
    "categoryPath": [
      "(259674) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika"
    ],
    "hierarchy": "(259674) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Honownice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do sprężyn zaworowych",
    "categoryPath": [
      "(259675) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika"
    ],
    "hierarchy": "(259675) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Narzędzia do sprężyn zaworowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do tłoków",
    "categoryPath": [
      "(259676) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika"
    ],
    "hierarchy": "(259676) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Narzędzia do tłoków",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do uszczelniaczy",
    "categoryPath": [
      "(259631) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika"
    ],
    "hierarchy": "(259631) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Narzędzia do uszczelniaczy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259634) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika"
    ],
    "hierarchy": "(259634) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259792) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika",
      "Testery i próbniki"
    ],
    "hierarchy": "(259792) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Testery i próbniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Próbniki ciśnienia oleju",
    "categoryPath": [
      "(259787) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika",
      "Testery i próbniki"
    ],
    "hierarchy": "(259787) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Testery i próbniki / Próbniki ciśnienia oleju",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Próbniki ciśnienia sprężania",
    "categoryPath": [
      "(259788) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika",
      "Testery i próbniki"
    ],
    "hierarchy": "(259788) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Testery i próbniki / Próbniki ciśnienia sprężania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Próbniki szczelności cylindrów",
    "categoryPath": [
      "(259789) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika",
      "Testery i próbniki"
    ],
    "hierarchy": "(259789) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Testery i próbniki / Próbniki szczelności cylindrów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Próbniki szczelności uszczelek głowicy",
    "categoryPath": [
      "(259790) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika",
      "Testery i próbniki"
    ],
    "hierarchy": "(259790) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Testery i próbniki / Próbniki szczelności uszczelek głowicy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery wtryskiwaczy",
    "categoryPath": [
      "(259791) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika",
      "Testery i próbniki"
    ],
    "hierarchy": "(259791) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Testery i próbniki / Testery wtryskiwaczy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągacze do wtryskiwaczy",
    "categoryPath": [
      "(259633) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa silnika"
    ],
    "hierarchy": "(259633) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa silnika / Ściągacze do wtryskiwaczy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Giętarki",
    "categoryPath": [
      "(259677) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(259677) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Giętarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do przewodów hamulcowych",
    "categoryPath": [
      "(259678) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(259678) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Klucze do przewodów hamulcowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do szczęk hamulcowych",
    "categoryPath": [
      "(260613) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(260613) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Narzędzia do szczęk hamulcowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do tłoczków hamulcowych",
    "categoryPath": [
      "(259679) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(259679) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Narzędzia do tłoczków hamulcowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do zacisków hamulcowych",
    "categoryPath": [
      "(259680) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(259680) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Narzędzia do zacisków hamulcowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do zarabiania przewodów",
    "categoryPath": [
      "(259681) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(259681) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Narzędzia do zarabiania przewodów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Testery płynu hamulcowego",
    "categoryPath": [
      "(259682) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(259682) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Testery płynu hamulcowego",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wymiana i odpowietrzanie płynu",
    "categoryPath": [
      "(259683) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu hamulcowego"
    ],
    "hierarchy": "(259683) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu hamulcowego / Wymiana i odpowietrzanie płynu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259795) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego",
      "Narzędzia do przegubów"
    ],
    "hierarchy": "(259795) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do przegubów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szczypce do opasek przegubów",
    "categoryPath": [
      "(259794) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego",
      "Narzędzia do przegubów"
    ],
    "hierarchy": "(259794) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do przegubów / Szczypce do opasek przegubów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągacze do przegubów",
    "categoryPath": [
      "(259793) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego",
      "Narzędzia do przegubów"
    ],
    "hierarchy": "(259793) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do przegubów / Ściągacze do przegubów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blokady rozrządu",
    "categoryPath": [
      "(259798) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego",
      "Narzędzia do rozrządu"
    ],
    "hierarchy": "(259798) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do rozrządu / Blokady rozrządu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klucze do rozrządu",
    "categoryPath": [
      "(259797) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego",
      "Narzędzia do rozrządu"
    ],
    "hierarchy": "(259797) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do rozrządu / Klucze do rozrządu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259799) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego",
      "Narzędzia do rozrządu"
    ],
    "hierarchy": "(259799) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do rozrządu / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ściągacze do rozrządu",
    "categoryPath": [
      "(259796) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego",
      "Narzędzia do rozrządu"
    ],
    "hierarchy": "(259796) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do rozrządu / Ściągacze do rozrządu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do skrzyni biegów",
    "categoryPath": [
      "(259687) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego"
    ],
    "hierarchy": "(259687) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do skrzyni biegów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do sprzęgła",
    "categoryPath": [
      "(259688) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego"
    ],
    "hierarchy": "(259688) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do sprzęgła",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Narzędzia do wału napędowego",
    "categoryPath": [
      "(260919) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego"
    ],
    "hierarchy": "(260919) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Narzędzia do wału napędowego",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zakuwarki do łańcuchów",
    "categoryPath": [
      "(260717) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa układu napędowego"
    ],
    "hierarchy": "(260717) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa układu napędowego / Zakuwarki do łańcuchów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do amortyzatorów",
    "categoryPath": [
      "(259690) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa zawieszenia"
    ],
    "hierarchy": "(259690) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa zawieszenia / Narzędzia do amortyzatorów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Narzędzia do wahaczy i tulei",
    "categoryPath": [
      "(259691) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa zawieszenia"
    ],
    "hierarchy": "(259691) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa zawieszenia / Narzędzia do wahaczy i tulei",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągacze do sprężyn",
    "categoryPath": [
      "(259692) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa zawieszenia"
    ],
    "hierarchy": "(259692) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa zawieszenia / Ściągacze do sprężyn",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ściągacze do łożysk i piast",
    "categoryPath": [
      "(259693) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Obsługa zawieszenia"
    ],
    "hierarchy": "(259693) Motoryzacja / Narzędzia i sprzęt warsztatowy / Obsługa zawieszenia / Ściągacze do łożysk i piast",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(252298) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Odzież i obuwie robocze"
    ],
    "hierarchy": "(252298) Motoryzacja / Narzędzia i sprzęt warsztatowy / Odzież i obuwie robocze / Bluzy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(252299) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Odzież i obuwie robocze"
    ],
    "hierarchy": "(252299) Motoryzacja / Narzędzia i sprzęt warsztatowy / Odzież i obuwie robocze / Kamizelki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Maski lakiernicze",
    "categoryPath": [
      "(252303) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Odzież i obuwie robocze"
    ],
    "hierarchy": "(252303) Motoryzacja / Narzędzia i sprzęt warsztatowy / Odzież i obuwie robocze / Maski lakiernicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(252305) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Odzież i obuwie robocze"
    ],
    "hierarchy": "(252305) Motoryzacja / Narzędzia i sprzęt warsztatowy / Odzież i obuwie robocze / Obuwie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochrona głowy",
    "categoryPath": [
      "(252306) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Odzież i obuwie robocze"
    ],
    "hierarchy": "(252306) Motoryzacja / Narzędzia i sprzęt warsztatowy / Odzież i obuwie robocze / Ochrona głowy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(252309) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Odzież i obuwie robocze"
    ],
    "hierarchy": "(252309) Motoryzacja / Narzędzia i sprzęt warsztatowy / Odzież i obuwie robocze / Rękawice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bity udarowe",
    "categoryPath": [
      "(259760) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(259760) Motoryzacja / Narzędzia i sprzęt warsztatowy / Osprzęt do elektronarzędzi / Bity udarowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakładki polerskie",
    "categoryPath": [
      "(259762) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(259762) Motoryzacja / Narzędzia i sprzęt warsztatowy / Osprzęt do elektronarzędzi / Nakładki polerskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nasadki udarowe",
    "categoryPath": [
      "(322652) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(322652) Motoryzacja / Narzędzia i sprzęt warsztatowy / Osprzęt do elektronarzędzi / Nasadki udarowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259768) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(259768) Motoryzacja / Narzędzia i sprzęt warsztatowy / Osprzęt do elektronarzędzi / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szczotki szlifierskie",
    "categoryPath": [
      "(259806) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(259806) Motoryzacja / Narzędzia i sprzęt warsztatowy / Osprzęt do elektronarzędzi / Szczotki szlifierskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tarcze do cięcia",
    "categoryPath": [
      "(259765) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(259765) Motoryzacja / Narzędzia i sprzęt warsztatowy / Osprzęt do elektronarzędzi / Tarcze do cięcia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tarcze do szlifowania",
    "categoryPath": [
      "(259766) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Osprzęt do elektronarzędzi"
    ],
    "hierarchy": "(259766) Motoryzacja / Narzędzia i sprzęt warsztatowy / Osprzęt do elektronarzędzi / Tarcze do szlifowania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Polerki",
    "categoryPath": [
      "(322021) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy"
    ],
    "hierarchy": "(322021) Motoryzacja / Narzędzia i sprzęt warsztatowy / Polerki",
    "comissionGroupOld": "C32",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28463) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy"
    ],
    "hierarchy": "(28463) Motoryzacja / Narzędzia i sprzęt warsztatowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259932) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Szlifierki"
    ],
    "hierarchy": "(259932) Motoryzacja / Narzędzia i sprzęt warsztatowy / Szlifierki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szlifierki kątowe",
    "categoryPath": [
      "(259936) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Szlifierki"
    ],
    "hierarchy": "(259936) Motoryzacja / Narzędzia i sprzęt warsztatowy / Szlifierki / Szlifierki kątowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Szlifierki mimośrodowe",
    "categoryPath": [
      "(259937) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Szlifierki"
    ],
    "hierarchy": "(259937) Motoryzacja / Narzędzia i sprzęt warsztatowy / Szlifierki / Szlifierki mimośrodowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Szlifierki oscylacyjne",
    "categoryPath": [
      "(259930) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Szlifierki"
    ],
    "hierarchy": "(259930) Motoryzacja / Narzędzia i sprzęt warsztatowy / Szlifierki / Szlifierki oscylacyjne",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Szlifierki stołowe",
    "categoryPath": [
      "(259931) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Szlifierki"
    ],
    "hierarchy": "(259931) Motoryzacja / Narzędzia i sprzęt warsztatowy / Szlifierki / Szlifierki stołowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Szlifierki taśmowe",
    "categoryPath": [
      "(259938) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Szlifierki"
    ],
    "hierarchy": "(259938) Motoryzacja / Narzędzia i sprzęt warsztatowy / Szlifierki / Szlifierki taśmowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Szlifierki trzpieniowe",
    "categoryPath": [
      "(259935) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Szlifierki"
    ],
    "hierarchy": "(259935) Motoryzacja / Narzędzia i sprzęt warsztatowy / Szlifierki / Szlifierki trzpieniowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Wiertarki",
    "categoryPath": [
      "(322050) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wiertarki i wkrętarki"
    ],
    "hierarchy": "(322050) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wiertarki i wkrętarki / Wiertarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Wkrętaki udarowe",
    "categoryPath": [
      "(259585) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wiertarki i wkrętarki"
    ],
    "hierarchy": "(259585) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wiertarki i wkrętarki / Wkrętaki udarowe",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Wkrętarki",
    "categoryPath": [
      "(259924) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wiertarki i wkrętarki"
    ],
    "hierarchy": "(259924) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wiertarki i wkrętarki / Wkrętarki",
    "comissionGroupOld": "C9",
    "comissionGroupNew": "D26"
  },
  {
    "segment": "Leżanki",
    "categoryPath": [
      "(252373) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(252373) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Leżanki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Myjki do części",
    "categoryPath": [
      "(252380) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(252380) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Myjki do części",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osuszacze",
    "categoryPath": [
      "(252383) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Nagrzewnice, osuszacze"
    ],
    "hierarchy": "(252383) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Nagrzewnice, osuszacze / Osuszacze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Najazdy",
    "categoryPath": [
      "(261637) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(261637) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Najazdy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lampy warsztatowe",
    "categoryPath": [
      "(252386) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Oświetlenie"
    ],
    "hierarchy": "(252386) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Oświetlenie / Lampy warsztatowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Latarki czołowe",
    "categoryPath": [
      "(252387) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Oświetlenie"
    ],
    "hierarchy": "(252387) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Oświetlenie / Latarki czołowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Latarki ręczne",
    "categoryPath": [
      "(252388) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Oświetlenie"
    ],
    "hierarchy": "(252388) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Oświetlenie / Latarki ręczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252384) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Oświetlenie"
    ],
    "hierarchy": "(252384) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Oświetlenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Piaskarki",
    "categoryPath": [
      "(252389) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(252389) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Piaskarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osprzęt i akcesoria do podnośników",
    "categoryPath": [
      "(321958) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(321958) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Osprzęt i akcesoria do podnośników",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Podnośniki kolumnowe",
    "categoryPath": [
      "(259712) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259712) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Podnośniki kolumnowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnośniki nożycowe",
    "categoryPath": [
      "(259713) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259713) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Podnośniki nożycowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnośniki pneumatyczne",
    "categoryPath": [
      "(259714) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259714) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Podnośniki pneumatyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnośniki punktowe (żaby)",
    "categoryPath": [
      "(259708) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259708) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Podnośniki punktowe (żaby)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnośniki skrzyń biegów",
    "categoryPath": [
      "(259709) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259709) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Podnośniki skrzyń biegów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnośniki słupkowe (butelkowe)",
    "categoryPath": [
      "(259710) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259710) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Podnośniki słupkowe (butelkowe)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podnośniki trapezowe",
    "categoryPath": [
      "(259711) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259711) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Podnośniki trapezowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259715) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Podnośniki warsztatowe"
    ],
    "hierarchy": "(259715) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Podnośniki warsztatowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Na błotniki",
    "categoryPath": [
      "(252405) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Pokrowce"
    ],
    "hierarchy": "(252405) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Pokrowce / Na błotniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na fotele",
    "categoryPath": [
      "(252406) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Pokrowce"
    ],
    "hierarchy": "(252406) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Pokrowce / Na fotele",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252404) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Pokrowce"
    ],
    "hierarchy": "(252404) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Pokrowce / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28393) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(28393) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Regały",
    "categoryPath": [
      "(252375) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(252375) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Regały",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Druty, elektrody",
    "categoryPath": [
      "(252414) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Spawanie, zgrzewanie, cięcie plazmą"
    ],
    "hierarchy": "(252414) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Spawanie, zgrzewanie, cięcie plazmą / Druty, elektrody",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Spawarki do plastiku",
    "categoryPath": [
      "(259804) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Spawanie, zgrzewanie, cięcie plazmą"
    ],
    "hierarchy": "(259804) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Spawanie, zgrzewanie, cięcie plazmą / Spawarki do plastiku",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zgrzewarki",
    "categoryPath": [
      "(252416) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Spawanie, zgrzewanie, cięcie plazmą"
    ],
    "hierarchy": "(252416) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Spawanie, zgrzewanie, cięcie plazmą / Zgrzewarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Belki do silników",
    "categoryPath": [
      "(252392) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Stojaki, belki, żurawie"
    ],
    "hierarchy": "(252392) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Stojaki, belki, żurawie / Belki do silników",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Podpory (kobyłki)",
    "categoryPath": [
      "(252401) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Stojaki, belki, żurawie"
    ],
    "hierarchy": "(252401) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Stojaki, belki, żurawie / Podpory (kobyłki)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252391) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Stojaki, belki, żurawie"
    ],
    "hierarchy": "(252391) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Stojaki, belki, żurawie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rampy",
    "categoryPath": [
      "(259805) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Stojaki, belki, żurawie"
    ],
    "hierarchy": "(259805) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Stojaki, belki, żurawie / Rampy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stojaki i żurawie do silników",
    "categoryPath": [
      "(252402) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Stojaki, belki, żurawie"
    ],
    "hierarchy": "(252402) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Stojaki, belki, żurawie / Stojaki i żurawie do silników",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(252376) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(252376) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Stoły",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Szafy narzędziowe",
    "categoryPath": [
      "(252377) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(252377) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Szafy narzędziowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Taborety",
    "categoryPath": [
      "(252379) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(252379) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Taborety",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linowe elektryczne",
    "categoryPath": [
      "(252424) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Wyciągarki"
    ],
    "hierarchy": "(252424) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Wyciągarki / Linowe elektryczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linowe ręczne",
    "categoryPath": [
      "(252425) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Wyciągarki"
    ],
    "hierarchy": "(252425) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Wyciągarki / Linowe ręczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252423) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Wyciągarki"
    ],
    "hierarchy": "(252423) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Wyciągarki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Łańcuchowe",
    "categoryPath": [
      "(252426) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu",
      "Wyciągarki"
    ],
    "hierarchy": "(252426) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Wyciągarki / Łańcuchowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wózki transportowe i rolki do kół",
    "categoryPath": [
      "(261660) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wyposażenie warsztatu"
    ],
    "hierarchy": "(261660) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wyposażenie warsztatu / Wózki transportowe i rolki do kół",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pojemniki",
    "categoryPath": [
      "(252374) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wózki, skrzynki i organizery na narzędzia"
    ],
    "hierarchy": "(252374) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wózki, skrzynki i organizery na narzędzia / Pojemniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skrzynki narzędziowe",
    "categoryPath": [
      "(252409) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wózki, skrzynki i organizery na narzędzia"
    ],
    "hierarchy": "(252409) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wózki, skrzynki i organizery na narzędzia / Skrzynki narzędziowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tablice narzędziowe",
    "categoryPath": [
      "(252378) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wózki, skrzynki i organizery na narzędzia"
    ],
    "hierarchy": "(252378) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wózki, skrzynki i organizery na narzędzia / Tablice narzędziowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uchwyty, haki",
    "categoryPath": [
      "(261639) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wózki, skrzynki i organizery na narzędzia"
    ],
    "hierarchy": "(261639) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wózki, skrzynki i organizery na narzędzia / Uchwyty, haki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Wkładki do wózków narzędziowych",
    "categoryPath": [
      "(252410) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wózki, skrzynki i organizery na narzędzia"
    ],
    "hierarchy": "(252410) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wózki, skrzynki i organizery na narzędzia / Wkładki do wózków narzędziowych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wózki narzędziowe",
    "categoryPath": [
      "(252411) Motoryzacja",
      "Narzędzia i sprzęt warsztatowy",
      "Wózki, skrzynki i organizery na narzędzia"
    ],
    "hierarchy": "(252411) Motoryzacja / Narzędzia i sprzęt warsztatowy / Wózki, skrzynki i organizery na narzędzia / Wózki narzędziowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Do innych pojazdów",
    "categoryPath": [
      "(260111) Motoryzacja",
      "Opony i felgi",
      "Felgi"
    ],
    "hierarchy": "(260111) Motoryzacja / Opony i felgi / Felgi / Do innych pojazdów",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do motocykli i skuterów",
    "categoryPath": [
      "(257710) Motoryzacja",
      "Opony i felgi",
      "Felgi"
    ],
    "hierarchy": "(257710) Motoryzacja / Opony i felgi / Felgi / Do motocykli i skuterów",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Aluminiowe",
    "categoryPath": [
      "(257711) Motoryzacja",
      "Opony i felgi",
      "Felgi",
      "Do samochodów"
    ],
    "hierarchy": "(257711) Motoryzacja / Opony i felgi / Felgi / Do samochodów / Aluminiowe",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Stalowe",
    "categoryPath": [
      "(257712) Motoryzacja",
      "Opony i felgi",
      "Felgi",
      "Do samochodów"
    ],
    "hierarchy": "(257712) Motoryzacja / Opony i felgi / Felgi / Do samochodów / Stalowe",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do innych pojazdów",
    "categoryPath": [
      "(260112) Motoryzacja",
      "Opony i felgi",
      "Koła (felgi z oponami)"
    ],
    "hierarchy": "(260112) Motoryzacja / Opony i felgi / Koła (felgi z oponami) / Do innych pojazdów",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do motocykli i skuterów",
    "categoryPath": [
      "(257715) Motoryzacja",
      "Opony i felgi",
      "Koła (felgi z oponami)"
    ],
    "hierarchy": "(257715) Motoryzacja / Opony i felgi / Koła (felgi z oponami) / Do motocykli i skuterów",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do samochodów",
    "categoryPath": [
      "(257714) Motoryzacja",
      "Opony i felgi",
      "Koła (felgi z oponami)"
    ],
    "hierarchy": "(257714) Motoryzacja / Opony i felgi / Koła (felgi z oponami) / Do samochodów",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Koła dojazdowe",
    "categoryPath": [
      "(257716) Motoryzacja",
      "Opony i felgi",
      "Koła (felgi z oponami)"
    ],
    "hierarchy": "(257716) Motoryzacja / Opony i felgi / Koła (felgi z oponami) / Koła dojazdowe",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do innych pojazdów",
    "categoryPath": [
      "(257707) Motoryzacja",
      "Opony i felgi",
      "Opony"
    ],
    "hierarchy": "(257707) Motoryzacja / Opony i felgi / Opony / Do innych pojazdów",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do maszyn budowlanych",
    "categoryPath": [
      "(257704) Motoryzacja",
      "Opony i felgi",
      "Opony"
    ],
    "hierarchy": "(257704) Motoryzacja / Opony i felgi / Opony / Do maszyn budowlanych",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do maszyn rolniczych",
    "categoryPath": [
      "(257703) Motoryzacja",
      "Opony i felgi",
      "Opony"
    ],
    "hierarchy": "(257703) Motoryzacja / Opony i felgi / Opony / Do maszyn rolniczych",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Komplety opon (przód + tył)",
    "categoryPath": [
      "(301106) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do motocykli i skuterów"
    ],
    "hierarchy": "(301106) Motoryzacja / Opony i felgi / Opony / Do motocykli i skuterów / Komplety opon (przód + tył)",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Opony pojedyncze",
    "categoryPath": [
      "(301094) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do motocykli i skuterów"
    ],
    "hierarchy": "(301094) Motoryzacja / Opony i felgi / Opony / Do motocykli i skuterów / Opony pojedyncze",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do quadów",
    "categoryPath": [
      "(257706) Motoryzacja",
      "Opony i felgi",
      "Opony"
    ],
    "hierarchy": "(257706) Motoryzacja / Opony i felgi / Opony / Do quadów",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Całoroczne",
    "categoryPath": [
      "(257696) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów 4x4/SUV"
    ],
    "hierarchy": "(257696) Motoryzacja / Opony i felgi / Opony / Do samochodów 4x4/SUV / Całoroczne",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Letnie",
    "categoryPath": [
      "(257694) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów 4x4/SUV"
    ],
    "hierarchy": "(257694) Motoryzacja / Opony i felgi / Opony / Do samochodów 4x4/SUV / Letnie",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Zimowe",
    "categoryPath": [
      "(257695) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów 4x4/SUV"
    ],
    "hierarchy": "(257695) Motoryzacja / Opony i felgi / Opony / Do samochodów 4x4/SUV / Zimowe",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Do samochodów ciężarowych",
    "categoryPath": [
      "(257701) Motoryzacja",
      "Opony i felgi",
      "Opony"
    ],
    "hierarchy": "(257701) Motoryzacja / Opony i felgi / Opony / Do samochodów ciężarowych",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Całoroczne",
    "categoryPath": [
      "(257700) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów dostawczych"
    ],
    "hierarchy": "(257700) Motoryzacja / Opony i felgi / Opony / Do samochodów dostawczych / Całoroczne",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Letnie",
    "categoryPath": [
      "(257698) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów dostawczych"
    ],
    "hierarchy": "(257698) Motoryzacja / Opony i felgi / Opony / Do samochodów dostawczych / Letnie",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Zimowe",
    "categoryPath": [
      "(257699) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów dostawczych"
    ],
    "hierarchy": "(257699) Motoryzacja / Opony i felgi / Opony / Do samochodów dostawczych / Zimowe",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Całoroczne",
    "categoryPath": [
      "(257692) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów osobowych"
    ],
    "hierarchy": "(257692) Motoryzacja / Opony i felgi / Opony / Do samochodów osobowych / Całoroczne",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Letnie",
    "categoryPath": [
      "(257689) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów osobowych"
    ],
    "hierarchy": "(257689) Motoryzacja / Opony i felgi / Opony / Do samochodów osobowych / Letnie",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Zimowe",
    "categoryPath": [
      "(257691) Motoryzacja",
      "Opony i felgi",
      "Opony",
      "Do samochodów osobowych"
    ],
    "hierarchy": "(257691) Motoryzacja / Opony i felgi / Opony / Do samochodów osobowych / Zimowe",
    "comissionGroupOld": "C33",
    "comissionGroupNew": "D27"
  },
  {
    "segment": "Czujniki ciśnienia w oponach i programatory",
    "categoryPath": [
      "(257625) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257625) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Czujniki ciśnienia w oponach i programatory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dekielki",
    "categoryPath": [
      "(257626) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257626) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Dekielki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dystanse",
    "categoryPath": [
      "(257628) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257628) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Dystanse",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dętki i ochraniacze",
    "categoryPath": [
      "(257627) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257627) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Dętki i ochraniacze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kołpaki",
    "categoryPath": [
      "(257629) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257629) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Kołpaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakrętki",
    "categoryPath": [
      "(257631) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257631) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Nakrętki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pierścienie centrujące",
    "categoryPath": [
      "(257632) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257632) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Pierścienie centrujące",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pompki i kompresory 12V",
    "categoryPath": [
      "(257637) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257637) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Pompki i kompresory 12V",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257636) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257636) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szpilki",
    "categoryPath": [
      "(257633) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257633) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Szpilki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentyle",
    "categoryPath": [
      "(257635) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257635) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Wentyle",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Łańcuchy śniegowe",
    "categoryPath": [
      "(257630) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257630) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Łańcuchy śniegowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Śruby",
    "categoryPath": [
      "(257634) Motoryzacja",
      "Opony i felgi",
      "Osprzęt i akcesoria"
    ],
    "hierarchy": "(257634) Motoryzacja / Opony i felgi / Osprzęt i akcesoria / Śruby",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Apteczki",
    "categoryPath": [
      "(253533) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Apteczki, gaśnice, kamizelki, trójkąty"
    ],
    "hierarchy": "(253533) Motoryzacja / Wyposażenie i akcesoria samochodowe / Apteczki, gaśnice, kamizelki, trójkąty / Apteczki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gaśnice",
    "categoryPath": [
      "(253534) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Apteczki, gaśnice, kamizelki, trójkąty"
    ],
    "hierarchy": "(253534) Motoryzacja / Wyposażenie i akcesoria samochodowe / Apteczki, gaśnice, kamizelki, trójkąty / Gaśnice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(253535) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Apteczki, gaśnice, kamizelki, trójkąty"
    ],
    "hierarchy": "(253535) Motoryzacja / Wyposażenie i akcesoria samochodowe / Apteczki, gaśnice, kamizelki, trójkąty / Kamizelki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Trójkąty",
    "categoryPath": [
      "(253536) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Apteczki, gaśnice, kamizelki, trójkąty"
    ],
    "hierarchy": "(253536) Motoryzacja / Wyposażenie i akcesoria samochodowe / Apteczki, gaśnice, kamizelki, trójkąty / Trójkąty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(253537) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Apteczki, gaśnice, kamizelki, trójkąty"
    ],
    "hierarchy": "(253537) Motoryzacja / Wyposażenie i akcesoria samochodowe / Apteczki, gaśnice, kamizelki, trójkąty / Zestawy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(322868) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki"
    ],
    "hierarchy": "(322868) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Belki",
    "categoryPath": [
      "(322307) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Bazowe"
    ],
    "hierarchy": "(322307) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Bazowe / Belki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kity",
    "categoryPath": [
      "(322309) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Bazowe"
    ],
    "hierarchy": "(322309) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Bazowe / Kity",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Stopy",
    "categoryPath": [
      "(322308) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Bazowe"
    ],
    "hierarchy": "(322308) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Bazowe / Stopy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Bez relingów",
    "categoryPath": [
      "(253546) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Bazowe",
      "Zestawy"
    ],
    "hierarchy": "(253546) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Bazowe / Zestawy / Bez relingów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Na relingi",
    "categoryPath": [
      "(253547) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Bazowe",
      "Zestawy"
    ],
    "hierarchy": "(253547) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Bazowe / Zestawy / Na relingi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Boxy dachowe",
    "categoryPath": [
      "(253540) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki"
    ],
    "hierarchy": "(253540) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Boxy dachowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kosze dachowe",
    "categoryPath": [
      "(253541) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki"
    ],
    "hierarchy": "(253541) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Kosze dachowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253545) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki"
    ],
    "hierarchy": "(253545) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Torby, pokrowce",
    "categoryPath": [
      "(253542) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki"
    ],
    "hierarchy": "(253542) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Torby, pokrowce",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uchwyty narciarskie",
    "categoryPath": [
      "(253543) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki"
    ],
    "hierarchy": "(253543) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Uchwyty narciarskie",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na dach",
    "categoryPath": [
      "(253548) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Uchwyty rowerowe"
    ],
    "hierarchy": "(253548) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Uchwyty rowerowe / Na dach",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na hak holowniczy",
    "categoryPath": [
      "(253549) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Uchwyty rowerowe"
    ],
    "hierarchy": "(253549) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Uchwyty rowerowe / Na hak holowniczy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na tylną klapę",
    "categoryPath": [
      "(253550) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Bagażniki",
      "Uchwyty rowerowe"
    ],
    "hierarchy": "(253550) Motoryzacja / Wyposażenie i akcesoria samochodowe / Bagażniki / Uchwyty rowerowe / Na tylną klapę",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Chlapacze",
    "categoryPath": [
      "(253559) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe"
    ],
    "hierarchy": "(253559) Motoryzacja / Wyposażenie i akcesoria samochodowe / Chlapacze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czujniki cofania",
    "categoryPath": [
      "(253561) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Czujniki i kamery cofania"
    ],
    "hierarchy": "(253561) Motoryzacja / Wyposażenie i akcesoria samochodowe / Czujniki i kamery cofania / Czujniki cofania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kamery cofania",
    "categoryPath": [
      "(253562) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Czujniki i kamery cofania"
    ],
    "hierarchy": "(253562) Motoryzacja / Wyposażenie i akcesoria samochodowe / Czujniki i kamery cofania / Kamery cofania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dywaniki eva",
    "categoryPath": [
      "(322444) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(322444) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Dywaniki eva",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dywaniki gumowe",
    "categoryPath": [
      "(253564) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(253564) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Dywaniki gumowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dywaniki pikowane",
    "categoryPath": [
      "(260059) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(260059) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Dywaniki pikowane",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dywaniki welurowe",
    "categoryPath": [
      "(253565) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(253565) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Dywaniki welurowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Maty do bagażnika",
    "categoryPath": [
      "(253566) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(253566) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Maty do bagażnika",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Osłony tunelu",
    "categoryPath": [
      "(308857) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(308857) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Osłony tunelu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253568) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(253568) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spinki, stopery",
    "categoryPath": [
      "(253567) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Dywaniki"
    ],
    "hierarchy": "(253567) Motoryzacja / Wyposażenie i akcesoria samochodowe / Dywaniki / Spinki, stopery",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Alkomaty",
    "categoryPath": [
      "(257405) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Alkomaty i ustniki"
    ],
    "hierarchy": "(257405) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Alkomaty i ustniki / Alkomaty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ustniki",
    "categoryPath": [
      "(257406) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Alkomaty i ustniki"
    ],
    "hierarchy": "(257406) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Alkomaty i ustniki / Ustniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Antyradary",
    "categoryPath": [
      "(257395) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257395) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Antyradary",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Anteny",
    "categoryPath": [
      "(257402) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "CB Radia"
    ],
    "hierarchy": "(257402) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / CB Radia / Anteny",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Radia",
    "categoryPath": [
      "(257403) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "CB Radia"
    ],
    "hierarchy": "(257403) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / CB Radia / Radia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(257404) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "CB Radia"
    ],
    "hierarchy": "(257404) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / CB Radia / Zestawy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akcesoria montażowe",
    "categoryPath": [
      "(257965) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Car audio"
    ],
    "hierarchy": "(257965) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Car audio / Akcesoria montażowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Anteny",
    "categoryPath": [
      "(257407) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Car audio"
    ],
    "hierarchy": "(257407) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Car audio / Anteny",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(257408) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Car audio"
    ],
    "hierarchy": "(257408) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Car audio / Głośniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skrzynie basowe i tuby",
    "categoryPath": [
      "(257966) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Car audio"
    ],
    "hierarchy": "(257966) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Car audio / Skrzynie basowe i tuby",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Czajniki turystyczne",
    "categoryPath": [
      "(315612) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(315612) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Czajniki turystyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Kamery samochodowe",
    "categoryPath": [
      "(257398) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257398) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Kamery samochodowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lodówki turystyczne",
    "categoryPath": [
      "(257968) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257968) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Lodówki turystyczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Maty grzewcze i masujące",
    "categoryPath": [
      "(257970) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257970) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Maty grzewcze i masujące",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akcesoria i oprogramowanie",
    "categoryPath": [
      "(257973) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Nawigacje i akcesoria GPS"
    ],
    "hierarchy": "(257973) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Nawigacje i akcesoria GPS / Akcesoria i oprogramowanie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odkurzacze samochodowe",
    "categoryPath": [
      "(257976) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257976) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Odkurzacze samochodowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257980) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257980) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przetwornice napięcia",
    "categoryPath": [
      "(257400) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257400) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Przetwornice napięcia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Rozdzielacze gniazda zapalniczki",
    "categoryPath": [
      "(257977) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257977) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Rozdzielacze gniazda zapalniczki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Słuchawki bluetooth",
    "categoryPath": [
      "(257978) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257978) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Słuchawki bluetooth",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Czytniki tachografów",
    "categoryPath": [
      "(257111) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Tachografy"
    ],
    "hierarchy": "(257111) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Tachografy / Czytniki tachografów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tachografy",
    "categoryPath": [
      "(257110) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Tachografy"
    ],
    "hierarchy": "(257110) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Tachografy / Tachografy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wentylatory",
    "categoryPath": [
      "(257979) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa"
    ],
    "hierarchy": "(257979) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Wentylatory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ładowarki USB",
    "categoryPath": [
      "(257972) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Ładowarki samochodowe"
    ],
    "hierarchy": "(257972) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Ładowarki samochodowe / Ładowarki USB",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ładowarki do laptopów",
    "categoryPath": [
      "(257974) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Elektronika samochodowa",
      "Ładowarki samochodowe"
    ],
    "hierarchy": "(257974) Motoryzacja / Wyposażenie i akcesoria samochodowe / Elektronika samochodowa / Ładowarki samochodowe / Ładowarki do laptopów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Emblematy",
    "categoryPath": [
      "(253569) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe"
    ],
    "hierarchy": "(253569) Motoryzacja / Wyposażenie i akcesoria samochodowe / Emblematy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Breloczki",
    "categoryPath": [
      "(253799) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253799) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Breloczki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(253800) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253800) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Czapki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Gadżety OE",
    "categoryPath": [
      "(319168) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(319168) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Gadżety OE",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Kalendarze",
    "categoryPath": [
      "(253801) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253801) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Kalendarze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(253802) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253802) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Koszulki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kubki",
    "categoryPath": [
      "(253803) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253803) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Kubki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Maskotki",
    "categoryPath": [
      "(253805) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253805) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Maskotki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Naklejki",
    "categoryPath": [
      "(253806) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253806) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Naklejki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Naszywki",
    "categoryPath": [
      "(253807) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253807) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Naszywki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odznaki",
    "categoryPath": [
      "(253808) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253808) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Odznaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Okulary dla kierowców",
    "categoryPath": [
      "(253809) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253809) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Okulary dla kierowców",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Plakaty",
    "categoryPath": [
      "(253810) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253810) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Plakaty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poduszki",
    "categoryPath": [
      "(253811) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253811) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Poduszki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253815) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253815) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Smycze do kluczy",
    "categoryPath": [
      "(253812) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253812) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Smycze do kluczy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tablice",
    "categoryPath": [
      "(253813) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253813) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Tablice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zegary i zegarki",
    "categoryPath": [
      "(253814) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Gadżety motoryzacyjne"
    ],
    "hierarchy": "(253814) Motoryzacja / Wyposażenie i akcesoria samochodowe / Gadżety motoryzacyjne / Zegary i zegarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Kompletne haki holownicze (belka + kula)",
    "categoryPath": [
      "(253572) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Holowanie"
    ],
    "hierarchy": "(253572) Motoryzacja / Wyposażenie i akcesoria samochodowe / Holowanie / Kompletne haki holownicze (belka + kula)",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kule",
    "categoryPath": [
      "(256640) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Holowanie"
    ],
    "hierarchy": "(256640) Motoryzacja / Wyposażenie i akcesoria samochodowe / Holowanie / Kule",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki holownicze",
    "categoryPath": [
      "(253573) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Holowanie"
    ],
    "hierarchy": "(253573) Motoryzacja / Wyposażenie i akcesoria samochodowe / Holowanie / Linki holownicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253575) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Holowanie"
    ],
    "hierarchy": "(253575) Motoryzacja / Wyposażenie i akcesoria samochodowe / Holowanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stopnie do haka holowniczego",
    "categoryPath": [
      "(322346) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Holowanie"
    ],
    "hierarchy": "(322346) Motoryzacja / Wyposażenie i akcesoria samochodowe / Holowanie / Stopnie do haka holowniczego",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ucha holownicze",
    "categoryPath": [
      "(253574) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Holowanie"
    ],
    "hierarchy": "(253574) Motoryzacja / Wyposażenie i akcesoria samochodowe / Holowanie / Ucha holownicze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wiązki, gniazda",
    "categoryPath": [
      "(256641) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Holowanie"
    ],
    "hierarchy": "(256641) Motoryzacja / Wyposażenie i akcesoria samochodowe / Holowanie / Wiązki, gniazda",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kanistry",
    "categoryPath": [
      "(257948) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Kanistry, lejki i pompki do paliwa"
    ],
    "hierarchy": "(257948) Motoryzacja / Wyposażenie i akcesoria samochodowe / Kanistry, lejki i pompki do paliwa / Kanistry",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lejki",
    "categoryPath": [
      "(257949) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Kanistry, lejki i pompki do paliwa"
    ],
    "hierarchy": "(257949) Motoryzacja / Wyposażenie i akcesoria samochodowe / Kanistry, lejki i pompki do paliwa / Lejki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Maszyny budowlane",
    "categoryPath": [
      "(253817) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna"
    ],
    "hierarchy": "(253817) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Maszyny budowlane",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instrukcje napraw",
    "categoryPath": [
      "(253822) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Maszyny rolnicze"
    ],
    "hierarchy": "(253822) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Maszyny rolnicze / Instrukcje napraw",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instrukcje obsługi",
    "categoryPath": [
      "(253823) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Maszyny rolnicze"
    ],
    "hierarchy": "(253823) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Maszyny rolnicze / Instrukcje obsługi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Katalogi części",
    "categoryPath": [
      "(253824) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Maszyny rolnicze"
    ],
    "hierarchy": "(253824) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Maszyny rolnicze / Katalogi części",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253825) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Maszyny rolnicze"
    ],
    "hierarchy": "(253825) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Maszyny rolnicze / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Historia",
    "categoryPath": [
      "(253826) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253826) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Historia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instrukcje napraw",
    "categoryPath": [
      "(253827) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253827) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Instrukcje napraw",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Instrukcje obsługi",
    "categoryPath": [
      "(253828) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253828) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Instrukcje obsługi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Katalogi części",
    "categoryPath": [
      "(253829) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253829) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Katalogi części",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Książki serwisowe",
    "categoryPath": [
      "(253830) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253830) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Książki serwisowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Poradniki",
    "categoryPath": [
      "(253831) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253831) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Poradniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253834) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253834) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prasa motoryzacyjna",
    "categoryPath": [
      "(253832) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253832) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Prasa motoryzacyjna",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Prospekty",
    "categoryPath": [
      "(253833) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Motocykle"
    ],
    "hierarchy": "(253833) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Motocykle / Prospekty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253821) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna"
    ],
    "hierarchy": "(253821) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Historia",
    "categoryPath": [
      "(253835) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(253835) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Historia",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instrukcje napraw",
    "categoryPath": [
      "(253836) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(253836) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Instrukcje napraw",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Instrukcje obsługi",
    "categoryPath": [
      "(253837) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(253837) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Instrukcje obsługi",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Katalogi części",
    "categoryPath": [
      "(253838) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(253838) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Katalogi części",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Książki serwisowe",
    "categoryPath": [
      "(253839) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(253839) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Książki serwisowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253842) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(253842) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Prasa motoryzacyjna",
    "categoryPath": [
      "(315615) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(315615) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Prasa motoryzacyjna",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Prospekty",
    "categoryPath": [
      "(253841) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Literatura motoryzacyjna",
      "Samochody"
    ],
    "hierarchy": "(253841) Motoryzacja / Wyposażenie i akcesoria samochodowe / Literatura motoryzacyjna / Samochody / Prospekty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Liny",
    "categoryPath": [
      "(253583) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Off-road"
    ],
    "hierarchy": "(253583) Motoryzacja / Wyposażenie i akcesoria samochodowe / Off-road / Liny",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Osłony i płyty",
    "categoryPath": [
      "(306441) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Off-road"
    ],
    "hierarchy": "(306441) Motoryzacja / Wyposażenie i akcesoria samochodowe / Off-road / Osłony i płyty",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Snorkele",
    "categoryPath": [
      "(253584) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Off-road"
    ],
    "hierarchy": "(253584) Motoryzacja / Wyposażenie i akcesoria samochodowe / Off-road / Snorkele",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Wyciągarki",
    "categoryPath": [
      "(253585) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Off-road"
    ],
    "hierarchy": "(253585) Motoryzacja / Wyposażenie i akcesoria samochodowe / Off-road / Wyciągarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Linki, pasy transportowe",
    "categoryPath": [
      "(253607) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Organizery i siatki do bagażnika"
    ],
    "hierarchy": "(253607) Motoryzacja / Wyposażenie i akcesoria samochodowe / Organizery i siatki do bagażnika / Linki, pasy transportowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253610) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Organizery i siatki do bagażnika"
    ],
    "hierarchy": "(253610) Motoryzacja / Wyposażenie i akcesoria samochodowe / Organizery i siatki do bagażnika / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(253608) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Organizery i siatki do bagażnika"
    ],
    "hierarchy": "(253608) Motoryzacja / Wyposażenie i akcesoria samochodowe / Organizery i siatki do bagażnika / Siatki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Torby i organizery",
    "categoryPath": [
      "(253609) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Organizery i siatki do bagażnika"
    ],
    "hierarchy": "(253609) Motoryzacja / Wyposażenie i akcesoria samochodowe / Organizery i siatki do bagażnika / Torby i organizery",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Maty na szyby",
    "categoryPath": [
      "(253601) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Osłony na szyby"
    ],
    "hierarchy": "(253601) Motoryzacja / Wyposażenie i akcesoria samochodowe / Osłony na szyby / Maty na szyby",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony przeciwsłoneczne",
    "categoryPath": [
      "(253602) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Osłony na szyby"
    ],
    "hierarchy": "(253602) Motoryzacja / Wyposażenie i akcesoria samochodowe / Osłony na szyby / Osłony przeciwsłoneczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Owiewki",
    "categoryPath": [
      "(257947) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Osłony na szyby"
    ],
    "hierarchy": "(257947) Motoryzacja / Wyposażenie i akcesoria samochodowe / Osłony na szyby / Owiewki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253605) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Osłony na szyby"
    ],
    "hierarchy": "(253605) Motoryzacja / Wyposażenie i akcesoria samochodowe / Osłony na szyby / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rolety przeciwsłoneczne",
    "categoryPath": [
      "(253604) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Osłony na szyby"
    ],
    "hierarchy": "(253604) Motoryzacja / Wyposażenie i akcesoria samochodowe / Osłony na szyby / Rolety przeciwsłoneczne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zasłony",
    "categoryPath": [
      "(319977) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Osłony na szyby"
    ],
    "hierarchy": "(319977) Motoryzacja / Wyposażenie i akcesoria samochodowe / Osłony na szyby / Zasłony",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pojedyncze",
    "categoryPath": [
      "(257360) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pióra wycieraczek"
    ],
    "hierarchy": "(257360) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pióra wycieraczek / Pojedyncze",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(257361) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pióra wycieraczek"
    ],
    "hierarchy": "(257361) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pióra wycieraczek / Zestawy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na kierownice",
    "categoryPath": [
      "(253589) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pokrowce"
    ],
    "hierarchy": "(253589) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pokrowce / Na kierownice",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Na koła zapasowe",
    "categoryPath": [
      "(253590) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pokrowce"
    ],
    "hierarchy": "(253590) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pokrowce / Na koła zapasowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na samochód",
    "categoryPath": [
      "(253591) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pokrowce"
    ],
    "hierarchy": "(253591) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pokrowce / Na samochód",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dedykowane",
    "categoryPath": [
      "(320419) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pokrowce",
      "Na siedzenia"
    ],
    "hierarchy": "(320419) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pokrowce / Na siedzenia / Dedykowane",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Uniwersalne",
    "categoryPath": [
      "(320422) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pokrowce",
      "Na siedzenia"
    ],
    "hierarchy": "(320422) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pokrowce / Na siedzenia / Uniwersalne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253593) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Pokrowce"
    ],
    "hierarchy": "(253593) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pokrowce / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253624) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe"
    ],
    "hierarchy": "(253624) Motoryzacja / Wyposażenie i akcesoria samochodowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kable rozruchowe",
    "categoryPath": [
      "(253596) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Prostowniki i kable rozruchowe"
    ],
    "hierarchy": "(253596) Motoryzacja / Wyposażenie i akcesoria samochodowe / Prostowniki i kable rozruchowe / Kable rozruchowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Prostowniki",
    "categoryPath": [
      "(253597) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Prostowniki i kable rozruchowe"
    ],
    "hierarchy": "(253597) Motoryzacja / Wyposażenie i akcesoria samochodowe / Prostowniki i kable rozruchowe / Prostowniki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Ramki do tablic rejestracyjnych",
    "categoryPath": [
      "(253598) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe"
    ],
    "hierarchy": "(253598) Motoryzacja / Wyposażenie i akcesoria samochodowe / Ramki do tablic rejestracyjnych",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Skrobaczki do szyb",
    "categoryPath": [
      "(253611) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe"
    ],
    "hierarchy": "(253611) Motoryzacja / Wyposażenie i akcesoria samochodowe / Skrobaczki do szyb",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Brewki i rzęsy",
    "categoryPath": [
      "(253766) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253766) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Brewki i rzęsy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Diody, neony, stroboskopy",
    "categoryPath": [
      "(253767) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253767) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Diody, neony, stroboskopy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Dokładki zderzaków",
    "categoryPath": [
      "(253769) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253769) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Dokładki zderzaków",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akcesoria do aplikacji",
    "categoryPath": [
      "(260269) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny",
      "Folie samochodowe"
    ],
    "hierarchy": "(260269) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Folie samochodowe / Akcesoria do aplikacji",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Folie do karoserii",
    "categoryPath": [
      "(260267) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny",
      "Folie samochodowe"
    ],
    "hierarchy": "(260267) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Folie samochodowe / Folie do karoserii",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Folie do kokpitu",
    "categoryPath": [
      "(260268) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny",
      "Folie samochodowe"
    ],
    "hierarchy": "(260268) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Folie samochodowe / Folie do kokpitu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Folie przyciemniające",
    "categoryPath": [
      "(260266) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny",
      "Folie samochodowe"
    ],
    "hierarchy": "(260266) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Folie samochodowe / Folie przyciemniające",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Gałki zmiany biegów",
    "categoryPath": [
      "(253770) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253770) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Gałki zmiany biegów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Grille",
    "categoryPath": [
      "(253771) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253771) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Grille",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Kierownice sportowe",
    "categoryPath": [
      "(253772) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253772) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Kierownice sportowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Klamki, nakładki",
    "categoryPath": [
      "(253773) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253773) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Klamki, nakładki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Końcówki tłumików",
    "categoryPath": [
      "(253774) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253774) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Końcówki tłumików",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Listwy ozdobne",
    "categoryPath": [
      "(253775) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253775) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Listwy ozdobne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Lusterka, nakładki",
    "categoryPath": [
      "(253776) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253776) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Lusterka, nakładki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Mieszki ochronne",
    "categoryPath": [
      "(253777) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253777) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Mieszki ochronne",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Naklejki",
    "categoryPath": [
      "(253778) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253778) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Naklejki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakładki na pasy",
    "categoryPath": [
      "(253779) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253779) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Nakładki na pasy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakładki na pedały",
    "categoryPath": [
      "(253780) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253780) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Nakładki na pedały",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakładki na wlew paliwa",
    "categoryPath": [
      "(253781) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253781) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Nakładki na wlew paliwa",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Nakładki progowe",
    "categoryPath": [
      "(253782) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253782) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Nakładki progowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Orurowania",
    "categoryPath": [
      "(253784) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253784) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Orurowania",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Osłony grilla",
    "categoryPath": [
      "(257958) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(257958) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Osłony grilla",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Projektory",
    "categoryPath": [
      "(253788) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253788) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Projektory",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(253785) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253785) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Siatki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Tarcze zegarów",
    "categoryPath": [
      "(253787) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(253787) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Tarcze zegarów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Termometry i zegarki",
    "categoryPath": [
      "(257959) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Tuning wizualny"
    ],
    "hierarchy": "(257959) Motoryzacja / Wyposażenie i akcesoria samochodowe / Tuning wizualny / Termometry i zegarki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Do tabletów",
    "categoryPath": [
      "(253616) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Uchwyty, wieszaki"
    ],
    "hierarchy": "(253616) Motoryzacja / Wyposażenie i akcesoria samochodowe / Uchwyty, wieszaki / Do tabletów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Do telefonów",
    "categoryPath": [
      "(253617) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Uchwyty, wieszaki"
    ],
    "hierarchy": "(253617) Motoryzacja / Wyposażenie i akcesoria samochodowe / Uchwyty, wieszaki / Do telefonów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na kubki",
    "categoryPath": [
      "(253614) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Uchwyty, wieszaki"
    ],
    "hierarchy": "(253614) Motoryzacja / Wyposażenie i akcesoria samochodowe / Uchwyty, wieszaki / Na kubki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Na okulary",
    "categoryPath": [
      "(253615) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Uchwyty, wieszaki"
    ],
    "hierarchy": "(253615) Motoryzacja / Wyposażenie i akcesoria samochodowe / Uchwyty, wieszaki / Na okulary",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253619) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Uchwyty, wieszaki"
    ],
    "hierarchy": "(253619) Motoryzacja / Wyposażenie i akcesoria samochodowe / Uchwyty, wieszaki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wieszaki",
    "categoryPath": [
      "(315618) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Uchwyty, wieszaki"
    ],
    "hierarchy": "(315618) Motoryzacja / Wyposażenie i akcesoria samochodowe / Uchwyty, wieszaki / Wieszaki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Autoalarmy",
    "categoryPath": [
      "(253626) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(253626) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Autoalarmy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blokady kierownicy",
    "categoryPath": [
      "(253627) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(253627) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Blokady kierownicy",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blokady parkingowe",
    "categoryPath": [
      "(302378) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(302378) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Blokady parkingowe",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blokady skrzyni biegów",
    "categoryPath": [
      "(253628) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(253628) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Blokady skrzyni biegów",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Blokady zapłonu",
    "categoryPath": [
      "(253629) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(253629) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Blokady zapłonu",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D25"
  },
  {
    "segment": "Lokalizatory GPS",
    "categoryPath": [
      "(253630) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(253630) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Lokalizatory GPS",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Odstraszacze zwierząt",
    "categoryPath": [
      "(257957) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(257957) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Odstraszacze zwierząt",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253631) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe",
      "Zabezpieczenia"
    ],
    "hierarchy": "(253631) Motoryzacja / Wyposażenie i akcesoria samochodowe / Zabezpieczenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Żarówki",
    "categoryPath": [
      "(257359) Motoryzacja",
      "Wyposażenie i akcesoria samochodowe"
    ],
    "hierarchy": "(257359) Motoryzacja / Wyposażenie i akcesoria samochodowe / Żarówki",
    "comissionGroupOld": "C10",
    "comissionGroupNew": "D24"
  },
  {
    "segment": "Akcesoria odblaskowe",
    "categoryPath": [
      "(260740) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260740) Sport i turystyka / Bieganie / Akcesoria odblaskowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bidony, bukłaki",
    "categoryPath": [
      "(260741) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260741) Sport i turystyka / Bieganie / Bidony, bukłaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Etui, opaski na ramię",
    "categoryPath": [
      "(260742) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260742) Sport i turystyka / Bieganie / Etui, opaski na ramię",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kolce",
    "categoryPath": [
      "(147298) Sport i turystyka",
      "Bieganie",
      "Obuwie"
    ],
    "hierarchy": "(147298) Sport i turystyka / Bieganie / Obuwie / Kolce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Naturalne",
    "categoryPath": [
      "(147297) Sport i turystyka",
      "Bieganie",
      "Obuwie"
    ],
    "hierarchy": "(147297) Sport i turystyka / Bieganie / Obuwie / Naturalne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147293) Sport i turystyka",
      "Bieganie",
      "Obuwie"
    ],
    "hierarchy": "(147293) Sport i turystyka / Bieganie / Obuwie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Startowe",
    "categoryPath": [
      "(147296) Sport i turystyka",
      "Bieganie",
      "Obuwie"
    ],
    "hierarchy": "(147296) Sport i turystyka / Bieganie / Obuwie / Startowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Terenowe (trailowe)",
    "categoryPath": [
      "(147295) Sport i turystyka",
      "Bieganie",
      "Obuwie"
    ],
    "hierarchy": "(147295) Sport i turystyka / Bieganie / Obuwie / Terenowe (trailowe)",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Treningowe",
    "categoryPath": [
      "(147294) Sport i turystyka",
      "Bieganie",
      "Obuwie"
    ],
    "hierarchy": "(147294) Sport i turystyka / Bieganie / Obuwie / Treningowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dół",
    "categoryPath": [
      "(147290) Sport i turystyka",
      "Bieganie",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(147290) Sport i turystyka / Bieganie / Odzież / Bielizna / Dół",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Góra",
    "categoryPath": [
      "(147289) Sport i turystyka",
      "Bieganie",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(147289) Sport i turystyka / Bieganie / Odzież / Bielizna / Góra",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplet",
    "categoryPath": [
      "(147291) Sport i turystyka",
      "Bieganie",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(147291) Sport i turystyka / Bieganie / Odzież / Bielizna / Komplet",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(147292) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147292) Sport i turystyka / Bieganie / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(147285) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147285) Sport i turystyka / Bieganie / Odzież / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Getry, legginsy",
    "categoryPath": [
      "(260668) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(260668) Sport i turystyka / Bieganie / Odzież / Getry, legginsy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(147590) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147590) Sport i turystyka / Bieganie / Odzież / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kominy, chusty, bandany",
    "categoryPath": [
      "(147310) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147310) Sport i turystyka / Bieganie / Odzież / Kominy, chusty, bandany",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(260661) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(260661) Sport i turystyka / Bieganie / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(147279) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147279) Sport i turystyka / Bieganie / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski na głowę",
    "categoryPath": [
      "(147286) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147286) Sport i turystyka / Bieganie / Odzież / Opaski na głowę",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(147284) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147284) Sport i turystyka / Bieganie / Odzież / Rękawiczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(147287) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147287) Sport i turystyka / Bieganie / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(147282) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147282) Sport i turystyka / Bieganie / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(147281) Sport i turystyka",
      "Bieganie",
      "Odzież"
    ],
    "hierarchy": "(147281) Sport i turystyka / Bieganie / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147299) Sport i turystyka",
      "Bieganie",
      "Odżywki i suplementy dla biegaczy"
    ],
    "hierarchy": "(147299) Sport i turystyka / Bieganie / Odżywki i suplementy dla biegaczy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Opaski, rękawki i nogawki kompresyjne",
    "categoryPath": [
      "(260743) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260743) Sport i turystyka / Bieganie / Opaski, rękawki i nogawki kompresyjne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Plecaki do biegania",
    "categoryPath": [
      "(260744) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260744) Sport i turystyka / Bieganie / Plecaki do biegania",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(147263) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(147263) Sport i turystyka / Bieganie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Saszetki, nerki",
    "categoryPath": [
      "(260746) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260746) Sport i turystyka / Bieganie / Saszetki, nerki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Słuchawki",
    "categoryPath": [
      "(260747) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260747) Sport i turystyka / Bieganie / Słuchawki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wkładki do butów",
    "categoryPath": [
      "(260748) Sport i turystyka",
      "Bieganie"
    ],
    "hierarchy": "(260748) Sport i turystyka / Bieganie / Wkładki do butów",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obudowy",
    "categoryPath": [
      "(260596) Sport i turystyka",
      "Elektronika sportowa",
      "Kamery sportowe i akcesoria"
    ],
    "hierarchy": "(260596) Sport i turystyka / Elektronika sportowa / Kamery sportowe i akcesoria / Obudowy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260598) Sport i turystyka",
      "Elektronika sportowa",
      "Kamery sportowe i akcesoria"
    ],
    "hierarchy": "(260598) Sport i turystyka / Elektronika sportowa / Kamery sportowe i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Krokomierze (pedometry)",
    "categoryPath": [
      "(256151) Sport i turystyka",
      "Elektronika sportowa"
    ],
    "hierarchy": "(256151) Sport i turystyka / Elektronika sportowa / Krokomierze (pedometry)",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(256154) Sport i turystyka",
      "Elektronika sportowa",
      "Nawigacje i lokalizatory GPS"
    ],
    "hierarchy": "(256154) Sport i turystyka / Elektronika sportowa / Nawigacje i lokalizatory GPS / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lokalizatory GPS",
    "categoryPath": [
      "(261765) Sport i turystyka",
      "Elektronika sportowa",
      "Nawigacje i lokalizatory GPS"
    ],
    "hierarchy": "(261765) Sport i turystyka / Elektronika sportowa / Nawigacje i lokalizatory GPS / Lokalizatory GPS",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Nawigacje GPS",
    "categoryPath": [
      "(261764) Sport i turystyka",
      "Elektronika sportowa",
      "Nawigacje i lokalizatory GPS"
    ],
    "hierarchy": "(261764) Sport i turystyka / Elektronika sportowa / Nawigacje i lokalizatory GPS / Nawigacje GPS",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(252783) Sport i turystyka",
      "Elektronika sportowa"
    ],
    "hierarchy": "(252783) Sport i turystyka / Elektronika sportowa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stopery",
    "categoryPath": [
      "(256150) Sport i turystyka",
      "Elektronika sportowa"
    ],
    "hierarchy": "(256150) Sport i turystyka / Elektronika sportowa / Stopery",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Wagi",
    "categoryPath": [
      "(256152) Sport i turystyka",
      "Elektronika sportowa"
    ],
    "hierarchy": "(256152) Sport i turystyka / Elektronika sportowa / Wagi",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(256156) Sport i turystyka",
      "Elektronika sportowa",
      "Zegarki sportowe, smartbandy"
    ],
    "hierarchy": "(256156) Sport i turystyka / Elektronika sportowa / Zegarki sportowe, smartbandy / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zegarki sportowe, smartbandy",
    "categoryPath": [
      "(256155) Sport i turystyka",
      "Elektronika sportowa",
      "Zegarki sportowe, smartbandy"
    ],
    "hierarchy": "(256155) Sport i turystyka / Elektronika sportowa / Zegarki sportowe, smartbandy / Zegarki sportowe, smartbandy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Autografy",
    "categoryPath": [
      "(3966) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(3966) Sport i turystyka / Kolekcje / Autografy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Spotkania ligowe",
    "categoryPath": [
      "(321768) Sport i turystyka",
      "Kolekcje",
      "Bilety kolekcjonerskie",
      "Piłka nożna"
    ],
    "hierarchy": "(321768) Sport i turystyka / Kolekcje / Bilety kolekcjonerskie / Piłka nożna / Spotkania ligowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Spotkania pucharowe",
    "categoryPath": [
      "(16667) Sport i turystyka",
      "Kolekcje",
      "Bilety kolekcjonerskie",
      "Piłka nożna"
    ],
    "hierarchy": "(16667) Sport i turystyka / Kolekcje / Bilety kolekcjonerskie / Piłka nożna / Spotkania pucharowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Spotkania reprezentacji",
    "categoryPath": [
      "(16668) Sport i turystyka",
      "Kolekcje",
      "Bilety kolekcjonerskie",
      "Piłka nożna"
    ],
    "hierarchy": "(16668) Sport i turystyka / Kolekcje / Bilety kolekcjonerskie / Piłka nożna / Spotkania reprezentacji",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16662) Sport i turystyka",
      "Kolekcje",
      "Bilety kolekcjonerskie"
    ],
    "hierarchy": "(16662) Sport i turystyka / Kolekcje / Bilety kolekcjonerskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Żużel",
    "categoryPath": [
      "(75819) Sport i turystyka",
      "Kolekcje",
      "Bilety kolekcjonerskie"
    ],
    "hierarchy": "(75819) Sport i turystyka / Kolekcje / Bilety kolekcjonerskie / Żużel",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gadżety kolekcjonerskie",
    "categoryPath": [
      "(321371) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(321371) Sport i turystyka / Kolekcje / Gadżety kolekcjonerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karty sportowe",
    "categoryPath": [
      "(3969) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(3969) Sport i turystyka / Kolekcje / Karty sportowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Medale i plakiety",
    "categoryPath": [
      "(11667) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(11667) Sport i turystyka / Kolekcje / Medale i plakiety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Naklejki (vlepki)",
    "categoryPath": [
      "(16672) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(16672) Sport i turystyka / Kolekcje / Naklejki (vlepki)",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Federacje i organizacje",
    "categoryPath": [
      "(10473) Sport i turystyka",
      "Kolekcje",
      "Odznaki"
    ],
    "hierarchy": "(10473) Sport i turystyka / Kolekcje / Odznaki / Federacje i organizacje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Imprezy sportowe",
    "categoryPath": [
      "(10474) Sport i turystyka",
      "Kolekcje",
      "Odznaki"
    ],
    "hierarchy": "(10474) Sport i turystyka / Kolekcje / Odznaki / Imprezy sportowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Klubowe",
    "categoryPath": [
      "(321765) Sport i turystyka",
      "Kolekcje",
      "Odznaki"
    ],
    "hierarchy": "(321765) Sport i turystyka / Kolekcje / Odznaki / Klubowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Turystyczne",
    "categoryPath": [
      "(45873) Sport i turystyka",
      "Kolekcje",
      "Odznaki"
    ],
    "hierarchy": "(45873) Sport i turystyka / Kolekcje / Odznaki / Turystyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3965) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(3965) Sport i turystyka / Kolekcje / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Programy sportowe",
    "categoryPath": [
      "(321026) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(321026) Sport i turystyka / Kolekcje / Programy sportowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Proporczyki",
    "categoryPath": [
      "(321772) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(321772) Sport i turystyka / Kolekcje / Proporczyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Puchary i statuetki",
    "categoryPath": [
      "(47003) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(47003) Sport i turystyka / Kolekcje / Puchary i statuetki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szaliki",
    "categoryPath": [
      "(321711) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(321711) Sport i turystyka / Kolekcje / Szaliki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zdjęcia i plakaty",
    "categoryPath": [
      "(3972) Sport i turystyka",
      "Kolekcje"
    ],
    "hierarchy": "(3972) Sport i turystyka / Kolekcje / Zdjęcia i plakaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Celowniki, lunety",
    "categoryPath": [
      "(253884) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253884) Sport i turystyka / Militaria / ASG / Celowniki, lunety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Części ASG",
    "categoryPath": [
      "(253885) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253885) Sport i turystyka / Militaria / ASG / Części ASG",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karabinki szturmowe",
    "categoryPath": [
      "(253887) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253887) Sport i turystyka / Militaria / ASG / Karabinki szturmowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karabiny maszynowe",
    "categoryPath": [
      "(253888) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253888) Sport i turystyka / Militaria / ASG / Karabiny maszynowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karabiny snajperskie",
    "categoryPath": [
      "(253889) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253889) Sport i turystyka / Militaria / ASG / Karabiny snajperskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kulki ASG",
    "categoryPath": [
      "(253891) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253891) Sport i turystyka / Militaria / ASG / Kulki ASG",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Magazynki",
    "categoryPath": [
      "(253893) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253893) Sport i turystyka / Militaria / ASG / Magazynki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Oporządzenie taktyczne",
    "categoryPath": [
      "(253895) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253895) Sport i turystyka / Militaria / ASG / Oporządzenie taktyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Osprzęt ASG",
    "categoryPath": [
      "(253896) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253896) Sport i turystyka / Militaria / ASG / Osprzęt ASG",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pistolety i rewolwery",
    "categoryPath": [
      "(253898) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253898) Sport i turystyka / Militaria / ASG / Pistolety i rewolwery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pistolety maszynowe",
    "categoryPath": [
      "(253899) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253899) Sport i turystyka / Militaria / ASG / Pistolety maszynowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Strzelby",
    "categoryPath": [
      "(253901) Sport i turystyka",
      "Militaria",
      "ASG"
    ],
    "hierarchy": "(253901) Sport i turystyka / Militaria / ASG / Strzelby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gogle ochronne",
    "categoryPath": [
      "(253961) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253961) Sport i turystyka / Militaria / Akcesoria ochronne / Gogle ochronne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Hełmy",
    "categoryPath": [
      "(253964) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253964) Sport i turystyka / Militaria / Akcesoria ochronne / Hełmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maski ASG",
    "categoryPath": [
      "(253962) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253962) Sport i turystyka / Militaria / Akcesoria ochronne / Maski ASG",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maski paintballowe",
    "categoryPath": [
      "(253963) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253963) Sport i turystyka / Militaria / Akcesoria ochronne / Maski paintballowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochrona kolan i łokci",
    "categoryPath": [
      "(253965) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253965) Sport i turystyka / Militaria / Akcesoria ochronne / Ochrona kolan i łokci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochrona słuchu",
    "categoryPath": [
      "(253958) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253958) Sport i turystyka / Militaria / Akcesoria ochronne / Ochrona słuchu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Okulary",
    "categoryPath": [
      "(253960) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253960) Sport i turystyka / Militaria / Akcesoria ochronne / Okulary",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(253959) Sport i turystyka",
      "Militaria",
      "Akcesoria ochronne"
    ],
    "hierarchy": "(253959) Sport i turystyka / Militaria / Akcesoria ochronne / Rękawice",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ambony",
    "categoryPath": [
      "(320107) Sport i turystyka",
      "Militaria",
      "Myślistwo"
    ],
    "hierarchy": "(320107) Sport i turystyka / Militaria / Myślistwo / Ambony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Czyszczenie i konserwacja broni myśliwskiej",
    "categoryPath": [
      "(320104) Sport i turystyka",
      "Militaria",
      "Myślistwo"
    ],
    "hierarchy": "(320104) Sport i turystyka / Militaria / Myślistwo / Czyszczenie i konserwacja broni myśliwskiej",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(253945) Sport i turystyka",
      "Militaria",
      "Myślistwo"
    ],
    "hierarchy": "(253945) Sport i turystyka / Militaria / Myślistwo / Literatura",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253948) Sport i turystyka",
      "Militaria",
      "Myślistwo"
    ],
    "hierarchy": "(253948) Sport i turystyka / Militaria / Myślistwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Trofea",
    "categoryPath": [
      "(253946) Sport i turystyka",
      "Militaria",
      "Myślistwo"
    ],
    "hierarchy": "(253946) Sport i turystyka / Militaria / Myślistwo / Trofea",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wabiki",
    "categoryPath": [
      "(253947) Sport i turystyka",
      "Militaria",
      "Myślistwo"
    ],
    "hierarchy": "(253947) Sport i turystyka / Militaria / Myślistwo / Wabiki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Noże, maczety",
    "categoryPath": [
      "(253949) Sport i turystyka",
      "Militaria"
    ],
    "hierarchy": "(253949) Sport i turystyka / Militaria / Noże, maczety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256131) Sport i turystyka",
      "Militaria"
    ],
    "hierarchy": "(256131) Sport i turystyka / Militaria / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bielizna",
    "categoryPath": [
      "(253920) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253920) Sport i turystyka / Militaria / Odzież / Bielizna",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(253922) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253922) Sport i turystyka / Militaria / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki i kapelusze",
    "categoryPath": [
      "(253924) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253924) Sport i turystyka / Militaria / Odzież / Czapki i kapelusze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(253925) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253925) Sport i turystyka / Militaria / Odzież / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety mundurowe",
    "categoryPath": [
      "(320743) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(320743) Sport i turystyka / Militaria / Odzież / Komplety mundurowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule",
    "categoryPath": [
      "(253926) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253926) Sport i turystyka / Militaria / Odzież / Koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(253928) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253928) Sport i turystyka / Militaria / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Odzież patriotyczna",
    "categoryPath": [
      "(253929) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253929) Sport i turystyka / Militaria / Odzież / Odzież patriotyczna",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pasy",
    "categoryPath": [
      "(253931) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253931) Sport i turystyka / Militaria / Odzież / Pasy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(253932) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253932) Sport i turystyka / Militaria / Odzież / Rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(253934) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253934) Sport i turystyka / Militaria / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(253937) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253937) Sport i turystyka / Militaria / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(253938) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253938) Sport i turystyka / Militaria / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "T-shirty",
    "categoryPath": [
      "(253939) Sport i turystyka",
      "Militaria",
      "Odzież"
    ],
    "hierarchy": "(253939) Sport i turystyka / Militaria / Odzież / T-shirty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Lornetki",
    "categoryPath": [
      "(253911) Sport i turystyka",
      "Militaria",
      "Optyka"
    ],
    "hierarchy": "(253911) Sport i turystyka / Militaria / Optyka / Lornetki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Lunety celownicze",
    "categoryPath": [
      "(253912) Sport i turystyka",
      "Militaria",
      "Optyka"
    ],
    "hierarchy": "(253912) Sport i turystyka / Militaria / Optyka / Lunety celownicze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Butle i zawory",
    "categoryPath": [
      "(253973) Sport i turystyka",
      "Militaria",
      "Paintball"
    ],
    "hierarchy": "(253973) Sport i turystyka / Militaria / Paintball / Butle i zawory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Części do markerów",
    "categoryPath": [
      "(253974) Sport i turystyka",
      "Militaria",
      "Paintball"
    ],
    "hierarchy": "(253974) Sport i turystyka / Militaria / Paintball / Części do markerów",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kulki",
    "categoryPath": [
      "(253975) Sport i turystyka",
      "Militaria",
      "Paintball"
    ],
    "hierarchy": "(253975) Sport i turystyka / Militaria / Paintball / Kulki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Loadery",
    "categoryPath": [
      "(253976) Sport i turystyka",
      "Militaria",
      "Paintball"
    ],
    "hierarchy": "(253976) Sport i turystyka / Militaria / Paintball / Loadery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Lufy",
    "categoryPath": [
      "(253977) Sport i turystyka",
      "Militaria",
      "Paintball"
    ],
    "hierarchy": "(253977) Sport i turystyka / Militaria / Paintball / Lufy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Magazynki i kolanka",
    "categoryPath": [
      "(253978) Sport i turystyka",
      "Militaria",
      "Paintball"
    ],
    "hierarchy": "(253978) Sport i turystyka / Militaria / Paintball / Magazynki i kolanka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Markery",
    "categoryPath": [
      "(253979) Sport i turystyka",
      "Militaria",
      "Paintball"
    ],
    "hierarchy": "(253979) Sport i turystyka / Militaria / Paintball / Markery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Plecaki taktyczne",
    "categoryPath": [
      "(315533) Sport i turystyka",
      "Militaria"
    ],
    "hierarchy": "(315533) Sport i turystyka / Militaria / Plecaki taktyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253063) Sport i turystyka",
      "Militaria"
    ],
    "hierarchy": "(253063) Sport i turystyka / Militaria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dmuchawki",
    "categoryPath": [
      "(253951) Sport i turystyka",
      "Militaria",
      "Proce i dmuchawki"
    ],
    "hierarchy": "(253951) Sport i turystyka / Militaria / Proce i dmuchawki / Dmuchawki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kulki",
    "categoryPath": [
      "(253952) Sport i turystyka",
      "Militaria",
      "Proce i dmuchawki"
    ],
    "hierarchy": "(253952) Sport i turystyka / Militaria / Proce i dmuchawki / Kulki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Proce",
    "categoryPath": [
      "(253953) Sport i turystyka",
      "Militaria",
      "Proce i dmuchawki"
    ],
    "hierarchy": "(253953) Sport i turystyka / Militaria / Proce i dmuchawki / Proce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pokrowce, kufry, walizki",
    "categoryPath": [
      "(253906) Sport i turystyka",
      "Militaria",
      "Przechowywanie broni"
    ],
    "hierarchy": "(253906) Sport i turystyka / Militaria / Przechowywanie broni / Pokrowce, kufry, walizki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szafy i sejfy",
    "categoryPath": [
      "(315563) Sport i turystyka",
      "Militaria",
      "Przechowywanie broni"
    ],
    "hierarchy": "(315563) Sport i turystyka / Militaria / Przechowywanie broni / Szafy i sejfy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gazy pieprzowe",
    "categoryPath": [
      "(255084) Sport i turystyka",
      "Militaria",
      "Samoobrona"
    ],
    "hierarchy": "(255084) Sport i turystyka / Militaria / Samoobrona / Gazy pieprzowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kajdanki",
    "categoryPath": [
      "(253971) Sport i turystyka",
      "Militaria",
      "Samoobrona"
    ],
    "hierarchy": "(253971) Sport i turystyka / Militaria / Samoobrona / Kajdanki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kubotany",
    "categoryPath": [
      "(253967) Sport i turystyka",
      "Militaria",
      "Samoobrona"
    ],
    "hierarchy": "(253967) Sport i turystyka / Militaria / Samoobrona / Kubotany",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Odstraszacze i alarmy",
    "categoryPath": [
      "(253970) Sport i turystyka",
      "Militaria",
      "Samoobrona"
    ],
    "hierarchy": "(253970) Sport i turystyka / Militaria / Samoobrona / Odstraszacze i alarmy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Paralizatory",
    "categoryPath": [
      "(255085) Sport i turystyka",
      "Militaria",
      "Samoobrona"
    ],
    "hierarchy": "(255085) Sport i turystyka / Militaria / Samoobrona / Paralizatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pałki teleskopowe",
    "categoryPath": [
      "(253968) Sport i turystyka",
      "Militaria",
      "Samoobrona"
    ],
    "hierarchy": "(253968) Sport i turystyka / Militaria / Samoobrona / Pałki teleskopowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Tonfy i pałki klasyczne",
    "categoryPath": [
      "(253969) Sport i turystyka",
      "Militaria",
      "Samoobrona"
    ],
    "hierarchy": "(253969) Sport i turystyka / Militaria / Samoobrona / Tonfy i pałki klasyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Siatki maskujące",
    "categoryPath": [
      "(311793) Sport i turystyka",
      "Militaria"
    ],
    "hierarchy": "(311793) Sport i turystyka / Militaria / Siatki maskujące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria PCP",
    "categoryPath": [
      "(253886) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253886) Sport i turystyka / Militaria / Wiatrówki / Akcesoria PCP",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Czyszczenie i konserwacja wiatrówek",
    "categoryPath": [
      "(253890) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253890) Sport i turystyka / Militaria / Wiatrówki / Czyszczenie i konserwacja wiatrówek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(253892) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253892) Sport i turystyka / Militaria / Wiatrówki / Części",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Dwójnogi",
    "categoryPath": [
      "(253942) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253942) Sport i turystyka / Militaria / Wiatrówki / Dwójnogi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kabury",
    "categoryPath": [
      "(253894) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253894) Sport i turystyka / Militaria / Wiatrówki / Kabury",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karabinki",
    "categoryPath": [
      "(253897) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253897) Sport i turystyka / Militaria / Wiatrówki / Karabinki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Magazynki",
    "categoryPath": [
      "(253900) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253900) Sport i turystyka / Militaria / Wiatrówki / Magazynki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Naboje CO2",
    "categoryPath": [
      "(253902) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253902) Sport i turystyka / Militaria / Wiatrówki / Naboje CO2",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Okładziny rękojeści",
    "categoryPath": [
      "(253904) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253904) Sport i turystyka / Militaria / Wiatrówki / Okładziny rękojeści",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pistolety",
    "categoryPath": [
      "(253905) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253905) Sport i turystyka / Militaria / Wiatrówki / Pistolety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szyny i montaże",
    "categoryPath": [
      "(253909) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253909) Sport i turystyka / Militaria / Wiatrówki / Szyny i montaże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Tarcze, cele i kulochwyty",
    "categoryPath": [
      "(253914) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253914) Sport i turystyka / Militaria / Wiatrówki / Tarcze, cele i kulochwyty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Tuning",
    "categoryPath": [
      "(253916) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253916) Sport i turystyka / Militaria / Wiatrówki / Tuning",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Tłumiki, adaptery, kompensatory",
    "categoryPath": [
      "(253918) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253918) Sport i turystyka / Militaria / Wiatrówki / Tłumiki, adaptery, kompensatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Śruty",
    "categoryPath": [
      "(253921) Sport i turystyka",
      "Militaria",
      "Wiatrówki"
    ],
    "hierarchy": "(253921) Sport i turystyka / Militaria / Wiatrówki / Śruty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Cięciwy",
    "categoryPath": [
      "(253941) Sport i turystyka",
      "Militaria",
      "Łucznictwo"
    ],
    "hierarchy": "(253941) Sport i turystyka / Militaria / Łucznictwo / Cięciwy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kołczany",
    "categoryPath": [
      "(322281) Sport i turystyka",
      "Militaria",
      "Łucznictwo"
    ],
    "hierarchy": "(322281) Sport i turystyka / Militaria / Łucznictwo / Kołczany",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253933) Sport i turystyka",
      "Militaria",
      "Łucznictwo"
    ],
    "hierarchy": "(253933) Sport i turystyka / Militaria / Łucznictwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Strzały",
    "categoryPath": [
      "(253935) Sport i turystyka",
      "Militaria",
      "Łucznictwo"
    ],
    "hierarchy": "(253935) Sport i turystyka / Militaria / Łucznictwo / Strzały",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Tarcze łucznicze",
    "categoryPath": [
      "(253930) Sport i turystyka",
      "Militaria",
      "Łucznictwo"
    ],
    "hierarchy": "(253930) Sport i turystyka / Militaria / Łucznictwo / Tarcze łucznicze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Łuki",
    "categoryPath": [
      "(253936) Sport i turystyka",
      "Militaria",
      "Łucznictwo"
    ],
    "hierarchy": "(253936) Sport i turystyka / Militaria / Łucznictwo / Łuki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Baterie i akumulatory rowerowe",
    "categoryPath": [
      "(251483) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(251483) Sport i turystyka / Rowery i akcesoria / Akcesoria / Baterie i akumulatory rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bidony rowerowe",
    "categoryPath": [
      "(110167) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(110167) Sport i turystyka / Rowery i akcesoria / Akcesoria / Bidony rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Błotniki rowerowe",
    "categoryPath": [
      "(16424) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16424) Sport i turystyka / Rowery i akcesoria / Akcesoria / Błotniki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dzwonki rowerowe",
    "categoryPath": [
      "(110169) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(110169) Sport i turystyka / Rowery i akcesoria / Akcesoria / Dzwonki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Foteliki rowerowe",
    "categoryPath": [
      "(16425) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16425) Sport i turystyka / Rowery i akcesoria / Akcesoria / Foteliki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koszyki na bidony",
    "categoryPath": [
      "(110168) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(110168) Sport i turystyka / Rowery i akcesoria / Akcesoria / Koszyki na bidony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Liczniki rowerowe",
    "categoryPath": [
      "(16426) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16426) Sport i turystyka / Rowery i akcesoria / Akcesoria / Liczniki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lusterka rowerowe",
    "categoryPath": [
      "(110170) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(110170) Sport i turystyka / Rowery i akcesoria / Akcesoria / Lusterka rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maski antysmogowe",
    "categoryPath": [
      "(257496) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(257496) Sport i turystyka / Rowery i akcesoria / Akcesoria / Maski antysmogowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Naklejki na rower",
    "categoryPath": [
      "(98844) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(98844) Sport i turystyka / Rowery i akcesoria / Akcesoria / Naklejki na rower",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Odblaski",
    "categoryPath": [
      "(258268) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(258268) Sport i turystyka / Rowery i akcesoria / Akcesoria / Odblaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Osłony rowerowe",
    "categoryPath": [
      "(251484) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(251484) Sport i turystyka / Rowery i akcesoria / Akcesoria / Osłony rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Oświetlenie rowerowe",
    "categoryPath": [
      "(16427) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16427) Sport i turystyka / Rowery i akcesoria / Akcesoria / Oświetlenie rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Plecaki rowerowe",
    "categoryPath": [
      "(110171) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(110171) Sport i turystyka / Rowery i akcesoria / Akcesoria / Plecaki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce rowerowe",
    "categoryPath": [
      "(98845) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(98845) Sport i turystyka / Rowery i akcesoria / Akcesoria / Pokrowce rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pompki rowerowe",
    "categoryPath": [
      "(16428) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16428) Sport i turystyka / Rowery i akcesoria / Akcesoria / Pompki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16431) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16431) Sport i turystyka / Rowery i akcesoria / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyczepki rowerowe",
    "categoryPath": [
      "(98846) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(98846) Sport i turystyka / Rowery i akcesoria / Akcesoria / Przyczepki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pulsometry",
    "categoryPath": [
      "(16691) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16691) Sport i turystyka / Rowery i akcesoria / Akcesoria / Pulsometry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bagażniki rowerowe",
    "categoryPath": [
      "(98850) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt bagażowy"
    ],
    "hierarchy": "(98850) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt bagażowy / Bagażniki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gumy i taśmy do bagażnika",
    "categoryPath": [
      "(260889) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt bagażowy"
    ],
    "hierarchy": "(260889) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt bagażowy / Gumy i taśmy do bagażnika",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosze rowerowe",
    "categoryPath": [
      "(98851) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt bagażowy"
    ],
    "hierarchy": "(98851) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt bagażowy / Kosze rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kufry rowerowe",
    "categoryPath": [
      "(98852) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt bagażowy"
    ],
    "hierarchy": "(98852) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt bagażowy / Kufry rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mapniki i torebki rowerowe",
    "categoryPath": [
      "(98853) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt bagażowy"
    ],
    "hierarchy": "(98853) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt bagażowy / Mapniki i torebki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(98849) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt bagażowy"
    ],
    "hierarchy": "(98849) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt bagażowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sakwy rowerowe",
    "categoryPath": [
      "(98855) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt bagażowy"
    ],
    "hierarchy": "(98855) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt bagażowy / Sakwy rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stojaki na rower",
    "categoryPath": [
      "(98858) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt postojowy"
    ],
    "hierarchy": "(98858) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt postojowy / Stojaki na rower",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stopki rowerowe",
    "categoryPath": [
      "(98859) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt postojowy"
    ],
    "hierarchy": "(98859) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt postojowy / Stopki rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wieszaki, uchwyty na rower",
    "categoryPath": [
      "(98860) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria",
      "Sprzęt postojowy"
    ],
    "hierarchy": "(98860) Sport i turystyka / Rowery i akcesoria / Akcesoria / Sprzęt postojowy / Wieszaki, uchwyty na rower",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty na rower",
    "categoryPath": [
      "(251485) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(251485) Sport i turystyka / Rowery i akcesoria / Akcesoria / Uchwyty na rower",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zabezpieczenia rowerowe",
    "categoryPath": [
      "(16430) Sport i turystyka",
      "Rowery i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(16430) Sport i turystyka / Rowery i akcesoria / Akcesoria / Zabezpieczenia rowerowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Przednie",
    "categoryPath": [
      "(16695) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Amortyzatory"
    ],
    "hierarchy": "(16695) Sport i turystyka / Rowery i akcesoria / Części / Amortyzatory / Przednie",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Tylne",
    "categoryPath": [
      "(16694) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Amortyzatory"
    ],
    "hierarchy": "(16694) Sport i turystyka / Rowery i akcesoria / Części / Amortyzatory / Tylne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Chwyty",
    "categoryPath": [
      "(16433) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16433) Sport i turystyka / Rowery i akcesoria / Części / Chwyty",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Części do rowerów elektrycznych",
    "categoryPath": [
      "(319835) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(319835) Sport i turystyka / Rowery i akcesoria / Części / Części do rowerów elektrycznych",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Adaptery",
    "categoryPath": [
      "(251497) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251497) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Adaptery",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Części do hamulców",
    "categoryPath": [
      "(251498) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251498) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Części do hamulców",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Dźwignie hamulcowe",
    "categoryPath": [
      "(251499) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251499) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Dźwignie hamulcowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Hamulce szczękowe",
    "categoryPath": [
      "(259807) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(259807) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Hamulce szczękowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Hamulce tarczowe hydrauliczne",
    "categoryPath": [
      "(251501) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251501) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Hamulce tarczowe hydrauliczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Hamulce tarczowe mechaniczne",
    "categoryPath": [
      "(251502) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251502) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Hamulce tarczowe mechaniczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Klocki, okładziny",
    "categoryPath": [
      "(251503) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251503) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Klocki, okładziny",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Odpowietrzanie hamulców",
    "categoryPath": [
      "(259877) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(259877) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Odpowietrzanie hamulców",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Przewody hydrauliczne",
    "categoryPath": [
      "(251505) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251505) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Przewody hydrauliczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Płyny hamulcowe",
    "categoryPath": [
      "(251504) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251504) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Płyny hamulcowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Tarcze hamulcowe",
    "categoryPath": [
      "(251506) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251506) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Tarcze hamulcowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Zaciski hydrauliczne",
    "categoryPath": [
      "(251507) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Hamulce"
    ],
    "hierarchy": "(251507) Sport i turystyka / Rowery i akcesoria / Części / Hamulce / Zaciski hydrauliczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Części do kaset",
    "categoryPath": [
      "(251514) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Kasety, łańcuchy, wolnobiegi"
    ],
    "hierarchy": "(251514) Sport i turystyka / Rowery i akcesoria / Części / Kasety, łańcuchy, wolnobiegi / Części do kaset",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Kasety",
    "categoryPath": [
      "(251515) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Kasety, łańcuchy, wolnobiegi"
    ],
    "hierarchy": "(251515) Sport i turystyka / Rowery i akcesoria / Części / Kasety, łańcuchy, wolnobiegi / Kasety",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Kasety z łańcuchami",
    "categoryPath": [
      "(251516) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Kasety, łańcuchy, wolnobiegi"
    ],
    "hierarchy": "(251516) Sport i turystyka / Rowery i akcesoria / Części / Kasety, łańcuchy, wolnobiegi / Kasety z łańcuchami",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Spinki i ogniwa",
    "categoryPath": [
      "(251518) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Kasety, łańcuchy, wolnobiegi"
    ],
    "hierarchy": "(251518) Sport i turystyka / Rowery i akcesoria / Części / Kasety, łańcuchy, wolnobiegi / Spinki i ogniwa",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Wolnobiegi",
    "categoryPath": [
      "(251519) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Kasety, łańcuchy, wolnobiegi"
    ],
    "hierarchy": "(251519) Sport i turystyka / Rowery i akcesoria / Części / Kasety, łańcuchy, wolnobiegi / Wolnobiegi",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Łańcuchy",
    "categoryPath": [
      "(251517) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Kasety, łańcuchy, wolnobiegi"
    ],
    "hierarchy": "(251517) Sport i turystyka / Rowery i akcesoria / Części / Kasety, łańcuchy, wolnobiegi / Łańcuchy",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Kierownice",
    "categoryPath": [
      "(16453) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16453) Sport i turystyka / Rowery i akcesoria / Części / Kierownice",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Kompletne grupy osprzętu",
    "categoryPath": [
      "(318951) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(318951) Sport i turystyka / Rowery i akcesoria / Części / Kompletne grupy osprzętu",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "12\"/ 203mm",
    "categoryPath": [
      "(251762) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251762) Sport i turystyka / Rowery i akcesoria / Części / Koła / 12\"/ 203mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "16\"/ 305/349mm",
    "categoryPath": [
      "(251763) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251763) Sport i turystyka / Rowery i akcesoria / Części / Koła / 16\"/ 305/349mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "20\"/ 406mm",
    "categoryPath": [
      "(251764) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251764) Sport i turystyka / Rowery i akcesoria / Części / Koła / 20\"/ 406mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "24\"/ 507mm",
    "categoryPath": [
      "(251765) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251765) Sport i turystyka / Rowery i akcesoria / Części / Koła / 24\"/ 507mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "26\"/ 559mm",
    "categoryPath": [
      "(251521) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251521) Sport i turystyka / Rowery i akcesoria / Części / Koła / 26\"/ 559mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "27,5\"/ 585mm",
    "categoryPath": [
      "(251522) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251522) Sport i turystyka / Rowery i akcesoria / Części / Koła / 27,5\"/ 585mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "28\"/ 622mm",
    "categoryPath": [
      "(251523) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251523) Sport i turystyka / Rowery i akcesoria / Części / Koła / 28\"/ 622mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "29\"/ 622mm",
    "categoryPath": [
      "(251524) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251524) Sport i turystyka / Rowery i akcesoria / Części / Koła / 29\"/ 622mm",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Opaski na obręcz",
    "categoryPath": [
      "(251525) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251525) Sport i turystyka / Rowery i akcesoria / Części / Koła / Opaski na obręcz",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(251520) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251520) Sport i turystyka / Rowery i akcesoria / Części / Koła / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zaciski",
    "categoryPath": [
      "(251526) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Koła"
    ],
    "hierarchy": "(251526) Sport i turystyka / Rowery i akcesoria / Części / Koła / Zaciski",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Linki i pancerze",
    "categoryPath": [
      "(16684) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16684) Sport i turystyka / Rowery i akcesoria / Części / Linki i pancerze",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Akcesoria i części",
    "categoryPath": [
      "(251537) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Manetki, klamki, klamkomanetki"
    ],
    "hierarchy": "(251537) Sport i turystyka / Rowery i akcesoria / Części / Manetki, klamki, klamkomanetki / Akcesoria i części",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klamkomanetki",
    "categoryPath": [
      "(251536) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Manetki, klamki, klamkomanetki"
    ],
    "hierarchy": "(251536) Sport i turystyka / Rowery i akcesoria / Części / Manetki, klamki, klamkomanetki / Klamkomanetki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Manetki",
    "categoryPath": [
      "(251534) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Manetki, klamki, klamkomanetki"
    ],
    "hierarchy": "(251534) Sport i turystyka / Rowery i akcesoria / Części / Manetki, klamki, klamkomanetki / Manetki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Mechanizmy korbowe",
    "categoryPath": [
      "(251529) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Mechanizmy korbowe i części"
    ],
    "hierarchy": "(251529) Sport i turystyka / Rowery i akcesoria / Części / Mechanizmy korbowe i części / Mechanizmy korbowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Osłony",
    "categoryPath": [
      "(251530) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Mechanizmy korbowe i części"
    ],
    "hierarchy": "(251530) Sport i turystyka / Rowery i akcesoria / Części / Mechanizmy korbowe i części / Osłony",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Tarcze i części",
    "categoryPath": [
      "(251531) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Mechanizmy korbowe i części"
    ],
    "hierarchy": "(251531) Sport i turystyka / Rowery i akcesoria / Części / Mechanizmy korbowe i części / Tarcze i części",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "ahead",
    "categoryPath": [
      "(251538) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Mostki"
    ],
    "hierarchy": "(251538) Sport i turystyka / Rowery i akcesoria / Części / Mostki / ahead",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "wpuszczane",
    "categoryPath": [
      "(251539) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Mostki"
    ],
    "hierarchy": "(251539) Sport i turystyka / Rowery i akcesoria / Części / Mostki / wpuszczane",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Obręcze",
    "categoryPath": [
      "(16437) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16437) Sport i turystyka / Rowery i akcesoria / Części / Obręcze",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Dętki",
    "categoryPath": [
      "(251496) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Opony i dętki"
    ],
    "hierarchy": "(251496) Sport i turystyka / Rowery i akcesoria / Części / Opony i dętki / Dętki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Opony",
    "categoryPath": [
      "(251495) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Opony i dętki"
    ],
    "hierarchy": "(251495) Sport i turystyka / Rowery i akcesoria / Części / Opony i dętki / Opony",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Szytki",
    "categoryPath": [
      "(322918) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Opony i dętki"
    ],
    "hierarchy": "(322918) Sport i turystyka / Rowery i akcesoria / Części / Opony i dętki / Szytki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Wentyle i części",
    "categoryPath": [
      "(321065) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Opony i dętki"
    ],
    "hierarchy": "(321065) Sport i turystyka / Rowery i akcesoria / Części / Opony i dętki / Wentyle i części",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Wkładki",
    "categoryPath": [
      "(322134) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Opony i dętki"
    ],
    "hierarchy": "(322134) Sport i turystyka / Rowery i akcesoria / Części / Opony i dętki / Wkładki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Łatki",
    "categoryPath": [
      "(322133) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Opony i dętki"
    ],
    "hierarchy": "(322133) Sport i turystyka / Rowery i akcesoria / Części / Opony i dętki / Łatki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Owijki",
    "categoryPath": [
      "(258575) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(258575) Sport i turystyka / Rowery i akcesoria / Części / Owijki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Akcesoria i części",
    "categoryPath": [
      "(251542) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Pedały i akcesoria"
    ],
    "hierarchy": "(251542) Sport i turystyka / Rowery i akcesoria / Części / Pedały i akcesoria / Akcesoria i części",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bloki (zatrzaski)",
    "categoryPath": [
      "(251543) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Pedały i akcesoria"
    ],
    "hierarchy": "(251543) Sport i turystyka / Rowery i akcesoria / Części / Pedały i akcesoria / Bloki (zatrzaski)",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pedały platformowe",
    "categoryPath": [
      "(251545) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Pedały i akcesoria"
    ],
    "hierarchy": "(251545) Sport i turystyka / Rowery i akcesoria / Części / Pedały i akcesoria / Pedały platformowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pedały zatrzaskowe",
    "categoryPath": [
      "(251544) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Pedały i akcesoria"
    ],
    "hierarchy": "(251544) Sport i turystyka / Rowery i akcesoria / Części / Pedały i akcesoria / Pedały zatrzaskowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Piasty",
    "categoryPath": [
      "(16445) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16445) Sport i turystyka / Rowery i akcesoria / Części / Piasty",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16452) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16452) Sport i turystyka / Rowery i akcesoria / Części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Części",
    "categoryPath": [
      "(251682) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Przerzutki"
    ],
    "hierarchy": "(251682) Sport i turystyka / Rowery i akcesoria / Części / Przerzutki / Części",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Przednie",
    "categoryPath": [
      "(251547) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Przerzutki"
    ],
    "hierarchy": "(251547) Sport i turystyka / Rowery i akcesoria / Części / Przerzutki / Przednie",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Tylne",
    "categoryPath": [
      "(251546) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Przerzutki"
    ],
    "hierarchy": "(251546) Sport i turystyka / Rowery i akcesoria / Części / Przerzutki / Tylne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Ramy",
    "categoryPath": [
      "(16447) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16447) Sport i turystyka / Rowery i akcesoria / Części / Ramy",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Rogi",
    "categoryPath": [
      "(16462) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16462) Sport i turystyka / Rowery i akcesoria / Części / Rogi",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Siodełka",
    "categoryPath": [
      "(16448) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16448) Sport i turystyka / Rowery i akcesoria / Części / Siodełka",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Stery",
    "categoryPath": [
      "(16449) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16449) Sport i turystyka / Rowery i akcesoria / Części / Stery",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Suporty",
    "categoryPath": [
      "(16440) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16440) Sport i turystyka / Rowery i akcesoria / Części / Suporty",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Taśmy obręczowe",
    "categoryPath": [
      "(321010) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "System bezdętkowy (tubeless)"
    ],
    "hierarchy": "(321010) Sport i turystyka / Rowery i akcesoria / Części / System bezdętkowy (tubeless) / Taśmy obręczowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Uszczelniacze do opon",
    "categoryPath": [
      "(321025) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "System bezdętkowy (tubeless)"
    ],
    "hierarchy": "(321025) Sport i turystyka / Rowery i akcesoria / Części / System bezdętkowy (tubeless) / Uszczelniacze do opon",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Wentyle",
    "categoryPath": [
      "(321013) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "System bezdętkowy (tubeless)"
    ],
    "hierarchy": "(321013) Sport i turystyka / Rowery i akcesoria / Części / System bezdętkowy (tubeless) / Wentyle",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(321016) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "System bezdętkowy (tubeless)"
    ],
    "hierarchy": "(321016) Sport i turystyka / Rowery i akcesoria / Części / System bezdętkowy (tubeless) / Zestawy",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Szprychy",
    "categoryPath": [
      "(16438) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16438) Sport i turystyka / Rowery i akcesoria / Części / Szprychy",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Amortyzowane",
    "categoryPath": [
      "(251548) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Sztyce"
    ],
    "hierarchy": "(251548) Sport i turystyka / Rowery i akcesoria / Części / Sztyce / Amortyzowane",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Regulowane",
    "categoryPath": [
      "(254858) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Sztyce"
    ],
    "hierarchy": "(254858) Sport i turystyka / Rowery i akcesoria / Części / Sztyce / Regulowane",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Sztywne",
    "categoryPath": [
      "(251549) Sport i turystyka",
      "Rowery i akcesoria",
      "Części",
      "Sztyce"
    ],
    "hierarchy": "(251549) Sport i turystyka / Rowery i akcesoria / Części / Sztyce / Sztywne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Widelce sztywne",
    "categoryPath": [
      "(16693) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16693) Sport i turystyka / Rowery i akcesoria / Części / Widelce sztywne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Zabytkowe",
    "categoryPath": [
      "(16451) Sport i turystyka",
      "Rowery i akcesoria",
      "Części"
    ],
    "hierarchy": "(16451) Sport i turystyka / Rowery i akcesoria / Części / Zabytkowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(110163) Sport i turystyka",
      "Rowery i akcesoria"
    ],
    "hierarchy": "(110163) Sport i turystyka / Rowery i akcesoria / Kaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Narzędzia",
    "categoryPath": [
      "(45627) Sport i turystyka",
      "Rowery i akcesoria",
      "Narzędzia i smary"
    ],
    "hierarchy": "(45627) Sport i turystyka / Rowery i akcesoria / Narzędzia i smary / Narzędzia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Oleje, smary, odtłuszczacze",
    "categoryPath": [
      "(45628) Sport i turystyka",
      "Rowery i akcesoria",
      "Narzędzia i smary"
    ],
    "hierarchy": "(45628) Sport i turystyka / Rowery i akcesoria / Narzędzia i smary / Oleje, smary, odtłuszczacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(110166) Sport i turystyka",
      "Rowery i akcesoria"
    ],
    "hierarchy": "(110166) Sport i turystyka / Rowery i akcesoria / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(110164) Sport i turystyka",
      "Rowery i akcesoria"
    ],
    "hierarchy": "(110164) Sport i turystyka / Rowery i akcesoria / Ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(110172) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110172) Sport i turystyka / Rowery i akcesoria / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(251486) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(251486) Sport i turystyka / Rowery i akcesoria / Odzież / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(110174) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110174) Sport i turystyka / Rowery i akcesoria / Odzież / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(110175) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110175) Sport i turystyka / Rowery i akcesoria / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(110176) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110176) Sport i turystyka / Rowery i akcesoria / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Nakrycia głowy",
    "categoryPath": [
      "(110173) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110173) Sport i turystyka / Rowery i akcesoria / Odzież / Nakrycia głowy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Nogawki",
    "categoryPath": [
      "(251487) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(251487) Sport i turystyka / Rowery i akcesoria / Odzież / Nogawki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(110177) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110177) Sport i turystyka / Rowery i akcesoria / Odzież / Rękawiczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawki",
    "categoryPath": [
      "(251489) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(251489) Sport i turystyka / Rowery i akcesoria / Odzież / Rękawki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpetki",
    "categoryPath": [
      "(110178) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110178) Sport i turystyka / Rowery i akcesoria / Odzież / Skarpetki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(110179) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110179) Sport i turystyka / Rowery i akcesoria / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie, legginsy",
    "categoryPath": [
      "(110180) Sport i turystyka",
      "Rowery i akcesoria",
      "Odzież"
    ],
    "hierarchy": "(110180) Sport i turystyka / Rowery i akcesoria / Odzież / Spodnie, legginsy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Okulary",
    "categoryPath": [
      "(110182) Sport i turystyka",
      "Rowery i akcesoria"
    ],
    "hierarchy": "(110182) Sport i turystyka / Rowery i akcesoria / Okulary",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16421) Sport i turystyka",
      "Rowery i akcesoria"
    ],
    "hierarchy": "(16421) Sport i turystyka / Rowery i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "BMX",
    "categoryPath": [
      "(16480) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16480) Sport i turystyka / Rowery i akcesoria / Rowery / BMX",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Crossowe",
    "categoryPath": [
      "(125055) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(125055) Sport i turystyka / Rowery i akcesoria / Rowery / Crossowe",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Cruiser",
    "categoryPath": [
      "(254379) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254379) Sport i turystyka / Rowery i akcesoria / Rowery / Cruiser",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Dirt, Dual",
    "categoryPath": [
      "(254380) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254380) Sport i turystyka / Rowery i akcesoria / Rowery / Dirt, Dual",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Dziecięce",
    "categoryPath": [
      "(16481) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16481) Sport i turystyka / Rowery i akcesoria / Rowery / Dziecięce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Elektryczne",
    "categoryPath": [
      "(125056) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(125056) Sport i turystyka / Rowery i akcesoria / Rowery / Elektryczne",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Fatbike",
    "categoryPath": [
      "(254381) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254381) Sport i turystyka / Rowery i akcesoria / Rowery / Fatbike",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Junior (koła 24 cale)",
    "categoryPath": [
      "(254382) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254382) Sport i turystyka / Rowery i akcesoria / Rowery / Junior (koła 24 cale)",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "MTB (górskie)",
    "categoryPath": [
      "(16483) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16483) Sport i turystyka / Rowery i akcesoria / Rowery / MTB (górskie)",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Miejskie",
    "categoryPath": [
      "(16482) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16482) Sport i turystyka / Rowery i akcesoria / Rowery / Miejskie",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16479) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16479) Sport i turystyka / Rowery i akcesoria / Rowery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przełajowe, Gravel",
    "categoryPath": [
      "(254383) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254383) Sport i turystyka / Rowery i akcesoria / Rowery / Przełajowe, Gravel",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Singlespeed, Ostre koło",
    "categoryPath": [
      "(254386) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254386) Sport i turystyka / Rowery i akcesoria / Rowery / Singlespeed, Ostre koło",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Składane",
    "categoryPath": [
      "(254384) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254384) Sport i turystyka / Rowery i akcesoria / Rowery / Składane",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Szosowe",
    "categoryPath": [
      "(16484) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16484) Sport i turystyka / Rowery i akcesoria / Rowery / Szosowe",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Tandemy",
    "categoryPath": [
      "(254387) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254387) Sport i turystyka / Rowery i akcesoria / Rowery / Tandemy",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Trekkingowe",
    "categoryPath": [
      "(16485) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16485) Sport i turystyka / Rowery i akcesoria / Rowery / Trekkingowe",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Triathlonowe",
    "categoryPath": [
      "(254385) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(254385) Sport i turystyka / Rowery i akcesoria / Rowery / Triathlonowe",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Trójkołowe",
    "categoryPath": [
      "(257345) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(257345) Sport i turystyka / Rowery i akcesoria / Rowery / Trójkołowe",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Zabytkowe",
    "categoryPath": [
      "(16486) Sport i turystyka",
      "Rowery i akcesoria",
      "Rowery"
    ],
    "hierarchy": "(16486) Sport i turystyka / Rowery i akcesoria / Rowery / Zabytkowe",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Trenażery",
    "categoryPath": [
      "(28573) Sport i turystyka",
      "Rowery i akcesoria"
    ],
    "hierarchy": "(28573) Sport i turystyka / Rowery i akcesoria / Trenażery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Maski treningowe, wydolnościowe",
    "categoryPath": [
      "(310497) Sport i turystyka",
      "Siłownia i fitness",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(310497) Sport i turystyka / Siłownia i fitness / Akcesoria treningowe / Maski treningowe, wydolnościowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Opaski magnetyczne, silikonowe",
    "categoryPath": [
      "(147585) Sport i turystyka",
      "Siłownia i fitness",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(147585) Sport i turystyka / Siłownia i fitness / Akcesoria treningowe / Opaski magnetyczne, silikonowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ręczniki treningowe",
    "categoryPath": [
      "(147584) Sport i turystyka",
      "Siłownia i fitness",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(147584) Sport i turystyka / Siłownia i fitness / Akcesoria treningowe / Ręczniki treningowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Shakery, bidony",
    "categoryPath": [
      "(147582) Sport i turystyka",
      "Siłownia i fitness",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(147582) Sport i turystyka / Siłownia i fitness / Akcesoria treningowe / Shakery, bidony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Torby i plecaki treningowe",
    "categoryPath": [
      "(147583) Sport i turystyka",
      "Siłownia i fitness",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(147583) Sport i turystyka / Siłownia i fitness / Akcesoria treningowe / Torby i plecaki treningowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Filmy",
    "categoryPath": [
      "(19632) Sport i turystyka",
      "Siłownia i fitness",
      "Literatura i filmy"
    ],
    "hierarchy": "(19632) Sport i turystyka / Siłownia i fitness / Literatura i filmy / Filmy",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(19630) Sport i turystyka",
      "Siłownia i fitness",
      "Literatura i filmy"
    ],
    "hierarchy": "(19630) Sport i turystyka / Siłownia i fitness / Literatura i filmy / Literatura",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256132) Sport i turystyka",
      "Siłownia i fitness"
    ],
    "hierarchy": "(256132) Sport i turystyka / Siłownia i fitness / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(19636) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(19636) Sport i turystyka / Siłownia i fitness / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(147576) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(147576) Sport i turystyka / Siłownia i fitness / Odzież / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(110162) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(110162) Sport i turystyka / Siłownia i fitness / Odzież / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(19638) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(19638) Sport i turystyka / Siłownia i fitness / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Legginsy",
    "categoryPath": [
      "(260337) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(260337) Sport i turystyka / Siłownia i fitness / Odzież / Legginsy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Majtki",
    "categoryPath": [
      "(19635) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(19635) Sport i turystyka / Siłownia i fitness / Odzież / Majtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawiczki treningowe",
    "categoryPath": [
      "(19640) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(19640) Sport i turystyka / Siłownia i fitness / Odzież / Rękawiczki treningowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(147577) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(147577) Sport i turystyka / Siłownia i fitness / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(147578) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(147578) Sport i turystyka / Siłownia i fitness / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie treningowe",
    "categoryPath": [
      "(19641) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(19641) Sport i turystyka / Siłownia i fitness / Odzież / Spodnie treningowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Staniki sportowe, topy",
    "categoryPath": [
      "(260336) Sport i turystyka",
      "Siłownia i fitness",
      "Odzież"
    ],
    "hierarchy": "(260336) Sport i turystyka / Siłownia i fitness / Odzież / Staniki sportowe, topy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19628) Sport i turystyka",
      "Siłownia i fitness"
    ],
    "hierarchy": "(19628) Sport i turystyka / Siłownia i fitness / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Aminokwasy",
    "categoryPath": [
      "(19657) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19657) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Aminokwasy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Boostery testosteronu",
    "categoryPath": [
      "(19667) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19667) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Boostery testosteronu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Gainery",
    "categoryPath": [
      "(45626) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(45626) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Gainery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "HMB",
    "categoryPath": [
      "(19659) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19659) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / HMB",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kreatyny",
    "categoryPath": [
      "(19660) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19660) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Kreatyny",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ochrona stawów",
    "categoryPath": [
      "(19661) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19661) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Ochrona stawów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odżywki białkowe",
    "categoryPath": [
      "(19662) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19662) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Odżywki białkowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odżywki potreningowe",
    "categoryPath": [
      "(256645) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(256645) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Odżywki potreningowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odżywki przedtreningowe",
    "categoryPath": [
      "(125522) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(125522) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Odżywki przedtreningowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(19656) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19656) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spalacze tłuszczu",
    "categoryPath": [
      "(19664) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19664) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Spalacze tłuszczu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Witaminy i minerały",
    "categoryPath": [
      "(19666) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19666) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Witaminy i minerały",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Węglowodany",
    "categoryPath": [
      "(19665) Sport i turystyka",
      "Siłownia i fitness",
      "Suplementy i odżywki"
    ],
    "hierarchy": "(19665) Sport i turystyka / Siłownia i fitness / Suplementy i odżywki / Węglowodany",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Akcesoria do jogi",
    "categoryPath": [
      "(307405) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(307405) Sport i turystyka / Siłownia i fitness / Trening fitness / Akcesoria do jogi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bieżnie",
    "categoryPath": [
      "(110133) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110133) Sport i turystyka / Siłownia i fitness / Trening fitness / Bieżnie",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Drabinki treningowe",
    "categoryPath": [
      "(260314) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(260314) Sport i turystyka / Siłownia i fitness / Trening fitness / Drabinki treningowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Ekspandery",
    "categoryPath": [
      "(110160) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110160) Sport i turystyka / Siłownia i fitness / Trening fitness / Ekspandery",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Hantelki",
    "categoryPath": [
      "(110134) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110134) Sport i turystyka / Siłownia i fitness / Trening fitness / Hantelki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Hula hop",
    "categoryPath": [
      "(110158) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110158) Sport i turystyka / Siłownia i fitness / Trening fitness / Hula hop",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Kołyski do brzuszków",
    "categoryPath": [
      "(147563) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(147563) Sport i turystyka / Siłownia i fitness / Trening fitness / Kołyski do brzuszków",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Masażery i platformy wibracyjne",
    "categoryPath": [
      "(110135) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110135) Sport i turystyka / Siłownia i fitness / Trening fitness / Masażery i platformy wibracyjne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Materace gimnastyczne",
    "categoryPath": [
      "(147562) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(147562) Sport i turystyka / Siłownia i fitness / Trening fitness / Materace gimnastyczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Maty",
    "categoryPath": [
      "(110136) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110136) Sport i turystyka / Siłownia i fitness / Trening fitness / Maty",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Motylki do ćwiczeń",
    "categoryPath": [
      "(259699) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(259699) Sport i turystyka / Siłownia i fitness / Trening fitness / Motylki do ćwiczeń",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Obciążniki do ćwiczeń",
    "categoryPath": [
      "(110137) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110137) Sport i turystyka / Siłownia i fitness / Trening fitness / Obciążniki do ćwiczeń",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Pasy wyszczuplające i elektrostymulatory mięśni",
    "categoryPath": [
      "(110142) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110142) Sport i turystyka / Siłownia i fitness / Trening fitness / Pasy wyszczuplające i elektrostymulatory mięśni",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Piłki do ćwiczeń",
    "categoryPath": [
      "(110139) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110139) Sport i turystyka / Siłownia i fitness / Trening fitness / Piłki do ćwiczeń",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Rollery, wałki, kółka i piłeczki do masażu",
    "categoryPath": [
      "(147564) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(147564) Sport i turystyka / Siłownia i fitness / Trening fitness / Rollery, wałki, kółka i piłeczki do masażu",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Rowery treningowe",
    "categoryPath": [
      "(110140) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110140) Sport i turystyka / Siłownia i fitness / Trening fitness / Rowery treningowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Skakanki",
    "categoryPath": [
      "(110159) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110159) Sport i turystyka / Siłownia i fitness / Trening fitness / Skakanki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Stepy i steppery",
    "categoryPath": [
      "(110141) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110141) Sport i turystyka / Siłownia i fitness / Trening fitness / Stepy i steppery",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Taśmy i gumy do ćwiczeń",
    "categoryPath": [
      "(110161) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110161) Sport i turystyka / Siłownia i fitness / Trening fitness / Taśmy i gumy do ćwiczeń",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Trampoliny fitness",
    "categoryPath": [
      "(257022) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(257022) Sport i turystyka / Siłownia i fitness / Trening fitness / Trampoliny fitness",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Trenażery eliptyczne",
    "categoryPath": [
      "(110138) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110138) Sport i turystyka / Siłownia i fitness / Trening fitness / Trenażery eliptyczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Twistery",
    "categoryPath": [
      "(110143) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110143) Sport i turystyka / Siłownia i fitness / Trening fitness / Twistery",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Wioślarze",
    "categoryPath": [
      "(110144) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(110144) Sport i turystyka / Siłownia i fitness / Trening fitness / Wioślarze",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Ściskacze, kule żyroskopowe",
    "categoryPath": [
      "(147565) Sport i turystyka",
      "Siłownia i fitness",
      "Trening fitness"
    ],
    "hierarchy": "(147565) Sport i turystyka / Siłownia i fitness / Trening fitness / Ściskacze, kule żyroskopowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Atlasy",
    "categoryPath": [
      "(110146) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110146) Sport i turystyka / Siłownia i fitness / Trening siłowy / Atlasy",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Drążki i poręcze",
    "categoryPath": [
      "(110147) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110147) Sport i turystyka / Siłownia i fitness / Trening siłowy / Drążki i poręcze",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Gryfy",
    "categoryPath": [
      "(110149) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110149) Sport i turystyka / Siłownia i fitness / Trening siłowy / Gryfy",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Hantle",
    "categoryPath": [
      "(110148) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110148) Sport i turystyka / Siłownia i fitness / Trening siłowy / Hantle",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Kettlebelle",
    "categoryPath": [
      "(256902) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(256902) Sport i turystyka / Siłownia i fitness / Trening siłowy / Kettlebelle",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Obciążenia",
    "categoryPath": [
      "(110151) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110151) Sport i turystyka / Siłownia i fitness / Trening siłowy / Obciążenia",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Pasy kulturystyczne",
    "categoryPath": [
      "(110152) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110152) Sport i turystyka / Siłownia i fitness / Trening siłowy / Pasy kulturystyczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Stojaki",
    "categoryPath": [
      "(260308) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(260308) Sport i turystyka / Siłownia i fitness / Trening siłowy / Stojaki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Sztangi",
    "categoryPath": [
      "(110153) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110153) Sport i turystyka / Siłownia i fitness / Trening siłowy / Sztangi",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Uchwyty do pompek",
    "categoryPath": [
      "(147567) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(147567) Sport i turystyka / Siłownia i fitness / Trening siłowy / Uchwyty do pompek",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Wyciągi",
    "categoryPath": [
      "(260309) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(260309) Sport i turystyka / Siłownia i fitness / Trening siłowy / Wyciągi",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Zaciski",
    "categoryPath": [
      "(322055) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(322055) Sport i turystyka / Siłownia i fitness / Trening siłowy / Zaciski",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Zestawy kulturystyczne",
    "categoryPath": [
      "(110154) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110154) Sport i turystyka / Siłownia i fitness / Trening siłowy / Zestawy kulturystyczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Ławki",
    "categoryPath": [
      "(110150) Sport i turystyka",
      "Siłownia i fitness",
      "Trening siłowy"
    ],
    "hierarchy": "(110150) Sport i turystyka / Siłownia i fitness / Trening siłowy / Ławki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Ściągacze i stabilizatory",
    "categoryPath": [
      "(110155) Sport i turystyka",
      "Siłownia i fitness"
    ],
    "hierarchy": "(110155) Sport i turystyka / Siłownia i fitness / Ściągacze i stabilizatory",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Blaty",
    "categoryPath": [
      "(260652) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260652) Sport i turystyka / Skating, slackline / Części / Blaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gripy",
    "categoryPath": [
      "(260655) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260655) Sport i turystyka / Skating, slackline / Części / Gripy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Hamulce",
    "categoryPath": [
      "(260658) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260658) Sport i turystyka / Skating, slackline / Części / Hamulce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kółka",
    "categoryPath": [
      "(260653) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260653) Sport i turystyka / Skating, slackline / Części / Kółka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Opony",
    "categoryPath": [
      "(321317) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(321317) Sport i turystyka / Skating, slackline / Części / Opony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260651) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260651) Sport i turystyka / Skating, slackline / Części / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Trucki",
    "categoryPath": [
      "(260656) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260656) Sport i turystyka / Skating, slackline / Części / Trucki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Łożyska",
    "categoryPath": [
      "(260654) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260654) Sport i turystyka / Skating, slackline / Części / Łożyska",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Śruby",
    "categoryPath": [
      "(260657) Sport i turystyka",
      "Skating, slackline",
      "Części"
    ],
    "hierarchy": "(260657) Sport i turystyka / Skating, slackline / Części / Śruby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Deskorolki elektryczne",
    "categoryPath": [
      "(256913) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(256913) Sport i turystyka / Skating, slackline / Deskorolki elektryczne",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Deskorolki kompletne",
    "categoryPath": [
      "(148303) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148303) Sport i turystyka / Skating, slackline / Deskorolki kompletne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Fingerboard, fingerbike",
    "categoryPath": [
      "(148304) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148304) Sport i turystyka / Skating, slackline / Fingerboard, fingerbike",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Hulajnogi",
    "categoryPath": [
      "(260643) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(260643) Sport i turystyka / Skating, slackline / Hulajnogi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Hulajnogi elektryczne",
    "categoryPath": [
      "(260628) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(260628) Sport i turystyka / Skating, slackline / Hulajnogi elektryczne",
    "comissionGroupOld": "C36",
    "comissionGroupNew": "D30"
  },
  {
    "segment": "Longboard",
    "categoryPath": [
      "(148309) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148309) Sport i turystyka / Skating, slackline / Longboard",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Ochraniacze, kaski",
    "categoryPath": [
      "(148335) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148335) Sport i turystyka / Skating, slackline / Ochraniacze, kaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(148338) Sport i turystyka",
      "Skating, slackline",
      "Odzież, obuwie, akcesoria"
    ],
    "hierarchy": "(148338) Sport i turystyka / Skating, slackline / Odzież, obuwie, akcesoria / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(260708) Sport i turystyka",
      "Skating, slackline",
      "Odzież, obuwie, akcesoria"
    ],
    "hierarchy": "(260708) Sport i turystyka / Skating, slackline / Odzież, obuwie, akcesoria / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(260707) Sport i turystyka",
      "Skating, slackline",
      "Odzież, obuwie, akcesoria"
    ],
    "hierarchy": "(260707) Sport i turystyka / Skating, slackline / Odzież, obuwie, akcesoria / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148343) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148343) Sport i turystyka / Skating, slackline / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rolki",
    "categoryPath": [
      "(260629) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(260629) Sport i turystyka / Skating, slackline / Rolki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Slackline",
    "categoryPath": [
      "(148317) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148317) Sport i turystyka / Skating, slackline / Slackline",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Trickboard",
    "categoryPath": [
      "(148318) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148318) Sport i turystyka / Skating, slackline / Trickboard",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Waveboard",
    "categoryPath": [
      "(148319) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148319) Sport i turystyka / Skating, slackline / Waveboard",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wrotki",
    "categoryPath": [
      "(148320) Sport i turystyka",
      "Skating, slackline"
    ],
    "hierarchy": "(148320) Sport i turystyka / Skating, slackline / Wrotki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kije",
    "categoryPath": [
      "(13377) Sport i turystyka",
      "Sporty drużynowe",
      "Baseball"
    ],
    "hierarchy": "(13377) Sport i turystyka / Sporty drużynowe / Baseball / Kije",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koszulki, bluzy, kurtki",
    "categoryPath": [
      "(259102) Sport i turystyka",
      "Sporty drużynowe",
      "Baseball",
      "Odzież"
    ],
    "hierarchy": "(259102) Sport i turystyka / Sporty drużynowe / Baseball / Odzież / Koszulki, bluzy, kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(259103) Sport i turystyka",
      "Sporty drużynowe",
      "Baseball",
      "Odzież"
    ],
    "hierarchy": "(259103) Sport i turystyka / Sporty drużynowe / Baseball / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(259104) Sport i turystyka",
      "Sporty drużynowe",
      "Baseball"
    ],
    "hierarchy": "(259104) Sport i turystyka / Sporty drużynowe / Baseball / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(13378) Sport i turystyka",
      "Sporty drużynowe",
      "Baseball"
    ],
    "hierarchy": "(13378) Sport i turystyka / Sporty drużynowe / Baseball / Rękawice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Flagi, chorągiewki, proporczyki",
    "categoryPath": [
      "(124060) Sport i turystyka",
      "Sporty drużynowe",
      "Dla kibiców"
    ],
    "hierarchy": "(124060) Sport i turystyka / Sporty drużynowe / Dla kibiców / Flagi, chorągiewki, proporczyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gadżety",
    "categoryPath": [
      "(124059) Sport i turystyka",
      "Sporty drużynowe",
      "Dla kibiców"
    ],
    "hierarchy": "(124059) Sport i turystyka / Sporty drużynowe / Dla kibiców / Gadżety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(124061) Sport i turystyka",
      "Sporty drużynowe",
      "Dla kibiców"
    ],
    "hierarchy": "(124061) Sport i turystyka / Sporty drużynowe / Dla kibiców / Koszulki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Nakrycia głowy",
    "categoryPath": [
      "(124062) Sport i turystyka",
      "Sporty drużynowe",
      "Dla kibiców"
    ],
    "hierarchy": "(124062) Sport i turystyka / Sporty drużynowe / Dla kibiców / Nakrycia głowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szaliki",
    "categoryPath": [
      "(124063) Sport i turystyka",
      "Sporty drużynowe",
      "Dla kibiców"
    ],
    "hierarchy": "(124063) Sport i turystyka / Sporty drużynowe / Dla kibiców / Szaliki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kaski i ochraniacze",
    "categoryPath": [
      "(18011) Sport i turystyka",
      "Sporty drużynowe",
      "Futbol amerykański"
    ],
    "hierarchy": "(18011) Sport i turystyka / Sporty drużynowe / Futbol amerykański / Kaski i ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koszulki, bluzy, kurtki",
    "categoryPath": [
      "(259105) Sport i turystyka",
      "Sporty drużynowe",
      "Futbol amerykański",
      "Odzież"
    ],
    "hierarchy": "(259105) Sport i turystyka / Sporty drużynowe / Futbol amerykański / Odzież / Koszulki, bluzy, kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(259106) Sport i turystyka",
      "Sporty drużynowe",
      "Futbol amerykański",
      "Odzież"
    ],
    "hierarchy": "(259106) Sport i turystyka / Sporty drużynowe / Futbol amerykański / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(18012) Sport i turystyka",
      "Sporty drużynowe",
      "Futbol amerykański"
    ],
    "hierarchy": "(18012) Sport i turystyka / Sporty drużynowe / Futbol amerykański / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18010) Sport i turystyka",
      "Sporty drużynowe",
      "Futbol amerykański"
    ],
    "hierarchy": "(18010) Sport i turystyka / Sporty drużynowe / Futbol amerykański / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kaski i ochraniacze",
    "categoryPath": [
      "(259278) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej"
    ],
    "hierarchy": "(259278) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Kaski i ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kije",
    "categoryPath": [
      "(16653) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej"
    ],
    "hierarchy": "(16653) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Kije",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Krążki i piłeczki",
    "categoryPath": [
      "(259166) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej"
    ],
    "hierarchy": "(259166) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Krążki i piłeczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koszulki, bluzy",
    "categoryPath": [
      "(121803) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej",
      "Odzież"
    ],
    "hierarchy": "(121803) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Odzież / Koszulki, bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(259157) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej",
      "Odzież"
    ],
    "hierarchy": "(259157) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(16657) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej"
    ],
    "hierarchy": "(16657) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(259158) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej"
    ],
    "hierarchy": "(259158) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Rękawice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Łyżwy",
    "categoryPath": [
      "(16654) Sport i turystyka",
      "Sporty drużynowe",
      "Hokej i unihokej"
    ],
    "hierarchy": "(16654) Sport i turystyka / Sporty drużynowe / Hokej i unihokej / Łyżwy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kosze, tablice i obręcze",
    "categoryPath": [
      "(121804) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka"
    ],
    "hierarchy": "(121804) Sport i turystyka / Sporty drużynowe / Koszykówka / Kosze, tablice i obręcze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(13380) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka"
    ],
    "hierarchy": "(13380) Sport i turystyka / Sporty drużynowe / Koszykówka / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(258754) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka"
    ],
    "hierarchy": "(258754) Sport i turystyka / Sporty drużynowe / Koszykówka / Ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(258752) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka",
      "Odzież"
    ],
    "hierarchy": "(258752) Sport i turystyka / Sporty drużynowe / Koszykówka / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(13384) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka",
      "Odzież"
    ],
    "hierarchy": "(13384) Sport i turystyka / Sporty drużynowe / Koszykówka / Odzież / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(13385) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka",
      "Odzież"
    ],
    "hierarchy": "(13385) Sport i turystyka / Sporty drużynowe / Koszykówka / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(258753) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka",
      "Odzież"
    ],
    "hierarchy": "(258753) Sport i turystyka / Sporty drużynowe / Koszykówka / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki i spodnie",
    "categoryPath": [
      "(13386) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka",
      "Odzież"
    ],
    "hierarchy": "(13386) Sport i turystyka / Sporty drużynowe / Koszykówka / Odzież / Spodenki i spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(13382) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka"
    ],
    "hierarchy": "(13382) Sport i turystyka / Sporty drużynowe / Koszykówka / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13379) Sport i turystyka",
      "Sporty drużynowe",
      "Koszykówka"
    ],
    "hierarchy": "(13379) Sport i turystyka / Sporty drużynowe / Koszykówka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Gwizdki sędziowskie",
    "categoryPath": [
      "(148823) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria sędziowskie"
    ],
    "hierarchy": "(148823) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria sędziowskie / Gwizdki sędziowskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kartki sędziowskie",
    "categoryPath": [
      "(148825) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria sędziowskie"
    ],
    "hierarchy": "(148825) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria sędziowskie / Kartki sędziowskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koszulki sędziowskie",
    "categoryPath": [
      "(148824) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria sędziowskie"
    ],
    "hierarchy": "(148824) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria sędziowskie / Koszulki sędziowskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bidony",
    "categoryPath": [
      "(148828) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(148828) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria treningowe / Bidony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Drabinki koordynacyjne",
    "categoryPath": [
      "(148829) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(148829) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria treningowe / Drabinki koordynacyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pachołki i talerzyki treningowe",
    "categoryPath": [
      "(148830) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(148830) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria treningowe / Pachołki i talerzyki treningowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Płotki i przeszkody treningowe",
    "categoryPath": [
      "(148831) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(148831) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria treningowe / Płotki i przeszkody treningowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tablice taktyczne i bloki trenerskie",
    "categoryPath": [
      "(148832) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(148832) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria treningowe / Tablice taktyczne i bloki trenerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Znaczniki treningowe (koszulki)",
    "categoryPath": [
      "(258073) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Akcesoria treningowe"
    ],
    "hierarchy": "(258073) Sport i turystyka / Sporty drużynowe / Piłka nożna / Akcesoria treningowe / Znaczniki treningowe (koszulki)",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bramki",
    "categoryPath": [
      "(112365) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna"
    ],
    "hierarchy": "(112365) Sport i turystyka / Sporty drużynowe / Piłka nożna / Bramki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Halowe",
    "categoryPath": [
      "(18015) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Obuwie"
    ],
    "hierarchy": "(18015) Sport i turystyka / Sporty drużynowe / Piłka nożna / Obuwie / Halowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(18014) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Obuwie"
    ],
    "hierarchy": "(18014) Sport i turystyka / Sporty drużynowe / Piłka nożna / Obuwie / Korki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Turfy",
    "categoryPath": [
      "(148836) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Obuwie"
    ],
    "hierarchy": "(148836) Sport i turystyka / Sporty drużynowe / Piłka nożna / Obuwie / Turfy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wkładki do butów",
    "categoryPath": [
      "(148837) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Obuwie"
    ],
    "hierarchy": "(148837) Sport i turystyka / Sporty drużynowe / Piłka nożna / Obuwie / Wkładki do butów",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(14737) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(14737) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(26911) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(26911) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Getry, skarpety piłkarskie",
    "categoryPath": [
      "(13395) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(13395) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Getry, skarpety piłkarskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(13396) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(13396) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(13397) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(13397) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(148839) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(148839) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki, podspodenki",
    "categoryPath": [
      "(13399) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(13399) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Spodenki, podspodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(258426) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna",
      "Odzież"
    ],
    "hierarchy": "(258426) Sport i turystyka / Sporty drużynowe / Piłka nożna / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski, ochraniacze i taśmy",
    "categoryPath": [
      "(13392) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna"
    ],
    "hierarchy": "(13392) Sport i turystyka / Sporty drużynowe / Piłka nożna / Opaski, ochraniacze i taśmy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(13393) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna"
    ],
    "hierarchy": "(13393) Sport i turystyka / Sporty drużynowe / Piłka nożna / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13387) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna"
    ],
    "hierarchy": "(13387) Sport i turystyka / Sporty drużynowe / Piłka nożna / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawice bramkarskie",
    "categoryPath": [
      "(258427) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna"
    ],
    "hierarchy": "(258427) Sport i turystyka / Sporty drużynowe / Piłka nożna / Rękawice bramkarskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Siatki do bramki",
    "categoryPath": [
      "(258078) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna"
    ],
    "hierarchy": "(258078) Sport i turystyka / Sporty drużynowe / Piłka nożna / Siatki do bramki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby, plecaki i worki sportowe",
    "categoryPath": [
      "(258077) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka nożna"
    ],
    "hierarchy": "(258077) Sport i turystyka / Sporty drużynowe / Piłka nożna / Torby, plecaki i worki sportowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kleje i środki do usuwania kleju",
    "categoryPath": [
      "(258912) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna"
    ],
    "hierarchy": "(258912) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Kleje i środki do usuwania kleju",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(121806) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna"
    ],
    "hierarchy": "(121806) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(258909) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna",
      "Odzież"
    ],
    "hierarchy": "(258909) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(258908) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna",
      "Odzież"
    ],
    "hierarchy": "(258908) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Odzież / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(258906) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna",
      "Odzież"
    ],
    "hierarchy": "(258906) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(258910) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna",
      "Odzież"
    ],
    "hierarchy": "(258910) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki, podspodenki",
    "categoryPath": [
      "(258907) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna",
      "Odzież"
    ],
    "hierarchy": "(258907) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Odzież / Spodenki, podspodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Opaski i ochraniacze",
    "categoryPath": [
      "(121807) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna"
    ],
    "hierarchy": "(121807) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Opaski i ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(13401) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna"
    ],
    "hierarchy": "(13401) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(258911) Sport i turystyka",
      "Sporty drużynowe",
      "Piłka ręczna"
    ],
    "hierarchy": "(258911) Sport i turystyka / Sporty drużynowe / Piłka ręczna / Siatki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13369) Sport i turystyka",
      "Sporty drużynowe"
    ],
    "hierarchy": "(13369) Sport i turystyka / Sporty drużynowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(121809) Sport i turystyka",
      "Sporty drużynowe",
      "Rugby"
    ],
    "hierarchy": "(121809) Sport i turystyka / Sporty drużynowe / Rugby / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(259108) Sport i turystyka",
      "Sporty drużynowe",
      "Rugby"
    ],
    "hierarchy": "(259108) Sport i turystyka / Sporty drużynowe / Rugby / Ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koszulki, bluzy",
    "categoryPath": [
      "(14055) Sport i turystyka",
      "Sporty drużynowe",
      "Rugby",
      "Odzież"
    ],
    "hierarchy": "(14055) Sport i turystyka / Sporty drużynowe / Rugby / Odzież / Koszulki, bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki i spodnie",
    "categoryPath": [
      "(259107) Sport i turystyka",
      "Sporty drużynowe",
      "Rugby",
      "Odzież"
    ],
    "hierarchy": "(259107) Sport i turystyka / Sporty drużynowe / Rugby / Odzież / Spodenki i spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(13403) Sport i turystyka",
      "Sporty drużynowe",
      "Rugby"
    ],
    "hierarchy": "(13403) Sport i turystyka / Sporty drużynowe / Rugby / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Nakolanniki i rękawki",
    "categoryPath": [
      "(13406) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka"
    ],
    "hierarchy": "(13406) Sport i turystyka / Sporty drużynowe / Siatkówka / Nakolanniki i rękawki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(121808) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka"
    ],
    "hierarchy": "(121808) Sport i turystyka / Sporty drużynowe / Siatkówka / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(258843) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka",
      "Odzież"
    ],
    "hierarchy": "(258843) Sport i turystyka / Sporty drużynowe / Siatkówka / Odzież / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(14058) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka",
      "Odzież"
    ],
    "hierarchy": "(14058) Sport i turystyka / Sporty drużynowe / Siatkówka / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(258844) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka",
      "Odzież"
    ],
    "hierarchy": "(258844) Sport i turystyka / Sporty drużynowe / Siatkówka / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki, podspodenki",
    "categoryPath": [
      "(258842) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka",
      "Odzież"
    ],
    "hierarchy": "(258842) Sport i turystyka / Sporty drużynowe / Siatkówka / Odzież / Spodenki, podspodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(13407) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka"
    ],
    "hierarchy": "(13407) Sport i turystyka / Sporty drużynowe / Siatkówka / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13404) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka"
    ],
    "hierarchy": "(13404) Sport i turystyka / Sporty drużynowe / Siatkówka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(258845) Sport i turystyka",
      "Sporty drużynowe",
      "Siatkówka"
    ],
    "hierarchy": "(258845) Sport i turystyka / Sporty drużynowe / Siatkówka / Siatki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256121) Sport i turystyka",
      "Sporty ekstremalne",
      "Lotnictwo"
    ],
    "hierarchy": "(256121) Sport i turystyka / Sporty ekstremalne / Lotnictwo / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(112255) Sport i turystyka",
      "Sporty ekstremalne",
      "Lotnictwo"
    ],
    "hierarchy": "(112255) Sport i turystyka / Sporty ekstremalne / Lotnictwo / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Paralotnie",
    "categoryPath": [
      "(112259) Sport i turystyka",
      "Sporty ekstremalne",
      "Paralotniarstwo"
    ],
    "hierarchy": "(112259) Sport i turystyka / Sporty ekstremalne / Paralotniarstwo / Paralotnie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Sprzęt pomiarowy",
    "categoryPath": [
      "(112260) Sport i turystyka",
      "Sporty ekstremalne",
      "Paralotniarstwo"
    ],
    "hierarchy": "(112260) Sport i turystyka / Sporty ekstremalne / Paralotniarstwo / Sprzęt pomiarowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Uprzęże",
    "categoryPath": [
      "(112261) Sport i turystyka",
      "Sporty ekstremalne",
      "Paralotniarstwo"
    ],
    "hierarchy": "(112261) Sport i turystyka / Sporty ekstremalne / Paralotniarstwo / Uprzęże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112301) Sport i turystyka",
      "Sporty ekstremalne"
    ],
    "hierarchy": "(112301) Sport i turystyka / Sporty ekstremalne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(112265) Sport i turystyka",
      "Sporty ekstremalne",
      "Spadochroniarstwo"
    ],
    "hierarchy": "(112265) Sport i turystyka / Sporty ekstremalne / Spadochroniarstwo / Kaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Spadochrony",
    "categoryPath": [
      "(112264) Sport i turystyka",
      "Sporty ekstremalne",
      "Spadochroniarstwo"
    ],
    "hierarchy": "(112264) Sport i turystyka / Sporty ekstremalne / Spadochroniarstwo / Spadochrony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(112268) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka"
    ],
    "hierarchy": "(112268) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Kaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(112269) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka"
    ],
    "hierarchy": "(112269) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bielizna termoaktywna",
    "categoryPath": [
      "(148063) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Odzież"
    ],
    "hierarchy": "(148063) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Odzież / Bielizna termoaktywna",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(148064) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Odzież"
    ],
    "hierarchy": "(148064) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(148065) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Odzież"
    ],
    "hierarchy": "(148065) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Odzież / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki, koszule",
    "categoryPath": [
      "(148066) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Odzież"
    ],
    "hierarchy": "(148066) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Odzież / Koszulki, koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(148067) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Odzież"
    ],
    "hierarchy": "(148067) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(148068) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Odzież"
    ],
    "hierarchy": "(148068) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Odzież / Rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(148069) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Odzież"
    ],
    "hierarchy": "(148069) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sprzęt jaskiniowy",
    "categoryPath": [
      "(148084) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka"
    ],
    "hierarchy": "(148084) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt jaskiniowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bloczki, rolki",
    "categoryPath": [
      "(148070) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148070) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Bloczki, rolki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Chwyty, chwytotablice",
    "categoryPath": [
      "(148071) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148071) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Chwyty, chwytotablice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Crashpady",
    "categoryPath": [
      "(148072) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148072) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Crashpady",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Czekany",
    "categoryPath": [
      "(148073) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148073) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Czekany",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Ekspresy",
    "categoryPath": [
      "(148074) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148074) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Ekspresy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karabinki",
    "categoryPath": [
      "(112275) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(112275) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Karabinki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kości, haki, śruby",
    "categoryPath": [
      "(112276) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(112276) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Kości, haki, śruby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Dynamiczne",
    "categoryPath": [
      "(148077) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy",
      "Liny i linki"
    ],
    "hierarchy": "(148077) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Liny i linki / Dynamiczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148075) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy",
      "Liny i linki"
    ],
    "hierarchy": "(148075) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Liny i linki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Repsznury, pomocnicze",
    "categoryPath": [
      "(148078) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy",
      "Liny i linki"
    ],
    "hierarchy": "(148078) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Liny i linki / Repsznury, pomocnicze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Statyczne",
    "categoryPath": [
      "(148076) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy",
      "Liny i linki"
    ],
    "hierarchy": "(148076) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Liny i linki / Statyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby na linę",
    "categoryPath": [
      "(148085) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy",
      "Liny i linki"
    ],
    "hierarchy": "(148085) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Liny i linki / Torby na linę",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Lonże, absorbery energii",
    "categoryPath": [
      "(148079) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148079) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Lonże, absorbery energii",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Magnezja i woreczki",
    "categoryPath": [
      "(112278) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(112278) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Magnezja i woreczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112281) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(112281) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyrządy asekuracyjne, zjazdowe",
    "categoryPath": [
      "(148080) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148080) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Przyrządy asekuracyjne, zjazdowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Przyrządy zaciskowe",
    "categoryPath": [
      "(148081) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148081) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Przyrządy zaciskowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Raki",
    "categoryPath": [
      "(148082) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148082) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Raki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Taśmy, pętle",
    "categoryPath": [
      "(148083) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(148083) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Taśmy, pętle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Uprzęże",
    "categoryPath": [
      "(112280) Sport i turystyka",
      "Sporty ekstremalne",
      "Wspinaczka",
      "Sprzęt wspinaczkowy"
    ],
    "hierarchy": "(112280) Sport i turystyka / Sporty ekstremalne / Wspinaczka / Sprzęt wspinaczkowy / Uprzęże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(17230) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(17230) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bile",
    "categoryPath": [
      "(13412) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(13412) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Bile",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gadżety",
    "categoryPath": [
      "(17236) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(17236) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Gadżety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kije",
    "categoryPath": [
      "(13413) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(13413) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Kije",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Lampy bilardowe",
    "categoryPath": [
      "(17231) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(17231) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Lampy bilardowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(13414) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(13414) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Stoły",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Sukno",
    "categoryPath": [
      "(17234) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(17234) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Sukno",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wieszaki i stojaki",
    "categoryPath": [
      "(17235) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bilard"
    ],
    "hierarchy": "(17235) Sport i turystyka / Sporty towarzyskie i rekreacja / Bilard / Wieszaki i stojaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kule",
    "categoryPath": [
      "(13417) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Bowling i kręgle"
    ],
    "hierarchy": "(13417) Sport i turystyka / Sporty towarzyskie i rekreacja / Bowling i kręgle / Kule",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bule",
    "categoryPath": [
      "(248942) Sport i turystyka",
      "Sporty towarzyskie i rekreacja"
    ],
    "hierarchy": "(248942) Sport i turystyka / Sporty towarzyskie i rekreacja / Bule",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13419) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Dart"
    ],
    "hierarchy": "(13419) Sport i turystyka / Sporty towarzyskie i rekreacja / Dart / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rzutki, groty, piórka",
    "categoryPath": [
      "(13420) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Dart"
    ],
    "hierarchy": "(13420) Sport i turystyka / Sporty towarzyskie i rekreacja / Dart / Rzutki, groty, piórka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Tablice",
    "categoryPath": [
      "(13421) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Dart"
    ],
    "hierarchy": "(13421) Sport i turystyka / Sporty towarzyskie i rekreacja / Dart / Tablice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria treningowe",
    "categoryPath": [
      "(318295) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(318295) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Akcesoria treningowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Elektronika golfowa",
    "categoryPath": [
      "(318298) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(318298) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Elektronika golfowa",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Komponenty kijów golfowych",
    "categoryPath": [
      "(318292) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf",
      "Kije"
    ],
    "hierarchy": "(318292) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Kije / Komponenty kijów golfowych",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(27698) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf",
      "Kije"
    ],
    "hierarchy": "(27698) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Kije / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Puttery",
    "categoryPath": [
      "(27694) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf",
      "Kije"
    ],
    "hierarchy": "(27694) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Kije / Puttery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Woody",
    "categoryPath": [
      "(27695) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf",
      "Kije"
    ],
    "hierarchy": "(27695) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Kije / Woody",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(27697) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf",
      "Kije"
    ],
    "hierarchy": "(27697) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Kije / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Żelaza",
    "categoryPath": [
      "(27696) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf",
      "Kije"
    ],
    "hierarchy": "(27696) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Kije / Żelaza",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kołeczki (tee)",
    "categoryPath": [
      "(320831) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(320831) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Kołeczki (tee)",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256122) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(256122) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(27693) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(27693) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(13425) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(13425) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(27699) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(27699) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Pokrowce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13423) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(13423) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Torby i wózki",
    "categoryPath": [
      "(14742) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(14742) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Torby i wózki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Znaczniki",
    "categoryPath": [
      "(320837) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Golf"
    ],
    "hierarchy": "(320837) Sport i turystyka / Sporty towarzyskie i rekreacja / Golf / Znaczniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Czapraki",
    "categoryPath": [
      "(112312) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112312) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Czapraki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Derki",
    "categoryPath": [
      "(112304) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112304) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Derki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kantary i uwiązy",
    "categoryPath": [
      "(311021) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(311021) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Kantary i uwiązy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kiełzna i wędzidła",
    "categoryPath": [
      "(112305) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112305) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Kiełzna i wędzidła",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nauszniki",
    "categoryPath": [
      "(322385) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(322385) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Nauszniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze i owijki",
    "categoryPath": [
      "(112306) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112306) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Ochraniacze i owijki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ogłowia",
    "categoryPath": [
      "(112307) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112307) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Ogłowia",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pielęgnacja i kosmetyka",
    "categoryPath": [
      "(112308) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112308) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Pielęgnacja i kosmetyka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Praca z koniem",
    "categoryPath": [
      "(112309) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112309) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Praca z koniem",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Siodła",
    "categoryPath": [
      "(112311) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(112311) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Siodła",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Strzemiona",
    "categoryPath": [
      "(322280) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Akcesoria"
    ],
    "hierarchy": "(322280) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Akcesoria / Strzemiona",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gadżety",
    "categoryPath": [
      "(112313) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo"
    ],
    "hierarchy": "(112313) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Gadżety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Literatura",
    "categoryPath": [
      "(112314) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo"
    ],
    "hierarchy": "(112314) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Literatura",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256133) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo"
    ],
    "hierarchy": "(256133) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bryczesy",
    "categoryPath": [
      "(112316) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(112316) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Bryczesy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapsy",
    "categoryPath": [
      "(112318) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(112318) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Czapsy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(112319) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(112319) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki i koszule",
    "categoryPath": [
      "(112320) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(112320) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Koszulki i koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(112321) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(112321) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(112322) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(112322) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Rękawiczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety i podkolanówki",
    "categoryPath": [
      "(319664) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(319664) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Skarpety i podkolanówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Toczki i kaski",
    "categoryPath": [
      "(112323) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo",
      "Odzież"
    ],
    "hierarchy": "(112323) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Odzież / Toczki i kaski",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pasze i suplementy",
    "categoryPath": [
      "(251622) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo"
    ],
    "hierarchy": "(251622) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Pasze i suplementy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Powozy i sanie",
    "categoryPath": [
      "(112325) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Jeździectwo"
    ],
    "hierarchy": "(112325) Sport i turystyka / Sporty towarzyskie i rekreacja / Jeździectwo / Powozy i sanie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(125743) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Nordic Walking"
    ],
    "hierarchy": "(125743) Sport i turystyka / Sporty towarzyskie i rekreacja / Nordic Walking / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kije",
    "categoryPath": [
      "(16528) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Nordic Walking"
    ],
    "hierarchy": "(16528) Sport i turystyka / Sporty towarzyskie i rekreacja / Nordic Walking / Kije",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256123) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Nordic Walking"
    ],
    "hierarchy": "(256123) Sport i turystyka / Sporty towarzyskie i rekreacja / Nordic Walking / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(125742) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Nordic Walking"
    ],
    "hierarchy": "(125742) Sport i turystyka / Sporty towarzyskie i rekreacja / Nordic Walking / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(125745) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Piłkarzyki"
    ],
    "hierarchy": "(125745) Sport i turystyka / Sporty towarzyskie i rekreacja / Piłkarzyki / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(125744) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Piłkarzyki"
    ],
    "hierarchy": "(125744) Sport i turystyka / Sporty towarzyskie i rekreacja / Piłkarzyki / Stoły",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13409) Sport i turystyka",
      "Sporty towarzyskie i rekreacja"
    ],
    "hierarchy": "(13409) Sport i turystyka / Sporty towarzyskie i rekreacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sporty z psami",
    "categoryPath": [
      "(319860) Sport i turystyka",
      "Sporty towarzyskie i rekreacja"
    ],
    "hierarchy": "(319860) Sport i turystyka / Sporty towarzyskie i rekreacja / Sporty z psami",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Filmy i książki",
    "categoryPath": [
      "(18006) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Taniec"
    ],
    "hierarchy": "(18006) Sport i turystyka / Sporty towarzyskie i rekreacja / Taniec / Filmy i książki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(18007) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Taniec"
    ],
    "hierarchy": "(18007) Sport i turystyka / Sporty towarzyskie i rekreacja / Taniec / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(18005) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Taniec"
    ],
    "hierarchy": "(18005) Sport i turystyka / Sporty towarzyskie i rekreacja / Taniec / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stroje",
    "categoryPath": [
      "(18008) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Taniec"
    ],
    "hierarchy": "(18008) Sport i turystyka / Sporty towarzyskie i rekreacja / Taniec / Stroje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Diabola",
    "categoryPath": [
      "(16026) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Żonglerka"
    ],
    "hierarchy": "(16026) Sport i turystyka / Sporty towarzyskie i rekreacja / Żonglerka / Diabola",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Dyski, frisbee, bumerangi",
    "categoryPath": [
      "(16032) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Żonglerka"
    ],
    "hierarchy": "(16032) Sport i turystyka / Sporty towarzyskie i rekreacja / Żonglerka / Dyski, frisbee, bumerangi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kije, Sticki",
    "categoryPath": [
      "(16027) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Żonglerka"
    ],
    "hierarchy": "(16027) Sport i turystyka / Sporty towarzyskie i rekreacja / Żonglerka / Kije, Sticki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Maczugi",
    "categoryPath": [
      "(16029) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Żonglerka"
    ],
    "hierarchy": "(16029) Sport i turystyka / Sporty towarzyskie i rekreacja / Żonglerka / Maczugi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Piłeczki, footbagi, zośki",
    "categoryPath": [
      "(16031) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Żonglerka"
    ],
    "hierarchy": "(16031) Sport i turystyka / Sporty towarzyskie i rekreacja / Żonglerka / Piłeczki, footbagi, zośki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Poi",
    "categoryPath": [
      "(16028) Sport i turystyka",
      "Sporty towarzyskie i rekreacja",
      "Żonglerka"
    ],
    "hierarchy": "(16028) Sport i turystyka / Sporty towarzyskie i rekreacja / Żonglerka / Poi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(13528) Sport i turystyka",
      "Sporty walki",
      "Boks"
    ],
    "hierarchy": "(13528) Sport i turystyka / Sporty walki / Boks / Kaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(121815) Sport i turystyka",
      "Sporty walki",
      "Boks"
    ],
    "hierarchy": "(121815) Sport i turystyka / Sporty walki / Boks / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(121816) Sport i turystyka",
      "Sporty walki",
      "Boks"
    ],
    "hierarchy": "(121816) Sport i turystyka / Sporty walki / Boks / Ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(121817) Sport i turystyka",
      "Sporty walki",
      "Boks"
    ],
    "hierarchy": "(121817) Sport i turystyka / Sporty walki / Boks / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(13529) Sport i turystyka",
      "Sporty walki",
      "Boks"
    ],
    "hierarchy": "(13529) Sport i turystyka / Sporty walki / Boks / Rękawice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Worki i gruszki treningowe",
    "categoryPath": [
      "(13530) Sport i turystyka",
      "Sporty walki",
      "Boks"
    ],
    "hierarchy": "(13530) Sport i turystyka / Sporty walki / Boks / Worki i gruszki treningowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(124056) Sport i turystyka",
      "Sporty walki",
      "MMA"
    ],
    "hierarchy": "(124056) Sport i turystyka / Sporty walki / MMA / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(124057) Sport i turystyka",
      "Sporty walki",
      "MMA"
    ],
    "hierarchy": "(124057) Sport i turystyka / Sporty walki / MMA / Rękawice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13523) Sport i turystyka",
      "Sporty walki"
    ],
    "hierarchy": "(13523) Sport i turystyka / Sporty walki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szermierka",
    "categoryPath": [
      "(13525) Sport i turystyka",
      "Sporty walki"
    ],
    "hierarchy": "(13525) Sport i turystyka / Sporty walki / Szermierka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Broń",
    "categoryPath": [
      "(17216) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu"
    ],
    "hierarchy": "(17216) Sport i turystyka / Sporty walki / Walki wschodu / Broń",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Czasopisma",
    "categoryPath": [
      "(17223) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu",
      "Literatura i multimedia"
    ],
    "hierarchy": "(17223) Sport i turystyka / Sporty walki / Walki wschodu / Literatura i multimedia / Czasopisma",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Książki",
    "categoryPath": [
      "(17224) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu",
      "Literatura i multimedia"
    ],
    "hierarchy": "(17224) Sport i turystyka / Sporty walki / Walki wschodu / Literatura i multimedia / Książki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Multimedia",
    "categoryPath": [
      "(17222) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu",
      "Literatura i multimedia"
    ],
    "hierarchy": "(17222) Sport i turystyka / Sporty walki / Walki wschodu / Literatura i multimedia / Multimedia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256134) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu"
    ],
    "hierarchy": "(256134) Sport i turystyka / Sporty walki / Walki wschodu / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(17217) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu"
    ],
    "hierarchy": "(17217) Sport i turystyka / Sporty walki / Walki wschodu / Ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kimona",
    "categoryPath": [
      "(17220) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu",
      "Odzież"
    ],
    "hierarchy": "(17220) Sport i turystyka / Sporty walki / Walki wschodu / Odzież / Kimona",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(319165) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu",
      "Odzież"
    ],
    "hierarchy": "(319165) Sport i turystyka / Sporty walki / Walki wschodu / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pasy",
    "categoryPath": [
      "(17221) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu",
      "Odzież"
    ],
    "hierarchy": "(17221) Sport i turystyka / Sporty walki / Walki wschodu / Odzież / Pasy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(319162) Sport i turystyka",
      "Sporty walki",
      "Walki wschodu",
      "Odzież"
    ],
    "hierarchy": "(319162) Sport i turystyka / Sporty walki / Walki wschodu / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Manekiny zapaśnicze",
    "categoryPath": [
      "(320855) Sport i turystyka",
      "Sporty walki",
      "Zapasy"
    ],
    "hierarchy": "(320855) Sport i turystyka / Sporty walki / Zapasy / Manekiny zapaśnicze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(121814) Sport i turystyka",
      "Sporty walki",
      "Zapasy"
    ],
    "hierarchy": "(121814) Sport i turystyka / Sporty walki / Zapasy / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(121812) Sport i turystyka",
      "Sporty walki",
      "Zapasy"
    ],
    "hierarchy": "(121812) Sport i turystyka / Sporty walki / Zapasy / Ochraniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(121813) Sport i turystyka",
      "Sporty walki",
      "Zapasy"
    ],
    "hierarchy": "(121813) Sport i turystyka / Sporty walki / Zapasy / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kajaki",
    "categoryPath": [
      "(13544) Sport i turystyka",
      "Sporty wodne",
      "Kajakarstwo"
    ],
    "hierarchy": "(13544) Sport i turystyka / Sporty wodne / Kajakarstwo / Kajaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Opakowania wodoszczelne",
    "categoryPath": [
      "(83702) Sport i turystyka",
      "Sporty wodne",
      "Kajakarstwo"
    ],
    "hierarchy": "(83702) Sport i turystyka / Sporty wodne / Kajakarstwo / Opakowania wodoszczelne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wiosła",
    "categoryPath": [
      "(83701) Sport i turystyka",
      "Sporty wodne",
      "Kajakarstwo"
    ],
    "hierarchy": "(83701) Sport i turystyka / Sporty wodne / Kajakarstwo / Wiosła",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bary, leashe",
    "categoryPath": [
      "(148502) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(148502) Sport i turystyka / Sporty wodne / Kitesurfing / Bary, leashe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Buty",
    "categoryPath": [
      "(148507) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(148507) Sport i turystyka / Sporty wodne / Kitesurfing / Buty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Deski",
    "categoryPath": [
      "(13546) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(13546) Sport i turystyka / Sporty wodne / Kitesurfing / Deski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(148504) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(148504) Sport i turystyka / Sporty wodne / Kitesurfing / Kamizelki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kaptury",
    "categoryPath": [
      "(148508) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(148508) Sport i turystyka / Sporty wodne / Kitesurfing / Kaptury",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Latawce",
    "categoryPath": [
      "(13547) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(13547) Sport i turystyka / Sporty wodne / Kitesurfing / Latawce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Linki, pompki",
    "categoryPath": [
      "(148503) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(148503) Sport i turystyka / Sporty wodne / Kitesurfing / Linki, pompki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pokrowce, torby",
    "categoryPath": [
      "(83703) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(83703) Sport i turystyka / Sporty wodne / Kitesurfing / Pokrowce, torby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Poncha",
    "categoryPath": [
      "(318991) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(318991) Sport i turystyka / Sporty wodne / Kitesurfing / Poncha",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13545) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(13545) Sport i turystyka / Sporty wodne / Kitesurfing / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(148511) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(148511) Sport i turystyka / Sporty wodne / Kitesurfing / Rękawice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Spodenki, boardshorty",
    "categoryPath": [
      "(148512) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(148512) Sport i turystyka / Sporty wodne / Kitesurfing / Spodenki, boardshorty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Trapezy",
    "categoryPath": [
      "(13548) Sport i turystyka",
      "Sporty wodne",
      "Kitesurfing"
    ],
    "hierarchy": "(13548) Sport i turystyka / Sporty wodne / Kitesurfing / Trapezy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(148122) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(148122) Sport i turystyka / Sporty wodne / Nurkowanie / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Automaty oddechowe",
    "categoryPath": [
      "(13550) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13550) Sport i turystyka / Sporty wodne / Nurkowanie / Automaty oddechowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Balast",
    "categoryPath": [
      "(83705) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(83705) Sport i turystyka / Sporty wodne / Nurkowanie / Balast",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Boje, kołowrotki, szpulki",
    "categoryPath": [
      "(148123) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(148123) Sport i turystyka / Sporty wodne / Nurkowanie / Boje, kołowrotki, szpulki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Butle i zawory",
    "categoryPath": [
      "(148124) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(148124) Sport i turystyka / Sporty wodne / Nurkowanie / Butle i zawory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Buty",
    "categoryPath": [
      "(13552) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13552) Sport i turystyka / Sporty wodne / Nurkowanie / Buty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Fajki",
    "categoryPath": [
      "(148133) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(148133) Sport i turystyka / Sporty wodne / Nurkowanie / Fajki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Jackety",
    "categoryPath": [
      "(13554) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13554) Sport i turystyka / Sporty wodne / Nurkowanie / Jackety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kusze i groty",
    "categoryPath": [
      "(83706) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(83706) Sport i turystyka / Sporty wodne / Nurkowanie / Kusze i groty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Maski",
    "categoryPath": [
      "(148134) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(148134) Sport i turystyka / Sporty wodne / Nurkowanie / Maski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Noże",
    "categoryPath": [
      "(13556) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13556) Sport i turystyka / Sporty wodne / Nurkowanie / Noże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(13557) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13557) Sport i turystyka / Sporty wodne / Nurkowanie / Oświetlenie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13549) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13549) Sport i turystyka / Sporty wodne / Nurkowanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płetwy",
    "categoryPath": [
      "(148135) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(148135) Sport i turystyka / Sporty wodne / Nurkowanie / Płetwy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Mokre",
    "categoryPath": [
      "(148125) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Rękawice"
    ],
    "hierarchy": "(148125) Sport i turystyka / Sporty wodne / Nurkowanie / Rękawice / Mokre",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Suche",
    "categoryPath": [
      "(148126) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Rękawice"
    ],
    "hierarchy": "(148126) Sport i turystyka / Sporty wodne / Nurkowanie / Rękawice / Suche",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Skafandry",
    "categoryPath": [
      "(13559) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13559) Sport i turystyka / Sporty wodne / Nurkowanie / Skafandry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Głębokościomierze",
    "categoryPath": [
      "(148127) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Sprzęt pomiarowy"
    ],
    "hierarchy": "(148127) Sport i turystyka / Sporty wodne / Nurkowanie / Sprzęt pomiarowy / Głębokościomierze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kompasy",
    "categoryPath": [
      "(148128) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Sprzęt pomiarowy"
    ],
    "hierarchy": "(148128) Sport i turystyka / Sporty wodne / Nurkowanie / Sprzęt pomiarowy / Kompasy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Komputery",
    "categoryPath": [
      "(13563) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Sprzęt pomiarowy"
    ],
    "hierarchy": "(13563) Sport i turystyka / Sporty wodne / Nurkowanie / Sprzęt pomiarowy / Komputery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Manometry",
    "categoryPath": [
      "(148129) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Sprzęt pomiarowy"
    ],
    "hierarchy": "(148129) Sport i turystyka / Sporty wodne / Nurkowanie / Sprzęt pomiarowy / Manometry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby",
    "categoryPath": [
      "(13561) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(13561) Sport i turystyka / Sporty wodne / Nurkowanie / Torby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "BC (niskie ciśnienie)",
    "categoryPath": [
      "(148132) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Węże"
    ],
    "hierarchy": "(148132) Sport i turystyka / Sporty wodne / Nurkowanie / Węże / BC (niskie ciśnienie)",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "HP (wysokie ciśnienie)",
    "categoryPath": [
      "(148130) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Węże"
    ],
    "hierarchy": "(148130) Sport i turystyka / Sporty wodne / Nurkowanie / Węże / HP (wysokie ciśnienie)",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "LP (niskie ciśnienie)",
    "categoryPath": [
      "(148131) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie",
      "Węże"
    ],
    "hierarchy": "(148131) Sport i turystyka / Sporty wodne / Nurkowanie / Węże / LP (niskie ciśnienie)",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(148136) Sport i turystyka",
      "Sporty wodne",
      "Nurkowanie"
    ],
    "hierarchy": "(148136) Sport i turystyka / Sporty wodne / Nurkowanie / Zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13536) Sport i turystyka",
      "Sporty wodne"
    ],
    "hierarchy": "(13536) Sport i turystyka / Sporty wodne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Buty i klapki",
    "categoryPath": [
      "(83708) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(83708) Sport i turystyka / Sporty wodne / Pływanie / Buty i klapki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Czepki",
    "categoryPath": [
      "(13565) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(13565) Sport i turystyka / Sporty wodne / Pływanie / Czepki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(148002) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(148002) Sport i turystyka / Sporty wodne / Pływanie / Koszulki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Okulary pływackie",
    "categoryPath": [
      "(13566) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(13566) Sport i turystyka / Sporty wodne / Pływanie / Okulary pływackie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13564) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(13564) Sport i turystyka / Sporty wodne / Pływanie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ręczniki",
    "categoryPath": [
      "(148008) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(148008) Sport i turystyka / Sporty wodne / Pływanie / Ręczniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rękawki, deski i koła dmuchane",
    "categoryPath": [
      "(13567) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(13567) Sport i turystyka / Sporty wodne / Pływanie / Rękawki, deski i koła dmuchane",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kombinezony",
    "categoryPath": [
      "(148044) Sport i turystyka",
      "Sporty wodne",
      "Pływanie",
      "Stroje pływackie"
    ],
    "hierarchy": "(148044) Sport i turystyka / Sporty wodne / Pływanie / Stroje pływackie / Kombinezony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Dwuczęściowe",
    "categoryPath": [
      "(148012) Sport i turystyka",
      "Sporty wodne",
      "Pływanie",
      "Stroje pływackie",
      "Kostiumy"
    ],
    "hierarchy": "(148012) Sport i turystyka / Sporty wodne / Pływanie / Stroje pływackie / Kostiumy / Dwuczęściowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Jednoczęściowe",
    "categoryPath": [
      "(148011) Sport i turystyka",
      "Sporty wodne",
      "Pływanie",
      "Stroje pływackie",
      "Kostiumy"
    ],
    "hierarchy": "(148011) Sport i turystyka / Sporty wodne / Pływanie / Stroje pływackie / Kostiumy / Jednoczęściowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Slipy",
    "categoryPath": [
      "(148042) Sport i turystyka",
      "Sporty wodne",
      "Pływanie",
      "Stroje pływackie",
      "Kąpielówki"
    ],
    "hierarchy": "(148042) Sport i turystyka / Sporty wodne / Pływanie / Stroje pływackie / Kąpielówki / Slipy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(148043) Sport i turystyka",
      "Sporty wodne",
      "Pływanie",
      "Stroje pływackie",
      "Kąpielówki"
    ],
    "hierarchy": "(148043) Sport i turystyka / Sporty wodne / Pływanie / Stroje pływackie / Kąpielówki / Spodenki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szorty plażowe",
    "categoryPath": [
      "(148045) Sport i turystyka",
      "Sporty wodne",
      "Pływanie",
      "Stroje pływackie"
    ],
    "hierarchy": "(148045) Sport i turystyka / Sporty wodne / Pływanie / Stroje pływackie / Szorty plażowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby, plecaki, worki",
    "categoryPath": [
      "(148015) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(148015) Sport i turystyka / Sporty wodne / Pływanie / Torby, plecaki, worki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wiosełka na dłonie",
    "categoryPath": [
      "(148014) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(148014) Sport i turystyka / Sporty wodne / Pływanie / Wiosełka na dłonie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zatyczki, zaciski",
    "categoryPath": [
      "(148016) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(148016) Sport i turystyka / Sporty wodne / Pływanie / Zatyczki, zaciski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zegarki",
    "categoryPath": [
      "(148017) Sport i turystyka",
      "Sporty wodne",
      "Pływanie"
    ],
    "hierarchy": "(148017) Sport i turystyka / Sporty wodne / Pływanie / Zegarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "SUP",
    "categoryPath": [
      "(256111) Sport i turystyka",
      "Sporty wodne"
    ],
    "hierarchy": "(256111) Sport i turystyka / Sporty wodne / SUP",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Skimboard",
    "categoryPath": [
      "(249082) Sport i turystyka",
      "Sporty wodne"
    ],
    "hierarchy": "(249082) Sport i turystyka / Sporty wodne / Skimboard",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bojki i rzutki",
    "categoryPath": [
      "(83715) Sport i turystyka",
      "Sporty wodne",
      "Sprzęt ratunkowy i asekuracyjny"
    ],
    "hierarchy": "(83715) Sport i turystyka / Sporty wodne / Sprzęt ratunkowy i asekuracyjny / Bojki i rzutki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(83716) Sport i turystyka",
      "Sporty wodne",
      "Sprzęt ratunkowy i asekuracyjny"
    ],
    "hierarchy": "(83716) Sport i turystyka / Sporty wodne / Sprzęt ratunkowy i asekuracyjny / Kamizelki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kapoki",
    "categoryPath": [
      "(83717) Sport i turystyka",
      "Sporty wodne",
      "Sprzęt ratunkowy i asekuracyjny"
    ],
    "hierarchy": "(83717) Sport i turystyka / Sporty wodne / Sprzęt ratunkowy i asekuracyjny / Kapoki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koła ratunkowe",
    "categoryPath": [
      "(83718) Sport i turystyka",
      "Sporty wodne",
      "Sprzęt ratunkowy i asekuracyjny"
    ],
    "hierarchy": "(83718) Sport i turystyka / Sporty wodne / Sprzęt ratunkowy i asekuracyjny / Koła ratunkowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Surfing",
    "categoryPath": [
      "(260502) Sport i turystyka",
      "Sporty wodne"
    ],
    "hierarchy": "(260502) Sport i turystyka / Sporty wodne / Surfing",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(148149) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148149) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Kamizelki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(148143) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148143) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Kaski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koła, banany",
    "categoryPath": [
      "(148147) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148147) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Koła, banany",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Liny do holowania, akcesoria",
    "categoryPath": [
      "(148145) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148145) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Liny do holowania, akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Narty",
    "categoryPath": [
      "(148150) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148150) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Narty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pianki, rękawice",
    "categoryPath": [
      "(148148) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148148) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Pianki, rękawice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wakeboardy",
    "categoryPath": [
      "(148146) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148146) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Wakeboardy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wiązania, buty",
    "categoryPath": [
      "(148144) Sport i turystyka",
      "Sporty wodne",
      "Wakeboard i narty wodne"
    ],
    "hierarchy": "(148144) Sport i turystyka / Sporty wodne / Wakeboard i narty wodne / Wiązania, buty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bomy",
    "categoryPath": [
      "(13572) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(13572) Sport i turystyka / Sporty wodne / Windsurfing / Bomy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Deski",
    "categoryPath": [
      "(13573) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(13573) Sport i turystyka / Sporty wodne / Windsurfing / Deski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Fały i linki trapezowe",
    "categoryPath": [
      "(19696) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(19696) Sport i turystyka / Sporty wodne / Windsurfing / Fały i linki trapezowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Maszty",
    "categoryPath": [
      "(13575) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(13575) Sport i turystyka / Sporty wodne / Windsurfing / Maszty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(83709) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(83709) Sport i turystyka / Sporty wodne / Windsurfing / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kaptury, opaski, rękawice",
    "categoryPath": [
      "(83710) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing",
      "Odzież"
    ],
    "hierarchy": "(83710) Sport i turystyka / Sporty wodne / Windsurfing / Odzież / Kaptury, opaski, rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pianki",
    "categoryPath": [
      "(13583) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing",
      "Odzież"
    ],
    "hierarchy": "(13583) Sport i turystyka / Sporty wodne / Windsurfing / Odzież / Pianki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pokrowce i osłony",
    "categoryPath": [
      "(19695) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(19695) Sport i turystyka / Sporty wodne / Windsurfing / Pokrowce i osłony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13571) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(13571) Sport i turystyka / Sporty wodne / Windsurfing / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stateczniki",
    "categoryPath": [
      "(13577) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(13577) Sport i turystyka / Sporty wodne / Windsurfing / Stateczniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Stopy, palety, przedłużki",
    "categoryPath": [
      "(19697) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(19697) Sport i turystyka / Sporty wodne / Windsurfing / Stopy, palety, przedłużki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Trapezy",
    "categoryPath": [
      "(13578) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(13578) Sport i turystyka / Sporty wodne / Windsurfing / Trapezy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Żagle",
    "categoryPath": [
      "(13579) Sport i turystyka",
      "Sporty wodne",
      "Windsurfing"
    ],
    "hierarchy": "(13579) Sport i turystyka / Sporty wodne / Windsurfing / Żagle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akumulatory",
    "categoryPath": [
      "(148203) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148203) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Akumulatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Anteny",
    "categoryPath": [
      "(148204) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148204) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Anteny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Barometry",
    "categoryPath": [
      "(148262) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148262) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Barometry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "GPS, akcesoria",
    "categoryPath": [
      "(148206) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148206) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / GPS, akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Głośniki",
    "categoryPath": [
      "(148205) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148205) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Głośniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kable",
    "categoryPath": [
      "(148207) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148207) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Kable",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kompasy",
    "categoryPath": [
      "(148263) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148263) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Kompasy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Lampy",
    "categoryPath": [
      "(148208) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148208) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Lampy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obrotomierze",
    "categoryPath": [
      "(148259) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148259) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Obrotomierze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Przełączniki",
    "categoryPath": [
      "(148210) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148210) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Przełączniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Prędkościomierze",
    "categoryPath": [
      "(148261) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148261) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Prędkościomierze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Radia",
    "categoryPath": [
      "(148209) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148209) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Radia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rozdzielnie",
    "categoryPath": [
      "(148211) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148211) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Rozdzielnie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wiatromierze",
    "categoryPath": [
      "(148212) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Elektronika, sprzęt pomiarowy"
    ],
    "hierarchy": "(148212) Sport i turystyka / Sporty wodne / Żeglarstwo / Elektronika, sprzęt pomiarowy / Wiatromierze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Farby, lakiery",
    "categoryPath": [
      "(148265) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Konserwacja i naprawa"
    ],
    "hierarchy": "(148265) Sport i turystyka / Sporty wodne / Żeglarstwo / Konserwacja i naprawa / Farby, lakiery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kleje, uszczelniacze",
    "categoryPath": [
      "(148216) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Konserwacja i naprawa"
    ],
    "hierarchy": "(148216) Sport i turystyka / Sporty wodne / Żeglarstwo / Konserwacja i naprawa / Kleje, uszczelniacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kosmetyki",
    "categoryPath": [
      "(148266) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Konserwacja i naprawa"
    ],
    "hierarchy": "(148266) Sport i turystyka / Sporty wodne / Żeglarstwo / Konserwacja i naprawa / Kosmetyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148215) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Konserwacja i naprawa"
    ],
    "hierarchy": "(148215) Sport i turystyka / Sporty wodne / Żeglarstwo / Konserwacja i naprawa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Szpachlówki",
    "categoryPath": [
      "(148267) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Konserwacja i naprawa"
    ],
    "hierarchy": "(148267) Sport i turystyka / Sporty wodne / Żeglarstwo / Konserwacja i naprawa / Szpachlówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Żywice, tkaniny",
    "categoryPath": [
      "(148268) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Konserwacja i naprawa"
    ],
    "hierarchy": "(148268) Sport i turystyka / Sporty wodne / Żeglarstwo / Konserwacja i naprawa / Żywice, tkaniny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bawełniane",
    "categoryPath": [
      "(310181) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(310181) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Bawełniane",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Cumownicze",
    "categoryPath": [
      "(148218) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(148218) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Cumownicze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Fałowe, szotowe",
    "categoryPath": [
      "(148219) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(148219) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Fałowe, szotowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gumowe",
    "categoryPath": [
      "(148220) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(148220) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Gumowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Jutowe",
    "categoryPath": [
      "(148221) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(148221) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Jutowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Polipropylenowe, poliestrowe",
    "categoryPath": [
      "(148222) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(148222) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Polipropylenowe, poliestrowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(148217) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(148217) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stalowe, nierdzewne",
    "categoryPath": [
      "(148223) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Liny"
    ],
    "hierarchy": "(148223) Sport i turystyka / Sporty wodne / Żeglarstwo / Liny / Stalowe, nierdzewne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Książki",
    "categoryPath": [
      "(13592) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Literatura"
    ],
    "hierarchy": "(13592) Sport i turystyka / Sporty wodne / Żeglarstwo / Literatura / Książki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Mapy",
    "categoryPath": [
      "(13593) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Literatura"
    ],
    "hierarchy": "(13593) Sport i turystyka / Sporty wodne / Żeglarstwo / Literatura / Mapy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(83711) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo"
    ],
    "hierarchy": "(83711) Sport i turystyka / Sporty wodne / Żeglarstwo / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(14068) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Odzież"
    ],
    "hierarchy": "(14068) Sport i turystyka / Sporty wodne / Żeglarstwo / Odzież / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki i koszule",
    "categoryPath": [
      "(14069) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Odzież"
    ],
    "hierarchy": "(14069) Sport i turystyka / Sporty wodne / Żeglarstwo / Odzież / Koszulki i koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki i spodnie",
    "categoryPath": [
      "(14070) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Odzież"
    ],
    "hierarchy": "(14070) Sport i turystyka / Sporty wodne / Żeglarstwo / Odzież / Kurtki i spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(14071) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Odzież"
    ],
    "hierarchy": "(14071) Sport i turystyka / Sporty wodne / Żeglarstwo / Odzież / Rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sztormiaki",
    "categoryPath": [
      "(83712) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Odzież"
    ],
    "hierarchy": "(83712) Sport i turystyka / Sporty wodne / Żeglarstwo / Odzież / Sztormiaki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Amortyzatory cumy",
    "categoryPath": [
      "(148226) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148226) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Amortyzatory cumy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bandery, flagi",
    "categoryPath": [
      "(148227) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148227) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Bandery, flagi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bloki, bloczki",
    "categoryPath": [
      "(148228) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148228) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Bloki, bloczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Boje cumownicze",
    "categoryPath": [
      "(148229) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148229) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Boje cumownicze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bosaki, groty",
    "categoryPath": [
      "(148230) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148230) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Bosaki, groty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Drabiny",
    "categoryPath": [
      "(148231) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148231) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Drabiny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Fotele, akcesoria",
    "categoryPath": [
      "(148232) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148232) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Fotele, akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Haki",
    "categoryPath": [
      "(148233) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148233) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Haki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kabestany, akcesoria",
    "categoryPath": [
      "(148235) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148235) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Kabestany, akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karabińczyki",
    "categoryPath": [
      "(148236) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148236) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Karabińczyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Knagi",
    "categoryPath": [
      "(148237) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148237) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Knagi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kotwice i ciężarki",
    "categoryPath": [
      "(148239) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148239) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Kotwice i ciężarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Końcówki",
    "categoryPath": [
      "(148238) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148238) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Końcówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Krętliki",
    "categoryPath": [
      "(148240) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148240) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Krętliki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Luki, dekle",
    "categoryPath": [
      "(148241) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148241) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Luki, dekle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Maszty, akcesoria",
    "categoryPath": [
      "(148242) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148242) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Maszty, akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Maty",
    "categoryPath": [
      "(320852) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(320852) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Maty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Noże",
    "categoryPath": [
      "(148243) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148243) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Noże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Odbijacze, kosze",
    "categoryPath": [
      "(148244) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148244) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Odbijacze, kosze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Przedłużki, przeguby",
    "categoryPath": [
      "(148245) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148245) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Przedłużki, przeguby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Przelotki, ucha",
    "categoryPath": [
      "(148246) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148246) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Przelotki, ucha",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Przetyczki, sworznie",
    "categoryPath": [
      "(148247) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148247) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Przetyczki, sworznie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rolery, sztagi",
    "categoryPath": [
      "(148248) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148248) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Rolery, sztagi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rolki i prowadnice",
    "categoryPath": [
      "(148249) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148249) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Rolki i prowadnice",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Stopery fałowe",
    "categoryPath": [
      "(148250) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148250) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Stopery fałowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szekle i kausze",
    "categoryPath": [
      "(148251) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148251) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Szekle i kausze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Uchwyty",
    "categoryPath": [
      "(148234) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148234) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Uchwyty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wkręty i śruby",
    "categoryPath": [
      "(148253) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148253) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Wkręty i śruby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zaciski do lin",
    "categoryPath": [
      "(148254) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148254) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Zaciski do lin",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zamknięcia",
    "categoryPath": [
      "(148255) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148255) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Zamknięcia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zawiasy",
    "categoryPath": [
      "(148256) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148256) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Zawiasy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Ściągacze",
    "categoryPath": [
      "(148252) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo",
      "Osprzęt jachtowy"
    ],
    "hierarchy": "(148252) Sport i turystyka / Sporty wodne / Żeglarstwo / Osprzęt jachtowy / Ściągacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pompy, akcesoria",
    "categoryPath": [
      "(148258) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo"
    ],
    "hierarchy": "(148258) Sport i turystyka / Sporty wodne / Żeglarstwo / Pompy, akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13585) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo"
    ],
    "hierarchy": "(13585) Sport i turystyka / Sporty wodne / Żeglarstwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Silniki, akcesoria",
    "categoryPath": [
      "(148257) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo"
    ],
    "hierarchy": "(148257) Sport i turystyka / Sporty wodne / Żeglarstwo / Silniki, akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Worki żeglarskie, opakowania wodoszczelne",
    "categoryPath": [
      "(249422) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo"
    ],
    "hierarchy": "(249422) Sport i turystyka / Sporty wodne / Żeglarstwo / Worki żeglarskie, opakowania wodoszczelne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Łodzie",
    "categoryPath": [
      "(148224) Sport i turystyka",
      "Sporty wodne",
      "Żeglarstwo"
    ],
    "hierarchy": "(148224) Sport i turystyka / Sporty wodne / Żeglarstwo / Łodzie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Foki skiturowe",
    "categoryPath": [
      "(256776) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256776) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Foki skiturowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klucze",
    "categoryPath": [
      "(256745) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256745) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Klucze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Naklejki",
    "categoryPath": [
      "(256746) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256746) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Naklejki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochraniacze",
    "categoryPath": [
      "(256747) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256747) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Ochraniacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Plecaki",
    "categoryPath": [
      "(256748) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256748) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Plecaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce, torby",
    "categoryPath": [
      "(256749) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256749) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Pokrowce, torby",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Smary i woski",
    "categoryPath": [
      "(256751) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256751) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Smary i woski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Suszarki",
    "categoryPath": [
      "(256753) Sport i turystyka",
      "Sporty zimowe",
      "Akcesoria narciarskie i snowboardowe"
    ],
    "hierarchy": "(256753) Sport i turystyka / Sporty zimowe / Akcesoria narciarskie i snowboardowe / Suszarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Biegowe",
    "categoryPath": [
      "(256771) Sport i turystyka",
      "Sporty zimowe",
      "Buty narciarskie"
    ],
    "hierarchy": "(256771) Sport i turystyka / Sporty zimowe / Buty narciarskie / Biegowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Skiturowe",
    "categoryPath": [
      "(256772) Sport i turystyka",
      "Sporty zimowe",
      "Buty narciarskie"
    ],
    "hierarchy": "(256772) Sport i turystyka / Sporty zimowe / Buty narciarskie / Skiturowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zjazdowe",
    "categoryPath": [
      "(256773) Sport i turystyka",
      "Sporty zimowe",
      "Buty narciarskie"
    ],
    "hierarchy": "(256773) Sport i turystyka / Sporty zimowe / Buty narciarskie / Zjazdowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Buty snowboardowe",
    "categoryPath": [
      "(256739) Sport i turystyka",
      "Sporty zimowe"
    ],
    "hierarchy": "(256739) Sport i turystyka / Sporty zimowe / Buty snowboardowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "All mountain",
    "categoryPath": [
      "(256767) Sport i turystyka",
      "Sporty zimowe",
      "Deski snowboardowe"
    ],
    "hierarchy": "(256767) Sport i turystyka / Sporty zimowe / Deski snowboardowe / All mountain",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Freeride",
    "categoryPath": [
      "(256768) Sport i turystyka",
      "Sporty zimowe",
      "Deski snowboardowe"
    ],
    "hierarchy": "(256768) Sport i turystyka / Sporty zimowe / Deski snowboardowe / Freeride",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Freestyle",
    "categoryPath": [
      "(256769) Sport i turystyka",
      "Sporty zimowe",
      "Deski snowboardowe"
    ],
    "hierarchy": "(256769) Sport i turystyka / Sporty zimowe / Deski snowboardowe / Freestyle",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256770) Sport i turystyka",
      "Sporty zimowe",
      "Deski snowboardowe"
    ],
    "hierarchy": "(256770) Sport i turystyka / Sporty zimowe / Deski snowboardowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Gogle i okulary",
    "categoryPath": [
      "(256722) Sport i turystyka",
      "Sporty zimowe"
    ],
    "hierarchy": "(256722) Sport i turystyka / Sporty zimowe / Gogle i okulary",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kaski",
    "categoryPath": [
      "(256723) Sport i turystyka",
      "Sporty zimowe"
    ],
    "hierarchy": "(256723) Sport i turystyka / Sporty zimowe / Kaski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Biegowe",
    "categoryPath": [
      "(256731) Sport i turystyka",
      "Sporty zimowe",
      "Kijki"
    ],
    "hierarchy": "(256731) Sport i turystyka / Sporty zimowe / Kijki / Biegowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256735) Sport i turystyka",
      "Sporty zimowe",
      "Kijki"
    ],
    "hierarchy": "(256735) Sport i turystyka / Sporty zimowe / Kijki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Zjazdowe",
    "categoryPath": [
      "(256733) Sport i turystyka",
      "Sporty zimowe",
      "Kijki"
    ],
    "hierarchy": "(256733) Sport i turystyka / Sporty zimowe / Kijki / Zjazdowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Biegowe",
    "categoryPath": [
      "(256752) Sport i turystyka",
      "Sporty zimowe",
      "Narty"
    ],
    "hierarchy": "(256752) Sport i turystyka / Sporty zimowe / Narty / Biegowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Skiturowe",
    "categoryPath": [
      "(256754) Sport i turystyka",
      "Sporty zimowe",
      "Narty"
    ],
    "hierarchy": "(256754) Sport i turystyka / Sporty zimowe / Narty / Skiturowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zjazdowe",
    "categoryPath": [
      "(256756) Sport i turystyka",
      "Sporty zimowe",
      "Narty"
    ],
    "hierarchy": "(256756) Sport i turystyka / Sporty zimowe / Narty / Zjazdowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Dół",
    "categoryPath": [
      "(256763) Sport i turystyka",
      "Sporty zimowe",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(256763) Sport i turystyka / Sporty zimowe / Odzież / Bielizna / Dół",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Góra",
    "categoryPath": [
      "(256764) Sport i turystyka",
      "Sporty zimowe",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(256764) Sport i turystyka / Sporty zimowe / Odzież / Bielizna / Góra",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplet",
    "categoryPath": [
      "(256765) Sport i turystyka",
      "Sporty zimowe",
      "Odzież",
      "Bielizna"
    ],
    "hierarchy": "(256765) Sport i turystyka / Sporty zimowe / Odzież / Bielizna / Komplet",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(256728) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256728) Sport i turystyka / Sporty zimowe / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(256729) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256729) Sport i turystyka / Sporty zimowe / Odzież / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kombinezony narciarskie",
    "categoryPath": [
      "(256730) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256730) Sport i turystyka / Sporty zimowe / Odzież / Kombinezony narciarskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kominiarki",
    "categoryPath": [
      "(256732) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256732) Sport i turystyka / Sporty zimowe / Odzież / Kominiarki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(256734) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256734) Sport i turystyka / Sporty zimowe / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(256744) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256744) Sport i turystyka / Sporty zimowe / Odzież / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(256736) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256736) Sport i turystyka / Sporty zimowe / Odzież / Rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(256737) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256737) Sport i turystyka / Sporty zimowe / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(256740) Sport i turystyka",
      "Sporty zimowe",
      "Odzież"
    ],
    "hierarchy": "(256740) Sport i turystyka / Sporty zimowe / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13600) Sport i turystyka",
      "Sporty zimowe"
    ],
    "hierarchy": "(13600) Sport i turystyka / Sporty zimowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rakiety śnieżne",
    "categoryPath": [
      "(306573) Sport i turystyka",
      "Sporty zimowe"
    ],
    "hierarchy": "(306573) Sport i turystyka / Sporty zimowe / Rakiety śnieżne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Buty",
    "categoryPath": [
      "(16515) Sport i turystyka",
      "Sporty zimowe",
      "Snowkiting"
    ],
    "hierarchy": "(16515) Sport i turystyka / Sporty zimowe / Snowkiting / Buty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Deski",
    "categoryPath": [
      "(16516) Sport i turystyka",
      "Sporty zimowe",
      "Snowkiting"
    ],
    "hierarchy": "(16516) Sport i turystyka / Sporty zimowe / Snowkiting / Deski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Latawce",
    "categoryPath": [
      "(16517) Sport i turystyka",
      "Sporty zimowe",
      "Snowkiting"
    ],
    "hierarchy": "(16517) Sport i turystyka / Sporty zimowe / Snowkiting / Latawce",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odzież",
    "categoryPath": [
      "(16518) Sport i turystyka",
      "Sporty zimowe",
      "Snowkiting"
    ],
    "hierarchy": "(16518) Sport i turystyka / Sporty zimowe / Snowkiting / Odzież",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trapezy",
    "categoryPath": [
      "(16519) Sport i turystyka",
      "Sporty zimowe",
      "Snowkiting"
    ],
    "hierarchy": "(16519) Sport i turystyka / Sporty zimowe / Snowkiting / Trapezy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wiązania",
    "categoryPath": [
      "(16520) Sport i turystyka",
      "Sporty zimowe",
      "Snowkiting"
    ],
    "hierarchy": "(16520) Sport i turystyka / Sporty zimowe / Snowkiting / Wiązania",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Biegowe",
    "categoryPath": [
      "(256759) Sport i turystyka",
      "Sporty zimowe",
      "Wiązania narciarskie"
    ],
    "hierarchy": "(256759) Sport i turystyka / Sporty zimowe / Wiązania narciarskie / Biegowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Skiturowe",
    "categoryPath": [
      "(256760) Sport i turystyka",
      "Sporty zimowe",
      "Wiązania narciarskie"
    ],
    "hierarchy": "(256760) Sport i turystyka / Sporty zimowe / Wiązania narciarskie / Skiturowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zjazdowe",
    "categoryPath": [
      "(256761) Sport i turystyka",
      "Sporty zimowe",
      "Wiązania narciarskie"
    ],
    "hierarchy": "(256761) Sport i turystyka / Sporty zimowe / Wiązania narciarskie / Zjazdowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wiązania snowboardowe",
    "categoryPath": [
      "(256742) Sport i turystyka",
      "Sporty zimowe"
    ],
    "hierarchy": "(256742) Sport i turystyka / Sporty zimowe / Wiązania snowboardowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(14074) Sport i turystyka",
      "Sporty zimowe",
      "Łyżwiarstwo"
    ],
    "hierarchy": "(14074) Sport i turystyka / Sporty zimowe / Łyżwiarstwo / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Figurowe",
    "categoryPath": [
      "(97928) Sport i turystyka",
      "Sporty zimowe",
      "Łyżwiarstwo",
      "Łyżwy"
    ],
    "hierarchy": "(97928) Sport i turystyka / Sporty zimowe / Łyżwiarstwo / Łyżwy / Figurowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Hokejowe",
    "categoryPath": [
      "(97929) Sport i turystyka",
      "Sporty zimowe",
      "Łyżwiarstwo",
      "Łyżwy"
    ],
    "hierarchy": "(97929) Sport i turystyka / Sporty zimowe / Łyżwiarstwo / Łyżwy / Hokejowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(97927) Sport i turystyka",
      "Sporty zimowe",
      "Łyżwiarstwo",
      "Łyżwy"
    ],
    "hierarchy": "(97927) Sport i turystyka / Sporty zimowe / Łyżwiarstwo / Łyżwy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Regulowane",
    "categoryPath": [
      "(97930) Sport i turystyka",
      "Sporty zimowe",
      "Łyżwiarstwo",
      "Łyżwy"
    ],
    "hierarchy": "(97930) Sport i turystyka / Sporty zimowe / Łyżwiarstwo / Łyżwy / Regulowane",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Badminton",
    "categoryPath": [
      "(13640) Sport i turystyka",
      "Tenis i pokrewne"
    ],
    "hierarchy": "(13640) Sport i turystyka / Tenis i pokrewne / Badminton",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(13639) Sport i turystyka",
      "Tenis i pokrewne"
    ],
    "hierarchy": "(13639) Sport i turystyka / Tenis i pokrewne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Naciągi",
    "categoryPath": [
      "(252713) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash"
    ],
    "hierarchy": "(252713) Sport i turystyka / Tenis i pokrewne / Squash / Naciągi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(252711) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash"
    ],
    "hierarchy": "(252711) Sport i turystyka / Tenis i pokrewne / Squash / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(260891) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash",
      "Odzież"
    ],
    "hierarchy": "(260891) Sport i turystyka / Tenis i pokrewne / Squash / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(257807) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash",
      "Odzież"
    ],
    "hierarchy": "(257807) Sport i turystyka / Tenis i pokrewne / Squash / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(257806) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash",
      "Odzież"
    ],
    "hierarchy": "(257806) Sport i turystyka / Tenis i pokrewne / Squash / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(257808) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash",
      "Odzież"
    ],
    "hierarchy": "(257808) Sport i turystyka / Tenis i pokrewne / Squash / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(260890) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash",
      "Odzież"
    ],
    "hierarchy": "(260890) Sport i turystyka / Tenis i pokrewne / Squash / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spódniczki",
    "categoryPath": [
      "(257810) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash",
      "Odzież"
    ],
    "hierarchy": "(257810) Sport i turystyka / Tenis i pokrewne / Squash / Odzież / Spódniczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(252716) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash"
    ],
    "hierarchy": "(252716) Sport i turystyka / Tenis i pokrewne / Squash / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rakiety",
    "categoryPath": [
      "(13645) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash"
    ],
    "hierarchy": "(13645) Sport i turystyka / Tenis i pokrewne / Squash / Rakiety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby",
    "categoryPath": [
      "(252718) Sport i turystyka",
      "Tenis i pokrewne",
      "Squash"
    ],
    "hierarchy": "(252718) Sport i turystyka / Tenis i pokrewne / Squash / Torby",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Tenis plażowy",
    "categoryPath": [
      "(311165) Sport i turystyka",
      "Tenis i pokrewne"
    ],
    "hierarchy": "(311165) Sport i turystyka / Tenis i pokrewne / Tenis plażowy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(13646) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis stołowy"
    ],
    "hierarchy": "(13646) Sport i turystyka / Tenis i pokrewne / Tenis stołowy / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Deski",
    "categoryPath": [
      "(14736) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis stołowy"
    ],
    "hierarchy": "(14736) Sport i turystyka / Tenis i pokrewne / Tenis stołowy / Deski",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(310789) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis stołowy"
    ],
    "hierarchy": "(310789) Sport i turystyka / Tenis i pokrewne / Tenis stołowy / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Okładziny",
    "categoryPath": [
      "(14735) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis stołowy"
    ],
    "hierarchy": "(14735) Sport i turystyka / Tenis i pokrewne / Tenis stołowy / Okładziny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Piłeczki",
    "categoryPath": [
      "(13647) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis stołowy"
    ],
    "hierarchy": "(13647) Sport i turystyka / Tenis i pokrewne / Tenis stołowy / Piłeczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rakietki",
    "categoryPath": [
      "(13648) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis stołowy"
    ],
    "hierarchy": "(13648) Sport i turystyka / Tenis i pokrewne / Tenis stołowy / Rakietki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(13649) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis stołowy"
    ],
    "hierarchy": "(13649) Sport i turystyka / Tenis i pokrewne / Tenis stołowy / Stoły",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Naciągi tenisowe",
    "categoryPath": [
      "(13651) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(13651) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Naciągi tenisowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256135) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(256135) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(13656) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(13656) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(260893) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(260893) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(13657) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(13657) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(257795) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(257795) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(13659) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(13659) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(260892) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(260892) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spódniczki",
    "categoryPath": [
      "(13660) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(13660) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Spódniczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki",
    "categoryPath": [
      "(257794) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny",
      "Odzież"
    ],
    "hierarchy": "(257794) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Odzież / Sukienki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Owijki tenisowe",
    "categoryPath": [
      "(13653) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(13653) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Owijki tenisowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Piłki tenisowe",
    "categoryPath": [
      "(13654) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(13654) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Piłki tenisowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rakiety",
    "categoryPath": [
      "(13655) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(13655) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Rakiety",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(14080) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(14080) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Siatki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby tenisowe, plecaki i pokrowce",
    "categoryPath": [
      "(14081) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(14081) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Torby tenisowe, plecaki i pokrowce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wibrastopy",
    "categoryPath": [
      "(322282) Sport i turystyka",
      "Tenis i pokrewne",
      "Tenis ziemny"
    ],
    "hierarchy": "(322282) Sport i turystyka / Tenis i pokrewne / Tenis ziemny / Wibrastopy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kije trekkingowe",
    "categoryPath": [
      "(147865) Sport i turystyka",
      "Turystyka",
      "Akcesoria"
    ],
    "hierarchy": "(147865) Sport i turystyka / Turystyka / Akcesoria / Kije trekkingowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Moskitiery",
    "categoryPath": [
      "(257384) Sport i turystyka",
      "Turystyka",
      "Akcesoria"
    ],
    "hierarchy": "(257384) Sport i turystyka / Turystyka / Akcesoria / Moskitiery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Okulary, gogle",
    "categoryPath": [
      "(147873) Sport i turystyka",
      "Turystyka",
      "Akcesoria"
    ],
    "hierarchy": "(147873) Sport i turystyka / Turystyka / Akcesoria / Okulary, gogle",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pompki",
    "categoryPath": [
      "(102877) Sport i turystyka",
      "Turystyka",
      "Akcesoria"
    ],
    "hierarchy": "(102877) Sport i turystyka / Turystyka / Akcesoria / Pompki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(102884) Sport i turystyka",
      "Turystyka",
      "Akcesoria"
    ],
    "hierarchy": "(102884) Sport i turystyka / Turystyka / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Raczki turystyczne, nakładki antypoślizgowe",
    "categoryPath": [
      "(322404) Sport i turystyka",
      "Turystyka",
      "Akcesoria"
    ],
    "hierarchy": "(322404) Sport i turystyka / Turystyka / Akcesoria / Raczki turystyczne, nakładki antypoślizgowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ładowarki",
    "categoryPath": [
      "(147875) Sport i turystyka",
      "Turystyka",
      "Akcesoria"
    ],
    "hierarchy": "(147875) Sport i turystyka / Turystyka / Akcesoria / Ładowarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Apteczki",
    "categoryPath": [
      "(258153) Sport i turystyka",
      "Turystyka",
      "Apteczki i środki na owady"
    ],
    "hierarchy": "(258153) Sport i turystyka / Turystyka / Apteczki i środki na owady / Apteczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Folie termiczne",
    "categoryPath": [
      "(258154) Sport i turystyka",
      "Turystyka",
      "Apteczki i środki na owady"
    ],
    "hierarchy": "(258154) Sport i turystyka / Turystyka / Apteczki i środki na owady / Folie termiczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Środki na owady",
    "categoryPath": [
      "(258155) Sport i turystyka",
      "Turystyka",
      "Apteczki i środki na owady"
    ],
    "hierarchy": "(258155) Sport i turystyka / Turystyka / Apteczki i środki na owady / Środki na owady",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kosmetyczki",
    "categoryPath": [
      "(258156) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(258156) Sport i turystyka / Turystyka / Bagaż / Kosmetyczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Organizery i pokrowce",
    "categoryPath": [
      "(260883) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(260883) Sport i turystyka / Turystyka / Bagaż / Organizery i pokrowce",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Portfele i paszportówki",
    "categoryPath": [
      "(258157) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(258157) Sport i turystyka / Turystyka / Bagaż / Portfele i paszportówki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Torby",
    "categoryPath": [
      "(258159) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(258159) Sport i turystyka / Turystyka / Bagaż / Torby",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wagi bagażowe",
    "categoryPath": [
      "(258160) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(258160) Sport i turystyka / Turystyka / Bagaż / Wagi bagażowe",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Walizki",
    "categoryPath": [
      "(258161) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(258161) Sport i turystyka / Turystyka / Bagaż / Walizki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Worki, torby i saszetki wodoszczelne",
    "categoryPath": [
      "(258162) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(258162) Sport i turystyka / Turystyka / Bagaż / Worki, torby i saszetki wodoszczelne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Zabezpieczenie bagażu",
    "categoryPath": [
      "(258163) Sport i turystyka",
      "Turystyka",
      "Bagaż"
    ],
    "hierarchy": "(258163) Sport i turystyka / Turystyka / Bagaż / Zabezpieczenie bagażu",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Impregnaty, środki piorące i czyszczące",
    "categoryPath": [
      "(258165) Sport i turystyka",
      "Turystyka",
      "Higiena"
    ],
    "hierarchy": "(258165) Sport i turystyka / Turystyka / Higiena / Impregnaty, środki piorące i czyszczące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Prysznice turystyczne",
    "categoryPath": [
      "(258166) Sport i turystyka",
      "Turystyka",
      "Higiena"
    ],
    "hierarchy": "(258166) Sport i turystyka / Turystyka / Higiena / Prysznice turystyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Ręczniki szybkoschnące",
    "categoryPath": [
      "(258167) Sport i turystyka",
      "Turystyka",
      "Higiena"
    ],
    "hierarchy": "(258167) Sport i turystyka / Turystyka / Higiena / Ręczniki szybkoschnące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Toalety turystyczne",
    "categoryPath": [
      "(258169) Sport i turystyka",
      "Turystyka",
      "Higiena"
    ],
    "hierarchy": "(258169) Sport i turystyka / Turystyka / Higiena / Toalety turystyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zbiorniki, baniaki",
    "categoryPath": [
      "(258170) Sport i turystyka",
      "Turystyka",
      "Higiena"
    ],
    "hierarchy": "(258170) Sport i turystyka / Turystyka / Higiena / Zbiorniki, baniaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Środki dezynfekujące, odkażające",
    "categoryPath": [
      "(258168) Sport i turystyka",
      "Turystyka",
      "Higiena"
    ],
    "hierarchy": "(258168) Sport i turystyka / Turystyka / Higiena / Środki dezynfekujące, odkażające",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Filtry do wody",
    "categoryPath": [
      "(322509) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(322509) Sport i turystyka / Turystyka / Kuchnia turystyczna / Filtry do wody",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kartusze",
    "categoryPath": [
      "(258171) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258171) Sport i turystyka / Turystyka / Kuchnia turystyczna / Kartusze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kubki termiczne",
    "categoryPath": [
      "(258172) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258172) Sport i turystyka / Turystyka / Kuchnia turystyczna / Kubki termiczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kuchenki turystyczne",
    "categoryPath": [
      "(258173) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258173) Sport i turystyka / Turystyka / Kuchnia turystyczna / Kuchenki turystyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Lodówki turystyczne",
    "categoryPath": [
      "(258175) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258175) Sport i turystyka / Turystyka / Kuchnia turystyczna / Lodówki turystyczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Menażki",
    "categoryPath": [
      "(258176) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258176) Sport i turystyka / Turystyka / Kuchnia turystyczna / Menażki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Naczynia",
    "categoryPath": [
      "(258177) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258177) Sport i turystyka / Turystyka / Kuchnia turystyczna / Naczynia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Sztućce, sporki, niezbędniki",
    "categoryPath": [
      "(258178) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258178) Sport i turystyka / Turystyka / Kuchnia turystyczna / Sztućce, sporki, niezbędniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Termosy",
    "categoryPath": [
      "(258179) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258179) Sport i turystyka / Turystyka / Kuchnia turystyczna / Termosy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Termosy na żywność",
    "categoryPath": [
      "(258180) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258180) Sport i turystyka / Turystyka / Kuchnia turystyczna / Termosy na żywność",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Żywność liofilizowana",
    "categoryPath": [
      "(258174) Sport i turystyka",
      "Turystyka",
      "Kuchnia turystyczna"
    ],
    "hierarchy": "(258174) Sport i turystyka / Turystyka / Kuchnia turystyczna / Żywność liofilizowana",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(258183) Sport i turystyka",
      "Turystyka",
      "Latarki i lampy"
    ],
    "hierarchy": "(258183) Sport i turystyka / Turystyka / Latarki i lampy / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lampy",
    "categoryPath": [
      "(258181) Sport i turystyka",
      "Turystyka",
      "Latarki i lampy"
    ],
    "hierarchy": "(258181) Sport i turystyka / Turystyka / Latarki i lampy / Lampy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Latarki",
    "categoryPath": [
      "(258182) Sport i turystyka",
      "Turystyka",
      "Latarki i lampy"
    ],
    "hierarchy": "(258182) Sport i turystyka / Turystyka / Latarki i lampy / Latarki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Światła chemiczne",
    "categoryPath": [
      "(322111) Sport i turystyka",
      "Turystyka",
      "Latarki i lampy"
    ],
    "hierarchy": "(322111) Sport i turystyka / Turystyka / Latarki i lampy / Światła chemiczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Krzesła",
    "categoryPath": [
      "(147858) Sport i turystyka",
      "Turystyka",
      "Meble turystyczne"
    ],
    "hierarchy": "(147858) Sport i turystyka / Turystyka / Meble turystyczne / Krzesła",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Stoły",
    "categoryPath": [
      "(147859) Sport i turystyka",
      "Turystyka",
      "Meble turystyczne"
    ],
    "hierarchy": "(147859) Sport i turystyka / Turystyka / Meble turystyczne / Stoły",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szafki",
    "categoryPath": [
      "(147861) Sport i turystyka",
      "Turystyka",
      "Meble turystyczne"
    ],
    "hierarchy": "(147861) Sport i turystyka / Turystyka / Meble turystyczne / Szafki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Łóżka",
    "categoryPath": [
      "(147860) Sport i turystyka",
      "Turystyka",
      "Meble turystyczne"
    ],
    "hierarchy": "(147860) Sport i turystyka / Turystyka / Meble turystyczne / Łóżka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koce piknikowe, maty",
    "categoryPath": [
      "(258184) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik"
    ],
    "hierarchy": "(258184) Sport i turystyka / Turystyka / Na plażę/Na piknik / Koce piknikowe, maty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kosze, plecaki piknikowe",
    "categoryPath": [
      "(258185) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik"
    ],
    "hierarchy": "(258185) Sport i turystyka / Turystyka / Na plażę/Na piknik / Kosze, plecaki piknikowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Fotele",
    "categoryPath": [
      "(318367) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318367) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Fotele",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(318395) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318395) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Inne akcesoria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Leżaki",
    "categoryPath": [
      "(318377) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318377) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Leżaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Materace, pontony",
    "categoryPath": [
      "(318374) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318374) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Materace, pontony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Piłki",
    "categoryPath": [
      "(318380) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318380) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Piłki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Podstawki pod napoje",
    "categoryPath": [
      "(318389) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318389) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Podstawki pod napoje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wyspy",
    "categoryPath": [
      "(318383) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318383) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Wyspy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zabawki",
    "categoryPath": [
      "(318386) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik",
      "Materace plażowe i akcesoria dmuchane"
    ],
    "hierarchy": "(318386) Sport i turystyka / Turystyka / Na plażę/Na piknik / Materace plażowe i akcesoria dmuchane / Zabawki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Namioty plażowe i parawany",
    "categoryPath": [
      "(258187) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik"
    ],
    "hierarchy": "(258187) Sport i turystyka / Turystyka / Na plażę/Na piknik / Namioty plażowe i parawany",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Parasole plażowe",
    "categoryPath": [
      "(258188) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik"
    ],
    "hierarchy": "(258188) Sport i turystyka / Turystyka / Na plażę/Na piknik / Parasole plażowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby termiczne",
    "categoryPath": [
      "(258189) Sport i turystyka",
      "Turystyka",
      "Na plażę/Na piknik"
    ],
    "hierarchy": "(258189) Sport i turystyka / Turystyka / Na plażę/Na piknik / Torby termiczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Linki, naciągi",
    "categoryPath": [
      "(257439) Sport i turystyka",
      "Turystyka",
      "Namioty i akcesoria"
    ],
    "hierarchy": "(257439) Sport i turystyka / Turystyka / Namioty i akcesoria / Linki, naciągi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Namioty",
    "categoryPath": [
      "(257528) Sport i turystyka",
      "Turystyka",
      "Namioty i akcesoria"
    ],
    "hierarchy": "(257528) Sport i turystyka / Turystyka / Namioty i akcesoria / Namioty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pałąki",
    "categoryPath": [
      "(257437) Sport i turystyka",
      "Turystyka",
      "Namioty i akcesoria"
    ],
    "hierarchy": "(257437) Sport i turystyka / Turystyka / Namioty i akcesoria / Pałąki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Podłogi do namiotu",
    "categoryPath": [
      "(257440) Sport i turystyka",
      "Turystyka",
      "Namioty i akcesoria"
    ],
    "hierarchy": "(257440) Sport i turystyka / Turystyka / Namioty i akcesoria / Podłogi do namiotu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257441) Sport i turystyka",
      "Turystyka",
      "Namioty i akcesoria"
    ],
    "hierarchy": "(257441) Sport i turystyka / Turystyka / Namioty i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płachty, tarpy",
    "categoryPath": [
      "(147842) Sport i turystyka",
      "Turystyka",
      "Namioty i akcesoria"
    ],
    "hierarchy": "(147842) Sport i turystyka / Turystyka / Namioty i akcesoria / Płachty, tarpy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Szpilki, śledzie",
    "categoryPath": [
      "(257438) Sport i turystyka",
      "Turystyka",
      "Namioty i akcesoria"
    ],
    "hierarchy": "(257438) Sport i turystyka / Turystyka / Namioty i akcesoria / Szpilki, śledzie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bransoletki survivalowe",
    "categoryPath": [
      "(258194) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(258194) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Bransoletki survivalowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karty przeżycia",
    "categoryPath": [
      "(258195) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(258195) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Karty przeżycia",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Multitoole",
    "categoryPath": [
      "(258193) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(258193) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Multitoole",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Noże",
    "categoryPath": [
      "(258191) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(258191) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Noże",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Ostrzałki, osełki",
    "categoryPath": [
      "(258197) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(258197) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Ostrzałki, osełki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Saperki",
    "categoryPath": [
      "(258196) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(258196) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Saperki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Scyzoryki",
    "categoryPath": [
      "(258192) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(258192) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Scyzoryki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zestawy survivalowe",
    "categoryPath": [
      "(321831) Sport i turystyka",
      "Turystyka",
      "Noże, scyzoryki i multitoole"
    ],
    "hierarchy": "(321831) Sport i turystyka / Turystyka / Noże, scyzoryki i multitoole / Zestawy survivalowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(147826) Sport i turystyka",
      "Turystyka",
      "Obuwie"
    ],
    "hierarchy": "(147826) Sport i turystyka / Turystyka / Obuwie / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miejskie",
    "categoryPath": [
      "(147804) Sport i turystyka",
      "Turystyka",
      "Obuwie"
    ],
    "hierarchy": "(147804) Sport i turystyka / Turystyka / Obuwie / Miejskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sandały, klapki",
    "categoryPath": [
      "(147805) Sport i turystyka",
      "Turystyka",
      "Obuwie"
    ],
    "hierarchy": "(147805) Sport i turystyka / Turystyka / Obuwie / Sandały, klapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trekkingowe niskie",
    "categoryPath": [
      "(147802) Sport i turystyka",
      "Turystyka",
      "Obuwie"
    ],
    "hierarchy": "(147802) Sport i turystyka / Turystyka / Obuwie / Trekkingowe niskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Trekkingowe wysokie",
    "categoryPath": [
      "(147803) Sport i turystyka",
      "Turystyka",
      "Obuwie"
    ],
    "hierarchy": "(147803) Sport i turystyka / Turystyka / Obuwie / Trekkingowe wysokie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wysokogórskie",
    "categoryPath": [
      "(112284) Sport i turystyka",
      "Turystyka",
      "Obuwie"
    ],
    "hierarchy": "(112284) Sport i turystyka / Turystyka / Obuwie / Wysokogórskie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dół",
    "categoryPath": [
      "(147811) Sport i turystyka",
      "Turystyka",
      "Odzież",
      "Bielizna termoaktywna"
    ],
    "hierarchy": "(147811) Sport i turystyka / Turystyka / Odzież / Bielizna termoaktywna / Dół",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Góra",
    "categoryPath": [
      "(147812) Sport i turystyka",
      "Turystyka",
      "Odzież",
      "Bielizna termoaktywna"
    ],
    "hierarchy": "(147812) Sport i turystyka / Turystyka / Odzież / Bielizna termoaktywna / Góra",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplet",
    "categoryPath": [
      "(147813) Sport i turystyka",
      "Turystyka",
      "Odzież",
      "Bielizna termoaktywna"
    ],
    "hierarchy": "(147813) Sport i turystyka / Turystyka / Odzież / Bielizna termoaktywna / Komplet",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy, swetry",
    "categoryPath": [
      "(147806) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(147806) Sport i turystyka / Turystyka / Odzież / Bluzy, swetry",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(147809) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(147809) Sport i turystyka / Turystyka / Odzież / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszule",
    "categoryPath": [
      "(257532) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(257532) Sport i turystyka / Turystyka / Odzież / Koszule",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(257533) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(257533) Sport i turystyka / Turystyka / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(112290) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(112290) Sport i turystyka / Turystyka / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Chusty wielofunkcyjne",
    "categoryPath": [
      "(257553) Sport i turystyka",
      "Turystyka",
      "Odzież",
      "Nakrycia głowy"
    ],
    "hierarchy": "(257553) Sport i turystyka / Turystyka / Odzież / Nakrycia głowy / Chusty wielofunkcyjne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki",
    "categoryPath": [
      "(257551) Sport i turystyka",
      "Turystyka",
      "Odzież",
      "Nakrycia głowy"
    ],
    "hierarchy": "(257551) Sport i turystyka / Turystyka / Odzież / Nakrycia głowy / Czapki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kapelusze",
    "categoryPath": [
      "(257554) Sport i turystyka",
      "Turystyka",
      "Odzież",
      "Nakrycia głowy"
    ],
    "hierarchy": "(257554) Sport i turystyka / Turystyka / Odzież / Nakrycia głowy / Kapelusze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Peleryny, poncha",
    "categoryPath": [
      "(147825) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(147825) Sport i turystyka / Turystyka / Odzież / Peleryny, poncha",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Polary",
    "categoryPath": [
      "(147807) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(147807) Sport i turystyka / Turystyka / Odzież / Polary",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112294) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(112294) Sport i turystyka / Turystyka / Odzież / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawice",
    "categoryPath": [
      "(112291) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(112291) Sport i turystyka / Turystyka / Odzież / Rękawice",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(112292) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(112292) Sport i turystyka / Turystyka / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodenki",
    "categoryPath": [
      "(147549) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(147549) Sport i turystyka / Turystyka / Odzież / Spodenki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(112293) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(112293) Sport i turystyka / Turystyka / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Stuptuty",
    "categoryPath": [
      "(125748) Sport i turystyka",
      "Turystyka",
      "Odzież"
    ],
    "hierarchy": "(125748) Sport i turystyka / Turystyka / Odzież / Stuptuty",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Krzesiwa",
    "categoryPath": [
      "(258198) Sport i turystyka",
      "Turystyka",
      "Ogień i ciepło"
    ],
    "hierarchy": "(258198) Sport i turystyka / Turystyka / Ogień i ciepło / Krzesiwa",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Ogrzewacze",
    "categoryPath": [
      "(258199) Sport i turystyka",
      "Turystyka",
      "Ogień i ciepło"
    ],
    "hierarchy": "(258199) Sport i turystyka / Turystyka / Ogień i ciepło / Ogrzewacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Promienniki, piecyki turystyczne",
    "categoryPath": [
      "(258200) Sport i turystyka",
      "Turystyka",
      "Ogień i ciepło"
    ],
    "hierarchy": "(258200) Sport i turystyka / Turystyka / Ogień i ciepło / Promienniki, piecyki turystyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zapałki i zapalniczki",
    "categoryPath": [
      "(258201) Sport i turystyka",
      "Turystyka",
      "Ogień i ciepło"
    ],
    "hierarchy": "(258201) Sport i turystyka / Turystyka / Ogień i ciepło / Zapałki i zapalniczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kompasy",
    "categoryPath": [
      "(258202) Sport i turystyka",
      "Turystyka",
      "Orientacja w terenie"
    ],
    "hierarchy": "(258202) Sport i turystyka / Turystyka / Orientacja w terenie / Kompasy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Literatura podróżnicza, mapy i przewodniki",
    "categoryPath": [
      "(258203) Sport i turystyka",
      "Turystyka",
      "Orientacja w terenie"
    ],
    "hierarchy": "(258203) Sport i turystyka / Turystyka / Orientacja w terenie / Literatura podróżnicza, mapy i przewodniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Mapniki",
    "categoryPath": [
      "(258204) Sport i turystyka",
      "Turystyka",
      "Orientacja w terenie"
    ],
    "hierarchy": "(258204) Sport i turystyka / Turystyka / Orientacja w terenie / Mapniki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kieszenie",
    "categoryPath": [
      "(258205) Sport i turystyka",
      "Turystyka",
      "Plecaki"
    ],
    "hierarchy": "(258205) Sport i turystyka / Turystyka / Plecaki / Kieszenie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Klamry, troki, taśmy",
    "categoryPath": [
      "(258206) Sport i turystyka",
      "Turystyka",
      "Plecaki"
    ],
    "hierarchy": "(258206) Sport i turystyka / Turystyka / Plecaki / Klamry, troki, taśmy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Miejskie",
    "categoryPath": [
      "(147828) Sport i turystyka",
      "Turystyka",
      "Plecaki"
    ],
    "hierarchy": "(147828) Sport i turystyka / Turystyka / Plecaki / Miejskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pokrowce",
    "categoryPath": [
      "(258207) Sport i turystyka",
      "Turystyka",
      "Plecaki"
    ],
    "hierarchy": "(258207) Sport i turystyka / Turystyka / Plecaki / Pokrowce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Turystyczne",
    "categoryPath": [
      "(147827) Sport i turystyka",
      "Turystyka",
      "Plecaki"
    ],
    "hierarchy": "(147827) Sport i turystyka / Turystyka / Plecaki / Turystyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wojskowe, taktyczne",
    "categoryPath": [
      "(148382) Sport i turystyka",
      "Turystyka",
      "Plecaki"
    ],
    "hierarchy": "(148382) Sport i turystyka / Turystyka / Plecaki / Wojskowe, taktyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria do pontonów i łodzi",
    "categoryPath": [
      "(257531) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie"
    ],
    "hierarchy": "(257531) Sport i turystyka / Turystyka / Pontony i łodzie / Akcesoria do pontonów i łodzi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Akcesoria do silników",
    "categoryPath": [
      "(257530) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie"
    ],
    "hierarchy": "(257530) Sport i turystyka / Turystyka / Pontony i łodzie / Akcesoria do silników",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce, plandeki",
    "categoryPath": [
      "(257511) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie"
    ],
    "hierarchy": "(257511) Sport i turystyka / Turystyka / Pontony i łodzie / Pokrowce, plandeki",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Pontony",
    "categoryPath": [
      "(102880) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie"
    ],
    "hierarchy": "(102880) Sport i turystyka / Turystyka / Pontony i łodzie / Pontony",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Elektryczne",
    "categoryPath": [
      "(252720) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie",
      "Silniki"
    ],
    "hierarchy": "(252720) Sport i turystyka / Turystyka / Pontony i łodzie / Silniki / Elektryczne",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Spalinowe",
    "categoryPath": [
      "(252719) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie",
      "Silniki"
    ],
    "hierarchy": "(252719) Sport i turystyka / Turystyka / Pontony i łodzie / Silniki / Spalinowe",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Wiosła",
    "categoryPath": [
      "(257512) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie"
    ],
    "hierarchy": "(257512) Sport i turystyka / Turystyka / Pontony i łodzie / Wiosła",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Łodzie",
    "categoryPath": [
      "(102881) Sport i turystyka",
      "Turystyka",
      "Pontony i łodzie"
    ],
    "hierarchy": "(102881) Sport i turystyka / Turystyka / Pontony i łodzie / Łodzie",
    "comissionGroupOld": "C35",
    "comissionGroupNew": "D29"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(3964) Sport i turystyka",
      "Turystyka"
    ],
    "hierarchy": "(3964) Sport i turystyka / Turystyka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Karimaty",
    "categoryPath": [
      "(258209) Sport i turystyka",
      "Turystyka",
      "Śpiwory, materace i karimaty"
    ],
    "hierarchy": "(258209) Sport i turystyka / Turystyka / Śpiwory, materace i karimaty / Karimaty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Materace",
    "categoryPath": [
      "(258210) Sport i turystyka",
      "Turystyka",
      "Śpiwory, materace i karimaty"
    ],
    "hierarchy": "(258210) Sport i turystyka / Turystyka / Śpiwory, materace i karimaty / Materace",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Maty samopompujące",
    "categoryPath": [
      "(258212) Sport i turystyka",
      "Turystyka",
      "Śpiwory, materace i karimaty"
    ],
    "hierarchy": "(258212) Sport i turystyka / Turystyka / Śpiwory, materace i karimaty / Maty samopompujące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Poduszki, zagłówki",
    "categoryPath": [
      "(258211) Sport i turystyka",
      "Turystyka",
      "Śpiwory, materace i karimaty"
    ],
    "hierarchy": "(258211) Sport i turystyka / Turystyka / Śpiwory, materace i karimaty / Poduszki, zagłówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wkładki do śpiworów",
    "categoryPath": [
      "(147855) Sport i turystyka",
      "Turystyka",
      "Śpiwory, materace i karimaty"
    ],
    "hierarchy": "(147855) Sport i turystyka / Turystyka / Śpiwory, materace i karimaty / Wkładki do śpiworów",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Śpiwory",
    "categoryPath": [
      "(257897) Sport i turystyka",
      "Turystyka",
      "Śpiwory, materace i karimaty"
    ],
    "hierarchy": "(257897) Sport i turystyka / Turystyka / Śpiwory, materace i karimaty / Śpiwory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Agrafki, krętliki, kółka łącznikowe",
    "categoryPath": [
      "(132182) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(132182) Sport i turystyka / Wędkarstwo / Akcesoria / Agrafki, krętliki, kółka łącznikowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ciężarki, śruciny, gruntomierze",
    "categoryPath": [
      "(132183) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(132183) Sport i turystyka / Wędkarstwo / Akcesoria / Ciężarki, śruciny, gruntomierze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dzwonki",
    "categoryPath": [
      "(317793) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(317793) Sport i turystyka / Wędkarstwo / Akcesoria / Dzwonki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Główki jigowe",
    "categoryPath": [
      "(132242) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(132242) Sport i turystyka / Wędkarstwo / Akcesoria / Główki jigowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Haczyki i kotwiczki",
    "categoryPath": [
      "(121732) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(121732) Sport i turystyka / Wędkarstwo / Akcesoria / Haczyki i kotwiczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Koszyki, sprężyny zanętowe",
    "categoryPath": [
      "(123483) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(123483) Sport i turystyka / Wędkarstwo / Akcesoria / Koszyki, sprężyny zanętowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maty karpiowe",
    "categoryPath": [
      "(307441) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(307441) Sport i turystyka / Wędkarstwo / Akcesoria / Maty karpiowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Namioty, parasole wędkarskie",
    "categoryPath": [
      "(123484) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(123484) Sport i turystyka / Wędkarstwo / Akcesoria / Namioty, parasole wędkarskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Noże, skrobaki",
    "categoryPath": [
      "(123486) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(123486) Sport i turystyka / Wędkarstwo / Akcesoria / Noże, skrobaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podbieraki, osęki, siatki",
    "categoryPath": [
      "(121733) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(121733) Sport i turystyka / Wędkarstwo / Akcesoria / Podbieraki, osęki, siatki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podpórki",
    "categoryPath": [
      "(121734) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(121734) Sport i turystyka / Wędkarstwo / Akcesoria / Podpórki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121737) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(121737) Sport i turystyka / Wędkarstwo / Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przelotki",
    "categoryPath": [
      "(132184) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(132184) Sport i turystyka / Wędkarstwo / Akcesoria / Przelotki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Przypony",
    "categoryPath": [
      "(132185) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(132185) Sport i turystyka / Wędkarstwo / Akcesoria / Przypony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rzepy",
    "categoryPath": [
      "(322135) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(322135) Sport i turystyka / Wędkarstwo / Akcesoria / Rzepy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sprzęt do nęcenia",
    "categoryPath": [
      "(309553) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(309553) Sport i turystyka / Wędkarstwo / Akcesoria / Sprzęt do nęcenia",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Spławiki, dyski",
    "categoryPath": [
      "(132186) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(132186) Sport i turystyka / Wędkarstwo / Akcesoria / Spławiki, dyski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stopery",
    "categoryPath": [
      "(125747) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(125747) Sport i turystyka / Wędkarstwo / Akcesoria / Stopery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Systemy antysplątaniowe",
    "categoryPath": [
      "(319935) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(319935) Sport i turystyka / Wędkarstwo / Akcesoria / Systemy antysplątaniowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczypce",
    "categoryPath": [
      "(125746) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(125746) Sport i turystyka / Wędkarstwo / Akcesoria / Szczypce",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szydła, wiertła, igły",
    "categoryPath": [
      "(319938) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(319938) Sport i turystyka / Wędkarstwo / Akcesoria / Szydła, wiertła, igły",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wagi, miarki",
    "categoryPath": [
      "(123487) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(123487) Sport i turystyka / Wędkarstwo / Akcesoria / Wagi, miarki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wiązarki do haczyków",
    "categoryPath": [
      "(319944) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(319944) Sport i turystyka / Wędkarstwo / Akcesoria / Wiązarki do haczyków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wypychacze do haczyków",
    "categoryPath": [
      "(319941) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(319941) Sport i turystyka / Wędkarstwo / Akcesoria / Wypychacze do haczyków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zwijadełka",
    "categoryPath": [
      "(317543) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(317543) Sport i turystyka / Wędkarstwo / Akcesoria / Zwijadełka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Świetliki",
    "categoryPath": [
      "(317901) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria"
    ],
    "hierarchy": "(317901) Sport i turystyka / Wędkarstwo / Akcesoria / Świetliki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Plecionki",
    "categoryPath": [
      "(121739) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria",
      "Żyłki i plecionki"
    ],
    "hierarchy": "(121739) Sport i turystyka / Wędkarstwo / Akcesoria / Żyłki i plecionki / Plecionki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121738) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria",
      "Żyłki i plecionki"
    ],
    "hierarchy": "(121738) Sport i turystyka / Wędkarstwo / Akcesoria / Żyłki i plecionki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Żyłki",
    "categoryPath": [
      "(121740) Sport i turystyka",
      "Wędkarstwo",
      "Akcesoria",
      "Żyłki i plecionki"
    ],
    "hierarchy": "(121740) Sport i turystyka / Wędkarstwo / Akcesoria / Żyłki i plecionki / Żyłki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Morskie",
    "categoryPath": [
      "(132189) Sport i turystyka",
      "Wędkarstwo",
      "Kołowrotki"
    ],
    "hierarchy": "(132189) Sport i turystyka / Wędkarstwo / Kołowrotki / Morskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Muchowe",
    "categoryPath": [
      "(132190) Sport i turystyka",
      "Wędkarstwo",
      "Kołowrotki"
    ],
    "hierarchy": "(132190) Sport i turystyka / Wędkarstwo / Kołowrotki / Muchowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Multiplikatory",
    "categoryPath": [
      "(132191) Sport i turystyka",
      "Wędkarstwo",
      "Kołowrotki"
    ],
    "hierarchy": "(132191) Sport i turystyka / Wędkarstwo / Kołowrotki / Multiplikatory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(132188) Sport i turystyka",
      "Wędkarstwo",
      "Kołowrotki"
    ],
    "hierarchy": "(132188) Sport i turystyka / Wędkarstwo / Kołowrotki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Z przednim hamulcem",
    "categoryPath": [
      "(132192) Sport i turystyka",
      "Wędkarstwo",
      "Kołowrotki"
    ],
    "hierarchy": "(132192) Sport i turystyka / Wędkarstwo / Kołowrotki / Z przednim hamulcem",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Z tylnym hamulcem",
    "categoryPath": [
      "(132193) Sport i turystyka",
      "Wędkarstwo",
      "Kołowrotki"
    ],
    "hierarchy": "(132193) Sport i turystyka / Wędkarstwo / Kołowrotki / Z tylnym hamulcem",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Z wolnym biegiem",
    "categoryPath": [
      "(132194) Sport i turystyka",
      "Wędkarstwo",
      "Kołowrotki"
    ],
    "hierarchy": "(132194) Sport i turystyka / Wędkarstwo / Kołowrotki / Z wolnym biegiem",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Krzesełka wędkarskie",
    "categoryPath": [
      "(121767) Sport i turystyka",
      "Wędkarstwo"
    ],
    "hierarchy": "(121767) Sport i turystyka / Wędkarstwo / Krzesełka wędkarskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Literatura wędkarska",
    "categoryPath": [
      "(121724) Sport i turystyka",
      "Wędkarstwo"
    ],
    "hierarchy": "(121724) Sport i turystyka / Wędkarstwo / Literatura wędkarska",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Obuwie",
    "categoryPath": [
      "(256136) Sport i turystyka",
      "Wędkarstwo"
    ],
    "hierarchy": "(256136) Sport i turystyka / Wędkarstwo / Obuwie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bluzy",
    "categoryPath": [
      "(261454) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(261454) Sport i turystyka / Wędkarstwo / Odzież / Bluzy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czapki i kapelusze",
    "categoryPath": [
      "(121779) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(121779) Sport i turystyka / Wędkarstwo / Odzież / Czapki i kapelusze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kamizelki",
    "categoryPath": [
      "(121778) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(121778) Sport i turystyka / Wędkarstwo / Odzież / Kamizelki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kombinezony i komplety",
    "categoryPath": [
      "(261457) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(261457) Sport i turystyka / Wędkarstwo / Odzież / Kombinezony i komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki",
    "categoryPath": [
      "(261455) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(261455) Sport i turystyka / Wędkarstwo / Odzież / Koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kurtki",
    "categoryPath": [
      "(261456) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(261456) Sport i turystyka / Wędkarstwo / Odzież / Kurtki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121777) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(121777) Sport i turystyka / Wędkarstwo / Odzież / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawiczki",
    "categoryPath": [
      "(261458) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(261458) Sport i turystyka / Wędkarstwo / Odzież / Rękawiczki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skarpety",
    "categoryPath": [
      "(307465) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(307465) Sport i turystyka / Wędkarstwo / Odzież / Skarpety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie",
    "categoryPath": [
      "(258960) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(258960) Sport i turystyka / Wędkarstwo / Odzież / Spodnie",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Wodery",
    "categoryPath": [
      "(121781) Sport i turystyka",
      "Wędkarstwo",
      "Odzież"
    ],
    "hierarchy": "(121781) Sport i turystyka / Wędkarstwo / Odzież / Wodery",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Okulary",
    "categoryPath": [
      "(261459) Sport i turystyka",
      "Wędkarstwo"
    ],
    "hierarchy": "(261459) Sport i turystyka / Wędkarstwo / Okulary",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121723) Sport i turystyka",
      "Wędkarstwo"
    ],
    "hierarchy": "(121723) Sport i turystyka / Wędkarstwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Naturalne",
    "categoryPath": [
      "(121770) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty"
    ],
    "hierarchy": "(121770) Sport i turystyka / Wędkarstwo / Przynęty / Naturalne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Błystki",
    "categoryPath": [
      "(121773) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(121773) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Błystki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Cykady",
    "categoryPath": [
      "(261010) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(261010) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Cykady",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gumy",
    "categoryPath": [
      "(121774) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(121774) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Gumy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Jaskółki",
    "categoryPath": [
      "(261009) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(261009) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Jaskółki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Koguty i mandule",
    "categoryPath": [
      "(261011) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(261011) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Koguty i mandule",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Kukurydza",
    "categoryPath": [
      "(321456) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(321456) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Kukurydza",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Mormyszki",
    "categoryPath": [
      "(132214) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(132214) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Mormyszki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Muchy",
    "categoryPath": [
      "(121775) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(121775) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Muchy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pilkery",
    "categoryPath": [
      "(132213) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(132213) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Pilkery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121772) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(121772) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przywieszki morskie",
    "categoryPath": [
      "(309061) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(309061) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Przywieszki morskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Rippery i kopyta",
    "categoryPath": [
      "(132215) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(132215) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Rippery i kopyta",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Robaki",
    "categoryPath": [
      "(321670) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(321670) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Robaki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Twistery",
    "categoryPath": [
      "(132216) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(132216) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Twistery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wertykalne",
    "categoryPath": [
      "(322272) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(322272) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Wertykalne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Wirujące ogonki",
    "categoryPath": [
      "(322014) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(322014) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Wirujące ogonki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Woblery",
    "categoryPath": [
      "(121776) Sport i turystyka",
      "Wędkarstwo",
      "Przynęty",
      "Sztuczne"
    ],
    "hierarchy": "(121776) Sport i turystyka / Wędkarstwo / Przynęty / Sztuczne / Woblery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(257793) Sport i turystyka",
      "Wędkarstwo",
      "Sprzęt elektroniczny"
    ],
    "hierarchy": "(257793) Sport i turystyka / Wędkarstwo / Sprzęt elektroniczny / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Echosondy",
    "categoryPath": [
      "(132209) Sport i turystyka",
      "Wędkarstwo",
      "Sprzęt elektroniczny"
    ],
    "hierarchy": "(132209) Sport i turystyka / Wędkarstwo / Sprzęt elektroniczny / Echosondy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Sygnalizatory brań",
    "categoryPath": [
      "(132210) Sport i turystyka",
      "Wędkarstwo",
      "Sprzęt elektroniczny"
    ],
    "hierarchy": "(132210) Sport i turystyka / Wędkarstwo / Sprzęt elektroniczny / Sygnalizatory brań",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Łodzie zanętowe",
    "categoryPath": [
      "(318165) Sport i turystyka",
      "Wędkarstwo",
      "Sprzęt elektroniczny"
    ],
    "hierarchy": "(318165) Sport i turystyka / Wędkarstwo / Sprzęt elektroniczny / Łodzie zanętowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pudełka i skrzynki",
    "categoryPath": [
      "(121768) Sport i turystyka",
      "Wędkarstwo",
      "Torby, pojemniki"
    ],
    "hierarchy": "(121768) Sport i turystyka / Wędkarstwo / Torby, pojemniki / Pudełka i skrzynki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Torby i pokrowce",
    "categoryPath": [
      "(121769) Sport i turystyka",
      "Wędkarstwo",
      "Torby, pojemniki"
    ],
    "hierarchy": "(121769) Sport i turystyka / Wędkarstwo / Torby, pojemniki / Torby i pokrowce",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Baty, tyczki",
    "categoryPath": [
      "(132197) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132197) Sport i turystyka / Wędkarstwo / Wędki / Baty, tyczki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Bolonki",
    "categoryPath": [
      "(132198) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132198) Sport i turystyka / Wędkarstwo / Wędki / Bolonki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Feedery, pickery",
    "categoryPath": [
      "(132200) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132200) Sport i turystyka / Wędkarstwo / Wędki / Feedery, pickery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Gruntowe",
    "categoryPath": [
      "(318786) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(318786) Sport i turystyka / Wędkarstwo / Wędki / Gruntowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Karpiowe",
    "categoryPath": [
      "(132201) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132201) Sport i turystyka / Wędkarstwo / Wędki / Karpiowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Matchowe",
    "categoryPath": [
      "(132203) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132203) Sport i turystyka / Wędkarstwo / Wędki / Matchowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Morskie",
    "categoryPath": [
      "(132202) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132202) Sport i turystyka / Wędkarstwo / Wędki / Morskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Muchowe",
    "categoryPath": [
      "(132204) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132204) Sport i turystyka / Wędkarstwo / Wędki / Muchowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Podlodowe",
    "categoryPath": [
      "(132199) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132199) Sport i turystyka / Wędkarstwo / Wędki / Podlodowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(132196) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132196) Sport i turystyka / Wędkarstwo / Wędki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spinningowe",
    "categoryPath": [
      "(132205) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132205) Sport i turystyka / Wędkarstwo / Wędki / Spinningowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Spławikowe",
    "categoryPath": [
      "(318792) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(318792) Sport i turystyka / Wędkarstwo / Wędki / Spławikowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Sumowe",
    "categoryPath": [
      "(318789) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(318789) Sport i turystyka / Wędkarstwo / Wędki / Sumowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Teleskopowe",
    "categoryPath": [
      "(132206) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132206) Sport i turystyka / Wędkarstwo / Wędki / Teleskopowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zestawy wędkarskie",
    "categoryPath": [
      "(132207) Sport i turystyka",
      "Wędkarstwo",
      "Wędki"
    ],
    "hierarchy": "(132207) Sport i turystyka / Wędkarstwo / Wędki / Zestawy wędkarskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Zanęty",
    "categoryPath": [
      "(121730) Sport i turystyka",
      "Wędkarstwo"
    ],
    "hierarchy": "(121730) Sport i turystyka / Wędkarstwo / Zanęty",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Łóżka wędkarskie",
    "categoryPath": [
      "(319881) Sport i turystyka",
      "Wędkarstwo"
    ],
    "hierarchy": "(319881) Sport i turystyka / Wędkarstwo / Łóżka wędkarskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D28"
  },
  {
    "segment": "Akwaria",
    "categoryPath": [
      "(28047) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwaria i zestawy"
    ],
    "hierarchy": "(28047) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwaria i zestawy / Akwaria",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kotniki i kojce",
    "categoryPath": [
      "(257449) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwaria i zestawy"
    ],
    "hierarchy": "(257449) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwaria i zestawy / Kotniki i kojce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maty i podstawki",
    "categoryPath": [
      "(90096) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwaria i zestawy"
    ],
    "hierarchy": "(90096) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwaria i zestawy / Maty i podstawki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(28048) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwaria i zestawy"
    ],
    "hierarchy": "(28048) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwaria i zestawy / Zestawy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koralowce i skały",
    "categoryPath": [
      "(257443) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwarystyka morska"
    ],
    "hierarchy": "(257443) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwarystyka morska / Koralowce i skały",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mierniki zasolenia",
    "categoryPath": [
      "(257444) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwarystyka morska"
    ],
    "hierarchy": "(257444) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwarystyka morska / Mierniki zasolenia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odpieniacze",
    "categoryPath": [
      "(257445) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwarystyka morska"
    ],
    "hierarchy": "(257445) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwarystyka morska / Odpieniacze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pompy cyrkulacyjne",
    "categoryPath": [
      "(257446) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwarystyka morska"
    ],
    "hierarchy": "(257446) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwarystyka morska / Pompy cyrkulacyjne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sól morska",
    "categoryPath": [
      "(257447) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwarystyka morska"
    ],
    "hierarchy": "(257447) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwarystyka morska / Sól morska",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(257448) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Akwarystyka morska"
    ],
    "hierarchy": "(257448) Supermarket / Artykuły dla zwierząt / Akwarystyka / Akwarystyka morska / Zestawy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nawozy",
    "categoryPath": [
      "(28051) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Chemia i nawozy"
    ],
    "hierarchy": "(28051) Supermarket / Artykuły dla zwierząt / Akwarystyka / Chemia i nawozy / Nawozy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Preparaty",
    "categoryPath": [
      "(28053) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Chemia i nawozy"
    ],
    "hierarchy": "(28053) Supermarket / Artykuły dla zwierząt / Akwarystyka / Chemia i nawozy / Preparaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Testy",
    "categoryPath": [
      "(28052) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Chemia i nawozy"
    ],
    "hierarchy": "(28052) Supermarket / Artykuły dla zwierząt / Akwarystyka / Chemia i nawozy / Testy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uzdatnianie wody",
    "categoryPath": [
      "(45945) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Chemia i nawozy"
    ],
    "hierarchy": "(45945) Supermarket / Artykuły dla zwierząt / Akwarystyka / Chemia i nawozy / Uzdatnianie wody",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Czyściki",
    "categoryPath": [
      "(257462) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Czyszczenie"
    ],
    "hierarchy": "(257462) Supermarket / Artykuły dla zwierząt / Akwarystyka / Czyszczenie / Czyściki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odmulacze",
    "categoryPath": [
      "(257463) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Czyszczenie"
    ],
    "hierarchy": "(257463) Supermarket / Artykuły dla zwierząt / Akwarystyka / Czyszczenie / Odmulacze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Siatki",
    "categoryPath": [
      "(320959) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Czyszczenie"
    ],
    "hierarchy": "(320959) Supermarket / Artykuły dla zwierząt / Akwarystyka / Czyszczenie / Siatki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skrobaki",
    "categoryPath": [
      "(257464) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Czyszczenie"
    ],
    "hierarchy": "(257464) Supermarket / Artykuły dla zwierząt / Akwarystyka / Czyszczenie / Skrobaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szczoteczki i gąbki",
    "categoryPath": [
      "(257465) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Czyszczenie"
    ],
    "hierarchy": "(257465) Supermarket / Artykuły dla zwierząt / Akwarystyka / Czyszczenie / Szczoteczki i gąbki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(257466) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Czyszczenie"
    ],
    "hierarchy": "(257466) Supermarket / Artykuły dla zwierząt / Akwarystyka / Czyszczenie / Węże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Fantazyjne",
    "categoryPath": [
      "(257488) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Dekoracje sztuczne"
    ],
    "hierarchy": "(257488) Supermarket / Artykuły dla zwierząt / Akwarystyka / Dekoracje sztuczne / Fantazyjne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kamienie",
    "categoryPath": [
      "(257489) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Dekoracje sztuczne"
    ],
    "hierarchy": "(257489) Supermarket / Artykuły dla zwierząt / Akwarystyka / Dekoracje sztuczne / Kamienie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Korzenie",
    "categoryPath": [
      "(257490) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Dekoracje sztuczne"
    ],
    "hierarchy": "(257490) Supermarket / Artykuły dla zwierząt / Akwarystyka / Dekoracje sztuczne / Korzenie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257492) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Dekoracje sztuczne"
    ],
    "hierarchy": "(257492) Supermarket / Artykuły dla zwierząt / Akwarystyka / Dekoracje sztuczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rośliny",
    "categoryPath": [
      "(257491) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Dekoracje sztuczne"
    ],
    "hierarchy": "(257491) Supermarket / Artykuły dla zwierząt / Akwarystyka / Dekoracje sztuczne / Rośliny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Części i akcesoria",
    "categoryPath": [
      "(257450) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Filtry"
    ],
    "hierarchy": "(257450) Supermarket / Artykuły dla zwierząt / Akwarystyka / Filtry / Części i akcesoria",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Filtry odwróconej osmozy",
    "categoryPath": [
      "(257452) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Filtry"
    ],
    "hierarchy": "(257452) Supermarket / Artykuły dla zwierząt / Akwarystyka / Filtry / Filtry odwróconej osmozy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sterylizatory UV",
    "categoryPath": [
      "(257451) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Filtry"
    ],
    "hierarchy": "(257451) Supermarket / Artykuły dla zwierząt / Akwarystyka / Filtry / Sterylizatory UV",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wewnętrzne",
    "categoryPath": [
      "(90099) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Filtry"
    ],
    "hierarchy": "(90099) Supermarket / Artykuły dla zwierząt / Akwarystyka / Filtry / Wewnętrzne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkłady",
    "categoryPath": [
      "(90101) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Filtry"
    ],
    "hierarchy": "(90101) Supermarket / Artykuły dla zwierząt / Akwarystyka / Filtry / Wkłady",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zewnętrzne",
    "categoryPath": [
      "(90100) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Filtry"
    ],
    "hierarchy": "(90100) Supermarket / Artykuły dla zwierząt / Akwarystyka / Filtry / Zewnętrzne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Opakowania oryginalne",
    "categoryPath": [
      "(68738) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Karmienie",
      "Dla krewetek"
    ],
    "hierarchy": "(68738) Supermarket / Artykuły dla zwierząt / Akwarystyka / Karmienie / Dla krewetek / Opakowania oryginalne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uzupełnienia",
    "categoryPath": [
      "(68739) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Karmienie",
      "Dla krewetek"
    ],
    "hierarchy": "(68739) Supermarket / Artykuły dla zwierząt / Akwarystyka / Karmienie / Dla krewetek / Uzupełnienia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Opakowania oryginalne",
    "categoryPath": [
      "(68740) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Karmienie",
      "Dla ryb"
    ],
    "hierarchy": "(68740) Supermarket / Artykuły dla zwierząt / Akwarystyka / Karmienie / Dla ryb / Opakowania oryginalne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uzupełnienia",
    "categoryPath": [
      "(68741) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Karmienie",
      "Dla ryb"
    ],
    "hierarchy": "(68741) Supermarket / Artykuły dla zwierząt / Akwarystyka / Karmienie / Dla ryb / Uzupełnienia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inne pokarmy",
    "categoryPath": [
      "(28054) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Karmienie"
    ],
    "hierarchy": "(28054) Supermarket / Artykuły dla zwierząt / Akwarystyka / Karmienie / Inne pokarmy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmniki",
    "categoryPath": [
      "(257473) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Karmienie"
    ],
    "hierarchy": "(257473) Supermarket / Artykuły dla zwierząt / Akwarystyka / Karmienie / Karmniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pokarm uniwersalny",
    "categoryPath": [
      "(257472) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Karmienie"
    ],
    "hierarchy": "(257472) Supermarket / Artykuły dla zwierząt / Akwarystyka / Karmienie / Pokarm uniwersalny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(322436) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka"
    ],
    "hierarchy": "(322436) Supermarket / Artykuły dla zwierząt / Akwarystyka / Kleje",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inne",
    "categoryPath": [
      "(257453) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Korzenie, kamienie i skały"
    ],
    "hierarchy": "(257453) Supermarket / Artykuły dla zwierząt / Akwarystyka / Korzenie, kamienie i skały / Inne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kamienie",
    "categoryPath": [
      "(257455) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Korzenie, kamienie i skały"
    ],
    "hierarchy": "(257455) Supermarket / Artykuły dla zwierząt / Akwarystyka / Korzenie, kamienie i skały / Kamienie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Korzenie",
    "categoryPath": [
      "(257454) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Korzenie, kamienie i skały"
    ],
    "hierarchy": "(257454) Supermarket / Artykuły dla zwierząt / Akwarystyka / Korzenie, kamienie i skały / Korzenie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Muszle",
    "categoryPath": [
      "(257529) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Korzenie, kamienie i skały"
    ],
    "hierarchy": "(257529) Supermarket / Artykuły dla zwierząt / Akwarystyka / Korzenie, kamienie i skały / Muszle",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skały",
    "categoryPath": [
      "(257456) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Korzenie, kamienie i skały"
    ],
    "hierarchy": "(257456) Supermarket / Artykuły dla zwierząt / Akwarystyka / Korzenie, kamienie i skały / Skały",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Części i akcesoria",
    "categoryPath": [
      "(257458) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Napowietrzanie"
    ],
    "hierarchy": "(257458) Supermarket / Artykuły dla zwierząt / Akwarystyka / Napowietrzanie / Części i akcesoria",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kamienie napowietrzające",
    "categoryPath": [
      "(315898) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Napowietrzanie"
    ],
    "hierarchy": "(315898) Supermarket / Artykuły dla zwierząt / Akwarystyka / Napowietrzanie / Kamienie napowietrzające",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pompki",
    "categoryPath": [
      "(257457) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Napowietrzanie"
    ],
    "hierarchy": "(257457) Supermarket / Artykuły dla zwierząt / Akwarystyka / Napowietrzanie / Pompki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(257459) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Napowietrzanie"
    ],
    "hierarchy": "(257459) Supermarket / Artykuły dla zwierząt / Akwarystyka / Napowietrzanie / Zestawy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Grzałki",
    "categoryPath": [
      "(257467) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Ogrzewanie i temperatura"
    ],
    "hierarchy": "(257467) Supermarket / Artykuły dla zwierząt / Akwarystyka / Ogrzewanie i temperatura / Grzałki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Termometry",
    "categoryPath": [
      "(257468) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Ogrzewanie i temperatura"
    ],
    "hierarchy": "(257468) Supermarket / Artykuły dla zwierząt / Akwarystyka / Ogrzewanie i temperatura / Termometry",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(90097) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka"
    ],
    "hierarchy": "(90097) Supermarket / Artykuły dla zwierząt / Akwarystyka / Oświetlenie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Piaski i żwiry",
    "categoryPath": [
      "(257469) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Podłoża"
    ],
    "hierarchy": "(257469) Supermarket / Artykuły dla zwierząt / Akwarystyka / Podłoża / Piaski i żwiry",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podłoża aktywne",
    "categoryPath": [
      "(257470) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Podłoża"
    ],
    "hierarchy": "(257470) Supermarket / Artykuły dla zwierząt / Akwarystyka / Podłoża / Podłoża aktywne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Substraty podżwirowe",
    "categoryPath": [
      "(257471) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Podłoża"
    ],
    "hierarchy": "(257471) Supermarket / Artykuły dla zwierząt / Akwarystyka / Podłoża / Substraty podżwirowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pokrywy",
    "categoryPath": [
      "(257486) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka"
    ],
    "hierarchy": "(257486) Supermarket / Artykuły dla zwierząt / Akwarystyka / Pokrywy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5341) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka"
    ],
    "hierarchy": "(5341) Supermarket / Artykuły dla zwierząt / Akwarystyka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Nożyczki",
    "categoryPath": [
      "(257475) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Rośliny i pielęgnacja",
      "Pielęgnacja"
    ],
    "hierarchy": "(257475) Supermarket / Artykuły dla zwierząt / Akwarystyka / Rośliny i pielęgnacja / Pielęgnacja / Nożyczki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pęsety",
    "categoryPath": [
      "(257476) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Rośliny i pielęgnacja",
      "Pielęgnacja"
    ],
    "hierarchy": "(257476) Supermarket / Artykuły dla zwierząt / Akwarystyka / Rośliny i pielęgnacja / Pielęgnacja / Pęsety",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szczypce",
    "categoryPath": [
      "(257477) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Rośliny i pielęgnacja",
      "Pielęgnacja"
    ],
    "hierarchy": "(257477) Supermarket / Artykuły dla zwierząt / Akwarystyka / Rośliny i pielęgnacja / Pielęgnacja / Szczypce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(257478) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Rośliny i pielęgnacja",
      "Pielęgnacja"
    ],
    "hierarchy": "(257478) Supermarket / Artykuły dla zwierząt / Akwarystyka / Rośliny i pielęgnacja / Pielęgnacja / Zestawy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rośliny",
    "categoryPath": [
      "(28057) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Rośliny i pielęgnacja"
    ],
    "hierarchy": "(28057) Supermarket / Artykuły dla zwierząt / Akwarystyka / Rośliny i pielęgnacja / Rośliny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szafki, stoliki i regały",
    "categoryPath": [
      "(28059) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka"
    ],
    "hierarchy": "(28059) Supermarket / Artykuły dla zwierząt / Akwarystyka / Szafki, stoliki i regały",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Butle",
    "categoryPath": [
      "(257481) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Technika CO2"
    ],
    "hierarchy": "(257481) Supermarket / Artykuły dla zwierząt / Akwarystyka / Technika CO2 / Butle",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dyfuzory",
    "categoryPath": [
      "(257482) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Technika CO2"
    ],
    "hierarchy": "(257482) Supermarket / Artykuły dla zwierząt / Akwarystyka / Technika CO2 / Dyfuzory",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Reduktory",
    "categoryPath": [
      "(257483) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Technika CO2"
    ],
    "hierarchy": "(257483) Supermarket / Artykuły dla zwierząt / Akwarystyka / Technika CO2 / Reduktory",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zawory",
    "categoryPath": [
      "(257484) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Technika CO2"
    ],
    "hierarchy": "(257484) Supermarket / Artykuły dla zwierząt / Akwarystyka / Technika CO2 / Zawory",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(257485) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Technika CO2"
    ],
    "hierarchy": "(257485) Supermarket / Artykuły dla zwierząt / Akwarystyka / Technika CO2 / Zestawy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tła",
    "categoryPath": [
      "(90105) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka"
    ],
    "hierarchy": "(90105) Supermarket / Artykuły dla zwierząt / Akwarystyka / Tła",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mięczaki",
    "categoryPath": [
      "(90176) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Zwierzęta akwariowe"
    ],
    "hierarchy": "(90176) Supermarket / Artykuły dla zwierząt / Akwarystyka / Zwierzęta akwariowe / Mięczaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ryby",
    "categoryPath": [
      "(90175) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Zwierzęta akwariowe"
    ],
    "hierarchy": "(90175) Supermarket / Artykuły dla zwierząt / Akwarystyka / Zwierzęta akwariowe / Ryby",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skorupiaki",
    "categoryPath": [
      "(90174) Supermarket",
      "Artykuły dla zwierząt",
      "Akwarystyka",
      "Zwierzęta akwariowe"
    ],
    "hierarchy": "(90174) Supermarket / Artykuły dla zwierząt / Akwarystyka / Zwierzęta akwariowe / Skorupiaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmy i przysmaki",
    "categoryPath": [
      "(90023) Supermarket",
      "Artykuły dla zwierząt",
      "Dla fretek"
    ],
    "hierarchy": "(90023) Supermarket / Artykuły dla zwierząt / Dla fretek / Karmy i przysmaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Klatki, kojce, transportery",
    "categoryPath": [
      "(90022) Supermarket",
      "Artykuły dla zwierząt",
      "Dla fretek"
    ],
    "hierarchy": "(90022) Supermarket / Artykuły dla zwierząt / Dla fretek / Klatki, kojce, transportery",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Legowiska i zabawki",
    "categoryPath": [
      "(90024) Supermarket",
      "Artykuły dla zwierząt",
      "Dla fretek"
    ],
    "hierarchy": "(90024) Supermarket / Artykuły dla zwierząt / Dla fretek / Legowiska i zabawki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gołębniki i wyposażenie",
    "categoryPath": [
      "(90034) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gołębi"
    ],
    "hierarchy": "(90034) Supermarket / Artykuły dla zwierząt / Dla gołębi / Gołębniki i wyposażenie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmy i preparaty",
    "categoryPath": [
      "(90035) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gołębi"
    ],
    "hierarchy": "(90035) Supermarket / Artykuły dla zwierząt / Dla gołębi / Karmy i preparaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obrączki",
    "categoryPath": [
      "(90036) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gołębi"
    ],
    "hierarchy": "(90036) Supermarket / Artykuły dla zwierząt / Dla gołębi / Obrączki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Domki i legowiska",
    "categoryPath": [
      "(90026) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(90026) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Domki i legowiska",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Higiena",
    "categoryPath": [
      "(261279) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(261279) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Higiena",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmy i przysmaki",
    "categoryPath": [
      "(90027) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(90027) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Karmy i przysmaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Klatki, akwaria, kojce",
    "categoryPath": [
      "(90028) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(90028) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Klatki, akwaria, kojce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Miski, poidła, karmniki",
    "categoryPath": [
      "(90029) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(90029) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Miski, poidła, karmniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Transportery i akcesoria spacerowe",
    "categoryPath": [
      "(90031) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(90031) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Transportery i akcesoria spacerowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Witaminy i preparaty",
    "categoryPath": [
      "(261278) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(261278) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Witaminy i preparaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zabawki",
    "categoryPath": [
      "(90032) Supermarket",
      "Artykuły dla zwierząt",
      "Dla gryzoni i królików"
    ],
    "hierarchy": "(90032) Supermarket / Artykuły dla zwierząt / Dla gryzoni i królików / Zabawki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Drapaki",
    "categoryPath": [
      "(90038) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90038) Supermarket / Artykuły dla zwierząt / Dla kotów / Drapaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Drzwiczki, klapki, tunele",
    "categoryPath": [
      "(260676) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(260676) Supermarket / Artykuły dla zwierząt / Dla kotów / Drzwiczki, klapki, tunele",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Identyfikatory",
    "categoryPath": [
      "(260674) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(260674) Supermarket / Artykuły dla zwierząt / Dla kotów / Identyfikatory",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mokra karma",
    "categoryPath": [
      "(90041) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów",
      "Karmy"
    ],
    "hierarchy": "(90041) Supermarket / Artykuły dla zwierząt / Dla kotów / Karmy / Mokra karma",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Sucha karma",
    "categoryPath": [
      "(90040) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów",
      "Karmy"
    ],
    "hierarchy": "(90040) Supermarket / Artykuły dla zwierząt / Dla kotów / Karmy / Sucha karma",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kuwety",
    "categoryPath": [
      "(90052) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90052) Supermarket / Artykuły dla zwierząt / Dla kotów / Kuwety",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Legowiska i budki",
    "categoryPath": [
      "(90045) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90045) Supermarket / Artykuły dla zwierząt / Dla kotów / Legowiska i budki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Miski",
    "categoryPath": [
      "(90046) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90046) Supermarket / Artykuły dla zwierząt / Dla kotów / Miski",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obcinaczki i nożyczki do pazurów",
    "categoryPath": [
      "(260675) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(260675) Supermarket / Artykuły dla zwierząt / Dla kotów / Obcinaczki i nożyczki do pazurów",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pojemniki na karmę",
    "categoryPath": [
      "(260683) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(260683) Supermarket / Artykuły dla zwierząt / Dla kotów / Pojemniki na karmę",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(90037) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90037) Supermarket / Artykuły dla zwierząt / Dla kotów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty",
    "categoryPath": [
      "(90049) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90049) Supermarket / Artykuły dla zwierząt / Dla kotów / Preparaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Produkty odkłaczające",
    "categoryPath": [
      "(260680) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(260680) Supermarket / Artykuły dla zwierząt / Dla kotów / Produkty odkłaczające",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Siatki i zabezpieczenia",
    "categoryPath": [
      "(260677) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(260677) Supermarket / Artykuły dla zwierząt / Dla kotów / Siatki i zabezpieczenia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Smakołyki",
    "categoryPath": [
      "(90042) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90042) Supermarket / Artykuły dla zwierząt / Dla kotów / Smakołyki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Szelki, smycze, obroże",
    "categoryPath": [
      "(90050) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90050) Supermarket / Artykuły dla zwierząt / Dla kotów / Szelki, smycze, obroże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Torby i transportery",
    "categoryPath": [
      "(90044) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90044) Supermarket / Artykuły dla zwierząt / Dla kotów / Torby i transportery",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zabawki",
    "categoryPath": [
      "(90043) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90043) Supermarket / Artykuły dla zwierząt / Dla kotów / Zabawki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żwirki",
    "categoryPath": [
      "(90051) Supermarket",
      "Artykuły dla zwierząt",
      "Dla kotów"
    ],
    "hierarchy": "(90051) Supermarket / Artykuły dla zwierząt / Dla kotów / Żwirki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria szkoleniowe",
    "categoryPath": [
      "(90056) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90056) Supermarket / Artykuły dla zwierząt / Dla psów / Akcesoria szkoleniowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Baseny",
    "categoryPath": [
      "(319980) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(319980) Supermarket / Artykuły dla zwierząt / Dla psów / Baseny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Budy",
    "categoryPath": [
      "(90058) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90058) Supermarket / Artykuły dla zwierząt / Dla psów / Budy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Grzebienie i szczotki",
    "categoryPath": [
      "(90077) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90077) Supermarket / Artykuły dla zwierząt / Dla psów / Grzebienie i szczotki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Higiena",
    "categoryPath": [
      "(257435) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(257435) Supermarket / Artykuły dla zwierząt / Dla psów / Higiena",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Identyfikatory, adresówki, lokalizatory",
    "categoryPath": [
      "(90057) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90057) Supermarket / Artykuły dla zwierząt / Dla psów / Identyfikatory, adresówki, lokalizatory",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kagańce",
    "categoryPath": [
      "(90059) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90059) Supermarket / Artykuły dla zwierząt / Dla psów / Kagańce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mokra karma",
    "categoryPath": [
      "(90062) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Karmy"
    ],
    "hierarchy": "(90062) Supermarket / Artykuły dla zwierząt / Dla psów / Karmy / Mokra karma",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Sucha karma",
    "categoryPath": [
      "(90061) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Karmy"
    ],
    "hierarchy": "(90061) Supermarket / Artykuły dla zwierząt / Dla psów / Karmy / Sucha karma",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Klatki i kojce",
    "categoryPath": [
      "(90068) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90068) Supermarket / Artykuły dla zwierząt / Dla psów / Klatki i kojce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kołnierze pooperacyjne",
    "categoryPath": [
      "(320956) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(320956) Supermarket / Artykuły dla zwierząt / Dla psów / Kołnierze pooperacyjne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Legowiska",
    "categoryPath": [
      "(90064) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90064) Supermarket / Artykuły dla zwierząt / Dla psów / Legowiska",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maszynki, trymery, nożyczki",
    "categoryPath": [
      "(90076) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90076) Supermarket / Artykuły dla zwierząt / Dla psów / Maszynki, trymery, nożyczki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Miski",
    "categoryPath": [
      "(90065) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90065) Supermarket / Artykuły dla zwierząt / Dla psów / Miski",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obroże",
    "categoryPath": [
      "(90070) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90070) Supermarket / Artykuły dla zwierząt / Dla psów / Obroże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pojemniki na karmę",
    "categoryPath": [
      "(260855) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(260855) Supermarket / Artykuły dla zwierząt / Dla psów / Pojemniki na karmę",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(90053) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90053) Supermarket / Artykuły dla zwierząt / Dla psów / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty",
    "categoryPath": [
      "(90078) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90078) Supermarket / Artykuły dla zwierząt / Dla psów / Preparaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Schody dla psów",
    "categoryPath": [
      "(302793) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(302793) Supermarket / Artykuły dla zwierząt / Dla psów / Schody dla psów",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Smakołyki",
    "categoryPath": [
      "(90063) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90063) Supermarket / Artykuły dla zwierząt / Dla psów / Smakołyki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Smycze",
    "categoryPath": [
      "(257556) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(257556) Supermarket / Artykuły dla zwierząt / Dla psów / Smycze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Spinki i kokardy",
    "categoryPath": [
      "(90055) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90055) Supermarket / Artykuły dla zwierząt / Dla psów / Spinki i kokardy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stoły i wanny groomerskie",
    "categoryPath": [
      "(320161) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(320161) Supermarket / Artykuły dla zwierząt / Dla psów / Stoły i wanny groomerskie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szelki",
    "categoryPath": [
      "(90074) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90074) Supermarket / Artykuły dla zwierząt / Dla psów / Szelki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Foteliki samochodowe",
    "categoryPath": [
      "(317697) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317697) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Foteliki samochodowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koszyki na rower",
    "categoryPath": [
      "(317700) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317700) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Koszyki na rower",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kratki i siatki do samochodu",
    "categoryPath": [
      "(317703) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317703) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Kratki i siatki do samochodu",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maty do samochodu",
    "categoryPath": [
      "(317706) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317706) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Maty do samochodu",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pasy bezpieczeństwa",
    "categoryPath": [
      "(317709) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317709) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Pasy bezpieczeństwa",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Plecaki",
    "categoryPath": [
      "(317712) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317712) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Plecaki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przyczepy rowerowe dla psa",
    "categoryPath": [
      "(317715) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317715) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Przyczepy rowerowe dla psa",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Torby",
    "categoryPath": [
      "(317718) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317718) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Torby",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Transportery",
    "categoryPath": [
      "(317721) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317721) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Transportery",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wózki",
    "categoryPath": [
      "(317724) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów",
      "Transportery, torby podróżne"
    ],
    "hierarchy": "(317724) Supermarket / Artykuły dla zwierząt / Dla psów / Transportery, torby podróżne / Wózki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ubranka",
    "categoryPath": [
      "(90054) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90054) Supermarket / Artykuły dla zwierząt / Dla psów / Ubranka",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zabawki",
    "categoryPath": [
      "(90069) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90069) Supermarket / Artykuły dla zwierząt / Dla psów / Zabawki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Środki na pasożyty",
    "categoryPath": [
      "(90079) Supermarket",
      "Artykuły dla zwierząt",
      "Dla psów"
    ],
    "hierarchy": "(90079) Supermarket / Artykuły dla zwierząt / Dla psów / Środki na pasożyty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Budki lęgowe",
    "categoryPath": [
      "(90081) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(90081) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Budki lęgowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Higiena",
    "categoryPath": [
      "(261827) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(261827) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Higiena",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karmy i smakołyki",
    "categoryPath": [
      "(90086) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(90086) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Karmy i smakołyki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Klatki i woliery",
    "categoryPath": [
      "(90083) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(90083) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Klatki i woliery",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Miski i poidła",
    "categoryPath": [
      "(90085) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(90085) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Miski i poidła",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obrączki",
    "categoryPath": [
      "(90082) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(90082) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Obrączki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podłoża",
    "categoryPath": [
      "(90084) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(90084) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Podłoża",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Witaminy i preparaty",
    "categoryPath": [
      "(261828) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(261828) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Witaminy i preparaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zabawki i baseny",
    "categoryPath": [
      "(90087) Supermarket",
      "Artykuły dla zwierząt",
      "Dla ptaków egzotycznych"
    ],
    "hierarchy": "(90087) Supermarket / Artykuły dla zwierząt / Dla ptaków egzotycznych / Zabawki i baseny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gadżety zoologiczne",
    "categoryPath": [
      "(90019) Supermarket",
      "Artykuły dla zwierząt"
    ],
    "hierarchy": "(90019) Supermarket / Artykuły dla zwierząt / Gadżety zoologiczne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Leki weterynaryjne bez recepty",
    "categoryPath": [
      "(321823) Supermarket",
      "Artykuły dla zwierząt"
    ],
    "hierarchy": "(321823) Supermarket / Artykuły dla zwierząt / Leki weterynaryjne bez recepty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(972) Supermarket",
      "Artykuły dla zwierząt"
    ],
    "hierarchy": "(972) Supermarket / Artykuły dla zwierząt / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Suplementy dla psów i kotów",
    "categoryPath": [
      "(90193) Supermarket",
      "Artykuły dla zwierząt"
    ],
    "hierarchy": "(90193) Supermarket / Artykuły dla zwierząt / Suplementy dla psów i kotów",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szampony i odżywki dla psów i kotów",
    "categoryPath": [
      "(90075) Supermarket",
      "Artykuły dla zwierząt"
    ],
    "hierarchy": "(90075) Supermarket / Artykuły dla zwierząt / Szampony i odżywki dla psów i kotów",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pokarmy",
    "categoryPath": [
      "(28110) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka"
    ],
    "hierarchy": "(28110) Supermarket / Artykuły dla zwierząt / Terrarystyka / Pokarmy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ogrzewanie i temperatura",
    "categoryPath": [
      "(28088) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie"
    ],
    "hierarchy": "(28088) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Ogrzewanie i temperatura",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oświetlenie",
    "categoryPath": [
      "(28087) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie"
    ],
    "hierarchy": "(28087) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Oświetlenie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podłoża, tła i ozdoby",
    "categoryPath": [
      "(28086) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie"
    ],
    "hierarchy": "(28086) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Podłoża, tła i ozdoby",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28082) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie"
    ],
    "hierarchy": "(28082) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyrządy pomiarowe",
    "categoryPath": [
      "(28085) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie"
    ],
    "hierarchy": "(28085) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Przyrządy pomiarowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sztuczne",
    "categoryPath": [
      "(28089) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie",
      "Rośliny"
    ],
    "hierarchy": "(28089) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Rośliny / Sztuczne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żywe",
    "categoryPath": [
      "(28090) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie",
      "Rośliny"
    ],
    "hierarchy": "(28090) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Rośliny / Żywe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Terraria",
    "categoryPath": [
      "(28083) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Terraria i wyposażenie"
    ],
    "hierarchy": "(28083) Supermarket / Artykuły dla zwierząt / Terrarystyka / Terraria i wyposażenie / Terraria",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Jaszczurki",
    "categoryPath": [
      "(28098) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Zwierzęta terrariowe",
      "Gady"
    ],
    "hierarchy": "(28098) Supermarket / Artykuły dla zwierząt / Terrarystyka / Zwierzęta terrariowe / Gady / Jaszczurki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(28100) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Zwierzęta terrariowe",
      "Gady"
    ],
    "hierarchy": "(28100) Supermarket / Artykuły dla zwierząt / Terrarystyka / Zwierzęta terrariowe / Gady / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Węże",
    "categoryPath": [
      "(28099) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Zwierzęta terrariowe",
      "Gady"
    ],
    "hierarchy": "(28099) Supermarket / Artykuły dla zwierząt / Terrarystyka / Zwierzęta terrariowe / Gady / Węże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Owady",
    "categoryPath": [
      "(28095) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Zwierzęta terrariowe"
    ],
    "hierarchy": "(28095) Supermarket / Artykuły dla zwierząt / Terrarystyka / Zwierzęta terrariowe / Owady",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pająki",
    "categoryPath": [
      "(28092) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Zwierzęta terrariowe",
      "Pajęczaki"
    ],
    "hierarchy": "(28092) Supermarket / Artykuły dla zwierząt / Terrarystyka / Zwierzęta terrariowe / Pajęczaki / Pająki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zwierzęta karmowe",
    "categoryPath": [
      "(28096) Supermarket",
      "Artykuły dla zwierząt",
      "Terrarystyka",
      "Zwierzęta terrariowe"
    ],
    "hierarchy": "(28096) Supermarket / Artykuły dla zwierząt / Terrarystyka / Zwierzęta terrariowe / Zwierzęta karmowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kandyzowane owoce",
    "categoryPath": [
      "(261228) Supermarket",
      "Produkty spożywcze",
      "Bakalie, orzechy, pestki"
    ],
    "hierarchy": "(261228) Supermarket / Produkty spożywcze / Bakalie, orzechy, pestki / Kandyzowane owoce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mieszanki bakaliowe",
    "categoryPath": [
      "(261229) Supermarket",
      "Produkty spożywcze",
      "Bakalie, orzechy, pestki"
    ],
    "hierarchy": "(261229) Supermarket / Produkty spożywcze / Bakalie, orzechy, pestki / Mieszanki bakaliowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nasiona, ziarna, pestki",
    "categoryPath": [
      "(112645) Supermarket",
      "Produkty spożywcze",
      "Bakalie, orzechy, pestki"
    ],
    "hierarchy": "(112645) Supermarket / Produkty spożywcze / Bakalie, orzechy, pestki / Nasiona, ziarna, pestki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Orzechy",
    "categoryPath": [
      "(261230) Supermarket",
      "Produkty spożywcze",
      "Bakalie, orzechy, pestki"
    ],
    "hierarchy": "(261230) Supermarket / Produkty spożywcze / Bakalie, orzechy, pestki / Orzechy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112646) Supermarket",
      "Produkty spożywcze",
      "Bakalie, orzechy, pestki"
    ],
    "hierarchy": "(112646) Supermarket / Produkty spożywcze / Bakalie, orzechy, pestki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Suszone owoce",
    "categoryPath": [
      "(261227) Supermarket",
      "Produkty spożywcze",
      "Bakalie, orzechy, pestki"
    ],
    "hierarchy": "(261227) Supermarket / Produkty spożywcze / Bakalie, orzechy, pestki / Suszone owoce",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Cukier",
    "categoryPath": [
      "(111089) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(111089) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Cukier",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Erytrol",
    "categoryPath": [
      "(261704) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(261704) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Erytrol",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Fruktoza i glukoza",
    "categoryPath": [
      "(261705) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(261705) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Fruktoza i glukoza",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ksylitol",
    "categoryPath": [
      "(111090) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(111090) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Ksylitol",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Melasa, słód, syropy słodzące",
    "categoryPath": [
      "(261706) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(261706) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Melasa, słód, syropy słodzące",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(111091) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(111091) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stewia",
    "categoryPath": [
      "(261707) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(261707) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Stewia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sukraloza",
    "categoryPath": [
      "(261708) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(261708) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Sukraloza",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Syrop klonowy",
    "categoryPath": [
      "(307537) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(307537) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Syrop klonowy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Syrop z agawy",
    "categoryPath": [
      "(261709) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(261709) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Syrop z agawy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Słodziki",
    "categoryPath": [
      "(261710) Supermarket",
      "Produkty spożywcze",
      "Cukier i substancje słodzące"
    ],
    "hierarchy": "(261710) Supermarket / Produkty spożywcze / Cukier i substancje słodzące / Słodziki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ciasta",
    "categoryPath": [
      "(112613) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(112613) Supermarket / Produkty spożywcze / Dania gotowe / Ciasta",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dania mięsne",
    "categoryPath": [
      "(112615) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(112615) Supermarket / Produkty spożywcze / Dania gotowe / Dania mięsne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dania warzywne",
    "categoryPath": [
      "(112616) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(112616) Supermarket / Produkty spożywcze / Dania gotowe / Dania warzywne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dania śniadaniowe",
    "categoryPath": [
      "(261180) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(261180) Supermarket / Produkty spożywcze / Dania gotowe / Dania śniadaniowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dodatki do dań gotowych",
    "categoryPath": [
      "(261179) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(261179) Supermarket / Produkty spożywcze / Dania gotowe / Dodatki do dań gotowych",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Makarony, kluski, pierogi",
    "categoryPath": [
      "(112614) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(112614) Supermarket / Produkty spożywcze / Dania gotowe / Makarony, kluski, pierogi",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112617) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(112617) Supermarket / Produkty spożywcze / Dania gotowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sałatki",
    "categoryPath": [
      "(261181) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(261181) Supermarket / Produkty spożywcze / Dania gotowe / Sałatki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zupy",
    "categoryPath": [
      "(112612) Supermarket",
      "Produkty spożywcze",
      "Dania gotowe"
    ],
    "hierarchy": "(112612) Supermarket / Produkty spożywcze / Dania gotowe / Zupy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Formy silikonowe",
    "categoryPath": [
      "(320861) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320861) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Formy silikonowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(320888) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320888) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Noże cukiernicze",
    "categoryPath": [
      "(320867) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320867) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Noże cukiernicze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Patyczki",
    "categoryPath": [
      "(320873) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320873) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Patyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rękawy cukiernicze",
    "categoryPath": [
      "(320876) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320876) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Rękawy cukiernicze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stempelki",
    "categoryPath": [
      "(320879) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320879) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Stempelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szablony do dekoracji",
    "categoryPath": [
      "(320882) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320882) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Szablony do dekoracji",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szpatułki cukiernicze",
    "categoryPath": [
      "(320870) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320870) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Szpatułki cukiernicze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Toppery",
    "categoryPath": [
      "(320885) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320885) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Toppery",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tylki, końcówki do rękawów",
    "categoryPath": [
      "(320864) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia",
      "Akcesoria"
    ],
    "hierarchy": "(320864) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Akcesoria / Tylki, końcówki do rękawów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Aromaty",
    "categoryPath": [
      "(111073) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(111073) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Aromaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Barwniki",
    "categoryPath": [
      "(111074) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(111074) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Barwniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ciasta w proszku",
    "categoryPath": [
      "(260977) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(260977) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Ciasta w proszku",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dekoracje tortów i ciast",
    "categoryPath": [
      "(111075) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(111075) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Dekoracje tortów i ciast",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Drożdże",
    "categoryPath": [
      "(308485) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(308485) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Drożdże",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kremy i masy do ciast",
    "categoryPath": [
      "(260976) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(260976) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Kremy i masy do ciast",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podkładki pod tort i monoporcje",
    "categoryPath": [
      "(318331) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(318331) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Podkładki pod tort i monoporcje",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Polewy do ciast i deserów",
    "categoryPath": [
      "(260975) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(260975) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Polewy do ciast i deserów",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(111077) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(111077) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyprawy do ciast",
    "categoryPath": [
      "(260974) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(260974) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Przyprawy do ciast",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Spody do ciast, babeczek i wafle",
    "categoryPath": [
      "(260973) Supermarket",
      "Produkty spożywcze",
      "Dekoracje cukiernicze i produkty do pieczenia"
    ],
    "hierarchy": "(260973) Supermarket / Produkty spożywcze / Dekoracje cukiernicze i produkty do pieczenia / Spody do ciast, babeczek i wafle",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Herbata dla diabetyków",
    "categoryPath": [
      "(261184) Supermarket",
      "Produkty spożywcze",
      "Dla diabetyków"
    ],
    "hierarchy": "(261184) Supermarket / Produkty spożywcze / Dla diabetyków / Herbata dla diabetyków",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Napoje dla diabetyków",
    "categoryPath": [
      "(261185) Supermarket",
      "Produkty spożywcze",
      "Dla diabetyków"
    ],
    "hierarchy": "(261185) Supermarket / Produkty spożywcze / Dla diabetyków / Napoje dla diabetyków",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261182) Supermarket",
      "Produkty spożywcze",
      "Dla diabetyków"
    ],
    "hierarchy": "(261182) Supermarket / Produkty spożywcze / Dla diabetyków / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Słodycze dla diabetyków",
    "categoryPath": [
      "(261183) Supermarket",
      "Produkty spożywcze",
      "Dla diabetyków"
    ],
    "hierarchy": "(261183) Supermarket / Produkty spożywcze / Dla diabetyków / Słodycze dla diabetyków",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Inne dodatki spożywcze",
    "categoryPath": [
      "(320458) Supermarket",
      "Produkty spożywcze",
      "Dodatki spożywcze"
    ],
    "hierarchy": "(320458) Supermarket / Produkty spożywcze / Dodatki spożywcze / Inne dodatki spożywcze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Substancje żelujące i zagęstniki",
    "categoryPath": [
      "(320455) Supermarket",
      "Produkty spożywcze",
      "Dodatki spożywcze"
    ],
    "hierarchy": "(320455) Supermarket / Produkty spożywcze / Dodatki spożywcze / Substancje żelujące i zagęstniki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(74834) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74834) Supermarket / Produkty spożywcze / Herbata i napary / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chai",
    "categoryPath": [
      "(261203) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(261203) Supermarket / Produkty spożywcze / Herbata i napary / Chai",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata biała",
    "categoryPath": [
      "(74039) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74039) Supermarket / Produkty spożywcze / Herbata i napary / Herbata biała",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata czarna",
    "categoryPath": [
      "(74040) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74040) Supermarket / Produkty spożywcze / Herbata i napary / Herbata czarna",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata czerwona",
    "categoryPath": [
      "(74041) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74041) Supermarket / Produkty spożywcze / Herbata i napary / Herbata czerwona",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata mieszana",
    "categoryPath": [
      "(74042) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74042) Supermarket / Produkty spożywcze / Herbata i napary / Herbata mieszana",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata oolong",
    "categoryPath": [
      "(251904) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(251904) Supermarket / Produkty spożywcze / Herbata i napary / Herbata oolong",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata owocowa",
    "categoryPath": [
      "(74043) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74043) Supermarket / Produkty spożywcze / Herbata i napary / Herbata owocowa",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata zielona",
    "categoryPath": [
      "(74044) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74044) Supermarket / Produkty spożywcze / Herbata i napary / Herbata zielona",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata ziołowa",
    "categoryPath": [
      "(74045) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74045) Supermarket / Produkty spożywcze / Herbata i napary / Herbata ziołowa",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Herbata żółta",
    "categoryPath": [
      "(251903) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(251903) Supermarket / Produkty spożywcze / Herbata i napary / Herbata żółta",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Matcha",
    "categoryPath": [
      "(261204) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(261204) Supermarket / Produkty spożywcze / Herbata i napary / Matcha",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Napoje herbaciane",
    "categoryPath": [
      "(261205) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(261205) Supermarket / Produkty spożywcze / Herbata i napary / Napoje herbaciane",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74046) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(74046) Supermarket / Produkty spożywcze / Herbata i napary / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rooibos",
    "categoryPath": [
      "(251905) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(251905) Supermarket / Produkty spożywcze / Herbata i napary / Rooibos",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Zestawy herbat",
    "categoryPath": [
      "(261206) Supermarket",
      "Produkty spożywcze",
      "Herbata i napary"
    ],
    "hierarchy": "(261206) Supermarket / Produkty spożywcze / Herbata i napary / Zestawy herbat",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Czekolada do picia",
    "categoryPath": [
      "(261003) Supermarket",
      "Produkty spożywcze",
      "Kakao i czekolada do picia"
    ],
    "hierarchy": "(261003) Supermarket / Produkty spożywcze / Kakao i czekolada do picia / Czekolada do picia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kakao",
    "categoryPath": [
      "(261004) Supermarket",
      "Produkty spożywcze",
      "Kakao i czekolada do picia"
    ],
    "hierarchy": "(261004) Supermarket / Produkty spożywcze / Kakao i czekolada do picia / Kakao",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria i dodatki",
    "categoryPath": [
      "(125776) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(125776) Supermarket / Produkty spożywcze / Kawa / Akcesoria i dodatki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Cappuccino",
    "categoryPath": [
      "(74032) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(74032) Supermarket / Produkty spożywcze / Kawa / Cappuccino",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Cold brew (parzona na zimno)",
    "categoryPath": [
      "(261122) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(261122) Supermarket / Produkty spożywcze / Kawa / Cold brew (parzona na zimno)",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kapsułki do ekspresów",
    "categoryPath": [
      "(74824) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(74824) Supermarket / Produkty spożywcze / Kawa / Kapsułki do ekspresów",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kawa bezkofeinowa",
    "categoryPath": [
      "(261120) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(261120) Supermarket / Produkty spożywcze / Kawa / Kawa bezkofeinowa",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kawa mielona",
    "categoryPath": [
      "(74033) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(74033) Supermarket / Produkty spożywcze / Kawa / Kawa mielona",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kawa rozpuszczalna",
    "categoryPath": [
      "(74034) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(74034) Supermarket / Produkty spożywcze / Kawa / Kawa rozpuszczalna",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kawa w saszetkach",
    "categoryPath": [
      "(254546) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(254546) Supermarket / Produkty spożywcze / Kawa / Kawa w saszetkach",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kawa zbożowa",
    "categoryPath": [
      "(261121) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(261121) Supermarket / Produkty spożywcze / Kawa / Kawa zbożowa",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kawa ziarnista",
    "categoryPath": [
      "(74035) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(74035) Supermarket / Produkty spożywcze / Kawa / Kawa ziarnista",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kawa zielona",
    "categoryPath": [
      "(251906) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(251906) Supermarket / Produkty spożywcze / Kawa / Kawa zielona",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Napoje kawowe",
    "categoryPath": [
      "(261123) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(261123) Supermarket / Produkty spożywcze / Kawa / Napoje kawowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74037) Supermarket",
      "Produkty spożywcze",
      "Kawa"
    ],
    "hierarchy": "(74037) Supermarket / Produkty spożywcze / Kawa / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kuchnie świata",
    "categoryPath": [
      "(321613) Supermarket",
      "Produkty spożywcze"
    ],
    "hierarchy": "(321613) Supermarket / Produkty spożywcze / Kuchnie świata",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Miód i produkty pszczele",
    "categoryPath": [
      "(73976) Supermarket",
      "Produkty spożywcze"
    ],
    "hierarchy": "(73976) Supermarket / Produkty spożywcze / Miód i produkty pszczele",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Miód",
    "categoryPath": [
      "(260969) Supermarket",
      "Produkty spożywcze",
      "Miód i produkty pszczele"
    ],
    "hierarchy": "(260969) Supermarket / Produkty spożywcze / Miód i produkty pszczele / Miód",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Produkty pszczele",
    "categoryPath": [
      "(260970) Supermarket",
      "Produkty spożywcze",
      "Miód i produkty pszczele"
    ],
    "hierarchy": "(260970) Supermarket / Produkty spożywcze / Miód i produkty pszczele / Produkty pszczele",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Jelita i osłonki",
    "categoryPath": [
      "(261013) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny",
      "Akcesoria i dodatki"
    ],
    "hierarchy": "(261013) Supermarket / Produkty spożywcze / Mięso i wędliny / Akcesoria i dodatki / Jelita i osłonki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Nadziewarki",
    "categoryPath": [
      "(261014) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny",
      "Akcesoria i dodatki"
    ],
    "hierarchy": "(261014) Supermarket / Produkty spożywcze / Mięso i wędliny / Akcesoria i dodatki / Nadziewarki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Nici i siatki wędliniarskie",
    "categoryPath": [
      "(261015) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny",
      "Akcesoria i dodatki"
    ],
    "hierarchy": "(261015) Supermarket / Produkty spożywcze / Mięso i wędliny / Akcesoria i dodatki / Nici i siatki wędliniarskie",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261019) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny",
      "Akcesoria i dodatki"
    ],
    "hierarchy": "(261019) Supermarket / Produkty spożywcze / Mięso i wędliny / Akcesoria i dodatki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sól peklowa",
    "categoryPath": [
      "(261016) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny",
      "Akcesoria i dodatki"
    ],
    "hierarchy": "(261016) Supermarket / Produkty spożywcze / Mięso i wędliny / Akcesoria i dodatki / Sól peklowa",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Termometry",
    "categoryPath": [
      "(261018) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny",
      "Akcesoria i dodatki"
    ],
    "hierarchy": "(261018) Supermarket / Produkty spożywcze / Mięso i wędliny / Akcesoria i dodatki / Termometry",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Boczek i bekon",
    "categoryPath": [
      "(261020) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(261020) Supermarket / Produkty spożywcze / Mięso i wędliny / Boczek i bekon",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kiełbasy i parówki",
    "categoryPath": [
      "(261021) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(261021) Supermarket / Produkty spożywcze / Mięso i wędliny / Kiełbasy i parówki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Konserwy mięsne",
    "categoryPath": [
      "(261022) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(261022) Supermarket / Produkty spożywcze / Mięso i wędliny / Konserwy mięsne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Mięso świeże",
    "categoryPath": [
      "(261023) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(261023) Supermarket / Produkty spożywcze / Mięso i wędliny / Mięso świeże",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pasztety i metki",
    "categoryPath": [
      "(73998) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(73998) Supermarket / Produkty spożywcze / Mięso i wędliny / Pasztety i metki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74001) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(74001) Supermarket / Produkty spożywcze / Mięso i wędliny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Smalec i słonina",
    "categoryPath": [
      "(261024) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(261024) Supermarket / Produkty spożywcze / Mięso i wędliny / Smalec i słonina",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Suszona wołowina",
    "categoryPath": [
      "(307549) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(307549) Supermarket / Produkty spożywcze / Mięso i wędliny / Suszona wołowina",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Wędliny, szynki, polędwice",
    "categoryPath": [
      "(74000) Supermarket",
      "Produkty spożywcze",
      "Mięso i wędliny"
    ],
    "hierarchy": "(74000) Supermarket / Produkty spożywcze / Mięso i wędliny / Wędliny, szynki, polędwice",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Desery mleczne",
    "categoryPath": [
      "(261568) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(261568) Supermarket / Produkty spożywcze / Nabiał i jaja / Desery mleczne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Jaja",
    "categoryPath": [
      "(111079) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(111079) Supermarket / Produkty spożywcze / Nabiał i jaja / Jaja",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Jogurty",
    "categoryPath": [
      "(261567) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(261567) Supermarket / Produkty spożywcze / Nabiał i jaja / Jogurty",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kultury bakterii",
    "categoryPath": [
      "(261569) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(261569) Supermarket / Produkty spożywcze / Nabiał i jaja / Kultury bakterii",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Masło",
    "categoryPath": [
      "(111081) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(111081) Supermarket / Produkty spożywcze / Nabiał i jaja / Masło",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Mleko i napoje mleczne",
    "categoryPath": [
      "(111080) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(111080) Supermarket / Produkty spożywcze / Nabiał i jaja / Mleko i napoje mleczne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Podpuszczka i akcesoria serowarskie",
    "categoryPath": [
      "(111085) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(111085) Supermarket / Produkty spożywcze / Nabiał i jaja / Podpuszczka i akcesoria serowarskie",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(111086) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(111086) Supermarket / Produkty spożywcze / Nabiał i jaja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Białe i twarogowe",
    "categoryPath": [
      "(111084) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(111084) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Białe i twarogowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Inne sery",
    "categoryPath": [
      "(318501) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(318501) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Inne sery",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kozie i owcze",
    "categoryPath": [
      "(318492) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(318492) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Kozie i owcze",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pleśniowe",
    "categoryPath": [
      "(318489) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(318489) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Pleśniowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Sery do smarowania",
    "categoryPath": [
      "(318495) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(318495) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Sery do smarowania",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Sery smażone",
    "categoryPath": [
      "(318498) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(318498) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Sery smażone",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Twarde",
    "categoryPath": [
      "(318504) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(318504) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Twarde",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Żółte",
    "categoryPath": [
      "(111083) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja",
      "Sery"
    ],
    "hierarchy": "(111083) Supermarket / Produkty spożywcze / Nabiał i jaja / Sery / Żółte",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Śmietana i śmietanki",
    "categoryPath": [
      "(261566) Supermarket",
      "Produkty spożywcze",
      "Nabiał i jaja"
    ],
    "hierarchy": "(261566) Supermarket / Produkty spożywcze / Nabiał i jaja / Śmietana i śmietanki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(112630) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(112630) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Dodatki do alkoholu i zaprawki",
    "categoryPath": [
      "(112632) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(112632) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Dodatki do alkoholu i zaprawki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Napoje energetyczne",
    "categoryPath": [
      "(322932) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(322932) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Napoje energetyczne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Napoje funkcjonalne",
    "categoryPath": [
      "(261591) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(261591) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Napoje funkcjonalne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Napoje gazowane",
    "categoryPath": [
      "(112633) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(112633) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Napoje gazowane",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Napoje w proszku",
    "categoryPath": [
      "(112634) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(112634) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Napoje w proszku",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112638) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(112638) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Soki i nektary",
    "categoryPath": [
      "(112635) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(112635) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Soki i nektary",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Syropy i koncentraty",
    "categoryPath": [
      "(112636) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(112636) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Syropy i koncentraty",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Woda",
    "categoryPath": [
      "(261592) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(261592) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Woda",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Woda kokosowa",
    "categoryPath": [
      "(309085) Supermarket",
      "Produkty spożywcze",
      "Napoje i Akcesoria"
    ],
    "hierarchy": "(309085) Supermarket / Produkty spożywcze / Napoje i Akcesoria / Woda kokosowa",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Ocet",
    "categoryPath": [
      "(261676) Supermarket",
      "Produkty spożywcze",
      "Oliwa, olej, ocet"
    ],
    "hierarchy": "(261676) Supermarket / Produkty spożywcze / Oliwa, olej, ocet / Ocet",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Olej",
    "categoryPath": [
      "(261675) Supermarket",
      "Produkty spożywcze",
      "Oliwa, olej, ocet"
    ],
    "hierarchy": "(261675) Supermarket / Produkty spożywcze / Oliwa, olej, ocet / Olej",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oliwa",
    "categoryPath": [
      "(261674) Supermarket",
      "Produkty spożywcze",
      "Oliwa, olej, ocet"
    ],
    "hierarchy": "(261674) Supermarket / Produkty spożywcze / Oliwa, olej, ocet / Oliwa",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bułki",
    "categoryPath": [
      "(319568) Supermarket",
      "Produkty spożywcze",
      "Pieczywo"
    ],
    "hierarchy": "(319568) Supermarket / Produkty spożywcze / Pieczywo / Bułki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Chleby",
    "categoryPath": [
      "(319565) Supermarket",
      "Produkty spożywcze",
      "Pieczywo"
    ],
    "hierarchy": "(319565) Supermarket / Produkty spożywcze / Pieczywo / Chleby",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Inne pieczywo",
    "categoryPath": [
      "(319574) Supermarket",
      "Produkty spożywcze",
      "Pieczywo"
    ],
    "hierarchy": "(319574) Supermarket / Produkty spożywcze / Pieczywo / Inne pieczywo",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pieczywo chrupkie",
    "categoryPath": [
      "(319571) Supermarket",
      "Produkty spożywcze",
      "Pieczywo"
    ],
    "hierarchy": "(319571) Supermarket / Produkty spożywcze / Pieczywo / Pieczywo chrupkie",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Dania gotowe",
    "categoryPath": [
      "(261419) Supermarket",
      "Produkty spożywcze",
      "Produkty bezglutenowe"
    ],
    "hierarchy": "(261419) Supermarket / Produkty spożywcze / Produkty bezglutenowe / Dania gotowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Napoje",
    "categoryPath": [
      "(261418) Supermarket",
      "Produkty spożywcze",
      "Produkty bezglutenowe"
    ],
    "hierarchy": "(261418) Supermarket / Produkty spożywcze / Produkty bezglutenowe / Napoje",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pieczywo bezglutenowe",
    "categoryPath": [
      "(261421) Supermarket",
      "Produkty spożywcze",
      "Produkty bezglutenowe"
    ],
    "hierarchy": "(261421) Supermarket / Produkty spożywcze / Produkty bezglutenowe / Pieczywo bezglutenowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261416) Supermarket",
      "Produkty spożywcze",
      "Produkty bezglutenowe"
    ],
    "hierarchy": "(261416) Supermarket / Produkty spożywcze / Produkty bezglutenowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Produkty sypkie",
    "categoryPath": [
      "(261417) Supermarket",
      "Produkty spożywcze",
      "Produkty bezglutenowe"
    ],
    "hierarchy": "(261417) Supermarket / Produkty spożywcze / Produkty bezglutenowe / Produkty sypkie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Słodycze i przekąski bezglutenowe",
    "categoryPath": [
      "(261420) Supermarket",
      "Produkty spożywcze",
      "Produkty bezglutenowe"
    ],
    "hierarchy": "(261420) Supermarket / Produkty spożywcze / Produkty bezglutenowe / Słodycze i przekąski bezglutenowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Granola",
    "categoryPath": [
      "(261713) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Artykuły śniadaniowe"
    ],
    "hierarchy": "(261713) Supermarket / Produkty spożywcze / Produkty sypkie / Artykuły śniadaniowe / Granola",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Musli",
    "categoryPath": [
      "(261711) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Artykuły śniadaniowe"
    ],
    "hierarchy": "(261711) Supermarket / Produkty spożywcze / Produkty sypkie / Artykuły śniadaniowe / Musli",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Otręby",
    "categoryPath": [
      "(261714) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Artykuły śniadaniowe"
    ],
    "hierarchy": "(261714) Supermarket / Produkty spożywcze / Produkty sypkie / Artykuły śniadaniowe / Otręby",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płatki",
    "categoryPath": [
      "(261712) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Artykuły śniadaniowe"
    ],
    "hierarchy": "(261712) Supermarket / Produkty spożywcze / Produkty sypkie / Artykuły śniadaniowe / Płatki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bułka tarta",
    "categoryPath": [
      "(261697) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie"
    ],
    "hierarchy": "(261697) Supermarket / Produkty spożywcze / Produkty sypkie / Bułka tarta",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kasza",
    "categoryPath": [
      "(111093) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie"
    ],
    "hierarchy": "(111093) Supermarket / Produkty spożywcze / Produkty sypkie / Kasza",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Makaron",
    "categoryPath": [
      "(111094) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie"
    ],
    "hierarchy": "(111094) Supermarket / Produkty spożywcze / Produkty sypkie / Makaron",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mąka i mieszanki chlebowe",
    "categoryPath": [
      "(111095) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie"
    ],
    "hierarchy": "(111095) Supermarket / Produkty spożywcze / Produkty sypkie / Mąka i mieszanki chlebowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(111097) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie"
    ],
    "hierarchy": "(111097) Supermarket / Produkty spożywcze / Produkty sypkie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Ciecierzyca",
    "categoryPath": [
      "(261702) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Rośliny strączkowe"
    ],
    "hierarchy": "(261702) Supermarket / Produkty spożywcze / Produkty sypkie / Rośliny strączkowe / Ciecierzyca",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Fasola",
    "categoryPath": [
      "(261699) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Rośliny strączkowe"
    ],
    "hierarchy": "(261699) Supermarket / Produkty spożywcze / Produkty sypkie / Rośliny strączkowe / Fasola",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Groch",
    "categoryPath": [
      "(261701) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Rośliny strączkowe"
    ],
    "hierarchy": "(261701) Supermarket / Produkty spożywcze / Produkty sypkie / Rośliny strączkowe / Groch",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Soczewica",
    "categoryPath": [
      "(261700) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Rośliny strączkowe"
    ],
    "hierarchy": "(261700) Supermarket / Produkty spożywcze / Produkty sypkie / Rośliny strączkowe / Soczewica",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Soja",
    "categoryPath": [
      "(261703) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie",
      "Rośliny strączkowe"
    ],
    "hierarchy": "(261703) Supermarket / Produkty spożywcze / Produkty sypkie / Rośliny strączkowe / Soja",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ryż",
    "categoryPath": [
      "(308293) Supermarket",
      "Produkty spożywcze",
      "Produkty sypkie"
    ],
    "hierarchy": "(308293) Supermarket / Produkty spożywcze / Produkty sypkie / Ryż",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dania gotowe",
    "categoryPath": [
      "(74070) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie"
    ],
    "hierarchy": "(74070) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Dania gotowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Napoje roślinne",
    "categoryPath": [
      "(261648) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie"
    ],
    "hierarchy": "(261648) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Napoje roślinne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pasty, smarowidła, zamienniki pasztetu",
    "categoryPath": [
      "(74071) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie"
    ],
    "hierarchy": "(74071) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Pasty, smarowidła, zamienniki pasztetu",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74072) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie"
    ],
    "hierarchy": "(74072) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261654) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne zamienniki nabiału"
    ],
    "hierarchy": "(261654) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne zamienniki nabiału / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tofu",
    "categoryPath": [
      "(261652) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne zamienniki nabiału"
    ],
    "hierarchy": "(261652) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne zamienniki nabiału / Tofu",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zamienniki jaj",
    "categoryPath": [
      "(261653) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne zamienniki nabiału"
    ],
    "hierarchy": "(261653) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne zamienniki nabiału / Zamienniki jaj",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zamienniki jogurtów, desery",
    "categoryPath": [
      "(261650) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne zamienniki nabiału"
    ],
    "hierarchy": "(261650) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne zamienniki nabiału / Zamienniki jogurtów, desery",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zamienniki serów i serków",
    "categoryPath": [
      "(261651) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne zamienniki nabiału"
    ],
    "hierarchy": "(261651) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne zamienniki nabiału / Zamienniki serów i serków",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Granulaty, krajanki",
    "categoryPath": [
      "(261655) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne źródła białka"
    ],
    "hierarchy": "(261655) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne źródła białka / Granulaty, krajanki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Owoc chlebowca (jackfruit)",
    "categoryPath": [
      "(261656) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne źródła białka"
    ],
    "hierarchy": "(261656) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne źródła białka / Owoc chlebowca (jackfruit)",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261659) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne źródła białka"
    ],
    "hierarchy": "(261659) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne źródła białka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Tempeh i seitan",
    "categoryPath": [
      "(261657) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne źródła białka"
    ],
    "hierarchy": "(261657) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne źródła białka / Tempeh i seitan",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zamienniki wędlin, kiełbasek, parówek",
    "categoryPath": [
      "(261658) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie",
      "Roślinne źródła białka"
    ],
    "hierarchy": "(261658) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Roślinne źródła białka / Zamienniki wędlin, kiełbasek, parówek",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Słodycze i przekąski",
    "categoryPath": [
      "(261647) Supermarket",
      "Produkty spożywcze",
      "Produkty wegetariańskie i wegańskie"
    ],
    "hierarchy": "(261647) Supermarket / Produkty spożywcze / Produkty wegetariańskie i wegańskie / Słodycze i przekąski",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261248) Supermarket",
      "Produkty spożywcze",
      "Przetwory"
    ],
    "hierarchy": "(261248) Supermarket / Produkty spożywcze / Przetwory / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Borówki i żurawiny",
    "categoryPath": [
      "(261234) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory owocowe"
    ],
    "hierarchy": "(261234) Supermarket / Produkty spożywcze / Przetwory / Przetwory owocowe / Borówki i żurawiny",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dżemy, konfitury, powidła",
    "categoryPath": [
      "(261233) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory owocowe"
    ],
    "hierarchy": "(261233) Supermarket / Produkty spożywcze / Przetwory / Przetwory owocowe / Dżemy, konfitury, powidła",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kompoty",
    "categoryPath": [
      "(261236) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory owocowe"
    ],
    "hierarchy": "(261236) Supermarket / Produkty spożywcze / Przetwory / Przetwory owocowe / Kompoty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Owoce w syropie",
    "categoryPath": [
      "(261235) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory owocowe"
    ],
    "hierarchy": "(261235) Supermarket / Produkty spożywcze / Przetwory / Przetwory owocowe / Owoce w syropie",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261275) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory owocowe"
    ],
    "hierarchy": "(261275) Supermarket / Produkty spożywcze / Przetwory / Przetwory owocowe / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przeciery i musy owocowe",
    "categoryPath": [
      "(261237) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory owocowe"
    ],
    "hierarchy": "(261237) Supermarket / Produkty spożywcze / Przetwory / Przetwory owocowe / Przeciery i musy owocowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Antipasti",
    "categoryPath": [
      "(261243) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261243) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Antipasti",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chutney",
    "categoryPath": [
      "(261244) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261244) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Chutney",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kiszonki",
    "categoryPath": [
      "(261247) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261247) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Kiszonki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koncentraty warzywne",
    "categoryPath": [
      "(261240) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261240) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Koncentraty warzywne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ogórki i pikle",
    "categoryPath": [
      "(261246) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261246) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Ogórki i pikle",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pasty i dipy",
    "categoryPath": [
      "(261242) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261242) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Pasty i dipy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pesto",
    "categoryPath": [
      "(261241) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261241) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Pesto",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przeciery warzywne",
    "categoryPath": [
      "(261276) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261276) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Przeciery warzywne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sosy do makaronów",
    "categoryPath": [
      "(261239) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261239) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Sosy do makaronów",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Warzywa marynowane",
    "categoryPath": [
      "(261245) Supermarket",
      "Produkty spożywcze",
      "Przetwory",
      "Przetwory warzywne"
    ],
    "hierarchy": "(261245) Supermarket / Produkty spożywcze / Przetwory / Przetwory warzywne / Warzywa marynowane",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kostki rosołowe, buliony",
    "categoryPath": [
      "(261159) Supermarket",
      "Produkty spożywcze",
      "Przyprawy i zioła"
    ],
    "hierarchy": "(261159) Supermarket / Produkty spożywcze / Przyprawy i zioła / Kostki rosołowe, buliony",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mieszanki przyprawowe",
    "categoryPath": [
      "(77747) Supermarket",
      "Produkty spożywcze",
      "Przyprawy i zioła"
    ],
    "hierarchy": "(77747) Supermarket / Produkty spożywcze / Przyprawy i zioła / Mieszanki przyprawowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Panierki i sypkie marynaty",
    "categoryPath": [
      "(77748) Supermarket",
      "Produkty spożywcze",
      "Przyprawy i zioła"
    ],
    "hierarchy": "(77748) Supermarket / Produkty spożywcze / Przyprawy i zioła / Panierki i sypkie marynaty",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pieprz",
    "categoryPath": [
      "(261160) Supermarket",
      "Produkty spożywcze",
      "Przyprawy i zioła"
    ],
    "hierarchy": "(261160) Supermarket / Produkty spożywcze / Przyprawy i zioła / Pieprz",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(77744) Supermarket",
      "Produkty spożywcze",
      "Przyprawy i zioła"
    ],
    "hierarchy": "(77744) Supermarket / Produkty spożywcze / Przyprawy i zioła / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyprawy jednoskładnikowe",
    "categoryPath": [
      "(77746) Supermarket",
      "Produkty spożywcze",
      "Przyprawy i zioła"
    ],
    "hierarchy": "(77746) Supermarket / Produkty spożywcze / Przyprawy i zioła / Przyprawy jednoskładnikowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sól",
    "categoryPath": [
      "(77745) Supermarket",
      "Produkty spożywcze",
      "Przyprawy i zioła"
    ],
    "hierarchy": "(77745) Supermarket / Produkty spożywcze / Przyprawy i zioła / Sól",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kawior",
    "categoryPath": [
      "(74003) Supermarket",
      "Produkty spożywcze",
      "Ryby i owoce morza"
    ],
    "hierarchy": "(74003) Supermarket / Produkty spożywcze / Ryby i owoce morza / Kawior",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Mięczaki i skorupiaki",
    "categoryPath": [
      "(74004) Supermarket",
      "Produkty spożywcze",
      "Ryby i owoce morza"
    ],
    "hierarchy": "(74004) Supermarket / Produkty spożywcze / Ryby i owoce morza / Mięczaki i skorupiaki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74007) Supermarket",
      "Produkty spożywcze",
      "Ryby i owoce morza"
    ],
    "hierarchy": "(74007) Supermarket / Produkty spożywcze / Ryby i owoce morza / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przetwory rybne",
    "categoryPath": [
      "(77742) Supermarket",
      "Produkty spożywcze",
      "Ryby i owoce morza",
      "Ryby"
    ],
    "hierarchy": "(77742) Supermarket / Produkty spożywcze / Ryby i owoce morza / Ryby / Przetwory rybne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Ryby wędzone",
    "categoryPath": [
      "(77741) Supermarket",
      "Produkty spożywcze",
      "Ryby i owoce morza",
      "Ryby"
    ],
    "hierarchy": "(77741) Supermarket / Produkty spożywcze / Ryby i owoce morza / Ryby / Ryby wędzone",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Ryby świeże",
    "categoryPath": [
      "(261154) Supermarket",
      "Produkty spożywcze",
      "Ryby i owoce morza",
      "Ryby"
    ],
    "hierarchy": "(261154) Supermarket / Produkty spożywcze / Ryby i owoce morza / Ryby / Ryby świeże",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Chrzany",
    "categoryPath": [
      "(261694) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(261694) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Chrzany",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dressingi",
    "categoryPath": [
      "(261695) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(261695) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Dressingi",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ketchupy",
    "categoryPath": [
      "(112621) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(112621) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Ketchupy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Majonezy",
    "categoryPath": [
      "(112623) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(112623) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Majonezy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Musztardy",
    "categoryPath": [
      "(112622) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(112622) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Musztardy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(112620) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(112620) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płynne marynaty do mięs",
    "categoryPath": [
      "(261696) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(261696) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Płynne marynaty do mięs",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sosy",
    "categoryPath": [
      "(112627) Supermarket",
      "Produkty spożywcze",
      "Sosy kanapkowe i dressingi"
    ],
    "hierarchy": "(112627) Supermarket / Produkty spożywcze / Sosy kanapkowe i dressingi / Sosy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Batony",
    "categoryPath": [
      "(74021) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(74021) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Batony",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Chałwa i sezamki",
    "categoryPath": [
      "(261431) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(261431) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Chałwa i sezamki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Biszkopty",
    "categoryPath": [
      "(261442) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Ciastka i ciasteczka"
    ],
    "hierarchy": "(261442) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Ciastka i ciasteczka / Biszkopty",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Ciastka kruche",
    "categoryPath": [
      "(261443) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Ciastka i ciasteczka"
    ],
    "hierarchy": "(261443) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Ciastka i ciasteczka / Ciastka kruche",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Markizy",
    "categoryPath": [
      "(261446) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Ciastka i ciasteczka"
    ],
    "hierarchy": "(261446) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Ciastka i ciasteczka / Markizy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pierniki",
    "categoryPath": [
      "(261444) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Ciastka i ciasteczka"
    ],
    "hierarchy": "(261444) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Ciastka i ciasteczka / Pierniki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261437) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Ciastka i ciasteczka"
    ],
    "hierarchy": "(261437) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Ciastka i ciasteczka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wafle",
    "categoryPath": [
      "(261445) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Ciastka i ciasteczka"
    ],
    "hierarchy": "(261445) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Ciastka i ciasteczka / Wafle",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Cukierki i draże",
    "categoryPath": [
      "(74018) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(74018) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Cukierki i draże",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Czekolady i czekoladki",
    "categoryPath": [
      "(74020) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(74020) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Czekolady i czekoladki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Bakalie w czekoladzie",
    "categoryPath": [
      "(319959) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Czekolady i czekoladki"
    ],
    "hierarchy": "(319959) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Czekolady i czekoladki / Bakalie w czekoladzie",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Czekoladki, bombonierki",
    "categoryPath": [
      "(261440) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Czekolady i czekoladki"
    ],
    "hierarchy": "(261440) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Czekolady i czekoladki / Czekoladki, bombonierki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Czekolady",
    "categoryPath": [
      "(261439) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Czekolady i czekoladki"
    ],
    "hierarchy": "(261439) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Czekolady i czekoladki / Czekolady",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Figurki i lizaki czekoladowe",
    "categoryPath": [
      "(309097) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Czekolady i czekoladki"
    ],
    "hierarchy": "(309097) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Czekolady i czekoladki / Figurki i lizaki czekoladowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261438) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Czekolady i czekoladki"
    ],
    "hierarchy": "(261438) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Czekolady i czekoladki / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Trufle",
    "categoryPath": [
      "(261441) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Czekolady i czekoladki"
    ],
    "hierarchy": "(261441) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Czekolady i czekoladki / Trufle",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Budyń",
    "categoryPath": [
      "(261434) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Desery"
    ],
    "hierarchy": "(261434) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Desery / Budyń",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Desery instant",
    "categoryPath": [
      "(319956) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Desery"
    ],
    "hierarchy": "(319956) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Desery / Desery instant",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Galaretki",
    "categoryPath": [
      "(261436) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Desery"
    ],
    "hierarchy": "(261436) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Desery / Galaretki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kisiel",
    "categoryPath": [
      "(261435) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Desery"
    ],
    "hierarchy": "(261435) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Desery / Kisiel",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Gumy do żucia",
    "categoryPath": [
      "(74019) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(74019) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Gumy do żucia",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kremy i smarowidła",
    "categoryPath": [
      "(74833) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(74833) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Kremy i smarowidła",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Lizaki",
    "categoryPath": [
      "(261479) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(261479) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Lizaki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74025) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(74025) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Chipsy, chrupki, nachosy",
    "categoryPath": [
      "(261448) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Słone i pikantne przekąski"
    ],
    "hierarchy": "(261448) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Słone i pikantne przekąski / Chipsy, chrupki, nachosy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Dipy",
    "categoryPath": [
      "(261449) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Słone i pikantne przekąski"
    ],
    "hierarchy": "(261449) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Słone i pikantne przekąski / Dipy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Krakersy",
    "categoryPath": [
      "(261450) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Słone i pikantne przekąski"
    ],
    "hierarchy": "(261450) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Słone i pikantne przekąski / Krakersy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Orzeszki",
    "categoryPath": [
      "(261451) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Słone i pikantne przekąski"
    ],
    "hierarchy": "(261451) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Słone i pikantne przekąski / Orzeszki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Paluszki i precelki",
    "categoryPath": [
      "(261452) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Słone i pikantne przekąski"
    ],
    "hierarchy": "(261452) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Słone i pikantne przekąski / Paluszki i precelki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Popcorn",
    "categoryPath": [
      "(261453) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Słone i pikantne przekąski"
    ],
    "hierarchy": "(261453) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Słone i pikantne przekąski / Popcorn",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261447) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery",
      "Słone i pikantne przekąski"
    ],
    "hierarchy": "(261447) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Słone i pikantne przekąski / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Toffi, krówki, karmelki",
    "categoryPath": [
      "(261432) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(261432) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Toffi, krówki, karmelki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Wafelki",
    "categoryPath": [
      "(321932) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(321932) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Wafelki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Żelki, galaretki, pianki",
    "categoryPath": [
      "(74023) Supermarket",
      "Produkty spożywcze",
      "Słodycze, przekąski, desery"
    ],
    "hierarchy": "(74023) Supermarket / Produkty spożywcze / Słodycze, przekąski, desery / Żelki, galaretki, pianki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Grzybnie",
    "categoryPath": [
      "(318528) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Grzyby"
    ],
    "hierarchy": "(318528) Supermarket / Produkty spożywcze / Warzywa i owoce / Grzyby / Grzybnie",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Inny rodzaj grzybów",
    "categoryPath": [
      "(318525) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Grzyby"
    ],
    "hierarchy": "(318525) Supermarket / Produkty spożywcze / Warzywa i owoce / Grzyby / Inny rodzaj grzybów",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Marynowane",
    "categoryPath": [
      "(318516) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Grzyby"
    ],
    "hierarchy": "(318516) Supermarket / Produkty spożywcze / Warzywa i owoce / Grzyby / Marynowane",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Suszone",
    "categoryPath": [
      "(318513) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Grzyby"
    ],
    "hierarchy": "(318513) Supermarket / Produkty spożywcze / Warzywa i owoce / Grzyby / Suszone",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Świeże",
    "categoryPath": [
      "(318510) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Grzyby"
    ],
    "hierarchy": "(318510) Supermarket / Produkty spożywcze / Warzywa i owoce / Grzyby / Świeże",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kwiaty i rośliny jadalne",
    "categoryPath": [
      "(260966) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce"
    ],
    "hierarchy": "(260966) Supermarket / Produkty spożywcze / Warzywa i owoce / Kwiaty i rośliny jadalne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260967) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce"
    ],
    "hierarchy": "(260967) Supermarket / Produkty spożywcze / Warzywa i owoce / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skrzynki z owocami i warzywami",
    "categoryPath": [
      "(318468) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce"
    ],
    "hierarchy": "(318468) Supermarket / Produkty spożywcze / Warzywa i owoce / Skrzynki z owocami i warzywami",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Ananasy i melony",
    "categoryPath": [
      "(318705) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318705) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Ananasy i melony",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Banany",
    "categoryPath": [
      "(318699) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318699) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Banany",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Brzoskwinie i morele",
    "categoryPath": [
      "(318717) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318717) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Brzoskwinie i morele",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Cytrusy",
    "categoryPath": [
      "(318696) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318696) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Cytrusy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Gruszki",
    "categoryPath": [
      "(318693) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318693) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Gruszki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Inne owoce",
    "categoryPath": [
      "(318726) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318726) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Inne owoce",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Jabłka",
    "categoryPath": [
      "(318690) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318690) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Jabłka",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Mango",
    "categoryPath": [
      "(318708) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318708) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Mango",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Owoce egzotyczne",
    "categoryPath": [
      "(318723) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318723) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Owoce egzotyczne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Owoce leśne",
    "categoryPath": [
      "(318720) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318720) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Owoce leśne",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Truskawki i maliny",
    "categoryPath": [
      "(318711) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318711) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Truskawki i maliny",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Wiśnie i czereśnie",
    "categoryPath": [
      "(318714) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318714) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Wiśnie i czereśnie",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Śliwki",
    "categoryPath": [
      "(318702) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże owoce"
    ],
    "hierarchy": "(318702) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże owoce / Śliwki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Brokuły i kalafiory",
    "categoryPath": [
      "(318681) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318681) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Brokuły i kalafiory",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Buraki",
    "categoryPath": [
      "(318657) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318657) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Buraki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Cebula",
    "categoryPath": [
      "(318660) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318660) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Cebula",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Czosnek",
    "categoryPath": [
      "(318663) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318663) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Czosnek",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Dynie, bakłażany i cukinie",
    "categoryPath": [
      "(318672) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318672) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Dynie, bakłażany i cukinie",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Fasola i rośliny strączkowe",
    "categoryPath": [
      "(318684) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318684) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Fasola i rośliny strączkowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Imbir i kurkuma",
    "categoryPath": [
      "(318666) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318666) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Imbir i kurkuma",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Inne warzywa",
    "categoryPath": [
      "(318687) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318687) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Inne warzywa",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Jarmuż i szpinak",
    "categoryPath": [
      "(318678) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318678) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Jarmuż i szpinak",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Kapusta",
    "categoryPath": [
      "(318669) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318669) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Kapusta",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Marchewka",
    "categoryPath": [
      "(318645) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318645) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Marchewka",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Ogórki",
    "categoryPath": [
      "(318636) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318636) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Ogórki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Papryki i papryczki",
    "categoryPath": [
      "(318642) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318642) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Papryki i papryczki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pietruszka",
    "categoryPath": [
      "(318648) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318648) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Pietruszka",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pomidory",
    "categoryPath": [
      "(318633) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318633) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Pomidory",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Rzodkiewki",
    "categoryPath": [
      "(318639) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318639) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Rzodkiewki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Sałaty, mieszanki sałat",
    "categoryPath": [
      "(318675) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318675) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Sałaty, mieszanki sałat",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Włoszczyzna",
    "categoryPath": [
      "(318651) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318651) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Włoszczyzna",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Ziemniaki",
    "categoryPath": [
      "(318654) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce",
      "Świeże warzywa"
    ],
    "hierarchy": "(318654) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże warzywa / Ziemniaki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Świeże zioła i natki",
    "categoryPath": [
      "(260965) Supermarket",
      "Produkty spożywcze",
      "Warzywa i owoce"
    ],
    "hierarchy": "(260965) Supermarket / Produkty spożywcze / Warzywa i owoce / Świeże zioła i natki",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Wina i napoje bezalkoholowe",
    "categoryPath": [
      "(261477) Supermarket",
      "Produkty spożywcze"
    ],
    "hierarchy": "(261477) Supermarket / Produkty spożywcze / Wina i napoje bezalkoholowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Piwo bezalkoholowe",
    "categoryPath": [
      "(311869) Supermarket",
      "Produkty spożywcze",
      "Wina i napoje bezalkoholowe"
    ],
    "hierarchy": "(311869) Supermarket / Produkty spożywcze / Wina i napoje bezalkoholowe / Piwo bezalkoholowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Pozostałe napoje bezalkoholowe",
    "categoryPath": [
      "(312053) Supermarket",
      "Produkty spożywcze",
      "Wina i napoje bezalkoholowe"
    ],
    "hierarchy": "(312053) Supermarket / Produkty spożywcze / Wina i napoje bezalkoholowe / Pozostałe napoje bezalkoholowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Wino bezalkoholowe",
    "categoryPath": [
      "(261481) Supermarket",
      "Produkty spożywcze",
      "Wina i napoje bezalkoholowe"
    ],
    "hierarchy": "(261481) Supermarket / Produkty spożywcze / Wina i napoje bezalkoholowe / Wino bezalkoholowe",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(125774) Supermarket",
      "Produkty spożywcze",
      "Yerba mate i akcesoria"
    ],
    "hierarchy": "(125774) Supermarket / Produkty spożywcze / Yerba mate i akcesoria / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Yerba mate",
    "categoryPath": [
      "(125773) Supermarket",
      "Produkty spożywcze",
      "Yerba mate i akcesoria"
    ],
    "hierarchy": "(125773) Supermarket / Produkty spożywcze / Yerba mate i akcesoria / Yerba mate",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(125775) Supermarket",
      "Produkty spożywcze",
      "Yerba mate i akcesoria"
    ],
    "hierarchy": "(125775) Supermarket / Produkty spożywcze / Yerba mate i akcesoria / Zestawy",
    "comissionGroupOld": "C34",
    "comissionGroupNew": "D10"
  },
  {
    "segment": "Fit słodycze i przekąski",
    "categoryPath": [
      "(261779) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność"
    ],
    "hierarchy": "(261779) Supermarket / Produkty spożywcze / Zdrowa żywność / Fit słodycze i przekąski",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Karob",
    "categoryPath": [
      "(261778) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność"
    ],
    "hierarchy": "(261778) Supermarket / Produkty spożywcze / Zdrowa żywność / Karob",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kiełki",
    "categoryPath": [
      "(261781) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność"
    ],
    "hierarchy": "(261781) Supermarket / Produkty spożywcze / Zdrowa żywność / Kiełki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koktajle",
    "categoryPath": [
      "(261785) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Napoje"
    ],
    "hierarchy": "(261785) Supermarket / Produkty spożywcze / Zdrowa żywność / Napoje / Koktajle",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kombucha",
    "categoryPath": [
      "(261784) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Napoje"
    ],
    "hierarchy": "(261784) Supermarket / Produkty spożywcze / Zdrowa żywność / Napoje / Kombucha",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(121660) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Napoje"
    ],
    "hierarchy": "(121660) Supermarket / Produkty spożywcze / Zdrowa żywność / Napoje / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Syropy",
    "categoryPath": [
      "(261786) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Napoje"
    ],
    "hierarchy": "(261786) Supermarket / Produkty spożywcze / Zdrowa żywność / Napoje / Syropy",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(74068) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność"
    ],
    "hierarchy": "(74068) Supermarket / Produkty spożywcze / Zdrowa żywność / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płatki drożdżowe",
    "categoryPath": [
      "(307525) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność"
    ],
    "hierarchy": "(307525) Supermarket / Produkty spożywcze / Zdrowa żywność / Płatki drożdżowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Baobab",
    "categoryPath": [
      "(261796) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261796) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Baobab",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Białko konopne",
    "categoryPath": [
      "(261812) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261812) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Białko konopne",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Camu Camu",
    "categoryPath": [
      "(261797) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261797) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Camu Camu",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Guarana",
    "categoryPath": [
      "(261798) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261798) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Guarana",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Jagody Acai",
    "categoryPath": [
      "(261799) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261799) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Jagody Acai",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lucuma",
    "categoryPath": [
      "(261800) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261800) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Lucuma",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maca",
    "categoryPath": [
      "(261801) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261801) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Maca",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Miechunka",
    "categoryPath": [
      "(261808) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261808) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Miechunka",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mieszanki superfood",
    "categoryPath": [
      "(261802) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261802) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Mieszanki superfood",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Morwa biała",
    "categoryPath": [
      "(261803) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261803) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Morwa biała",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Młoda pszenica",
    "categoryPath": [
      "(261804) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261804) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Młoda pszenica",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nasiona chia",
    "categoryPath": [
      "(261811) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261811) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Nasiona chia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nasiona kakao",
    "categoryPath": [
      "(261813) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261813) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Nasiona kakao",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nasiona konopi",
    "categoryPath": [
      "(261805) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261805) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Nasiona konopi",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(261810) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261810) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Spirulina",
    "categoryPath": [
      "(261806) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261806) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Spirulina",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zielony jęczmień",
    "categoryPath": [
      "(261807) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność",
      "Superfood"
    ],
    "hierarchy": "(261807) Supermarket / Produkty spożywcze / Zdrowa żywność / Superfood / Zielony jęczmień",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Słodkie kremy i smarowidła",
    "categoryPath": [
      "(261777) Supermarket",
      "Produkty spożywcze",
      "Zdrowa żywność"
    ],
    "hierarchy": "(261777) Supermarket / Produkty spożywcze / Zdrowa żywność / Słodkie kremy i smarowidła",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy prezentowe",
    "categoryPath": [
      "(251902) Supermarket",
      "Produkty spożywcze"
    ],
    "hierarchy": "(251902) Supermarket / Produkty spożywcze / Zestawy prezentowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Deski do prasowania",
    "categoryPath": [
      "(260134) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260134) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Deski do prasowania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gąbki, zmywaki, druciaki",
    "categoryPath": [
      "(260251) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260251) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Gąbki, zmywaki, druciaki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klamerki, linki i koszyczki",
    "categoryPath": [
      "(260137) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260137) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Klamerki, linki i koszyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosze na śmieci",
    "categoryPath": [
      "(260146) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260146) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Kosze na śmieci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miotełki do kurzu",
    "categoryPath": [
      "(260561) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260561) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Miotełki do kurzu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miotły, zmiotki i szufelki",
    "categoryPath": [
      "(260147) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260147) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Miotły, zmiotki i szufelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Mopy",
    "categoryPath": [
      "(260149) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260149) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Mopy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pokrowce na deski",
    "categoryPath": [
      "(260135) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260135) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Pokrowce na deski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260157) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260157) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Rękawiczki domowe",
    "categoryPath": [
      "(260155) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260155) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Rękawiczki domowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Suszarki i ociekacze",
    "categoryPath": [
      "(260252) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260252) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Suszarki i ociekacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Suszarki na pranie",
    "categoryPath": [
      "(260136) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260136) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Suszarki na pranie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(260150) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260150) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Szczotki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczotki do WC",
    "categoryPath": [
      "(260148) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260148) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Szczotki do WC",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wiadra",
    "categoryPath": [
      "(260152) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260152) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Wiadra",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Worki na śmieci",
    "categoryPath": [
      "(260153) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260153) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Worki na śmieci",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Worki próżniowe",
    "categoryPath": [
      "(260154) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260154) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Worki próżniowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ścierki, ściereczki, ręczniki papierowe",
    "categoryPath": [
      "(260151) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260151) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Ścierki, ściereczki, ręczniki papierowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ściągaczki",
    "categoryPath": [
      "(260156) Supermarket",
      "Utrzymanie czystości",
      "Akcesoria do prania i sprzątania"
    ],
    "hierarchy": "(260156) Supermarket / Utrzymanie czystości / Akcesoria do prania i sprzątania / Ściągaczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chemia profesjonalna",
    "categoryPath": [
      "(317372) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza"
    ],
    "hierarchy": "(317372) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Chemia profesjonalna",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mydła",
    "categoryPath": [
      "(253350) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza"
    ],
    "hierarchy": "(253350) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Mydła",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odkamieniacze",
    "categoryPath": [
      "(253353) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza"
    ],
    "hierarchy": "(253353) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Odkamieniacze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odświeżacze powietrza",
    "categoryPath": [
      "(253354) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza"
    ],
    "hierarchy": "(253354) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Odświeżacze powietrza",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy chemii domowej",
    "categoryPath": [
      "(253366) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza"
    ],
    "hierarchy": "(253366) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Zestawy chemii domowej",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Środki czyszczące",
    "categoryPath": [
      "(253359) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza"
    ],
    "hierarchy": "(253359) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki czyszczące",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chusteczki do prania i suszenia",
    "categoryPath": [
      "(260131) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260131) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Chusteczki do prania i suszenia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Czyszczenie pralki",
    "categoryPath": [
      "(260133) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260133) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Czyszczenie pralki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Farby i barwniki do tkanin",
    "categoryPath": [
      "(260553) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260553) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Farby i barwniki do tkanin",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kapsułki i tabletki do prania",
    "categoryPath": [
      "(260126) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260126) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Kapsułki i tabletki do prania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Krochmale",
    "categoryPath": [
      "(260554) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260554) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Krochmale",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kule do prania i suszenia",
    "categoryPath": [
      "(260552) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260552) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Kule do prania i suszenia",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Listki do prania",
    "categoryPath": [
      "(309073) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(309073) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Listki do prania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odplamiacze",
    "categoryPath": [
      "(260129) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260129) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Odplamiacze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Orzechy do prania",
    "categoryPath": [
      "(260551) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260551) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Orzechy do prania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Perełki zapachowe",
    "categoryPath": [
      "(260132) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260132) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Perełki zapachowe",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Proszki do prania",
    "categoryPath": [
      "(260124) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260124) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Proszki do prania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płyny do prania",
    "categoryPath": [
      "(260128) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260128) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Płyny do prania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płyny do płukania",
    "categoryPath": [
      "(260125) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260125) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Płyny do płukania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wybielacze",
    "categoryPath": [
      "(260130) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260130) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Wybielacze",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Środki do prasowania",
    "categoryPath": [
      "(260140) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260140) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Środki do prasowania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żele do prania",
    "categoryPath": [
      "(260127) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do prania"
    ],
    "hierarchy": "(260127) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do prania / Żele do prania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Czyściki do zmywarki",
    "categoryPath": [
      "(260248) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260248) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Czyściki do zmywarki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nabłyszczacze do zmywarki",
    "categoryPath": [
      "(260247) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260247) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Nabłyszczacze do zmywarki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płyny do naczyń",
    "categoryPath": [
      "(260253) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260253) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Płyny do naczyń",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sole do zmywarki",
    "categoryPath": [
      "(260246) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260246) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Sole do zmywarki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tabletki do zmywarki",
    "categoryPath": [
      "(260244) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260244) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Tabletki do zmywarki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zapachy do zmywarki",
    "categoryPath": [
      "(260249) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260249) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Zapachy do zmywarki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy produktów do zmywania",
    "categoryPath": [
      "(260820) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260820) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Zestawy produktów do zmywania",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żele i proszki do zmywarki",
    "categoryPath": [
      "(260245) Supermarket",
      "Utrzymanie czystości",
      "Chemia gospodarcza",
      "Środki do zmywania"
    ],
    "hierarchy": "(260245) Supermarket / Utrzymanie czystości / Chemia gospodarcza / Środki do zmywania / Żele i proszki do zmywarki",
    "comissionGroupOld": "C13",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(253367) Supermarket",
      "Utrzymanie czystości"
    ],
    "hierarchy": "(253367) Supermarket / Utrzymanie czystości / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Aplikatory",
    "categoryPath": [
      "(317751) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317751) Uroda / Makijaż / Oczy / Akcesoria / Aplikatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(317823) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317823) Uroda / Makijaż / Oczy / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Narzędzia do henny",
    "categoryPath": [
      "(317730) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317730) Uroda / Makijaż / Oczy / Akcesoria / Narzędzia do henny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nożyki i nożyczki",
    "categoryPath": [
      "(317733) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317733) Uroda / Makijaż / Oczy / Akcesoria / Nożyki i nożyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pęsety",
    "categoryPath": [
      "(317736) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317736) Uroda / Makijaż / Oczy / Akcesoria / Pęsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szablony i taśmy",
    "categoryPath": [
      "(317739) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317739) Uroda / Makijaż / Oczy / Akcesoria / Szablony i taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczoteczki",
    "categoryPath": [
      "(317742) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317742) Uroda / Makijaż / Oczy / Akcesoria / Szczoteczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Temperówki",
    "categoryPath": [
      "(317745) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317745) Uroda / Makijaż / Oczy / Akcesoria / Temperówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zalotki",
    "categoryPath": [
      "(317748) Uroda",
      "Makijaż",
      "Oczy",
      "Akcesoria"
    ],
    "hierarchy": "(317748) Uroda / Makijaż / Oczy / Akcesoria / Zalotki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Bazy pod cienie",
    "categoryPath": [
      "(89012) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(89012) Uroda / Makijaż / Oczy / Bazy pod cienie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Cienie",
    "categoryPath": [
      "(45664) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(45664) Uroda / Makijaż / Oczy / Cienie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Eyelinery",
    "categoryPath": [
      "(255558) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(255558) Uroda / Makijaż / Oczy / Eyelinery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Korektory pod oczy",
    "categoryPath": [
      "(89013) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(89013) Uroda / Makijaż / Oczy / Korektory pod oczy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kredki do oczu",
    "categoryPath": [
      "(45665) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(45665) Uroda / Makijaż / Oczy / Kredki do oczu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Makijaż brwi",
    "categoryPath": [
      "(255559) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(255559) Uroda / Makijaż / Oczy / Makijaż brwi",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Aplikatory",
    "categoryPath": [
      "(320200) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320200) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Aplikatory",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Grzebyki",
    "categoryPath": [
      "(320203) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320203) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Grzebyki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(320620) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320620) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lusterka",
    "categoryPath": [
      "(320206) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320206) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Lusterka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pierścionki i wkłady na klej",
    "categoryPath": [
      "(320212) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320212) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Pierścionki i wkłady na klej",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pojemniki na rzęsy",
    "categoryPath": [
      "(320218) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320218) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Pojemniki na rzęsy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pęsety",
    "categoryPath": [
      "(320209) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320209) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Pęsety",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Płatki pod oczy",
    "categoryPath": [
      "(320215) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320215) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Płatki pod oczy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szampony do rzęs",
    "categoryPath": [
      "(320221) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320221) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Szampony do rzęs",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczoteczki",
    "categoryPath": [
      "(320224) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320224) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Szczoteczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy",
    "categoryPath": [
      "(320227) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320227) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Taśmy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Waciki",
    "categoryPath": [
      "(320230) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320230) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Waciki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy do laminacji",
    "categoryPath": [
      "(320233) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320233) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Zestawy do laminacji",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy do przedłużania",
    "categoryPath": [
      "(320236) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy",
      "Akcesoria"
    ],
    "hierarchy": "(320236) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Akcesoria / Zestawy do przedłużania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(93072) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy"
    ],
    "hierarchy": "(93072) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Kleje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Preparaty do usuwania rzęs",
    "categoryPath": [
      "(93073) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy"
    ],
    "hierarchy": "(93073) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Preparaty do usuwania rzęs",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rzęsy",
    "categoryPath": [
      "(93074) Uroda",
      "Makijaż",
      "Oczy",
      "Przedłużanie rzęs, sztuczne rzęsy"
    ],
    "hierarchy": "(93074) Uroda / Makijaż / Oczy / Przedłużanie rzęs, sztuczne rzęsy / Rzęsy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Serum i odżywki do brwi i rzęs",
    "categoryPath": [
      "(255638) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(255638) Uroda / Makijaż / Oczy / Serum i odżywki do brwi i rzęs",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tusze do rzęs",
    "categoryPath": [
      "(45666) Uroda",
      "Makijaż",
      "Oczy"
    ],
    "hierarchy": "(45666) Uroda / Makijaż / Oczy / Tusze do rzęs",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Palety do makijażu i zestawy",
    "categoryPath": [
      "(49054) Uroda",
      "Makijaż"
    ],
    "hierarchy": "(49054) Uroda / Makijaż / Palety do makijażu i zestawy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(45663) Uroda",
      "Makijaż"
    ],
    "hierarchy": "(45663) Uroda / Makijaż / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Gąbki do makijażu",
    "categoryPath": [
      "(255560) Uroda",
      "Makijaż",
      "Pędzle i akcesoria"
    ],
    "hierarchy": "(255560) Uroda / Makijaż / Pędzle i akcesoria / Gąbki do makijażu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lusterka",
    "categoryPath": [
      "(89008) Uroda",
      "Makijaż",
      "Pędzle i akcesoria"
    ],
    "hierarchy": "(89008) Uroda / Makijaż / Pędzle i akcesoria / Lusterka",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(89007) Uroda",
      "Makijaż",
      "Pędzle i akcesoria"
    ],
    "hierarchy": "(89007) Uroda / Makijaż / Pędzle i akcesoria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pędzle do makijażu",
    "categoryPath": [
      "(89009) Uroda",
      "Makijaż",
      "Pędzle i akcesoria"
    ],
    "hierarchy": "(89009) Uroda / Makijaż / Pędzle i akcesoria / Pędzle do makijażu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bazy pod makijaż",
    "categoryPath": [
      "(89010) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(89010) Uroda / Makijaż / Twarz / Bazy pod makijaż",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bronzery",
    "categoryPath": [
      "(255956) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(255956) Uroda / Makijaż / Twarz / Bronzery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Korektory",
    "categoryPath": [
      "(89011) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(89011) Uroda / Makijaż / Twarz / Korektory",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kremy koloryzujące",
    "categoryPath": [
      "(255958) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(255958) Uroda / Makijaż / Twarz / Kremy koloryzujące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podkłady",
    "categoryPath": [
      "(45668) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(45668) Uroda / Makijaż / Twarz / Podkłady",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pudry",
    "categoryPath": [
      "(45669) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(45669) Uroda / Makijaż / Twarz / Pudry",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rozświetlacze",
    "categoryPath": [
      "(255957) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(255957) Uroda / Makijaż / Twarz / Rozświetlacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Róże do policzków",
    "categoryPath": [
      "(45670) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(45670) Uroda / Makijaż / Twarz / Róże do policzków",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Utrwalenie makijażu",
    "categoryPath": [
      "(255989) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(255989) Uroda / Makijaż / Twarz / Utrwalenie makijażu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zdobienie twarzy",
    "categoryPath": [
      "(315684) Uroda",
      "Makijaż",
      "Twarz"
    ],
    "hierarchy": "(315684) Uroda / Makijaż / Twarz / Zdobienie twarzy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Błyszczyki",
    "categoryPath": [
      "(45673) Uroda",
      "Makijaż",
      "Usta"
    ],
    "hierarchy": "(45673) Uroda / Makijaż / Usta / Błyszczyki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Konturówki",
    "categoryPath": [
      "(45674) Uroda",
      "Makijaż",
      "Usta"
    ],
    "hierarchy": "(45674) Uroda / Makijaż / Usta / Konturówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pomadki",
    "categoryPath": [
      "(45675) Uroda",
      "Makijaż",
      "Usta"
    ],
    "hierarchy": "(45675) Uroda / Makijaż / Usta / Pomadki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy do makijażu ust",
    "categoryPath": [
      "(315687) Uroda",
      "Makijaż",
      "Usta"
    ],
    "hierarchy": "(315687) Uroda / Makijaż / Usta / Zestawy do makijażu ust",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria i przybory na wrastające paznokcie",
    "categoryPath": [
      "(308929) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(308929) Uroda / Manicure i pedicure / Akcesoria i przybory / Akcesoria i przybory na wrastające paznokcie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klipsy do usuwania hybrydy, żelu, akrylu",
    "categoryPath": [
      "(260547) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(260547) Uroda / Manicure i pedicure / Akcesoria i przybory / Klipsy do usuwania hybrydy, żelu, akrylu",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kuferki",
    "categoryPath": [
      "(257497) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(257497) Uroda / Manicure i pedicure / Akcesoria i przybory / Kuferki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nożyczki, cążki, kopytka",
    "categoryPath": [
      "(45687) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(45687) Uroda / Manicure i pedicure / Akcesoria i przybory / Nożyczki, cążki, kopytka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ochrona skórek przed zabrudzeniem",
    "categoryPath": [
      "(260546) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(260546) Uroda / Manicure i pedicure / Akcesoria i przybory / Ochrona skórek przed zabrudzeniem",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Patyczki",
    "categoryPath": [
      "(257493) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(257493) Uroda / Manicure i pedicure / Akcesoria i przybory / Patyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pilniki i polerki do rąk",
    "categoryPath": [
      "(45689) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(45689) Uroda / Manicure i pedicure / Akcesoria i przybory / Pilniki i polerki do rąk",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pilniki, tarki, pumeksy do stóp",
    "categoryPath": [
      "(260718) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(260718) Uroda / Manicure i pedicure / Akcesoria i przybory / Pilniki, tarki, pumeksy do stóp",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podkładki, poduszki",
    "categoryPath": [
      "(93063) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(93063) Uroda / Manicure i pedicure / Akcesoria i przybory / Podkładki, poduszki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pojemniki, pudełka",
    "categoryPath": [
      "(49356) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(49356) Uroda / Manicure i pedicure / Akcesoria i przybory / Pojemniki, pudełka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(45692) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(45692) Uroda / Manicure i pedicure / Akcesoria i przybory / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Przyborniki do manicure i pedicure",
    "categoryPath": [
      "(320239) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(320239) Uroda / Manicure i pedicure / Akcesoria i przybory / Przyborniki do manicure i pedicure",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pędzelki",
    "categoryPath": [
      "(45688) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(45688) Uroda / Manicure i pedicure / Akcesoria i przybory / Pędzelki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Separatory do pedicure",
    "categoryPath": [
      "(308917) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(308917) Uroda / Manicure i pedicure / Akcesoria i przybory / Separatory do pedicure",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szablony",
    "categoryPath": [
      "(93062) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(93062) Uroda / Manicure i pedicure / Akcesoria i przybory / Szablony",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczoteczki",
    "categoryPath": [
      "(260550) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(260550) Uroda / Manicure i pedicure / Akcesoria i przybory / Szczoteczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Waciki",
    "categoryPath": [
      "(45690) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(45690) Uroda / Manicure i pedicure / Akcesoria i przybory / Waciki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wzorniki kolorów",
    "categoryPath": [
      "(260549) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(260549) Uroda / Manicure i pedicure / Akcesoria i przybory / Wzorniki kolorów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zaciskarki do paznokci, do tuneli",
    "categoryPath": [
      "(308893) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(308893) Uroda / Manicure i pedicure / Akcesoria i przybory / Zaciskarki do paznokci, do tuneli",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy akcesoriów",
    "categoryPath": [
      "(45691) Uroda",
      "Manicure i pedicure",
      "Akcesoria i przybory"
    ],
    "hierarchy": "(45691) Uroda / Manicure i pedicure / Akcesoria i przybory / Zestawy akcesoriów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Akryle",
    "categoryPath": [
      "(45693) Uroda",
      "Manicure i pedicure",
      "Akryle i żele"
    ],
    "hierarchy": "(45693) Uroda / Manicure i pedicure / Akryle i żele / Akryle",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy akrylowe",
    "categoryPath": [
      "(45695) Uroda",
      "Manicure i pedicure",
      "Akryle i żele"
    ],
    "hierarchy": "(45695) Uroda / Manicure i pedicure / Akryle i żele / Zestawy akrylowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy żelowe",
    "categoryPath": [
      "(45696) Uroda",
      "Manicure i pedicure",
      "Akryle i żele"
    ],
    "hierarchy": "(45696) Uroda / Manicure i pedicure / Akryle i żele / Zestawy żelowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żele",
    "categoryPath": [
      "(257562) Uroda",
      "Manicure i pedicure",
      "Akryle i żele"
    ],
    "hierarchy": "(257562) Uroda / Manicure i pedicure / Akryle i żele / Żele",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lakiery do paznokci",
    "categoryPath": [
      "(45680) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(45680) Uroda / Manicure i pedicure / Lakiery do paznokci",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lakiery hybrydowe",
    "categoryPath": [
      "(126042) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(126042) Uroda / Manicure i pedicure / Lakiery hybrydowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Manicure japoński",
    "categoryPath": [
      "(257218) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(257218) Uroda / Manicure i pedicure / Manicure japoński",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nabłyszczacze, utrwalacze",
    "categoryPath": [
      "(90426) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(90426) Uroda / Manicure i pedicure / Nabłyszczacze, utrwalacze",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Do paznokci",
    "categoryPath": [
      "(90424) Uroda",
      "Manicure i pedicure",
      "Odżywki do paznokci i skórek"
    ],
    "hierarchy": "(90424) Uroda / Manicure i pedicure / Odżywki do paznokci i skórek / Do paznokci",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Do skórek",
    "categoryPath": [
      "(90425) Uroda",
      "Manicure i pedicure",
      "Odżywki do paznokci i skórek"
    ],
    "hierarchy": "(90425) Uroda / Manicure i pedicure / Odżywki do paznokci i skórek / Do skórek",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ozdoby i przyrządy do zdobień",
    "categoryPath": [
      "(45682) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(45682) Uroda / Manicure i pedicure / Ozdoby i przyrządy do zdobień",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podkłady, bazy",
    "categoryPath": [
      "(45683) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(45683) Uroda / Manicure i pedicure / Podkłady, bazy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(45677) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(45677) Uroda / Manicure i pedicure / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pudry tytanowe",
    "categoryPath": [
      "(321308) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(321308) Uroda / Manicure i pedicure / Pudry tytanowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sztuczne paznokcie, tipsy",
    "categoryPath": [
      "(45684) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(45684) Uroda / Manicure i pedicure / Sztuczne paznokcie, tipsy",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Frezarki do paznokci i akcesoria do frezarek",
    "categoryPath": [
      "(45697) Uroda",
      "Manicure i pedicure",
      "Urządzenia"
    ],
    "hierarchy": "(45697) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Filtry",
    "categoryPath": [
      "(319712) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek",
      "Akcesoria"
    ],
    "hierarchy": "(319712) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Akcesoria / Filtry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Frezy i nośniki",
    "categoryPath": [
      "(319715) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek",
      "Akcesoria"
    ],
    "hierarchy": "(319715) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Akcesoria / Frezy i nośniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Głowice i rączki",
    "categoryPath": [
      "(319718) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek",
      "Akcesoria"
    ],
    "hierarchy": "(319718) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Akcesoria / Głowice i rączki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inne akcesoria",
    "categoryPath": [
      "(319727) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek",
      "Akcesoria"
    ],
    "hierarchy": "(319727) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Akcesoria / Inne akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nakładki ścierne",
    "categoryPath": [
      "(319721) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek",
      "Akcesoria"
    ],
    "hierarchy": "(319721) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Akcesoria / Nakładki ścierne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Napędy nożne",
    "categoryPath": [
      "(319730) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek",
      "Akcesoria"
    ],
    "hierarchy": "(319730) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Akcesoria / Napędy nożne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczoteczki do frezów",
    "categoryPath": [
      "(319724) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek",
      "Akcesoria"
    ],
    "hierarchy": "(319724) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Akcesoria / Szczoteczki do frezów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Frezarki do paznokci",
    "categoryPath": [
      "(260720) Uroda",
      "Manicure i pedicure",
      "Urządzenia",
      "Frezarki do paznokci i akcesoria do frezarek"
    ],
    "hierarchy": "(260720) Uroda / Manicure i pedicure / Urządzenia / Frezarki do paznokci i akcesoria do frezarek / Frezarki do paznokci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Lampy UV i LED",
    "categoryPath": [
      "(45698) Uroda",
      "Manicure i pedicure",
      "Urządzenia"
    ],
    "hierarchy": "(45698) Uroda / Manicure i pedicure / Urządzenia / Lampy UV i LED",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Lampy kosmetyczne",
    "categoryPath": [
      "(257433) Uroda",
      "Manicure i pedicure",
      "Urządzenia"
    ],
    "hierarchy": "(257433) Uroda / Manicure i pedicure / Urządzenia / Lampy kosmetyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Parafiniarki",
    "categoryPath": [
      "(45699) Uroda",
      "Manicure i pedicure",
      "Urządzenia"
    ],
    "hierarchy": "(45699) Uroda / Manicure i pedicure / Urządzenia / Parafiniarki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pochłaniacze pyłu",
    "categoryPath": [
      "(49053) Uroda",
      "Manicure i pedicure",
      "Urządzenia"
    ],
    "hierarchy": "(49053) Uroda / Manicure i pedicure / Urządzenia / Pochłaniacze pyłu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Sterylizatory",
    "categoryPath": [
      "(90432) Uroda",
      "Manicure i pedicure",
      "Urządzenia"
    ],
    "hierarchy": "(90432) Uroda / Manicure i pedicure / Urządzenia / Sterylizatory",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Suszarki do paznokci",
    "categoryPath": [
      "(45700) Uroda",
      "Manicure i pedicure",
      "Urządzenia"
    ],
    "hierarchy": "(45700) Uroda / Manicure i pedicure / Urządzenia / Suszarki do paznokci",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy do manicure hybrydowego",
    "categoryPath": [
      "(257217) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(257217) Uroda / Manicure i pedicure / Zestawy do manicure hybrydowego",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy do manicure tytanowego",
    "categoryPath": [
      "(322323) Uroda",
      "Manicure i pedicure"
    ],
    "hierarchy": "(322323) Uroda / Manicure i pedicure / Zestawy do manicure tytanowego",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Acetony, removery",
    "categoryPath": [
      "(93067) Uroda",
      "Manicure i pedicure",
      "Zmywacze, odtłuszczacze, kleje"
    ],
    "hierarchy": "(93067) Uroda / Manicure i pedicure / Zmywacze, odtłuszczacze, kleje / Acetony, removery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kleje",
    "categoryPath": [
      "(90427) Uroda",
      "Manicure i pedicure",
      "Zmywacze, odtłuszczacze, kleje"
    ],
    "hierarchy": "(90427) Uroda / Manicure i pedicure / Zmywacze, odtłuszczacze, kleje / Kleje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odtłuszczacze, primery",
    "categoryPath": [
      "(90428) Uroda",
      "Manicure i pedicure",
      "Zmywacze, odtłuszczacze, kleje"
    ],
    "hierarchy": "(90428) Uroda / Manicure i pedicure / Zmywacze, odtłuszczacze, kleje / Odtłuszczacze, primery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Acetonowe",
    "categoryPath": [
      "(90430) Uroda",
      "Manicure i pedicure",
      "Zmywacze, odtłuszczacze, kleje",
      "Zmywacze"
    ],
    "hierarchy": "(90430) Uroda / Manicure i pedicure / Zmywacze, odtłuszczacze, kleje / Zmywacze / Acetonowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bezacetonowe",
    "categoryPath": [
      "(90431) Uroda",
      "Manicure i pedicure",
      "Zmywacze, odtłuszczacze, kleje",
      "Zmywacze"
    ],
    "hierarchy": "(90431) Uroda / Manicure i pedicure / Zmywacze, odtłuszczacze, kleje / Zmywacze / Bezacetonowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Flakony, atomizery podróżne",
    "categoryPath": [
      "(260681) Uroda",
      "Perfumy i wody"
    ],
    "hierarchy": "(260681) Uroda / Perfumy i wody / Flakony, atomizery podróżne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(234) Uroda",
      "Perfumy i wody"
    ],
    "hierarchy": "(234) Uroda / Perfumy i wody / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dezodoranty",
    "categoryPath": [
      "(17751) Uroda",
      "Perfumy i wody",
      "Zapachy dla kobiet"
    ],
    "hierarchy": "(17751) Uroda / Perfumy i wody / Zapachy dla kobiet / Dezodoranty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Perfumy i wody perfumowane",
    "categoryPath": [
      "(17752) Uroda",
      "Perfumy i wody",
      "Zapachy dla kobiet"
    ],
    "hierarchy": "(17752) Uroda / Perfumy i wody / Zapachy dla kobiet / Perfumy i wody perfumowane",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody toaletowe",
    "categoryPath": [
      "(17753) Uroda",
      "Perfumy i wody",
      "Zapachy dla kobiet"
    ],
    "hierarchy": "(17753) Uroda / Perfumy i wody / Zapachy dla kobiet / Wody toaletowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Dezodoranty",
    "categoryPath": [
      "(17755) Uroda",
      "Perfumy i wody",
      "Zapachy dla mężczyzn"
    ],
    "hierarchy": "(17755) Uroda / Perfumy i wody / Zapachy dla mężczyzn / Dezodoranty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody kolońskie",
    "categoryPath": [
      "(17758) Uroda",
      "Perfumy i wody",
      "Zapachy dla mężczyzn"
    ],
    "hierarchy": "(17758) Uroda / Perfumy i wody / Zapachy dla mężczyzn / Wody kolońskie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody perfumowane",
    "categoryPath": [
      "(17756) Uroda",
      "Perfumy i wody",
      "Zapachy dla mężczyzn"
    ],
    "hierarchy": "(17756) Uroda / Perfumy i wody / Zapachy dla mężczyzn / Wody perfumowane",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody po goleniu",
    "categoryPath": [
      "(17759) Uroda",
      "Perfumy i wody",
      "Zapachy dla mężczyzn"
    ],
    "hierarchy": "(17759) Uroda / Perfumy i wody / Zapachy dla mężczyzn / Wody po goleniu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody toaletowe",
    "categoryPath": [
      "(17757) Uroda",
      "Perfumy i wody",
      "Zapachy dla mężczyzn"
    ],
    "hierarchy": "(17757) Uroda / Perfumy i wody / Zapachy dla mężczyzn / Wody toaletowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody kolońskie",
    "categoryPath": [
      "(319292) Uroda",
      "Perfumy i wody",
      "Zapachy unisex"
    ],
    "hierarchy": "(319292) Uroda / Perfumy i wody / Zapachy unisex / Wody kolońskie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody perfumowane",
    "categoryPath": [
      "(319286) Uroda",
      "Perfumy i wody",
      "Zapachy unisex"
    ],
    "hierarchy": "(319286) Uroda / Perfumy i wody / Zapachy unisex / Wody perfumowane",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wody toaletowe",
    "categoryPath": [
      "(319289) Uroda",
      "Perfumy i wody",
      "Zapachy unisex"
    ],
    "hierarchy": "(319289) Uroda / Perfumy i wody / Zapachy unisex / Wody toaletowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Damskie",
    "categoryPath": [
      "(93079) Uroda",
      "Perfumy i wody",
      "Zestawy"
    ],
    "hierarchy": "(93079) Uroda / Perfumy i wody / Zestawy / Damskie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Męskie",
    "categoryPath": [
      "(93080) Uroda",
      "Perfumy i wody",
      "Zestawy"
    ],
    "hierarchy": "(93080) Uroda / Perfumy i wody / Zestawy / Męskie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Antyperspiranty",
    "categoryPath": [
      "(256777) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(256777) Uroda / Pielęgnacja / Ciało / Antyperspiranty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Balsamy, masła, kremy",
    "categoryPath": [
      "(5351) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(5351) Uroda / Pielęgnacja / Ciało / Balsamy, masła, kremy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Do biustu",
    "categoryPath": [
      "(10790) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(10790) Uroda / Pielęgnacja / Ciało / Do biustu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Mydła",
    "categoryPath": [
      "(93055) Uroda",
      "Pielęgnacja",
      "Ciało",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(93055) Uroda / Pielęgnacja / Ciało / Kąpiel i prysznic / Mydła",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Myjki, gąbki, szczotki",
    "categoryPath": [
      "(93056) Uroda",
      "Pielęgnacja",
      "Ciało",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(93056) Uroda / Pielęgnacja / Ciało / Kąpiel i prysznic / Myjki, gąbki, szczotki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Płyny, emulsje, olejki, pianki",
    "categoryPath": [
      "(93057) Uroda",
      "Pielęgnacja",
      "Ciało",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(93057) Uroda / Pielęgnacja / Ciało / Kąpiel i prysznic / Płyny, emulsje, olejki, pianki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Sole i kule",
    "categoryPath": [
      "(93058) Uroda",
      "Pielęgnacja",
      "Ciało",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(93058) Uroda / Pielęgnacja / Ciało / Kąpiel i prysznic / Sole i kule",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Żele",
    "categoryPath": [
      "(93059) Uroda",
      "Pielęgnacja",
      "Ciało",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(93059) Uroda / Pielęgnacja / Ciało / Kąpiel i prysznic / Żele",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Mgiełki do ciała",
    "categoryPath": [
      "(256778) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(256778) Uroda / Pielęgnacja / Ciało / Mgiełki do ciała",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Na rozstępy",
    "categoryPath": [
      "(90404) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(90404) Uroda / Pielęgnacja / Ciało / Na rozstępy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Olejki",
    "categoryPath": [
      "(144742) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(144742) Uroda / Pielęgnacja / Ciało / Olejki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Peelingi i scruby",
    "categoryPath": [
      "(90405) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(90405) Uroda / Pielęgnacja / Ciało / Peelingi i scruby",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5354) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(5354) Uroda / Pielęgnacja / Ciało / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Wyszczuplające, antycellulitowe",
    "categoryPath": [
      "(9314) Uroda",
      "Pielęgnacja",
      "Ciało"
    ],
    "hierarchy": "(9314) Uroda / Pielęgnacja / Ciało / Wyszczuplające, antycellulitowe",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Dezodoranty do stóp",
    "categoryPath": [
      "(93060) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(93060) Uroda / Pielęgnacja / Dłonie i stopy / Dezodoranty do stóp",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kremy do rąk",
    "categoryPath": [
      "(5355) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(5355) Uroda / Pielęgnacja / Dłonie i stopy / Kremy do rąk",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kremy do stóp",
    "categoryPath": [
      "(5356) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(5356) Uroda / Pielęgnacja / Dłonie i stopy / Kremy do stóp",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Maski, serum do rąk",
    "categoryPath": [
      "(260494) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260494) Uroda / Pielęgnacja / Dłonie i stopy / Maski, serum do rąk",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Maski, serum do stóp",
    "categoryPath": [
      "(260525) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260525) Uroda / Pielęgnacja / Dłonie i stopy / Maski, serum do stóp",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Na odciski, zrogowacenia, modzele, kurzajki, brodawki",
    "categoryPath": [
      "(260496) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260496) Uroda / Pielęgnacja / Dłonie i stopy / Na odciski, zrogowacenia, modzele, kurzajki, brodawki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Parafiny",
    "categoryPath": [
      "(93061) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(93061) Uroda / Pielęgnacja / Dłonie i stopy / Parafiny",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Peelingi do rąk",
    "categoryPath": [
      "(260495) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260495) Uroda / Pielęgnacja / Dłonie i stopy / Peelingi do rąk",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Peelingi do stóp",
    "categoryPath": [
      "(260497) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260497) Uroda / Pielęgnacja / Dłonie i stopy / Peelingi do stóp",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5357) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(5357) Uroda / Pielęgnacja / Dłonie i stopy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Skarpetki i rękawiczki bawełniane/kosmetyczne",
    "categoryPath": [
      "(260500) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260500) Uroda / Pielęgnacja / Dłonie i stopy / Skarpetki i rękawiczki bawełniane/kosmetyczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Skarpetki i rękawiczki z preparatami",
    "categoryPath": [
      "(260499) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260499) Uroda / Pielęgnacja / Dłonie i stopy / Skarpetki i rękawiczki z preparatami",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Skarpetki złuszczające",
    "categoryPath": [
      "(255530) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(255530) Uroda / Pielęgnacja / Dłonie i stopy / Skarpetki złuszczające",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Sole do rąk",
    "categoryPath": [
      "(260526) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260526) Uroda / Pielęgnacja / Dłonie i stopy / Sole do rąk",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Sole do stóp",
    "categoryPath": [
      "(260498) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260498) Uroda / Pielęgnacja / Dłonie i stopy / Sole do stóp",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(260501) Uroda",
      "Pielęgnacja",
      "Dłonie i stopy"
    ],
    "hierarchy": "(260501) Uroda / Pielęgnacja / Dłonie i stopy / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Paski",
    "categoryPath": [
      "(93134) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet",
      "Depilacja woskiem, pastą"
    ],
    "hierarchy": "(93134) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja woskiem, pastą / Paski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Plastry z woskiem",
    "categoryPath": [
      "(260317) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet",
      "Depilacja woskiem, pastą"
    ],
    "hierarchy": "(260317) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja woskiem, pastą / Plastry z woskiem",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Podgrzewacze",
    "categoryPath": [
      "(93135) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet",
      "Depilacja woskiem, pastą"
    ],
    "hierarchy": "(93135) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja woskiem, pastą / Podgrzewacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Płyny do czyszczenia urządzeń",
    "categoryPath": [
      "(260319) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet",
      "Depilacja woskiem, pastą"
    ],
    "hierarchy": "(260319) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja woskiem, pastą / Płyny do czyszczenia urządzeń",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szpatułki",
    "categoryPath": [
      "(260318) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet",
      "Depilacja woskiem, pastą"
    ],
    "hierarchy": "(260318) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja woskiem, pastą / Szpatułki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Woski, pasty",
    "categoryPath": [
      "(93133) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet",
      "Depilacja woskiem, pastą"
    ],
    "hierarchy": "(93133) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja woskiem, pastą / Woski, pasty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(93136) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet",
      "Depilacja woskiem, pastą"
    ],
    "hierarchy": "(93136) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja woskiem, pastą / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Depilacja światłem",
    "categoryPath": [
      "(256096) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(256096) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Depilacja światłem",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kosmetyki po depilacji",
    "categoryPath": [
      "(260322) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(260322) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Kosmetyki po depilacji",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kosmetyki przed depilacją",
    "categoryPath": [
      "(260320) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(260320) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Kosmetyki przed depilacją",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kremy, żele, pianki do depilacji",
    "categoryPath": [
      "(260321) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(260321) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Kremy, żele, pianki do depilacji",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Maszynki",
    "categoryPath": [
      "(93131) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(93131) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Maszynki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pianki, żele mydła do golenia",
    "categoryPath": [
      "(260324) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(260324) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Pianki, żele mydła do golenia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Rozjaśniacze do włosków",
    "categoryPath": [
      "(260323) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(260323) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Rozjaśniacze do włosków",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wkłady do maszynek",
    "categoryPath": [
      "(260325) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla kobiet"
    ],
    "hierarchy": "(260325) Uroda / Pielęgnacja / Golenie i depilacja / Dla kobiet / Wkłady do maszynek",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ałuny",
    "categoryPath": [
      "(260328) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(260328) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Ałuny",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Balsamy po goleniu",
    "categoryPath": [
      "(260327) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(260327) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Balsamy po goleniu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Brzytwy",
    "categoryPath": [
      "(315795) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Brzytwy, szawetki i akcesoria"
    ],
    "hierarchy": "(315795) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Brzytwy, szawetki i akcesoria / Brzytwy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Etui",
    "categoryPath": [
      "(315810) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Brzytwy, szawetki i akcesoria"
    ],
    "hierarchy": "(315810) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Brzytwy, szawetki i akcesoria / Etui",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kamienie",
    "categoryPath": [
      "(315801) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Brzytwy, szawetki i akcesoria"
    ],
    "hierarchy": "(315801) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Brzytwy, szawetki i akcesoria / Kamienie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pasty",
    "categoryPath": [
      "(315807) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Brzytwy, szawetki i akcesoria"
    ],
    "hierarchy": "(315807) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Brzytwy, szawetki i akcesoria / Pasty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pasy",
    "categoryPath": [
      "(315804) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Brzytwy, szawetki i akcesoria"
    ],
    "hierarchy": "(315804) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Brzytwy, szawetki i akcesoria / Pasy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szawetki",
    "categoryPath": [
      "(315798) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Brzytwy, szawetki i akcesoria"
    ],
    "hierarchy": "(315798) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Brzytwy, szawetki i akcesoria / Szawetki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kosmetyki przed goleniem",
    "categoryPath": [
      "(260326) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(260326) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Kosmetyki przed goleniem",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kremy, żele, pianki do depilacji",
    "categoryPath": [
      "(260329) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(260329) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Kremy, żele, pianki do depilacji",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Maszynki",
    "categoryPath": [
      "(93138) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(93138) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Maszynki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pianki, żele, mydła do golenia",
    "categoryPath": [
      "(93139) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(93139) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pianki, żele, mydła do golenia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Fartuchy, płachty",
    "categoryPath": [
      "(315822) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów",
      "Akcesoria"
    ],
    "hierarchy": "(315822) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Akcesoria / Fartuchy, płachty",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gruszki do talku",
    "categoryPath": [
      "(315828) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów",
      "Akcesoria"
    ],
    "hierarchy": "(315828) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Akcesoria / Gruszki do talku",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ręczniki",
    "categoryPath": [
      "(315819) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów",
      "Akcesoria"
    ],
    "hierarchy": "(315819) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Akcesoria / Ręczniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stojaki na pędzel",
    "categoryPath": [
      "(315831) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów",
      "Akcesoria"
    ],
    "hierarchy": "(315831) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Akcesoria / Stojaki na pędzel",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szablony do stylizacji",
    "categoryPath": [
      "(315825) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów",
      "Akcesoria"
    ],
    "hierarchy": "(315825) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Akcesoria / Szablony do stylizacji",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Balsamy",
    "categoryPath": [
      "(260382) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260382) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Balsamy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Grzebienie",
    "categoryPath": [
      "(260387) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260387) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Grzebienie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Mydła",
    "categoryPath": [
      "(260521) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260521) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Mydła",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odżywki",
    "categoryPath": [
      "(260385) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260385) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Odżywki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Olejki",
    "categoryPath": [
      "(260384) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260384) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Olejki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Preparaty zagęszczające zarost",
    "categoryPath": [
      "(260523) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260523) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Preparaty zagęszczające zarost",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szampony",
    "categoryPath": [
      "(260386) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260386) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Szampony",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szczotki i kartacze",
    "categoryPath": [
      "(260388) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260388) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Szczotki i kartacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Toniki",
    "categoryPath": [
      "(260522) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260522) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Toniki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Woski",
    "categoryPath": [
      "(260383) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260383) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Woski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(260381) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn",
      "Pielęgnacja brody i wąsów"
    ],
    "hierarchy": "(260381) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pielęgnacja brody i wąsów / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pędzle do golenia",
    "categoryPath": [
      "(256055) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(256055) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Pędzle do golenia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wkłady do maszynek",
    "categoryPath": [
      "(256027) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(256027) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Wkłady do maszynek",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy do golenia",
    "categoryPath": [
      "(256056) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(256056) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Zestawy do golenia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Żyletki",
    "categoryPath": [
      "(256054) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja",
      "Dla mężczyzn"
    ],
    "hierarchy": "(256054) Uroda / Pielęgnacja / Golenie i depilacja / Dla mężczyzn / Żyletki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(93125) Uroda",
      "Pielęgnacja",
      "Golenie i depilacja"
    ],
    "hierarchy": "(93125) Uroda / Pielęgnacja / Golenie i depilacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Chusteczki do higieny intymnej",
    "categoryPath": [
      "(259328) Uroda",
      "Pielęgnacja",
      "Higiena intymna"
    ],
    "hierarchy": "(259328) Uroda / Pielęgnacja / Higiena intymna / Chusteczki do higieny intymnej",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Płyny do higieny intymnej",
    "categoryPath": [
      "(259327) Uroda",
      "Pielęgnacja",
      "Higiena intymna"
    ],
    "hierarchy": "(259327) Uroda / Pielęgnacja / Higiena intymna / Płyny do higieny intymnej",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kosmetyki po opalaniu",
    "categoryPath": [
      "(47627) Uroda",
      "Pielęgnacja",
      "Opalanie"
    ],
    "hierarchy": "(47627) Uroda / Pielęgnacja / Opalanie / Kosmetyki po opalaniu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Opalanie na słońcu",
    "categoryPath": [
      "(47628) Uroda",
      "Pielęgnacja",
      "Opalanie"
    ],
    "hierarchy": "(47628) Uroda / Pielęgnacja / Opalanie / Opalanie na słońcu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Preparaty",
    "categoryPath": [
      "(260624) Uroda",
      "Pielęgnacja",
      "Opalanie",
      "Opalanie natryskowe"
    ],
    "hierarchy": "(260624) Uroda / Pielęgnacja / Opalanie / Opalanie natryskowe / Preparaty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Urządzenia",
    "categoryPath": [
      "(260623) Uroda",
      "Pielęgnacja",
      "Opalanie",
      "Opalanie natryskowe"
    ],
    "hierarchy": "(260623) Uroda / Pielęgnacja / Opalanie / Opalanie natryskowe / Urządzenia",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(260622) Uroda",
      "Pielęgnacja",
      "Opalanie",
      "Opalanie natryskowe"
    ],
    "hierarchy": "(260622) Uroda / Pielęgnacja / Opalanie / Opalanie natryskowe / Zestawy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Opalanie w solarium",
    "categoryPath": [
      "(47629) Uroda",
      "Pielęgnacja",
      "Opalanie"
    ],
    "hierarchy": "(47629) Uroda / Pielęgnacja / Opalanie / Opalanie w solarium",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Samoopalacze",
    "categoryPath": [
      "(47630) Uroda",
      "Pielęgnacja",
      "Opalanie"
    ],
    "hierarchy": "(47630) Uroda / Pielęgnacja / Opalanie / Samoopalacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(519) Uroda",
      "Pielęgnacja"
    ],
    "hierarchy": "(519) Uroda / Pielęgnacja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dla mężczyzn",
    "categoryPath": [
      "(88999) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(88999) Uroda / Pielęgnacja / Twarz / Dla mężczyzn",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kolagen",
    "categoryPath": [
      "(258425) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(258425) Uroda / Pielęgnacja / Twarz / Kolagen",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kremy do twarzy",
    "categoryPath": [
      "(258462) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(258462) Uroda / Pielęgnacja / Twarz / Kremy do twarzy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kremy pod oczy",
    "categoryPath": [
      "(5359) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(5359) Uroda / Pielęgnacja / Twarz / Kremy pod oczy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Kwasy, peelingi chemiczne",
    "categoryPath": [
      "(258424) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(258424) Uroda / Pielęgnacja / Twarz / Kwasy, peelingi chemiczne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Maseczki",
    "categoryPath": [
      "(5360) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(5360) Uroda / Pielęgnacja / Twarz / Maseczki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Oczyszczanie i demakijaż",
    "categoryPath": [
      "(5361) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(5361) Uroda / Pielęgnacja / Twarz / Oczyszczanie i demakijaż",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Olejki do twarzy",
    "categoryPath": [
      "(144743) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(144743) Uroda / Pielęgnacja / Twarz / Olejki do twarzy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Peelingi i scruby",
    "categoryPath": [
      "(10785) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(10785) Uroda / Pielęgnacja / Twarz / Peelingi i scruby",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pielęgnacja ust",
    "categoryPath": [
      "(45672) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(45672) Uroda / Pielęgnacja / Twarz / Pielęgnacja ust",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5362) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(5362) Uroda / Pielęgnacja / Twarz / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Serum",
    "categoryPath": [
      "(89000) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(89000) Uroda / Pielęgnacja / Twarz / Serum",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Toniki, hydrolaty, wody termalne",
    "categoryPath": [
      "(255028) Uroda",
      "Pielęgnacja",
      "Twarz"
    ],
    "hierarchy": "(255028) Uroda / Pielęgnacja / Twarz / Toniki, hydrolaty, wody termalne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Masażery",
    "categoryPath": [
      "(318168) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(318168) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Masażery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odkurzacze na wągry",
    "categoryPath": [
      "(258806) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(258806) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Odkurzacze na wągry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Peelingi kawitacyjne",
    "categoryPath": [
      "(256079) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(256079) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Peelingi kawitacyjne",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Sauny parowe i nawilżacze",
    "categoryPath": [
      "(318171) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(318171) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Sauny parowe i nawilżacze",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szczoteczki do twarzy",
    "categoryPath": [
      "(256082) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(256082) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Szczoteczki do twarzy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Urządzenia do mezoterapii",
    "categoryPath": [
      "(256081) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(256081) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Urządzenia do mezoterapii",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Urządzenia do okolic oczu",
    "categoryPath": [
      "(256085) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(256085) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Urządzenia do okolic oczu",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Urządzenia do terapii fotonowej",
    "categoryPath": [
      "(318177) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(318177) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Urządzenia do terapii fotonowej",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Urządzenia typu Darsonval",
    "categoryPath": [
      "(256080) Uroda",
      "Pielęgnacja",
      "Twarz",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(256080) Uroda / Pielęgnacja / Twarz / Urządzenia kosmetyczne / Urządzenia typu Darsonval",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Ampułki, toniki, wcierki",
    "categoryPath": [
      "(259392) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259392) Uroda / Pielęgnacja / Włosy / Ampułki, toniki, wcierki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Czepki na włosy",
    "categoryPath": [
      "(315690) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(315690) Uroda / Pielęgnacja / Włosy / Czepki na włosy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Koloryzacja",
    "categoryPath": [
      "(47631) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(47631) Uroda / Pielęgnacja / Włosy / Koloryzacja",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Lakiery",
    "categoryPath": [
      "(259381) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259381) Uroda / Pielęgnacja / Włosy / Lakiery",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Maski do włosów",
    "categoryPath": [
      "(89001) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(89001) Uroda / Pielęgnacja / Włosy / Maski do włosów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Nabłyszczanie, wygładzanie",
    "categoryPath": [
      "(259386) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259386) Uroda / Pielęgnacja / Włosy / Nabłyszczanie, wygładzanie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Odżywki do włosów",
    "categoryPath": [
      "(5364) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(5364) Uroda / Pielęgnacja / Włosy / Odżywki do włosów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Olejki do włosów",
    "categoryPath": [
      "(144744) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(144744) Uroda / Pielęgnacja / Włosy / Olejki do włosów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pasma",
    "categoryPath": [
      "(261677) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(261677) Uroda / Pielęgnacja / Włosy / Pasma",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Peelingi do skóry głowy",
    "categoryPath": [
      "(308941) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(308941) Uroda / Pielęgnacja / Włosy / Peelingi do skóry głowy",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Peruki, treski",
    "categoryPath": [
      "(261678) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(261678) Uroda / Pielęgnacja / Włosy / Peruki, treski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pianki",
    "categoryPath": [
      "(259382) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259382) Uroda / Pielęgnacja / Włosy / Pianki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(5365) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(5365) Uroda / Pielęgnacja / Włosy / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty do zagęszczania",
    "categoryPath": [
      "(260142) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(260142) Uroda / Pielęgnacja / Włosy / Preparaty do zagęszczania",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Prostowanie",
    "categoryPath": [
      "(259384) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259384) Uroda / Pielęgnacja / Włosy / Prostowanie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Pudry",
    "categoryPath": [
      "(259385) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259385) Uroda / Pielęgnacja / Włosy / Pudry",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Płyny do ondulacji",
    "categoryPath": [
      "(322095) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(322095) Uroda / Pielęgnacja / Włosy / Płyny do ondulacji",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szampony",
    "categoryPath": [
      "(5363) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(5363) Uroda / Pielęgnacja / Włosy / Szampony",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szampony suche",
    "categoryPath": [
      "(259391) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259391) Uroda / Pielęgnacja / Włosy / Szampony suche",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Grzebienie",
    "categoryPath": [
      "(259696) Uroda",
      "Pielęgnacja",
      "Włosy",
      "Szczotki i grzebienie"
    ],
    "hierarchy": "(259696) Uroda / Pielęgnacja / Włosy / Szczotki i grzebienie / Grzebienie",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Szczotki",
    "categoryPath": [
      "(259695) Uroda",
      "Pielęgnacja",
      "Włosy",
      "Szczotki i grzebienie"
    ],
    "hierarchy": "(259695) Uroda / Pielęgnacja / Włosy / Szczotki i grzebienie / Szczotki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Termoochrona włosów",
    "categoryPath": [
      "(259387) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259387) Uroda / Pielęgnacja / Włosy / Termoochrona włosów",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Termoloki",
    "categoryPath": [
      "(259703) Uroda",
      "Pielęgnacja",
      "Włosy",
      "Urządzenia do stylizacji"
    ],
    "hierarchy": "(259703) Uroda / Pielęgnacja / Włosy / Urządzenia do stylizacji / Termoloki",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Wałki i papiloty",
    "categoryPath": [
      "(259390) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259390) Uroda / Pielęgnacja / Włosy / Wałki i papiloty",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Żele, gumy, woski",
    "categoryPath": [
      "(259383) Uroda",
      "Pielęgnacja",
      "Włosy"
    ],
    "hierarchy": "(259383) Uroda / Pielęgnacja / Włosy / Żele, gumy, woski",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Zestawy kosmetyków",
    "categoryPath": [
      "(1437) Uroda",
      "Pielęgnacja"
    ],
    "hierarchy": "(1437) Uroda / Pielęgnacja / Zestawy kosmetyków",
    "comissionGroupOld": "C18",
    "comissionGroupNew": "D15"
  },
  {
    "segment": "Recepcje",
    "categoryPath": [
      "(261672) Uroda",
      "Profesjonalne wyposażenie salonów"
    ],
    "hierarchy": "(261672) Uroda / Profesjonalne wyposażenie salonów / Recepcje",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Aplikatory do farb",
    "categoryPath": [
      "(315735) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(315735) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Aplikatory do farb",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Fartuchy, peleryny fryzjerskie",
    "categoryPath": [
      "(261538) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261538) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Fartuchy, peleryny fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Folie fryzjerskie",
    "categoryPath": [
      "(261541) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261541) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Folie fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Gumki do włosów, do wałków",
    "categoryPath": [
      "(261544) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261544) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Gumki do włosów, do wałków",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Główki fryzjerskie",
    "categoryPath": [
      "(261476) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261476) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Główki fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kabury fryzjerskie",
    "categoryPath": [
      "(261475) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261475) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Kabury fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klipsy, klamry, wsuwki fryzjerskie",
    "categoryPath": [
      "(261548) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261548) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Klipsy, klamry, wsuwki fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kołnierze fryzjerskie",
    "categoryPath": [
      "(261474) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261474) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Kołnierze fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lustra fryzjerskie",
    "categoryPath": [
      "(261547) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261547) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Lustra fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miseczki, pędzelki do farbowania",
    "categoryPath": [
      "(261546) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261546) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Miseczki, pędzelki do farbowania",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pędzle fryzjerskie, szczotki karkówki",
    "categoryPath": [
      "(261539) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261539) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Pędzle fryzjerskie, szczotki karkówki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Rozpylacze fryzjerskie",
    "categoryPath": [
      "(261542) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261542) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Rozpylacze fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ręczniki fryzjerskie",
    "categoryPath": [
      "(308953) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(308953) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Ręczniki fryzjerskie",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Siatki fryzjerskie na włosy, na wałki",
    "categoryPath": [
      "(261473) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261473) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Siatki fryzjerskie na włosy, na wałki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stojaki na nożyczki",
    "categoryPath": [
      "(315738) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(315738) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Stojaki na nożyczki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Taśmy klejowe do przedłużania włosów",
    "categoryPath": [
      "(261543) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261543) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Taśmy klejowe do przedłużania włosów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Tulejki, ringi",
    "categoryPath": [
      "(261545) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261545) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Tulejki, ringi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Uchwyty na suszarkę",
    "categoryPath": [
      "(261540) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(261540) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Uchwyty na suszarkę",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Wyciskarki do tubek",
    "categoryPath": [
      "(315741) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Akcesoria"
    ],
    "hierarchy": "(315741) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Akcesoria / Wyciskarki do tubek",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Fotele barberskie",
    "categoryPath": [
      "(261667) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Meble fryzjerskie"
    ],
    "hierarchy": "(261667) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Meble fryzjerskie / Fotele barberskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Fotele fryzjerskie",
    "categoryPath": [
      "(261666) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Meble fryzjerskie"
    ],
    "hierarchy": "(261666) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Meble fryzjerskie / Fotele fryzjerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Konsole fryzjerskie",
    "categoryPath": [
      "(261669) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Meble fryzjerskie"
    ],
    "hierarchy": "(261669) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Meble fryzjerskie / Konsole fryzjerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podnóżki",
    "categoryPath": [
      "(261671) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Meble fryzjerskie"
    ],
    "hierarchy": "(261671) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Meble fryzjerskie / Podnóżki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pomocniki, wózki",
    "categoryPath": [
      "(261670) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Meble fryzjerskie"
    ],
    "hierarchy": "(261670) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Meble fryzjerskie / Pomocniki, wózki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Taborety, hokery, krzesła",
    "categoryPath": [
      "(261668) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Meble fryzjerskie"
    ],
    "hierarchy": "(261668) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Meble fryzjerskie / Taborety, hokery, krzesła",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Grzebienie fryzjerskie",
    "categoryPath": [
      "(261408) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Narzędzia fryzjerskie"
    ],
    "hierarchy": "(261408) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Narzędzia fryzjerskie / Grzebienie fryzjerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nożyczki fryzjerskie, degażówki",
    "categoryPath": [
      "(261409) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Narzędzia fryzjerskie"
    ],
    "hierarchy": "(261409) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Narzędzia fryzjerskie / Nożyczki fryzjerskie, degażówki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szczotki fryzjerskie",
    "categoryPath": [
      "(261407) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Narzędzia fryzjerskie"
    ],
    "hierarchy": "(261407) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Narzędzia fryzjerskie / Szczotki fryzjerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szczypce fryzjerskie",
    "categoryPath": [
      "(261410) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Narzędzia fryzjerskie"
    ],
    "hierarchy": "(261410) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Narzędzia fryzjerskie / Szczypce fryzjerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szydełka fryzjerskie",
    "categoryPath": [
      "(261411) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Narzędzia fryzjerskie"
    ],
    "hierarchy": "(261411) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Narzędzia fryzjerskie / Szydełka fryzjerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122624) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie"
    ],
    "hierarchy": "(122624) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Baterie, słuchawki natryskowe do myjni fryzjerskich",
    "categoryPath": [
      "(261401) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Sprzęt fryzjerski"
    ],
    "hierarchy": "(261401) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Sprzęt fryzjerski / Baterie, słuchawki natryskowe do myjni fryzjerskich",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Infrazony",
    "categoryPath": [
      "(261404) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Sprzęt fryzjerski"
    ],
    "hierarchy": "(261404) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Sprzęt fryzjerski / Infrazony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Myjki fryzjerskie przenośne",
    "categoryPath": [
      "(261400) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Sprzęt fryzjerski"
    ],
    "hierarchy": "(261400) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Sprzęt fryzjerski / Myjki fryzjerskie przenośne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Myjnie fryzjerskie",
    "categoryPath": [
      "(261399) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Sprzęt fryzjerski"
    ],
    "hierarchy": "(261399) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Sprzęt fryzjerski / Myjnie fryzjerskie",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sauny do włosów",
    "categoryPath": [
      "(261405) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Sprzęt fryzjerski"
    ],
    "hierarchy": "(261405) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Sprzęt fryzjerski / Sauny do włosów",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Suszarki hełmowe",
    "categoryPath": [
      "(261403) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony fryzjerskie",
      "Sprzęt fryzjerski"
    ],
    "hierarchy": "(261403) Uroda / Profesjonalne wyposażenie salonów / Salony fryzjerskie / Sprzęt fryzjerski / Suszarki hełmowe",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Biustonosze jednorazowe",
    "categoryPath": [
      "(308965) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(308965) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Biustonosze jednorazowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Brodziki do pedicure",
    "categoryPath": [
      "(300821) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(300821) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Brodziki do pedicure",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Chusty kosmetyczne",
    "categoryPath": [
      "(308977) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(308977) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Chusty kosmetyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Folie do zabiegów",
    "categoryPath": [
      "(315756) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(315756) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Folie do zabiegów",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Klapki, japonki jednorazowe",
    "categoryPath": [
      "(308989) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(308989) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Klapki, japonki jednorazowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kosmetyczki i kuferki",
    "categoryPath": [
      "(122609) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(122609) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Kosmetyczki i kuferki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kołderki kosmetyczne",
    "categoryPath": [
      "(309001) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(309001) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Kołderki kosmetyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Membrany do kriolipolizy",
    "categoryPath": [
      "(309037) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(309037) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Membrany do kriolipolizy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miarki do brwi",
    "categoryPath": [
      "(315768) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(315768) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Miarki do brwi",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Miseczki kosmetyczne",
    "categoryPath": [
      "(300817) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(300817) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Miseczki kosmetyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Opaski",
    "categoryPath": [
      "(300825) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(300825) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Opaski",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Peleryny kosmetyczne",
    "categoryPath": [
      "(300813) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(300813) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Peleryny kosmetyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Prześcieradła, pokrowce na fotele i taborety kosmetyczne",
    "categoryPath": [
      "(300829) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(300829) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Prześcieradła, pokrowce na fotele i taborety kosmetyczne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Stringi jednorazowe",
    "categoryPath": [
      "(309025) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(309025) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Stringi jednorazowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Łyżeczki unny",
    "categoryPath": [
      "(309013) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Akcesoria"
    ],
    "hierarchy": "(309013) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Akcesoria / Łyżeczki unny",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lampy kosmetyczne",
    "categoryPath": [
      "(122628) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne"
    ],
    "hierarchy": "(122628) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Lampy kosmetyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Biurka kosmetyczne",
    "categoryPath": [
      "(309049) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Meble kosmetyczne"
    ],
    "hierarchy": "(309049) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Meble kosmetyczne / Biurka kosmetyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Fotele kosmetyczne",
    "categoryPath": [
      "(300641) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Meble kosmetyczne"
    ],
    "hierarchy": "(300641) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Meble kosmetyczne / Fotele kosmetyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podnóżki na fotele",
    "categoryPath": [
      "(300637) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Meble kosmetyczne",
      "Podnóżki do pedicure"
    ],
    "hierarchy": "(300637) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Meble kosmetyczne / Podnóżki do pedicure / Podnóżki na fotele",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podnóżki wolnostojące",
    "categoryPath": [
      "(300633) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Meble kosmetyczne",
      "Podnóżki do pedicure"
    ],
    "hierarchy": "(300633) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Meble kosmetyczne / Podnóżki do pedicure / Podnóżki wolnostojące",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pomocniki, wózki, stoliki",
    "categoryPath": [
      "(122629) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Meble kosmetyczne"
    ],
    "hierarchy": "(122629) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Meble kosmetyczne / Pomocniki, wózki, stoliki",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Taborety kosmetyczne",
    "categoryPath": [
      "(122627) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Meble kosmetyczne"
    ],
    "hierarchy": "(122627) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Meble kosmetyczne / Taborety kosmetyczne",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odzież kosmetyczna",
    "categoryPath": [
      "(122626) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne"
    ],
    "hierarchy": "(122626) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Odzież kosmetyczna",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122637) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne"
    ],
    "hierarchy": "(122637) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Do mikrodermabrazji",
    "categoryPath": [
      "(122631) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(122631) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Urządzenia kosmetyczne / Do mikrodermabrazji",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kapsuły",
    "categoryPath": [
      "(122632) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(122632) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Urządzenia kosmetyczne / Kapsuły",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kombajny",
    "categoryPath": [
      "(122633) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(122633) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Urządzenia kosmetyczne / Kombajny",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lasery",
    "categoryPath": [
      "(122634) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(122634) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Urządzenia kosmetyczne / Lasery",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podgrzewacze ręczników",
    "categoryPath": [
      "(300645) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(300645) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Urządzenia kosmetyczne / Podgrzewacze ręczników",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wapozony",
    "categoryPath": [
      "(122635) Uroda",
      "Profesjonalne wyposażenie salonów",
      "Salony kosmetyczne",
      "Urządzenia kosmetyczne"
    ],
    "hierarchy": "(122635) Uroda / Profesjonalne wyposażenie salonów / Salony kosmetyczne / Urządzenia kosmetyczne / Wapozony",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Salony tatuażu",
    "categoryPath": [
      "(122608) Uroda",
      "Profesjonalne wyposażenie salonów"
    ],
    "hierarchy": "(122608) Uroda / Profesjonalne wyposażenie salonów / Salony tatuażu",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Solaria",
    "categoryPath": [
      "(122638) Uroda",
      "Profesjonalne wyposażenie salonów"
    ],
    "hierarchy": "(122638) Uroda / Profesjonalne wyposażenie salonów / Solaria",
    "comissionGroupOld": "C12",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Antyperspiranty",
    "categoryPath": [
      "(258389) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała"
    ],
    "hierarchy": "(258389) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Antyperspiranty",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Balsamy, masła, kremy do ciała",
    "categoryPath": [
      "(258390) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała"
    ],
    "hierarchy": "(258390) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Balsamy, masła, kremy do ciała",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kremy do rąk",
    "categoryPath": [
      "(258393) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała"
    ],
    "hierarchy": "(258393) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Kremy do rąk",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kremy do stóp",
    "categoryPath": [
      "(258394) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała"
    ],
    "hierarchy": "(258394) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Kremy do stóp",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Mydła",
    "categoryPath": [
      "(258383) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(258383) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Kąpiel i prysznic / Mydła",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Płyny, emulsje, olejki",
    "categoryPath": [
      "(258385) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(258385) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Kąpiel i prysznic / Płyny, emulsje, olejki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Sole i kule",
    "categoryPath": [
      "(258379) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(258379) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Kąpiel i prysznic / Sole i kule",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Żele",
    "categoryPath": [
      "(258381) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała",
      "Kąpiel i prysznic"
    ],
    "hierarchy": "(258381) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Kąpiel i prysznic / Żele",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Mgiełki do ciała",
    "categoryPath": [
      "(258391) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała"
    ],
    "hierarchy": "(258391) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Mgiełki do ciała",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Olejki do ciała",
    "categoryPath": [
      "(258387) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała"
    ],
    "hierarchy": "(258387) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Olejki do ciała",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Peelingi i scruby do ciała",
    "categoryPath": [
      "(258392) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do ciała"
    ],
    "hierarchy": "(258392) Zdrowie / Dermokosmetyki / Dermokosmetyki do ciała / Peelingi i scruby do ciała",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kosmetyki po opalaniu",
    "categoryPath": [
      "(258356) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do opalania"
    ],
    "hierarchy": "(258356) Zdrowie / Dermokosmetyki / Dermokosmetyki do opalania / Kosmetyki po opalaniu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Opalanie na słońcu",
    "categoryPath": [
      "(258357) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do opalania"
    ],
    "hierarchy": "(258357) Zdrowie / Dermokosmetyki / Dermokosmetyki do opalania / Opalanie na słońcu",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Samoopalacze, preparaty brązujące",
    "categoryPath": [
      "(258355) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do opalania"
    ],
    "hierarchy": "(258355) Zdrowie / Dermokosmetyki / Dermokosmetyki do opalania / Samoopalacze, preparaty brązujące",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kremy do twarzy",
    "categoryPath": [
      "(258370) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258370) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Kremy do twarzy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kremy pod oczy",
    "categoryPath": [
      "(258369) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258369) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Kremy pod oczy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Korektory",
    "categoryPath": [
      "(258382) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy",
      "Makijaż"
    ],
    "hierarchy": "(258382) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Makijaż / Korektory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kremy koloryzujące",
    "categoryPath": [
      "(258384) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy",
      "Makijaż"
    ],
    "hierarchy": "(258384) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Makijaż / Kremy koloryzujące",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Podkłady i fluidy",
    "categoryPath": [
      "(258377) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy",
      "Makijaż"
    ],
    "hierarchy": "(258377) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Makijaż / Podkłady i fluidy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pomadki",
    "categoryPath": [
      "(258386) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy",
      "Makijaż"
    ],
    "hierarchy": "(258386) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Makijaż / Pomadki",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Pudry",
    "categoryPath": [
      "(258380) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy",
      "Makijaż"
    ],
    "hierarchy": "(258380) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Makijaż / Pudry",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Maseczki do twarzy",
    "categoryPath": [
      "(258373) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258373) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Maseczki do twarzy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Oczyszczanie i demakijaż",
    "categoryPath": [
      "(258371) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258371) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Oczyszczanie i demakijaż",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Olejki do twarzy",
    "categoryPath": [
      "(258368) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258368) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Olejki do twarzy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Peelingi i scruby do twarzy",
    "categoryPath": [
      "(258366) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258366) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Peelingi i scruby do twarzy",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Serum",
    "categoryPath": [
      "(258367) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258367) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Serum",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Toniki, hydrolaty, wody termalne",
    "categoryPath": [
      "(258372) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do twarzy"
    ],
    "hierarchy": "(258372) Zdrowie / Dermokosmetyki / Dermokosmetyki do twarzy / Toniki, hydrolaty, wody termalne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Kuracje do włosów",
    "categoryPath": [
      "(258360) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do włosów"
    ],
    "hierarchy": "(258360) Zdrowie / Dermokosmetyki / Dermokosmetyki do włosów / Kuracje do włosów",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Odżywki, maski, balsamy do włosów",
    "categoryPath": [
      "(258361) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do włosów"
    ],
    "hierarchy": "(258361) Zdrowie / Dermokosmetyki / Dermokosmetyki do włosów / Odżywki, maski, balsamy do włosów",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Olejki do włosów",
    "categoryPath": [
      "(258363) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do włosów"
    ],
    "hierarchy": "(258363) Zdrowie / Dermokosmetyki / Dermokosmetyki do włosów / Olejki do włosów",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Szampony",
    "categoryPath": [
      "(258362) Zdrowie",
      "Dermokosmetyki",
      "Dermokosmetyki do włosów"
    ],
    "hierarchy": "(258362) Zdrowie / Dermokosmetyki / Dermokosmetyki do włosów / Szampony",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Zestawy dermokosmetyków",
    "categoryPath": [
      "(258396) Zdrowie",
      "Dermokosmetyki"
    ],
    "hierarchy": "(258396) Zdrowie / Dermokosmetyki / Zestawy dermokosmetyków",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Apteczki pierwszej pomocy",
    "categoryPath": [
      "(300389) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300389) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Apteczki pierwszej pomocy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bandaże, opaski, siatki opatrunkowe",
    "categoryPath": [
      "(300373) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300373) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Bandaże, opaski, siatki opatrunkowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gazy i kompresy",
    "categoryPath": [
      "(300381) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300381) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Gazy i kompresy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Obturatory, piratki, ortopady",
    "categoryPath": [
      "(310753) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(310753) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Obturatory, piratki, ortopady",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Opatrunki specjalistyczne",
    "categoryPath": [
      "(300385) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300385) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Opatrunki specjalistyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Opatrunki unieruchamiające",
    "categoryPath": [
      "(300377) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300377) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Opatrunki unieruchamiające",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Paski do zamykania ran",
    "categoryPath": [
      "(300369) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300369) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Paski do zamykania ran",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Plastry, przylepce, taśmy opatrunkowe",
    "categoryPath": [
      "(300365) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300365) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Plastry, przylepce, taśmy opatrunkowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Waty i ligniny",
    "categoryPath": [
      "(300361) Zdrowie",
      "Domowa apteczka",
      "Materiały opatrunkowe"
    ],
    "hierarchy": "(300361) Zdrowie / Domowa apteczka / Materiały opatrunkowe / Waty i ligniny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Preparaty do nosa",
    "categoryPath": [
      "(322361) Zdrowie",
      "Domowa apteczka"
    ],
    "hierarchy": "(322361) Zdrowie / Domowa apteczka / Preparaty do nosa",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Preparaty do oczu",
    "categoryPath": [
      "(322359) Zdrowie",
      "Domowa apteczka"
    ],
    "hierarchy": "(322359) Zdrowie / Domowa apteczka / Preparaty do oczu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Preparaty do uszu",
    "categoryPath": [
      "(322362) Zdrowie",
      "Domowa apteczka"
    ],
    "hierarchy": "(322362) Zdrowie / Domowa apteczka / Preparaty do uszu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Preparaty na wszy i gnidy",
    "categoryPath": [
      "(322374) Zdrowie",
      "Domowa apteczka"
    ],
    "hierarchy": "(322374) Zdrowie / Domowa apteczka / Preparaty na wszy i gnidy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dla dzieci",
    "categoryPath": [
      "(122565) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122565) Zdrowie / Domowa apteczka / Suplementy diety / Dla dzieci",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dla kobiet w ciąży i mam karmiących",
    "categoryPath": [
      "(322364) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(322364) Zdrowie / Domowa apteczka / Suplementy diety / Dla kobiet w ciąży i mam karmiących",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kontrola wagi",
    "categoryPath": [
      "(257513) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(257513) Zdrowie / Domowa apteczka / Suplementy diety / Kontrola wagi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oczyszczanie",
    "categoryPath": [
      "(122566) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122566) Zdrowie / Domowa apteczka / Suplementy diety / Oczyszczanie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odporność",
    "categoryPath": [
      "(122567) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122567) Zdrowie / Domowa apteczka / Suplementy diety / Odporność",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pamięć, układ nerwowy",
    "categoryPath": [
      "(122568) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122568) Zdrowie / Domowa apteczka / Suplementy diety / Pamięć, układ nerwowy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122576) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122576) Zdrowie / Domowa apteczka / Suplementy diety / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty witaminowo-mineralne",
    "categoryPath": [
      "(122569) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122569) Zdrowie / Domowa apteczka / Suplementy diety / Preparaty witaminowo-mineralne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skóra, włosy, paznokcie",
    "categoryPath": [
      "(122570) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122570) Zdrowie / Domowa apteczka / Suplementy diety / Skóra, włosy, paznokcie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sprawność seksualna",
    "categoryPath": [
      "(122571) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122571) Zdrowie / Domowa apteczka / Suplementy diety / Sprawność seksualna",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stawy, kości, mięśnie",
    "categoryPath": [
      "(122572) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122572) Zdrowie / Domowa apteczka / Suplementy diety / Stawy, kości, mięśnie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Układ krążenia",
    "categoryPath": [
      "(257514) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(257514) Zdrowie / Domowa apteczka / Suplementy diety / Układ krążenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Układ moczowy",
    "categoryPath": [
      "(122573) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122573) Zdrowie / Domowa apteczka / Suplementy diety / Układ moczowy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Układ pokarmowy",
    "categoryPath": [
      "(122574) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122574) Zdrowie / Domowa apteczka / Suplementy diety / Układ pokarmowy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wzrok",
    "categoryPath": [
      "(122575) Zdrowie",
      "Domowa apteczka",
      "Suplementy diety"
    ],
    "hierarchy": "(122575) Zdrowie / Domowa apteczka / Suplementy diety / Wzrok",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Testy diagnostyczne",
    "categoryPath": [
      "(320269) Zdrowie",
      "Domowa apteczka"
    ],
    "hierarchy": "(320269) Zdrowie / Domowa apteczka / Testy diagnostyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żywność medyczna",
    "categoryPath": [
      "(320266) Zdrowie",
      "Domowa apteczka"
    ],
    "hierarchy": "(320266) Zdrowie / Domowa apteczka / Żywność medyczna",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Depilacja i higiena intymna",
    "categoryPath": [
      "(63790) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63790) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Depilacja i higiena intymna",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Ekspandery",
    "categoryPath": [
      "(63791) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63791) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Ekspandery",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Gadżety i zabawki",
    "categoryPath": [
      "(63792) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63792) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Gadżety i zabawki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Huśtawki miłosne",
    "categoryPath": [
      "(63793) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63793) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Huśtawki miłosne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Korki i sondy analne",
    "categoryPath": [
      "(63794) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63794) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Korki i sondy analne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kulki i jajka stymulujące",
    "categoryPath": [
      "(63795) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63795) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Kulki i jajka stymulujące",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Lalki miłości",
    "categoryPath": [
      "(63796) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63796) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Lalki miłości",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Masażery i motylki",
    "categoryPath": [
      "(64959) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(64959) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Masażery i motylki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Masażery prostaty",
    "categoryPath": [
      "(310509) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(310509) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Masażery prostaty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Penisy i dilda",
    "categoryPath": [
      "(63797) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63797) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Penisy i dilda",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Nasadki i nakładki",
    "categoryPath": [
      "(63802) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Pierścienie i nasadki"
    ],
    "hierarchy": "(63802) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Pierścienie i nasadki / Nasadki i nakładki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pierścienie i zaciski",
    "categoryPath": [
      "(63803) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Pierścienie i nasadki"
    ],
    "hierarchy": "(63803) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Pierścienie i nasadki / Pierścienie i zaciski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Przedłużki",
    "categoryPath": [
      "(63804) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Pierścienie i nasadki"
    ],
    "hierarchy": "(63804) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Pierścienie i nasadki / Przedłużki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pochwy i masturbatory",
    "categoryPath": [
      "(63805) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63805) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Pochwy i masturbatory",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pompki",
    "categoryPath": [
      "(63806) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(63806) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Pompki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Rury do tańca",
    "categoryPath": [
      "(98315) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(98315) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Rury do tańca",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Cukierki erotyczne",
    "categoryPath": [
      "(314937) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Słodycze erotyczne"
    ],
    "hierarchy": "(314937) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Słodycze erotyczne / Cukierki erotyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Czekoladki i figurki erotyczne",
    "categoryPath": [
      "(314925) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Słodycze erotyczne"
    ],
    "hierarchy": "(314925) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Słodycze erotyczne / Czekoladki i figurki erotyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Farby do malowania ciała",
    "categoryPath": [
      "(314901) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Słodycze erotyczne"
    ],
    "hierarchy": "(314901) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Słodycze erotyczne / Farby do malowania ciała",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Jadalna bielizna",
    "categoryPath": [
      "(63789) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Słodycze erotyczne"
    ],
    "hierarchy": "(63789) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Słodycze erotyczne / Jadalna bielizna",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Lizaki erotyczne",
    "categoryPath": [
      "(314913) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Słodycze erotyczne"
    ],
    "hierarchy": "(314913) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Słodycze erotyczne / Lizaki erotyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Klasyczne",
    "categoryPath": [
      "(63808) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Wibratory"
    ],
    "hierarchy": "(63808) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Wibratory / Klasyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Naturalne",
    "categoryPath": [
      "(63809) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Wibratory"
    ],
    "hierarchy": "(63809) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Wibratory / Naturalne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(63813) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Wibratory"
    ],
    "hierarchy": "(63813) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Wibratory / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stymulujące punkt G",
    "categoryPath": [
      "(63810) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Wibratory"
    ],
    "hierarchy": "(63810) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Wibratory / Stymulujące punkt G",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Wielofunkcyjne",
    "categoryPath": [
      "(63811) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Wibratory"
    ],
    "hierarchy": "(63811) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Wibratory / Wielofunkcyjne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(63812) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne",
      "Wibratory"
    ],
    "hierarchy": "(63812) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Wibratory / Zestawy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy do klonowania",
    "categoryPath": [
      "(310549) Zdrowie",
      "Erotyka",
      "Akcesoria i gadżety erotyczne"
    ],
    "hierarchy": "(310549) Zdrowie / Erotyka / Akcesoria i gadżety erotyczne / Zestawy do klonowania",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Dilatory",
    "categoryPath": [
      "(310561) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(310561) Zdrowie / Erotyka / BDSM / Dilatory",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kajdanki",
    "categoryPath": [
      "(63773) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63773) Zdrowie / Erotyka / BDSM / Kajdanki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Klamry i klipsy",
    "categoryPath": [
      "(63775) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63775) Zdrowie / Erotyka / BDSM / Klamry i klipsy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Klatki erekcyjne",
    "categoryPath": [
      "(63774) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63774) Zdrowie / Erotyka / BDSM / Klatki erekcyjne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Kneble",
    "categoryPath": [
      "(63777) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63777) Zdrowie / Erotyka / BDSM / Kneble",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Koła kolczaste",
    "categoryPath": [
      "(310573) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(310573) Zdrowie / Erotyka / BDSM / Koła kolczaste",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Lewatywy",
    "categoryPath": [
      "(63778) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63778) Zdrowie / Erotyka / BDSM / Lewatywy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Linki",
    "categoryPath": [
      "(63779) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63779) Zdrowie / Erotyka / BDSM / Linki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Maski",
    "categoryPath": [
      "(63780) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63780) Zdrowie / Erotyka / BDSM / Maski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Meble i urządzenia",
    "categoryPath": [
      "(63781) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63781) Zdrowie / Erotyka / BDSM / Meble i urządzenia",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pasy cnoty",
    "categoryPath": [
      "(63782) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63782) Zdrowie / Erotyka / BDSM / Pasy cnoty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pejcze i baty",
    "categoryPath": [
      "(63783) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63783) Zdrowie / Erotyka / BDSM / Pejcze i baty",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Piórka do łaskotania",
    "categoryPath": [
      "(310585) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(310585) Zdrowie / Erotyka / BDSM / Piórka do łaskotania",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(63788) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63788) Zdrowie / Erotyka / BDSM / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pościele",
    "categoryPath": [
      "(63784) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63784) Zdrowie / Erotyka / BDSM / Pościele",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Smycze i obroże",
    "categoryPath": [
      "(63785) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63785) Zdrowie / Erotyka / BDSM / Smycze i obroże",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Uprzęże",
    "categoryPath": [
      "(63786) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63786) Zdrowie / Erotyka / BDSM / Uprzęże",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Wzierniki",
    "categoryPath": [
      "(63787) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(63787) Zdrowie / Erotyka / BDSM / Wzierniki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Zestawy BDSM",
    "categoryPath": [
      "(310597) Zdrowie",
      "Erotyka",
      "BDSM"
    ],
    "hierarchy": "(310597) Zdrowie / Erotyka / BDSM / Zestawy BDSM",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Biustonosze",
    "categoryPath": [
      "(63814) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63814) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Biustonosze",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Body",
    "categoryPath": [
      "(63815) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63815) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Body",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Bodystocking",
    "categoryPath": [
      "(63816) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63816) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Bodystocking",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Clubwear - Dancewear",
    "categoryPath": [
      "(73874) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(73874) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Clubwear - Dancewear",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dla mężczyzn",
    "categoryPath": [
      "(63824) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63824) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Dla mężczyzn",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Dodatki",
    "categoryPath": [
      "(63827) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63827) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Dodatki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Figi i stringi",
    "categoryPath": [
      "(63817) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63817) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Figi i stringi",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Gorsety",
    "categoryPath": [
      "(63818) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63818) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Gorsety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Halki i koszulki",
    "categoryPath": [
      "(63819) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63819) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Halki i koszulki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety",
    "categoryPath": [
      "(63820) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63820) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Komplety",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Kostiumy i przebrania",
    "categoryPath": [
      "(63821) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63821) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Kostiumy i przebrania",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Latex, lack, vinyl",
    "categoryPath": [
      "(63823) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63823) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Latex, lack, vinyl",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pończochy i rajstopy",
    "categoryPath": [
      "(63825) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63825) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Pończochy i rajstopy",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Skóra",
    "categoryPath": [
      "(63826) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(63826) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Skóra",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki",
    "categoryPath": [
      "(73873) Zdrowie",
      "Erotyka",
      "Bielizna i odzież erotyczna"
    ],
    "hierarchy": "(73873) Zdrowie / Erotyka / Bielizna i odzież erotyczna / Sukienki",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Biżuteria erotyczna",
    "categoryPath": [
      "(63761) Zdrowie",
      "Erotyka"
    ],
    "hierarchy": "(63761) Zdrowie / Erotyka / Biżuteria erotyczna",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Dłuższy seks",
    "categoryPath": [
      "(63833) Zdrowie",
      "Erotyka",
      "Drogeria erotyczna"
    ],
    "hierarchy": "(63833) Zdrowie / Erotyka / Drogeria erotyczna / Dłuższy seks",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Masaż ciała (olejki i żele)",
    "categoryPath": [
      "(64957) Zdrowie",
      "Erotyka",
      "Drogeria erotyczna"
    ],
    "hierarchy": "(64957) Zdrowie / Erotyka / Drogeria erotyczna / Masaż ciała (olejki i żele)",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Potencja i libido",
    "categoryPath": [
      "(63835) Zdrowie",
      "Erotyka",
      "Drogeria erotyczna"
    ],
    "hierarchy": "(63835) Zdrowie / Erotyka / Drogeria erotyczna / Potencja i libido",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Preparaty do czyszczenia",
    "categoryPath": [
      "(310609) Zdrowie",
      "Erotyka",
      "Drogeria erotyczna"
    ],
    "hierarchy": "(310609) Zdrowie / Erotyka / Drogeria erotyczna / Preparaty do czyszczenia",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Seks oralny (krople, kremy i żele)",
    "categoryPath": [
      "(64958) Zdrowie",
      "Erotyka",
      "Drogeria erotyczna"
    ],
    "hierarchy": "(64958) Zdrowie / Erotyka / Drogeria erotyczna / Seks oralny (krople, kremy i żele)",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Środki powiększające",
    "categoryPath": [
      "(63836) Zdrowie",
      "Erotyka",
      "Drogeria erotyczna"
    ],
    "hierarchy": "(63836) Zdrowie / Erotyka / Drogeria erotyczna / Środki powiększające",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Walentynki",
    "categoryPath": [
      "(111693) Zdrowie",
      "Erotyka",
      "Erotyka okazje"
    ],
    "hierarchy": "(111693) Zdrowie / Erotyka / Erotyka okazje / Walentynki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Wieczór kawalerski",
    "categoryPath": [
      "(98318) Zdrowie",
      "Erotyka",
      "Erotyka okazje"
    ],
    "hierarchy": "(98318) Zdrowie / Erotyka / Erotyka okazje / Wieczór kawalerski",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Wieczór panieński",
    "categoryPath": [
      "(98317) Zdrowie",
      "Erotyka",
      "Erotyka okazje"
    ],
    "hierarchy": "(98317) Zdrowie / Erotyka / Erotyka okazje / Wieczór panieński",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Feromony i afrodyzjaki",
    "categoryPath": [
      "(63769) Zdrowie",
      "Erotyka"
    ],
    "hierarchy": "(63769) Zdrowie / Erotyka / Feromony i afrodyzjaki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Filmy erotyczne",
    "categoryPath": [
      "(63764) Zdrowie",
      "Erotyka"
    ],
    "hierarchy": "(63764) Zdrowie / Erotyka / Filmy erotyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Gry erotyczne",
    "categoryPath": [
      "(63765) Zdrowie",
      "Erotyka"
    ],
    "hierarchy": "(63765) Zdrowie / Erotyka / Gry erotyczne",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Czasopisma",
    "categoryPath": [
      "(63772) Zdrowie",
      "Erotyka",
      "Literatura erotyczna"
    ],
    "hierarchy": "(63772) Zdrowie / Erotyka / Literatura erotyczna / Czasopisma",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Komiksy",
    "categoryPath": [
      "(63857) Zdrowie",
      "Erotyka",
      "Literatura erotyczna"
    ],
    "hierarchy": "(63857) Zdrowie / Erotyka / Literatura erotyczna / Komiksy",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Poradniki",
    "categoryPath": [
      "(63858) Zdrowie",
      "Erotyka",
      "Literatura erotyczna"
    ],
    "hierarchy": "(63858) Zdrowie / Erotyka / Literatura erotyczna / Poradniki",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Powieści",
    "categoryPath": [
      "(63859) Zdrowie",
      "Erotyka",
      "Literatura erotyczna"
    ],
    "hierarchy": "(63859) Zdrowie / Erotyka / Literatura erotyczna / Powieści",
    "comissionGroupOld": "C27",
    "comissionGroupNew": "D21"
  },
  {
    "segment": "Obuwie erotyczne",
    "categoryPath": [
      "(63768) Zdrowie",
      "Erotyka"
    ],
    "hierarchy": "(63768) Zdrowie / Erotyka / Obuwie erotyczne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(63770) Zdrowie",
      "Erotyka"
    ],
    "hierarchy": "(63770) Zdrowie / Erotyka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(260540) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(260540) Zdrowie / Higiena jamy ustnej / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Irygatory",
    "categoryPath": [
      "(257761) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257761) Zdrowie / Higiena jamy ustnej / Irygatory",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Końcówki do irygatorów",
    "categoryPath": [
      "(257762) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257762) Zdrowie / Higiena jamy ustnej / Końcówki do irygatorów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Końcówki do szczoteczek",
    "categoryPath": [
      "(257763) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257763) Zdrowie / Higiena jamy ustnej / Końcówki do szczoteczek",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nakładki na zęby",
    "categoryPath": [
      "(317480) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(317480) Zdrowie / Higiena jamy ustnej / Nakładki na zęby",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nici dentystyczne",
    "categoryPath": [
      "(257764) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257764) Zdrowie / Higiena jamy ustnej / Nici dentystyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pasty",
    "categoryPath": [
      "(257765) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257765) Zdrowie / Higiena jamy ustnej / Pasty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pielęgnacja protez i aparatów ortodontycznych",
    "categoryPath": [
      "(257766) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257766) Zdrowie / Higiena jamy ustnej / Pielęgnacja protez i aparatów ortodontycznych",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(257770) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257770) Zdrowie / Higiena jamy ustnej / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Płyny do płukania ust",
    "categoryPath": [
      "(257767) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257767) Zdrowie / Higiena jamy ustnej / Płyny do płukania ust",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Manualne",
    "categoryPath": [
      "(257772) Zdrowie",
      "Higiena jamy ustnej",
      "Szczoteczki"
    ],
    "hierarchy": "(257772) Zdrowie / Higiena jamy ustnej / Szczoteczki / Manualne",
    "comissionGroupOld": "C19",
    "comissionGroupNew": "D16"
  },
  {
    "segment": "Wybarwianie płytki nazębnej",
    "categoryPath": [
      "(260541) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(260541) Zdrowie / Higiena jamy ustnej / Wybarwianie płytki nazębnej",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wybielanie",
    "categoryPath": [
      "(257769) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(257769) Zdrowie / Higiena jamy ustnej / Wybielanie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Świeży oddech",
    "categoryPath": [
      "(260539) Zdrowie",
      "Higiena jamy ustnej"
    ],
    "hierarchy": "(260539) Zdrowie / Higiena jamy ustnej / Świeży oddech",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chusteczki higieniczne",
    "categoryPath": [
      "(300441) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(300441) Zdrowie / Higiena osobista / Artykuły higieniczne / Chusteczki higieniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chusteczki odświeżające, antybakteryjne",
    "categoryPath": [
      "(308065) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(308065) Zdrowie / Higiena osobista / Artykuły higieniczne / Chusteczki odświeżające, antybakteryjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maseczki ochronne wielorazowe",
    "categoryPath": [
      "(308497) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(308497) Zdrowie / Higiena osobista / Artykuły higieniczne / Maseczki ochronne wielorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Patyczki higieniczne",
    "categoryPath": [
      "(300529) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(300529) Zdrowie / Higiena osobista / Artykuły higieniczne / Patyczki higieniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Produkty jednorazowe",
    "categoryPath": [
      "(122613) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(122613) Zdrowie / Higiena osobista / Artykuły higieniczne / Produkty jednorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płatki i waciki higieniczne",
    "categoryPath": [
      "(300533) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(300533) Zdrowie / Higiena osobista / Artykuły higieniczne / Płatki i waciki higieniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ręczniki papierowe",
    "categoryPath": [
      "(300517) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(300517) Zdrowie / Higiena osobista / Artykuły higieniczne / Ręczniki papierowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Toaletowe podkładki higieniczne",
    "categoryPath": [
      "(300449) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(300449) Zdrowie / Higiena osobista / Artykuły higieniczne / Toaletowe podkładki higieniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkładki pod pachy",
    "categoryPath": [
      "(319280) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(319280) Zdrowie / Higiena osobista / Artykuły higieniczne / Wkładki pod pachy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Żele antybakteryjne do rąk",
    "categoryPath": [
      "(308053) Zdrowie",
      "Higiena osobista",
      "Artykuły higieniczne"
    ],
    "hierarchy": "(308053) Zdrowie / Higiena osobista / Artykuły higieniczne / Żele antybakteryjne do rąk",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kubeczki menstruacyjne",
    "categoryPath": [
      "(300413) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(300413) Zdrowie / Higiena osobista / Higiena intymna / Kubeczki menstruacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lubrykanty i żele intymne",
    "categoryPath": [
      "(259301) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(259301) Zdrowie / Higiena osobista / Higiena intymna / Lubrykanty i żele intymne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Majtki menstruacyjne",
    "categoryPath": [
      "(322398) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(322398) Zdrowie / Higiena osobista / Higiena intymna / Majtki menstruacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podpaski",
    "categoryPath": [
      "(300397) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(300397) Zdrowie / Higiena osobista / Higiena intymna / Podpaski",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podpaski wielorazowe",
    "categoryPath": [
      "(300401) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(300401) Zdrowie / Higiena osobista / Higiena intymna / Podpaski wielorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Preparaty",
    "categoryPath": [
      "(259302) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(259302) Zdrowie / Higiena osobista / Higiena intymna / Preparaty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Prezerwatywy",
    "categoryPath": [
      "(259300) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(259300) Zdrowie / Higiena osobista / Higiena intymna / Prezerwatywy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tampony",
    "categoryPath": [
      "(300409) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(300409) Zdrowie / Higiena osobista / Higiena intymna / Tampony",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkładki higieniczne",
    "categoryPath": [
      "(300405) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(300405) Zdrowie / Higiena osobista / Higiena intymna / Wkładki higieniczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkładki wielorazowe",
    "categoryPath": [
      "(319271) Zdrowie",
      "Higiena osobista",
      "Higiena intymna"
    ],
    "hierarchy": "(319271) Zdrowie / Higiena osobista / Higiena intymna / Wkładki wielorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Majtki chłonne",
    "categoryPath": [
      "(300425) Zdrowie",
      "Higiena osobista",
      "Nietrzymanie moczu"
    ],
    "hierarchy": "(300425) Zdrowie / Higiena osobista / Nietrzymanie moczu / Majtki chłonne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Majtki siatkowe",
    "categoryPath": [
      "(319277) Zdrowie",
      "Higiena osobista",
      "Nietrzymanie moczu"
    ],
    "hierarchy": "(319277) Zdrowie / Higiena osobista / Nietrzymanie moczu / Majtki siatkowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pieluchomajtki",
    "categoryPath": [
      "(122612) Zdrowie",
      "Higiena osobista",
      "Nietrzymanie moczu"
    ],
    "hierarchy": "(122612) Zdrowie / Higiena osobista / Nietrzymanie moczu / Pieluchomajtki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pieluchy anatomiczne i wkłady chłonne",
    "categoryPath": [
      "(300433) Zdrowie",
      "Higiena osobista",
      "Nietrzymanie moczu"
    ],
    "hierarchy": "(300433) Zdrowie / Higiena osobista / Nietrzymanie moczu / Pieluchy anatomiczne i wkłady chłonne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkładki urologiczne",
    "categoryPath": [
      "(300417) Zdrowie",
      "Higiena osobista",
      "Nietrzymanie moczu"
    ],
    "hierarchy": "(300417) Zdrowie / Higiena osobista / Nietrzymanie moczu / Wkładki urologiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chusteczki nawilżane do okularów",
    "categoryPath": [
      "(310717) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(310717) Zdrowie / Korekcja wzroku / Okulary / Chusteczki nawilżane do okularów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Etui na okulary",
    "categoryPath": [
      "(310729) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(310729) Zdrowie / Korekcja wzroku / Okulary / Etui na okulary",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gotowe okulary",
    "categoryPath": [
      "(122429) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(122429) Zdrowie / Korekcja wzroku / Okulary / Gotowe okulary",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nakładki na okulary",
    "categoryPath": [
      "(318232) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(318232) Zdrowie / Korekcja wzroku / Okulary / Nakładki na okulary",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Noski do okularów",
    "categoryPath": [
      "(318229) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(318229) Zdrowie / Korekcja wzroku / Okulary / Noski do okularów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oprawki",
    "categoryPath": [
      "(122428) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(122428) Zdrowie / Korekcja wzroku / Okulary / Oprawki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płyny do czyszczenia okularów",
    "categoryPath": [
      "(310777) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(310777) Zdrowie / Korekcja wzroku / Okulary / Płyny do czyszczenia okularów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Soczewki do okularów",
    "categoryPath": [
      "(122430) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(122430) Zdrowie / Korekcja wzroku / Okulary / Soczewki do okularów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zauszniki do okularów i końcówki",
    "categoryPath": [
      "(318226) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(318226) Zdrowie / Korekcja wzroku / Okulary / Zauszniki do okularów i końcówki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łańcuszki, sznurki, gumki do okularów",
    "categoryPath": [
      "(310741) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(310741) Zdrowie / Korekcja wzroku / Okulary / Łańcuszki, sznurki, gumki do okularów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ściereczki, czyściki do okularów",
    "categoryPath": [
      "(310765) Zdrowie",
      "Korekcja wzroku",
      "Okulary"
    ],
    "hierarchy": "(310765) Zdrowie / Korekcja wzroku / Okulary / Ściereczki, czyściki do okularów",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122431) Zdrowie",
      "Korekcja wzroku"
    ],
    "hierarchy": "(122431) Zdrowie / Korekcja wzroku / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pojemniki na soczewki",
    "categoryPath": [
      "(122427) Zdrowie",
      "Korekcja wzroku",
      "Soczewki"
    ],
    "hierarchy": "(122427) Zdrowie / Korekcja wzroku / Soczewki / Pojemniki na soczewki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przyssawki i pęsety do soczewek",
    "categoryPath": [
      "(318238) Zdrowie",
      "Korekcja wzroku",
      "Soczewki"
    ],
    "hierarchy": "(318238) Zdrowie / Korekcja wzroku / Soczewki / Przyssawki i pęsety do soczewek",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płyny do soczewek",
    "categoryPath": [
      "(122425) Zdrowie",
      "Korekcja wzroku",
      "Soczewki"
    ],
    "hierarchy": "(122425) Zdrowie / Korekcja wzroku / Soczewki / Płyny do soczewek",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Soczewki kontaktowe",
    "categoryPath": [
      "(122424) Zdrowie",
      "Korekcja wzroku",
      "Soczewki"
    ],
    "hierarchy": "(122424) Zdrowie / Korekcja wzroku / Soczewki / Soczewki kontaktowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tabletki odbiałczające",
    "categoryPath": [
      "(318244) Zdrowie",
      "Korekcja wzroku",
      "Soczewki"
    ],
    "hierarchy": "(318244) Zdrowie / Korekcja wzroku / Soczewki / Tabletki odbiałczające",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akupunktura, igły",
    "categoryPath": [
      "(261422) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(261422) Zdrowie / Medycyna naturalna / Akupunktura, igły",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bańki",
    "categoryPath": [
      "(261423) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(261423) Zdrowie / Medycyna naturalna / Bańki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chrapanie",
    "categoryPath": [
      "(310921) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(310921) Zdrowie / Medycyna naturalna / Chrapanie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kremy i maści",
    "categoryPath": [
      "(258261) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258261) Zdrowie / Medycyna naturalna / Kremy i maści",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Grzyb herbaciany",
    "categoryPath": [
      "(317477) Zdrowie",
      "Medycyna naturalna",
      "Medycyna alternatywna"
    ],
    "hierarchy": "(317477) Zdrowie / Medycyna naturalna / Medycyna alternatywna / Grzyb herbaciany",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Okulary ajurwedyjskie",
    "categoryPath": [
      "(261425) Zdrowie",
      "Medycyna naturalna",
      "Medycyna alternatywna"
    ],
    "hierarchy": "(261425) Zdrowie / Medycyna naturalna / Medycyna alternatywna / Okulary ajurwedyjskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Orgonity i odpromienniki",
    "categoryPath": [
      "(261424) Zdrowie",
      "Medycyna naturalna",
      "Medycyna alternatywna"
    ],
    "hierarchy": "(261424) Zdrowie / Medycyna naturalna / Medycyna alternatywna / Orgonity i odpromienniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Plastry oczyszczające",
    "categoryPath": [
      "(261426) Zdrowie",
      "Medycyna naturalna",
      "Medycyna alternatywna"
    ],
    "hierarchy": "(261426) Zdrowie / Medycyna naturalna / Medycyna alternatywna / Plastry oczyszczające",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szungit i krzemień",
    "categoryPath": [
      "(261430) Zdrowie",
      "Medycyna naturalna",
      "Medycyna alternatywna"
    ],
    "hierarchy": "(261430) Zdrowie / Medycyna naturalna / Medycyna alternatywna / Szungit i krzemień",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Oleje roślinne",
    "categoryPath": [
      "(258262) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258262) Zdrowie / Medycyna naturalna / Oleje roślinne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Olejki eteryczne",
    "categoryPath": [
      "(258263) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258263) Zdrowie / Medycyna naturalna / Olejki eteryczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(258267) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258267) Zdrowie / Medycyna naturalna / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty",
    "categoryPath": [
      "(258264) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258264) Zdrowie / Medycyna naturalna / Preparaty",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Produkty konopne",
    "categoryPath": [
      "(261428) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(261428) Zdrowie / Medycyna naturalna / Produkty konopne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Puste kapsułki",
    "categoryPath": [
      "(317474) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(317474) Zdrowie / Medycyna naturalna / Puste kapsułki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Soki",
    "categoryPath": [
      "(258265) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258265) Zdrowie / Medycyna naturalna / Soki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Spirulina, chlorella, algi",
    "categoryPath": [
      "(258260) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258260) Zdrowie / Medycyna naturalna / Spirulina, chlorella, algi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Srebro koloidalne, koloidy",
    "categoryPath": [
      "(261427) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(261427) Zdrowie / Medycyna naturalna / Srebro koloidalne, koloidy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Waporyzatory",
    "categoryPath": [
      "(321959) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(321959) Zdrowie / Medycyna naturalna / Waporyzatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zioła",
    "categoryPath": [
      "(258266) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(258266) Zdrowie / Medycyna naturalna / Zioła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Świecowanie uszu",
    "categoryPath": [
      "(261429) Zdrowie",
      "Medycyna naturalna"
    ],
    "hierarchy": "(261429) Zdrowie / Medycyna naturalna / Świecowanie uszu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(321432) Zdrowie"
    ],
    "hierarchy": "(321432) Zdrowie / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Dłuta chirurgiczne",
    "categoryPath": [
      "(259958) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259958) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Dłuta chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Haki chirurgiczne",
    "categoryPath": [
      "(259964) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259964) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Haki chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Igłotrzymacze",
    "categoryPath": [
      "(259957) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259957) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Igłotrzymacze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kleszczyki i kleszcze chirurgiczne",
    "categoryPath": [
      "(259963) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259963) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Kleszczyki i kleszcze chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nerki, tacki chirurgiczne",
    "categoryPath": [
      "(259965) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259965) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Nerki, tacki chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nici chirurgiczne",
    "categoryPath": [
      "(259959) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259959) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Nici chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nożyczki chirurgiczne",
    "categoryPath": [
      "(259961) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259961) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Nożyczki chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259956) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259956) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Pęsety chirurgiczne i zabiegowe",
    "categoryPath": [
      "(259962) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259962) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Pęsety chirurgiczne i zabiegowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skalpele i ostrza",
    "categoryPath": [
      "(259960) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259960) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Skalpele i ostrza",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ssaki medyczne",
    "categoryPath": [
      "(259966) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Chirurgia"
    ],
    "hierarchy": "(259966) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Chirurgia / Ssaki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Latarki diagnostyczne",
    "categoryPath": [
      "(259719) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Diagnostyka"
    ],
    "hierarchy": "(259719) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Diagnostyka / Latarki diagnostyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Młotki neurologiczne",
    "categoryPath": [
      "(259721) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Diagnostyka"
    ],
    "hierarchy": "(259721) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Diagnostyka / Młotki neurologiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Otoskopy",
    "categoryPath": [
      "(259720) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Diagnostyka"
    ],
    "hierarchy": "(259720) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Diagnostyka / Otoskopy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259504) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Diagnostyka"
    ],
    "hierarchy": "(259504) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Diagnostyka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sprzęt i urządzenia diagnostyczne",
    "categoryPath": [
      "(259723) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Diagnostyka"
    ],
    "hierarchy": "(259723) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Diagnostyka / Sprzęt i urządzenia diagnostyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stetoskopy",
    "categoryPath": [
      "(259503) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Diagnostyka"
    ],
    "hierarchy": "(259503) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Diagnostyka / Stetoskopy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wzierniki",
    "categoryPath": [
      "(259722) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Diagnostyka"
    ],
    "hierarchy": "(259722) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Diagnostyka / Wzierniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bibuły, gilzy, filtry",
    "categoryPath": [
      "(260097) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260097) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Bibuły, gilzy, filtry",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Korki",
    "categoryPath": [
      "(260091) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260091) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Korki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Kulki szklane",
    "categoryPath": [
      "(317483) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(317483) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Kulki szklane",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Papierki lakmusowe",
    "categoryPath": [
      "(260095) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260095) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Papierki lakmusowe",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Podnośniki laboratoryjne",
    "categoryPath": [
      "(260093) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260093) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Podnośniki laboratoryjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Pojemniki, słoiki, pudełka",
    "categoryPath": [
      "(260090) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260090) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Pojemniki, słoiki, pudełka",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Statywy i elementy łączące",
    "categoryPath": [
      "(260092) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260092) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Statywy i elementy łączące",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Szczotki laboratoryjne",
    "categoryPath": [
      "(260094) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260094) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Szczotki laboratoryjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Sączki",
    "categoryPath": [
      "(260096) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260096) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Sączki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Węże, zaciski, łączniki",
    "categoryPath": [
      "(260098) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Akcesoria"
    ],
    "hierarchy": "(260098) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Akcesoria / Węże, zaciski, łączniki",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Biurety",
    "categoryPath": [
      "(260108) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Miareczkowanie, dozowanie"
    ],
    "hierarchy": "(260108) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Miareczkowanie, dozowanie / Biurety",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Dozowniki i adaptery",
    "categoryPath": [
      "(260109) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Miareczkowanie, dozowanie"
    ],
    "hierarchy": "(260109) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Miareczkowanie, dozowanie / Dozowniki i adaptery",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Gruszki, pompki, pipetory",
    "categoryPath": [
      "(260110) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Miareczkowanie, dozowanie"
    ],
    "hierarchy": "(260110) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Miareczkowanie, dozowanie / Gruszki, pompki, pipetory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Końcówki do pipet",
    "categoryPath": [
      "(260107) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Miareczkowanie, dozowanie"
    ],
    "hierarchy": "(260107) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Miareczkowanie, dozowanie / Końcówki do pipet",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pipety",
    "categoryPath": [
      "(260106) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Miareczkowanie, dozowanie"
    ],
    "hierarchy": "(260106) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Miareczkowanie, dozowanie / Pipety",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bagietki, szpatułki, łyżeczki, szufelki",
    "categoryPath": [
      "(260074) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260074) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Bagietki, szpatułki, łyżeczki, szufelki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Butelki, kroplomierze",
    "categoryPath": [
      "(260072) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260072) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Butelki, kroplomierze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chłodnice",
    "categoryPath": [
      "(260084) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260084) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Chłodnice",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Cylindry",
    "categoryPath": [
      "(260073) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260073) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Cylindry",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Eksykatory",
    "categoryPath": [
      "(260085) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260085) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Eksykatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kolby",
    "categoryPath": [
      "(260075) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260075) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Kolby",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Krystalizatory, parownice, tygle, moździerze",
    "categoryPath": [
      "(260077) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260077) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Krystalizatory, parownice, tygle, moździerze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kuwety",
    "categoryPath": [
      "(260082) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260082) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Kuwety",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lejki",
    "categoryPath": [
      "(260076) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260076) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Lejki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Naczynka wagowe",
    "categoryPath": [
      "(260086) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260086) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Naczynka wagowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Probówki",
    "categoryPath": [
      "(260078) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260078) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Probówki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płuczki",
    "categoryPath": [
      "(260083) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260083) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Płuczki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rozdzielacze",
    "categoryPath": [
      "(260087) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260087) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Rozdzielacze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szalki Petriego",
    "categoryPath": [
      "(260079) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260079) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Szalki Petriego",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szkiełka",
    "categoryPath": [
      "(260080) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260080) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Szkiełka",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tryskawki",
    "categoryPath": [
      "(260088) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260088) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Tryskawki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zlewki",
    "categoryPath": [
      "(260081) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Naczynia, szkło laboratoryjne"
    ],
    "hierarchy": "(260081) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Naczynia, szkło laboratoryjne / Zlewki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Odczynniki chemiczne",
    "categoryPath": [
      "(260070) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium"
    ],
    "hierarchy": "(260070) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Odczynniki chemiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260065) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium"
    ],
    "hierarchy": "(260065) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Cieplarki, suszarki",
    "categoryPath": [
      "(260102) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Sprzęt i urządzenia laboratoryjne"
    ],
    "hierarchy": "(260102) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Sprzęt i urządzenia laboratoryjne / Cieplarki, suszarki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Mieszadła",
    "categoryPath": [
      "(260100) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Sprzęt i urządzenia laboratoryjne"
    ],
    "hierarchy": "(260100) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Sprzęt i urządzenia laboratoryjne / Mieszadła",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przyrządy pomiarowe",
    "categoryPath": [
      "(260113) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Sprzęt i urządzenia laboratoryjne"
    ],
    "hierarchy": "(260113) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Sprzęt i urządzenia laboratoryjne / Przyrządy pomiarowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Płaszcze grzewcze",
    "categoryPath": [
      "(260104) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Sprzęt i urządzenia laboratoryjne"
    ],
    "hierarchy": "(260104) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Sprzęt i urządzenia laboratoryjne / Płaszcze grzewcze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wirówki",
    "categoryPath": [
      "(260103) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Sprzęt i urządzenia laboratoryjne"
    ],
    "hierarchy": "(260103) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Sprzęt i urządzenia laboratoryjne / Wirówki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łaźnie",
    "categoryPath": [
      "(260101) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Laboratorium",
      "Sprzęt i urządzenia laboratoryjne"
    ],
    "hierarchy": "(260101) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Laboratorium / Sprzęt i urządzenia laboratoryjne / Łaźnie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostały sprzęt medyczny",
    "categoryPath": [
      "(259464) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny"
    ],
    "hierarchy": "(259464) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Pozostały sprzęt medyczny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ampularia",
    "categoryPath": [
      "(259991) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Apteczki, torby, zestawy ratownicze"
    ],
    "hierarchy": "(259991) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Apteczki, torby, zestawy ratownicze / Ampularia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Apteczki",
    "categoryPath": [
      "(259993) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Apteczki, torby, zestawy ratownicze"
    ],
    "hierarchy": "(259993) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Apteczki, torby, zestawy ratownicze / Apteczki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Plecaki ratownicze",
    "categoryPath": [
      "(259992) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Apteczki, torby, zestawy ratownicze"
    ],
    "hierarchy": "(259992) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Apteczki, torby, zestawy ratownicze / Plecaki ratownicze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Torby medyczne",
    "categoryPath": [
      "(259994) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Apteczki, torby, zestawy ratownicze"
    ],
    "hierarchy": "(259994) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Apteczki, torby, zestawy ratownicze / Torby medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zestawy ratownicze",
    "categoryPath": [
      "(259995) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Apteczki, torby, zestawy ratownicze"
    ],
    "hierarchy": "(259995) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Apteczki, torby, zestawy ratownicze / Zestawy ratownicze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Defibrylatory",
    "categoryPath": [
      "(259987) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo"
    ],
    "hierarchy": "(259987) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Defibrylatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Laryngoskopy",
    "categoryPath": [
      "(260002) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Intubacja, respiratory"
    ],
    "hierarchy": "(260002) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Intubacja, respiratory / Laryngoskopy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maski krtaniowe",
    "categoryPath": [
      "(260001) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Intubacja, respiratory"
    ],
    "hierarchy": "(260001) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Intubacja, respiratory / Maski krtaniowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Respiratory",
    "categoryPath": [
      "(259999) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Intubacja, respiratory"
    ],
    "hierarchy": "(259999) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Intubacja, respiratory / Respiratory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rurki intubacyjne",
    "categoryPath": [
      "(260000) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Intubacja, respiratory"
    ],
    "hierarchy": "(260000) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Intubacja, respiratory / Rurki intubacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259985) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo"
    ],
    "hierarchy": "(259985) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Fantomy",
    "categoryPath": [
      "(259997) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Resuscytacja"
    ],
    "hierarchy": "(259997) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Resuscytacja / Fantomy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maseczki do resuscytacji",
    "categoryPath": [
      "(259998) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Resuscytacja"
    ],
    "hierarchy": "(259998) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Resuscytacja / Maseczki do resuscytacji",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Resuscytatory",
    "categoryPath": [
      "(259996) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo",
      "Resuscytacja"
    ],
    "hierarchy": "(259996) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Resuscytacja / Resuscytatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Unieruchomienie i transport",
    "categoryPath": [
      "(259989) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Ratownictwo"
    ],
    "hierarchy": "(259989) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Ratownictwo / Unieruchomienie i transport",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Autoklawy, sterylizatory",
    "categoryPath": [
      "(259885) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259885) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Autoklawy, sterylizatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Myjki ultradźwiękowe, dezynfektory",
    "categoryPath": [
      "(259880) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259880) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Myjki ultradźwiękowe, dezynfektory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259879) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259879) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Preparaty do dezynfekcji",
    "categoryPath": [
      "(259882) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259882) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Preparaty do dezynfekcji",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Testy do sterylizacji",
    "categoryPath": [
      "(259884) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259884) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Testy do sterylizacji",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Torebki, rękawy do sterylizacji",
    "categoryPath": [
      "(259883) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259883) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Torebki, rękawy do sterylizacji",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wanienki, pojemniki do dezynfekcji",
    "categoryPath": [
      "(259886) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259886) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Wanienki, pojemniki do dezynfekcji",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zgrzewarki medyczne",
    "categoryPath": [
      "(259881) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Sterylizacja i dezynfekcja"
    ],
    "hierarchy": "(259881) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Sterylizacja i dezynfekcja / Zgrzewarki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(259944) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka"
    ],
    "hierarchy": "(259944) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Materiały polerskie",
    "categoryPath": [
      "(259942) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka"
    ],
    "hierarchy": "(259942) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Materiały polerskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materiały stomatologiczne",
    "categoryPath": [
      "(259955) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka"
    ],
    "hierarchy": "(259955) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Materiały stomatologiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Narzędzia stomatologiczne",
    "categoryPath": [
      "(259945) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka"
    ],
    "hierarchy": "(259945) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Narzędzia stomatologiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(259941) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka"
    ],
    "hierarchy": "(259941) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Frezy, materiały polerskie",
    "categoryPath": [
      "(259952) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka",
      "Protetyka"
    ],
    "hierarchy": "(259952) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Protetyka / Frezy, materiały polerskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materiały protetyczne",
    "categoryPath": [
      "(259948) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka",
      "Protetyka"
    ],
    "hierarchy": "(259948) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Protetyka / Materiały protetyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Narzędzia i akcesoria protetyczne",
    "categoryPath": [
      "(259949) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka",
      "Protetyka"
    ],
    "hierarchy": "(259949) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Protetyka / Narzędzia i akcesoria protetyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sprzęt i urządzenia protetyczne",
    "categoryPath": [
      "(259950) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka",
      "Protetyka"
    ],
    "hierarchy": "(259950) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Protetyka / Sprzęt i urządzenia protetyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Zęby",
    "categoryPath": [
      "(260527) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka",
      "Protetyka"
    ],
    "hierarchy": "(260527) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Protetyka / Zęby",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Sprzęt i urządzenia stomatologiczne",
    "categoryPath": [
      "(259947) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka"
    ],
    "hierarchy": "(259947) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Sprzęt i urządzenia stomatologiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wiertła stomatologiczne",
    "categoryPath": [
      "(259943) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Stomatologia i protetyka"
    ],
    "hierarchy": "(259943) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Stomatologia i protetyka / Wiertła stomatologiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Opatrunki weterynaryjne",
    "categoryPath": [
      "(260530) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Weterynaria"
    ],
    "hierarchy": "(260530) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Weterynaria / Opatrunki weterynaryjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(260528) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Weterynaria"
    ],
    "hierarchy": "(260528) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Weterynaria / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Sprzęt i urządzenia weterynaryjne",
    "categoryPath": [
      "(260529) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Specjalistyczny sprzęt medyczny",
      "Weterynaria"
    ],
    "hierarchy": "(260529) Zdrowie / Sprzęt i wyposażenie medyczne / Specjalistyczny sprzęt medyczny / Weterynaria / Sprzęt i urządzenia weterynaryjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Aplikatory wieloigłowe",
    "categoryPath": [
      "(311105) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu",
      "Akupresura"
    ],
    "hierarchy": "(311105) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Akupresura / Aplikatory wieloigłowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maty i poduszki do akupresury",
    "categoryPath": [
      "(311093) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu",
      "Akupresura"
    ],
    "hierarchy": "(311093) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Akupresura / Maty i poduszki do akupresury",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Fotele masujące",
    "categoryPath": [
      "(122544) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu"
    ],
    "hierarchy": "(122544) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Fotele masujące",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Krzesła do masażu",
    "categoryPath": [
      "(311057) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu"
    ],
    "hierarchy": "(311057) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Krzesła do masażu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Hydromasaż, maty ozonujące",
    "categoryPath": [
      "(122545) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu",
      "Masażery i urządzenia masujące"
    ],
    "hierarchy": "(122545) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Masażery i urządzenia masujące / Hydromasaż, maty ozonujące",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Masażery",
    "categoryPath": [
      "(122546) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu",
      "Masażery i urządzenia masujące"
    ],
    "hierarchy": "(122546) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Masażery i urządzenia masujące / Masażery",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maty masujące",
    "categoryPath": [
      "(122551) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu",
      "Masażery i urządzenia masujące"
    ],
    "hierarchy": "(122551) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Masażery i urządzenia masujące / Maty masujące",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poduszki masujące",
    "categoryPath": [
      "(311117) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu",
      "Masażery i urządzenia masujące"
    ],
    "hierarchy": "(311117) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Masażery i urządzenia masujące / Poduszki masujące",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podgrzewacze i kamienie do masażu",
    "categoryPath": [
      "(311069) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu"
    ],
    "hierarchy": "(311069) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Podgrzewacze i kamienie do masażu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122553) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu"
    ],
    "hierarchy": "(122553) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Stoły, łóżka do masażu",
    "categoryPath": [
      "(122552) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt i urządzenia do masażu"
    ],
    "hierarchy": "(122552) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt i urządzenia do masażu / Stoły, łóżka do masażu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poduszki i krążki przeciwodleżynowe",
    "categoryPath": [
      "(260790) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Poduszki ortopedyczne i przeciwodleżynowe"
    ],
    "hierarchy": "(260790) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Poduszki ortopedyczne i przeciwodleżynowe / Poduszki i krążki przeciwodleżynowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poduszki ortopedyczne",
    "categoryPath": [
      "(260788) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Poduszki ortopedyczne i przeciwodleżynowe"
    ],
    "hierarchy": "(260788) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Poduszki ortopedyczne i przeciwodleżynowe / Poduszki ortopedyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poszewki na poduszki ortopedyczne",
    "categoryPath": [
      "(260789) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Poduszki ortopedyczne i przeciwodleżynowe"
    ],
    "hierarchy": "(260789) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Poduszki ortopedyczne i przeciwodleżynowe / Poszewki na poduszki ortopedyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Chwytaki do podnoszenia",
    "categoryPath": [
      "(260822) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Pomoce dla seniorów i osób niepełnosprawnych"
    ],
    "hierarchy": "(260822) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Pomoce dla seniorów i osób niepełnosprawnych / Chwytaki do podnoszenia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pojemniki, kasetki na leki",
    "categoryPath": [
      "(260823) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Pomoce dla seniorów i osób niepełnosprawnych"
    ],
    "hierarchy": "(260823) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Pomoce dla seniorów i osób niepełnosprawnych / Pojemniki, kasetki na leki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przecinarki do tabletek",
    "categoryPath": [
      "(260824) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Pomoce dla seniorów i osób niepełnosprawnych"
    ],
    "hierarchy": "(260824) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Pomoce dla seniorów i osób niepełnosprawnych / Przecinarki do tabletek",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przyrządy do zakładania skarpet",
    "categoryPath": [
      "(260825) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Pomoce dla seniorów i osób niepełnosprawnych"
    ],
    "hierarchy": "(260825) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Pomoce dla seniorów i osób niepełnosprawnych / Przyrządy do zakładania skarpet",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Śliniaki dla dorosłych",
    "categoryPath": [
      "(310933) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Pomoce dla seniorów i osób niepełnosprawnych"
    ],
    "hierarchy": "(310933) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Pomoce dla seniorów i osób niepełnosprawnych / Śliniaki dla dorosłych",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pozostałe",
    "categoryPath": [
      "(122563) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny"
    ],
    "hierarchy": "(122563) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Pozostałe",
    "comissionGroupOld": "C5",
    "comissionGroupNew": "D4"
  },
  {
    "segment": "Kleje, zmywacze do taśm",
    "categoryPath": [
      "(260761) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia",
      "Kinesiotaping"
    ],
    "hierarchy": "(260761) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Kinesiotaping / Kleje, zmywacze do taśm",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Taśmy do tapingu",
    "categoryPath": [
      "(260760) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia",
      "Kinesiotaping"
    ],
    "hierarchy": "(260760) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Kinesiotaping / Taśmy do tapingu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Korektory postawy",
    "categoryPath": [
      "(260780) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia"
    ],
    "hierarchy": "(260780) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Korektory postawy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kształtki rehabilitacyjne",
    "categoryPath": [
      "(260767) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia"
    ],
    "hierarchy": "(260767) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Kształtki rehabilitacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Magnetoterapia",
    "categoryPath": [
      "(319550) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia"
    ],
    "hierarchy": "(319550) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Magnetoterapia",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poduszki sensomotoryczne",
    "categoryPath": [
      "(260763) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia"
    ],
    "hierarchy": "(260763) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Poduszki sensomotoryczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przyrządy do rehabilitacji i ćwiczeń dłoni",
    "categoryPath": [
      "(260766) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia"
    ],
    "hierarchy": "(260766) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Przyrządy do rehabilitacji i ćwiczeń dłoni",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rotory rehabilitacyjne",
    "categoryPath": [
      "(260758) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia"
    ],
    "hierarchy": "(260758) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Rotory rehabilitacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Terapia zimnem i ciepłem",
    "categoryPath": [
      "(260765) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Rehabilitacja i ćwiczenia"
    ],
    "hierarchy": "(260765) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Rehabilitacja i ćwiczenia / Terapia zimnem i ciepłem",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stabilizatory, ortezy, opaski",
    "categoryPath": [
      "(122561) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny"
    ],
    "hierarchy": "(122561) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Buty ortopedyczne i pooperacyjne",
    "categoryPath": [
      "(260828) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Stabilizatory, ortezy, opaski"
    ],
    "hierarchy": "(260828) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski / Buty ortopedyczne i pooperacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kołnierze ortopedyczne",
    "categoryPath": [
      "(260829) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Stabilizatory, ortezy, opaski"
    ],
    "hierarchy": "(260829) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski / Kołnierze ortopedyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Opaski i pasy magnetyczne",
    "categoryPath": [
      "(260834) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Stabilizatory, ortezy, opaski"
    ],
    "hierarchy": "(260834) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski / Opaski i pasy magnetyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ortezy kończyny dolnej",
    "categoryPath": [
      "(260832) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Stabilizatory, ortezy, opaski"
    ],
    "hierarchy": "(260832) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski / Ortezy kończyny dolnej",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ortezy kończyny górnej",
    "categoryPath": [
      "(260831) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Stabilizatory, ortezy, opaski"
    ],
    "hierarchy": "(260831) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski / Ortezy kończyny górnej",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pasy i gorsety ortopedyczne",
    "categoryPath": [
      "(260833) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Stabilizatory, ortezy, opaski"
    ],
    "hierarchy": "(260833) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski / Pasy i gorsety ortopedyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Temblaki",
    "categoryPath": [
      "(260830) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Stabilizatory, ortezy, opaski"
    ],
    "hierarchy": "(260830) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Stabilizatory, ortezy, opaski / Temblaki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Balkoniki, chodziki rehabilitacyjne",
    "categoryPath": [
      "(260801) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Transport i poruszanie"
    ],
    "hierarchy": "(260801) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Transport i poruszanie / Balkoniki, chodziki rehabilitacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kule ortopedyczne",
    "categoryPath": [
      "(260802) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Transport i poruszanie"
    ],
    "hierarchy": "(260802) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Transport i poruszanie / Kule ortopedyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Laski inwalidzkie",
    "categoryPath": [
      "(260803) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Transport i poruszanie"
    ],
    "hierarchy": "(260803) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Transport i poruszanie / Laski inwalidzkie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podnośniki i pionizatory transportowe",
    "categoryPath": [
      "(260806) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Transport i poruszanie"
    ],
    "hierarchy": "(260806) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Transport i poruszanie / Podnośniki i pionizatory transportowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Schodołazy",
    "categoryPath": [
      "(260805) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Transport i poruszanie"
    ],
    "hierarchy": "(260805) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Transport i poruszanie / Schodołazy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skutery inwalidzkie",
    "categoryPath": [
      "(260807) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Transport i poruszanie"
    ],
    "hierarchy": "(260807) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Transport i poruszanie / Skutery inwalidzkie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wózki inwalidzkie",
    "categoryPath": [
      "(260804) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Transport i poruszanie"
    ],
    "hierarchy": "(260804) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Transport i poruszanie / Wózki inwalidzkie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kołdry obciążeniowe",
    "categoryPath": [
      "(260797) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie sypialni"
    ],
    "hierarchy": "(260797) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie sypialni / Kołdry obciążeniowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Materace przeciwodleżynowe",
    "categoryPath": [
      "(260798) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie sypialni"
    ],
    "hierarchy": "(260798) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie sypialni / Materace przeciwodleżynowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podpórki pod plecy",
    "categoryPath": [
      "(260796) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie sypialni"
    ],
    "hierarchy": "(260796) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie sypialni / Podpórki pod plecy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Poręcze do łóżka, drabinki łóżkowe, wysięgniki",
    "categoryPath": [
      "(260795) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie sypialni"
    ],
    "hierarchy": "(260795) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie sypialni / Poręcze do łóżka, drabinki łóżkowe, wysięgniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stoliki przyłóżkowe, tace do łóżka",
    "categoryPath": [
      "(260794) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie sypialni"
    ],
    "hierarchy": "(260794) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie sypialni / Stoliki przyłóżkowe, tace do łóżka",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łóżka rehabilitacyjne",
    "categoryPath": [
      "(260793) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie sypialni"
    ],
    "hierarchy": "(260793) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie sypialni / Łóżka rehabilitacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Baseny do mycia głowy",
    "categoryPath": [
      "(260755) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(260755) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Baseny do mycia głowy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kaczki, baseny sanitarne",
    "categoryPath": [
      "(260754) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(260754) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Kaczki, baseny sanitarne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maty antypoślizgowe",
    "categoryPath": [
      "(260756) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(260756) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Maty antypoślizgowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nakładki na sedes",
    "categoryPath": [
      "(260750) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(260750) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Nakładki na sedes",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podnóżki toaletowe",
    "categoryPath": [
      "(310957) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(310957) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Podnóżki toaletowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Siedziska prysznicowe i wannowe",
    "categoryPath": [
      "(260752) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(260752) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Siedziska prysznicowe i wannowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Uchwyty i poręcze łazienkowe",
    "categoryPath": [
      "(260751) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(260751) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Uchwyty i poręcze łazienkowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wózki, krzesła toaletowe",
    "categoryPath": [
      "(260753) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Wyposażenie łazienki"
    ],
    "hierarchy": "(260753) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Wyposażenie łazienki / Wózki, krzesła toaletowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kliny i osłony na haluksy",
    "categoryPath": [
      "(260813) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Zdrowe nogi i stopy"
    ],
    "hierarchy": "(260813) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Zdrowe nogi i stopy / Kliny i osłony na haluksy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Produkty przeciwzakrzepowe",
    "categoryPath": [
      "(260810) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Zdrowe nogi i stopy"
    ],
    "hierarchy": "(260810) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Zdrowe nogi i stopy / Produkty przeciwzakrzepowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Produkty przeciwżylakowe",
    "categoryPath": [
      "(260809) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Zdrowe nogi i stopy"
    ],
    "hierarchy": "(260809) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Zdrowe nogi i stopy / Produkty przeciwżylakowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Skarpety bezuciskowe",
    "categoryPath": [
      "(260811) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Zdrowe nogi i stopy"
    ],
    "hierarchy": "(260811) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Zdrowe nogi i stopy / Skarpety bezuciskowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wkładki ortopedyczne, podpiętki",
    "categoryPath": [
      "(260812) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Sprzęt rehabilitacyjny i ortopedyczny",
      "Zdrowe nogi i stopy"
    ],
    "hierarchy": "(260812) Zdrowie / Sprzęt i wyposażenie medyczne / Sprzęt rehabilitacyjny i ortopedyczny / Zdrowe nogi i stopy / Wkładki ortopedyczne, podpiętki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Aparaty słuchowe",
    "categoryPath": [
      "(258781) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Aparaty słuchowe i akcesoria"
    ],
    "hierarchy": "(258781) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Aparaty słuchowe i akcesoria / Aparaty słuchowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Baterie do aparatów słuchowych",
    "categoryPath": [
      "(258782) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Aparaty słuchowe i akcesoria"
    ],
    "hierarchy": "(258782) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Aparaty słuchowe i akcesoria / Baterie do aparatów słuchowych",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pielęgnacja i czyszczenie aparatów słuchowych",
    "categoryPath": [
      "(320254) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Aparaty słuchowe i akcesoria"
    ],
    "hierarchy": "(320254) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Aparaty słuchowe i akcesoria / Pielęgnacja i czyszczenie aparatów słuchowych",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(258786) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Ciśnieniomierze i akcesoria"
    ],
    "hierarchy": "(258786) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Ciśnieniomierze i akcesoria / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ciśnieniomierze",
    "categoryPath": [
      "(258785) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Ciśnieniomierze i akcesoria"
    ],
    "hierarchy": "(258785) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Ciśnieniomierze i akcesoria / Ciśnieniomierze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(258789) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Glukometry i akcesoria"
    ],
    "hierarchy": "(258789) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Glukometry i akcesoria / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Glukometry",
    "categoryPath": [
      "(258788) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Glukometry i akcesoria"
    ],
    "hierarchy": "(258788) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Glukometry i akcesoria / Glukometry",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Grzebienie na wszy i gnidy",
    "categoryPath": [
      "(260869) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(260869) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Grzebienie na wszy i gnidy",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Filtry powietrza",
    "categoryPath": [
      "(317784) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317784) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Filtry powietrza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Maski i komory inhalacyjne",
    "categoryPath": [
      "(317760) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317760) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Maski i komory inhalacyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Nebulizatory i rozpylacze",
    "categoryPath": [
      "(317766) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317766) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Nebulizatory i rozpylacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Przewody powietrza",
    "categoryPath": [
      "(317769) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317769) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Przewody powietrza",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Solanki inhalacyjne",
    "categoryPath": [
      "(317772) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317772) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Solanki inhalacyjne",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Ustniki, smoczki, końcówki do nosa",
    "categoryPath": [
      "(317781) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317781) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Ustniki, smoczki, końcówki do nosa",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zasilacze",
    "categoryPath": [
      "(317775) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317775) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Zasilacze",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Zestawy",
    "categoryPath": [
      "(317778) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria",
      "Akcesoria"
    ],
    "hierarchy": "(317778) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Akcesoria / Zestawy",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Inhalatory",
    "categoryPath": [
      "(258791) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Inhalatory i akcesoria"
    ],
    "hierarchy": "(258791) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Inhalatory i akcesoria / Inhalatory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Jonizatory wody",
    "categoryPath": [
      "(258793) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(258793) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Jonizatory wody",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koce, poduszki elektryczne",
    "categoryPath": [
      "(258794) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(258794) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Koce, poduszki elektryczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lampy lecznicze i relaksacyjne",
    "categoryPath": [
      "(258795) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(258795) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Lampy lecznicze i relaksacyjne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Nawilżacze, oczyszczacze powietrza",
    "categoryPath": [
      "(258796) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(258796) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Nawilżacze, oczyszczacze powietrza",
    "comissionGroupOld": "C17",
    "comissionGroupNew": "D14"
  },
  {
    "segment": "Pikflometry",
    "categoryPath": [
      "(310969) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(310969) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Pikflometry",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Przyrządy do usuwania kleszczy i jadu",
    "categoryPath": [
      "(260870) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(260870) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Przyrządy do usuwania kleszczy i jadu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Termofory",
    "categoryPath": [
      "(258797) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(258797) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Termofory",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Termometry",
    "categoryPath": [
      "(258798) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(258798) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Termometry",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Koncentratory tlenu",
    "categoryPath": [
      "(258829) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Tlenoterapia"
    ],
    "hierarchy": "(258829) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Tlenoterapia / Koncentratory tlenu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tlen inhalacyjny",
    "categoryPath": [
      "(258830) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne",
      "Tlenoterapia"
    ],
    "hierarchy": "(258830) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Tlenoterapia / Tlen inhalacyjny",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urządzenia do czyszczenia uszu",
    "categoryPath": [
      "(260868) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(260868) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Urządzenia do czyszczenia uszu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Urządzenia do mierzenia pulsu i saturacji krwi",
    "categoryPath": [
      "(258827) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Urządzenia medyczne"
    ],
    "hierarchy": "(258827) Zdrowie / Sprzęt i wyposażenie medyczne / Urządzenia medyczne / Urządzenia do mierzenia pulsu i saturacji krwi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Akcesoria",
    "categoryPath": [
      "(259490) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów"
    ],
    "hierarchy": "(259490) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Akcesoria",
    "comissionGroupOld": "C1",
    "comissionGroupNew": "D1"
  },
  {
    "segment": "Lampy bakteriobójcze",
    "categoryPath": [
      "(259875) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Lampy medyczne"
    ],
    "hierarchy": "(259875) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Lampy medyczne / Lampy bakteriobójcze",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Lampy zabiegowe, operacyjne, diagnostyczne",
    "categoryPath": [
      "(259876) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Lampy medyczne"
    ],
    "hierarchy": "(259876) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Lampy medyczne / Lampy zabiegowe, operacyjne, diagnostyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Fotele zabiegowe",
    "categoryPath": [
      "(259726) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259726) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Fotele zabiegowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Kozetki, leżanki",
    "categoryPath": [
      "(259731) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259731) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Kozetki, leżanki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Krzesła, taborety lekarskie",
    "categoryPath": [
      "(259727) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259727) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Krzesła, taborety lekarskie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Parawany medyczne",
    "categoryPath": [
      "(259729) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259729) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Parawany medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stanowiska do pobierania krwi",
    "categoryPath": [
      "(259733) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259733) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Stanowiska do pobierania krwi",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stojaki na kroplówki",
    "categoryPath": [
      "(259730) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259730) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Stojaki na kroplówki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stoliki, asystory, wózki medyczne",
    "categoryPath": [
      "(259725) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259725) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Stoliki, asystory, wózki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Stoły operacyjne, zabiegowe",
    "categoryPath": [
      "(259732) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259732) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Stoły operacyjne, zabiegowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szafy, szafki medyczne",
    "categoryPath": [
      "(259734) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259734) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Szafy, szafki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Łóżka szpitalne",
    "categoryPath": [
      "(259728) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Meble medyczne"
    ],
    "hierarchy": "(259728) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Meble medyczne / Łóżka szpitalne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Modele anatomiczne",
    "categoryPath": [
      "(310993) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów"
    ],
    "hierarchy": "(310993) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Modele anatomiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Bluzy medyczne",
    "categoryPath": [
      "(259892) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259892) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Bluzy medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Czepki medyczne",
    "categoryPath": [
      "(259897) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259897) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Czepki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Fartuchy medyczne",
    "categoryPath": [
      "(259894) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259894) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Fartuchy medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Komplety medyczne",
    "categoryPath": [
      "(259896) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259896) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Komplety medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Koszulki medyczne",
    "categoryPath": [
      "(259889) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259889) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Koszulki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Obuwie medyczne",
    "categoryPath": [
      "(259888) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259888) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Obuwie medyczne",
    "comissionGroupOld": "C11",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Pozostała odzież medyczna",
    "categoryPath": [
      "(259887) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259887) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Pozostała odzież medyczna",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spodnie medyczne",
    "categoryPath": [
      "(259890) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259890) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Spodnie medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Spódnice medyczne",
    "categoryPath": [
      "(259895) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259895) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Spódnice medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Sukienki medyczne",
    "categoryPath": [
      "(259891) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259891) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Sukienki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Żakiety i marynarki medyczne",
    "categoryPath": [
      "(259893) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Odzież i obuwie medyczne"
    ],
    "hierarchy": "(259893) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Odzież i obuwie medyczne / Żakiety i marynarki medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D8"
  },
  {
    "segment": "Cewniki, dreny, zgłębniki",
    "categoryPath": [
      "(259903) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259903) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Cewniki, dreny, zgłębniki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Igły",
    "categoryPath": [
      "(259905) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259905) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Igły",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Maseczki chirurgiczne",
    "categoryPath": [
      "(259898) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259898) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Maseczki chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Ochraniacze na obuwie",
    "categoryPath": [
      "(259900) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259900) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Ochraniacze na obuwie",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Podkłady higieniczne, prześcieradła jednorazowe",
    "categoryPath": [
      "(300649) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(300649) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Podkłady higieniczne, prześcieradła jednorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Pojemniki na odpady medyczne",
    "categoryPath": [
      "(259906) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259906) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Pojemniki na odpady medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Rękawiczki jednorazowe",
    "categoryPath": [
      "(259899) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259899) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Rękawiczki jednorazowe",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Serwety operacyjne, obłożenia chirurgiczne",
    "categoryPath": [
      "(300653) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(300653) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Serwety operacyjne, obłożenia chirurgiczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Strzykawki",
    "categoryPath": [
      "(259907) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259907) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Strzykawki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Szpatułki",
    "categoryPath": [
      "(259904) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259904) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Szpatułki",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Wenflony, kaniule",
    "categoryPath": [
      "(259902) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(259902) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Wenflony, kaniule",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Worki do zbiórki moczu",
    "categoryPath": [
      "(311005) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów",
      "Produkty jednorazowego użytku"
    ],
    "hierarchy": "(311005) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Produkty jednorazowego użytku / Worki do zbiórki moczu",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  },
  {
    "segment": "Tablice medyczne",
    "categoryPath": [
      "(310981) Zdrowie",
      "Sprzęt i wyposażenie medyczne",
      "Wyposażenie szpitali i gabinetów"
    ],
    "hierarchy": "(310981) Zdrowie / Sprzęt i wyposażenie medyczne / Wyposażenie szpitali i gabinetów / Tablice medyczne",
    "comissionGroupOld": "C16",
    "comissionGroupNew": "D17"
  }
];
